
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2EYDP", function(module, exports) {

$parcel$export(module.exports, "attachAbortListeners", () => $1a78b7e80091176c$export$9010aa71841a6887);

var $d8F95 = parcelRequire("d8F95");

var $e39tT = parcelRequire("e39tT");

var $elyOj = parcelRequire("elyOj");
function $1a78b7e80091176c$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $d8F95.bind)(window, {
        type: (0, $e39tT.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $e39tT.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $d8F95.bind)(window, {
        type: (0, $e39tT.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $e39tT.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $d8F95.bind)(window, {
        type: (0, $e39tT.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $elyOj.getViewportWidth)() !== initialViewPort.w || (0, $elyOj.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $e39tT.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("e39tT", function(module, exports) {

$parcel$export(module.exports, "AbortEvent", () => $2fd4bed2a879aa78$export$199edc0307b5587f);
const $2fd4bed2a879aa78$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("elyOj", function(module, exports) {

$parcel$export(module.exports, "getViewportWidth", () => $82c51b218c57a7bd$export$a497a1dcb4408212);
$parcel$export(module.exports, "getViewportHeight", () => $82c51b218c57a7bd$export$4f01c15d21ef9cc6);
function $82c51b218c57a7bd$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $82c51b218c57a7bd$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("9wGTI", function(module, exports) {

$parcel$export(module.exports, "fg", () => $1519d2098734f64b$export$b40ec24ac8275656);

var $c6GJD = parcelRequire("c6GJD");

var $g68Gk = parcelRequire("g68Gk");
const $1519d2098734f64b$export$b40ec24ac8275656 = (gateName)=>{
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $c6GJD.default).checkGate(gateName);
    (0, $g68Gk.addFeatureFlagAccessed)(gateName, value);
    return value;
};

});
parcelRegister("c6GJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e97dbefc75c56cbc$export$2e2bcd8739ae039);

var $96xxk = parcelRequire("96xxk");

var $hEUUD = parcelRequire("hEUUD");



var $7OROP = parcelRequire("7OROP");
var $e97dbefc75c56cbc$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $e97dbefc75c56cbc$var$FeatureGates {
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
}
$e97dbefc75c56cbc$var$_FeatureGates = $e97dbefc75c56cbc$var$FeatureGates;
$e97dbefc75c56cbc$var$FeatureGates.client = new (0, $96xxk.Client)();
$e97dbefc75c56cbc$var$FeatureGates.hasCheckGateErrorOccurred = false;
$e97dbefc75c56cbc$var$FeatureGates.hasGetExperimentValueErrorOccurred = false;
$e97dbefc75c56cbc$var$FeatureGates.checkGate = (gateName, options)=>{
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e97dbefc75c56cbc$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $e97dbefc75c56cbc$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $e97dbefc75c56cbc$var$_FeatureGates.client.checkGate(gateName, options);
};
$e97dbefc75c56cbc$var$FeatureGates.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e97dbefc75c56cbc$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $e97dbefc75c56cbc$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $e97dbefc75c56cbc$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
};
$e97dbefc75c56cbc$var$FeatureGates.initializeCalled = $e97dbefc75c56cbc$var$_FeatureGates.client.initializeCalled.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.initializeCompleted = $e97dbefc75c56cbc$var$_FeatureGates.client.initializeCompleted.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.initialize = $e97dbefc75c56cbc$var$_FeatureGates.client.initialize.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.initializeWithProvider = $e97dbefc75c56cbc$var$_FeatureGates.client.initializeWithProvider.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.initializeFromValues = $e97dbefc75c56cbc$var$_FeatureGates.client.initializeFromValues.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.manuallyLogGateExposure = $e97dbefc75c56cbc$var$_FeatureGates.client.manuallyLogGateExposure.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.getExperiment = $e97dbefc75c56cbc$var$_FeatureGates.client.getExperiment.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.manuallyLogExperimentExposure = $e97dbefc75c56cbc$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.manuallyLogLayerExposure = $e97dbefc75c56cbc$var$_FeatureGates.client.manuallyLogLayerExposure.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.shutdownStatsig = $e97dbefc75c56cbc$var$_FeatureGates.client.shutdownStatsig.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.overrideGate = $e97dbefc75c56cbc$var$_FeatureGates.client.overrideGate.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.clearGateOverride = $e97dbefc75c56cbc$var$_FeatureGates.client.clearGateOverride.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.overrideConfig = $e97dbefc75c56cbc$var$_FeatureGates.client.overrideConfig.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.clearConfigOverride = $e97dbefc75c56cbc$var$_FeatureGates.client.clearConfigOverride.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.setOverrides = $e97dbefc75c56cbc$var$_FeatureGates.client.setOverrides.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.getOverrides = $e97dbefc75c56cbc$var$_FeatureGates.client.getOverrides.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.clearAllOverrides = $e97dbefc75c56cbc$var$_FeatureGates.client.clearAllOverrides.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.isCurrentUser = $e97dbefc75c56cbc$var$_FeatureGates.client.isCurrentUser.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.onGateUpdated = $e97dbefc75c56cbc$var$_FeatureGates.client.onGateUpdated.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.onExperimentValueUpdated = $e97dbefc75c56cbc$var$_FeatureGates.client.onExperimentValueUpdated.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.onAnyUpdated = $e97dbefc75c56cbc$var$_FeatureGates.client.onAnyUpdated.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.updateUser = $e97dbefc75c56cbc$var$_FeatureGates.client.updateUser.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.updateUserWithProvider = $e97dbefc75c56cbc$var$_FeatureGates.client.updateUserWithProvider.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.updateUserWithValues = $e97dbefc75c56cbc$var$_FeatureGates.client.updateUserWithValues.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.getPackageVersion = $e97dbefc75c56cbc$var$_FeatureGates.client.getPackageVersion.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.getLayer = $e97dbefc75c56cbc$var$_FeatureGates.client.getLayer.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.getLayerValue = $e97dbefc75c56cbc$var$_FeatureGates.client.getLayerValue.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
let $e97dbefc75c56cbc$var$boundFGJS = $e97dbefc75c56cbc$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $e97dbefc75c56cbc$var$FeatureGates;
    else {
        $e97dbefc75c56cbc$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $e97dbefc75c56cbc$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $hEUUD.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $hEUUD.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $e97dbefc75c56cbc$export$2e2bcd8739ae039 = $e97dbefc75c56cbc$var$boundFGJS;

});
parcelRegister("96xxk", function(module, exports) {

$parcel$export(module.exports, "Client", () => $a8f72bf32701f8a4$export$1f2bb630327ac4b6);

var $hLr0l = parcelRequire("hLr0l");

var $4Mp9u = parcelRequire("4Mp9u");

var $kWb5j = parcelRequire("kWb5j");

var $iGqJ3 = parcelRequire("iGqJ3");

var $3Fnbb = parcelRequire("3Fnbb");

var $1ej3u = parcelRequire("1ej3u");

var $1DPjW = parcelRequire("1DPjW");

var $iVeJ7 = parcelRequire("iVeJ7");

var $7OROP = parcelRequire("7OROP");

var $dYDWA = parcelRequire("dYDWA");

var $hEUUD = parcelRequire("hEUUD");
const $a8f72bf32701f8a4$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $a8f72bf32701f8a4$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $a8f72bf32701f8a4$export$1f2bb630327ac4b6 {
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $dYDWA.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $dYDWA.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
   * @description
   * This method initializes the client using the provider given to call to fetch the bootstrap values.
   * If the client is initialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param provider {Provider}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $dYDWA.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $dYDWA.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $hEUUD.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        this.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $hEUUD.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $7OROP.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $dYDWA.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $dYDWA.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $dYDWA.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $1ej3u.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user using the provider given on initialisation to get the new set of
   * values.
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the
   * server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
   * <code>options.fireGateExposure</code> is false.
   * @param gateName
   */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = client.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $kWb5j.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $kWb5j.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $3Fnbb.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
   * if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the
   * expected type. If this function returns false, then the default value will be returned
   * instead. This can be set to protect your code from unexpected values being set remotely. By
   * default, this will be done by asserting that the default value and value are the same primitive
   * type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
   * default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
  	 const isValidColor: ValidColorTypeCheck =
  		(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
  	 const buttonColor: ValidColor = client.getExperimentValue(
  		'example-experiment-name',
  		'backgroundColor',
  		'yellow',
  		{
  				typeGuard: isValidColor
  		}
   );
   ```
  */ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
   * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   * @param experimentName
   */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
   * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
   * @param layerName
   * @param parameterName
   */ manuallyLogLayerExposure(layerName, parameterName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getLayer(layerName)?.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to
   * build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearGateOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given gate.
   */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment
   * names to build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearConfigOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been
   * added via prior calls to {@link Client.overrideConfig} or
   * {@link Client.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearAllOverrides} after your tests are completed to remove this
   * localStorage entry.
   */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link Client.updateUser},
   * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ isCurrentUser(identifiers, customAttributes) {
        return (0, $dYDWA.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $dYDWA.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current checkGate value
   * @param gateName
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current experiment value
   * @param experimentName
   * @param parameterName
   * @param defaultValue
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
   * Subscribe so on any update the callback will be called.
   * NOTE: The callback will be called whenever the values are updated even if the values have not
   * changed.
   * @param callback
   * @returns off function to unsubscribe from updates
   */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the
   * given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $1ej3u.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $1ej3u.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the
   * server-side SDKs.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $dYDWA.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $a8f72bf32701f8a4$var$DEFAULT_CLIENT_KEY;
        if (!newClientOptions.networkConfig?.logEventUrl) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $a8f72bf32701f8a4$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $7OROP.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        this.user = (0, $dYDWA.toStatsigUser)(identifiers, customAttributes);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $hLr0l.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        try {
            this.statsigClient = new (0, $hLr0l.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $hLr0l.StatsigClient)($a8f72bf32701f8a4$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given
   * Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on the nested Statsig client
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            user = (0, $dYDWA.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            this.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        this.initOptions?.updateUserCompletionCallback?.(success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
   * @returns string version of the current package in semver style.
   */ getPackageVersion() {
        return 0, $hEUUD.CLIENT_VERSION;
    }
    /**
   * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
   *
   * @param {string} layerName - The name of the layer
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns A layer
   * @example
   * ```ts
   * const layer = client.getLayer('example-layer-name');
   * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
   * ```
   */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $iGqJ3.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $iGqJ3.Layer).fromLayer((0, $hLr0l._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
   * Returns the value of a given parameter in a layer config.
   *
   * @template T
   * @param {string} layerName - The name of the layer
   * @param {string} parameterName - The name of the parameter to fetch from the layer config
   * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
   * returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
   * @example
   * ``` ts
   * type ValidColor = 'blue' | 'red' | 'yellow';
   * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
   *
   * const isValidColor: ValidColorTypeCheck =
   *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
   *
   * const buttonColor: ValidColor = client.getLayerValue(
   *    'example-layer-name',
   *    'backgroundColor',
   *    'yellow',
   *    {
   *        typeGuard: isValidColor
   *    }
   * );
   * ```
   */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    constructor({ localStorageKey: localStorageKey = (0, $iVeJ7.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.statsigClient = void 0;
        this.user = void 0;
        this.initOptions = void 0;
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ this.initWithDefaults = false;
        this.currentIdentifiers = void 0;
        this.currentAttributes = void 0;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.provider = void 0;
        this.subscriptions = new (0, $4Mp9u.default)();
        this.dataAdapter = new (0, $1DPjW.NoFetchDataAdapter)();
        this.overrideAdapter = void 0;
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $iVeJ7.PersistentOverrideAdapter)(localStorageKey);
    }
}

});
parcelRegister("4Mp9u", function(module, exports) {

$parcel$export(module.exports, "default", () => $06378c6481821a0e$export$2e2bcd8739ae039);

var $aD3QS = parcelRequire("aD3QS");
const $06378c6481821a0e$export$a66cbd9b2289cd78 = '@all-features';
class $06378c6481821a0e$export$2e2bcd8739ae039 {
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($06378c6481821a0e$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($06378c6481821a0e$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($06378c6481821a0e$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $06378c6481821a0e$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
    constructor(){
        this.emitter = void 0;
        this.eventToValue = new Map();
        this.emitter = new (0, $aD3QS.EventEmitter2)();
    }
}

});

parcelRegister("kWb5j", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", () => $83240849c9194eb7$export$6dc24881a3d96325);

var $dYDWA = parcelRequire("dYDWA");
class $83240849c9194eb7$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        const config = new $83240849c9194eb7$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $dYDWA.migrateEvaluationDetails)(experiment.details), (0, $dYDWA.migrateSecondaryExposures)(experiment.__evaluation?.secondary_exposures ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            this._onDefaultValueFallback?.(this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        this._onDefaultValueFallback?.(this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = void 0;
        this._name = void 0;
        this._ruleID = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._secondaryExposures = void 0;
        this._allocatedExperimentName = void 0;
        this._evaluationDetails = void 0;
        this._onDefaultValueFallback = void 0;
        this.experiment = void 0;
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
}

});
parcelRegister("dYDWA", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", () => $1e37ba36f51c6658$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $1e37ba36f51c6658$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $1e37ba36f51c6658$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $1e37ba36f51c6658$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $1e37ba36f51c6658$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $1e37ba36f51c6658$export$55fd683752d01e67);

var $lzcvT = parcelRequire("lzcvT");

var $3Fnbb = parcelRequire("3Fnbb");

var $7OROP = parcelRequire("7OROP");
const $1e37ba36f51c6658$export$d119b37e5f788b43 = (options)=>({
        /**
	 * If more federal PerimeterTypes are added in the future, this should be updated so
	 * that isFedRamp() === true always returns the strictest perimeter.
	 */ perimeter: (0, $lzcvT.isFedRamp)() ? (0, $7OROP.PerimeterType).FEDRAMP_MODERATE : (0, $7OROP.PerimeterType).COMMERCIAL,
        ...options
    });
const $1e37ba36f51c6658$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};
const $1e37ba36f51c6658$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    const user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
const $1e37ba36f51c6658$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};
const $1e37ba36f51c6658$var$evaluationReasonMappings = Object.entries((0, $3Fnbb.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $1e37ba36f51c6658$export$18ad168d3dbac899 = (details)=>{
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: $1e37ba36f51c6658$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))?.[1] ?? (0, $3Fnbb.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};
const $1e37ba36f51c6658$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("lzcvT", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $72d6d9b79d5ad30d$export$64d6499adf9b2e51);

var $g46Dm = parcelRequire("g46Dm");
function $72d6d9b79d5ad30d$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $g46Dm.FEDRAMP_MODERATE);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("g46Dm", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $70009cc17afae0c4$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $70009cc17afae0c4$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "FEDRAMP_FEDEX", () => $70009cc17afae0c4$export$bd6b5a7802d76127);
$parcel$export(module.exports, "STAGING", () => $70009cc17afae0c4$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $70009cc17afae0c4$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $70009cc17afae0c4$export$404582bc18fe4d9e);
const $70009cc17afae0c4$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $70009cc17afae0c4$export$f005e2e9f707cb5f = 'commercial';
const $70009cc17afae0c4$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $70009cc17afae0c4$export$a739cd5aac835909 = 'stg';
const $70009cc17afae0c4$export$42dd0cdd351a4a9 = 'prod';
const $70009cc17afae0c4$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("3Fnbb", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", () => $bf64b280dc5c1dad$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $bf64b280dc5c1dad$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({});

});

parcelRegister("7OROP", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", () => $c6e78d3b2e417294$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $c6e78d3b2e417294$export$c42b7bbc5e7ba555);
var $c6e78d3b2e417294$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $c6e78d3b2e417294$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
const $c6e78d3b2e417294$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("iGqJ3", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $4d5e0688f3ef3f8c$export$936d0764594b6eb3);

var $dYDWA = parcelRequire("dYDWA");
class $4d5e0688f3ef3f8c$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        const value = new $4d5e0688f3ef3f8c$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $dYDWA.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $dYDWA.migrateSecondaryExposures)(layer.__evaluation?.secondary_exposures ?? []), (0, $dYDWA.migrateSecondaryExposures)(layer.__evaluation?.undelegated_secondary_exposures ?? []), layer.__evaluation?.allocated_experiment_name, layer.__evaluation?.explicit_parameters);
        return value;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        this._logParameterFunction?.(this, parameterName);
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._name = void 0;
        this._value = void 0;
        this._ruleID = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._secondaryExposures = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._undelegatedSecondaryExposures = void 0;
        this._allocatedExperimentName = void 0;
        this._explicitParameters = void 0;
        this._evaluationDetails = void 0;
        this._logParameterFunction = void 0;
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
}

});

parcelRegister("1ej3u", function(module, exports) {

$parcel$export(module.exports, "default", () => $7919757618009ac3$export$2e2bcd8739ae039);

var $7OROP = parcelRequire("7OROP");

var $hEUUD = parcelRequire("hEUUD");

var $lrQOC = parcelRequire("lrQOC");
const $7919757618009ac3$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $7919757618009ac3$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $7919757618009ac3$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $7919757618009ac3$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $7919757618009ac3$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $7919757618009ac3$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $7919757618009ac3$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $7919757618009ac3$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $lrQOC.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $lrQOC.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter) {
        if (useGatewayUrl) return $7919757618009ac3$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $7OROP.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $7OROP.FeatureGateEnvironment).Production:
                return $7919757618009ac3$export$18c93900db9358a4;
            case (0, $7OROP.FeatureGateEnvironment).Staging:
                return $7919757618009ac3$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $7OROP.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $7OROP.FeatureGateEnvironment).Development:
                return $7919757618009ac3$export$f058dbf75c3bc647;
            case (0, $7OROP.FeatureGateEnvironment).Staging:
                return $7919757618009ac3$export$942ba04389b0d5a2;
            default:
                return $7919757618009ac3$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $7919757618009ac3$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $7919757618009ac3$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $hEUUD.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
}

});
parcelRegister("hEUUD", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", () => $1f4159c5567c1673$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $1f4159c5567c1673$export$a59f8d67326bd1cb = "0.0.0-use.local";

});

parcelRegister("lrQOC", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $1189bd9dc67f1683$export$286baf652d0b1206);
class $1189bd9dc67f1683$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("1DPjW", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", () => $437a381907a752dd$export$55fffef3474104af);

var $hLr0l = parcelRequire("hLr0l");
class $437a381907a752dd$export$55fffef3474104af extends (0, $hLr0l.DataAdapterCore) {
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $hLr0l.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $hLr0l._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $hLr0l._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $hLr0l._getStorageKey)(this._getSdkKey(), user);
        return `${0, $hLr0l.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
    constructor(){
        super('NoFetchDataAdapter', 'nofetch');
        this.bootstrapResult = null;
    }
}

});

parcelRegister("iVeJ7", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $944e02537a6d683d$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $944e02537a6d683d$export$bcb28fbac1def494);

var $9ha2C = parcelRequire("9ha2C");
const $944e02537a6d683d$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $944e02537a6d683d$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $944e02537a6d683d$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $944e02537a6d683d$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $944e02537a6d683d$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $944e02537a6d683d$export$bcb28fbac1def494 {
    parseStoredOverrides(localStorageKey) {
        try {
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $944e02537a6d683d$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $944e02537a6d683d$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $944e02537a6d683d$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($944e02537a6d683d$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            window.localStorage.removeItem($944e02537a6d683d$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $9ha2C._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$944e02537a6d683d$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($944e02537a6d683d$var$djb2MapKey((0, $9ha2C._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($944e02537a6d683d$var$djb2MapKey((0, $9ha2C._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($944e02537a6d683d$var$djb2MapKey((0, $9ha2C._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($944e02537a6d683d$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $944e02537a6d683d$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($944e02537a6d683d$var$djb2MapKey((0, $9ha2C._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($944e02537a6d683d$var$djb2MapKey((0, $9ha2C._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($944e02537a6d683d$var$djb2MapKey((0, $9ha2C._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($944e02537a6d683d$var$djb2MapKey((0, $9ha2C._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($944e02537a6d683d$var$djb2MapKey((0, $9ha2C._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($944e02537a6d683d$var$djb2MapKey((0, $9ha2C._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $944e02537a6d683d$var$makeEmptyStore();
        try {
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($944e02537a6d683d$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $9ha2C._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $944e02537a6d683d$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($944e02537a6d683d$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $9ha2C._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $944e02537a6d683d$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    constructor(localStorageKey){
        this._overrides = void 0;
        this._localStorageKey = void 0;
        this._djb2Map = void 0;
        this._overrides = $944e02537a6d683d$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
}

});



parcelRegister("g68Gk", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $537d0f3cd5aa6a0a$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $537d0f3cd5aa6a0a$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $537d0f3cd5aa6a0a$export$47fade9662f71000);

var $liN2H = parcelRequire("liN2H");
const $537d0f3cd5aa6a0a$export$5b78c989c8db2561 = new Map();
const $537d0f3cd5aa6a0a$export$2a5c8df26bb89760 = new Map();
function $537d0f3cd5aa6a0a$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $liN2H.redactValue)(featureFlagValue);
    $537d0f3cd5aa6a0a$export$5b78c989c8db2561.set(featureFlagName, value);
    $537d0f3cd5aa6a0a$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("liN2H", function(module, exports) {

$parcel$export(module.exports, "redactValue", () => $d8474266700c35e0$export$fcc03ee4c944962f);

var $bort6 = parcelRequire("bort6");
function $d8474266700c35e0$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
}
function $d8474266700c35e0$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $d8474266700c35e0$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $d8474266700c35e0$export$7b4abba432e57989(value) {
    return $d8474266700c35e0$var$isString(value) && $d8474266700c35e0$var$startsAsObject(value) || $d8474266700c35e0$var$isObject(value);
}
function $d8474266700c35e0$export$fcc03ee4c944962f(featureFlagValue) {
    return $d8474266700c35e0$export$7b4abba432e57989(featureFlagValue) ? (0, $bort6.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("bort6", function(module, exports) {

$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $a1f27f7c28cc6bf7$export$42f4885608027d0c);
const $a1f27f7c28cc6bf7$export$42f4885608027d0c = 'non_boolean';

});




parcelRegister("1iSzD", function(module, exports) {

$parcel$export(module.exports, "isEmbeddedConfluence_DO_NOT_USE", () => $f673983857dd97cf$export$9c21f25960873ecb);

var $jiJCD = parcelRequire("jiJCD");

var $kUvaU = parcelRequire("kUvaU");
const $f673983857dd97cf$export$9c21f25960873ecb = (location)=>{
    if (!location) location = window.location;
    const { query: query } = (0, (/*@__PURE__*/$parcel$interopDefault($jiJCD))).parse(location.search, true);
    return query.embedded === 'true' || Boolean(query.parentProduct) || (0, $kUvaU.isEmbeddedConfluenceInIframe_DO_NOT_USE)();
};

});
parcelRegister("kUvaU", function(module, exports) {

$parcel$export(module.exports, "isEmbeddedConfluenceInIframe_DO_NOT_USE", () => $6897d68cb85ce934$export$8195e508b27d5978);

var $3XKuW = parcelRequire("3XKuW");

var $diaaX = parcelRequire("diaaX");
const $6897d68cb85ce934$export$8195e508b27d5978 = ()=>Boolean(window?.frameElement?.[0, $3XKuW.EP_REACT_PROPS_OBSERVABLE_OBJECT]) || window?.name.includes((0, $diaaX.CHANNEL_NAME));

});
parcelRegister("3XKuW", function(module, exports) {

$parcel$export(module.exports, "EP_REACT_PROPS_OBSERVABLE_OBJECT", () => $4186db0e7e18f734$export$cdb0163d35da79f3);

var $eFNS0 = parcelRequire("eFNS0");
const $4186db0e7e18f734$export$cdb0163d35da79f3 = '__EP_REACT_PROPS_OBSERVABLE_OBJECT__';

});
parcelRegister("eFNS0", function(module, exports) {

$parcel$export(module.exports, "ObservableObject", () => $6be6b2d330604e6b$export$b176171395436676);
class $6be6b2d330604e6b$export$b176171395436676 {
    subscribe(fn) {
        this._observers.push(fn);
        return ()=>this.unsubscribe(fn);
    }
    unsubscribe(fn) {
        this._observers = this._observers.filter((observerFn)=>fn !== observerFn);
    }
    notify() {
        this._observers.forEach((observerFn)=>observerFn.call(this));
    }
    get object() {
        return this._object;
    }
    set object(value) {
        this._object = value;
        this.notify();
    }
    constructor(){
        this._observers = void 0;
        this._object = void 0;
        this._observers = [];
        this._object = null;
    }
}

});


parcelRegister("diaaX", function(module, exports) {

$parcel$export(module.exports, "CHANNEL_NAME", () => $53fc47f1270327a6$export$ab9998995666ebe3);
$parcel$export(module.exports, "PASSTHROUGH_PROPS_MODULE_NAME", () => $53fc47f1270327a6$export$45b0adb7f9689286);
$parcel$export(module.exports, "PROPS_UPDATED", () => $53fc47f1270327a6$export$78cada8c8749e264);
$parcel$export(module.exports, "EXPERIENCE_FORWARDING_MODULE_NAME", () => $53fc47f1270327a6$export$b75934a6b56fd9ba);
const $53fc47f1270327a6$export$ab9998995666ebe3 = 'embedded-confluence-iframe';
const $53fc47f1270327a6$export$45b0adb7f9689286 = 'passThroughProps';
const $53fc47f1270327a6$export$78cada8c8749e264 = 'propsUpdated';
const $53fc47f1270327a6$export$b75934a6b56fd9ba = 'experienceForwarding';

});



parcelRegister("1haRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58ecef6d8b05339$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $a58ecef6d8b05339$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $a58ecef6d8b05339$export$2e2bcd8739ae039 = $a58ecef6d8b05339$var$coinflip;

});

parcelRegister("53d5Q", function(module, exports) {

$parcel$export(module.exports, "setUFOConfig", () => $2ab671efdff53c35$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $2ab671efdff53c35$export$44487a86467333c3);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $2ab671efdff53c35$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $2ab671efdff53c35$export$70184d6e2c753893);
$parcel$export(module.exports, "getInteractionRate", () => $2ab671efdff53c35$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "getExperimentalInteractionRate", () => $2ab671efdff53c35$export$563f73272328c0d);
$parcel$export(module.exports, "getPostInteractionRate", () => $2ab671efdff53c35$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $2ab671efdff53c35$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $2ab671efdff53c35$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $2ab671efdff53c35$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $2ab671efdff53c35$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $2ab671efdff53c35$export$d6dc9444bd15f70f);
let $2ab671efdff53c35$var$config;
const $2ab671efdff53c35$var$DEFAULT_TTVC_REVISION = 'fy25.02';
function $2ab671efdff53c35$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = newConfig?.vc ?? {};
    if (typeof enabledVCRevisions?.byExperience === 'object') $2ab671efdff53c35$var$config = {
        ...newConfig,
        vc: {
            ...newConfig.vc,
            enabledVCRevisions: {
                // enforce axiom about `enabledVCRevisions.all` config
                all: Array.from(new Set([
                    $2ab671efdff53c35$var$DEFAULT_TTVC_REVISION,
                    ...enabledVCRevisions?.all,
                    ...Object.values(enabledVCRevisions?.byExperience).flat()
                ])),
                byExperience: {
                    ...enabledVCRevisions?.byExperience
                }
            }
        }
    };
    else $2ab671efdff53c35$var$config = newConfig;
}
function $2ab671efdff53c35$export$44487a86467333c3() {
    return $2ab671efdff53c35$var$config;
}
const $2ab671efdff53c35$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $2ab671efdff53c35$export$87fbc8e01b137811(experienceKey = '') {
    try {
        if (!$2ab671efdff53c35$var$config) return [];
        if ($2ab671efdff53c35$var$config.vc?.enabled) {
            const { enabledVCRevisions: enabledVCRevisions } = $2ab671efdff53c35$var$config.vc ?? {};
            if ($2ab671efdff53c35$var$isValidConfigArray(enabledVCRevisions?.byExperience?.[experienceKey])) return enabledVCRevisions.byExperience?.[experienceKey];
            if ($2ab671efdff53c35$var$isValidConfigArray(enabledVCRevisions?.all)) return enabledVCRevisions.all;
            return [
                $2ab671efdff53c35$var$DEFAULT_TTVC_REVISION
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $2ab671efdff53c35$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $2ab671efdff53c35$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $2ab671efdff53c35$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $2ab671efdff53c35$export$87fbc8e01b137811(experienceKey);
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $2ab671efdff53c35$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$2ab671efdff53c35$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $2ab671efdff53c35$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $2ab671efdff53c35$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$2ab671efdff53c35$var$config) return 0;
        const { experimentalInteractionMetrics: experimentalInteractionMetrics } = $2ab671efdff53c35$var$config;
        if (!experimentalInteractionMetrics?.enabled) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $2ab671efdff53c35$export$1d459f020c06ae34(name, interactionType) {
    try {
        if (!$2ab671efdff53c35$var$config) return 0;
        const { postInteractionLog: postInteractionLog } = $2ab671efdff53c35$var$config;
        if (!postInteractionLog?.enabled) return 0;
        if (postInteractionLog.rates && typeof postInteractionLog.rates[name] === 'number') return postInteractionLog.rates[name];
        if (postInteractionLog.kind && typeof postInteractionLog.kind[interactionType] === 'number') return postInteractionLog.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $2ab671efdff53c35$export$29b9ffb14861a1d(capability) {
    try {
        if (!$2ab671efdff53c35$var$config) return 0;
        const { capability: capabilityRate } = $2ab671efdff53c35$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
const $2ab671efdff53c35$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $2ab671efdff53c35$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$2ab671efdff53c35$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $2ab671efdff53c35$var$config;
        if (typingMethod != null && $2ab671efdff53c35$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $2ab671efdff53c35$export$2d311b3fd18dcab1() {
    try {
        if (!$2ab671efdff53c35$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $2ab671efdff53c35$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $2ab671efdff53c35$export$e2ea675800536898() {
    try {
        if (!$2ab671efdff53c35$var$config) return false;
        const { removePageSegmentsUFOPrefixes: removePageSegmentsUFOPrefixes } = $2ab671efdff53c35$var$config;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $2ab671efdff53c35$export$525ba53ca98e9db() {
    try {
        if (!$2ab671efdff53c35$var$config) return false;
        const { removeInteractionsUFOPrefixes: removeInteractionsUFOPrefixes } = $2ab671efdff53c35$var$config;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $2ab671efdff53c35$export$4f4649ef27b6f5d6() {
    try {
        if (!$2ab671efdff53c35$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $2ab671efdff53c35$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $2ab671efdff53c35$export$3c170167645a0eff() {
    try {
        if (!$2ab671efdff53c35$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $2ab671efdff53c35$var$config;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $2ab671efdff53c35$export$d6dc9444bd15f70f() {
    try {
        if (!$2ab671efdff53c35$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $2ab671efdff53c35$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}

});

parcelRegister("lMdlY", function(module, exports) {

$parcel$export(module.exports, "setInteractionActiveTrace", () => $4dec21a3dc57ba14$export$f2e521e495a88544);
$parcel$export(module.exports, "setActiveTrace", () => $4dec21a3dc57ba14$export$a1002be327997103);
$parcel$export(module.exports, "getActiveTrace", () => $4dec21a3dc57ba14$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $4dec21a3dc57ba14$export$17ab21d7be720b);
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $4dec21a3dc57ba14$export$6e17cce6446848f9);
$parcel$export(module.exports, "getActiveTraceAsQueryParams", () => $4dec21a3dc57ba14$export$a1e7396778592551);

var $gk7JT = parcelRequire("gk7JT");
const $4dec21a3dc57ba14$var$state = {
    context: null
};
function $4dec21a3dc57ba14$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $4dec21a3dc57ba14$export$f2e521e495a88544(interactionId, experienceType) {
    $4dec21a3dc57ba14$export$a1002be327997103(interactionId.replace(/-/g, ''), $4dec21a3dc57ba14$export$295213bc4d0c54ad(), experienceType);
}
function $4dec21a3dc57ba14$export$a1002be327997103(traceId, spanId, type) {
    $4dec21a3dc57ba14$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $4dec21a3dc57ba14$export$b6ac780db3a3cc77() {
    return $4dec21a3dc57ba14$var$state.context || undefined;
}
function $4dec21a3dc57ba14$export$17ab21d7be720b() {
    $4dec21a3dc57ba14$var$state.context = null;
}
function $4dec21a3dc57ba14$export$6e17cce6446848f9(_url) {
    if ($4dec21a3dc57ba14$var$state.context === null) return null;
    const { traceId: traceId, spanId: spanId } = $4dec21a3dc57ba14$var$state.context;
    return (0, $gk7JT.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function $4dec21a3dc57ba14$export$a1e7396778592551(_url) {
    const traceHeaders = $4dec21a3dc57ba14$export$6e17cce6446848f9(_url);
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

});
parcelRegister("gk7JT", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $42b5f5931b7891aa$export$1115c5277eb10d5e);
function $42b5f5931b7891aa$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("9x4nt", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b539692aab07d21$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useInteractionContext", () => $2b539692aab07d21$export$11bcb6e9af2aca35);

var $gwFzn = parcelRequire("gwFzn");

var $90YwQ = parcelRequire("90YwQ");
var $2b539692aab07d21$export$2e2bcd8739ae039 = (0, $90YwQ.default);
function $2b539692aab07d21$export$11bcb6e9af2aca35() {
    return (0, $gwFzn.useContext)((0, $90YwQ.default));
}

});
parcelRegister("90YwQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ca7c9a0a318ac25$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
var $2ca7c9a0a318ac25$export$2e2bcd8739ae039 = (0, $gwFzn.createContext)(null);

});


parcelRegister("feexy", function(module, exports) {

$parcel$export(module.exports, "DefaultInteractionID", () => $2119f5c3d305813e$export$3109542b68df9ba1);
$parcel$export(module.exports, "default", () => $2119f5c3d305813e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getInteractionId", () => $2119f5c3d305813e$export$37bca3107733ac1e);

var $gwFzn = parcelRequire("gwFzn");
const $2119f5c3d305813e$export$3109542b68df9ba1 = {
    current: null
};
var // We use a context to allow modals to have their own lifecycle
$2119f5c3d305813e$export$2e2bcd8739ae039 = (0, $gwFzn.createContext)($2119f5c3d305813e$export$3109542b68df9ba1);
const $2119f5c3d305813e$export$37bca3107733ac1e = ()=>$2119f5c3d305813e$export$3109542b68df9ba1;
const $2119f5c3d305813e$export$9f6000531b78127e = ()=>$2119f5c3d305813e$export$3109542b68df9ba1;

});

parcelRegister("4u5NT", function(module, exports) {

$parcel$export(module.exports, "postInteractionLog", () => $ffef50b38ff136d5$export$d8f52e8f804021e8);
$parcel$export(module.exports, "getActiveInteraction", () => $ffef50b38ff136d5$export$2b3954d2e8509985);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $ffef50b38ff136d5$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addCustomData", () => $ffef50b38ff136d5$export$e4380431c2bdabee);
$parcel$export(module.exports, "addCustomTiming", () => $ffef50b38ff136d5$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $ffef50b38ff136d5$export$728e28c22a0fba4);
$parcel$export(module.exports, "addSpan", () => $ffef50b38ff136d5$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $ffef50b38ff136d5$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "addHold", () => $ffef50b38ff136d5$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $ffef50b38ff136d5$export$10582acd678c213);
$parcel$export(module.exports, "removeHoldByID", () => $ffef50b38ff136d5$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "getCurrentInteractionType", () => $ffef50b38ff136d5$export$2df109852219d16e);
$parcel$export(module.exports, "addError", () => $ffef50b38ff136d5$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $ffef50b38ff136d5$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $ffef50b38ff136d5$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $ffef50b38ff136d5$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $ffef50b38ff136d5$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $ffef50b38ff136d5$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $ffef50b38ff136d5$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $ffef50b38ff136d5$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $ffef50b38ff136d5$export$614a7af2affc5dff);
$parcel$export(module.exports, "addOnCancelCallback", () => $ffef50b38ff136d5$export$7b9261a96cfe427b);
$parcel$export(module.exports, "addNewInteraction", () => $ffef50b38ff136d5$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $ffef50b38ff136d5$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdex", () => $ffef50b38ff136d5$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $ffef50b38ff136d5$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $ffef50b38ff136d5$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $ffef50b38ff136d5$export$d0365e48b58231c3);
$parcel$export(module.exports, "interactionSpans", () => $ffef50b38ff136d5$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $ffef50b38ff136d5$export$5342dcad19138a1c);

var $9HkI0 = parcelRequire("9HkI0");

var $1haRI = parcelRequire("1haRI");

var $53d5Q = parcelRequire("53d5Q");

var $aqLdL = parcelRequire("aqLdL");

var $lMdlY = parcelRequire("lMdlY");

var $g68Gk = parcelRequire("g68Gk");

var $feexy = parcelRequire("feexy");

var $2DIgf = parcelRequire("2DIgf");

var $5joKL = parcelRequire("5joKL");

var $l4FNC = parcelRequire("l4FNC");
const $ffef50b38ff136d5$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
const $ffef50b38ff136d5$export$d8f52e8f804021e8 = new (0, $l4FNC.default)();
const $ffef50b38ff136d5$var$interactionQueue = [];
const $ffef50b38ff136d5$var$segmentCache = new Map();
const $ffef50b38ff136d5$var$CLEANUP_TIMEOUT = 60000;
const $ffef50b38ff136d5$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
const $ffef50b38ff136d5$var$segmentObservers = [];
function $ffef50b38ff136d5$export$2b3954d2e8509985() {
    const interactionId = (0, $feexy.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $5joKL.interactions).get(interactionId.current);
}
function $ffef50b38ff136d5$var$isPerformanceTracingEnabled() {
    return (0, $53d5Q.getConfig)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $ffef50b38ff136d5$var$performanceEventObserver;
const $ffef50b38ff136d5$export$17afbba0f16b4b19 = ()=>{
    $ffef50b38ff136d5$var$performanceEventObserver = $ffef50b38ff136d5$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $ffef50b38ff136d5$export$e6be05b411ce21a6(entry);
    });
    return $ffef50b38ff136d5$var$performanceEventObserver;
};
const $ffef50b38ff136d5$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $ffef50b38ff136d5$export$2b3954d2e8509985();
    if (interaction?.type === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $ffef50b38ff136d5$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $ffef50b38ff136d5$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $ffef50b38ff136d5$var$addSegmentObserver(observer) {
    $ffef50b38ff136d5$var$segmentObservers.push(observer);
    for (const segmentInfo of $ffef50b38ff136d5$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $ffef50b38ff136d5$var$removeSegmentObserver(observer) {
    const index = $ffef50b38ff136d5$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $ffef50b38ff136d5$var$segmentObservers.splice(index, 1);
}
function $ffef50b38ff136d5$export$cd7f480d6b8286c3(interactionId) {
    (0, $5joKL.interactions).delete(interactionId);
}
function $ffef50b38ff136d5$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $ffef50b38ff136d5$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $ffef50b38ff136d5$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $ffef50b38ff136d5$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $ffef50b38ff136d5$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(data)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
function $ffef50b38ff136d5$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $ffef50b38ff136d5$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $5joKL.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $ffef50b38ff136d5$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
}
function $ffef50b38ff136d5$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $5joKL.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end
        });
    } catch (e) {
    // do nothing
    }
}
function $ffef50b38ff136d5$export$9e04fe1a58571ec(moduleId, timestamp) {
    $ffef50b38ff136d5$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $ffef50b38ff136d5$export$6f228d1fdc911d7(identifier, start, end) {
    $ffef50b38ff136d5$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $ffef50b38ff136d5$var$moduleLoadingRequests = {};
function $ffef50b38ff136d5$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $ffef50b38ff136d5$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $ffef50b38ff136d5$var$labelStackToString(labelStack), name, startTime);
}
function $ffef50b38ff136d5$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $ffef50b38ff136d5$export$7606887303596f82(interactionId, labelStack, name, experimental) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    const id = (0, $9HkI0.v4)();
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ((0, $53d5Q.getConfig)()?.experimentalInteractionMetrics?.enabled && experimental) interaction.holdExpActive.set(id, {
            ...holdActive,
            start: start
        });
        if (!experimental) interaction.holdActive.set(id, {
            ...holdActive,
            start: start
        });
        $ffef50b38ff136d5$var$addHoldCriterion(id, labelStack, name, start);
        return ()=>{
            const end = performance.now();
            if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end
                });
            } catch (e) {
            // do nothing
            }
            $ffef50b38ff136d5$var$removeHoldCriterion(id);
            const currentInteraction = (0, $5joKL.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            const expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push({
                        ...expHold,
                        end: end
                    });
                    interaction.holdExpActive.delete(id);
                }
            }
        };
    }
    return ()=>{};
}
function $ffef50b38ff136d5$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
        $ffef50b38ff136d5$var$addHoldCriterion(id, labelStack, name, start);
    }
    return ()=>{};
}
function $ffef50b38ff136d5$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $5joKL.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $ffef50b38ff136d5$var$removeHoldCriterion(id);
        }
    }
}
function $ffef50b38ff136d5$export$2df109852219d16e(interactionId) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $ffef50b38ff136d5$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $ffef50b38ff136d5$export$9e04fe1a58571ec($ffef50b38ff136d5$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $ffef50b38ff136d5$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $ffef50b38ff136d5$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $ffef50b38ff136d5$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $ffef50b38ff136d5$var$moduleLoadingRequests[info.identifier];
            $ffef50b38ff136d5$export$6f228d1fdc911d7($ffef50b38ff136d5$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $feexy.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $ffef50b38ff136d5$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $feexy.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $ffef50b38ff136d5$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $ffef50b38ff136d5$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError
    });
}
function $ffef50b38ff136d5$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $5joKL.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
}
function $ffef50b38ff136d5$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration
        });
    } catch (e) {
    // do nothing
    }
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $53d5Q.getConfig)()?.postInteractionLog?.enabled) $ffef50b38ff136d5$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $ffef50b38ff136d5$var$pushToQueue(id, data) {
    $ffef50b38ff136d5$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $ffef50b38ff136d5$var$handleInteraction = $ffef50b38ff136d5$var$pushToQueue;
function $ffef50b38ff136d5$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $ffef50b38ff136d5$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $g68Gk.currentFeatureFlagsAccessed));
    (0, $lMdlY.clearActiveTrace)();
    $ffef50b38ff136d5$var$callCleanUpCallbacks(data);
    if ((0, $53d5Q.getConfig)()?.vc?.stopVCAtInteractionFinish) data.vc = (0, $2DIgf.getVCObserver)().getVCRawData();
    if (!(0, $53d5Q.getConfig)()?.experimentalInteractionMetrics?.enabled) $ffef50b38ff136d5$export$cd7f480d6b8286c3(id);
    $ffef50b38ff136d5$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
    $ffef50b38ff136d5$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) $ffef50b38ff136d5$var$handleInteraction(id, data);
    if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $ffef50b38ff136d5$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (error) {
    // do nothing
    }
}
function $ffef50b38ff136d5$export$9e614a29a1ac213e(sinkFn) {
    if ($ffef50b38ff136d5$var$handleInteraction === $ffef50b38ff136d5$var$pushToQueue) {
        $ffef50b38ff136d5$var$handleInteraction = sinkFn;
        $ffef50b38ff136d5$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $ffef50b38ff136d5$var$interactionQueue.length = 0;
    }
}
function $ffef50b38ff136d5$export$8a1ba7bef607358a(sinkFn) {
    $ffef50b38ff136d5$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $ffef50b38ff136d5$var$activeSubmitted = false;
function $ffef50b38ff136d5$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const noMoreExpHolds = interaction.holdExpActive.size === 0;
        const postInteraction = async ()=>{
            if ((0, $53d5Q.getConfig)()?.postInteractionLog?.enabled) {
                let experimentalVC90;
                let experimentalTTAI;
                if ((0, $53d5Q.getConfig)()?.experimentalInteractionMetrics?.enabled) {
                    experimentalVC90 = (await (0, $aqLdL.getExperimentalVCMetrics)(interaction))?.['metric:experimental:vc90'];
                    const { start: start, end: end } = interaction;
                    experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                }
                $ffef50b38ff136d5$export$d8f52e8f804021e8.onInteractionComplete({
                    ...interaction,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90
                });
            }
            if ((0, $53d5Q.getConfig)()?.experimentalInteractionMetrics?.enabled) $ffef50b38ff136d5$export$cd7f480d6b8286c3(interactionId);
            $ffef50b38ff136d5$var$activeSubmitted = false;
        };
        if (noMoreActiveHolds) {
            if (!$ffef50b38ff136d5$var$activeSubmitted) {
                $ffef50b38ff136d5$var$finishInteraction(interactionId, interaction, endTime);
                $ffef50b38ff136d5$var$activeSubmitted = true;
            }
            if (noMoreExpHolds) {
                if ((0, $53d5Q.getConfig)()?.experimentalInteractionMetrics?.enabled) (0, $aqLdL.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                postInteraction();
            }
        }
    }
}
function $ffef50b38ff136d5$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $ffef50b38ff136d5$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) {
        $ffef50b38ff136d5$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $ffef50b38ff136d5$var$finishInteraction(interactionId, interaction);
        if ((0, $53d5Q.getConfig)()?.experimentalInteractionMetrics?.enabled) {
            (0, $aqLdL.onExperimentalInteractionComplete)(interactionId, interaction);
            $ffef50b38ff136d5$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $ffef50b38ff136d5$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) {
        $ffef50b38ff136d5$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $ffef50b38ff136d5$var$finishInteraction(interactionId, interaction);
        if ((0, $53d5Q.getConfig)()?.experimentalInteractionMetrics?.enabled) {
            (0, $aqLdL.onExperimentalInteractionComplete)(interactionId, interaction);
            $ffef50b38ff136d5$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $ffef50b38ff136d5$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    (0, $5joKL.interactions).forEach((interaction, interactionId)=>{
        const noMoreHolds = interaction.holdActive.size === 0;
        if (!noMoreHolds) {
            $ffef50b38ff136d5$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $ffef50b38ff136d5$var$finishInteraction(interactionId, interaction);
        if ((0, $53d5Q.getConfig)()?.experimentalInteractionMetrics?.enabled) {
            (0, $aqLdL.onExperimentalInteractionComplete)(interactionId, interaction);
            $ffef50b38ff136d5$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $ffef50b38ff136d5$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $5joKL.interactions).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $ffef50b38ff136d5$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    if ((0, $53d5Q.getConfig)()?.postInteractionLog?.enabled) $ffef50b38ff136d5$export$d8f52e8f804021e8.reset();
    let previousTime = startTime;
    let timeoutTime = $ffef50b38ff136d5$var$CLEANUP_TIMEOUT;
    const timerID = setTimeout(()=>{
        $ffef50b38ff136d5$export$5def58af4fd46132(interactionId, 'timeout');
    }, $ffef50b38ff136d5$var$CLEANUP_TIMEOUT);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $ffef50b38ff136d5$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $1haRI.default)((0, $53d5Q.getCapabilityRate)('feature_flag_access'));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $ffef50b38ff136d5$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $ffef50b38ff136d5$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $g68Gk.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace
    };
    if (addFeatureFlagsToInteraction) (0, $g68Gk.currentFeatureFlagsAccessed).clear();
    (0, $5joKL.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $ffef50b38ff136d5$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $ffef50b38ff136d5$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    const awaitBM3TTIList = (0, $53d5Q.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $ffef50b38ff136d5$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition') {
        (0, $2DIgf.getVCObserver)().start({
            startTime: startTime,
            experienceKey: ufoName
        });
        $ffef50b38ff136d5$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((0, $53d5Q.getConfig)()?.experimentalInteractionMetrics?.enabled) (0, $aqLdL.experimentalVC).start({
            startTime: startTime
        });
    }
}
function $ffef50b38ff136d5$export$4a759336b50e86e3(event) {
    const interaction = $ffef50b38ff136d5$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') {
            interaction.changeTimeout($ffef50b38ff136d5$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $ffef50b38ff136d5$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
        }
    }
}
function $ffef50b38ff136d5$export$ad216cc25852d44b(apdex) {
    (0, $5joKL.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($ffef50b38ff136d5$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $ffef50b38ff136d5$export$4983dfbbb996f7ae(key, interaction.ufoName);
        }
    });
}
function $ffef50b38ff136d5$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($ffef50b38ff136d5$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $ffef50b38ff136d5$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
        }
    }
}
function $ffef50b38ff136d5$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $ffef50b38ff136d5$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $ffef50b38ff136d5$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($ffef50b38ff136d5$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $ffef50b38ff136d5$export$1c43f9ac826b6462(labelStack) {
    const key = $ffef50b38ff136d5$var$getSegmentCacheKey(labelStack);
    const existingSegment = $ffef50b38ff136d5$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $ffef50b38ff136d5$var$segmentCache.set(key, segmentInfo);
        $ffef50b38ff136d5$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $ffef50b38ff136d5$export$d0365e48b58231c3(labelStack) {
    const key = $ffef50b38ff136d5$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $ffef50b38ff136d5$var$segmentCache.get(key);
    if (segmentInfo) {
        $ffef50b38ff136d5$var$segmentCache.delete(JSON.stringify(labelStack));
        $ffef50b38ff136d5$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $ffef50b38ff136d5$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $5joKL.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
const $ffef50b38ff136d5$export$6ce04c7ca6810a7e = [];
const $ffef50b38ff136d5$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $ffef50b38ff136d5$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $ffef50b38ff136d5$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $ffef50b38ff136d5$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("aqLdL", function(module, exports) {

$parcel$export(module.exports, "sinkExperimentalHandler", () => $20d47b5b6d735815$export$7aa99c40634ac65f);
$parcel$export(module.exports, "onExperimentalInteractionComplete", () => $20d47b5b6d735815$export$1aed449484dedf63);
$parcel$export(module.exports, "experimentalVC", () => $20d47b5b6d735815$export$81b28dca2587ec47);
$parcel$export(module.exports, "getExperimentalVCMetrics", () => $20d47b5b6d735815$export$d17d2b5c5e8d732e);

var $jJ2Ec = parcelRequire("jJ2Ec");

var $cptoO = parcelRequire("cptoO");
const $20d47b5b6d735815$var$interactionBuffer = [];
let $20d47b5b6d735815$var$bufferInteractionData = (interactionId, data)=>{
    $20d47b5b6d735815$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $20d47b5b6d735815$var$clearInteractionBuffer() {
    $20d47b5b6d735815$var$interactionBuffer.length = 0;
}
function $20d47b5b6d735815$var$appendInteractionData(interactionId, data) {
    $20d47b5b6d735815$var$bufferInteractionData(interactionId, data);
}
function $20d47b5b6d735815$export$c8a9e17ae62a073d(handler) {
    for (const { interactionId: interactionId, data: data } of $20d47b5b6d735815$var$interactionBuffer)handler(interactionId, data);
    $20d47b5b6d735815$var$clearInteractionBuffer();
    $20d47b5b6d735815$var$bufferInteractionData = handler;
}
function $20d47b5b6d735815$export$7aa99c40634ac65f(sinkFn) {
    $20d47b5b6d735815$export$c8a9e17ae62a073d(sinkFn);
}
function $20d47b5b6d735815$export$1aed449484dedf63(interactionId, data, endTime = performance.now()) {
    if (data.ufoName) {
        data.end = endTime;
        $20d47b5b6d735815$var$appendInteractionData(interactionId, data);
        $20d47b5b6d735815$var$clearInteractionBuffer();
    }
}
class $20d47b5b6d735815$export$f9a59f57e0282541 {
    initialize(options) {
        if (this.vcObserver === null) this.vcObserver = new (0, $cptoO.VCObserver)({
            ...options,
            isPostInteraction: true
        });
        return this;
    }
    start({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    constructor(){
        this.vcObserver = null;
    }
}
const $20d47b5b6d735815$export$81b28dca2587ec47 = new $20d47b5b6d735815$export$f9a59f57e0282541();
async function $20d47b5b6d735815$export$d17d2b5c5e8d732e(interaction) {
    if ($20d47b5b6d735815$export$81b28dca2587ec47.vcObserver) {
        const prefix = 'ufo-experimental';
        const result = await $20d47b5b6d735815$export$81b28dca2587ec47.vcObserver.getVCResult({
            start: interaction.start,
            stop: interaction.end,
            tti: interaction.apdex?.[0]?.stopTime,
            isEventAborted: !!interaction.abortReason,
            prefix: prefix,
            vc: interaction.vc,
            experienceKey: interaction.ufoName,
            interactionId: interaction.id
        });
        const VC = result?.['metrics:vc'];
        if (!VC || !result?.[`${prefix}:vc:clean`]) return result;
        const pageVisibilityUpToTTAI = (0, $jJ2Ec.getPageVisibilityState)(interaction.start, interaction.end);
        if (interaction.abortReason || pageVisibilityUpToTTAI !== 'visible') return result;
        return {
            ...result,
            'metric:experimental:vc90': VC['90']
        };
    }
    return null;
}

});
parcelRegister("jJ2Ec", function(module, exports) {

$parcel$export(module.exports, "setupHiddenTimingCapture", () => $b3ecb6ba1f66206b$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $b3ecb6ba1f66206b$export$768b2008623433e1);

var $d8F95 = parcelRequire("d8F95");
const $b3ecb6ba1f66206b$var$timings = [];
let $b3ecb6ba1f66206b$var$wasHiddenFlag;
let $b3ecb6ba1f66206b$var$setupFlag = false;
function $b3ecb6ba1f66206b$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $b3ecb6ba1f66206b$var$SIZE = 50;
let $b3ecb6ba1f66206b$var$insertIndex = 0;
function $b3ecb6ba1f66206b$var$pushHidden(isPageHiddenFlag, time) {
    $b3ecb6ba1f66206b$var$timings[$b3ecb6ba1f66206b$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $b3ecb6ba1f66206b$var$insertIndex = ($b3ecb6ba1f66206b$var$insertIndex + 1) % $b3ecb6ba1f66206b$var$SIZE;
    $b3ecb6ba1f66206b$var$wasHiddenFlag = isPageHiddenFlag;
}
function $b3ecb6ba1f66206b$var$handleChange() {
    const isPageHiddenFlag = $b3ecb6ba1f66206b$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$b3ecb6ba1f66206b$var$wasHiddenFlag) $b3ecb6ba1f66206b$var$pushHidden(isPageHiddenFlag);
        $b3ecb6ba1f66206b$var$wasHiddenFlag = true;
    } else {
        if ($b3ecb6ba1f66206b$var$wasHiddenFlag) $b3ecb6ba1f66206b$var$pushHidden(isPageHiddenFlag);
        $b3ecb6ba1f66206b$var$wasHiddenFlag = false;
    }
}
function $b3ecb6ba1f66206b$var$setup() {
    (0, $d8F95.bind)(window, {
        type: 'pageshow',
        listener: $b3ecb6ba1f66206b$var$handleChange
    });
    (0, $d8F95.bind)(window, {
        type: 'pagehide',
        listener: $b3ecb6ba1f66206b$var$handleChange
    });
    (0, $d8F95.bind)(document, {
        type: 'visibilitychange',
        listener: $b3ecb6ba1f66206b$var$handleChange
    });
}
function $b3ecb6ba1f66206b$export$554cefe0f0373da4() {
    if (!$b3ecb6ba1f66206b$var$setupFlag) {
        const isPageHiddenFlag = $b3ecb6ba1f66206b$var$isPageHidden();
        $b3ecb6ba1f66206b$var$pushHidden(isPageHiddenFlag, 0);
        $b3ecb6ba1f66206b$var$setup();
        $b3ecb6ba1f66206b$var$setupFlag = true;
    }
}
function $b3ecb6ba1f66206b$export$768b2008623433e1(start, end) {
    // Desirable default value is visible
    if ($b3ecb6ba1f66206b$var$timings.length === 0) return 'visible';
    const currentSize = $b3ecb6ba1f66206b$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $b3ecb6ba1f66206b$var$insertIndex;
    let endIdx = $b3ecb6ba1f66206b$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($b3ecb6ba1f66206b$var$insertIndex + i) % currentSize;
        if ($b3ecb6ba1f66206b$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($b3ecb6ba1f66206b$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    if (endIdx - startIdx === 0) {
        if ($b3ecb6ba1f66206b$var$timings[startIdx].hidden) hiddenState = 'hidden';
        else hiddenState = 'visible';
    }
    return hiddenState;
}

});

parcelRegister("cptoO", function(module, exports) {

$parcel$export(module.exports, "VCObserver", () => $04f37cea0d8299f4$export$1f70d263701b1d01);

var $dh538 = parcelRequire("dh538");

var $53d5Q = parcelRequire("53d5Q");

var $4u5NT = parcelRequire("4u5NT");

var $2EYDP = parcelRequire("2EYDP");

var $cFH2U = parcelRequire("cFH2U");

var $3UFtu = parcelRequire("3UFtu");

var $elyOj = parcelRequire("elyOj");

var $agUA5 = parcelRequire("agUA5");
const $04f37cea0d8299f4$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $04f37cea0d8299f4$var$UNUSED_SECTOR = 0;
function $04f37cea0d8299f4$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $04f37cea0d8299f4$export$1f70d263701b1d01 {
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $04f37cea0d8299f4$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport }) {
        const lastUpdate = {};
        let totalPainted = 0;
        if (ssr !== $04f37cea0d8299f4$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssr]) componentsLog[ssr] = [];
            componentsLog[ssr].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $04f37cea0d8299f4$var$UNUSED_SECTOR && ssr !== $04f37cea0d8299f4$var$UNUSED_SECTOR ? ssr : entry);
                totalPainted += rounded !== $04f37cea0d8299f4$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $04f37cea0d8299f4$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $04f37cea0d8299f4$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $04f37cea0d8299f4$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $04f37cea0d8299f4$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $04f37cea0d8299f4$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $53d5Q.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($04f37cea0d8299f4$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $elyOj.getViewportWidth)();
        this.viewport.h = (0, $elyOj.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($04f37cea0d8299f4$var$abortReason.error, time, `index - ${row}`);
                } catch (e) {
                    this.setAbortReason($04f37cea0d8299f4$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $04f37cea0d8299f4$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.heatmap = void 0;
        this.heatmapNext = void 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this.observers = void 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.devToolsEnabled = void 0;
        this.oldDomUpdatesEnabled = void 0;
        this.unbind = [];
        this.isPostInteraction = void 0;
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $53d5Q.isVCRevisionEnabled)('fy25.01', experienceKey);
            // NOTE: as part of platform_ufo_add_vc_abort_reason_by_revisions feature,
            // we want to report abort by scroll events the same way as other abort reasons
            // i.e. not have the concept of `abortReason.blocking` anymore
            if (abortReasonInfo !== null && (0, $dh538.fg)('platform_ufo_add_vc_abort_reason_by_revisions')) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch (e) {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:state`]: false,
                    [`${fullPrefix}vc:abort:reason`]: abortReason.reason,
                    [`${fullPrefix}vc:abort:timestamp`]: abortReason.timestamp,
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason
                });
                return vcAbortedResultWithRevisions;
            } else if (abortReasonInfo !== null && abortReason.blocking) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch (e) {}
                return {
                    [`${fullPrefix}vc:state`]: false,
                    [`${fullPrefix}vc:abort:reason`]: abortReasonInfo,
                    [`${fullPrefix}vc:abort:timestamp`]: abortReason.timestamp
                };
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $04f37cea0d8299f4$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $04f37cea0d8299f4$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport
            });
            try {
                if (!this.isPostInteraction) $04f37cea0d8299f4$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                    if (isTTVCv1Disabled) {
                        const duration = vcNext.VC[key];
                        if (duration !== null && duration !== undefined) {
                            performance.measure(`VC${key}`, {
                                start: start,
                                duration: duration
                            });
                            performance.measure(`VC_Next${key}`, {
                                start: start,
                                duration: duration
                            });
                        }
                    } else {
                        const ttvcV1duration = VC[key];
                        if (ttvcV1duration !== null && ttvcV1duration !== undefined) performance.measure(`VC${key}`, {
                            start: start,
                            duration: ttvcV1duration
                        });
                        const ttvcV2duration = vcNext.VC[key];
                        if (ttvcV2duration !== null && ttvcV2duration !== undefined) performance.measure(`VC_Next${key}`, {
                            start: start,
                            duration: ttvcV2duration
                        });
                    }
                });
            } catch (e) {
            /* empty */ }
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $04f37cea0d8299f4$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                    // Add devtool callback for both v1 and v2
                    if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' && (0, $dh538.fg)('platform_ufo_ttvc_v3_devtool')) {
                        // Handle v1 if not disabled
                        if (!isTTVCv1Disabled) window.__ufo_devtool_onVCRevisionReady__?.((0, $cFH2U.getVCRevisionDebugDetails)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        }));
                        // Handle v2
                        window.__ufo_devtool_onVCRevisionReady__?.((0, $cFH2U.getVCRevisionDebugDetails)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        }));
                    }
                }
            } catch (e) {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $3UFtu.getVCRevisionsData)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $53d5Q.isVCRevisionEnabled)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $4u5NT.getActiveInteraction)();
                const isTTVCv1Disabled = !(0, $53d5Q.isVCRevisionEnabled)('fy25.01', interaction?.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($04f37cea0d8299f4$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    this.setAbortReason($04f37cea0d8299f4$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($04f37cea0d8299f4$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            let unbinds = (0, $2EYDP.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if (window?.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder } = options;
        this.observers = new (0, $agUA5.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            },
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            }
        });
        this.heatmap = !(0, $53d5Q.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
}
/** config * */ $04f37cea0d8299f4$export$1f70d263701b1d01.VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];

});
parcelRegister("dh538", function(module, exports) {

$parcel$export(module.exports, "setBooleanFeatureFlagResolver", () => $525cfba0b60a0f0c$export$ba05d765b8392e5e);
$parcel$export(module.exports, "getBooleanFF", () => $525cfba0b60a0f0c$export$470e5c2be1411c89);
$parcel$export(module.exports, "fg", () => $525cfba0b60a0f0c$export$b40ec24ac8275656);

var $9Zd5K = parcelRequire("9Zd5K");
function $525cfba0b60a0f0c$export$ba05d765b8392e5e(flagResolver) {
    (0, $9Zd5K.setBooleanResolver)(flagResolver);
}
function $525cfba0b60a0f0c$export$470e5c2be1411c89(name) {
    return (0, $9Zd5K.resolveBooleanFlag)(name);
}
function $525cfba0b60a0f0c$export$b40ec24ac8275656(name) {
    return (0, $9Zd5K.resolveBooleanFlag)(name);
}

});
parcelRegister("9Zd5K", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", () => $11c935177cdc07c6$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $11c935177cdc07c6$export$6333b6aff9fc6275);

var $c6GJD = parcelRequire("c6GJD");

var $8cxK1 = parcelRequire("8cxK1");

var $3mTvL = parcelRequire("3mTvL");
const $11c935177cdc07c6$var$pkgName = '@atlaskit/platform-feature-flags';
const $11c935177cdc07c6$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $11c935177cdc07c6$var$hasProcessEnv = typeof $3mTvL !== 'undefined' && typeof $3mTvL.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
const $11c935177cdc07c6$var$ENV_ENABLE_PLATFORM_FF = $11c935177cdc07c6$var$hasProcessEnv ? false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
const $11c935177cdc07c6$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $11c935177cdc07c6$var$hasProcessEnv ? false : false;
const $11c935177cdc07c6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $11c935177cdc07c6$var$ENV_ENABLE_PLATFORM_FF || $11c935177cdc07c6$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
const $11c935177cdc07c6$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $11c935177cdc07c6$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$11c935177cdc07c6$var$globalVar[$11c935177cdc07c6$export$7e41b1b2bdee3f98] = $11c935177cdc07c6$var$globalVar[$11c935177cdc07c6$export$7e41b1b2bdee3f98] || $11c935177cdc07c6$var$DEFAULT_PFF_GLOBAL;
function $11c935177cdc07c6$export$f2b591175b3e424c(resolver) {
    $11c935177cdc07c6$var$globalVar[$11c935177cdc07c6$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $11c935177cdc07c6$export$6333b6aff9fc6275(flagKey) {
    if ($11c935177cdc07c6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $8cxK1.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $11c935177cdc07c6$var$pkgName, flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ($11c935177cdc07c6$var$globalVar[$11c935177cdc07c6$export$7e41b1b2bdee3f98]?.booleanResolver === undefined || $11c935177cdc07c6$var$globalVar[$11c935177cdc07c6$export$7e41b1b2bdee3f98]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $c6GJD.default).checkGate(flagKey);
        const result = $11c935177cdc07c6$var$globalVar[$11c935177cdc07c6$export$7e41b1b2bdee3f98]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("8cxK1", function(module, exports) {

$parcel$export(module.exports, "debug", () => $bf2538ea95b40513$export$1c9f709888824e05);
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $bf2538ea95b40513$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $bf2538ea95b40513$var$DEBUG_MODE = !$bf2538ea95b40513$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $bf2538ea95b40513$export$1c9f709888824e05 = (...args)=>{
    if (!$bf2538ea95b40513$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});



parcelRegister("cFH2U", function(module, exports) {

$parcel$export(module.exports, "getVCRevisionDebugDetails", () => $33ed54be14546eef$export$72e6dda9d5859230);
function $33ed54be14546eef$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: VCEntries.map((entry)=>({
                time: entry.time,
                viewportPercentage: entry.vc,
                entries: entry.elements.map((element)=>{
                    const logEntry = componentsLog[entry.time]?.find((log)=>log.targetName === element);
                    return {
                        elementName: element,
                        type: logEntry?.type,
                        rect: logEntry?.intersectionRect,
                        visible: true,
                        attributeName: logEntry?.attributeName,
                        oldValue: logEntry?.oldValue,
                        newValue: logEntry?.newValue
                    };
                })
            })),
        interactionId: interactionId
    };
}

});

parcelRegister("3UFtu", function(module, exports) {

$parcel$export(module.exports, "getVCRevisionsData", () => $e9d251734418be78$export$5c86a34c9becd6d0);

var $53d5Q = parcelRequire("53d5Q");

var $jJ2Ec = parcelRequire("jJ2Ec");
const $e9d251734418be78$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $e9d251734418be78$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $e9d251734418be78$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $e9d251734418be78$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $e9d251734418be78$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $e9d251734418be78$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey }) {
    const pageVisibilityUpToTTAI = (0, $jJ2Ec.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $53d5Q.isVCRevisionEnabled)('fy25.01', experienceKey)) availableVCRevisionPayloads.push({
        revision: 'fy25.01',
        clean: isVCClean,
        'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
        vcDetails: $e9d251734418be78$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
    });
    if ((0, $53d5Q.isVCRevisionEnabled)('fy25.02', experienceKey)) availableVCRevisionPayloads.push({
        revision: 'fy25.02',
        clean: isVCClean,
        'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
        vcDetails: $e9d251734418be78$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
    });
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}

});

parcelRegister("agUA5", function(module, exports) {

$parcel$export(module.exports, "Observers", () => $326b3a610770232c$export$b65d046240060e78);

var $IkgpF = parcelRequire("IkgpF");

var $10BiY = parcelRequire("10BiY");

var $dV52u = parcelRequire("dV52u");
const $326b3a610770232c$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $326b3a610770232c$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $326b3a610770232c$export$b65d046240060e78 {
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $326b3a610770232c$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $326b3a610770232c$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $326b3a610770232c$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $326b3a610770232c$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $326b3a610770232c$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $326b3a610770232c$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $IkgpF.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $10BiY.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $IkgpF.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch (e) {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if (!$326b3a610770232c$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch (e) {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(opts){
        this.intersectionObserver = void 0;
        this.mutationObserver = void 0;
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssrPlaceholderHandler = void 0;
        this.ssr = {
            state: $326b3a610770232c$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        this.selectorConfig = {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        this.ssrPlaceholderHandler = new (0, $dV52u.SSRPlaceholderHandlers)(opts.SSRConfig?.enablePageLayoutPlaceholder);
    }
}

});
parcelRegister("IkgpF", function(module, exports) {

$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $32fda68705ce6e9f$export$f61fbc3b9c4a9019);

var $gxsT9 = parcelRequire("gxsT9");
function $32fda68705ce6e9f$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $gxsT9.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("gxsT9", function(module, exports) {

$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $544e044791cfaa0b$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $544e044791cfaa0b$export$7028e9efe569888c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $544e044791cfaa0b$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $544e044791cfaa0b$export$7028e9efe569888c = {
    [$544e044791cfaa0b$export$7674290405cc25b0]: true
};
function $544e044791cfaa0b$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ...$544e044791cfaa0b$export$7028e9efe569888c,
        children: children
    });
}

});


parcelRegister("10BiY", function(module, exports) {

$parcel$export(module.exports, "default", () => $01f78ad7890991d7$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $01f78ad7890991d7$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $01f78ad7890991d7$export$2e2bcd8739ae039 = $01f78ad7890991d7$var$isNonVisualStyleMutation;

});

parcelRegister("dV52u", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $396431ece6ae946e$export$c0102f1a1198d10f);
const $396431ece6ae946e$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $396431ece6ae946e$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $396431ece6ae946e$export$c0102f1a1198d10f {
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $396431ece6ae946e$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            this.intersectionObserver?.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    hasSameSizePosition(rect, boundingClientRect) {
        return rect && Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD || false;
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
    constructor(enablePageLayoutPlaceholder = false){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.intersectionObserver = void 0;
        this.EQUALITY_THRESHOLD = 1;
        this.enablePageLayoutPlaceholder = void 0;
        this.getPlaceholderId = (el)=>{
            const ssrPlaceholderId = el?.dataset?.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $396431ece6ae946e$var$PAGE_LAYOUT_ID) return $396431ece6ae946e$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            const ssrPlaceholderReplaceId = el?.dataset?.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $396431ece6ae946e$var$PAGE_LAYOUT_ID) return $396431ece6ae946e$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver?.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = target.getBoundingClientRect();
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = target.getBoundingClientRect();
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
            const existingElements = document.querySelectorAll(selector);
            existingElements.forEach((el)=>{
                const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
                if (placeholderId) {
                    let width = -1;
                    let height = -1;
                    let x = -1;
                    let y = -1;
                    const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[placeholderId];
                    if (boundingClientRect) {
                        width = boundingClientRect.width;
                        height = boundingClientRect.height;
                        x = boundingClientRect.x;
                        y = boundingClientRect.y;
                    }
                    this.staticPlaceholders.set(placeholderId, {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    });
                    this.intersectionObserver?.observe(el);
                }
            });
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
}

});




parcelRegister("2DIgf", function(module, exports) {

$parcel$export(module.exports, "VCObserverWrapper", () => $9ea2b504429cafec$export$4a1fe1ab3c13bbf5);
$parcel$export(module.exports, "getVCObserver", () => $9ea2b504429cafec$export$b3bc47985717b49e);

var $53d5Q = parcelRequire("53d5Q");

var $cNPWf = parcelRequire("cNPWf");

var $cptoO = parcelRequire("cptoO");

var $63V9f = parcelRequire("63V9f");

var $3mTvL = parcelRequire("3mTvL");
class $9ea2b504429cafec$export$4a1fe1ab3c13bbf5 {
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        // Process any SSR abort listeners that remain
        if (window?.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        if ((0, $53d5Q.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $53d5Q.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.start({
            startTime: startTime
        });
        if ((0, $53d5Q.isVCRevisionEnabled)('fy25.03', experienceKey)) this.newVCObserver?.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        if ((0, $53d5Q.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $53d5Q.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.stop();
        if ((0, $53d5Q.isVCRevisionEnabled)('fy25.03', experienceKey)) this.newVCObserver?.stop();
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        const { experienceKey: experienceKey } = param;
        const v1v2Result = (0, $53d5Q.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $53d5Q.isVCRevisionEnabled)('fy25.02', experienceKey) ? await this.oldVCObserver?.getVCResult(param) : {};
        const v3Result = (0, $53d5Q.isVCRevisionEnabled)('fy25.03', experienceKey) ? await this.newVCObserver?.getVCResult({
            start: param.start,
            stop: param.stop
        }) : [];
        if (!v3Result) return v1v2Result ?? {};
        return {
            ...v1v2Result,
            'ufo:vc:rev': [
                ...v1v2Result?.['ufo:vc:rev'] ?? [],
                ...v3Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
    constructor(opts = {}){
        this.oldVCObserver = void 0;
        this.newVCObserver = void 0;
        this.newVCObserver = null;
        this.oldVCObserver = null;
        if ((0, $53d5Q.isVCRevisionEnabled)('fy25.03')) this.newVCObserver = new (0, $63V9f.default)({
            selectorConfig: opts.selectorConfig
        });
        if ((0, $53d5Q.isVCRevisionEnabled)('fy25.01') || (0, $53d5Q.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $cptoO.VCObserver)(opts);
    }
}
// Some products set this variable to indicate it is running in SSR
let $9ea2b504429cafec$var$isServer = Boolean(globalThis?.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let $9ea2b504429cafec$var$isReactSSR = typeof $3mTvL !== 'undefined' && Boolean($3mTvL?.env?.REACT_SSR || false);
function $9ea2b504429cafec$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($9ea2b504429cafec$var$isReactSSR || $9ea2b504429cafec$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof globalThis?.WeakRef !== 'function') return false;
    if (typeof globalThis?.MutationObserver !== 'function' || typeof globalThis?.IntersectionObserver !== 'function' || typeof globalThis?.PerformanceObserver !== 'function') return false;
    return true;
}
function $9ea2b504429cafec$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !$9ea2b504429cafec$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $cNPWf.VCObserverNOOP)() : new $9ea2b504429cafec$export$4a1fe1ab3c13bbf5(opts);
    }
    return globalThis.__vcObserver;
}

});
parcelRegister("cNPWf", function(module, exports) {

$parcel$export(module.exports, "VCObserverNOOP", () => $28512cdc9c8c0bdd$export$24d07287b49da906);
class $28512cdc9c8c0bdd$export$24d07287b49da906 {
    start(startArg) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(param) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(element) {}
    setReactRootRenderStart(startTime) {}
    setReactRootRenderStop(stopTime) {}
}

});

parcelRegister("63V9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $723ea224b58449b0$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $7p13H = parcelRequire("7p13H");

var $3xXm4 = parcelRequire("3xXm4");

var $91u2e = parcelRequire("91u2e");

var $1KSrb = parcelRequire("1KSrb");

var $vYAAO = parcelRequire("vYAAO");
const $723ea224b58449b0$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
class $723ea224b58449b0$export$2e2bcd8739ae039 {
    start({ startTime: startTime }) {
        this.viewportObserver?.start();
        if (window?.__SSR_ABORT_LISTENERS__ && (0, $dh538.fg)('platform_ufo_vc_observer_new_ssr_abort_listener')) {
            const abortListeners = window.__SSR_ABORT_LISTENERS__;
            const aborts = abortListeners.aborts;
            if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                if (typeof time === 'number') this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: key
                    }
                });
            });
        }
        this.windowEventObserver?.start();
        this.entriesTimeline.clear();
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId } = param;
        const results = [];
        const calculator_fy25_03 = new (0, $91u2e.default)();
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            isPostInteraction: this.isPostInteraction
        });
        if (fy25_03) results.push(fy25_03);
        return results;
    }
    getElementName(element) {
        return (0, $3xXm4.default)(this.selectorConfig, element);
    }
    constructor(config){
        this.selectorConfig = void 0;
        this.viewportObserver = null;
        this.windowEventObserver = null;
        this.entriesTimeline = void 0;
        this.isPostInteraction = void 0;
        this.entriesTimeline = new (0, $7p13H.default)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        this.selectorConfig = config.selectorConfig ?? $723ea224b58449b0$var$DEFAULT_SELECTOR_CONFIG;
        this.viewportObserver = new (0, $1KSrb.default)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: type,
                        elementName: elementName,
                        rect: rect,
                        previousRect: previousRect,
                        visible: visible,
                        attributeName: mutationData?.attributeName,
                        oldValue: mutationData?.oldValue,
                        newValue: mutationData?.newValue
                    }
                });
            }
        });
        this.windowEventObserver = new (0, $vYAAO.default)({
            onEvent: ({ time: time, type: type })=>{
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type
                    }
                });
            }
        });
    }
}

});
parcelRegister("7p13H", function(module, exports) {

$parcel$export(module.exports, "default", () => $54c4326969eba852$export$2e2bcd8739ae039);
class $54c4326969eba852$export$2e2bcd8739ae039 {
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
    constructor(){
        this.unorderedEntries = void 0;
        this.sortedEntriesCache = void 0;
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
}

});

parcelRegister("3xXm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $51929824de558c61$export$2e2bcd8739ae039);
const $51929824de558c61$var$nameCache = new WeakMap();
function $51929824de558c61$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $51929824de558c61$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (e) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $51929824de558c61$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $51929824de558c61$var$nameCache.set(element, name);
    return name;
}
var $51929824de558c61$export$2e2bcd8739ae039 = $51929824de558c61$var$getElementName;

});

parcelRegister("91u2e", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4e44337be132e66$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $2E13S = parcelRequire("2E13S");

var $gC08F = parcelRequire("gC08F");
const $c4e44337be132e66$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $c4e44337be132e66$var$REVISION_NO = 'fy25.03';
const $c4e44337be132e66$var$CONSIDERED_ENTRY_TYPE = [
    'mutation:child-element',
    'mutation:element',
    'mutation:attribute',
    'layout-shift',
    'window:event'
];
const $c4e44337be132e66$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'draggable'
];
class $c4e44337be132e66$export$2e2bcd8739ae039 extends (0, $2E13S.default) {
    isEntryIncluded(entry) {
        if (!$c4e44337be132e66$var$CONSIDERED_ENTRY_TYPE.includes(entry.data.type)) return false;
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || $c4e44337be132e66$export$98812f4e79596e2b.includes(attributeName)) return false;
            if (attributeName === 'data-aui-version' && (0, $dh538.fg)('platform_ufo_filter_out_aui_attribute_changes')) return false;
            return true;
        }
        if ((0, $gC08F.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    isVCClean(filteredEntries) {
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                if ($c4e44337be132e66$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) return true;
            }
            return false;
        });
        return !hasAbortEvent;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                if ($c4e44337be132e66$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) {
                    dirtyReason = data.eventType === 'keydown' ? 'keypress' : data.eventType;
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason
        };
        return {
            isVCClean: true
        };
    }
    constructor(){
        super($c4e44337be132e66$var$REVISION_NO);
    }
}

});
parcelRegister("2E13S", function(module, exports) {

$parcel$export(module.exports, "default", () => $8455fa3262740b78$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $eHWCA = parcelRequire("eHWCA");

var $ldHBN = parcelRequire("ldHBN");

var $bt7Ch = parcelRequire("bt7Ch");
class $8455fa3262740b78$export$2e2bcd8739ae039 {
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    async calculateBasic(filteredEntries, startTime, stopTime) {
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const vcLogs = await (0, $eHWCA.default)({
            viewport: {
                width: (0, $bt7Ch.default)(),
                height: (0, $ldHBN.default)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries,
            percentiles: percentiles
        });
        return vcLogs;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionId, dirtyReason) {
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const vcLogs = await (0, $eHWCA.calculateTTVCPercentilesWithDebugInfo)({
            viewport: {
                width: (0, $bt7Ch.default)(),
                height: (0, $ldHBN.default)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = entries.map((e)=>e.elementName);
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        // Handle devtool callback
        if (!isPostInteraction && typeof window !== 'undefined' && typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' && (0, $dh538.fg)('platform_ufo_ttvc_v3_devtool')) try {
            window.__ufo_devtool_onVCRevisionReady__?.({
                revision: this.revisionNo,
                isClean: isVCClean,
                abortReason: dirtyReason,
                vcLogs: vcLogs,
                interactionId: interactionId
            });
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        return vcDetails;
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry);
        });
        let isVCClean;
        let dirtyReason;
        if ((0, $dh538.fg)('platform_ufo_add_vc_abort_reason_by_revisions')) {
            const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
            isVCClean = getVCCleanStatusResult.isVCClean;
            dirtyReason = getVCCleanStatusResult.dirtyReason;
            if (!isVCClean) return {
                revision: this.revisionNo,
                'metric:vc90': null,
                clean: false,
                abortReason: dirtyReason
            };
        } else {
            isVCClean = this.isVCClean(filteredEntries);
            if (!isVCClean) return {
                revision: this.revisionNo,
                'metric:vc90': null,
                clean: false
            };
        }
        const useDebugInfo = (0, $dh538.fg)('platform_ufo_ttvc_v3_devtool');
        const vcDetails = useDebugInfo ? await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionId, dirtyReason) : await this.calculateBasic(filteredEntries, startTime, stopTime);
        return {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': vcDetails?.['90']?.t ?? null,
            vcDetails: vcDetails ?? undefined
        };
    }
    constructor(revisionNo){
        this.revisionNo = void 0;
        this.revisionNo = revisionNo;
    }
}

});
parcelRegister("eHWCA", function(module, exports) {

$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", () => $6e0ea22d2e325cd7$export$96ea73435089b05a);
$parcel$export(module.exports, "default", () => $6e0ea22d2e325cd7$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $1MQk4 = parcelRequire("1MQk4");
async function $6e0ea22d2e325cd7$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $1MQk4.ViewportCanvas)(viewport, (0, $dh538.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return $6e0ea22d2e325cd7$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $6e0ea22d2e325cd7$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $1MQk4.ViewportCanvas)(viewport, (0, $dh538.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return $6e0ea22d2e325cd7$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime);
}
var $6e0ea22d2e325cd7$export$2e2bcd8739ae039 = $6e0ea22d2e325cd7$var$calculateTTVCPercentiles;
function $6e0ea22d2e325cd7$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}
function $6e0ea22d2e325cd7$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const results = new Array(elementMap.size);
    let cumulativePixels = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        results[i] = {
            time: Math.round(Number(time - startTime)),
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
    }
    return results;
}

});
parcelRegister("1MQk4", function(module, exports) {

$parcel$export(module.exports, "ViewportCanvas", () => $570b96390c1c1394$export$3e59ac9de7402fb1);

var $dh538 = parcelRequire("dh538");

var $c9mci = parcelRequire("c9mci");
class $570b96390c1c1394$export$3e59ac9de7402fb1 {
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   * or if the feature flag is disabled
   */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined' && (0, $dh538.fg)('platform_ufo_use_offscreen_canvas')) return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
   * Clears the entire canvas by removing all drawn content.
   * @private
   */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * Generates a unique RGB color from an incrementing counter.
   * Uses a 24-bit color space (16,777,216 possible colors).
   *
   * @private
   * @returns A unique RGB color string
   *
   * @example
   * // Example bit operations for color 0x00FF8040:
   * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
   * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
   * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
   */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return $570b96390c1c1394$export$54591583ed0b20ce(rgbColor);
    }
    /**
   * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
   * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
   *
   * @param rect - The rectangle dimensions to draw
   * @param timestamp - The timestamp to associate with this drawing operation
   */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
   * Calculates the number of pixels drawn for each timestamp.
   * This method:
   * 1. Reads the pixel data from the canvas
   * 2. Counts pixels of each unique color
   * 3. Maps colors back to their timestamps
   * 4. Adjusts counts based on the scale factor
   *
   * @returns A Map containing timestamp to pixel count mappings
   */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await $570b96390c1c1394$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = $570b96390c1c1394$export$54591583ed0b20ce(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
    /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ constructor(viewport, scaleFactor = 1){
        /** The underlying Canvas instance (either OffscreenCanvas or HTMLCanvasElement) */ this.canvas = void 0;
        /** The 2D rendering context of the canvas */ this.ctx = void 0;
        /** Scale factor applied to the canvas (affects final pixel counts) */ this.scaleFactor = void 0;
        /** Maps unique colors to their corresponding timestamps */ this.colorTimeMap = void 0;
        /** Counter used to generate unique colors */ this.colorCounter = void 0;
        this.scaledWidth = void 0;
        this.scaledHeight = void 0;
        this.scaleX = void 0;
        this.scaleY = void 0;
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        if ((0, $dh538.fg)('platform_ufo_use_offscreen_canvas')) this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
}
function $570b96390c1c1394$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function $570b96390c1c1394$export$fafc9be44839f9c8(imageData, scaleFactor, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $c9mci.default)();
    }
    return arr;
}

});
parcelRegister("c9mci", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a072dc24a59f4c9$export$2e2bcd8739ae039);
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $6a072dc24a59f4c9$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $6a072dc24a59f4c9$export$2e2bcd8739ae039 = $6a072dc24a59f4c9$var$taskYield;

});



parcelRegister("ldHBN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e65b64cb72b81f$export$2e2bcd8739ae039);
function $b5e65b64cb72b81f$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $b5e65b64cb72b81f$export$2e2bcd8739ae039 = $b5e65b64cb72b81f$var$getViewportHeight;

});

parcelRegister("bt7Ch", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb9a40762bd3d01e$export$2e2bcd8739ae039);
function $cb9a40762bd3d01e$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $cb9a40762bd3d01e$export$2e2bcd8739ae039 = $cb9a40762bd3d01e$var$getViewportWidth;

});


parcelRegister("gC08F", function(module, exports) {

$parcel$export(module.exports, "default", () => $743f36b544f5c8c4$export$2e2bcd8739ae039);
function $743f36b544f5c8c4$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $743f36b544f5c8c4$export$2e2bcd8739ae039 = $743f36b544f5c8c4$var$isViewportEntryData;

});


parcelRegister("1KSrb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca01fd40e56693af$export$2e2bcd8739ae039);

var $IkgpF = parcelRequire("IkgpF");

var $10BiY = parcelRequire("10BiY");

var $ll2K6 = parcelRequire("ll2K6");

var $4ixpU = parcelRequire("4ixpU");

var $bIsez = parcelRequire("bIsez");
function $ca01fd40e56693af$var$isElementVisible(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-expect-error
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}
function $ca01fd40e56693af$var$sameRectSize(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height;
}
function $ca01fd40e56693af$var$sameRectDimensions(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height && a.x === b.x && a.y === b.y;
}
const $ca01fd40e56693af$var$createElementMutationsWatcher = (removedNodeRects)=>({ rect: rect })=>{
        const wasDeleted = removedNodeRects.some((nr)=>$ca01fd40e56693af$var$sameRectDimensions(nr, rect));
        if (wasDeleted) return 'mutation:element-replacement';
        return 'mutation:element';
    };
class $ca01fd40e56693af$export$2e2bcd8739ae039 {
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $ll2K6.createIntersectionObserver)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $4ixpU.default)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $bIsez.default)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        if (this.isStarted) return;
        this.initializeObservers();
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore-error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        if (!this.isStarted) return;
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
        this.isStarted = false;
    }
    constructor({ onChange: onChange }){
        this.intersectionObserver = void 0;
        this.mutationObserver = void 0;
        this.performanceObserver = void 0;
        this.mapVisibleNodeRects = void 0;
        this.onChange = void 0;
        this.isStarted = void 0;
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = $ca01fd40e56693af$var$isElementVisible(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = ({ addedNodes: addedNodes, removedNodes: removedNodes })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            addedNodes.forEach((addedNodeRef)=>{
                const addedNode = addedNodeRef.deref();
                if (!addedNode) return;
                const sameDeletedNode = removedNodes.find((ref)=>{
                    const n = ref.deref();
                    if (!n || !addedNode) return false;
                    return n.isEqualNode(addedNode);
                });
                if (sameDeletedNode) {
                    this.intersectionObserver?.watchAndTag(addedNode, 'mutation:remount');
                    return;
                }
                if ((0, $IkgpF.isContainedWithinMediaWrapper)(addedNode)) {
                    this.intersectionObserver?.watchAndTag(addedNode, 'mutation:media');
                    return;
                }
                this.intersectionObserver?.watchAndTag(addedNode, $ca01fd40e56693af$var$createElementMutationsWatcher(removedNodeRects));
            });
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue })=>{
            this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $IkgpF.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $10BiY.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && $ca01fd40e56693af$var$sameRectSize(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) this.onChange({
                    time: time,
                    elementRef: new WeakRef(target),
                    visible: true,
                    rect: changedRect.rect,
                    previousRect: changedRect.previousRect,
                    type: 'layout-shift'
                });
            }
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
    }
}

});
parcelRegister("ll2K6", function(module, exports) {

$parcel$export(module.exports, "createIntersectionObserver", () => $3599442dd1fcaa0d$export$c3799d33e0ae80a5);
function $3599442dd1fcaa0d$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $3599442dd1fcaa0d$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement) || !$3599442dd1fcaa0d$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved?.({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});

parcelRegister("4ixpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdfa95ab5931774e$export$2e2bcd8739ae039);
function $cdfa95ab5931774e$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const addedNodes = [];
        const removedNodes = [];
        const targets = [];
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if (mut.type === 'attributes') {
                /*
							"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
							I think it might have been something along the lines that for consistency every setAttribute call should create a record.
							Conceptually there is after all a mutation: there is an old value replaced with a new one,
							and whether or not they are the same doesn't really matter.
							And Custom elements should work the same way as MutationObserver."
							https://github.com/whatwg/dom/issues/520#issuecomment-336574796
						*/ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue
                });
                continue;
            } else if (mut.type === 'childList') {
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) addedNodes.push(new WeakRef(node));
                });
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        onChildListMutation({
            addedNodes: addedNodes,
            removedNodes: removedNodes
        });
        onMutationFinished?.({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $cdfa95ab5931774e$export$2e2bcd8739ae039 = $cdfa95ab5931774e$var$createMutationObserver;

});

parcelRegister("bIsez", function(module, exports) {

$parcel$export(module.exports, "default", () => $a239136ea775ec9b$export$2e2bcd8739ae039);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $a239136ea775ec9b$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $a239136ea775ec9b$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift') {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: $a239136ea775ec9b$export$5e3f54cad8cb65e2(attr.currentRect),
                    previousRect: $a239136ea775ec9b$export$5e3f54cad8cb65e2(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var $a239136ea775ec9b$export$2e2bcd8739ae039 = $a239136ea775ec9b$var$createPerformanceObserver;

});


parcelRegister("vYAAO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cacec3838b48fe2$export$2e2bcd8739ae039);

var $d8F95 = parcelRequire("d8F95");
class $4cacec3838b48fe2$export$2e2bcd8739ae039 {
    bindEvent(type) {
        const unbindCallback = (0, $d8F95.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = void 0;
        this.onEvent = opts.onEvent;
    }
}

});



parcelRegister("5joKL", function(module, exports) {

$parcel$export(module.exports, "interactions", () => $06d19b54423b55b9$export$cc97b17ef9aeb088);
const $06d19b54423b55b9$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("l4FNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $36700964d55365aa$export$2e2bcd8739ae039);

var $53d5Q = parcelRequire("53d5Q");

var $2DIgf = parcelRequire("2DIgf");
const $36700964d55365aa$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $36700964d55365aa$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $2DIgf.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
   * Set the VC result as per the last interaction
   * Used to compare diffs of VC updates vs post interaction VC observer
   * @param result - VC result as calculated by UFO create payload
   */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
   * Set the fn that would be invoked to process / send the observation data
   */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
   * Reset state of the log
   */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
   * Check if there is data in the log
   */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
   * Send the log if there is data
   */ async sendPostInteractionLog() {
        if (!this.hasData() || !this.lastInteractionFinish || !this.sinkHandlerFn) {
            this.reset();
            if ((0, $53d5Q.getConfig)()?.experimentalInteractionMetrics?.enabled) this.vcObserver?.stop();
            return;
        }
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            // no need for TTI value here
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            ...this.vcObserverSSRConfig,
            experienceKey: this.lastInteractionFinish.ufoName
        });
        if ((0, $53d5Q.getConfig)()?.experimentalInteractionMetrics?.enabled) this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: // NOTE: invoking `getVCResult` at latest possible point in time here (not earlier) to get the most accurate result (from performance.now())
            postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult
        });
        this.reset();
    }
    /**
   * This fn should be invoked when an interaction has finished
   * Basic details about the finished interaction will be recorded
   * A timeout will be setup to send the post interaction observation after some time.
   */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, experimentalTTAI: experimentalTTAI, experimentalVC90: experimentalVC90, errors: errors }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            experimentalTTAI: experimentalTTAI,
            experimentalVC90: experimentalVC90,
            errors: errors
        };
        const timeout = (0, $53d5Q.getConfig)()?.timeWindowForLateMutationsInMilliseconds || $36700964d55365aa$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
   * This fn should be invoked when a React render happens after interaction has finished
   */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    constructor(){
        /**
     * Basic info about interaction that has just finished
     */ this.lastInteractionFinish = null;
        /**
     * Array of observed react render timings
     */ this.reactProfilerTimings = [];
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ this.sinkTimeoutId = null;
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        this.lastInteractionFinishVCResult = void 0;
        /**
     * Handler function to process / send the observation data
     */ this.sinkHandlerFn = ()=>{};
    }
}

});


parcelRegister("ic4nn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b5134df6eb19c4$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $e6b5134df6eb19c4$var$UFORouteName = {
    current: null
};
var $e6b5134df6eb19c4$export$2e2bcd8739ae039 = $e6b5134df6eb19c4$var$UFORouteName;

});

parcelRegister("5QpZa", function(module, exports) {

$parcel$export(module.exports, "getGlobalErrorCount", () => $74a91b492495e33b$export$d06c0426664e7c08);
$parcel$export(module.exports, "default", () => $74a91b492495e33b$export$2e2bcd8739ae039);

var $d8F95 = parcelRequire("d8F95");
let $74a91b492495e33b$var$shouldInitilizeGlobalErrorHandler = true;
let $74a91b492495e33b$var$globalCount = 0;
const $74a91b492495e33b$var$errors = [];
let $74a91b492495e33b$var$push = (name, labelStack, errorType, errorMessage, errorStack)=>{
    $74a91b492495e33b$var$errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack
    });
};
function $74a91b492495e33b$export$ebe081a8c9bf8176(sinkFunc) {
    $74a91b492495e33b$var$push = sinkFunc;
    $74a91b492495e33b$var$errors.forEach((e)=>{
        sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
    });
    $74a91b492495e33b$var$errors.length = 0;
}
function $74a91b492495e33b$export$d06c0426664e7c08() {
    return $74a91b492495e33b$var$globalCount;
}
function $74a91b492495e33b$var$handleError(e) {
    $74a91b492495e33b$var$globalCount++;
    if (e.error?.UFOhasCaught === undefined) try {
        if (e.error instanceof Error) $74a91b492495e33b$var$push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
        else if (e.error) {
            const hint = JSON.stringify(e.error).slice(0, 50);
            $74a91b492495e33b$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        } else if (e.message !== undefined) {
            const hint = e.message.slice(0, 50);
            $74a91b492495e33b$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        }
        if (e.error && typeof e.error === 'object') e.error.UFOhasCaught = true;
    // eslint-disable-next-line no-empty
    } catch (e) {}
}
function $74a91b492495e33b$var$handlePromiseRejection(e) {
    $74a91b492495e33b$var$globalCount++;
    if (e.reason instanceof Error) $74a91b492495e33b$var$push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
    else if (e.reason) try {
        const hint = JSON.stringify(e.reason).slice(0, 50);
        $74a91b492495e33b$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
    // eslint-disable-next-line no-empty
    } catch (e) {}
}
function $74a91b492495e33b$var$setupUFOGlobalErrorHandler() {
    if ($74a91b492495e33b$var$shouldInitilizeGlobalErrorHandler) {
        (0, $d8F95.bind)(window, {
            type: 'error',
            listener: (e)=>$74a91b492495e33b$var$handleError(e)
        });
        (0, $d8F95.bind)(window, {
            type: 'unhandledrejection',
            listener: $74a91b492495e33b$var$handlePromiseRejection
        });
        $74a91b492495e33b$var$shouldInitilizeGlobalErrorHandler = false;
    }
}
var $74a91b492495e33b$export$2e2bcd8739ae039 = $74a91b492495e33b$var$setupUFOGlobalErrorHandler;

});

parcelRegister("04e9M", function(module, exports) {

$parcel$export(module.exports, "getWorkspaceId", () => $395aeb7a9cfb70e5$export$cac1fa7ce63519ac);
$parcel$export(module.exports, "initializeAnalyticsClient", () => $395aeb7a9cfb70e5$export$7d842b959fcdcd03);
$parcel$export(module.exports, "getAnalyticsWebClient", () => $395aeb7a9cfb70e5$export$e9ba7ef9458d1a4a);
$parcel$export(module.exports, "getDwellTimeHelper", () => $395aeb7a9cfb70e5$export$68106415736c5577);
/**
 *  Data Services - Analytics Web Client for E-MAU
 *  url to the JIRA ticket (https://product-fabric.atlassian.net/browse/CFEA-16)
 *  source code (https://bitbucket.org/atlassian/analytics-web-client)
 */ 
var $6Co6F = parcelRequire("6Co6F");

var $cMvQV = parcelRequire("cMvQV");

var $hmRc4 = parcelRequire("hmRc4");

var $eSuZj = parcelRequire("eSuZj");

var $6X8o4 = parcelRequire("6X8o4");

var $8dwdz = parcelRequire("8dwdz");

var $hNuGv = parcelRequire("hNuGv");
// Must call this before any browser-helper functions, to ensure user agent has been set first
(0, $cMvQV.setUserAgent)();
let $395aeb7a9cfb70e5$var$provideClient;
const $395aeb7a9cfb70e5$var$analyticsWebClientPromise = (0, $6X8o4.liftPromiseState)(new Promise((resolve)=>{
    $395aeb7a9cfb70e5$var$provideClient = resolve;
}));
let $395aeb7a9cfb70e5$var$provideDwellTimeHelper;
const $395aeb7a9cfb70e5$var$dwellTimeHelperPromise = (0, $6X8o4.liftPromiseState)(new Promise((resolve)=>{
    $395aeb7a9cfb70e5$var$provideDwellTimeHelper = resolve;
}));
const $395aeb7a9cfb70e5$export$45a69314cf48a3eb = ({ envType: envType, originType: originType, environment: environment, platformType: platformType, locale: locale, product: product, subproduct: subproduct })=>{
    const env = // In dev, proxying to a site will give that site's environment,
    // which is not what we want
    window.location.hostname === 'localhost' ? envType.DEV : environment === 'STAGING' ? envType.STAGING : environment === 'PRODUCTION' ? envType.PROD : envType.DEV;
    return {
        env: env,
        product: product || 'confluence',
        ...subproduct ? {
            subproduct: subproduct
        } : undefined,
        version: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
        origin: originType.WEB,
        platform: (0, $8dwdz.shouldShowMobileWeb)() ? platformType.MOBILE_WEB : platformType.WEB,
        locale: locale
    };
};
const $395aeb7a9cfb70e5$export$cac1fa7ce63519ac = (cloudId, activationId)=>`ari:cloud:confluence:${cloudId}:workspace/${activationId}`;




const $395aeb7a9cfb70e5$export$7d842b959fcdcd03 = ({ cloudId: cloudId, userId: userId, environment: environment, product: product, subproduct: subproduct, locale: locale, activationId: activationId, eventFilterOptions: eventFilterOptions = {
    shouldFilterEvents: false,
    eventMatchers: []
}, callback: callback })=>{
    let config;
    Promise.all([
        (parcelRequire("1nHJi")),
        (parcelRequire("6i7sf")),
        // This is needed for @atlassiansox/origin-tracing to work in old versions of Edge (<=16).
        // Origin Tracing needs URLSearchParams, but the API is missing from old Edge,
        // and old Edge is not served the ES5/polyfills bundle.
        typeof URLSearchParams === 'undefined' ? (parcelRequire("jJvsh")) : Promise.resolve()
    ]).then(async ([analyticsWebClientModule, { buildCompressionFunction: buildCompressionFunction, canCompress: canCompress }])=>{
        const { default: AnalyticsWebClient, originType: originType, tenantType: tenantType, userType: userType, envType: envType, platformType: platformType, DwellTimeHelper: DwellTimeHelper, CompressionRule: CompressionRule } = analyticsWebClientModule;
        config = $395aeb7a9cfb70e5$export$45a69314cf48a3eb({
            envType: envType,
            originType: originType,
            environment: environment,
            platformType: platformType,
            locale: locale,
            product: product,
            subproduct: subproduct
        });
        let analyticsWebClient;
        // COMMENTS-195 - Send an operational event when a session starts
        const handleSessionStarted = ()=>{
            analyticsWebClient && analyticsWebClient.sendOperationalEvent({
                action: 'started',
                actionSubject: 'session',
                source: 'webClient'
            });
        };
        $395aeb7a9cfb70e5$var$provideDwellTimeHelper(DwellTimeHelper);
        const browserHistory = (0, $hmRc4.getBrowserHistory)();
        const settings = {
            historyReplaceFn: (url)=>{
                const { pathname: pathname, search: search, hash: hash } = new URL(url);
                // Warning: can't pass an instance of URL here as it will erase query params and hash
                // Caused: https://product-fabric.atlassian.net/browse/WS-2317
                browserHistory.replace({
                    pathname: pathname,
                    search: search,
                    hash: hash
                });
            },
            delayQueueCompressors: [
                new CompressionRule(canCompress, buildCompressionFunction())
            ],
            onNewSessionStarted: handleSessionStarted,
            apiHostProtocol: window.location.hostname === 'localhost' ? 'http' : 'https',
            disableCookiePersistence: true
        };
        const { shouldFilterEvents: shouldFilterEvents, eventMatchers: eventMatchers } = eventFilterOptions;
        // We suppress analytics events if we're within the mobile app so that we don't
        // end up firing overlapping events from the native and web code
        if (shouldFilterEvents || (0, $cMvQV.isNativeMobile)()) {
            /**
       * Don't use Stargate if we're filtering events.
       * According to the analytics-web-client package source code at https://bitbucket.org/atlassian/analytics-web-client/src/bf3bd861ee8d08759e0e79830fcb1d69156db1a5/src/analyticsWebClient.js?at=master#lines-208
       * By default, useStargate is true. On a production instance, even if we set the env to "staging" or "dev", this event will land to the huge production Redash Socrates table, such as cloud.event_operational.
       * For the purpose of preproduction performance detection, we need the analytics event to send to staging table, such as raw_dlf_stg.event_operational.
       * The staging table has much less data, so we can run data transformation job hourly, and query more real-time data. Production table is huge, so we can only run data transformation job daily.
       */ const useStargate = !shouldFilterEvents;
            const { createFilteredAWC: createFilteredAWC } = await (parcelRequire("ffzg1"));
            analyticsWebClient = createFilteredAWC(analyticsWebClientModule, config, {
                ...settings,
                useStargate: useStargate
            }, eventMatchers);
        } else analyticsWebClient = new AnalyticsWebClient(config, settings);
        analyticsWebClient.setTenantInfo(tenantType.CLOUD_ID, cloudId);
        if (activationId) {
            const workspaceId = $395aeb7a9cfb70e5$export$cac1fa7ce63519ac(cloudId, activationId);
            analyticsWebClient.setWorkspaceInfo(workspaceId);
        }
        // userId is null when the user is anonymous. In that scenario we don't
        // want to set any account ID on the analytics client.
        if (userId) analyticsWebClient.setUserInfo(userType.ATLASSIAN_ACCOUNT, userId);
        analyticsWebClient.setOriginTracingHandlers({
            atlOrigin: (encodedOrigin)=>{
                const origin = (0, $6Co6F.default).fromEncoded(encodedOrigin);
                const attributes = origin.toAnalyticsAttributes();
                if (userId) (0, $hNuGv.storeOrigin)(attributes);
                return {
                    originTracingAttributes: {
                        id: attributes.originId,
                        product: attributes.originProduct,
                        library: attributes.originLibrary
                    },
                    taskSessionId: origin.id
                };
            }
        });
        analyticsWebClient.startUIViewedEvent();
        $395aeb7a9cfb70e5$var$provideClient(analyticsWebClient);
        callback && callback();
    }).catch((error)=>{
        throw new Error(`Analytics Web Client ${error}, ${JSON.stringify({
            ...config
        })}`);
    });
};
const $395aeb7a9cfb70e5$export$e9ba7ef9458d1a4a = ()=>$395aeb7a9cfb70e5$var$analyticsWebClientPromise;
const $395aeb7a9cfb70e5$export$68106415736c5577 = ()=>$395aeb7a9cfb70e5$var$dwellTimeHelperPromise;

});
parcelRegister("6Co6F", function(module, exports) {

$parcel$export(module.exports, "default", () => $29c1a49acaf4d5a1$export$2e2bcd8739ae039);
// import uuid from 'uuid/v4';

var $9HkI0 = parcelRequire("9HkI0");

var $5htiY = parcelRequire("5htiY");

var $1tnex = parcelRequire("1tnex");
const $29c1a49acaf4d5a1$var$packageVersion = "0.0.0-use.local";
const $29c1a49acaf4d5a1$var$originParamName = 'atlOrigin';
const $29c1a49acaf4d5a1$var$originVersioningAttributes = {
    originLibrary: `origin-tracing.js@${$29c1a49acaf4d5a1$var$packageVersion}`
};
class $29c1a49acaf4d5a1$export$2e2bcd8739ae039 {
    static isValidId(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
    }
    static isValidProduct(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
    }
    static generateId() {
        const id = (0, $9HkI0.v4)();
        // Dash positions are fixed so they don't add to uniqueness.
        // Remove them to save space in the encoded form.
        return id.replace(/-/g, '');
    }
    static createEmpty() {
        return new $29c1a49acaf4d5a1$var$EmptyOriginTracer();
    }
    static createMalformed() {
        return new $29c1a49acaf4d5a1$var$MalformedOriginTracer();
    }
    static fromUrl(url) {
        let params = new ((0, $1tnex.getEnv)()).URLSearchParams();
        $29c1a49acaf4d5a1$var$replaceQuery(url, (queryString)=>{
            params = new ((0, $1tnex.getEnv)()).URLSearchParams(queryString);
        });
        return $29c1a49acaf4d5a1$export$2e2bcd8739ae039.fromEncoded(params.get($29c1a49acaf4d5a1$var$originParamName));
    }
    static fromEncoded(encoded) {
        if (!encoded) return $29c1a49acaf4d5a1$export$2e2bcd8739ae039.createEmpty();
        try {
            return $29c1a49acaf4d5a1$export$2e2bcd8739ae039.decode(encoded);
        } catch (e) {
            return $29c1a49acaf4d5a1$export$2e2bcd8739ae039.createMalformed();
        }
    }
    static removeFromUrl(url) {
        return $29c1a49acaf4d5a1$var$replaceQuery(url, (queryString)=>{
            const params = new ((0, $1tnex.getEnv)()).URLSearchParams(queryString);
            params.delete($29c1a49acaf4d5a1$var$originParamName);
            return params.toString();
        });
    }
    static decode(encodedOrigin) {
        const originData = (0, $5htiY.decode)(encodedOrigin);
        return new $29c1a49acaf4d5a1$export$2e2bcd8739ae039(originData);
    }
    encode() {
        return (0, $5htiY.encode)({
            id: this.id,
            product: this.product
        });
    }
    addToUrl(url) {
        return $29c1a49acaf4d5a1$var$replaceQuery(url, (originalQueryString)=>{
            const params = new ((0, $1tnex.getEnv)()).URLSearchParams(originalQueryString);
            params.set($29c1a49acaf4d5a1$var$originParamName, this.encode());
            return params.toString();
        });
    }
    isEmpty() {
        return false;
    }
    isMalformed() {
        return !this.isEmpty() && !this.isValid();
    }
    isValid() {
        return true;
    }
    toAnalyticsAttributes({ transformValue: transformValue = (v)=>v === null ? undefined : v, hasGeneratedId: hasGeneratedId = false } = {}) {
        // `originIdGenerated` should be used in analytic events that generated this originId.
        // Subsequent events should use `originId`.
        // No two events should have the same value of originIdGenerated.
        const originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
        return {
            [originIdProp]: transformValue(this.id),
            originProduct: transformValue(this.product),
            ...$29c1a49acaf4d5a1$var$originVersioningAttributes
        };
    }
    validate() {
        if (!$29c1a49acaf4d5a1$export$2e2bcd8739ae039.isValidId(this.id)) throw new TypeError('Invalid Origin id');
        if (!$29c1a49acaf4d5a1$export$2e2bcd8739ae039.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
    }
    constructor({ id: id = $29c1a49acaf4d5a1$export$2e2bcd8739ae039.generateId(), product: product, dangerouslySkipValidation: dangerouslySkipValidation = false }){
        this.id = void 0;
        this.product = void 0;
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
}
class $29c1a49acaf4d5a1$var$EmptyOriginTracer extends $29c1a49acaf4d5a1$export$2e2bcd8739ae039 {
    isValid() {
        return false;
    }
    isEmpty() {
        return true;
    }
    toAnalyticsAttributes() {
        return {
            ...$29c1a49acaf4d5a1$var$originVersioningAttributes
        };
    }
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
}
class $29c1a49acaf4d5a1$var$MalformedOriginTracer extends $29c1a49acaf4d5a1$export$2e2bcd8739ae039 {
    isValid() {
        return false;
    }
    isEmpty() {
        return false;
    }
    toAnalyticsAttributes() {
        return {
            originMalformed: true,
            ...$29c1a49acaf4d5a1$var$originVersioningAttributes
        };
    }
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
}
function $29c1a49acaf4d5a1$var$replaceQuery(url, replacer) {
    const urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    const urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, (_wholeMatch, beforeQuery, queryString, afterQuery)=>{
        let newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = `?${newQueryString}`;
        return `${beforeQuery}${newQueryString}${afterQuery}`;
    });
}

});
parcelRegister("5htiY", function(module, exports) {

$parcel$export(module.exports, "encode", () => $60c4e943508abf9b$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $60c4e943508abf9b$export$2f872c0f2117be69);

var $66IME = parcelRequire("66IME");

var $1tnex = parcelRequire("1tnex");
const $60c4e943508abf9b$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $60c4e943508abf9b$export$c564cdbbe6da493(originData) {
    const json = JSON.stringify($60c4e943508abf9b$export$4bc4b533a565aabe(originData));
    const base64 = (0, $1tnex.getEnv)().btoa(json);
    return (0, $66IME.base64ToBase64Url)(base64);
}
function $60c4e943508abf9b$export$2f872c0f2117be69(encodedOriginString) {
    const base64 = (0, $66IME.base64UrlToBase64)(encodedOriginString);
    const json = (0, $1tnex.getEnv)().atob(base64);
    return $60c4e943508abf9b$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $60c4e943508abf9b$export$4bc4b533a565aabe({ id: id, product: product }) {
    return {
        i: id,
        p: product && product in $60c4e943508abf9b$var$productShorthands ? $60c4e943508abf9b$var$productShorthands[product] : product
    };
}
function $60c4e943508abf9b$export$46d5cda6b884b7ab(originJSONObject) {
    const originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $60c4e943508abf9b$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $60c4e943508abf9b$var$expandProductShorthand(maybeShorthand) {
    const products = Object.keys($60c4e943508abf9b$var$productShorthands);
    for(let i = 0; i < products.length; i++){
        const product = products[i];
        const shorthand = $60c4e943508abf9b$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}

});
parcelRegister("66IME", function(module, exports) {

$parcel$export(module.exports, "base64ToBase64Url", () => $13a72d3092eaa770$export$3b91e21dac1023c6);
$parcel$export(module.exports, "base64UrlToBase64", () => $13a72d3092eaa770$export$47c5265a25535d02);
/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $13a72d3092eaa770$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $13a72d3092eaa770$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    const base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - base64url.length % 4) % 4;
    const pad = '==='.slice(0, padLength);
    return base64 + pad;
}

});

parcelRegister("1tnex", function(module, exports) {

$parcel$export(module.exports, "getEnv", () => $3ca81fa3e85f1ccb$export$4bd44a2aa29d3d6e);

var $fhwsL = parcelRequire("fhwsL");

const $3ca81fa3e85f1ccb$export$d3cd91e0fdbfdbc0 = ()=>({
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $fhwsL.Buffer) !== 'undefined' && ((encoded)=>(0, $fhwsL.Buffer).from(encoded, 'base64').toString()),
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $fhwsL.Buffer) !== 'undefined' && ((str)=>(0, $fhwsL.Buffer).from(str).toString('base64')),
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (0, (parcelRequire("jiJCD")).URLSearchParams)
    });
let $3ca81fa3e85f1ccb$var$env;
const $3ca81fa3e85f1ccb$export$4bd44a2aa29d3d6e = ()=>$3ca81fa3e85f1ccb$var$env || ($3ca81fa3e85f1ccb$var$env = $3ca81fa3e85f1ccb$var$validateEnv($3ca81fa3e85f1ccb$export$d3cd91e0fdbfdbc0()));
const $3ca81fa3e85f1ccb$var$validateEnv = (env)=>{
    if (!(env.atob && env.btoa && env.URLSearchParams)) throw new TypeError(`Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).`);
    return env;
};

});



parcelRegister("cMvQV", function(module, exports) {

$parcel$export(module.exports, "setUserAgent", () => $f7403687c64b23d9$export$57d3cdb500cb5402);
$parcel$export(module.exports, "isFirefox", () => $f7403687c64b23d9$export$b7d78993b74f766d);
$parcel$export(module.exports, "isMSEdge", () => $f7403687c64b23d9$export$552b0ed0b7a8f620);
$parcel$export(module.exports, "isIE", () => $f7403687c64b23d9$export$7e7b1a9668aaed8);
$parcel$export(module.exports, "isChrome", () => $f7403687c64b23d9$export$6446a186d09e379e);
$parcel$export(module.exports, "isSafari", () => $f7403687c64b23d9$export$95df08bae54cb4df);
$parcel$export(module.exports, "isNativeMobile", () => $f7403687c64b23d9$export$6d5620528cf86fa2);
$parcel$export(module.exports, "version", () => $f7403687c64b23d9$export$83d89fbfd8236492);
$parcel$export(module.exports, "friendlyName", () => $f7403687c64b23d9$export$f52e1a142ed579d);
let $f7403687c64b23d9$export$3dcce53a3755dc8c;
const $f7403687c64b23d9$export$57d3cdb500cb5402 = (agent)=>{
    if (agent) $f7403687c64b23d9$export$3dcce53a3755dc8c = agent;
    else if (typeof window !== 'undefined' && window.navigator) $f7403687c64b23d9$export$3dcce53a3755dc8c = window.navigator.userAgent;
};
const $f7403687c64b23d9$export$aad8462122ac592b = ()=>{
    $f7403687c64b23d9$export$3dcce53a3755dc8c = undefined;
};
const $f7403687c64b23d9$export$b7d78993b74f766d = ()=>{
    return $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Firefox/') !== -1;
};
const $f7403687c64b23d9$export$c87f7e935aea4901 = ()=>{
    return !$f7403687c64b23d9$export$b7d78993b74f766d();
};
const $f7403687c64b23d9$export$552b0ed0b7a8f620 = ()=>{
    return $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Edge/') !== -1;
};
const $f7403687c64b23d9$export$bf319670985f797f = ()=>{
    return !$f7403687c64b23d9$export$552b0ed0b7a8f620();
};
const $f7403687c64b23d9$export$7e7b1a9668aaed8 = ()=>{
    return $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('MSIE') !== -1 || $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Trident/') !== -1 || $f7403687c64b23d9$export$552b0ed0b7a8f620();
};
const $f7403687c64b23d9$export$a9ab798d36ba46c = ()=>{
    return !$f7403687c64b23d9$export$7e7b1a9668aaed8();
};
const $f7403687c64b23d9$export$6446a186d09e379e = ()=>{
    return $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Chrome/') !== -1;
};
const $f7403687c64b23d9$export$23ee57a84a15eab5 = ()=>{
    return !$f7403687c64b23d9$export$6446a186d09e379e();
};
const $f7403687c64b23d9$export$95df08bae54cb4df = ()=>{
    return $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Safari/') !== -1 && $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Chrome/') === -1;
};
const $f7403687c64b23d9$export$bc187e33086c8385 = ()=>{
    return !$f7403687c64b23d9$export$95df08bae54cb4df();
};
const $f7403687c64b23d9$export$7b405d3c2ef63516 = ()=>{
    return $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('PhantomJS') !== -1;
};
const $f7403687c64b23d9$export$f11fe2ca946efdb2 = ()=>{
    return !$f7403687c64b23d9$export$7b405d3c2ef63516();
};
const $f7403687c64b23d9$export$6d5620528cf86fa2 = ()=>{
    return !!$f7403687c64b23d9$export$3dcce53a3755dc8c && ($f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Confluence iOS/') !== -1 || $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Confluence Android/') !== -1);
};
const $f7403687c64b23d9$export$83d89fbfd8236492 = ()=>{
    let versionMatch;
    if ($f7403687c64b23d9$export$7e7b1a9668aaed8()) versionMatch = $f7403687c64b23d9$export$3dcce53a3755dc8c?.match(/MSIE\s([\d.]+)/) || $f7403687c64b23d9$export$3dcce53a3755dc8c?.match(/rv:([\d.]+)/) || $f7403687c64b23d9$export$3dcce53a3755dc8c?.match(/Edge\/([\d.]+)/);
    else if ($f7403687c64b23d9$export$6446a186d09e379e()) versionMatch = $f7403687c64b23d9$export$3dcce53a3755dc8c?.match(/Chrome\/([\d.]+)/);
    else if ($f7403687c64b23d9$export$95df08bae54cb4df()) versionMatch = $f7403687c64b23d9$export$3dcce53a3755dc8c?.match(/Version\/([\d.]+)/);
    else if ($f7403687c64b23d9$export$b7d78993b74f766d()) versionMatch = $f7403687c64b23d9$export$3dcce53a3755dc8c?.match(/Firefox\/([\d.]+)/);
    return versionMatch && parseInt(versionMatch[1]);
};
const $f7403687c64b23d9$export$f52e1a142ed579d = ()=>{
    if ($f7403687c64b23d9$export$552b0ed0b7a8f620()) return 'MSEdge';
    if ($f7403687c64b23d9$export$7e7b1a9668aaed8()) return 'IE';
    if ($f7403687c64b23d9$export$6446a186d09e379e()) return 'Chrome';
    if ($f7403687c64b23d9$export$95df08bae54cb4df()) return 'Safari';
    if ($f7403687c64b23d9$export$b7d78993b74f766d()) return 'Firefox';
};

});

parcelRegister("hmRc4", function(module, exports) {

$parcel$export(module.exports, "setBrowserHistoryListener", () => $f54fcd98c424e4b2$export$39f750fd76b05ae3);
$parcel$export(module.exports, "getBrowserHistory", () => $f54fcd98c424e4b2$export$1ddb08151d15bc78);

var $7PY4o = parcelRequire("7PY4o");

var $csnse = parcelRequire("csnse");
let $f54fcd98c424e4b2$var$browserHistoryListener = null;
const $f54fcd98c424e4b2$export$39f750fd76b05ae3 = (newBrowserHistoryListener)=>{
    $f54fcd98c424e4b2$var$browserHistoryListener = newBrowserHistoryListener;
    return ()=>{
        $f54fcd98c424e4b2$var$browserHistoryListener = null;
    };
};
const $f54fcd98c424e4b2$export$1ddb08151d15bc78 = (0, $csnse.default)(()=>{
    const browserHistory = (0, $7PY4o.default)();
    browserHistory.listen((location, action)=>{
        $f54fcd98c424e4b2$var$browserHistoryListener?.(location, action);
    });
    return browserHistory;
});

});

parcelRegister("eSuZj", function(module, exports) {

$parcel$export(module.exports, "getBuildInfo", () => $fb0776fab4601f82$export$4ea39b9726d98a51);
// The build information here are populated by the code inlined in the bootstrapping HTML
// They can be found in:
// - packages/confluence-frontend-server/templates/*
// - next/packages/app/src/indexTemplate.tsx
function $fb0776fab4601f82$var$getReleaseTrack() {
    return 'canary';
}
function $fb0776fab4601f82$export$4ea39b9726d98a51() {
    const injectedBuildInfo = window.__buildInfo || {};
    let { FRONTEND_VERSION: FRONTEND_VERSION } = injectedBuildInfo;
    if (!FRONTEND_VERSION) FRONTEND_VERSION = '';
    const FRONTEND_VERSION_PATTERN = /^([^-]+)-(.+)-(\d+)$/;
    const match = FRONTEND_VERSION_PATTERN.exec(FRONTEND_VERSION);
    return {
        FRONTEND_VERSION: match ? FRONTEND_VERSION : 'UNKNOWN-unknown-0',
        BRANCH_NAME: match ? match[2] : 'unknown',
        BUILD_NUMBER: match ? parseInt(match[3], 10) : 0,
        BUILD_DATE: injectedBuildInfo.BUILD_DATE || 0,
        PUBLIC_PATH: injectedBuildInfo.PUBLIC_PATH || 'unknown',
        RELEASE_TRACK: $fb0776fab4601f82$var$getReleaseTrack()
    };
}

});

parcelRegister("6X8o4", function(module, exports) {

$parcel$export(module.exports, "liftPromiseState", () => $bcb98143ff5ee717$export$cc373701aed148fc);
$parcel$export(module.exports, "isResolved", () => $bcb98143ff5ee717$export$b1a2a6bd0c6f9666);
$parcel$export(module.exports, "getValue", () => $bcb98143ff5ee717$export$bf7199a9ebcb84a9);
const $bcb98143ff5ee717$var$PromiseStatus = Symbol.for('PromiseStatus');
const $bcb98143ff5ee717$var$PromiseValue = Symbol.for('PromiseValue');
const $bcb98143ff5ee717$export$cc373701aed148fc = (promise)=>{
    const newPromise = promise.then((value)=>{
        newPromise[$bcb98143ff5ee717$var$PromiseStatus] = 'resolved';
        newPromise[$bcb98143ff5ee717$var$PromiseValue] = value;
        return value;
    }, (error)=>{
        newPromise[$bcb98143ff5ee717$var$PromiseStatus] = 'rejected';
        newPromise[$bcb98143ff5ee717$var$PromiseValue] = error;
        throw error;
    });
    newPromise[$bcb98143ff5ee717$var$PromiseStatus] = 'pending';
    return newPromise;
};
const $bcb98143ff5ee717$export$b1a2a6bd0c6f9666 = (liftedPromise)=>liftedPromise[$bcb98143ff5ee717$var$PromiseStatus] === 'resolved';
const $bcb98143ff5ee717$export$bf7199a9ebcb84a9 = (liftedPromise)=>liftedPromise[$bcb98143ff5ee717$var$PromiseValue];

});

parcelRegister("8dwdz", function(module, exports) {

$parcel$export(module.exports, "isMobileUserAgent", () => $a209961579457491$export$abee7d877fc322c9);
$parcel$export(module.exports, "isDesktopOverrideActive", () => $a209961579457491$export$cc63546398e0df2);
$parcel$export(module.exports, "activateDesktopOverride", () => $a209961579457491$export$47a2095e97aaa3d3);
$parcel$export(module.exports, "deactivateDesktopOverride", () => $a209961579457491$export$77ee453f21ed22ca);
$parcel$export(module.exports, "shouldShowMobileWeb", () => $a209961579457491$export$1adf40e7373cdd98);
$parcel$export(module.exports, "isNativeAndroid", () => $a209961579457491$export$4483f9f8ce987764);
$parcel$export(module.exports, "isNativeIOS", () => $a209961579457491$export$63c82ea425a2bb3d);

var $cMvQV = parcelRequire("cMvQV");

var $7W8i8 = parcelRequire("7W8i8");
// Must call this before any browser-helper functions, to ensure user agent has been set first
(0, $cMvQV.setUserAgent)();
const $a209961579457491$var$logger = (0, $7W8i8.getLogger)('mobile-detection');
// Copied from com.atlassian.confluence.mobile.MobileUtils
const $a209961579457491$var$NATIVE_IOS_REGEX_STRING = 'iPhone;|iPad;|iPhone Simulator;|iPod;|iPod touch;';
const $a209961579457491$var$NATIVE_ANDROID_REGEX_STRING = 'Linux; U; Android|Android';
const $a209961579457491$var$MOBILE_USER_AGENT_REGEX = new RegExp(`(${$a209961579457491$var$NATIVE_IOS_REGEX_STRING}|${$a209961579457491$var$NATIVE_ANDROID_REGEX_STRING})`, 'i');
const $a209961579457491$var$ANDROID_CHROME = /Chrome\/[.\d]* Mobile/i;
const $a209961579457491$var$OLD_ANDROID = /Linux; U; Android (?:[23]\.\d|4\.0\.[12])/i;
const $a209961579457491$var$NATIVE_IOS = new RegExp(`(${$a209961579457491$var$NATIVE_IOS_REGEX_STRING})`, 'i');
const $a209961579457491$var$NATIVE_ANDROID = new RegExp(`(${$a209961579457491$var$NATIVE_ANDROID_REGEX_STRING})`, 'i');
const $a209961579457491$export$bb3c728251279d4a = 'mobileWebTestingMode=testing';
const $a209961579457491$export$2275282fb5681637 = 'mobile.web.desktop.override.active';
const $a209961579457491$export$abee7d877fc322c9 = ()=>{
    // Port from com.atlassian.confluence.mobile.MobileUtils#isMobileViewRequest
    const ua = window.navigator.userAgent;
    return !!ua && !$a209961579457491$var$OLD_ANDROID.test(ua) && ($a209961579457491$var$MOBILE_USER_AGENT_REGEX.test(ua) || $a209961579457491$var$ANDROID_CHROME.test(ua) || (0, $cMvQV.isNativeMobile)());
};
const $a209961579457491$export$cc63546398e0df2 = ()=>window.localStorage.getItem($a209961579457491$export$2275282fb5681637) === 'true';
const $a209961579457491$export$47a2095e97aaa3d3 = ()=>{
    try {
        // TODO: Remove lint rule once storage is updated to use atlassian/browser-storage-controls or confluence/storage-manager
        // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
        window.localStorage.setItem($a209961579457491$export$2275282fb5681637, 'true');
    } catch (err) {
        $a209961579457491$var$logger.error`Unable to set local storage. key = "${$a209961579457491$export$2275282fb5681637}", value = "true"`;
    }
};
const $a209961579457491$export$77ee453f21ed22ca = ()=>window.localStorage.removeItem($a209961579457491$export$2275282fb5681637);
function $a209961579457491$export$1adf40e7373cdd98() {
    // for testing purposes, query param forces mobile web
    if (window.location.search.includes($a209961579457491$export$bb3c728251279d4a)) return true;
    return $a209961579457491$export$abee7d877fc322c9() && !$a209961579457491$export$cc63546398e0df2();
}
const $a209961579457491$export$4483f9f8ce987764 = ()=>{
    const ua = window.navigator.userAgent;
    return !!ua && $a209961579457491$var$NATIVE_ANDROID.test(ua);
};
const $a209961579457491$export$63c82ea425a2bb3d = ()=>{
    const ua = window.navigator.userAgent;
    return !!ua && $a209961579457491$var$NATIVE_IOS.test(ua);
};

});
parcelRegister("7W8i8", function(module, exports) {

$parcel$export(module.exports, "getLogger", () => $adab7063d3512c85$export$2b1d391cd05230fd);
/* eslint-disable no-console */ function $adab7063d3512c85$var$getLoggerName(logSource) {
    return typeof logSource === 'string' ? logSource : logSource.displayName || logSource.name || 'Unknown';
}
class $adab7063d3512c85$var$Logger {
    log(strings, ...values) {
        this.logAnyLevel(1, console.log, strings, values);
    }
    debug(strings, ...values) {
        this.logAnyLevel(2, console.debug, strings, values);
    }
    info(strings, ...values) {
        this.logAnyLevel(3, console.info, strings, values);
    }
    warn(strings, ...values) {
        this.logAnyLevel(4, console.warn, strings, values);
    }
    error(strings, ...values) {
        this.logAnyLevel(5, console.error, strings, values);
    }
    logAnyLevel(logLevel, consoleFunction, strings, values) {
        try {
            if (// There's no sessionStorage in service workers.
            // We'll just enable logging from service workers for simplicity.
            typeof sessionStorage === 'undefined' || sessionStorage.getItem('confluence.enable-logging') === 'true') {
                const logLevelSetting = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('confluence.log-level');
                const configuredLogLevel = parseInt(logLevelSetting || '', 10) || 1;
                if (configuredLogLevel > logLevel) return;
                const prefix = [
                    `[@${Math.round(performance.now())} ${this.name}]`
                ];
                const messages = strings.reduce((processed, str, index)=>{
                    const value = values[index];
                    const trimmedStr = str.trim()// Allow multiline strings to be indented in code but printed without indenting
                    .replace(/\n\s+/g, '\n');
                    if (trimmedStr) processed.push(trimmedStr);
                    if (index !== strings.length - 1) processed.push(typeof value === 'string' ? JSON.stringify(value) : value);
                    return processed;
                }, prefix);
                consoleFunction(...messages);
            }
        } catch (e) {
            // Catch and log.
            // We don't want to stop execution due to a logging error.
            console.error(e);
        }
    }
    constructor(logSource){
        this.name = void 0;
        this.name = $adab7063d3512c85$var$getLoggerName(logSource);
    }
}
const $adab7063d3512c85$export$2b1d391cd05230fd = (logSource)=>new $adab7063d3512c85$var$Logger(logSource);

});


parcelRegister("hNuGv", function(module, exports) {

$parcel$export(module.exports, "storeOrigin", () => $58c1a29bfb57901c$export$53cb6decc268273b);

var $f7B1p = parcelRequire("f7B1p");

var $45Amf = parcelRequire("45Amf");
const $58c1a29bfb57901c$export$53cb6decc268273b = (attributes)=>{
    const URI = window['GLOBAL_APOLLO_CLIENT_URI'] || '/cgraphql';
    (0, $f7B1p.cfetch)(`${URI}?q=isNewUserQuery`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'X-APOLLO-OPERATION-NAME': 'isNewUserQuery',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            operationName: 'isNewUserQuery',
            query: (0, $45Amf.isNewUserQuery)
        })
    }).then(async (res)=>{
        if (res.ok) {
            const data = await res.json();
            const isNewUser = data?.data?.isNewUser || false;
            if (!!isNewUser) {
                (0, $f7B1p.cfetch)('/wiki/rest/onboarding/1/store', {
                    method: 'PUT',
                    body: JSON.stringify({
                        key: 'onboarding-origin-state:attributes',
                        value: JSON.stringify(attributes)
                    }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                window.dispatchEvent(new Event('onboardingAttributesUpdated'));
            }
        }
    });
};

});
parcelRegister("f7B1p", function(module, exports) {

$parcel$export(module.exports, "cfetch", () => $9d631243cbb35282$export$7fd82c6bb3f5e7d5);

var $7W8i8 = parcelRequire("7W8i8");


var $cgNzK = parcelRequire("cgNzK");

var $hBkCm = parcelRequire("hBkCm");

var $flE5X = parcelRequire("flE5X");

var $8pZFw = parcelRequire("8pZFw");

var $14DR2 = parcelRequire("14DR2");

var $3P4tJ = parcelRequire("3P4tJ");

var $c0BL4 = parcelRequire("c0BL4");
const $9d631243cbb35282$export$7fd82c6bb3f5e7d5 = async (resource, init = {})=>{
    if (typeof window !== 'undefined' && window['GLOBAL_FALLBACK_ATL_EXP']) {
        if (resource instanceof Request && resource.url.startsWith('/cgraphql')) resource.headers.append((0, $c0BL4.X_ATL_EXPERIENCE), resource.headers.get((0, $c0BL4.X_ATL_EXPERIENCE)) || window['GLOBAL_FALLBACK_ATL_EXP']);
        else if (String(resource).startsWith('/cgraphql')) {
            init.headers = init?.headers || {};
            // For requests sending outside of exp tracker scope fallback to URL based exp name
            (0, $14DR2.appendHeader)(init.headers, (0, $c0BL4.X_ATL_EXPERIENCE), (0, $3P4tJ.getHeaderValue)(init.headers, (0, $c0BL4.X_ATL_EXPERIENCE)) || window['GLOBAL_FALLBACK_ATL_EXP']);
        }
    }
    // eslint-disable-next-line prefer-const
    let { ignoreNoNetworkError: ignoreNoNetworkError, requestInit: requestInit } = $9d631243cbb35282$var$decomposeInit(init);
    // XXX Default RequestInit's credentials to "include" but not always: if the
    // caller provided a Request as resource and no init, then us adding a
    // RequestInit can break the caller.
    if (!resource || typeof resource === 'string' || !resource.credentials) requestInit = {
        credentials: 'include',
        ...requestInit
    };
    let response;
    try {
        // eslint-disable-next-line check-credentials-option/has-credentials-option, no-restricted-syntax
        response = await fetch(resource, requestInit);
    } catch (e) {
        // According to the fetch spec, a network failure results in a Promise
        // rejected with a TypeError. Any Response at all will resolve the Promise,
        // with the status property revealing the HTTP status code.
        const error = new (0, $flE5X.NoNetworkError)(`Network failure: ${e}`, {
            cause: e
        });
        error.ignore = ignoreNoNetworkError;
        error.ignore || $9d631243cbb35282$var$emit(/* response */ undefined, error);
        throw error;
    }
    // If we don't get a 2xx Response, we'll consider that an error, and we'll
    // throw an exception. If we don't, we risk developers not checking the
    // Response status, running parsing logic such as parsing JSON, and failing
    // on non-2xx HTTP status code with weird errors like:
    // * Unexpected end of JSON input
    // * Unexpected token < in JSON at position 0
    // * JSON.parse: unexpected end of data at line 1 column 1 of the JSON data
    // * etc.
    //
    // By using our own Error subclass, we can prevent such unintended running of
    // parsing logic and we allow the product easily recognize the error and apply
    // product-wide processing.
    if (!response.ok) {
        let error;
        if (response.status === 429) error = new (0, $8pZFw.RateLimitedError)(resource.toString(), response);
        else error = new (0, $hBkCm.BadStatusError)(`Received status ${response.status}`, response);
        $9d631243cbb35282$var$emit(response, error);
        throw error;
    }
    $9d631243cbb35282$var$emit(response, /* error */ undefined);
    return response;
};
function $9d631243cbb35282$var$decomposeInit(init = {}) {
    const { ignoreNoNetworkError: ignoreNoNetworkError, ...requestInit } = init;
    return {
        ignoreNoNetworkError: ignoreNoNetworkError,
        requestInit: Object.getOwnPropertyNames(requestInit).length ? (0, $cgNzK.constructCompatibleRequestInit)(requestInit) : undefined
    };
}
const $9d631243cbb35282$var$logger = (0, $7W8i8.getLogger)($9d631243cbb35282$export$7fd82c6bb3f5e7d5);
let $9d631243cbb35282$var$subscribers = [];
/**
 * Adds a specific `subscriber` to be notified whenever any `cfetch` call
 * resolves with a `Response` and/or an `Error`. If you're calling `cfetch` and
 * are interested in the outcome of that particular call only, please await the
 * resolution of the `Promise` returned by `cfetch`.
 */ $9d631243cbb35282$export$7fd82c6bb3f5e7d5.subscribe = (subscriber)=>{
    if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
    $9d631243cbb35282$var$subscribers.push(subscriber);
    return ()=>{
        $9d631243cbb35282$var$subscribers = $9d631243cbb35282$var$subscribers.filter((x)=>x !== subscriber);
    };
};
function $9d631243cbb35282$var$emit(response, error) {
    $9d631243cbb35282$var$subscribers.forEach((subscriber)=>{
        try {
            subscriber(response, error);
        } catch (e) {
            $9d631243cbb35282$var$logger.error`Error occurred in a cfetch subscriber: ${e}`;
        }
    });
}

});
parcelRegister("cgNzK", function(module, exports) {

$parcel$export(module.exports, "constructCompatibleRequestInit", () => $e9eb431104406f8e$export$eca64eb737a4c2bc);
function $e9eb431104406f8e$export$eca64eb737a4c2bc(requestInit) {
    // referrerPolicy is not supported by Edge pre Chromium:
    if (requestInit && 'referrerPolicy' in requestInit) {
        const { referrerPolicy: referrerPolicy, ...requestInitWithoutReferrerPolicy } = requestInit;
        try {
            new Request('/', {
                referrerPolicy: referrerPolicy
            });
        // The referrerPolicy seems to be supported. Leave it in requestInit.
        } catch (_) {
            // The referrerPolicy does not seem to be supported. Drop it from
            // requestInit; otherwise, the Request constructor and fetch will throw:
            requestInit = requestInitWithoutReferrerPolicy;
        }
    }
    return requestInit;
}

});

parcelRegister("hBkCm", function(module, exports) {

$parcel$export(module.exports, "BadStatusError", () => $725b5147ae15e4c9$export$12c8b3d0a1a46f87);

var $9kGfD = parcelRequire("9kGfD");

var $6fil2 = parcelRequire("6fil2");
class $725b5147ae15e4c9$export$12c8b3d0a1a46f87 extends (0, $6fil2.NetworkError) {
    get traceId() {
        return (0, $9kGfD.getTraceIdFromResponse)(this.response);
    }
    static isBadStatusError(value) {
        return value instanceof $725b5147ae15e4c9$export$12c8b3d0a1a46f87;
    }
    constructor(message, response){
        super(message);
        this.response = void 0;
        this.name = 'BadStatusError';
        this.response = response;
    }
}

});
parcelRegister("9kGfD", function(module, exports) {

$parcel$export(module.exports, "getTraceIdFromResponse", () => $2ab84c9d21556fcf$export$9f229e40eb65abfc);
const $2ab84c9d21556fcf$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-b3-traceid') || response?.headers?.get('atl-traceid') || null;

});

parcelRegister("6fil2", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $28de7f8962acb00f$export$bae979e68e4dc802);
/**
 * The base type of all `Error` subclasses defined by the package
 * @confluence/network. Introduced to facilitate the recognition of the errors
 * within the product and, for example, not rewrap them into more generic
 * `Error` types at exception `catch` sites.
 */ class $28de7f8962acb00f$export$bae979e68e4dc802 extends Error {
}

});


parcelRegister("flE5X", function(module, exports) {

$parcel$export(module.exports, "NoNetworkError", () => $97ab40fc05a809aa$export$79f50640f30c1c0e);
$parcel$export(module.exports, "containsNoNetworkError", () => $97ab40fc05a809aa$export$c56f51797021fa9f);
$parcel$export(module.exports, "causedByAbortError", () => $97ab40fc05a809aa$export$762bd3eeab681428);

var $aTqya = parcelRequire("aTqya");

var $8H5XZ = parcelRequire("8H5XZ");

var $6fil2 = parcelRequire("6fil2");
class $97ab40fc05a809aa$export$79f50640f30c1c0e extends (0, $6fil2.NetworkError) {
    constructor(...args){
        super(...args);
        /**
     * If the call site of `cfetch` has indicated that `NoNetworkError`s are to be
     * ignored by handlers, then `true`; otherwise, `false` or `undefined`.
     */ this.ignore = void 0;
        /**
     * Indicates whether the error was exposed to the feature gate `platform_editor_bubble_cfe_gql_network_errors`
     * and subsequently bubbled up to the client. This property is used to track errors originating from this
     * feature gate in analytics events.
     *
     * Note: This property is temporary and may be removed during the cleanup of the feature gate.
     */ this.wasBubbledUp = void 0;
    }
}
function $97ab40fc05a809aa$export$c56f51797021fa9f(error) {
    if (error instanceof $97ab40fc05a809aa$export$79f50640f30c1c0e) return true;
    if ((0, $aTqya.isApolloError)(error)) {
        const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
        if (networkError) // ApolloError describes a network-related error if its networkError
        // property value is truthy. These are errors that have occurred within a
        // NetworkLink of ApolloClient. Think non-experimental queries (and
        // mutations).
        return true;
        return graphQLErrors.some($97ab40fc05a809aa$export$c56f51797021fa9f);
    }
    if ((0, $8H5XZ.isGraphQLError)(error)) {
        const { originalError: originalError } = error;
        if (originalError) return $97ab40fc05a809aa$export$c56f51797021fa9f(originalError);
    }
    return false;
}
function $97ab40fc05a809aa$export$762bd3eeab681428(error) {
    return error.cause instanceof Error && error.cause?.name === 'AbortError';
}

});
parcelRegister("8H5XZ", function(module, exports) {

$parcel$export(module.exports, "isGraphQLError", () => $82406df716527994$export$d54488e5d0ecaef7);

var $bGj3X = parcelRequire("bGj3X");
function $82406df716527994$export$d54488e5d0ecaef7(value) {
    return value instanceof (0, $bGj3X.GraphQLError);
}

});


parcelRegister("8pZFw", function(module, exports) {

$parcel$export(module.exports, "RateLimitedError", () => $7671de4d2b536449$export$b5f929f4d77c16a9);

var $hBkCm = parcelRequire("hBkCm");
const $7671de4d2b536449$var$RATE_LIMIT_TEXT_MARK = 'rate limit exceeded';
class $7671de4d2b536449$export$b5f929f4d77c16a9 extends (0, $hBkCm.BadStatusError) {
    constructor(message, response){
        super(`${message} ${$7671de4d2b536449$var$RATE_LIMIT_TEXT_MARK}`, response);
    }
}

});

parcelRegister("14DR2", function(module, exports) {

$parcel$export(module.exports, "appendHeader", () => $92ce0641c5e05da2$export$bee20cbc27fea50);
function $92ce0641c5e05da2$export$bee20cbc27fea50(headers, headerName, headerValue) {
    if (Array.isArray(headers)) {
        headers.push([
            headerName,
            headerValue
        ]);
        return;
    }
    if (headers instanceof Headers) {
        headers.append(headerName, headerValue);
        return;
    }
    headers[headerName] = headerValue;
}

});

parcelRegister("3P4tJ", function(module, exports) {

$parcel$export(module.exports, "getHeaderValue", () => $82686a09d9ecb1b0$export$149b1181d497cd);
function $82686a09d9ecb1b0$export$149b1181d497cd(headers, headerName) {
    if (Array.isArray(headers)) {
        const header = headers.find(([name])=>name === headerName);
        return header ? header[1] : null;
    }
    if (headers instanceof Headers) return headers.get(headerName);
    return headers[headerName] ?? null;
}

});

parcelRegister("c0BL4", function(module, exports) {

$parcel$export(module.exports, "X_ATL_EXPERIENCE", () => $ef04b7af4a33fe58$export$1fccf6c6ebec28fe);
$parcel$export(module.exports, "X_ATL_EXPERIENCE_ID", () => $ef04b7af4a33fe58$export$ecc9e1785213e182);
const $ef04b7af4a33fe58$export$1fccf6c6ebec28fe = 'X-Atl-Experience';
const $ef04b7af4a33fe58$export$ecc9e1785213e182 = 'X-Atl-Experience-Id';

});


parcelRegister("45Amf", function(module, exports) {

$parcel$export(module.exports, "isNewUserQuery", () => $fc053589e4468ba9$export$54fe7bbc3a8667b6);
const $fc053589e4468ba9$export$54fe7bbc3a8667b6 = `
  query isNewUserQuery {
    isNewUser
  }
`;

});


parcelRegister("1nHJi", function(module, exports) {

let $1019dc32308d5298$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1019dc32308d5298$var$load("5NexJ"),
    $1019dc32308d5298$var$load("kksGF"),
    $1019dc32308d5298$var$load("e1Z8a")
]).then(()=>parcelRequire('dQOC0'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});



parcelRegister("6i7sf", function(module, exports) {

let $494a34dbd30bd9d7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $494a34dbd30bd9d7$var$load("iEydq").then(()=>parcelRequire('cOKrX'));

});

parcelRegister("jJvsh", function(module, exports) {

let $e5da9e9c43a1c77e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e5da9e9c43a1c77e$var$load("8pGOz").then(()=>parcelRequire('2d1CS'));

});

parcelRegister("ffzg1", function(module, exports) {

let $b1a39b232a4cb454$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b1a39b232a4cb454$var$load("cjBpP").then(()=>parcelRequire('2Y5wI'));

});


parcelRegister("a9sR2", function(module, exports) {

$parcel$export(module.exports, "STARGATE_PROXY_PATH", () => $bc3bdafb6daaa863$export$5df9262e102d0c32);
$parcel$export(module.exports, "default", () => $bc3bdafb6daaa863$export$2e2bcd8739ae039);

var $kyKWe = parcelRequire("kyKWe");

var $5DUgU = parcelRequire("5DUgU");

var $aJbPn = parcelRequire("aJbPn");

var $8q32I = parcelRequire("8q32I");

var $7Ehig = parcelRequire("7Ehig");

var $gdxd7 = parcelRequire("gdxd7");

var $eEfSM = parcelRequire("eEfSM");

var $epqyT = parcelRequire("epqyT");

var $kmef7 = parcelRequire("kmef7");

var $a2fLP = parcelRequire("a2fLP");

var $jPyiF = parcelRequire("jPyiF");

var $3D7sH = parcelRequire("3D7sH");

var $2Wu5Y = parcelRequire("2Wu5Y");

var $79AM5 = parcelRequire("79AM5");

var $2ineN = parcelRequire("2ineN");

var $5eUc8 = parcelRequire("5eUc8");

var $jHQZY = parcelRequire("jHQZY");

var $4IbNq = parcelRequire("4IbNq");

var $iExg3 = parcelRequire("iExg3");

var $jExeP = parcelRequire("jExeP");

var $31AK1 = parcelRequire("31AK1");

var $irySC = parcelRequire("irySC");

var $6zoZA = parcelRequire("6zoZA");
const $bc3bdafb6daaa863$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
const $bc3bdafb6daaa863$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $bc3bdafb6daaa863$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $bc3bdafb6daaa863$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $bc3bdafb6daaa863$export$2e2bcd8739ae039 {
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $31AK1.TestSupport).isGeminiVREnvironment() && !(0, $31AK1.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $31AK1.TestSupport).isGeminiVREnvironment() && !(0, $31AK1.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
    constructor(productInfo, settings = {}){
        this._apdexEvent = void 0;
        this._context = void 0;
        this._eventDelayQueue = void 0;
        this._historyReplaceFn = void 0;
        this._orgInfo = void 0;
        this._pageVisibility = void 0;
        this._internalProductInfo = void 0;
        this._safeSessionStorage = void 0;
        this._sessionTracking = void 0;
        this._tabTracking = void 0;
        this._tenantInfo = void 0;
        this._testingCache = void 0;
        this._uiViewedAttributes = void 0;
        this._uiViewedEvent = void 0;
        this._userInfo = void 0;
        this._originTracing = void 0;
        this._task = void 0;
        this._pageLoadId = void 0;
        this._workspaceInfo = void 0;
        this._aliases = void 0;
        this._groups = void 0;
        this._eventProcessor = void 0;
        this._logger = void 0;
        this._embeddedContext = void 0;
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $8q32I.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $8q32I.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($bc3bdafb6daaa863$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (err) {
                this._safeSessionStorage.removeItem($bc3bdafb6daaa863$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($bc3bdafb6daaa863$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $5DUgU.eventType).UI:
                case (0, $5DUgU.eventType).OPERATIONAL:
                case (0, $5DUgU.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $5DUgU.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $5DUgU.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $5DUgU.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $5DUgU.isType)((0, $5DUgU.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $5DUgU.objectValues)((0, $5DUgU.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $epqyT.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $5DUgU.isType)((0, $5DUgU.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $5DUgU.objectValues)((0, $5DUgU.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $5DUgU.isType)((0, $5DUgU.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $5DUgU.objectValues)((0, $5DUgU.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $5DUgU.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $epqyT.validateScreenEvent)(screenName);
            (0, $epqyT.validateContainers)(screenContainers);
            const builtEvent = (0, $gdxd7.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $irySC.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $epqyT.validateTrackEvent)(event);
            const builtEvent = (0, $gdxd7.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $5DUgU.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $gdxd7.buildActionName)(event), builtEvent, this._context, (0, $irySC.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $epqyT.validateUIEvent)(event);
            const builtEvent = (0, $gdxd7.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $5DUgU.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $gdxd7.buildActionName)(event), builtEvent, this._context, (0, $irySC.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $epqyT.validateOperationalEvent)(event);
            const builtEvent = (0, $gdxd7.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $5DUgU.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $gdxd7.buildActionName)(event), builtEvent, this._context, (0, $irySC.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $iExg3.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $5DUgU.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $5DUgU.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $5DUgU.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $5DUgU.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $5DUgU.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $5DUgU.objectValues)((0, $5DUgU.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $5DUgU.isType)((0, $5DUgU.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $5DUgU.objectValues)((0, $5DUgU.envType))}]`);
        if (productInfo.perimeter && !(0, $5DUgU.isType)((0, $5DUgU.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $5DUgU.objectValues)((0, $5DUgU.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $5DUgU.originType).WEB;
        else if (!(0, $5DUgU.isType)((0, $5DUgU.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $5DUgU.objectValues)((0, $5DUgU.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $5DUgU.originType).WEB ? (0, $5DUgU.platformType).WEB : (0, $5DUgU.platformType).DESKTOP;
        else (0, $epqyT.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo?.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $7Ehig.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $7Ehig.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $gdxd7.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $2ineN.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $2Wu5Y.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $6zoZA.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $a2fLP.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $kmef7.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $bc3bdafb6daaa863$export$48361b6ed38f1b0.getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $3D7sH.default)();
        this._tabTracking = new (0, $5eUc8.default)();
        this._sessionTracking = new (0, $79AM5.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $jHQZY.default)();
        this._originTracing = new (0, $jPyiF.default)();
        // Init Apdex
        this._apdexEvent = new (0, $aJbPn.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $jExeP.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $eEfSM.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $4IbNq.default)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
    }
}

});
parcelRegister("5DUgU", function(module, exports) {

$parcel$export(module.exports, "envType", () => $70ec6637eda69bb4$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $70ec6637eda69bb4$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $70ec6637eda69bb4$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $70ec6637eda69bb4$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $70ec6637eda69bb4$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $70ec6637eda69bb4$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $70ec6637eda69bb4$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $70ec6637eda69bb4$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $70ec6637eda69bb4$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $70ec6637eda69bb4$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $70ec6637eda69bb4$export$62a500c02dc63ee);
$parcel$export(module.exports, "objectValues", () => $70ec6637eda69bb4$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "isType", () => $70ec6637eda69bb4$export$26b9f946b448f23e);
$parcel$export(module.exports, "perimeterType", () => $70ec6637eda69bb4$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $70ec6637eda69bb4$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $70ec6637eda69bb4$export$e73680b18d9b7c6e);
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $70ec6637eda69bb4$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $70ec6637eda69bb4$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $70ec6637eda69bb4$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
	 *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
	 */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $70ec6637eda69bb4$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $70ec6637eda69bb4$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $70ec6637eda69bb4$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $70ec6637eda69bb4$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $70ec6637eda69bb4$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $70ec6637eda69bb4$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $70ec6637eda69bb4$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $70ec6637eda69bb4$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $70ec6637eda69bb4$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $70ec6637eda69bb4$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var $70ec6637eda69bb4$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $70ec6637eda69bb4$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $70ec6637eda69bb4$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $70ec6637eda69bb4$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("aJbPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4b812cbc3a59940$export$2e2bcd8739ae039);

var $5DUgU = parcelRequire("5DUgU");

var $3D7sH = parcelRequire("3D7sH");

var $ipDXS = parcelRequire("ipDXS");
class $a4b812cbc3a59940$export$2e2bcd8739ae039 {
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
    constructor(onEvent, pageVisibility){
        this._isActiveEvents = void 0;
        this._onEvent = void 0;
        this._pageVisibility = void 0;
        this._performance = void 0;
        this._startedEvents = void 0;
        this._threshold = void 0;
        this._wasPreviouslyHidden = void 0;
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $5DUgU.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $5DUgU.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $5DUgU.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $5DUgU.isType)((0, $5DUgU.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $5DUgU.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $3D7sH.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $ipDXS.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
}

});
parcelRegister("3D7sH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5401be2930f14104$export$2e2bcd8739ae039);
class $5401be2930f14104$export$2e2bcd8739ae039 {
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
    constructor(){
        this._callbacks = void 0;
        this._hidden = void 0;
        this._isHidden = void 0;
        this._visibilityChange = void 0;
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
}

});

parcelRegister("ipDXS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e78379f44c50158e$export$2e2bcd8739ae039);
class $e78379f44c50158e$export$2e2bcd8739ae039 {
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
    constructor(){
        this._performance = void 0;
        this._performance = window.performance;
    }
}

});


parcelRegister("8q32I", function(module, exports) {

$parcel$export(module.exports, "default", () => $29a361f5f1eed66e$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $29a361f5f1eed66e$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $29a361f5f1eed66e$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($29a361f5f1eed66e$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("7Ehig", function(module, exports) {

$parcel$export(module.exports, "isFirstParty", () => $a12ec36efbd18e1b$export$f56713ced121eb91);
$parcel$export(module.exports, "isThirdParty", () => $a12ec36efbd18e1b$export$ab34f90cc32c8960);

var $5DUgU = parcelRequire("5DUgU");
const $a12ec36efbd18e1b$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $5DUgU.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const $a12ec36efbd18e1b$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $5DUgU.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("gdxd7", function(module, exports) {

$parcel$export(module.exports, "buildActionFields", () => $7599af0b503dbd64$export$655ecf7241feac42);
$parcel$export(module.exports, "buildScreenEvent", () => $7599af0b503dbd64$export$c7d9a5f56acc4b19);
$parcel$export(module.exports, "buildActionName", () => $7599af0b503dbd64$export$9c5623a792efc9b0);
$parcel$export(module.exports, "buildContext", () => $7599af0b503dbd64$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "buildActionEvent", () => $7599af0b503dbd64$export$7bf451af4a8e3dd9);

var $5DUgU = parcelRequire("5DUgU");

var $bKFjF = parcelRequire("bKFjF");
const $7599af0b503dbd64$var$libraryVersion = "0.0.0-use.local";
function $7599af0b503dbd64$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $7599af0b503dbd64$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $7599af0b503dbd64$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $7599af0b503dbd64$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $7599af0b503dbd64$var$buildAliases(aliases) {
    if ($7599af0b503dbd64$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $7599af0b503dbd64$var$buildGroups(groups) {
    if ($7599af0b503dbd64$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $7599af0b503dbd64$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $7599af0b503dbd64$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $7599af0b503dbd64$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $7599af0b503dbd64$var$getProductField(productInfo.env, overrides.env);
    const product = $7599af0b503dbd64$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $7599af0b503dbd64$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $7599af0b503dbd64$var$getProductField(productInfo.version, overrides.version);
    const origin = $7599af0b503dbd64$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $7599af0b503dbd64$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $7599af0b503dbd64$var$isNotEmptyObject(obj) {
    return (0, $bKFjF.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $7599af0b503dbd64$var$buildAttributesWithName(name, attrObject) {
    return $7599af0b503dbd64$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $7599af0b503dbd64$var$buildAttributes(attributes) {
    return $7599af0b503dbd64$var$buildAttributesWithName('attributes', attributes);
}
function $7599af0b503dbd64$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $7599af0b503dbd64$export$f045f238d77c002a(containers) {
    if ($7599af0b503dbd64$var$isNotEmptyObject(containers)) {
        const validContainers = $7599af0b503dbd64$export$3f5115a568819c1a(containers);
        return $7599af0b503dbd64$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $7599af0b503dbd64$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...$7599af0b503dbd64$export$f045f238d77c002a(event.containers)
    };
}
function $7599af0b503dbd64$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $7599af0b503dbd64$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $7599af0b503dbd64$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $7599af0b503dbd64$var$buildProductFields(productInfo);
    const tenantFields = $7599af0b503dbd64$var$buildTenantFields(tenantInfo);
    const userFields = $7599af0b503dbd64$var$buildUserFields(userInfo);
    const orgFields = $7599af0b503dbd64$var$buildOrgFields(orgInfo);
    const workspaceFields = $7599af0b503dbd64$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $5DUgU.eventType).SCREEN
    };
    return {
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...overrides,
        ...$7599af0b503dbd64$var$buildAttributes(attributes),
        ...$7599af0b503dbd64$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...$7599af0b503dbd64$export$f045f238d77c002a(containers),
        ...$7599af0b503dbd64$var$buildEventOverrides(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$7599af0b503dbd64$var$buildAliases(aliases),
        ...$7599af0b503dbd64$var$buildGroups(groups)
    };
}
function $7599af0b503dbd64$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
var $7599af0b503dbd64$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $7599af0b503dbd64$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return "quiet";
    if (environment.includes('prod')) return "quiet";
    return "complete";
}
function $7599af0b503dbd64$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $7599af0b503dbd64$var$libraryVersion
            },
            validationMode: $7599af0b503dbd64$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $7599af0b503dbd64$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $7599af0b503dbd64$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $7599af0b503dbd64$var$buildProductFields(productInfo, $7599af0b503dbd64$export$e3d99b4bfec06f6e(event));
    const tenantFields = $7599af0b503dbd64$var$buildTenantFields(tenantInfo);
    const orgFields = $7599af0b503dbd64$var$buildOrgFields(orgInfo);
    const workspaceFields = $7599af0b503dbd64$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $7599af0b503dbd64$var$buildUserFields(userInfo);
    const actionFields = $7599af0b503dbd64$export$655ecf7241feac42(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...$7599af0b503dbd64$var$buildEventOverrides(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$7599af0b503dbd64$var$buildAliases(aliases),
        ...$7599af0b503dbd64$var$buildGroups(groups)
    };
}

});
parcelRegister("bKFjF", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $9679a611363f717e$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $9679a611363f717e$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $9679a611363f717e$var$isObjectObject(o) {
    return $9679a611363f717e$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $9679a611363f717e$export$53b83ca8eaab0383(o) {
    if ($9679a611363f717e$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($9679a611363f717e$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("eEfSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa4b133ceb32e864$export$2e2bcd8739ae039);

var $c1ivF = parcelRequire("c1ivF");

var $hjbVE = parcelRequire("hjbVE");

var $jFax1 = parcelRequire("jFax1");
class $fa4b133ceb32e864$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.delayQueue = void 0;
        this.delayTimeout = void 0;
        this.delayCallback = void 0;
        this.isDelaying = void 0;
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $c1ivF.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $c1ivF.MAX_DELAY_TIMEOUT)) : (0, $c1ivF.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $jFax1.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $jFax1.StopLowPriorityEventDelayReason).MANUAL)=>{
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            this.delayCallback?.(reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $hjbVE.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("c1ivF", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $1de1af54ad722408$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $1de1af54ad722408$export$8575e30be0feb909);
const $1de1af54ad722408$export$cf090d5281b5ae06 = 10000;
const $1de1af54ad722408$export$8575e30be0feb909 = 30000;

});

parcelRegister("hjbVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $447d46b89aa14820$export$2e2bcd8739ae039);

var $gdxd7 = parcelRequire("gdxd7");

var $ewjj9 = parcelRequire("ewjj9");

var $6bN5Y = parcelRequire("6bN5Y");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $447d46b89aa14820$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $447d46b89aa14820$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $447d46b89aa14820$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.compressor = void 0;
        this.eventArgs = void 0;
        this.flushBatchTimeout = void 0;
        this.processFn = void 0;
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $447d46b89aa14820$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $447d46b89aa14820$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $ewjj9.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $ewjj9.equals)(group.userInfo, args.userInfo) && (0, $ewjj9.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $gdxd7.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $6bN5Y.default)(compressionRules);
    }
}

});
parcelRegister("ewjj9", function(module, exports) {

$parcel$export(module.exports, "mapKeys", () => $99ce6124d9125272$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $99ce6124d9125272$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $99ce6124d9125272$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $99ce6124d9125272$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $99ce6124d9125272$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $99ce6124d9125272$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $99ce6124d9125272$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $99ce6124d9125272$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $99ce6124d9125272$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $99ce6124d9125272$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $99ce6124d9125272$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $99ce6124d9125272$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $99ce6124d9125272$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$99ce6124d9125272$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $99ce6124d9125272$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});

parcelRegister("6bN5Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bea471a7c54f53e$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $gdxd7 = parcelRequire("gdxd7");

var $ewjj9 = parcelRequire("ewjj9");

var $iSMQS = parcelRequire("iSMQS");
class $1bea471a7c54f53e$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.compressionRules = void 0;
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $gdxd7.buildActionFields)(event, event.eventType);
                    contextFields = (0, $ewjj9.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $ewjj9.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $iSMQS.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("iSMQS", function(module, exports) {

$parcel$export(module.exports, "CompressionRule", () => $a4fe5d5c8f4d3ad2$export$89b3253ddfd2e6e8);

var $epqyT = parcelRequire("epqyT");

var $ewjj9 = parcelRequire("ewjj9");
class $a4fe5d5c8f4d3ad2$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        this.compressFn = void 0;
        this.predicate = void 0;
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ this.canCompress = (event)=>{
            try {
                return event && (0, $epqyT.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $ewjj9.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $epqyT.validateActionEventType)(event.eventType);
                (0, $epqyT.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("epqyT", function(module, exports) {

$parcel$export(module.exports, "validateContainers", () => $de815167dc148761$export$e63ea5d8477971d3);
$parcel$export(module.exports, "isActionEventType", () => $de815167dc148761$export$d19cebda16f7579a);
$parcel$export(module.exports, "validateActionEventType", () => $de815167dc148761$export$4a8d7476662aebcc);
$parcel$export(module.exports, "validateActionEvent", () => $de815167dc148761$export$e0c121325c66ed4c);
$parcel$export(module.exports, "validateScreenEvent", () => $de815167dc148761$export$dc993432a592dc27);
$parcel$export(module.exports, "validateTrackEvent", () => $de815167dc148761$export$8c014fd74b0c8b99);
$parcel$export(module.exports, "validateDwellBaseEvent", () => $de815167dc148761$export$39d6334da9a44984);
$parcel$export(module.exports, "validateUIEvent", () => $de815167dc148761$export$e5bac0930c812e90);
$parcel$export(module.exports, "validateOperationalEvent", () => $de815167dc148761$export$1e561554275607ef);
$parcel$export(module.exports, "validateIdentifyEvent", () => $de815167dc148761$export$c16a4e16aa4026c0);
$parcel$export(module.exports, "validatePlatform", () => $de815167dc148761$export$801b46c35394d316);

var $5DUgU = parcelRequire("5DUgU");

var $bKFjF = parcelRequire("bKFjF");
const $de815167dc148761$var$actionEventTypes = Object.freeze([
    (0, $5DUgU.eventType).OPERATIONAL,
    (0, $5DUgU.eventType).TRACK,
    (0, $5DUgU.eventType).UI
]);
function $de815167dc148761$export$df8ff30e3c960006(container) {
    if (!(0, $bKFjF.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $de815167dc148761$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$de815167dc148761$export$df8ff30e3c960006(container));
}
function $de815167dc148761$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $5DUgU.eventType).OPERATIONAL:
        case (0, $5DUgU.eventType).TRACK:
        case (0, $5DUgU.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $de815167dc148761$export$4a8d7476662aebcc(type) {
    if (!$de815167dc148761$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$de815167dc148761$var$actionEventTypes}]`);
    return true;
}
function $de815167dc148761$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $de815167dc148761$export$e63ea5d8477971d3(event.containers);
}
function $de815167dc148761$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $de815167dc148761$export$8c014fd74b0c8b99(event) {
    $de815167dc148761$export$e0c121325c66ed4c(event);
}
function $de815167dc148761$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $de815167dc148761$export$e5bac0930c812e90(event) {
    $de815167dc148761$export$e0c121325c66ed4c(event);
}
function $de815167dc148761$export$1e561554275607ef(event) {
    $de815167dc148761$export$e0c121325c66ed4c(event);
}
function $de815167dc148761$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $5DUgU.isType)((0, $5DUgU.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $5DUgU.objectValues)((0, $5DUgU.userType))}]`);
}
function $de815167dc148761$export$801b46c35394d316(productInfo) {
    if (!(0, $5DUgU.isType)((0, $5DUgU.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $5DUgU.objectValues)((0, $5DUgU.platformType))}]`);
    if (productInfo.origin === (0, $5DUgU.originType).DESKTOP && !(0, $5DUgU.isType)((0, $5DUgU.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $5DUgU.originType).WEB && !(0, $5DUgU.isType)((0, $5DUgU.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("jFax1", function(module, exports) {

$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $23e03d9a7e96f25d$export$fa6e3729c21cb8f);
var $23e03d9a7e96f25d$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("kmef7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d320daaca5f992f9$export$2e2bcd8739ae039);

var $kyKWe = parcelRequire("kyKWe");

var $2V7JZ = parcelRequire("2V7JZ");

var $5DfT9 = parcelRequire("5DfT9");

var $daDZU = parcelRequire("daDZU");

var $lnajN = parcelRequire("lnajN");

var $6YtDn = parcelRequire("6YtDn");

var $h8Ywp = parcelRequire("h8Ywp");

var $6sAlM = parcelRequire("6sAlM");

var $gJXXx = parcelRequire("gJXXx");

var $dY3L6 = parcelRequire("dY3L6");
class $d320daaca5f992f9$var$AnalyticsAPIResponse {
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
    constructor(success, validationErrors, message, code, validationReports){
        this.success = void 0;
        this.validationErrors = void 0;
        this.message = void 0;
        this.code = void 0;
        this.validationReports = void 0;
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
}
class $d320daaca5f992f9$var$Message {
    constructor(error){
        this.error = void 0;
        this.error = error;
    }
}
class $d320daaca5f992f9$var$EventValidationReport {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    constructor(messageId, results){
        this.messageId = void 0;
        this.results = void 0;
        this.messageId = messageId;
        this.results = results;
    }
}
class $d320daaca5f992f9$export$133650fcdde1b226 {
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
    constructor(success, statusCode, message, eventResponseList){
        this.success = void 0;
        this.statusCode = void 0;
        this.message = void 0;
        this.eventResponseList = void 0;
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
}
class $d320daaca5f992f9$var$EventResponse {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
    constructor(messageId, results, segmentEvent){
        this.messageId = void 0;
        this.results = void 0;
        this.segmentEvent = void 0;
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
}
class $d320daaca5f992f9$var$EventValidationResult {
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
    constructor(type, severity, propertyPath, message){
        this.type = void 0;
        this.severity = void 0;
        this.propertyPath = void 0;
        this.message = void 0;
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
}
class $d320daaca5f992f9$export$2e2bcd8739ae039 {
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $6sAlM.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $6sAlM.SegmentEventTypes).TRACK,
            properties: (0, $dY3L6.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $6sAlM.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $6sAlM.SegmentEventTypes).PAGE,
            properties: (0, $dY3L6.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $6sAlM.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $6sAlM.SegmentEventTypes).IDENTIFY,
            traits: (0, $dY3L6.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $dY3L6.prepareEventProperties)(context);
        const segmentContext = (0, $dY3L6.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo?.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch (error) {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $d320daaca5f992f9$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $d320daaca5f992f9$var$Message(responseObject.message?.error || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $d320daaca5f992f9$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $daDZU.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
    constructor(options){
        this.user = void 0;
        this.options = void 0;
        this.resilienceQueue = void 0;
        this.gasv3BatchUrl = void 0;
        this.metrics = void 0;
        this.xidPromiseCallback = void 0;
        this.responseCallback = void 0;
        this.metadataClient = void 0;
        this.useUrlFromMetadata = void 0;
        this.lastSendEventsError = void 0;
        this.lastUrlFallbackError = void 0;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: this.lastSendEventsError?.message || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: metadataInfo?.props || null,
                metadataClientMetrics: this.metadataClient?.metrics || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $h8Ywp.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $6sAlM.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $6sAlM.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $6sAlM.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $6sAlM.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $lnajN.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $gJXXx.default)(this.options?.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $5DfT9.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $2V7JZ.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
}
class $d320daaca5f992f9$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                analyticsAPIResponse.validationReports?.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $d320daaca5f992f9$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $d320daaca5f992f9$export$133650fcdde1b226(success, statusCode, (0, $6YtDn.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = analyticsAPIResponse.message?.error !== null ? analyticsAPIResponse.message.error : (0, $6YtDn.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $6YtDn.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $6YtDn.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $d320daaca5f992f9$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $d320daaca5f992f9$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error?.message) {
            const match = error.message.match($d320daaca5f992f9$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $d320daaca5f992f9$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $d320daaca5f992f9$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $d320daaca5f992f9$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $d320daaca5f992f9$export$133650fcdde1b226(false, -1, (0, $6YtDn.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}
$d320daaca5f992f9$var$BatchInterceptor.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;

});
parcelRegister("2V7JZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b5e3d6df16f2e76$export$2e2bcd8739ae039);

var $hTFK2 = parcelRequire("hTFK2");

var $hVXIk = parcelRequire("hVXIk");
var $2b5e3d6df16f2e76$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $hTFK2.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("hTFK2", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $fce38ef6e3eb1741$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $fce38ef6e3eb1741$export$2e2bcd8739ae039);

var $1uamq = parcelRequire("1uamq");
var $aSvNs = parcelRequire("aSvNs");

var $a2LhX = parcelRequire("a2LhX");
var $bE2VE = parcelRequire("bE2VE");
var $abcF7 = parcelRequire("abcF7");

var $5DfT9 = parcelRequire("5DfT9");

var $Q88CI = parcelRequire("Q88CI");

var $jqGdF = parcelRequire("jqGdF");
var $1UbVG = parcelRequire("1UbVG");

var $hVXIk = parcelRequire("hVXIk");
const $fce38ef6e3eb1741$var$ONE_MINUTE = 60000;
const $fce38ef6e3eb1741$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $fce38ef6e3eb1741$var$ONE_MINUTE,
    minRetryDelay: $fce38ef6e3eb1741$var$ONE_MINUTE,
    maxRetryDelay: $fce38ef6e3eb1741$var$ONE_MINUTE
};
const $fce38ef6e3eb1741$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $fce38ef6e3eb1741$export$2e2bcd8739ae039 {
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $abcF7.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $hVXIk.NetworkStatusEnum).OFFLINE) {
            done((0, $1UbVG.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $a2LhX.CallbackProcessingErrorName)) {
                done((0, $1UbVG.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $1uamq.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $aSvNs.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $abcF7.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $1UbVG.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $1UbVG.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $1UbVG.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || $fce38ef6e3eb1741$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $fce38ef6e3eb1741$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || $fce38ef6e3eb1741$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || $fce38ef6e3eb1741$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || $fce38ef6e3eb1741$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: options?.maxItems || $fce38ef6e3eb1741$export$d219df4fe04c04a7.maxItems,
            maxAttempts: options?.maxAttempts || $fce38ef6e3eb1741$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || $fce38ef6e3eb1741$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || $fce38ef6e3eb1741$export$d219df4fe04c04a7.minRetryDelay
        };
    }
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = void 0;
        this.resilience = void 0;
        this.batchFlushCallback = void 0;
        this.options = void 0;
        this.scheduler = void 0;
        this.longPollingScheduler = void 0;
        this.metricsCollector = void 0;
        this.networkStatus = void 0;
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $bE2VE.default)(product, {
            logger: logger,
            maxAttempts: options?.maxAttempts,
            maxEventLimit: options?.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $jqGdF.default)({
            ...this.options,
            waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $jqGdF.default)({
            ...$fce38ef6e3eb1741$var$LONG_POLLING_OPTIONS,
            waitInterval: $fce38ef6e3eb1741$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $5DfT9.default)();
        this.networkStatus = new (0, $Q88CI.default)((status)=>{
            if (status === (0, $hVXIk.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
}

});
parcelRegister("1uamq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1de69a39d0b1f5d2$export$2e2bcd8739ae039);

var $c89tL = parcelRequire("c89tL");

var $4TkE7 = parcelRequire("4TkE7");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $1de69a39d0b1f5d2$var$validSuffixs = Object.values((0, $c89tL.LocalStorageKeySuffix));
var $1de69a39d0b1f5d2$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $1de69a39d0b1f5d2$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $c89tL.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $4TkE7.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("c89tL", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeySuffix", () => $810aef977e468468$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $810aef977e468468$export$8bb2c1fb2b1765a9);
var $810aef977e468468$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $810aef977e468468$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("4TkE7", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageKeys", () => $31e8ba78da167a43$export$8433d54f767cbec5);

var $c89tL = parcelRequire("c89tL");
const $31e8ba78da167a43$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $c89tL.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $c89tL.LocalStorageKeySuffix).ACK}`,
        [(0, $c89tL.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $c89tL.LocalStorageKeySuffix).QUEUE}`,
        [(0, $c89tL.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $c89tL.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $c89tL.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $c89tL.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $c89tL.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $c89tL.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("aSvNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a21ab0356ac08551$export$2e2bcd8739ae039);

var $kyKWe = parcelRequire("kyKWe");

var $c89tL = parcelRequire("c89tL");

var $4TkE7 = parcelRequire("4TkE7");
const $a21ab0356ac08551$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $a21ab0356ac08551$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $c89tL.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $c89tL.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $a21ab0356ac08551$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $a21ab0356ac08551$var$promisedSetTimeout((0, $c89tL.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $c89tL.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $a21ab0356ac08551$var$promisedSetTimeout((0, $c89tL.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $c89tL.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $a21ab0356ac08551$var$reclaim(options, callback);
};
const $a21ab0356ac08551$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $a21ab0356ac08551$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $a21ab0356ac08551$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $a21ab0356ac08551$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $a21ab0356ac08551$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const queuesToReclaim = $a21ab0356ac08551$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$a21ab0356ac08551$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $4TkE7.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});

parcelRegister("a2LhX", function(module, exports) {

$parcel$export(module.exports, "CallbackProcessingErrorName", () => $59d0fa0e69f3d586$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $59d0fa0e69f3d586$export$2e2bcd8739ae039);
const $59d0fa0e69f3d586$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $59d0fa0e69f3d586$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $59d0fa0e69f3d586$export$2e2bcd8739ae039.prototype);
        this.name = $59d0fa0e69f3d586$export$a409c8de90e11e14;
    }
}

});

parcelRegister("bE2VE", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ba44361c624334$export$2e2bcd8739ae039);

var $7f5CY = parcelRequire("7f5CY");

var $abcF7 = parcelRequire("abcF7");

var $a2LhX = parcelRequire("a2LhX");
var $19ba44361c624334$export$2e2bcd8739ae039 = (0, $7f5CY.default);

});
parcelRegister("7f5CY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bee71b2ddcd8462$export$2e2bcd8739ae039);

var $abcF7 = parcelRequire("abcF7");

var $3a0TA = parcelRequire("3a0TA");
var $dvqOf = parcelRequire("dvqOf");

var $8Evma = parcelRequire("8Evma");

var $rBKnt = parcelRequire("rBKnt");

var $bwxao = parcelRequire("bwxao");
class $0bee71b2ddcd8462$export$2e2bcd8739ae039 {
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $8Evma.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $3a0TA.default))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
        }
        return new (0, $rBKnt.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $abcF7.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $abcF7.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $dvqOf.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $abcF7.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $rBKnt.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $abcF7.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
    constructor(namespace, options = {}){
        this.resilience = void 0;
        this.options = void 0;
        this.namespace = void 0;
        this.namespace = namespace;
        this.options = (0, $bwxao.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
}

});
parcelRegister("abcF7", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $b045c83a22757ad7$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $b045c83a22757ad7$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $b045c83a22757ad7$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $b045c83a22757ad7$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $b045c83a22757ad7$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $b045c83a22757ad7$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $b045c83a22757ad7$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $b045c83a22757ad7$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $b045c83a22757ad7$export$7710d69e6f450f20);
const $b045c83a22757ad7$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $b045c83a22757ad7$export$8cad224051643259 = 'analytics-web-client';
const $b045c83a22757ad7$export$3d8420be07b276ab = 'analytics-resilience';
const $b045c83a22757ad7$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $b045c83a22757ad7$export$89d9c1ff8ac91862 = 'timeAdded';
const $b045c83a22757ad7$export$a37d385bcd713809 = 'retryAttempts';
const $b045c83a22757ad7$export$6d8635fed0e4b14d = 15000;
var $b045c83a22757ad7$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $b045c83a22757ad7$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("3a0TA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca7ec8e55be33d55$export$2e2bcd8739ae039);
const $ca7ec8e55be33d55$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $ca7ec8e55be33d55$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $ca7ec8e55be33d55$export$2e2bcd8739ae039.prototype);
        this.name = $ca7ec8e55be33d55$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("dvqOf", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $8f3ccf74a1ef98ac$export$74101021e0969375);

var $G66Ew = parcelRequire("G66Ew");

var $a2LhX = parcelRequire("a2LhX");

var $hPwQa = parcelRequire("hPwQa");
const $8f3ccf74a1ef98ac$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $G66Ew.AbandonWriteErrorName) || errorWithName.name === (0, $a2LhX.CallbackProcessingErrorName) || errorWithName.name === (0, $hPwQa.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("G66Ew", function(module, exports) {

$parcel$export(module.exports, "AbandonWriteErrorName", () => $d395f595a54ad6ce$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $d395f595a54ad6ce$export$2e2bcd8739ae039);
const $d395f595a54ad6ce$export$ba95206613c96b28 = 'AbandonWriteError';
class $d395f595a54ad6ce$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $d395f595a54ad6ce$export$2e2bcd8739ae039.prototype);
        this.name = $d395f595a54ad6ce$export$ba95206613c96b28;
    }
}

});

parcelRegister("hPwQa", function(module, exports) {

$parcel$export(module.exports, "InvalidPolicyErrorName", () => $6052bdbaad264038$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $6052bdbaad264038$export$2e2bcd8739ae039);
const $6052bdbaad264038$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $6052bdbaad264038$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $6052bdbaad264038$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("8Evma", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9c6c49af4b53e48$export$2e2bcd8739ae039);

var $abcF7 = parcelRequire("abcF7");

var $3DBsX = parcelRequire("3DBsX");

var $a2LhX = parcelRequire("a2LhX");
var $hPwQa = parcelRequire("hPwQa");
var $3a0TA = parcelRequire("3a0TA");
var $dvqOf = parcelRequire("dvqOf");

var $kthpY = parcelRequire("kthpY");

var $bwxao = parcelRequire("bwxao");
class $c9c6c49af4b53e48$export$2e2bcd8739ae039 {
    storeType() {
        return (0, $abcF7.StoreType).INDEXEDDB;
    }
    constructor(_namespace, _options = {}){
        this.db = void 0;
        this.logger = void 0;
        this.globalEventLimitGuard = void 0;
        this.options = void 0;
        this.namespace = void 0;
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $3a0TA.default)());
                    }, (0, $abcF7.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $abcF7.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $abcF7.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $abcF7.TIME_TO_PROCESS_AFTER_INDEX), (0, $abcF7.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $abcF7.RETRY_INDEX), (0, $abcF7.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $abcF7.TIME_ADDED_INDEX), (0, $abcF7.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $abcF7.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $3a0TA.default)());
                    };
                    try {
                        await (0, $bwxao.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $3a0TA.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $3a0TA.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $abcF7.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $bwxao.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $abcF7.GuardPolicy).IGNORE) throw new (0, $hPwQa.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $dvqOf.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $abcF7.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $bwxao.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $dvqOf.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $3DBsX.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $3DBsX.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $abcF7.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $3DBsX.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $bwxao.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $bwxao.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $bwxao.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $bwxao.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $abcF7.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $bwxao.requestToPromise)(request);
            await (0, $bwxao.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $3DBsX.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $a2LhX.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $bwxao.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $abcF7.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $abcF7.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $bwxao.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $3a0TA.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $kthpY.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
}

});
parcelRegister("3DBsX", function(module, exports) {

$parcel$export(module.exports, "GET_ITEM_COUNT", () => $ac25b5ff880ec5b8$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $ac25b5ff880ec5b8$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $ac25b5ff880ec5b8$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $ac25b5ff880ec5b8$export$1188664dfff364c8);
const $ac25b5ff880ec5b8$export$b6df3d334cec060f = 7;
const $ac25b5ff880ec5b8$export$14ef152a03a4b6ee = 60000;
const $ac25b5ff880ec5b8$export$da9ab7b2fd5998e8 = 10;
const $ac25b5ff880ec5b8$export$1188664dfff364c8 = 5000;

});

parcelRegister("kthpY", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc5734d26b96ca81$export$2e2bcd8739ae039);

var $abcF7 = parcelRequire("abcF7");

var $G66Ew = parcelRequire("G66Ew");

var $bwxao = parcelRequire("bwxao");
class $bc5734d26b96ca81$export$2e2bcd8739ae039 {
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $abcF7.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $abcF7.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $abcF7.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $abcF7.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $bwxao.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $bwxao.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $G66Ew.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $abcF7.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $bwxao.requestToPromise)(request);
        return event.target.result;
    }
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        this.eventLimit = void 0;
        this.namespace = void 0;
        this.logger = void 0;
        this.deleteItemHandler = void 0;
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ this.deleteOldestNEvents = async (objectStore, count)=>{
            const productTimeAddedIndex = objectStore.index((0, $abcF7.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $bwxao.requestToPromise)(getAllRequest);
            const result = event?.target?.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
}

});
parcelRegister("bwxao", function(module, exports) {

$parcel$export(module.exports, "convertToItemWrapper", () => $b64847155b9e134b$export$aec476f33d77be11);
$parcel$export(module.exports, "createOptionsWithDefaults", () => $b64847155b9e134b$export$ddc6718318090f71);
$parcel$export(module.exports, "requestToPromise", () => $b64847155b9e134b$export$85ceed0783e42041);
$parcel$export(module.exports, "commitTransaction", () => $b64847155b9e134b$export$feab8418f018df89);
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $b64847155b9e134b$export$342d941b6f724995);

var $kyKWe = parcelRequire("kyKWe");

var $3DBsX = parcelRequire("3DBsX");
const $b64847155b9e134b$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $b64847155b9e134b$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $3DBsX.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $3DBsX.EVENT_COUNT_LIMIT)
    });
const $b64847155b9e134b$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $b64847155b9e134b$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $b64847155b9e134b$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $b64847155b9e134b$export$2a5213bce1720b42(transaction);
};
const $b64847155b9e134b$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("rBKnt", function(module, exports) {

$parcel$export(module.exports, "default", () => $702d2cb9e96a32fb$export$2e2bcd8739ae039);

var $abcF7 = parcelRequire("abcF7");

var $3DBsX = parcelRequire("3DBsX");

var $a2LhX = parcelRequire("a2LhX");
var $hPwQa = parcelRequire("hPwQa");

var $25TlB = parcelRequire("25TlB");

var $bwxao = parcelRequire("bwxao");
class $702d2cb9e96a32fb$export$2e2bcd8739ae039 {
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $abcF7.GuardPolicy).ABANDON) {
        if (policy === (0, $abcF7.GuardPolicy).IGNORE) throw new (0, $hPwQa.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $bwxao.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $abcF7.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $bwxao.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $abcF7.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $3DBsX.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $3DBsX.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $3DBsX.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $3DBsX.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $a2LhX.default)(error);
        }
    }
    storeType() {
        return (0, $abcF7.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
    constructor(namespace, options = {}){
        this.memoryStore = void 0;
        this.options = void 0;
        this.globalEventLimitGuard = void 0;
        this.namespace = void 0;
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $bwxao.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $25TlB.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
}

});
parcelRegister("25TlB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf01c485b1751ff$export$2e2bcd8739ae039);

var $abcF7 = parcelRequire("abcF7");

var $G66Ew = parcelRequire("G66Ew");
class $cbf01c485b1751ff$export$2e2bcd8739ae039 {
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $G66Ew.default)((0, $abcF7.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
    constructor(eventLimit, memoryItemHandlers){
        this.eventLimit = void 0;
        this.memoryItemHandlers = void 0;
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $abcF7.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $abcF7.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $abcF7.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
}

});




parcelRegister("5DfT9", function(module, exports) {

$parcel$export(module.exports, "default", () => $36fd87bc225a2648$export$2e2bcd8739ae039);

var $hVXIk = parcelRequire("hVXIk");
class $36fd87bc225a2648$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $hVXIk.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}
let $36fd87bc225a2648$var$cachedMetricsClient = null;
var $36fd87bc225a2648$export$2e2bcd8739ae039 = ()=>{
    if (!$36fd87bc225a2648$var$cachedMetricsClient) $36fd87bc225a2648$var$cachedMetricsClient = new $36fd87bc225a2648$export$4b62ee5120ab50a8();
    return $36fd87bc225a2648$var$cachedMetricsClient;
};

});
parcelRegister("hVXIk", function(module, exports) {

$parcel$export(module.exports, "ResilienceMechanism", () => $633a56c35f8a61f6$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $633a56c35f8a61f6$export$ee138fa712d11b84);
var $633a56c35f8a61f6$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $633a56c35f8a61f6$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("Q88CI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7583c71c35f1b55e$export$2e2bcd8739ae039);

var $hVXIk = parcelRequire("hVXIk");
class $7583c71c35f1b55e$export$2e2bcd8739ae039 {
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $hVXIk.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $hVXIk.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $hVXIk.NetworkStatusEnum).ONLINE;
        return (0, $hVXIk.NetworkStatusEnum).OFFLINE;
    }
    constructor(networkChangeCallback){
        this._networkChangeCallback = void 0;
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $hVXIk.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $hVXIk.NetworkStatusEnum).ONLINE));
        }
    }
}

});

parcelRegister("jqGdF", function(module, exports) {

$parcel$export(module.exports, "default", () => $075a1d94af401b85$export$2e2bcd8739ae039);

var $e8YUu = parcelRequire("e8YUu");

var $1UbVG = parcelRequire("1UbVG");
const $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $075a1d94af401b85$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $075a1d94af401b85$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.callback = void 0;
        this.failureCount = void 0;
        this.operationInFlight = void 0;
        this.options = void 0;
        this.queuedSchedule = void 0;
        this.scheduledTimeout = void 0;
        this.callbackTimer = void 0;
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $1UbVG.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $1UbVG.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $e8YUu.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $1UbVG.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $e8YUu.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("e8YUu", function(module, exports) {

$parcel$export(module.exports, "CallbackStatus", () => $633697aac9c9f6a8$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $633697aac9c9f6a8$export$590a718599f8f8b3);
var $633697aac9c9f6a8$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $633697aac9c9f6a8$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $633697aac9c9f6a8$export$590a718599f8f8b3 {
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
    constructor(timeoutPeriod){
        // Milliseconds to wait
        this.timeoutPeriod = void 0;
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
}

});

parcelRegister("1UbVG", function(module, exports) {

$parcel$export(module.exports, "DoneState", () => $22268497503b9859$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $22268497503b9859$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("daDZU", function(module, exports) {

$parcel$export(module.exports, "attachXidToMultipleEvents", () => $2e21bfed4d180604$export$c21270cab66ab290);

var $6sAlM = parcelRequire("6sAlM");
function $2e21bfed4d180604$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $6sAlM.SegmentEventTypes).PAGE || item.msg.type === (0, $6sAlM.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $6sAlM.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}
async function $2e21bfed4d180604$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$2e21bfed4d180604$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("6sAlM", function(module, exports) {

$parcel$export(module.exports, "LastError", () => $d3448b122cc731d9$export$a63e16b3351b8c36);
$parcel$export(module.exports, "FetchError", () => $d3448b122cc731d9$export$26e841bcf1aeb894);
$parcel$export(module.exports, "SegmentEventTypes", () => $d3448b122cc731d9$export$ddf929981dc6feb3);
$parcel$export(module.exports, "MetadataResponse", () => $d3448b122cc731d9$export$4b1a5e5486cc0d80);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $d3448b122cc731d9$export$96f086dcf574a9e2);
class $d3448b122cc731d9$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof $d3448b122cc731d9$export$26e841bcf1aeb894 ? error.statusCode : null;
    }
}
var $d3448b122cc731d9$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $d3448b122cc731d9$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $d3448b122cc731d9$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
class $d3448b122cc731d9$export$4b1a5e5486cc0d80 {
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json?.url) ? json.url.trim() : '';
        return new $d3448b122cc731d9$export$4b1a5e5486cc0d80(json?.props || null, url.startsWith('http') ? url : null);
    }
    constructor(props, url){
        this.props = void 0;
        this.url = void 0;
        this.props = props;
        this.url = url;
    }
}
class $d3448b122cc731d9$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = void 0;
        this.statusText = void 0;
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}
const $d3448b122cc731d9$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});


parcelRegister("lnajN", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $9164eeffd0539b5d$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $9164eeffd0539b5d$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $9164eeffd0539b5d$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $9164eeffd0539b5d$export$6f1c008dd0c3b67e);
const $9164eeffd0539b5d$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $9164eeffd0539b5d$export$8fddcd1eff390364 = 60000; // 60 seconds
const $9164eeffd0539b5d$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $9164eeffd0539b5d$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("6YtDn", function(module, exports) {

$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $7165fde85bff9235$export$ba118f9de1e5ac63);
const $7165fde85bff9235$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("h8Ywp", function(module, exports) {

$parcel$export(module.exports, "sendEvents", () => $972d61447de85e3a$export$8e8f0180c1b41fad);

var $csnse = parcelRequire("csnse");

var $6sAlM = parcelRequire("6sAlM");
const $972d61447de85e3a$export$8e8f0180c1b41fad = async (options)=>{
    const signal = $972d61447de85e3a$var$createOrGetAbortController(options)?.signal;
    const corsOptions = $972d61447de85e3a$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new (0, $6sAlM.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $972d61447de85e3a$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $972d61447de85e3a$var$getCorsForUrl = (0, $csnse.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("gJXXx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d730249ef708149$export$2e2bcd8739ae039);

var $5PE1K = parcelRequire("5PE1K");

var $kyKWe = parcelRequire("kyKWe");

var $3Sze1 = parcelRequire("3Sze1");
var $kT00C = parcelRequire("kT00C");

var $6kCqZ = parcelRequire("6kCqZ");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $9d730249ef708149$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $9d730249ef708149$var$SAFE = 'SAFE';
const $9d730249ef708149$var$UNSAFE = 'UNSAFE';
const $9d730249ef708149$var$NOT_FOUND = 'NOT_FOUND';
const $9d730249ef708149$var$COOKIE = 'COOKIE';
const $9d730249ef708149$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $9d730249ef708149$export$2e2bcd8739ae039 {
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $3Sze1.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $3Sze1.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $9d730249ef708149$var$LOCAL_STORAGE ? this.store.getItem((0, $3Sze1.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $3Sze1.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $9d730249ef708149$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $9d730249ef708149$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $9d730249ef708149$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($9d730249ef708149$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $5PE1K.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $9d730249ef708149$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $9d730249ef708149$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $9d730249ef708149$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $9d730249ef708149$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($9d730249ef708149$var$COOKIE);
        switch(cookieValue.type){
            case $9d730249ef708149$var$SAFE:
            case $9d730249ef708149$var$UNSAFE:
                this.store.setItem((0, $3Sze1.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $9d730249ef708149$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
    constructor(disableCookiePersistence){
        this.store = void 0;
        this.cookie = void 0;
        this.userId = void 0;
        this.lastAnonymousIdCookieUpdate = void 0;
        this.store = new (0, $6kCqZ.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $kT00C.default)(disableCookiePersistence);
    }
}

});
parcelRegister("3Sze1", function(module, exports) {

$parcel$export(module.exports, "AWCCookiesKeys", () => $ed50499514b90321$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $ed50499514b90321$export$d4cb17942ea57c95);
var $ed50499514b90321$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $ed50499514b90321$var$CookieSchema {
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
    constructor(key, options){
        this.key = void 0;
        this.options = void 0;
        this.key = key;
        this.options = options;
    }
}
const $ed50499514b90321$var$isSecure = ()=>{
    try {
        return window && window.location && window.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $ed50499514b90321$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $ed50499514b90321$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $ed50499514b90321$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $ed50499514b90321$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $ed50499514b90321$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $ed50499514b90321$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $ed50499514b90321$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("kT00C", function(module, exports) {

$parcel$export(module.exports, "default", () => $76142d2a9a314c64$export$2e2bcd8739ae039);

var $7g5Pn = parcelRequire("7g5Pn");

var $3Sze1 = parcelRequire("3Sze1");

var $dMpOZ = parcelRequire("dMpOZ");

var $3hrRx = parcelRequire("3hrRx");
class $76142d2a9a314c64$export$2e2bcd8739ae039 {
    set(name, value, options) {
        // no-op
        if (!(0, $3Sze1.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $3Sze1.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $3Sze1.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $3hrRx.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $3Sze1.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $3Sze1.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $3Sze1.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $3Sze1.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
    constructor(disableCookiePersistence){
        this.cookieLike = void 0;
        this.cookieLike = (0, $3hrRx.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))) : new (0, $dMpOZ.default)();
    }
}

});
parcelRegister("dMpOZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b1a4e934d8db12a$export$2e2bcd8739ae039);

var $6kCqZ = parcelRequire("6kCqZ");
class $8b1a4e934d8db12a$export$2e2bcd8739ae039 {
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
    constructor(){
        this.safeStorage = void 0;
        this.safeStorage = new (0, $6kCqZ.default)({
            useStoragePrefix: false
        });
    }
}

});
parcelRegister("6kCqZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00656ffbea15235e$export$2e2bcd8739ae039);

var $fRh5d = parcelRequire("fRh5d");

var $eus20 = parcelRequire("eus20");
class $00656ffbea15235e$export$2e2bcd8739ae039 extends (0, $eus20.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $fRh5d.default);
        } catch (err) {
            storageToUse = (0, $fRh5d.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("fRh5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca64da15c4c0a7aa$export$2e2bcd8739ae039);
class $ca64da15c4c0a7aa$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$ca64da15c4c0a7aa$export$2e2bcd8739ae039 = new $ca64da15c4c0a7aa$export$90e3e001bcac59c7();

});

parcelRegister("eus20", function(module, exports) {

$parcel$export(module.exports, "default", () => $8db0efe23d1f1048$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $5DUgU = parcelRequire("5DUgU");

var $fRh5d = parcelRequire("fRh5d");
const $8db0efe23d1f1048$export$41c06fdd37b7e9a5 = 'awc';
const $8db0efe23d1f1048$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $8db0efe23d1f1048$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $8db0efe23d1f1048$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $8db0efe23d1f1048$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this._prefix = void 0;
        this._store = void 0;
        this.options = void 0;
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($8db0efe23d1f1048$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $fRh5d.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($8db0efe23d1f1048$export$48c17662a6902497(window[$8db0efe23d1f1048$export$770aa8bc07b3de03])) inMemoryStorage = window[$8db0efe23d1f1048$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $fRh5d.default);
                if (!window[$8db0efe23d1f1048$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$8db0efe23d1f1048$export$770aa8bc07b3de03] = (0, $fRh5d.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($8db0efe23d1f1048$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $5DUgU.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($8db0efe23d1f1048$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("3hrRx", function(module, exports) {

$parcel$export(module.exports, "canUseCookie", () => $4f9007717dfe8915$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $4f9007717dfe8915$export$de6821eed3d5f32d);

var $7g5Pn = parcelRequire("7g5Pn");

var $csnse = parcelRequire("csnse");

var $3Sze1 = parcelRequire("3Sze1");
const $4f9007717dfe8915$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $4f9007717dfe8915$export$eb80e1beaa8dacf8 = (0, $3Sze1.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $4f9007717dfe8915$export$19164982d36535d8 = 'tld_test';
const $4f9007717dfe8915$export$de6821eed3d5f32d = (0, $csnse.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).set($4f9007717dfe8915$export$eb80e1beaa8dacf8, $4f9007717dfe8915$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).get($4f9007717dfe8915$export$eb80e1beaa8dacf8) === $4f9007717dfe8915$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).remove($4f9007717dfe8915$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("dY3L6", function(module, exports) {

$parcel$export(module.exports, "buildContext", () => $88ca4b3f953c89b1$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "prepareEventProperties", () => $88ca4b3f953c89b1$export$44d22e5fb02cc68e);
// @ts-ignore

var $5y8P7 = parcelRequire("5y8P7");
const $88ca4b3f953c89b1$export$3a7fe28f9bf4f3d9 = (context)=>{
    return {
        ...context.context,
        userAgent: navigator.userAgent
    };
};
const $88ca4b3f953c89b1$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $88ca4b3f953c89b1$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5y8P7)))(propertiesWithoutUndefined);
};
const $88ca4b3f953c89b1$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== 'object') return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $88ca4b3f953c89b1$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$88ca4b3f953c89b1$export$2250ccecd1e040fd(i));
            else if (typeof value === 'object' && value !== null) clone[key] = $88ca4b3f953c89b1$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $88ca4b3f953c89b1$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};

});


parcelRegister("a2fLP", function(module, exports) {

$parcel$export(module.exports, "MetadataClient", () => $70ceb115a3b23ecd$export$1ac223ae496131c9);

var $Q88CI = parcelRequire("Q88CI");

var $hTFK2 = parcelRequire("hTFK2");

var $jqGdF = parcelRequire("jqGdF");
var $1UbVG = parcelRequire("1UbVG");

var $hVXIk = parcelRequire("hVXIk");

var $2Wu5Y = parcelRequire("2Wu5Y");

var $31AK1 = parcelRequire("31AK1");

var $lnajN = parcelRequire("lnajN");

var $acRAP = parcelRequire("acRAP");

var $6sAlM = parcelRequire("6sAlM");
var $70ceb115a3b23ecd$var$_MetadataClient;
class $70ceb115a3b23ecd$export$1ac223ae496131c9 {
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $70ceb115a3b23ecd$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        this._fetchAbortController?.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $Q88CI.default)((status)=>{
            if (status === (0, $hVXIk.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        if ((0, $31AK1.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        this._fetchAbortController?.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $acRAP.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $lnajN.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $6sAlM.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $6sAlM.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $6sAlM.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        if (this._userInfo?.userId === userInfo?.userId && this._userInfo?.userIdType === userInfo?.userIdType) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        if (this._tenantInfo?.tenantId === tenantInfo?.tenantId && this._tenantInfo?.tenantIdType === tenantInfo?.tenantIdType) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        if (this._networkStatus?.getNetworkStatus() === (0, $hVXIk.NetworkStatusEnum).OFFLINE) {
            done((0, $1UbVG.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $1UbVG.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch (error) {
            done((0, $1UbVG.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $lnajN.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || (0, $hTFK2.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : (0, $hTFK2.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || (0, $hTFK2.DEFAULT_POLLING_OPTIONS).batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || (0, $hTFK2.DEFAULT_POLLING_OPTIONS).flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || (0, $hTFK2.DEFAULT_POLLING_OPTIONS).flushWaitMs,
            maxItems: options?.maxItems || (0, $hTFK2.DEFAULT_POLLING_OPTIONS).maxItems,
            maxAttempts: options?.maxAttempts || (0, $hTFK2.DEFAULT_POLLING_OPTIONS).maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || (0, $hTFK2.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || (0, $hTFK2.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = void 0;
        this._tenantInfo = void 0;
        this._url = void 0;
        this._metadataHost = void 0;
        this._product = void 0;
        this._metadataInfo = void 0;
        this._requestStatus = void 0;
        this._lastFetchRequestCount = void 0;
        this._options = void 0;
        this._scheduler = void 0;
        this._networkStatus = void 0;
        this._lastErrorReason = void 0;
        this._fetchAbortController = void 0;
        this._hasBeenStopped = void 0;
        this._isEnabled = void 0;
        this._propertyChangeRefreshTimeout = void 0;
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $2Wu5Y.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.2,
            batchFlushSize: 7,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            maxItems: 1000,
            maxRetryDelay: 30000,
            minRetryDelay: 1000
        });
        this._scheduler = new (0, $jqGdF.default)({
            ...this._options,
            waitInterval: (0, $lnajN.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
}
$70ceb115a3b23ecd$var$_MetadataClient = $70ceb115a3b23ecd$export$1ac223ae496131c9;
$70ceb115a3b23ecd$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY = 1;
$70ceb115a3b23ecd$export$1ac223ae496131c9.Factory = (apiHostProtocol, apiHost, product)=>{
    return new $70ceb115a3b23ecd$var$_MetadataClient(apiHostProtocol, apiHost, product);
};

});
parcelRegister("2Wu5Y", function(module, exports) {

$parcel$export(module.exports, "selectHost", () => $ec9186f5a2212b6f$export$18c0b81944902eae);
$parcel$export(module.exports, "isStargateProxyPath", () => $ec9186f5a2212b6f$export$83a9dd8d74be72c);

var $5DUgU = parcelRequire("5DUgU");
const $ec9186f5a2212b6f$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $ec9186f5a2212b6f$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $ec9186f5a2212b6f$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $ec9186f5a2212b6f$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $ec9186f5a2212b6f$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $ec9186f5a2212b6f$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $ec9186f5a2212b6f$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $ec9186f5a2212b6f$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $ec9186f5a2212b6f$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const $ec9186f5a2212b6f$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $5DUgU.envType).LOCAL || env === (0, $5DUgU.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $5DUgU.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $5DUgU.envType).PROD ? $ec9186f5a2212b6f$var$FEDRAMP_PROD_HOST : $ec9186f5a2212b6f$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $5DUgU.envType).PROD ? $ec9186f5a2212b6f$var$STARGATE_FEDRAMP_PROD_HOST : $ec9186f5a2212b6f$var$STARGATE_FEDRAMP_STAGING_HOST;
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $ec9186f5a2212b6f$var$STARGATE_PROXY_PATH;
};
const $ec9186f5a2212b6f$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $5DUgU.envType).PROD ? $ec9186f5a2212b6f$var$PROD_HOST : $ec9186f5a2212b6f$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $5DUgU.envType).PROD ? $ec9186f5a2212b6f$var$STARGATE_PROD_HOST : $ec9186f5a2212b6f$var$STARGATE_STAGING_HOST;
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $ec9186f5a2212b6f$var$STARGATE_PROXY_PATH;
};
function $ec9186f5a2212b6f$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride }) {
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true.');
        throw Error('IC is set but no apiHost provided.');
    }
    if (perimeter === (0, $5DUgU.perimeterType).FEDRAMP_MODERATE) return $ec9186f5a2212b6f$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $ec9186f5a2212b6f$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}
function $ec9186f5a2212b6f$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === window.location.host + $ec9186f5a2212b6f$var$STARGATE_PROXY_PATH;
}

});

parcelRegister("31AK1", function(module, exports) {

$parcel$export(module.exports, "TestSupport", () => $39be788a663b8d7e$export$44b578549c42d779);
class $39be788a663b8d7e$export$44b578549c42d779 {
    static isGeminiVREnvironment() {
        try {
            for(const k in $parcel$global){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($39be788a663b8d7e$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($39be788a663b8d7e$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($39be788a663b8d7e$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if ($parcel$global && $parcel$global.hasOwnProperty(propertyName)) return $parcel$global[propertyName] === true;
        return false;
    }
}
$39be788a663b8d7e$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
$39be788a663b8d7e$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
$39be788a663b8d7e$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';

});

parcelRegister("acRAP", function(module, exports) {

$parcel$export(module.exports, "fetchMetadata", () => $b479b6178b262e9f$export$55b0d0261469055);

var $csnse = parcelRequire("csnse");

var $6sAlM = parcelRequire("6sAlM");
const $b479b6178b262e9f$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    const requestAbortController = $b479b6178b262e9f$var$createRequestAbortController(timeout, signal);
    const corsOptions = $b479b6178b262e9f$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${params.userInfo?.userId || ''}`,
        userIdType: `${params.userInfo?.userIdType || ''}`,
        tenantId: `${params.tenantInfo?.tenantId || ''}`,
        tenantIdType: `${params.tenantInfo?.tenantIdType || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $6sAlM.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $b479b6178b262e9f$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal?.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $b479b6178b262e9f$var$getCorsForUrl = (0, $csnse.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});


parcelRegister("jPyiF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6dd695367b163ca$export$2e2bcd8739ae039);

var $5DUgU = parcelRequire("5DUgU");

var $jExeP = parcelRequire("jExeP");
class $c6dd695367b163ca$export$2e2bcd8739ae039 {
    constructor(){
        this._originStore = void 0;
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $5DUgU.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $jExeP.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        };
        this._originStore = {};
    }
}

});
parcelRegister("jExeP", function(module, exports) {

$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $945a6126a5ece0de$export$600dd5bf1b049f11);
$parcel$export(module.exports, "default", () => $945a6126a5ece0de$export$2e2bcd8739ae039);

var $3URyZ = parcelRequire("3URyZ");

var $ewjj9 = parcelRequire("ewjj9");
const $945a6126a5ece0de$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $945a6126a5ece0de$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $945a6126a5ece0de$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $3URyZ.parseUrl)(removedFragmentURL);
    const captureParams = (0, $ewjj9.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $ewjj9.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $3URyZ.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $945a6126a5ece0de$export$2e2bcd8739ae039 = $945a6126a5ece0de$var$urlParamExtractor;

});
parcelRegister("3URyZ", function(module, exports) {

$parcel$export(module.exports, "extract", () => $2da0269ed397402a$export$f9380c9a627682d3, (v) => $2da0269ed397402a$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $2da0269ed397402a$export$98e6a39c04603d36, (v) => $2da0269ed397402a$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $2da0269ed397402a$export$fac44ee5b035f737, (v) => $2da0269ed397402a$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $2da0269ed397402a$export$7a5253c0f62e0150, (v) => $2da0269ed397402a$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $2da0269ed397402a$export$a8c1621ea79325d3, (v) => $2da0269ed397402a$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $2da0269ed397402a$export$357523c63a2253b9, (v) => $2da0269ed397402a$export$357523c63a2253b9 = v);
var $2da0269ed397402a$export$f9380c9a627682d3;
var $2da0269ed397402a$export$98e6a39c04603d36;
var $2da0269ed397402a$export$fac44ee5b035f737;
var $2da0269ed397402a$export$7a5253c0f62e0150;
var $2da0269ed397402a$export$a8c1621ea79325d3;
var $2da0269ed397402a$export$357523c63a2253b9;
var $2da0269ed397402a$export$44c361b8ec72ef7f;
'use strict';

var $9CzV6 = parcelRequire("9CzV6");

var $gs5az = parcelRequire("gs5az");

var $fR0YA = parcelRequire("fR0YA");

var $4VWo6 = parcelRequire("4VWo6");
const $2da0269ed397402a$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $2da0269ed397402a$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $2da0269ed397402a$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $2da0269ed397402a$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $2da0269ed397402a$var$encode(key, options),
                            '[',
                            $2da0269ed397402a$var$encode(index, options),
                            ']=',
                            $2da0269ed397402a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $2da0269ed397402a$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $2da0269ed397402a$var$encode(key, options),
                            '[]=',
                            $2da0269ed397402a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $2da0269ed397402a$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $2da0269ed397402a$var$encode(key, options),
                            ':list=',
                            $2da0269ed397402a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $2da0269ed397402a$var$encode(key, options),
                                keyValueSep,
                                $2da0269ed397402a$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $2da0269ed397402a$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $2da0269ed397402a$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $2da0269ed397402a$var$encode(key, options),
                            '=',
                            $2da0269ed397402a$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $2da0269ed397402a$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $2da0269ed397402a$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $2da0269ed397402a$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$2da0269ed397402a$var$decode(item, options)) : value === null ? value : $2da0269ed397402a$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $2da0269ed397402a$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$2da0269ed397402a$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $2da0269ed397402a$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $2da0269ed397402a$var$encode(value, options) {
    if (options.encode) return options.strict ? $9CzV6(value) : encodeURIComponent(value);
    return value;
}
function $2da0269ed397402a$var$decode(value, options) {
    if (options.decode) return $gs5az(value);
    return value;
}
function $2da0269ed397402a$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $2da0269ed397402a$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $2da0269ed397402a$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $2da0269ed397402a$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $2da0269ed397402a$var$extract(input) {
    input = $2da0269ed397402a$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $2da0269ed397402a$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $2da0269ed397402a$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $2da0269ed397402a$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $2da0269ed397402a$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $fR0YA(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $2da0269ed397402a$var$decode(value, options);
        formatter($2da0269ed397402a$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $2da0269ed397402a$var$parseValue(value[k], options);
        else ret[key] = $2da0269ed397402a$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $2da0269ed397402a$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$2da0269ed397402a$export$f9380c9a627682d3 = $2da0269ed397402a$var$extract;
$2da0269ed397402a$export$98e6a39c04603d36 = $2da0269ed397402a$var$parse;
$2da0269ed397402a$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $2da0269ed397402a$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $2da0269ed397402a$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $2da0269ed397402a$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $2da0269ed397402a$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $2da0269ed397402a$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $2da0269ed397402a$var$encode(key, options) + '=' + $2da0269ed397402a$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$2da0269ed397402a$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $fR0YA(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $2da0269ed397402a$var$parse($2da0269ed397402a$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $2da0269ed397402a$var$decode(hash, options)
    } : {});
};
$2da0269ed397402a$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$2da0269ed397402a$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $2da0269ed397402a$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $2da0269ed397402a$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $2da0269ed397402a$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $2da0269ed397402a$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $2da0269ed397402a$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$2da0269ed397402a$var$encodeFragmentIdentifier] ? $2da0269ed397402a$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$2da0269ed397402a$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$2da0269ed397402a$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $2da0269ed397402a$export$7a5253c0f62e0150(input, options);
    return $2da0269ed397402a$export$a8c1621ea79325d3({
        url: url,
        query: $4VWo6(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$2da0269ed397402a$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $2da0269ed397402a$export$357523c63a2253b9(input, exclusionFilter, options);
};

});



parcelRegister("79AM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d8eeb7f4033b441$export$2e2bcd8739ae039);

var $6kCqZ = parcelRequire("6kCqZ");
const $1d8eeb7f4033b441$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $1d8eeb7f4033b441$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $1d8eeb7f4033b441$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $1d8eeb7f4033b441$export$285f6bddd927a06d = 1800000; // 30 minutes
const $1d8eeb7f4033b441$export$a92e915d70316eb2 = 5000; // 5 seconds
const $1d8eeb7f4033b441$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $1d8eeb7f4033b441$export$5702a91a6f42969f = ()=>{};
class $1d8eeb7f4033b441$export$2e2bcd8739ae039 {
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($1d8eeb7f4033b441$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($1d8eeb7f4033b441$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$1d8eeb7f4033b441$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
    constructor(options = {}){
        this._safeLocalStorage = void 0;
        this._sessionExpiryTime = void 0;
        this._sessionExpiryDebounce = void 0;
        this._sessionExpiryDebounceThresholdPercentage = void 0;
        this._sessionExpiryDebounceTimer = void 0;
        this._onNewSessionStarted = void 0;
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($1d8eeb7f4033b441$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($1d8eeb7f4033b441$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $1d8eeb7f4033b441$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $1d8eeb7f4033b441$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $1d8eeb7f4033b441$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $1d8eeb7f4033b441$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $6kCqZ.default)();
    }
}

});

parcelRegister("2ineN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b131b21fd6988d6$export$2e2bcd8739ae039);

var $fRh5d = parcelRequire("fRh5d");

var $eus20 = parcelRequire("eus20");
class $6b131b21fd6988d6$export$2e2bcd8739ae039 extends (0, $eus20.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $fRh5d.default);
        } catch (err) {
            storageToUse = (0, $fRh5d.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("5eUc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $665df044bb2c8b06$export$2e2bcd8739ae039);

var $kyKWe = parcelRequire("kyKWe");

var $2ineN = parcelRequire("2ineN");
const $665df044bb2c8b06$var$STORAGE_KEY = 'tab.id';
class $665df044bb2c8b06$export$2e2bcd8739ae039 {
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($665df044bb2c8b06$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
    constructor(){
        this._safeSessionStorage = void 0;
        this._generateNewTabId = ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
            this._safeSessionStorage.setItem($665df044bb2c8b06$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $2ineN.default)();
    }
}

});

parcelRegister("jHQZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e12a166f16cadc43$export$2e2bcd8739ae039);

var $3URyZ = parcelRequire("3URyZ");

var $kyKWe = parcelRequire("kyKWe");

var $5DUgU = parcelRequire("5DUgU");

var $ewjj9 = parcelRequire("ewjj9");

var $2ineN = parcelRequire("2ineN");

var $jExeP = parcelRequire("jExeP");
const $e12a166f16cadc43$var$STORAGE_KEY = 'taskSessions';
const $e12a166f16cadc43$var$INIT_KEY = 'taskSessionsInit';
const $e12a166f16cadc43$var$AWC_PARAM_PREFIX = 'awc.';
const $e12a166f16cadc43$var$TASK_SESSION_RELOAD_TIME = 3000;
class $e12a166f16cadc43$export$2e2bcd8739ae039 {
    constructor(){
        this._safeSessionStorage = void 0;
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($e12a166f16cadc43$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($e12a166f16cadc43$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($e12a166f16cadc43$var$INIT_KEY) || '0', 10) < currentTimestamp - $e12a166f16cadc43$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($e12a166f16cadc43$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($e12a166f16cadc43$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($e12a166f16cadc43$var$STORAGE_KEY) || '');
            } catch (e) {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($e12a166f16cadc43$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $3URyZ.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $ewjj9.pick)(currentState, includedTaskSessions) : (0, $ewjj9.omit)(currentState, Object.values((0, $5DUgU.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $ewjj9.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$e12a166f16cadc43$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $3URyZ.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $ewjj9.mapKeys)((0, $jExeP.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $2ineN.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($e12a166f16cadc43$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

});

parcelRegister("4IbNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $201c469b9a404af6$export$2e2bcd8739ae039);

var $7g5Pn = parcelRequire("7g5Pn");

var $3Sze1 = parcelRequire("3Sze1");
const $201c469b9a404af6$var$MAX_CACHE_SIZE = 100;
const $201c469b9a404af6$var$COOKIE_NAME = (0, $3Sze1.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $201c469b9a404af6$var$DEBUG_TAG = 'synthetic';
const $201c469b9a404af6$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).get($201c469b9a404af6$var$COOKIE_NAME) || 'false');
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).remove($201c469b9a404af6$var$COOKIE_NAME);
    }
    return false;
};
class $201c469b9a404af6$var$TestingCache {
    constructor(){
        this._isDebugCookieEnabled = void 0;
        this._bind = ()=>{
            if (typeof window === 'undefined' || window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem('awc.ui.viewed.last.sent');
                        localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                        localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                        localStorage.removeItem('awc-local.ui.viewed.last.sent');
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        };
        this._cache = (event)=>{
            if (typeof window === 'undefined') return;
            if (window.testAnalytics.eventCache.length >= $201c469b9a404af6$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        };
        this._shouldCacheEvent = ()=>this._isDebugCookieEnabled;
        this.saveEvent = (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($201c469b9a404af6$var$DEBUG_TAG);
                else event.tags = [
                    $201c469b9a404af6$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        };
        this._isDebugCookieEnabled = $201c469b9a404af6$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $201c469b9a404af6$export$2e2bcd8739ae039 = $201c469b9a404af6$var$TestingCache;

});

parcelRegister("iExg3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffc19307df5cc51a$export$2e2bcd8739ae039);

var $5DUgU = parcelRequire("5DUgU");

var $eq434 = parcelRequire("eq434");

var $6kCqZ = parcelRequire("6kCqZ");
const $ffc19307df5cc51a$var$DEFAULT_DELAY = 2000; // 2 seconds
const $ffc19307df5cc51a$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $ffc19307df5cc51a$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $ffc19307df5cc51a$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
class $ffc19307df5cc51a$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this._blurListener = void 0;
        this._delay = void 0;
        this._focusListener = void 0;
        this._getContext = void 0;
        this._intervalId = void 0;
        this._onEvent = void 0;
        this._product = void 0;
        this._productInfo = void 0;
        this._safeLocalStorage = void 0;
        this._storageKey = void 0;
        this._malformedEventStorageKey = void 0;
        this._throttle = void 0;
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch (error) {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            const document = (0, $eq434.getDocument)();
            if (document && !document.hasFocus()) return 'FocusLost';
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $5DUgU.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 'UserOrTenantIncomplete';
                return 'MalformedUiViewedRateLimited';
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 'EligibleToSend';
            return 'UiViewedRateLimited';
        };
        this._handleInterval = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const shouldSendEventTriggerStatus = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(shouldSendEventTriggerStatus){
                case 'EligibleToSend':
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 'UserOrTenantIncomplete':
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $ffc19307df5cc51a$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $ffc19307df5cc51a$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $ffc19307df5cc51a$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $ffc19307df5cc51a$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $6kCqZ.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("eq434", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $c298aef6a0d197ce$export$f65ca476c09acec0);
const $c298aef6a0d197ce$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("irySC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec692407b558bb24$export$2e2bcd8739ae039);
function $ec692407b558bb24$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("6zoZA", function(module, exports) {

$parcel$export(module.exports, "XIDPromise", () => $37dac68d15a97eff$export$fbe53bbbe682bcdd);

var $jvgSM = parcelRequire("jvgSM");
const $37dac68d15a97eff$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $jvgSM.createTimeoutXid)()), (0, $jvgSM.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $jvgSM.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("jvgSM", function(module, exports) {

$parcel$export(module.exports, "XID_TIMEOUT", () => $8ec072c6b5f8105f$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $8ec072c6b5f8105f$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $8ec072c6b5f8105f$export$fa341d0c750d705b);

var $4kOUS = parcelRequire("4kOUS");
const $8ec072c6b5f8105f$export$545bcbd53afabfa3 = 5000;
const $8ec072c6b5f8105f$export$af4087e36d63846 = ()=>[
        {
            type: (0, $4kOUS.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $4kOUS.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $8ec072c6b5f8105f$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $4kOUS.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $4kOUS.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("4kOUS", function(module, exports) {

$parcel$export(module.exports, "XIDItemType", () => $5c7af631796b958c$export$92ca0438bcb0d396);
var $5c7af631796b958c$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $5c7af631796b958c$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("27y2X", function(module, exports) {

$parcel$export(module.exports, "defaultEventMatchers", () => $6bca2d59b6606ecd$export$322c2f7d58c321eb);
$parcel$export(module.exports, "isAllowedEvent", () => $6bca2d59b6606ecd$export$a4c2a3f0b2be7eb);

var $hRun9 = parcelRequire("hRun9");
const $6bca2d59b6606ecd$export$322c2f7d58c321eb = [
    {
        action: 'measured',
        actionSubject: 'performance',
        source: 'performance',
        attributes: {
            properties: {
                'event:type': 'page-load'
            }
        }
    },
    {
        action: 'measured',
        actionSubject: 'performance',
        source: 'performance',
        attributes: {
            properties: {
                'event:key': 'confluence.fe.page-segment-load.content-renderer'
            }
        }
    }
];
const $6bca2d59b6606ecd$export$a4c2a3f0b2be7eb = (event, matchers)=>{
    if (typeof event !== 'object' || !event) return false;
    return matchers.some((matcher)=>(0, (/*@__PURE__*/$parcel$interopDefault($hRun9)))(event, matcher));
};

});

parcelRegister("9eE57", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $e8c3b9e45ae9a31e$export$1a717feb4df1a945);
$parcel$export(module.exports, "getEntryByName", () => $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce);
$parcel$export(module.exports, "measureMarks", () => $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d);
$parcel$export(module.exports, "getMark", () => $e8c3b9e45ae9a31e$export$f45af69d005a6ed);
$parcel$export(module.exports, "perfMarkStart", () => $e8c3b9e45ae9a31e$export$91b34dd9e71ad666);
$parcel$export(module.exports, "perfMarkEnd", () => $e8c3b9e45ae9a31e$export$9cbdebb35a11386);

var $ge2sX = parcelRequire("ge2sX");

var $04e9M = parcelRequire("04e9M");

var $5ZqQS = parcelRequire("5ZqQS");
const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};

});
parcelRegister("ge2sX", function(module, exports) {

$parcel$export(module.exports, "getSessionData", () => $49211747c0c1fb72$export$4163744babc94103);
$parcel$export(module.exports, "getCloudId", () => $49211747c0c1fb72$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "SessionData", () => $49211747c0c1fb72$export$14dde3d2ec7dfd8f);

var $gwFzn = parcelRequire("gwFzn");

var $6X8o4 = parcelRequire("6X8o4");

var $iC5L0 = parcelRequire("iC5L0");

var $fcgrS = parcelRequire("fcgrS");
const $49211747c0c1fb72$export$4163744babc94103 = ()=>{
    // Not using memorize here because we want to reset promise in test
    if (window['__SITEINFORMATION_PROMISE__']) return window['__SITEINFORMATION_PROMISE__'];
    return window['__SITEINFORMATION_PROMISE__'] = (0, $6X8o4.liftPromiseState)((0, $fcgrS.loadSessionData)().then((0, $iC5L0.processSessionData)));
};
const $49211747c0c1fb72$export$fdd2c0ba94025c3c = ()=>{
    const sessionDataPromise = $49211747c0c1fb72$export$4163744babc94103();
    if ((0, $6X8o4.isResolved)(sessionDataPromise)) return (0, $6X8o4.getValue)(sessionDataPromise)?.cloudId;
    else // Session data is not loaded yet, return null
    return null;
};
class $49211747c0c1fb72$export$14dde3d2ec7dfd8f extends (0, $gwFzn.Component) {
    componentWillUnmount() {
        this._mount = false;
    }
    render() {
        const { sessionData: sessionData } = this.state;
        if (sessionData) return this.props.children(sessionData);
        if (this.props.renderChildrenWhenLoading === true) return this.props.children({
            loading: true
        });
        return null;
    }
    constructor(props){
        super(props);
        this._mount = void 0;
        this.state = {};
        const promise = $49211747c0c1fb72$export$4163744babc94103();
        this._mount = true;
        if ((0, $6X8o4.isResolved)(promise)) this.state = {
            sessionData: (0, $6X8o4.getValue)(promise)
        };
        else promise.then((sessionData)=>{
            if (this._mount) this.setState({
                sessionData: sessionData
            });
        });
    }
}

});
parcelRegister("iC5L0", function(module, exports) {

$parcel$export(module.exports, "getEmptySessionData", () => $f22ae18572ac4cf5$export$3aa1d70b86d65666);
$parcel$export(module.exports, "processSessionData", () => $f22ae18572ac4cf5$export$48ea97dcec207a60);

var $llq4j = parcelRequire("llq4j");
function $f22ae18572ac4cf5$var$nonNull(value) {
    return value !== null;
}
const $f22ae18572ac4cf5$export$3aa1d70b86d65666 = ()=>$f22ae18572ac4cf5$export$48ea97dcec207a60(null);
function $f22ae18572ac4cf5$export$48ea97dcec207a60(data) {
    const { originalFeatureFlags: originalFeatureFlags, featureFlagsWithOverrides: featureFlagsWithOverrides, featureFlagClient: featureFlagClient } = (0, $llq4j.processFeatureFlags)(data?.featureFlags?.nodes?.filter($f22ae18572ac4cf5$var$nonNull) || [], data?.platformFeatureFlags?.nodes?.filter($f22ae18572ac4cf5$var$nonNull) || []);
    // nullability of `tenant` is probably a schema issue
    // `userForAnalytics.id` would probably never be null, follow up with Xiao
    const confluenceLocale = data?.user?.confluence?.locale?.replace('_', '-');
    return {
        shard: data?.tenant?.shard || '',
        cloudId: data?.tenant?.cloudId || '',
        activationId: data?.tenant?.activationId || '',
        orgId: data?.organization?.orgId || undefined,
        environment: data?.tenant?.environment || 'PRODUCTION',
        edition: data?.tenant?.editions?.edition || null,
        userId: data?.user?.id || null,
        displayName: data?.user?.displayName || null,
        isLoggedIn: Boolean(data?.user?.id),
        // CCP-472: This is for JSD users who are unlicensed for
        // Confluence usage. In that case, we need to skip
        // `WatchDialogQuery` as they are causing NullPointerExceptions
        // in the BE.
        isLicensed: Boolean(data?.user?.confluence?.accountId && data?.user?.confluence?.userKey),
        accessStatus: data?.user?.confluence?.accessStatus || null,
        userIdForAnalytics: data?.userForAnalytics?.id || null,
        featureFlags: featureFlagsWithOverrides,
        featureFlagClient: featureFlagClient,
        _originalFeatureFlags: originalFeatureFlags,
        locale: confluenceLocale || 'en-US',
        timeZone: data?.user?.timeZone || null,
        tenantTimeZone: data?.confluence_tenantContext?.timeZone || null,
        isAdminHubAIEnabled: Boolean(data?.getAIConfig?.isEnabled),
        isRovoEnabled: Boolean(data?.getAIConfig?.isRovoEnabled),
        isRovoLLMEnabled: Boolean(data?.getAIConfig?.isRovoLLMEnabled)
    };
}

});
parcelRegister("llq4j", function(module, exports) {

$parcel$export(module.exports, "processFeatureFlags", () => $11652f2649e2c81d$export$8c9b5e98a87ea54c);

var $csnse = parcelRequire("csnse");

var $dh538 = parcelRequire("dh538");

var $8ihu7 = parcelRequire("8ihu7");
parcelRequire("23W1g");
var $ECRpY = parcelRequire("ECRpY");

var $9wGTI = parcelRequire("9wGTI");

var $eT7Z2 = parcelRequire("eT7Z2");
function $11652f2649e2c81d$var$normalizeValue(rawValue) {
    if (typeof rawValue === 'object' && 'value' in rawValue) return {
        ...rawValue.explanation ? {
            explanation: {
                ...rawValue.explanation
            }
        } : {},
        value: (0, $eT7Z2.unwrapValue)(rawValue.value)
    };
    else return {
        value: (0, $eT7Z2.unwrapValue)(rawValue),
        explanation: undefined
    };
}
const $11652f2649e2c81d$var$noopAnalyticsHandler = {
    sendOperationalEvent: (_event)=>Promise.resolve()
};
const $11652f2649e2c81d$export$8c9b5e98a87ea54c = (0, $csnse.default)((flags, platformFlags)=>{
    const normalizedFeatureFlags = flags ? (0, $eT7Z2.keyById)(flags, $11652f2649e2c81d$var$normalizeValue) : {};
    const normalizedPlatformFeatureFlags = platformFlags != null ? (0, $eT7Z2.keyById)(platformFlags, $11652f2649e2c81d$var$normalizeValue) : {};
    Object.assign(normalizedFeatureFlags, normalizedPlatformFeatureFlags);
    const featureFlagClient = new (0, $ECRpY.default)({
        flags: normalizedFeatureFlags,
        analyticsHandler: $11652f2649e2c81d$var$noopAnalyticsHandler
    });
    // This sets up tooling for the editor experiments
    (0, $8ihu7.setupEditorExperiments)('confluence');
    // This sets up the platform feature flags
    (0, $dh538.setBooleanFeatureFlagResolver)((flagKey)=>{
        // eslint-disable-next-line confluence-feature-gating/static-feature-gates
        if ((0, $9wGTI.fg)(flagKey)) return true;
        return false;
    });
    const allFlags = flags.concat(platformFlags);
    const original = (0, $eT7Z2.processFeatureFlagsPure)(allFlags);
    return {
        originalFeatureFlags: original,
        featureFlagsWithOverrides: original,
        featureFlagClient: featureFlagClient
    };
});

});
parcelRegister("8ihu7", function(module, exports) {

$parcel$export(module.exports, "_overrides", () => $47435f399fa7774f$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $47435f399fa7774f$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $47435f399fa7774f$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $47435f399fa7774f$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7Rqpr = parcelRequire("7Rqpr");
let $47435f399fa7774f$export$e5d73bf4f8e2ae96 = {};
let $47435f399fa7774f$export$4e849416bb5c5b52 = {};
let $47435f399fa7774f$export$cf7305fc65acbf0d;
function $47435f399fa7774f$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $7Rqpr.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $47435f399fa7774f$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    $47435f399fa7774f$export$cf7305fc65acbf0d = product;
    if (paramOverrides) $47435f399fa7774f$export$4e849416bb5c5b52 = paramOverrides;
}

});
parcelRegister("7Rqpr", function(module, exports) {

$parcel$export(module.exports, "editorExperimentsConfig", () => $2b0767b4f0dbf85f$export$6cbb856f286b07ef);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $fLJXK = parcelRequire("fLJXK");
const $2b0767b4f0dbf85f$export$6cbb856f286b07ef = {
    // Added 2024-08-08
    'example-boolean': (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $fLJXK.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $fLJXK.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-09
    platform_editor_advanced_code_blocks: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-16
    live_pages_graceful_edit: (0, $fLJXK.createMultivariateExperiment)({
        productKeys: {
            confluence: 'live_pages_graceful_edit'
        },
        param: 'cohort',
        values: [
            'control',
            'text-click-delayed',
            'text-click-no-delay',
            'initially-hide-toolbar'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $fLJXK.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 28-02-2025
    platform_editor_insertion: (0, $fLJXK.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_insertion'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_vanilla_dom/setup
    platform_editor_vanilla_dom: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vanilla_dom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-13
    editor_text_highlight_orange_to_yellow: (0, $fLJXK.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_text_highlight_orange_to_yellow'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $fLJXK.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: (0, $fLJXK.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_inline_suggestion_date_v2'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-05
    editor_ai_contextual_selection_toolbar_button: (0, $fLJXK.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_contextual_selection_toolbar_button'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-05-08
    editor_ai_converge_free_gen_on_rovo: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_converge_free_gen_on_rovo'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    editor_ai_cmd_palette_remove_retry: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_cmd_palette_remove_retry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-08
    platform_editor_core_static_emotion: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_emotion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-13
    editor_ai_comment_freegen_rovo: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_comment_freegen_rovo'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    confluence_p2m_style_recalc_and_expand_joint_exp: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_p2m_style_recalc_and_expand_joint_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $fLJXK.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("fLJXK", function(module, exports) {

$parcel$export(module.exports, "createBooleanExperiment", () => $856a57b67e416c72$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $856a57b67e416c72$export$fb89e8a786694d1);

var $8O0tz = parcelRequire("8O0tz");
function $856a57b67e416c72$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $8O0tz.isBoolean),
        defaultValue: config.defaultValue
    };
}
function $856a57b67e416c72$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $8O0tz.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("8O0tz", function(module, exports) {

$parcel$export(module.exports, "isBoolean", () => $d057f5e142af87dd$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $d057f5e142af87dd$export$a9a18ae5ba42aeab);
function $d057f5e142af87dd$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $d057f5e142af87dd$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($d057f5e142af87dd$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $d057f5e142af87dd$var$IS_TESTING_ENV = false;

});




parcelRegister("23W1g", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("ECRpY")).default);

var $ECRpY = parcelRequire("ECRpY");

var $iGqJ7 = parcelRequire("iGqJ7");

});
parcelRegister("ECRpY", function(module, exports) {

$parcel$export(module.exports, "default", () => $beddd9d801215c13$export$2e2bcd8739ae039);

var $iGqJ7 = parcelRequire("iGqJ7");

var $gpBUp = parcelRequire("gpBUp");

var $2lD5U = parcelRequire("2lD5U");

var $aT3n9 = parcelRequire("aT3n9");
class $beddd9d801215c13$export$2e2bcd8739ae039 {
    setFlags(flags) {
        if (!(0, $gpBUp.isObject)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
   * This method returns the wrapper object for the given flag key.
   * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
   * so it is always guaranteed to return an object.
   */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $aT3n9.default)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $2lD5U.default)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $gpBUp.enforceAttributes)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $gpBUp.enforceAttributes)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $gpBUp.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $gpBUp.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
   * This method combines both the trackExposure and sendAutomaticExposure flows into
   * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
   * is sent.
   **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $iGqJ7.ExposureTriggerReason).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $iGqJ7.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $iGqJ7.ExposureTriggerReason).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $gpBUp.checkForReservedAttributes)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $gpBUp.isObjectEmptyOrUndefined)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            // In theory this shouldnt be necessary
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $iGqJ7.ExposureTriggerReason).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $gpBUp.isObjectEmptyOrUndefined)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $iGqJ7.ExposureTriggerReason).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
    constructor(options){
        this.flags = void 0;
        this.flagWrapperCache = void 0;
        this.analyticsHandler = void 0;
        this.isAutomaticExposuresEnabled = void 0;
        this.trackedFlags = void 0;
        this.customAttributesExposuresCache = void 0;
        this.ignoreTypes = void 0;
        (0, $gpBUp.enforceAttributes)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
}

});
parcelRegister("iGqJ7", function(module, exports) {

$parcel$export(module.exports, "ExposureTriggerReason", () => $c0cc6a0eb5682405$export$2c20ffeba7dbc068);
var $c0cc6a0eb5682405$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});

});

parcelRegister("gpBUp", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $f3838902fc4e0ba4$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isObjectEmptyOrUndefined", () => $f3838902fc4e0ba4$export$8ed1df9dbe2e9a7d);
$parcel$export(module.exports, "enforceAttributes", () => $f3838902fc4e0ba4$export$c7d37910dd25ecbf);
$parcel$export(module.exports, "checkForReservedAttributes", () => $f3838902fc4e0ba4$export$891630e169ca14a4);
const $f3838902fc4e0ba4$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $f3838902fc4e0ba4$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $f3838902fc4e0ba4$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $f3838902fc4e0ba4$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $f3838902fc4e0ba4$var$validateFlag = (flagKey, flag)=>{
    if ($f3838902fc4e0ba4$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $f3838902fc4e0ba4$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$f3838902fc4e0ba4$var$validateFlag(key, flags[key]));
};

});

parcelRegister("2lD5U", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2d1168707e5ae70$export$2e2bcd8739ae039);
const $f2d1168707e5ae70$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $f2d1168707e5ae70$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $f2d1168707e5ae70$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}

});

parcelRegister("aT3n9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5c427f90aa2c3ea$export$2e2bcd8739ae039);

var $iGqJ7 = parcelRequire("iGqJ7");
class $f5c427f90aa2c3ea$export$2e2bcd8739ae039 {
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $iGqJ7.ExposureTriggerReason).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $iGqJ7.ExposureTriggerReason).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.evaluationCount = void 0;
        this.flagKey = void 0;
        this.flag = void 0;
        this.trackExposure = void 0;
        this.sendAutomaticExposure = void 0;
        this.ignoreTypes = void 0;
        // Makes the casting easier later on. The APIs should not leak any.
        // Should only be used in private functions.
        this.evaluationResult = void 0;
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
}

});



parcelRegister("eT7Z2", function(module, exports) {

$parcel$export(module.exports, "unwrapValue", () => $575a5c9b172039f7$export$30a0bf30ea993fb);
$parcel$export(module.exports, "keyById", () => $575a5c9b172039f7$export$254798ec7ef71406);
$parcel$export(module.exports, "processFeatureFlagsPure", () => $575a5c9b172039f7$export$b474714fac955e7c);
function $575a5c9b172039f7$export$30a0bf30ea993fb(value) {
    if (value === 'true') return true;
    else if (value === 'false') return false;
    else if (typeof value === 'object') return JSON.stringify(value);
    return value;
}
function $575a5c9b172039f7$export$254798ec7ef71406(objectList, valueGetter) {
    return objectList.reduce((keyedObject, item)=>{
        keyedObject[item.id] = valueGetter(item);
        return keyedObject;
    }, {});
}
const $575a5c9b172039f7$export$b474714fac955e7c = (flags)=>{
    return $575a5c9b172039f7$export$254798ec7ef71406(flags, (item)=>$575a5c9b172039f7$export$30a0bf30ea993fb(item.value));
};

});



parcelRegister("fcgrS", function(module, exports) {

$parcel$export(module.exports, "loadSessionData", () => $65cf320a85975377$export$5ae208508f6870b);

var $9WAeG = parcelRequire("9WAeG");

var $5ZqQS = parcelRequire("5ZqQS");

var $36Ied = parcelRequire("36Ied");

var $gFHOP = parcelRequire("gFHOP");
function $65cf320a85975377$var$apolloQuery({ query: query, queryName: queryName, client: client = window.GLOBAL_APOLLO_CLIENT }) {
    if (!client) return Promise.reject(new Error(`ApolloClient not available, cannot load query ${queryName}`));
    return (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/fetch:${queryName}`, async ()=>client.query({
            query: query,
            errorPolicy: 'all',
            fetchPolicy: 'cache-first',
            context: {
                single: false,
                allowOnExternalPage: true
            }
        }));
}
// Since all LD FFs are archived, we can safely assume that both featureFlags and platformFeatureFlags are empty.
const $65cf320a85975377$var$emptyFeatureFlagsRaw = {
    featureFlags: {
        nodes: []
    },
    platformFeatureFlags: {
        nodes: []
    }
};
async function $65cf320a85975377$export$5ae208508f6870b() {
    // __SITEINFORMATION__ is either actual session data
    // or the promise that is resolving the session data
    // In the case when page is rendered by SSR, the __SITEINFORMATION__ will be populated with JSON data.
    if (window['__SITEINFORMATION__']) return window['__SITEINFORMATION__'];
    const queries = [];
    const isSiteInformationQueryEnabledValue = window['__ENABLE_SITE_INFORMATION_QUERY__'] || false;
    queries.push($65cf320a85975377$var$apolloQuery({
        query: isSiteInformationQueryEnabledValue ? (0, $gFHOP.SiteInformationQuery) : (0, $36Ied.SessionDataQuery),
        queryName: 'SiteInformationQuery'
    }));
    // Maintain compatibility with old code that expects __LD_FEATURE_FLAGS__ to be set.
    window['__LD_FEATURE_FLAGS__'] = $65cf320a85975377$var$emptyFeatureFlagsRaw;
    window['__SITEINFORMATION__'] = Promise.all(queries).then((queriesRes)=>{
        const SiteInformationQueryResult = queriesRes[0];
        const featureFlagsQueryResult = {
            data: $65cf320a85975377$var$emptyFeatureFlagsRaw
        };
        const errors = SiteInformationQueryResult.errors ?? [];
        if (errors.length > 0) {
            errors.forEach((e)=>(0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    attribution: 'FATAL'
                }));
            // #hot-116748:
            // We only respect FG value __ENABLE_TOLERANT_SESSION_DATA_ERROR_HANDLING__ when SSR.
            // Because FG is not available in non-SSR at this stage.
            // For non-SSR, we act as if FG is true, and use the errorAllowedFieldSetNONSSR
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            !window['__ENABLE_TOLERANT_SESSION_DATA_ERROR_HANDLING__'] && undefined;
        }
        let result = null;
        if (SiteInformationQueryResult.data && featureFlagsQueryResult.data) result = {
            ...SiteInformationQueryResult.data,
            ...featureFlagsQueryResult.data
        };
        return result;
    }).catch((error)=>{
        if (Array.isArray(error)) error.forEach((e)=>(0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: 'FATAL'
            }));
        else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: 'FATAL'
        });
        return null;
    });
    return window['__SITEINFORMATION__'];
}

});
parcelRegister("9WAeG", function(module, exports) {

$parcel$export(module.exports, "SSRMeasures", () => $7b5f61d5ad055a5c$export$5467c8c7fa0f4d06);

var $kGrzq = parcelRequire("kGrzq");
class $7b5f61d5ad055a5c$var$SSRMeasure extends (0, $kGrzq.BaseMeasures) {
    fetchCountIncr() {
        this.fetchCount++;
    }
    getFetchCount() {
        return this.fetchCount;
    }
    setStartTime(startTimeOffset = 0) {
        this.startTimeOffset = startTimeOffset;
        if (!this.startTime) this.startTime = Math.floor(performance.now());
    }
    getStartTime() {
        return this.startTime;
    }
    getStartTimeOffset() {
        return this.startTimeOffset;
    }
    markMeasureStart(name) {
        if (!this.measures[name]) this.measures[name] = {
            startTime: Math.floor(performance.now()) - this.startTime,
            duration: 0
        };
    }
    markMeasureEnd(name) {
        const entry = this.measures[name];
        if (entry) entry.duration = Math.floor(performance.now()) - this.startTime - entry.startTime;
    }
    getMeasures() {
        for(const key in this.measures)this.measures[key].startTime += this.startTimeOffset;
        return this.measures;
    }
    clearMeasures() {
        this.startTimeOffset = 0;
        this.startTime = 0;
        this.fetchCount = 0;
        this.measures = {};
    }
    constructor(...args){
        super(...args);
        this.startTimeOffset = 0;
        this.startTime = 0;
        this.fetchCount = 0;
    }
}
const $7b5f61d5ad055a5c$export$5467c8c7fa0f4d06 = new $7b5f61d5ad055a5c$var$SSRMeasure();

});
parcelRegister("kGrzq", function(module, exports) {

$parcel$export(module.exports, "BaseMeasures", () => $533cd45aab169de9$export$31c6869b8bca23f6);
/* eslint-disable no-dupe-class-members */ class $533cd45aab169de9$export$31c6869b8bca23f6 {
    run(name, fn) {
        const names = Array.isArray(name) ? name : [
            name
        ];
        names.forEach((name)=>this.markMeasureStart(name));
        const result = fn();
        if (typeof result?.then === 'function') // eslint-disable-next-line @typescript-eslint/no-floating-promises
        result.finally(()=>{
            names.forEach((name)=>this.markMeasureEnd(name));
        });
        else names.forEach((name)=>this.markMeasureEnd(name));
        return result;
    }
    markMeasureStart(name, timestamp) {
        //if startTime already marked, don't mark again.
        if (this.measures[name]?.startTime) return;
        this.measures[name] = {
            startTime: Math.floor(timestamp ?? performance.now()),
            duration: 0
        };
    }
    markMeasureEnd(name, timestamp, allowEndOnly = false) {
        const entry = this.measures[name];
        if (!entry?.duration && entry?.startTime) entry.duration = Math.floor((timestamp ?? performance.now()) - entry.startTime);
        else if (!entry && allowEndOnly) // In allowEndOnly mode we take FIRST end time as duration
        this.measures[name] = {
            startTime: 0,
            duration: timestamp ?? performance.now()
        };
    }
    getMeasures() {
        return this.measures;
    }
    clearMeasures() {
        this.measures = {};
    }
    constructor(){
        this.measures = {};
    }
}

});


parcelRegister("5ZqQS", function(module, exports) {

$parcel$export(module.exports, "getMonitoringClient", () => $b63a154ad6e5cc75$export$39a3b7739331403b);
$parcel$export(module.exports, "enableSendErrorsToTelemetryService", () => $b63a154ad6e5cc75$export$b97a02aaddc4fced);

var $6vgsX = parcelRequire("6vgsX");

var $9lScf = parcelRequire("9lScf");

let $b63a154ad6e5cc75$var$monitoringClient;
const $b63a154ad6e5cc75$export$39a3b7739331403b = ()=>{
    if (!$b63a154ad6e5cc75$var$monitoringClient) {
        if (/bot/i.test(window.navigator.userAgent)) // Do nothing for search engine crawlers
        $b63a154ad6e5cc75$var$monitoringClient = new (0, $9lScf.NoOpMonitoringClient)();
        else $b63a154ad6e5cc75$var$monitoringClient = new (0, $6vgsX.CustomMonitoringClient)();
    }
    return $b63a154ad6e5cc75$var$monitoringClient;
};
const $b63a154ad6e5cc75$export$b97a02aaddc4fced = ()=>{
    if ($b63a154ad6e5cc75$var$monitoringClient instanceof (0, $6vgsX.CustomMonitoringClient)) $b63a154ad6e5cc75$var$monitoringClient.enableSendErrorsToTelemetryService();
};

});
parcelRegister("6vgsX", function(module, exports) {

$parcel$export(module.exports, "CustomMonitoringClient", () => $5c815a7d2f4ec0f7$export$a54226afd3e3cacc);

var $lMdlY = parcelRequire("lMdlY");

var $7W8i8 = parcelRequire("7W8i8");

var $04e9M = parcelRequire("04e9M");

var $eSuZj = parcelRequire("eSuZj");

var $9wGTI = parcelRequire("9wGTI");

var $6X8o4 = parcelRequire("6X8o4");

var $flE5X = parcelRequire("flE5X");

var $jO2fj = parcelRequire("jO2fj");

var $1qZ9Y = parcelRequire("1qZ9Y");

var $fJlJm = parcelRequire("fJlJm");
const $5c815a7d2f4ec0f7$var$logger = (0, $7W8i8.getLogger)('CustomMonitoringClient');

class $5c815a7d2f4ec0f7$export$a54226afd3e3cacc {
    enableNewSentry() {
        this.newSentryEnabled = true;
    }
    enableSendErrorsToTelemetryService() {
        this.sendErrorsToTelemetryService = true;
    }
    submitError(error, errorData) {
        if (this.errorsPerCurrentTransition === this.errorsPerTransitionLimit) // limit reached; do not submit the errors
        return;
        this.errorsPerCurrentTransition++;
        const logSafeErrorAttributes = (0, $fJlJm.getLogSafeErrorAttributes)(error);
        const { attribution: attribution } = errorData;
        let isFirstInSession = this.firstErrorInSession;
        const errorWithStackTrace = error && error.stack && error.message ? error : new Error(error && error.message || String(error));
        if ($5c815a7d2f4ec0f7$var$isErrorIgnorableByOnCall(errorWithStackTrace, attribution, logSafeErrorAttributes)) isFirstInSession = false;
        else this.firstErrorInSession = false;
        this.incrementCounter('jsErrors', [
            `attribution:${attribution}`,
            `firstInSession:${isFirstInSession}`,
            ...logSafeErrorAttributes.operationName ? [
                `queryName:${logSafeErrorAttributes.operationName}`
            ] : []
        ]);
        const sentryTags = {
            attribution: attribution
        };
        if (this.context.slaExperience) sentryTags.slaExperience = this.context.slaExperience;
        if (this.context.pageName) sentryTags.pageName = this.context.pageName;
        if (logSafeErrorAttributes.failedSlaExperience) sentryTags.failedSlaExperience = logSafeErrorAttributes.failedSlaExperience;
        if (logSafeErrorAttributes.operationName) sentryTags.operationName = logSafeErrorAttributes.operationName;
        sentryTags.ssrRendered = Boolean(window.__SSR_RENDERED__).toString();
        if (logSafeErrorAttributes.failedSlaExperience) this.logSlaErrorToSentry(errorWithStackTrace, sentryTags).catch((sentryError)=>{
            this.logError(sentryError, {
                attribution: 'backbone'
            });
        });
        else if (this.newSentryEnabled) this.logErrorToSentry(errorWithStackTrace, sentryTags);
        this.logError(errorWithStackTrace, {
            ...errorData,
            ...logSafeErrorAttributes,
            firstInSession: isFirstInSession
        });
    }
    updateContext(update) {
        if (update.transitionId !== undefined && (update.transitionId === 0 || this.context.transitionId !== update.transitionId)) {
            this.incrementCounter('session', [
                `type:${update.transitionId === 0 ? 'initial' : 'transition'}`
            ]);
            // Next error will be first in the session when there is a initial load (transition id = 0) or a SPA transition.
            this.firstErrorInSession = true;
            this.errorsPerCurrentTransition = 0;
        }
        if (update.pageName && this.context.pageName !== update.pageName) // since the page name changed, all the events in the current batch were done
        // under an old page name. Hence we force-flush the batch, and only then set the new context.
        {
            if (this.context.pageName !== undefined) // skip force-flush if that's the first time we set pageName (i.e. initial navigation)
            this.batcher.forceFlush();
        }
        Object.assign(this.context, update);
    }
    incrementCounter(counterName, tags) {
        this.batcher.add(this.createMetric({
            type: 'increment',
            name: counterName,
            value: 1,
            tags: tags
        }));
    }
    logErrorToSentry(error, tags) {
        (parcelRequire("jrilp")).then(({ withScope: withScope, captureException: captureException })=>{
            withScope((scope)=>{
                scope.setTags(tags);
                captureException(error);
            });
        }).catch((sentryError)=>{
            this.logError(sentryError, {
                attribution: 'backbone'
            });
        });
    }
    async logSlaErrorToSentry(error, tags) {
        let sentryHub = null;
        const standaloneSentryPromise = (0, $jO2fj.getSentryHubForSLAErrors)();
        if ((0, $6X8o4.isResolved)(standaloneSentryPromise)) sentryHub = (0, $6X8o4.getValue)(standaloneSentryPromise);
        else sentryHub = await standaloneSentryPromise;
        if (sentryHub) sentryHub.withScope((scope)=>{
            scope.setTags(tags);
            sentryHub.captureException(error);
        });
    }
    /**
   * There is a 64kb payload limit for navigator.sendBeacon requests
   * 10 events sent max.
   * 3 fields that are being trimmed
   * That allows for 65536/10/3 = 2184.5 per field
   * we add a bit of buffer for the rest of the payload by reducing that number further to 1000
   * @param errorAttributes
   * @returns a new object with trimmed attributes if they exceed the limit determined by
   * errorBatchMsgTrimLength` which is calculated based on the following details
   */ trimAttributes(errorAttributes) {
        const attributesToTrim = [
            'error',
            'stack',
            'componentStack'
        ];
        const newErrorAttributes = {
            ...errorAttributes
        };
        attributesToTrim.forEach((attribute)=>{
            if (newErrorAttributes[attribute]) newErrorAttributes[attribute] = this.trimTextLength(newErrorAttributes[attribute], this.errorBatchMsgTrimLength);
        });
        return newErrorAttributes;
    }
    async logError(error, additionalData) {
        try {
            const analyticsWebClientPromise = (0, $04e9M.getAnalyticsWebClient)();
            let client;
            if ((0, $6X8o4.isResolved)(analyticsWebClientPromise)) client = (0, $6X8o4.getValue)(analyticsWebClientPromise);
            else client = await analyticsWebClientPromise;
            const errorAttributes = {
                error: error.message || String(error),
                stack: error.stack,
                browserInfo: window.navigator.userAgent,
                ssrRendered: Boolean(window.__SSR_RENDERED__),
                releaseId: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
                track: (0, $eSuZj.getBuildInfo)().RELEASE_TRACK,
                pageName: this.context.pageName,
                shard: this.context.shard,
                edition: this.context.edition,
                jqVer: window.jQuery?.fn?.jquery,
                activeExperiences: this.context.activeExperiences ? Array.from(this.context.activeExperiences) : undefined,
                slaExperience: this.context.slaExperience,
                ufoTraceId: (0, $lMdlY.getActiveTrace)()?.traceId,
                ufoTraceType: (0, $lMdlY.getActiveTrace)()?.type,
                ...additionalData
            };
            if ((0, $9wGTI.fg)('confluence_trim_ui_errors')) this.errorBatchMsgTrimLength = 1000;
            const trimmedErrorAttributes = this.trimAttributes(errorAttributes);
            client.sendOperationalEvent({
                source: 'ui',
                action: 'unhandledError',
                actionSubject: 'ui',
                attributes: (0, $9wGTI.fg)('confluence_trim_ui_errors') ? trimmedErrorAttributes : errorAttributes
            });
            if (this.sendErrorsToTelemetryService) this.errorBatcher.add({
                event: trimmedErrorAttributes
            });
        } catch  {
        // no-op, if an error occurs here, there's really nowhere to submit it
        }
    }
    /**
   * Defines an allow-list of context attributes that will be sent as "global" tags to FE Telemetry and SignalFX with every event.
   * Tags additionally have to be allow-listed in the FE Telemetry repository. We PURPOSELY exclude certain tags (that are allowed by FE Telemetry)
   * such as "edition", as we do not want to be sending that tag for every experience event (thereby increasing metric cardinality). Instead, those tags
   * are included with specific experience events.
   * @private
   */ formatContextAsTags() {
        const tags = [];
        if (this.context.pageName) tags.push(`page:${this.context.pageName}`);
        if (this.context.tenantId) tags.push(`cloudId:${this.context.tenantId}`);
        if (this.context.shard) tags.push(`shard:${this.context.shard}`);
        if (this.context.product) tags.push(`product:${this.context.product}`);
        const { FRONTEND_VERSION: frontendVersion, RELEASE_TRACK: releaseTrack } = (0, $eSuZj.getBuildInfo)();
        if (frontendVersion) tags.push(`version:${frontendVersion}`);
        if (releaseTrack) tags.push(`track:${releaseTrack}`);
        return tags;
    }
    onBatch(batch) {
        const payload = {
            type: 'metric',
            meta: {
                globalTags: this.formatContextAsTags()
            },
            data: batch
        };
        this.send(payload);
    }
    onErrorBatch(batch) {
        const payload = {
            type: 'error',
            meta: {
                globalTags: this.formatContextAsTags()
            },
            data: batch
        };
        this.send(payload);
    }
    send(telemetryPayload) {
        try {
            $5c815a7d2f4ec0f7$var$logger.info`Sending monitoring events: ${telemetryPayload}`;
            const reportingUrl = '/gateway/api/telemetry';
            const data = JSON.stringify(telemetryPayload);
            let isSentViaBeacon = false;
            if (navigator.sendBeacon) isSentViaBeacon = navigator.sendBeacon(reportingUrl, data);
            if (!isSentViaBeacon) {
                // resorting to XMLHttpRequest instead of fetch here so that we can submit these events *synchronously* when
                // the page unloads (`fetch` can't do that)
                const client = new XMLHttpRequest();
                const shouldBeSync = this.isWindowUnloading;
                client.open('POST', reportingUrl, !shouldBeSync);
                // we're setting the "Content-Type" header to "text/plain" to behave as closely to `sendBeacon` as possible
                client.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
                client.send(data);
            }
        } catch (e) {
            // ignore - there's nothing we can do when monitoring is down
            $5c815a7d2f4ec0f7$var$logger.error`Sending monitoring data failed: ${e}`;
        }
    }
    createMetric({ type: type, name: name, value: value, tags: tags = [] }) {
        return {
            type: type,
            name: name,
            value: value,
            sampleRate: 1,
            tags: tags,
            timestamp: new Date().toISOString()
        };
    }
    trimTextLength(text, trimmedLength) {
        if (!text || !trimmedLength) return text;
        if (text.length > trimmedLength) return `${text.substring(0, trimmedLength)}...`;
        return text;
    }
    constructor({ errorsPerTransitionLimit: errorsPerTransitionLimit = 1000, metricBatchMaxSize: metricBatchMaxSize = 50, metricBatchFlushIntervalMs: metricBatchFlushIntervalMs = 10000, errorBatchFlushIntervalMs: errorBatchFlushIntervalMs = 10000, errorBatchMaxSize: errorBatchMaxSize = 10, errorBatchMsgTrimLength: errorBatchMsgTrimLength = 7168 } = {}){
        this.batcher = void 0;
        this.errorBatcher = void 0;
        this.isWindowUnloading = false;
        this.context = {};
        // First error occurred in initial load or transition
        this.firstErrorInSession = true;
        this.newSentryEnabled = false;
        this.sendErrorsToTelemetryService = false;
        this.errorsPerTransitionLimit = void 0;
        this.errorsPerCurrentTransition = 0;
        this.errorBatchMsgTrimLength = void 0;
        this.errorsPerTransitionLimit = errorsPerTransitionLimit;
        this.errorBatchMsgTrimLength = errorBatchMsgTrimLength;
        this.batcher = new (0, $1qZ9Y.Batcher)(metricBatchFlushIntervalMs, metricBatchMaxSize);
        this.errorBatcher = new (0, $1qZ9Y.Batcher)(errorBatchFlushIntervalMs, errorBatchMaxSize);
        this.batcher.onFlush((batch)=>{
            this.onBatch(batch);
        });
        this.errorBatcher.onFlush((batch)=>{
            this.onErrorBatch(batch);
        });
        const unloadListener = ()=>{
            this.isWindowUnloading = true;
            this.batcher.forceFlush();
            this.errorBatcher.forceFlush();
        };
        window.addEventListener('pagehide', unloadListener);
    }
}
function $5c815a7d2f4ec0f7$var$isErrorIgnorableByOnCall(error, attribution, attrs) {
    // make sure that this condition remains first, as it should override everything else
    if (Boolean(attrs.failedSlaExperience)) // non-ignorable, because it resulted in a failure of an SLA-bound experience
    return false;
    if ((0, $flE5X.containsNoNetworkError)(error)) // ignorable, because on-call can't do much about user-side network connectivity
    return true;
    if (attribution === 'backbone-loadable') // while we do want to report those, we don't want to overwhelm our error rate detector
    return true;
    if (error.message.includes('com.atlassian.confluence.api.service.exceptions.PermissionException') || error.message.includes('Authorization failed: Principal has insufficient permissions') || error.message.includes('com.atlassian.confluence.api.service.exceptions.NotFoundException') || attrs.statusCode === 401 || attrs.statusCode === 403) // on-call engineers can't do much about those errors, because they indicate a client-side issue
    return true;
    return false;
}

});
parcelRegister("jO2fj", function(module, exports) {

$parcel$export(module.exports, "getSentryHubForSLAErrors", () => $1965025ede6bc114$export$c2e2a07dfafd1ea2);

var $csnse = parcelRequire("csnse");

var $6X8o4 = parcelRequire("6X8o4");

var $eSuZj = parcelRequire("eSuZj");

var $50bhB = parcelRequire("50bhB");

var $fJlJm = parcelRequire("fJlJm");
const $1965025ede6bc114$var$cloudFrontRegex = /(https?):\/\/[a-z0-9]+\.cloudfront\.net\//g;
const $1965025ede6bc114$var$cloudFrontS3Regex = /(https?):\/\/[a-z0-9]+\.cloudfront\.net\/download\//g;
// Used to match web resource URLs like this:
//   .../wiki/s/99914b932bd37a50b983c5e7c90ae93b-CDN/-1510873586/6452/236c4aa50522e3b557db968ff45d01d44604ffe1/1000.0.53/_/download/...
//   .../wiki/s/d41d8cd98f00b204e9800998ecf8427e-CDN/-783152381/h/2ddebfb80ae902fe7ab6e15441fe94e2/_/download/batch/...
//   .../wiki/s/d065fee603fdcf75115204ec65310e1c-CDN/-1510873586/6452/236c4aa50522e3b557db968ff45d01d44604ffe1/11d5083bb8bb9dac4c3a5987eeac4b5b/_/download/contextbatch/...
//   .../wiki/s/1283600969/6452/571d5459a4fbf60c255c41bb4e0d3ef3b8022627/_/download/resources/...
const $1965025ede6bc114$var$wrmResourceRegex = /s\/[^_]+_\/download\//g;
/**
 * For values which represent a stringified JSON, tries to extract the `"message"`
 * property and returns it if found. Returned result defaults to input value.
 */ function $1965025ede6bc114$var$tryExtractMessage(value) {
    try {
        const parsedValue = JSON.parse(value);
        return parsedValue.message || value;
    } catch (_) {
        return value;
    }
}
// Turns the culprit URL into .../wiki/download/... to remove the hash information.
function $1965025ede6bc114$var$stripHashAndCDNHost(url) {
    return url.match($1965025ede6bc114$var$wrmResourceRegex) ? url.replace($1965025ede6bc114$var$wrmResourceRegex, 'download/').replace($1965025ede6bc114$var$cloudFrontRegex, '$1://') : url;
}
function $1965025ede6bc114$var$getErrorFingerprint(error) {
    // See docs at https://docs.sentry.io/platforms/javascript/data-management/event-grouping/sdk-fingerprinting/
    const DEFAULT_FINGERPRINT = '{{ default }}';
    if (error.message.startsWith('Quota exceeded on key') || error.message.startsWith('QuotaExceededError')) return [
        'storage-quota-error'
    ];
    if (error.message.startsWith('Maximum call stack size exceeded') || error.message.startsWith('too much recursion')) // Most (if not all) of these errors originate from editor/prosemirror, and they
    // are hard to troubleshoot. So, although they all might represent a
    // different error, we're bundling them together
    return [
        'maximum-call-stack'
    ];
    if (error.message.startsWith('Invalid position')) // These errors originate from editor/prosemirror. The rest of the message
    // is the position number itself, and Sentry seldom groups those together.
    // By giving them all the same fingerprint, we're forcing Sentry to treat all
    // of those as the occurrence of one and the same error.
    return [
        'invalid-position'
    ];
    if (error.message.match(/Loading chunk .+? failed/)) // These are webpack chunk load errors, which often have very different stack traces.
    // We're grouping them together.
    return [
        'chunk-load-error'
    ];
    if (error.message.startsWith('Error creating blueprint content:')) // Grouping those by message should work better than looking at the stack trace
    return [
        'blueprint-creation-error',
        error.message.substr(0, 100)
    ];
    if (error.message.startsWith('Error from synchrony plugin')) // These are hard to troubleshoot, so to reduce noise we group them together
    return [
        'error-from-synchrony-plugin'
    ];
    if (error.message.includes('Error fetching data from identity - Error has been logged with execution ID:')) // The "execution ID" part in these errors is always different.
    return [
        'identity-fetching-error'
    ];
    if (error.message.includes('java.net.SocketTimeoutException')) return [
        'socket-timeout'
    ];
    if (error instanceof URIError) // This will group all URI errors together, as they often have different stack traces
    return [
        'malformed-uri-error'
    ];
    if (error instanceof (0, $50bhB.ConfluenceRestApiError) && error.route) // These errors tend to produce unpredictable messages which are hard to group.
    // So, instead of grouping by message, we'll group them by `route` and status code (which should be more predictable)
    return [
        `rest-api-${error.route}-${error.statusCode}`
    ];
    const logSafeAttributes = (0, $fJlJm.getLogSafeErrorAttributes)(error);
    if (logSafeAttributes.failedSlaExperience) {
        if (logSafeAttributes.operationName || logSafeAttributes.statusCode) // This code branch is for GraphQL/REST failures which result in experience failures.
        // Since the same backend errors can be thrown for different operations/endpoints,
        // we're applying a per-message grouping.
        // Also, we're **not** including default fingerprint here.
        return [
            `experience-${logSafeAttributes.failedSlaExperience}`,
            $1965025ede6bc114$var$tryExtractMessage(error.message).substr(0, 100)
        ];
        else // this way SLA-affecting errors shouldn't be bundled with other types of errors
        return [
            DEFAULT_FINGERPRINT,
            `experience-${logSafeAttributes.failedSlaExperience}`
        ];
    }
    return undefined;
}
const $1965025ede6bc114$var$dataTransformer = function(data, hint) {
    let fromWRM = false;
    let fromS3 = false;
    if (data.exception?.values) // Go through the stack trace and sanitize all the exception URLs.
    data.exception.values = data.exception.values.map((exception)=>{
        if (exception.stacktrace && exception.stacktrace.frames) exception.stacktrace.frames = exception.stacktrace.frames.map((frame)=>{
            if (frame.filename) {
                fromWRM = Boolean(frame.filename.match($1965025ede6bc114$var$wrmResourceRegex));
                fromS3 = Boolean(frame.filename.match($1965025ede6bc114$var$cloudFrontS3Regex));
                frame.filename = $1965025ede6bc114$var$stripHashAndCDNHost(frame.filename);
            }
            return frame;
        });
        return exception;
    });
    if (typeof hint?.originalException === 'object' && hint?.originalException !== null) {
        data.fingerprint = $1965025ede6bc114$var$getErrorFingerprint(hint.originalException);
        const { componentStack: _1, // this field is very big
        failedSlaExperience: _2, // this one is included as tag
        ...rest } = (0, $fJlJm.getLogSafeErrorAttributes)(hint.originalException);
        data.extra = {
            ...data.extra,
            ...rest
        };
    }
    if (fromWRM) data.logger = 'wrm';
    else if (fromS3) data.logger = 'react';
    else data.logger = 'javascript';
    // strip out url and breadcrumbs which include customer sensitive data
    if (data.request) delete data.request.url;
    delete data.breadcrumbs;
    data.transaction = ''; // transactions can have URLs in them, too
    return data;
};
// Structure: https://<PUBLIC_KEY>@o55978.ingest.sentry.io/<PROJECT_ID>
// See: https://hello.atlassian.net/wiki/spaces/OBSERVABILITY/pages/1436386358/Sentry+Cloud+-+Getting+Started#Setting-up-the-Sentry-SDK-for-your-project
function $1965025ede6bc114$var$getSentryDsn() {
    // https://sentry.io/settings/atlassian-2y/projects/confluence/keys/
    const SENTRY_DSN_PROD = 'https://1f56d81aaaae4b1ea5ca08bca6633223@o55978.ingest.sentry.io/5988811';
    // https://sentry.io/settings/atlassian-2y/projects/confluence-staging/keys/
    const SENTRY_DSN_STAGING = 'https://ce2ea70bbd2a439793b772cc1d59e2fe@o55978.ingest.sentry.io/5988871';
    return SENTRY_DSN_PROD;
}
function $1965025ede6bc114$var$getSentryEnvironment() {
    const SENTRY_ENV_PROD = 'CONFLUENCE';
    const SENTRY_ENV_STAGING = 'CONFLUENCE-STAGING';
    const SENTRY_ENV_HELLO = 'HELLO';
    return SENTRY_ENV_PROD;
}
function $1965025ede6bc114$var$getSentryOptions(dsn) {
    const additionalOptions = {};
    return {
        release: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
        dsn: dsn,
        environment: $1965025ede6bc114$var$getSentryEnvironment(),
        beforeSend (event, hint) {
            return $1965025ede6bc114$var$dataTransformer(event, hint);
        },
        ignoreErrors: [
            'Transport destroyed',
            // Error being thrown by media that won't be resolved any time soon.
            'Worker was destroyed',
            // Error being thrown by media that won't be resolved any time soon.
            'Failed to connect on any of the ADC ports',
            // Error being thrown by media that won't be resolved any time soon.
            "Cannot read property 'postMessage' of undefined",
            // Error being thrown by Connect that won't be resolved any time soon.
            "Cannot read property 'postMessage' of null",
            // Error being thrown by Connect that won't be resolved any time soon.
            'd.hide is not a function',
            // From com.atlassian.auiplugin:aui-date-picker,
            /^network error/i,
            // We can't do anything about network issues
            /^network failure/i,
            // We can't do anything about network issues
            'TypeError: Failed to fetch',
            // We can't do anything about network issues
            'ResizeObserver loop limit exceeded',
            // A benign error, see https://stackoverflow.com/a/50387233/2645305
            /ResizeObserver loop completed with undelivered notifications/
        ],
        autoSessionTracking: false,
        ...additionalOptions
    };
}

const $1965025ede6bc114$export$c2e2a07dfafd1ea2 = (0, $csnse.default)(async ()=>{
    // https://sentry.io/settings/atlassian-2y/projects/confluence-sla/keys/
    const SENTRY_DSN_SLA = 'https://2d329ea4a8a04cf0b19117b4675b336f@o55978.ingest.sentry.io/5988900';
    return (0, $6X8o4.liftPromiseState)((parcelRequire("jrilp")).then(({ BrowserClient: BrowserClient, Hub: Hub })=>{
        const client = new BrowserClient($1965025ede6bc114$var$getSentryOptions(SENTRY_DSN_SLA));
        return new Hub(client);
    }).catch(()=>{
        // noop, there's nowhere to report this error
        return null;
    }));
});

function $1965025ede6bc114$export$1f7656c617418e15() {
    (parcelRequire("jrilp")).then(({ init: init })=>{
        init($1965025ede6bc114$var$getSentryOptions($1965025ede6bc114$var$getSentryDsn()));
    }).catch(()=>{
    // noop, there's nowhere to report this error
    });
}

});
parcelRegister("50bhB", function(module, exports) {

$parcel$export(module.exports, "ConfluenceRestApiError", () => $b13ce33266da6499$export$e704fce35c66bf42);
/**
 * The error returned if an error occurs while calling a REST API.
 */ class $b13ce33266da6499$export$e704fce35c66bf42 extends Error {
    constructor({ message: message, method: method, url: url, 'status-code': statusCode }, { route: route, traceId: traceId } = {}){
        const formattedMessage = message.length ? message : `Failed to ${method} ${route || url}`;
        super(formattedMessage);
        /**
     * The URL of the failed request.
     */ this.url = void 0;
        /**
     * The attempted http request method.
     */ this.method = void 0;
        /**
     * The status code returned in the response
     */ this.statusCode = void 0;
        /**
     * The name of the requested route (without UGC/PII)
     */ this.route = void 0;
        /**
     * The traceId of the request
     */ this.traceId = void 0;
        this.url = url;
        this.route = route;
        this.method = method;
        this.statusCode = statusCode;
        this.traceId = traceId;
    }
}

});

parcelRegister("fJlJm", function(module, exports) {

$parcel$export(module.exports, "setReactErrorAttributes", () => $abd29dc8c63e723c$export$df1c6d0ba3db287e);
$parcel$export(module.exports, "getReactErrorAttributes", () => $abd29dc8c63e723c$export$8b5fa6128aa81e5e);
$parcel$export(module.exports, "setGraphqlErrorAttributes", () => $abd29dc8c63e723c$export$6f0dbe4e2bbe0509);
$parcel$export(module.exports, "getGraphqlErrorAttributes", () => $abd29dc8c63e723c$export$b19e649eafc62480);
$parcel$export(module.exports, "setSlaErrorAttributes", () => $abd29dc8c63e723c$export$a986f274521b30d7);
$parcel$export(module.exports, "setContentErrorAttributes", () => $abd29dc8c63e723c$export$c37ca7d37ab54fcc);
$parcel$export(module.exports, "getContentErrorAttributes", () => $abd29dc8c63e723c$export$bc010311f017b17c);
$parcel$export(module.exports, "setLoadableErrorAttributes", () => $abd29dc8c63e723c$export$6f86bd8e510ff607);
$parcel$export(module.exports, "getTraceIdFromApolloError", () => $abd29dc8c63e723c$export$69408b85ed2a0e77);
$parcel$export(module.exports, "getLogSafeErrorAttributes", () => $abd29dc8c63e723c$export$d08bac32cb78075f);
// Please only keep this import as a *type import* to avoid bringing in the entire lib

var $hBkCm = parcelRequire("hBkCm");
var $50bhB = parcelRequire("50bhB");
var $9kGfD = parcelRequire("9kGfD");
function $abd29dc8c63e723c$var$isApolloError(error) {
    // theoretically this could be an `instanceof ApolloError` check, but bringing another
    // dependency to this package for the sake of this single check seems like an overkill
    return typeof error === 'object' && error !== null && ('graphQLErrors' in error || 'networkError' in error);
}
const $abd29dc8c63e723c$var$REACT_ERROR_CONTEXT_SYMBOL = Symbol('React error context');
function $abd29dc8c63e723c$export$df1c6d0ba3db287e(error, context) {
    if (typeof error === 'object' && error !== null) error[$abd29dc8c63e723c$var$REACT_ERROR_CONTEXT_SYMBOL] = context;
}
function $abd29dc8c63e723c$export$8b5fa6128aa81e5e(error) {
    if (typeof error === 'object' && error !== null) return error[$abd29dc8c63e723c$var$REACT_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL = Symbol('Graphql error context');
function $abd29dc8c63e723c$export$6f0dbe4e2bbe0509(error, context) {
    if (typeof error === 'object' && error !== null) error[$abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL] = context;
}
function $abd29dc8c63e723c$export$b19e649eafc62480(error) {
    if (typeof error !== 'object' || error === null) return undefined;
    if (error[$abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL]) return error[$abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    // Currently the graphql error context is set on the first entry of the `graphqlErrors`
    // property of `ApolloError`. That way, `ApolloError` itself does not have the context
    // set properly. This method is a measure to overcome this and make sure that
    // we are able to retrieve the context correctly.
    return $abd29dc8c63e723c$var$getGraphqlErrorAttributesFromApolloError(error);
}
function $abd29dc8c63e723c$var$getGraphqlErrorAttributesFromApolloError(error) {
    if (!$abd29dc8c63e723c$var$isApolloError(error)) return undefined;
    const graphqlErrors = error.graphQLErrors;
    // the context is populated by next/packages/graphql/src/links/OnErrorLink.ts
    if (graphqlErrors && graphqlErrors.length > 0 && graphqlErrors[0][$abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL]) return graphqlErrors[0][$abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    if (error.networkError) return error.networkError[$abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $abd29dc8c63e723c$var$SLA_ERROR_CONTEXT_SYMBOL = Symbol('SLA error context');
function $abd29dc8c63e723c$export$d4fe004fb0aaaf4f(error) {
    if (typeof error === 'object' && error !== null) return error[$abd29dc8c63e723c$var$SLA_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
function $abd29dc8c63e723c$export$a986f274521b30d7(error, context) {
    if (typeof error === 'object' && error !== null) error[$abd29dc8c63e723c$var$SLA_ERROR_CONTEXT_SYMBOL] = context;
}
function $abd29dc8c63e723c$var$getBadStatusErrorAttributes(error) {
    if (!(error instanceof (0, $hBkCm.BadStatusError))) return undefined;
    return {
        statusCode: error.response.status,
        traceId: (0, $9kGfD.getTraceIdFromResponse)(error.response)
    };
}
function $abd29dc8c63e723c$var$getConfluenceRestApiErrorAttributes(error) {
    if (!(error instanceof (0, $50bhB.ConfluenceRestApiError))) return undefined;
    return {
        statusCode: error.statusCode,
        restMethod: error.method,
        restRoute: error.route,
        traceId: error.traceId
    };
}
const $abd29dc8c63e723c$var$CONTENT_ERROR_CONTEXT_SYMBOL = Symbol('Content error context');
function $abd29dc8c63e723c$export$c37ca7d37ab54fcc(error, context) {
    if (typeof error === 'object' && error !== null) error[$abd29dc8c63e723c$var$CONTENT_ERROR_CONTEXT_SYMBOL] = context;
}
function $abd29dc8c63e723c$export$bc010311f017b17c(error) {
    if (typeof error === 'object' && error !== null) return error[$abd29dc8c63e723c$var$CONTENT_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $abd29dc8c63e723c$var$LOADABLE_ERROR_CONTEXT_SYMBOL = Symbol('Loadable error context');
function $abd29dc8c63e723c$export$6f86bd8e510ff607(error, context) {
    if (typeof error === 'object' && error !== null) error[$abd29dc8c63e723c$var$LOADABLE_ERROR_CONTEXT_SYMBOL] = context;
}
function $abd29dc8c63e723c$export$b8f8f1e62c6397ed(error) {
    if (typeof error === 'object' && error !== null) return error[$abd29dc8c63e723c$var$LOADABLE_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
function $abd29dc8c63e723c$export$69408b85ed2a0e77(error) {
    const traceId = $abd29dc8c63e723c$export$b19e649eafc62480(error)?.traceId || $abd29dc8c63e723c$export$b19e649eafc62480(error?.graphQLErrors?.[0])?.traceId;
    if (traceId) return traceId;
    // handle experimental query error
    if (error.graphQLErrors?.[0].originalError instanceof (0, $hBkCm.BadStatusError)) return error.graphQLErrors[0].originalError?.traceId;
    return null;
}
function $abd29dc8c63e723c$export$d08bac32cb78075f(error) {
    if (!error || typeof error !== 'object') return {};
    return {
        ...$abd29dc8c63e723c$export$8b5fa6128aa81e5e(error),
        ...$abd29dc8c63e723c$export$b19e649eafc62480(error),
        ...$abd29dc8c63e723c$export$d4fe004fb0aaaf4f(error),
        ...$abd29dc8c63e723c$export$bc010311f017b17c(error),
        ...$abd29dc8c63e723c$export$b8f8f1e62c6397ed(error),
        ...$abd29dc8c63e723c$var$getConfluenceRestApiErrorAttributes(error),
        ...$abd29dc8c63e723c$var$getBadStatusErrorAttributes(error)
    };
}

});

parcelRegister("jrilp", function(module, exports) {

let $e26ec4bc5ba22a81$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e26ec4bc5ba22a81$var$load("dUXgJ"),
    $e26ec4bc5ba22a81$var$load("8RcKV")
]).then(()=>parcelRequire('4JAbX'));

});


parcelRegister("1qZ9Y", function(module, exports) {

$parcel$export(module.exports, "Batcher", () => $c8946d14d771a4cc$export$704b12ddc1dacdd2);
/* eslint-disable no-useless-constructor */ class $c8946d14d771a4cc$export$704b12ddc1dacdd2 {
    add(item) {
        this.scheduleFlush();
        this.currentBatch.push(item);
        if (this.currentBatch.length >= this.batchMaxSize) this.flush();
    }
    onFlush(callback) {
        if (!(callback instanceof Function)) throw new Error(`"onFlush" callback is supposed to be a function; saw ${typeof callback} instead`);
        this.onFlushCallbacks.add(callback);
        return {
            unsubscribe: ()=>{
                this.onFlushCallbacks.delete(callback);
            }
        };
    }
    /**
   * Forcefully flushes the batcher. Noop if current batch is empty.
   */ forceFlush() {
        // Currently force-flush is synchronous. Make sure the call sites are updated if
        // this is changed to a promise-based approach
        this.flush();
    }
    renewBatch() {
        const oldBatch = this.currentBatch;
        this.currentBatch = [];
        return oldBatch;
    }
    scheduleFlush() {
        if (!this.flushIntervalId) this.flushIntervalId = window.setInterval(this.flush, this.flushIntervalMs);
    }
    unscheduleFlush() {
        if (this.flushIntervalId) {
            window.clearInterval(this.flushIntervalId);
            this.flushIntervalId = undefined;
        }
    }
    constructor(flushIntervalMs, batchMaxSize){
        this.flushIntervalMs = flushIntervalMs;
        this.batchMaxSize = batchMaxSize;
        this.flushIntervalId = void 0;
        this.onFlushCallbacks = new Set();
        this.currentBatch = [];
        this.flush = ()=>{
            const batch = this.renewBatch();
            this.unscheduleFlush();
            if (batch.length === 0) return;
            this.onFlushCallbacks.forEach((cb)=>{
                try {
                    cb(batch);
                } catch (e) {
                    // rethrow error asynchronously to allow other callbacks to execute
                    setTimeout(()=>{
                        /* eslint-disable-next-line no-console */ console.error(`"onFlush" callback threw the below error. Please make sure your callbacks have proper error handling`);
                        throw e;
                    }, 0);
                }
            });
        };
    }
}

});


parcelRegister("9lScf", function(module, exports) {

$parcel$export(module.exports, "NoOpMonitoringClient", () => $c344a94841b8c8c5$export$97cc0a779e2b1c0d);
class $c344a94841b8c8c5$export$97cc0a779e2b1c0d {
    submitError() {}
    updateContext() {}
    incrementCounter() {}
}

});


parcelRegister("36Ied", function(module, exports) {

$parcel$export(module.exports, "SessionDataQuery", () => $5d92c8fad19fca47$export$762d831b63426eae);

var $d2LG0 = parcelRequire("d2LG0");

var $gkmg4 = parcelRequire("gkmg4");
const $5d92c8fad19fca47$export$762d831b63426eae = (0, $d2LG0.default)`${(0, $gkmg4.SessionDataQueryRaw)}`;

});
parcelRegister("gkmg4", function(module, exports) {

$parcel$export(module.exports, "SessionDataQueryRaw", () => $97bbb97337251f15$export$9ea19e712531aad4);
const $97bbb97337251f15$export$9ea19e712531aad4 = /* GraphQL */ `
	query SessionDataQuery @SLA {
		tenant {
			shard
			cloudId
			environment
			activationId
			editions {
				edition
			}
		}
		organization {
			orgId
		}
		userForAnalytics: user {
			id
		}
		user(current: true) {
			id
			displayName
			confluence {
				accessStatus
				accountId
				userKey
				locale
			}
			timeZone
		}
		getAIConfig(product: CONFLUENCE) {
			isEnabled
			isRovoEnabled
			isRovoLLMEnabled
		}
	}
`;

});


parcelRegister("gFHOP", function(module, exports) {

$parcel$export(module.exports, "SiteInformationQuery", () => $e67eec7423072f68$export$e344c3770925712a);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $e67eec7423072f68$export$e344c3770925712a = (0, $d2LG0.default)`query SiteInformationQuery@SLA{tenant{shard cloudId environment activationId editions{edition}}organization{orgId}userForAnalytics:confluence_atlassianUser{id}user:confluence_atlassianUser(current:true){id displayName confluence{accessStatus accountId userKey locale}timeZone}getAIConfig(product:CONFLUENCE){isEnabled isRovoEnabled isRovoLLMEnabled}confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}timeZone}isSiteAdmin abTestCohorts experimentFeatures userCanCreateContent isNewUser siteSettings{homepage{uri title}siteTitle showApplicationTitle frontCover{frontCoverState}companyHubName}siteDescription{logoUrl}currentConfluenceUser{isAnonymous}}`;

});




parcelRegister("4VJDS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d209d7de5393726f$export$2e2bcd8739ae039);

var $cO8uZ = parcelRequire("cO8uZ");

var $c6GJD = parcelRequire("c6GJD");
class $d209d7de5393726f$var$StatsigConfigurations {
    static initializeFromValues(configCollectionValues) {
        this.configCollection = (0, $cO8uZ.ConfigCollection).fromValues(configCollectionValues);
        if ((0, $c6GJD.default).initializeCompleted()) $d209d7de5393726f$var$StatsigConfigurations.initializeOverrides();
    }
    static initializeOverrides() {
        const featureGateOverrides = (0, $c6GJD.default).getOverrides();
        this.configOverrides = Object.entries(featureGateOverrides.configs).reduce((overrideConfigs, [name, value])=>{
            // We currently use FeatureGates library for Statsig gate and experiment overrides.
            // Experiment overrides are stored in the same configs object, so we need to extract the
            // overrides for dynamic configs.
            if (Object.keys(value).length === 1 && value.hasOwnProperty('value')) overrideConfigs[name] = value;
            return overrideConfigs;
        }, {});
    }
    static getValueOrDefault(getFunction, configName, defaultVal) {
        if (this.configOverrides && Object.keys(this.configOverrides).length > 0) {
            const override = this.configOverrides[configName];
            if (override && typeof override.value === typeof defaultVal) return override.value;
        }
        if (!this.configCollection) return defaultVal;
        const configResult = getFunction.call(this.configCollection, configName);
        if (!configResult || 'error' in configResult || !('value' in configResult)) return defaultVal;
        return configResult.value;
    }
    static isKillSwitchOn(configName) {
        return this.getValueOrDefault(this.configCollection?.getBoolean, configName, false);
    }
    static getBoolean(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getBoolean, configName, defaultVal);
    }
    static getString(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getString, configName, defaultVal);
    }
    static getNumber(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getNumber, configName, defaultVal);
    }
    static getStringList(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getStringList, configName, defaultVal);
    }
    static getNumberList(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getNumberList, configName, defaultVal);
    }
}
/* eslint-disable import/no-default-export */ $d209d7de5393726f$var$StatsigConfigurations.configCollection = void 0;
$d209d7de5393726f$var$StatsigConfigurations.configOverrides = void 0;
var $d209d7de5393726f$export$2e2bcd8739ae039 = $d209d7de5393726f$var$StatsigConfigurations;

});
parcelRegister("cO8uZ", function(module, exports) {

$parcel$export(module.exports, "ConfigCollection", () => $acc48749799652be$export$2be5653e4dada0a3);

var $9JIG7 = parcelRequire("9JIG7");
class $acc48749799652be$export$f9c837a54db411d extends Error {
    constructor(message, cause){
        super(message), this.cause = cause;
    }
}
function $acc48749799652be$var$safeParse(json) {
    try {
        return {
            data: (0, $9JIG7.AnyConfigSchema).parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $acc48749799652be$export$f9c837a54db411d('An unknown error occurred during parsing', error)
        };
    }
}
class $acc48749799652be$export$2be5653e4dada0a3 {
    static fromValues(values, options) {
        const result = $acc48749799652be$var$safeParse(values);
        if (!result.success) {
            const parseError = new $acc48749799652be$export$f9c837a54db411d('Failed to deserialize config', result.error);
            if (options?.throw) throw parseError;
            // eslint-disable-next-line no-console
            console.error(parseError);
            return $acc48749799652be$export$2be5653e4dada0a3.empty();
        }
        return new $acc48749799652be$export$2be5653e4dada0a3(Array.isArray(result.data) ? (0, $9JIG7.minimalToMap)(result.data) : (0, $9JIG7.standardToMap)(result.data));
    }
    static empty() {
        return new $acc48749799652be$export$2be5653e4dada0a3(new Map());
    }
    toJson(format) {
        switch(format){
            case 'standard':
                return JSON.stringify((0, $9JIG7.mapToStandard)(this.config));
            case 'minimal':
                return JSON.stringify((0, $9JIG7.mapToMinimal)(this.config));
        }
    }
    getBoolean(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $9JIG7.ConfigError).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'boolean') return {
            error: (0, $9JIG7.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getString(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $9JIG7.ConfigError).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'string') return {
            error: (0, $9JIG7.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumber(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $9JIG7.ConfigError).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'number') return {
            error: (0, $9JIG7.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getStringList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $9JIG7.ConfigError).NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === 'string')) return {
            error: (0, $9JIG7.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumberList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $9JIG7.ConfigError).NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === 'number')) return {
            error: (0, $9JIG7.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    constructor(config){
        this.config = config;
    }
}

});
parcelRegister("9JIG7", function(module, exports) {

$parcel$export(module.exports, "ConfigError", () => $395103940609b8b3$export$c5fb415882705cf4);
$parcel$export(module.exports, "AnyConfigSchema", () => $395103940609b8b3$export$960d45de79bd7d81);
$parcel$export(module.exports, "minimalToMap", () => $395103940609b8b3$export$c29ba52779f58587);
$parcel$export(module.exports, "standardToMap", () => $395103940609b8b3$export$be5b69ecb011d7cc);
$parcel$export(module.exports, "mapToMinimal", () => $395103940609b8b3$export$460f06addafd9f86);
$parcel$export(module.exports, "mapToStandard", () => $395103940609b8b3$export$9d0101ad8235e092);

var $2ci8P = parcelRequire("2ci8P");
var $395103940609b8b3$export$c5fb415882705cf4 = /*#__PURE__*/ function(ConfigError) {
    ConfigError["NotFound"] = "not_found";
    ConfigError["InvalidState"] = "state_invalid";
    ConfigError["IncorrectType"] = "incorrect_type";
    return ConfigError;
}({});
const $395103940609b8b3$export$e94ee64b2671e155 = (0, $2ci8P.z).record((0, $2ci8P.z).string(), (0, $2ci8P.z).object({
    value: (0, $2ci8P.z).union([
        (0, $2ci8P.z).boolean(),
        (0, $2ci8P.z).string(),
        (0, $2ci8P.z).number(),
        (0, $2ci8P.z).string().array(),
        (0, $2ci8P.z).number().array()
    ])
}));
const $395103940609b8b3$export$e38f7b10db0e126a = (0, $2ci8P.z).tuple([
    // list of boolean configs which are on
    (0, $2ci8P.z).string().array(),
    // list of string config tuples
    (0, $2ci8P.z).array((0, $2ci8P.z).string()).refine((arr)=>arr.length % 2 === 0),
    // list of number config tuples
    (0, $2ci8P.z).array((0, $2ci8P.z).union([
        (0, $2ci8P.z).string(),
        (0, $2ci8P.z).number()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== 'string') return false;
            if (typeof arr[i + 1] !== 'number') return false;
        }
        return true;
    }),
    // list of string list config tuples
    (0, $2ci8P.z).array((0, $2ci8P.z).union([
        (0, $2ci8P.z).string(),
        (0, $2ci8P.z).string().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === 'string')) return false;
        }
        return true;
    }),
    // list of number list config tuples
    (0, $2ci8P.z).array((0, $2ci8P.z).union([
        (0, $2ci8P.z).string(),
        (0, $2ci8P.z).number().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === 'number')) return false;
        }
        return true;
    })
]);
const $395103940609b8b3$export$960d45de79bd7d81 = (0, $2ci8P.z).union([
    $395103940609b8b3$export$e94ee64b2671e155,
    $395103940609b8b3$export$e38f7b10db0e126a
]);
const $395103940609b8b3$export$ac2e9c88ba5d7cbb = (0, $2ci8P.z).map((0, $2ci8P.z).string(), (0, $2ci8P.z).object({
    value: (0, $2ci8P.z).union([
        (0, $2ci8P.z).boolean(),
        (0, $2ci8P.z).string(),
        (0, $2ci8P.z).number(),
        (0, $2ci8P.z).string().array(),
        (0, $2ci8P.z).number().array()
    ])
}));
function $395103940609b8b3$var$pairs(arr, fn) {
    for(let i = 0; i < arr.length; i += 2){
        const key = arr[i];
        const val = arr[i + 1];
        if (typeof key !== 'string') throw new Error(`Expected a string while iterating pairs, got: ${arr[i]}`);
        fn(key, val);
    }
}
function $395103940609b8b3$export$c29ba52779f58587(minimal) {
    const map = new Map();
    minimal[0].forEach((boolean)=>map.set(boolean, {
            value: true
        }));
    $395103940609b8b3$var$pairs(minimal[1], (a, b)=>map.set(a, {
            value: b
        }));
    $395103940609b8b3$var$pairs(minimal[2], (a, b)=>map.set(a, {
            value: b
        }));
    $395103940609b8b3$var$pairs(minimal[3], (a, b)=>map.set(a, {
            value: b
        }));
    $395103940609b8b3$var$pairs(minimal[4], (a, b)=>map.set(a, {
            value: b
        }));
    return map;
}
function $395103940609b8b3$export$be5b69ecb011d7cc(standard) {
    const map = new Map();
    Object.entries(standard).forEach(([key, value])=>map.set(key, value));
    return map;
}
function $395103940609b8b3$export$460f06addafd9f86(map) {
    const minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    for (const [key, { value: value }] of map.entries())switch(typeof value){
        case 'boolean':
            if (value) minimal[0].push(key);
            break;
        case 'string':
            minimal[1].push(key, value);
            break;
        case 'number':
            minimal[2].push(key, value);
            break;
        default:
            if (!Array.isArray(value)) throw new Error(`Unexpected configuration value: ${value}`);
            const allStrings = value.every((x)=>typeof x === 'string');
            if (allStrings) {
                minimal[3].push(key, value);
                break;
            }
            const allNumbers = value.every((x)=>typeof x === 'number');
            if (allNumbers) {
                minimal[4].push(key, value);
                break;
            }
            throw new Error(`Unexpected configuration value: ${value}`);
    }
    return minimal;
}
function $395103940609b8b3$export$9d0101ad8235e092(map) {
    return Object.fromEntries(map.entries());
}

});



parcelRegister("6VdZc", function(module, exports) {

$parcel$export(module.exports, "browserMetricsState", () => $395744933753531e$export$cae3e50f876b8cc);
$parcel$export(module.exports, "isInitial", () => $395744933753531e$export$5700203954193e40);
const $395744933753531e$export$cae3e50f876b8cc = {
    transitionId: 0,
    pageLoadStartTimestamp: 0,
    routeName: null,
    previousRoute: null,
    startTimes: {},
    previousContentId: null,
    contentId: null
};
const $395744933753531e$export$5700203954193e40 = ()=>$395744933753531e$export$cae3e50f876b8cc.transitionId === 0;

});

parcelRegister("e9zUf", function(module, exports) {

$parcel$export(module.exports, "confluenceLocalStorageInstance", () => $084441766924685c$export$7691d7c35a352a10);
$parcel$export(module.exports, "confluenceSessionStorageInstance", () => $084441766924685c$export$fb051bd2501e65b3);
$parcel$export(module.exports, "initializeStorageManager", () => $084441766924685c$export$68017d60ff81319c);
$parcel$export(module.exports, "getRemoteLocalStorage", () => (parcelRequire("i6sMX")).getRemoteLocalStorage);

var $c4TO3 = parcelRequire("c4TO3");

var $9wGTI = parcelRequire("9wGTI");

var $5MeCb = parcelRequire("5MeCb");

var $fPYum = parcelRequire("fPYum");


var $i6sMX = parcelRequire("i6sMX");

var $1UApO = parcelRequire("1UApO");

var $blhvm = parcelRequire("blhvm");
// check if local and session storage are valid
const $084441766924685c$var$isStorageValid = (storage)=>{
    try {
        return typeof storage !== 'undefined' && 'setItem' in storage && // in IE8 typeof localStorage.setItem === 'object'
        !!storage.setItem;
    } catch (e) {
        return false;
    }
};
const $084441766924685c$var$getStorage = (type)=>{
    if (typeof window === 'object' && $084441766924685c$var$isStorageValid(window[type])) return window[type];
    return null;
};
let $084441766924685c$export$7691d7c35a352a10;
let $084441766924685c$export$fb051bd2501e65b3;
const $084441766924685c$export$68017d60ff81319c = async (initializationData)=>{
    let confluenceLocalStorage = null;
    let confluenceSessionStorage = null;
    if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) {
        confluenceLocalStorage = (0, $c4TO3.AtlBrowserStorageLocal);
        confluenceSessionStorage = (0, $c4TO3.AtlBrowserStorageSession);
    } else {
        confluenceLocalStorage = $084441766924685c$var$getStorage('localStorage');
        confluenceSessionStorage = $084441766924685c$var$getStorage('sessionStorage');
    }
    $084441766924685c$export$7691d7c35a352a10 = new (0, $5MeCb.StorageManager)(confluenceLocalStorage, (0, $fPYum.STORAGE_MANAGER_PREFIX), (0, $fPYum.STORAGE_MANAGER_ID), (0, $fPYum.LOCAL_STORAGE_MANAGER), initializationData);
    $084441766924685c$export$fb051bd2501e65b3 = new (0, $5MeCb.StorageManager)(confluenceSessionStorage, (0, $fPYum.STORAGE_MANAGER_PREFIX), (0, $fPYum.STORAGE_MANAGER_ID), (0, $fPYum.SESSION_STORAGE_MANAGER), initializationData);
    const result = await (0, $i6sMX.getRemoteLocalStorage)(initializationData);
    if (result) $084441766924685c$export$7691d7c35a352a10.initializeFromServer(result);
};

});
parcelRegister("c4TO3", function(module, exports) {

$parcel$export(module.exports, "AtlBrowserStorageLocal", () => $eb1e45e810a4d372$export$c8cc3ffd3f2c1d2f);
$parcel$export(module.exports, "AtlBrowserStorageSession", () => $eb1e45e810a4d372$export$edbae459bdf957a5);
$parcel$export(module.exports, "findStorageTarget", () => $eb1e45e810a4d372$export$14921bfc334334c0);
$parcel$export(module.exports, "WebStorageType", () => (parcelRequire("hohxW")).WebStorageType);

var $2i8PW = parcelRequire("2i8PW");
var $kfwMJ = parcelRequire("kfwMJ");

var $6ZgEd = parcelRequire("6ZgEd");

var $ccRXO = parcelRequire("ccRXO");

var $8oAcs = parcelRequire("8oAcs");

var $hohxW = parcelRequire("hohxW");

var $9mMcH = parcelRequire("9mMcH");
var $6fFVU = parcelRequire("6fFVU");
var $uh7ZL = parcelRequire("uh7ZL");
class $eb1e45e810a4d372$export$8e4a3cf07a10930b {
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStoragedEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $2i8PW.getBscGlobalState)().webStorageEnabled) return true;
        (0, $6ZgEd.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $6ZgEd.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $9mMcH.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $6ZgEd.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return;
        }
        const globalStateProduct = (0, $2i8PW.getBscGlobalState)().product;
        const itemSetStatus = await (0, $6fFVU.setStorageItem)(key, value, this.storageType, globalStateProduct, this.storage);
        (0, $6ZgEd.Logger).debug(`${itemSetStatus === (0, $ccRXO.Status).SUCCESS ? 'Successfully' : 'Failed to'} set item ${key} with value ${value}`);
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $6ZgEd.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $uh7ZL.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        (0, $6ZgEd.Logger).debug(`${itemSetStatus === (0, $ccRXO.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $6ZgEd.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $kfwMJ.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
    constructor(storage, storageType){
        this.storage = void 0;
        this.storageType = void 0;
        this.isAvailable = false;
        this.checkIfSetByPackage = async ({ itemKey: itemKey, isSetCallback: isSetCallback = ()=>{}, isNotSetCallback: isNotSetCallback = ()=>{} })=>{
            // As IDB is asynchronous in nature, when this in invoked, we need to rely on the callbacks
            // to actually do something with the result.
            try {
                const record = await (0, $8oAcs.BSCIndexedDB).getRecord(itemKey);
                if (record) {
                    isSetCallback();
                    return true;
                } else {
                    isNotSetCallback();
                    return false;
                }
            } catch (e) {
                // If it fails to pull from IDB, we can't validate that it's been set by our package or not, so log the error
                // and assume it hasn't been set by our package. This will only impact our analytics correctness.
                (0, $6ZgEd.Logger).errorWithOperationalEvent({
                    action: 'usedCheckIfSetByPackageError',
                    message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                    attributes: {
                        itemKey: itemKey
                    }
                });
                isNotSetCallback();
                return false;
            }
        };
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
}
const $eb1e45e810a4d372$export$c8cc3ffd3f2c1d2f = new $eb1e45e810a4d372$export$8e4a3cf07a10930b(window?.localStorage, (0, $hohxW.WebStorageType).LocalStorage);
const $eb1e45e810a4d372$export$edbae459bdf957a5 = new $eb1e45e810a4d372$export$8e4a3cf07a10930b(window?.sessionStorage, (0, $hohxW.WebStorageType).SessionStorage);
const $eb1e45e810a4d372$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $hohxW.WebStorageType).LocalStorage]: $eb1e45e810a4d372$export$c8cc3ffd3f2c1d2f,
        [(0, $hohxW.WebStorageType).SessionStorage]: $eb1e45e810a4d372$export$edbae459bdf957a5
    })[type];
};

});
parcelRegister("2i8PW", function(module, exports) {

$parcel$export(module.exports, "getBscGlobalState", () => $d0f80ab9024add60$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "initializeGlobalState", () => $d0f80ab9024add60$export$882c4530c58781d8);

var $7g5Pn = parcelRequire("7g5Pn");

var $dh538 = parcelRequire("dh538");

var $ccRXO = parcelRequire("ccRXO");

var $3Tbv0 = parcelRequire("3Tbv0");

var $6ZgEd = parcelRequire("6ZgEd");
let $d0f80ab9024add60$var$analyticsEnabledGlobalState;
let $d0f80ab9024add60$var$productGlobalState;
let $d0f80ab9024add60$var$webStorageControlsEnabledGlobalState;
let $d0f80ab9024add60$var$localConsentModeGlobalState;
let $d0f80ab9024add60$var$packageDebugModeEnabledGlobalState;
let $d0f80ab9024add60$var$allowUncategorizedCookiesInOverridesGlobalState;
let $d0f80ab9024add60$var$hasInitialized = false;
let $d0f80ab9024add60$var$cookiesCacheLoader;
let $d0f80ab9024add60$var$localStorageCacheLoader;
let $d0f80ab9024add60$var$sessionStorageCacheLoader;
let $d0f80ab9024add60$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $ccRXO.CategoryStorageType).Cookies:
            return await $d0f80ab9024add60$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $ccRXO.CategoryStorageType).LocalStorage:
            return await $d0f80ab9024add60$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $ccRXO.CategoryStorageType).SessionStorage:
            return await $d0f80ab9024add60$var$sessionStorageCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $d0f80ab9024add60$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $d0f80ab9024add60$var$analyticsEnabledGlobalState ?? true,
        product: $d0f80ab9024add60$var$productGlobalState,
        webStorageEnabled: $d0f80ab9024add60$var$webStorageControlsEnabledGlobalState ?? false,
        localConsentMode: $d0f80ab9024add60$var$localConsentModeGlobalState ?? false,
        packageDebugMode: $d0f80ab9024add60$var$packageDebugModeEnabledGlobalState,
        allowUncategorizedCookiesInOverrides: $d0f80ab9024add60$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        cookiesCacheLoader: $d0f80ab9024add60$var$cookiesCacheLoader,
        localStorageCacheLoader: $d0f80ab9024add60$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $d0f80ab9024add60$var$sessionStorageCacheLoader,
        loadCache: $d0f80ab9024add60$var$loadCache,
        hasInitialized: $d0f80ab9024add60$var$hasInitialized
    };
};
const $d0f80ab9024add60$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, localConsentMode: localConsentMode = false, product: product = 'all', analyticsEnabled: analyticsEnabled = true } = {})=>{
    (0, $6ZgEd.Logger).debug('Initialize global state invoked');
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!$d0f80ab9024add60$var$productGlobalState || $d0f80ab9024add60$var$productGlobalState == null || $d0f80ab9024add60$var$productGlobalState === 'all') && product) $d0f80ab9024add60$var$productGlobalState = product;
    // Treating webStorageEnabled and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    if (webStorageEnabled !== undefined && $d0f80ab9024add60$var$webStorageControlsEnabledGlobalState === undefined) $d0f80ab9024add60$var$webStorageControlsEnabledGlobalState = webStorageEnabled && !(0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $dh538.fg)('platform_moonjelly_bsc_web_storage_killswitch');
    if (allowUncategorizedCookiesInOverrides !== undefined && $d0f80ab9024add60$var$allowUncategorizedCookiesInOverridesGlobalState === undefined) $d0f80ab9024add60$var$allowUncategorizedCookiesInOverridesGlobalState = allowUncategorizedCookiesInOverrides;
    // All other state can only be initialized once and is defaulted if not passed on the first initialization
    if ($d0f80ab9024add60$var$hasInitialized) return;
    $d0f80ab9024add60$var$localConsentModeGlobalState = localConsentMode;
    $d0f80ab9024add60$var$analyticsEnabledGlobalState = analyticsEnabled;
    $d0f80ab9024add60$var$cookiesCacheLoader = new (0, $3Tbv0.CacheLoader)((0, $ccRXO.CategoryStorageType).Cookies);
    $d0f80ab9024add60$var$localStorageCacheLoader = new (0, $3Tbv0.CacheLoader)((0, $ccRXO.CategoryStorageType).LocalStorage);
    $d0f80ab9024add60$var$sessionStorageCacheLoader = new (0, $3Tbv0.CacheLoader)((0, $ccRXO.CategoryStorageType).SessionStorage);
    if ((0, $dh538.fg)('platform_moonjelly_bsc_debug_mode')) $d0f80ab9024add60$var$packageDebugModeEnabledGlobalState = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).get('atl-bsc-debug-mode'));
    $d0f80ab9024add60$var$hasInitialized = true;
};
const $d0f80ab9024add60$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, product: overrideProduct })=>{
    if (overrideLoadCache) $d0f80ab9024add60$var$loadCache = overrideLoadCache;
    if (overrideProduct) $d0f80ab9024add60$var$productGlobalState = overrideProduct;
};
const $d0f80ab9024add60$export$ac7c2edd09656c05 = ()=>{
    $d0f80ab9024add60$var$analyticsEnabledGlobalState = undefined;
    $d0f80ab9024add60$var$productGlobalState = undefined;
    $d0f80ab9024add60$var$webStorageControlsEnabledGlobalState = undefined;
    $d0f80ab9024add60$var$localConsentModeGlobalState = undefined;
    $d0f80ab9024add60$var$packageDebugModeEnabledGlobalState = undefined;
    $d0f80ab9024add60$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $d0f80ab9024add60$var$cookiesCacheLoader = undefined;
    $d0f80ab9024add60$var$localStorageCacheLoader = undefined;
    $d0f80ab9024add60$var$sessionStorageCacheLoader = undefined;
    $d0f80ab9024add60$var$hasInitialized = false;
};

});
parcelRegister("ccRXO", function(module, exports) {

$parcel$export(module.exports, "PreferenceCategory", () => $5f54433b8b296b64$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $5f54433b8b296b64$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $5f54433b8b296b64$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $5f54433b8b296b64$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $5f54433b8b296b64$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $5f54433b8b296b64$export$96e9906d6d93a972);
var $5f54433b8b296b64$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $5f54433b8b296b64$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $5f54433b8b296b64$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $5f54433b8b296b64$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $5f54433b8b296b64$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $5f54433b8b296b64$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    return CategoryStorageType;
}({});
var $5f54433b8b296b64$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});
var $5f54433b8b296b64$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});

parcelRegister("3Tbv0", function(module, exports) {

$parcel$export(module.exports, "CacheLoader", () => $ee0817fc7043f39c$export$e479342c697b82a9);

var $ccRXO = parcelRequire("ccRXO");

var $6ZgEd = parcelRequire("6ZgEd");

var $iL7bG = parcelRequire("iL7bG");
class $ee0817fc7043f39c$export$e479342c697b82a9 {
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
   * Unpacks the response promise from the categories CDN
   *
   * errors if that request was unsuccessful, returns the categories data otherwise
   *
   */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
        return this.localResponseJsonPromiseCache;
    }
    async loadStorageControlsData() {
        if (this.localResponseCache) return this.localResponseCache;
        else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $6ZgEd.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            return this.localResponseCache;
        } catch (e) {
            (0, $6ZgEd.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
    constructor(storageType){
        this.cacheUrl = void 0;
        /**
     * Cache variable for storing categorized cookies cache
     */ this.localResponseCache = void 0;
        /**
     * Cache variable for storing a promise that's been fired by a different invocation of loadStorageControls
     *
     * Allows for many invocations to happen simultaneously, and for only one fetch to go out
     */ this.localResponsePromiseCache = void 0;
        /**
     * Cache variable for storing the promise returned from the response object's json method
     *
     * Ensures we don't invoke response.json multiple times
     */ this.localResponseJsonPromiseCache = void 0;
        switch(storageType){
            case (0, $ccRXO.CategoryStorageType).Cookies:
                this.cacheUrl = (0, $iL7bG.COOKIE_CACHE_URL_PROD);
                break;
            case (0, $ccRXO.CategoryStorageType).LocalStorage:
                this.cacheUrl = (0, $iL7bG.LOCAL_STORAGE_CACHE_URL_PROD);
                break;
            case (0, $ccRXO.CategoryStorageType).SessionStorage:
                this.cacheUrl = (0, $iL7bG.SESSION_STORAGE_CACHE_URL_PROD);
                break;
            default:
                this.cacheUrl = (0, $iL7bG.LEGACY_COOKIE_CACHE_URL_PROD);
        }
    }
}

});
parcelRegister("6ZgEd", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $db6c09c54436b4b9$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $dh538 = parcelRequire("dh538");

var $c5a0x = parcelRequire("c5a0x");

var $2i8PW = parcelRequire("2i8PW");
const $db6c09c54436b4b9$var$LOG_PREFIX = '[browser-storage-controls]';
class $db6c09c54436b4b9$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${$db6c09c54436b4b9$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${$db6c09c54436b4b9$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            (0, $c5a0x.sendPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${$db6c09c54436b4b9$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    /**
   * Logger for additional debugging of the package. Debug logs are only sent when the
   * atl-bsc-debug-mode cookie is set on the browser. This is evaluated via global state
   */ static debug(message, metadata) {
        if ((0, $2i8PW.getBscGlobalState)().packageDebugMode && (0, $dh538.fg)('platform_moonjelly_bsc_debug_mode')) console.debug(`${$db6c09c54436b4b9$var$LOG_PREFIX}: DEBUG ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}

});
parcelRegister("c5a0x", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", () => $b83574581275e153$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $b83574581275e153$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUIEvent", () => $b83574581275e153$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $b83574581275e153$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $b83574581275e153$export$1ba525b8a711eaac);

var $a9sR2 = parcelRequire("a9sR2");
var $5DUgU = parcelRequire("5DUgU");

var $2i8PW = parcelRequire("2i8PW");

var $6ZgEd = parcelRequire("6ZgEd");

var $eFVEk = parcelRequire("eFVEk");

var $esXRu = parcelRequire("esXRu");
const $b83574581275e153$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.')) return (0, $5DUgU.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $5DUgU.envType).DEV;
    return (0, $5DUgU.envType).PROD;
};
const $b83574581275e153$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $b83574581275e153$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $b83574581275e153$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $b83574581275e153$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $b83574581275e153$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $b83574581275e153$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $b83574581275e153$export$fce3dd735e04d566();
    return {
        packageName: $eFVEk.packageName,
        packageVersion: $eFVEk.packageVersion,
        domain: domain,
        product: (0, $2i8PW.getBscGlobalState)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $b83574581275e153$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $2i8PW.getBscGlobalState)().analyticsEnabled) instance = new (0, $a9sR2.default)({
                env: $b83574581275e153$var$getEnvironment(),
                product: 'atlassianCookies'
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $6ZgEd.Logger).error(`Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $2i8PW.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $b83574581275e153$export$5bfe55348e7aebc1(properties) {
    (0, $esXRu.withAnalyticsEventSampling)(properties.action, ()=>$b83574581275e153$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $b83574581275e153$var$decorateEventAttributes(properties.attributes)
        }));
}
function $b83574581275e153$export$1aecf263098db667(properties) {
    $b83574581275e153$export$fde53e78fd93a54d()?.sendUIEvent({
        ...properties,
        attributes: $b83574581275e153$var$decorateEventAttributes(properties.attributes)
    });
}
function $b83574581275e153$export$22a3b1671f38a193(properties) {
    $b83574581275e153$export$fde53e78fd93a54d()?.sendScreenEvent({
        ...properties,
        attributes: $b83574581275e153$var$decorateEventAttributes(properties.attributes)
    });
}
function $b83574581275e153$export$1ba525b8a711eaac(properties) {
    $b83574581275e153$export$fde53e78fd93a54d()?.sendTrackEvent({
        ...properties,
        attributes: $b83574581275e153$var$decorateEventAttributes(properties.attributes)
    });
}

});
parcelRegister("eFVEk", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $85089a659aa0f6a0$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $85089a659aa0f6a0$export$91546b032799aa40);

var $3mTvL = parcelRequire("3mTvL");
const $85089a659aa0f6a0$export$9345d7360ffe0722 = $3mTvL?.env._PACKAGE_NAME_ ?? '';
const $85089a659aa0f6a0$export$91546b032799aa40 = $3mTvL?.env._PACKAGE_VERSION_ ?? '';

});

parcelRegister("esXRu", function(module, exports) {

$parcel$export(module.exports, "withAnalyticsEventSampling", () => $769f0e6f7d98c46f$export$67b6e87f323cb6ad);

var $ccRXO = parcelRequire("ccRXO");

var $2i8PW = parcelRequire("2i8PW");

var $h1urf = parcelRequire("h1urf");

var $kfwMJ = parcelRequire("kfwMJ");
const $769f0e6f7d98c46f$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $769f0e6f7d98c46f$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $769f0e6f7d98c46f$var$loadSamplingConfig() {
    if ((0, $h1urf.cache).cachedSamplingConfig) return (0, $h1urf.cache).cachedSamplingConfig;
    if ((0, $kfwMJ.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $2i8PW.getBscGlobalState)();
    const controlsData = await loadCache((0, $ccRXO.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $h1urf.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $769f0e6f7d98c46f$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($769f0e6f7d98c46f$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $769f0e6f7d98c46f$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $769f0e6f7d98c46f$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $769f0e6f7d98c46f$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $769f0e6f7d98c46f$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $769f0e6f7d98c46f$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $769f0e6f7d98c46f$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $769f0e6f7d98c46f$export$b286f5e8716d11ad(analyticsEventKey);
    $769f0e6f7d98c46f$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("h1urf", function(module, exports) {

$parcel$export(module.exports, "cache", () => $2fa9fd5c1c6e215e$export$69a3209f1a06c04d);

var $5l1Ri = parcelRequire("5l1Ri");
const $2fa9fd5c1c6e215e$export$69a3209f1a06c04d = new (0, $5l1Ri.CachedSamplingConfig)();

});
parcelRegister("5l1Ri", function(module, exports) {

$parcel$export(module.exports, "CachedSamplingConfig", () => $be56294e3642020b$export$b886edaf6623554a);
class $be56294e3642020b$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
    constructor(){
        this.cache = void 0;
    }
}

});


parcelRegister("kfwMJ", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $655e54454efd9c73$export$48d7c418edadb60c);

var $a9sR2 = parcelRequire("a9sR2");

var $dh538 = parcelRequire("dh538");

var $6ZgEd = parcelRequire("6ZgEd");
const $655e54454efd9c73$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $dh538.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $a9sR2.default));
    // When rendering from the server document/window may not be available
    if (isMissingNecessaryBrowserUtils) (0, $6ZgEd.Logger).warn('Browser context is not available.');
    if (isMissingBooleanFF) (0, $6ZgEd.Logger).warn('Platform Feature Flag library is not available');
    if (!(0, $a9sR2.default)) (0, $6ZgEd.Logger).warn('analytics-web-client is not available');
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});




parcelRegister("iL7bG", function(module, exports) {

$parcel$export(module.exports, "LEGACY_COOKIE_CACHE_URL_PROD", () => $4c43fb9fb9da63bb$export$194c34963e6f0bc6);
$parcel$export(module.exports, "COOKIE_CACHE_URL_PROD", () => $4c43fb9fb9da63bb$export$ab0619f627170401);
$parcel$export(module.exports, "LOCAL_STORAGE_CACHE_URL_PROD", () => $4c43fb9fb9da63bb$export$38bed9fd9923fef3);
$parcel$export(module.exports, "SESSION_STORAGE_CACHE_URL_PROD", () => $4c43fb9fb9da63bb$export$4f73a4b5fdb7ed6c);
const $4c43fb9fb9da63bb$export$194c34963e6f0bc6 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
const $4c43fb9fb9da63bb$export$ab0619f627170401 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_COOKIE.json';
const $4c43fb9fb9da63bb$export$38bed9fd9923fef3 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json';
const $4c43fb9fb9da63bb$export$4f73a4b5fdb7ed6c = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_SESSION_STORAGE.json';

});



parcelRegister("8oAcs", function(module, exports) {

$parcel$export(module.exports, "BSCIndexedDB", () => $cb97cb9e1f37d0e0$export$36328b3bcbe4623a);

var $kfwMJ = parcelRequire("kfwMJ");

var $6ZgEd = parcelRequire("6ZgEd");
class $cb97cb9e1f37d0e0$export$fde2a4e0e57f47e {
    async boot() {
        if (!this.isAvailable) {
            (0, $6ZgEd.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $6ZgEd.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $kfwMJ.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        return new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $6ZgEd.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $6ZgEd.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
    constructor(dbName, storeName){
        this.dbName = void 0;
        this.storeName = void 0;
        this.bootUpPromiseCache = void 0;
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $6ZgEd.Logger).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $6ZgEd.Logger).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $6ZgEd.Logger).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
}
const $cb97cb9e1f37d0e0$export$36328b3bcbe4623a = new $cb97cb9e1f37d0e0$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');

});

parcelRegister("hohxW", function(module, exports) {

$parcel$export(module.exports, "WebStorageType", () => $63afadb48eb6c49e$export$259e3a861f28589b);
var $63afadb48eb6c49e$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});

});

parcelRegister("9mMcH", function(module, exports) {

$parcel$export(module.exports, "getStorageItem", () => $bbae81025aa9741c$export$e612bb1301d659de);

var $c5a0x = parcelRequire("c5a0x");

var $6ZgEd = parcelRequire("6ZgEd");
const $bbae81025aa9741c$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

});

parcelRegister("6fFVU", function(module, exports) {

$parcel$export(module.exports, "setStorageItem", () => $b351bf29be3f52e2$export$5ee8760f703d9d62);

var $c5a0x = parcelRequire("c5a0x");

var $6RSiP = parcelRequire("6RSiP");

var $6ZgEd = parcelRequire("6ZgEd");

var $8oAcs = parcelRequire("8oAcs");

var $ccRXO = parcelRequire("ccRXO");

var $hohxW = parcelRequire("hohxW");
const $b351bf29be3f52e2$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    // user belongs to an org that opted into cookies management and we should respect their preferences
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetItem = await (0, $6RSiP.isProcessingAllowedByPreferences)({
        itemKey: itemKey,
        storageType: storageType === (0, $hohxW.WebStorageType).LocalStorage ? (0, $ccRXO.CategoryStorageType).LocalStorage : (0, $ccRXO.CategoryStorageType).SessionStorage,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // Store the item as a record in our IDB service to track that we've seen it before.
            // That way, when we can confirm/deny that this has been set by our service when we check again.
            // If it fails for some reason, it will be caught before actually setting the item
            await (0, $8oAcs.BSCIndexedDB).setRecord(itemKey);
            browserStorage.setItem(itemKey, value);
            return (0, $ccRXO.Status).SUCCESS;
        } else return (0, $ccRXO.Status).BLOCKED;
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetItemError',
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`
        });
        return (0, $ccRXO.Status).BLOCKED;
    }
};

});
parcelRegister("6RSiP", function(module, exports) {

$parcel$export(module.exports, "isProcessingAllowedByPreferences", () => $1a7ba0e7c7adf589$export$e7a3dca206fec6e2);
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

var $7MEbC = parcelRequire("7MEbC");

var $ccRXO = parcelRequire("ccRXO");

var $2i8PW = parcelRequire("2i8PW");
const $1a7ba0e7c7adf589$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $1a7ba0e7c7adf589$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $1a7ba0e7c7adf589$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName?.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    const productStartsWithPatterns = {
        ...patterns.startsWith['all'],
        ...downcasedProduct ? patterns.startsWith[downcasedProduct] : {}
    };
    const productEndsWithPatterns = {
        ...patterns.endsWith['all'],
        ...downcasedProduct ? patterns.endsWith[downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else {
        // Find pattern match or null
        itemCategoryNumber = $1a7ba0e7c7adf589$export$2c141b1c00f3e482(itemKey, productStartsWithPatterns);
        if (itemCategoryNumber === null) itemCategoryNumber = $1a7ba0e7c7adf589$export$c4a1dd71bbd8954c(itemKey, productEndsWithPatterns);
    }
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $ccRXO.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $ccRXO.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $ccRXO.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $ccRXO.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $ccRXO.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
const $1a7ba0e7c7adf589$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $2i8PW.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $1a7ba0e7c7adf589$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $1a7ba0e7c7adf589$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName })=>{
    let shouldProcessItem;
    const itemCategory = await $1a7ba0e7c7adf589$export$ec8ce5237293e4a4(itemKey, storageType, productName);
    if (itemCategory === (0, $ccRXO.PreferenceCategory).StrictlyNecessary) shouldProcessItem = true;
    else {
        const preferences = await (0, $7MEbC.getPreferences)();
        let hasPreferencesForCategory = false;
        if (!!preferences) {
            if (!!itemCategory) hasPreferencesForCategory = preferences[itemCategory];
        }
        shouldProcessItem = hasPreferencesForCategory;
    }
    if (shouldProcessItem) allowedCallback?.();
    else blockedCallback?.({
        itemHasCategory: itemCategory != null
    });
    return shouldProcessItem;
};

});
parcelRegister("7MEbC", function(module, exports) {

$parcel$export(module.exports, "getPreferences", () => $ae6e4777014e490b$export$1de6a888ae076ff8);

var $2i8PW = parcelRequire("2i8PW");
var $kfwMJ = parcelRequire("kfwMJ");

var $301rJ = parcelRequire("301rJ");

var $6Dx3l = parcelRequire("6Dx3l");

var $hEbxW = parcelRequire("hEbxW");

var $6gmJj = parcelRequire("6gmJj");
async function $ae6e4777014e490b$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $2i8PW.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $hEbxW.getCookie)((0, $301rJ.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $6gmJj.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $hEbxW.getCookie)((0, $301rJ.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $6Dx3l.getConsentToken)();
            if ((0, $kfwMJ.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $6gmJj.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $6gmJj.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

});
parcelRegister("301rJ", function(module, exports) {

$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $40c7c2c8d2a7c49c$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $40c7c2c8d2a7c49c$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $40c7c2c8d2a7c49c$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $40c7c2c8d2a7c49c$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $40c7c2c8d2a7c49c$export$37073d560ecebada);
$parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", () => $40c7c2c8d2a7c49c$export$5dc0026db06844f3);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $40c7c2c8d2a7c49c$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $40c7c2c8d2a7c49c$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $40c7c2c8d2a7c49c$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $40c7c2c8d2a7c49c$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $40c7c2c8d2a7c49c$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $40c7c2c8d2a7c49c$export$31deaeaebce525bb);

var $ccRXO = parcelRequire("ccRXO");
const $40c7c2c8d2a7c49c$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $40c7c2c8d2a7c49c$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $40c7c2c8d2a7c49c$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $40c7c2c8d2a7c49c$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $40c7c2c8d2a7c49c$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $40c7c2c8d2a7c49c$export$37073d560ecebada = 'atl-testing-consents';
const $40c7c2c8d2a7c49c$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $40c7c2c8d2a7c49c$export$b28b5d760fe14a21 = {
    [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $ccRXO.PreferenceCategory).Functional]: true,
    [(0, $ccRXO.PreferenceCategory).Marketing]: true,
    [(0, $ccRXO.PreferenceCategory).Analytics]: true,
    [(0, $ccRXO.PreferenceCategory).Unknown]: true // Includes uncategorized cookies
};
const $40c7c2c8d2a7c49c$export$4a12f9e99971760a = {
    [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $ccRXO.PreferenceCategory).Functional]: false,
    [(0, $ccRXO.PreferenceCategory).Marketing]: false,
    [(0, $ccRXO.PreferenceCategory).Analytics]: false,
    [(0, $ccRXO.PreferenceCategory).Unknown]: false
};
const $40c7c2c8d2a7c49c$export$f0fd1d13ec1d48f2 = {
    ...$40c7c2c8d2a7c49c$export$4a12f9e99971760a,
    [(0, $ccRXO.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $40c7c2c8d2a7c49c$export$f95182b7aa141c57 = '001';
const $40c7c2c8d2a7c49c$export$1f25427b34f9c405 = '002';
const $40c7c2c8d2a7c49c$export$31deaeaebce525bb = '003';

});

parcelRegister("6Dx3l", function(module, exports) {

$parcel$export(module.exports, "getConsentToken", () => $a3f302f220b048aa$export$f1b8f2ca713fca08);

var $301rJ = parcelRequire("301rJ");

var $hEbxW = parcelRequire("hEbxW");

var $kQGVz = parcelRequire("kQGVz");

var $iUc7J = parcelRequire("iUc7J");

var $1uqEa = parcelRequire("1uqEa");
const $a3f302f220b048aa$export$f1b8f2ca713fca08 = async ()=>{
    const fallbackConsentToken = (0, $hEbxW.getCookie)((0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $1uqEa.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $kQGVz.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $hEbxW.getCookie)((0, $301rJ.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $iUc7J.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $iUc7J.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $iUc7J.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};

});
parcelRegister("hEbxW", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $8e95c28822451851$export$4be65e66cfa2648a);

var $7g5Pn = parcelRequire("7g5Pn");

var $dh538 = parcelRequire("dh538");

var $c5a0x = parcelRequire("c5a0x");

var $6ZgEd = parcelRequire("6ZgEd");
function $8e95c28822451851$export$4be65e66cfa2648a(key) {
    if ((0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).get();
    try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).get();
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});

parcelRegister("kQGVz", function(module, exports) {

$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $aeecb3bd7a78465f$export$b5282052fc15e1ae);

var $301rJ = parcelRequire("301rJ");

var $hEbxW = parcelRequire("hEbxW");
const $aeecb3bd7a78465f$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $hEbxW.getCookie)((0, $301rJ.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("iUc7J", function(module, exports) {

$parcel$export(module.exports, "setConsentTokenCookie", () => $37dc478bedf1c7a1$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $37dc478bedf1c7a1$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $37dc478bedf1c7a1$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $37dc478bedf1c7a1$export$b3365240280cb3c3);

var $9P7Na = parcelRequire("9P7Na");
var $6ZgEd = parcelRequire("6ZgEd");

var $301rJ = parcelRequire("301rJ");

var $26elP = parcelRequire("26elP");

var $gqmdp = parcelRequire("gqmdp");
const $37dc478bedf1c7a1$export$8e560d0760f733a2 = (consentToken)=>{
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $gqmdp.setStrictlyNecessaryCookie)((0, $301rJ.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $6ZgEd.Logger).debug(`Set Consent Token ${(0, $301rJ.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $37dc478bedf1c7a1$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $gqmdp.setStrictlyNecessaryCookie)((0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $6ZgEd.Logger).debug(`set fallback consent token: ${(0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $37dc478bedf1c7a1$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $26elP.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $9P7Na.getBitValueFromBool)(!!bannerVisibility);
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $gqmdp.setStrictlyNecessaryCookie)((0, $301rJ.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $6ZgEd.Logger).debug(`set shouldShowBannerCookie: ${(0, $301rJ.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $37dc478bedf1c7a1$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $37dc478bedf1c7a1$export$8e560d0760f733a2(consentToken);
    $37dc478bedf1c7a1$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("9P7Na", function(module, exports) {

$parcel$export(module.exports, "getBitValueFromBool", () => $2ba5b22c48713c1b$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $2ba5b22c48713c1b$export$27647458f3cf29d2);
const $2ba5b22c48713c1b$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $2ba5b22c48713c1b$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("26elP", function(module, exports) {

$parcel$export(module.exports, "getBannerVisibility", () => $0e690d47726d7678$export$bfdb9f82a9194c1e);

var $kfwMJ = parcelRequire("kfwMJ");

var $9P7Na = parcelRequire("9P7Na");

var $301rJ = parcelRequire("301rJ");

var $hvqgK = parcelRequire("hvqgK");

var $hEbxW = parcelRequire("hEbxW");

var $6gmJj = parcelRequire("6gmJj");
const $0e690d47726d7678$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $6gmJj.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $0e690d47726d7678$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $0e690d47726d7678$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $9P7Na.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $hvqgK.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $0e690d47726d7678$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $hvqgK.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $0e690d47726d7678$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $hvqgK.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $0e690d47726d7678$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $0e690d47726d7678$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $9P7Na.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $hvqgK.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
        They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
        then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)

        UX Problem:
        Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
        But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
        is infrequent (either via Account Privacy Page or once this fallback expires in a year).

        Example:
        While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
        fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
        because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...

        We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
        to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
        persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.

        Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
        consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year

        Result: Show the banner again and hope we officially recapture consents this time around
      */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $0e690d47726d7678$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $hvqgK.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $0e690d47726d7678$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $hvqgK.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $0e690d47726d7678$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    const fallbackConsentToken = (0, $kfwMJ.isSSR)() ? fallbackConsents // When coming from SSR, we don't want to invoke `getCookie` since it will error
     : fallbackConsents || (0, $hEbxW.getCookie)((0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $0e690d47726d7678$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $9P7Na.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $0e690d47726d7678$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $0e690d47726d7678$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("hvqgK", function(module, exports) {

$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $2616b1a95751a75f$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $2616b1a95751a75f$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $2616b1a95751a75f$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $2616b1a95751a75f$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $2616b1a95751a75f$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $2616b1a95751a75f$export$3387347b75450ae1);
$parcel$export(module.exports, "StatusCodeError", () => $2616b1a95751a75f$export$a79c0ea3d7c2444a);

var $9P7Na = parcelRequire("9P7Na");

var $301rJ = parcelRequire("301rJ");

var $hEbxW = parcelRequire("hEbxW");

var $ccRXO = parcelRequire("ccRXO");

var $kVvmE = parcelRequire("kVvmE");
const $2616b1a95751a75f$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $301rJ.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $2616b1a95751a75f$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $301rJ.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $2616b1a95751a75f$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($2616b1a95751a75f$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $2616b1a95751a75f$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $2616b1a95751a75f$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $2616b1a95751a75f$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $2616b1a95751a75f$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $9P7Na.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $2616b1a95751a75f$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $301rJ.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $301rJ.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $ccRXO.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $9P7Na.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $9P7Na.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $9P7Na.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $2616b1a95751a75f$export$42a0b3fb1e53e7b9 = (consents)=>{
    const version = (0, $301rJ.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $9P7Na.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $kVvmE.ConsentHubKey).Functional)?.granted);
    const analyticsConsent = (0, $9P7Na.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $kVvmE.ConsentHubKey).Analytics)?.granted);
    const marketingConsent = (0, $9P7Na.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $kVvmE.ConsentHubKey).Marketing)?.granted);
    const unknownConsent = (0, $9P7Na.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $kVvmE.ConsentHubKey).Unknown)?.granted);
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $2616b1a95751a75f$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $hEbxW.getCookie)((0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $2616b1a95751a75f$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $2616b1a95751a75f$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $2616b1a95751a75f$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $2616b1a95751a75f$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $ccRXO.PreferenceCategory).StrictlyNecessary,
        (0, $ccRXO.PreferenceCategory).Functional,
        (0, $ccRXO.PreferenceCategory).Analytics,
        (0, $ccRXO.PreferenceCategory).Marketing,
        (0, $ccRXO.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: (0, $kVvmE.ConsentHubKey).StrictlyNecessary,
        [(0, $ccRXO.PreferenceCategory).Functional]: (0, $kVvmE.ConsentHubKey).Functional,
        [(0, $ccRXO.PreferenceCategory).Analytics]: (0, $kVvmE.ConsentHubKey).Analytics,
        [(0, $ccRXO.PreferenceCategory).Marketing]: (0, $kVvmE.ConsentHubKey).Marketing,
        [(0, $ccRXO.PreferenceCategory).Unknown]: (0, $kVvmE.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $2616b1a95751a75f$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $2616b1a95751a75f$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
class $2616b1a95751a75f$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = void 0;
        this.status = status;
        Object.setPrototypeOf(this, $2616b1a95751a75f$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $2616b1a95751a75f$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("kVvmE", function(module, exports) {

$parcel$export(module.exports, "ConsentHubKey", () => $6512ea116fbd6587$export$31140359b1e505cf);
var $6512ea116fbd6587$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});


parcelRegister("6gmJj", function(module, exports) {

$parcel$export(module.exports, "checkTokenVersionValidity", () => $5eb06e64c98e776e$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $5eb06e64c98e776e$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $5eb06e64c98e776e$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initialPreferencesAreMissing", () => $5eb06e64c98e776e$export$67f70eb55341bd29);
$parcel$export(module.exports, "initializePreferencesData", () => $5eb06e64c98e776e$export$7962405c3ca274b1);

var $2i8PW = parcelRequire("2i8PW");

var $9P7Na = parcelRequire("9P7Na");

var $301rJ = parcelRequire("301rJ");

var $hvqgK = parcelRequire("hvqgK");

var $ccRXO = parcelRequire("ccRXO");
const $5eb06e64c98e776e$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $301rJ.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $301rJ.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $301rJ.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $301rJ.V001_SCHEMA_KEY),
        (0, $301rJ.V002_SCHEMA_KEY),
        (0, $301rJ.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $5eb06e64c98e776e$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $301rJ.V001_SCHEMA_KEY);
    return [
        version,
        (0, $9P7Na.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $9P7Na.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $9P7Na.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $9P7Na.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $5eb06e64c98e776e$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $ccRXO.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $ccRXO.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $ccRXO.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $ccRXO.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $5eb06e64c98e776e$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $301rJ.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $ccRXO.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $ccRXO.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $ccRXO.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $ccRXO.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Functional]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Analytics]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Marketing]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Unknown]),
        (0, $9P7Na.getBitValueFromBool)(isDefaultConsentBit),
        (0, $9P7Na.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $9P7Na.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $5eb06e64c98e776e$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $hvqgK.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$5eb06e64c98e776e$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $ccRXO.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $5eb06e64c98e776e$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $301rJ.V003_SCHEMA_KEY);
    return [
        version,
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Functional]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Analytics]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Marketing]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Unknown]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $5eb06e64c98e776e$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $ccRXO.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $ccRXO.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $ccRXO.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $ccRXO.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $ccRXO.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $5eb06e64c98e776e$var$V002SpecificBitKeys = [
    (0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $ccRXO.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $ccRXO.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $ccRXO.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $ccRXO.ConsentPreferenceV2).ConsentedUnderFADP
];
const $5eb06e64c98e776e$var$V003SpecificBitKeys = [
    (0, $ccRXO.ContextualConsentProperty).ConsentsAreDefault,
    (0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated,
    (0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable
];
function $5eb06e64c98e776e$export$3199823fec979bd1(userPreferences) {
    if ((0, $2i8PW.getBscGlobalState)().localConsentMode) return $5eb06e64c98e776e$var$packPrefsVersion001(userPreferences);
    const isV002 = $5eb06e64c98e776e$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $5eb06e64c98e776e$var$packPrefsVersion002(userPreferences);
    const isV003 = $5eb06e64c98e776e$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $5eb06e64c98e776e$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $5eb06e64c98e776e$var$packPrefsVersion001(userPreferences);
}
function $5eb06e64c98e776e$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $2i8PW.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $301rJ.V001_SCHEMA_KEY)) return $5eb06e64c98e776e$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $5eb06e64c98e776e$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $5eb06e64c98e776e$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $5eb06e64c98e776e$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $5eb06e64c98e776e$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $5eb06e64c98e776e$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $5eb06e64c98e776e$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $ccRXO.PrefetchedPreferenceState).INTERNAL) {
        if ($5eb06e64c98e776e$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $5eb06e64c98e776e$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $hvqgK.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $5eb06e64c98e776e$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $ccRXO.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});


parcelRegister("gqmdp", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $716b9b66ec43bd8d$export$93509ff9a62ee022);

var $7g5Pn = parcelRequire("7g5Pn");

var $dh538 = parcelRequire("dh538");

var $c5a0x = parcelRequire("c5a0x");

var $6ZgEd = parcelRequire("6ZgEd");
const $716b9b66ec43bd8d$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});


parcelRegister("1uqEa", function(module, exports) {

$parcel$export(module.exports, "getValidConsentData", () => $8ca3b9a2789bb5d6$export$c515de1cc9cebc71);

var $dh538 = parcelRequire("dh538");

var $301rJ = parcelRequire("301rJ");

var $6RCHl = parcelRequire("6RCHl");

var $6gmJj = parcelRequire("6gmJj");
const $8ca3b9a2789bb5d6$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $6RCHl.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $6gmJj.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else if ((0, $dh538.fg)('platform_moonjelly_bsc_fallback_token_audit')) {
            const version = (0, $301rJ.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        } else // Temporary: Sets the default token to have true consentedUnderXXXX bits
        // when ConsentHub is inaccessible and there is not fallback token. This
        // will ensure the banner isn't shown when ConsentHub is down.
        consentToken = `${consentToken.slice(0, 8)}1111`;
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});
parcelRegister("6RCHl", function(module, exports) {

$parcel$export(module.exports, "fetchConsentPreferences", () => $78d0e78883127ca6$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $78d0e78883127ca6$export$f8422650c3dec8b2);

var $6ZgEd = parcelRequire("6ZgEd");

var $hvqgK = parcelRequire("hvqgK");
const $78d0e78883127ca6$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $78d0e78883127ca6$var$POST_CONSENTS_URL = `${$78d0e78883127ca6$var$BASE_CONSENTS_URL}/user`;
const $78d0e78883127ca6$var$GET_CONSENTS_URL = `${$78d0e78883127ca6$var$POST_CONSENTS_URL}/consents/cookies`;
const $78d0e78883127ca6$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $hvqgK.serializeConsents)(consentData);
        const consentTimestamp = (0, $hvqgK.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $hvqgK.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $78d0e78883127ca6$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$78d0e78883127ca6$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $78d0e78883127ca6$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $78d0e78883127ca6$export$bd9f5bcbf9cd947c();
    }
};
const $78d0e78883127ca6$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $hvqgK.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $78d0e78883127ca6$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$78d0e78883127ca6$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $78d0e78883127ca6$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $hvqgK.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});






parcelRegister("uh7ZL", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryStorageItem", () => $a68a22533abb1f74$export$f1b0c189562aa9fd);

var $c5a0x = parcelRequire("c5a0x");

var $6ZgEd = parcelRequire("6ZgEd");

var $ccRXO = parcelRequire("ccRXO");

var $8oAcs = parcelRequire("8oAcs");
const $a68a22533abb1f74$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    // Flag disabled, allow all items.
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // Store the item as a record in our IDB service to track that we've seen it before.
        // That way, when we can confirm/deny that this has been set by our service when we check again.
        // If it fails for some reason, it will be caught before actually setting the item
        // As setting Strictly Necessary requires synchronous operation, wait on the promise in an OG fashion
        (0, $8oAcs.BSCIndexedDB).setRecord(itemKey).then(()=>{
        // NOTE: Should this just no-op/be removed? It already set and returned the item theoretically since this main func is sync
        }).catch((e)=>{
            // Rethrow to the above catch clause since this is async within a sync func
            throw new Error(e.message || '');
        });
        browserStorage.setItem(itemKey, value);
        return (0, $ccRXO.Status).SUCCESS;
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $ccRXO.Status).FAILED;
    }
};

});


parcelRegister("5MeCb", function(module, exports) {

$parcel$export(module.exports, "isQuotaExceededError", () => $46257fa69570a280$export$4fc2001188ec893d);
$parcel$export(module.exports, "StorageManager", () => $46257fa69570a280$export$93525d6e221593cb);
/* eslint-disable check-set-storage-usage/no-unimported-storage-set */ 
var $9wGTI = parcelRequire("9wGTI");

var $7W8i8 = parcelRequire("7W8i8");

var $5ZqQS = parcelRequire("5ZqQS");

var $cRYpA = parcelRequire("cRYpA");

var $1UApO = parcelRequire("1UApO");

var $573Av = parcelRequire("573Av");
const $46257fa69570a280$var$logger = (0, $7W8i8.getLogger)('storage-manager');
const $46257fa69570a280$var$localStorageMigrationEntriesKey = 'localstorage-migration-entries';
function $46257fa69570a280$export$4fc2001188ec893d(error) {
    if (error && 'code' in error) switch(error.code){
        case 22:
            return true;
        case 1014:
            // Firefox
            if (error.name === 'NS_ERROR_DOM_QUOTA_REACHED') return true;
            break;
        default:
            return false;
    }
    return false;
}
function $46257fa69570a280$export$b4ff986ecbd5f7f2(value) {
    if (!value) return value;
    try {
        return JSON.parse(value);
    } catch (_) {
        return value;
    }
}
class $46257fa69570a280$export$93525d6e221593cb {
    /**
   * PRIVATE Does not trigger Init
   * creates a prefix for a value
   */ _getPrefix(seconds) {
        const milliseconds = (seconds || 0) * 1000;
        if (!milliseconds) return '';
        return Date.now() + milliseconds + this._delimiter;
    }
    constructor(storageManager, prefix, id, storagePrefix, { userId: userId, isLicensed: isLicensed }){
        this._storageManager = void 0;
        this._delimiter = '#';
        this._namespace = void 0;
        this._userId = void 0;
        this._isLicensedUser = void 0;
        this._hasQuotaErrorBeenSubmitted = false;
        this._persistSetValue = (originalKey, value, persistKey)=>{
            // there is a cyclic dependency with @confluence/graphql
            // communicate local/session storage update to cc-bandana
            if (Object.values((0, $1UApO.PERSISTED_KEYS_ON_SERVER)).indexOf(originalKey) > -1 && !sessionStorage.getItem('confluence.disable-persisted-storage-for-tests') && window['GLOBAL_APOLLO_CLIENT'] && this._userId && this._isLicensedUser) {
                const mutationVariables = {
                    storageinput: {
                        stringValues: [
                            {
                                key: persistKey,
                                value: value
                            }
                        ]
                    },
                    stringKeys: [
                        persistKey
                    ]
                };
                window['GLOBAL_APOLLO_CLIENT'].mutate({
                    mutation: (0, $cRYpA.UpdateLocalStorageMutation),
                    variables: mutationVariables
                }).catch((e)=>{
                    this._submitError(e, `Error updating user preferences with key ${originalKey} and value ${value}: ${e}`);
                });
            }
        };
        /**
     * Gets the item stored in local storage for the given key. null is returned if it doesn't exist.
     * Note that this method will always return a string representation of what is stored.
     */ this.getItem = (key)=>{
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const cacheKey = (0, $573Av.getStorageKey)(key, `${this._namespace}.${key}`);
                let item;
                if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) item = this._storageManager.getItem(key);
                else {
                    item = this._storageManager.getItem(cacheKey);
                    /**
           * Currently some keys from independent usages of native local/session storage
          	 were adding keys without namespace. This helps cleanup those keys and return the
          	values for those keys if they exist
          * Once we stop seeing increments in counter in metrics for localStorageMigrationEntriesKey
          		we can remove this logic*/ if (!item) {
                        item = this._storageManager.getItem(key);
                        if (item) {
                            this._incrementLocalStorageMigrationEntries();
                            this.setItem(key, item);
                            this._storageManager.removeItem(`${key}`);
                        }
                    }
                }
                if (item) {
                    item = $46257fa69570a280$export$b4ff986ecbd5f7f2(item);
                    let match;
                    const prefixMatch = /(\d+)#/;
                    if (typeof item === 'string' && (match = prefixMatch.exec(item))) {
                        const itemWithStrippedExpirationPrefix = item.replace(match[0], '');
                        const expirationTimestamp = parseInt(match[1], 10);
                        const isExpired = !isNaN(expirationTimestamp) && Date.now() > expirationTimestamp;
                        if (isExpired) {
                            this.removeItem(key);
                            return null;
                        }
                        return itemWithStrippedExpirationPrefix;
                    }
                    return item;
                }
                return null;
            } catch (e) {
                this._submitError(e, `Error getting value from storage manager for key:${key} : ${e}`);
                return null;
            }
        };
        this.getAndRemoveItem = (key)=>{
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const item = this.getItem(key);
                if (item) {
                    this.removeItem(key);
                    return item;
                }
                return null;
            } catch (e) {
                this._submitError(e, `Error getting and removing value from storage manager for key:${key} : ${e}`);
                return null;
            }
        };
        /**
     * Get all the items in local storage that are bound to the given context.
     */ this.getAllItems = ()=>{
            const items = {};
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return items;
            }
            const length = this._storageManager.length;
            // Currently getAllItems is unsupported if _storageManager is AtlBrowserStorage,
            // which retrieves length differently
            if (typeof length !== 'number') return items;
            try {
                for(let i = 0; i < length; i++){
                    const itemKey = this._storageManager.key(i);
                    if (itemKey && itemKey.includes(`${this._namespace}.`)) {
                        const keyWithoutNamespace = itemKey.split(`${this._namespace}.`)[1];
                        const rawItemValue = this._storageManager.getItem(itemKey);
                        items[keyWithoutNamespace] = $46257fa69570a280$export$b4ff986ecbd5f7f2(rawItemValue);
                    }
                }
                return items;
            } catch (e) {
                this._submitError(e, `Error getting all items from storage manager : ${e}`);
                return items;
            }
        };
        /**
     * Returns a boolean to let you know if we contain a key that matches, and has not expired.
     */ this.doesContain = (key)=>{
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return false;
            }
            try {
                const value = this.getItem(key);
                return typeof value === 'boolean' ? !value : !!value;
            } catch (e) {
                this._submitError(e, `Error getting value from storage manager for key ${key}: ${e}`);
                return false;
            }
        };
        /**
     * Gets the item stored in local storage for the given key and returns the boolean value of it.
     * It correctly convert the "true" and "false" strings to return true/false booleans.
     */ this.getItemAsBoolean = (key)=>{
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return false;
            }
            try {
                const value = this.getItem(key);
                if (value && typeof value === 'string' && value.indexOf('false') >= 0) return false;
                if (value && typeof value === 'string' && value.indexOf('true') >= 0) return true;
                return !!value;
            } catch (e) {
                this._submitError(e, `Error getting value as boolean from storage manager for key ${key}: ${e}`);
                return false;
            }
        };
        /**
     * synchronously sets a value
     * @param expire expiration time in seconds
     * @returns {string}
     */ this.setItem = (key, value, expire)=>{
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const cacheKey = (0, $573Av.getStorageKey)(key, `${this._namespace}.${key}`);
                // If it's not an object then append prefix.
                if (typeof value !== 'object') value = `${this._getPrefix(expire)}${value}`;
                value = JSON.stringify(value);
                // Use original key to call AtlBrowserStorage setItem, because only the original key is registered
                if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) {
                    const processSetItem = this._storageManager.setItem(key, value);
                    processSetItem?.then(()=>{
                        // Currently AtlBrowserStorage setItem does not return SUCCESS or BLOCKED,
                        // so we check the successful status by calling getItem
                        // only persist the value if the setItem was successful
                        const isSuccessful = this._storageManager && this._storageManager.getItem(key);
                        if (isSuccessful) this._persistSetValue(key, value, cacheKey);
                    });
                } else {
                    this._storageManager.setItem(cacheKey, value);
                    this._persistSetValue(key, value, cacheKey);
                }
                return JSON.parse(value);
            } catch (e) {
                if ($46257fa69570a280$export$4fc2001188ec893d(e)) {
                    // for "quota exceeded" errors we're re-massaging the error message to exclude `this._namespace`
                    // DOMException properties are read-only, so we can't just modify them inline, see https://developer.mozilla.org/en-US/docs/Web/API/DOMException
                    if (!this._hasQuotaErrorBeenSubmitted) {
                        // we'll only submit "quota exceeded" error to the monitoring systems once per user session -- there isn't really a need to submit all such errors.
                        this._submitError(new Error(`Quota exceeded on key "${key}"`));
                        this._hasQuotaErrorBeenSubmitted = true;
                    }
                    $46257fa69570a280$var$logger.error`Storage quota exceeded when for key ${key} and value ${value}; original error: ${e}`;
                } else this._submitError(e, `Error setting value from storage manager with key ${key} and value ${value}: ${e}`);
                return null;
            }
        };
        /**
     * Removes a Key from the Store
     */ this.removeItem = (key)=>{
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return;
            }
            try {
                const cacheKey = (0, $573Av.getStorageKey)(key, `${this._namespace}.${key}`);
                if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) this._storageManager.removeItem(`${key}`);
                else this._storageManager.removeItem(`${cacheKey}`);
                return;
            } catch (e) {
                this._submitError(e, `Error removing value from storage manager for key ${key}: ${e}`);
                return;
            }
        };
        this.initializeFromServer = (results)=>{
            if (!Array.isArray(results)) return;
            if (sessionStorage.getItem('confluence.disable-persisted-storage-for-tests')) return;
            try {
                if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) results.forEach((val)=>{
                    const originalKey = val?.key?.replace(`${this._namespace}.`, '');
                    if (this._storageManager && originalKey) this._storageManager.setItem(originalKey, val.value);
                });
                else results.forEach((val)=>this._storageManager && this._storageManager.setItem(val.key, val.value));
            } catch (e) {
                if ($46257fa69570a280$export$4fc2001188ec893d(e)) this._submitError(new Error('Quota exceeded on intializing persisted values from server'));
                else this._submitError(e, `Error setting value from storage manager while initializing persisted values from server: ${e}`);
            }
        };
        this._submitError = (e, message)=>{
            if (message) $46257fa69570a280$var$logger.error`${message}`;
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: 'unknown'
            });
        };
        this._incrementLocalStorageMigrationEntries = ()=>{
            (0, $5ZqQS.getMonitoringClient)().incrementCounter($46257fa69570a280$var$localStorageMigrationEntriesKey);
        };
        this._storageManager = storageManager;
        this._namespace = userId ? `${storagePrefix}/${prefix}.${userId}.${id}` : `${storagePrefix}/null`;
        this._userId = userId;
        this._isLicensedUser = isLicensed ?? false;
    }
}

});
parcelRegister("cRYpA", function(module, exports) {

$parcel$export(module.exports, "UpdateLocalStorageMutation", () => $59e51e74b68fd68c$export$359ef83116415c8a);

var $d2LG0 = parcelRequire("d2LG0");
const $59e51e74b68fd68c$export$359ef83116415c8a = (0, $d2LG0.default)`mutation UpdateLocalStorageMutation($storageinput:LocalStorageInput!$stringKeys:[String]!){updateLocalStorage(localStorage:$storageinput){stringValues(keys:$stringKeys){key value}}}`;

});

parcelRegister("1UApO", function(module, exports) {

$parcel$export(module.exports, "keys", () => $490666dac3ea5b14$export$ed97f33186d4b816);
$parcel$export(module.exports, "PERSISTED_KEYS_ON_SERVER", () => $490666dac3ea5b14$export$84dce893719feb44);
const $490666dac3ea5b14$export$ed97f33186d4b816 = {
    DISCOVER_ROUTE: 'discover.route.last',
    GLOBAL_SIDEBAR_PANEL: 'sidebar.global.panel',
    EDITOR_SURVEY_LAST_SUBMITTED: 'editor.survey.last.submitted',
    SUPERADMIN_SURVEY_REQUESTED: 'superadmin.survey.requested',
    SUPERADMIN_SURVEY_SUBMITTED: 'superadmin.survey.submitted',
    SUPERADMIN_SESSION_EXPIRED: 'superadmin.session.expired',
    RESTRICTED_PAGE_CONFIRMED: 'restricted.page.confirmed',
    HOME_ONBOARDING: 'home.onboarding',
    PAGE_JUST_CONVERTED: 'migration.page.just.converted',
    NAVIGATION_CLASSIC_OPT_OUT: 'navigation.classic.opt.out',
    NAVIGATION_HOME_OPT_OUT: 'navigation.home.opt.out',
    NAVIGATION_DEFAULT_OPTED_OUT: 'navigation.default.opted.out',
    NAVIGATION_OPT_IN_SEEN_SPOTLIGHT: 'navigation.opt.in.seen.spotlight',
    NAVIGATION_CLICKED_LOUD_OPT_IN_OR_VIEWED_FLAG: 'navigation.clicked.loud.opt.in.or.viewed.flag',
    NOTIFICATION_SPOTLIGHT_VIEWED: 'notification.spotlight.viewed',
    HOME_SECTION_COLLAPSED: 'home.section.collapsed',
    RECENTLY_WATCHED_SPACE: 'recentlyWatchedSpace',
    GROWTH_EXPERIMENT_REQUEST_UPGRADE_SENT: 'growth.experiment.request.upgrade.sent',
    GROWTH_EXPERIMENT_UPGRADE_DISMISSED_COUNT: 'growth.experiment.engagedUpgrade.dismissed.count',
    GROWTH_EXPERIMENT_UPGRADE_LAST_DISMISSED_DATE: 'growth.experiment.engagedUpgrade.last.dismissed.date',
    LOCAL_STORAGE_DISPLAYS_NEXT_AT_KEY: 'growth.experiment.engagedBilling.displays.next.at',
    LOCAL_STORAGE_HAS_BILLING_DETAILS: 'growth.experiment.engagedBilling.has.billing.details',
    LOCAL_STORAGE_BILLING_API_NEXT_CALLED_AT_KEY: 'growth.experiment.engagedBilling.billing.api.next.called.at',
    LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION: 'ce.content.view.best.element.scroll.position',
    CONFLUENCE_SLACK_APP_IS_ENABLED: 'growth.experiment.confluence.slack-is-enabled',
    INVITE_ON_LINK_INSERT_DISMISSAL_COUNT: 'growth.experiment.confluence.invite-on-link-insert-dismissal-count',
    INVITE_ON_LINK_INSERT_OPT_OUT: 'growth.experiment.confluence.invite-on-link-insert-opt-out',
    CROSS_JOIN_NUDGES_V3_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-v3-visited',
    CROSS_JOIN_NUDGES_JPD_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-jpd-visited',
    CROSS_JOIN_NUDGES_V3_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-v3-visited-count',
    CROSS_JOIN_NUDGES_JPD_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-jpd-visited-count',
    CROSS_JOIN_NUDGES_V3_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-v3-opt-out',
    CROSS_JOIN_NUDGES_JPD_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-jpd-opt-out',
    CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_KEY: 'growth.experiment.confluence.cross-join-third-party-nudges-visited',
    CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_COUNT: 'growth.experiment.confluence.cross-join-third-party-nudges-visited-count',
    /**
   * The width of the right panel on Home
   */ HOME_SIDEBAR_WIDTH: 'home.sidebar.width',
    /**
   * Used to store starred/favorited feature flags for the dev tools panel
   */ STARRED_FEATURE_FLAGS: 'confluence-frontend-next.starredFeatureFlags',
    /**
   * Indicates that "Copy space permissions" (implemented by
   * @confluence/copy-space-permissions) has completed i.e. space permissions
   * have been copied.
   */ COPIED_SPACE_PERMISSIONS: 'copied.space.permissions',
    PERSIST_SCROLL_POSITION_IN_VIEW_PAGE: 'editor-persit-scroll-position',
    ID_START_CONTENT_IN_VIEW_PAGE: 'main-content',
    FABRIC_PAGE_OPTIN_MIGRATION_BANNER: 'fabric.page.optin.migration.banner.discovery.feature',
    FABRIC_TEMPLATE_MIGRATION_SUCCESS_FLAG: 'fabric-template-migration.success.flag',
    FABRIC_TEMPLATE_MIGRATION_ERROR_FLAG: 'fabric-template-migration.error.flag',
    BYLINE_APPS_SHOW_ALL: 'byline.apps.show-all',
    SPACENAV_APPS_SHOW_ALL: 'spacenav.apps.show-all',
    HIDE_BULK_CONFIRMATION_DIALOG_LOCAL_STORAGE_KEY: 'archive-pages.bulk-archive.confirmation-dialog.opt-out',
    ONBOARDING_STEP_INDEX: 'onboarding.account.setup.step.index',
    ONBOARDING_STEP_HAS_TEAM_NAME: 'onboarding.account.setup.step.hasTeamName',
    ONBOARDING_FORM_VALUES: 'onboarding.account.setup.form.values',
    ONBOARDING_QUICKSTART_TOUR_STATE: 'onboarding.quickstart.tour.state',
    RIGHT_SIDEBAR: 'right.sidebar',
    CONNECT_APP_ANALYTICS: 'ecosystem.confluence.connect.analytics',
    /**
   * Auto Convert TinyMCE pages
   */ EDITOR_REVERTED: 'autoconverted.pages.reverted',
    BLOGPOST_PERMISSIONS_NOTICE: 'blogpost.permissions.notice.error',
    QUERY_OVERRIDES: 'query.overrides',
    CANVAS_SERVER: 'canvas-server',
    CANVAS_RELAY: 'canvas-relay',
    CANVAS_FRONTEND_VERSION: 'canvas-frontend-version',
    // Below are cc-automation keys for in-context discoverability messages
    AUTOMATION_DISCOVER_ARCHIVE_FROM_OVERFLOW_MENU: 'automation.discover.archive-from-overflow-menu',
    AUTOMATION_DISCOVER_ARCHIVE_FROM_HOVER_OVER_PAGE_TITLE: 'automation.discover.archive-from-hover-over-page-title',
    AUTOMATION_DISCOVER_BULK_ARCHIVE: 'automation.discover.bulk-archive',
    AUTOMATION_DISCOVER_BULK_CHANGE_PAGE_OWNER: 'automation.discover.bulk-change-page-owner',
    AUTOMATION_DISCOVER_ADD_LABEL_TO_PAGE: 'automation.discover.add-label-to-page',
    AUTOMATION_DISCOVER_MEETING_NOTES_TEMPLATE: 'automation.discover.meeting-notes-template',
    AUTOMATION_DISCOVER_JIRA_LINK: 'automation.discover.jira-link',
    AUTOMATION_DISCOVER_MANUAL_TRIGGER: 'automation.discover.manual.trigger',
    AUTOMATION_DISCOVER_MANUAL_RULE_COUNT: 'automation.discover.manual.rule.count',
    AUTOMTION_DISCOVER_MANUAL_RULE_SMART_BUTTON: 'automation.discover.manual.rule.smart.button',
    AUTOMATION_DISCOVER_PAGE_PUBLIC_LINK: 'automation.discover.page-public-link',
    AUTOMATION_DISCOVER_GLOBAL_PUBLIC_LINK: 'automation.discover.global-public-link',
    AUTOMATION_DISCOVER_SPACE_ASSIGNED_BULK: 'automation.discover.space-assigned-bulk',
    AUTOMATION_DISCOVER_SPACE_ASSIGNED_INDIVIDUAL: 'automation.discover.space-assigned-individual',
    AUTOMATION_DISCOVER_GLOBAL_DEFAULT_SPACE: 'automation.discover.global-default-space',
    AUTOMATION_DISCOVER_VERIFIED_CONTENT: 'automation.discover.verified.content',
    AUTOMATION_DISCOVER_WHITE_BOARDS: 'automation.discover.publish.white.boards',
    AUTOMATION_DISCOVER_SHARE_SLACK: 'automation.discover.share.slack',
    AUTOMATION_DISCOVER_SET_CONTENT_STATE: 'automation.discover.set-content-state',
    AUTOMATION_DISCOVER_PRODUCT_REQUIREMENTS: 'automation.discover.product-requirements',
    AUTOMATION_DISCOVER_FEEDBACK_ANALYSIS: 'automation.discover.feedback-analysis',
    AUTOMATION_DISCOVER_RELEASE_NOTES: 'automation.discover.release-notes',
    AUTOMATION_ONBOARDING: 'automation.onboarding',
    AUTOMATION_EXECUTION_LIMIT: 'automation.execution.limit',
    SPACE_SETTINGS_NAV_SECTIONS_EXPANDED_STATES: 'space-settings-nav.sections.expand-states',
    SITE_SETTINGS_NAV_SECTIONS_EXPANDED_STATES: 'site-settings-nav.sections.expand-states',
    /**
   * Comment Drafts
   */ COMMENT_DRAFTS_PAGE_CREATE: 'comments.drafts.page.create',
    COMMENT_DRAFTS_PAGE_EDIT: 'comments.drafts.page.edit',
    COMMENT_DRAFTS_PAGE_REPLY: 'comments.drafts.page.reply',
    COMMENT_DRAFTS_INLINE_CREATE: 'comments.drafts.inline.comments.create',
    COMMENT_DRAFTS_INLINE_EDIT: 'comments.drafts.inline.comments.edit',
    COMMENT_DRAFTS_INLINE_REPLY: 'comments.drafts.inline.reply',
    COMMENT_DRAFTS_EDITOR_INLINE_CREATE: 'comments.drafts.editor.inline.create',
    COMMENT_DRAFTS_EDITOR_INLINE_EDIT: 'comments.drafts.editor.inline.edit',
    COMMENT_DRAFTS_EDITOR_INLINE_REPLY: 'comments.drafts.editor.inline.reply',
    LOOM_BETA_ENABLED: 'loom.beta.enabled',
    BROWSER_BANNER_CLOSED_BY_USER: 'devloop.browser-support-warning.closed',
    /**
   * Home Feeds
   */ HOME_FOLLOWING_FEED_SESSION_ID: 'home.follow-feed.sessionId',
    HOME_POPULAR_FEED_SESSION_ID: 'home.popular-feed.sessionId',
    HOME_FOLLOWING_FEED_SORTING: 'home.follow-feed.sorting',
    HOME_POPULAR_FEED_TIME_GRANULARITY: 'home.popular-feed.time-granularity',
    /**
   * Live Pages
   */ LIVE_PAGES_IN_PRODUCT_PROMPT_MODAL_LAST_DISMISSED: 'live-pages.in-product-prompt.modal.last-dismissed',
    LIVE_PAGES_IN_PRODUCT_PROMPT_BANNER_SPACE_SETTINGS_LAST_DISMISSED: 'live-pages.in-product-prompt.banner.space-settings.last-dismissed',
    LIVE_PAGES_IN_PRODUCT_PROMPT_BANNER_MISSION_CONTROL_LAST_DISMISSED: 'live-pages.in-product-prompt.banner.mission-control.last-dismissed',
    LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN: 'live-pages.mode-switcher.flag.shown',
    LIVE_PAGES_OPEN_BETA_PROMPT_MODAL_FIRST_SEEN: 'live-pages.open-beta-prompt-modal.first-seen',
    LIVE_PAGES_OPEN_BETA_PROMPT_GLOBAL_BANNER_FIRST_DISMISSED: 'live-pages.open-beta-prompt-global-banner.first-dismissed',
    LIVE_DOCS_HAS_INIT_MODERNIZE: 'live-docs.has-init-modernize',
    LIVE_DOCS_HAS_EXPOSED_AA_EXP: 'live-docs.has-exposed-aa-exp',
    UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL: 'universal-shortcuts.deprecated-shortcut-flag.hide-until',
    // Bold new pages experiment
    UNREAD_PAGES_VISITED: 'bold-new-pages.experiment.unread-pages.visited',
    // Mention Reminders experiment
    MENTION_REMINDERS_SENT: 'mention-reminders.experiment.sent',
    ELEMENT_INSERTION_STATS: 'track-element-analytics.element-insertion-stats',
    // Nav 4 Site/Space settings back button URL
    NAV4_SETTINGS_BACK_BUTTON_URL: 'navigation.settings.back-button.url',
    // Nav 4 opt out cache
    NAV4_OPT_OUT_CACHE: 'navigation.opt-out',
    // Nav 4 admin opt in cache
    NAV4_ADMIN_OPT_IN_CACHE: 'navigation.admin.opt-in',
    // Nav 4 misaligned nav versions flag
    NAV4_MISALIGNED_NAV_VERSIONS_FLAG: 'navigation.misaligned.nav.versions.flag',
    // EOT Banner experiment
    EOT_BANNER_DISMISS_UNTIL: 'eot-banner.dismiss-until',
    // Issue Create
    ISSUE_CREATE_WITH_AI: 'issue-create.with-ai',
    // AI Unsplash Header Experiment
    AI_UNSPLASH_HEADER_ACCEPTED: 'ai-unsplash.header.accepted',
    //Notify User On 1st View expeirment
    NOTIFY_USERS_ON_FIRST_VIEW_MUTATION_FIRED: 'notify-users-on-first-view.mutation.fired',
    // Analytics migration changeboarding EP message toggle
    ANALYTICS_MIGRATION_CHANGEBOARDING_MESSAGE: 'analytics-migration-changeboarding-message',
    NAVDEX_STORAGE_KEY: 'navigationSession',
    // Super Admin Timeout
    SUPER_ADMIN_TIMEOUT: 'confluence.super.admin.timeout',
    // Premium Onboarding
    PTO_PHASE_TWO_SPOTLIGHT_TARGET: 'pto-phase-two-spotlight',
    // Have I Seen It prefix
    HAVE_I_SEEN_IT_PREFIX: 'cf_hisi_',
    // Migrations
    IMPORT_CONTENT_TIMESTAMP: 'importContentTimestamp',
    // Onboarding
    INFI_SPOTLIGHT_KEY: 'is-infi-spotlight-seen',
    // Page Experience
    AE_TABLE_COPIED: 'copied',
    AE_TABLE_COPIED_COLS: 'copiedCols',
    LAST_TAB_SUFFIX: 'last-tab',
    // AI Audio Playback Speed
    AI_AUDIO_PLAYBACK_SPEED: 'ai.audio.playback-speed',
    // EditorTeamCreatedFlag
    RETROSPECTIVE_BLUEPRINT_TEAM_CREATED: 'retrospective-blueprint.team.created',
    RETROSPECTIVE_BLUEPRINT_TEAM_USED: 'retrospective-blueprint.team.used',
    // Confluence Custom Origins
    CONFLUENCE_CUSTOM_ORIGINS: 'confluenceCustomOrigins',
    // Dev and Testing
    HIDE_FEATURE_FLAG_ICON: 'confluence-frontend-next.hideFeatureFlagIcon',
    FE_FIXTURE_PARAMS: '__confluence-frontend-fixture-params',
    TEST_FAILURES_LINK_MODE: 'testFailuresLink.mode',
    TEST_FAILURES_LINK_OPERATIONS_PREFIX: 'testFailuresLink.operations.',
    // Disable Engagement for tests
    DISABLE_ENGAGEMENT_FOR_TESTS: 'confluence.disable-engagement-for-tests',
    // Jira Crossflow Experiment
    JIRA_ACCESS_REQUESTED: 'jira_access_requested',
    JIRA_TRIAL_REQUESTED: 'jira_trial_requested',
    // Feature Discovery Override
    FEATURE_DISCOVERY_OVERRIDE_PREFIX: 'featureDiscoveryOverride-',
    // Chrome Extension
    CONFLUENCE_SSR_OUTLINE_PRIORITY: 'confluence.ssr-outline-priority',
    CONFLUENCE_SSR_OUTLINE_ENABLED: 'confluence.ssr-outline-enabled',
    CONFLUENCE_LOADABLE_STEP_OVER_ENABLED: 'confluence.loadable-step-over-enabled',
    // Automated Meeting Notes
    AMN_SPOTLIGHT_KEY: 'automated-meeting-notes-spotlight-seen-count'
};
const $490666dac3ea5b14$export$84dce893719feb44 = {
    //keys stored on backend start with persisted
    PERSISTED_LEFT_SIDEBAR_WIDTH: 'persisted.left.sidebar.width',
    PERSISTED_LEFT_SIDEBAR_COLLAPSED: 'persisted.left.sidebar.collapsed',
    PERSISTED_GROWTH_PERSISTENT_UPGRADE_PRETRIAL_BANNER: 'persisted.growth.persistent.upgrade.preTrial.banner',
    PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES: 'persisted.space-nav.sections.expand-states',
    // The next time to show the External Collaboration Guest Satisfaction Survey to this guest user
    PERSISTED_GUEST_SURVEY_NEXT_TIME_TO_SHOW: 'persisted.guest.survey.next.time.to.show',
    // Overrided feature flags. These are persisted to the server so they can be
    // used when rendering in SSR
    PERSISTED_OVERRIDE_FEATURE_FLAGS: 'persisted.enterprise-experience.override.feature.flags',
    PERSISTED_OVERRIDES_STATSIG: 'persisted.enterprise-experience.override.statsig',
    PERSISTED_ADMIN_ANNOUNCEMENT_BANNER: 'persisted.admin.announcement.banner',
    PERSISTED_ADMIN_ANNOUNCEMENT_BANNER_MIGRATOR_PROMPT: 'persisted.admin.announcement.banner.migrator.prompt',
    PERSISTED_STORAGE_ENFORCEMENT_BANNER: 'persisted.storage.enforcement.banner',
    // Nav 4 prompt banner
    PERSISTED_NAV4_PROMPT_BANNER_FIRST_DISMISSED: 'persisted.navigation.prompt-banner.first-dismissed',
    // Nav 4 prompt reminder banner
    PERSISTED_NAV4_PROMPT_REMINDER_BANNER_FIRST_DISMISSED: 'persisted.navigation.prompt-reminder-banner.first-dismissed',
    // Public Links Modals
    PERSISTED_RESTRICTIONS_DIALOG_PUBLIC_LINKS_MODAL: 'persisted.restrictions.dialog.public.links.modal',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_ON_MODAL: 'persisted.share.dialog.public.links.toggle.on.modal',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_ON_MODAL_SMART_SECTIONS: 'persisted.share.dialog.public.links.toggle.on.modal.smart.sections',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_OFF_MODAL: 'persisted.share.dialog.public.links.toggle.off.modal',
    // Public Links Edit Whiteboard Banner
    PERSISTED_PUBLIC_LINKS_EDIT_WHITEBOARD_BANNER: 'persisted.public.links.edit.whiteboard.banner',
    // Theming
    PERSISTED_USER_THEME_PREFERENCE: 'persisted.ecosystem.user.theme.preference',
    // Premium feature highlight
    PERSISTED_PREMIUM_FEATURE_HIGHLIGHT: 'persisted.premium.feature.highlight',
    // Reading Aids
    PERSISTED_READING_AIDS_AUTO_HIGHLIGHT: 'persisted.reading.aids.auto.highlight',
    // Bold new pages experiment
    PERSISTED_BOLD_NEW_PAGES_SATISFACTION_SURVEY_HAS_SEEN: 'persisted.bold-new-pages.experiment.satisfaction-survey.has-seen',
    // Page to Folder conversion banner
    PERSISTED_PAGE_TO_FOLDER_CONVERSION_BANNER_DISMISSED: 'persisted.convert-page-to-folder.banner.dismissed',
    // Previously trialed premium users experiment
    PERSISTED_PREVIOUSLY_TRIALED_PREMIUM_USERS_DISMISSED: 'persisted.previously.trialed.premium.users.banner.dismissed',
    // Quick Summary Experiment
    PERSISTED_QUICK_SUMMARY_REQUEST_SENT: 'persisted.growth.quick-summary-request-sent',
    // Experiment for Jira Project Board in Conflunce
    // Growth: Trailblazer experiment TBLZ-1289 : go/trailblazerexperiments
    PERSISTED_JIRA_AD_DISMISSAL: 'persisted.jira.crossflow.ad.dismissal',
    PERSISTED_JIRA_PROJECT_BOARD_TRIAL_REQUESTED: 'persisted.jira.crossflow.jira-project-board.trial-requested',
    PERSISTED_JIRA_PROJECT_BOARD_ACCESS_REQUESTED: 'persisted.jira.crossflow.jira-project-board.access-requested',
    // Live Pages
    PERSISTED_LIVE_PAGES_FEEDBACK_BANNER_LAST_DISMISSED: 'persisted.live-pages.feedback-banner.last-dismissed',
    // Editor Controls
    PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_LIVE_PAGE_DISMISSED: 'persisted.editor-controls.onboarding-banner.live-page.dismissed',
    PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_CLASSIC_PAGE_DISMISSED: 'persisted.editor-controls.onboarding-banner.classic-page.dismissed',
    PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_DISMISSED: 'persisted.editor-controls.onboarding-banner-updated.dismissed',
    //Bite Sized Generic Premium Messages
    PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_GENERIC_CADENCE: 'persisted.bite-sized.premium-messages.generic.cadence',
    //Bite Sized Automation Premium Messages
    PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_AUTOMATION_CADENCE: 'persisted.bite-sized.premium-messages.automation.cadence',
    //Role Based Access Control
    PERSISTED_RBAC_TRACKING: 'persisted.rbac.tracking',
    // Loom cross_flow ad-control not interested preference
    PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED: 'persisted.loom-cross-flow.ad-control.not-interested',
    // Status of exposure to a series of spotlight pulse outlines
    // highlighting Loom entrypoints to cross-sell-eligible customers
    PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED: 'persisted.loom-cross-sell.discoverability-pulses.have-ended',
    // Jira Cloud ID preference for site picker on Jira Issue Create
    PERSISTED_JIRA_CLOUD_ID_PREFERENCE: 'persisted.jira-cloud-id.preference',
    // Selected site, project and issue type from the configure view on bulk AI Jira Issue Create
    PERSISTED_BULK_CREATE_JIRA_CONFIG_FOR_USER: 'persisted.bulk-create.jira.config.for.user',
    // Importers
    PERSISTED_IMPORT_FEEDBACK_DISABLED: 'persisted.imports.import-feedback-disabled'
};

});

parcelRegister("573Av", function(module, exports) {

$parcel$export(module.exports, "getKeysForLocalStorageQuery", () => $024a6c1f3e085dca$export$7c5eda5500a5f08d);
$parcel$export(module.exports, "getStorageKey", () => $024a6c1f3e085dca$export$902ba6ec74c93f9d);

var $1UApO = parcelRequire("1UApO");

var $fPYum = parcelRequire("fPYum");
const $024a6c1f3e085dca$var$serverCacheKeyRegex = /[^A-Za-z0-9\-._\/]/g;
const $024a6c1f3e085dca$export$7c5eda5500a5f08d = (userId)=>{
    const keys = [];
    let prefix = `${(0, $fPYum.LOCAL_STORAGE_MANAGER)}/${(0, $fPYum.STORAGE_MANAGER_PREFIX)}.${userId}.${(0, $fPYum.STORAGE_MANAGER_ID)}`;
    prefix = prefix.replace($024a6c1f3e085dca$var$serverCacheKeyRegex, '_');
    Object.keys((0, $1UApO.PERSISTED_KEYS_ON_SERVER)).forEach((key)=>keys.push(`${prefix}.${(0, $1UApO.PERSISTED_KEYS_ON_SERVER)[key]}`));
    return keys;
};
const $024a6c1f3e085dca$export$902ba6ec74c93f9d = (key, cacheKey)=>{
    if (Object.values((0, $1UApO.PERSISTED_KEYS_ON_SERVER)).indexOf(key) > -1) cacheKey = cacheKey.replace($024a6c1f3e085dca$var$serverCacheKeyRegex, '_');
    return cacheKey;
};

});
parcelRegister("fPYum", function(module, exports) {

$parcel$export(module.exports, "STORAGE_MANAGER_PREFIX", () => $c1e570c94f11101f$export$94c92810ef76851);
$parcel$export(module.exports, "STORAGE_MANAGER_ID", () => $c1e570c94f11101f$export$cae0fbb99c422e2);
$parcel$export(module.exports, "LOCAL_STORAGE_MANAGER", () => $c1e570c94f11101f$export$1b311d1dfe8a9349);
$parcel$export(module.exports, "SESSION_STORAGE_MANAGER", () => $c1e570c94f11101f$export$16f5e866917d6fd1);
const $c1e570c94f11101f$export$94c92810ef76851 = 'atlassian';
const $c1e570c94f11101f$export$cae0fbb99c422e2 = 'frontend';
const $c1e570c94f11101f$export$1b311d1dfe8a9349 = 'localStorage';
const $c1e570c94f11101f$export$16f5e866917d6fd1 = 'sessionStorage';

});



parcelRegister("i6sMX", function(module, exports) {

$parcel$export(module.exports, "getRemoteLocalStorage", () => $3dc381592a319f3c$export$efc60d6604f5fc7a);

var $f7B1p = parcelRequire("f7B1p");

var $9WAeG = parcelRequire("9WAeG");

var $hfKCi = parcelRequire("hfKCi");

var $573Av = parcelRequire("573Av");
async function $3dc381592a319f3c$export$efc60d6604f5fc7a({ userId: userId, isLicensed: isLicensed }) {
    if (window['__REMOTE_LOCAL_STORAGE__']) return window['__REMOTE_LOCAL_STORAGE__'];
    const URI = window['GLOBAL_APOLLO_CLIENT_URI'] || '/cgraphql';
    return window['__REMOTE_LOCAL_STORAGE__'] = (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:LocalStorageQuery', async ()=>{
        let result = null;
        try {
            if (isLicensed && userId) {
                const variables = {
                    stringKeys: (0, $573Av.getKeysForLocalStorageQuery)(userId)
                };
                const res = await (0, $f7B1p.cfetch)(`${URI}?q=LocalStorageQuery`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'X-APOLLO-OPERATION-NAME': 'LocalStorageQuery',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        operationName: 'LocalStorageQuery',
                        query: (0, $hfKCi.LocalStorageQuery),
                        variables: variables
                    })
                });
                if (res.ok) {
                    const { data: data } = await res.json();
                    result = data?.localStorage?.stringValues;
                }
            }
        } catch (e) {}
        return window['__REMOTE_LOCAL_STORAGE__'] = result;
    });
}

});
parcelRegister("hfKCi", function(module, exports) {

$parcel$export(module.exports, "LocalStorageQuery", () => $045f09a1878b32fd$export$72dc662ac05b1fbb);
const $045f09a1878b32fd$export$72dc662ac05b1fbb = `
  query LocalStorageQuery($stringKeys: [String]!) {
    localStorage {
      stringValues(keys: $stringKeys) {
        key
        value
      }
    }
  }
`;

});


parcelRegister("blhvm", function(module, exports) {

$parcel$export(module.exports, "patchLocalStorage", () => $c417ee49d66f0195$export$87ce35ca55792fef);

var $5MeCb = parcelRequire("5MeCb");
const $c417ee49d66f0195$export$87ce35ca55792fef = ()=>{
    const realSetItem = window.localStorage.setItem;
    function newSetItem(...args) {
        try {
            return realSetItem.apply(this, args);
        } catch (e) {
            if ((0, $5MeCb.isQuotaExceededError)(e)) window.dispatchEvent(new CustomEvent('local-storage.quota.exceeded'));
            throw e;
        }
    }
    window.localStorage.setItem = newSetItem;
};

});


parcelRegister("gpK3n", function(module, exports) {

$parcel$export(module.exports, "getPerformanceEntries", () => $ebf4d3ce910d3665$export$6adfe6668ae1a7f8);
$parcel$export(module.exports, "collectDurationFromPerfMarkers", () => $ebf4d3ce910d3665$export$a52fc5851be9b858);

var $kGrzq = parcelRequire("kGrzq");
const $ebf4d3ce910d3665$export$6adfe6668ae1a7f8 = (prefix)=>{
    const filteredMarkers = (window.performance?.getEntriesByType?.('mark') || []).filter((marker)=>marker.name.startsWith(prefix));
    filteredMarkers.sort((a, b)=>a.startTime - b.startTime);
    return filteredMarkers;
};
const $ebf4d3ce910d3665$export$a52fc5851be9b858 = (prefix)=>{
    const measures = new (0, $kGrzq.BaseMeasures)();
    for (const { name: name, startTime: startTime } of $ebf4d3ce910d3665$export$6adfe6668ae1a7f8(prefix)){
        const fieldName = name.replace(/\.start|\.end$/, '').replace(prefix, '');
        // Handle multiple pairs of markers due to re-renders
        if (name.endsWith('.start')) measures.markMeasureStart(fieldName, Math.floor(startTime));
        else measures.markMeasureEnd(fieldName, Math.floor(startTime), true);
    }
    const durations = {};
    for (const [name, { duration: duration }] of Object.entries(measures.getMeasures()))durations[name] = duration;
    return durations;
};

});

parcelRegister("3kTfj", function(module, exports) {

$parcel$export(module.exports, "browserMetrics", () => $473ea7efe1dbee82$export$c08e7affcf78b064);

var $h6RR2 = parcelRequire("h6RR2");

var $7RgFv = parcelRequire("7RgFv");

var $69Zr8 = parcelRequire("69Zr8");

var $2BcbG = parcelRequire("2BcbG");

var $c1uRl = parcelRequire("c1uRl");

var $lH7GJ = parcelRequire("lH7GJ");

var $11Zqj = parcelRequire("11Zqj");

var $j4jXg = parcelRequire("j4jXg");
const $473ea7efe1dbee82$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            (0, $2BcbG.visibilityChangeObserver).start();
            if (config.events[(0, $j4jXg.BMEventsType).WEB_VITALS]?.enabled) (0, $c1uRl.webVitalsObserver).start();
            if (config.debug) {
                (0, $7RgFv.logger).enable();
                (0, $11Zqj.submitter).setDebug(true);
                (0, $69Zr8.pageLoadMetaMetric).setDebug(true);
            }
            (0, $11Zqj.submitter).configure(config);
            if (config.ssr?.getDoneMark) (0, $h6RR2.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $lH7GJ.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $69Zr8.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $69Zr8.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $69Zr8.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $69Zr8.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $473ea7efe1dbee82$export$c08e7affcf78b064 = $473ea7efe1dbee82$var$makeBrowserMetrics();

});
parcelRegister("h6RR2", function(module, exports) {

$parcel$export(module.exports, "SSRGetDoneMark", () => $ccbe82b8c20465d3$export$9e87a201397ac0a9);
const $ccbe82b8c20465d3$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $ccbe82b8c20465d3$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("7RgFv", function(module, exports) {

$parcel$export(module.exports, "logger", () => $de756a2051fbb2ae$export$af88d00dbe7f521);
const $de756a2051fbb2ae$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};

});

parcelRegister("69Zr8", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetaMetric", () => $31e407dce760f8b0$export$24b7a1a311eb05dc);

var $j4jXg = parcelRequire("j4jXg");

var $4k3LC = parcelRequire("4k3LC");

var $3znwT = parcelRequire("3znwT");
class $31e407dce760f8b0$export$9609608c00ea5077 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $4k3LC.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args);
        this.activePageLoadMetric = null;
    }
}
const $31e407dce760f8b0$export$24b7a1a311eb05dc = new $31e407dce760f8b0$export$9609608c00ea5077({
    type: (0, $j4jXg.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("j4jXg", function(module, exports) {

$parcel$export(module.exports, "BMEventsType", () => $d2d81ebd075ab34b$export$9c73e297d4be9159);
$parcel$export(module.exports, "StorableBMEventsType", () => $d2d81ebd075ab34b$export$9b7037ec30489597);
$parcel$export(module.exports, "BMPageLoadMetrics", () => $d2d81ebd075ab34b$export$74c1fb0997d51e2a);
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", () => $d2d81ebd075ab34b$export$88195ac8200d03a6);
$parcel$export(module.exports, "BMInteractionMetrics", () => $d2d81ebd075ab34b$export$6e28252a002afdb2);
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", () => $d2d81ebd075ab34b$export$474154836bfd8dd9);
$parcel$export(module.exports, "PageVisibleFields", () => $d2d81ebd075ab34b$export$e89802082dab5633);
$parcel$export(module.exports, "PageVisibleValueOrigin", () => $d2d81ebd075ab34b$export$983b017156c2aee2);
$parcel$export(module.exports, "isDetailedPageLoadSlo", () => $d2d81ebd075ab34b$export$5866f95702a15142);
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", () => $d2d81ebd075ab34b$export$f087a59bd717e49d);
$parcel$export(module.exports, "isInteractionMetricsSlo", () => $d2d81ebd075ab34b$export$b10c1d9a7db7765b);
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", () => $d2d81ebd075ab34b$export$60c0193054fc3040);

var $4k3LC = parcelRequire("4k3LC");
var $d2d81ebd075ab34b$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $d2d81ebd075ab34b$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $d2d81ebd075ab34b$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $d2d81ebd075ab34b$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $d2d81ebd075ab34b$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $d2d81ebd075ab34b$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $d2d81ebd075ab34b$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $d2d81ebd075ab34b$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
const $d2d81ebd075ab34b$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};
const $d2d81ebd075ab34b$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};
const $d2d81ebd075ab34b$export$153c4c72fa5eeece = (data)=>{
    const obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
const $d2d81ebd075ab34b$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $d2d81ebd075ab34b$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("4k3LC", function(module, exports) {

$parcel$export(module.exports, "MetricState", () => $233403977176019b$export$1e458f18c0c7bfe3);
$parcel$export(module.exports, "PageVisibleState", () => $233403977176019b$export$a12c67b37a306b13);
$parcel$export(module.exports, "BaseMetric", () => $233403977176019b$export$2bce4ffdd840e878);

var $jGRlW = parcelRequire("jGRlW");

var $7RgFv = parcelRequire("7RgFv");

var $2BcbG = parcelRequire("2BcbG");

var $8hwiw = parcelRequire("8hwiw");
var $233403977176019b$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $233403977176019b$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $233403977176019b$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $233403977176019b$export$2bce4ffdd840e878 {
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $7RgFv.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $233403977176019b$var$getPageVisibleState();
        (0, $2BcbG.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $7RgFv.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $7RgFv.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $2BcbG.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return true;
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $7RgFv.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $2BcbG.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
   *
   * @param metric
   * The array of Until metrics can be of two types
   * This function returns an UntilExperience
   */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $233403977176019b$export$2bce4ffdd840e878 ? (0, $8hwiw.UntilExperience).fromMetric(metricOrConfig) : (0, $8hwiw.UntilExperience).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = currentLatestSegment?.getFullyInteractiveStopTime() ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment?.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment?.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $233403977176019b$var$getPageVisibleState();
    }
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.config = void 0;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $233403977176019b$var$getPageVisibleState();
        this.key = void 0;
        this.type = void 0;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        this.config.timings?.forEach((entry)=>{
            if ((0, $jGRlW.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
}
$233403977176019b$export$2bce4ffdd840e878.FMP = 'fmp';

});
parcelRegister("jGRlW", function(module, exports) {

$parcel$export(module.exports, "restrictedTimingKeys", () => $cb88293f5f41b972$export$1d17377365286b00);
$parcel$export(module.exports, "clsWaitTimeMs", () => $cb88293f5f41b972$export$df21d285cfcda81e);
const $cb88293f5f41b972$export$1d17377365286b00 = [
    'ssr'
];
const $cb88293f5f41b972$export$df21d285cfcda81e = 7500;

});

parcelRegister("2BcbG", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $301057c16b344423$export$13e680397ec8f3eb);
class $301057c16b344423$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $301057c16b344423$export$13e680397ec8f3eb = new $301057c16b344423$var$VisibilityChangeObserver();

});

parcelRegister("8hwiw", function(module, exports) {

$parcel$export(module.exports, "UntilExperience", () => $36ec057a8677823e$export$3fcc0936ee2cc852);
class $36ec057a8677823e$export$3fcc0936ee2cc852 {
    static fromConfig(config) {
        return new $36ec057a8677823e$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $36ec057a8677823e$export$3fcc0936ee2cc852(metric);
    }
    /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$36ec057a8677823e$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
   * Get the time it takes for a segment to become fully interactable,
   * regardless of whether it uses the FMP as the stop time. (Eventual load)
   */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$36ec057a8677823e$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
}
$36ec057a8677823e$export$3fcc0936ee2cc852.FMP = 'fmp';

});



parcelRegister("3znwT", function(module, exports) {

$parcel$export(module.exports, "BasePageLoadMetric", () => $f7f7f3887cc305ae$export$fd1447b187f590fe);

var $7RgFv = parcelRequire("7RgFv");

var $4k3LC = parcelRequire("4k3LC");
class $f7f7f3887cc305ae$export$fd1447b187f590fe extends (0, $4k3LC.BaseMetric) {
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $7RgFv.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $4k3LC.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $7RgFv.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $7RgFv.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $f7f7f3887cc305ae$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $f7f7f3887cc305ae$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($f7f7f3887cc305ae$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
    constructor(args){
        super(args);
        this.isInitial = true;
        this.explicitTimings = null;
        this.config = void 0;
        this.config = args;
    }
}
$f7f7f3887cc305ae$export$fd1447b187f590fe.FMP = 'fmp';

});


parcelRegister("c1uRl", function(module, exports) {

$parcel$export(module.exports, "webVitalsObserver", () => $f0923312a6e4cc5b$export$253d38dccbb37615);


class $f0923312a6e4cc5b$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("h0Mxo"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("5soMc"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.ttciDetermined = void 0;
        this.webVitalsDetermined = void 0;
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $f0923312a6e4cc5b$export$253d38dccbb37615 = new $f0923312a6e4cc5b$var$WebVitalsObserver();

});
parcelRegister("h0Mxo", function(module, exports) {

let $c62816520ff3f039$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c62816520ff3f039$var$load("2NBvi").then(()=>parcelRequire('kNVhQ'));

});

parcelRegister("5soMc", function(module, exports) {

let $3f92c955648be1fb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3f92c955648be1fb$var$load("egrVC").then(()=>parcelRequire('lJOkF'));

});


parcelRegister("lH7GJ", function(module, exports) {

$parcel$export(module.exports, "Route", () => $3241056149fc9c6f$export$e7b0ac011bb776c6);
const $3241056149fc9c6f$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});

parcelRegister("11Zqj", function(module, exports) {

$parcel$export(module.exports, "submitter", () => $8505cab7e2dd39df$export$c21a25872e3f5a2b);

var $4u5NT = parcelRequire("4u5NT");

var $j4jXg = parcelRequire("j4jXg");

var $6EdIh = parcelRequire("6EdIh");

var $5vr33 = parcelRequire("5vr33");
const $8505cab7e2dd39df$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $5vr33.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $j4jXg.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $4u5NT.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $6EdIh.eventDataProcessor)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
    }
};

});
parcelRegister("6EdIh", function(module, exports) {

$parcel$export(module.exports, "eventDataProcessor", () => $e006c4b0ad00daa3$export$896b6e121bbaec25);

var $jGRlW = parcelRequire("jGRlW");

var $7RgFv = parcelRequire("7RgFv");

var $jm1nt = parcelRequire("jm1nt");

var $lalfC = parcelRequire("lalfC");

var $b0RNa = parcelRequire("b0RNa");

var $i7Arf = parcelRequire("i7Arf");

var $3nMMg = parcelRequire("3nMMg");

var $3S3Uv = parcelRequire("3S3Uv");

var $4ceR6 = parcelRequire("4ceR6");

var $9egOJ = parcelRequire("9egOJ");

var $8SJXI = parcelRequire("8SJXI");

var $csfaO = parcelRequire("csfaO");

var $6jhHi = parcelRequire("6jhHi");

var $aO17s = parcelRequire("aO17s");

var $bIrQl = parcelRequire("bIrQl");

var $8OZbM = parcelRequire("8OZbM");

var $99r43 = parcelRequire("99r43");

var $vqWHo = parcelRequire("vqWHo");

var $1ursX = parcelRequire("1ursX");

var $cPQrm = parcelRequire("cPQrm");

var $8a4zc = parcelRequire("8a4zc");

var $jP0eh = parcelRequire("jP0eh");

var $bwm9o = parcelRequire("bwm9o");

var $goclR = parcelRequire("goclR");

var $hSotW = parcelRequire("hSotW");

var $6jw6y = parcelRequire("6jw6y");

var $iNrJV = parcelRequire("iNrJV");

var $9S5ba = parcelRequire("9S5ba");

var $eIhG2 = parcelRequire("eIhG2");

var $hqz5T = parcelRequire("hqz5T");

var $lPbh8 = parcelRequire("lPbh8");

var $25UCq = parcelRequire("25UCq");

var $d1baU = parcelRequire("d1baU");

var $99bTZ = parcelRequire("99bTZ");

var $9US2G = parcelRequire("9US2G");

var $bJyuJ = parcelRequire("bJyuJ");

var $j4jXg = parcelRequire("j4jXg");
const $e006c4b0ad00daa3$var$defaultSet = [
    (0, $9egOJ.eventKey),
    (0, $bIrQl.eventType),
    (0, $csfaO.eventProduct),
    (0, $aO17s.eventRoute),
    (0, $3S3Uv.eventId),
    (0, $8SJXI.eventLocalTime),
    (0, $6jhHi.eventRegion),
    (0, $lalfC.appFramework),
    (0, $b0RNa.appVersion),
    (0, $i7Arf.bmVersion),
    (0, $hqz5T.telemetryBrowser),
    (0, $lPbh8.telemetryCpu),
    (0, $25UCq.telemetryMemory),
    (0, $d1baU.telemetryNetwork),
    (0, $3nMMg.customData),
    (0, $8OZbM.featureFlags),
    (0, $99r43.hostname),
    (0, $iNrJV.productCustomData),
    (0, $99bTZ.appTimings),
    (0, $bJyuJ.resourceTimings)
];
const $e006c4b0ad00daa3$var$pageLoadCommon = [
    ...$e006c4b0ad00daa3$var$defaultSet,
    (0, $hSotW.pageVisibleState),
    (0, $6jw6y.pageVisibleValue),
    (0, $4ceR6.eventInitial),
    (0, $jP0eh.pageLoadMetrics),
    (0, $9US2G.bundleEvalTimings)
];
const $e006c4b0ad00daa3$var$initialPageLoadSet = [
    ...$e006c4b0ad00daa3$var$pageLoadCommon,
    (0, $1ursX.initialPageLoadMetrics),
    (0, $8a4zc.navigationMetrics),
    (0, $eIhG2.ssrSuccess),
    (0, $9S5ba.ssrFeatureFlags)
];
const $e006c4b0ad00daa3$var$spaTransitionSet = [
    ...$e006c4b0ad00daa3$var$pageLoadCommon
];
const $e006c4b0ad00daa3$var$pageSegmentLoadSet = [
    ...$e006c4b0ad00daa3$var$defaultSet,
    (0, $bwm9o.pageSegmentLoadMetrics),
    (0, $hSotW.pageVisibleState),
    (0, $6jw6y.pageVisibleValue),
    (0, $4ceR6.eventInitial),
    (0, $9US2G.bundleEvalTimings)
];
const $e006c4b0ad00daa3$var$interactionSet = [
    ...$e006c4b0ad00daa3$var$defaultSet,
    (0, $hSotW.pageVisibleState),
    (0, $6jw6y.pageVisibleValue),
    (0, $cPQrm.interactionMetrics)
];
const $e006c4b0ad00daa3$var$customMetricSet = [
    ...$e006c4b0ad00daa3$var$defaultSet,
    (0, $hSotW.pageVisibleState),
    (0, $6jw6y.pageVisibleValue),
    (0, $vqWHo.customEventMetrics)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $e006c4b0ad00daa3$var$webVitalsMetricSet = [
    ...$e006c4b0ad00daa3$var$defaultSet,
    (0, $goclR.webVitalsMetrics)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $e006c4b0ad00daa3$var$waitForCLS = (delay = (0, $jGRlW.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $e006c4b0ad00daa3$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $7RgFv.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $j4jXg.BMEventsType).PAGE_LOAD && (0, $jm1nt.isPageLoadMetricData)(data) && data.isInitial) set = $e006c4b0ad00daa3$var$initialPageLoadSet;
    if (data.config.type === (0, $j4jXg.BMEventsType).PAGE_LOAD && (0, $jm1nt.isPageLoadMetricData)(data) && !data.isInitial) set = $e006c4b0ad00daa3$var$spaTransitionSet;
    if (data.config.type === (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD && (0, $jm1nt.isPageSegmentLoadMetricData)(data)) set = $e006c4b0ad00daa3$var$pageSegmentLoadSet;
    if (data.config.type === (0, $j4jXg.BMEventsType).INLINE_RESULT) set = $e006c4b0ad00daa3$var$interactionSet;
    if (data.config.type === (0, $j4jXg.BMEventsType).CUSTOM) set = $e006c4b0ad00daa3$var$customMetricSet;
    if (data.config.type === (0, $j4jXg.BMEventsType).WEB_VITALS) {
        set = $e006c4b0ad00daa3$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $e006c4b0ad00daa3$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};

});
parcelRegister("jm1nt", function(module, exports) {

$parcel$export(module.exports, "isPageLoadMetricData", () => $efcc8f2969c1a9e1$export$b0e12e7abb0bff11);
$parcel$export(module.exports, "isPageSegmentLoadMetricData", () => $efcc8f2969c1a9e1$export$83d0099ee6dbb5b0);
$parcel$export(module.exports, "isPageLoadConfig", () => $efcc8f2969c1a9e1$export$8672fa27ba8bba88);
$parcel$export(module.exports, "isPageSegmentLoadConfig", () => $efcc8f2969c1a9e1$export$abe063537ef4987b);
$parcel$export(module.exports, "isInteractionConfig", () => $efcc8f2969c1a9e1$export$ae68674b6a9353be);
$parcel$export(module.exports, "isCustomConfig", () => $efcc8f2969c1a9e1$export$b493eb8b2ba87421);

var $j4jXg = parcelRequire("j4jXg");
const $efcc8f2969c1a9e1$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $j4jXg.BMEventsType).PAGE_LOAD;
};
const $efcc8f2969c1a9e1$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $efcc8f2969c1a9e1$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $j4jXg.BMEventsType).PAGE_LOAD;
};
const $efcc8f2969c1a9e1$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $efcc8f2969c1a9e1$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $j4jXg.BMEventsType).INLINE_RESULT;
};
const $efcc8f2969c1a9e1$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $j4jXg.BMEventsType).CUSTOM;
};

});

parcelRegister("lalfC", function(module, exports) {

$parcel$export(module.exports, "appFramework", () => $424dc36f0807a928$export$e34e4529b979f74c);
const $424dc36f0807a928$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("b0RNa", function(module, exports) {

$parcel$export(module.exports, "appVersion", () => $6e8b1c857eebec48$export$82ae485178b37419);
const $6e8b1c857eebec48$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("i7Arf", function(module, exports) {

$parcel$export(module.exports, "bmVersion", () => $70dbe12aa2dfd563$export$5cafa465fc876895);
const $70dbe12aa2dfd563$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};

});

parcelRegister("3nMMg", function(module, exports) {

$parcel$export(module.exports, "customData", () => $6e6463ef8e4e0e74$export$f7e743c7db162193);
const $6e6463ef8e4e0e74$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("3S3Uv", function(module, exports) {

$parcel$export(module.exports, "eventId", () => $44a21ec37983890e$export$aed28df7ac07d79a);
const $44a21ec37983890e$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};

});

parcelRegister("4ceR6", function(module, exports) {

$parcel$export(module.exports, "eventInitial", () => $99dd6e3f6551d108$export$fa8e91d436b3ef8b);

var $jm1nt = parcelRequire("jm1nt");
const $99dd6e3f6551d108$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $jm1nt.isPageLoadMetricData)(data) && !(0, $jm1nt.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("9egOJ", function(module, exports) {

$parcel$export(module.exports, "eventKey", () => $9e765cb34550f933$export$10be2d3a558d3f88);

var $epWWY = parcelRequire("epWWY");
const $9e765cb34550f933$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $epWWY.mapEventType)(config.type)}.${config.key}`
    };
};

});
parcelRegister("epWWY", function(module, exports) {

$parcel$export(module.exports, "mapEventType", () => $80dc3af8237ab164$export$b334d07f11140768);

var $j4jXg = parcelRequire("j4jXg");
const $80dc3af8237ab164$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $j4jXg.BMEventsType).CUSTOM:
            return (0, $j4jXg.StorableBMEventsType).CUSTOM;
        case (0, $j4jXg.BMEventsType).INLINE_RESULT:
            return (0, $j4jXg.StorableBMEventsType).INLINE_RESULT;
        case (0, $j4jXg.BMEventsType).PAGE_LOAD:
            return (0, $j4jXg.StorableBMEventsType).PAGE_LOAD;
        case (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $j4jXg.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $j4jXg.BMEventsType).WEB_VITALS:
            return (0, $j4jXg.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("8SJXI", function(module, exports) {

$parcel$export(module.exports, "eventLocalTime", () => $80a17b6788fb547a$export$5219854ae7ec45da);

var $62ptY = parcelRequire("62ptY");
const $80a17b6788fb547a$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $62ptY.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $62ptY.default)(new Date(), 'i'), 10)
    });

});

parcelRegister("csfaO", function(module, exports) {

$parcel$export(module.exports, "eventProduct", () => $2f0a4cde357a0769$export$a7df4e8088db8843);
const $2f0a4cde357a0769$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};

});

parcelRegister("6jhHi", function(module, exports) {

$parcel$export(module.exports, "eventRegion", () => $35cb4ac3a690a03e$export$d0117b71adcdebc0);
const $35cb4ac3a690a03e$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};

});

parcelRegister("aO17s", function(module, exports) {

$parcel$export(module.exports, "eventRoute", () => $910243865496e322$export$44d3627af289ca16);
const $910243865496e322$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("bIrQl", function(module, exports) {

$parcel$export(module.exports, "eventType", () => $87a77fb0e31b1cc0$export$4c045e605d532c98);

var $epWWY = parcelRequire("epWWY");
const $87a77fb0e31b1cc0$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $epWWY.mapEventType)(config.type)
    };
};

});

parcelRegister("8OZbM", function(module, exports) {

$parcel$export(module.exports, "featureFlags", () => $04ff6b238051e023$export$e62953d023125748);
const $04ff6b238051e023$export$e62953d023125748 = (config, _data, globalConfig)=>{
    const localFeatureFlags = config.featureFlags?.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {}) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};

});

parcelRegister("99r43", function(module, exports) {

$parcel$export(module.exports, "hostname", () => $50145cd0851d18bd$export$640106f6dc7d2706);
const $50145cd0851d18bd$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("vqWHo", function(module, exports) {

$parcel$export(module.exports, "customEventMetrics", () => $b4ccb9ab041da62a$export$cab039265c52a2e9);

var $jm1nt = parcelRequire("jm1nt");
const $b4ccb9ab041da62a$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    if (!(0, $jm1nt.isCustomConfig)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (config.slo?.threshold !== undefined) {
        payload['metric:duration:slo'] = payload['metric:duration'] <= config.slo?.threshold;
        payload['metric:duration:slo:threshold'] = config.slo?.threshold;
    }
    if (config.histogram?.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("1ursX", function(module, exports) {

$parcel$export(module.exports, "initialPageLoadMetrics", () => $ab2376fa3ea38ed7$export$cc95aa3f6ea8e5cb);
const $ab2376fa3ea38ed7$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("cPQrm", function(module, exports) {

$parcel$export(module.exports, "interactionMetrics", () => $671959ab64cde9bf$export$86db56030b57ba34);

var $jm1nt = parcelRequire("jm1nt");

var $j4jXg = parcelRequire("j4jXg");
const $671959ab64cde9bf$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    if (!(0, $jm1nt.isInteractionConfig)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if (config.histogram?.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $j4jXg.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $j4jXg.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if (config.histogram?.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $j4jXg.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $j4jXg.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $j4jXg.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("8a4zc", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", () => $e10e43a829a5023f$export$b88d990436be0f8a);
const $e10e43a829a5023f$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("jP0eh", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", () => $0b776cd311b78b58$export$2878bf482e539059);

var $jm1nt = parcelRequire("jm1nt");

var $j4jXg = parcelRequire("j4jXg");
const $0b776cd311b78b58$var$getThreshold = (isInitial, metric)=>{
    return (0, $j4jXg.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $0b776cd311b78b58$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $0b776cd311b78b58$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $jm1nt.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $j4jXg.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $0b776cd311b78b58$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $0b776cd311b78b58$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $0b776cd311b78b58$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $0b776cd311b78b58$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $0b776cd311b78b58$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $0b776cd311b78b58$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};

});

parcelRegister("bwm9o", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoadMetrics", () => $22ff91b9f30764a0$export$ba86cb47f2f22db5);

var $69Zr8 = parcelRequire("69Zr8");

var $jm1nt = parcelRequire("jm1nt");

var $j4jXg = parcelRequire("j4jXg");
const $22ff91b9f30764a0$var$getThreshold = (isInitial, metric)=>{
    return (0, $j4jXg.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $22ff91b9f30764a0$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $22ff91b9f30764a0$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    if (!(0, $jm1nt.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $j4jXg.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $22ff91b9f30764a0$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $22ff91b9f30764a0$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $22ff91b9f30764a0$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $22ff91b9f30764a0$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if (config.slo?.fmp) {
        const threshold = $22ff91b9f30764a0$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo?.tti) {
        const threshold = $22ff91b9f30764a0$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $j4jXg.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $j4jXg.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};

});

parcelRegister("goclR", function(module, exports) {

$parcel$export(module.exports, "webVitalsMetrics", () => $7ec2d928c9c84cee$export$3731db279f590f30);

var $4k3LC = parcelRequire("4k3LC");

var $2BcbG = parcelRequire("2BcbG");

var $c1uRl = parcelRequire("c1uRl");

var $6jw6y = parcelRequire("6jw6y");
const $7ec2d928c9c84cee$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $4k3LC.PageVisibleState).MIXED;
    };
    (0, $2BcbG.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = globalConfig.webVitals?.ttciEnabled !== undefined ? globalConfig.webVitals?.ttciEnabled : true;
    const webVitalMetrics = await $7ec2d928c9c84cee$export$193ae490b52081dd(ttciEnabled, globalConfig.webVitals?.timeout || 30000);
    (0, $2BcbG.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $6jw6y.pageVisibleValue)(config, data, globalConfig)
    };
};
const $7ec2d928c9c84cee$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $c1uRl.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $c1uRl.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $c1uRl.webVitalsObserver).data;
};

});
parcelRegister("6jw6y", function(module, exports) {

$parcel$export(module.exports, "pageVisibleValue", () => $6b008d45a834dab9$export$177b923114656380);

var $4k3LC = parcelRequire("4k3LC");
var $j4jXg = parcelRequire("j4jXg");
const $6b008d45a834dab9$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $j4jXg.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $4k3LC.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});


parcelRegister("hSotW", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", () => $15e782691c8a124e$export$723b4c298aca63af);
const $15e782691c8a124e$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("iNrJV", function(module, exports) {

$parcel$export(module.exports, "productCustomData", () => $15388c422c57c113$export$fa2af6e412815a74);
const $15388c422c57c113$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};

});

parcelRegister("9S5ba", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", () => $280e5be904f73614$export$fdbea518c19dfa8);

var $j4jXg = parcelRequire("j4jXg");
const $280e5be904f73614$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $280e5be904f73614$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    // no config or missing
    if (!globalConfig.ssr?.getFeatureFlags) return null;
    const includeFeatureFlags = config.ssr?.includeFeatureFlags || globalConfig.ssr?.includeFeatureFlags || (0, $j4jXg.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $j4jXg.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || config.ssr?.doneAsFmp && includeFeatureFlags === (0, $j4jXg.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $280e5be904f73614$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};

});

parcelRegister("eIhG2", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", () => $ab47fb9471ac947b$export$a3dc8251cf55b2e0);
const $ab47fb9471ac947b$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("hqz5T", function(module, exports) {

$parcel$export(module.exports, "telemetryBrowser", () => $f09d583c5e93983f$export$386b10ac64a50b1);

var $cDast = parcelRequire("cDast");
const $f09d583c5e93983f$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cDast))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($cDast))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});

parcelRegister("lPbh8", function(module, exports) {

$parcel$export(module.exports, "telemetryCpu", () => $1159930910719782$export$9f84cb359ed29139);
const $1159930910719782$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("25UCq", function(module, exports) {

$parcel$export(module.exports, "telemetryMemory", () => $4c8b1c6ed30d2c96$export$496c14d72b257e07);
const $4c8b1c6ed30d2c96$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("d1baU", function(module, exports) {

$parcel$export(module.exports, "telemetryNetwork", () => $7a6e7161ff6869e1$export$88bf7b55f7fc4e8e);
const $7a6e7161ff6869e1$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("99bTZ", function(module, exports) {

$parcel$export(module.exports, "appTimings", () => $d50599dd2bf33f2d$export$e952f50a4f2d02da);

var $j4jXg = parcelRequire("j4jXg");

var $aJRos = parcelRequire("aJRos");

var $e1ZTA = parcelRequire("e1ZTA");
const $d50599dd2bf33f2d$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $j4jXg.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $aJRos.customTimings)(config, data);
    const ssr = config.type === (0, $j4jXg.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $e1ZTA.ssrTimings)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("aJRos", function(module, exports) {

$parcel$export(module.exports, "customTimings", () => $ff3b864a7caa86f4$export$6126f85083a72c6e);

var $LIEQX = parcelRequire("LIEQX");
const $ff3b864a7caa86f4$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $ff3b864a7caa86f4$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $ff3b864a7caa86f4$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $ff3b864a7caa86f4$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $LIEQX.NESTED_METRIC_SEPARATOR)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
parcelRegister("LIEQX", function(module, exports) {

$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", () => $53fd409e91f6c97b$export$b98e411ae80c806f);
const $53fd409e91f6c97b$export$b98e411ae80c806f = '/';

});


parcelRegister("e1ZTA", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", () => $98616be5571fa4a4$export$130f411261a599c5);

var $LIEQX = parcelRequire("LIEQX");
const $98616be5571fa4a4$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $98616be5571fa4a4$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $98616be5571fa4a4$var$SSR_PREFIX = 'ssr';
const $98616be5571fa4a4$var$mapKey = (key)=>{
    if (key === 'total') return $98616be5571fa4a4$var$SSR_PREFIX;
    return `${$98616be5571fa4a4$var$SSR_PREFIX}${0, $LIEQX.NESTED_METRIC_SEPARATOR}${key}`;
};
const $98616be5571fa4a4$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($98616be5571fa4a4$var$filterEntry(entry[1])) acc[$98616be5571fa4a4$var$mapKey(entry[0])] = $98616be5571fa4a4$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("9US2G", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", () => $cc11d350e6fa37d7$export$1a2bb347935fc536);
const $cc11d350e6fa37d7$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = globalConfig?.enableBundleEvalTimings ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $cc11d350e6fa37d7$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($cc11d350e6fa37d7$var$bundleEvalTimingsInternal(...args));
        });
    });
};

});

parcelRegister("bJyuJ", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", () => $6df3a42a4d7960d4$export$81a7d52441a06b50);
const $6df3a42a4d7960d4$var$cacheableTypes = [
    'script',
    'link'
];
const $6df3a42a4d7960d4$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $6df3a42a4d7960d4$var$CACHE_NETWORK = 'network';
const $6df3a42a4d7960d4$var$CACHE_MEMORY = 'memory';
const $6df3a42a4d7960d4$var$CACHE_DISK = 'disk';
const $6df3a42a4d7960d4$var$calculateTransferType = (type, duration, size)=>{
    if (!$6df3a42a4d7960d4$var$cacheableTypes.includes(type)) return $6df3a42a4d7960d4$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $6df3a42a4d7960d4$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $6df3a42a4d7960d4$var$CACHE_DISK;
    if (size === undefined) return null;
    return $6df3a42a4d7960d4$var$CACHE_NETWORK;
};
const $6df3a42a4d7960d4$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$6df3a42a4d7960d4$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $6df3a42a4d7960d4$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $6df3a42a4d7960d4$var$withoutHeaders = ()=>false;
const $6df3a42a4d7960d4$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $6df3a42a4d7960d4$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $6df3a42a4d7960d4$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $6df3a42a4d7960d4$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $6df3a42a4d7960d4$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $6df3a42a4d7960d4$var$getNetworkData = (item, eventStart, hasTimingHeaders = $6df3a42a4d7960d4$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$6df3a42a4d7960d4$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($6df3a42a4d7960d4$var$cacheableTypes.includes(type)) {
        const transferType = $6df3a42a4d7960d4$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$6df3a42a4d7960d4$var$getSizeObject(size)
        };
        if (transferType !== $6df3a42a4d7960d4$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$6df3a42a4d7960d4$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$6df3a42a4d7960d4$var$getSizeObject(size)
    };
};
const $6df3a42a4d7960d4$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $6df3a42a4d7960d4$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $6df3a42a4d7960d4$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$6df3a42a4d7960d4$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$6df3a42a4d7960d4$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});


parcelRegister("5vr33", function(module, exports) {

$parcel$export(module.exports, "makeShareableGlobalConfig", () => $eb97406c20d3bb4c$export$5b4fb14409a2a825);

var $j4jXg = parcelRequire("j4jXg");
const $eb97406c20d3bb4c$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $eb97406c20d3bb4c$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = eventConfig?.pageVisibleValueOrigin ?? allEventsConfig?.pageVisibleValueOrigin ?? (0, $j4jXg.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($eb97406c20d3bb4c$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig?.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig?.enableBundleEvalTimings
    });
};
const $eb97406c20d3bb4c$export$5b4fb14409a2a825 = async (globalConfig)=>{
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: globalConfig.events[(0, $j4jXg.BMEventsType).WEB_VITALS]?.enabled,
            timeout: globalConfig.events[(0, $j4jXg.BMEventsType).WEB_VITALS]?.timeout,
            ttciEnabled: globalConfig.events[(0, $j4jXg.BMEventsType).WEB_VITALS]?.ttciEnabled
        }
    };
    return {
        [(0, $j4jXg.BMEventsType).PAGE_LOAD]: $eb97406c20d3bb4c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $j4jXg.BMEventsType).PAGE_LOAD]),
        [(0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD]: $eb97406c20d3bb4c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $j4jXg.BMEventsType).INLINE_RESULT]: $eb97406c20d3bb4c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $j4jXg.BMEventsType).INLINE_RESULT]),
        [(0, $j4jXg.BMEventsType).CUSTOM]: $eb97406c20d3bb4c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $j4jXg.BMEventsType).CUSTOM]),
        [(0, $j4jXg.BMEventsType).WEB_VITALS]: $eb97406c20d3bb4c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $j4jXg.BMEventsType).WEB_VITALS])
    };
};

});



parcelRegister("6vg9V", function(module, exports) {

$parcel$export(module.exports, "initMetalClient", () => $45686ac01c9cf60d$export$3a42ebcb7c12336a);
$parcel$export(module.exports, "getMetalClient", () => $45686ac01c9cf60d$export$7ac70c72d404ac36);

var $eSuZj = parcelRequire("eSuZj");

var $6X8o4 = parcelRequire("6X8o4");
let $45686ac01c9cf60d$var$provideClient;
const $45686ac01c9cf60d$var$metalClientPromise = (0, $6X8o4.liftPromiseState)(new Promise((resolve)=>{
    $45686ac01c9cf60d$var$provideClient = resolve;
}));

const $45686ac01c9cf60d$export$3a42ebcb7c12336a = ({ environment: environment, synthetic: synthetic })=>{
    Promise.all([
        (parcelRequire("2Ofge"))
    ]).then(([MetalClientModule])=>{
        const { default: MetalClient, envTypes: envTypes } = MetalClientModule;
        const metalEnvironment = // In dev, proxying to a site will give that site's environment,
        // which is not what we want
        window.location.hostname === 'localhost' ? envTypes.DEV : environment === 'STAGING' ? envTypes.STAGING : environment === 'PRODUCTION' ? envTypes.PROD : envTypes.DEV;
        const productInfo = {
            metalId: '88dcca98-e854-4063-954c-eabe3aeb25d2',
            version: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
            env: metalEnvironment
        };
        const settings = {
            meta: {
                synthetic: synthetic
            }
        };
        const metalClient = new MetalClient({
            productInfo: productInfo,
            settings: settings
        });
        $45686ac01c9cf60d$var$provideClient(metalClient);
    }).catch((error)=>{
        throw new Error(`Fail to import metal-client: ${error}`);
    });
};
const $45686ac01c9cf60d$export$7ac70c72d404ac36 = ()=>$45686ac01c9cf60d$var$metalClientPromise;

});
parcelRegister("2Ofge", function(module, exports) {

let $20bc16c66b73f229$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $20bc16c66b73f229$var$load("egrVC"),
    $20bc16c66b73f229$var$load("gvaCb")
]).then(()=>parcelRequire('fILuR'));

});


parcelRegister("45prt", function(module, exports) {

$parcel$export(module.exports, "getSSRFeatureFlag", () => $2eb04c81cbe63357$export$a8d5a1f8cf02de5);
let $2eb04c81cbe63357$var$flags = typeof window !== 'undefined' ? window['__SSR_FEATURE_FLAGS__'] || {} : {};
function $2eb04c81cbe63357$export$f9d0db67c92b2ab2(map = {}) {
    // Apply overrides from url query params
    $2eb04c81cbe63357$var$flags = {
        ...map
    };
}
function $2eb04c81cbe63357$export$a8d5a1f8cf02de5(key) {
    return key in $2eb04c81cbe63357$var$flags ? $2eb04c81cbe63357$var$flags[key] : null;
}
function $2eb04c81cbe63357$export$36416368cbc77142() {
    return $2eb04c81cbe63357$var$flags;
}

});

parcelRegister("hpjl4", function(module, exports) {

$parcel$export(module.exports, "JS_LOAD_START", () => $8ec1d41979385654$export$9ef9aab55130f276);
$parcel$export(module.exports, "JS_LOAD_END", () => $8ec1d41979385654$export$c3d490e973eda5e2);
const $8ec1d41979385654$export$9ef9aab55130f276 = ':load-start';
const $8ec1d41979385654$export$c3d490e973eda5e2 = ':load-end';

});

parcelRegister("2oDRW", function(module, exports) {

$parcel$export(module.exports, "FF_ALLOWLIST_FOR_PERF_METRICS", () => $a7aad5d0a1d87072$export$eb13033bc77c7e96);
$parcel$export(module.exports, "ALLOWLIST_FFS_CUSTOM_EVENTS", () => $a7aad5d0a1d87072$export$e669174961337a38);
// used for page-load and page-segment-load events
const $a7aad5d0a1d87072$export$eb13033bc77c7e96 = [
    'confluence.ssr.page-statuses',
    'analytics-next-use-modern-context_jira',
    'confluence_ssr_enable_tesseract_stream_endpoint',
    'confluence_use_canary',
    'confluence_use_parcel',
    'confluence_frontend_use_modern_rendering_engine',
    'confluence_ssr_load_after_paint_loadables_as_paint',
    'ssr_end_of_page_recommendation',
    'confluence_ssr_enable_hydration',
    'confluence_react_streaming',
    'confluence_ssr_enable_hydration_home',
    'confluence_preload_forge_viewport_heights',
    'confluence_frontend_vc_observer_initialization',
    'platform_fix_banner_spacer_vc',
    'platform_fix_media_image_resizing',
    'confluence_frontend_preload_edit_and_analytics',
    'platform_exclude_media_offender_from_vc',
    'confluence_ssr_enable_hydration_space_overview',
    'confluence_frontend_remove_comments_placeholder',
    'enable_loadable_placeholder_for_legacy_macros',
    'confluence_frontend_remove_eop_initial_animation',
    'confluence_frontend_cache_pagetree_reference',
    'confluence_frontend_tree_create_popover_offset',
    'confluence_frontend_memoize_content_tree_rendering',
    'edition_awareness_standard_upsell_confluence_ab',
    'edition_awareness_standard_upsell_confluence_ab_fg',
    'platform_exclude_media_single_from_vc',
    'confluence_frontend_content_body_container',
    'platform-ssr-table-resize',
    'confluence_ssr_permissions_error_handler',
    'confluence_frontend_show_breadcrumbs_initial_load',
    'platform_hide_heading_anchor_wrapper_before_hover',
    'team-bi-directional-container-connection',
    'confluence_frontend_ssr_autohighlights',
    'cc_search_input_open_press_tracing',
    'cc_fix_spaceoverview_macro_preload',
    'cc_fix_macro_resource_ssr'
];
const $a7aad5d0a1d87072$export$e669174961337a38 = [];

});

parcelRegister("78QFu", function(module, exports) {

$parcel$export(module.exports, "getUniquePageLoadId", () => $f3219f2436e4dde1$export$3dc3660453120ccc);
$parcel$export(module.exports, "setUniquePageLoadId", () => $f3219f2436e4dde1$export$8c17c676096b7909);
$parcel$export(module.exports, "setIsLivePage", () => $f3219f2436e4dde1$export$2cb0d16c23c1cda0);

var $lMdlY = parcelRequire("lMdlY");

var $iVwsA = parcelRequire("iVwsA");
const $f3219f2436e4dde1$export$3dc3660453120ccc = ()=>{
    (0, $iVwsA.pageLoadState).currentSavedTimestamp = performance.now();
    const activeTrace = (0, $lMdlY.getActiveTrace)();
    const activeTraceId = activeTrace?.traceId;
    return {
        uuid: (0, $iVwsA.pageLoadState).uuid,
        contentId: (0, $iVwsA.pageLoadState).pageId,
        isInitial: (0, $iVwsA.pageLoadState).transitionId === 0,
        isSSR: Boolean(window['__SSR_RENDERED__']),
        routingDuration: (0, $iVwsA.pageLoadState).currentSavedTimestamp - (0, $iVwsA.pageLoadState).routingTimestamp,
        ...activeTraceId ? {
            ufoTraceId: activeTraceId,
            ufoTraceType: activeTrace.type
        } : {},
        ...(0, $iVwsA.pageLoadState).isLivePage !== null ? {
            isLivePage: (0, $iVwsA.pageLoadState).isLivePage
        } : {}
    };
};
const $f3219f2436e4dde1$export$eef458cd11f4b6e7 = ()=>{
    return (0, $iVwsA.pageLoadState).currentSavedTimestamp;
};
const $f3219f2436e4dde1$export$8c17c676096b7909 = (routeName = '', match, transitionId, userInfo)=>{
    const contentId = match?.params?.contentId;
    const useUserInfo = userInfo.userId;
    if ((0, $iVwsA.pageLoadState).pageId !== contentId || (0, $iVwsA.pageLoadState).routeName !== routeName) {
        let savedUniqueId;
        if (useUserInfo) savedUniqueId = $f3219f2436e4dde1$var$createPageLoadId(routeName, contentId, userInfo);
        else savedUniqueId = $f3219f2436e4dde1$var$createUniqueId();
        (0, $iVwsA.pageLoadState).uuid = savedUniqueId;
        (0, $iVwsA.pageLoadState).routeName = routeName;
        (0, $iVwsA.pageLoadState).pageId = contentId;
        (0, $iVwsA.pageLoadState).transitionId = transitionId;
        (0, $iVwsA.pageLoadState).routingTimestamp = performance.now();
    }
};
const $f3219f2436e4dde1$export$2cb0d16c23c1cda0 = (isLivePage)=>{
    (0, $iVwsA.pageLoadState).isLivePage = isLivePage;
};
// refer to https://gist.github.com/jed/982883 for uuid generation
// For Anonymous users
const $f3219f2436e4dde1$var$createUniqueId = ()=>{
    return `${1e7}${-1000}${-4000}${-8000}${-100000000000}`.replace(/1|0/g, function() {
        // This is a LEGACY disable statement after rule addition. Use `Math.floor()` next time
        // eslint-disable-next-line no-bitwise
        return (0 | Math.random() * 16).toString(16);
    });
};
// For Atlassian users
const $f3219f2436e4dde1$var$createPageLoadId = (routeName, contentId, userInfo)=>{
    const { userId: userId, cloudId: cloudId } = userInfo;
    routeName = routeName || 'route';
    contentId = contentId || 'page';
    // TO-DO ask Dennis if he wants to take any of these out
    return `${routeName}-${contentId}-${userId}-${cloudId}-${Date.now()}`;
};

});
parcelRegister("iVwsA", function(module, exports) {

$parcel$export(module.exports, "pageLoadState", () => $eb84b6996ee1c453$export$1e9642d012cc75d6);
const $eb84b6996ee1c453$export$1e9642d012cc75d6 = {
    uuid: null,
    pageId: '',
    routeName: '',
    transitionId: 0,
    routingTimestamp: 0,
    currentSavedTimestamp: 0,
    isLivePage: null
};

});


parcelRegister("dPJCf", function(module, exports) {

$parcel$export(module.exports, "RouteStateContainer", () => $58376b192eccc221$export$52c04f66b1983f2a);
$parcel$export(module.exports, "useRouteActions", () => $58376b192eccc221$export$2467ee40aa778f80);
$parcel$export(module.exports, "createRouteParamHook", () => $58376b192eccc221$export$a434162a7524cfb3);
$parcel$export(module.exports, "createSingleQueryParamHook", () => $58376b192eccc221$export$a3421b85303fa9de);
$parcel$export(module.exports, "useHash", () => $58376b192eccc221$export$b1482fdc3ffb1b4a);
$parcel$export(module.exports, "useRouteUrl", () => $58376b192eccc221$export$244d8f2aa1ab504f);
$parcel$export(module.exports, "useRouteName", () => $58376b192eccc221$export$30aadaab39fae199);
$parcel$export(module.exports, "useRouteDataRef", () => $58376b192eccc221$export$c9f0d094e50e1bbc);
$parcel$export(module.exports, "useTransitionId", () => $58376b192eccc221$export$7926129229271134);
$parcel$export(module.exports, "useIsTransition", () => $58376b192eccc221$export$632429935326e9d2);
$parcel$export(module.exports, "useHistory", () => $58376b192eccc221$export$3420e1dc2c4a518c);
$parcel$export(module.exports, "useMatchRoute", () => $58376b192eccc221$export$d2ec911fa7f74821);
$parcel$export(module.exports, "usePathnameMatcher", () => $58376b192eccc221$export$ce9ea1d788472f7b);

var $jiJCD = parcelRequire("jiJCD");

var $gwFzn = parcelRequire("gwFzn");

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");
var $bd25s = parcelRequire("bd25s");

var $054Kg = parcelRequire("054Kg");
const $58376b192eccc221$var$nullNoop = ()=>null;
const $58376b192eccc221$var$objNoop = ()=>({});
const $58376b192eccc221$var$stringNoop = ()=>'';
const $58376b192eccc221$var$voidNoop = ()=>{};
const $58376b192eccc221$var$RouteStore = (0, $4ZoIm.createStore)({
    initialState: {
        getHref: $58376b192eccc221$var$stringNoop,
        history: null,
        location: null,
        match: null,
        transitionId: null,
        toUrl: $58376b192eccc221$var$stringNoop,
        matchRoute: $58376b192eccc221$var$nullNoop,
        matchSupportedRoute: $58376b192eccc221$var$nullNoop,
        getQueryParams: $58376b192eccc221$var$objNoop,
        setQueryParams: $58376b192eccc221$var$voidNoop,
        getHash: $58376b192eccc221$var$stringNoop,
        setHash: $58376b192eccc221$var$voidNoop,
        replace: $58376b192eccc221$var$voidNoop,
        routes: [],
        push: $58376b192eccc221$var$voidNoop,
        open: $58376b192eccc221$var$nullNoop,
        onPageReload: $58376b192eccc221$var$voidNoop,
        preloadRoute: $58376b192eccc221$var$voidNoop
    },
    actions: {
        push (...args) {
            return ({ getState: getState })=>getState().push(...args);
        },
        replace (...args) {
            return ({ getState: getState })=>getState().replace(...args);
        },
        setQueryParams: (query, replace)=>({ getState: getState })=>getState().setQueryParams(query, replace),
        setHash: (hash)=>({ getState: getState })=>getState().setHash(hash),
        getLatestRouteData: ()=>({ getState: getState })=>{
                const match = getState().match;
                return {
                    routeName: match?.name,
                    routeParams: match?.params ?? {},
                    hash: getState().location?.hash?.substring(1) ?? '',
                    href: getState().getHref(),
                    queryParams: (0, $jiJCD.parse)(getState().location?.search ?? '', true)?.query,
                    toUrl: match?.toUrl?.bind(match) ?? function() {
                        return '';
                    }
                };
            },
        overrideUFORouteName: (newName)=>({ getState: getState })=>{
                (0, $054Kg.updatePageloadName)(newName, getState().match?.name);
            }
    },
    name: 'RouteState'
});
const $58376b192eccc221$export$52c04f66b1983f2a = (0, $2S0Fz.createContainer)($58376b192eccc221$var$RouteStore, {
    onInit: ()=>({ setState: setState }, routeState)=>{
            setState(routeState);
        },
    onUpdate: ()=>({ setState: setState }, routeState)=>{
            setState(routeState);
        }
});
const $58376b192eccc221$export$d4f74eb8532c85b4 = (0, $bd25s.createSubscriber)($58376b192eccc221$var$RouteStore);
/**
 * `useAllRouteActions` exposes all RouteState actions for internal use.
 * This is used to limit which route actions are publicly exposed.
 */ const $58376b192eccc221$var$useAllRouteActions = (0, $iFWZA.createActionsHook)($58376b192eccc221$var$RouteStore);
const $58376b192eccc221$export$2467ee40aa778f80 = ()=>{
    const { push: push, replace: replace, setQueryParams: setQueryParams, setHash: setHash, overrideUFORouteName: overrideUFORouteName } = $58376b192eccc221$var$useAllRouteActions();
    return {
        push: /** See {@link RouteActionsType.push} for documentation */ push,
        replace: /** See {@link RouteActionsType.replace} for documentation */ replace,
        setQueryParams: /** See {@link RouteActionsType.setQueryParams} for documentation */ setQueryParams,
        setHash: /** See {@link RouteActionsType.setHash} for documentation */ setHash,
        overrideUFORouteName: /** See {@link RouteActionsType.overrideUFORouteName} for documentation */ overrideUFORouteName
    };
};
const $58376b192eccc221$export$a434162a7524cfb3 = (routeParam)=>(0, $iFWZA.createStateHook)($58376b192eccc221$var$RouteStore, {
        selector: (state)=>state?.match?.params?.[routeParam]
    });
const $58376b192eccc221$export$a3421b85303fa9de = (queryParam)=>$58376b192eccc221$export$a7bf969075a175d2(queryParam, (parseResult)=>$58376b192eccc221$var$singleQueryParamParser(parseResult));
const $58376b192eccc221$export$2c2c4e775b5e6393 = (queryParam)=>$58376b192eccc221$export$a7bf969075a175d2(queryParam, (parseResult)=>{
        if (parseResult === '') return [];
        else if (typeof parseResult === 'string') return [
            parseResult
        ];
        return parseResult;
    });
const $58376b192eccc221$export$a7bf969075a175d2 = (queryParam, customParser)=>(0, $iFWZA.createStateHook)($58376b192eccc221$var$RouteStore, {
        selector: (state)=>{
            const parseResult = (0, $jiJCD.parse)(state.location?.search ?? '', true)?.query?.[queryParam];
            return customParser(parseResult);
        }
    });
const $58376b192eccc221$export$b1482fdc3ffb1b4a = (0, $iFWZA.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state)=>{
        const hash = state.location?.hash;
        return hash ? hash.substring(1) : '';
    }
});
const $58376b192eccc221$export$244d8f2aa1ab504f = (0, $iFWZA.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.match?.url);
    }
});
const $58376b192eccc221$export$30aadaab39fae199 = (0, $iFWZA.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.match?.name);
    }
});
function $58376b192eccc221$var$singleQueryParamParser(parseResult) {
    return Array.isArray(parseResult) ? parseResult?.[0] : parseResult;
}
function $58376b192eccc221$export$85e000103cdf6a77(route) {
    return $58376b192eccc221$export$30aadaab39fae199({
        selector: (matchName)=>matchName === route.name
    });
}
const $58376b192eccc221$export$c9f0d094e50e1bbc = ()=>{
    const { getLatestRouteData: getLatestRouteData } = $58376b192eccc221$var$useAllRouteActions();
    return (0, $gwFzn.useMemo)(()=>({
            get current () {
                return getLatestRouteData();
            }
        }), [
        getLatestRouteData
    ]);
};
const $58376b192eccc221$export$7926129229271134 = (0, $iFWZA.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state)=>state.transitionId ?? 0
});
const $58376b192eccc221$export$632429935326e9d2 = (0, $iFWZA.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state)=>!!state.transitionId
});
const $58376b192eccc221$export$3420e1dc2c4a518c = (0, $iFWZA.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state)=>state.history
});
const $58376b192eccc221$export$d2ec911fa7f74821 = (0, $iFWZA.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state)=>state.matchRoute
});
const $58376b192eccc221$export$ce9ea1d788472f7b = (0, $iFWZA.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.location?.pathname);
    }
});

});
parcelRegister("054Kg", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c6d94f33ca9a8a9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "updatePageloadName", () => $0c6d94f33ca9a8a9$export$d0f99433cd4f4028);

var $9HkI0 = parcelRequire("9HkI0");

var $1haRI = parcelRequire("1haRI");

var $53d5Q = parcelRequire("53d5Q");

var $lMdlY = parcelRequire("lMdlY");

var $feexy = parcelRequire("feexy");

var $4u5NT = parcelRequire("4u5NT");

var $ic4nn = parcelRequire("ic4nn");
const $0c6d94f33ca9a8a9$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $0c6d94f33ca9a8a9$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    const activeInteraction = (0, $4u5NT.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $ic4nn.default).current = routeName || null;
    const rate = ufoName ? (0, $53d5Q.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $1haRI.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        const newId = (0, $9HkI0.v4)();
        (0, $feexy.DefaultInteractionID).current = newId;
        (0, $4u5NT.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $lMdlY.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $4u5NT.addHoldByID)(newId, [], $0c6d94f33ca9a8a9$var$AWAITING_PAGELOAD_NAME, $0c6d94f33ca9a8a9$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $4u5NT.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $4u5NT.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $4u5NT.removeHoldByID)(activeInteraction.id, $0c6d94f33ca9a8a9$var$AWAITING_PAGELOAD_NAME);
    }
}
var $0c6d94f33ca9a8a9$export$2e2bcd8739ae039 = $0c6d94f33ca9a8a9$var$traceUFOPageLoad;
function $0c6d94f33ca9a8a9$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $53d5Q.getInteractionRate)(ufoName, 'page_load');
        (0, $4u5NT.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $1haRI.default)(rate)) (0, $ic4nn.default).current = ufoName;
        else (0, $4u5NT.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $4u5NT.removeHoldByID)(interaction.id, $0c6d94f33ca9a8a9$var$AWAITING_PAGELOAD_NAME);
}

});


parcelRegister("gKr8t", function(module, exports) {

$parcel$export(module.exports, "apolloAGGCache", () => $6d0c6b833ab477dd$export$8ddb56c88a6a3feb);
$parcel$export(module.exports, "getAGGClient", () => $6d0c6b833ab477dd$export$13fdb03e350a572c);

var $aTqya = parcelRequire("aTqya");

var $gZ7FC = parcelRequire("gZ7FC");

var $3zyWe = parcelRequire("3zyWe");

var $csQ66 = parcelRequire("csQ66");

var $aU4fU = parcelRequire("aU4fU");

var $gTOUc = parcelRequire("gTOUc");

var $9wGTI = parcelRequire("9wGTI");

var $adWn1 = parcelRequire("adWn1");

var $9jPdT = parcelRequire("9jPdT");



var $iMHGI = parcelRequire("iMHGI");

var $b6OuN = parcelRequire("b6OuN");
let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)(false);
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $aU4fU.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $aU4fU.InMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.__APOLLO_AGG_CLIENT__ = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $gTOUc.UFOLoggerLink));
    subscriptionLinks.push((0, $b6OuN.getAGGWebSocketLinkInstance)());
    links.push(new (0, $csQ66.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $gZ7FC.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        if ((0, $9wGTI.fg)('confluence_enable_agg_subscription_link')) {
            const definition = (0, $3zyWe.getMainDefinition)(query);
            return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            !Boolean(undefined);
        } else return false;
    }, // WebSocket link for subscriptions
    (0, $gZ7FC.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $gZ7FC.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $aTqya.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $gZ7FC.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};

});
parcelRegister("gTOUc", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $28d9509e838f50ce$export$fb326ed954631f3f);

var $gZ7FC = parcelRequire("gZ7FC");

var $4u5NT = parcelRequire("4u5NT");
const $28d9509e838f50ce$export$fb326ed954631f3f = new (0, $gZ7FC.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $4u5NT.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("adWn1", function(module, exports) {
module.exports = JSON.parse("[{\"possibleTypes\":[{\"name\":\"SearchConfluencePageBlogAttachment\"},{\"name\":\"SearchConfluenceSpace\"}],\"kind\":\"INTERFACE\",\"name\":\"SearchResult\"},{\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"ConfluenceBlogPost\"}],\"kind\":\"UNION\",\"name\":\"SearchConfluenceEntity\"},{\"possibleTypes\":[{\"name\":\"AppUser\"},{\"name\":\"AtlassianAccountUser\"},{\"name\":\"CustomerUser\"}],\"kind\":\"INTERFACE\",\"name\":\"User\"},{\"possibleTypes\":[{\"name\":\"InvokeAuxEffectsResponse\"},{\"name\":\"InvokeExtensionResponse\"}],\"kind\":\"INTERFACE\",\"name\":\"Payload\"}]");

});

parcelRegister("9jPdT", function(module, exports) {

$parcel$export(module.exports, "createOnErrorLink", () => $f891c7498335b8fa$export$b330696930e048ff);

var $d6g2l = parcelRequire("d6g2l");

var $fJlJm = parcelRequire("fJlJm");

var $9kGfD = parcelRequire("9kGfD");
var $flE5X = parcelRequire("flE5X");

var $7Sm4c = parcelRequire("7Sm4c");
const $f891c7498335b8fa$export$b330696930e048ff = ()=>(0, $d6g2l.onError)(({ operation: operation, graphQLErrors: graphQLErrors, networkError: networkError })=>{
        let response = operation.getContext()?.response;
        if (!response) // Experimental queries don't have 'response' populated in context, so try
        // to get the Response object from graphQLErrors:
        response = graphQLErrors?.map((e)=>$f891c7498335b8fa$var$getResponseFromError(e.originalError)).find((e)=>e != null);
        const traceId = (0, $9kGfD.getTraceIdFromResponse)(response);
        if (graphQLErrors?.length) graphQLErrors.forEach((e)=>{
            (0, $fJlJm.setGraphqlErrorAttributes)(e, {
                graphqlPath: e.path?.join('.'),
                operationName: operation.operationName,
                statusCode: response?.status,
                traceId: traceId
            });
            (0, $7Sm4c.processError)(e);
        });
        if (networkError) {
            (0, $fJlJm.setGraphqlErrorAttributes)(networkError, {
                operationName: operation.operationName,
                statusCode: $f891c7498335b8fa$var$getResponseFromError(networkError)?.status,
                traceId: traceId,
                ...networkError instanceof (0, $flE5X.NoNetworkError) && networkError.wasBubbledUp === true ? {
                    wasBubbledUp: true
                } // Extra analytics attribute to mark errors caused by platform_editor_bubble_cfe_gql_network_errors. This can probably be removed during fg cleanup.
                 : {}
            });
            (0, $7Sm4c.processError)(networkError);
        }
    });
function $f891c7498335b8fa$var$getResponseFromError(error) {
    if (typeof error === 'object' && error && 'response' in error) {
        const { response: response } = error;
        if (typeof response === 'object' && response && 'status' in response) return response;
    }
    return undefined;
}

});
parcelRegister("7Sm4c", function(module, exports) {

$parcel$export(module.exports, "markErrorAsHandled", () => $bef4b00c86d1ff04$export$702f853386561b84);
$parcel$export(module.exports, "isErrorMarkedAsHandled", () => $bef4b00c86d1ff04$export$792efb60958ecf86);
$parcel$export(module.exports, "processError", () => $bef4b00c86d1ff04$export$83457a6c00af4df7);

var $aTqya = parcelRequire("aTqya");

var $5ZqQS = parcelRequire("5ZqQS");
function $bef4b00c86d1ff04$var$onGraphqlError(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: 'graphql'
    });
}
// NOTE: use `Symbol.for(...)` here because this module is bundled into two separate
// chunks - preloader and main app. Creating it via `Symbol(...)` will result in two
// different symbols, so errors that are handled in the preloader won't be identified
// as handled in the main app.
const $bef4b00c86d1ff04$var$HANDLED_ERROR_MARK_SYMBOL = Symbol.for('error marked as handled');
class $bef4b00c86d1ff04$export$bba8f5318e9cae27 {
    scheduleErrorReporting(error) {
        const timeoutId = window.setTimeout(()=>{
            // NOTE: This is an extra measure to prevent over-reporting of an otherwise handled error.
            // When query is preloaded and errors out, the reporting is scheduled by onErrorLink from
            // both preloader and from the place where query data is processed, but `errorsToHandle`
            // would only contain the entry of the error mapped to the latest timeoutId.
            if (this.isErrorMarkedAsHandled(error)) return;
            this.errorHandler(error);
            $bef4b00c86d1ff04$export$702f853386561b84(error);
        }, this.gracefulHandlingPeriodMs);
        this.errorsToHandle.set(error, timeoutId);
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(gracefulHandlingPeriodMs, errorHandler){
        this.gracefulHandlingPeriodMs = gracefulHandlingPeriodMs;
        this.errorHandler = errorHandler;
        // map of Error to timeoutId of when the generic error handling will kick-off
        this.errorsToHandle = new Map();
        this.processError = (error)=>{
            if (error) this.scheduleErrorReporting(error);
        };
        this.isErrorMarkedAsHandled = (error)=>{
            if (!error) return false;
            if (typeof error !== 'object') return false;
            return Boolean(error[$bef4b00c86d1ff04$var$HANDLED_ERROR_MARK_SYMBOL]);
        };
        this.markErrorAsHandled = (error)=>{
            if (!error) return;
            if ((0, $aTqya.isApolloError)(error)) {
                (error.graphQLErrors || []).forEach((e)=>this.markErrorAsHandled(e));
                this.markErrorAsHandled(error.networkError);
            }
            const timeoutId = this.errorsToHandle.get(error);
            if (typeof error === 'object') error[$bef4b00c86d1ff04$var$HANDLED_ERROR_MARK_SYMBOL] = true;
            window.clearTimeout(timeoutId);
            this.errorsToHandle.delete(error);
        };
    }
}
const $bef4b00c86d1ff04$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS = 100;
// GraphqlErrorProcessor is stateful and should be a singleton. Given that this module
// is bundled into two separate chunks - preloader and main app, we need to make sure
// that the same instance is used in both places.
let $bef4b00c86d1ff04$var$defaultGraphqlErrorProcessor = window.__GRAPHQL_ERROR_PROCESSOR__;
if (!$bef4b00c86d1ff04$var$defaultGraphqlErrorProcessor) {
    $bef4b00c86d1ff04$var$defaultGraphqlErrorProcessor = new $bef4b00c86d1ff04$export$bba8f5318e9cae27($bef4b00c86d1ff04$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS, $bef4b00c86d1ff04$var$onGraphqlError);
    window.__GRAPHQL_ERROR_PROCESSOR__ = $bef4b00c86d1ff04$var$defaultGraphqlErrorProcessor;
}
const $bef4b00c86d1ff04$export$db43d00048f0afe4 = $bef4b00c86d1ff04$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS;
const $bef4b00c86d1ff04$export$702f853386561b84 = $bef4b00c86d1ff04$var$defaultGraphqlErrorProcessor.markErrorAsHandled;
const $bef4b00c86d1ff04$export$792efb60958ecf86 = $bef4b00c86d1ff04$var$defaultGraphqlErrorProcessor.isErrorMarkedAsHandled;
const $bef4b00c86d1ff04$export$83457a6c00af4df7 = $bef4b00c86d1ff04$var$defaultGraphqlErrorProcessor.processError;

});


parcelRegister("iMHGI", function(module, exports) {

$parcel$export(module.exports, "createWrappedFetch", () => $2386d66c0d937812$export$ea28bdf504d67aa4);

var $lMdlY = parcelRequire("lMdlY");

var $9wGTI = parcelRequire("9wGTI");

var $14DR2 = parcelRequire("14DR2");
var $f7B1p = parcelRequire("f7B1p");

var $hZpML = parcelRequire("hZpML");

var $60cDW = parcelRequire("60cDW");

var $eecps = parcelRequire("eecps");
const $2386d66c0d937812$var$experienceAwareFetch = (0, $eecps.createExperienceAwareFetch)();
const $2386d66c0d937812$export$ea28bdf504d67aa4 = (isCcGraphQL)=>{
    return (uri, options)=>{
        if (isCcGraphQL) // On client side the uri is /cgraphql
        // However when running on the server side we want to dynamic change the URI
        // So we can route the request to the graphql deployment that closer to the data.
        // AGG host is redirected by Tesseract so we don't need to change the URI
        uri = window.GLOBAL_APOLLO_CLIENT_URI || uri;
        const payload = [].concat(typeof options.body === 'string' ? JSON.parse(options.body) : []); // concat normalizes into an array
        const operationNames = payload.map(({ operationName: operationName, variables: variables })=>{
            // There are various webitem location we want to distinguish them
            if (operationName === 'WebItemLocationQuery' || operationName === 'WebPanelLocationQuery') return `${operationName}:${variables?.location || (variables?.locations || []).join(',') || ''}`;
            return operationName;
        });
        // pass as headers for rate-limiting compatibility
        const operationNamesList = operationNames.join(',');
        if (!options.headers) options.headers = {};
        (0, $14DR2.appendHeader)(options.headers, 'X-APOLLO-OPERATION-NAME', operationNamesList);
        // Headers are already getting forwarded explicitly to cc-graphql via SSR
        // so we only need to append them here for AGG requests
        if (!isCcGraphQL) {
            const { aggHeaders: aggHeaders } = (0, $60cDW.getSSRRenderInputs)();
            if (aggHeaders) Object.entries(aggHeaders).forEach(([header, val])=>{
                if (val) (0, $14DR2.appendHeader)(options.headers, header, val);
            });
        }
        options.referrerPolicy = options.referrerPolicy || 'same-origin';
        // add experience tracing headers
        if ((0, $9wGTI.fg)('confluence_fe_enable_trace_propagation')) {
            const tracingHeaders = (0, $lMdlY.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
            options.headers = Object.assign(options.headers, tracingHeaders);
        }
        // At this point the query has lost the structure and formatted back to string
        // However it is different in experimental queries. The AST is always accessible
        // Refer to next/packages/graphql/src/links/ExperimentalLink/schemaLink.ts
        const executeFetch = ()=>{
            return ((0, $eecps.isExperienceAwareFetchAlwaysEnabled)() || payload.some((item)=>item.query.includes('@SLA')) ? $2386d66c0d937812$var$experienceAwareFetch : (0, $f7B1p.cfetch))(`${uri}?q=${operationNamesList}`, options);
        };
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const markingPrefix = 'wf/client-graphql/';
        const markingNames = operationNames.map((name)=>{
            name = isCcGraphQL ? name : `agg_${name}`;
            return `${markingPrefix}${name?.replace(/[^\-\.\w]/g, '_')}`;
        });
        // Ignore batch queries because they are not deterministic. Don't make sense to show on performance waterfall.
        return operationNames.length > 1 ? executeFetch() : (0, $hZpML.WaterfallMeasures).run(markingNames, executeFetch);
    };
};

});
parcelRegister("hZpML", function(module, exports) {

$parcel$export(module.exports, "WATERFALL_INITIAL_MEASURES", () => $37b533d524acf2b8$export$5cd865dcdb41adf);
$parcel$export(module.exports, "perfMark", () => $37b533d524acf2b8$export$61a691dabeb80f51);
$parcel$export(module.exports, "WaterfallMeasures", () => $37b533d524acf2b8$export$d7d6a49c52882aad);

var $gwFzn = parcelRequire("gwFzn");

var $kGrzq = parcelRequire("kGrzq");
var $37b533d524acf2b8$export$5cd865dcdb41adf = /*#__PURE__*/ function(WATERFALL_INITIAL_MEASURES) {
    WATERFALL_INITIAL_MEASURES["REDIRECTION"] = "wf/navigation/redirection";
    WATERFALL_INITIAL_MEASURES["DNS"] = "wf/navigation/dns";
    WATERFALL_INITIAL_MEASURES["TCP"] = "wf/navigation/tcp";
    WATERFALL_INITIAL_MEASURES["TLS"] = "wf/navigation/tls";
    WATERFALL_INITIAL_MEASURES["RESPONSE"] = "wf/navigation/response";
    WATERFALL_INITIAL_MEASURES["TTFB"] = "wf/navigation/ttfb";
    WATERFALL_INITIAL_MEASURES["FULL_HTML"] = "wf/navigation/fullHtml";
    WATERFALL_INITIAL_MEASURES["CSS_MAIN"] = "wf/css/main";
    WATERFALL_INITIAL_MEASURES["CSS_SUPERBATCH"] = "wf/css/superbatch";
    WATERFALL_INITIAL_MEASURES["CSS_CONNECT_WEB_RESOURCES"] = "wf/css/connectWebResources";
    WATERFALL_INITIAL_MEASURES["CSS_COMPILED"] = "wf/css/compiled";
    WATERFALL_INITIAL_MEASURES["JS_SUPERBATCH"] = "wf/js/superbatch";
    WATERFALL_INITIAL_MEASURES["JS_CONNECT_WEB_RESOURCES"] = "wf/js/connectWebResources";
    WATERFALL_INITIAL_MEASURES["HTML_THEME_INIT"] = "wf/html/themeInit";
    WATERFALL_INITIAL_MEASURES["HTML_REACT_ROOT"] = "wf/html/reactRoot";
    WATERFALL_INITIAL_MEASURES["HTML_SSR_SCRIPTS"] = "wf/html/ssrScripts";
    WATERFALL_INITIAL_MEASURES["HTML_TOP_NAV"] = "wf/html/topNav";
    WATERFALL_INITIAL_MEASURES["HTML_SIDE_NAV"] = "wf/html/sideNav";
    WATERFALL_INITIAL_MEASURES["HTML_MAIN"] = "wf/html/main";
    WATERFALL_INITIAL_MEASURES["HTML_FORCE_LAYOUT"] = "wf/html/forceLayout";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_SESSION_DATA"] = "wf/bootstrap/getSessionData";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_TRANSLATION"] = "wf/bootstrap/loadTranslation";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_LOADABLE"] = "wf/bootstrap/preloadLoadable";
    return WATERFALL_INITIAL_MEASURES;
}({});
function $37b533d524acf2b8$export$61a691dabeb80f51(name) {
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window["__SSR_RENDERED__"]&&window.performance.mark("${name}");`
        }
    });
}
class $37b533d524acf2b8$var$WaterfallMeasure extends (0, $kGrzq.BaseMeasures) {
    markMeasureStart(name, timestamp) {
        this.markedKeys.add(name);
        window.performance.clearMarks(`${name}.start`);
        window.performance.mark(`${name}.start`, {
            startTime: Math.floor(timestamp ?? performance.now())
        });
    }
    markMeasureEnd(name, timestamp) {
        window.performance.clearMarks(`${name}.end`);
        window.performance.mark(`${name}.end`, {
            startTime: Math.floor(timestamp ?? performance.now())
        });
    }
    getMeasureKeys(after) {
        return Array.from(this.markedKeys).filter((key)=>{
            const mark = performance.getEntriesByName(`${key}.start`, 'mark');
            return mark.length && mark[0].startTime >= after;
        });
    }
    clearMeasures() {
        super.clearMeasures();
        this.markedKeys.clear();
    }
    constructor(...args){
        super(...args);
        this.markedKeys = new Set();
    }
}
const $37b533d524acf2b8$export$d7d6a49c52882aad = new $37b533d524acf2b8$var$WaterfallMeasure();

});

parcelRegister("60cDW", function(module, exports) {

$parcel$export(module.exports, "getSSRRenderInputs", () => $54ddb4ed97d05eb8$export$5a7bc2bed2a23636);
let $54ddb4ed97d05eb8$var$ssrRenderInputs = {};
function $54ddb4ed97d05eb8$export$23e824c634636b62(inputs) {
    $54ddb4ed97d05eb8$var$ssrRenderInputs = inputs;
}
function $54ddb4ed97d05eb8$export$5a7bc2bed2a23636() {
    return $54ddb4ed97d05eb8$var$ssrRenderInputs;
}

});

parcelRegister("eecps", function(module, exports) {

$parcel$export(module.exports, "createExperienceAwareFetch", () => $854bdac570650ebc$export$3dbb48b3da33bedb);
$parcel$export(module.exports, "isExperienceAwareFetchAlwaysEnabled", () => $854bdac570650ebc$export$be6d8e5a7e346e2e);

var $9wGTI = parcelRequire("9wGTI");

var $fGzMp = parcelRequire("fGzMp");

var $14DR2 = parcelRequire("14DR2");
var $f7B1p = parcelRequire("f7B1p");
var $3P4tJ = parcelRequire("3P4tJ");
var $c0BL4 = parcelRequire("c0BL4");
function $854bdac570650ebc$export$3dbb48b3da33bedb() {
    return (resource, init = {})=>{
        const activeSlaExperience = (0, $fGzMp.getLatestActiveSlaExperience)();
        if (activeSlaExperience) {
            init.headers = init.headers || {};
            // Here we're very far from where the query was triggered and we haven't
            // been told explicitly that the query was triggered because of any of the
            // currently active experiences but we're presuming there's a correlation
            // because it's our best available guess. If the header was already added
            // (e.g. when preloading a route on transition) and because we can only
            // send one experience at this time, presume that whoever added the header
            // before us knew better:
            (0, $14DR2.appendHeader)(init.headers, (0, $c0BL4.X_ATL_EXPERIENCE), (0, $3P4tJ.getHeaderValue)(init.headers, (0, $c0BL4.X_ATL_EXPERIENCE)) || activeSlaExperience.name);
            (0, $14DR2.appendHeader)(init.headers, (0, $c0BL4.X_ATL_EXPERIENCE_ID), (0, $3P4tJ.getHeaderValue)(init.headers, (0, $c0BL4.X_ATL_EXPERIENCE_ID)) || (activeSlaExperience.attributes?.uniqueExperienceId ?? activeSlaExperience.id));
        }
        // eslint-disable-next-line no-restricted-syntax
        return (0, $f7B1p.cfetch)(resource, init);
    };
}
const $854bdac570650ebc$export$be6d8e5a7e346e2e = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (0, $9wGTI.fg)('confluence_frontend_experience_aware_fetch');
};

});
parcelRegister("fGzMp", function(module, exports) {

$parcel$export(module.exports, "getLatestActiveSlaExperience", () => $9713ba3226cd0c48$export$1e7d0a9a962cdd28);
$parcel$export(module.exports, "getExperienceTracker", () => $9713ba3226cd0c48$export$a1fa58e5690a5a9a);
$parcel$export(module.exports, "stopExperienceOnError", () => $9713ba3226cd0c48$export$720dc4209419df4e);
$parcel$export(module.exports, "forwardExperience", () => $9713ba3226cd0c48$export$1c9cdc2685ab8d2);
$parcel$export(module.exports, "captureRouteChange", () => $9713ba3226cd0c48$export$e8918c537d57dc96);
$parcel$export(module.exports, "getPreviousRouteExperienceData", () => $9713ba3226cd0c48$export$5259f71d975e46f5);

var $csnse = parcelRequire("csnse");

var $kyKWe = parcelRequire("kyKWe");

var $kquTo = parcelRequire("kquTo");

var $04e9M = parcelRequire("04e9M");

var $8EsbU = parcelRequire("8EsbU");

var $9wGTI = parcelRequire("9wGTI");

var $fJlJm = parcelRequire("fJlJm");
var $5ZqQS = parcelRequire("5ZqQS");

var $cEgMD = parcelRequire("cEgMD");

var $irVI7 = parcelRequire("irVI7");

var $glCMv = parcelRequire("glCMv");

var $kmyYx = parcelRequire("kmyYx");

var $949zl = parcelRequire("949zl");
const $9713ba3226cd0c48$var$SLA_EXPERIENCES = new Set([
    // Currently not SLA experience, but will be in the future
    (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
    (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
    // SLA experiences ⬇️
    (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
    (0, $irVI7.CREATE_PAGE_EXPERIENCE),
    (0, $irVI7.EDIT_PAGE_EXPERIENCE),
    (0, $irVI7.VIEW_PAGE_EXPERIENCE)
]);
const $9713ba3226cd0c48$var$activeSlaExperiences = new Map();
const $9713ba3226cd0c48$var$activeExperiences = new Set();
const $9713ba3226cd0c48$var$currentRoute = {
    routeName: '',
    successfulExperiences: new Set()
};
const $9713ba3226cd0c48$var$previousRoute = {
    routeName: '',
    successfulExperiences: new Set()
};
function $9713ba3226cd0c48$export$6369eb07eb8a8518({ action: action, name: name, id: id, attributes: attributes = {} }) {
    const isSlaExperience = $9713ba3226cd0c48$var$SLA_EXPERIENCES.has(name);
    if (action === 'taskStart') {
        if (isSlaExperience) {
            // Create a unique experience ID for request headers
            attributes.uniqueExperienceId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
            $9713ba3226cd0c48$var$activeSlaExperiences.set(name, {
                id: id,
                attributes: attributes
            });
        }
        $9713ba3226cd0c48$var$activeExperiences.add(name);
    } else {
        if (isSlaExperience) {
            // Extract unique experience ID to attach to event attributes for analytics/monitoring logs
            attributes.uniqueExperienceId = $9713ba3226cd0c48$var$activeSlaExperiences.get(name)?.attributes?.uniqueExperienceId;
            $9713ba3226cd0c48$var$activeSlaExperiences.delete(name);
        }
        $9713ba3226cd0c48$var$activeExperiences.delete(name);
        if (action === 'taskSuccess') $9713ba3226cd0c48$var$currentRoute.successfulExperiences.add(name);
    }
    const slaExperience = $9713ba3226cd0c48$export$1e7d0a9a962cdd28();
    const experiences = $9713ba3226cd0c48$var$activeExperiences.size > 0 ? $9713ba3226cd0c48$var$activeExperiences : null;
    if (slaExperience || experiences) {
        const updatedContext = {};
        if (experiences) updatedContext.activeExperiences = $9713ba3226cd0c48$var$activeExperiences;
        if (slaExperience) updatedContext.slaExperience = slaExperience.name;
        (0, $5ZqQS.getMonitoringClient)().updateContext(updatedContext);
    }
}
function $9713ba3226cd0c48$export$1e7d0a9a962cdd28() {
    if ($9713ba3226cd0c48$var$activeSlaExperiences.size === 0) return null;
    const experienceEntry = Array.from($9713ba3226cd0c48$var$activeSlaExperiences).pop();
    return {
        ...experienceEntry[1],
        name: experienceEntry[0]
    };
}
const $9713ba3226cd0c48$export$a1fa58e5690a5a9a = (0, $csnse.default)(()=>{
    const tracker = new (0, $kmyYx.ExperienceTracker)();
    // Do nothing for search engine crawlers
    if (/bot/i.test(window.navigator.userAgent)) return tracker;
    tracker.subscribe((event)=>{
        //
        // View Page SLA Split
        //
        if (event.name === (0, $irVI7.VIEW_CONTENT_EXPERIENCE)) {
            $9713ba3226cd0c48$var$splitViewContentExperience(tracker, event);
            // View-content was introduced only to split space-overview out of
            // view-page, because view-page is covered by Premium SLA and
            // space-overview was not satisfactorily reliable. View-content is not
            // allowlisted in cc-fe-telemetry so submitting through MonitoringClient
            // below is a waste. Sending through AnalyticsWebClient is a waste too
            // since view-content is not tracked as an SLO and it could be derived
            // from view-page and space-overview which are tracked as separate SLOs
            // already anyway. Splunk found 23 million view-content events in the last
            // 24 hours which is about 3% of experience-tracker events.
            return;
        }
        $9713ba3226cd0c48$export$6369eb07eb8a8518(event);
        //
        // AnalyticsWebClient
        //
        (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
            client.sendOperationalEvent((0, $kquTo.createExperienceTrackerAnalyticsEventPayload)($9713ba3226cd0c48$var$provideGenericAttributes(event)));
        });
        //
        // MonitoringClient
        //
        const isTimeoutError = event.action === 'taskFail' && event?.error?.name === 'ExperienceTimeoutError' || event.action === 'taskAbort' && typeof event?.reason === 'string' && event.reason.startsWith('ExperienceTimeout');
        const isPermissionError = event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && event.action === 'taskAbort' && (event.reason?.includes?.('401') || event.reason?.includes?.('403'));
        const tags = [
            `action:${event.action}`,
            `isActiveTab:${document.visibilityState === 'visible'}`,
            ...event.action === 'taskFail' || event.action === 'taskAbort' ? [
                `isTimeoutError:${isTimeoutError}`
            ] : [],
            ...event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && event.action === 'taskAbort' ? [
                `isPermissionError:${isPermissionError}`
            ] : []
        ];
        if (event.attributes) for(const a in event.attributes)tags.push(`${a}:${event.attributes[a]}`);
        if (event.action === 'taskFail' && $9713ba3226cd0c48$var$SLA_EXPERIENCES.has(event.name)) {
            // in this section, we submit information about SLA-affecting experience failures.
            // We don't submit timeout errors to monitoring systems however; they would be submitted to Analytics instead.
            // cc-fe-telemetry will filter these additional tags before sending to SFX, these are only for "Raw TelemetryEvent" Splunk logs
            if (event?.error?.message) tags.push(`error:${event.error.message}`);
            // Supply additional information from alternative sources, for case where SessionDataQuery is not available
            tags.push(`hostname:${window.location.hostname}`);
            tags.push(`tenantIdMeta:${(0, $8EsbU.getOverride)('cloud-id')}`);
            (0, $5ZqQS.getMonitoringClient)().incrementCounter(`experience-tracker:${event.name}`, tags);
            if (!(event.error instanceof (0, $glCMv.ExperienceTimeoutError))) {
                (0, $fJlJm.setContentErrorAttributes)(event.error, {
                    objectId: event.attributes?.contentId
                });
                (0, $fJlJm.setSlaErrorAttributes)(event.error, {
                    failedSlaExperience: event.name,
                    experienceId: event.attributes?.uniqueExperienceId ?? event.id
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(event.error, {
                    attribution: 'sla'
                });
            }
        } else (0, $5ZqQS.getMonitoringClient)().incrementCounter(`experience-tracker:${event.name}`, tags);
    });
    return tracker;
});
function $9713ba3226cd0c48$export$720dc4209419df4e(name, error, attributes) {
    $9713ba3226cd0c48$export$a1fa58e5690a5a9a().stopOnError({
        name: name,
        error: error,
        attributes: attributes
    });
}
const $9713ba3226cd0c48$export$1c9cdc2685ab8d2 = (tracker, event, name = event.name)=>{
    switch(event.action){
        case 'taskStart':
            tracker.start({
                ...event,
                name: name
            });
            break;
        case 'taskSuccess':
            tracker.succeed({
                ...event,
                name: name
            });
            break;
        case 'taskFail':
            tracker.fail({
                ...event,
                name: name
            });
            break;
        case 'taskAbort':
            tracker.abort({
                ...event,
                name: name
            });
    }
};
function $9713ba3226cd0c48$export$e8918c537d57dc96(routeName) {
    $9713ba3226cd0c48$var$previousRoute.routeName = $9713ba3226cd0c48$var$currentRoute.routeName;
    $9713ba3226cd0c48$var$previousRoute.successfulExperiences = $9713ba3226cd0c48$var$currentRoute.successfulExperiences;
    $9713ba3226cd0c48$var$currentRoute.routeName = routeName;
    $9713ba3226cd0c48$var$currentRoute.successfulExperiences = new Set();
}
function $9713ba3226cd0c48$export$5259f71d975e46f5() {
    return {
        ...$9713ba3226cd0c48$var$previousRoute
    };
}
const $9713ba3226cd0c48$var$splitViewContentExperience = (tracker, event)=>{
    let name;
    if (event.attributes?.contentType === 'space') {
        name = (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE);
        const spaceKey = event.attributes?.spaceKey;
        if (typeof spaceKey === 'string' && (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) name = (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE);
    } else {
        name = (0, $irVI7.VIEW_PAGE_EXPERIENCE);
        if (event.action === 'taskStart') (0, $949zl.startViewPageSessionExperience)({
            tracker: tracker,
            attributes: {
                ...event.attributes
            },
            startTime: event.startTime,
            id: event.id
        });
    }
    $9713ba3226cd0c48$export$1c9cdc2685ab8d2(tracker, event, name);
};
/**
 * Extend the ExperienceEvent with Confluence-specific additional attributes based on available data and type of event.
 *
 * @param event ExperienceEvent
 * @returns ExperienceEvent with additional attributes
 */ const $9713ba3226cd0c48$var$provideGenericAttributes = (event)=>{
    if (!(0, $9wGTI.fg)('experience_tracker_trace_id')) return event;
    const errorTraceId = event.action === 'taskFail' && !!event?.error ? (0, $fJlJm.getLogSafeErrorAttributes)(event.error)?.traceId : undefined;
    // Expected that condition will be extended with && for other attributes added in the future
    if (!errorTraceId) return event;
    event.attributes = {
        ...!!errorTraceId && {
            traceId: errorTraceId
        },
        ...event.attributes
    };
    return event;
};

});
parcelRegister("kquTo", function(module, exports) {

$parcel$export(module.exports, "createExperienceTrackerAnalyticsEventPayload", () => $84862b0cf58a5511$export$9c05e7ef9f2c8895);
const $84862b0cf58a5511$export$9c05e7ef9f2c8895 = (event)=>({
        // Events should match the schema defined here:
        // https://hello.atlassian.net/wiki/spaces/BIZOPS/pages/387788554/Analytics+Event+Schema+for+SLA
        source: 'ui',
        actionSubject: 'ui',
        action: event.action,
        eventType: 'operational',
        attributes: $84862b0cf58a5511$var$createExperienceTrackerAnalyticsAttributes(event)
    });
function $84862b0cf58a5511$var$createExperienceTrackerAnalyticsAttributes(event) {
    const { action: action, name: name, id: id, attributes: experienceAttributes, ...rest } = event;
    const attributes = {
        ...experienceAttributes,
        ...rest,
        task: name,
        taskId: id
    };
    if (attributes.error) {
        let error;
        if (typeof attributes.error === 'string') error = new Error(attributes.error);
        else error = attributes.error;
        delete attributes.error;
        attributes.errorName = error.name;
        if (!attributes.traceId && error.traceId) attributes.traceId = error.traceId;
        attributes.errorMessage = error.message;
    }
    attributes.browserInfo = window.navigator.userAgent;
    // Matches the analytics-web-client's apdex event
    attributes.isActiveTab = document.visibilityState === 'visible';
    return attributes;
}

});

parcelRegister("8EsbU", function(module, exports) {

$parcel$export(module.exports, "setOverride", () => $60f04d82b79373b9$export$357972e1dc28ee9f);
$parcel$export(module.exports, "getOverride", () => $60f04d82b79373b9$export$72427a1521dd0069);
$parcel$export(module.exports, "getAllAsMap", () => $60f04d82b79373b9$export$49258654c956d9af);
$parcel$export(module.exports, "getTagsAsMap", () => $60f04d82b79373b9$export$594c6655c9709eda);
/**
 * confluence/meta is used to access dynamic metadata passed from the
 * server to JavaScript via the page HTML.
 */ /**
 *  A backing map to use if the user sets data.
 */ const $60f04d82b79373b9$export$1591b5b8c61dbb9c = {};
const $60f04d82b79373b9$export$357972e1dc28ee9f = (key, value)=>{
    $60f04d82b79373b9$export$1591b5b8c61dbb9c[key] = value;
};
const $60f04d82b79373b9$export$70f24959ef00553b = (value)=>{
    const evaluatedValue = typeof value === 'string' ? value.toLowerCase() : '';
    const booleanEnum = {
        true: true,
        false: false
    };
    return evaluatedValue in booleanEnum ? booleanEnum[evaluatedValue] : value;
};
const $60f04d82b79373b9$export$72427a1521dd0069 = (key)=>{
    // Check if we're server-side or client-side
    if ($60f04d82b79373b9$export$9542afab8c2a5f48()) {
        const metaEl = document.querySelector(`meta[name='ajs-${key}']`);
        if (metaEl) return $60f04d82b79373b9$export$70f24959ef00553b(metaEl.content);
        return $60f04d82b79373b9$export$1591b5b8c61dbb9c[key];
    }
    // Always return undefined on the server-side
    return undefined;
};
const $60f04d82b79373b9$export$49258654c956d9af = ()=>{
    const map = {};
    if (!document?.querySelectorAll?.length) return map;
    const metas = document.querySelectorAll('meta[name^=ajs-]');
    if (metas) for(let i = 0; i < metas.length; i++){
        const { name: name, content: content } = metas[i];
        map[name.substring(4)] = content;
    }
    return Object.assign(map, $60f04d82b79373b9$export$1591b5b8c61dbb9c);
};
const $60f04d82b79373b9$export$594c6655c9709eda = ()=>{
    const metaData = {};
    if ($60f04d82b79373b9$export$9542afab8c2a5f48()) {
        const metaTags = document.querySelectorAll('meta[name^=ajs-]');
        for(let i = 0; i < metaTags.length; i++){
            const { name: name, content: content } = metaTags[i];
            metaData[name.replace(/^ajs-/, '')] = content;
        }
    }
    return metaData;
};
const $60f04d82b79373b9$export$9542afab8c2a5f48 = ()=>{
    return typeof document !== 'undefined';
};
const $60f04d82b79373b9$export$578af21a462ae10b = ()=>{
    Object.keys($60f04d82b79373b9$export$1591b5b8c61dbb9c).forEach((key)=>{
        delete $60f04d82b79373b9$export$1591b5b8c61dbb9c[key];
    });
};

});

parcelRegister("cEgMD", function(module, exports) {

$parcel$export(module.exports, "isCompanyHubSpaceKey", () => $b72d43032a695cf0$export$5ab9c400208ad907);
$parcel$export(module.exports, "getCompanyHubSpaceKey", () => $b72d43032a695cf0$export$6193f65d76fa4c00);
$parcel$export(module.exports, "FrontCoverStateEnum", () => $b72d43032a695cf0$export$8b92a390c1734cf9);

var $ge2sX = parcelRequire("ge2sX");

var $6X8o4 = parcelRequire("6X8o4");
const $b72d43032a695cf0$var$COMPANY_HUB_SPACE_KEY_PREFIX = '~HUB';
const $b72d43032a695cf0$export$5ab9c400208ad907 = (spaceKey)=>!!(spaceKey?.startsWith($b72d43032a695cf0$var$COMPANY_HUB_SPACE_KEY_PREFIX) && spaceKey?.endsWith('~'));
const $b72d43032a695cf0$export$6193f65d76fa4c00 = (sessionData)=>{
    if (!sessionData?.activationId || !sessionData?.cloudId) sessionData = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)());
    if (sessionData) {
        const { activationId: activationId, cloudId: cloudId } = sessionData;
        if (activationId && cloudId) return `${$b72d43032a695cf0$var$COMPANY_HUB_SPACE_KEY_PREFIX}-${cloudId}-${activationId}~`;
    }
    // We used to return undefined, but pretty much always we fell back to the empty string with code like `?? ''` or `|| ''`.
    // Instead of sprinkling noise like that all over, it's less complex to do the de facto fallback here.
    return '';
};
var $b72d43032a695cf0$export$8b92a390c1734cf9 = /*#__PURE__*/ function(FrontCoverStateEnum) {
    FrontCoverStateEnum["UNSET"] = "unset";
    FrontCoverStateEnum["HIDDEN"] = "hidden";
    FrontCoverStateEnum["EDITORS_ONLY"] = "editors_only";
    FrontCoverStateEnum["SHOWN"] = "shown";
    return FrontCoverStateEnum;
}({});
var $b72d43032a695cf0$export$ec1312b61cf60ef3 = /*#__PURE__*/ function(FrontCoverStateInputEnum) {
    FrontCoverStateInputEnum["UNSET"] = "UNSET";
    FrontCoverStateInputEnum["HIDDEN"] = "HIDDEN";
    FrontCoverStateInputEnum["SHOWN"] = "SHOWN";
    return FrontCoverStateInputEnum;
}({});

});

parcelRegister("irVI7", function(module, exports) {

$parcel$export(module.exports, "FOLLOW_DEEP_LINK_EXPERIENCE", () => $4a617be77ace987f$export$61f782d99db03c49);
$parcel$export(module.exports, "VIEW_ALL_MACRO_EXPERIENCE", () => $4a617be77ace987f$export$54747aca26cee3f8);
$parcel$export(module.exports, "VIEW_JIRA_MACRO_EXPERIENCE", () => $4a617be77ace987f$export$f8afba90a5a815ad);
$parcel$export(module.exports, "MIGRATE_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$87daa9a1b1dd910d);
$parcel$export(module.exports, "MIGRATE_PAGE_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$6c0a7d453b9ba427);
$parcel$export(module.exports, "MIGRATE_TEMPLATE_EXPERIENCE", () => $4a617be77ace987f$export$b39a77dbc03575b1);
$parcel$export(module.exports, "ADD_PAGE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$f94e85276e6d639f);
$parcel$export(module.exports, "ADD_PAGE_COMMENT_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$31bd7de6ca230764);
$parcel$export(module.exports, "ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$4cb6cf73aff93e7d);
$parcel$export(module.exports, "EDIT_PAGE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$2a99a63e28df64fd);
$parcel$export(module.exports, "EDIT_PAGE_COMMENT_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$515913089a77cb7c);
$parcel$export(module.exports, "EDIT_PAGE_COMMENT_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$c0906b23fa1e3b63);
$parcel$export(module.exports, "REPLY_TO_PAGE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$e9a5501ca0d5d256);
$parcel$export(module.exports, "REPLY_TO_PAGE_COMMENT_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$3fdffa656412b99a);
$parcel$export(module.exports, "REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$bfebfbab40727cd6);
$parcel$export(module.exports, "DELETE_PAGE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$91d50c2b267d0461);
$parcel$export(module.exports, "RESOLVE_PAGE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$24ef8c79de5598b9);
$parcel$export(module.exports, "CREATE_INLINE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$6f58645a9a5f7936);
$parcel$export(module.exports, "CREATE_INLINE_COMMENT_INIT_EXPERIENCE", () => $4a617be77ace987f$export$8180a49fb6c681b1);
$parcel$export(module.exports, "CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$ed5e210bce3a41a9);
$parcel$export(module.exports, "CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$db23cb60632b0aa0);
$parcel$export(module.exports, "SELECT_INLINE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$f8e0e16825f0d222);
$parcel$export(module.exports, "SELECT_INLINE_COMMENT_SELECT_ANNOTATION_EXPERIENCE", () => $4a617be77ace987f$export$20e298cec054250a);
$parcel$export(module.exports, "SELECT_INLINE_COMMENT_SHOW_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$6a0f9ba61b7d60f5);
$parcel$export(module.exports, "ADD_INLINE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$2003fd9c8f509d96);
$parcel$export(module.exports, "ADD_INLINE_COMMENT_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$a69ecd33d83d56ce);
$parcel$export(module.exports, "ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$eb89dbd7422d8194);
$parcel$export(module.exports, "EDIT_INLINE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$29c433981d13c955);
$parcel$export(module.exports, "EDIT_INLINE_COMMENT_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$a557d8a611f835b);
$parcel$export(module.exports, "EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$e9dafdd46fb3d4ed);
$parcel$export(module.exports, "VIEW_INLINE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$20fbac00cba3c8a);
$parcel$export(module.exports, "VIEW_INLINE_COMMENT_TOP_LEVEL_EXPERIENCE", () => $4a617be77ace987f$export$533f2a7cfe4f757e);
$parcel$export(module.exports, "VIEW_INLINE_COMMENT_REPLY_EXPERIENCE", () => $4a617be77ace987f$export$fb1f28583d577755);
$parcel$export(module.exports, "REPLY_TO_INLINE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$9d157677f817543f);
$parcel$export(module.exports, "REPLY_TO_INLINE_COMMENT_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$b4f2ad99abb89883);
$parcel$export(module.exports, "REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$32059abd767a1104);
$parcel$export(module.exports, "DELETE_INLINE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$bcfccb61f33e9641);
$parcel$export(module.exports, "RESOLVE_INLINE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$819fbef15068ac1d);
$parcel$export(module.exports, "UNRESOLVE_INLINE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$996a096215f40255);
$parcel$export(module.exports, "REATTACH_INLINE_COMMENT_EXPERIENCE", () => $4a617be77ace987f$export$a32711b0e13e94b7);
$parcel$export(module.exports, "VIEW_REACTIONS_EXPERIENCE", () => $4a617be77ace987f$export$d6f52083721d3342);
$parcel$export(module.exports, "VIEW_REACTION_USER_LIST_EXPERIENCE", () => $4a617be77ace987f$export$e6f0efe9d461092e);
$parcel$export(module.exports, "ADD_REACTION_EXPERIENCE", () => $4a617be77ace987f$export$ba45b443cf775f1b);
$parcel$export(module.exports, "DELETE_REACTION_EXPERIENCE", () => $4a617be77ace987f$export$63f7987e2f1f8f3);
$parcel$export(module.exports, "ADD_QUICK_REACTION_EXPERIENCE", () => $4a617be77ace987f$export$aa1b3aa6132c5165);
$parcel$export(module.exports, "COPY_SPACE_PERMISSIONS_EXPERIENCE", () => $4a617be77ace987f$export$7321222ee6dc4c8a);
$parcel$export(module.exports, "CREATE_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$227ea80a7d6d8ef2);
$parcel$export(module.exports, "CREATE_PAGE_LOAD_DIALOG_EXPERIENCE", () => $4a617be77ace987f$export$1773354263fb7a1f);
$parcel$export(module.exports, "CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE", () => $4a617be77ace987f$export$5f80ef7b2915bb38);
$parcel$export(module.exports, "CREATE_WHITEBOARD_EXPERIENCE", () => $4a617be77ace987f$export$f27db95814bbdf0);
$parcel$export(module.exports, "CREATE_DATABASE_EXPERIENCE", () => $4a617be77ace987f$export$13566a78bbba7568);
$parcel$export(module.exports, "CREATE_EMBED_EXPERIENCE", () => $4a617be77ace987f$export$c6222c9fbf47e43b);
$parcel$export(module.exports, "CREATE_FOLDER_EXPERIENCE", () => $4a617be77ace987f$export$63a2c018dc189e0);
$parcel$export(module.exports, "EDIT_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$dd70d6707192298e);
$parcel$export(module.exports, "EDIT_LEGACY_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$cd96dc6a09f60949);
$parcel$export(module.exports, "EDIT_PAGE_EMBED_EXPERIENCE", () => $4a617be77ace987f$export$b6f302e969b56ed5);
$parcel$export(module.exports, "EDIT_PAGE_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$54650b8dd9597591);
$parcel$export(module.exports, "EDIT_LEGACY_PAGE_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$9cfef550e5af515d);
$parcel$export(module.exports, "EDIT_PAGE_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$4aed0cf42acf9c68);
$parcel$export(module.exports, "EDIT_LEGACY_PAGE_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$770ea955fed26e20);
$parcel$export(module.exports, "EDIT_PAGE_PUBLISH_AS_BLOG_EXPERIENCE", () => $4a617be77ace987f$export$4abcdf78bb75330c);
$parcel$export(module.exports, "EDIT_PAGE_CLOSE_EXPERIENCE", () => $4a617be77ace987f$export$92edebd76eb1ad1);
$parcel$export(module.exports, "EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE", () => $4a617be77ace987f$export$1339ae8dc80b092c);
$parcel$export(module.exports, "EDIT_PAGE_REVERT_DRAFT_EXPERIENCE", () => $4a617be77ace987f$export$42ce143b9452f768);
$parcel$export(module.exports, "LIVE_PAGE_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$d3dcb341de2e384f);
$parcel$export(module.exports, "LIVE_PAGE_EDIT_EXPERIENCE", () => $4a617be77ace987f$export$f8e950d04ce466ff);
$parcel$export(module.exports, "LIVE_PAGE_SESSION_EXPERIENCE", () => $4a617be77ace987f$export$3814d28dd3802a02);
$parcel$export(module.exports, "LIVE_PAGE_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$40fb2b7b657bf7d);
$parcel$export(module.exports, "CREATE_AND_EDIT_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$9e0dcc9389703292);
$parcel$export(module.exports, "TEMPLATE_EDIT_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$b9892a850189b3e9);
$parcel$export(module.exports, "TEMPLATE_EDIT_PAGE_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$3604f7decc6e0567);
$parcel$export(module.exports, "TEMPLATE_EDIT_PAGE_CLOSE_EXPERIENCE", () => $4a617be77ace987f$export$1a3cf6b911b3771);
$parcel$export(module.exports, "TEMPLATE_EDIT_PAGE_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$a7f90c693668eabe);
$parcel$export(module.exports, "TEMPLATE_EDIT_PAGE_PUBLISH_TEMPLATE_BODY_EXPERIENCE", () => $4a617be77ace987f$export$3c5dcebba4317c7e);
$parcel$export(module.exports, "TEMPLATE_EDIT_PAGE_PUBLISH_TEMPLATE_PROPERTIES_EXPERIENCE", () => $4a617be77ace987f$export$3a8f568ddb8f3189);
$parcel$export(module.exports, "IN_EDITOR_TEMPLATES_LOAD_PANEL_EXPERIENCE", () => $4a617be77ace987f$export$583391c24e8a1735);
$parcel$export(module.exports, "IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE", () => $4a617be77ace987f$export$6afe1d2e05c85172);
$parcel$export(module.exports, "IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE", () => $4a617be77ace987f$export$6085a8760b035f6);
$parcel$export(module.exports, "IN_EDITOR_TEMPLATES_LOAD_PANEL_SPACE_SELECTOR_EXPERIENCE", () => $4a617be77ace987f$export$cbd9dfa0a050a0e0);
$parcel$export(module.exports, "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_EXPERIENCE", () => $4a617be77ace987f$export$8fcf8395eb106389);
$parcel$export(module.exports, "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR_EXPERIENCE", () => $4a617be77ace987f$export$eac277758b783558);
$parcel$export(module.exports, "TEMPLATE_SUGGESTIONS_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$d3b70eeb61a68ef1);
$parcel$export(module.exports, "VIEW_IN_PRODUCT_HELP_EXPERIENCE", () => $4a617be77ace987f$export$89e30156af35c723);
$parcel$export(module.exports, "SEARCH_IN_PRODUCT_HELP_EXPERIENCE", () => $4a617be77ace987f$export$1072a5750cf51c7e);
$parcel$export(module.exports, "VIEW_ARTICLE_IN_PRODUCT_HELP_EXPERIENCE", () => $4a617be77ace987f$export$49e4c787a6cc62e);
$parcel$export(module.exports, "TEMPLATE_GALLERY_EXPERIENCE", () => $4a617be77ace987f$export$54615853abc6859);
$parcel$export(module.exports, "TEMPLATE_GALLERY_SPACE_SELECTOR_EXPERIENCE", () => $4a617be77ace987f$export$82c983e2a60f2e28);
$parcel$export(module.exports, "TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE", () => $4a617be77ace987f$export$61439b391c5a3aca);
$parcel$export(module.exports, "TEMPLATE_GALLERY_CARDS_EXPERIENCE", () => $4a617be77ace987f$export$81cd8bf6923e1bf1);
$parcel$export(module.exports, "TEMPLATE_GALLERY_TEMPLATE_DETAIL_EXPERIENCE", () => $4a617be77ace987f$export$b6af3a64b182b9d0);
$parcel$export(module.exports, "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$588acf29fbd8637d);
$parcel$export(module.exports, "TEMPLATE_GALLERY_TEMPLATE_DETAIL_HEADER_EXPERIENCE", () => $4a617be77ace987f$export$a1cf4f28febc3bee);
$parcel$export(module.exports, "TEMPLATE_PREVIEW_EXPERIENCE", () => $4a617be77ace987f$export$b802716fd0c5b93f);
$parcel$export(module.exports, "REFRESH_EDITOR_CONTENT_EXPERIENCE", () => $4a617be77ace987f$export$e0195c05e32ed777);
$parcel$export(module.exports, "CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE", () => $4a617be77ace987f$export$9194ae178043ade6);
$parcel$export(module.exports, "BLUEPRINT_WIZARD_LOAD_DIALOG_EXPERIENCE", () => $4a617be77ace987f$export$1545639c80579c53);
$parcel$export(module.exports, "CONNECT_ADDON_EXPERIENCE", () => $4a617be77ace987f$export$fc0c176abc30d17b);
$parcel$export(module.exports, "QUICK_RELOAD_EXPERIENCE", () => $4a617be77ace987f$export$97b170c4be77228);
$parcel$export(module.exports, "RESTRICTED_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$dbbd27df623b094f);
$parcel$export(module.exports, "RESTRICTED_SPACE_FOR_GUEST_EXPERIENCE", () => $4a617be77ace987f$export$8f404e4bd2a13aa);
$parcel$export(module.exports, "RESTRICTED_SPACE_EXPERIENCE", () => $4a617be77ace987f$export$727b779ceeca0a78);
$parcel$export(module.exports, "RESTRICTIONS_DIALOG_EXPERIENCE", () => $4a617be77ace987f$export$b9ee7465c962e842);
$parcel$export(module.exports, "RESTRICTIONS_DIALOG_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$2e96e7e6b8da0317);
$parcel$export(module.exports, "RESTRICTIONS_DIALOG_APPLY_EXPERIENCE", () => $4a617be77ace987f$export$6b54d78a736a983b);
$parcel$export(module.exports, "PUBLISH_MODAL_LOAD_RESTRICTIONS_EXPERIENCE", () => $4a617be77ace987f$export$a66250c876dd8838);
$parcel$export(module.exports, "IMPERSONATION_FLAG_EXPERIENCE", () => $4a617be77ace987f$export$e64caae0c75dd921);
$parcel$export(module.exports, "INSPECT_PERMISSIONS_EXPERIENCE", () => $4a617be77ace987f$export$7ebe8ae2b3f231cb);
$parcel$export(module.exports, "USER_ACCESS_EXPERIENCE", () => $4a617be77ace987f$export$b659623b19114e87);
$parcel$export(module.exports, "UPSELL_EDITION_PREMIUM_EXPERIENCE", () => $4a617be77ace987f$export$9d715fddec195756);
$parcel$export(module.exports, "UPSELL_EDITION_UPFLOW_EXPERIENCE", () => $4a617be77ace987f$export$a7ffbea51ff646ee);
$parcel$export(module.exports, "ARCHIVE_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$bd5028ea224c4de1);
$parcel$export(module.exports, "RESTORE_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$e63a17e805ed8387);
$parcel$export(module.exports, "SPACE_ARCHIVED_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$d74c17e82f5dbc27);
$parcel$export(module.exports, "SPACE_ARCHIVED_PAGES_PAGINATE_EXPERIENCE", () => $4a617be77ace987f$export$b7a40ae431fd676d);
$parcel$export(module.exports, "NOTES_ARCHIVE_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$b84de3b67d7aa4be);
$parcel$export(module.exports, "BULK_NOTES_ARCHIVE_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$9efd42121cbefbff);
$parcel$export(module.exports, "ARCHIVED_PAGE_BANNER_EXPERIENCE", () => $4a617be77ace987f$export$c30b739e25dc756b);
$parcel$export(module.exports, "AUTOMATION_DISCOVERY_ADD_LABEL_EXPERIENCE", () => $4a617be77ace987f$export$fc9036c892e05ff9);
$parcel$export(module.exports, "AUTOMATION_DISCOVERY_PUBLISH_MEETING_NOTES_EXPERIENCE", () => $4a617be77ace987f$export$abe2705723fc11ac);
$parcel$export(module.exports, "AUTOMATION_DISCOVERY_ARCHIVE_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$90d9afd417e81733);
$parcel$export(module.exports, "AUTOMATION_DISCOVERY_HOVER_OVER_PAGE_TITLE_EXPERIENCE", () => $4a617be77ace987f$export$bcf33c3d2ec343df);
$parcel$export(module.exports, "AUTOMATION_DISCOVERY_JIRA_LINK", () => $4a617be77ace987f$export$8b43be9232ec143f);
$parcel$export(module.exports, "AUTOMATION_DISCOVERY_PAGE_PUBLIC_LINK", () => $4a617be77ace987f$export$65a0bbd38d8f5b63);
$parcel$export(module.exports, "AUTOMATION_MANUAL_TRIGGERS", () => $4a617be77ace987f$export$c7dca20d997e95ed);
$parcel$export(module.exports, "AUTOMATION_DISCOVERY_WHITEBOARDS", () => $4a617be77ace987f$export$2504afae65d57ffb);
$parcel$export(module.exports, "AUTOMATION_DISCOVERY_BULK_CHANGE_PAGE_OWNER", () => $4a617be77ace987f$export$cf23f74117283d17);
$parcel$export(module.exports, "AUTOMATION_SMART_BUTTON_RUN_RULE", () => $4a617be77ace987f$export$78bf51c34f43d049);
$parcel$export(module.exports, "AUTOMATION_SMART_BUTTON_CREATE_RULE", () => $4a617be77ace987f$export$d0afbe071e52a5cf);
$parcel$export(module.exports, "AUTOMATION_SMART_BUTTON_EDIT_RULE", () => $4a617be77ace987f$export$b30eb768fa4c3967);
$parcel$export(module.exports, "AUTOMATION_SMART_BUTTON_PREVIEW_RULE", () => $4a617be77ace987f$export$2cc8139334567c4f);
$parcel$export(module.exports, "AUTOMATION_SIDE_NAV_BAR_EXPERIENCE", () => $4a617be77ace987f$export$cab2a1e3c7ddbb06);
$parcel$export(module.exports, "AUTOMATION_UPSELL_EXPERIENCE", () => $4a617be77ace987f$export$a03bf7627f412dc4);
$parcel$export(module.exports, "DELETE_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$a26e99521ea3a9f4);
$parcel$export(module.exports, "BULK_DELETE_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$57cc53c6e3b9be1b);
$parcel$export(module.exports, "BULK_CHANGE_OWNER_EXPERIENCE", () => $4a617be77ace987f$export$91d3a54b5d7e1b7f);
$parcel$export(module.exports, "BULK_CHANGE_STATUS_EXPERIENCE", () => $4a617be77ace987f$export$ba8b23dd795f5f9e);
$parcel$export(module.exports, "BULK_CONVERT_PAGE_TO_LIVE_DOC_EXPERIENCE", () => $4a617be77ace987f$export$7bea875d555696ca);
$parcel$export(module.exports, "EDIT_SIDEBAR_EXPERIENCE", () => $4a617be77ace987f$export$a837ee39f68fa2dd);
$parcel$export(module.exports, "EDIT_SIDEBAR_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$e69ba0c4a7667861);
$parcel$export(module.exports, "MANAGE_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$c6fd99844ee488c5);
$parcel$export(module.exports, "CONTENT_MANAGER_EXPERIENCE", () => $4a617be77ace987f$export$d4b4a08489e4dfe2);
$parcel$export(module.exports, "MOVE_PAGE_DIALOG_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$c03f98139dd9719e);
$parcel$export(module.exports, "MOVE_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$1167cf561a6df618);
$parcel$export(module.exports, "MOVE_BLOG_EXPERIENCE", () => $4a617be77ace987f$export$95c6dda6cbbf364);
$parcel$export(module.exports, "NOT_FOUND_EXPERIENCE", () => $4a617be77ace987f$export$fbbc408e16c59382);
$parcel$export(module.exports, "VIEW_CONTENT_EXPERIENCE", () => $4a617be77ace987f$export$cf73dfff88c1f700);
$parcel$export(module.exports, "VIEW_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$d4712ac27cc4e72f);
$parcel$export(module.exports, "VIEW_PAGE_SESSION_EXPERIENCE", () => $4a617be77ace987f$export$5e30e9d7ea54dcd2);
$parcel$export(module.exports, "SPACE_OVERVIEW_EXPERIENCE", () => $4a617be77ace987f$export$2a57468d23984a9d);
$parcel$export(module.exports, "BREADCRUMBS_EXPERIENCE", () => $4a617be77ace987f$export$54504a2cc31519bf);
$parcel$export(module.exports, "BREADCRUMBS_DROPDOWN_EXPERIENCE", () => $4a617be77ace987f$export$68af05e1cf40b8e6);
$parcel$export(module.exports, "VIEW_PAGE_TITLE_EXPERIENCE", () => $4a617be77ace987f$export$863ebd92a50403cf);
$parcel$export(module.exports, "VIEW_PAGE_LABELS_EXPERIENCE", () => $4a617be77ace987f$export$bdd2d0f331a38827);
$parcel$export(module.exports, "VIEW_PAGE_BYLINE_EXPERIENCE", () => $4a617be77ace987f$export$49fde5724a27b431);
$parcel$export(module.exports, "VIEW_PAGE_BYLINE_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$7a119c18309263c);
$parcel$export(module.exports, "VIEW_PAGE_COMMENTS_EXPERIENCE", () => $4a617be77ace987f$export$45c9f537ef090ccd);
$parcel$export(module.exports, "VIEW_PAGE_EDIT_BUTTON_EXPERIENCE", () => $4a617be77ace987f$export$dc03e514628af5e9);
$parcel$export(module.exports, "VIEW_PAGE_CONTENT_TOOLS_EXPERIENCE", () => $4a617be77ace987f$export$38478feb41239856);
$parcel$export(module.exports, "VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$ef641459105e6b1a);
$parcel$export(module.exports, "VIEW_PAGE_CONTEXT_MENU_EXPERIENCE", () => $4a617be77ace987f$export$255077470163d493);
$parcel$export(module.exports, "VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$43081e88ffac9568);
$parcel$export(module.exports, "VIEW_PAGE_CONTENT_HEADER_EXPERIENCE", () => $4a617be77ace987f$export$14a39beec323232a);
$parcel$export(module.exports, "VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE", () => $4a617be77ace987f$export$5870dabed6d7b7fc);
$parcel$export(module.exports, "VIEW_PAGE_SHARE_BUTTON_EXPERIENCE", () => $4a617be77ace987f$export$857306718a36d667);
$parcel$export(module.exports, "VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE", () => $4a617be77ace987f$export$b7907767002e32d);
$parcel$export(module.exports, "VIEW_PAGE_COMMENT_BUTTON_EXPERIENCE", () => $4a617be77ace987f$export$aa15347df133b367);
$parcel$export(module.exports, "VIEW_PAGE_DISCOVER_INLINE_COMMENTS_FEATURE_EXPERIENCE", () => $4a617be77ace987f$export$18cb1bed3afb8173);
$parcel$export(module.exports, "VIEW_PAGE_PUBLISH_AS_BLOG_EXPERIENCE", () => $4a617be77ace987f$export$b500820ed8b3aee5);
$parcel$export(module.exports, "WHITEBOARD_EXPERIENCE", () => $4a617be77ace987f$export$a83700d85c7e0745);
$parcel$export(module.exports, "WHITEBOARD_CONTENT_EXPERIENCE", () => $4a617be77ace987f$export$bdaf5db6d84a5581);
$parcel$export(module.exports, "WHITEBOARD_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE", () => $4a617be77ace987f$export$4252e8d96c415d57);
$parcel$export(module.exports, "WHITEBOARD_VERSION_HISTORY_RESTORE_EXPERIENCE", () => $4a617be77ace987f$export$b8cdecdc06b6252);
$parcel$export(module.exports, "WHITEBOARD_VERSION_HISTORY_LOAD_RESTORE_MODAL", () => $4a617be77ace987f$export$90f5a89f66458e77);
$parcel$export(module.exports, "DATABASE_EXPERIENCE", () => $4a617be77ace987f$export$f02aef641190ead6);
$parcel$export(module.exports, "DATABASE_CONTENT_EXPERIENCE", () => $4a617be77ace987f$export$7140ccdb0c7b2b37);
$parcel$export(module.exports, "DATABASE_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE", () => $4a617be77ace987f$export$857587c3b96ae00c);
$parcel$export(module.exports, "DATABASE_VERSION_HISTORY_RESTORE_EXPERIENCE", () => $4a617be77ace987f$export$bdbfe4dafa70ffab);
$parcel$export(module.exports, "DATABASE_VERSION_HISTORY_LOAD_RESTORE_MODAL", () => $4a617be77ace987f$export$7cc7b880d5b3f324);
$parcel$export(module.exports, "DATABASE_LOAD_HISTORICAL_VERSION", () => $4a617be77ace987f$export$ba3b240cb9a3ffd0);
$parcel$export(module.exports, "EMBED_EXPERIENCE", () => $4a617be77ace987f$export$c85a8dac7f241add);
$parcel$export(module.exports, "EMBED_CONTENT_EXPERIENCE", () => $4a617be77ace987f$export$927658f514adba70);
$parcel$export(module.exports, "EDIT_EMBED_EXPERIENCE", () => $4a617be77ace987f$export$c1092431c58e1571);
$parcel$export(module.exports, "FOLDER_EXPERIENCE", () => $4a617be77ace987f$export$3485e62ad9c27d0b);
$parcel$export(module.exports, "FOLDER_CONTENT_EXPERIENCE", () => $4a617be77ace987f$export$6237c6dbe5a63f05);
$parcel$export(module.exports, "CONTENT_TYPES_HEADER_EXPERIENCE", () => $4a617be77ace987f$export$7fd0425089f6d999);
$parcel$export(module.exports, "CONTENT_TYPES_HEADER_WATCH_EXPERIENCE", () => $4a617be77ace987f$export$47f14e5e827cfff3);
$parcel$export(module.exports, "CONTENT_CREATION_PAYWALL_EXPERIENCE", () => $4a617be77ace987f$export$748b7f600814978a);
$parcel$export(module.exports, "RECORD_LOOM_ENTRY_POINT", () => $4a617be77ace987f$export$5e1aeeb6f31be57a);
$parcel$export(module.exports, "LOOM_PAGE_HEADER_CONTENT_INSERTION", () => $4a617be77ace987f$export$c427a8b1052a6522);
$parcel$export(module.exports, "LOOM_CROSS_SELL_EXPERIENCE", () => $4a617be77ace987f$export$6ca90e5df7047c10);
$parcel$export(module.exports, "EDIT_PAGE_LABELS_EXPERIENCE", () => $4a617be77ace987f$export$96f8e8997d2c8722);
$parcel$export(module.exports, "LABELS_ADD_LABEL_EXPERIENCE", () => $4a617be77ace987f$export$e9e0897b7cf2ab3f);
$parcel$export(module.exports, "LABELS_CREATE_LABEL_EXPERIENCE", () => $4a617be77ace987f$export$5a4fc6855f9c48e);
$parcel$export(module.exports, "LABELS_DELETE_LABEL_EXPERIENCE", () => $4a617be77ace987f$export$3f19e9a9a0d72413);
$parcel$export(module.exports, "LABELS_SEARCH_LABEL_EXPERIENCE", () => $4a617be77ace987f$export$39d403abc2174e5e);
$parcel$export(module.exports, "LABELS_RECOMMENDED_EXPERIENCE", () => $4a617be77ace987f$export$4d573c9dfbc9337c);
$parcel$export(module.exports, "TEMPLATE_EDIT_PAGE_LABELS_EXPERIENCE", () => $4a617be77ace987f$export$8af5d568de2d4e43);
$parcel$export(module.exports, "TEMPLATE_EDIT_PAGE_LABELS_ADD_LABEL_EXPERIENCE", () => $4a617be77ace987f$export$c5ef6dea1c804893);
$parcel$export(module.exports, "TEMPLATE_EDIT_PAGE_LABELS_CREATE_LABEL_EXPERIENCE", () => $4a617be77ace987f$export$fa82b911a68fea4d);
$parcel$export(module.exports, "TEMPLATE_EDIT_PAGE_LABELS_DELETE_LABEL_EXPERIENCE", () => $4a617be77ace987f$export$20b2f79b83628af0);
$parcel$export(module.exports, "TEMPLATE_EDIT_PAGE_LABELS_SEARCH_LABEL_EXPERIENCE", () => $4a617be77ace987f$export$479dc90f08ae49d);
$parcel$export(module.exports, "HOME_EXPERIENCE", () => $4a617be77ace987f$export$66f0a82e06e92ea);
$parcel$export(module.exports, "HOME_SPACES_EXPERIENCE", () => $4a617be77ace987f$export$8856e11bfa69959d);
$parcel$export(module.exports, "HOME_RIGHT_PANEL_EXPERIENCE", () => $4a617be77ace987f$export$d931b261468db3be);
$parcel$export(module.exports, "HOME_RIGHT_PANEL_WELCOME_MESSAGE_EXPERIENCE", () => $4a617be77ace987f$export$45cf379c9ef28a2d);
$parcel$export(module.exports, "HOME_RIGHT_PANEL_CALENDARS_EXPERIENCE", () => $4a617be77ace987f$export$ceb391a6374fc2);
$parcel$export(module.exports, "HOME_RIGHT_PANEL_APPS_EXPERIENCE", () => $4a617be77ace987f$export$799c1b543715aab4);
$parcel$export(module.exports, "HOME_RIGHT_PANEL_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$519eb6f457873738);
$parcel$export(module.exports, "FEED_EXPERIENCE", () => $4a617be77ace987f$export$680e462c4f71cea1);
$parcel$export(module.exports, "HOME_OVERVIEW_EXPERIENCE", () => $4a617be77ace987f$export$d660d67b42309542);
$parcel$export(module.exports, "HOME_OVERVIEW_RECENT_EXPERIENCE", () => $4a617be77ace987f$export$f987075f870b167d);
$parcel$export(module.exports, "HOME_RECENT_EXPERIENCE", () => $4a617be77ace987f$export$94f2ecf008a81b99);
$parcel$export(module.exports, "HOME_STARRED_EXPERIENCE", () => $4a617be77ace987f$export$45d7f7ed7a82bcd);
$parcel$export(module.exports, "HOME_WATCHING_EXPERIENCE", () => $4a617be77ace987f$export$ecf5fd41d4da9bf8);
$parcel$export(module.exports, "HOME_DRAFTS_EXPERIENCE", () => $4a617be77ace987f$export$9b242f2ddcd908fc);
$parcel$export(module.exports, "ADVANCED_SEARCH_EXPERIENCE", () => $4a617be77ace987f$export$5393f7f46c9e5055);
$parcel$export(module.exports, "QUICK_SEARCH_PRE_QUERY", () => $4a617be77ace987f$export$ec545137ad6ac054);
$parcel$export(module.exports, "RECENT_DROPDOWN_VISITED_EXPERIENCE", () => $4a617be77ace987f$export$e64dfa2771353f5c);
$parcel$export(module.exports, "RECENT_DROPDOWN_CREATED_BY_ME_EXPERIENCE", () => $4a617be77ace987f$export$53f4f21972586e42);
$parcel$export(module.exports, "RECENT_DROPDOWN_WORKED_ON_EXPERIENCE", () => $4a617be77ace987f$export$985013c384c228e1);
$parcel$export(module.exports, "RECENT_DROPDOWN_DRAFTS_EXPERIENCE", () => $4a617be77ace987f$export$605220fac97de);
$parcel$export(module.exports, "RECENT_DROPDOWN_STARRED_EXPERIENCE", () => $4a617be77ace987f$export$7c6d9e11a2120c1b);
$parcel$export(module.exports, "PAGE_TREE_EXPERIENCE", () => $4a617be77ace987f$export$59a9c2c7ae337de7);
$parcel$export(module.exports, "PAGE_TREE_DND_EXPERIENCE", () => $4a617be77ace987f$export$bbc326cd1f124322);
$parcel$export(module.exports, "PAGE_TREE_QUICK_ACTIONS_EXPERIENCE", () => $4a617be77ace987f$export$f9d04e98575a0216);
$parcel$export(module.exports, "PAGE_TREE_RENAME_EXPERIENCE", () => $4a617be77ace987f$export$cd3eec90d152a8ea);
$parcel$export(module.exports, "BLOG_TREE_EXPERIENCE", () => $4a617be77ace987f$export$9d1f80f618a6627b);
$parcel$export(module.exports, "BLOG_TREE_PAGINATION_EXPERIENCE", () => $4a617be77ace987f$export$899513ff8720fa55);
$parcel$export(module.exports, "NAV2_ADMIN_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$357a2b9b5fb0f4e4);
$parcel$export(module.exports, "APP_NAV_GLOBAL_EXPERIENCE", () => $4a617be77ace987f$export$9b5915bb3a4fbcae);
$parcel$export(module.exports, "APP_NAV_CONTAINER_EXPERIENCE", () => $4a617be77ace987f$export$e3e183dd97af67fd);
$parcel$export(module.exports, "APP_NAV_ADMIN_EXPERIENCE", () => $4a617be77ace987f$export$14b67f3e8f5e6f95);
$parcel$export(module.exports, "APP_NAV_SPACES_DROPDOWN_EXPERIENCE", () => $4a617be77ace987f$export$f089f204ab93864e);
$parcel$export(module.exports, "APP_NAV_PAGES_DROPDOWN_EXPERIENCE", () => $4a617be77ace987f$export$5c3671291c82150b);
$parcel$export(module.exports, "APP_NAV_APPS_DROPDOWN_EXPERIENCE", () => $4a617be77ace987f$export$63d03b6879925116);
$parcel$export(module.exports, "APP_NAV_PROFILE_DROPDOWN_EXPERIENCE", () => $4a617be77ace987f$export$986139018de1521a);
$parcel$export(module.exports, "SPACE_DIRECTORY_EXPERIENCE", () => $4a617be77ace987f$export$6cebb7e0b005cd28);
$parcel$export(module.exports, "SPACE_DIRECTORY_YOUR_SPACES_EXPERIENCE", () => $4a617be77ace987f$export$aeda23f4b92ccc3b);
$parcel$export(module.exports, "SPACE_DIRECTORY_FILTER_EXPERIENCE", () => $4a617be77ace987f$export$4a890f75d0a61967);
$parcel$export(module.exports, "SPACE_DIRECTORY_PAGINATE_EXPERIENCE", () => $4a617be77ace987f$export$39e9ebfcfd8e8bad);
$parcel$export(module.exports, "CREATE_SPACE_SUBMIT_EXPERIENCE", () => $4a617be77ace987f$export$de6098630f95035a);
$parcel$export(module.exports, "CREATE_SPACE_VALIDATE_EXPERIENCE", () => $4a617be77ace987f$export$9b47bc79e174bc93);
$parcel$export(module.exports, "ONBOARDING_START_EXPERIENCE", () => $4a617be77ace987f$export$1d45fd96fcd751f5);
$parcel$export(module.exports, "ONBOARDING_CHOOSE_A_SPACE_CARD_EXPERIENCE", () => $4a617be77ace987f$export$a453322b492264d1);
$parcel$export(module.exports, "ONBOARDING_FOLLOW_SPACES_EXPERIENCE", () => $4a617be77ace987f$export$4ead33eb5b37dee5);
$parcel$export(module.exports, "ONBOARDING_NUDGE_EXPERIENCE", () => $4a617be77ace987f$export$749c4d9c23381805);
$parcel$export(module.exports, "ONBOARDING_ACCOUNT_SETUP_MODAL_EXPERIENCE", () => $4a617be77ace987f$export$1aaba3dd5fd71b43);
$parcel$export(module.exports, "ONBOARDING_QUICKSTART_EXPERIENCE", () => $4a617be77ace987f$export$e974684738710b35);
$parcel$export(module.exports, "ONBOARDING_JSW_XFLOW_ADMIN_SWITCHER_TOUR_EXPERIENCE", () => $4a617be77ace987f$export$7989a920a6248647);
$parcel$export(module.exports, "ONBOARDING_JSW_XFLOW_NTH_SWITCHER_TOUR_EXPERIENCE", () => $4a617be77ace987f$export$55172161173a2d6e);
$parcel$export(module.exports, "ONBOARDING_EDITOR_DRAFT_BANNER_EXPERIENCE", () => $4a617be77ace987f$export$e40755126e0d0b54);
$parcel$export(module.exports, "ONBOARDING_LAND_IN_EDITOR_BANNER_EXPERIENCE", () => $4a617be77ace987f$export$32b7ff7de164c7ad);
$parcel$export(module.exports, "ONBOARDING_EDITOR_PUBLISH_MODAL_PROMPT_EXPERIENCE", () => $4a617be77ace987f$export$d04515c6314fec11);
$parcel$export(module.exports, "ONBOARDING_EDITOR_PUBLISH_SUCCESS_FLAG_EXPERIENCE", () => $4a617be77ace987f$export$8425321c06a7c373);
$parcel$export(module.exports, "ONBOARDING_EDITOR_RECENT_DRAFT_SPOTLIGHT_EXPERIENCE", () => $4a617be77ace987f$export$f3de65caafc09b21);
$parcel$export(module.exports, "ONBOARDING_GRACE_PERIOD_BANNER_EXPERIENCE", () => $4a617be77ace987f$export$8ef86f4d4da92fa5);
$parcel$export(module.exports, "ONBOARDING_STORAGE_ENFORCEMENT_BANNER_EXPERIENCE", () => $4a617be77ace987f$export$8125e64b190d01e2);
$parcel$export(module.exports, "ONBOARDING_STORAGE_ENFORCEMENT_BANNER_DISMISS_EXPERIENCE", () => $4a617be77ace987f$export$343afc350dc963df);
$parcel$export(module.exports, "ONBOARDING_STORAGE_ENFORCEMENT_FLAGS_EXPERIENCE", () => $4a617be77ace987f$export$9491541521237449);
$parcel$export(module.exports, "ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL", () => $4a617be77ace987f$export$616864953f0d339);
$parcel$export(module.exports, "ONBOARDING_TEMPLATE_COLLECTIONS_EXPERIENCE", () => $4a617be77ace987f$export$61418bee30087820);
$parcel$export(module.exports, "ONBOARDING_TEMPLATE_COLLECTIONS_CREATE_TEMPLATE_EXPERIENCE", () => $4a617be77ace987f$export$70cb2a8c47e6afd8);
$parcel$export(module.exports, "ONBOARDING_IBO_NEW_HOME_RECENT_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$e61bc67cff9e0f2);
$parcel$export(module.exports, "ONBOARDING_IBO_NEW_HOME_SPACES_EXPERIENCE", () => $4a617be77ace987f$export$c1f744d5e0181dd);
$parcel$export(module.exports, "ONBOARDING_NTH_USER_SETUP_MODAL_EXPERIENCE", () => $4a617be77ace987f$export$c03570fb82968b7e);
$parcel$export(module.exports, "ONBOARDING_GLOBAL_IMPORT_PAGE_CREATE", () => $4a617be77ace987f$export$3971f3f0bdcc083);
$parcel$export(module.exports, "ONBOARDING_CONFLUENCE_RECAP_MODAL_EXPERIENCE", () => $4a617be77ace987f$export$7e62e90cd8969fd8);
$parcel$export(module.exports, "ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER", () => $4a617be77ace987f$export$3edd3fbbb3bde42a);
$parcel$export(module.exports, "ONBOARDING_PERSONALIZED_TEMPLATES_V2", () => $4a617be77ace987f$export$be5f66bc85ac48a2);
$parcel$export(module.exports, "ONBOARDING_NTH_USER_CONTENT_TYPE_SPOTLIGHT", () => $4a617be77ace987f$export$6778622238e08857);
$parcel$export(module.exports, "CONTENT_ACTION_APPS_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$241c40e7f0f7d7b2);
$parcel$export(module.exports, "BYLINE_APPS_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$404655cfa9ecfbc3);
$parcel$export(module.exports, "CONTEXT_MENU_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$224bdd20537c043c);
$parcel$export(module.exports, "SETTINGS_PAGE_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$fe9e3a7216162400);
$parcel$export(module.exports, "CUSTOM_CONTENT_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$16a139fd3cad706d);
$parcel$export(module.exports, "SPACE_PAGE_APPS_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$a333c0535291436a);
$parcel$export(module.exports, "SPACE_SETTINGS_INTEGRATIONS_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$4e660f0eec1b7b63);
$parcel$export(module.exports, "SPACE_SETTINGS_V2_INTEGRATIONS_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$42fe8757b12b9abb);
$parcel$export(module.exports, "SPACE_SETTINGS_LANDING_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$e4e961f07f20b1e9);
$parcel$export(module.exports, "GLOBAL_PAGE_APPS_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$30670c5b5576bc9d);
$parcel$export(module.exports, "BACKGROUND_SCRIPT_APPS_FORGE_EXPERIENCE", () => $4a617be77ace987f$export$7fee035e8993093b);
$parcel$export(module.exports, "SPACE_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$1fdf87b44bf66203);
$parcel$export(module.exports, "SPACE_PAGES_FILTER_EXPERIENCE", () => $4a617be77ace987f$export$eab5c9963f80520c);
$parcel$export(module.exports, "SPACE_PAGES_PAGINATE_EXPERIENCE", () => $4a617be77ace987f$export$6af7d14b23c7ed20);
$parcel$export(module.exports, "SPACE_VIEWS_INITIAL_EXPERIENCE", () => $4a617be77ace987f$export$1ae7d5b32e27dd1b);
$parcel$export(module.exports, "SPACE_VIEWS_CHANGE_EXPERIENCE", () => $4a617be77ace987f$export$92e7a42b4d134675);
$parcel$export(module.exports, "SPACE_VIEWS_PAGINATE_EXPERIENCE", () => $4a617be77ace987f$export$cd0c9383cd80d210);
$parcel$export(module.exports, "SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE", () => $4a617be77ace987f$export$90dff6c3d9facebb);
$parcel$export(module.exports, "SITE_PERMISSION_REMOVE_SPACE_ACCESS_EXPERIENCE", () => $4a617be77ace987f$export$8a00f2824cff2c5e);
$parcel$export(module.exports, "SITE_PERMISSION_ADD_SPACE_ACCESS_EXPERIENCE", () => $4a617be77ace987f$export$30e6c2e5c854e3d7);
$parcel$export(module.exports, "SITE_PERMISSION_CHANGE_GUEST_SPACE_ACCESS_EXPERIENCE", () => $4a617be77ace987f$export$b07723d1eb2313ad);
$parcel$export(module.exports, "ANALYTICS_BYLINE_EXPERIENCE", () => $4a617be77ace987f$export$94d2e4338cb54b2c);
$parcel$export(module.exports, "ANALYTICS_DIALOG_EXPERIENCE", () => $4a617be77ace987f$export$27bffcf643f6c238);
$parcel$export(module.exports, "ANALYTICS_DIALOG_UPSELL_EXPERIENCE", () => $4a617be77ace987f$export$460c09ff51f88f24);
$parcel$export(module.exports, "PAGE_ANALYTICS_EXPERIENCE", () => $4a617be77ace987f$export$371cd738ccd37b38);
$parcel$export(module.exports, "PAGE_ANALYTICS_VIEW_CHART_EXPERIENCE", () => $4a617be77ace987f$export$3861bdd55a91a4a0);
$parcel$export(module.exports, "PAGE_ANALYTICS_TOTAL_VIEWS_CARD_EXPERIENCE", () => $4a617be77ace987f$export$968182ed9835d21a);
$parcel$export(module.exports, "PAGE_ANALYTICS_UNIQUE_VIEWERS_CARD_EXPERIENCE", () => $4a617be77ace987f$export$24ed3cf43f154734);
$parcel$export(module.exports, "PAGE_ANALYTICS_MENTIONED_USERS_CARD_EXPERIENCE", () => $4a617be77ace987f$export$a531b5e2ff0b9747);
$parcel$export(module.exports, "PAGE_ANALYTICS_VIEWERS_TABLE_EXPERIENCE", () => $4a617be77ace987f$export$27ccd506e08e0e);
$parcel$export(module.exports, "PAGE_ANALYTICS_MENTIONED_USERS_REMINDER_EXPERIENCE", () => $4a617be77ace987f$export$ec84fc419c424bb5);
$parcel$export(module.exports, "PAGE_ANALYTICS_MENTIONED_USERS_TABLE_EXPERIENCE", () => $4a617be77ace987f$export$8ddcb6f0d9ebf30e);
$parcel$export(module.exports, "PAGE_ANALYTICS_LINKS_INBOUND_TOTAL_CLICKS_CARD_EXPERIENCE", () => $4a617be77ace987f$export$f8f3f70f34becef9);
$parcel$export(module.exports, "PAGE_ANALYTICS_LINKS_INBOUND_CTR_CARD_EXPERIENCE", () => $4a617be77ace987f$export$3d388f0f7fc44c3f);
$parcel$export(module.exports, "PAGE_ANALYTICS_LINKS_INBOUND_TABLE_EXPERIENCE", () => $4a617be77ace987f$export$310d1207c2b3ca7d);
$parcel$export(module.exports, "PAGE_ANALYTICS_LINKS_OUTBOUND_TOTAL_CLICKS_CARD_EXPERIENCE", () => $4a617be77ace987f$export$ab6abc47e6a1b436);
$parcel$export(module.exports, "PAGE_ANALYTICS_LINKS_OUTBOUND_CTR_CARD_EXPERIENCE", () => $4a617be77ace987f$export$a1934b3cd762057c);
$parcel$export(module.exports, "PAGE_ANALYTICS_LINKS_OUTBOUND_TABLE_EXPERIENCE", () => $4a617be77ace987f$export$11b4f841e984d2a8);
$parcel$export(module.exports, "SPACE_ANALYTICS_EXPERIENCE", () => $4a617be77ace987f$export$5478a6cbf2100291);
$parcel$export(module.exports, "SPACE_ANALYTICS_OVERVIEW_CHART_EXPERIENCE", () => $4a617be77ace987f$export$12f42654844570d0);
$parcel$export(module.exports, "SPACE_ANALYTICS_POPULAR_CONTENT_CARD_EXPERIENCE", () => $4a617be77ace987f$export$40a98279383e549e);
$parcel$export(module.exports, "SPACE_ANALYTICS_ACTIVE_READERS_CARD_EXPERIENCE", () => $4a617be77ace987f$export$340eeaf9226a3e00);
$parcel$export(module.exports, "SPACE_ANALYTICS_ACTIVE_CONTRIBUTORS_CARD_EXPERIENCE", () => $4a617be77ace987f$export$327f825878dc4802);
$parcel$export(module.exports, "SPACE_ANALYTICS_CONTENT_ACTIVITY_TABLE_EXPERIENCE", () => $4a617be77ace987f$export$9595ac2edfb0edec);
$parcel$export(module.exports, "SPACE_ANALYTICS_USER_ACTIVITY_TABLE_EXPERIENCE", () => $4a617be77ace987f$export$bfbd1b5517d327f6);
$parcel$export(module.exports, "SPACE_ANALYTICS_ASYNC_EXPORT_EXPERIENCE", () => $4a617be77ace987f$export$ae73006a481ab5bc);
$parcel$export(module.exports, "SPACE_ANALYTICS_PERMISSIONS_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$e27cd103e9670e33);
$parcel$export(module.exports, "SPACE_ANALYTICS_PERMISSIONS_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$5a507008b468c991);
$parcel$export(module.exports, "SITE_ANALYTICS_EXPERIENCE", () => $4a617be77ace987f$export$8ed4273d919d1070);
$parcel$export(module.exports, "SITE_ANALYTICS_OVERVIEW_CHART_EXPERIENCE", () => $4a617be77ace987f$export$f2d660eb8a9ba56e);
$parcel$export(module.exports, "SITE_ANALYTICS_POPULAR_SPACES_CARD_EXPERIENCE", () => $4a617be77ace987f$export$8e5ed6a75264c549);
$parcel$export(module.exports, "SITE_ANALYTICS_ACTIVE_READERS_CARD_EXPERIENCE", () => $4a617be77ace987f$export$7cc392d1f03d59f9);
$parcel$export(module.exports, "SITE_ANALYTICS_POPULAR_SEARCHES_CARD_EXPERIENCE", () => $4a617be77ace987f$export$e5b5e8161ac66e90);
$parcel$export(module.exports, "SITE_ANALYTICS_SPACES_TABLE_EXPERIENCE", () => $4a617be77ace987f$export$221bc81bca00257);
$parcel$export(module.exports, "SITE_ANALYTICS_USERS_TABLE_EXPERIENCE", () => $4a617be77ace987f$export$31b3362136d95230);
$parcel$export(module.exports, "SITE_ANALYTICS_SEARCH_TABLE_EXPERIENCE", () => $4a617be77ace987f$export$86dcda8aa2b50b8a);
$parcel$export(module.exports, "SITE_ANALYTICS_SEARCH_PANEL_EXPERIENCE", () => $4a617be77ace987f$export$91ffba1860245927);
$parcel$export(module.exports, "SITE_ANALYTICS_SEARCH_PANEL_GRAPH_EXPERIENCE", () => $4a617be77ace987f$export$1b7a393d48199f1c);
$parcel$export(module.exports, "SITE_ANALYTICS_SEARCH_PANEL_CONTENT_LIST_EXPERIENCE", () => $4a617be77ace987f$export$4020b74c723b4607);
$parcel$export(module.exports, "SITE_ANALYTICS_SEARCH_PANEL_SPACES_LIST_EXPERIENCE", () => $4a617be77ace987f$export$343c48c7798baab8);
$parcel$export(module.exports, "SITE_ANALYTICS_PERMISSIONS_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$58ad08103bb62c4b);
$parcel$export(module.exports, "SITE_ANALYTICS_PERMISSIONS_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$f73b370055c8cbef);
$parcel$export(module.exports, "BULK_SPACE_PERMISSIONS_EXPERIENCE", () => $4a617be77ace987f$export$5d12872cd9595692);
$parcel$export(module.exports, "GLOBAL_PERMS_EXPERIENCE", () => $4a617be77ace987f$export$ee395498ea9fc566);
$parcel$export(module.exports, "EXPAND_GROUP_EXPERIENCE", () => $4a617be77ace987f$export$bbc6348b8482e5b1);
$parcel$export(module.exports, "GROUP_MEMBERS_LOAD_MORE_EXPERIENCE", () => $4a617be77ace987f$export$f96f0a60f840676c);
$parcel$export(module.exports, "TEAM_CALENDAR_EXPERIENCE", () => $4a617be77ace987f$export$b3639316349424);
$parcel$export(module.exports, "TEAM_CALENDAR_UPSELL_EXPERIENCE", () => $4a617be77ace987f$export$b731d5eab77f5ae2);
$parcel$export(module.exports, "TEAM_CALENDARS_ADD_NEW_CALENDAR_EXPERIENCE", () => $4a617be77ace987f$export$6e2e950545a96fb5);
$parcel$export(module.exports, "TEAM_CALENDARS_ADD_EXISTING_CALENDAR_EXPERIENCE", () => $4a617be77ace987f$export$e60dce5b561d6551);
$parcel$export(module.exports, "TEAM_CALENDARS_DELETE_CALENDAR_EXPERIENCE", () => $4a617be77ace987f$export$25067b28cdd34cc6);
$parcel$export(module.exports, "TEAM_CALENDARS_REMOVE_CALENDAR_EXPERIENCE", () => $4a617be77ace987f$export$19d86a52695ae312);
$parcel$export(module.exports, "TEAM_CALENDARS_SUBSCRIBE_CALENDAR_EXPERIENCE", () => $4a617be77ace987f$export$120ce8feec0488aa);
$parcel$export(module.exports, "TEAM_CALENDARS_UPDATE_CALENDAR_EXPERIENCE", () => $4a617be77ace987f$export$dc96bc0456e09d60);
$parcel$export(module.exports, "TEAM_CALENDARS_IMPORT_CALENDAR_EXPERIENCE", () => $4a617be77ace987f$export$d23cc4800e46d1e6);
$parcel$export(module.exports, "TEAM_CALENDARS_ADD_EVENT_TYPE_EXPERIENCE", () => $4a617be77ace987f$export$13b2254026213b46);
$parcel$export(module.exports, "TEAM_CALENDARS_DELETE_EVENT_TYPE_EXPERIENCE", () => $4a617be77ace987f$export$c348a46d97587ee4);
$parcel$export(module.exports, "TEAM_CALENDARS_UPDATE_EVENT_TYPE_EXPERIENCE", () => $4a617be77ace987f$export$bfd3172de881908e);
$parcel$export(module.exports, "TEAM_CALENDARS_ADD_EVENT_EXPERIENCE", () => $4a617be77ace987f$export$e1a32de918001908);
$parcel$export(module.exports, "TEAM_CALENDARS_JIRA_CALENDAR_EXPERIENCE", () => $4a617be77ace987f$export$36abe825d06f7b68);
$parcel$export(module.exports, "TEAM_CALENDARS_UPDATE_EVENT_EXPERIENCE", () => $4a617be77ace987f$export$1be22ae521e809a9);
$parcel$export(module.exports, "TEAM_CALENDARS_DELETE_EVENT_EXPERIENCE", () => $4a617be77ace987f$export$eb40d48a494923c8);
$parcel$export(module.exports, "TEAM_CALENDARS_UPDATE_RESTRICTIONS_EXPERIENCE", () => $4a617be77ace987f$export$66104f246f979de9);
$parcel$export(module.exports, "EDIT_SPACE_LOGO_RESTORE_EXPERIENCE", () => $4a617be77ace987f$export$a245b5e8e50aca4e);
$parcel$export(module.exports, "EDIT_SPACE_LOGO_SAVE_EXPERIENCE", () => $4a617be77ace987f$export$38c64d0e786460e8);
$parcel$export(module.exports, "EDIT_SPACE_LOGO_DETAILS_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$53b6eab7c794efdf);
$parcel$export(module.exports, "COVER_PICTURE_UNSPLASH_UPLOAD_EXPERIENCE", () => $4a617be77ace987f$export$d4e50447c54e832a);
$parcel$export(module.exports, "COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE", () => $4a617be77ace987f$export$3b296e5e8d4fbd72);
$parcel$export(module.exports, "COVER_PICTURE_REMOVE_EXPERIENCE", () => $4a617be77ace987f$export$75c73b1e1363abb2);
$parcel$export(module.exports, "VIEW_APP_SUGGESTIONS_EXPERIENCE", () => $4a617be77ace987f$export$56b59e3252d65c77);
$parcel$export(module.exports, "CONDITIONAL_PUBLISH_DIALOG_EXPERIENCE", () => $4a617be77ace987f$export$61ad3866e7413864);
$parcel$export(module.exports, "EXTENSION_POINT_BYLINE_EXPERIENCE", () => $4a617be77ace987f$export$5685c80727d12c34);
$parcel$export(module.exports, "EXTENSION_POINT_SPACE_BUTTONS_EXPERIENCE", () => $4a617be77ace987f$export$4b9cf95d297cf82f);
$parcel$export(module.exports, "EXTENSION_POINT_HOME_FOOTER_EXPERIENCE", () => $4a617be77ace987f$export$811ef7c3a5f94996);
$parcel$export(module.exports, "EXTENSION_POINT_HOME_HEADER_EXPERIENCE", () => $4a617be77ace987f$export$dfab08323861cbc1);
$parcel$export(module.exports, "EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE", () => $4a617be77ace987f$export$aa9a33eaf0b3cefa);
$parcel$export(module.exports, "EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE", () => $4a617be77ace987f$export$4933a09c775176cb);
$parcel$export(module.exports, "EXTENSION_POINT_PAGE_BANNER_EXPERIENCE", () => $4a617be77ace987f$export$645909341bfebc9b);
$parcel$export(module.exports, "EXTENSION_POINT_SPACE_SETTINGS_TABS_EXPERIENCE", () => $4a617be77ace987f$export$facf18b53398c3d7);
$parcel$export(module.exports, "CORE_INVITES_EXPERIENCE", () => $4a617be77ace987f$export$23be08d2ca73ecf);
$parcel$export(module.exports, "CUSTOM_CONTENT_PAGE_ALL_EXPERIENCE", () => $4a617be77ace987f$export$b1dd9d960d4ea959);
$parcel$export(module.exports, "CUSTOM_CONTENT_SPACE_LIST_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$38660dec2eb2a695);
$parcel$export(module.exports, "CUSTOM_CONTENT_PAGE_LIST_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$7b1fe4d076a9542a);
$parcel$export(module.exports, "CUSTOM_CONTENT_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$ad06e79f63068f5e);
$parcel$export(module.exports, "CONNECTIONS_PANEL_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$eef674482902ef6d);
$parcel$export(module.exports, "EOP_RECS_EXPERIENCE", () => $4a617be77ace987f$export$c5bcbbcb1df627e5);
$parcel$export(module.exports, "NOTIFY_ON_FIRST_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$3b683344868f9f0a);
$parcel$export(module.exports, "PRESENTER_MODE_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$4fdd9934209dba0e);
$parcel$export(module.exports, "PRESENTER_MODE_FULLSCREEN_API_EXPERIENCE", () => $4a617be77ace987f$export$40638d9b45e8ceca);
$parcel$export(module.exports, "VIEW_PUBLIC_LINK_SITE_SETTINGS_EXPERIENCE", () => $4a617be77ace987f$export$b1f7a84b45eb9afb);
$parcel$export(module.exports, "VIEW_PUBLIC_LINK_SPACES_TABLE_EXPERIENCE", () => $4a617be77ace987f$export$8294c237289049c4);
$parcel$export(module.exports, "VIEW_PUBLIC_LINKS_PAGE_TABLE_EXPERIENCE", () => $4a617be77ace987f$export$ec6e09c5fd9fa221);
$parcel$export(module.exports, "PUBLIC_LINKS_SPACES_TABLE_ACTION_EXPERIENCE", () => $4a617be77ace987f$export$5cc7e9470bfae723);
$parcel$export(module.exports, "PUBLIC_LINK_SITE_TOGGLE_CHANGE_EXPERIENCE", () => $4a617be77ace987f$export$c102a9d514fc95ac);
$parcel$export(module.exports, "VIEW_PUBLIC_LINKS_SPACE_SETTINGS_EXPERIENCE", () => $4a617be77ace987f$export$ff2fb656c8231637);
$parcel$export(module.exports, "PUBLIC_LINKS_SPACE_TOGGLE_CHANGE_EXPERIENCE", () => $4a617be77ace987f$export$ba803d464f49a265);
$parcel$export(module.exports, "VIEW_PUBLIC_LINKS_DEFAULT_SPACE_SETTINGS_EXPERIENCE", () => $4a617be77ace987f$export$d95bcf023bd8993);
$parcel$export(module.exports, "PUBLIC_LINKS_DEFAULT_SPACE_TOGGLE_CHANGE_EXPERIENCE", () => $4a617be77ace987f$export$7362876707c57af9);
$parcel$export(module.exports, "VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$c7ff49e7eaa45ff1);
$parcel$export(module.exports, "PUBLIC_LINK_RENDERED_EXPERIENCE", () => $4a617be77ace987f$export$24cbec84f278c600);
$parcel$export(module.exports, "PUBLIC_LINK_TOGGLE_CHANGE_EXPERIENCE", () => $4a617be77ace987f$export$5b89a66b04cea206);
$parcel$export(module.exports, "PUBLIC_LINK_DISABLE_FROM_RESTRICTIONS_EXPERIENCE", () => $4a617be77ace987f$export$44b7602dc9689e08);
$parcel$export(module.exports, "PUBLIC_LINK_PAGE_TABLE_ACTION_EXPERIENCE", () => $4a617be77ace987f$export$eed7907041fecd69);
$parcel$export(module.exports, "EXTERNAL_SHARE_EXPERIENCE", () => $4a617be77ace987f$export$49a01ffc1a18656b);
$parcel$export(module.exports, "COPY_CONTENT_LINK_EXPERIENCE", () => $4a617be77ace987f$export$e25df1f458506fcd);
$parcel$export(module.exports, "CONTENT_HISTORY_EXPERIENCE", () => $4a617be77ace987f$export$7c34e8285a2b9238);
$parcel$export(module.exports, "VIEW_TASKS_EXPERIENCE", () => $4a617be77ace987f$export$b9b41dfe39f06772);
$parcel$export(module.exports, "SET_TASK_COMPLETE_EXPERIENCE", () => $4a617be77ace987f$export$6be3453279e7dd85);
$parcel$export(module.exports, "CHANGE_PAGE_OWNER_EXPERIENCE", () => $4a617be77ace987f$export$80a3b142ba868b57);
$parcel$export(module.exports, "CONTENT_OWNERSHIP_DIALOG_EXPERIENCE", () => $4a617be77ace987f$export$19875313f499fad9);
$parcel$export(module.exports, "ADMIN_ANNOUNCEMENT_BANNER_EXPERIENCE", () => $4a617be77ace987f$export$e94c6163c32592ce);
$parcel$export(module.exports, "ADMIN_ANNOUNCEMENT_BANNER_DISMISS_EXPERIENCE", () => $4a617be77ace987f$export$7653dfd9fd5557b);
$parcel$export(module.exports, "ADMIN_ANNOUNCEMENT_BANNER_SETTINGS_EXPERIENCE", () => $4a617be77ace987f$export$394294e59b36efb9);
$parcel$export(module.exports, "ADMIN_ANNOUNCEMENT_BANNER_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$8f017785cc4bb995);
$parcel$export(module.exports, "ADMIN_ANNOUNCEMENT_BANNER_TURN_OFF_EXPERIENCE", () => $4a617be77ace987f$export$a4d890726485d79a);
$parcel$export(module.exports, "ADMIN_ANNOUNCEMENT_BANNER_TABLE_EXPERIENCE", () => $4a617be77ace987f$export$47d510c88b13ea8d);
$parcel$export(module.exports, "SPACE_MANAGER_EXPERIENCE", () => $4a617be77ace987f$export$548adb1a2fe6e6b1);
$parcel$export(module.exports, "SPACE_MANAGER_QUICK_ACTION_ITEM_EXPERIENCE", () => $4a617be77ace987f$export$35f739fc0b127205);
$parcel$export(module.exports, "COMPANY_HUB_GENERAL_SETTINGS_EXPERIENCE", () => $4a617be77ace987f$export$2decaadcf840e6b3);
$parcel$export(module.exports, "COMPANY_HUB_GENERAL_SETTINGS_YOUR_HUB_EXPERIENCE", () => $4a617be77ace987f$export$23b4a008c670d304);
$parcel$export(module.exports, "COMPANY_HUB_GENERAL_SETTINGS_YOUR_HUB_ACTIONS_EXPERIENCE", () => $4a617be77ace987f$export$c6198e9d6ab9e417);
$parcel$export(module.exports, "COMPANY_HUB_GENERAL_SETTINGS_HUB_RECENT_ACTIVITY_EXPERIENCE", () => $4a617be77ace987f$export$e1b506612f6e9657);
$parcel$export(module.exports, "COMPANY_HUB_GENERAL_SETTINGS_HUB_VIEWS_EXPERIENCE", () => $4a617be77ace987f$export$dfdc3f1142f40689);
$parcel$export(module.exports, "COMPANY_HUB_GENERAL_SETTINGS_MOST_CLICKS_EXPERIENCE", () => $4a617be77ace987f$export$e9845af7b7fd8501);
$parcel$export(module.exports, "ADMIN_CENTER_EXPERIENCE", () => $4a617be77ace987f$export$237a7d3a8e219dbb);
$parcel$export(module.exports, "ADMIN_CENTER_CONFLUENCE_ADMINS_EXPERIENCE", () => $4a617be77ace987f$export$b7b3a9d4d05ffd12);
$parcel$export(module.exports, "ADMIN_CENTER_SEARCH_COUNT_EXPERIENCE", () => $4a617be77ace987f$export$367f60a3ad6918c1);
$parcel$export(module.exports, "ADMIN_CENTER_SEARCH_CTR_EXPERIENCE", () => $4a617be77ace987f$export$9a8113803e6447cf);
$parcel$export(module.exports, "ADMIN_CENTER_TOP_SEARCHES_EXPERIENCE", () => $4a617be77ace987f$export$8f37d7eb1e6f681d);
$parcel$export(module.exports, "ADMIN_CENTER_TOP_UNSUCCESSFUL_SEARCHES_EXPERIENCE", () => $4a617be77ace987f$export$2ad5d40786f81da0);
$parcel$export(module.exports, "ADMIN_CENTER_EXTERNAL_ACCESS_EXPERIENCE", () => $4a617be77ace987f$export$e68566fb281dbb33);
$parcel$export(module.exports, "ADMIN_CENTER_BETA_FEATURES_EXPERIENCE", () => $4a617be77ace987f$export$a7f1ee469fd8596c);
$parcel$export(module.exports, "ADMIN_CENTER_TOTAL_SPACES_EXPERIENCE", () => $4a617be77ace987f$export$8a3b06f53918d80e);
$parcel$export(module.exports, "ADMIN_CENTER_TOTAL_CONTENT_EXPERIENCE", () => $4a617be77ace987f$export$d4f2672a4a997be2);
$parcel$export(module.exports, "ADMIN_CENTER_GROUPED_SUMMARY_EXPERIENCE", () => $4a617be77ace987f$export$61440d1f5d765856);
$parcel$export(module.exports, "ADMIN_CENTER_INACTIVE_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$a122d82c3b13ba99);
$parcel$export(module.exports, "ADMIN_CENTER_TOP_INACTIVE_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$bf035e1987052c42);
$parcel$export(module.exports, "ADMIN_CENTER_DEACTIVATED_OWNER_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$1613edca53571ea3);
$parcel$export(module.exports, "ADMIN_CENTER_TOP_DEACTIVATED_OWNER_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$4ba2b40dc30760f9);
$parcel$export(module.exports, "ADMIN_CENTER_CONTENT_CREATED_EXPERIENCE", () => $4a617be77ace987f$export$5d6b6234c4e9f70d);
$parcel$export(module.exports, "ADMIN_CENTER_CONTENT_UPDATED_EXPERIENCE", () => $4a617be77ace987f$export$39552d32ae5efc36);
$parcel$export(module.exports, "ADMIN_CENTER_CONTENT_VIEWS_EXPERIENCE", () => $4a617be77ace987f$export$a4934c826482e207);
$parcel$export(module.exports, "ADMIN_CENTER_TOP_CONTENT_VIEWS_EXPERIENCE", () => $4a617be77ace987f$export$4c0549ea0cf0f43d);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$6b8c8a94a6fb0b10);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_EXPERIENCE", () => $4a617be77ace987f$export$a4855248cbcdc638);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_SEARCH_COUNT_EXPERIENCE", () => $4a617be77ace987f$export$f1c6b44ad858e24f);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_SEARCH_CTR_EXPERIENCE", () => $4a617be77ace987f$export$aaba8c517b5b0014);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_TOTAL_SPACES_EXPERIENCE", () => $4a617be77ace987f$export$3463471aa64d2a20);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_TOTAL_CONTENT_EXPERIENCE", () => $4a617be77ace987f$export$aed49d47c6d277d2);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_INACTIVE_PAGES_NUM_EXPERIENCE", () => $4a617be77ace987f$export$c89944dc251c7694);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_INACTIVE_PAGES_PERCENT_EXPERIENCE", () => $4a617be77ace987f$export$45d06e7b1bc06ed4);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_DEACTIVATED_OWNER_PAGES_NUM_EXPERIENCE", () => $4a617be77ace987f$export$50744fb70a2982a2);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_DEACTIVATED_OWNER_PAGES_PERCENT_EXPERIENCE", () => $4a617be77ace987f$export$35f523c785c60e15);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_CONTENT_CREATED_EXPERIENCE", () => $4a617be77ace987f$export$d4f40a3c80d7fa00);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_CONTENT_UPDATED_EXPERIENCE", () => $4a617be77ace987f$export$3e98f2df16d1f652);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_CONTENT_VIEWS_EXPERIENCE", () => $4a617be77ace987f$export$512d403dd28c8f13);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_PUBLIC_LINK_VIEWS_EXPERIENCE", () => $4a617be77ace987f$export$b5db801ede6fe9e5);
$parcel$export(module.exports, "ADMIN_CENTER_OVERVIEW_PUBLIC_LINKS_EXPERIENCE", () => $4a617be77ace987f$export$2df6bcfd56d7c9e8);
$parcel$export(module.exports, "ADMIN_CENTER_PREMIUM_TRIAL_INSIGHTS_EXPERIENCE", () => $4a617be77ace987f$export$cc151de96adac045);
$parcel$export(module.exports, "ADMIN_CENTER_SUGGESTIONS_EXPERIENCE", () => $4a617be77ace987f$export$6c98543cf0a07a9f);
$parcel$export(module.exports, "ADMIN_CENTER_SUGGESTIONS_UNASSIGNED_GUEST_EXPERIENCE", () => $4a617be77ace987f$export$9f5be3c30e870f46);
$parcel$export(module.exports, "ADMIN_CENTER_SUGGESTIONS_INACTIVE_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$56c7132579558fc8);
$parcel$export(module.exports, "ADMIN_CENTER_SUGGESTIONS_DEACTIVATED_OWNER_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$4bc17e6067981b1f);
$parcel$export(module.exports, "ADMIN_CENTER_SUGGESTIONS_SPACE_MANAGER_EXPERIENCE", () => $4a617be77ace987f$export$2f62829f51afa45a);
$parcel$export(module.exports, "ADMIN_CENTER_SUGGESTIONS_USER_ACCESS_EXPERIENCE", () => $4a617be77ace987f$export$19020e617b152304);
$parcel$export(module.exports, "ADMIN_CENTER_SUGGESTIONS_QUICK_ACTION_ITEM_EXPERIENCE", () => $4a617be77ace987f$export$12a435102ccb624a);
$parcel$export(module.exports, "ADMIN_CENTER_SUGGESTIONS_METRIC_CTA_EXPERIENCE", () => $4a617be77ace987f$export$dec2cee4628ab9c4);
$parcel$export(module.exports, "SPACE_ADMIN_CENTER_EXPERIENCE", () => $4a617be77ace987f$export$88a8c07833ef47b1);
$parcel$export(module.exports, "SPACE_ADMIN_CENTER_GROUPED_SUMMARY_EXPERIENCE", () => $4a617be77ace987f$export$fb0bb005ed2de56c);
$parcel$export(module.exports, "SPACE_ADMIN_CENTER_EXTERNAL_ACCESS_EXPERIENCE", () => $4a617be77ace987f$export$73c5a862f5073e46);
$parcel$export(module.exports, "SPACE_ADMIN_CENTER_SPACE_ADMINS_EXPERIENCE", () => $4a617be77ace987f$export$4d72041a86e9e003);
$parcel$export(module.exports, "SPACE_ADMIN_CENTER_CONTENT_VIEWS_EXPERIENCE", () => $4a617be77ace987f$export$724928cbf61f8819);
$parcel$export(module.exports, "SPACE_ADMIN_CENTER_TOP_CONTENT_VIEWS_EXPERIENCE", () => $4a617be77ace987f$export$eee5f90734589227);
$parcel$export(module.exports, "SPACE_ADMIN_CENTER_CONTENT_CREATED_EXPERIENCE", () => $4a617be77ace987f$export$a5e95165e3a702d1);
$parcel$export(module.exports, "SPACE_ADMIN_CENTER_CONTENT_UPDATED_EXPERIENCE", () => $4a617be77ace987f$export$32dde1d12c499528);
$parcel$export(module.exports, "SPACE_ADMIN_CENTER_TOTAL_CONTENT_EXPERIENCE", () => $4a617be77ace987f$export$147226654b32f956);
$parcel$export(module.exports, "SPACE_ADMIN_CENTER_INACTIVE_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$648d00fafa66ae14);
$parcel$export(module.exports, "SPACE_ADMIN_CENTER_TOP_INACTIVE_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$a3fdce9bb003f0b8);
$parcel$export(module.exports, "SPACE_ADMIN_CENTER_DEACTIVATED_OWNER_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$71daddda71b57298);
$parcel$export(module.exports, "SPACE_ADMIN_CENTER_TOP_DEACTIVATED_OWNER_PAGES_EXPERIENCE", () => $4a617be77ace987f$export$62d9e5dacf2e073d);
$parcel$export(module.exports, "DWELL_TIME_START_EXPERIENCE", () => $4a617be77ace987f$export$8c3b600f7a5dce0f);
$parcel$export(module.exports, "TRIAL_COMPONENTS_ACTION_MENU_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$17c6a28e6e0e88af);
$parcel$export(module.exports, "TRIAL_COMPONENTS_LOZENGE_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$b0fe8424f6f27f51);
$parcel$export(module.exports, "TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$40c0cee2cad141c5);
$parcel$export(module.exports, "TRIAL_COMPONENTS_PREMIUM_INSIGHTS_ACTION_MENU_ITEM_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$d6bad6d87d8c028f);
$parcel$export(module.exports, "TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$d0e7688ec900110c);
$parcel$export(module.exports, "QUICK_SUMMARY_EXPERIENCE", () => $4a617be77ace987f$export$f8372d329c2aeea0);
$parcel$export(module.exports, "QUICK_SUMMARY_WHITEBOARDS_EXPERIENCE", () => $4a617be77ace987f$export$31e4e6e2658a6cae);
$parcel$export(module.exports, "QUICK_SUMMARY_TO_PAGE_EXPERIENCE", () => $4a617be77ace987f$export$4a493e4dc06e57e7);
$parcel$export(module.exports, "COMMENTS_SUMMARY_EXPERIENCE", () => $4a617be77ace987f$export$5565b0bba4d72eee);
$parcel$export(module.exports, "AI_CONTENT_CATCHUP_EXPERIENCE", () => $4a617be77ace987f$export$8d9dfd2f17501337);
$parcel$export(module.exports, "AI_PRESENTATION_GENERATION_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$eb38477d5de37f36);
$parcel$export(module.exports, "AI_PRESENTATION_GENERATION_CREATE_EXPERIENCE", () => $4a617be77ace987f$export$ed3e815374d54f04);
$parcel$export(module.exports, "AI_SNIPPET_EXPERIENCE", () => $4a617be77ace987f$export$bb8fdee2f545676e);
$parcel$export(module.exports, "AI_AUDIO", () => $4a617be77ace987f$export$a48ee5f2c131dea3);
$parcel$export(module.exports, "AI_TITLE_GENERATION", () => $4a617be77ace987f$export$daafa0ab79e187e5);
$parcel$export(module.exports, "PLAN_COMPARISON_MODAL", () => $4a617be77ace987f$export$530e334566c01c65);
$parcel$export(module.exports, "READING_AIDS_EXPERIENCE", () => $4a617be77ace987f$export$7f32d11b06ee25ff);
$parcel$export(module.exports, "AI_DEFINITIONS_AUTOHIGHLIGHT_EXPERIENCE", () => $4a617be77ace987f$export$38e6a52d8f0a641f);
$parcel$export(module.exports, "VIEW_GUEST_REQUEST_TO_UPGRADE_EXPERIENCE", () => $4a617be77ace987f$export$9bd965a890617f5b);
$parcel$export(module.exports, "SUBMIT_GUEST_REQUEST_TO_UPGRADE_EXPERIENCE", () => $4a617be77ace987f$export$85b1366ed05e7209);
$parcel$export(module.exports, "SUBMIT_GUEST_MENTIONS_UPGRADE_FLOW_EXPERIENCE", () => $4a617be77ace987f$export$aace851408b6de3e);
$parcel$export(module.exports, "VIEW_GUEST_SPACES_MENU_REQUEST_TO_UPGRADE_EXPERIENCE", () => $4a617be77ace987f$export$611140537004e76c);
$parcel$export(module.exports, "SUBMIT_GUEST_SPACES_MENU_REQUEST_TO_UPGRADE_EXPERIENCE", () => $4a617be77ace987f$export$e73147035caab2f2);
$parcel$export(module.exports, "RESTORE_SPACE_EXPERIENCE", () => $4a617be77ace987f$export$11311af26ac8cb8b);
$parcel$export(module.exports, "HARD_DELETE_SPACE_EXPERIENCE", () => $4a617be77ace987f$export$dec29f1de3a4a5ce);
$parcel$export(module.exports, "VIEW_SPACE_PERMISSIONS", () => $4a617be77ace987f$export$e69556d68987dda1);
$parcel$export(module.exports, "EDIT_SPACE_PERMISSIONS", () => $4a617be77ace987f$export$a5bcda9ae1f6839a);
$parcel$export(module.exports, "VIEW_JSM_BANNER", () => $4a617be77ace987f$export$c39bf2cb4e8cc70c);
$parcel$export(module.exports, "DISABLE_JSM_PERMISSIONS", () => $4a617be77ace987f$export$4e373788dac39943);
$parcel$export(module.exports, "VIEW_DEFAULT_SPACE_PERMISSIONS", () => $4a617be77ace987f$export$f7308c84ae7be9c8);
$parcel$export(module.exports, "EDIT_DEFAULT_SPACE_PERMISSIONS", () => $4a617be77ace987f$export$85cd19170159a085);
$parcel$export(module.exports, "VIEW_ALL_SPACES_TAB", () => $4a617be77ace987f$export$3cfa8e4552e9e6ce);
$parcel$export(module.exports, "COMPANY_HOME_BUILDER_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$c9f8ebbba8f73eeb);
$parcel$export(module.exports, "COMPANY_HOME_BUILDER_EDIT_EXPERIENCE", () => $4a617be77ace987f$export$d4d3fc5b22a2a5d2);
$parcel$export(module.exports, "COMPANY_HOME_BUILDER_UPLOAD_EXPERIENCE", () => $4a617be77ace987f$export$cc438f9a49eb57aa);
$parcel$export(module.exports, "COMPANY_HUB_CREATION_EXPERIENCE", () => $4a617be77ace987f$export$90e15cc4582adffa);
$parcel$export(module.exports, "COMPANY_HUB_CHANGE_HUB_NAME_EXPERIENCE", () => $4a617be77ace987f$export$9458ecd4beb6dc6b);
$parcel$export(module.exports, "FRONT_COVER_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$7f2689ec25c432a4);
$parcel$export(module.exports, "FRONT_COVER_PUBLISH_EXPERIENCE", () => $4a617be77ace987f$export$eef6122c9774ba1c);
$parcel$export(module.exports, "COMPANY_HUB_UNPUBLISH_HUB_EXPERIENCE", () => $4a617be77ace987f$export$c8ff6311a26d2c8c);
$parcel$export(module.exports, "COMPANY_HUB_ANALYTICS_EXPERIENCE", () => $4a617be77ace987f$export$f5a5045f5872d850);
$parcel$export(module.exports, "COMPANY_HUB_ANALYTICS_BOX_ROW_EXPERIENCE", () => $4a617be77ace987f$export$2c2b8afe13693d2b);
$parcel$export(module.exports, "COMPANY_HUB_ANALYTICS_CHART_EXPERIENCE", () => $4a617be77ace987f$export$db8c2f7bf58fe015);
$parcel$export(module.exports, "COMPANY_HUB_ANALYTICS_TABLE_EXPERIENCE", () => $4a617be77ace987f$export$b0852f88603c392f);
$parcel$export(module.exports, "COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE", () => $4a617be77ace987f$export$c5e974e322d233b1);
$parcel$export(module.exports, "CARDS_IMAGE_UPLOAD_EXPERIENCE", () => $4a617be77ace987f$export$651b4e780cbf5647);
$parcel$export(module.exports, "ADMIN_TEAM_CALENDARS_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$3e70adb2ef2d5f7a);
$parcel$export(module.exports, "ADMIN_TEAM_CALENDARS_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$18051474a34eda87);
$parcel$export(module.exports, "ADMIN_GENERAL_CONFIGURATION_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$dc2f45d36e47ca3a);
$parcel$export(module.exports, "ADMIN_GENERAL_CONFIGURATION_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$b27bac0c0dea2a55);
$parcel$export(module.exports, "ADMIN_GENERAL_CONFIGURATION_UPDATE_FAVICON_UPLOAD_EXPERIENCE", () => $4a617be77ace987f$export$a3c4dc4a199ee1b8);
$parcel$export(module.exports, "NOTIFICATIONS_SITE_SETTINGS_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$d32cd699d9dbf985);
$parcel$export(module.exports, "NOTIFICATIONS_SITE_SETTINGS_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$6fd7ab2f1e137193);
$parcel$export(module.exports, "ADMIN_CONFIGURE_CODE_MACRO_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$7875e1f75aa15306);
$parcel$export(module.exports, "ADMIN_CONFIGURE_CODE_MACRO_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$164e825247db8d43);
$parcel$export(module.exports, "ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$c390f9e07c545581);
$parcel$export(module.exports, "ADMIN_DEFAULT_SPACE_LOGO_CONFIG_MEDIA_SERVICE_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$4090d6a71e5b3ead);
$parcel$export(module.exports, "ADMIN_DEFAULT_SPACE_LOGO_CONFIG_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$a1986920605a1163);
$parcel$export(module.exports, "ADMIN_HEADER_AND_FOOTER_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$313ad6157a5a0ea9);
$parcel$export(module.exports, "ADMIN_HEADER_AND_FOOTER_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$dd6c028654f91f02);
$parcel$export(module.exports, "SPACE_SETTINGS_ADMIN_PAGE_LAYOUT_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$bb009baa1a9cbcf0);
$parcel$export(module.exports, "SPACE_SETTINGS_ADMIN_PAGE_LAYOUT_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$6d0fbdff5b6fa174);
$parcel$export(module.exports, "ADMIN_SECURITY_CONFIGURATION_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$8abd8604ca7982c7);
$parcel$export(module.exports, "ADMIN_SECURITY_CONFIGURATION_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$21855cac8c6f3d91);
$parcel$export(module.exports, "ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$faa6a1cbc50fd4a5);
$parcel$export(module.exports, "ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_TEMPLATES_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$9cfd44509d36312b);
$parcel$export(module.exports, "ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_BLUEPRINTS_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$fb29220c46f6993);
$parcel$export(module.exports, "ADMIN_TEMPLATES_AND_BLUEPRINTS_SYSTEM_TEMPLATES_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$90402aae1ab35229);
$parcel$export(module.exports, "SPACE_SETTINGS_ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$8e008c4796774e26);
$parcel$export(module.exports, "ADMIN_IMPORT_SPACES_CONFIGURATION_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$bc61a3e94ba2560e);
$parcel$export(module.exports, "ADMIN_IMPORT_SPACES_IMPORT_EXPERIENCE", () => $4a617be77ace987f$export$936492407dd3e3ab);
$parcel$export(module.exports, "ADMIN_TRASHED_SPACES_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$99f32e90f59041e7);
$parcel$export(module.exports, "ADMIN_RESTORE_SPACE_EXPERIENCE", () => $4a617be77ace987f$export$1057adadb9206825);
$parcel$export(module.exports, "ADMIN_HARD_DELETE_SPACE_EXPERIENCE", () => $4a617be77ace987f$export$9f610d573468ea4);
$parcel$export(module.exports, "ADMIN_APPLICATION_NAVIGATOR_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$4447822883006e0);
$parcel$export(module.exports, "ADMIN_APPLICATION_NAVIGATOR_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$93194ca916026abe);
$parcel$export(module.exports, "ADMIN_APPLICATION_NAVIGATOR_ADD_EXPERIENCE", () => $4a617be77ace987f$export$c226034eea0cb4de);
$parcel$export(module.exports, "ADMIN_THEMES_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$22f1f1a21c7d0c50);
$parcel$export(module.exports, "ADMIN_THEMES_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$12093307e4f8fd56);
$parcel$export(module.exports, "SPACE_SETTINGS_ADMIN_THEMES_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$a48b049eb2fcbe71);
$parcel$export(module.exports, "SPACE_SETTINGS_ADMIN_THEMES_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$5b92dfbf1efa2144);
$parcel$export(module.exports, "ADMIN_JIRA_MACRO_REPAIR_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$565897f0a51f5efd);
$parcel$export(module.exports, "ADMIN_JIRA_MACRO_REPAIR_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$2292c61864873ec0);
$parcel$export(module.exports, "ADMIN_PDF_EXPORT_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$d8f5df97692e60be);
$parcel$export(module.exports, "ADMIN_PDF_EXPORT_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$e2eb28f9e03e0850);
$parcel$export(module.exports, "SPACE_SETTINGS_ADMIN_PDF_EXPORT_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$ab0128b7a160aaed);
$parcel$export(module.exports, "SPACE_SETTINGS_ADMIN_PDF_EXPORT_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$e65a54ac514355c1);
$parcel$export(module.exports, "SPACE_SETTINGS_EXPORT_SPACE_LOAD_PAGE_TREE", () => $4a617be77ace987f$export$fde5d45e43ea2ca4);
$parcel$export(module.exports, "SPACE_SETTINGS_EXPORT_COMPLETED_EXPORT_AND_DOWNLOAD", () => $4a617be77ace987f$export$b9b428ecdf423548);
$parcel$export(module.exports, "ADMIN_MACRO_USAGE_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$c08c7422d3e7a141);
$parcel$export(module.exports, "WATCH_DIALOG_WATCH_EXPERIENCE", () => $4a617be77ace987f$export$d6369a194e24ad7f);
$parcel$export(module.exports, "WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE", () => $4a617be77ace987f$export$8012a45d3107312e);
$parcel$export(module.exports, "MANAGE_WATCHERS_DIALOG_EXPERIENCE", () => $4a617be77ace987f$export$7ee8a55d7cbc7735);
$parcel$export(module.exports, "MANAGE_WATCHERS_DIALOG_UNFILTERED_EXPERIENCE", () => $4a617be77ace987f$export$84a690fd513af1de);
$parcel$export(module.exports, "SPACE_SETTINGS_ADMIN_LOOK_AND_FEEL_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$6d5416d96215c2a6);
$parcel$export(module.exports, "SPACE_PERMISSIONS_REPORT_EXPERIENCE", () => $4a617be77ace987f$export$ae036afd16ed2b49);
$parcel$export(module.exports, "CONVERT_PAGE_TO_FOLDER_EXPERIENCE", () => $4a617be77ace987f$export$2361c2310cf691ea);
$parcel$export(module.exports, "SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$e85b045b69985ed1);
$parcel$export(module.exports, "SHARE_AND_RESTRICT_DIALOG_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$4717394ee1c94acc);
$parcel$export(module.exports, "SHARE_AND_RESTRICT_DIALOG_SAVE_ACTION_EXPERIENCE", () => $4a617be77ace987f$export$15b0dc8b7eaf2460);
$parcel$export(module.exports, "SHARE_AND_RESTRICT_DIALOG_SHARE_ACTION_EXPERIENCE", () => $4a617be77ace987f$export$d7fbaabd51b7e8aa);
$parcel$export(module.exports, "RBAC_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$b3185617ebec44c9);
$parcel$export(module.exports, "RBAC_EDIT_EXPERIENCE", () => $4a617be77ace987f$export$2bf4fa4e191abad2);
$parcel$export(module.exports, "DEFAULT_RBAC_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$a2e8aa26b8f23b29);
$parcel$export(module.exports, "DEFAULT_RBAC_EDIT_EXPERIENCE", () => $4a617be77ace987f$export$f615f6649fe944d3);
$parcel$export(module.exports, "SITE_RBAC_VIEW_EXPERIENCE", () => $4a617be77ace987f$export$c355f58335217bcc);
$parcel$export(module.exports, "SITE_RBAC_EDIT_EXPERIENCE", () => $4a617be77ace987f$export$ea342babb9acb6bc);
$parcel$export(module.exports, "SPACE_DETAILS_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$f6c4ac51d51b4d11);
$parcel$export(module.exports, "SPACE_DETAILS_UPDATE_EXPERIENCE", () => $4a617be77ace987f$export$e6949233f3fd16fa);
$parcel$export(module.exports, "SPACE_DETAILS_SPACE_LABEL_SEARCH_EXPERIENCE", () => $4a617be77ace987f$export$ac4798c67f4aca63);
$parcel$export(module.exports, "OBJECT_HEADER_EXPERIENCE", () => $4a617be77ace987f$export$13c8bebb873a5fd2);
$parcel$export(module.exports, "SIDEBAR_DETAILS_PANEL_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$717078a23de7ce41);
$parcel$export(module.exports, "SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE", () => $4a617be77ace987f$export$8bb2fdea912e6360);
$parcel$export(module.exports, "IMPORT_CONTENT_EXPERIENCE", () => $4a617be77ace987f$export$1f5ef81ae9b1b308);
$parcel$export(module.exports, "IMPORT_MIRO_USERS", () => $4a617be77ace987f$export$8e0f9138cc943183);
$parcel$export(module.exports, "CONTENT_OVERFLOW_MENU", () => $4a617be77ace987f$export$bf23e3ec80d510d);
// Deep link visiting
const $4a617be77ace987f$export$61f782d99db03c49 = 'follow-deep-link';
const $4a617be77ace987f$export$ed2197e4948fef6c = 'view-macro-renderer';
const $4a617be77ace987f$export$136d4e1bb3adaa98 = 'view-macro-editor';
const $4a617be77ace987f$export$54747aca26cee3f8 = 'view-all-macro';
const $4a617be77ace987f$export$f8afba90a5a815ad = 'view-jira-macro';
const $4a617be77ace987f$export$87daa9a1b1dd910d = 'migrate-page';
const $4a617be77ace987f$export$6c0a7d453b9ba427 = 'migrate-page/publish';
const $4a617be77ace987f$export$b39a77dbc03575b1 = 'migrate-template';
const $4a617be77ace987f$export$f94e85276e6d639f = 'add-page-comment';
const $4a617be77ace987f$export$31bd7de6ca230764 = 'add-page-comment/load';
const $4a617be77ace987f$export$4cb6cf73aff93e7d = 'add-page-comment/publish';
const $4a617be77ace987f$export$2a99a63e28df64fd = 'edit-page-comment';
const $4a617be77ace987f$export$515913089a77cb7c = 'edit-page-comment/load';
const $4a617be77ace987f$export$c0906b23fa1e3b63 = 'edit-page-comment/publish';
const $4a617be77ace987f$export$e9a5501ca0d5d256 = 'reply-to-page-comment';
const $4a617be77ace987f$export$3fdffa656412b99a = 'reply-to-page-comment/load';
const $4a617be77ace987f$export$bfebfbab40727cd6 = 'reply-to-page-comment/publish';
const $4a617be77ace987f$export$91d50c2b267d0461 = 'delete-page-comment';
const $4a617be77ace987f$export$24ef8c79de5598b9 = 'resolve-page-comment';
const $4a617be77ace987f$export$6f58645a9a5f7936 = 'create-inline-comment';
const $4a617be77ace987f$export$8180a49fb6c681b1 = 'create-inline-comment/init';
const $4a617be77ace987f$export$ed5e210bce3a41a9 = 'create-inline-comment/draft-to-publish';
const $4a617be77ace987f$export$db23cb60632b0aa0 = 'create-inline-comment/attach-comment';
const $4a617be77ace987f$export$f8e0e16825f0d222 = 'select-inline-comment';
const $4a617be77ace987f$export$20e298cec054250a = 'select-inline-comment/select-annotation';
const $4a617be77ace987f$export$6a0f9ba61b7d60f5 = 'select-inline-comment/show-comment';
const $4a617be77ace987f$export$2003fd9c8f509d96 = 'add-inline-comment';
const $4a617be77ace987f$export$a69ecd33d83d56ce = 'add-inline-comment/load';
const $4a617be77ace987f$export$eb89dbd7422d8194 = 'add-inline-comment/publish';
const $4a617be77ace987f$export$29c433981d13c955 = 'edit-inline-comment';
const $4a617be77ace987f$export$a557d8a611f835b = 'edit-inline-comment/load';
const $4a617be77ace987f$export$e9dafdd46fb3d4ed = 'edit-inline-comment/publish';
const $4a617be77ace987f$export$20fbac00cba3c8a = 'view-inline-comment';
const $4a617be77ace987f$export$533f2a7cfe4f757e = 'view-inline-comment/toplevel';
const $4a617be77ace987f$export$fb1f28583d577755 = 'view-inline-comment/reply';
const $4a617be77ace987f$export$9d157677f817543f = 'reply-to-inline-comment';
const $4a617be77ace987f$export$b4f2ad99abb89883 = 'reply-to-inline-comment/load';
const $4a617be77ace987f$export$32059abd767a1104 = 'reply-to-inline-comment/publish';
const $4a617be77ace987f$export$bcfccb61f33e9641 = 'delete-inline-comment';
const $4a617be77ace987f$export$819fbef15068ac1d = 'resolve-inline-comment';
const $4a617be77ace987f$export$996a096215f40255 = 'unresolve-inline-comment';
const $4a617be77ace987f$export$c64ae72fd2ff5bed = 'resolved-inline-comments-dialog-sort';
const $4a617be77ace987f$export$a32711b0e13e94b7 = 'reattach-inline-comment';
const $4a617be77ace987f$export$d6f52083721d3342 = 'view-reactions';
const $4a617be77ace987f$export$e6f0efe9d461092e = 'view-reaction-user-list';
const $4a617be77ace987f$export$ba45b443cf775f1b = 'add-reaction';
const $4a617be77ace987f$export$63f7987e2f1f8f3 = 'delete-reaction';
const $4a617be77ace987f$export$aa1b3aa6132c5165 = 'add-quick-reaction';
const $4a617be77ace987f$export$7321222ee6dc4c8a = 'copy-space-permissions';
const $4a617be77ace987f$export$227ea80a7d6d8ef2 = 'create-page';
const $4a617be77ace987f$export$1773354263fb7a1f = 'create-page/load-dialog';
const $4a617be77ace987f$export$5f80ef7b2915bb38 = 'create-page/template-variable-input';
const $4a617be77ace987f$export$f27db95814bbdf0 = 'create-whiteboard';
const $4a617be77ace987f$export$13566a78bbba7568 = 'create-database';
const $4a617be77ace987f$export$c6222c9fbf47e43b = 'create-embed';
const $4a617be77ace987f$export$63a2c018dc189e0 = 'create-folder';
const $4a617be77ace987f$export$dd70d6707192298e = 'edit-page';
const $4a617be77ace987f$export$cd96dc6a09f60949 = 'edit-legacy-page';
const $4a617be77ace987f$export$b6f302e969b56ed5 = 'edit-page-embed';
const $4a617be77ace987f$export$cfe717283b384dee = 'edit-page/loader'; // loader to determine editor routing (next vs. classic)
const $4a617be77ace987f$export$54650b8dd9597591 = 'edit-page/load';
const $4a617be77ace987f$export$9cfef550e5af515d = 'edit-legacy-page/load';
const $4a617be77ace987f$export$4aed0cf42acf9c68 = 'edit-page/publish';
const $4a617be77ace987f$export$770ea955fed26e20 = 'edit-legacy-page/publish';
const $4a617be77ace987f$export$4abcdf78bb75330c = 'edit-page/publish-as-blog';
const $4a617be77ace987f$export$92edebd76eb1ad1 = 'edit-page/close';
const $4a617be77ace987f$export$1339ae8dc80b092c = 'edit-legacy-page/close';
const $4a617be77ace987f$export$42ce143b9452f768 = 'edit-page/revert-draft';
const $4a617be77ace987f$export$d3dcb341de2e384f = 'live-page';
const $4a617be77ace987f$export$f8e950d04ce466ff = 'live-page/edit';
const $4a617be77ace987f$export$3814d28dd3802a02 = 'live-page-session';
const $4a617be77ace987f$export$40fb2b7b657bf7d = 'live-page/publish';
const $4a617be77ace987f$export$9e0dcc9389703292 = 'create-and-edit-page';
const $4a617be77ace987f$export$b9892a850189b3e9 = 'template-edit-page';
const $4a617be77ace987f$export$3604f7decc6e0567 = 'template-edit-page/load';
const $4a617be77ace987f$export$1a3cf6b911b3771 = 'template-edit-page/close';
const $4a617be77ace987f$export$a7f90c693668eabe = 'template-edit-page/publish';
const $4a617be77ace987f$export$3c5dcebba4317c7e = 'template-edit-page/publish/template-body';
const $4a617be77ace987f$export$3a8f568ddb8f3189 = 'template-edit-page/publish/template-properties';
const $4a617be77ace987f$export$583391c24e8a1735 = 'in-editor-templates-load-panel';
const $4a617be77ace987f$export$6afe1d2e05c85172 = 'in-editor-templates-load-panel/template-list';
const $4a617be77ace987f$export$6085a8760b035f6 = 'in-editor-templates-load-panel/categories';
const $4a617be77ace987f$export$cbd9dfa0a050a0e0 = 'in-editor-templates-load-panel/space-selector';
const $4a617be77ace987f$export$8fcf8395eb106389 = 'in-editor-templates-update-content';
const $4a617be77ace987f$export$eac277758b783558 = 'in-editor-templates-update-content/refresh-editor';
const $4a617be77ace987f$export$d3b70eeb61a68ef1 = 'template-suggestions';
const $4a617be77ace987f$export$89e30156af35c723 = 'view-in-product-help';
const $4a617be77ace987f$export$1072a5750cf51c7e = 'search-in-product-help';
const $4a617be77ace987f$export$85f8b3853315a126 = 'search-in-product-help/load';
const $4a617be77ace987f$export$49e4c787a6cc62e = 'view-article-in-product-help';
const $4a617be77ace987f$export$3d1292b099f0e166 = 'view-article-in-product-help/load';
const $4a617be77ace987f$export$54615853abc6859 = 'template-gallery';
const $4a617be77ace987f$export$82c983e2a60f2e28 = 'template-gallery/space-selector';
const $4a617be77ace987f$export$61439b391c5a3aca = 'template-gallery/categories';
const $4a617be77ace987f$export$81cd8bf6923e1bf1 = 'template-gallery/cards';
const $4a617be77ace987f$export$b6af3a64b182b9d0 = 'template-gallery/template-detail';
const $4a617be77ace987f$export$588acf29fbd8637d = 'template-gallery/template-detail-update';
const $4a617be77ace987f$export$a1cf4f28febc3bee = 'template-gallery/template-detail/header';
const $4a617be77ace987f$export$b802716fd0c5b93f = 'template-preview';
const $4a617be77ace987f$export$e0195c05e32ed777 = 'refresh-editor-content';
const $4a617be77ace987f$export$9194ae178043ade6 = 'create-content-from-template';
const $4a617be77ace987f$export$1545639c80579c53 = 'blueprint-wizard-load-dialog';
const $4a617be77ace987f$export$fc0c176abc30d17b = 'connect-addon';
const $4a617be77ace987f$export$97b170c4be77228 = 'quick-reload';
const $4a617be77ace987f$export$9625ccab45afe35a = 'quick-reload-v3';
const $4a617be77ace987f$export$dbbd27df623b094f = 'restricted-page';
const $4a617be77ace987f$export$8f404e4bd2a13aa = 'restricted-space-for-guest';
const $4a617be77ace987f$export$727b779ceeca0a78 = 'restricted-space';
const $4a617be77ace987f$export$b9ee7465c962e842 = 'restrictions-dialog';
const $4a617be77ace987f$export$2e96e7e6b8da0317 = 'restrictions-dialog/load';
const $4a617be77ace987f$export$6b54d78a736a983b = 'restrictions-dialog/apply';
const $4a617be77ace987f$export$a66250c876dd8838 = 'publish-modal/load-restrictions';
const $4a617be77ace987f$export$e64caae0c75dd921 = 'impersonation-flag';
const $4a617be77ace987f$export$7ebe8ae2b3f231cb = 'inspect-permissions';
const $4a617be77ace987f$export$b659623b19114e87 = 'user-access';
const $4a617be77ace987f$export$9d715fddec195756 = 'upsell-edition';
const $4a617be77ace987f$export$a7ffbea51ff646ee = 'upsell-edition-upflow';
const $4a617be77ace987f$export$bd5028ea224c4de1 = 'archiving/archive-pages';
const $4a617be77ace987f$export$e63a17e805ed8387 = 'archiving/restore-pages';
const $4a617be77ace987f$export$d74c17e82f5dbc27 = 'archiving/view-space-archived-pages';
const $4a617be77ace987f$export$b7a40ae431fd676d = 'archiving/view-space-archived-pages/paginate';
const $4a617be77ace987f$export$b84de3b67d7aa4be = 'archiving/edit-notes-archive-pages';
const $4a617be77ace987f$export$9efd42121cbefbff = 'archiving/bulk-edit-notes-archive-pages';
const $4a617be77ace987f$export$c30b739e25dc756b = 'archiving/archived-page-banner';
const $4a617be77ace987f$export$fc9036c892e05ff9 = 'automation-discovery/add-label';
const $4a617be77ace987f$export$abe2705723fc11ac = 'automation-discovery/publish-meeting-notes';
const $4a617be77ace987f$export$90d9afd417e81733 = 'automation-discovery/archive-page';
const $4a617be77ace987f$export$bcf33c3d2ec343df = 'automation-discovery/hover-over-page-title';
const $4a617be77ace987f$export$8b43be9232ec143f = 'automation-discovery/jira-link';
const $4a617be77ace987f$export$adc097acaa5bd53a = 'automation-discovery/manual-trigger';
const $4a617be77ace987f$export$184da8822d56484c = 'automation-discovery/bulk-archive';
const $4a617be77ace987f$export$65a0bbd38d8f5b63 = 'automation-discovery/page-public-link';
const $4a617be77ace987f$export$c7dca20d997e95ed = 'automation-manual-triggers';
const $4a617be77ace987f$export$2504afae65d57ffb = 'automation-discovery/whiteboards';
const $4a617be77ace987f$export$cf23f74117283d17 = 'automation-discovery/bulk-change-page-owner';
const $4a617be77ace987f$export$78bf51c34f43d049 = 'automation-smart-button-run-rule';
const $4a617be77ace987f$export$d0afbe071e52a5cf = 'automation-smart-button-create-rule';
const $4a617be77ace987f$export$b30eb768fa4c3967 = 'automation-smart-button-edit-rule';
const $4a617be77ace987f$export$2cc8139334567c4f = 'automation-smart-button-preview-rule';
const $4a617be77ace987f$export$cab2a1e3c7ddbb06 = 'automation-side-nav-bar';
const $4a617be77ace987f$export$a03bf7627f412dc4 = 'automation-upsell';
const $4a617be77ace987f$export$a26e99521ea3a9f4 = 'delete-page';
const $4a617be77ace987f$export$57cc53c6e3b9be1b = 'bulk-delete-pages';
const $4a617be77ace987f$export$91d3a54b5d7e1b7f = 'bulk-change-owner';
const $4a617be77ace987f$export$ba8b23dd795f5f9e = 'bulk-change-status';
const $4a617be77ace987f$export$7bea875d555696ca = 'bulk-convert-page-to-live-doc';
const $4a617be77ace987f$export$a837ee39f68fa2dd = 'edit-sidebar';
const $4a617be77ace987f$export$e69ba0c4a7667861 = 'edit-sidebar/update';
const $4a617be77ace987f$export$c6fd99844ee488c5 = 'manage-pages';
const $4a617be77ace987f$export$8fc86f50c7402da0 = 'manage-pages/paginate';
const $4a617be77ace987f$export$d4b4a08489e4dfe2 = 'content-manager';
const $4a617be77ace987f$export$c03f98139dd9719e = 'move-page-dialog-load';
const $4a617be77ace987f$export$1167cf561a6df618 = 'move-published-page';
const $4a617be77ace987f$export$95c6dda6cbbf364 = 'move-blog';
const $4a617be77ace987f$export$fbbc408e16c59382 = 'not-found';
const $4a617be77ace987f$export$cf73dfff88c1f700 = 'view-content';
const $4a617be77ace987f$export$d4712ac27cc4e72f = 'view-page';
const $4a617be77ace987f$export$5e30e9d7ea54dcd2 = 'view-page-session';
const $4a617be77ace987f$export$2a57468d23984a9d = 'space-overview';
const $4a617be77ace987f$export$54504a2cc31519bf = 'breadcrumbs';
const $4a617be77ace987f$export$68af05e1cf40b8e6 = 'breadcrumbs/dropdown';
const $4a617be77ace987f$export$863ebd92a50403cf = 'view-page/title';
const $4a617be77ace987f$export$df0793573ff7d63c = 'view-page/reactions';
const $4a617be77ace987f$export$bdd2d0f331a38827 = 'view-page/labels';
const $4a617be77ace987f$export$49fde5724a27b431 = 'view-page/byline';
const $4a617be77ace987f$export$7a119c18309263c = 'view-page/byline/forge';
const $4a617be77ace987f$export$45c9f537ef090ccd = 'view-page/comments';
const $4a617be77ace987f$export$dc03e514628af5e9 = 'view-page/edit';
const $4a617be77ace987f$export$38478feb41239856 = 'view-page/content-tools';
const $4a617be77ace987f$export$ef641459105e6b1a = 'view-page/content-tools/forge';
const $4a617be77ace987f$export$255077470163d493 = 'view-page/context-menu';
const $4a617be77ace987f$export$43081e88ffac9568 = 'view-page/context-menu/forge';
const $4a617be77ace987f$export$14a39beec323232a = 'view-page/content-header'; // for old view page header
const $4a617be77ace987f$export$5870dabed6d7b7fc = 'view-page/favorite';
const $4a617be77ace987f$export$857306718a36d667 = 'view-page/share-button';
const $4a617be77ace987f$export$b7907767002e32d = 'view-page/restrictions-button';
const $4a617be77ace987f$export$aa15347df133b367 = 'view-page/comment-button';
const $4a617be77ace987f$export$18cb1bed3afb8173 = 'view-page/discover-inline-comments-feature';
const $4a617be77ace987f$export$b500820ed8b3aee5 = 'view-page/publish-as-blog';
const $4a617be77ace987f$export$a83700d85c7e0745 = 'whiteboard-page';
const $4a617be77ace987f$export$bdaf5db6d84a5581 = 'whiteboard-page/content';
const $4a617be77ace987f$export$4252e8d96c415d57 = 'whiteboard-version-history-side-panel';
const $4a617be77ace987f$export$b8cdecdc06b6252 = 'whiteboard-restore-version';
const $4a617be77ace987f$export$90f5a89f66458e77 = 'whiteboard-version-history-restore-modal';
const $4a617be77ace987f$export$f02aef641190ead6 = 'database-page';
const $4a617be77ace987f$export$7140ccdb0c7b2b37 = 'database-page/content';
const $4a617be77ace987f$export$857587c3b96ae00c = 'database-version-history-side-panel';
const $4a617be77ace987f$export$bdbfe4dafa70ffab = 'database-restore-version';
const $4a617be77ace987f$export$7cc7b880d5b3f324 = 'database-version-history-restore-modal';
const $4a617be77ace987f$export$ba3b240cb9a3ffd0 = 'database-load-historical-version';
const $4a617be77ace987f$export$c85a8dac7f241add = 'embed-page';
const $4a617be77ace987f$export$927658f514adba70 = 'embed-page/content';
const $4a617be77ace987f$export$c1092431c58e1571 = 'edit-embed';
const $4a617be77ace987f$export$3485e62ad9c27d0b = 'folder-page';
const $4a617be77ace987f$export$6237c6dbe5a63f05 = 'folder-page/content';
const $4a617be77ace987f$export$7fd0425089f6d999 = 'content-types-header';
const $4a617be77ace987f$export$47f14e5e827cfff3 = 'content-types-header/watch';
const $4a617be77ace987f$export$748b7f600814978a = 'content-creation-paywall';
const $4a617be77ace987f$export$5e1aeeb6f31be57a = 'record-loom-entry-point';
const $4a617be77ace987f$export$c427a8b1052a6522 = 'loom-page-header-content-insertion';
const $4a617be77ace987f$export$6ca90e5df7047c10 = 'loom-cross-sell';
const $4a617be77ace987f$export$96f8e8997d2c8722 = 'edit-page/labels';
const $4a617be77ace987f$export$e9e0897b7cf2ab3f = 'labels/add-label';
const $4a617be77ace987f$export$5a4fc6855f9c48e = 'labels/create-label';
const $4a617be77ace987f$export$3f19e9a9a0d72413 = 'labels/delete-label';
const $4a617be77ace987f$export$39d403abc2174e5e = 'labels/search-label';
const $4a617be77ace987f$export$4d573c9dfbc9337c = 'labels/recommended';
const $4a617be77ace987f$export$8af5d568de2d4e43 = 'template-edit-page/labels';
const $4a617be77ace987f$export$c5ef6dea1c804893 = 'template-edit-page/labels/add-label';
const $4a617be77ace987f$export$fa82b911a68fea4d = 'template-edit-page/labels/create-label';
const $4a617be77ace987f$export$20b2f79b83628af0 = 'template-edit-page/labels/delete-label';
const $4a617be77ace987f$export$479dc90f08ae49d = 'template-edit-page/labels/search-label';
const $4a617be77ace987f$export$d8e5793fc3893dd0 = 'header-items/group-load';
const $4a617be77ace987f$export$66f0a82e06e92ea = 'home';
const $4a617be77ace987f$export$8856e11bfa69959d = 'home/spaces';
const $4a617be77ace987f$export$8ef0e6a462dfc555 = 'home/recent-pages';
const $4a617be77ace987f$export$d931b261468db3be = 'home/right-panel';
const $4a617be77ace987f$export$cd6478684fc4b278 = 'home/right-panel/activity';
const $4a617be77ace987f$export$45cf379c9ef28a2d = 'home/right-panel/welcome-message';
const $4a617be77ace987f$export$ceb391a6374fc2 = 'home/right-panel/calendars';
const $4a617be77ace987f$export$799c1b543715aab4 = 'home/right-panel/apps';
const $4a617be77ace987f$export$519eb6f457873738 = 'home/right-panel/forge';
const $4a617be77ace987f$export$b57c8eba324f4ab1 = 'home/right-panel/recommendations';
const $4a617be77ace987f$export$cf6a4f3279a69e87 = 'confluence';
const $4a617be77ace987f$export$680e462c4f71cea1 = 'feed';
const $4a617be77ace987f$export$d660d67b42309542 = 'home/overview';
const $4a617be77ace987f$export$f987075f870b167d = 'home/overview/recent';
const $4a617be77ace987f$export$6c96437f170477a4 = 'home/overview/recent/paginate';
const $4a617be77ace987f$export$94f2ecf008a81b99 = 'home/recent';
const $4a617be77ace987f$export$45d7f7ed7a82bcd = 'home/starred';
const $4a617be77ace987f$export$ecf5fd41d4da9bf8 = 'home/watching';
const $4a617be77ace987f$export$9b242f2ddcd908fc = 'home/drafts';
const $4a617be77ace987f$export$5393f7f46c9e5055 = 'advanced-search';
const $4a617be77ace987f$export$91a00c702eb82c2c = 'advanced-search/space-filter';
const $4a617be77ace987f$export$3f0c1a8eb5419bb4 = 'advanced-search/contributor-filter';
const $4a617be77ace987f$export$bda2c35d9a84e22c = 'advanced-search/smart-contributor-filter';
const $4a617be77ace987f$export$ec545137ad6ac054 = 'quick-search/pre-query';
const $4a617be77ace987f$export$e64dfa2771353f5c = 'recent-dropdown/visited';
const $4a617be77ace987f$export$53f4f21972586e42 = 'recent-dropdown/created-by-me';
const $4a617be77ace987f$export$985013c384c228e1 = 'recent-dropdown/worked-on';
const $4a617be77ace987f$export$605220fac97de = 'recent-dropdown/drafts';
const $4a617be77ace987f$export$7c6d9e11a2120c1b = 'recent-dropdown/starred';
const $4a617be77ace987f$export$59a9c2c7ae337de7 = 'page-tree';
const $4a617be77ace987f$export$bbc326cd1f124322 = 'page-tree/dnd';
const $4a617be77ace987f$export$f9d04e98575a0216 = 'page-tree/quick-actions';
const $4a617be77ace987f$export$cd3eec90d152a8ea = 'page-tree/rename';
const $4a617be77ace987f$export$9d1f80f618a6627b = 'blog-tree';
const $4a617be77ace987f$export$899513ff8720fa55 = 'blog-tree/pagination';
const $4a617be77ace987f$export$d200becb25c80dc0 = 'activity/tailored';
const $4a617be77ace987f$export$8729a78bfed79808 = 'activity/create-space-button';
const $4a617be77ace987f$export$b0be9d71080b7c81 = 'activity/right-sidebar';
const $4a617be77ace987f$export$2783f61e72caafb5 = 'feed-migration/activity/popular';
const $4a617be77ace987f$export$fcff442a18d04a5d = 'feed-migration/activity/all-updates';
const $4a617be77ace987f$export$357a2b9b5fb0f4e4 = 'navigation/nav-2-admin-navigation/forge';
const $4a617be77ace987f$export$9b5915bb3a4fbcae = 'navigation/app-nav-global-navigation';
const $4a617be77ace987f$export$e3e183dd97af67fd = 'navigation/app-nav-container-navigation';
const $4a617be77ace987f$export$14b67f3e8f5e6f95 = 'navigation/app-nav-admin-navigation';
const $4a617be77ace987f$export$f089f204ab93864e = 'navigation/app-nav-spaces-dropdown';
const $4a617be77ace987f$export$5c3671291c82150b = 'navigation/app-nav-pages-dropdown';
const $4a617be77ace987f$export$63d03b6879925116 = 'navigation/app-nav-apps-dropdown';
const $4a617be77ace987f$export$fa160b39d3766fc0 = 'navigation/app-nav-notifications-dropdown';
const $4a617be77ace987f$export$986139018de1521a = 'navigation/app-nav-profile-dropdown';
const $4a617be77ace987f$export$6cebb7e0b005cd28 = 'space-directory';
const $4a617be77ace987f$export$aeda23f4b92ccc3b = 'space-directory/your-spaces';
const $4a617be77ace987f$export$4a890f75d0a61967 = 'space-directory/filter';
const $4a617be77ace987f$export$39e9ebfcfd8e8bad = 'space-directory/paginate';
const $4a617be77ace987f$export$de6098630f95035a = 'create-space/submit';
const $4a617be77ace987f$export$9b47bc79e174bc93 = 'create-space/validate';
const $4a617be77ace987f$export$1d45fd96fcd751f5 = 'onboarding/start';
const $4a617be77ace987f$export$c33c0eca528dad5c = 'onboarding/invite-users';
const $4a617be77ace987f$export$6d895b52727161d4 = 'onboarding/remove-invite-users';
const $4a617be77ace987f$export$be07109624e8a07e = 'onboarding/create-a-space';
const $4a617be77ace987f$export$d5e6e79f726e8007 = 'onboarding/choose-a-space';
const $4a617be77ace987f$export$87a646b39eb224a = 'onboarding/end';
const $4a617be77ace987f$export$a453322b492264d1 = 'onboarding/choose-a-space-card';
const $4a617be77ace987f$export$4ead33eb5b37dee5 = 'onboarding/follow-spaces';
const $4a617be77ace987f$export$a09834a747086083 = 'onboarding/shared-link-spotlight';
const $4a617be77ace987f$export$749c4d9c23381805 = 'onboarding/nudge';
const $4a617be77ace987f$export$1aaba3dd5fd71b43 = 'onboarding-account-setup-modal';
const $4a617be77ace987f$export$e974684738710b35 = 'onboarding-quickstart';
const $4a617be77ace987f$export$f782724a6a771d54 = 'onboarding-quickstart/invite-tour';
const $4a617be77ace987f$export$17ca485a01223d00 = 'onboarding-nth-user-quick-start/home-tour';
const $4a617be77ace987f$export$f29cf5607319432e = 'onboarding-nth-user-quick-start/space-tour';
const $4a617be77ace987f$export$7989a920a6248647 = 'onboarding-jsw-xflow/admin-switcher-tour';
const $4a617be77ace987f$export$55172161173a2d6e = 'onboarding-jsw-xflow/nth-switcher-tour';
const $4a617be77ace987f$export$aaf55a29d2f12a6e = 'onboarding-jsw-xflow/invite-teammate-task';
const $4a617be77ace987f$export$e40755126e0d0b54 = 'onboarding-editor/draft-banner';
const $4a617be77ace987f$export$32b7ff7de164c7ad = 'onboarding-editor/land-in-editor-banner';
const $4a617be77ace987f$export$b154482ef737e03a = 'onboarding-editor/quickstart-tutorial-task';
const $4a617be77ace987f$export$d04515c6314fec11 = 'onboarding-editor/publish-modal-prompt';
const $4a617be77ace987f$export$8425321c06a7c373 = 'onboarding-editor/publish-success-flag';
const $4a617be77ace987f$export$f3de65caafc09b21 = 'onboarding-editor/recent-draft-spotlight';
const $4a617be77ace987f$export$25e1b00b32cd992d = 'onboarding/query/labels';
const $4a617be77ace987f$export$8ef86f4d4da92fa5 = 'onboarding/grace-period-banner';
const $4a617be77ace987f$export$8125e64b190d01e2 = 'onboarding/storage-enforcement-banner';
const $4a617be77ace987f$export$343afc350dc963df = 'onboarding/storage-enforcement-banner/dismiss';
const $4a617be77ace987f$export$9491541521237449 = 'onboarding/storage-enforcement-flags';
const $4a617be77ace987f$export$616864953f0d339 = 'onboarding/storage-enforcement/block-create-modal';
const $4a617be77ace987f$export$61418bee30087820 = 'onboarding/home/templates-collection';
const $4a617be77ace987f$export$70cb2a8c47e6afd8 = 'onboarding/home/templates-collection/create-template';
const $4a617be77ace987f$export$e61bc67cff9e0f2 = 'onboarding/ibo/new-home/recent-page';
const $4a617be77ace987f$export$c1f744d5e0181dd = 'onboarding/ibo/new-home/spaces';
const $4a617be77ace987f$export$5ddea2545ba37329 = 'onboarding/ibo/new-home';
const $4a617be77ace987f$export$c03570fb82968b7e = 'onboarding/nth-user-setup-modal';
const $4a617be77ace987f$export$59679d849f29c62b = 'onboarding/onboarding-tracker';
const $4a617be77ace987f$export$7893ecd5dfd2c478 = 'onboarding/onboarding-tracker/organize-space/spotlight';
const $4a617be77ace987f$export$f63cf886d6298a0d = 'onboarding/onboarding-tracker/add-content/spotlight';
const $4a617be77ace987f$export$7b13a63caff7cb41 = 'onboarding/onboarding-tracker/invite-people/spotlight';
const $4a617be77ace987f$export$3971f3f0bdcc083 = 'onboarding/onboarding-surface-import/global-import/create-page';
const $4a617be77ace987f$export$7e62e90cd8969fd8 = 'onboarding/confluence-recap-modal';
const $4a617be77ace987f$export$5612c7c22aba3ae8 = 'onboarding/confluence-home-onboarding-takeover-v2';
const $4a617be77ace987f$export$3edd3fbbb3bde42a = 'onboarding/nth-user-confluence-home-onboarding-takeover';
const $4a617be77ace987f$export$e97003dd72490d60 = 'onboarding/confluence-home-onboarding-takeover-v2/home-nudge';
const $4a617be77ace987f$export$be5f66bc85ac48a2 = 'onboarding/confluence-personalized-templates-v2';
const $4a617be77ace987f$export$6778622238e08857 = 'onboarding/nth-user-content-type-spotlight';
const $4a617be77ace987f$export$241c40e7f0f7d7b2 = 'content-action-apps/forge';
const $4a617be77ace987f$export$404655cfa9ecfbc3 = 'byline-apps/forge';
const $4a617be77ace987f$export$224bdd20537c043c = 'context-menu-apps/forge';
const $4a617be77ace987f$export$fe9e3a7216162400 = 'settings-page-apps/forge';
const $4a617be77ace987f$export$16a139fd3cad706d = 'custom-content-apps/forge';
const $4a617be77ace987f$export$a333c0535291436a = 'space-page-apps/forge';
const $4a617be77ace987f$export$4e660f0eec1b7b63 = 'space-settings/integrations/forge';
const $4a617be77ace987f$export$42fe8757b12b9abb = 'space-settings-v2/integrations/forge';
const $4a617be77ace987f$export$e4e961f07f20b1e9 = 'space-settings-v2/landing-page';
const $4a617be77ace987f$export$30670c5b5576bc9d = 'global-page-apps/forge';
const $4a617be77ace987f$export$7fee035e8993093b = 'background-script-apps/forge';
const $4a617be77ace987f$export$d773e3323beb4d91 = 'site-permission/space-access';
const $4a617be77ace987f$export$1fdf87b44bf66203 = 'space-pages';
const $4a617be77ace987f$export$eab5c9963f80520c = 'space-pages/filter';
const $4a617be77ace987f$export$6af7d14b23c7ed20 = 'space-pages/paginate';
const $4a617be77ace987f$export$1ae7d5b32e27dd1b = 'space-views/initial';
const $4a617be77ace987f$export$92e7a42b4d134675 = 'space-views/change';
const $4a617be77ace987f$export$cd0c9383cd80d210 = 'space-views/paginate';
const $4a617be77ace987f$export$90dff6c3d9facebb = 'space-views/hover-page-card';
const $4a617be77ace987f$export$8a00f2824cff2c5e = 'site-permissions/space-access/remove';
const $4a617be77ace987f$export$30e6c2e5c854e3d7 = 'site-permissions/space-access/add';
const $4a617be77ace987f$export$b07723d1eb2313ad = 'site-permissions/space-access/guest/change';
const $4a617be77ace987f$export$94d2e4338cb54b2c = 'insights/page-byline';
const $4a617be77ace987f$export$27bffcf643f6c238 = 'insights/page-dialog';
const $4a617be77ace987f$export$460c09ff51f88f24 = 'insights/page-dialog-upsell';
const $4a617be77ace987f$export$371cd738ccd37b38 = 'insights/page-analytics';
const $4a617be77ace987f$export$3861bdd55a91a4a0 = 'insights/page-analytics/view-chart';
const $4a617be77ace987f$export$968182ed9835d21a = 'insights/page-analytics/total-views-card';
const $4a617be77ace987f$export$24ed3cf43f154734 = 'insights/page-analytics/unique-viewers-card';
const $4a617be77ace987f$export$a531b5e2ff0b9747 = 'insights/page-analytics/mentioned-users-card';
const $4a617be77ace987f$export$27ccd506e08e0e = 'insights/page-analytics/viewers-table';
const $4a617be77ace987f$export$ec84fc419c424bb5 = 'insights/page-analytics/mentioned-users-reminder';
const $4a617be77ace987f$export$8ddcb6f0d9ebf30e = 'insights/page-analytics/mentioned-users-table';
const $4a617be77ace987f$export$f8f3f70f34becef9 = 'insights/page-analytics/links-inbound-total-clicks-card';
const $4a617be77ace987f$export$3d388f0f7fc44c3f = 'insights/page-analytics/links-inbound-ctr-card';
const $4a617be77ace987f$export$310d1207c2b3ca7d = 'insights/page-analytics/links-inbound-table';
const $4a617be77ace987f$export$ab6abc47e6a1b436 = 'insights/page-analytics/links-outbound-total-clicks-card';
const $4a617be77ace987f$export$a1934b3cd762057c = 'insights/page-analytics/links-outbound-ctr-card';
const $4a617be77ace987f$export$11b4f841e984d2a8 = 'insights/page-analytics/links-outbound-table';
const $4a617be77ace987f$export$5478a6cbf2100291 = 'insights/space-analytics';
const $4a617be77ace987f$export$12f42654844570d0 = 'insights/space-analytics/overview-chart';
const $4a617be77ace987f$export$40a98279383e549e = 'insights/space-analytics/popular-content-card';
const $4a617be77ace987f$export$340eeaf9226a3e00 = 'insights/space-analytics/active-readers-card';
const $4a617be77ace987f$export$327f825878dc4802 = 'insights/space-analytics/active-contributors-card';
const $4a617be77ace987f$export$9595ac2edfb0edec = 'insights/space-analytics/content-activity-table';
const $4a617be77ace987f$export$bfbd1b5517d327f6 = 'insights/space-analytics/user-activity-table';
const $4a617be77ace987f$export$ae73006a481ab5bc = 'insights/space-analytics/async-export';
const $4a617be77ace987f$export$e27cd103e9670e33 = 'insights/space-analytics/permissions/load';
const $4a617be77ace987f$export$5a507008b468c991 = 'insights/space-analytics/permissions/update';
const $4a617be77ace987f$export$8ed4273d919d1070 = 'insights/site-analytics';
const $4a617be77ace987f$export$f2d660eb8a9ba56e = 'insights/site-analytics/overview-chart';
const $4a617be77ace987f$export$8e5ed6a75264c549 = 'insights/site-analytics/popular-spaces-card';
const $4a617be77ace987f$export$7cc392d1f03d59f9 = 'insights/site-analytics/active-readers-card';
const $4a617be77ace987f$export$e5b5e8161ac66e90 = 'insights/site-analytics/popular-searches-card';
const $4a617be77ace987f$export$221bc81bca00257 = 'insights/site-analytics/spaces-table';
const $4a617be77ace987f$export$31b3362136d95230 = 'insights/site-analytics/users-table';
const $4a617be77ace987f$export$86dcda8aa2b50b8a = 'insights/site-analytics/search-table';
const $4a617be77ace987f$export$91ffba1860245927 = 'insights/site-analytics/search-panel';
const $4a617be77ace987f$export$1b7a393d48199f1c = 'insights/site-analytics/search-panel/graph';
const $4a617be77ace987f$export$4020b74c723b4607 = 'insights/site-analytics/search-panel/content-list';
const $4a617be77ace987f$export$343c48c7798baab8 = 'insights/site-analytics/search-panel/spaces-list';
const $4a617be77ace987f$export$58ad08103bb62c4b = 'insights/site-analytics/permissions/load';
const $4a617be77ace987f$export$f73b370055c8cbef = 'insights/site-analytics/permissions/update';
const $4a617be77ace987f$export$5d12872cd9595692 = 'bulk-space-permissions';
const $4a617be77ace987f$export$ee395498ea9fc566 = 'global-perms';
const $4a617be77ace987f$export$bbc6348b8482e5b1 = 'expand-group';
const $4a617be77ace987f$export$f96f0a60f840676c = 'group-members-load-more';
const $4a617be77ace987f$export$7b06f43e66d37bd9 = 'view-space-guest-list';
const $4a617be77ace987f$export$b3639316349424 = 'team-calendar';
const $4a617be77ace987f$export$b731d5eab77f5ae2 = 'team-calendar-upsell';
const $4a617be77ace987f$export$6e2e950545a96fb5 = 'team-calendars/calendar/add';
const $4a617be77ace987f$export$e60dce5b561d6551 = 'team-calendars/calendar/add-existing';
const $4a617be77ace987f$export$25067b28cdd34cc6 = 'team-calendars/calendar/delete';
const $4a617be77ace987f$export$19d86a52695ae312 = 'team-calendars/calendar/remove';
const $4a617be77ace987f$export$120ce8feec0488aa = 'team-calendars/calendar/subscribe';
const $4a617be77ace987f$export$dc96bc0456e09d60 = 'team-calendars/calendar/update';
const $4a617be77ace987f$export$d23cc4800e46d1e6 = 'team-calendars/calendar/import';
const $4a617be77ace987f$export$13b2254026213b46 = 'team-calendars/event-type/add';
const $4a617be77ace987f$export$c348a46d97587ee4 = 'team-calendars/event-type/delete';
const $4a617be77ace987f$export$bfd3172de881908e = 'team-calendars/event-type/update';
const $4a617be77ace987f$export$e1a32de918001908 = 'team-calendars/event/add';
const $4a617be77ace987f$export$36abe825d06f7b68 = 'team-calendars/event/jira-calendar';
const $4a617be77ace987f$export$1be22ae521e809a9 = 'team-calendars/event/update';
const $4a617be77ace987f$export$eb40d48a494923c8 = 'team-calendars/event/delete';
const $4a617be77ace987f$export$66104f246f979de9 = 'team-calendars/restrictions/update';
const $4a617be77ace987f$export$a245b5e8e50aca4e = 'edit-space-logo/restore';
const $4a617be77ace987f$export$38c64d0e786460e8 = 'edit-space-logo/save';
const $4a617be77ace987f$export$53b6eab7c794efdf = 'edit-space-logo/details-load';
const $4a617be77ace987f$export$d4e50447c54e832a = 'cover-picture/unsplash-upload';
const $4a617be77ace987f$export$3b296e5e8d4fbd72 = 'cover-picture/media-upload';
const $4a617be77ace987f$export$75c73b1e1363abb2 = 'cover-picture/remove';
const $4a617be77ace987f$export$56b59e3252d65c77 = 'view-app-suggestions';
const $4a617be77ace987f$export$61ad3866e7413864 = 'conditional_publish_dialog';
const $4a617be77ace987f$export$5685c80727d12c34 = 'extension_point_byline';
const $4a617be77ace987f$export$4b9cf95d297cf82f = 'extension_point_space_buttons';
const $4a617be77ace987f$export$811ef7c3a5f94996 = 'extension_point_home_footer';
const $4a617be77ace987f$export$dfab08323861cbc1 = 'extension_point_home_header';
const $4a617be77ace987f$export$aa9a33eaf0b3cefa = 'extension_point_editor_savebar';
const $4a617be77ace987f$export$4933a09c775176cb = 'extension_point_page_metadata_banner';
const $4a617be77ace987f$export$645909341bfebc9b = 'extension_point_page_banner';
const $4a617be77ace987f$export$facf18b53398c3d7 = 'extension_point_space_settings_tabs';
const $4a617be77ace987f$export$23be08d2ca73ecf = 'core-invites';
const $4a617be77ace987f$export$b1dd9d960d4ea959 = 'custom-content-page-all';
const $4a617be77ace987f$export$38660dec2eb2a695 = 'custom-content-space-list-view';
const $4a617be77ace987f$export$7b1fe4d076a9542a = 'custom-content-page-list-view';
const $4a617be77ace987f$export$ad06e79f63068f5e = 'custom-content-view';
const $4a617be77ace987f$export$eef674482902ef6d = 'connections-panel-view';
const $4a617be77ace987f$export$c5bcbbcb1df627e5 = 'end-of-page-recommendations';
const $4a617be77ace987f$export$3b683344868f9f0a = 'notify-on-first-view';
const $4a617be77ace987f$export$4fdd9934209dba0e = 'presenter-mode/view';
const $4a617be77ace987f$export$40638d9b45e8ceca = 'presenter-mode/full-screen-api';
const $4a617be77ace987f$export$b1f7a84b45eb9afb = 'view-public-link-site-settings';
const $4a617be77ace987f$export$8294c237289049c4 = 'view-public-link-spaces-table';
const $4a617be77ace987f$export$ec6e09c5fd9fa221 = 'view-public-links-page-table';
const $4a617be77ace987f$export$5cc7e9470bfae723 = 'public-links-spaces-table-action';
const $4a617be77ace987f$export$c102a9d514fc95ac = 'public-link-site-toggle-change';
const $4a617be77ace987f$export$ff2fb656c8231637 = 'view-public-links-space-settings';
const $4a617be77ace987f$export$ba803d464f49a265 = 'public-links-space-toggle-change';
const $4a617be77ace987f$export$d95bcf023bd8993 = 'view-public-links-default-space-settings';
const $4a617be77ace987f$export$7362876707c57af9 = 'public-links-default-space-toggle-change';
const $4a617be77ace987f$export$c7ff49e7eaa45ff1 = 'view-public-link-shared-page';
const $4a617be77ace987f$export$24cbec84f278c600 = 'public-link-rendered';
const $4a617be77ace987f$export$5b89a66b04cea206 = 'public-link-toggle-change';
const $4a617be77ace987f$export$44b7602dc9689e08 = 'public-link-disable-from-restrictions';
const $4a617be77ace987f$export$eed7907041fecd69 = 'public-link-page-table-action';
const $4a617be77ace987f$export$49a01ffc1a18656b = 'external-share';
const $4a617be77ace987f$export$e25df1f458506fcd = 'copy-content-link';
const $4a617be77ace987f$export$7c34e8285a2b9238 = 'content-history';
const $4a617be77ace987f$export$b9b41dfe39f06772 = 'view-tasks';
const $4a617be77ace987f$export$6be3453279e7dd85 = 'set-task-complete';
const $4a617be77ace987f$export$80a3b142ba868b57 = 'change-page-owner';
const $4a617be77ace987f$export$19875313f499fad9 = 'content-ownership/dialog';
const $4a617be77ace987f$export$e94c6163c32592ce = 'admin-announcement-banner';
const $4a617be77ace987f$export$7653dfd9fd5557b = 'admin-announcement-banner-dismissed';
const $4a617be77ace987f$export$394294e59b36efb9 = 'admin-announcement-banner-settings';
const $4a617be77ace987f$export$8f017785cc4bb995 = 'admin-announcement-banner-publish';
const $4a617be77ace987f$export$a4d890726485d79a = 'admin-announcement-banner-turn-off';
const $4a617be77ace987f$export$47d510c88b13ea8d = 'admin-announcement-banner-table';
const $4a617be77ace987f$export$548adb1a2fe6e6b1 = 'space-manager';
const $4a617be77ace987f$export$35f739fc0b127205 = 'space-manager-quick-action-item';
const $4a617be77ace987f$export$2decaadcf840e6b3 = 'company-hub-general-settings';
const $4a617be77ace987f$export$23b4a008c670d304 = 'company-hub-general-settings-your-hub';
const $4a617be77ace987f$export$c6198e9d6ab9e417 = 'company-hub-general-settings-your-hub-actions';
const $4a617be77ace987f$export$e1b506612f6e9657 = 'company-hub-general-settings-recent-activity';
const $4a617be77ace987f$export$dfdc3f1142f40689 = 'company-hub-general-settings-hub-views';
const $4a617be77ace987f$export$e9845af7b7fd8501 = 'company-hub-general-settings-most-clicks';
const $4a617be77ace987f$export$237a7d3a8e219dbb = 'admin-center';
const $4a617be77ace987f$export$b7b3a9d4d05ffd12 = 'admin-center-confluence-admins';
const $4a617be77ace987f$export$367f60a3ad6918c1 = 'admin-center-search-count';
const $4a617be77ace987f$export$9a8113803e6447cf = 'admin-center-search-ctr';
const $4a617be77ace987f$export$8f37d7eb1e6f681d = 'admin-center-top-searches';
const $4a617be77ace987f$export$2ad5d40786f81da0 = 'admin-center-top-unsuccessful-searches';
const $4a617be77ace987f$export$e68566fb281dbb33 = 'admin-center-external-access';
const $4a617be77ace987f$export$a7f1ee469fd8596c = 'admin-center-beta-features';
const $4a617be77ace987f$export$8a3b06f53918d80e = 'admin-center-total-spaces';
const $4a617be77ace987f$export$d4f2672a4a997be2 = 'admin-center-total-content';
const $4a617be77ace987f$export$61440d1f5d765856 = 'admin-center-grouped-summary-section';
const $4a617be77ace987f$export$a122d82c3b13ba99 = 'admin-center-inactive-pages';
const $4a617be77ace987f$export$bf035e1987052c42 = 'admin-center-top-inactive-pages';
const $4a617be77ace987f$export$1613edca53571ea3 = 'admin-center-deactivated-owner-pages';
const $4a617be77ace987f$export$4ba2b40dc30760f9 = 'admin-center-top-deactivated-owner-pages';
const $4a617be77ace987f$export$5d6b6234c4e9f70d = 'admin-center-content-created';
const $4a617be77ace987f$export$39552d32ae5efc36 = 'admin-center-content-updated';
const $4a617be77ace987f$export$a4934c826482e207 = 'admin-center-content-views';
const $4a617be77ace987f$export$4c0549ea0cf0f43d = 'admin-center-top-content-views';
const $4a617be77ace987f$export$6b8c8a94a6fb0b10 = 'admin-center-grouped-summary-section-v2-update';
const $4a617be77ace987f$export$a4855248cbcdc638 = 'admin-center-grouped-summary-section-v2';
const $4a617be77ace987f$export$f1c6b44ad858e24f = 'admin-center-search-count-summary';
const $4a617be77ace987f$export$aaba8c517b5b0014 = 'admin-center-search-ctr-summary';
const $4a617be77ace987f$export$3463471aa64d2a20 = 'admin-center-total-spaces-summary';
const $4a617be77ace987f$export$aed49d47c6d277d2 = 'admin-center-total-content-summary';
const $4a617be77ace987f$export$c89944dc251c7694 = 'admin-center-inactive-pages-num-summary';
const $4a617be77ace987f$export$45d06e7b1bc06ed4 = 'admin-center-inactive-pages-percent-summary';
const $4a617be77ace987f$export$50744fb70a2982a2 = 'admin-center-deactivated-owner-pages-num-summary';
const $4a617be77ace987f$export$35f523c785c60e15 = 'admin-center-deactivated-owner-pages-percent-summary';
const $4a617be77ace987f$export$d4f40a3c80d7fa00 = 'admin-center-content-created-summary';
const $4a617be77ace987f$export$3e98f2df16d1f652 = 'admin-center-content-updated-summary';
const $4a617be77ace987f$export$512d403dd28c8f13 = 'admin-center-content-views-summary';
const $4a617be77ace987f$export$b5db801ede6fe9e5 = 'admin-center-public-link-views-summary';
const $4a617be77ace987f$export$2df6bcfd56d7c9e8 = 'admin-center-public-links-summary';
const $4a617be77ace987f$export$cc151de96adac045 = 'admin-center-premium-trial-insights';
const $4a617be77ace987f$export$6c98543cf0a07a9f = 'admin-center-suggestions';
const $4a617be77ace987f$export$9f5be3c30e870f46 = 'admin-center-suggestions-unassigned-guest';
const $4a617be77ace987f$export$56c7132579558fc8 = 'admin-center-suggestions-inactive-pages';
const $4a617be77ace987f$export$4bc17e6067981b1f = 'admin-center-suggestions-deactivated-owner-pages';
const $4a617be77ace987f$export$2f62829f51afa45a = 'admin-center-suggestions-space-manager';
const $4a617be77ace987f$export$19020e617b152304 = 'admin-center-suggestions-user-access';
const $4a617be77ace987f$export$12a435102ccb624a = 'admin-center-suggestions-quick-action-item';
const $4a617be77ace987f$export$dec2cee4628ab9c4 = 'admin-center-suggestions-metric-cta';
const $4a617be77ace987f$export$88a8c07833ef47b1 = 'space-admin-center';
const $4a617be77ace987f$export$fb0bb005ed2de56c = 'space-admin-center-grouped-summary-section';
const $4a617be77ace987f$export$73c5a862f5073e46 = 'space-admin-center-external-access';
const $4a617be77ace987f$export$4d72041a86e9e003 = 'space-admin-center-space-admins';
const $4a617be77ace987f$export$724928cbf61f8819 = 'space-admin-center-content-views';
const $4a617be77ace987f$export$eee5f90734589227 = 'space-admin-center-top-content-views';
const $4a617be77ace987f$export$a5e95165e3a702d1 = 'space-admin-center-content-created';
const $4a617be77ace987f$export$32dde1d12c499528 = 'space-admin-center-content-updated';
const $4a617be77ace987f$export$147226654b32f956 = 'space-admin-center-total-content';
const $4a617be77ace987f$export$648d00fafa66ae14 = 'space-admin-center-inactive-pages';
const $4a617be77ace987f$export$a3fdce9bb003f0b8 = 'space-admin-center-top-inactive-pages';
const $4a617be77ace987f$export$71daddda71b57298 = 'space-admin-center-deactivated-owner-pages';
const $4a617be77ace987f$export$62d9e5dacf2e073d = 'space-admin-center-top-deactivated-owner-pages';
const $4a617be77ace987f$export$8c3b600f7a5dce0f = 'dwell-time/start';
const $4a617be77ace987f$export$17c6a28e6e0e88af = 'trial-components/action-menu-view';
const $4a617be77ace987f$export$b0fe8424f6f27f51 = 'trial-components/lozenge-view';
const $4a617be77ace987f$export$40c0cee2cad141c5 = 'trial-components/flag-view';
const $4a617be77ace987f$export$d6bad6d87d8c028f = 'trial-components/premium-insights-action-menu-item-view';
const $4a617be77ace987f$export$d0e7688ec900110c = 'team-presence/avatar-group-view';
const $4a617be77ace987f$export$a3748c7e642ec857 = 'flywheel-feature-discovery';
const $4a617be77ace987f$export$f8372d329c2aeea0 = 'quick-summary';
const $4a617be77ace987f$export$31e4e6e2658a6cae = 'quick-summary-whiteboards';
const $4a617be77ace987f$export$4a493e4dc06e57e7 = 'quick-summary-to-page';
const $4a617be77ace987f$export$5565b0bba4d72eee = 'comments-summary';
const $4a617be77ace987f$export$8d9dfd2f17501337 = 'ai-content-catchup';
const $4a617be77ace987f$export$eb38477d5de37f36 = 'ai-presentation-generation-view';
const $4a617be77ace987f$export$ed3e815374d54f04 = 'ai-presentation-generation-create';
const $4a617be77ace987f$export$bb8fdee2f545676e = 'ai-snippet';
const $4a617be77ace987f$export$c114a6d7848b93cb = 'ai-bulk-issue-create';
const $4a617be77ace987f$export$a48ee5f2c131dea3 = 'ai-audio';
const $4a617be77ace987f$export$daafa0ab79e187e5 = 'ai-title-generation';
const $4a617be77ace987f$export$530e334566c01c65 = 'plan-comparison-modal';
const $4a617be77ace987f$export$af3f8586c2e30e0 = 'pendo-installation';
const $4a617be77ace987f$export$7f32d11b06ee25ff = 'reading-aids';
const $4a617be77ace987f$export$38e6a52d8f0a641f = 'ai-definitions-autohighlight';
const $4a617be77ace987f$export$9bd965a890617f5b = 'view-guest-request-to-upgrade';
const $4a617be77ace987f$export$85b1366ed05e7209 = 'submit-guest-request-to-upgrade';
const $4a617be77ace987f$export$7ca653e6d1fa2509 = 'view-guest-request-to-upgrade-side-nav';
const $4a617be77ace987f$export$30addda68c1793d0 = 'submit-guest-request-to-upgrade-side-nav';
const $4a617be77ace987f$export$aace851408b6de3e = 'submit-guest-mentions-upgrade-flow';
const $4a617be77ace987f$export$611140537004e76c = 'view-guest-spaces-menu-request-to-upgrade';
const $4a617be77ace987f$export$e73147035caab2f2 = 'submit-guest-spaces-menu-request-to-upgrade';
const $4a617be77ace987f$export$11311af26ac8cb8b = 'restore-space';
const $4a617be77ace987f$export$dec29f1de3a4a5ce = 'hard-delete-space';
const $4a617be77ace987f$export$e69556d68987dda1 = 'view-space-permissions';
const $4a617be77ace987f$export$a5bcda9ae1f6839a = 'edit-space-permissions';
const $4a617be77ace987f$export$c39bf2cb4e8cc70c = 'view-jsm-banner';
const $4a617be77ace987f$export$4e373788dac39943 = 'disable-jsm-permissions';
const $4a617be77ace987f$export$f7308c84ae7be9c8 = 'view-default-space-permissions';
const $4a617be77ace987f$export$85cd19170159a085 = 'edit-default-space-permissions';
const $4a617be77ace987f$export$3cfa8e4552e9e6ce = 'view-all-spaces-tab';
const $4a617be77ace987f$export$c9f8ebbba8f73eeb = 'company-home-builder-load';
const $4a617be77ace987f$export$d4d3fc5b22a2a5d2 = 'company-home-builder-edit';
const $4a617be77ace987f$export$cc438f9a49eb57aa = 'company-home-builder-edit/upload';
const $4a617be77ace987f$export$90e15cc4582adffa = 'company-hub-creation';
const $4a617be77ace987f$export$9458ecd4beb6dc6b = 'company-hub-change-hub-name';
const $4a617be77ace987f$export$7f2689ec25c432a4 = 'front-cover-load';
const $4a617be77ace987f$export$eef6122c9774ba1c = 'front-cover-publish';
const $4a617be77ace987f$export$c8ff6311a26d2c8c = 'company-hub-unpublish-hub';
const $4a617be77ace987f$export$f5a5045f5872d850 = 'company-hub-analytics';
const $4a617be77ace987f$export$2c2b8afe13693d2b = 'company-hub-analytics-box-row';
const $4a617be77ace987f$export$db8c2f7bf58fe015 = 'company-hub-analytics-chart';
const $4a617be77ace987f$export$b0852f88603c392f = 'company-hub-analytics-table';
const $4a617be77ace987f$export$c5e974e322d233b1 = 'company-hub-card-ai-description';
const $4a617be77ace987f$export$b414a79d615eda80 = 'end-of-trial-modal';
const $4a617be77ace987f$export$393f60effc43223a = 'end-of-trial-modal/number-of-users';
const $4a617be77ace987f$export$85f2b0ac7d403e39 = 'end-of-trial-modal/guest-access';
const $4a617be77ace987f$export$d28aabd131a0c82d = 'end-of-trial-modal/page-insights';
const $4a617be77ace987f$export$a3809cd1b0c7c1f9 = 'end-of-trial-modal/page-restrictions';
const $4a617be77ace987f$export$82fbc9c9caa0525b = 'end-of-trial-modal/osb-link';
const $4a617be77ace987f$export$651b4e780cbf5647 = 'cards-image-upload';
const $4a617be77ace987f$export$3e70adb2ef2d5f7a = 'admin-team-calendars-load';
const $4a617be77ace987f$export$18051474a34eda87 = 'admin-team-calendars-update';
const $4a617be77ace987f$export$7e4c7c98306e835d = 'standard-differentiators-onboarding';
const $4a617be77ace987f$export$1230cc550a8fe90f = 'standard-differentiators-help';
const $4a617be77ace987f$export$dc2f45d36e47ca3a = 'admin-general-configuration-load';
const $4a617be77ace987f$export$b27bac0c0dea2a55 = 'admin-general-configuration-update';
const $4a617be77ace987f$export$a3c4dc4a199ee1b8 = 'admin-general-configuration-update/favicon-upload';
const $4a617be77ace987f$export$d32cd699d9dbf985 = 'notifications-site-settings-load';
const $4a617be77ace987f$export$6fd7ab2f1e137193 = 'notifications-site-settings-update';
const $4a617be77ace987f$export$7875e1f75aa15306 = 'admin-configure-code-macro-load';
const $4a617be77ace987f$export$164e825247db8d43 = 'admin-configure-code-macro-update';
const $4a617be77ace987f$export$c390f9e07c545581 = 'admin-default-space-logo-config-load';
const $4a617be77ace987f$export$4090d6a71e5b3ead = 'admin-default-space-logo-config-media-service-load';
const $4a617be77ace987f$export$a1986920605a1163 = 'admin-default-space-logo-config-update';
const $4a617be77ace987f$export$313ad6157a5a0ea9 = 'admin-header-and-footer-load';
const $4a617be77ace987f$export$dd6c028654f91f02 = 'admin-header-and-footer-update';
const $4a617be77ace987f$export$bb009baa1a9cbcf0 = 'space-settings-admin-page-layout-load';
const $4a617be77ace987f$export$6d0fbdff5b6fa174 = 'space-settings-admin-page-layout-update';
const $4a617be77ace987f$export$8abd8604ca7982c7 = 'admin-security-configuration-load';
const $4a617be77ace987f$export$21855cac8c6f3d91 = 'admin-security-configuration-update';
const $4a617be77ace987f$export$faa6a1cbc50fd4a5 = 'admin-templates-and-blueprints-load';
const $4a617be77ace987f$export$9cfd44509d36312b = 'admin-templates-and-blueprints-load/page-templates';
const $4a617be77ace987f$export$fb29220c46f6993 = 'admin-templates-and-blueprints-load/page-blueprints';
const $4a617be77ace987f$export$90402aae1ab35229 = 'admin-templates-and-blueprints-load/system-templates';
const $4a617be77ace987f$export$8e008c4796774e26 = 'space-settings-admin-templates-and-blueprints-load';
const $4a617be77ace987f$export$bc61a3e94ba2560e = 'admin-import-spaces-configuration-load';
const $4a617be77ace987f$export$936492407dd3e3ab = 'admin-import-spaces-import';
const $4a617be77ace987f$export$99f32e90f59041e7 = 'admin-trashed-spaces-load';
const $4a617be77ace987f$export$1057adadb9206825 = 'admin-trashed-spaces-restore';
const $4a617be77ace987f$export$9f610d573468ea4 = 'admin-trashed-spaces-hard-delete';
const $4a617be77ace987f$export$86fdc512ee3200db = 'admin-color-scheme-load';
const $4a617be77ace987f$export$db764d23341437ca = 'admin-color-scheme-update';
const $4a617be77ace987f$export$4447822883006e0 = 'admin-application-navigator-load';
const $4a617be77ace987f$export$93194ca916026abe = 'admin-application-navigator-update';
const $4a617be77ace987f$export$c226034eea0cb4de = 'admin-application-navigator-add';
const $4a617be77ace987f$export$22f1f1a21c7d0c50 = 'admin-themes-load';
const $4a617be77ace987f$export$12093307e4f8fd56 = 'admin-themes-update';
const $4a617be77ace987f$export$a48b049eb2fcbe71 = 'space-settings-admin-themes-load';
const $4a617be77ace987f$export$5b92dfbf1efa2144 = 'space-settings-admin-themes-update';
const $4a617be77ace987f$export$565897f0a51f5efd = 'admin-jira-macro-repair-load';
const $4a617be77ace987f$export$2292c61864873ec0 = 'admin-jira-macro-repair-update';
const $4a617be77ace987f$export$d8f5df97692e60be = 'admin-pdf-export-load-experience';
const $4a617be77ace987f$export$e2eb28f9e03e0850 = 'admin-pdf-export-update-experience';
const $4a617be77ace987f$export$ab0128b7a160aaed = 'space-settings-admin-pdf-export-load-experience';
const $4a617be77ace987f$export$e65a54ac514355c1 = 'space-settings-admin-pdf-export-update-experience';
const $4a617be77ace987f$export$fde5d45e43ea2ca4 = 'export-page-tree-load';
const $4a617be77ace987f$export$b9b428ecdf423548 = 'export-page-export-completed-export-and-download';
const $4a617be77ace987f$export$c08c7422d3e7a141 = 'admin-macro-usage-load';
const $4a617be77ace987f$export$d6369a194e24ad7f = 'watch-dialog-watch';
const $4a617be77ace987f$export$8012a45d3107312e = 'watch-dialog-watch-children';
const $4a617be77ace987f$export$7ee8a55d7cbc7735 = 'manage-watchers-dialog';
const $4a617be77ace987f$export$84a690fd513af1de = 'manage-watchers-dialog-unfiltered';
const $4a617be77ace987f$export$7c7b27adbfa0b2a1 = 'auto-upgrade-awareness-modal';
const $4a617be77ace987f$export$6d5416d96215c2a6 = 'space-settings-admin-look-and-feel-experience';
const $4a617be77ace987f$export$ce75b3763db649b5 = 'user-access-update';
const $4a617be77ace987f$export$ae036afd16ed2b49 = 'user-access-space-permissions-report';
const $4a617be77ace987f$export$2361c2310cf691ea = 'convert-page-to-folder';
const $4a617be77ace987f$export$e85b045b69985ed1 = 'share-and-restrict-button-load';
const $4a617be77ace987f$export$4717394ee1c94acc = 'share-and-restrict-dialog-load';
const $4a617be77ace987f$export$3d9f84a4f00f6434 = 'share-and-restrict-dialog-apply-action';
const $4a617be77ace987f$export$15b0dc8b7eaf2460 = 'share-and-restrict-dialog-save-action';
const $4a617be77ace987f$export$d7fbaabd51b7e8aa = 'share-and-restrict-dialog-share-action';
const $4a617be77ace987f$export$62f393504fed6ed = 'flyout-messaging';
const $4a617be77ace987f$export$5409fe2736a41b4e = 'confluence-eot-premium-recommend-standard-buy';
const $4a617be77ace987f$export$b3185617ebec44c9 = 'view-space-role-assignments';
const $4a617be77ace987f$export$2bf4fa4e191abad2 = 'edit-space-role-assignments';
const $4a617be77ace987f$export$a2e8aa26b8f23b29 = 'view-default-space-role-assignments';
const $4a617be77ace987f$export$f615f6649fe944d3 = 'edit-default-space-role-assignments';
const $4a617be77ace987f$export$c355f58335217bcc = 'view-site-roles';
const $4a617be77ace987f$export$ea342babb9acb6bc = 'edit-site-roles';
const $4a617be77ace987f$export$f6c4ac51d51b4d11 = 'space-details-load';
const $4a617be77ace987f$export$e6949233f3fd16fa = 'space-details-update';
const $4a617be77ace987f$export$ac4798c67f4aca63 = 'space-details-space-label-search';
const $4a617be77ace987f$export$13c8bebb873a5fd2 = 'object-header';
const $4a617be77ace987f$export$717078a23de7ce41 = 'sidebar-details-panel-load';
const $4a617be77ace987f$export$8bb2fdea912e6360 = 'sidebar-comments-panel-load';
const $4a617be77ace987f$export$1f5ef81ae9b1b308 = 'import-content';
const $4a617be77ace987f$export$8e0f9138cc943183 = 'import-miro-users';
const $4a617be77ace987f$export$c81d8b61dfed18d = 'mpucup-free-to-standard-fg-modal';
const $4a617be77ace987f$export$bf23e3ec80d510d = 'content-overflow-menu';

});

parcelRegister("glCMv", function(module, exports) {

$parcel$export(module.exports, "ExperienceTimeoutError", () => $fe10bf271dd83f00$export$d27a2b6293f7631c);
class $fe10bf271dd83f00$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}

});

parcelRegister("kmyYx", function(module, exports) {

$parcel$export(module.exports, "ExperienceTracker", () => $1061b47f4cb3b15f$export$12b6b072930fd68f);

var $kyKWe = parcelRequire("kyKWe");

var $7W8i8 = parcelRequire("7W8i8");

var $flE5X = parcelRequire("flE5X");
var $lbti1 = parcelRequire("lbti1");

var $bEzR8 = parcelRequire("bEzR8");

var $2qKrx = parcelRequire("2qKrx");

var $7v9li = parcelRequire("7v9li");

var $949zl = parcelRequire("949zl");

var $irVI7 = parcelRequire("irVI7");

var $amL1s = parcelRequire("amL1s");
function $1061b47f4cb3b15f$var$getExperienceStopReason(error) {
    // message text check is a stop-gap measure due to re-packaging of errors. refactoring is underway.
    if ((0, $lbti1.containsSessionExpiredError)(error)) return `Aborted because of session expiration error: ${error.toString()}`;
    if ((0, $flE5X.containsNoNetworkError)(error)) return `Aborted because of network error: ${error.toString()}`;
    return undefined;
}
class $1061b47f4cb3b15f$export$12b6b072930fd68f {
    start({ name: name, id: id = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))(), timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        // Do not restart an experience that has the same id and is still running
        if (current && current.id === id && !current.hasStopped) return;
        // Before replacing a current experience, abort it to ensure it is cleaned up.
        if (current && !current.hasStopped) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $bEzR8.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        Object.values(this.experiences).forEach((experience)=>{
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        });
    }
    stopOnError({ error: error, name: name, attributes: attributes }) {
        const reason = $1061b47f4cb3b15f$var$getExperienceStopReason(error);
        if (reason) {
            this.abort({
                name: name,
                reason: reason,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    getExperienceState(experienceName) {
        return this.experiences[experienceName] ? this.experiences[experienceName].getState() : null;
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    attachDebugPoint({ name: name, message: message, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.attachDebugPoint(message, attributes);
    }
    emit(event) {
        this.logger.debug`${event.action} ${event}`;
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {
                this.logger.error`Error occurred in ExperienceTracker subscriber ${e} when handling event ${event}`;
            }
        });
    }
    constructor(){
        this.experiences = {};
        this.subscribers = [];
        this.logger = (0, $7W8i8.getLogger)('ExperienceTracker');
        (0, $2qKrx.getFreezeTracker)().start();
        if (typeof window !== 'undefined') window.addEventListener('pagehide', ()=>{
            const livePageEditExperienceName = (0, $amL1s.getLivePageEditExperienceName)();
            const livePageEditExperienceState = this.getExperienceState(livePageEditExperienceName);
            const livePageSessionExperienceState = this.getExperienceState((0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE));
            const experiencesToSucceed = [
                {
                    name: livePageEditExperienceName,
                    successCondition: livePageEditExperienceState && !livePageEditExperienceState.hasStopped && livePageEditExperienceState.attributes?.isLivePage
                },
                {
                    name: (0, $irVI7.EDIT_PAGE_EXPERIENCE),
                    successCondition: (0, $7v9li.hasHealthyRunningEditPageExperience)()
                },
                {
                    name: (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE),
                    successCondition: (0, $949zl.hasHealthyRunningViewPageExperience)()
                },
                {
                    name: (0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE),
                    successCondition: livePageSessionExperienceState && !livePageSessionExperienceState.hasStopped
                }
            ];
            experiencesToSucceed.forEach(({ name: name, successCondition: successCondition })=>{
                if (successCondition) this.succeed({
                    name: name
                });
            });
            // Abort the rest of our experiences.
            this.abort({
                reason: 'Window unloading'
            });
        });
    }
}

});
parcelRegister("lbti1", function(module, exports) {

$parcel$export(module.exports, "SessionExpiredError", () => $5b75579fd3114473$export$8220cdf0bd206e05);
$parcel$export(module.exports, "isSessionExpiredError", () => $5b75579fd3114473$export$1bd7f0128d65baef);
$parcel$export(module.exports, "containsSessionExpiredError", () => $5b75579fd3114473$export$b8c2308c7b82c3a9);

var $aTqya = parcelRequire("aTqya");

var $hBkCm = parcelRequire("hBkCm");
const $5b75579fd3114473$var$CAUGHT_SESSION_ERROR_TEXT = 'Session expired';
class $5b75579fd3114473$export$8220cdf0bd206e05 extends (0, $hBkCm.BadStatusError) {
    constructor(message, response){
        super(`${message} ${$5b75579fd3114473$var$CAUGHT_SESSION_ERROR_TEXT}`, response);
    }
}
function $5b75579fd3114473$export$1bd7f0128d65baef(error) {
    if (!error) return false;
    if (error instanceof $5b75579fd3114473$export$8220cdf0bd206e05) return true;
    const errorMessage = error?.message || '';
    if (errorMessage.indexOf($5b75579fd3114473$var$CAUGHT_SESSION_ERROR_TEXT) != -1) return true;
    const errorStatusCode = error?.extensions?.statusCode;
    if (errorStatusCode == 401) return true;
    return false;
}
function $5b75579fd3114473$export$b8c2308c7b82c3a9(error) {
    if (!error) return false;
    if ($5b75579fd3114473$export$1bd7f0128d65baef(error)) return true;
    if ((0, $aTqya.isApolloError)(error)) {
        const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
        if ($5b75579fd3114473$export$1bd7f0128d65baef(networkError)) return true;
        if ((graphQLErrors || []).some($5b75579fd3114473$export$1bd7f0128d65baef)) return true;
    }
    return false;
}

});

parcelRegister("bEzR8", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $2b8b14878b3a8327$export$c90b54e658fc4d7c);

var $csnse = parcelRequire("csnse");

var $78QFu = parcelRequire("78QFu");

var $9wGTI = parcelRequire("9wGTI");

var $glCMv = parcelRequire("glCMv");

var $2KpT3 = parcelRequire("2KpT3");

var $2qKrx = parcelRequire("2qKrx");

var $irVI7 = parcelRequire("irVI7");
// Whenever we want to target view-page experience, we should ensure we're targeting all correlated view-page experiences.
// This is more complete and helps avoid bugs related to view-content experience forwarding to view-page.
const $2b8b14878b3a8327$var$VIEW_PAGE_EXPERIENCES = [
    (0, $irVI7.VIEW_PAGE_EXPERIENCE),
    (0, $irVI7.VIEW_CONTENT_EXPERIENCE),
    (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE)
];
// Experience timeouts by default are considered taskFails. Certain experiencs should instead treat timeouts as aborts, to reduce unnecessary noise and improve SLI accuracy.
const $2b8b14878b3a8327$var$EXPERIENCE_TIMEOUTS_TO_ABORT = [
    (0, $irVI7.CREATE_PAGE_EXPERIENCE),
    ...$2b8b14878b3a8327$var$VIEW_PAGE_EXPERIENCES
];
// Errors that are thrown by client side and can be ignored, this is to avoid treating these as fails that can impact SLOs.
// ideally we can show the user a flag that shows something is wrong, please avoid adding to this list unless absolutely necessary.
const $2b8b14878b3a8327$var$IGNORABLE_CLIENT_SIDE_ERRORS = [
    "can't access dead object"
];
class $2b8b14878b3a8327$export$c90b54e658fc4d7c {
    succeed(attributes) {
        if (this.hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: this.getDurationAdjustedForTabActivity(),
            attributes: {
                ...(0, $78QFu.getUniquePageLoadId)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this.hasStopped) return;
        if (error?.message && $2b8b14878b3a8327$var$IGNORABLE_CLIENT_SIDE_ERRORS.includes(error.message)) {
            this.abort({
                reason: 'Aborted because of client side error',
                attributes: {
                    ...attributes,
                    clientSideError: error.message
                }
            });
            return;
        }
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: this.getDurationAdjustedForTabActivity(),
            debugPoints: this.debugPoints,
            error: error,
            attributes: {
                ...(0, $78QFu.getUniquePageLoadId)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this.hasStopped) return;
        const adjustedDuration = this.getDurationAdjustedForTabActivity();
        const isTimeout = checkForTimeout && this.timeout != null && adjustedDuration >= this.timeout;
        // Check if the experience should have failed due to timeout
        if (isTimeout) // We want to abort timeouts from view-page and create-page to improve SLO reliability accuracy as they're not guaranteed to be correlated to real user impact. For more info see MODES-4806.
        {
            if (!$2b8b14878b3a8327$var$EXPERIENCE_TIMEOUTS_TO_ABORT.includes(this.name)) {
                this.fail({
                    attributes: {
                        originalAbortReason: reason,
                        ...attributes
                    },
                    error: new (0, $glCMv.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
                });
                return;
            }
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: adjustedDuration,
            reason: isTimeout ? `ExperienceTimeout: ${this.name} failed to complete in ${this.timeout}ms` : reason,
            checkForTimeout: checkForTimeout,
            attributes: {
                originalAbortReason: isTimeout ? reason : undefined,
                ...(0, $78QFu.getUniquePageLoadId)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    /**
   * Called on experience to stop it with the same action (success / failure / abort) and attributes as another event.
   * For example, compound experience (e.g. edit-page) is failed if sub-experience (e.g. edit-page/publish) fails.
   */ stopOn(event, extraAttributes = {}) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed({});
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            attributes: {
                ...extraAttributes,
                stoppedOn: event.name,
                stoppedOnPath: this.getStoppedOnPath(event)
            },
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error,
            attributes: {
                ...extraAttributes,
                stoppedOn: event.name,
                stoppedOnPath: this.getStoppedOnPath(event)
            }
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    attachDebugPoint(message, attributes = {}) {
        if (this.debugPoints?.some((debugPoint)=>debugPoint.message === message)) // Avoid adding duplicate debug points
        return;
        this.debugPoints.push({
            timestamp: new Date().toISOString(),
            now: window.performance.now(),
            message: message,
            attributes: attributes
        });
    }
    getState() {
        return {
            taskId: this.id,
            timeout: this.timeout,
            hasStopped: this.hasStopped,
            stopState: this.stopState,
            startTime: this.startTime,
            name: this.name,
            attributes: this.attributes
        };
    }
    get hasStopped() {
        return this.stopState !== null;
    }
    stop(event) {
        this.stopState = event.action;
        if (this.onStop) this.onStop(event);
        (0, $2qKrx.getFreezeTracker)().unsubscribe(this.name);
    }
    getAbsoluteDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    getDurationAdjustedForTabActivity() {
        return this.getAbsoluteDuration() - (0, $2KpT3.getTabInactivityTracker)().getInactiveMillisecondsSince(this.startTime);
    }
    getDurationAdjustedForActive() {
        return this.getAbsoluteDuration() - this.freezeTime;
    }
    getStoppedOnPath(event) {
        if (!event.attributes?.stoppedOnPath) return event.name;
        return `${event.name},${event.attributes.stoppedOnPath}`;
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this.freezeTime = 0;
        this.stopState = null;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.debugPoints = [];
        // Include certain broad-impact feature gates in experience events
        this.getFeatureGateAttributes = (0, $csnse.default)(()=>{
            return {
                isContentWrapperEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
                isNav4Enabled: (0, $9wGTI.fg)('confluence_nav4')
            };
        });
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: {
                ...(0, $78QFu.getUniquePageLoadId)(),
                ...attributes,
                ...this.getFeatureGateAttributes()
            }
        };
        if (onStart) this.onStop = onStart(startEvent);
        (0, $2qKrx.getFreezeTracker)().subscribe(name, (time)=>{
            this.freezeTime += time;
        });
    }
}

});
parcelRegister("2KpT3", function(module, exports) {

$parcel$export(module.exports, "getTabInactivityTracker", () => $74ab39b5aaac21ba$export$39c3eb20723b04b);

var $csnse = parcelRequire("csnse");

var $7W8i8 = parcelRequire("7W8i8");
class $74ab39b5aaac21ba$export$a00c080e726db0b {
    initialize() {
        if (typeof document === 'undefined') return {
            teardown: ()=>{}
        };
        if (document.hidden) // if the tab is active, `onVisibilityChange` will result in invariant violation
        this.onVisibilityChange();
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        return {
            teardown: ()=>{
                document.removeEventListener('visibilitychange', this.onVisibilityChange);
            }
        };
    }
    getInactiveMillisecondsSince(timestamp) {
        let inactivityDuration = 0;
        // for-loop will allow us to perform an early exit
        for (const [start, end] of this.inactivityIntervals){
            // cases:
            // - timestamp < start     < end        : Relevant
            // - start     < timestamp < end        : Relevant
            // - start     < timestamp ; end=null   : Relevant
            // - start     < end       < timestamp  : Irrelevant
            const inactivityEnd = end || window.performance.now();
            if (timestamp > inactivityEnd) break;
            inactivityDuration += inactivityEnd - Math.max(start, timestamp);
        }
        return inactivityDuration;
    }
    constructor({ maxIntervalsToStore: maxIntervalsToStore } = {}){
        /**
     * Stores intervals in reverse order (that is, latest interval will be the first item in the array).
     * The items in this array are tuples of [intervalStartTimestamp, intervalEndTimestamp].
     * If `intervalEndTimestamp` is `null`, that means that tab is still inactive.
     * Example value (number would actually be timestamps, but they are exemplified differently for ease of understanding):
     * ```js
     * // if the tab is currently active, but was hidden before
     * [ [500, 600], [300, 400], [100, 200] ]
     *
     * // while the tab is still inactive
     * [ [500, null], [100, 200] ]
     *
     * // if the tab has never been hidden
     * [ ]
     * ```
     */ this.inactivityIntervals = [];
        this.logger = (0, $7W8i8.getLogger)('TabInactivityTracker');
        // in order to not increase memory footprint indefinitely, we'll cap the maximum amount of items
        this.maxIntervalsToStore = void 0;
        this.onVisibilityChange = ()=>{
            if (!document.hidden) {
                // we were inactive before, which means that there is an "unfinished" interval
                // we'll finish it after verifying invariants
                if (this.inactivityIntervals.length === 0 || this.inactivityIntervals[0][1] != null) this.logger.error`Invariant violation: tab is currently active, but inactivity intervals are in inconsistent state`;
                else this.inactivityIntervals[0][1] = window.performance.now();
            } else {
                if (this.inactivityIntervals.length >= this.maxIntervalsToStore) // we're about to add a new interval; but we're also at max array capacity, so we'll
                // intentionally lose the most dated items in the array in the hope that they won't be needed anymore.
                this.inactivityIntervals.splice(this.maxIntervalsToStore - 1);
                // tab just became inactive; we'll create a new "unfinished" interval
                this.inactivityIntervals.unshift([
                    window.performance.now(),
                    null
                ]);
            }
        };
        const DEFAULT_MAX_INTERVALS_TO_STORE = 100;
        this.maxIntervalsToStore = typeof maxIntervalsToStore === 'number' ? maxIntervalsToStore : DEFAULT_MAX_INTERVALS_TO_STORE;
    }
}
const $74ab39b5aaac21ba$export$39c3eb20723b04b = (0, $csnse.default)(()=>{
    const tracker = new $74ab39b5aaac21ba$export$a00c080e726db0b();
    tracker.initialize();
    return tracker;
});

});

parcelRegister("2qKrx", function(module, exports) {

$parcel$export(module.exports, "getFreezeTracker", () => $9cb197567841b4e3$export$40336562f0f00c2a);

var $csnse = parcelRequire("csnse");
class $9cb197567841b4e3$export$51cec848073e2e7a {
    start() {
        let lastFreezeStart;
        if (typeof document !== 'undefined') {
            document.addEventListener('freeze', ()=>{
                lastFreezeStart = performance.now();
            });
            document.addEventListener('resume', ()=>{
                // probably zero chance of it happening, but still
                if (typeof lastFreezeStart !== 'number') return;
                const now = performance.now();
                for (const callback of this.callbacks.values())callback(now - lastFreezeStart);
            });
        }
    }
    subscribe(name, callback) {
        // We are not subscribe and unsubscribe with callback's reference.
        // Because there are known cases that experiences are not properly stopped.
        // In order prevent from memory leak here we are using the name as the key since the variation is bounded.
        this.callbacks.set(name, callback);
    }
    unsubscribe(name) {
        this.callbacks.delete(name);
    }
    constructor(){
        this.callbacks = new Map();
    }
}
const $9cb197567841b4e3$export$40336562f0f00c2a = (0, $csnse.default)(()=>new $9cb197567841b4e3$export$51cec848073e2e7a());

});


parcelRegister("7v9li", function(module, exports) {

$parcel$export(module.exports, "startCreateAndEditPage", () => $76d2f84cb77df08d$export$b4cbec267823a12e);
$parcel$export(module.exports, "hasHealthyRunningEditPageExperience", () => $76d2f84cb77df08d$export$2b69dcd5daaf6a2c);

var $irVI7 = parcelRequire("irVI7");

var $gykrH = parcelRequire("gykrH");

var $fGzMp = parcelRequire("fGzMp");
const $76d2f84cb77df08d$var$EDIT_PAGE_SUBEXPERIENCES = [
    (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
    (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE),
    (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)
];
const $76d2f84cb77df08d$export$b4cbec267823a12e = ()=>{
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_AND_EDIT_PAGE_EXPERIENCE),
        collect: $76d2f84cb77df08d$export$bb44f104e3c54dae
    });
};
const $76d2f84cb77df08d$export$bb44f104e3c54dae = (events, experience)=>{
    experience.stopOn($76d2f84cb77df08d$export$e2067cc0ba855137(events, 'taskSuccess'));
    experience.stopOn($76d2f84cb77df08d$export$e2067cc0ba855137(events, 'taskFail'));
};
const $76d2f84cb77df08d$export$e2067cc0ba855137 = (events, action)=>{
    return events.find((event)=>event.action === action && (0, $gykrH.hasName)(event, (0, $irVI7.EDIT_PAGE_EXPERIENCE)));
};
const $76d2f84cb77df08d$export$2b69dcd5daaf6a2c = ()=>{
    const tracker = (0, $fGzMp.getExperienceTracker)();
    const editPageExperienceState = tracker.getExperienceState((0, $irVI7.EDIT_PAGE_EXPERIENCE));
    const isEditPageRunning = editPageExperienceState && !editPageExperienceState.hasStopped;
    if (!isEditPageRunning) return false;
    // Validate all subexperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return $76d2f84cb77df08d$var$EDIT_PAGE_SUBEXPERIENCES.every((subexperience)=>{
        const subexperienceState = tracker.getExperienceState(subexperience);
        // Subexperience has not run, so edit-page is still healthy
        if (!subexperienceState) return true;
        // Subexperience has not run for current edit-page's contentId, so edit-page is still healthy
        if (subexperienceState.attributes?.contentId !== editPageExperienceState.attributes?.contentId) return true;
        // Subexperience has run and has finished successfully, so edit-page is still healthy
        if (subexperienceState.stopState === 'taskSuccess') return true;
        // Subexperience has run and has not finished successfully, so edit-page is unhealthy
        return false;
    });
};

});
parcelRegister("gykrH", function(module, exports) {

$parcel$export(module.exports, "isStop", () => $69558f20f281edc8$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $69558f20f281edc8$export$57069f5b2ecc9128);
$parcel$export(module.exports, "hasAttribute", () => $69558f20f281edc8$export$7895096fcdde5712);
const $69558f20f281edc8$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $69558f20f281edc8$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);
const $69558f20f281edc8$export$7895096fcdde5712 = (event, key, value)=>Boolean(event.attributes?.hasOwnProperty(key) && event.attributes[key] === value);

});


parcelRegister("949zl", function(module, exports) {

$parcel$export(module.exports, "hasHealthyRunningViewPageExperience", () => $dc61e055cb121158$export$77dd5573732a240c);
$parcel$export(module.exports, "startViewPageSessionExperience", () => $dc61e055cb121158$export$41f7b734fb3e4a50);

var $irVI7 = parcelRequire("irVI7");

var $iSkW7 = parcelRequire("iSkW7");
const $dc61e055cb121158$export$77dd5573732a240c = ()=>(0, $iSkW7.hasHealthyRunningExperience)({
        parentExperience: (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE),
        subExperiences: [
            (0, $irVI7.VIEW_PAGE_EXPERIENCE)
        ]
    });
const $dc61e055cb121158$export$41f7b734fb3e4a50 = ({ id: id, tracker: tracker, attributes: attributes, startTime: startTime })=>{
    tracker.start({
        name: (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE),
        id: id,
        startTime: startTime,
        attributes: attributes,
        collect: (events, experience)=>{
            const viewExperienceLoadingFailed = events.find(({ action: action, name: name })=>action === 'taskFail' && name === (0, $irVI7.VIEW_PAGE_EXPERIENCE));
            const viewExperienceLoadingAborted = events.find(({ action: action, name: name })=>action === 'taskAbort' && name === (0, $irVI7.VIEW_PAGE_EXPERIENCE));
            if (viewExperienceLoadingFailed) experience.fail({
                error: new Error('View page load experience failed')
            });
            else if (viewExperienceLoadingAborted) experience.abort({
                reason: 'View page load experience aborted'
            });
        }
    });
};

});
parcelRegister("iSkW7", function(module, exports) {

$parcel$export(module.exports, "hasHealthyRunningExperience", () => $1d28c59b5f724925$export$11699410c9e76883);

var $fGzMp = parcelRequire("fGzMp");
const $1d28c59b5f724925$export$11699410c9e76883 = ({ parentExperience: parentExperience, subExperiences: subExperiences })=>{
    const tracker = (0, $fGzMp.getExperienceTracker)();
    const parentExperienceState = tracker.getExperienceState(parentExperience);
    const isParentExperienceRunning = parentExperienceState && !parentExperienceState.hasStopped;
    if (!isParentExperienceRunning) return false;
    const parentExperienceContentId = String(parentExperienceState.attributes?.contentId);
    return $1d28c59b5f724925$var$areSubExperiencesHealthy({
        parentExperienceContentId: parentExperienceContentId,
        subExperiences: subExperiences
    });
};
const $1d28c59b5f724925$var$areSubExperiencesHealthy = ({ parentExperienceContentId: parentExperienceContentId, subExperiences: subExperiences = [] })=>{
    const tracker = (0, $fGzMp.getExperienceTracker)();
    // Validate all subExperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return subExperiences.every((subExperience)=>{
        const subExperienceState = tracker.getExperienceState(subExperience);
        // Subexperience has not run, so parent is still healthy
        if (!subExperienceState) return true;
        // Subexperience has not run for current parentExperience's contentId, so parentExperience is still healthy
        const isSubExperienceForDifferentContent = parentExperienceContentId !== subExperienceState.attributes?.contentId;
        if (isSubExperienceForDifferentContent) return true;
        const hasSubExperienceCompletedSuccessfully = subExperienceState.stopState === 'taskSuccess';
        if (hasSubExperienceCompletedSuccessfully) return true;
        // Subexperience has run and has not finished successfully, so parentExperience is unhealthy
        return false;
    });
};

});


parcelRegister("amL1s", function(module, exports) {

$parcel$export(module.exports, "getLivePageViewExperienceName", () => $cb18db7a80e4108b$export$fc45374fcefeb0f1);
$parcel$export(module.exports, "getLivePageEditExperienceName", () => $cb18db7a80e4108b$export$44bb710761a63941);

var $csnse = parcelRequire("csnse");

var $9wGTI = parcelRequire("9wGTI");

var $irVI7 = parcelRequire("irVI7");
const $cb18db7a80e4108b$export$fc45374fcefeb0f1 = (0, $csnse.default)(()=>{
    return (0, $9wGTI.fg)('live_page_exp_to_core_exp_migration') ? (0, $irVI7.VIEW_PAGE_EXPERIENCE) : (0, $irVI7.LIVE_PAGE_VIEW_EXPERIENCE);
});
const $cb18db7a80e4108b$export$44bb710761a63941 = (0, $csnse.default)(()=>{
    return (0, $9wGTI.fg)('live_page_exp_to_core_exp_migration') ? (0, $irVI7.EDIT_PAGE_EXPERIENCE) : (0, $irVI7.LIVE_PAGE_EDIT_EXPERIENCE);
});

});





parcelRegister("b6OuN", function(module, exports) {

$parcel$export(module.exports, "getAGGWebSocketLinkInstance", () => $82d5b34f86d4a9d1$export$4b71fe053d09625a);

var $kyKWe = parcelRequire("kyKWe");

var $9OOUR = parcelRequire("9OOUR");

var $gZ7FC = parcelRequire("gZ7FC");

var $aLaTe = parcelRequire("aLaTe");

var $aTqya = parcelRequire("aTqya");

var $04e9M = parcelRequire("04e9M");
function $82d5b34f86d4a9d1$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
class $82d5b34f86d4a9d1$export$9aef10bdbab07b6 extends (0, $gZ7FC.ApolloLink) {
    request(operation) {
        return new (0, $gZ7FC.Observable)((observer)=>{
            return this.client.subscribe({
                ...operation,
                query: (0, $aLaTe.print)(operation.query)
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $aTqya.ApolloError)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
        });
    }
    constructor(options){
        super();
        this.clientId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        this.client = void 0;
        this.generateID = ()=>{
            return this.clientId;
        };
        this.connected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected',
                    attributes: {
                        clientId: this.clientId
                    }
                });
            });
        };
        this.closed = (_event)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    action: 'closed',
                    actionSubject: 'webSocket',
                    attributes: {
                        clientId: this.clientId
                    }
                });
            });
        };
        this.client = (0, $9OOUR.createClient)({
            ...options,
            on: {
                connected: this.connected,
                closed: this.closed
            },
            generateID: this.generateID
        });
    }
}
let $82d5b34f86d4a9d1$var$wsLink;
function $82d5b34f86d4a9d1$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $82d5b34f86d4a9d1$export$91893b414ff080f2();
    if (!$82d5b34f86d4a9d1$var$wsLink) $82d5b34f86d4a9d1$var$wsLink = new $82d5b34f86d4a9d1$export$9aef10bdbab07b6({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        retryAttempts: 5
    });
    return $82d5b34f86d4a9d1$var$wsLink;
}

});


parcelRegister("hp2SH", function(module, exports) {

$parcel$export(module.exports, "getApolloClient", () => $3c7e293513d9f078$export$1e6cfeaf8b88bd01);

var $eHj6r = parcelRequire("eHj6r");
// Make sure there is only one client being created in the app
let $3c7e293513d9f078$var$apolloClient = null;
function $3c7e293513d9f078$export$1e6cfeaf8b88bd01(initializeNewCache = false) {
    // Ensure tests are using the same apollo client.
    // Also allow query in @confluence/query-preloader to use apollo without direct dependency.
    if (window['GLOBAL_APOLLO_CLIENT']) return window['GLOBAL_APOLLO_CLIENT'];
    if (!$3c7e293513d9f078$var$apolloClient) $3c7e293513d9f078$var$apolloClient = (0, $eHj6r.createClient)({
        initializeNewCache: initializeNewCache
    });
    window['GLOBAL_APOLLO_CLIENT'] = $3c7e293513d9f078$var$apolloClient;
    return $3c7e293513d9f078$var$apolloClient;
}

});
parcelRegister("eHj6r", function(module, exports) {

$parcel$export(module.exports, "resetApolloStats", () => $fa0df9a02d059b52$export$d4ebe6281d18dc6a);
$parcel$export(module.exports, "apolloCache", () => $fa0df9a02d059b52$export$2aa8a08d369336c5);
$parcel$export(module.exports, "createClient", () => $fa0df9a02d059b52$export$5d730b7aed1a3eb0);

var $aTqya = parcelRequire("aTqya");

var $gZ7FC = parcelRequire("gZ7FC");

var $csQ66 = parcelRequire("csQ66");

var $9hGvU = parcelRequire("9hGvU");

var $aU4fU = parcelRequire("aU4fU");

var $gTOUc = parcelRequire("gTOUc");

var $4VJDS = parcelRequire("4VJDS");

var $flE5X = parcelRequire("flE5X");
var $f7B1p = parcelRequire("f7B1p");

var $louAg = parcelRequire("louAg");
parcelRequire("brVcJ");
var $3m5TZ = parcelRequire("3m5TZ");
var $brVcJ = parcelRequire("brVcJ");

var $cnLti = parcelRequire("cnLti");

var $hyeEk = parcelRequire("hyeEk");


var $e43zd = parcelRequire("e43zd");

var $9jPdT = parcelRequire("9jPdT");

var $b2nDI = parcelRequire("b2nDI");

var $aOk8w = parcelRequire("aOk8w");

var $frpLx = parcelRequire("frpLx");

var $5Vp8B = parcelRequire("5Vp8B");



var $8iwsP = parcelRequire("8iwsP");

var $a9UQD = parcelRequire("a9UQD");

var $avrP0 = parcelRequire("avrP0");

var $3aShZ = parcelRequire("3aShZ");

var $8Li6j = parcelRequire("8Li6j");

var $iMHGI = parcelRequire("iMHGI");


var $11MAl = parcelRequire("11MAl");
const $fa0df9a02d059b52$var$URI = '/cgraphql';
const $fa0df9a02d059b52$var$MAX_CONCURRENCY_FOR_THROTTLED = 8;
const $fa0df9a02d059b52$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)(true);
function $fa0df9a02d059b52$export$d4ebe6281d18dc6a() {
    window.__APOLLO_STATS__ = {
        // Used in node_modules/apollo-client/bundle.esm.js
        broadcast: {}
    };
}
const $fa0df9a02d059b52$var$createCache = ()=>{
    return new (0, $aU4fU.InMemoryCache)({
        fragmentMatcher: $8iwsP.fragmentMatcher,
        dataIdFromObject: $a9UQD.dataIdFromObject,
        cacheRedirects: $avrP0.cacheRedirects
    });
};
/**
 * Override fetch function used in terminating (http batch) link, to throttle network requests.
 * Concurrent network requests are limited based on MAX_CONCURRENCY_FOR_THROTTLED constant.
 *
 * Realistically, this will be used when there are a large volume of queries are triggered together, upon page load. Therefore,
 * resolving requests in approximate order is sufficient.
 */ const $fa0df9a02d059b52$var$requestPool = [];
const $fa0df9a02d059b52$var$throttledFetch = (uri, options)=>{
    if ($fa0df9a02d059b52$var$requestPool.length >= $fa0df9a02d059b52$var$MAX_CONCURRENCY_FOR_THROTTLED) {
        // pool is full, so queue up next request behind the first request in the pool
        const queuedFetchFn = async ()=>{
            await $fa0df9a02d059b52$var$requestPool.shift();
            return $fa0df9a02d059b52$var$wrappedFetch(uri, options);
        };
        const queuedFetch = queuedFetchFn();
        $fa0df9a02d059b52$var$requestPool.push(queuedFetch);
        return queuedFetch;
    }
    // pool has available slot - add new request to pool and begin request immediately
    const nextFetch = $fa0df9a02d059b52$var$wrappedFetch(uri, options);
    $fa0df9a02d059b52$var$requestPool.push(nextFetch);
    return nextFetch;
};
const $fa0df9a02d059b52$var$createLink = ({ experimentalSchemaLinkOverride: experimentalSchemaLinkOverride, ccGraphqlSchemaLinkOverride: ccGraphqlSchemaLinkOverride })=>{
    const httpLinkOptions = {
        uri: $fa0df9a02d059b52$var$URI,
        credentials: 'same-origin',
        fetch: $fa0df9a02d059b52$var$wrappedFetch
    };
    var getContext;
    {
        const httpLink = (0, $gZ7FC.split)(({ getContext: getContext })=>{
            return getContext().single || // In integration tests we deliberately block some queries in order to test the loading state
            // Randomly batching other queries with them will make UI fail to load
            // @ts-ignore TODO FIXME
            window.Cypress || window.__CRITERION__ || // @ts-ignore Property 'isPlaywright' does not exist on type 'Window & typeof globalThis'
            Boolean(window.isPlaywright) || // we don't want query batching for contract tests
            // @ts-expect-error Property isContract doesn't exist on window
            Boolean(window.isContract) || !(0, $4VJDS.default).isKillSwitchOn('confluence_spa_query_batching');
        }, new (0, $csQ66.HttpLink)(httpLinkOptions), (0, $gZ7FC.split)(({ getContext: getContext })=>!!getContext().throttle, new (0, $csQ66.HttpLink)({
            ...httpLinkOptions,
            fetch: $fa0df9a02d059b52$var$throttledFetch
        }), new (0, $9hGvU.BatchHttpLink)(httpLinkOptions)));
        const processingLinks = [
            (0, $louAg.deleteExtensionsLink),
            (0, $hyeEk.addSuperAdminDirectiveLink),
            (0, $11MAl.SSRClientLink)($fa0df9a02d059b52$export$2aa8a08d369336c5),
            (0, $brVcJ.networkStatusLink)(),
            (0, $b2nDI.statusCodeRetryLink),
            (0, $e43zd.networkErrorRetryLink),
            (0, $cnLti.externalShareLink),
            (0, $gTOUc.UFOLoggerLink)
        ];
        let ccGraphLink;
        ccGraphLink = (0, $gZ7FC.from)(processingLinks).split((0, $3aShZ.isWS), (0, $5Vp8B.webSocketLink)(), httpLink);
        const links = [
            (0, $9jPdT.createOnErrorLink)(),
            (0, $aOk8w.graphqlSyntheticErrorGenerator)()
        ];
        return (0, $gZ7FC.from)(links).split(// Condition
        (operation)=>(0, $3aShZ.isExperimental)(operation), // If query contains @experimental directive
        experimentalSchemaLinkOverride || (0, $frpLx.ExperimentalLink)(), // Else
        ccGraphqlSchemaLinkOverride || ccGraphLink);
    }
};
const $fa0df9a02d059b52$export$2aa8a08d369336c5 = $fa0df9a02d059b52$var$createCache();
const $fa0df9a02d059b52$export$5d730b7aed1a3eb0 = (options = {})=>{
    // Creates window.__APOLLO_STATS__ call before creating the client
    $fa0df9a02d059b52$export$d4ebe6281d18dc6a();
    const cache = options.initializeNewCache ? $fa0df9a02d059b52$var$createCache() : $fa0df9a02d059b52$export$2aa8a08d369336c5;
    if (typeof window['__APOLLO_STATE__'] === 'object') cache.restore(window['__APOLLO_STATE__']);
    const client = new (0, $aTqya.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        link: $fa0df9a02d059b52$var$createLink(options),
        typeDefs: (0, $8Li6j.ClientSchema),
        cache: cache
    });
    // Don't initialize the client cache for tests so we can mock it
    if (!options.ccGraphqlSchemaLinkOverride) (0, $brVcJ.writeNetworkStatus)(client.cache, (0, $3m5TZ.ClientNetworkStatus).ONLINE);
    (0, $f7B1p.cfetch).subscribe((response, error)=>{
        if (response) // It's NetworkStatusLink's responsibility/concern to interpret
        // cc-graphql errors (which may be carried in an OK HTTP response).
        {
            if (response.url?.indexOf($fa0df9a02d059b52$var$URI) === -1) (0, $brVcJ.writeNetworkStatus)(client.cache, (0, $3m5TZ.ClientNetworkStatus).ONLINE);
        } else if (error instanceof (0, $flE5X.NoNetworkError) && !error.ignore && !(0, $flE5X.causedByAbortError)(error)) (0, $brVcJ.writeNetworkStatus)(client.cache, (0, $3m5TZ.ClientNetworkStatus).OFFLINE);
    });
    return client;
};

});
parcelRegister("louAg", function(module, exports) {

$parcel$export(module.exports, "deleteExtensionsLink", () => $27189d26cff73d8c$export$b09c71c2c352a47a);

var $gZ7FC = parcelRequire("gZ7FC");
const $27189d26cff73d8c$export$b09c71c2c352a47a = new (0, $gZ7FC.ApolloLink)((operation, forward)=>{
    // @ts-ignore - See above comment
    delete operation.extensions;
    return forward(operation);
});

});

parcelRegister("brVcJ", function(module, exports) {

$parcel$export(module.exports, "writeNetworkStatus", () => $93dbb5ab38237866$export$67a1ea7955e5b308);
$parcel$export(module.exports, "networkStatusLink", () => $93dbb5ab38237866$export$c6899cfecb91c18f);
$parcel$export(module.exports, "NetworkStatus", () => (parcelRequire("3m5TZ")).ClientNetworkStatus);

var $aTqya = parcelRequire("aTqya");

var $gZ7FC = parcelRequire("gZ7FC");

var $7W8i8 = parcelRequire("7W8i8");

var $hBkCm = parcelRequire("hBkCm");
var $flE5X = parcelRequire("flE5X");
var $lbti1 = parcelRequire("lbti1");

var $9wGTI = parcelRequire("9wGTI");

var $3m5TZ = parcelRequire("3m5TZ");

var $4s17h = parcelRequire("4s17h");
function $93dbb5ab38237866$var$readNetworkStatus(cache) {
    try {
        const data = cache.readQuery({
            query: (0, $4s17h.NetworkStatusLinkQuery)
        });
        return data?.network?.status;
    } catch (e) {
        return undefined;
    }
}
function $93dbb5ab38237866$export$67a1ea7955e5b308(cache, status) {
    const currentStatus = $93dbb5ab38237866$var$readNetworkStatus(cache);
    if (currentStatus === (0, $3m5TZ.ClientNetworkStatus).SESSION_EXPIRED) // recovering from this error only via page reload
    return;
    if (currentStatus !== status) cache.writeQuery({
        query: (0, $4s17h.NetworkStatusLinkQuery),
        data: {
            network: {
                // @ts-ignore
                __typename: 'ClientNetwork',
                status: status
            }
        }
    });
}
const $93dbb5ab38237866$export$c6899cfecb91c18f = ()=>{
    const logger = (0, $7W8i8.getLogger)($93dbb5ab38237866$export$c6899cfecb91c18f);
    return new (0, $gZ7FC.ApolloLink)((operation, forward)=>{
        return new (0, $gZ7FC.Observable)((observer)=>{
            forward(operation).subscribe({
                next (result) {
                    const context = operation.getContext();
                    if (result.errors?.some((0, $lbti1.isSessionExpiredError))) {
                        $93dbb5ab38237866$export$67a1ea7955e5b308(context.cache, (0, $3m5TZ.ClientNetworkStatus).SESSION_EXPIRED);
                        const sessionExpiredError = new (0, $lbti1.SessionExpiredError)(operation.operationName, context.response || {});
                        // Don't throw original errors when translating them:
                        // 1. By Error's convention, the original cause of the Error is in
                        //    `cause`.
                        // 2. By our convention inspired by GraphQLError, the original cause
                        //    of the Error is in `originalError`).
                        sessionExpiredError.originalError = sessionExpiredError.cause = new (0, $aTqya.ApolloError)({
                            graphQLErrors: result.errors
                        });
                        observer.error(sessionExpiredError);
                    } else {
                        $93dbb5ab38237866$export$67a1ea7955e5b308(context.cache, (0, $3m5TZ.ClientNetworkStatus).ONLINE);
                        observer.next(result);
                    }
                },
                error (error) {
                    const context = operation.getContext();
                    if (error instanceof (0, $hBkCm.BadStatusError)) switch(error.response.status){
                        case /* Forbidden */ 403:
                            logger.log`IP blocked for ${operation}`;
                            $93dbb5ab38237866$export$67a1ea7955e5b308(context.cache, (0, $3m5TZ.ClientNetworkStatus).IP_BLOCKED);
                            return; // as it doesn't call observer next/error, the request will stay in unresolved state
                        case /* Too Many Requests */ 429:
                            logger.log`Rate limit was reached for ${operation}`;
                            $93dbb5ab38237866$export$67a1ea7955e5b308(context.cache, (0, $3m5TZ.ClientNetworkStatus).RATE_LIMITED);
                            observer.error(error);
                            return;
                    }
                    else if (error instanceof (0, $flE5X.NoNetworkError) && !error.ignore && !(0, $flE5X.causedByAbortError)(error)) {
                        logger.log`Network is offline for ${operation}`;
                        $93dbb5ab38237866$export$67a1ea7955e5b308(context.cache, (0, $3m5TZ.ClientNetworkStatus).OFFLINE);
                        if ((0, $9wGTI.fg)('platform_editor_bubble_cfe_gql_network_errors')) {
                            // Attach metadata to be picked up by analytics, to make monitoring easier while this is being rolled out and tested
                            error.wasBubbledUp = true;
                            observer.error(error);
                        }
                        return; // as it doesn't call observer next/error, the request will stay in unresolved state;
                    }
                    observer.error(error);
                },
                complete () {
                    observer.complete();
                }
            });
        });
    });
};

});
parcelRegister("3m5TZ", function(module, exports) {

$parcel$export(module.exports, "ClientNetworkStatus", () => $ef9a57e67d61acdc$export$491825b5144ba722);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $ef9a57e67d61acdc$export$491825b5144ba722 = /*#__PURE__*/ function(ClientNetworkStatus) {
    ClientNetworkStatus["IP_BLOCKED"] = "IP_BLOCKED";
    ClientNetworkStatus["OFFLINE"] = "OFFLINE";
    ClientNetworkStatus["ONLINE"] = "ONLINE";
    ClientNetworkStatus["RATE_LIMITED"] = "RATE_LIMITED";
    ClientNetworkStatus["SESSION_EXPIRED"] = "SESSION_EXPIRED";
    return ClientNetworkStatus;
}({});

});

parcelRegister("4s17h", function(module, exports) {

$parcel$export(module.exports, "NetworkStatusLinkQuery", () => $042d88bae11db39d$export$bffc74e781c27d1e);

var $d2LG0 = parcelRequire("d2LG0");
const $042d88bae11db39d$export$bffc74e781c27d1e = (0, $d2LG0.default)`query NetworkStatusLinkQuery{network{status}}`;

});


parcelRegister("cnLti", function(module, exports) {

$parcel$export(module.exports, "externalShareLink", () => $d1576ec57364495d$export$624b4ef2030b3ab5);

var $gZ7FC = parcelRequire("gZ7FC");

var $1NBp8 = parcelRequire("1NBp8");
const $d1576ec57364495d$export$624b4ef2030b3ab5 = new (0, $gZ7FC.ApolloLink)((operation, forward)=>{
    const { allowOnExternalPage: allowOnExternalPage = false } = operation.getContext();
    const isExternalShareRequest = !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
    // this issue has given developers a lot of gripe, since things fail silently
    if (isExternalShareRequest && !allowOnExternalPage) // eslint-disable-next-line no-console
    console.warn('Trying to make a call on an external route without allowOnExternalPage', operation.operationName);
    if (allowOnExternalPage || !isExternalShareRequest) return forward(operation);
    return new (0, $gZ7FC.Observable)((observer)=>{
        observer.complete();
    });
});

});
parcelRegister("1NBp8", function(module, exports) {

$parcel$export(module.exports, "BASE", () => $ca532a827038ae75$export$9e15ff8aa6bc996f);
$parcel$export(module.exports, "WIKI", () => $ca532a827038ae75$export$2fd309376969662f);
$parcel$export(module.exports, "HOME", () => $ca532a827038ae75$export$a7c5707626fc90f);
$parcel$export(module.exports, "TEMPLATE_GALLERY", () => $ca532a827038ae75$export$6ccd7dc0d5aa30b0);
$parcel$export(module.exports, "CALENDAR", () => $ca532a827038ae75$export$7d65e474be175151);
$parcel$export(module.exports, "MY_CALENDAR", () => $ca532a827038ae75$export$ec8a7da990877da3);
$parcel$export(module.exports, "QUESTIONS", () => $ca532a827038ae75$export$aa473411bddb7e17);
$parcel$export(module.exports, "QUESTIONS_NATIVE", () => $ca532a827038ae75$export$42bb8ba9cae96927);
$parcel$export(module.exports, "QUESTION_NATIVE", () => $ca532a827038ae75$export$1e92de3a3dba0876);
$parcel$export(module.exports, "CONTENT_HISTORY", () => $ca532a827038ae75$export$6a85914fb9ca80a2);
$parcel$export(module.exports, "CONTENT_HISTORY_LEGACY", () => $ca532a827038ae75$export$1f238fcead086ec3);
$parcel$export(module.exports, "EDIT_PAGE", () => $ca532a827038ae75$export$b74c113024023274);
$parcel$export(module.exports, "EDIT_BLOG", () => $ca532a827038ae75$export$45222bf0cb32d6e2);
$parcel$export(module.exports, "EDIT_PAGE_V2", () => $ca532a827038ae75$export$7b1285e36c635f1f);
$parcel$export(module.exports, "EDIT_BLOG_V2", () => $ca532a827038ae75$export$36dcea4e08feb5c9);
$parcel$export(module.exports, "EDIT_PAGE_EMBED", () => $ca532a827038ae75$export$e63a462ee45b57cf);
$parcel$export(module.exports, "CREATE_CONTENT", () => $ca532a827038ae75$export$54edf7c16c47aeef);
$parcel$export(module.exports, "CREATE_PAGE", () => $ca532a827038ae75$export$d6ae9e544e98926f);
$parcel$export(module.exports, "CREATE_BLOG", () => $ca532a827038ae75$export$e8253e1b7e500d1c);
$parcel$export(module.exports, "DELETE_PAGE", () => $ca532a827038ae75$export$9a4ff2d809fc4156);
$parcel$export(module.exports, "ONBOARDING", () => $ca532a827038ae75$export$19c176cd0a878008);
$parcel$export(module.exports, "SPACE_DIRECTORY", () => $ca532a827038ae75$export$439074745692fe65);
$parcel$export(module.exports, "SPACE_SETTINGS", () => $ca532a827038ae75$export$2de9a69f9b51bb83);
$parcel$export(module.exports, "SPACE_SETTINGS_REORDERPAGES", () => $ca532a827038ae75$export$10f0439b47c8fdaf);
$parcel$export(module.exports, "SPACE_SETTINGS_HIDDEN_PAGES", () => $ca532a827038ae75$export$d0ac6fa12f3acafa);
$parcel$export(module.exports, "SPACE_SETTINGS_UNDEFINED_PAGES", () => $ca532a827038ae75$export$35123576da2e521);
$parcel$export(module.exports, "SPACE_SETTINGS_ATTACHMENTS", () => $ca532a827038ae75$export$e18ccd8ffafdf3dd);
$parcel$export(module.exports, "SPACE_SETTINGS_APPLICATION_LINKS", () => $ca532a827038ae75$export$9c4e8cdcbbacdf8f);
$parcel$export(module.exports, "SPACE_SETTINGS_RSS_FEEDS", () => $ca532a827038ae75$export$f85f59869a8dbbf8);
$parcel$export(module.exports, "SPACE_OVERVIEW_REDIRECT_LEGACY", () => $ca532a827038ae75$export$d87089dbdd7eeaf3);
$parcel$export(module.exports, "DELETE_SPACE_LEGACY", () => $ca532a827038ae75$export$dd174db99b3e6fea);
$parcel$export(module.exports, "SPACE_INDEX", () => $ca532a827038ae75$export$ef26ce515f06bc5e);
$parcel$export(module.exports, "SPACE_OVERVIEW", () => $ca532a827038ae75$export$65b723bb995d4fb6);
$parcel$export(module.exports, "COMPANY_HUB", () => $ca532a827038ae75$export$ada7925da580b561);
$parcel$export(module.exports, "COMPANY_HUB_ANALYTICS", () => $ca532a827038ae75$export$29df24b01e938adf);
$parcel$export(module.exports, "COMPANY_HUB_EDIT", () => $ca532a827038ae75$export$e003e97fab6b4368);
$parcel$export(module.exports, "COMPANY_HUB_SETTINGS", () => $ca532a827038ae75$export$5f7be6e90830de0c);
$parcel$export(module.exports, "VIEW_PAGE", () => $ca532a827038ae75$export$9257b5b55c8e2555);
$parcel$export(module.exports, "NEXT_VIEW_PAGE", () => $ca532a827038ae75$export$475fdaba8e6145bb);
$parcel$export(module.exports, "BLOG_HOME", () => $ca532a827038ae75$export$347d3b5edaae00e0);
$parcel$export(module.exports, "VIEW_BLOG", () => $ca532a827038ae75$export$91f49e7b30a9d34);
$parcel$export(module.exports, "SPACE_JIRA_PROJECT_BOARD", () => $ca532a827038ae75$export$ac51957e7110425e);
$parcel$export(module.exports, "WHITEBOARD_HOME", () => $ca532a827038ae75$export$c259921a01da55b4);
$parcel$export(module.exports, "WHITEBOARD_BOARD", () => $ca532a827038ae75$export$5b90ced7e51bcea0);
$parcel$export(module.exports, "CONTACT_ADMINISTRATOR", () => $ca532a827038ae75$export$7d8684a463b78f54);
$parcel$export(module.exports, "ADMIN_SETTINGS", () => $ca532a827038ae75$export$eb54044908e4e0bd);
$parcel$export(module.exports, "ADMIN_GLOBAL_AUTOMATION", () => $ca532a827038ae75$export$506a1a071415f2e);
$parcel$export(module.exports, "ADMIN_EDIT_EXTERNAL_SHARING", () => $ca532a827038ae75$export$4e4c6a9eb23f65ec);
$parcel$export(module.exports, "ADMIN_FORGE_APPS", () => $ca532a827038ae75$export$b17d28dbf200fde0);
$parcel$export(module.exports, "ADMIN_NEW_GLOBAL_PERMISSIONS", () => $ca532a827038ae75$export$5bfa1fef1b53dfdd);
$parcel$export(module.exports, "ADMIN_COMPANY_HUB_PERMISSIONS", () => $ca532a827038ae75$export$dd6de41f650dae89);
$parcel$export(module.exports, "ADMIN_COMPANY_HOME_BUILDER", () => $ca532a827038ae75$export$8c6393d6207d929);
$parcel$export(module.exports, "ADMIN_CUSTOMIZE_NAVIGATION", () => $ca532a827038ae75$export$9397e0d80cf06055);
$parcel$export(module.exports, "ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS", () => $ca532a827038ae75$export$f107e7a692a3a54e);
$parcel$export(module.exports, "ADMIN_SITE_SPACE_PERMISSIONS", () => $ca532a827038ae75$export$5bbec961de23dce7);
$parcel$export(module.exports, "ADMIN_AUDIT_LOG", () => $ca532a827038ae75$export$f0e8d063cba10e9c);
$parcel$export(module.exports, "ADMIN_BROWSE_SHORTCUTS", () => $ca532a827038ae75$export$3039840c47d9a13d);
$parcel$export(module.exports, "ADMIN_CREATE_SHORTCUT", () => $ca532a827038ae75$export$e1e5a41fa357e66f);
$parcel$export(module.exports, "ADMIN_REMOVE_SHORTCUT", () => $ca532a827038ae75$export$4fcc3f53642c593a);
$parcel$export(module.exports, "ADMIN_DARK_FEATURES", () => $ca532a827038ae75$export$7234e6926944adc0);
$parcel$export(module.exports, "ADMIN_ENABLE_DARK_FEATURE", () => $ca532a827038ae75$export$b86d7bd984fb9727);
$parcel$export(module.exports, "ADMIN_DISABLE_DARK_FEATURE", () => $ca532a827038ae75$export$1afd9317831e345e);
$parcel$export(module.exports, "ADMIN_BETA_FEATURES", () => $ca532a827038ae75$export$9e8d02f6bdb565e9);
$parcel$export(module.exports, "ADMIN_NEW_FEATURES", () => $ca532a827038ae75$export$f03a4adc711219ed);
$parcel$export(module.exports, "ADMIN_LIVE_EDIT", () => $ca532a827038ae75$export$af040d7344c912d1);
$parcel$export(module.exports, "SPACE_CALENDAR", () => $ca532a827038ae75$export$2925d036bbc38c7);
$parcel$export(module.exports, "SPACE_CALENDARS", () => $ca532a827038ae75$export$351b62e6f5786a73);
$parcel$export(module.exports, "SPACE_CALENDARS_SUBCALENDAR", () => $ca532a827038ae75$export$4a2048bb71da8b4b);
$parcel$export(module.exports, "SPACE_EMBEDDED_SUBCALENDAR", () => $ca532a827038ae75$export$7de5b687836953bd);
$parcel$export(module.exports, "DISCOVER", () => $ca532a827038ae75$export$27b2e48e28163360);
$parcel$export(module.exports, "ALL_UPDATES", () => $ca532a827038ae75$export$f178fb5b1e822288);
$parcel$export(module.exports, "POPULAR", () => $ca532a827038ae75$export$777796688df78f56);
$parcel$export(module.exports, "MY_WORK_HOME", () => $ca532a827038ae75$export$3907c7d8e57f70ba);
$parcel$export(module.exports, "MY_WORK_DRAFTS", () => $ca532a827038ae75$export$fe97ee265fd89939);
$parcel$export(module.exports, "MY_WORK_RECENT", () => $ca532a827038ae75$export$b71609db3dda2696);
$parcel$export(module.exports, "MY_RECENTLY_VISITED", () => $ca532a827038ae75$export$730392c243a0a367);
$parcel$export(module.exports, "MY_SAVED_FOR_LATER", () => $ca532a827038ae75$export$85bd3cea0cecb26c);
$parcel$export(module.exports, "RECENT_PAGES", () => $ca532a827038ae75$export$c8a37c9f76d4d03f);
$parcel$export(module.exports, "RECENT_VISITED", () => $ca532a827038ae75$export$771b75a6ca136f91);
$parcel$export(module.exports, "RECENT_DRAFTS", () => $ca532a827038ae75$export$8e4a8343b1614a02);
$parcel$export(module.exports, "RECENT_SAVED", () => $ca532a827038ae75$export$2c9cf254b3b24ff);
$parcel$export(module.exports, "TEMPLATE_MIGRATION_PREVIEW", () => $ca532a827038ae75$export$d925029e7ceadd51);
$parcel$export(module.exports, "EDIT_TEMPLATE", () => $ca532a827038ae75$export$e84c491e2d88d9f6);
$parcel$export(module.exports, "SITE_SETTINGS_EDIT_TEMPLATE_LEGACY", () => $ca532a827038ae75$export$4ce9d0d8218b9d84);
$parcel$export(module.exports, "EDIT_TEMPLATE_BLUEPRINT", () => $ca532a827038ae75$export$a990a60696f54618);
$parcel$export(module.exports, "EDIT_DEFAULT_BLUEPRINT_LEGACY", () => $ca532a827038ae75$export$f8d71dcb352ebe8c);
$parcel$export(module.exports, "SITE_SETTINGS_EDIT_SYSTEM_TEMPLATE_LEGACY", () => $ca532a827038ae75$export$b45af2e1d7abb289);
$parcel$export(module.exports, "EDIT_TEMPLATE_SPACE", () => $ca532a827038ae75$export$c0a209b0b0b16c75);
$parcel$export(module.exports, "CREATE_TEMPLATE", () => $ca532a827038ae75$export$dcee5dee04648c93);
$parcel$export(module.exports, "CREATE_TEMPLATE_SITE_LEGACY", () => $ca532a827038ae75$export$793ade69cc97583f);
$parcel$export(module.exports, "CREATE_TEMPLATE_SPACE_LEGACY", () => $ca532a827038ae75$export$499f432aa493cdd2);
$parcel$export(module.exports, "CREATE_TEMPLATE_SPACE", () => $ca532a827038ae75$export$dcda7f8b6fe54ba);
$parcel$export(module.exports, "HELLO_WORLD", () => $ca532a827038ae75$export$9e430f65574f5333);
$parcel$export(module.exports, "DASHBOARD_ACTION_LEGACY", () => $ca532a827038ae75$export$e9d78b13bbb4e56f);
$parcel$export(module.exports, "SPA_ACTION_LEGACY", () => $ca532a827038ae75$export$d7be6003270f6c2d);
$parcel$export(module.exports, "INDEX_ACTION_LEGACY", () => $ca532a827038ae75$export$b49467be269d2629);
$parcel$export(module.exports, "CREATE_PAGE_ACTION_LEGACY", () => $ca532a827038ae75$export$e52245e856f5c06);
$parcel$export(module.exports, "CREATE_BLOG_ACTION_LEGACY", () => $ca532a827038ae75$export$926e3916067d7530);
$parcel$export(module.exports, "CREATE_PAGE_VARIABLES_ACTION_LEGACY", () => $ca532a827038ae75$export$e720b1e170b46aae);
$parcel$export(module.exports, "RESUME_DRAFT_LEGACY", () => $ca532a827038ae75$export$6c7b95dcf08f3a6d);
$parcel$export(module.exports, "COPY_PAGE_LEGACY", () => $ca532a827038ae75$export$b010f02787df1e6);
$parcel$export(module.exports, "VIEW_PAGE_ACTION_LEGACY", () => $ca532a827038ae75$export$ecc28d15af39a8b2);
$parcel$export(module.exports, "SPACE_OVERVIEW_INDEX_ACTION_LEGACY", () => $ca532a827038ae75$export$482db086bc8c2289);
$parcel$export(module.exports, "SPACE_INDEX_ACTION_LEGACY", () => $ca532a827038ae75$export$3afea7266d0d139b);
$parcel$export(module.exports, "SPACE_PAGES", () => $ca532a827038ae75$export$4eb80c3a4e6fbe0f);
$parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", () => $ca532a827038ae75$export$bd2c9bb170b3681d);
$parcel$export(module.exports, "ACTION_REDIRECT_LEGACY", () => $ca532a827038ae75$export$5c9eaf42f32252ea);
$parcel$export(module.exports, "ADVANCED_SEARCH_LEGACY", () => $ca532a827038ae75$export$7ae0ea91a2dfc4d9);
$parcel$export(module.exports, "ADVANCED_SEARCH", () => $ca532a827038ae75$export$3bd4ec9f05d79904);
$parcel$export(module.exports, "LABELLED_CONTENT", () => $ca532a827038ae75$export$2bc30aa6642650c);
$parcel$export(module.exports, "EXTERNAL_SHARE", () => $ca532a827038ae75$export$d593e642a326a501);
$parcel$export(module.exports, "PDF_EXPORT_PAGE", () => $ca532a827038ae75$export$6490fab56523ceda);
$parcel$export(module.exports, "PDF_EXPORT_SPACE", () => $ca532a827038ae75$export$dcb1d1a9cda087b1);
$parcel$export(module.exports, "LEGACY_SPACE_PDF_EXPORT", () => $ca532a827038ae75$export$6b2db7909585abd7);
$parcel$export(module.exports, "EXPORT_SPACE_CSV", () => $ca532a827038ae75$export$2dd65cdecd8b05d7);
$parcel$export(module.exports, "EXPORT_SPACE_XML", () => $ca532a827038ae75$export$d78f611c1ddf7234);
$parcel$export(module.exports, "EXPORT_SPACE_HTML", () => $ca532a827038ae75$export$9dc7f7e5e1435bc);
$parcel$export(module.exports, "VIEW_PAGE_MOBILE", () => $ca532a827038ae75$export$1bc544543b946246);
$parcel$export(module.exports, "VIEW_BLOG_MOBILE", () => $ca532a827038ae75$export$d387bb8ca9ce25d1);
$parcel$export(module.exports, "PEOPLE_DIRECTORY_SEARCH", () => $ca532a827038ae75$export$f7bf92a6467c1557);
$parcel$export(module.exports, "CONFLUENCE_PEOPLE_DIRECTORY_SEARCH", () => $ca532a827038ae75$export$ed260c82a3e70a6a);
$parcel$export(module.exports, "MARKETPLACE_FIND_APPS", () => $ca532a827038ae75$export$a90430d7f36bfe9e);
$parcel$export(module.exports, "MARKETPLACE_APP_REQUESTS", () => $ca532a827038ae75$export$22bb05181a4b1501);
$parcel$export(module.exports, "MARKETPLACE_MANAGE_PROMOTIONS", () => $ca532a827038ae75$export$cb73aa9f5b7d1ea0);
$parcel$export(module.exports, "PEOPLE_DIRECTORY", () => $ca532a827038ae75$export$df78b182760b42f4);
$parcel$export(module.exports, "SPACE_RESTRICTED_PAGES", () => $ca532a827038ae75$export$2d3703cff5d9a27);
$parcel$export(module.exports, "SPACE_ARCHIVED_PAGES", () => $ca532a827038ae75$export$60773cf116cf5f30);
$parcel$export(module.exports, "PAGE_DIFF_BY_VERSION", () => $ca532a827038ae75$export$40e965fb568c3c83);
$parcel$export(module.exports, "SITE_ANALYTICS", () => $ca532a827038ae75$export$cb80c94a905e11b6);
$parcel$export(module.exports, "SITE_ANALYTICS_PERMISSIONS", () => $ca532a827038ae75$export$93b558a6e07dbdac);
$parcel$export(module.exports, "SPACE_ANALYTICS", () => $ca532a827038ae75$export$67acd8a63f03bc8);
$parcel$export(module.exports, "SPACE_ANALYTICS_PERMISSIONS", () => $ca532a827038ae75$export$6b9c632e635b4d77);
$parcel$export(module.exports, "PAGE_ANALYTICS", () => $ca532a827038ae75$export$37a588b556645c19);
$parcel$export(module.exports, "SPACE_QUESTIONS", () => $ca532a827038ae75$export$aded01fc53d469df);
$parcel$export(module.exports, "SPACE_QUESTIONS_NATIVE", () => $ca532a827038ae75$export$cdd412f0619f2d7e);
$parcel$export(module.exports, "SPACE_QUESTION_NATIVE", () => $ca532a827038ae75$export$aa72b945229db170);
$parcel$export(module.exports, "SPACE_CUSTOM_CONTENT_LIST", () => $ca532a827038ae75$export$f0c4a6dc3b3437aa);
$parcel$export(module.exports, "CUSTOM_CONTENT_VIEW", () => $ca532a827038ae75$export$1a5e481ee166ad7c);
$parcel$export(module.exports, "SPACE_BULK_TOOLS", () => $ca532a827038ae75$export$f39a30a3a5635bab);
$parcel$export(module.exports, "SPACE_SETTINGS_LANDING_PAGE", () => $ca532a827038ae75$export$3101773a7a844077);
$parcel$export(module.exports, "SPACE_SETTINGS_LANDING_PAGE_ALT", () => $ca532a827038ae75$export$f03524b1e395be4a);
$parcel$export(module.exports, "SPACE_SETTINGS_AUTOMATION", () => $ca532a827038ae75$export$38b94ff4631b44df);
$parcel$export(module.exports, "SPACE_SETTINGS_DETAILS", () => $ca532a827038ae75$export$5f63ad7e18293ec2);
$parcel$export(module.exports, "SPACE_SETTINGS_ARCHIVE_SPACE", () => $ca532a827038ae75$export$26dfba554adbf87e);
$parcel$export(module.exports, "SPACE_SETTINGS_TRASH_SPACE", () => $ca532a827038ae75$export$1b93424785e5f745);
$parcel$export(module.exports, "SPACE_SETTINGS_EDITOR_CONVERSION", () => $ca532a827038ae75$export$2cc9af506d64ef72);
$parcel$export(module.exports, "SPACE_SETTINGS_RELATED_PAGES", () => $ca532a827038ae75$export$693d9b367ae8d0f7);
$parcel$export(module.exports, "SPACE_SETTINGS_EDIT_FEATURES", () => $ca532a827038ae75$export$22f8e464aee70413);
$parcel$export(module.exports, "SPACE_SETTINGS_TEMPLATES", () => $ca532a827038ae75$export$345aea7dc51bac8a);
$parcel$export(module.exports, "SPACE_SETTINGS_EDIT_TEMPLATE_LEGACY", () => $ca532a827038ae75$export$499a561f6d1a011);
$parcel$export(module.exports, "SPACE_LOOK_AND_FEEL_SETTINGS", () => $ca532a827038ae75$export$4f46a1e4250ebe18);
$parcel$export(module.exports, "SPACE_PERMISSIONS_SETTINGS", () => $ca532a827038ae75$export$e64d4514fc584fbe);
$parcel$export(module.exports, "SPACE_PERMISSIONS_APPS", () => $ca532a827038ae75$export$2f6a532274e0cd9d);
$parcel$export(module.exports, "EDIT_SPACE_PERMISSIONS_APPS", () => $ca532a827038ae75$export$a007a4f7553ffc16);
$parcel$export(module.exports, "SPACE_MEMBERS", () => $ca532a827038ae75$export$629e966630a1f92e);
$parcel$export(module.exports, "SPACE_FORGE_APPS", () => $ca532a827038ae75$export$f0e860396acf6277);
$parcel$export(module.exports, "GLOBAL_PAGE_FORGE", () => $ca532a827038ae75$export$4442c9c7bb716896);
$parcel$export(module.exports, "SPACE_SETTINGS_FORGE_APPS", () => $ca532a827038ae75$export$ffd880217e61385f);
$parcel$export(module.exports, "SPACE_SETTINGS_AVATARS_AND_STATUS", () => $ca532a827038ae75$export$8bf619366f9e74f2);
$parcel$export(module.exports, "SPACE_SETTINGS_CONTENT_STATE", () => $ca532a827038ae75$export$a85b9c60514cd043);
$parcel$export(module.exports, "SPACE_SETTINGS_DATA_CLASSIFICATION", () => $ca532a827038ae75$export$19b893a9e64dac94);
$parcel$export(module.exports, "SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE", () => $ca532a827038ae75$export$939b28e9f8987d97);
$parcel$export(module.exports, "SPACE_SETTINGS_EXPORT", () => $ca532a827038ae75$export$3582accdd821993a);
$parcel$export(module.exports, "SPACE_SETTINGS_EXPORT_SPACE", () => $ca532a827038ae75$export$b8adcf19ff927cec);
$parcel$export(module.exports, "SPACE_TRASH", () => $ca532a827038ae75$export$751ae19fa150b7c);
$parcel$export(module.exports, "MOBILE_TAKEOVER_PAGE", () => $ca532a827038ae75$export$526ccce5d32f7beb);
$parcel$export(module.exports, "DEFAULT_ADMIN_MANAGE_APPS", () => $ca532a827038ae75$export$ed19a29c446e24d8);
$parcel$export(module.exports, "ADMIN_APP_AUDIT_LOGS", () => $ca532a827038ae75$export$7de52f6cc232129e);
$parcel$export(module.exports, "SPACE_SETTINGS_TEMPLATE_LIST_PAGE_LEGACY", () => $ca532a827038ae75$export$81cfd93b1b89cd07);
$parcel$export(module.exports, "ADMIN_TEMPLATES_AND_BLUEPRINTS", () => $ca532a827038ae75$export$31745f3bff21cd);
$parcel$export(module.exports, "ADMIN_APPLICATION_NAVIGATOR", () => $ca532a827038ae75$export$7af7a1e753a92264);
$parcel$export(module.exports, "CUSTOM_CONTENTS_ON_PAGE_LIST", () => $ca532a827038ae75$export$28e7e683f23a58d3);
$parcel$export(module.exports, "ADMIN_ANNOUNCEMENT_BANNER_RENDERER", () => $ca532a827038ae75$export$3ce513606c31c918);
$parcel$export(module.exports, "USER_ACCESS", () => $ca532a827038ae75$export$dfa725d05e18145e);
$parcel$export(module.exports, "SPACE_MANAGER", () => $ca532a827038ae75$export$4d1bccc78b263a8e);
$parcel$export(module.exports, "ADMIN_CENTER", () => $ca532a827038ae75$export$df327d9b56ca6b7c);
$parcel$export(module.exports, "ADMIN_CENTER_SPACE", () => $ca532a827038ae75$export$53f195d79ef3d4dd);
$parcel$export(module.exports, "ADMIN_TEAM_CALENDARS", () => $ca532a827038ae75$export$23e7002e5e9ef89e);
$parcel$export(module.exports, "ADMIN_CONFIGURATION", () => $ca532a827038ae75$export$299af9061dea1f09);
$parcel$export(module.exports, "ADMIN_DEFAULT_SPACE_LOGO", () => $ca532a827038ae75$export$eb5a785192323bd3);
$parcel$export(module.exports, "ADMIN_HEADER_AND_FOOTER", () => $ca532a827038ae75$export$168f3acd059931e0);
$parcel$export(module.exports, "ADMIN_SECURITY_CONFIGURATION", () => $ca532a827038ae75$export$3bcebf4f1e82d3ad);
$parcel$export(module.exports, "ADMIN_SPACE_REPORTS", () => $ca532a827038ae75$export$42599f111394c36c);
$parcel$export(module.exports, "ADMIN_COLOR_SCHEME", () => $ca532a827038ae75$export$e05db3c2f69bd3ae);
$parcel$export(module.exports, "ADMIN_CODE_MACRO_CONFIGURATION", () => $ca532a827038ae75$export$4c6bf75100b3b72);
$parcel$export(module.exports, "ADMIN_TRASHED_SPACES", () => $ca532a827038ae75$export$70914a626e2f0488);
$parcel$export(module.exports, "ADMIN_IMPORT_SPACES", () => $ca532a827038ae75$export$3d0698fcdc33631d);
$parcel$export(module.exports, "ADMIN_JIRA_MACRO_REPAIR", () => $ca532a827038ae75$export$85c61af9d225a707);
$parcel$export(module.exports, "ADMIN_MACRO_USAGE", () => $ca532a827038ae75$export$c0d0d3f98d45e5f1);
$parcel$export(module.exports, "ADMIN_MACRO_USAGE_LEGACY", () => $ca532a827038ae75$export$69df75bd8c217ade);
$parcel$export(module.exports, "ADMIN_THEMES", () => $ca532a827038ae75$export$e8beba40e140a443);
$parcel$export(module.exports, "ADMIN_PDF_EXPORT", () => $ca532a827038ae75$export$c471be73599ccae1);
$parcel$export(module.exports, "ADMIN_WORKFLOWS", () => $ca532a827038ae75$export$f9c5de90a82d0d1e);
$parcel$export(module.exports, "DATABASE_CUSTOM_OVERVIEW", () => $ca532a827038ae75$export$9859a7a7049d0585);
$parcel$export(module.exports, "DATABASE_CUSTOM_VIEW", () => $ca532a827038ae75$export$90480461935b54cc);
$parcel$export(module.exports, "DATABASE_VIEW", () => $ca532a827038ae75$export$851ba2be5095d586);
$parcel$export(module.exports, "EMBED_VIEW", () => $ca532a827038ae75$export$84b5e15197aaaa12);
$parcel$export(module.exports, "FOLDER_VIEW", () => $ca532a827038ae75$export$4dcf771d1a1901ef);
$parcel$export(module.exports, "ADMIN_BULK_PERMISSIONS", () => $ca532a827038ae75$export$752c480a913a6712);
$parcel$export(module.exports, "ADMIN_NOTIFICATIONS", () => $ca532a827038ae75$export$16172a64bcdb79f8);
$parcel$export(module.exports, "TOPICS", () => $ca532a827038ae75$export$59a52cdd0906f4cb);
$parcel$export(module.exports, "WORKFLOWS", () => $ca532a827038ae75$export$c4e8a8651a3f7aed);
$parcel$export(module.exports, "SMART_CREATE_PROMPT", () => $ca532a827038ae75$export$ade28a8f0ba1efba);
/* eslint-disable prefer-template */ 
var $fMEnQ = parcelRequire("fMEnQ");

var $jlIaF = parcelRequire("jlIaF");

var $bqMNb = parcelRequire("bqMNb");
// Please do NOT remove /*@__PURE__*/ in this file.
// These comments hints Terser (webpack's minifier) to remove the definition if they are not used.
//
// Please do NOT change string concatenation to string interpolation.
// String interpolations are compiled to "".concat("").concat("") because even the latest edge don't support them natively.
// This made minifier give up removing the dead code because it can't ensure the function call won't have side effects.
//
// Please keep these optimizations here and follow the existing one if you need to add new ones.
const $ca532a827038ae75$var$contentTransition = (prev, curr)=>prev.params.contentId !== curr.params.contentId;
const $ca532a827038ae75$var$spaceTransition = (prev, curr)=>prev.params.spaceKey !== curr.params.spaceKey;
const $ca532a827038ae75$export$9e15ff8aa6bc996f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'BASE',
    pattern: '/'
});
const $ca532a827038ae75$export$2fd309376969662f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'WIKI',
    pattern: (0, $jlIaF.CONTEXT_PATH)
});
const $ca532a827038ae75$export$a7c5707626fc90f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'HOME',
    ufoName: 'confluence-home',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/home/:view?',
    bifrost: {
        bundling: {
            packageName: 'HomeRoute',
            whichExportToUse: 'HomeRoute'
        },
        enabled: true,
        indexHtml: 'error-app.html'
    }
});
const $ca532a827038ae75$export$6ccd7dc0d5aa30b0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'TEMPLATE_GALLERY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/templates'
});
const $ca532a827038ae75$export$7d65e474be175151 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CALENDAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/calendar/mycalendar.action'
});
const $ca532a827038ae75$export$ec8a7da990877da3 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MY_CALENDAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/mycalendar'
});
const $ca532a827038ae75$export$aa473411bddb7e17 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'QUESTIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/plugins/servlet/ac/com.atlassian.confluence.plugins.confluence-questions/globalQuestionsViewer\\?ac.com.atlassian.confluence.plugins.confluence-questions.pattern=/questions/ask'
});
const $ca532a827038ae75$export$42bb8ba9cae96927 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'QUESTIONS_NATIVE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/questions'
});
const $ca532a827038ae75$export$1e92de3a3dba0876 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'QUESTION_NATIVE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/questions/:spaceKey/:questionId'
});
const $ca532a827038ae75$export$6a85914fb9ca80a2 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CONTENT_HISTORY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/history/:contentId(\\d+)/:contentSlug?'
});
const $ca532a827038ae75$export$1f238fcead086ec3 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CONTENT_HISTORY_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/viewpreviousversions.action'
});
const $ca532a827038ae75$export$b74c113024023274 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_PAGE',
    ufoName: 'edit-page',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(pages)/edit/:contentId(\\d+)'
});
const $ca532a827038ae75$export$45222bf0cb32d6e2 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_BLOG',
    ufoName: 'edit-page',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(blog)/edit/:contentId(\\d+)'
});
const $ca532a827038ae75$export$7b1285e36c635f1f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_PAGE_V2',
    ufoName: 'edit-page',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(pages)/edit-v2/:contentId(\\d+)',
    isTransition: $ca532a827038ae75$var$contentTransition
});
const $ca532a827038ae75$export$36dcea4e08feb5c9 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_BLOG_V2',
    ufoName: 'edit-page',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(blog)/edit-v2/:contentId(\\d+)',
    isTransition: $ca532a827038ae75$var$contentTransition
});
const $ca532a827038ae75$export$e63a462ee45b57cf = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_PAGE_EMBED',
    ufoName: 'edit-page-embed',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(pages)/edit-embed/:contentId(\\d+)'
});
const $ca532a827038ae75$export$54edf7c16c47aeef = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_CONTENT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/create-content/:contentType'
});
const $ca532a827038ae75$export$d6ae9e544e98926f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(pages)/create'
});
const $ca532a827038ae75$export$e8253e1b7e500d1c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_BLOG',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(blog)/create'
});
const $ca532a827038ae75$export$9a4ff2d809fc4156 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DELETE_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/removepage.action\\?pageId=:contentId(\\d+)'
});
const $ca532a827038ae75$export$19c176cd0a878008 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ONBOARDING',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/welcome'
});
const $ca532a827038ae75$export$439074745692fe65 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_DIRECTORY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces'
});
const $ca532a827038ae75$export$2de9a69f9b51bb83 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/viewspacesummary.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$10f0439b47c8fdaf = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_REORDERPAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/reorderpages.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$d0ac6fa12f3acafa = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_HIDDEN_PAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/listorphanedpages.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$35123576da2e521 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_UNDEFINED_PAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/listundefinedpages.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$e18ccd8ffafdf3dd = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_ATTACHMENTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/listattachmentsforspace.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$9c4e8cdcbbacdf8f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_APPLICATION_LINKS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + 'spaces/listentitylinks.action'
});
const $ca532a827038ae75$export$f85f59869a8dbbf8 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_RSS_FEEDS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + 'spaces/listrssfeeds.action'
});
const $ca532a827038ae75$export$d87089dbdd7eeaf3 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_OVERVIEW_REDIRECT_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/viewspace.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$dd174db99b3e6fea = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DELETE_SPACE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/doremovespace.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$ef26ce515f06bc5e = Object.assign(/*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_INDEX',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey',
    /**
   * /spaces/:spaceKey will incorrectly match /spaces/something.action.
   * In that case the request should be sent to Monolith.
   */ condition: ({ params: params })=>Boolean(params.spaceKey && !params.spaceKey.endsWith('.action')),
    isTransition: $ca532a827038ae75$var$spaceTransition
}), {
    /**
   * Used for optimization purposes. See SPACE_OVERVIEW for more detail.
   */ HOMEPAGE_ID_QUERY_KEY: 'homepageId'
});
const $ca532a827038ae75$export$65b723bb995d4fb6 = Object.assign(/*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_OVERVIEW',
    ufoName: 'space-overview',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/overview',
    isTransition: $ca532a827038ae75$var$spaceTransition
}), {
    /**
   * The key/name of the optional space overview URL query parameter which was
   * introduced for optimization purposes only and is used by
   * `@confluence/query-preloaders` to preload space
   * homepage-related queries.
   */ HOMEPAGE_ID_QUERY_KEY: 'homepageId'
});
const $ca532a827038ae75$export$ada7925da580b561 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'COMPANY_HUB',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/company-hub'
});
const $ca532a827038ae75$export$29df24b01e938adf = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'COMPANY_HUB_ANALYTICS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/company-hub/analytics'
});
const $ca532a827038ae75$export$e003e97fab6b4368 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'COMPANY_HUB_EDIT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/company-hub/edit'
});
const $ca532a827038ae75$export$5f7be6e90830de0c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'COMPANY_HUB_SETTINGS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/company-hub/settings/:tab(general)?'
});
const $ca532a827038ae75$export$9257b5b55c8e2555 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'VIEW_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?',
    isTransition: (previousMatch, currentMatch)=>(0, $bqMNb.isForceTransition)(previousMatch, currentMatch) || $ca532a827038ae75$var$contentTransition(previousMatch, currentMatch)
});
const $ca532a827038ae75$export$475fdaba8e6145bb = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'NEXT_VIEW_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/next-pages/:contentId(\\d+)/:contentSlug?',
    isTransition: $ca532a827038ae75$var$contentTransition
});
const $ca532a827038ae75$export$347d3b5edaae00e0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'BLOG_HOME',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/blog'
});
const $ca532a827038ae75$export$91f49e7b30a9d34 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'VIEW_BLOG',
    ufoName: 'blog',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/blog/:contentId(\\d+)/:contentSlug?',
    isTransition: $ca532a827038ae75$var$contentTransition
});
const $ca532a827038ae75$export$ac51957e7110425e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_JIRA_PROJECT_BOARD',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/jira-project-board'
});
const $ca532a827038ae75$export$c259921a01da55b4 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'WHITEBOARD_HOME',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/whiteboard'
});
const $ca532a827038ae75$export$5b90ced7e51bcea0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'WHITEBOARD_BOARD',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/whiteboard/:contentId'
});
const $ca532a827038ae75$export$7d8684a463b78f54 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CONTACT_ADMINISTRATOR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/contact-administrators'
});
const $ca532a827038ae75$export$eb54044908e4e0bd = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_SETTINGS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin'
});
const $ca532a827038ae75$export$506a1a071415f2e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_GLOBAL_AUTOMATION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/automation'
});
const $ca532a827038ae75$export$4e4c6a9eb23f65ec = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_EDIT_EXTERNAL_SHARING',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/public-links'
});
const $ca532a827038ae75$export$b17d28dbf200fde0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_FORGE_APPS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/forge\\?id=:id(.+)'
});
const $ca532a827038ae75$export$5bfa1fef1b53dfdd = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_NEW_GLOBAL_PERMISSIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/permissions/global'
});
const $ca532a827038ae75$export$dd6de41f650dae89 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_COMPANY_HUB_PERMISSIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/permissions/hub/:tab(groups|users|guests)?'
});
const $ca532a827038ae75$export$8c6393d6207d929 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_COMPANY_HOME_BUILDER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/look-and-feel/company-home-builder'
});
const $ca532a827038ae75$export$9397e0d80cf06055 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_CUSTOMIZE_NAVIGATION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/look-and-feel/customize-navigation'
});
const $ca532a827038ae75$export$f107e7a692a3a54e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/permissions/global/user/:accountId'
});
const $ca532a827038ae75$export$5bbec961de23dce7 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_SITE_SPACE_PERMISSIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/permissions/space-permissions/:tab(defaults|allspaces|roles)?'
});
const $ca532a827038ae75$export$f0e8d063cba10e9c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_AUDIT_LOG',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/auditlogging.action'
});
const $ca532a827038ae75$export$3039840c47d9a13d = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_BROWSE_SHORTCUTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/browseshortcuts.action'
});
const $ca532a827038ae75$export$e1e5a41fa357e66f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_CREATE_SHORTCUT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/createshortcut.action'
});
const $ca532a827038ae75$export$4fcc3f53642c593a = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_REMOVE_SHORTCUT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/removeshortcut.action'
});
const $ca532a827038ae75$export$7234e6926944adc0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_DARK_FEATURES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/darkfeatures.action'
});
const $ca532a827038ae75$export$b86d7bd984fb9727 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_ENABLE_DARK_FEATURE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/enabledarkfeature.action'
});
const $ca532a827038ae75$export$1afd9317831e345e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_DISABLE_DARK_FEATURE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/disabledarkfeature.action'
});
const $ca532a827038ae75$export$9e8d02f6bdb565e9 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_BETA_FEATURES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/betafeatures'
});
const $ca532a827038ae75$export$f03a4adc711219ed = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_NEW_FEATURES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/newfeatures'
});
const $ca532a827038ae75$export$af040d7344c912d1 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_LIVE_EDIT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/liveedit'
});
const $ca532a827038ae75$export$2925d036bbc38c7 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_CALENDAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/calendars\\?src=sidebar&openAddCalDialog=true'
});
const $ca532a827038ae75$export$351b62e6f5786a73 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_CALENDARS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/calendars'
});
const $ca532a827038ae75$export$4a2048bb71da8b4b = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_CALENDARS_SUBCALENDAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/calendars/:subCalendarId'
});
const $ca532a827038ae75$export$7de5b687836953bd = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_EMBEDDED_SUBCALENDAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/embedded/calendars/:subCalendarId'
});
const $ca532a827038ae75$export$27b2e48e28163360 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DISCOVER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/discover'
});
const $ca532a827038ae75$export$f178fb5b1e822288 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ALL_UPDATES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/discover/all-updates'
});
const $ca532a827038ae75$export$777796688df78f56 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'POPULAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/discover/popular'
});
const $ca532a827038ae75$export$3907c7d8e57f70ba = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MY_WORK_HOME',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/my'
});
const $ca532a827038ae75$export$fe97ee265fd89939 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MY_WORK_DRAFTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/my/drafts'
});
const $ca532a827038ae75$export$b71609db3dda2696 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MY_WORK_RECENT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/my/recent-work'
});
const $ca532a827038ae75$export$730392c243a0a367 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MY_RECENTLY_VISITED',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/my/recently-visited'
});
const $ca532a827038ae75$export$85bd3cea0cecb26c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MY_SAVED_FOR_LATER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/my/saved-for-later'
});
const $ca532a827038ae75$export$c8a37c9f76d4d03f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'RECENT_PAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/recent'
});
const $ca532a827038ae75$export$771b75a6ca136f91 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'RECENT_VISITED',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/recent/visited'
});
const $ca532a827038ae75$export$8e4a8343b1614a02 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'RECENT_DRAFTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/recent/draft'
});
const $ca532a827038ae75$export$2c9cf254b3b24ff = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'RECENT_SAVED',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/recent/saved'
});
const $ca532a827038ae75$export$d925029e7ceadd51 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'TEMPLATE_MIGRATION_PREVIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/template/migration/preview\\?templateId=:contentId([0-9a-z-]+)'
});
const $ca532a827038ae75$export$e84c491e2d88d9f6 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_TEMPLATE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/templates/edit/:contentId([0-9a-z-]+)'
});
const $ca532a827038ae75$export$4ce9d0d8218b9d84 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SITE_SETTINGS_EDIT_TEMPLATE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/templates2/editpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.entityId && Object.keys(query).length === 1)
});
const $ca532a827038ae75$export$a990a60696f54618 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_TEMPLATE_BLUEPRINT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/templates/edit/:pluginKey/:moduleKey'
});
const $ca532a827038ae75$export$f8d71dcb352ebe8c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_DEFAULT_BLUEPRINT_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/plugins/createcontent/edit-template.action',
    condition: ({ query: query })=>Boolean(query.key && query.contentTemplateRefId && Object.keys(query).length === 2) || Boolean(query.contentTemplateRefId && Object.keys(query).length === 1)
});
const $ca532a827038ae75$export$b45af2e1d7abb289 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SITE_SETTINGS_EDIT_SYSTEM_TEMPLATE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/plugins/createcontent/edit-template.action',
    condition: ({ query: query })=>Boolean(query.pluginKey && query.moduleKey && Object.keys(query).length === 2)
});
const $ca532a827038ae75$export$c0a209b0b0b16c75 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_TEMPLATE_SPACE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/templates/edit/:contentId([0-9a-z-]+)'
});
const $ca532a827038ae75$export$dcee5dee04648c93 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_TEMPLATE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/templates/create'
});
const $ca532a827038ae75$export$793ade69cc97583f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_TEMPLATE_SITE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/templates2/createpagetemplate.action'
});
const $ca532a827038ae75$export$499f432aa493cdd2 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_TEMPLATE_SPACE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/templates2/createpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.key && Object.keys(query).length === 1)
});
const $ca532a827038ae75$export$dcda7f8b6fe54ba = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_TEMPLATE_SPACE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/templates/create'
});
const $ca532a827038ae75$export$9e430f65574f5333 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'HELLO_WORLD',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/hello-world'
});
const $ca532a827038ae75$export$e9d78b13bbb4e56f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DASHBOARD_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/dashboard.action'
});
const $ca532a827038ae75$export$d7be6003270f6c2d = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPA_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spa.action'
});
const $ca532a827038ae75$export$b49467be269d2629 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'INDEX_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/index.action'
});
const $ca532a827038ae75$export$e52245e856f5c06 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_PAGE_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/createpage.action'
});
const $ca532a827038ae75$export$926e3916067d7530 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_BLOG_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/createblogpost.action'
});
const $ca532a827038ae75$export$e720b1e170b46aae = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_PAGE_VARIABLES_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/createpage-entervariables.action'
});
const $ca532a827038ae75$export$6c7b95dcf08f3a6d = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'RESUME_DRAFT_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/resumedraft.action'
});
const $ca532a827038ae75$export$b010f02787df1e6 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'COPY_PAGE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/copypage.action'
});
const $ca532a827038ae75$export$ecc28d15af39a8b2 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'VIEW_PAGE_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/viewpage.action',
    // viewpage.action should be served from Monolith when it has pageVersion query
    condition: ({ query: query })=>Boolean(query.pageId && Object.keys(query).length === 1)
});
const $ca532a827038ae75$export$482db086bc8c2289 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_OVERVIEW_INDEX_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/overview/index.action'
});
const $ca532a827038ae75$export$3afea7266d0d139b = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_INDEX_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/index.action'
});
const $ca532a827038ae75$export$4eb80c3a4e6fbe0f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_PAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/pages'
});
const $ca532a827038ae75$export$bd2c9bb170b3681d = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'VIEW_BLOG_DATE_LEGACY',
    ufoName: 'blog',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?',
    isTransition: $ca532a827038ae75$var$contentTransition
});
const $ca532a827038ae75$export$5c9eaf42f32252ea = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ACTION_REDIRECT_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/(.*).action',
    condition: ({ query: query })=>query.key == null
});
const $ca532a827038ae75$export$7ae0ea91a2dfc4d9 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADVANCED_SEARCH_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/dosearchsite.action'
});
const $ca532a827038ae75$export$3bd4ec9f05d79904 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADVANCED_SEARCH',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/search'
});
const $ca532a827038ae75$export$2bc30aa6642650c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'LABELLED_CONTENT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/label/:spaceKey/:labelName(.+)'
});
const $ca532a827038ae75$export$d593e642a326a501 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EXTERNAL_SHARE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/external/:contentId?/:externalToken'
});
const $ca532a827038ae75$export$6490fab56523ceda = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PDF_EXPORT_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pdf/spaces/:spaceKey/pages/:contentId(\\d+)'
});
const $ca532a827038ae75$export$dcb1d1a9cda087b1 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PDF_EXPORT_SPACE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pdf/spaces/:spaceKey/pages/overview'
});
const $ca532a827038ae75$export$6b2db7909585abd7 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'LEGACY_SPACE_PDF_EXPORT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/flyingpdf/flyingpdf.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$2dd65cdecd8b05d7 = new (0, $fMEnQ.Route)({
    name: 'EXPORT_SPACE_CSV',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/exportspacecsv.action\\?key=:spaceKey'
});
const $ca532a827038ae75$export$d78f611c1ddf7234 = new (0, $fMEnQ.Route)({
    name: 'EXPORT_SPACE_XML',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/exportspacexml.action\\?key=:spaceKey'
});
const $ca532a827038ae75$export$9dc7f7e5e1435bc = new (0, $fMEnQ.Route)({
    name: 'EXPORT_SPACE_HTML',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/exportspacehtml.action\\?key=:spaceKey'
});
const $ca532a827038ae75$export$1bc544543b946246 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'VIEW_PAGE_MOBILE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/mobile/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?'
});
const $ca532a827038ae75$export$d387bb8ca9ce25d1 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'VIEW_BLOG_MOBILE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/mobile/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?'
});
const $ca532a827038ae75$export$f7bf92a6467c1557 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PEOPLE_DIRECTORY_SEARCH',
    pattern: '/people/search'
});
const $ca532a827038ae75$export$ed260c82a3e70a6a = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CONFLUENCE_PEOPLE_DIRECTORY_SEARCH',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/people/search'
});
const $ca532a827038ae75$export$a90430d7f36bfe9e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MARKETPLACE_FIND_APPS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/marketplace(.*)'
});
const $ca532a827038ae75$export$22bb05181a4b1501 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MARKETPLACE_APP_REQUESTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/marketplace/manage/app-requests'
});
const $ca532a827038ae75$export$cb73aa9f5b7d1ea0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MARKETPLACE_MANAGE_PROMOTIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/marketplace/manage/promotions'
});
const $ca532a827038ae75$export$df78b182760b42f4 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PEOPLE_DIRECTORY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/people/([\\w:-]+)*'
});
const $ca532a827038ae75$export$2d3703cff5d9a27 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_RESTRICTED_PAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/listpermissionpages.action'
});
const $ca532a827038ae75$export$60773cf116cf5f30 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_ARCHIVED_PAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/archivedpages'
});
const $ca532a827038ae75$export$40e965fb568c3c83 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PAGE_DIFF_BY_VERSION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/diffpagesbyversion.action'
});
const $ca532a827038ae75$export$cb80c94a905e11b6 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SITE_ANALYTICS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/analytics/:tab(overview|spaces|users|search)?'
});
const $ca532a827038ae75$export$93b558a6e07dbdac = new (0, $fMEnQ.Route)({
    name: 'SITE_ANALYTICS_PERMISSIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/analytics/permissions'
});
const $ca532a827038ae75$export$67acd8a63f03bc8 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_ANALYTICS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/analytics/:tab(overview|content|users)?'
});
const $ca532a827038ae75$export$6b9c632e635b4d77 = new (0, $fMEnQ.Route)({
    name: 'SPACE_ANALYTICS_PERMISSIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/analytics/permissions'
});
const $ca532a827038ae75$export$37a588b556645c19 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PAGE_ANALYTICS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/analytics/:contentId(\\d+)/:tab(overview|mentions|links)?'
});
const $ca532a827038ae75$export$aded01fc53d469df = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_QUESTIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/display/:spaceKey/customcontent/list/ac%3Acom.atlassian.confluence.plugins.confluence-questions%3Aquestion'
});
const $ca532a827038ae75$export$cdd412f0619f2d7e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_QUESTIONS_NATIVE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/questions'
});
const $ca532a827038ae75$export$aa72b945229db170 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_QUESTION_NATIVE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/questions/:questionId'
});
const $ca532a827038ae75$export$f0c4a6dc3b3437aa = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_CUSTOM_CONTENT_LIST',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/display/:spaceKey/customcontent/list/:type'
});
const $ca532a827038ae75$export$1a5e481ee166ad7c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CUSTOM_CONTENT_VIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/display/:spaceKey/customcontent/:contentId(\\d+)'
});
const $ca532a827038ae75$export$f39a30a3a5635bab = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_BULK_TOOLS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/bulktools'
});
const $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH = (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/settings';
const $ca532a827038ae75$export$3101773a7a844077 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_LANDING_PAGE',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/home'
});
const $ca532a827038ae75$export$f03524b1e395be4a = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_LANDING_PAGE_ALT',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH
});
const $ca532a827038ae75$export$38b94ff4631b44df = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_AUTOMATION',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/automation'
});
const $ca532a827038ae75$export$5f63ad7e18293ec2 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_DETAILS',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/details'
});
const $ca532a827038ae75$export$26dfba554adbf87e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_ARCHIVE_SPACE',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/archiveSpace'
});
const $ca532a827038ae75$export$1b93424785e5f745 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_TRASH_SPACE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/removespace.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$2cc9af506d64ef72 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_EDITOR_CONVERSION',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/editorConversion'
});
const $ca532a827038ae75$export$693d9b367ae8d0f7 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_RELATED_PAGES',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/relatedPages'
});
const $ca532a827038ae75$export$22f8e464aee70413 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_EDIT_FEATURES',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/editFeatures'
});
const $ca532a827038ae75$export$345aea7dc51bac8a = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_TEMPLATES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/settings/look-and-feel/templates'
});
const $ca532a827038ae75$export$499a561f6d1a011 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_EDIT_TEMPLATE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/templates2/editpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.entityId && query.key && Object.keys(query).length === 2)
});
const $ca532a827038ae75$export$4f46a1e4250ebe18 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_LOOK_AND_FEEL_SETTINGS',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/look-and-feel/:tab(themes|templates|page-layout|pdf-export)'
});
const $ca532a827038ae75$export$e64d4514fc584fbe = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_PERMISSIONS_SETTINGS',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/permissions/:tab(groups|users|guests|anonymous|public-links|analytics)?'
});
const $ca532a827038ae75$export$2f6a532274e0cd9d = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_PERMISSIONS_APPS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/addonpermissions.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$a007a4f7553ffc16 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_SPACE_PERMISSIONS_APPS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/editaddonpermissions.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$629e966630a1f92e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_MEMBERS',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/members'
});
const $ca532a827038ae75$export$f0e860396acf6277 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_FORGE_APPS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)/:appRoutePath*'
});
const $ca532a827038ae75$export$4442c9c7bb716896 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'GLOBAL_PAGE_FORGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)/:appRoutePath*'
});
const $ca532a827038ae75$export$ffd880217e61385f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_FORGE_APPS',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)?/:appRoutePath*'
});
const $ca532a827038ae75$export$8bf619366f9e74f2 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_AVATARS_AND_STATUS',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/avatarsAndStatus'
});
const $ca532a827038ae75$export$a85b9c60514cd043 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_CONTENT_STATE',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/contentStatuses'
});
const $ca532a827038ae75$export$19b893a9e64dac94 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_DATA_CLASSIFICATION',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/classifications'
});
const $ca532a827038ae75$export$939b28e9f8987d97 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/exportSpaceUnavailable'
});
const $ca532a827038ae75$export$3582accdd821993a = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_EXPORT',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/export'
});
const $ca532a827038ae75$export$b8adcf19ff927cec = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_EXPORT_SPACE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/exportspacewelcome.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$751ae19fa150b7c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_TRASH',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/viewtrash.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$526ccce5d32f7beb = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MOBILE_TAKEOVER_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/mobileapp'
});
const $ca532a827038ae75$export$ed19a29c446e24d8 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DEFAULT_ADMIN_MANAGE_APPS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/plugins/servlet/upm'
});
const $ca532a827038ae75$export$7de52f6cc232129e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_APP_AUDIT_LOGS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/plugins/servlet/upm/log'
});
const $ca532a827038ae75$export$81cfd93b1b89cd07 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_TEMPLATE_LIST_PAGE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/templates2/listpagetemplates.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$31745f3bff21cd = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_TEMPLATES_AND_BLUEPRINTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/templates-and-blueprints'
});
const $ca532a827038ae75$export$7af7a1e753a92264 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_APPLICATION_NAVIGATOR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/application-navigator'
});
const $ca532a827038ae75$export$28e7e683f23a58d3 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CUSTOM_CONTENTS_ON_PAGE_LIST',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/display/:spaceKey/pages/:contentId(\\d+)/customcontents/:type?'
});
const $ca532a827038ae75$export$3ce513606c31c918 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_ANNOUNCEMENT_BANNER_RENDERER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/announcements/:id(.*)?'
});
const $ca532a827038ae75$export$dfa725d05e18145e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'USER_ACCESS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/user-access'
});
const $ca532a827038ae75$export$4d1bccc78b263a8e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_MANAGER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/space-manager'
});
const $ca532a827038ae75$export$df327d9b56ca6b7c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_CENTER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/center'
});
const $ca532a827038ae75$export$53f195d79ef3d4dd = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_CENTER_SPACE',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/mission-control'
});
const $ca532a827038ae75$export$23e7002e5e9ef89e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_TEAM_CALENDARS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/teamcalendars'
});
const $ca532a827038ae75$export$299af9061dea1f09 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_CONFIGURATION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/configuration'
});
const $ca532a827038ae75$export$eb5a785192323bd3 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_DEFAULT_SPACE_LOGO',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/default-space-logo'
});
const $ca532a827038ae75$export$168f3acd059931e0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_HEADER_AND_FOOTER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/header-and-footer'
});
const $ca532a827038ae75$export$3bcebf4f1e82d3ad = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_SECURITY_CONFIGURATION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/security-configuration'
});
const $ca532a827038ae75$export$42599f111394c36c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_SPACE_REPORTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/space-reports'
});
const $ca532a827038ae75$export$e05db3c2f69bd3ae = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_COLOR_SCHEME',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/color-scheme'
});
const $ca532a827038ae75$export$4c6bf75100b3b72 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_CODE_MACRO_CONFIGURATION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/code-macro-configuration'
});
const $ca532a827038ae75$export$70914a626e2f0488 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_TRASHED_SPACES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/trashed-spaces'
});
const $ca532a827038ae75$export$3d0698fcdc33631d = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_IMPORT_SPACES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/space-import'
});
const $ca532a827038ae75$export$85c61af9d225a707 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_JIRA_MACRO_REPAIR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/jira-macro-repair'
});
const $ca532a827038ae75$export$c0d0d3f98d45e5f1 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_MACRO_USAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/macro-usage'
});
const $ca532a827038ae75$export$69df75bd8c217ade = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_MACRO_USAGE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/pluginusage.action'
});
const $ca532a827038ae75$export$e8beba40e140a443 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_THEMES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/themes'
});
const $ca532a827038ae75$export$c471be73599ccae1 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_PDF_EXPORT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/pdf-export'
});
const $ca532a827038ae75$export$f9c5de90a82d0d1e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_WORKFLOWS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/workflows'
});
const $ca532a827038ae75$export$9859a7a7049d0585 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DATABASE_CUSTOM_OVERVIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/custom/database/overview'
});
const $ca532a827038ae75$export$90480461935b54cc = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DATABASE_CUSTOM_VIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/custom/database/:contentId(\\d+)'
});
const $ca532a827038ae75$export$851ba2be5095d586 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DATABASE_VIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/database/:contentId'
});
const $ca532a827038ae75$export$84b5e15197aaaa12 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EMBED_VIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/embed/:contentId'
});
const $ca532a827038ae75$export$4dcf771d1a1901ef = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'FOLDER_VIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/folder/:contentId'
});
const $ca532a827038ae75$export$752c480a913a6712 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_BULK_PERMISSIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/permissions/bulk-permissions'
});
const $ca532a827038ae75$export$16172a64bcdb79f8 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_NOTIFICATIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/notifications'
});
const $ca532a827038ae75$export$59a52cdd0906f4cb = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'TOPICS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/topics/:topicId'
});
const $ca532a827038ae75$export$c4e8a8651a3f7aed = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'WORKFLOWS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/workflows'
});
const $ca532a827038ae75$export$ade28a8f0ba1efba = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SMART_CREATE_PROMPT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/smart-create'
});

});
parcelRegister("fMEnQ", function(module, exports) {

$parcel$export(module.exports, "Route", () => $7279e7f5ffc03607$export$e7b0ac011bb776c6);

var $ifrXn = parcelRequire("ifrXn");

var $cxcMr = parcelRequire("cxcMr");
class $7279e7f5ffc03607$export$e7b0ac011bb776c6 {
    static matchFirst(routes, url) {
        for (const route of routes){
            if (!(route instanceof $7279e7f5ffc03607$export$e7b0ac011bb776c6)) continue;
            const matchResult = route.match(url);
            if (matchResult) return matchResult;
        }
        return null;
    }
    match(url) {
        const urlMatch = (0, $ifrXn.matchUrl)(this.pattern, url);
        if (urlMatch) {
            if (this.condition && !this.condition(urlMatch)) return null;
            return {
                ...urlMatch,
                name: this.name
            };
        }
        return null;
    }
    toUrl(params, options) {
        return (0, $cxcMr.toUrl)(this.pattern, params, options);
    }
    constructor(props){
        this.name = void 0;
        this.ufoName = void 0;
        this.bifrost = void 0;
        this.pattern = void 0;
        this.condition = void 0;
        this.isTransition = void 0;
        this.name = props.name;
        this.ufoName = props.ufoName;
        this.bifrost = props.bifrost;
        this.pattern = props.pattern;
        this.condition = props.condition ? props.condition : ()=>true;
        this.isTransition = (previous, current)=>{
            if (!previous) return true;
            if (props.isTransition) return previous.name === current.name ? props.isTransition(previous, current) : true;
            return previous.pathname !== current.pathname;
        };
    }
}

});
parcelRegister("ifrXn", function(module, exports) {

$parcel$export(module.exports, "matchUrl", () => $115737db32c49698$export$b5d8fba258cc9e89);

var $jiJCD = parcelRequire("jiJCD");

var $4y1GY = parcelRequire("4y1GY");
function $115737db32c49698$export$b5d8fba258cc9e89(pattern, url) {
    const parsed = (0, $jiJCD.parse)(url, true);
    const pathname = parsed.pathname || '';
    let match = (0, $4y1GY.matchPath)(pathname, {
        path: pattern,
        exact: true
    });
    // some of our routes need query params to match
    if (!match) match = (0, $4y1GY.matchPath)(`${pathname}${parsed.search}`, {
        path: pattern,
        exact: true
    });
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) for (const [key, value] of Object.entries(match.params)){
        let decodedValue = value;
        if (typeof value !== 'undefined') {
            try {
                // decodeURIComponent("%") throws "URI malformed" error
                decodedValue = decodeURIComponent(value);
            } catch (e) {}
            decodedParams[key] = decodedValue;
        }
    }
    return {
        url: url,
        pathname: pathname,
        search: parsed.search || '',
        hash: parsed.hash || '',
        pattern: pattern,
        params: decodedParams,
        query: parsed.query || ''
    };
}

});

parcelRegister("cxcMr", function(module, exports) {

$parcel$export(module.exports, "toUrl", () => $2727220b73d8e0f6$export$1758be3e5622c165);

var $jiJCD = parcelRequire("jiJCD");

var $8We1s = parcelRequire("8We1s");
const $2727220b73d8e0f6$export$1758be3e5622c165 = (pattern, params = {}, options = {})=>{
    const toPath = (0, $8We1s.compile)(pattern, {
        encode: decodeURIComponent
    });
    const path = toPath(params);
    const parsed = (0, $jiJCD.parse)(path, true);
    return (0, $jiJCD.format)({
        pathname: parsed.pathname,
        query: {
            ...parsed.query,
            ...options.query || {}
        },
        hash: options.hash
    });
};

});


parcelRegister("jlIaF", function(module, exports) {

$parcel$export(module.exports, "CONTEXT_PATH", () => $91bc4b300d6f4b96$export$8c6bf2df244e6a99);
const $91bc4b300d6f4b96$export$8c6bf2df244e6a99 = '/wiki';

});

parcelRegister("bqMNb", function(module, exports) {

$parcel$export(module.exports, "FORCE_TRANSITION_QUERY_PARAM", () => $316991bab9a5c4bb$export$e6eb0c6cf0c4b7e3);
$parcel$export(module.exports, "isForceTransition", () => $316991bab9a5c4bb$export$b5402fcece797a50);
const $316991bab9a5c4bb$export$e6eb0c6cf0c4b7e3 = 'force_transition';
const $316991bab9a5c4bb$export$b5402fcece797a50 = (prevMatch, currentMatch)=>{
    const currentForceTransitionId = currentMatch?.query?.[$316991bab9a5c4bb$export$e6eb0c6cf0c4b7e3];
    const previousForceTransitionId = prevMatch?.query?.[$316991bab9a5c4bb$export$e6eb0c6cf0c4b7e3];
    return Boolean(currentForceTransitionId && currentForceTransitionId !== previousForceTransitionId);
};

});



parcelRegister("hyeEk", function(module, exports) {

$parcel$export(module.exports, "addSuperAdminDirectiveLink", () => $e6ea36789beff9b8$export$6c3fe9c8b11bbd40);

var $gZ7FC = parcelRequire("gZ7FC");

var $6jrkJ = parcelRequire("6jrkJ");
const $e6ea36789beff9b8$var$SUPER_ADMIN_DIRECTIVE = 'asSuperAdmin';
const $e6ea36789beff9b8$export$6c3fe9c8b11bbd40 = new (0, $gZ7FC.ApolloLink)((operation, forward)=>{
    const { asSuperAdmin: asSuperAdmin = true } = operation.getContext();
    if (asSuperAdmin && (0, $6jrkJ.getSuperAdminClaim)()) operation.query.definitions.forEach((definition)=>{
        if (!('operation' in definition)) return;
        const { operation: operation, directives: directives } = definition;
        if (operation === 'query' || operation === 'mutation') {
            const superAdminDirectiveExists = directives?.some((directive)=>directive.name.value === $e6ea36789beff9b8$var$SUPER_ADMIN_DIRECTIVE);
            if (!superAdminDirectiveExists) {
                const superAdminDirective = {
                    arguments: [],
                    kind: 'Directive',
                    name: {
                        kind: 'Name',
                        value: $e6ea36789beff9b8$var$SUPER_ADMIN_DIRECTIVE
                    }
                };
                // @ts-ignore "directive" is marked as ReadonlyArray in types
                directives?.push(superAdminDirective);
            }
        }
    });
    return forward(operation);
});

});
parcelRegister("6jrkJ", function(module, exports) {

$parcel$export(module.exports, "getSuperAdminClaim", () => $00ee7f2affe27fcd$export$2fc1623749affa1a);
$parcel$export(module.exports, "removeSuperAdminClaim", () => $00ee7f2affe27fcd$export$b097cdee5288154b);
$parcel$export(module.exports, "setSuperAdminClaim", () => $00ee7f2affe27fcd$export$f5d5d0f409509831);

var $68uaC = parcelRequire("68uaC");
const $00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE = 'confluence.asSuperAdmin';
function $00ee7f2affe27fcd$export$2fc1623749affa1a() {
    return Boolean((0, $68uaC.Cookies).get($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE));
}
function $00ee7f2affe27fcd$export$b097cdee5288154b() {
    (0, $68uaC.Cookies).remove($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE);
}
async function $00ee7f2affe27fcd$export$f5d5d0f409509831() {
    await (0, $68uaC.Cookies).set($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE, 'true', undefined, (0, $68uaC.CookieLevel).NECESSARY);
}

});
parcelRegister("68uaC", function(module, exports) {

$parcel$export(module.exports, "CookieLevel", () => $d7bce23cc4785c4a$export$bd5b8250c8cdfbb5);
$parcel$export(module.exports, "Cookies", () => $d7bce23cc4785c4a$export$3a9db9793503eddb);

var $2urbH = parcelRequire("2urbH");
var $ajypD = parcelRequire("ajypD");
var $hEbxW = parcelRequire("hEbxW");
var $hU6fs = parcelRequire("hU6fs");
var $eGd7K = parcelRequire("eGd7K");
var $gqmdp = parcelRequire("gqmdp");
var $7L5zP = parcelRequire("7L5zP");

var $9wGTI = parcelRequire("9wGTI");
var $d7bce23cc4785c4a$export$bd5b8250c8cdfbb5 = /*#__PURE__*/ function(CookieLevel) {
    CookieLevel["USE_PREFERENCES"] = "USE_PREFERENCES";
    CookieLevel["NECESSARY"] = "NECESSARY";
    return CookieLevel;
}({});
class $d7bce23cc4785c4a$export$3a9db9793503eddb {
    static initialize() {
        // Initialize browser-storage-controls with webStorageEnabled
        // This will override browser default LocalStorage and SessionStorage
        if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) return (0, $hU6fs.initializeControls)({
            product: 'Confluence',
            webStorageEnabled: true
        });
        return (0, $hU6fs.initializeControls)({
            product: 'Confluence'
        });
    }
    /**
   * Attempts to set a cookie asynchronously using the user's preferences
   * @param level Describes how necessary the cookie is. Only use NECESSARY if the cookie is absolutely required.
   * @returns true if the cookie succeeded in being set based on the user's preferences
   */ static async set(key, value, attributes, level = "USE_PREFERENCES") {
        // This does not need to be behind the FF because
        // if the cookie is strictly necessary, its set synchronously using js-cookie anyways
        if (level === "NECESSARY") {
            (0, $gqmdp.setStrictlyNecessaryCookie)(key, value, attributes);
            return Promise.resolve(true);
        }
        return await (0, $eGd7K.setCookie)(key, value, attributes) === (0, $7L5zP.Status).SUCCESS;
    }
    // eslint-disable-next-line no-dupe-class-members
    static get(key) {
        if (!key) return (0, $hEbxW.getCookie)();
        return (0, $hEbxW.getCookie)(key);
    }
    /**
   * Deletes a cookie given a key
   */ static remove(key, attributes) {
        (0, $ajypD.deleteCookie)(key, attributes);
    }
    /**
   * Executes a callback if the user has allowed or denied a third party cookie
   */ static async checkThirdParty(key, onAllowed, onDenied) {
        await (0, $2urbH.checkThirdParty)(key, onAllowed, onDenied);
    }
}

});
parcelRegister("2urbH", function(module, exports) {

$parcel$export(module.exports, "checkThirdParty", () => $c2a064e2efbad315$export$6112f3b5ec1bcd0);

var $c5a0x = parcelRequire("c5a0x");

var $6ZgEd = parcelRequire("6ZgEd");

var $9QO9L = parcelRequire("9QO9L");
const $c2a064e2efbad315$export$6112f3b5ec1bcd0 = async (thirdParty, onAllowed, onDenied)=>{
    try {
        const isAllowed = await (0, $9QO9L.isThirdPartyAllowed)(thirdParty);
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedCheckThirdParty',
            attributes: {
                wasRejected: !isAllowed,
                thirdParty: thirdParty
            }
        });
        return isAllowed ? onAllowed() : onDenied?.();
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'checkThirdPartyError',
            attributes: {
                wasRejected: true,
                thirdParty: thirdParty
            },
            message: `Failed to use check third party. ${e.message || ''}`
        });
    }
};

});
parcelRegister("9QO9L", function(module, exports) {

$parcel$export(module.exports, "isThirdPartyAllowed", () => $190e6f4243fd9d93$export$3df7084d4be668cd);

var $2i8PW = parcelRequire("2i8PW");

var $ccRXO = parcelRequire("ccRXO");

var $7MEbC = parcelRequire("7MEbC");
const $190e6f4243fd9d93$export$3df7084d4be668cd = async (thirdParty)=>{
    /*
    If no preferences for whatever reason, deny
    If prefs exist and are default, they will default to block all
    If third party has no category for whatever reason or the data doesn't resolve, deny
    If third party has a category, check preferences and allow/deny
  */ const preferences = await (0, $7MEbC.getPreferences)();
    if (!preferences) return Promise.resolve(false);
    let shouldDenyThirdParty = false;
    let storageControlsData;
    const { loadCache: loadCache } = (0, $2i8PW.getBscGlobalState)();
    storageControlsData = await loadCache((0, $ccRXO.CategoryStorageType).Cookies);
    if (storageControlsData) {
        const { thirdPartyKeys: thirdPartyKeys, categories: categories } = storageControlsData;
        const thirdPartyCategoryNumber = thirdPartyKeys[thirdParty];
        const numToCategoryMap = {
            [categories.STRICTLY_NECESSARY]: (0, $ccRXO.PreferenceCategory).StrictlyNecessary,
            [categories.FUNCTIONAL]: (0, $ccRXO.PreferenceCategory).Functional,
            [categories.ANALYTICS]: (0, $ccRXO.PreferenceCategory).Analytics,
            [categories.MARKETING]: (0, $ccRXO.PreferenceCategory).Marketing,
            [categories.UNKNOWN]: (0, $ccRXO.PreferenceCategory).Unknown
        };
        const thirdPartyCategory = thirdPartyCategoryNumber !== null ? numToCategoryMap[thirdPartyCategoryNumber] : null;
        let hasPreferencesForCategoryType = false;
        if (!!thirdPartyCategory) hasPreferencesForCategoryType = preferences[thirdPartyCategory];
        shouldDenyThirdParty = hasPreferencesForCategoryType;
    }
    return Promise.resolve(shouldDenyThirdParty);
};

});


parcelRegister("ajypD", function(module, exports) {

$parcel$export(module.exports, "deleteCookie", () => $de038b90d1226c0e$export$b43e45590305ffaa);

var $7g5Pn = parcelRequire("7g5Pn");

var $dh538 = parcelRequire("dh538");

var $c5a0x = parcelRequire("c5a0x");

var $6ZgEd = parcelRequire("6ZgEd");
const $de038b90d1226c0e$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).remove(key, attributes);
    else try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).remove(key, attributes);
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
    }
};

});

parcelRegister("hU6fs", function(module, exports) {

$parcel$export(module.exports, "initializeControls", () => $bb4d89404279468d$export$919040c32a62c7db);

var $dh538 = parcelRequire("dh538");

var $c5a0x = parcelRequire("c5a0x");
var $kfwMJ = parcelRequire("kfwMJ");
var $6ZgEd = parcelRequire("6ZgEd");

var $2i8PW = parcelRequire("2i8PW");
parcelRequire("c4TO3");
var $hohxW = parcelRequire("hohxW");

var $iMbr2 = parcelRequire("iMbr2");

var $gNXDk = parcelRequire("gNXDk");
const $bb4d89404279468d$export$919040c32a62c7db = async (args = {
    analyticsEnabled: true
})=>{
    if ((0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch')) // Exit if the master killswitch is enabled
    return;
    try {
        (0, $6ZgEd.Logger).debug('initializeControls invoked');
        (0, $2i8PW.initializeGlobalState)(args);
        // Exit silently if in SSR context
        if ((0, $kfwMJ.isSSR)()) return;
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, $c5a0x.getAnalyticsClient)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (args.analyticsEnabled && !isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        await (0, $iMbr2.createDocumentCookiePassthrough)();
        const isWebStorageControlsEnabled = (0, $2i8PW.getBscGlobalState)().webStorageEnabled;
        if (!isWebStorageControlsEnabled) return;
        await (0, $gNXDk.createWebStoragePassthrough)((0, $hohxW.WebStorageType).LocalStorage);
        await (0, $gNXDk.createWebStoragePassthrough)((0, $hohxW.WebStorageType).SessionStorage);
        (0, $6ZgEd.Logger).debug('initiizeControls finished');
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
};

});
parcelRegister("iMbr2", function(module, exports) {

$parcel$export(module.exports, "createDocumentCookiePassthrough", () => $deca648bfb5be9c0$export$45a5573b04db016c);

var $6ZgEd = parcelRequire("6ZgEd");

var $8cv9C = parcelRequire("8cv9C");
const $deca648bfb5be9c0$export$45a5573b04db016c = async ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty?.set;
    const originalGetter = documentCookieProperty?.get;
    if (!originalSetter || !originalGetter) {
        (0, $6ZgEd.Logger).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, $8cv9C.getSetCookieOverride)(originalSetter),
        configurable: true
    });
};

});
parcelRegister("8cv9C", function(module, exports) {

$parcel$export(module.exports, "getSetCookieOverride", () => $0958c9ba5ffa5207$export$b7364c41ddbfdb0a);

var $2i8PW = parcelRequire("2i8PW");
var $c5a0x = parcelRequire("c5a0x");

var $6RSiP = parcelRequire("6RSiP");

var $6ZgEd = parcelRequire("6ZgEd");

var $ccRXO = parcelRequire("ccRXO");
const $0958c9ba5ffa5207$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $6ZgEd.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, $c5a0x.sendPackageOperationalEvent)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                const productName = (0, $2i8PW.getBscGlobalState)().product;
                // Attempt to set a known cookie that was set from outside the package
                (0, $6RSiP.isProcessingAllowedByPreferences)({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $2i8PW.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                        else return;
                    },
                    storageType: (0, $ccRXO.CategoryStorageType).Cookies,
                    productName: productName
                });
            } catch (e) {
                (0, $6ZgEd.Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
            }
        } catch (e) {
            (0, $6ZgEd.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
    };

});


parcelRegister("gNXDk", function(module, exports) {

$parcel$export(module.exports, "createWebStoragePassthrough", () => $746a09bdebd6d04b$export$619fe705922e5d61);

var $6ZgEd = parcelRequire("6ZgEd");

var $8oAcs = parcelRequire("8oAcs");

var $c4TO3 = parcelRequire("c4TO3");
var $hohxW = parcelRequire("hohxW");

var $d9QfB = parcelRequire("d9QfB");
const $746a09bdebd6d04b$export$619fe705922e5d61 = async (storageType)=>{
    const bscStorage = (0, $c4TO3.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $6ZgEd.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, $8oAcs.BSCIndexedDB).isAvailable) {
        (0, $6ZgEd.Logger).warn('IndexedDB is not available');
        return;
    }
    if (!(0, $8oAcs.BSCIndexedDB).isBooted) // If we've yet to invoke booting of the IDB service, ensure we do it here.
    await (0, $8oAcs.BSCIndexedDB).boot();
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, $d9QfB.setItemOverride)(bscStorage, originalSetItem, storageType)
    };
    const caseSensitiveStorageType = storageType === (0, $hohxW.WebStorageType).LocalStorage ? 'localStorage' : 'sessionStorage';
    Object.defineProperty(window, caseSensitiveStorageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};

});
parcelRegister("d9QfB", function(module, exports) {

$parcel$export(module.exports, "setItemOverride", () => $04cbb2a37e439c7b$export$b4469df6294ea6aa);

var $2i8PW = parcelRequire("2i8PW");
var $c5a0x = parcelRequire("c5a0x");

var $6RSiP = parcelRequire("6RSiP");

var $6ZgEd = parcelRequire("6ZgEd");
parcelRequire("c4TO3");
var $hohxW = parcelRequire("hohxW");

var $ccRXO = parcelRequire("ccRXO");
const $04cbb2a37e439c7b$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        bscStorage.checkIfSetByPackage({
            itemKey: originalItemKey,
            isSetCallback: ()=>{
                itemSetByPackage = true;
            },
            isNotSetCallback: ()=>{
                // Note: This is async and could fail, but if the call errors out in IDB,
                // it will forcibly resolve to false here, so we're not catching the error again here ✅
                itemSetByPackage = false;
            }
        });
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, $6ZgEd.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType: storageType
                }
            });
        }
        try {
            (0, $c5a0x.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    itemKey: originalItemKey,
                    outsidePackage: !itemSetByPackage,
                    storageType: storageType
                }
            });
            try {
                const productName = (0, $2i8PW.getBscGlobalState)().product;
                // Attempt to set a known item key that was set from outside the package
                (0, $6RSiP.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ()=>{
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $2i8PW.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                        else return;
                    },
                    storageType: storageType === (0, $hohxW.WebStorageType).LocalStorage ? (0, $ccRXO.CategoryStorageType).LocalStorage : (0, $ccRXO.CategoryStorageType).SessionStorage,
                    productName: productName
                });
            } catch (e) {
                (0, $6ZgEd.Logger).errorWithOperationalEvent({
                    action: 'usedAtlBrowserStorageSetItemError',
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType
                    }
                });
            }
        } catch (e) {
            (0, $6ZgEd.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`
            });
        }
    };

});



parcelRegister("eGd7K", function(module, exports) {

$parcel$export(module.exports, "setCookie", () => $caeb0e16e3fd62a1$export$110700823644f4a6);

var $7g5Pn = parcelRequire("7g5Pn");

var $dh538 = parcelRequire("dh538");

var $2i8PW = parcelRequire("2i8PW");
var $c5a0x = parcelRequire("c5a0x");

var $6RSiP = parcelRequire("6RSiP");

var $6ZgEd = parcelRequire("6ZgEd");

var $ccRXO = parcelRequire("ccRXO");
const $caeb0e16e3fd62a1$export$110700823644f4a6 = async (key, value, attributes)=>{
    if ((0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch')) {
        // Set the cookie without checking user preferences
        // when master killswitch is enabled
        (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
        return (0, $ccRXO.Status).SUCCESS;
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    const productName = (0, $2i8PW.getBscGlobalState)().product;
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetCookie = await (0, $6RSiP.isProcessingAllowedByPreferences)({
        itemKey: key,
        storageType: (0, $ccRXO.CategoryStorageType).Cookies,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetCookie,
        cookieKey: key
    };
    try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedSetCookie',
            attributes: eventAttributes
        });
        if (shouldSetCookie) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7g5Pn))).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
            return (0, $ccRXO.Status).SUCCESS;
        } else return (0, $ccRXO.Status).BLOCKED;
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: eventAttributes,
            message: `Failed to use set cookie. ${e.message || ''}`
        });
        return (0, $ccRXO.Status).BLOCKED;
    }
};

});

parcelRegister("7L5zP", function(module, exports) {

$parcel$export(module.exports, "Status", () => $028268adc8ed6848$export$96e9906d6d93a972);
var $028268adc8ed6848$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});

});




parcelRegister("e43zd", function(module, exports) {

$parcel$export(module.exports, "networkErrorRetryLink", () => $358c0fe063680ddb$export$bc8f9e5839290435);
$parcel$export(module.exports, "enableNetworkRetryLink", () => $358c0fe063680ddb$export$164e9e9b901ab24f);

var $clTd0 = parcelRequire("clTd0");

var $flE5X = parcelRequire("flE5X");
// In some circumstances, unmounting a <Query> won't cancel the underlying query,
// causing a retry-loop to continue long after the corresponding UI has
// disappeared (link-to-this-page-dialog was doing this for me -mdean2).
// Seems to need fetchPolicy="cache-first" (the default) and a not-single query
// to show the effect. While that's still an issue, be conservative with the
// max retries.
const $358c0fe063680ddb$var$NETWORK_ERROR_MAX_RETRIES = 2;
const $358c0fe063680ddb$var$NETWORK_ERROR_INITIAL_RETRY_DELAY_MS = 500;
const $358c0fe063680ddb$var$NETWORK_ERROR_MAX_RETRY_DELAY_MS = 5000;
// Query retries are disabled by default: reconsider after fetching feature flags
let $358c0fe063680ddb$var$retryEnabled = false;

const $358c0fe063680ddb$var$sendTrackEvent = (error, operation)=>{
    Promise.resolve((parcelRequire("04e9M"))).then(({ getAnalyticsWebClient: getAnalyticsWebClient })=>{
        getAnalyticsWebClient().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'graphql',
                action: 'errored',
                attributes: {
                    eventName: 'network.error.retry',
                    queryName: operation.operationName,
                    priorRetries: operation.getContext().networkRetries || 0,
                    message: error.message
                }
            });
        });
    });
};
const $358c0fe063680ddb$export$bc8f9e5839290435 = new (0, $clTd0.RetryLink)({
    delay: {
        initial: $358c0fe063680ddb$var$NETWORK_ERROR_INITIAL_RETRY_DELAY_MS,
        max: $358c0fe063680ddb$var$NETWORK_ERROR_MAX_RETRY_DELAY_MS,
        jitter: true
    },
    attempts: {
        max: $358c0fe063680ddb$var$NETWORK_ERROR_MAX_RETRIES,
        retryIf: (error, operation)=>{
            // Never retry if feature-flag not enabled
            if (!$358c0fe063680ddb$var$retryEnabled) return false;
            // Don't retry mutations, regardless of all other concerns
            if (operation.query.definitions.some((definition)=>'operation' in definition && definition.operation === 'mutation')) return false;
            // Do retry when connection failed at the network layer
            if (error instanceof (0, $flE5X.NoNetworkError)) {
                $358c0fe063680ddb$var$sendTrackEvent(error, operation);
                operation.setContext((context)=>({
                        networkRetries: (context.networkRetries || 0) + 1
                    }));
                return true;
            }
            // All other errors, leave it to a higher link in the chain to retry if it wants to
            return false;
        }
    }
});
function $358c0fe063680ddb$export$164e9e9b901ab24f() {
    $358c0fe063680ddb$var$retryEnabled = true;
}

});

parcelRegister("b2nDI", function(module, exports) {

$parcel$export(module.exports, "statusCodeRetryLink", () => $1fda01e907a51fcb$export$e30c063a9dc76f6b);
$parcel$export(module.exports, "enableStatusCodeRetryLink", () => $1fda01e907a51fcb$export$4496b6bcbac21996);

var $clTd0 = parcelRequire("clTd0");

var $hBkCm = parcelRequire("hBkCm");
// In some circumstances, unmounting a <Query> won't cancel the underlying query,
// causing a retry-loop to continue long after the corresponding UI has
// disappeared (link-to-this-page-dialog was doing this for me -mdean2).
// Seems to need fetchPolicy="cache-first" (the default) and a not-single query
// to show the effect. While that's still an issue, be conservative with the
// max retries.
const $1fda01e907a51fcb$var$BAD_STATUS_CODE_MAX_RETRIES = 2;
const $1fda01e907a51fcb$var$BAD_STATUS_CODE_INITIAL_RETRY_DELAY_MS = 500;
const $1fda01e907a51fcb$var$BAD_STATUS_CODE_MAX_RETRY_DELAY_MS = 5000;
// Query retries are disabled by default: reconsider after fetching feature flags
let $1fda01e907a51fcb$var$retryEnabled = false;

// @ts-ignore
// eslint-disable-next-line no-unused-vars
const $1fda01e907a51fcb$var$sendTrackEvent = (error, operation)=>{
    Promise.resolve((parcelRequire("04e9M"))).then(({ getAnalyticsWebClient: getAnalyticsWebClient })=>{
        getAnalyticsWebClient().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'graphql',
                action: 'errored',
                attributes: {
                    eventName: 'status.code.retry',
                    queryName: operation.operationName,
                    priorRetries: operation.getContext().statusRetries || 0,
                    status: error.response.status,
                    statusText: error.response.statusText
                }
            });
        });
    });
};
const $1fda01e907a51fcb$export$e30c063a9dc76f6b = new (0, $clTd0.RetryLink)({
    delay: {
        initial: $1fda01e907a51fcb$var$BAD_STATUS_CODE_INITIAL_RETRY_DELAY_MS,
        max: $1fda01e907a51fcb$var$BAD_STATUS_CODE_MAX_RETRY_DELAY_MS,
        jitter: true
    },
    attempts: {
        max: $1fda01e907a51fcb$var$BAD_STATUS_CODE_MAX_RETRIES,
        retryIf: (error, operation)=>{
            // Never retry if feature-flag not enabled
            if (!$1fda01e907a51fcb$var$retryEnabled) return false;
            // If we didn't receive a 2xx status code, then...
            if (error instanceof (0, $hBkCm.BadStatusError)) {
                // Don't retry mutations, regardless of all other concerns
                if (operation.query.definitions.some((definition)=>'operation' in definition && definition.operation === 'mutation')) return false;
            // When we've decided policy on which 5xx errors merit a retry, implement here.
            //
            // If you wanted, for instance, to retry based on your machine's WiFi being
            // down (where the dev proxy will be responding with 504 codes), uncomment this:
            /*
            if (error.response.status === 504) {
              console.log("Do not commit");
              sendTrackEvent(error, operation);
              operation.setContext(context => ({
                statusRetries: (context.statusRetries || 0) + 1
              }));
              return true;
            }
            */ }
            // All other errors, leave it to a higher link in the chain to retry if it wants to
            return false;
        }
    }
});
function $1fda01e907a51fcb$export$4496b6bcbac21996() {
    $1fda01e907a51fcb$var$retryEnabled = true;
}

});

parcelRegister("aOk8w", function(module, exports) {

$parcel$export(module.exports, "graphqlSyntheticErrorGenerator", () => $7d17e916549f650a$export$4669f4f7e5b2e8a0);

var $gZ7FC = parcelRequire("gZ7FC");

var $bGj3X = parcelRequire("bGj3X");

var $7W8i8 = parcelRequire("7W8i8");

var $1UApO = parcelRequire("1UApO");
const $7d17e916549f650a$var$createGraphQLError = (operationName, message = `This is a test error from \"testFailuresLink\". To skip this query from triggering a test error, run this in console:\n  excludeOperationFromFailureGeneration(\"${operationName}\")`, status = 500)=>{
    return new (0, $bGj3X.GraphQLError)(message, undefined, undefined, undefined, undefined, undefined, {
        statusCode: status,
        http: {
            status: status
        }
    });
};
function $7d17e916549f650a$var$devOnlyLinkImplementation() {
    class OperationController {
        get mode() {
            return this._mode;
        }
        set mode(value) {
            this._mode = value;
            switch(value){
                case 'include':
                case 'exclude':
                    // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
                    sessionStorage.setItem((0, $1UApO.keys).TEST_FAILURES_LINK_MODE, value);
                    break;
                case 'off':
                    sessionStorage.removeItem((0, $1UApO.keys).TEST_FAILURES_LINK_MODE);
            }
        }
        onOperationRequested(operationName) {
            if (this.mode === 'off') return {
                error: undefined
            };
            this.requestedOperations.add(operationName);
            this.scheduleDebugReporting();
            if (!this.shouldGenerateError(operationName)) return {
                error: undefined
            };
            switch(this.mode){
                case 'include':
                    {
                        const operations = this.getOperations();
                        return {
                            error: operations.get(operationName)
                        };
                    }
                case 'exclude':
                    return {
                        error: $7d17e916549f650a$var$createGraphQLError(operationName)
                    };
            }
        }
        addOperation(operationName, message, status) {
            const error = $7d17e916549f650a$var$createGraphQLError(operationName, message, status);
            const operations = this.getOperations();
            operations.set(operationName, error);
            // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
            sessionStorage.setItem(this.operationsStorageKey, JSON.stringify(Array.from(operations)));
        }
        removeOperation(operationName) {
            const operations = this.getOperations();
            operations.delete(operationName);
            // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
            sessionStorage.setItem(this.operationsStorageKey, JSON.stringify(Array.from(operations)));
        }
        getOperations() {
            return new Map(JSON.parse(sessionStorage.getItem(this.operationsStorageKey) || '[]'));
        }
        reset() {
            const modes = [
                'include',
                'exclude',
                'off'
            ];
            modes.forEach((mode)=>{
                this.mode = mode;
                sessionStorage.removeItem(this.operationsStorageKey);
            });
            sessionStorage.removeItem((0, $1UApO.keys).TEST_FAILURES_LINK_MODE);
            this._mode = 'off';
            this.requestedOperations.clear();
        }
        scheduleDebugReporting() {
            if (this.mode === 'off') return;
            window.clearTimeout(this.currentDebugReportingTimeoutId);
            this.currentDebugReportingTimeoutId = window.setTimeout(()=>{
                if (this.mode === 'include') {
                    const configuredOperations = this.getOperations();
                    const operationsThatWereFailedExplicitly = Array.from(this.requestedOperations).filter((op)=>configuredOperations.has(op));
                    const notYetRequestedOperations = Array.from(configuredOperations).filter((op)=>!this.requestedOperations.has(op[0]));
                    this.logger.log`OperationController mode: "include".`;
                    this.logger.log`Operations which have been failed explicitly:`;
                    this.logger.log`${operationsThatWereFailedExplicitly}`;
                    this.logger.log`Operations which were configured to fail explicitly, but have not been requested yet:`;
                    this.logger.log`${notYetRequestedOperations}`;
                } else if (this.mode === 'exclude') {
                    const configuredOperations = this.getOperations();
                    const operationsThatWereFailedExplicitly = Array.from(this.requestedOperations).filter((op)=>!configuredOperations.has(op));
                    const notYetRequestedOperations = Array.from(configuredOperations).filter((op)=>!this.requestedOperations.has(op[0]));
                    this.logger.log`OperationController mode: "exclude".`;
                    this.logger.log`Operations which have been failed explicitly:`;
                    this.logger.log`${operationsThatWereFailedExplicitly}`;
                    this.logger.log`Operations which were excluded from failures, but have not been requested yet:`;
                    this.logger.log`${notYetRequestedOperations}`;
                }
            }, 1000);
        }
        shouldGenerateError(operationName) {
            switch(this.mode){
                case 'off':
                    return false;
                case 'include':
                    return this.getOperations().has(operationName);
                case 'exclude':
                    return !this.getOperations().has(operationName);
            }
        }
        get operationsStorageKey() {
            return `${(0, $1UApO.keys).TEST_FAILURES_LINK_OPERATIONS_PREFIX}${this.mode}`;
        }
        constructor(){
            this.logger = (0, $7W8i8.getLogger)('DevOnlyGraphqlErrorGenerator');
            this._mode = 'off';
            this.currentDebugReportingTimeoutId = void 0;
            this.requestedOperations = new Set();
            const configuredMode = sessionStorage.getItem((0, $1UApO.keys).TEST_FAILURES_LINK_MODE);
            if (configuredMode === 'include' || configuredMode === 'exclude') this.mode = configuredMode;
        }
    }
    const operationController = new OperationController();
    window.graphqlOperationController = operationController;
    window.enableArtificialGraphqlFailures = ()=>{
        operationController.mode = 'exclude';
    };
    window.excludeOperationFromFailureGeneration = (operationName)=>{
        operationController.mode = 'exclude';
        operationController.addOperation(operationName);
    };
    window.includeOperationInFailureGeneration = (operationName, message, status)=>{
        operationController.mode = 'include';
        operationController.addOperation(operationName, message, status);
    };
    window.unexcludeOperationFromFailureGeneration = (operationName)=>{
        operationController.mode = 'exclude';
        operationController.removeOperation(operationName);
    };
    window.unincludeOperationInFailureGeneration = (operationName)=>{
        operationController.mode = 'include';
        operationController.removeOperation(operationName);
    };
    window.disableArtificialGraphqlFailures = ()=>{
        operationController.reset();
    };
    window.getArtificialGraphqlFailures = ()=>{
        return operationController.getOperations();
    };
    return new (0, $gZ7FC.ApolloLink)((operation, forward)=>{
        return forward(operation).map((response)=>{
            const { error: error } = operationController.onOperationRequested(operation.operationName);
            if (error) {
                delete response.data;
                response.errors = [
                    error
                ];
            }
            return response;
        });
    });
}
function $7d17e916549f650a$var$noopLink() {
    return new (0, $gZ7FC.ApolloLink)((operation, forward)=>forward(operation));
}
const $7d17e916549f650a$export$4669f4f7e5b2e8a0 = ()=>{
    return $7d17e916549f650a$var$noopLink();
};

});

parcelRegister("frpLx", function(module, exports) {

$parcel$export(module.exports, "ExperimentalLink", () => $b72b30640e216768$export$8990c5a8045f5ebc);

var $gZ7FC = parcelRequire("gZ7FC");

function $b72b30640e216768$export$8990c5a8045f5ebc() {
    return new (0, $gZ7FC.ApolloLink)((operation)=>{
        return new (0, $gZ7FC.Observable)((observer)=>{
            (parcelRequire("Ggh3P")).then(({ getSchemaLink: getSchemaLink })=>{
                (0, $gZ7FC.execute)(getSchemaLink(), operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            });
        });
    });
}

});
parcelRegister("Ggh3P", function(module, exports) {

let $07f08c11fb211f0a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $07f08c11fb211f0a$var$load("c6MKV"),
    $07f08c11fb211f0a$var$load("gGSRo")
]).then(()=>parcelRequire('cqeVP'));

});


parcelRegister("5Vp8B", function(module, exports) {

$parcel$export(module.exports, "webSocketLink", () => $e08c21cc4a2f58a8$export$1aba72d2a9bf603);

var $3WmiL = parcelRequire("3WmiL");

var $bCNnV = parcelRequire("bCNnV");

var $eq9Qf = parcelRequire("eq9Qf");
let $e08c21cc4a2f58a8$var$hasWebSocketLinkConnection;
function $e08c21cc4a2f58a8$var$getWebsocketURI() {
    let WEBSOCKET_URI;
    WEBSOCKET_URI = `wss://${window.location.host}/subscriptions/subscriptions`;
    return WEBSOCKET_URI;
}
let $e08c21cc4a2f58a8$var$subscriptionClient;
function $e08c21cc4a2f58a8$export$8f441d0995f71d98() {
    const WEBSOCKET_URI = $e08c21cc4a2f58a8$var$getWebsocketURI();
    // NOTE: current usage is geared towards quick reload, and subscription can be terminated by
    // next/packages/quick-reload/src/useWsSubscription.ts -> unsubscribeAll() call
    if (!$e08c21cc4a2f58a8$var$subscriptionClient) $e08c21cc4a2f58a8$var$subscriptionClient = new (0, $bCNnV.SubscriptionClient)(WEBSOCKET_URI, {
        reconnect: true,
        reconnectionAttempts: 2,
        // WS library closes a connection after a short timeout if the server was too slow to respond
        // https://github.com/apollographql/subscriptions-transport-ws/issues/377
        // https://github.com/apollographql/subscriptions-transport-ws/blob/master/src/client.ts#L548
        minTimeout: 5000,
        lazy: true
    });
    return $e08c21cc4a2f58a8$var$subscriptionClient;
}
const $e08c21cc4a2f58a8$export$1aba72d2a9bf603 = ()=>new (0, $3WmiL.WebSocketLink)($e08c21cc4a2f58a8$export$8f441d0995f71d98());
const $e08c21cc4a2f58a8$export$e0cd372dee37c8be = ()=>{
    const WEBSOCKET_URI = $e08c21cc4a2f58a8$var$getWebsocketURI();
    if ($e08c21cc4a2f58a8$var$hasWebSocketLinkConnection === undefined) $e08c21cc4a2f58a8$var$hasWebSocketLinkConnection = (0, $eq9Qf.checkWebSocketConnectivity)(WEBSOCKET_URI);
    return $e08c21cc4a2f58a8$var$hasWebSocketLinkConnection;
};

});
parcelRegister("eq9Qf", function(module, exports) {

$parcel$export(module.exports, "checkWebSocketConnectivity", () => $e55c37f1a957f9bd$export$4aacc15ba69cddd2);
function $e55c37f1a957f9bd$export$4aacc15ba69cddd2(url) {
    // we don't want WS connection to be established during SSR
    if (typeof window != 'undefined' && typeof window.WebSocket !== 'undefined') try {
        const ws = new window.WebSocket(url, 'graphql-ws');
        ws.onopen = ()=>{
            setTimeout(()=>{
                // do not pollute connection pool, but do not disconnect immediately as it causes error
                // "WebSocket is closed before the connection is established."
                ws.close();
            }, 100);
        };
        return true;
    } catch (error) {
    /* NOOP */ }
    return false;
}

});


parcelRegister("8iwsP", function(module, exports) {

$parcel$export(module.exports, "fragmentMatcher", () => $d3507e581863e385$export$851a7159daf49c89);

var $aU4fU = parcelRequire("aU4fU");

var $jSqub = parcelRequire("jSqub");
const $d3507e581863e385$export$851a7159daf49c89 = new (0, $aU4fU.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($jSqub)))
        }
    }
});

});
parcelRegister("jSqub", function(module, exports) {
module.exports = JSON.parse("[{\"kind\":\"UNION\",\"name\":\"ActivitiesEventExtension\",\"possibleTypes\":[{\"name\":\"ActivitiesCommentedEvent\"},{\"name\":\"ActivitiesTransitionedEvent\"}]},{\"kind\":\"UNION\",\"name\":\"ActivitiesObjectExtension\",\"possibleTypes\":[{\"name\":\"ActivitiesJiraIssue\"}]},{\"kind\":\"UNION\",\"name\":\"ActivityObjectData\",\"possibleTypes\":[{\"name\":\"ConfluenceBlogPost\"},{\"name\":\"ConfluenceDatabase\"},{\"name\":\"ConfluenceEmbed\"},{\"name\":\"ConfluenceFooterComment\"},{\"name\":\"ConfluenceInlineComment\"},{\"name\":\"ConfluencePage\"},{\"name\":\"ConfluenceWhiteboard\"}]},{\"kind\":\"INTERFACE\",\"name\":\"AllUpdatesFeedEvent\",\"possibleTypes\":[{\"name\":\"CommentUpdate\"},{\"name\":\"CreateUpdate\"},{\"name\":\"EditUpdate\"}]},{\"kind\":\"INTERFACE\",\"name\":\"CommentLocation\",\"possibleTypes\":[{\"name\":\"FooterComment\"},{\"name\":\"InlineComment\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluenceAncestor\",\"possibleTypes\":[{\"name\":\"ConfluenceDatabase\"},{\"name\":\"ConfluenceEmbed\"},{\"name\":\"ConfluenceFolder\"},{\"name\":\"ConfluencePage\"},{\"name\":\"ConfluenceWhiteboard\"}]},{\"kind\":\"INTERFACE\",\"name\":\"ConfluenceComment\",\"possibleTypes\":[{\"name\":\"ConfluenceFooterComment\"},{\"name\":\"ConfluenceInlineComment\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluenceCommentContainer\",\"possibleTypes\":[{\"name\":\"ConfluenceBlogPost\"},{\"name\":\"ConfluencePage\"},{\"name\":\"ConfluenceWhiteboard\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluenceInlineTaskContainer\",\"possibleTypes\":[{\"name\":\"ConfluenceBlogPost\"},{\"name\":\"ConfluencePage\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluenceLongTaskResult\",\"possibleTypes\":[{\"name\":\"ConfluenceCopyPageTaskResult\"}]},{\"kind\":\"INTERFACE\",\"name\":\"ConfluenceLongTaskState\",\"possibleTypes\":[{\"name\":\"ConfluenceLongTaskFailed\"},{\"name\":\"ConfluenceLongTaskInProgress\"},{\"name\":\"ConfluenceLongTaskSuccess\"}]},{\"kind\":\"INTERFACE\",\"name\":\"ConfluenceSearchResult\",\"possibleTypes\":[{\"name\":\"ConfluenceContentSearchResult\"},{\"name\":\"ConfluenceSpaceSearchResult\"}]},{\"kind\":\"INTERFACE\",\"name\":\"FeedEvent\",\"possibleTypes\":[{\"name\":\"FeedEventComment\"},{\"name\":\"FeedEventCreate\"},{\"name\":\"FeedEventEdit\"},{\"name\":\"FeedEventEditLive\"},{\"name\":\"FeedEventPublishLive\"}]},{\"kind\":\"UNION\",\"name\":\"MediaAttachmentOrError\",\"possibleTypes\":[{\"name\":\"MediaAttachment\"},{\"name\":\"MediaAttachmentError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"MutationErrorExtension\",\"possibleTypes\":[{\"name\":\"AdminAnnouncementBannerMutationErrorExtension\"},{\"name\":\"ConfluenceUpdatePdfExportConfigurationMutationErrorExtension\"},{\"name\":\"ConfluenceUpdateSiteConfigurationMutationErrorExtension\"},{\"name\":\"GenericMutationErrorExtension\"},{\"name\":\"PatchCommentsSummaryMutationErrorExtension\"},{\"name\":\"ReopenCommentsMutationErrorExtension\"},{\"name\":\"ResolveCommentsMutationErrorExtension\"},{\"name\":\"ResolveRestrictionsForSubjectMutationErrorExtension\"},{\"name\":\"UpdateExCoSpacePermissionsMutationErrorExtension\"},{\"name\":\"UpdateSpacePermissionsMutationErrorExtension\"}]},{\"kind\":\"INTERFACE\",\"name\":\"Node\",\"possibleTypes\":[{\"name\":\"ActivitiesEvent\"},{\"name\":\"ActivitiesItem\"},{\"name\":\"ActivitiesObject\"},{\"name\":\"ActivityNode\"},{\"name\":\"ConfluenceBlogPost\"}]},{\"kind\":\"INTERFACE\",\"name\":\"PageActivityEvent\",\"possibleTypes\":[{\"name\":\"PageActivityEventCreatedComment\"},{\"name\":\"PageActivityEventCreatedPage\"},{\"name\":\"PageActivityEventPublishedPage\"},{\"name\":\"PageActivityEventSnapshottedPage\"},{\"name\":\"PageActivityEventStartedPage\"},{\"name\":\"PageActivityEventUpdatedPage\"}]},{\"kind\":\"INTERFACE\",\"name\":\"Payload\",\"possibleTypes\":[{\"name\":\"ActivatePaywallContentPayload\"},{\"name\":\"AddPublicLinkPermissionsPayload\"},{\"name\":\"ArchiveSpacePayload\"},{\"name\":\"BulkDeleteContentDataClassificationLevelPayload\"},{\"name\":\"BulkRemoveRoleAssignmentFromSpacesPayload\"},{\"name\":\"BulkSetRoleAssignmentToSpacesPayload\"},{\"name\":\"BulkSetSpacePermissionAsyncPayload\"},{\"name\":\"BulkSetSpacePermissionPayload\"},{\"name\":\"BulkUpdateContentDataClassificationLevelPayload\"},{\"name\":\"ConfluenceAddCustomApplicationLinkPayload\"},{\"name\":\"ConfluenceChangeOrderOfCustomApplicationLinkPayload\"},{\"name\":\"ConfluenceCopySpaceSecurityConfigurationPayload\"},{\"name\":\"ConfluenceCreateAnswerPayload\"},{\"name\":\"ConfluenceCreateBlogPostPayload\"},{\"name\":\"ConfluenceCreateCustomRolePayload\"},{\"name\":\"ConfluenceCreateFooterCommentOnBlogPostPayload\"},{\"name\":\"ConfluenceCreateFooterCommentOnPagePayload\"},{\"name\":\"ConfluenceCreatePagePayload\"},{\"name\":\"ConfluenceCreatePdfExportTaskForBulkContentPayload\"},{\"name\":\"ConfluenceCreatePdfExportTaskForSingleContentPayload\"},{\"name\":\"ConfluenceCreateQuestionPayload\"},{\"name\":\"ConfluenceCreateSpacePayload\"},{\"name\":\"ConfluenceDeleteAnswerPayload\"},{\"name\":\"ConfluenceDeleteCalendarCustomEventTypePayload\"},{\"name\":\"ConfluenceDeleteCustomApplicationLinkPayload\"},{\"name\":\"ConfluenceDeleteCustomRolePayload\"},{\"name\":\"ConfluenceDeleteGlobalPageTemplatePayload\"},{\"name\":\"ConfluenceDeleteQuestionPayload\"},{\"name\":\"ConfluenceDeleteSubCalendarAllFutureEventsPayload\"},{\"name\":\"ConfluenceDeleteSubCalendarEventPayload\"},{\"name\":\"ConfluenceDeleteSubCalendarHiddenEventsPayload\"},{\"name\":\"ConfluenceDeleteSubCalendarSingleEventPayload\"},{\"name\":\"ConfluenceDisableBlueprintPayload\"},{\"name\":\"ConfluenceDisableDefaultSpaceLogoPayload\"},{\"name\":\"ConfluenceDisableGlobalPageBlueprintPayload\"},{\"name\":\"ConfluenceDisableSpaceBlueprintPayload\"},{\"name\":\"ConfluenceEnableBlueprintPayload\"},{\"name\":\"ConfluenceEnableDefaultSpaceLogoPayload\"},{\"name\":\"ConfluenceEnableGlobalPageBlueprintPayload\"},{\"name\":\"ConfluenceImportSpacePayload\"},{\"name\":\"ConfluenceMarkAllCommentsAsReadPayload\"},{\"name\":\"ConfluencePromoteBlueprintPayload\"},{\"name\":\"ConfluencePromotePageTemplatePayload\"},{\"name\":\"ConfluencePublishBlogPostPayload\"},{\"name\":\"ConfluencePublishPagePayload\"},{\"name\":\"ConfluencePurgeBlogPostPayload\"},{\"name\":\"ConfluencePurgePagePayload\"},{\"name\":\"ConfluenceReopenCommentPayload\"},{\"name\":\"ConfluenceRepairJiraMacroAppLinksPayload\"},{\"name\":\"ConfluenceRequestSpaceAccessPayload\"},{\"name\":\"ConfluenceResetDefaultSpaceLogoPayload\"},{\"name\":\"ConfluenceResetJiraMacroAppLinksScanStatusPayload\"},{\"name\":\"ConfluenceResolveCommentByContentIdPayload\"},{\"name\":\"ConfluenceResolveCommentsPayload\"},{\"name\":\"ConfluenceSaveOrUpdateSpaceOwnerPayload\"},{\"name\":\"ConfluenceScanJiraMacroAppLinksPayload\"},{\"name\":\"ConfluenceTrashBlogPostPayload\"},{\"name\":\"ConfluenceTrashPagePayload\"},{\"name\":\"ConfluenceUnpromoteBlueprintPayload\"},{\"name\":\"ConfluenceUnpromotePageTemplatePayload\"},{\"name\":\"ConfluenceUpdateAnswerPayload\"},{\"name\":\"ConfluenceUpdateCurrentBlogPostPayload\"},{\"name\":\"ConfluenceUpdateCurrentPagePayload\"},{\"name\":\"ConfluenceUpdateCustomApplicationLinkPayload\"},{\"name\":\"ConfluenceUpdateCustomPageConfigurationPayload\"},{\"name\":\"ConfluenceUpdateCustomRolePayload\"},{\"name\":\"ConfluenceUpdateDraftBlogPostPayload\"},{\"name\":\"ConfluenceUpdateDraftPagePayload\"},{\"name\":\"ConfluenceUpdateEmailSiteConfigurationPayload\"},{\"name\":\"ConfluenceUpdateGlobalDefaultLocaleConfigurationPayload\"},{\"name\":\"ConfluenceUpdateGlobalPageTemplateDescriptionPayload\"},{\"name\":\"ConfluenceUpdateGlobalThemePayload\"},{\"name\":\"ConfluenceUpdateIndexingLanguageConfigurationPayload\"},{\"name\":\"ConfluenceUpdateManageAppsSettingsPayload\"},{\"name\":\"ConfluenceUpdateNewCodeMacroPayload\"},{\"name\":\"ConfluenceUpdatePdfExportConfigurationPayload\"},{\"name\":\"ConfluenceUpdateQuestionPayload\"},{\"name\":\"ConfluenceUpdateSiteConfigurationPayload\"},{\"name\":\"ConfluenceUpdateSiteSecurityConfigurationPayload\"},{\"name\":\"ConfluenceUpdateSiteSenderEmailAddressPayload\"},{\"name\":\"ConfluenceUpdateSlackSiteConfigurationPayload\"},{\"name\":\"ConfluenceUpdateSpacePayload\"},{\"name\":\"ConfluenceUpdateSpaceSettingsPayload\"},{\"name\":\"ConfluenceUpdateSpaceThemePayload\"},{\"name\":\"ConfluenceUpdateSubCalendarHiddenEventsPayload\"},{\"name\":\"ConfluenceUpdateTeamPresenceSiteConfigurationPayload\"},{\"name\":\"ConfluenceUploadDefaultSpaceLogoPayload\"},{\"name\":\"ConvertPageToLiveEditActionPayload\"},{\"name\":\"CreateContentMentionNotificationActionPayload\"},{\"name\":\"CreateFaviconFilesPayload\"},{\"name\":\"CreateInlineTaskNotificationPayload\"},{\"name\":\"CreateMentionNotificationPayload\"},{\"name\":\"CreateMentionReminderNotificationPayload\"},{\"name\":\"DeactivatePaywallContentPayload\"},{\"name\":\"DeleteContentDataClassificationLevelPayload\"},{\"name\":\"DeleteDefaultSpaceRoleAssignmentsPayload\"},{\"name\":\"DeleteExCoSpacePermissionsPayload\"},{\"name\":\"DeleteExternalCollaboratorDefaultSpacePayload\"},{\"name\":\"DeleteSpaceDefaultClassificationLevelPayload\"},{\"name\":\"DeleteSpaceRoleAssignmentsPayload\"},{\"name\":\"EditorDraftSyncPayload\"},{\"name\":\"FavouriteSpaceBulkPayload\"},{\"name\":\"NotificationResponsePayload\"},{\"name\":\"RecoverSpaceAdminPermissionPayload\"},{\"name\":\"RecoverSpaceWithAdminRoleAssignmentPayload\"},{\"name\":\"RemovePublicLinkPermissionsPayload\"},{\"name\":\"ResetSpaceRolesFromAnotherSpacePayload\"},{\"name\":\"ResetToDefaultSpaceRoleAssignmentsPayload\"},{\"name\":\"ResolveRestrictionsPayload\"},{\"name\":\"RestoreSpacePayload\"},{\"name\":\"SetDefaultSpaceRoleAssignmentsPayload\"},{\"name\":\"SetSpaceRoleAssignmentsPayload\"},{\"name\":\"SoftDeleteSpacePayload\"},{\"name\":\"UnarchiveSpacePayload\"},{\"name\":\"UpdateContentDataClassificationLevelPayload\"},{\"name\":\"UpdateCoverPictureWidthPayload\"},{\"name\":\"UpdateDefaultSpacePermissionsPayloadV2\"},{\"name\":\"UpdateExCoSpacePermissionsPayload\"},{\"name\":\"UpdateExternalCollaboratorDefaultSpacePayload\"},{\"name\":\"UpdateNestedPageOwnersPayload\"},{\"name\":\"UpdatePageOwnersPayload\"},{\"name\":\"UpdatePageStatusesPayload\"},{\"name\":\"UpdateSiteLookAndFeelPayload\"},{\"name\":\"UpdateSpaceDefaultClassificationLevelPayload\"},{\"name\":\"UpdateSpaceDetailsPayload\"},{\"name\":\"UpdateSpacePermissionsPayloadV2\"},{\"name\":\"UpdateSpaceTypeSettingsPayload\"}]},{\"kind\":\"INTERFACE\",\"name\":\"Person\",\"possibleTypes\":[{\"name\":\"Anonymous\"},{\"name\":\"KnownUser\"},{\"name\":\"UnknownUser\"},{\"name\":\"User\"}]},{\"kind\":\"INTERFACE\",\"name\":\"SmartFeaturesResultResponse\",\"possibleTypes\":[{\"name\":\"SmartFeaturesPageResultResponse\"},{\"name\":\"SmartFeaturesSpaceResultResponse\"},{\"name\":\"SmartFeaturesUserResultResponse\"}]},{\"kind\":\"INTERFACE\",\"name\":\"SmartLink\",\"possibleTypes\":[{\"name\":\"BlockSmartLink\"},{\"name\":\"EmbeddedSmartLink\"},{\"name\":\"InlineSmartLink\"}]},{\"kind\":\"INTERFACE\",\"name\":\"SpaceRolePrincipal\",\"possibleTypes\":[{\"name\":\"SpaceRoleAccessClassPrincipal\"},{\"name\":\"SpaceRoleGroupPrincipal\"},{\"name\":\"SpaceRoleGuestPrincipal\"},{\"name\":\"SpaceRoleUserPrincipal\"}]}]");

});


parcelRegister("a9UQD", function(module, exports) {

$parcel$export(module.exports, "dataIdFromObject", () => $aea7a2153c208241$export$625a51ede6ece419);

var $aU4fU = parcelRequire("aU4fU");
const $aea7a2153c208241$export$625a51ede6ece419 = (object)=>{
    if (object.__typename === 'WebItem') return `${object.completeKey || object.id}; ${object.url}`;
    else if (object.__typename === 'OnboardingState') return object.key;
    else if (object.__typename === 'WebSection') return object.cacheKey || object.id;
    else if (object.__typename === 'DetailsSummaryLines') return `${object.macroId}_${object.currentPage}`;
    else if (object.__typename === 'DetailLine') return `${object.id}_${object.rowId}_${object.macroId}`;
    else if (object.__typename === 'ConfluenceSystemTemplate') return object.moduleCompleteKey;
    else if (object.id === null) return;
    return (0, $aU4fU.defaultDataIdFromObject)(object);
};

});

parcelRegister("avrP0", function(module, exports) {

$parcel$export(module.exports, "cacheRedirects", () => $c03fd16f3d96dc13$export$a79ab6376735332c);
const $c03fd16f3d96dc13$export$a79ab6376735332c = {
    Query: {
        singleContent (_, { id: id }, { getCacheKey: getCacheKey }) {
            return getCacheKey({
                __typename: 'Content',
                id: id
            });
        }
    }
};

});

parcelRegister("3aShZ", function(module, exports) {

$parcel$export(module.exports, "isExperimental", () => $0bce626b95208d8b$export$8de27827a7b1def2);
$parcel$export(module.exports, "isSLA", () => $0bce626b95208d8b$export$96fdb682321c31c1);
$parcel$export(module.exports, "isWS", () => $0bce626b95208d8b$export$fada5ef602d0fc36);
function $0bce626b95208d8b$var$isOperationDefinitionNode(node) {
    return 'operation' in node;
}
function $0bce626b95208d8b$var$hasDirective(name) {
    return (operation)=>{
        if (!operation.query.definitions) return false;
        for (const { operation: type, directives: directives } of operation.query.definitions.filter($0bce626b95208d8b$var$isOperationDefinitionNode)){
            if (type === 'query' || type === 'mutation') return (directives ?? []).some((directive)=>directive.name.value === name);
        }
        return false;
    };
}
// keeping this for now since we don't actually check for directives
// on subscription types
function $0bce626b95208d8b$var$isWSOperation() {
    return (operation)=>{
        if (!operation.query.definitions) return false;
        for (const { operation: type } of operation.query.definitions.filter($0bce626b95208d8b$var$isOperationDefinitionNode)){
            if (type === 'subscription') return true;
        }
        return false;
    };
}
const $0bce626b95208d8b$export$8de27827a7b1def2 = $0bce626b95208d8b$var$hasDirective('experimental');
const $0bce626b95208d8b$export$96fdb682321c31c1 = $0bce626b95208d8b$var$hasDirective('SLA');
const $0bce626b95208d8b$export$fada5ef602d0fc36 = $0bce626b95208d8b$var$isWSOperation();

});

parcelRegister("8Li6j", function(module, exports) {

$parcel$export(module.exports, "ClientSchema", () => $89ff56af6ad50e06$export$bf57708a85b8c0a4);

var $d2LG0 = parcelRequire("d2LG0");
const $89ff56af6ad50e06$export$bf57708a85b8c0a4 = (0, $d2LG0.default)`type FabricEditor{editorMode:String}directive@client on FIELD directive@connection(key:String!filter:[String])on FIELD extend type Query{network:ClientNetwork fabricEditor:FabricEditor localActivity:[LocalActivityEvent!]!}type ClientNetwork{status:ClientNetworkStatus}enum ClientNetworkStatus{IP_BLOCKED OFFLINE ONLINE RATE_LIMITED SESSION_EXPIRED}type LocalActivityEvent{id:ID!action:LocalActivityAction!timestamp:String!content:Content!}enum LocalActivityAction{viewed deleted}`;

});

parcelRegister("11MAl", function(module, exports) {

$parcel$export(module.exports, "SSRClientLink", () => $4661dfb4474ace55$export$498642ee116fe4df);

var $gZ7FC = parcelRequire("gZ7FC");

var $d2LG0 = parcelRequire("d2LG0");

var $aLaTe = parcelRequire("aLaTe");

var $atveb = parcelRequire("atveb");
parcelRequire("fPnFe");
var $dr1zO = parcelRequire("dr1zO");
class $4661dfb4474ace55$var$QueryResultCache {
    getMatchingResult(query, variables) {
        const results = this.queryResults.get(query);
        if (!results) return null;
        const matchingQueryResult = results.findIndex((result)=>(0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(result.variables, variables));
        if (matchingQueryResult === -1) return null;
        const matchingData = results[matchingQueryResult].result;
        results.splice(matchingQueryResult, 1);
        this.queryResults.set(query, results);
        return matchingData;
    }
    addResult(query, result, variables) {
        const results = this.queryResults.get(query) || [];
        results.push({
            result: result,
            variables: variables
        });
        this.queryResults.set(query, results);
    }
    constructor(cache){
        this.cache = cache;
        this.queryResults = void 0;
        this.queryResults = new Map();
        const data = (0, $dr1zO.getClientStream)('cgraphql');
        data.addListener((event)=>{
            if (event.type === 'result') try {
                this.cache.writeQuery({
                    query: (0, $d2LG0.gql)(event.operation),
                    variables: event.variables,
                    data: event.result.data
                });
                this.addResult(event.operation, event.result.data, event.variables);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('Failed to write query', e);
            }
        });
    }
}
const $4661dfb4474ace55$export$498642ee116fe4df = (cache)=>{
    let queryResultCache = null;
    if (window.__SSR_REACT_STREAMING__) queryResultCache = new $4661dfb4474ace55$var$QueryResultCache(cache);
    return new (0, $gZ7FC.ApolloLink)((operation, forward)=>{
        if (!window.__SSR_REACT_STREAMING__ || !queryResultCache) return forward(operation);
        const query = (0, $aLaTe.print)(operation.query);
        const result = queryResultCache.getMatchingResult(query, operation.variables);
        if (result) return (0, $gZ7FC.Observable).of({
            data: result
        });
        return forward(operation);
    });
};

});
parcelRegister("fPnFe", function(module, exports) {

$parcel$export(module.exports, "getServerStream", () => (parcelRequire("eUgss")).getServerStream);
$parcel$export(module.exports, "getClientStream", () => (parcelRequire("dr1zO")).getClientStream);

var $eUgss = parcelRequire("eUgss");

var $dr1zO = parcelRequire("dr1zO");

});
parcelRegister("eUgss", function(module, exports) {

$parcel$export(module.exports, "getServerStream", () => $42ff849c6357ec03$export$9b8a06415a43901d);

var $gwFzn = parcelRequire("gwFzn");

var $i2tcl = parcelRequire("i2tcl");
const $42ff849c6357ec03$var$pending = [];
function $42ff849c6357ec03$var$queueRenderCallback(callback) {
    $42ff849c6357ec03$var$pending.push(callback);
}
let $42ff849c6357ec03$var$inject = $42ff849c6357ec03$var$queueRenderCallback;
/**
 * Bootstrap script that is rendered inline before any data streams are emitted
 *
 * This initializes the following:
 * * window.__s - A map of stream names to a list of emitted values
 * * window.__sL - A map of stream names to a set of listeners
 * * window.__s_r - A function that initializes a stream if it doesn't exist
 * * window.__s__e - A function that emits a value to a stream
 */ const $42ff849c6357ec03$var$streamBootstrap = `
    if (!window.__s) {
        window.__s = {}; 
    }
    if (!window.__sL) {
        window.__sL = {}; 
    }
    window.__s_r = (s) => { 
        if (!window.__s[s]) { 
            window.__s[s] = []; 
        } 
        if (!window.__sL[s]) { 
            window.__sL[s] = new Set(); 
        } 
    }
    window.__s__e = (s, v) => { 
        try {
            var value = JSON.parse(v);
            if (!window.__s[s]) { 
                window.__s[s] = []; 
            } 
            window.__s[s].push(value); 
			if (window.__sL[s]) {
				window.__sL[s].forEach(fn => fn(value));
			}
        } catch (e) {
            console.error('[__s__e] error', e);
        }
    }`;
/**
 * Fix escape codes in a string to be encoded in JSON
 *
 * TODO: Backport this to sanitizeDataForSSR
 * @param value - The string to fix
 * @returns The string with escape codes fixed
 */ function $42ff849c6357ec03$var$sanitizeEscapeCodes(value) {
    return value.replaceAll('\\', '\\\\');
}
function $42ff849c6357ec03$export$b28f0b0600a86f70(callback) {
    $42ff849c6357ec03$var$inject = callback;
    if ($42ff849c6357ec03$var$pending.length > 0) {
        $42ff849c6357ec03$var$pending.forEach($42ff849c6357ec03$var$inject);
        $42ff849c6357ec03$var$pending.length = 0;
    }
}
function $42ff849c6357ec03$export$ccf708e2e2d09700() {
    $42ff849c6357ec03$var$inject = $42ff849c6357ec03$var$queueRenderCallback;
}
const $42ff849c6357ec03$var$streams = new Map();
function $42ff849c6357ec03$export$c8e414912e6da9df() {
    $42ff849c6357ec03$var$streams.clear();
}
class $42ff849c6357ec03$var$EventStream {
    emit(value) {
        $42ff849c6357ec03$var$inject(()=>{
            let script = '';
            if (!this.initialized) {
                script = `window.__s_r("${this.stream}");`;
                this.initialized = true;
            }
            const data = JSON.stringify(value);
            const sanitizedData = $42ff849c6357ec03$var$sanitizeEscapeCodes(data);
            script += `window.__s__e("${this.stream}", \"${(0, $i2tcl.sanitizeDataForSSR)(sanitizedData)}\");`;
            return (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement('script', {
                dangerouslySetInnerHTML: {
                    __html: script
                }
            });
        });
    }
    constructor(stream){
        this.initialized = false;
        this.stream = void 0;
        this.stream = stream;
    }
}
function $42ff849c6357ec03$export$9b8a06415a43901d(key) {
    if ($42ff849c6357ec03$var$streams.size === 0) $42ff849c6357ec03$var$inject(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement('script', {
            dangerouslySetInnerHTML: {
                __html: $42ff849c6357ec03$var$streamBootstrap
            }
        });
    });
    let stream = $42ff849c6357ec03$var$streams.get(key);
    if (!stream) {
        stream = new $42ff849c6357ec03$var$EventStream(key);
        $42ff849c6357ec03$var$streams.set(key, stream);
    }
    return stream;
}

});
parcelRegister("i2tcl", function(module, exports) {

$parcel$export(module.exports, "sanitizeDataForSSR", () => $e198cab8fbfaddbd$export$4e67e45851b43f37);
const $e198cab8fbfaddbd$var$UNSAFE_CHARS_REGEXP = /[<>\/\u2028\u2029"]/g;
const $e198cab8fbfaddbd$var$ESCAPED_CHARS = {
    '<': '\\u003C',
    '>': '\\u003E',
    '/': '\\u002F',
    '\u2028': '\\u2028',
    '\u2029': '\\u2029',
    '"': '\\u0022'
};
function $e198cab8fbfaddbd$export$4e67e45851b43f37(data) {
    const serialized = typeof data === 'string' ? data : JSON.stringify(data);
    // We cannot use serialize-javascript directly because it imports randombytes which relies on
    // a real browser or nodejs Here we are running scripts in JSDOM which makes randombytes to
    // think it is running in a real browser. It resulted "Error: Secure random number generation
    // is not supported by this browser. Use Chrome, Firefox or Internet Explorer 11":
    // https://github.com/yahoo/serialize-javascript/blob/main/index.js#L210
    return serialized.replace($e198cab8fbfaddbd$var$UNSAFE_CHARS_REGEXP, (char)=>$e198cab8fbfaddbd$var$ESCAPED_CHARS[char]);
}

});


parcelRegister("dr1zO", function(module, exports) {

$parcel$export(module.exports, "getClientStream", () => $874015b23cbd80ee$export$e2d3408bc322188a);
const $874015b23cbd80ee$var$streams = new Map();
function $874015b23cbd80ee$export$9545e1e15c32e6d6() {
    $874015b23cbd80ee$var$streams.clear();
}
class $874015b23cbd80ee$var$EventStream {
    /**
   * Add a listener to the stream
   * @param fn - The listener function
   */ addListener(fn) {
        for (const value of window.__s[this.stream])fn(value);
        this.listeners.add(fn);
    }
    /**
   * Remove a listener from the stream
   * @param fn - The listener function
   */ removeListener(fn) {
        this.listeners.delete(fn);
    }
    constructor(stream){
        var _window, _window1, _window___sL, _stream, _window___s, _stream1;
        this.stream = void 0;
        this.listeners = new Set();
        this.onEvent = (data)=>{
            this.listeners.forEach((fn)=>fn(data));
        };
        (_window = window).__s ?? (_window.__s = {});
        (_window1 = window).__sL ?? (_window1.__sL = {});
        (_window___sL = window.__sL)[_stream = stream] ?? (_window___sL[_stream] = new Set());
        window.__sL[stream].add(this.onEvent);
        (_window___s = window.__s)[_stream1 = stream] ?? (_window___s[_stream1] = []);
        this.stream = stream;
    }
}
function $874015b23cbd80ee$export$e2d3408bc322188a(key) {
    let stream = $874015b23cbd80ee$var$streams.get(key);
    if (!stream) {
        stream = new $874015b23cbd80ee$var$EventStream(key);
        $874015b23cbd80ee$var$streams.set(key, stream);
    }
    return stream;
}

});





parcelRegister("eE7v6", function(module, exports) {

$parcel$export(module.exports, "QUERY_OVERRIDE_KEYS", () => $f4cd2d3eccc0dda3$export$944ecde68d3596be);

var $gZ7FC = parcelRequire("gZ7FC");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
const $f4cd2d3eccc0dda3$export$944ecde68d3596be = {
    IS_NEW_USER: 'Query.isNewUser',
    IS_SITE_ADMIN: 'Query.isSiteAdmin',
    IS_ESTABLISHED_USER: 'ExperimentalUserPersonalization.isEstablishedUser',
    IS_MIGRATED_USER: 'quickstart-state:isMigratedUserV2',
    ORIGIN_PRODUCT: 'onboarding-origin-state:attributes'
};
const $f4cd2d3eccc0dda3$var$applyQueryOverrides = (response, overrides)=>{
    function deepApplyQueryOverrides(data, typename) {
        if (data == null || typeof data !== 'object') return data;
        if (!typename) {
            typename = data.__typename;
            if (!typename) return data;
        }
        data = shallowApplyQueryOverrides(data, typename);
        Object.entries(data).forEach(([key, value])=>data[key] = deepApplyQueryOverrides(value));
        return data;
    }
    const overrideEntries = Object.entries(overrides);
    function shallowApplyQueryOverrides(data, typename) {
        const typenamePrefix = `${typename}.`;
        overrideEntries.forEach(([overrideKey, overrideValue])=>{
            if (!overrideKey.startsWith(typenamePrefix)) return;
            const field = overrideKey.substring(typenamePrefix.length);
            if (!(field in data)) return;
            // Match the type of the override to the type of the field:
            switch(typeof data[field]){
                case 'boolean':
                    overrideValue = overrideValue === 'true';
                    break;
                case 'number':
                    overrideValue = Number(overrideValue);
                    break;
            }
            data[field] = overrideValue;
        });
        return data;
    }
    deepApplyQueryOverrides(response.data, 'Query');
};
const $f4cd2d3eccc0dda3$var$applyMigratedUserOverride = ({ data: { experimentalSitePersonalization: experimentalSitePersonalization } }, overrides)=>{
    // The useMigratedUser hook recomputes the state as false if these traits are not present
    if (experimentalSitePersonalization?.__typename === 'ExperimentalSitePersonalization' && $f4cd2d3eccc0dda3$export$944ecde68d3596be.IS_MIGRATED_USER in overrides) {
        const keys = [
            'confluence_migration_status',
            'confluence_first_migration_signal_date'
        ];
        const filteredAttributes = experimentalSitePersonalization.attributes.filter((i)=>!keys.includes(i.name));
        if (experimentalSitePersonalization?.attributes) experimentalSitePersonalization.attributes = [
            ...filteredAttributes,
            {
                name: 'confluence_migration_status',
                value: (overrides[$f4cd2d3eccc0dda3$export$944ecde68d3596be.IS_MIGRATED_USER] === 'true').toString(),
                __typename: 'ExperimentalSitePersonalizationAttributes'
            },
            {
                name: 'confluence_first_migration_signal_date',
                value: new Date().toISOString(),
                __typename: 'ExperimentalSitePersonalizationAttributes'
            }
        ];
    }
};
const $f4cd2d3eccc0dda3$var$applyEstablishedUserOverride = ({ data: { experimentalUserPersonalization: experimentalUserPersonalization } }, overrides)=>{
    let isEstablishedUserTraitName = 'confluence_is_established_user';
    const { hostname: hostname } = window.location;
    if (hostname.endsWith('.jira-dev.com')) isEstablishedUserTraitName = 'confluence_is_established_user_stg';
    if (experimentalUserPersonalization?.__typename === 'ExperimentalUserPersonalization' && $f4cd2d3eccc0dda3$export$944ecde68d3596be.IS_ESTABLISHED_USER in overrides) {
        if (experimentalUserPersonalization?.attributes) {
            const filteredAttributes = experimentalUserPersonalization.attributes.filter((i)=>i.name !== isEstablishedUserTraitName);
            experimentalUserPersonalization.attributes = [
                ...filteredAttributes,
                {
                    name: isEstablishedUserTraitName,
                    value: (overrides[$f4cd2d3eccc0dda3$export$944ecde68d3596be.IS_ESTABLISHED_USER] === 'true').toString(),
                    __typename: 'ExperimentalUserPersonalizationAttributes'
                }
            ];
        }
    }
};
const $f4cd2d3eccc0dda3$var$applyOnboardingStateOverride = ({ data: data }, overrides)=>{
    if (data.onboardingState) data.onboardingState = data.onboardingState.map((state)=>{
        const { __typename: __typename, key: key } = state;
        if (__typename === 'OnboardingState' && key in overrides) return {
            ...state,
            value: overrides[key].toString()
        };
        return state;
    });
};
const $f4cd2d3eccc0dda3$export$10cf870c4af4d010 = ()=>{
    let overrides;
    return new (0, $gZ7FC.ApolloLink)((operation, forward)=>forward(operation).map((response)=>{
            if (response?.data && (0, $e9zUf.confluenceLocalStorageInstance)) {
                if (!overrides) try {
                    overrides = JSON.parse((0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).QUERY_OVERRIDES)) || {};
                } catch  {
                    overrides = {};
                }
                if (Object.keys(overrides).length) {
                    if (operation.query.definitions.some((definition)=>'operation' in definition && definition.operation === 'query')) $f4cd2d3eccc0dda3$var$applyQueryOverrides(response, overrides);
                    $f4cd2d3eccc0dda3$var$applyMigratedUserOverride(response, overrides);
                    $f4cd2d3eccc0dda3$var$applyEstablishedUserOverride(response, overrides);
                    $f4cd2d3eccc0dda3$var$applyOnboardingStateOverride(response, overrides);
                }
            }
            return response;
        }));
};

});

parcelRegister("bLJr5", function(module, exports) {

$parcel$export(module.exports, "I18nProvider", () => (parcelRequire("h4kcT")).I18nProvider);
$parcel$export(module.exports, "loadTranslation", () => (parcelRequire("d4U2f")).loadTranslation);
$parcel$export(module.exports, "getTranslation", () => (parcelRequire("d4U2f")).getTranslation);
$parcel$export(module.exports, "DEFAULT_LOCALE", () => (parcelRequire("d4U2f")).DEFAULT_LOCALE);

var $h4kcT = parcelRequire("h4kcT");

var $d4U2f = parcelRequire("d4U2f");

});
parcelRegister("h4kcT", function(module, exports) {

$parcel$export(module.exports, "I18nProvider", () => $a338fab92c921401$export$a54013f0d02a8f82);

var $gwFzn = parcelRequire("gwFzn");

var $hlhtG = parcelRequire("hlhtG");

var $d4U2f = parcelRequire("d4U2f");
const $a338fab92c921401$export$a54013f0d02a8f82 = ({ children: children })=>{
    const [forcedLocale, setForcedLocale] = (0, $gwFzn.useState)(undefined);
    const { locale: unforcedLoadle, messages: messages } = (0, $d4U2f.getTranslation)();
    const locale = forcedLocale || unforcedLoadle;
    (0, $gwFzn.useEffect)(()=>{
        document.documentElement.lang = locale;
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hlhtG.default), {
        key: `intl-provider-${locale}-v5`,
        "data-test-language": locale,
        locale: locale,
        defaultLocale: (0, $d4U2f.DEFAULT_LOCALE),
        messages: messages,
        textComponent: "span",
        onError: (err)=>{}
    }, children);
};

});
parcelRegister("d4U2f", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $c257e233451d85a0$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "getTranslation", () => $c257e233451d85a0$export$202e99f82f7f0395);
$parcel$export(module.exports, "loadTranslation", () => $c257e233451d85a0$export$85e084dbe857046b);

var $jiJCD = parcelRequire("jiJCD");

var $c3Qwv = parcelRequire("c3Qwv");

var $584jG = parcelRequire("584jG");
function $c257e233451d85a0$var$getDefault(obj) {
    return obj.default && typeof obj.default !== 'string' ? obj.default : obj;
}
const $c257e233451d85a0$export$1af4c7e47ad72f44 = 'en-US';
const $c257e233451d85a0$var$translationCache = {};
function $c257e233451d85a0$var$isTranslationCacheSet(cache) {
    return Boolean(cache.locale && cache.messages);
}
function $c257e233451d85a0$export$202e99f82f7f0395() {
    if (!$c257e233451d85a0$var$isTranslationCacheSet($c257e233451d85a0$var$translationCache)) throw new Error('loadTranslation needs to be called before getTranslation');
    return $c257e233451d85a0$var$translationCache;
}
function $c257e233451d85a0$export$85e084dbe857046b(loader = ()=>[], forcedLocale) {
    let localeFromQueryParam;
    try {
        const localeParam = (0, $c3Qwv.getSingleParam)((0, $jiJCD.parse)(location.search, true).query, 'locale');
        Intl.getCanonicalLocales(localeParam); // Throws if the locale is not valid
        localeFromQueryParam = localeParam;
    } catch (error) {
    // Silently handle URI malformed error or invalid locale
    }
    let locale = forcedLocale ?? localeFromQueryParam ?? window?.__SSR_LOCALE__ ?? window?.__INITIAL_STATE__?.i18n?.locale ?? $c257e233451d85a0$export$1af4c7e47ad72f44;
    if (locale.includes('_')) // Note: the locale from session data is not standard aa-AA format. It is aa_AA
    locale = locale.replace('_', '-');
    return Promise.all([
        ...(0, $584jG.getMessages)(locale),
        ...loader(locale)
    ]).then(([...translations])=>{
        // Cache the result in module level.
        $c257e233451d85a0$var$translationCache.locale = locale;
        $c257e233451d85a0$var$translationCache.messages = translations.reduce((allTranslations, translation)=>{
            // import() with json behaves different in test and runtime.
            translation = $c257e233451d85a0$var$getDefault(translation);
            // We've now merged the translations a bit more careful, rather
            // than just blindly use a spread operator because a problem occurred
            // while blindly merging and sending the values to the legacy editor.
            // @see https://ops.internal.atlassian.com/jira/browse/HOT-84998
            for(const key in translation)if (typeof translation[key] === 'string') allTranslations[key] = translation[key];
            return allTranslations;
        }, {});
    });
}

});
parcelRegister("c3Qwv", function(module, exports) {

$parcel$export(module.exports, "getSingleParam", () => $8e6d57004e7493a0$export$69b4b1e5f81fb1ea);
$parcel$export(module.exports, "getSingleParamInt", () => $8e6d57004e7493a0$export$a44568e95e5c4a5c);
function $8e6d57004e7493a0$export$69b4b1e5f81fb1ea(queryParams, paramName) {
    const value = queryParams?.[paramName];
    return Array.isArray(value) ? value[0] : value;
}
function $8e6d57004e7493a0$export$a44568e95e5c4a5c(queryParams, paramName, defaultValue) {
    const value = $8e6d57004e7493a0$export$69b4b1e5f81fb1ea(queryParams, paramName);
    const intValue = parseInt(value ?? '', 10);
    return isNaN(intValue) ? defaultValue : intValue;
}

});

parcelRegister("584jG", function(module, exports) {

$parcel$export(module.exports, "getMessages", () => $53ca2ee1a59d82f1$export$8c20ab16ac9cf14f);
/* eslint-disable import/dynamic-import-chunkname */ 















































































































































































































































































































































































































































































































































































































const $53ca2ee1a59d82f1$export$8c20ab16ac9cf14f = (locale)=>{
    // en-ZZ is a special locale used for locate translation strings. Real user won't see it.
    // Split the condition statements so webpack can remove the whole thing when compiling for SSR
    // SSR doesn't have splits this file will make the ssr-app significantly bigger
    if (locale === 'en-ZZ') return [
        (parcelRequire("VgtFF")),
        (parcelRequire("eZPHz")),
        (parcelRequire("aJgJ8")),
        (parcelRequire("7nc5S")),
        (parcelRequire("lhchK")),
        (parcelRequire("giDZQ")),
        (parcelRequire("hpd5p")),
        (parcelRequire("4XYOr")),
        (parcelRequire("78gxf")),
        (parcelRequire("lkBXc")),
        (parcelRequire("872Ue")),
        (parcelRequire("3rmpj")),
        (parcelRequire("9My5N")),
        (parcelRequire("5np5d")),
        (parcelRequire("bu9PH")),
        (parcelRequire("35YYe")),
        (parcelRequire("kjpo3")),
        (parcelRequire("lS1wS")),
        (parcelRequire("hfsjZ")),
        (parcelRequire("c8KL1")),
        (parcelRequire("kH98Z")),
        (parcelRequire("4rOuc")),
        (parcelRequire("ejcM1")),
        (parcelRequire("iRCVs"))
    ];
    switch(locale){
        case 'fr-FR':
            return [
                (parcelRequire("5TZKC")),
                (parcelRequire("gtZfo")),
                (parcelRequire("aJzpt")),
                (parcelRequire("7FAUo")),
                (parcelRequire("aFxir")),
                (parcelRequire("fymd5")),
                (parcelRequire("1eDvR")),
                (parcelRequire("esIrF")),
                (parcelRequire("6zn1c")),
                (parcelRequire("3M2CD")),
                (parcelRequire("2GvqE")),
                (parcelRequire("c1h6W")),
                (parcelRequire("7zOsn")),
                (parcelRequire("6HoqC")),
                (parcelRequire("6SjA1")),
                (parcelRequire("bdOIM")),
                (parcelRequire("c9sFv")),
                (parcelRequire("57kcB")),
                (parcelRequire("2YTY6")),
                (parcelRequire("9FDdo")),
                (parcelRequire("a0fM3")),
                (parcelRequire("eVawm")),
                (parcelRequire("jNAHx")),
                (parcelRequire("gPbGi")),
                (parcelRequire("fNV3y"))
            ];
        case 'de-DE':
            return [
                (parcelRequire("cbf8z")),
                (parcelRequire("bVGyM")),
                (parcelRequire("kcCcq")),
                (parcelRequire("abmZm")),
                (parcelRequire("3rTFz")),
                (parcelRequire("5RwLN")),
                (parcelRequire("6ssMp")),
                (parcelRequire("2DyhW")),
                (parcelRequire("eJGkX")),
                (parcelRequire("iEFeQ")),
                (parcelRequire("gdXb1")),
                (parcelRequire("btDWB")),
                (parcelRequire("epQ3f")),
                (parcelRequire("bvEBf")),
                (parcelRequire("lKc2o")),
                (parcelRequire("l845G")),
                (parcelRequire("3iqrU")),
                (parcelRequire("feUt0")),
                (parcelRequire("azXg3")),
                (parcelRequire("f95aS")),
                (parcelRequire("acjNT")),
                (parcelRequire("wsX9H")),
                (parcelRequire("bwxzO")),
                (parcelRequire("h0zZD")),
                (parcelRequire("050d6"))
            ];
        case 'ja-JP':
            return [
                (parcelRequire("8WAwv")),
                (parcelRequire("cg82o")),
                (parcelRequire("e9ma2")),
                (parcelRequire("5VQZM")),
                (parcelRequire("5iEZp")),
                (parcelRequire("fxbQS")),
                (parcelRequire("6I0P9")),
                (parcelRequire("lfeWx")),
                (parcelRequire("9dWma")),
                (parcelRequire("fHzgP")),
                (parcelRequire("cDAd5")),
                (parcelRequire("c2qzE")),
                (parcelRequire("iRv2R")),
                (parcelRequire("5UMi9")),
                (parcelRequire("6aAZE")),
                (parcelRequire("fM7Ta")),
                (parcelRequire("a7m1s")),
                (parcelRequire("clLDO")),
                (parcelRequire("97QzI")),
                (parcelRequire("2PLo8")),
                (parcelRequire("1Vs2n")),
                (parcelRequire("lbZj8")),
                (parcelRequire("ea9d1")),
                (parcelRequire("dO2xL")),
                (parcelRequire("8G9rE"))
            ];
        case 'es-ES':
            return [
                (parcelRequire("dIi2g")),
                (parcelRequire("uisik")),
                (parcelRequire("5NWnj")),
                (parcelRequire("jfqzY")),
                (parcelRequire("5TI31")),
                (parcelRequire("9nMby")),
                (parcelRequire("9rinz")),
                (parcelRequire("jisFM")),
                (parcelRequire("eFGuE")),
                (parcelRequire("lacx4")),
                (parcelRequire("uKIDe")),
                (parcelRequire("kj0ci")),
                (parcelRequire("7kMtP")),
                (parcelRequire("cC2jy")),
                (parcelRequire("dSUTO")),
                (parcelRequire("aUplc")),
                (parcelRequire("fUY2T")),
                (parcelRequire("kcy9I")),
                (parcelRequire("fiNSy")),
                (parcelRequire("b9CUD")),
                (parcelRequire("aC9Z0")),
                (parcelRequire("isJ1l")),
                (parcelRequire("99NdS")),
                (parcelRequire("cU1Dl")),
                (parcelRequire("052aG"))
            ];
        case 'ko-KR':
            return [
                (parcelRequire("1uoWy")),
                (parcelRequire("gUgsy")),
                (parcelRequire("6IeAy")),
                (parcelRequire("ikkuH")),
                (parcelRequire("4Lc6F")),
                (parcelRequire("amlTZ")),
                (parcelRequire("fjaBA")),
                (parcelRequire("9ArCD")),
                (parcelRequire("e1nws")),
                (parcelRequire("5QfCV")),
                (parcelRequire("aJBry")),
                (parcelRequire("aRNuB")),
                (parcelRequire("4QRkk")),
                (parcelRequire("7ccAb")),
                (parcelRequire("cJtiJ")),
                (parcelRequire("2ouHI")),
                (parcelRequire("lLJFj")),
                (parcelRequire("dymXa")),
                (parcelRequire("5L4jp")),
                (parcelRequire("9wcaq")),
                (parcelRequire("9Bq5s")),
                (parcelRequire("dy1gf")),
                (parcelRequire("2mrAN")),
                (parcelRequire("aYBII")),
                (parcelRequire("9eps3"))
            ];
        case 'pt-BR':
            return [
                (parcelRequire("7WWVt")),
                (parcelRequire("eHYnE")),
                (parcelRequire("5R0Hw")),
                (parcelRequire("2PVHC")),
                (parcelRequire("3wM1g")),
                (parcelRequire("iI6oQ")),
                (parcelRequire("g2dyA")),
                (parcelRequire("7HQR9")),
                (parcelRequire("afK7E")),
                (parcelRequire("2911k")),
                (parcelRequire("bohce")),
                (parcelRequire("dYRKa")),
                (parcelRequire("jbwij")),
                (parcelRequire("2ew9N")),
                (parcelRequire("3IuV6")),
                (parcelRequire("51SFD")),
                (parcelRequire("5hAQr")),
                (parcelRequire("jNqQk")),
                (parcelRequire("e0AZ1")),
                (parcelRequire("hiy3e")),
                (parcelRequire("iGHPK")),
                (parcelRequire("6i0Xl")),
                (parcelRequire("9uIfZ")),
                (parcelRequire("cFWVV")),
                (parcelRequire("3HVCY"))
            ];
        case 'pt-PT':
            return [
                (parcelRequire("7gPYo")),
                (parcelRequire("l32Fs")),
                (parcelRequire("hw2EA")),
                (parcelRequire("cXGMq")),
                (parcelRequire("baosp")),
                (parcelRequire("9ZE3h")),
                (parcelRequire("hPQok")),
                (parcelRequire("khZjr")),
                (parcelRequire("ehEc4")),
                (parcelRequire("1QHTg"))
            ];
        case 'ru-RU':
            return [
                (parcelRequire("4wYVR")),
                (parcelRequire("fttbp")),
                (parcelRequire("gIhfm")),
                (parcelRequire("1HmJw")),
                (parcelRequire("27l7W")),
                (parcelRequire("60clV")),
                (parcelRequire("74L0N")),
                (parcelRequire("5cdzk")),
                (parcelRequire("iZ5iH")),
                (parcelRequire("i1MUo")),
                (parcelRequire("dRfgA")),
                (parcelRequire("2x6Z7")),
                (parcelRequire("juV8T")),
                (parcelRequire("1zoxv")),
                (parcelRequire("3OI3f")),
                (parcelRequire("lwMRo")),
                (parcelRequire("fIrHf")),
                (parcelRequire("bP8rP")),
                (parcelRequire("g7XdA")),
                (parcelRequire("7mSAq")),
                (parcelRequire("bmkl7")),
                (parcelRequire("jJ7l5")),
                (parcelRequire("hy82D")),
                (parcelRequire("3vcsV")),
                (parcelRequire("9FTnw"))
            ];
        case 'da-DK':
            return [
                (parcelRequire("7QJBL")),
                (parcelRequire("izS0M")),
                (parcelRequire("jIlmn")),
                (parcelRequire("hYGHc")),
                (parcelRequire("kYvyU")),
                (parcelRequire("jHQ1x")),
                (parcelRequire("kfj3Z")),
                (parcelRequire("b3P8q")),
                (parcelRequire("kMh6x")),
                (parcelRequire("2Rl0Q")),
                (parcelRequire("b8GJy")),
                (parcelRequire("afEXy")),
                (parcelRequire("82exJ")),
                (parcelRequire("lgQhX")),
                (parcelRequire("lC3Ox")),
                (parcelRequire("gUqya")),
                (parcelRequire("ioAUA")),
                (parcelRequire("38UgP")),
                (parcelRequire("uh65x")),
                (parcelRequire("aY5is")),
                (parcelRequire("enWze")),
                (parcelRequire("5WMIw")),
                (parcelRequire("40zYz")),
                (parcelRequire("iQpqH")),
                (parcelRequire("ft2jx"))
            ];
        case 'et-EE':
            return [
                (parcelRequire("k7ijU")),
                (parcelRequire("78pPO")),
                (parcelRequire("3iSuO")),
                (parcelRequire("24KSE")),
                (parcelRequire("8qBjl")),
                (parcelRequire("ZF7IX")),
                (parcelRequire("8J3T9")),
                (parcelRequire("fd6VN")),
                (parcelRequire("1nUJE")),
                (parcelRequire("edZ3Q")),
                (parcelRequire("hxDCF"))
            ];
        case 'fi-FI':
            return [
                (parcelRequire("7LPfq")),
                (parcelRequire("2Mx0J")),
                (parcelRequire("lKpUB")),
                (parcelRequire("bkzFU")),
                (parcelRequire("2lyk6")),
                (parcelRequire("4V2aC")),
                (parcelRequire("lLR47")),
                (parcelRequire("97RNW")),
                (parcelRequire("llBJ6")),
                (parcelRequire("6wOJe")),
                (parcelRequire("kWhvL")),
                (parcelRequire("9pBPk")),
                (parcelRequire("it7MS")),
                (parcelRequire("2Td4v")),
                (parcelRequire("7gckx")),
                (parcelRequire("hZbNa")),
                (parcelRequire("bjIwm")),
                (parcelRequire("kiJsA")),
                (parcelRequire("acjoO")),
                (parcelRequire("djtW4")),
                (parcelRequire("4SbVS")),
                (parcelRequire("3MmWY")),
                (parcelRequire("8WSqS")),
                (parcelRequire("dXz34")),
                (parcelRequire("hPPdp"))
            ];
        case 'hu-HU':
            return [
                (parcelRequire("6Bmmn")),
                (parcelRequire("9z5Am")),
                (parcelRequire("2BOtK")),
                (parcelRequire("lii1M")),
                (parcelRequire("jIHc6")),
                (parcelRequire("lLcTT")),
                (parcelRequire("a79ug")),
                (parcelRequire("29A9z")),
                (parcelRequire("dM9Cx")),
                (parcelRequire("2ro7o")),
                (parcelRequire("cnrtE")),
                (parcelRequire("1nKWI")),
                (parcelRequire("dyKcw")),
                (parcelRequire("8aT67")),
                (parcelRequire("5nPle")),
                (parcelRequire("jQQxR")),
                (parcelRequire("8mI7e")),
                (parcelRequire("tPOzk")),
                (parcelRequire("dekF0")),
                (parcelRequire("f741a")),
                (parcelRequire("6SuyL")),
                (parcelRequire("fs0nj")),
                (parcelRequire("wZG89")),
                (parcelRequire("k4A0F")),
                (parcelRequire("2f0RK"))
            ];
        case 'is-IS':
            return [
                (parcelRequire("2zsrj")),
                (parcelRequire("iAcm7")),
                (parcelRequire("4T24m")),
                (parcelRequire("2X7B6")),
                (parcelRequire("e50q8")),
                (parcelRequire("86QJP")),
                (parcelRequire("68BCL"))
            ];
        case 'it-IT':
            return [
                (parcelRequire("cjoOp")),
                (parcelRequire("imVGY")),
                (parcelRequire("inHPn")),
                (parcelRequire("esmiq")),
                (parcelRequire("7LxwD")),
                (parcelRequire("9vEnc")),
                (parcelRequire("85VUv")),
                (parcelRequire("6rHuX")),
                (parcelRequire("lrVwc")),
                (parcelRequire("cv1H3")),
                (parcelRequire("8vzwd")),
                (parcelRequire("CgdQB")),
                (parcelRequire("aWoGl")),
                (parcelRequire("eQODJ")),
                (parcelRequire("kIwgG")),
                (parcelRequire("4INr5")),
                (parcelRequire("1Yz2i")),
                (parcelRequire("aa4eb")),
                (parcelRequire("fAgdc")),
                (parcelRequire("5vTZj")),
                (parcelRequire("2ypfg")),
                (parcelRequire("7pS9S")),
                (parcelRequire("3vYO5")),
                (parcelRequire("5GsuB")),
                (parcelRequire("cbbhR"))
            ];
        case 'nl-NL':
            return [
                (parcelRequire("iIfOK")),
                (parcelRequire("8uqYk")),
                (parcelRequire("2SXdV")),
                (parcelRequire("l5mZh")),
                (parcelRequire("Z6SDd")),
                (parcelRequire("aa8q2")),
                (parcelRequire("1B8BV")),
                (parcelRequire("2XCzY")),
                (parcelRequire("66H4O")),
                (parcelRequire("kL4Jh")),
                (parcelRequire("2MDkR")),
                (parcelRequire("hhabz")),
                (parcelRequire("gglGj")),
                (parcelRequire("30MSy")),
                (parcelRequire("3xjnb")),
                (parcelRequire("b766Q")),
                (parcelRequire("lnjs9")),
                (parcelRequire("1shUB")),
                (parcelRequire("gtg53")),
                (parcelRequire("46e69")),
                (parcelRequire("hXZH1")),
                (parcelRequire("2WUnn")),
                (parcelRequire("dcH5y")),
                (parcelRequire("k9RtC")),
                (parcelRequire("9ZSH5"))
            ];
        case 'no-NO':
            /**
      * Fun fact: Norwegian has two written dialects! The W3C recommends using the Bokmål dialect,
      * which is why we use 'nb' as the language code for this locale rather than 'no'.
      * More info:
      * @see https://hello.atlassian.net/wiki/spaces/~139129757/pages/1604629732/User+preferences+for+language+and+locale
      * @see https://internal.stptrans.com/bokmal-and-nynorsk/
      */ return [
                (parcelRequire("jpnoV")),
                (parcelRequire("kLLQ7")),
                (parcelRequire("Y7Lij")),
                (parcelRequire("fZ6Us")),
                (parcelRequire("jFOrX")),
                (parcelRequire("cCLar")),
                (parcelRequire("efmHA")),
                (parcelRequire("3wllO")),
                (parcelRequire("2ejVQ")),
                (parcelRequire("d22yS")),
                (parcelRequire("jFHhX")),
                (parcelRequire("6DrBh")),
                (parcelRequire("7BgPj")),
                (parcelRequire("hGOF0")),
                (parcelRequire("cAyb7")),
                (parcelRequire("chk6L")),
                (parcelRequire("7kcGp")),
                (parcelRequire("gzVQe")),
                (parcelRequire("3JE9M")),
                (parcelRequire("i4Gy2")),
                (parcelRequire("1EKgF")),
                (parcelRequire("1ZwoN")),
                (parcelRequire("hn7IH")),
                (parcelRequire("7DZ1I")),
                (parcelRequire("cs6e6"))
            ];
        case 'pl-PL':
            return [
                (parcelRequire("30Z80")),
                (parcelRequire("fmFDX")),
                (parcelRequire("4k1DC")),
                (parcelRequire("kG1Wq")),
                (parcelRequire("e5oL3")),
                (parcelRequire("bPGfK")),
                (parcelRequire("dYPQi")),
                (parcelRequire("7CeSF")),
                (parcelRequire("5bVRd")),
                (parcelRequire("42B9a")),
                (parcelRequire("8Wgz2")),
                (parcelRequire("4Rhr6")),
                (parcelRequire("2zJWz")),
                (parcelRequire("2gzsE")),
                (parcelRequire("0427W")),
                (parcelRequire("b2LUN")),
                (parcelRequire("ednoZ")),
                (parcelRequire("g1If2")),
                (parcelRequire("jUPrs")),
                (parcelRequire("5rAD6")),
                (parcelRequire("dSS33")),
                (parcelRequire("2ux9b")),
                (parcelRequire("88yDx")),
                (parcelRequire("ktqgw")),
                (parcelRequire("Oa6nx"))
            ];
        case 'ro-RO':
            return [
                (parcelRequire("d2GXH")),
                (parcelRequire("jGwE7")),
                (parcelRequire("8aIwd")),
                (parcelRequire("f1pOX")),
                (parcelRequire("a34Vp")),
                (parcelRequire("4wnzv")),
                (parcelRequire("4g1Cn")),
                (parcelRequire("6ilcc"))
            ];
        case 'sk-SK':
            return [
                (parcelRequire("dDhE4")),
                (parcelRequire("bk86r")),
                (parcelRequire("fyzYZ")),
                (parcelRequire("iTlGW")),
                (parcelRequire("dMmE3")),
                (parcelRequire("eCwSZ")),
                (parcelRequire("l4mkb")),
                (parcelRequire("3YZwm")),
                (parcelRequire("jpJOQ")),
                (parcelRequire("38pL0"))
            ];
        case 'cs-CZ':
            return [
                (parcelRequire("lkrWp")),
                (parcelRequire("feuKA")),
                (parcelRequire("8CV0z")),
                (parcelRequire("lRFwt")),
                (parcelRequire("cHtEA")),
                (parcelRequire("9LZYt")),
                (parcelRequire("ciYHD")),
                (parcelRequire("6QfAK")),
                (parcelRequire("a2BuE")),
                (parcelRequire("lIfBs")),
                (parcelRequire("cGQZn")),
                (parcelRequire("fgnzR")),
                (parcelRequire("2YepE")),
                (parcelRequire("cCv6N")),
                (parcelRequire("gpsuY")),
                (parcelRequire("cRTov")),
                (parcelRequire("e2cQY")),
                (parcelRequire("Zc77P")),
                (parcelRequire("7bB3L")),
                (parcelRequire("7XfGx")),
                (parcelRequire("5eUPc")),
                (parcelRequire("aVpg5")),
                (parcelRequire("cY3Cx")),
                (parcelRequire("4UpGP")),
                (parcelRequire("bRhxV"))
            ];
        case 'sv-SE':
            return [
                (parcelRequire("7WGgv")),
                (parcelRequire("40p5l")),
                (parcelRequire("hlyml")),
                (parcelRequire("4VxYQ")),
                (parcelRequire("duJJs")),
                (parcelRequire("3My45")),
                (parcelRequire("4xtrC")),
                (parcelRequire("hlfB9")),
                (parcelRequire("9ty4O")),
                (parcelRequire("5pdjD")),
                (parcelRequire("buuAe")),
                (parcelRequire("52WxI")),
                (parcelRequire("j0bO3")),
                (parcelRequire("967Ea")),
                (parcelRequire("6ZjuQ")),
                (parcelRequire("6UOIT")),
                (parcelRequire("flljz")),
                (parcelRequire("3nuPt")),
                (parcelRequire("4rvZM")),
                (parcelRequire("3nKZa")),
                (parcelRequire("4TqyF")),
                (parcelRequire("9j0e7")),
                (parcelRequire("cuTii")),
                (parcelRequire("1hgor")),
                (parcelRequire("l7MZc"))
            ];
        case 'zh-CN':
            return [
                (parcelRequire("90Z4r")),
                (parcelRequire("7Cc3E")),
                (parcelRequire("lXLSN")),
                (parcelRequire("goInG")),
                (parcelRequire("5BFfE")),
                (parcelRequire("37OSC")),
                (parcelRequire("lLWMp")),
                (parcelRequire("6LdWk")),
                (parcelRequire("g7fvG")),
                (parcelRequire("dGnzI")),
                (parcelRequire("cw6KB")),
                (parcelRequire("33CyY")),
                (parcelRequire("by9TN")),
                (parcelRequire("fpWhT")),
                (parcelRequire("ifVVt")),
                (parcelRequire("fSAlL")),
                (parcelRequire("a2qZI")),
                (parcelRequire("2QfX9")),
                (parcelRequire("3l4Ec")),
                (parcelRequire("6oBuW")),
                (parcelRequire("lRn7H")),
                (parcelRequire("dTMPE")),
                (parcelRequire("gWCjs")),
                (parcelRequire("ajtAl")),
                (parcelRequire("1xJdc"))
            ];
        case 'zh-TW':
            return [
                (parcelRequire("gEYDh")),
                (parcelRequire("9Tsjp")),
                (parcelRequire("1LvqF")),
                (parcelRequire("hg0uq")),
                (parcelRequire("dHHk2")),
                (parcelRequire("fwOdQ")),
                (parcelRequire("1Qp1d")),
                (parcelRequire("lm7No")),
                (parcelRequire("58Q3Y")),
                (parcelRequire("fhtCf")),
                (parcelRequire("aNvMm")),
                (parcelRequire("ihRrc")),
                (parcelRequire("4XDL2")),
                (parcelRequire("2gJBo")),
                (parcelRequire("6HooY")),
                (parcelRequire("a3JBY")),
                (parcelRequire("1fqph")),
                (parcelRequire("lreZS")),
                (parcelRequire("ZCDDG")),
                (parcelRequire("6w2Bt")),
                (parcelRequire("kRC4s")),
                (parcelRequire("lEpOT")),
                (parcelRequire("kLNoH")),
                (parcelRequire("ifAHU")),
                (parcelRequire("cJqIE"))
            ];
        case 'tr-TR':
            return [
                (parcelRequire("3YAFQ")),
                (parcelRequire("2jLJJ")),
                (parcelRequire("hI8YY")),
                (parcelRequire("WxDg7")),
                (parcelRequire("gGmca")),
                (parcelRequire("lWjDm")),
                (parcelRequire("1YB72")),
                (parcelRequire("b2GBy")),
                (parcelRequire("i7Lk4")),
                (parcelRequire("7Fklt")),
                (parcelRequire("5IuNg")),
                (parcelRequire("hzPlC")),
                (parcelRequire("7R5zC")),
                (parcelRequire("9bMtm")),
                (parcelRequire("exaah")),
                (parcelRequire("5R3SD")),
                (parcelRequire("k265H")),
                (parcelRequire("6soHb")),
                (parcelRequire("aeo4w")),
                (parcelRequire("iiaFc")),
                (parcelRequire("dDtix")),
                (parcelRequire("ehnUp")),
                (parcelRequire("8EAnh")),
                (parcelRequire("bH59h"))
            ];
        case 'en-GB':
            return [
                (parcelRequire("7SQkZ")),
                (parcelRequire("1IcDg")),
                (parcelRequire("7vmNV")),
                (parcelRequire("9gyxj")),
                (parcelRequire("8cN5M")),
                (parcelRequire("c9qv9")),
                (parcelRequire("7OjpM")),
                (parcelRequire("bbfmS")),
                (parcelRequire("dEeoU")),
                (parcelRequire("a7S5p")),
                (parcelRequire("6ZCCi")),
                (parcelRequire("1T6fM")),
                (parcelRequire("jAuwn")),
                (parcelRequire("BoCck")),
                (parcelRequire("eps0G")),
                (parcelRequire("iIOMU")),
                (parcelRequire("4S5zS")),
                (parcelRequire("idqpU")),
                (parcelRequire("7AsV2")),
                (parcelRequire("bE0f4")),
                (parcelRequire("3NSlb")),
                (parcelRequire("9JGNt")),
                (parcelRequire("1rLBl")),
                (parcelRequire("kcXUD"))
            ];
        default:
            // Use default string defined in the source code.
            return [
                (parcelRequire("geO04")),
                (parcelRequire("7aqQ6")),
                (parcelRequire("7uyYt")),
                (parcelRequire("4kNVQ")),
                (parcelRequire("h0S0O")),
                (parcelRequire("lOJR8")),
                (parcelRequire("48R9K")),
                (parcelRequire("aKSm9")),
                (parcelRequire("ly1ZR")),
                (parcelRequire("eybrM")),
                (parcelRequire("eg7hI")),
                (parcelRequire("3OrPG")),
                (parcelRequire("eAHsz")),
                (parcelRequire("6VkGv")),
                (parcelRequire("6WIEr")),
                (parcelRequire("amhIJ")),
                (parcelRequire("amc4v")),
                (parcelRequire("BB5fd")),
                (parcelRequire("g0YTk")),
                (parcelRequire("gDp7m")),
                (parcelRequire("4Uc1x")),
                (parcelRequire("erep4")),
                (parcelRequire("dpvhi")),
                (parcelRequire("67nq6"))
            ];
    }
};

});
parcelRegister("VgtFF", function(module, exports) {

let $0ac21b166458e4ff$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0ac21b166458e4ff$var$load("5FaEJ").then(()=>parcelRequire('gnzRa'));

});

parcelRegister("eZPHz", function(module, exports) {

let $aeaede1989b8b192$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aeaede1989b8b192$var$load("1vIBg").then(()=>parcelRequire('eEPOC'));

});

parcelRegister("aJgJ8", function(module, exports) {

let $7cfb14f8f9fa8874$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7cfb14f8f9fa8874$var$load("c1fpJ").then(()=>parcelRequire('e4Fch'));

});

parcelRegister("7nc5S", function(module, exports) {

let $55e40ffa7af4239f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $55e40ffa7af4239f$var$load("b7FsF").then(()=>parcelRequire('8wRyR'));

});

parcelRegister("lhchK", function(module, exports) {

let $f7d4b714fc9b340d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f7d4b714fc9b340d$var$load("fJQPR").then(()=>parcelRequire('4FRcU'));

});

parcelRegister("giDZQ", function(module, exports) {

let $bddd5a3dfa1e8908$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bddd5a3dfa1e8908$var$load("8kce1").then(()=>parcelRequire('cwgsE'));

});

parcelRegister("hpd5p", function(module, exports) {

let $cabeec23481d01af$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cabeec23481d01af$var$load("2akqQ").then(()=>parcelRequire('9fM41'));

});

parcelRegister("4XYOr", function(module, exports) {

let $39dbd834eff52d39$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $39dbd834eff52d39$var$load("jp5mX").then(()=>parcelRequire('5SuH4'));

});

parcelRegister("78gxf", function(module, exports) {

let $53161b507eebaaf1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $53161b507eebaaf1$var$load("7C94V").then(()=>parcelRequire('fnqcW'));

});

parcelRegister("lkBXc", function(module, exports) {

let $f878e80d83a7cac6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f878e80d83a7cac6$var$load("ei2lH").then(()=>parcelRequire('246GD'));

});

parcelRegister("872Ue", function(module, exports) {

let $5e813b381650ea69$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5e813b381650ea69$var$load("221z2").then(()=>parcelRequire('7qCqp'));

});

parcelRegister("3rmpj", function(module, exports) {

let $2815464f6e58e6bf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2815464f6e58e6bf$var$load("5qdQG").then(()=>parcelRequire('PLdJF'));

});

parcelRegister("9My5N", function(module, exports) {

let $71f30ace4c91d1f9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $71f30ace4c91d1f9$var$load("jy9VC").then(()=>parcelRequire('1M1oj'));

});

parcelRegister("5np5d", function(module, exports) {

let $3ea28ebceef6b80b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3ea28ebceef6b80b$var$load("bmeMp").then(()=>parcelRequire('cUkSa'));

});

parcelRegister("bu9PH", function(module, exports) {

let $85ca1fa7cdfe1b28$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $85ca1fa7cdfe1b28$var$load("7bk10").then(()=>parcelRequire('dnJzi'));

});

parcelRegister("35YYe", function(module, exports) {

let $2411223743cb2c72$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2411223743cb2c72$var$load("hvq1G").then(()=>parcelRequire('lt9Ls'));

});

parcelRegister("kjpo3", function(module, exports) {

let $ec99464f658a4ff5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ec99464f658a4ff5$var$load("8hJrB").then(()=>parcelRequire('ioCvi'));

});

parcelRegister("lS1wS", function(module, exports) {

let $febfd3d04b546fb3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $febfd3d04b546fb3$var$load("dcw3x").then(()=>parcelRequire('EHYXh'));

});

parcelRegister("hfsjZ", function(module, exports) {

let $c8e9ce6a63f84a56$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c8e9ce6a63f84a56$var$load("dYk9q").then(()=>parcelRequire('29nf6'));

});

parcelRegister("c8KL1", function(module, exports) {

let $8d6a8075ef154812$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8d6a8075ef154812$var$load("dxWaS").then(()=>parcelRequire('6kq3q'));

});

parcelRegister("kH98Z", function(module, exports) {

let $f10eea99ea5e345d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f10eea99ea5e345d$var$load("gKMcG").then(()=>parcelRequire('cGPxs'));

});

parcelRegister("4rOuc", function(module, exports) {

let $33d0d885c6085730$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $33d0d885c6085730$var$load("2hvfJ").then(()=>parcelRequire('dYtch'));

});

parcelRegister("ejcM1", function(module, exports) {

let $a6acbf97c9be9e07$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a6acbf97c9be9e07$var$load("j0PWv"),
    $a6acbf97c9be9e07$var$load("eBoC7"),
    $a6acbf97c9be9e07$var$load("ksTQ6"),
    $a6acbf97c9be9e07$var$load("63R0Y")
]).then(()=>parcelRequire('c6G0e'));

});

parcelRegister("iRCVs", function(module, exports) {

let $dbbb5f14ca4b0a3b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dbbb5f14ca4b0a3b$var$load("hal1M").then(()=>parcelRequire('d9NM7'));

});

parcelRegister("5TZKC", function(module, exports) {

let $44c1fd3fb3e0f76b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $44c1fd3fb3e0f76b$var$load("35Ssm").then(()=>parcelRequire('j19wH'));

});

parcelRegister("gtZfo", function(module, exports) {

let $bffedd3987136d47$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bffedd3987136d47$var$load("04dfq").then(()=>parcelRequire('b9sjx'));

});

parcelRegister("aJzpt", function(module, exports) {

let $7d09930379bec94f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7d09930379bec94f$var$load("7qkmo").then(()=>parcelRequire('ViizB'));

});

parcelRegister("7FAUo", function(module, exports) {

let $5958fe093b404b1a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5958fe093b404b1a$var$load("hyAiq").then(()=>parcelRequire('lMsFR'));

});

parcelRegister("aFxir", function(module, exports) {

let $7c478fac5a895d65$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7c478fac5a895d65$var$load("cjhdF").then(()=>parcelRequire('225Fx'));

});

parcelRegister("fymd5", function(module, exports) {

let $b52b42791eca53f0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b52b42791eca53f0$var$load("7dYul").then(()=>parcelRequire('d7MLS'));

});

parcelRegister("1eDvR", function(module, exports) {

let $0e65bfaa9cc9ae63$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0e65bfaa9cc9ae63$var$load("f0PEA").then(()=>parcelRequire('a0pbo'));

});

parcelRegister("esIrF", function(module, exports) {

let $a876281df4345033$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a876281df4345033$var$load("bqAzS").then(()=>parcelRequire('gYv97'));

});

parcelRegister("6zn1c", function(module, exports) {

let $4c87dde6ff096cab$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4c87dde6ff096cab$var$load("hrccC").then(()=>parcelRequire('B4EgR'));

});

parcelRegister("3M2CD", function(module, exports) {

let $2bf7e38094ab16d9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2bf7e38094ab16d9$var$load("iFGgP").then(()=>parcelRequire('hw2KQ'));

});

parcelRegister("2GvqE", function(module, exports) {

let $1f47e21ea8b52004$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1f47e21ea8b52004$var$load("71E0U").then(()=>parcelRequire('gfNaO'));

});

parcelRegister("c1h6W", function(module, exports) {

let $8c02d9e6e0563c91$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8c02d9e6e0563c91$var$load("gEj1c").then(()=>parcelRequire('6mrsC'));

});

parcelRegister("7zOsn", function(module, exports) {

let $5842f0f45c3b02e2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5842f0f45c3b02e2$var$load("d5Lgc").then(()=>parcelRequire('6QY4I'));

});

parcelRegister("6HoqC", function(module, exports) {

let $4e09b52f33363d1c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4e09b52f33363d1c$var$load("bOYlI").then(()=>parcelRequire('37xrd'));

});

parcelRegister("6SjA1", function(module, exports) {

let $5016f96a005464b4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5016f96a005464b4$var$load("btL2P").then(()=>parcelRequire('gxpCh'));

});

parcelRegister("bdOIM", function(module, exports) {

let $82b840cc81fe6e01$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $82b840cc81fe6e01$var$load("4Z99Q").then(()=>parcelRequire('18l55'));

});

parcelRegister("c9sFv", function(module, exports) {

let $8d8c9042a179bf4e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8d8c9042a179bf4e$var$load("f3xe1").then(()=>parcelRequire('btGRq'));

});

parcelRegister("57kcB", function(module, exports) {

let $3b9d46f721fac0f0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3b9d46f721fac0f0$var$load("kKZ2R").then(()=>parcelRequire('unuyV'));

});

parcelRegister("2YTY6", function(module, exports) {

let $22bc998c3ca4c4f6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $22bc998c3ca4c4f6$var$load("chujL").then(()=>parcelRequire('4GFkJ'));

});

parcelRegister("9FDdo", function(module, exports) {

let $70a65cb17659d61d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $70a65cb17659d61d$var$load("1BEaf").then(()=>parcelRequire('cf5Cc'));

});

parcelRegister("a0fM3", function(module, exports) {

let $748623da7a113a42$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $748623da7a113a42$var$load("5zX1H").then(()=>parcelRequire('awhs8'));

});

parcelRegister("eVawm", function(module, exports) {

let $adce8cc870ab3ae7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $adce8cc870ab3ae7$var$load("ki9Rk").then(()=>parcelRequire('6qqPD'));

});

parcelRegister("jNAHx", function(module, exports) {

let $e69f10098cdc58cb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e69f10098cdc58cb$var$load("6wBhQ").then(()=>parcelRequire('h24zs'));

});

parcelRegister("gPbGi", function(module, exports) {

let $c3fa7863563c949d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c3fa7863563c949d$var$load("17m16"),
    $c3fa7863563c949d$var$load("cMubu"),
    $c3fa7863563c949d$var$load("kAg8V"),
    $c3fa7863563c949d$var$load("6z8G9")
]).then(()=>parcelRequire('1Lu20'));

});

parcelRegister("fNV3y", function(module, exports) {

let $b817b0cd74e9dfa5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b817b0cd74e9dfa5$var$load("at21v").then(()=>parcelRequire('llpqT'));

});

parcelRegister("cbf8z", function(module, exports) {

let $8de24112148db365$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8de24112148db365$var$load("eJgH8").then(()=>parcelRequire('gU4LI'));

});

parcelRegister("bVGyM", function(module, exports) {

let $8af6081ea3f65272$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8af6081ea3f65272$var$load("15JEv").then(()=>parcelRequire('4Wx0w'));

});

parcelRegister("kcCcq", function(module, exports) {

let $eb528f441da97d83$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $eb528f441da97d83$var$load("illcU").then(()=>parcelRequire('alkG3'));

});

parcelRegister("abmZm", function(module, exports) {

let $769cc38648c4f304$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $769cc38648c4f304$var$load("elJhQ").then(()=>parcelRequire('kSspz'));

});

parcelRegister("3rTFz", function(module, exports) {

let $282f137e3bbc62e5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $282f137e3bbc62e5$var$load("4UYlu").then(()=>parcelRequire('e7zr1'));

});

parcelRegister("5RwLN", function(module, exports) {

let $444b52694267927c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $444b52694267927c$var$load("6SaId").then(()=>parcelRequire('LXDBu'));

});

parcelRegister("6ssMp", function(module, exports) {

let $4b3baeae86cbf4a7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4b3baeae86cbf4a7$var$load("ccvnQ").then(()=>parcelRequire('c9O6m'));

});

parcelRegister("2DyhW", function(module, exports) {

let $1eb9d23d1e8930b1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1eb9d23d1e8930b1$var$load("aeErk").then(()=>parcelRequire('28QMN'));

});

parcelRegister("eJGkX", function(module, exports) {

let $02c4be62d03b2177$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $02c4be62d03b2177$var$load("gbNlu").then(()=>parcelRequire('8so3a'));

});

parcelRegister("iEFeQ", function(module, exports) {

let $d94bf37d2e15bb03$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d94bf37d2e15bb03$var$load("bvvfd").then(()=>parcelRequire('cKaxg'));

});

parcelRegister("gdXb1", function(module, exports) {

let $bcfbc38031999c23$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bcfbc38031999c23$var$load("yYZTe").then(()=>parcelRequire('oVpHS'));

});

parcelRegister("btDWB", function(module, exports) {

let $85b1633dd782a661$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $85b1633dd782a661$var$load("e14NZ").then(()=>parcelRequire('bptXN'));

});

parcelRegister("epQ3f", function(module, exports) {

let $a7ebc6caea37b28f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a7ebc6caea37b28f$var$load("bnXfh").then(()=>parcelRequire('d6lfc'));

});

parcelRegister("bvEBf", function(module, exports) {

let $8612153b926109da$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8612153b926109da$var$load("iWYiZ").then(()=>parcelRequire('kjqKG'));

});

parcelRegister("lKc2o", function(module, exports) {

let $fd473b3faa4b7b89$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd473b3faa4b7b89$var$load("5jvJa").then(()=>parcelRequire('8K7MZ'));

});

parcelRegister("l845G", function(module, exports) {

let $f61d84a01912f133$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f61d84a01912f133$var$load("h9ZsZ").then(()=>parcelRequire('9D3Wg'));

});

parcelRegister("3iqrU", function(module, exports) {

let $266791cea65de3a1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $266791cea65de3a1$var$load("8Qw0T").then(()=>parcelRequire('nEYSn'));

});

parcelRegister("feUt0", function(module, exports) {

let $b183f6f3ac30d8b9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b183f6f3ac30d8b9$var$load("eroFt").then(()=>parcelRequire('kqFte'));

});

parcelRegister("azXg3", function(module, exports) {

let $7b3b23a5715a505b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7b3b23a5715a505b$var$load("1VXoM").then(()=>parcelRequire('8YYHz'));

});

parcelRegister("f95aS", function(module, exports) {

let $b06bb5cc3c2e6447$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b06bb5cc3c2e6447$var$load("gmUcu").then(()=>parcelRequire('aJrGo'));

});

parcelRegister("acjNT", function(module, exports) {

let $76ca62f7424ef08c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $76ca62f7424ef08c$var$load("hDMsl").then(()=>parcelRequire('d5Wt5'));

});

parcelRegister("wsX9H", function(module, exports) {

let $061972c2a6365252$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $061972c2a6365252$var$load("7rPIb").then(()=>parcelRequire('8JbNx'));

});

parcelRegister("bwxzO", function(module, exports) {

let $863cba790b4b76fb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $863cba790b4b76fb$var$load("lNnZI").then(()=>parcelRequire('kU0T7'));

});

parcelRegister("h0zZD", function(module, exports) {

let $c61e5b3b401ef83b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c61e5b3b401ef83b$var$load("6dERU"),
    $c61e5b3b401ef83b$var$load("gd4qs"),
    $c61e5b3b401ef83b$var$load("7gF8f"),
    $c61e5b3b401ef83b$var$load("7nRXR")
]).then(()=>parcelRequire('04hGF'));

});

parcelRegister("050d6", function(module, exports) {

let $00f0a17ed095cc42$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $00f0a17ed095cc42$var$load("6AYT8").then(()=>parcelRequire('bKcVz'));

});

parcelRegister("8WAwv", function(module, exports) {

let $6830124000199ee3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6830124000199ee3$var$load("9GZ76").then(()=>parcelRequire('dbbA6'));

});

parcelRegister("cg82o", function(module, exports) {

let $8ecd36c33581c6b9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8ecd36c33581c6b9$var$load("ex4Yt").then(()=>parcelRequire('gHoLN'));

});

parcelRegister("e9ma2", function(module, exports) {

let $a4d318a20e7fee07$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a4d318a20e7fee07$var$load("6whrf").then(()=>parcelRequire('fKZKi'));

});

parcelRegister("5VQZM", function(module, exports) {

let $451b62648260e86c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $451b62648260e86c$var$load("exjK0").then(()=>parcelRequire('3japI'));

});

parcelRegister("5iEZp", function(module, exports) {

let $3dbe6dd9a4beb99e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3dbe6dd9a4beb99e$var$load("gmdLX").then(()=>parcelRequire('cF55v'));

});

parcelRegister("fxbQS", function(module, exports) {

let $b4f3219b6829d58b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b4f3219b6829d58b$var$load("5snOE").then(()=>parcelRequire('9Dgyh'));

});

parcelRegister("6I0P9", function(module, exports) {

let $4e277dc96a74ddbd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4e277dc96a74ddbd$var$load("g82cj").then(()=>parcelRequire('hwuOA'));

});

parcelRegister("lfeWx", function(module, exports) {

let $f77697153f79dc75$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f77697153f79dc75$var$load("kWbs6").then(()=>parcelRequire('hflsJ'));

});

parcelRegister("9dWma", function(module, exports) {

let $6b72985894f71c76$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6b72985894f71c76$var$load("a4IWt").then(()=>parcelRequire('fcP5z'));

});

parcelRegister("fHzgP", function(module, exports) {

let $b6e63b26afb5d8cc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b6e63b26afb5d8cc$var$load("lx0Mm").then(()=>parcelRequire('ldEQF'));

});

parcelRegister("cDAd5", function(module, exports) {

let $9335372448332839$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9335372448332839$var$load("jEOUT").then(()=>parcelRequire('zfyRh'));

});

parcelRegister("c2qzE", function(module, exports) {

let $8c3a48fc9c497eb8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8c3a48fc9c497eb8$var$load("80ztM").then(()=>parcelRequire('kkTYy'));

});

parcelRegister("iRv2R", function(module, exports) {

let $dbb54222095976bd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dbb54222095976bd$var$load("bxtFY").then(()=>parcelRequire('4xKLM'));

});

parcelRegister("5UMi9", function(module, exports) {

let $44e7a471fdcaf99d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $44e7a471fdcaf99d$var$load("aM92M").then(()=>parcelRequire('lM2nS'));

});

parcelRegister("6aAZE", function(module, exports) {

let $47e05f62f41ed0f5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $47e05f62f41ed0f5$var$load("fbz3S").then(()=>parcelRequire('bp2ak'));

});

parcelRegister("fM7Ta", function(module, exports) {

let $b7c175465981f4b6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b7c175465981f4b6$var$load("5V2x3").then(()=>parcelRequire('60bto'));

});

parcelRegister("a7m1s", function(module, exports) {

let $75dba40b6973bb23$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $75dba40b6973bb23$var$load("7JMo6").then(()=>parcelRequire('cCcsq'));

});

parcelRegister("clLDO", function(module, exports) {

let $8fdc66b6ac48c0fa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8fdc66b6ac48c0fa$var$load("fKuf2").then(()=>parcelRequire('dvmRd'));

});

parcelRegister("97QzI", function(module, exports) {

let $6a4d8cd2a9a32af3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6a4d8cd2a9a32af3$var$load("5Folx").then(()=>parcelRequire('cDvK1'));

});

parcelRegister("2PLo8", function(module, exports) {

let $21051a871355ecfb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $21051a871355ecfb$var$load("blNfJ").then(()=>parcelRequire('bcOcg'));

});

parcelRegister("1Vs2n", function(module, exports) {

let $1670dcf4156f92a1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1670dcf4156f92a1$var$load("c44jQ").then(()=>parcelRequire('5k5nc'));

});

parcelRegister("lbZj8", function(module, exports) {

let $f6da2e76792c8600$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f6da2e76792c8600$var$load("5dDBn").then(()=>parcelRequire('6NoQT'));

});

parcelRegister("ea9d1", function(module, exports) {

let $a4f92498b89b7c15$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a4f92498b89b7c15$var$load("9i3Cs").then(()=>parcelRequire('gbpRj'));

});

parcelRegister("dO2xL", function(module, exports) {

let $a0d1eafb080f3c55$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a0d1eafb080f3c55$var$load("38sfA"),
    $a0d1eafb080f3c55$var$load("h4OCL"),
    $a0d1eafb080f3c55$var$load("awkVi"),
    $a0d1eafb080f3c55$var$load("1510B")
]).then(()=>parcelRequire('eMsCn'));

});

parcelRegister("8G9rE", function(module, exports) {

let $651992930d2457db$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $651992930d2457db$var$load("gw63h").then(()=>parcelRequire('6eDlo'));

});

parcelRegister("dIi2g", function(module, exports) {

let $9fbd5fe5ede205fa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9fbd5fe5ede205fa$var$load("9yemY").then(()=>parcelRequire('7vmw8'));

});

parcelRegister("uisik", function(module, exports) {

let $05b11e4ed8c9d938$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $05b11e4ed8c9d938$var$load("dH4eU").then(()=>parcelRequire('8EREH'));

});

parcelRegister("5NWnj", function(module, exports) {

let $439ecf68da503ef0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $439ecf68da503ef0$var$load("k422C").then(()=>parcelRequire('Y851Q'));

});

parcelRegister("jfqzY", function(module, exports) {

let $e03409224a614e09$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e03409224a614e09$var$load("kaJUk").then(()=>parcelRequire('cSifk'));

});

parcelRegister("5TI31", function(module, exports) {

let $44b441bfa2aee5cf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $44b441bfa2aee5cf$var$load("gxipV").then(()=>parcelRequire('bG4aH'));

});

parcelRegister("9nMby", function(module, exports) {

let $6d4ba3a932601be6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6d4ba3a932601be6$var$load("8GjEG").then(()=>parcelRequire('lr7iY'));

});

parcelRegister("9rinz", function(module, exports) {

let $6df4e46a6599f151$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6df4e46a6599f151$var$load("2fZJm").then(()=>parcelRequire('fwp8v'));

});

parcelRegister("jisFM", function(module, exports) {

let $e0c5f096bd6e01ea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e0c5f096bd6e01ea$var$load("aWhd2").then(()=>parcelRequire('7TuuZ'));

});

parcelRegister("eFGuE", function(module, exports) {

let $aae5db4f67a27a55$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aae5db4f67a27a55$var$load("kFwKj").then(()=>parcelRequire('bjsPb'));

});

parcelRegister("lacx4", function(module, exports) {

let $f68440d2fbcff189$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f68440d2fbcff189$var$load("9thXI").then(()=>parcelRequire('9LIHd'));

});

parcelRegister("uKIDe", function(module, exports) {

let $05c70ad9bd4e3b6f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $05c70ad9bd4e3b6f$var$load("l5nPd").then(()=>parcelRequire('iy8ZX'));

});

parcelRegister("kj0ci", function(module, exports) {

let $ec85bc340d11c38b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ec85bc340d11c38b$var$load("84Qrl").then(()=>parcelRequire('fLr71'));

});

parcelRegister("7kMtP", function(module, exports) {

let $557001d19affdeb0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $557001d19affdeb0$var$load("f8xD9").then(()=>parcelRequire('b7VxC'));

});

parcelRegister("cC2jy", function(module, exports) {

let $92ead439b5f9efc2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $92ead439b5f9efc2$var$load("gjDHC").then(()=>parcelRequire('cRIcG'));

});

parcelRegister("dSUTO", function(module, exports) {

let $a1bc7486e2a85dde$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a1bc7486e2a85dde$var$load("26l9o").then(()=>parcelRequire('gvE09'));

});

parcelRegister("aUplc", function(module, exports) {

let $7f12ca8a8c9ce033$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7f12ca8a8c9ce033$var$load("1xw6j").then(()=>parcelRequire('l8fNN'));

});

parcelRegister("fUY2T", function(module, exports) {

let $b96aa9cb1daa06ae$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b96aa9cb1daa06ae$var$load("9d2MG").then(()=>parcelRequire('hK0fV'));

});

parcelRegister("kcy9I", function(module, exports) {

let $eb4f6c3eb374eb67$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $eb4f6c3eb374eb67$var$load("ryge4").then(()=>parcelRequire('eZIhV'));

});

parcelRegister("fiNSy", function(module, exports) {

let $b23f3a62e0f6f9d9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b23f3a62e0f6f9d9$var$load("cSFd6").then(()=>parcelRequire('wgY32'));

});

parcelRegister("b9CUD", function(module, exports) {

let $81eeb82ceb575b9f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $81eeb82ceb575b9f$var$load("kBThy").then(()=>parcelRequire('3ol7V'));

});

parcelRegister("aC9Z0", function(module, exports) {

let $7ba532650055df58$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7ba532650055df58$var$load("bVjPW").then(()=>parcelRequire('ca8zp'));

});

parcelRegister("isJ1l", function(module, exports) {

let $d70dc3b0a0270679$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d70dc3b0a0270679$var$load("1rD25").then(()=>parcelRequire('l6Hrk'));

});

parcelRegister("99NdS", function(module, exports) {

let $6aab22f3dea21bfd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6aab22f3dea21bfd$var$load("hLXEc").then(()=>parcelRequire('dHYwL'));

});

parcelRegister("cU1Dl", function(module, exports) {

let $964bfb65221c8dea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $964bfb65221c8dea$var$load("dlmud"),
    $964bfb65221c8dea$var$load("bNv64"),
    $964bfb65221c8dea$var$load("5CGnz"),
    $964bfb65221c8dea$var$load("jzbbz")
]).then(()=>parcelRequire('aeyZq'));

});

parcelRegister("052aG", function(module, exports) {

let $00f226e892b89e7d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $00f226e892b89e7d$var$load("bk3ho").then(()=>parcelRequire('ikUwV'));

});

parcelRegister("1uoWy", function(module, exports) {

let $115bf106d300a0ea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $115bf106d300a0ea$var$load("4sOIV").then(()=>parcelRequire('gVvM0'));

});

parcelRegister("gUgsy", function(module, exports) {

let $c4eea4d6d0650107$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c4eea4d6d0650107$var$load("7LVlm").then(()=>parcelRequire('5FLbD'));

});

parcelRegister("6IeAy", function(module, exports) {

let $4e322b1faa41bd12$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4e322b1faa41bd12$var$load("7ReuC").then(()=>parcelRequire('f9oto'));

});

parcelRegister("ikkuH", function(module, exports) {

let $d579fdf192632516$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d579fdf192632516$var$load("3L5cs").then(()=>parcelRequire('7xmMz'));

});

parcelRegister("4Lc6F", function(module, exports) {

let $3774f1500208ca94$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3774f1500208ca94$var$load("fcXn9").then(()=>parcelRequire('4IbNl'));

});

parcelRegister("amlTZ", function(module, exports) {

let $78acf2bcacc67ab8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $78acf2bcacc67ab8$var$load("gVlo8").then(()=>parcelRequire('hbela'));

});

parcelRegister("fjaBA", function(module, exports) {

let $b250db5d8094cbfd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b250db5d8094cbfd$var$load("5v6is").then(()=>parcelRequire('3KUUd'));

});

parcelRegister("9ArCD", function(module, exports) {

let $6face706b91f11f9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6face706b91f11f9$var$load("835WZ").then(()=>parcelRequire('73LWR'));

});

parcelRegister("e1nws", function(module, exports) {

let $a35367c557714ad2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a35367c557714ad2$var$load("2pBhR").then(()=>parcelRequire('liSWT'));

});

parcelRegister("5QfCV", function(module, exports) {

let $440dee40e7e59765$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $440dee40e7e59765$var$load("gLEw7").then(()=>parcelRequire('l4Hxk'));

});

parcelRegister("aJBry", function(module, exports) {

let $7d0b26cfd810d87f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7d0b26cfd810d87f$var$load("k3Zym").then(()=>parcelRequire('czXBj'));

});

parcelRegister("aRNuB", function(module, exports) {

let $7e953ed0d938aa69$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7e953ed0d938aa69$var$load("4PsHL").then(()=>parcelRequire('6xwuv'));

});

parcelRegister("4QRkk", function(module, exports) {

let $38856262b07658e9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $38856262b07658e9$var$load("9uyCS").then(()=>parcelRequire('fzGEY'));

});

parcelRegister("7ccAb", function(module, exports) {

let $53d36a0e84966819$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $53d36a0e84966819$var$load("iXiaJ").then(()=>parcelRequire('eS7e3'));

});

parcelRegister("cJtiJ", function(module, exports) {

let $94506a973b3362d4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $94506a973b3362d4$var$load("jkHNB").then(()=>parcelRequire('jxk0c'));

});

parcelRegister("2ouHI", function(module, exports) {

let $1be5a3de7696b337$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1be5a3de7696b337$var$load("eemhl").then(()=>parcelRequire('2ZKr3'));

});

parcelRegister("lLJFj", function(module, exports) {

let $fd9168f33d103440$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd9168f33d103440$var$load("4xwNi").then(()=>parcelRequire('uuhdj'));

});

parcelRegister("dymXa", function(module, exports) {

let $9de0415e149b0164$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9de0415e149b0164$var$load("iwieb").then(()=>parcelRequire('hrMGD'));

});

parcelRegister("5L4jp", function(module, exports) {

let $4314afd3bf5fbac1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4314afd3bf5fbac1$var$load("jixLg").then(()=>parcelRequire('f16xs'));

});

parcelRegister("9wcaq", function(module, exports) {

let $6ee08a5d99f72bc0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6ee08a5d99f72bc0$var$load("1U0vr").then(()=>parcelRequire('ezzhj'));

});

parcelRegister("9Bq5s", function(module, exports) {

let $6fdbce1309cda5fe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6fdbce1309cda5fe$var$load("fX2zx").then(()=>parcelRequire('8R1NN'));

});

parcelRegister("dy1gf", function(module, exports) {

let $9dcf6dc1d45760a4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9dcf6dc1d45760a4$var$load("azoml").then(()=>parcelRequire('4McjS'));

});

parcelRegister("2mrAN", function(module, exports) {

let $1b830a25d990ec44$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1b830a25d990ec44$var$load("ghi6m").then(()=>parcelRequire('7QWuh'));

});

parcelRegister("aYBII", function(module, exports) {

let $7fdcc46db0e4c9e5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7fdcc46db0e4c9e5$var$load("bjmre"),
    $7fdcc46db0e4c9e5$var$load("bcQs2"),
    $7fdcc46db0e4c9e5$var$load("11DLa"),
    $7fdcc46db0e4c9e5$var$load("aNQmP")
]).then(()=>parcelRequire('h0KE6'));

});

parcelRegister("9eps3", function(module, exports) {

let $6b892a013e698c27$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6b892a013e698c27$var$load("aq7Lk").then(()=>parcelRequire('bq6h7'));

});

parcelRegister("7WWVt", function(module, exports) {

let $5c9ba8ad3ed9d184$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5c9ba8ad3ed9d184$var$load("iRKhU").then(()=>parcelRequire('j6Zgo'));

});

parcelRegister("eHYnE", function(module, exports) {

let $ab53eb23abf86b50$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ab53eb23abf86b50$var$load("hPHXQ").then(()=>parcelRequire('aSfKa'));

});

parcelRegister("5R0Hw", function(module, exports) {

let $4432722b943faba4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4432722b943faba4$var$load("4IXyQ").then(()=>parcelRequire('6b5RU'));

});

parcelRegister("2PVHC", function(module, exports) {

let $210d1ab923d62ecb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $210d1ab923d62ecb$var$load("47OwM").then(()=>parcelRequire('5RjyS'));

});

parcelRegister("3wM1g", function(module, exports) {

let $29199bea97a19505$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $29199bea97a19505$var$load("Xi5AP").then(()=>parcelRequire('jwd3r'));

});

parcelRegister("iI6oQ", function(module, exports) {

let $d9f14ce3e2802d86$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d9f14ce3e2802d86$var$load("kzoZ8").then(()=>parcelRequire('ejnrO'));

});

parcelRegister("g2dyA", function(module, exports) {

let $bac7595d327e3793$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bac7595d327e3793$var$load("gpKR3").then(()=>parcelRequire('4iWHF'));

});

parcelRegister("7HQR9", function(module, exports) {

let $59c58cb1cb3df280$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $59c58cb1cb3df280$var$load("igUcR").then(()=>parcelRequire('lRfBG'));

});

parcelRegister("afK7E", function(module, exports) {

let $776f150fd24c6690$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $776f150fd24c6690$var$load("04NrR").then(()=>parcelRequire('UK5pP'));

});

parcelRegister("2911k", function(module, exports) {

let $18fd36b1e1534473$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $18fd36b1e1534473$var$load("3nUFq").then(()=>parcelRequire('9ikOx'));

});

parcelRegister("bohce", function(module, exports) {

let $84af466f6ebac95f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $84af466f6ebac95f$var$load("j6vMO").then(()=>parcelRequire('2mD47'));

});

parcelRegister("dYRKa", function(module, exports) {

let $a2da915020b4b8ed$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a2da915020b4b8ed$var$load("dKfLu").then(()=>parcelRequire('98QTw'));

});

parcelRegister("jbwij", function(module, exports) {

let $df78185eb6e145b0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $df78185eb6e145b0$var$load("4ivpv").then(()=>parcelRequire('37Hue'));

});

parcelRegister("2ew9N", function(module, exports) {

let $1a05d5433be5665d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1a05d5433be5665d$var$load("gqMsh").then(()=>parcelRequire('kwT2K'));

});

parcelRegister("3IuV6", function(module, exports) {

let $2b4d773d48d88647$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2b4d773d48d88647$var$load("fRZ3Z").then(()=>parcelRequire('fmlyw'));

});

parcelRegister("51SFD", function(module, exports) {

let $3a97743176aa282b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3a97743176aa282b$var$load("h4SIy").then(()=>parcelRequire('cpwql'));

});

parcelRegister("5hAQr", function(module, exports) {

let $3d8b1ee6f21e2864$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3d8b1ee6f21e2864$var$load("e86yh").then(()=>parcelRequire('6CcyL'));

});

parcelRegister("jNqQk", function(module, exports) {

let $e6976a63f3155fc9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e6976a63f3155fc9$var$load("2dAGH").then(()=>parcelRequire('3x2ID'));

});

parcelRegister("e0AZ1", function(module, exports) {

let $a32dc0de1a5984b3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a32dc0de1a5984b3$var$load("e6JD1").then(()=>parcelRequire('lpVqo'));

});

parcelRegister("hiy3e", function(module, exports) {

let $c97e87edb120203a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c97e87edb120203a$var$load("dyRLq").then(()=>parcelRequire('fmx3D'));

});

parcelRegister("iGHPK", function(module, exports) {

let $d9ae26b4f67aa3cc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d9ae26b4f67aa3cc$var$load("7gYaw").then(()=>parcelRequire('gpo11'));

});

parcelRegister("6i0Xl", function(module, exports) {

let $49452a6017b1435b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $49452a6017b1435b$var$load("hBhTm").then(()=>parcelRequire('egjZu'));

});

parcelRegister("9uIfZ", function(module, exports) {

let $6e993ee03b4244ae$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6e993ee03b4244ae$var$load("azr0k").then(()=>parcelRequire('k36HF'));

});

parcelRegister("cFWVV", function(module, exports) {

let $93a7075098c2a4ed$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $93a7075098c2a4ed$var$load("3fuR9"),
    $93a7075098c2a4ed$var$load("gZU54"),
    $93a7075098c2a4ed$var$load("2bqSD"),
    $93a7075098c2a4ed$var$load("6ScwG")
]).then(()=>parcelRequire('bHXNj'));

});

parcelRegister("3HVCY", function(module, exports) {

let $2b3216e4dd71c7ce$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2b3216e4dd71c7ce$var$load("aU943").then(()=>parcelRequire('10YMd'));

});

parcelRegister("7gPYo", function(module, exports) {

let $54b257d03ce13df9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $54b257d03ce13df9$var$load("aGECO").then(()=>parcelRequire('f4Sbd'));

});

parcelRegister("l32Fs", function(module, exports) {

let $f52bf28641adece6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f52bf28641adece6$var$load("9seb7").then(()=>parcelRequire('dXB7R'));

});

parcelRegister("hw2EA", function(module, exports) {

let $cc077bc77b5c18d1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cc077bc77b5c18d1$var$load("i6pHp").then(()=>parcelRequire('6CqDX'));

});

parcelRegister("cXGMq", function(module, exports) {

let $96fc2df6e25b9da4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $96fc2df6e25b9da4$var$load("eoyTp").then(()=>parcelRequire('iMa2r'));

});

parcelRegister("baosp", function(module, exports) {

let $8213999802e296ce$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8213999802e296ce$var$load("f7XHA").then(()=>parcelRequire('c2Dmg'));

});

parcelRegister("9ZE3h", function(module, exports) {

let $7468e106e7d6d522$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7468e106e7d6d522$var$load("f7rvX").then(()=>parcelRequire('90He8'));

});

parcelRegister("hPQok", function(module, exports) {

let $cfbfd6f1b90a20a9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cfbfd6f1b90a20a9$var$load("gTAsO").then(()=>parcelRequire('irrHX'));

});

parcelRegister("khZjr", function(module, exports) {

let $ec54f497b7c872cb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ec54f497b7c872cb$var$load("3WLlm").then(()=>parcelRequire('7MEzT'));

});

parcelRegister("ehEc4", function(module, exports) {

let $a661d4d8c95ae67f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a661d4d8c95ae67f$var$load("7pJGx").then(()=>parcelRequire('hqDaz'));

});

parcelRegister("1QHTg", function(module, exports) {

let $158cb17ab3f23654$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $158cb17ab3f23654$var$load("cs3js").then(()=>parcelRequire('cwiJf'));

});

parcelRegister("4wYVR", function(module, exports) {

let $34c96a76cd4d41c7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $34c96a76cd4d41c7$var$load("aEAsN").then(()=>parcelRequire('cLN01'));

});

parcelRegister("fttbp", function(module, exports) {

let $b440339277178221$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b440339277178221$var$load("e8MPB").then(()=>parcelRequire('dLctv'));

});

parcelRegister("gIhfm", function(module, exports) {

let $c2ae2245dd66e6f1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c2ae2245dd66e6f1$var$load("lAVaN").then(()=>parcelRequire('5UaLs'));

});

parcelRegister("1HmJw", function(module, exports) {

let $13cb70edd26c651d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $13cb70edd26c651d$var$load("d8clW").then(()=>parcelRequire('4layl'));

});

parcelRegister("27l7W", function(module, exports) {

let $18ac9f9efec4e409$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $18ac9f9efec4e409$var$load("lsFbX").then(()=>parcelRequire('fkCIe'));

});

parcelRegister("60clV", function(module, exports) {

let $45ec53210feb8133$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $45ec53210feb8133$var$load("fmjUN").then(()=>parcelRequire('kCmuH'));

});

parcelRegister("74L0N", function(module, exports) {

let $526d5fb0dfcc681a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $526d5fb0dfcc681a$var$load("54RZ3").then(()=>parcelRequire('3QY0x'));

});

parcelRegister("5cdzk", function(module, exports) {

let $3c88993e98a2d661$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3c88993e98a2d661$var$load("clhk4").then(()=>parcelRequire('hZouV'));

});

parcelRegister("iZ5iH", function(module, exports) {

let $dd220917d7984cb4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dd220917d7984cb4$var$load("c9Q8k").then(()=>parcelRequire('cKyEk'));

});

parcelRegister("i1MUo", function(module, exports) {

let $d1fe4232cf3d3cb2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d1fe4232cf3d3cb2$var$load("2qNkd").then(()=>parcelRequire('jl05c'));

});

parcelRegister("dRfgA", function(module, exports) {

let $a16c113017ff9cf1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a16c113017ff9cf1$var$load("gzPTb").then(()=>parcelRequire('kOCLQ'));

});

parcelRegister("2x6Z7", function(module, exports) {

let $1d8414dbe1a7ebce$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1d8414dbe1a7ebce$var$load("8tkSL").then(()=>parcelRequire('6yXvq'));

});

parcelRegister("juV8T", function(module, exports) {

let $e31d24f6ba940758$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e31d24f6ba940758$var$load("1er33").then(()=>parcelRequire('hklRK'));

});

parcelRegister("1zoxv", function(module, exports) {

let $124c185665a2b3a8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $124c185665a2b3a8$var$load("egSUp").then(()=>parcelRequire('7vli6'));

});

parcelRegister("3OI3f", function(module, exports) {

let $2c78364edcd5b575$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2c78364edcd5b575$var$load("ePgeS").then(()=>parcelRequire('6ztoV'));

});

parcelRegister("lwMRo", function(module, exports) {

let $fac27cc41d1ec9a9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fac27cc41d1ec9a9$var$load("kLFgm").then(()=>parcelRequire('dOK5O'));

});

parcelRegister("fIrHf", function(module, exports) {

let $b710730ca3e891a4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b710730ca3e891a4$var$load("7VrSQ").then(()=>parcelRequire('8CgL0'));

});

parcelRegister("bP8rP", function(module, exports) {

let $89bb02ae897eb70b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $89bb02ae897eb70b$var$load("04oBT").then(()=>parcelRequire('bLb11'));

});

parcelRegister("g7XdA", function(module, exports) {

let $bbdb3c4c3780a4ce$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bbdb3c4c3780a4ce$var$load("axxbu").then(()=>parcelRequire('2nJpt'));

});

parcelRegister("7mSAq", function(module, exports) {

let $55d4ee3b87336ff5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $55d4ee3b87336ff5$var$load("HKJjo").then(()=>parcelRequire('ksOte'));

});

parcelRegister("bmkl7", function(module, exports) {

let $845186c98950fb3a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $845186c98950fb3a$var$load("hs3S4").then(()=>parcelRequire('epI6x'));

});

parcelRegister("jJ7l5", function(module, exports) {

let $e5c7e9aeceaa6a15$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e5c7e9aeceaa6a15$var$load("5uCUY").then(()=>parcelRequire('1ot39'));

});

parcelRegister("hy82D", function(module, exports) {

let $cc6bd98a001b8b66$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cc6bd98a001b8b66$var$load("2BPbN").then(()=>parcelRequire('40eED'));

});

parcelRegister("3vcsV", function(module, exports) {

let $28cdefc2c12ccaf4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $28cdefc2c12ccaf4$var$load("fMrUo"),
    $28cdefc2c12ccaf4$var$load("4Wdqb"),
    $28cdefc2c12ccaf4$var$load("bJykp"),
    $28cdefc2c12ccaf4$var$load("6xeV7")
]).then(()=>parcelRequire('lX1JT'));

});

parcelRegister("9FTnw", function(module, exports) {

let $70b2e6659b33dc55$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $70b2e6659b33dc55$var$load("aHiPU").then(()=>parcelRequire('1cvAC'));

});

parcelRegister("7QJBL", function(module, exports) {

let $5b70c492c2b7681a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5b70c492c2b7681a$var$load("2Fu3d").then(()=>parcelRequire('15Tdz'));

});

parcelRegister("izS0M", function(module, exports) {

let $d865647a1c0c2a50$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d865647a1c0c2a50$var$load("bxTaA").then(()=>parcelRequire('cg8m4'));

});

parcelRegister("jIlmn", function(module, exports) {

let $e5a2b204981d6633$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e5a2b204981d6633$var$load("aoOfm").then(()=>parcelRequire('ebQs8'));

});

parcelRegister("hYGHc", function(module, exports) {

let $d16928c1950ff27f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d16928c1950ff27f$var$load("6YsGz").then(()=>parcelRequire('8rMrl'));

});

parcelRegister("kYvyU", function(module, exports) {

let $f451e4d1425dc0ef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f451e4d1425dc0ef$var$load("3qzeo").then(()=>parcelRequire('biDFC'));

});

parcelRegister("jHQ1x", function(module, exports) {

let $e58a6356818b9f60$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e58a6356818b9f60$var$load("dRBqK").then(()=>parcelRequire('djvs6'));

});

parcelRegister("kfj3Z", function(module, exports) {

let $ebd3feec05b2e374$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ebd3feec05b2e374$var$load("6NGzB").then(()=>parcelRequire('7HAe3'));

});

parcelRegister("b3P8q", function(module, exports) {

let $80d7a3dc02cd992d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $80d7a3dc02cd992d$var$load("b39oP").then(()=>parcelRequire('5CXR9'));

});

parcelRegister("kMh6x", function(module, exports) {

let $f2058eeb602818d5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f2058eeb602818d5$var$load("e73cP").then(()=>parcelRequire('5KGDH'));

});

parcelRegister("2Rl0Q", function(module, exports) {

let $2150d4af5a071b25$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2150d4af5a071b25$var$load("dFfpO").then(()=>parcelRequire('bZDTF'));

});

parcelRegister("b8GJy", function(module, exports) {

let $81c1971c80fbf34c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $81c1971c80fbf34c$var$load("eaI3o").then(()=>parcelRequire('f2JIn'));

});

parcelRegister("afEXy", function(module, exports) {

let $776b13ceb6c807b3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $776b13ceb6c807b3$var$load("Wtwkp").then(()=>parcelRequire('gWtu0'));

});

parcelRegister("82exJ", function(module, exports) {

let $5d99ca9806ed97ef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5d99ca9806ed97ef$var$load("ecT6J").then(()=>parcelRequire('2lvJW'));

});

parcelRegister("lgQhX", function(module, exports) {

let $f7c3a705f838de06$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f7c3a705f838de06$var$load("kQFf3").then(()=>parcelRequire('baR74'));

});

parcelRegister("lC3Ox", function(module, exports) {

let $fbc01af8da7f7146$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fbc01af8da7f7146$var$load("dhHRl").then(()=>parcelRequire('2jHH0'));

});

parcelRegister("gUqya", function(module, exports) {

let $c4f678947de4a49d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c4f678947de4a49d$var$load("5obLj").then(()=>parcelRequire('lFb12'));

});

parcelRegister("ioAUA", function(module, exports) {

let $d64719c9af71b62a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d64719c9af71b62a$var$load("4Lql5").then(()=>parcelRequire('iZn0V'));

});

parcelRegister("38UgP", function(module, exports) {

let $249dc49472fe271f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $249dc49472fe271f$var$load("bvmfY").then(()=>parcelRequire('4eVVU'));

});

parcelRegister("uh65x", function(module, exports) {

let $05b0109ac0686d7c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $05b0109ac0686d7c$var$load("kHuTn").then(()=>parcelRequire('93jah'));

});

parcelRegister("aY5is", function(module, exports) {

let $7fc39dce59820249$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7fc39dce59820249$var$load("lKWyW").then(()=>parcelRequire('4dfVD'));

});

parcelRegister("enWze", function(module, exports) {

let $a790a4e98b23afce$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a790a4e98b23afce$var$load("aA0V9").then(()=>parcelRequire('bO2d0'));

});

parcelRegister("5WMIw", function(module, exports) {

let $454828bd1bda5b28$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $454828bd1bda5b28$var$load("bUqpo").then(()=>parcelRequire('4Speu'));

});

parcelRegister("40zYz", function(module, exports) {

let $2eb3119bc6f56dc4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2eb3119bc6f56dc4$var$load("D1MVU").then(()=>parcelRequire('3CzqR'));

});

parcelRegister("iQpqH", function(module, exports) {

let $db80cf2404d13daf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $db80cf2404d13daf$var$load("deyvi"),
    $db80cf2404d13daf$var$load("4UPfH"),
    $db80cf2404d13daf$var$load("cdeuH"),
    $db80cf2404d13daf$var$load("c2KB7")
]).then(()=>parcelRequire('aU3fj'));

});

parcelRegister("ft2jx", function(module, exports) {

let $b42b5bf925c3de9a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b42b5bf925c3de9a$var$load("jREyT").then(()=>parcelRequire('7txW8'));

});

parcelRegister("k7ijU", function(module, exports) {

let $ea52ac19f0fe792e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ea52ac19f0fe792e$var$load("5IaSN").then(()=>parcelRequire('aeGBk'));

});

parcelRegister("78pPO", function(module, exports) {

let $531d51f77ef6823e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $531d51f77ef6823e$var$load("9l6Gt").then(()=>parcelRequire('a2bAW'));

});

parcelRegister("3iSuO", function(module, exports) {

let $267d534a92a52720$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $267d534a92a52720$var$load("jdrxF").then(()=>parcelRequire('lTO3M'));

});

parcelRegister("24KSE", function(module, exports) {

let $183051f90dcbaee2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $183051f90dcbaee2$var$load("a3In5").then(()=>parcelRequire('jd2D8'));

});

parcelRegister("8qBjl", function(module, exports) {

let $622db1a01d34260d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $622db1a01d34260d$var$load("3uZ1q").then(()=>parcelRequire('kVRsY'));

});

parcelRegister("ZF7IX", function(module, exports) {

let $0b9598e832fe9235$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0b9598e832fe9235$var$load("ashmf").then(()=>parcelRequire('axlpK'));

});

parcelRegister("8J3T9", function(module, exports) {

let $65a58ae00b857d2d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $65a58ae00b857d2d$var$load("fGPCC").then(()=>parcelRequire('d9A0j'));

});

parcelRegister("fd6VN", function(module, exports) {

let $b12d725186f3e4c3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b12d725186f3e4c3$var$load("aEoU0").then(()=>parcelRequire('3rara'));

});

parcelRegister("1nUJE", function(module, exports) {

let $1023f2dec81ecc5f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1023f2dec81ecc5f$var$load("1SX98").then(()=>parcelRequire('aM2eo'));

});

parcelRegister("edZ3Q", function(module, exports) {

let $a5b1a50d1e1bd882$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a5b1a50d1e1bd882$var$load("7snhF"),
    $a5b1a50d1e1bd882$var$load("bAoKR"),
    $a5b1a50d1e1bd882$var$load("X0Jic"),
    $a5b1a50d1e1bd882$var$load("96wGb")
]).then(()=>parcelRequire('H1FjW'));

});

parcelRegister("hxDCF", function(module, exports) {

let $cc5440f42c6448d6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cc5440f42c6448d6$var$load("bqlNZ").then(()=>parcelRequire('13mkU'));

});

parcelRegister("7LPfq", function(module, exports) {

let $5a84acf3f3ec1858$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5a84acf3f3ec1858$var$load("l2LZP").then(()=>parcelRequire('iDsnj'));

});

parcelRegister("2Mx0J", function(module, exports) {

let $2069abbe90e2dda4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2069abbe90e2dda4$var$load("5xy7Q").then(()=>parcelRequire('heDdi'));

});

parcelRegister("lKpUB", function(module, exports) {

let $fd51fe710d65e9f5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd51fe710d65e9f5$var$load("fiSRo").then(()=>parcelRequire('5AWOx'));

});

parcelRegister("bkzFU", function(module, exports) {

let $83fd3c48e93dac3b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $83fd3c48e93dac3b$var$load("20cfO").then(()=>parcelRequire('cCPXp'));

});

parcelRegister("2lyk6", function(module, exports) {

let $1b582acfad5d89c6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1b582acfad5d89c6$var$load("ardvv").then(()=>parcelRequire('FrZOj'));

});

parcelRegister("4V2aC", function(module, exports) {

let $394e2b45d6ad770f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $394e2b45d6ad770f$var$load("6ZYJY").then(()=>parcelRequire('eqTvU'));

});

parcelRegister("lLR47", function(module, exports) {

let $fd97266f09d5d290$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd97266f09d5d290$var$load("kCB37").then(()=>parcelRequire('eVNA1'));

});

parcelRegister("97RNW", function(module, exports) {

let $6a4e80fab7faaad4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6a4e80fab7faaad4$var$load("j7gH4").then(()=>parcelRequire('ezgWl'));

});

parcelRegister("llBJ6", function(module, exports) {

let $f8a8d2cfcff80ccb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f8a8d2cfcff80ccb$var$load("4wcKM").then(()=>parcelRequire('5RTxu'));

});

parcelRegister("6wOJe", function(module, exports) {

let $4c0d14da5af154b6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4c0d14da5af154b6$var$load("3BhSB").then(()=>parcelRequire('4Nitg'));

});

parcelRegister("kWhvL", function(module, exports) {

let $f3e6ced556c825e9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f3e6ced556c825e9$var$load("31wqh").then(()=>parcelRequire('jMzcV'));

});

parcelRegister("9pBPk", function(module, exports) {

let $6da3ca7624b03d10$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6da3ca7624b03d10$var$load("2wnUX").then(()=>parcelRequire('hK1FZ'));

});

parcelRegister("it7MS", function(module, exports) {

let $d720f9d79bb4ad98$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d720f9d79bb4ad98$var$load("emEdI").then(()=>parcelRequire('4bz8w'));

});

parcelRegister("2Td4v", function(module, exports) {

let $21aadb949299350c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $21aadb949299350c$var$load("fayjw").then(()=>parcelRequire('6d4D9'));

});

parcelRegister("7gckx", function(module, exports) {

let $54939791fb5841de$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $54939791fb5841de$var$load("jRG5y").then(()=>parcelRequire('hBKGT'));

});

parcelRegister("hZbNa", function(module, exports) {

let $d18147d3476b273c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d18147d3476b273c$var$load("dYQOj").then(()=>parcelRequire('dGr1q'));

});

parcelRegister("bjIwm", function(module, exports) {

let $83d400fbf48f3612$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $83d400fbf48f3612$var$load("kwJBr").then(()=>parcelRequire('3tyT4'));

});

parcelRegister("kiJsA", function(module, exports) {

let $ec78c080c0b45315$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ec78c080c0b45315$var$load("co6o3").then(()=>parcelRequire('3xLyL'));

});

parcelRegister("acjoO", function(module, exports) {

let $76ca12a2fab5d944$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $76ca12a2fab5d944$var$load("jSkUD").then(()=>parcelRequire('6bp4T'));

});

parcelRegister("djtW4", function(module, exports) {

let $9b144552badb310a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9b144552badb310a$var$load("aLH2u").then(()=>parcelRequire('kMgpE'));

});

parcelRegister("4SbVS", function(module, exports) {

let $38c5761b58360e97$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $38c5761b58360e97$var$load("h0Ttl").then(()=>parcelRequire('ghn9b'));

});

parcelRegister("3MmWY", function(module, exports) {

let $2c07a83ba1ca09e9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2c07a83ba1ca09e9$var$load("7zhvV").then(()=>parcelRequire('e150h'));

});

parcelRegister("8WSqS", function(module, exports) {

let $683df6ac8b2e373a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $683df6ac8b2e373a$var$load("5LzDa").then(()=>parcelRequire('gfrgP'));

});

parcelRegister("dXz34", function(module, exports) {

let $a29bf8fa073431e4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a29bf8fa073431e4$var$load("cbkj0"),
    $a29bf8fa073431e4$var$load("4Afgd"),
    $a29bf8fa073431e4$var$load("9Oxgj"),
    $a29bf8fa073431e4$var$load("1umAM")
]).then(()=>parcelRequire('4l1gQ'));

});

parcelRegister("hPPdp", function(module, exports) {

let $cfbeed5b04cabb34$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cfbeed5b04cabb34$var$load("cLbW0").then(()=>parcelRequire('lHFFD'));

});

parcelRegister("6Bmmn", function(module, exports) {

let $4ce78afc732c9fee$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4ce78afc732c9fee$var$load("ik6u5").then(()=>parcelRequire('iy7L3'));

});

parcelRegister("9z5Am", function(module, exports) {

let $6f6bb715d8a1782d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6f6bb715d8a1782d$var$load("erKNi").then(()=>parcelRequire('1a3n4'));

});

parcelRegister("2BOtK", function(module, exports) {

let $1e663186808e44b1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1e663186808e44b1$var$load("gmfK3").then(()=>parcelRequire('bgYxE'));

});

parcelRegister("lii1M", function(module, exports) {

let $f809435209075d4b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f809435209075d4b$var$load("7mKaC").then(()=>parcelRequire('8QBWd'));

});

parcelRegister("jIHc6", function(module, exports) {

let $e5b3a1da0ad9ac72$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e5b3a1da0ad9ac72$var$load("2mWUI").then(()=>parcelRequire('alG1N'));

});

parcelRegister("lLcTT", function(module, exports) {

let $fd77fe871db9b89b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd77fe871db9b89b$var$load("jeWFw").then(()=>parcelRequire('dsU2O'));

});

parcelRegister("a79ug", function(module, exports) {

let $75d1eac66e5e5e41$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $75d1eac66e5e5e41$var$load("dZ90g").then(()=>parcelRequire('9AIXr'));

});

parcelRegister("29A9z", function(module, exports) {

let $19187755496d6ea6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $19187755496d6ea6$var$load("9i8rS").then(()=>parcelRequire('bVNwo'));

});

parcelRegister("dM9Cx", function(module, exports) {

let $a077387c6795a016$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a077387c6795a016$var$load("3ggW0").then(()=>parcelRequire('tPMRe'));

});

parcelRegister("2ro7o", function(module, exports) {

let $1c70cfc2ef1ee6b5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1c70cfc2ef1ee6b5$var$load("g1qy9").then(()=>parcelRequire('jgi8A'));

});

parcelRegister("cnrtE", function(module, exports) {

let $902cf26810d77127$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $902cf26810d77127$var$load("ijCL9").then(()=>parcelRequire('6sVCc'));

});

parcelRegister("1nKWI", function(module, exports) {

let $101c5aec1eae9110$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $101c5aec1eae9110$var$load("4wBPg").then(()=>parcelRequire('3HHVh'));

});

parcelRegister("dyKcw", function(module, exports) {

let $9df249e3f0fdec8a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9df249e3f0fdec8a$var$load("6Yt6G").then(()=>parcelRequire('iUnd5'));

});

parcelRegister("8aT67", function(module, exports) {

let $5f39ff29b4f4368b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5f39ff29b4f4368b$var$load("7ZpSz").then(()=>parcelRequire('dQsky'));

});

parcelRegister("5nPle", function(module, exports) {

let $3eb6ed0c9b01818e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3eb6ed0c9b01818e$var$load("dNsXx").then(()=>parcelRequire('dQnsk'));

});

parcelRegister("jQQxR", function(module, exports) {

let $e73ba20b36f8f680$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e73ba20b36f8f680$var$load("izzBN").then(()=>parcelRequire('fzCrs'));

});

parcelRegister("8mI7e", function(module, exports) {

let $6172993f016f9573$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6172993f016f9573$var$load("dDLJP").then(()=>parcelRequire('60sfA'));

});

parcelRegister("tPOzk", function(module, exports) {

let $059ae6da748f8686$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $059ae6da748f8686$var$load("2t4Zn").then(()=>parcelRequire('hZrdz'));

});

parcelRegister("dekF0", function(module, exports) {

let $9a1c9be385340215$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9a1c9be385340215$var$load("94GxG").then(()=>parcelRequire('4NJ4u'));

});

parcelRegister("f741a", function(module, exports) {

let $b00aa053c84f637c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b00aa053c84f637c$var$load("1DFOb").then(()=>parcelRequire('dMw6u'));

});

parcelRegister("6SuyL", function(module, exports) {

let $501f7db9c550e51d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $501f7db9c550e51d$var$load("cZW0M").then(()=>parcelRequire('k5UMG'));

});

parcelRegister("fs0nj", function(module, exports) {

let $b3f9c30397507d4b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b3f9c30397507d4b$var$load("ayf3G").then(()=>parcelRequire('3nfCl'));

});

parcelRegister("wZG89", function(module, exports) {

let $0632d5580eaa1819$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0632d5580eaa1819$var$load("ecN0e").then(()=>parcelRequire('56nbu'));

});

parcelRegister("k4A0F", function(module, exports) {

let $e9d01d28cafb7a35$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e9d01d28cafb7a35$var$load("b4NO6"),
    $e9d01d28cafb7a35$var$load("3fLE9"),
    $e9d01d28cafb7a35$var$load("fM2oh"),
    $e9d01d28cafb7a35$var$load("iBUpc")
]).then(()=>parcelRequire('bq2TL'));

});

parcelRegister("2f0RK", function(module, exports) {

let $1a1da7739c5bee3a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1a1da7739c5bee3a$var$load("hThVo").then(()=>parcelRequire('192bY'));

});

parcelRegister("2zsrj", function(module, exports) {

let $1df4e926bd6575eb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1df4e926bd6575eb$var$load("fModo").then(()=>parcelRequire('gptiB'));

});

parcelRegister("iAcm7", function(module, exports) {

let $d8752c6621b71fea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d8752c6621b71fea$var$load("29Sce").then(()=>parcelRequire('lQyzT'));

});

parcelRegister("4T24m", function(module, exports) {

let $38ede7656b026bbf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $38ede7656b026bbf$var$load("7oe66").then(()=>parcelRequire('3Uagz'));

});

parcelRegister("2X7B6", function(module, exports) {

let $2266fc28ded106b8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2266fc28ded106b8$var$load("dhDvQ").then(()=>parcelRequire('02tsy'));

});

parcelRegister("e50q8", function(module, exports) {

let $a401dbd04565e952$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a401dbd04565e952$var$load("eUCJv").then(()=>parcelRequire('3TUMy'));

});

parcelRegister("86QJP", function(module, exports) {

let $5e77cafa8c889f00$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5e77cafa8c889f00$var$load("4aeSx").then(()=>parcelRequire('1rOkd'));

});

parcelRegister("68BCL", function(module, exports) {

let $4780accfc9c6ea3b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4780accfc9c6ea3b$var$load("hp6cH").then(()=>parcelRequire('ed6qk'));

});

parcelRegister("cjoOp", function(module, exports) {

let $8f6a81906d14d53d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8f6a81906d14d53d$var$load("Vt6S9").then(()=>parcelRequire('1kxh5'));

});

parcelRegister("imVGY", function(module, exports) {

let $037377e106b21b0c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $037377e106b21b0c$var$load("8o2F8").then(()=>parcelRequire('9TMai'));

});

parcelRegister("inHPn", function(module, exports) {

let $d61c5f3ba413b87f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d61c5f3ba413b87f$var$load("elU5E").then(()=>parcelRequire('eqHnL'));

});

parcelRegister("esmiq", function(module, exports) {

let $a864f9cb82652eac$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a864f9cb82652eac$var$load("l1TvY").then(()=>parcelRequire('eMqDh'));

});

parcelRegister("7LxwD", function(module, exports) {

let $5a76eda6816639e5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5a76eda6816639e5$var$load("dBvXj").then(()=>parcelRequire('gSUUF'));

});

parcelRegister("9vEnc", function(module, exports) {

let $6ec65399f9c8a3f7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6ec65399f9c8a3f7$var$load("8smjP").then(()=>parcelRequire('jTJ2Q'));

});

parcelRegister("85VUv", function(module, exports) {

let $5e4bb621999cb9a9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5e4bb621999cb9a9$var$load("8lrgl").then(()=>parcelRequire('aHso4'));

});

parcelRegister("6rHuX", function(module, exports) {

let $4b1701886ed24159$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4b1701886ed24159$var$load("dJLWv").then(()=>parcelRequire('lxZVf'));

});

parcelRegister("lrVwc", function(module, exports) {

let $f9d8bc8f7482d39e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f9d8bc8f7482d39e$var$load("5sbZB").then(()=>parcelRequire('bVayQ'));

});

parcelRegister("cv1H3", function(module, exports) {

let $9199b195b3026688$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9199b195b3026688$var$load("4fQoC").then(()=>parcelRequire('cmmhC'));

});

parcelRegister("8vzwd", function(module, exports) {

let $631cc5399375974a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $631cc5399375974a$var$load("iyvFv").then(()=>parcelRequire('lCr2G'));

});

parcelRegister("CgdQB", function(module, exports) {

let $07302224e62aa815$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $07302224e62aa815$var$load("92vLy").then(()=>parcelRequire('5lALU'));

});

parcelRegister("aWoGl", function(module, exports) {

let $7f72777f8630fbe9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7f72777f8630fbe9$var$load("7UntI").then(()=>parcelRequire('6DFbP'));

});

parcelRegister("eQODJ", function(module, exports) {

let $acfd3404c2ecc92c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $acfd3404c2ecc92c$var$load("9tVCu").then(()=>parcelRequire('aOxLa'));

});

parcelRegister("kIwgG", function(module, exports) {

let $f150f27938e8e63a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f150f27938e8e63a$var$load("4HPrl").then(()=>parcelRequire('cpn1Z'));

});

parcelRegister("4INr5", function(module, exports) {

let $37019e71866cec73$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $37019e71866cec73$var$load("32CsP").then(()=>parcelRequire('kKdu4'));

});

parcelRegister("1Yz2i", function(module, exports) {

let $1706927b3a0ce033$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1706927b3a0ce033$var$load("5I6km").then(()=>parcelRequire('9xBAG'));

});

parcelRegister("aa4eb", function(module, exports) {

let $765e1e19dcd50484$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $765e1e19dcd50484$var$load("4qZFn").then(()=>parcelRequire('cx6DD'));

});

parcelRegister("fAgdc", function(module, exports) {

let $b586cb20c7581235$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b586cb20c7581235$var$load("8gTGU").then(()=>parcelRequire('g8Fnr'));

});

parcelRegister("5vTZj", function(module, exports) {

let $403b470493fca54e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $403b470493fca54e$var$load("3OyXK").then(()=>parcelRequire('5Lzpa'));

});

parcelRegister("2ypfg", function(module, exports) {

let $1dc256eb0b602489$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1dc256eb0b602489$var$load("hv2bE").then(()=>parcelRequire('l9h9Z'));

});

parcelRegister("7pS9S", function(module, exports) {

let $5664e0e383a4a284$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5664e0e383a4a284$var$load("g0Dr6").then(()=>parcelRequire('6mRQz'));

});

parcelRegister("3vYO5", function(module, exports) {

let $28f36f51bdeeae3b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $28f36f51bdeeae3b$var$load("3kAza").then(()=>parcelRequire('bo3y3'));

});

parcelRegister("5GsuB", function(module, exports) {

let $4236fa03de17e346$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4236fa03de17e346$var$load("1K1Fj"),
    $4236fa03de17e346$var$load("8hOn0"),
    $4236fa03de17e346$var$load("xnqy2"),
    $4236fa03de17e346$var$load("fJ8y4")
]).then(()=>parcelRequire('iyVZx'));

});

parcelRegister("cbbhR", function(module, exports) {

let $8ddf44781a34fc55$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8ddf44781a34fc55$var$load("1NbSo").then(()=>parcelRequire('i5xYK'));

});

parcelRegister("iIfOK", function(module, exports) {

let $d9f89b122bf622bb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d9f89b122bf622bb$var$load("hrf1M").then(()=>parcelRequire('3QCDD'));

});

parcelRegister("8uqYk", function(module, exports) {

let $62e60c2b1c9337f2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $62e60c2b1c9337f2$var$load("44xD1").then(()=>parcelRequire('9hAXc'));

});

parcelRegister("2SXdV", function(module, exports) {

let $219e907e98ff9efe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $219e907e98ff9efe$var$load("DnRaL").then(()=>parcelRequire('kblsY'));

});

parcelRegister("l5mZh", function(module, exports) {

let $f59be56a922bbd86$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f59be56a922bbd86$var$load("huaEy").then(()=>parcelRequire('9bGZv'));

});

parcelRegister("Z6SDd", function(module, exports) {

let $0b7b08dffb504888$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0b7b08dffb504888$var$load("3OEsN").then(()=>parcelRequire('lGLcJ'));

});

parcelRegister("aa8q2", function(module, exports) {

let $76615e5e2180d03f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $76615e5e2180d03f$var$load("eQ37H").then(()=>parcelRequire('4A5oU'));

});

parcelRegister("1B8BV", function(module, exports) {

let $129fed0801f1546c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $129fed0801f1546c$var$load("iBVwV").then(()=>parcelRequire('kZ5TM'));

});

parcelRegister("2XCzY", function(module, exports) {

let $227f0479ed4f415b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $227f0479ed4f415b$var$load("lk62y").then(()=>parcelRequire('573SD'));

});

parcelRegister("66H4O", function(module, exports) {

let $4724b7bef1092cfa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4724b7bef1092cfa$var$load("6iS4F").then(()=>parcelRequire('jfPKi'));

});

parcelRegister("kL4Jh", function(module, exports) {

let $f1cbdd919ac39468$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f1cbdd919ac39468$var$load("3vO7l").then(()=>parcelRequire('eYEqr'));

});

parcelRegister("2MDkR", function(module, exports) {

let $206e93adcb39c877$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $206e93adcb39c877$var$load("hbn7C").then(()=>parcelRequire('9Blvx'));

});

parcelRegister("hhabz", function(module, exports) {

let $c93becdc91ed46fe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c93becdc91ed46fe$var$load("3jm7G").then(()=>parcelRequire('1WvJN'));

});

parcelRegister("gglGj", function(module, exports) {

let $bd6ef572edbde83a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bd6ef572edbde83a$var$load("bLVka").then(()=>parcelRequire('fp7aR'));

});

parcelRegister("30MSy", function(module, exports) {

let $231749870337ccf8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $231749870337ccf8$var$load("3XeDU").then(()=>parcelRequire('gf2E5'));

});

parcelRegister("3xjnb", function(module, exports) {

let $29337b3f83adbc62$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $29337b3f83adbc62$var$load("jKi31").then(()=>parcelRequire('5Mz5E'));

});

parcelRegister("b766Q", function(module, exports) {

let $8175165d78eba644$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8175165d78eba644$var$load("i7uJq").then(()=>parcelRequire('j3xsn'));

});

parcelRegister("lnjs9", function(module, exports) {

let $f8fad5e9e1c67adb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f8fad5e9e1c67adb$var$load("5QaAs").then(()=>parcelRequire('1GNtt'));

});

parcelRegister("1shUB", function(module, exports) {

let $10f64ce708720c2a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $10f64ce708720c2a$var$load("iho8v").then(()=>parcelRequire('4lHRm'));

});

parcelRegister("gtg53", function(module, exports) {

let $bfdbd4098fe97ad6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bfdbd4098fe97ad6$var$load("aryd9").then(()=>parcelRequire('g0MkC'));

});

parcelRegister("46e69", function(module, exports) {

let $2fc2a88c2a396ecf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2fc2a88c2a396ecf$var$load("dnObq").then(()=>parcelRequire('4RP7y'));

});

parcelRegister("hXZH1", function(module, exports) {

let $d147cd488ad49d68$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d147cd488ad49d68$var$load("37Dgy").then(()=>parcelRequire('jD1kq'));

});

parcelRegister("2WUnn", function(module, exports) {

let $225cbaa8f1ce26ab$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $225cbaa8f1ce26ab$var$load("3UUyL").then(()=>parcelRequire('ekfmK'));

});

parcelRegister("dcH5y", function(module, exports) {

let $99cdd1ddfbe0362c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $99cdd1ddfbe0362c$var$load("6iuAy").then(()=>parcelRequire('f8IWM'));

});

parcelRegister("k9RtC", function(module, exports) {

let $eace2144764fd8b8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $eace2144764fd8b8$var$load("7v6wU"),
    $eace2144764fd8b8$var$load("b544F"),
    $eace2144764fd8b8$var$load("a8heY"),
    $eace2144764fd8b8$var$load("bRVT8")
]).then(()=>parcelRequire('iDFnq'));

});

parcelRegister("9ZSH5", function(module, exports) {

let $74743ca30ad72810$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $74743ca30ad72810$var$load("fUDiz").then(()=>parcelRequire('cahEU'));

});

parcelRegister("jpnoV", function(module, exports) {

let $e2128110abcf1006$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e2128110abcf1006$var$load("QTjdE").then(()=>parcelRequire('hSCCx'));

});

parcelRegister("kLLQ7", function(module, exports) {

let $f1ed4e63559c0100$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f1ed4e63559c0100$var$load("9qhMm").then(()=>parcelRequire('lRW0v'));

});

parcelRegister("Y7Lij", function(module, exports) {

let $0b4ba00b934182a5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0b4ba00b934182a5$var$load("1obEx").then(()=>parcelRequire('6wuEn'));

});

parcelRegister("fZ6Us", function(module, exports) {

let $ba31e99e8329ae4c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ba31e99e8329ae4c$var$load("1DiRu").then(()=>parcelRequire('is7g5'));

});

parcelRegister("jFOrX", function(module, exports) {

let $e528faf41a995a49$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e528faf41a995a49$var$load("lH0NU").then(()=>parcelRequire('jKge3'));

});

parcelRegister("cCLar", function(module, exports) {

let $930d9f212a388ad8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $930d9f212a388ad8$var$load("3l3Az").then(()=>parcelRequire('18iDn'));

});

parcelRegister("efmHA", function(module, exports) {

let $a5f41389a646b08d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a5f41389a646b08d$var$load("jwYiv").then(()=>parcelRequire('6frTB'));

});

parcelRegister("3wllO", function(module, exports) {

let $2904ec10a334dc0c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2904ec10a334dc0c$var$load("d6wjH").then(()=>parcelRequire('h0YR4'));

});

parcelRegister("2ejVQ", function(module, exports) {

let $19fc59a8be6a9b01$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $19fc59a8be6a9b01$var$load("fU3WR").then(()=>parcelRequire('6F1or'));

});

parcelRegister("d22yS", function(module, exports) {

let $97cd72e9b79e79ea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $97cd72e9b79e79ea$var$load("6EYTv").then(()=>parcelRequire('f0428'));

});

parcelRegister("jFHhX", function(module, exports) {

let $e5236cde0f0aaa53$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e5236cde0f0aaa53$var$load("ephaU").then(()=>parcelRequire('e4lFW'));

});

parcelRegister("6DrBh", function(module, exports) {

let $4d4bcb6c00f9dac5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4d4bcb6c00f9dac5$var$load("gBYhv").then(()=>parcelRequire('gs0Um'));

});

parcelRegister("7BgPj", function(module, exports) {

let $58890a87d8021ea4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $58890a87d8021ea4$var$load("i9X8S").then(()=>parcelRequire('w1yis'));

});

parcelRegister("hGOF0", function(module, exports) {

let $ce0da802d595e474$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ce0da802d595e474$var$load("i4gOW").then(()=>parcelRequire('dJPHE'));

});

parcelRegister("cAyb7", function(module, exports) {

let $92a35bf47a0cee5a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $92a35bf47a0cee5a$var$load("1oyHf").then(()=>parcelRequire('awmxy'));

});

parcelRegister("chk6L", function(module, exports) {

let $8f06aba3e9e587db$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8f06aba3e9e587db$var$load("bfMNV").then(()=>parcelRequire('8svQx'));

});

parcelRegister("7kcGp", function(module, exports) {

let $55543d381fcba86c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $55543d381fcba86c$var$load("30B0p").then(()=>parcelRequire('cyKX8'));

});

parcelRegister("gzVQe", function(module, exports) {

let $c11cc85ac1acaabd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c11cc85ac1acaabd$var$load("ewZTP").then(()=>parcelRequire('g0mXN'));

});

parcelRegister("3JE9M", function(module, exports) {

let $2b84b95bb3264273$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2b84b95bb3264273$var$load("7Fxds").then(()=>parcelRequire('6P5eq'));

});

parcelRegister("i4Gy2", function(module, exports) {

let $d2899adde47dce6c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d2899adde47dce6c$var$load("9aM7M").then(()=>parcelRequire('kIPzK'));

});

parcelRegister("1EKgF", function(module, exports) {

let $134d6ab1dd1197e4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $134d6ab1dd1197e4$var$load("aYD34").then(()=>parcelRequire('3Aus6'));

});

parcelRegister("1ZwoN", function(module, exports) {

let $17349eb97e09a1d1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $17349eb97e09a1d1$var$load("8HPx4").then(()=>parcelRequire('jhqSm'));

});

parcelRegister("hn7IH", function(module, exports) {

let $ca5a92ac3779c36c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ca5a92ac3779c36c$var$load("dX2gb").then(()=>parcelRequire('dA2b2'));

});

parcelRegister("7DZ1I", function(module, exports) {

let $590b838809bba6fa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $590b838809bba6fa$var$load("asvK9"),
    $590b838809bba6fa$var$load("aBa7j"),
    $590b838809bba6fa$var$load("barSq"),
    $590b838809bba6fa$var$load("1H3US")
]).then(()=>parcelRequire('1r0I7'));

});

parcelRegister("cs6e6", function(module, exports) {

let $0256eb10777ded9f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0256eb10777ded9f$var$load("6A7am").then(()=>parcelRequire('duJA4'));

});

parcelRegister("30Z80", function(module, exports) {

let $2320c9f0bca1ba9e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2320c9f0bca1ba9e$var$load("lsloj").then(()=>parcelRequire('lT2Hu'));

});

parcelRegister("fmFDX", function(module, exports) {

let $b2f9369951e82286$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b2f9369951e82286$var$load("2YKuP").then(()=>parcelRequire('4mCP6'));

});

parcelRegister("4k1DC", function(module, exports) {

let $325a4cfa68ce9ec7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $325a4cfa68ce9ec7$var$load("13L6t").then(()=>parcelRequire('9YE9p'));

});

parcelRegister("kG1Wq", function(module, exports) {

let $f0d93c69d17667cb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f0d93c69d17667cb$var$load("AIiTi").then(()=>parcelRequire('ceO1g'));

});

parcelRegister("e5oL3", function(module, exports) {

let $a414bcba2b589741$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a414bcba2b589741$var$load("hGLdi").then(()=>parcelRequire('d7PIu'));

});

parcelRegister("bPGfK", function(module, exports) {

let $89d53bb327f1e4bf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $89d53bb327f1e4bf$var$load("7RILe").then(()=>parcelRequire('jZWJw'));

});

parcelRegister("dYPQi", function(module, exports) {

let $a2d917cbd0af85d4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a2d917cbd0af85d4$var$load("840Ej").then(()=>parcelRequire('kn4iW'));

});

parcelRegister("7CeSF", function(module, exports) {

let $58b7a00a57330bcb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $58b7a00a57330bcb$var$load("dJiiw").then(()=>parcelRequire('8sMYh'));

});

parcelRegister("5bVRd", function(module, exports) {

let $3c7adc15320c50c0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3c7adc15320c50c0$var$load("5H9Jz").then(()=>parcelRequire('ccyLS'));

});

parcelRegister("42B9a", function(module, exports) {

let $2f1429ec1fa8daa6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2f1429ec1fa8daa6$var$load("d57FZ").then(()=>parcelRequire('6Jsp2'));

});

parcelRegister("8Wgz2", function(module, exports) {

let $682096c96eb83bc4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $682096c96eb83bc4$var$load("h5HSy").then(()=>parcelRequire('l6esU'));

});

parcelRegister("4Rhr6", function(module, exports) {

let $3899a31af723623f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3899a31af723623f$var$load("ZGPmR").then(()=>parcelRequire('gQG16'));

});

parcelRegister("2zJWz", function(module, exports) {

let $1e027d19293b7289$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1e027d19293b7289$var$load("bPVgw").then(()=>parcelRequire('2ePcG'));

});

parcelRegister("2gzsE", function(module, exports) {

let $1a68953f35bd16fd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1a68953f35bd16fd$var$load("kqU5B").then(()=>parcelRequire('bJYvw'));

});

parcelRegister("0427W", function(module, exports) {

let $00c2063ec485616f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $00c2063ec485616f$var$load("9ONNB").then(()=>parcelRequire('lbM8c'));

});

parcelRegister("b2LUN", function(module, exports) {

let $80a50c8d2c10b2e4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $80a50c8d2c10b2e4$var$load("7w8WE").then(()=>parcelRequire('dXAEg'));

});

parcelRegister("ednoZ", function(module, exports) {

let $a5946ec3aa076a25$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a5946ec3aa076a25$var$load("agXE2").then(()=>parcelRequire('e2qmK'));

});

parcelRegister("g1If2", function(module, exports) {

let $baaf0ecb766302e6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $baaf0ecb766302e6$var$load("iCBCg").then(()=>parcelRequire('4DbYK'));

});

parcelRegister("jUPrs", function(module, exports) {

let $e7fb268b7e5a97f1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e7fb268b7e5a97f1$var$load("8h9es").then(()=>parcelRequire('5Ml5D'));

});

parcelRegister("5rAD6", function(module, exports) {

let $3f6be33e73c83406$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3f6be33e73c83406$var$load("fFbrC").then(()=>parcelRequire('43DFy'));

});

parcelRegister("dSS33", function(module, exports) {

let $a1ba3e5ff7810c3a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a1ba3e5ff7810c3a$var$load("3M7pT").then(()=>parcelRequire('eJjTT'));

});

parcelRegister("2ux9b", function(module, exports) {

let $1d08186f8a30fac6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1d08186f8a30fac6$var$load("lTjvS").then(()=>parcelRequire('aY2UQ'));

});

parcelRegister("88yDx", function(module, exports) {

let $5ec9f03a65397ab3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5ec9f03a65397ab3$var$load("fAsl8").then(()=>parcelRequire('1T1Uj'));

});

parcelRegister("ktqgw", function(module, exports) {

let $ee7ae3db33afd8f8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ee7ae3db33afd8f8$var$load("aEpRh"),
    $ee7ae3db33afd8f8$var$load("K6fhx"),
    $ee7ae3db33afd8f8$var$load("6hlNE"),
    $ee7ae3db33afd8f8$var$load("71JfN")
]).then(()=>parcelRequire('dsuKz'));

});

parcelRegister("Oa6nx", function(module, exports) {

let $096c81a66562d79d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $096c81a66562d79d$var$load("kPtjD").then(()=>parcelRequire('2yoxc'));

});

parcelRegister("d2GXH", function(module, exports) {

let $97ecc99c241acf1a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $97ecc99c241acf1a$var$load("aOdaf").then(()=>parcelRequire('3o50X'));

});

parcelRegister("jGwE7", function(module, exports) {

let $e54b4367316f3f32$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e54b4367316f3f32$var$load("lySio").then(()=>parcelRequire('8chQR'));

});

parcelRegister("8aIwd", function(module, exports) {

let $5f31ca620e3d234d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5f31ca620e3d234d$var$load("kOIXr").then(()=>parcelRequire('6XTGa'));

});

parcelRegister("f1pOX", function(module, exports) {

let $aefafa8284dac4e4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aefafa8284dac4e4$var$load("14AZs").then(()=>parcelRequire('l9Ug4'));

});

parcelRegister("a34Vp", function(module, exports) {

let $750e0133cf72c9b8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $750e0133cf72c9b8$var$load("IfGUb").then(()=>parcelRequire('fkfWe'));

});

parcelRegister("4wnzv", function(module, exports) {

let $34ac6f67b230a0f9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $34ac6f67b230a0f9$var$load("7IvTK").then(()=>parcelRequire('dGjHO'));

});

parcelRegister("4g1Cn", function(module, exports) {

let $3199e9572901e876$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3199e9572901e876$var$load("bSjyK"),
    $3199e9572901e876$var$load("hlJc4"),
    $3199e9572901e876$var$load("j6IGj"),
    $3199e9572901e876$var$load("5a6vI")
]).then(()=>parcelRequire('alf8C'));

});

parcelRegister("6ilcc", function(module, exports) {

let $4954dd92c1044fad$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4954dd92c1044fad$var$load("fDSlM").then(()=>parcelRequire('4uSeG'));

});

parcelRegister("dDhE4", function(module, exports) {

let $9ecc9ae26ad2ef43$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9ecc9ae26ad2ef43$var$load("5WkxF").then(()=>parcelRequire('aOLJW'));

});

parcelRegister("bk86r", function(module, exports) {

let $83e7d904c1453d0b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $83e7d904c1453d0b$var$load("4fGFV").then(()=>parcelRequire('g0CZR'));

});

parcelRegister("fyzYZ", function(module, exports) {

let $b535f1643c9c43a2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b535f1643c9c43a2$var$load("d9TxV").then(()=>parcelRequire('bXFr8'));

});

parcelRegister("iTlGW", function(module, exports) {

let $dc0e308e3aeb72a7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dc0e308e3aeb72a7$var$load("iyI96").then(()=>parcelRequire('4AHSJ'));

});

parcelRegister("dMmE3", function(module, exports) {

let $a08152e7b9674310$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a08152e7b9674310$var$load("ibz6c").then(()=>parcelRequire('hW2zm'));

});

parcelRegister("eCwSZ", function(module, exports) {

let $aa4e1fc52b7b027b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aa4e1fc52b7b027b$var$load("aHAWd").then(()=>parcelRequire('46MuN'));

});

parcelRegister("l4mkb", function(module, exports) {

let $f56b49e0aa5a244d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f56b49e0aa5a244d$var$load("iP06G").then(()=>parcelRequire('jzTw0'));

});

parcelRegister("3YZwm", function(module, exports) {

let $2e66b27586cbdf67$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2e66b27586cbdf67$var$load("71MIp").then(()=>parcelRequire('e68Bq'));

});

parcelRegister("jpJOQ", function(module, exports) {

let $e223e4d8861af02e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e223e4d8861af02e$var$load("34Qbm").then(()=>parcelRequire('6LMXR'));

});

parcelRegister("38pL0", function(module, exports) {

let $2486194620d814d5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2486194620d814d5$var$load("4C3hu").then(()=>parcelRequire('21OVa'));

});

parcelRegister("lkrWp", function(module, exports) {

let $f87123c2fbff8da6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f87123c2fbff8da6$var$load("hoPZ9").then(()=>parcelRequire('hhErb'));

});

parcelRegister("feuKA", function(module, exports) {

let $b1700438a6fd2842$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b1700438a6fd2842$var$load("8QehZ").then(()=>parcelRequire('hNmwG'));

});

parcelRegister("8CV0z", function(module, exports) {

let $647e18014aa178dd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $647e18014aa178dd$var$load("ex0Cl").then(()=>parcelRequire('5LyIQ'));

});

parcelRegister("lRFwt", function(module, exports) {

let $feaec1c7f5790174$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $feaec1c7f5790174$var$load("iGpXg").then(()=>parcelRequire('9YmZU'));

});

parcelRegister("cHtEA", function(module, exports) {

let $93f080c97bc67f0a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $93f080c97bc67f0a$var$load("5Pnad").then(()=>parcelRequire('6Yuab'));

});

parcelRegister("9LZYt", function(module, exports) {

let $71d893ac9ea4bbe1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $71d893ac9ea4bbe1$var$load("1D2zq").then(()=>parcelRequire('1vqLd'));

});

parcelRegister("ciYHD", function(module, exports) {

let $8f5640c62c4cd868$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8f5640c62c4cd868$var$load("krV0u").then(()=>parcelRequire('fV6QY'));

});

parcelRegister("6QfAK", function(module, exports) {

let $4fb3b19e7cb74c55$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4fb3b19e7cb74c55$var$load("bgvYl").then(()=>parcelRequire('k82rV'));

});

parcelRegister("a2BuE", function(module, exports) {

let $74f72caabe04eaa1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $74f72caabe04eaa1$var$load("56yEs").then(()=>parcelRequire('fSItB'));

});

parcelRegister("lIfBs", function(module, exports) {

let $fce9cf836566f14e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fce9cf836566f14e$var$load("hoTme").then(()=>parcelRequire('jLkf4'));

});

parcelRegister("cGQZn", function(module, exports) {

let $93d282c7c6c42f6d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $93d282c7c6c42f6d$var$load("2Kkkj").then(()=>parcelRequire('koRJI'));

});

parcelRegister("fgnzR", function(module, exports) {

let $b1caa39a9f626d4d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b1caa39a9f626d4d$var$load("i1yZZ").then(()=>parcelRequire('3uAOF'));

});

parcelRegister("2YepE", function(module, exports) {

let $229c5d7383cba277$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $229c5d7383cba277$var$load("j6zhg").then(()=>parcelRequire('6gxDB'));

});

parcelRegister("cCv6N", function(module, exports) {

let $93012a294b073fca$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $93012a294b073fca$var$load("7CI0R").then(()=>parcelRequire('7oLij'));

});

parcelRegister("gpsuY", function(module, exports) {

let $bf25165ff50c1ca4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bf25165ff50c1ca4$var$load("4nZkM").then(()=>parcelRequire('jdfub'));

});

parcelRegister("cRTov", function(module, exports) {

let $95e5676a709753a7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $95e5676a709753a7$var$load("fSOQ7").then(()=>parcelRequire('ki92G'));

});

parcelRegister("e2cQY", function(module, exports) {

let $a37b38fcc9529537$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a37b38fcc9529537$var$load("iy7la").then(()=>parcelRequire('8Egc9'));

});

parcelRegister("Zc77P", function(module, exports) {

let $0b7f18314b0826a0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0b7f18314b0826a0$var$load("dBXMX").then(()=>parcelRequire('3TQcd'));

});

parcelRegister("7bB3L", function(module, exports) {

let $53b64eca951976af$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $53b64eca951976af$var$load("8lD9V").then(()=>parcelRequire('41dWS'));

});

parcelRegister("7XfGx", function(module, exports) {

let $5caa35d4b47eaa99$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5caa35d4b47eaa99$var$load("cqrTP").then(()=>parcelRequire('kZYBr'));

});

parcelRegister("5eUPc", function(module, exports) {

let $3d0a56c48fc801e1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3d0a56c48fc801e1$var$load("1yq9n").then(()=>parcelRequire('e8AS0'));

});

parcelRegister("aVpg5", function(module, exports) {

let $7f42d20eafbbbd14$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7f42d20eafbbbd14$var$load("cMgMB").then(()=>parcelRequire('4O160'));

});

parcelRegister("cY3Cx", function(module, exports) {

let $970de59b9e1823db$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $970de59b9e1823db$var$load("5i3SC").then(()=>parcelRequire('iCQxS'));

});

parcelRegister("4UpGP", function(module, exports) {

let $393051d8b9c54704$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $393051d8b9c54704$var$load("1jsQH"),
    $393051d8b9c54704$var$load("i5eMd"),
    $393051d8b9c54704$var$load("bv8GZ"),
    $393051d8b9c54704$var$load("5Lpne")
]).then(()=>parcelRequire('2AHGb'));

});

parcelRegister("bRhxV", function(module, exports) {

let $8a22413cc8407658$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8a22413cc8407658$var$load("1PuvZ").then(()=>parcelRequire('i6OLF'));

});

parcelRegister("7WGgv", function(module, exports) {

let $5c8ebc26d9ab9c0e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5c8ebc26d9ab9c0e$var$load("l6YHr").then(()=>parcelRequire('4VjzZ'));

});

parcelRegister("40p5l", function(module, exports) {

let $2eaa9ee9c620d414$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2eaa9ee9c620d414$var$load("jtxFc").then(()=>parcelRequire('dLoPa'));

});

parcelRegister("hlyml", function(module, exports) {

let $ca0f0ce430b37be1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ca0f0ce430b37be1$var$load("ijQ6l").then(()=>parcelRequire('9mF1p'));

});

parcelRegister("4VxYQ", function(module, exports) {

let $3966d81451f7bd06$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3966d81451f7bd06$var$load("lCNhg").then(()=>parcelRequire('45SMe'));

});

parcelRegister("duJJs", function(module, exports) {

let $9d318d2aa0ecee04$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9d318d2aa0ecee04$var$load("7I8FK").then(()=>parcelRequire('gR0Ux'));

});

parcelRegister("3My45", function(module, exports) {

let $2c10475998daa4a1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2c10475998daa4a1$var$load("lQ681").then(()=>parcelRequire('1R9iT'));

});

parcelRegister("4xtrC", function(module, exports) {

let $34e1158be5f31053$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $34e1158be5f31053$var$load("6r90a").then(()=>parcelRequire('4ZPCd'));

});

parcelRegister("hlfB9", function(module, exports) {

let $ca007f545ff2b22d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ca007f545ff2b22d$var$load("drGhL").then(()=>parcelRequire('4LH4L'));

});

parcelRegister("9ty4O", function(module, exports) {

let $6e6141603c884039$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6e6141603c884039$var$load("06dxH").then(()=>parcelRequire('9jOdE'));

});

parcelRegister("5pdjD", function(module, exports) {

let $3ef99dc5b02f508f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3ef99dc5b02f508f$var$load("6M9As").then(()=>parcelRequire('aS062'));

});

parcelRegister("buuAe", function(module, exports) {

let $85da384078222681$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $85da384078222681$var$load("jlWQP").then(()=>parcelRequire('3qrgQ'));

});

parcelRegister("52WxI", function(module, exports) {

let $3aca8d0d83d1509c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3aca8d0d83d1509c$var$load("gu2Nj").then(()=>parcelRequire('h11RW'));

});

parcelRegister("j0bO3", function(module, exports) {

let $dd572ce867edbee0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dd572ce867edbee0$var$load("1tJE7").then(()=>parcelRequire('6F7ay'));

});

parcelRegister("967Ea", function(module, exports) {

let $69fa9b16a8c64fbe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $69fa9b16a8c64fbe$var$load("sv9xx").then(()=>parcelRequire('5kbqa'));

});

parcelRegister("6ZjuQ", function(module, exports) {

let $5167902cd3f2e131$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5167902cd3f2e131$var$load("kwhtC").then(()=>parcelRequire('cPZVY'));

});

parcelRegister("6UOIT", function(module, exports) {

let $508f51921213cce1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $508f51921213cce1$var$load("3qvUT").then(()=>parcelRequire('hBA7n'));

});

parcelRegister("flljz", function(module, exports) {

let $b2b959d255389f79$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b2b959d255389f79$var$load("7Wt6C").then(()=>parcelRequire('aZ75K'));

});

parcelRegister("3nuPt", function(module, exports) {

let $275b6f1fa1336ab4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $275b6f1fa1336ab4$var$load("7e4Nm").then(()=>parcelRequire('3GY0W'));

});

parcelRegister("4rvZM", function(module, exports) {

let $33c280b1fcf39056$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $33c280b1fcf39056$var$load("DsESC").then(()=>parcelRequire('jXHGs'));

});

parcelRegister("3nKZa", function(module, exports) {

let $2767f76e91461be6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2767f76e91461be6$var$load("jke3X").then(()=>parcelRequire('hJWhT'));

});

parcelRegister("4TqyF", function(module, exports) {

let $3900e659903520d1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3900e659903520d1$var$load("em8WG").then(()=>parcelRequire('23ZvC'));

});

parcelRegister("9j0e7", function(module, exports) {

let $6c661069fa5dc3ec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6c661069fa5dc3ec$var$load("qYLgW").then(()=>parcelRequire('hW3z1'));

});

parcelRegister("cuTii", function(module, exports) {

let $91932da2ada4474d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $91932da2ada4474d$var$load("lpcl9").then(()=>parcelRequire('9o8Q9'));

});

parcelRegister("1hgor", function(module, exports) {

let $0ee418561c60f25e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0ee418561c60f25e$var$load("9eNkX"),
    $0ee418561c60f25e$var$load("k10Cs"),
    $0ee418561c60f25e$var$load("dh2Er"),
    $0ee418561c60f25e$var$load("fCHx1")
]).then(()=>parcelRequire('caQCF'));

});

parcelRegister("l7MZc", function(module, exports) {

let $f6104005e2ea2554$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f6104005e2ea2554$var$load("jmAUD").then(()=>parcelRequire('jLDih'));

});

parcelRegister("90Z4r", function(module, exports) {

let $69037c856271d0b7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $69037c856271d0b7$var$load("7iCpI").then(()=>parcelRequire('6QVCK'));

});

parcelRegister("7Cc3E", function(module, exports) {

let $58b56f7081e0ce06$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $58b56f7081e0ce06$var$load("2Oecn").then(()=>parcelRequire('6XvEn'));

});

parcelRegister("lXLSN", function(module, exports) {

let $ffd4403595babfff$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ffd4403595babfff$var$load("idffh").then(()=>parcelRequire('igHdQ'));

});

parcelRegister("goInG", function(module, exports) {

let $bf0150619fd55551$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bf0150619fd55551$var$load("bxrJM").then(()=>parcelRequire('6A8Au'));

});

parcelRegister("5BFfE", function(module, exports) {

let $4150681bfb6d7ad4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4150681bfb6d7ad4$var$load("dZksg").then(()=>parcelRequire('jKBtA'));

});

parcelRegister("37OSC", function(module, exports) {

let $24697e41c09fe787$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $24697e41c09fe787$var$load("j1qvJ").then(()=>parcelRequire('fFFDo'));

});

parcelRegister("lLWMp", function(module, exports) {

let $fd9b952d51ba7771$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd9b952d51ba7771$var$load("85oXg").then(()=>parcelRequire('8KOQh'));

});

parcelRegister("6LdWk", function(module, exports) {

let $4ec1f204dea9f549$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4ec1f204dea9f549$var$load("8SArD").then(()=>parcelRequire('5WXmf'));

});

parcelRegister("g7fvG", function(module, exports) {

let $bbb954c0d6e814b6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bbb954c0d6e814b6$var$load("lV598").then(()=>parcelRequire('8N0Ia'));

});

parcelRegister("dGnzI", function(module, exports) {

let $9f617c1d034c2279$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9f617c1d034c2279$var$load("5qZQG").then(()=>parcelRequire('2lN8c'));

});

parcelRegister("cw6KB", function(module, exports) {

let $91cdb5bf20f67653$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $91cdb5bf20f67653$var$load("6sgZC").then(()=>parcelRequire('b5zD1'));

});

parcelRegister("33CyY", function(module, exports) {

let $239f90c018ebba8a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $239f90c018ebba8a$var$load("8i4Gc").then(()=>parcelRequire('ggpMi'));

});

parcelRegister("by9TN", function(module, exports) {

let $868a8c61f7037084$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $868a8c61f7037084$var$load("jWKNo").then(()=>parcelRequire('kdfal'));

});

parcelRegister("fpWhT", function(module, exports) {

let $b396677deacfb073$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b396677deacfb073$var$load("8Gnpv").then(()=>parcelRequire('lduxP'));

});

parcelRegister("ifVVt", function(module, exports) {

let $d4a68f9e24a34e4e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d4a68f9e24a34e4e$var$load("fWMTy").then(()=>parcelRequire('ea83r'));

});

parcelRegister("fSAlL", function(module, exports) {

let $b8f818853e7a37af$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b8f818853e7a37af$var$load("b5WKn").then(()=>parcelRequire('91VzV'));

});

parcelRegister("a2qZI", function(module, exports) {

let $74ef07ce5ec40c97$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $74ef07ce5ec40c97$var$load("8Z3BN").then(()=>parcelRequire('13oZu'));

});

parcelRegister("2QfX9", function(module, exports) {

let $211cd0118bb505d5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $211cd0118bb505d5$var$load("8m50R").then(()=>parcelRequire('6rKLI'));

});

parcelRegister("3l4Ec", function(module, exports) {

let $26e6f029164c4118$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $26e6f029164c4118$var$load("coSlg").then(()=>parcelRequire('7CKM8'));

});

parcelRegister("6oBuW", function(module, exports) {

let $4a82124b15f84d08$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4a82124b15f84d08$var$load("fESa7").then(()=>parcelRequire('1kKoV'));

});

parcelRegister("lRn7H", function(module, exports) {

let $fea07bfabc2f1873$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fea07bfabc2f1873$var$load("9yUm3").then(()=>parcelRequire('3Gv94'));

});

parcelRegister("dTMPE", function(module, exports) {

let $a1e64a723b30e89b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a1e64a723b30e89b$var$load("fnxSZ").then(()=>parcelRequire('5zGnG'));

});

parcelRegister("gWCjs", function(module, exports) {

let $c55fc840c3c9e59c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c55fc840c3c9e59c$var$load("byLpQ").then(()=>parcelRequire('59j1T'));

});

parcelRegister("ajtAl", function(module, exports) {

let $7822a0c1c5e9ac39$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7822a0c1c5e9ac39$var$load("gDiIK"),
    $7822a0c1c5e9ac39$var$load("f1B4n"),
    $7822a0c1c5e9ac39$var$load("eLlpV"),
    $7822a0c1c5e9ac39$var$load("852EO")
]).then(()=>parcelRequire('4MCxA'));

});

parcelRegister("1xJdc", function(module, exports) {

let $11fbf1ac175192b3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $11fbf1ac175192b3$var$load("4i4dx").then(()=>parcelRequire('aadJe'));

});

parcelRegister("gEYDh", function(module, exports) {

let $c20f6a1adf8dad91$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c20f6a1adf8dad91$var$load("afU9w").then(()=>parcelRequire('ignUV'));

});

parcelRegister("9Tsjp", function(module, exports) {

let $733f364eb29b7f86$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $733f364eb29b7f86$var$load("gmzrm").then(()=>parcelRequire('7EwjJ'));

});

parcelRegister("1LvqF", function(module, exports) {

let $14928f6229a1bc6e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $14928f6229a1bc6e$var$load("4oiyH").then(()=>parcelRequire('jt6zg'));

});

parcelRegister("hg0uq", function(module, exports) {

let $c9044f849ba361c1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c9044f849ba361c1$var$load("6lPSZ").then(()=>parcelRequire('7hDnX'));

});

parcelRegister("dHHk2", function(module, exports) {

let $9fa0e568a8bcc90e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9fa0e568a8bcc90e$var$load("7yGIa").then(()=>parcelRequire('lRTsu'));

});

parcelRegister("fwOdQ", function(module, exports) {

let $b4e0cd42c1e6ad04$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b4e0cd42c1e6ad04$var$load("5jtZi").then(()=>parcelRequire('crJQR'));

});

parcelRegister("1Qp1d", function(module, exports) {

let $157e0ded1467bbc5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $157e0ded1467bbc5$var$load("1BUH2").then(()=>parcelRequire('l3SRu'));

});

parcelRegister("lm7No", function(module, exports) {

let $f8c1b31700b2b141$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f8c1b31700b2b141$var$load("7eCND").then(()=>parcelRequire('6PXdj'));

});

parcelRegister("58Q3Y", function(module, exports) {

let $3be615bf71c365de$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3be615bf71c365de$var$load("f7W2A").then(()=>parcelRequire('iUxNS'));

});

parcelRegister("fhtCf", function(module, exports) {

let $b1ff6aaaa148e736$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b1ff6aaaa148e736$var$load("lWioM").then(()=>parcelRequire('7oUTT'));

});

parcelRegister("aNvMm", function(module, exports) {

let $7dc721a92113dfcf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7dc721a92113dfcf$var$load("b4OPs").then(()=>parcelRequire('kPU5q'));

});

parcelRegister("ihRrc", function(module, exports) {

let $d503442a45147f95$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d503442a45147f95$var$load("03UH2").then(()=>parcelRequire('5L7lK'));

});

parcelRegister("4XDL2", function(module, exports) {

let $39cb8323c5e93b84$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $39cb8323c5e93b84$var$load("4PQhR").then(()=>parcelRequire('eg68j'));

});

parcelRegister("2gJBo", function(module, exports) {

let $1a7073094ca07a04$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1a7073094ca07a04$var$load("cQoIB").then(()=>parcelRequire('ay1Qf'));

});

parcelRegister("6HooY", function(module, exports) {

let $4e09afea3d698c3b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4e09afea3d698c3b$var$load("hu6xO").then(()=>parcelRequire('dPHT6'));

});

parcelRegister("a3JBY", function(module, exports) {

let $752d90ab546bdaec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $752d90ab546bdaec$var$load("goDLu").then(()=>parcelRequire('3XVRA'));

});

parcelRegister("1fqph", function(module, exports) {

let $0e8bad033f4e82a7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0e8bad033f4e82a7$var$load("fwm7q").then(()=>parcelRequire('dpbjJ'));

});

parcelRegister("lreZS", function(module, exports) {

let $f9b7c0b4d47ab7ce$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f9b7c0b4d47ab7ce$var$load("dSz1k").then(()=>parcelRequire('6uNmH'));

});

parcelRegister("ZCDDG", function(module, exports) {

let $0b93ab63b35834b4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0b93ab63b35834b4$var$load("1ubTI").then(()=>parcelRequire('ahfQJ'));

});

parcelRegister("6w2Bt", function(module, exports) {

let $4be7c03a6c4626b6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4be7c03a6c4626b6$var$load("j8hoS").then(()=>parcelRequire('5A2f8'));

});

parcelRegister("kRC4s", function(module, exports) {

let $f30649f5367ae13d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f30649f5367ae13d$var$load("etHNI").then(()=>parcelRequire('5M5EC'));

});

parcelRegister("lEpOT", function(module, exports) {

let $fc315cacbbe83957$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fc315cacbbe83957$var$load("3WiUp").then(()=>parcelRequire('6QK8K'));

});

parcelRegister("kLNoH", function(module, exports) {

let $f1ee83bdd16b7c67$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f1ee83bdd16b7c67$var$load("bS1ax").then(()=>parcelRequire('5Dig0'));

});

parcelRegister("ifAHU", function(module, exports) {

let $d49619fae8fcf45d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d49619fae8fcf45d$var$load("j9OUx"),
    $d49619fae8fcf45d$var$load("l079e"),
    $d49619fae8fcf45d$var$load("bV8sS"),
    $d49619fae8fcf45d$var$load("44Li1")
]).then(()=>parcelRequire('k7fv3'));

});

parcelRegister("cJqIE", function(module, exports) {

let $944e69db480c2b44$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $944e69db480c2b44$var$load("68sdQ").then(()=>parcelRequire('eCiTS'));

});

parcelRegister("3YAFQ", function(module, exports) {

let $2e536c63ca4db68b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2e536c63ca4db68b$var$load("77dzh").then(()=>parcelRequire('eBV1M'));

});

parcelRegister("2jLJJ", function(module, exports) {

let $1b0262a11de7d7dc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1b0262a11de7d7dc$var$load("6NBZO").then(()=>parcelRequire('jzOsq'));

});

parcelRegister("hI8YY", function(module, exports) {

let $ce4d8371ee86d1a8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ce4d8371ee86d1a8$var$load("j31Az").then(()=>parcelRequire('24OvT'));

});

parcelRegister("WxDg7", function(module, exports) {

let $0aff818cdc48fd45$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0aff818cdc48fd45$var$load("k56jx").then(()=>parcelRequire('8PU9Z'));

});

parcelRegister("gGmca", function(module, exports) {

let $c251c919f6bc9a34$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c251c919f6bc9a34$var$load("4iSRl").then(()=>parcelRequire('4dnaM'));

});

parcelRegister("lWjDm", function(module, exports) {

let $ff8e3e9d33debc56$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ff8e3e9d33debc56$var$load("d0w2N").then(()=>parcelRequire('jRxlC'));

});

parcelRegister("1YB72", function(module, exports) {

let $17082ecb768a63d9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $17082ecb768a63d9$var$load("9IWvF").then(()=>parcelRequire('4r1nM'));

});

parcelRegister("b2GBy", function(module, exports) {

let $80a0ee0643597d33$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $80a0ee0643597d33$var$load("Pmv83").then(()=>parcelRequire('kepuY'));

});

parcelRegister("i7Lk4", function(module, exports) {

let $d31d96c58a4d75f2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d31d96c58a4d75f2$var$load("fjxJp").then(()=>parcelRequire('cfVzx'));

});

parcelRegister("7Fklt", function(module, exports) {

let $594c24e39d839380$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $594c24e39d839380$var$load("65uD9").then(()=>parcelRequire('fglhK'));

});

parcelRegister("5IuNg", function(module, exports) {

let $4298f2c7e06ca8f5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4298f2c7e06ca8f5$var$load("5gQy7").then(()=>parcelRequire('kcfNY'));

});

parcelRegister("hzPlC", function(module, exports) {

let $ccbd8926c4b36138$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ccbd8926c4b36138$var$load("9xmPC").then(()=>parcelRequire('11nrb'));

});

parcelRegister("7R5zC", function(module, exports) {

let $5b81ce71770291c5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5b81ce71770291c5$var$load("izlIU").then(()=>parcelRequire('gH2R4'));

});

parcelRegister("9bMtm", function(module, exports) {

let $6b0abdcb02cf58e9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6b0abdcb02cf58e9$var$load("3oRux").then(()=>parcelRequire('EGJr4'));

});

parcelRegister("exaah", function(module, exports) {

let $a94c08437d1abed5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a94c08437d1abed5$var$load("kUP81").then(()=>parcelRequire('633nq'));

});

parcelRegister("5R3SD", function(module, exports) {

let $4434e98a6147282d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4434e98a6147282d$var$load("IzvKp").then(()=>parcelRequire('ehIfn'));

});

parcelRegister("k265H", function(module, exports) {

let $e958b8124e2de777$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e958b8124e2de777$var$load("4APKF").then(()=>parcelRequire('beepI'));

});

parcelRegister("6soHb", function(module, exports) {

let $4b38839b700d3844$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4b38839b700d3844$var$load("i8F9y").then(()=>parcelRequire('3NTky'));

});

parcelRegister("aeo4w", function(module, exports) {

let $772de25ca8d10e90$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $772de25ca8d10e90$var$load("3Nc7d").then(()=>parcelRequire('nfKKY'));

});

parcelRegister("iiaFc", function(module, exports) {

let $d5122df6f5ce7345$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d5122df6f5ce7345$var$load("dLh5M").then(()=>parcelRequire('gXKeJ'));

});

parcelRegister("dDtix", function(module, exports) {

let $9ed5a4da223d424e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9ed5a4da223d424e$var$load("7S7lz").then(()=>parcelRequire('bcK8H'));

});

parcelRegister("ehnUp", function(module, exports) {

let $a65533043957aed6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a65533043957aed6$var$load("2ZNTa").then(()=>parcelRequire('8P1aa'));

});

parcelRegister("8EAnh", function(module, exports) {

let $64ce46614ab348a5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $64ce46614ab348a5$var$load("h0uBE"),
    $64ce46614ab348a5$var$load("1n8w9"),
    $64ce46614ab348a5$var$load("eBLgB"),
    $64ce46614ab348a5$var$load("fjrny")
]).then(()=>parcelRequire('dhWIx'));

});

parcelRegister("bH59h", function(module, exports) {

let $8837b44a57834809$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8837b44a57834809$var$load("hMh6Q").then(()=>parcelRequire('8Snjq'));

});

parcelRegister("7SQkZ", function(module, exports) {

let $5bd62cb095fe9c3c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5bd62cb095fe9c3c$var$load("7Lkvk").then(()=>parcelRequire('3okML'));

});

parcelRegister("1IcDg", function(module, exports) {

let $13f3b30a1fa8c7ac$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $13f3b30a1fa8c7ac$var$load("91duP").then(()=>parcelRequire('gHFZt'));

});

parcelRegister("7vmNV", function(module, exports) {

let $576d1e14108f6d1f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $576d1e14108f6d1f$var$load("14Bg4").then(()=>parcelRequire('8rFLj'));

});

parcelRegister("9gyxj", function(module, exports) {

let $6bf065dbcc4e2f3f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6bf065dbcc4e2f3f$var$load("gXJ2i").then(()=>parcelRequire('asNEt'));

});

parcelRegister("8cN5M", function(module, exports) {

let $5f95866a0d515935$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5f95866a0d515935$var$load("HY4Vc").then(()=>parcelRequire('4ykQ2'));

});

parcelRegister("c9qv9", function(module, exports) {

let $8d8ae1f256a13906$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8d8ae1f256a13906$var$load("iYHgz").then(()=>parcelRequire('eYr6k'));

});

parcelRegister("7OjpM", function(module, exports) {

let $5afc435098434bf1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5afc435098434bf1$var$load("blyPa").then(()=>parcelRequire('kJoum'));

});

parcelRegister("bbfmS", function(module, exports) {

let $823ca49269df530f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $823ca49269df530f$var$load("kDs7y").then(()=>parcelRequire('b4NXj'));

});

parcelRegister("dEeoU", function(module, exports) {

let $9efa2e7cffd61cc6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9efa2e7cffd61cc6$var$load("dWeF0").then(()=>parcelRequire('imSKL'));

});

parcelRegister("a7S5p", function(module, exports) {

let $75f483352e17c34e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $75f483352e17c34e$var$load("5Y5Hm").then(()=>parcelRequire('ftHHC'));

});

parcelRegister("6ZCCi", function(module, exports) {

let $517665108168f4bc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $517665108168f4bc$var$load("60RhQ").then(()=>parcelRequire('ehHfM'));

});

parcelRegister("1T6fM", function(module, exports) {

let $15ffc74c9d9c91ae$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $15ffc74c9d9c91ae$var$load("6UT2C").then(()=>parcelRequire('hdAEU'));

});

parcelRegister("jAuwn", function(module, exports) {

let $e4290df8ea78516e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e4290df8ea78516e$var$load("h47kR").then(()=>parcelRequire('bEFDz'));

});

parcelRegister("BoCck", function(module, exports) {

let $07068cdc83c37679$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $07068cdc83c37679$var$load("7bQq7").then(()=>parcelRequire('eEEMw'));

});

parcelRegister("eps0G", function(module, exports) {

let $a7d920adbe0c0459$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a7d920adbe0c0459$var$load("fYNZQ").then(()=>parcelRequire('9eCbu'));

});

parcelRegister("iIOMU", function(module, exports) {

let $da13bb7ba17ac414$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $da13bb7ba17ac414$var$load("Umxoq").then(()=>parcelRequire('5b8Rf'));

});

parcelRegister("4S5zS", function(module, exports) {

let $38c0882c243b1d2c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $38c0882c243b1d2c$var$load("dWBnF").then(()=>parcelRequire('1rbp7'));

});

parcelRegister("idqpU", function(module, exports) {

let $036c187ee283eb4c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $036c187ee283eb4c$var$load("4vUeL").then(()=>parcelRequire('idmAf'));

});

parcelRegister("7AsV2", function(module, exports) {

let $586253e617430a5f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $586253e617430a5f$var$load("kgAik").then(()=>parcelRequire('5qYor'));

});

parcelRegister("bE0f4", function(module, exports) {

let $87a39e304447175a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $87a39e304447175a$var$load("6nx0x").then(()=>parcelRequire('UVBHs'));

});

parcelRegister("3NSlb", function(module, exports) {

let $2c5019a501a44726$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2c5019a501a44726$var$load("jaV8G").then(()=>parcelRequire('0Xemw'));

});

parcelRegister("9JGNt", function(module, exports) {

let $7169839ca42a45b3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7169839ca42a45b3$var$load("2glzF").then(()=>parcelRequire('3zmBy'));

});

parcelRegister("1rLBl", function(module, exports) {

let $10dd3cae7325e2c4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $10dd3cae7325e2c4$var$load("kTurq"),
    $10dd3cae7325e2c4$var$load("fviv5"),
    $10dd3cae7325e2c4$var$load("djb49"),
    $10dd3cae7325e2c4$var$load("kE4VR")
]).then(()=>parcelRequire('2zbyK'));

});

parcelRegister("kcXUD", function(module, exports) {

let $eb636706110dbc31$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $eb636706110dbc31$var$load("fCOeQ").then(()=>parcelRequire('ctb0H'));

});

parcelRegister("geO04", function(module, exports) {

let $bd24bd262a15e87e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bd24bd262a15e87e$var$load("2YffH").then(()=>parcelRequire('8zeNo'));

});

parcelRegister("7aqQ6", function(module, exports) {

let $537e494a67697620$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $537e494a67697620$var$load("27NfI").then(()=>parcelRequire('l67DE'));

});

parcelRegister("7uyYt", function(module, exports) {

let $574676eaafbc18e6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $574676eaafbc18e6$var$load("2VAr2").then(()=>parcelRequire('62Ykk'));

});

parcelRegister("4kNVQ", function(module, exports) {

let $327fc3251250de5f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $327fc3251250de5f$var$load("i05W6").then(()=>parcelRequire('ksxpk'));

});

parcelRegister("h0S0O", function(module, exports) {

let $c62c5573ea440e97$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c62c5573ea440e97$var$load("ghoVB").then(()=>parcelRequire('3ku7m'));

});

parcelRegister("lOJR8", function(module, exports) {

let $fe21d68c92176a8f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fe21d68c92176a8f$var$load("kddSb").then(()=>parcelRequire('1qmxj'));

});

parcelRegister("48R9K", function(module, exports) {

let $3041247e41cb50f8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3041247e41cb50f8$var$load("6Z8WE").then(()=>parcelRequire('iaMDd'));

});

parcelRegister("aKSm9", function(module, exports) {

let $7d485d464be9cb33$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7d485d464be9cb33$var$load("g6xo3").then(()=>parcelRequire('cUgAc'));

});

parcelRegister("ly1ZR", function(module, exports) {

let $fafe52726b585cb8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fafe52726b585cb8$var$load("j2xC0").then(()=>parcelRequire('jT2TW'));

});

parcelRegister("eybrM", function(module, exports) {

let $a97d1ed3da699a93$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a97d1ed3da699a93$var$load("8T0gf").then(()=>parcelRequire('bcxcq'));

});

parcelRegister("eg7hI", function(module, exports) {

let $a61835e6cae60bda$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a61835e6cae60bda$var$load("fgtb2").then(()=>parcelRequire('3CQDq'));

});

parcelRegister("3OrPG", function(module, exports) {

let $2c6ba18fdcaa0bc7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2c6ba18fdcaa0bc7$var$load("b8sPf").then(()=>parcelRequire('cZiB3'));

});

parcelRegister("eAHsz", function(module, exports) {

let $a9f623b5af893e4f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a9f623b5af893e4f$var$load("lRy8u").then(()=>parcelRequire('eNRbc'));

});

parcelRegister("6VkGv", function(module, exports) {

let $50a81c7654274e09$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $50a81c7654274e09$var$load("1x5Vt").then(()=>parcelRequire('1qt4R'));

});

parcelRegister("6WIEr", function(module, exports) {

let $50eacbac7a363124$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $50eacbac7a363124$var$load("5VWb9").then(()=>parcelRequire('6ygMR'));

});

parcelRegister("amhIJ", function(module, exports) {

let $78a9b4655d1a6bb6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $78a9b4655d1a6bb6$var$load("3qbnQ").then(()=>parcelRequire('gbdrY'));

});

parcelRegister("amc4v", function(module, exports) {

let $78a552a420c2e700$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $78a552a420c2e700$var$load("9uVpc").then(()=>parcelRequire('8CvsG'));

});

parcelRegister("BB5fd", function(module, exports) {

let $071038d80749de9a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $071038d80749de9a$var$load("khxZX").then(()=>parcelRequire('3rcDX'));

});

parcelRegister("g0YTk", function(module, exports) {

let $ba8be136b08e120f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ba8be136b08e120f$var$load("1xWId").then(()=>parcelRequire('5h8br'));

});

parcelRegister("gDp7m", function(module, exports) {

let $c1c3c5b97a83e58a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c1c3c5b97a83e58a$var$load("3e5gt").then(()=>parcelRequire('4LrFA'));

});

parcelRegister("4Uc1x", function(module, exports) {

let $3925b815fc87e448$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3925b815fc87e448$var$load("duuHe").then(()=>parcelRequire('HoRo1'));

});

parcelRegister("erep4", function(module, exports) {

let $a82ec27d410dd158$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a82ec27d410dd158$var$load("bm2JI").then(()=>parcelRequire('93vxT'));

});

parcelRegister("dpvhi", function(module, exports) {

let $9c35df4d82fd5ac1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9c35df4d82fd5ac1$var$load("ciAVN"),
    $9c35df4d82fd5ac1$var$load("3HU3r")
]).then(()=>parcelRequire('iHpDm'));

});

parcelRegister("67nq6", function(module, exports) {

let $474590441c2cfde2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $474590441c2cfde2$var$load("dBhbr").then(()=>parcelRequire('ohVBG'));

});





parcelRegister("ezH4I", function(module, exports) {

$parcel$export(module.exports, "shouldUseOriginalElement", () => $4b3ec0821606f7ca$export$63934da3851c8633);
$parcel$export(module.exports, "lookupOriginalElement", () => $4b3ec0821606f7ca$export$e2641d9526374e60);
$parcel$export(module.exports, "getServerMarkup", () => $4b3ec0821606f7ca$export$c0d0f0d932478a98);
$parcel$export(module.exports, "getTotalHydratedElements", () => $4b3ec0821606f7ca$export$84b00002df734b1f);
$parcel$export(module.exports, "initLoadablePlaceholders", () => $4b3ec0821606f7ca$export$744cb48e81bb5e22);
$parcel$export(module.exports, "cleanUpLoadablePlaceholders", () => $4b3ec0821606f7ca$export$69945a3a97aa6a3f);
$parcel$export(module.exports, "getAndIncreaseServerMarkupPointer", () => $4b3ec0821606f7ca$export$910d417246cb12ca);

var $l3KBO = parcelRequire("l3KBO");

var $398ES = parcelRequire("398ES");
// Fix case for <p><span><marker start><span></p><marker end>
// Increase the depth needed if found other cases
const $4b3ec0821606f7ca$var$MAX_MOVE_UP_LEVEL_FOR_BEGIN_MARKER = 2;
const $4b3ec0821606f7ca$var$serverMarkup = new Map();
const $4b3ec0821606f7ca$var$serverMarkupIndexMap = new Map();
const $4b3ec0821606f7ca$var$refToOriginalElement = new WeakMap();
const $4b3ec0821606f7ca$export$18e9263e8e05fc3 = 10000; // 10s
const $4b3ec0821606f7ca$var$dataLoadableBeginRegex = /data-loadable-begin="([^"]*)"/;
const $4b3ec0821606f7ca$var$dataLoadableEndRegex = /data-loadable-end="([^"]*)"/;
let $4b3ec0821606f7ca$var$totalElementsToHydrate = 0;
function $4b3ec0821606f7ca$export$63934da3851c8633(el) {
    const tagName = el.tagName.toUpperCase();
    return tagName === 'VIDEO' || tagName === 'AUDIO' || tagName === 'IMG';
}
function $4b3ec0821606f7ca$var$saveRefToOriginalElement(el, clone) {
    if (!(el instanceof Element) || !(clone instanceof Element)) return;
    // For certain node like img. Inserting a cloned node or re-creating triggers the load again.
    // This caused flickering in emoji and media image. HOT-105601
    // Here we are walking the DOM tree and keeping a map of cloned node to original node.
    // Later when creating the placeholder from SSR result we can use the original node directly.
    if ($4b3ec0821606f7ca$export$63934da3851c8633(el)) $4b3ec0821606f7ca$var$refToOriginalElement.set(clone, el);
    el.childNodes.forEach((child, i)=>{
        $4b3ec0821606f7ca$var$saveRefToOriginalElement(child, clone.childNodes[i]);
    });
}
function $4b3ec0821606f7ca$export$e2641d9526374e60(el) {
    return $4b3ec0821606f7ca$var$refToOriginalElement.get(el);
}
function $4b3ec0821606f7ca$export$c42217d53a7ebafb(fromEl, loadableId) {
    let el = fromEl;
    const nodes = [];
    while(el = el.nextSibling){
        if (el instanceof HTMLElement) {
            if (el.dataset?.loadableEnd === loadableId) break;
            if (el.dataset?.loadableBegin || el.dataset?.loadableEnd) continue;
        }
        const clone = el.cloneNode(true);
        $4b3ec0821606f7ca$var$saveRefToOriginalElement(el, clone);
        nodes.push($4b3ec0821606f7ca$var$filterMarkers(clone));
    }
    return nodes;
}
function $4b3ec0821606f7ca$export$ccab362c10c055(fromEl, loadableId) {
    let el = fromEl;
    let foundCloseMarker = false;
    const nodes = [];
    while(el = el.nextSibling){
        const match = el?.nodeValue?.match($4b3ec0821606f7ca$var$dataLoadableEndRegex);
        if (match && match[1] === loadableId) {
            foundCloseMarker = true;
            break;
        }
        if (el instanceof Element) {
            const clone = el.cloneNode(true);
            $4b3ec0821606f7ca$var$saveRefToOriginalElement(el, clone);
            nodes.push(clone);
        }
    }
    return {
        cloned: nodes,
        foundCloseMarker: foundCloseMarker
    };
}
function $4b3ec0821606f7ca$var$filterMarkers(el) {
    // Deleted node doesn't have childNodes so wait until the end
    const pendingRemove = [];
    el.childNodes.forEach((child)=>{
        if (child instanceof HTMLElement && (child.dataset?.loadableBegin || child.dataset?.loadableEnd)) pendingRemove.push(child);
        $4b3ec0821606f7ca$var$filterMarkers(child);
    });
    pendingRemove.forEach((node)=>node.remove());
    return el;
}
function $4b3ec0821606f7ca$var$findAndCollectCommentMarkers(root) {
    const nodes = root.childNodes;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        const nodeType = node.nodeType;
        if (nodeType === Node.COMMENT_NODE && node?.nodeValue?.includes('data-loadable-begin')) {
            const match = node.nodeValue?.match($4b3ec0821606f7ca$var$dataLoadableBeginRegex);
            if (!match) continue;
            const loadableId = match[1];
            /**
			 * This is a bit messed up.
			 * In renderer there are case like <span><!-- begin -->..<div>...<!-- end --></span>
			 * This is an invalid HTML browser will correct it by closing the span tag.
			 * It ends up like <span><!-- begin --></span>..<div>...<!-- end --></div>
			 * In this case the ancestor of the begin marker should be treated as the begin marker.
			 */ let clonedElements = [];
            let beginNode = node;
            let moveUpLevelCount = 0;
            while(beginNode && moveUpLevelCount <= $4b3ec0821606f7ca$var$MAX_MOVE_UP_LEVEL_FOR_BEGIN_MARKER){
                const { cloned: cloned, foundCloseMarker: foundCloseMarker } = $4b3ec0821606f7ca$export$ccab362c10c055(beginNode, loadableId);
                if (foundCloseMarker) {
                    clonedElements = cloned;
                    break;
                } else {
                    // If we didn't find the close marker, we need to go up the tree and find the next begin marker.
                    beginNode = beginNode.parentNode;
                    moveUpLevelCount++;
                }
            }
            if (!clonedElements.length) continue;
            $4b3ec0821606f7ca$var$totalElementsToHydrate += 1;
            if ($4b3ec0821606f7ca$var$serverMarkup.has(loadableId)) $4b3ec0821606f7ca$var$serverMarkup.get(loadableId).push(clonedElements);
            else {
                $4b3ec0821606f7ca$var$serverMarkup.set(loadableId, [
                    clonedElements
                ]);
                $4b3ec0821606f7ca$var$serverMarkupIndexMap.set(loadableId, 0);
            }
        } else if (nodeType === Node.ELEMENT_NODE) $4b3ec0821606f7ca$var$findAndCollectCommentMarkers(node);
    }
}
function $4b3ec0821606f7ca$export$c0d0f0d932478a98() {
    return $4b3ec0821606f7ca$var$serverMarkup;
}
function $4b3ec0821606f7ca$export$4bb360e7ccd41a27() {
    return $4b3ec0821606f7ca$var$serverMarkupIndexMap;
}
function $4b3ec0821606f7ca$export$84b00002df734b1f() {
    return $4b3ec0821606f7ca$var$totalElementsToHydrate;
}
function $4b3ec0821606f7ca$export$744cb48e81bb5e22() {
    $4b3ec0821606f7ca$var$findAndCollectCommentMarkers(document.body);
}
function $4b3ec0821606f7ca$export$69945a3a97aa6a3f() {
    // Delay cleaning up server markups.
    // On a slower device or poor network connection, the client side rendering might not be completed,
    // server markups are still in use. Therefore, wait for ${DELAY_CLEAN_UP_SERVER_MARKUP_TIME}(10s) before clean it up.
    (0, $l3KBO.getTaskManager)().push({
        id: 'clean-up-server-markup',
        task: ()=>{
            setTimeout(()=>{
                $4b3ec0821606f7ca$var$serverMarkup.clear();
                $4b3ec0821606f7ca$var$serverMarkupIndexMap.clear();
                $4b3ec0821606f7ca$var$totalElementsToHydrate = 0;
            }, $4b3ec0821606f7ca$export$18e9263e8e05fc3);
        },
        priority: (0, $398ES.LoadingPriority).BACKGROUND
    });
}
function $4b3ec0821606f7ca$export$910d417246cb12ca(loadableId) {
    if (!loadableId || !$4b3ec0821606f7ca$var$serverMarkupIndexMap.has(loadableId)) return;
    const index = $4b3ec0821606f7ca$var$serverMarkupIndexMap.get(loadableId);
    $4b3ec0821606f7ca$var$serverMarkupIndexMap.set(loadableId, index + 1);
    return index;
}

});
parcelRegister("l3KBO", function(module, exports) {

$parcel$export(module.exports, "getTaskManager", () => $c072487ed52e1be0$export$68bd643cc48865fe);

var $2jjxD = parcelRequire("2jjxD");

var $7W8i8 = parcelRequire("7W8i8");

var $f5DmR = parcelRequire("f5DmR");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $jrqSm = parcelRequire("jrqSm");

var $398ES = parcelRequire("398ES");
const $c072487ed52e1be0$var$logger = (0, $7W8i8.getLogger)('TaskManager');
const $c072487ed52e1be0$var$TASK_TIME_QUANTUM = 35; // ms
const $c072487ed52e1be0$var$TASK_DELAY = 5; // ms
const $c072487ed52e1be0$var$trackLoadingPhase = (loadingPhase)=>{
    typeof window !== 'undefined' && undefined;
};
const $c072487ed52e1be0$var$isInputPending = ()=>{
    // This API is only available in Chrome 87 and higher, as of Oct 2021
    return navigator?.scheduling?.isInputPending() || false;
};
class $c072487ed52e1be0$export$9d8267e945b03765 {
    push({ id: id, priority: priority, task: task, _delayHydration: _delayHydration = false }) {
        if (this.disabled) priority = (0, $398ES.LoadingPriority).PAINT;
        if (_delayHydration && !this.serverMarkupHydratedCountMap.has(id)) this.serverMarkupHydratedCountMap.set(id, 0);
        if (_delayHydration && //totalTasksHydratedAtOnce acts as a switch to turn on/off hydration delay
        window.__SSR_RENDERED__ && this.totalTasksHydratedAtOncePerTaskId > 0 && this.serverMarkupHydratedCountMap.has(id)) {
            if (this.serverMarkupHydratedCountMap.get(id) >= this.totalTasksHydratedAtOncePerTaskId) return new Promise((resolve, reject)=>{
                const timer = setTimeout(()=>{
                    this.push({
                        id: id,
                        priority: priority,
                        task: task,
                        _delayHydration: _delayHydration
                    }).then(resolve, reject).finally(()=>clearTimeout(timer));
                }, 1);
            });
        }
        const futureTask = (0, $jrqSm.createFutureTask)(`${id}:${priority}`, task, this.maxQueueTimeMs);
        const QueueItem = {
            id: id,
            futureTask: futureTask,
            priority: priority,
            _delayHydration: _delayHydration
        };
        this.queue.add(QueueItem, QueueItem.priority);
        if (_delayHydration && //totalTasksHydratedAtOnce acts as a switch to turn on/off hydration delay
        window.__SSR_RENDERED__ && this.totalTasksHydratedAtOncePerTaskId > 0 && this.serverMarkupHydratedCountMap.has(id)) this.serverMarkupHydratedCountMap.set(id, this.serverMarkupHydratedCountMap.get(id) + 1);
        if (priority === (0, $398ES.LoadingPriority).PAINT) QueueItem.futureTask.run();
        this.runTasks();
        return futureTask.result;
    }
    reset() {
        this.allowedPriority = (0, $398ES.LoadingPriority).PAINT;
    }
    constructor(options = {}){
        this.maxQueueTimeMs = void 0;
        this.debounceTimeMs = void 0;
        this.disabled = void 0;
        this.allowedPriority = void 0;
        this.totalTasksHydratedAtOncePerTaskId = void 0;
        this.serverMarkupHydratedCountMap = void 0;
        // This is a priority queue. Lower priority numbers are ordered first.
        this.queue = new (0, $f5DmR.BucketQueue)((0, $398ES.LoadingPriority).MAX_PRIORITY);
        this.running = new Set();
        /**
     * Run any tasks that are the same priority as the head of the queue.
     *
     * This is debounced to allow for higher-priority tasks that are queued
     * (slightly) later to be run first.
     */ this.runTasks = void 0;
        let DEBUG_STEP_OVER = false;
        try {
            // handle The "operation is insecure" when cookie is disabled
            DEBUG_STEP_OVER = typeof window !== 'undefined' && Boolean((0, $e9zUf.confluenceSessionStorageInstance)?.getItem((0, $1UApO.keys).CONFLUENCE_LOADABLE_STEP_OVER_ENABLED));
        } catch (e) {}
        this.maxQueueTimeMs = options.maxQueueTimeMs || (DEBUG_STEP_OVER ? 0 : 10000);
        this.debounceTimeMs = options.debounceTimeMs || 0;
        this.disabled = options.disabled || false;
        this.allowedPriority = DEBUG_STEP_OVER ? (0, $398ES.LoadingPriority).PAINT : (0, $398ES.LoadingPriority).MAX_PRIORITY;
        this.totalTasksHydratedAtOncePerTaskId = options.totalHydratedAtOnce || 0;
        this.serverMarkupHydratedCountMap = new Map();
        this.runTasks = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(()=>{
            const deadline = performance.now() + $c072487ed52e1be0$var$TASK_TIME_QUANTUM;
            // Get all the heap items unless that is no more item with the same priority
            let lastPriority = Infinity;
            const batch = [];
            while(!this.running.size && this.queue.size && this.queue.peek().priority <= Math.min(this.allowedPriority, lastPriority)){
                // If runTask takes more than TIME_QUANTUM ms and there's a pending input
                // break the task execution to allow time for an input handler
                if ($c072487ed52e1be0$var$isInputPending() && performance.now() >= deadline) {
                    setTimeout(()=>this.runTasks(), $c072487ed52e1be0$var$TASK_DELAY);
                    return;
                }
                const item = this.queue.poll();
                lastPriority = item.priority;
                $c072487ed52e1be0$var$trackLoadingPhase(lastPriority);
                // Run task
                item.futureTask.run();
                batch.push(item);
                // On task finish
                item.futureTask.result.finally(()=>{
                    this.running.delete(item);
                    if (item._delayHydration && //totalTasksHydratedAtOnce acts as a switch to turn on/off hydration delay
                    window.__SSR_RENDERED__ && this.totalTasksHydratedAtOncePerTaskId > 0 && this.serverMarkupHydratedCountMap.has(item.id)) this.serverMarkupHydratedCountMap.set(item.id, this.serverMarkupHydratedCountMap.get(item.id) - 1);
                    this.runTasks();
                });
            }
            batch.forEach((t)=>this.running.add(t));
            batch.length = 0;
        }, this.debounceTimeMs);
        if (DEBUG_STEP_OVER) document.addEventListener('loadable-devtool-next-phase', ()=>{
            this.allowedPriority = Math.min(this.allowedPriority + 1, (0, $398ES.LoadingPriority).MAX_PRIORITY);
            $c072487ed52e1be0$var$logger.debug`Allowed priority: ${this.allowedPriority}. Remaining tasks: ${this.queue.size}`;
            this.runTasks();
        });
    }
}
let $c072487ed52e1be0$var$taskManager;
const $c072487ed52e1be0$export$68bd643cc48865fe = (options)=>{
    if (!$c072487ed52e1be0$var$taskManager) $c072487ed52e1be0$var$taskManager = new $c072487ed52e1be0$export$9d8267e945b03765({
        disabled: false,
        ...options
    });
    return $c072487ed52e1be0$var$taskManager;
};

});
parcelRegister("f5DmR", function(module, exports) {

$parcel$export(module.exports, "BucketQueue", () => $5b5fdfb1337bae5e$export$6cea0ddf8367090d);
/**
 * Bucket Queue
 *
 * A priority queue supporting N number of buckets
 * that represent the order in which items will be
 * dequeued. The lower the bucket-index, the higher
 * priority its items
 */ class $5b5fdfb1337bae5e$export$6cea0ddf8367090d {
    /**
   * Add
   *
   * Adds an item to the queue into the bucket specified. The
   * lower the number, the sooner your item will be dequeued
   */ add(t, bucket) {
        if (bucket >= this.buckets.length || bucket < 0) throw new Error('Range error: The bucket specified does not exist');
        this.buckets[bucket].push(t);
        this.size++;
    }
    /**
   * Peek
   *
   * Returns the highest priority item in the queue
   */ peek() {
        for (const bucket of this.buckets){
            if (bucket.length) return bucket[0];
        }
        return null;
    }
    /**
   * Poll
   *
   * Returns the highest priority item in the queue by
   * dequeuing it
   */ poll() {
        for (const bucket of this.buckets)if (bucket.length) {
            this.size--;
            return bucket.shift();
        }
        return null;
    }
    constructor(max){
        this.buckets = void 0;
        this.size = void 0;
        this.size = 0;
        this.buckets = Array(max + 1).fill(null).map(()=>[]);
    }
}

});

parcelRegister("jrqSm", function(module, exports) {

$parcel$export(module.exports, "createFutureTask", () => $6b5ba91e016c9f96$export$f95417658c1a3941);

var $7W8i8 = parcelRequire("7W8i8");
const $6b5ba91e016c9f96$var$logger = (0, $7W8i8.getLogger)('FutureTask');
const $6b5ba91e016c9f96$export$f95417658c1a3941 = (id, task, timeout)=>{
    let resolve;
    let reject;
    let started = false;
    let timer;
    const run = ()=>{
        if (started) return;
        if (timer && typeof clearTimeout !== 'undefined') clearTimeout(timer);
        started = true;
        $6b5ba91e016c9f96$var$logger.debug`${id} start`;
        try {
            const result = task();
            if (result instanceof Promise) result.then(resolve, reject);
            else resolve(result);
        } catch (e) {
            // result can be a Promise or a value
            // The try catch cannot catch async errors
            // It is used to catch sync throws
            reject(e);
        }
    };
    if (timeout && typeof setTimeout !== 'undefined') timer = setTimeout(run, timeout);
    return {
        get started () {
            return started;
        },
        result: new Promise((_resolve, _reject)=>{
            resolve = _resolve;
            reject = _reject;
        }),
        run: run
    };
};

});

parcelRegister("398ES", function(module, exports) {

$parcel$export(module.exports, "LoadingPriority", () => $9a0adacc260d241b$export$30478ea03273cd5);
$parcel$export(module.exports, "NOOP", () => $9a0adacc260d241b$export$5702a91a6f42969f);
/* eslint-disable check-file/filename-blocklist */ var $9a0adacc260d241b$export$30478ea03273cd5 = /*#__PURE__*/ function(LoadingPriority) {
    LoadingPriority[LoadingPriority["PAINT"] = 0] = "PAINT";
    // setting hover priority higher than after paint because there could be after paint components inside hover
    // and that can mess up the hierarchy order of components
    LoadingPriority[LoadingPriority["HYDRATE_ON_HOVER"] = 1] = "HYDRATE_ON_HOVER";
    LoadingPriority[LoadingPriority["AFTER_PAINT"] = 2] = "AFTER_PAINT";
    LoadingPriority[LoadingPriority["LAZY"] = 3] = "LAZY";
    LoadingPriority[LoadingPriority["BACKGROUND"] = 4] = "BACKGROUND";
    LoadingPriority[LoadingPriority["MAX_PRIORITY"] = 4] = "MAX_PRIORITY";
    return LoadingPriority;
}({});
const $9a0adacc260d241b$export$5702a91a6f42969f = ()=>null;

});



parcelRegister("3GQl6", function(module, exports) {

$parcel$export(module.exports, "preloadLoadable", () => $c077ecb804e28fe3$export$a6e3ec3b92c2b541);
$parcel$export(module.exports, "preloadIfNeeded", () => $c077ecb804e28fe3$export$be3c90707c2c118c);
$parcel$export(module.exports, "mustPreloadWhenRenderingSPA", () => $c077ecb804e28fe3$export$30d89501e59f558f);

var $7W8i8 = parcelRequire("7W8i8");

var $5ZqQS = parcelRequire("5ZqQS");
var $fJlJm = parcelRequire("fJlJm");
parcelRequire("fPnFe");
var $dr1zO = parcelRequire("dr1zO");
var $eUgss = parcelRequire("eUgss");

var $b6HON = parcelRequire("b6HON");
const $c077ecb804e28fe3$var$logger = (0, $7W8i8.getLogger)('Loadable');
const $c077ecb804e28fe3$var$LOADING_TIMEOUT = 8500;
let $c077ecb804e28fe3$var$pending = [];
let $c077ecb804e28fe3$var$resolveMap = {};
let $c077ecb804e28fe3$var$loadableSet = new Set();
let $c077ecb804e28fe3$var$preloadOnlyLoadableSet = new Set();
let $c077ecb804e28fe3$var$conditionalLoadableSet = new Set();
const $c077ecb804e28fe3$var$EVENT_STREAM_NAME = 'loadables';
let $c077ecb804e28fe3$var$clientInitialized = false;
function $c077ecb804e28fe3$var$enqueueLoadable(id) {
    const { resolve: resolve, promise: promise } = (0, $b6HON.defer)($c077ecb804e28fe3$var$LOADING_TIMEOUT, ()=>{
        $c077ecb804e28fe3$var$logger.error`__LOADABLE__ timed out: ${id}`;
        if (!window.__LOADABLE_TIMEOUTS__) window.__LOADABLE_TIMEOUTS__ = [];
        window.__LOADABLE_TIMEOUTS__.push(id);
    });
    $c077ecb804e28fe3$var$pending.push(promise);
    $c077ecb804e28fe3$var$resolveMap[id] = resolve;
}
function $c077ecb804e28fe3$var$initializeLoadable() {
    if (!$c077ecb804e28fe3$var$clientInitialized && window?.__SSR_REACT_STREAMING__) {
        (0, $dr1zO.getClientStream)($c077ecb804e28fe3$var$EVENT_STREAM_NAME).addListener((event)=>{
            $c077ecb804e28fe3$var$enqueueLoadable(event.id);
        });
        $c077ecb804e28fe3$var$clientInitialized = true;
        return;
    }
    if ($c077ecb804e28fe3$var$pending.length === 0) for (const nameOrId of window['__LOADABLE__'] || [])$c077ecb804e28fe3$var$enqueueLoadable(nameOrId);
}
function $c077ecb804e28fe3$export$a6e3ec3b92c2b541() {
    $c077ecb804e28fe3$var$initializeLoadable();
    return Promise.all($c077ecb804e28fe3$var$pending).then(()=>{
        if (window.__LOADABLE_TIMEOUTS__?.length) {
            const error = new Error(`Loadable initialization timeout`);
            const loadableIds = window.__LOADABLE_TIMEOUTS__;
            (0, $fJlJm.setLoadableErrorAttributes)(error, {
                loadableIds: loadableIds
            });
            // NOTE: apparently there's plenty of timeout errors happen during the normal flow of operation.
            // While we need to troubleshoot and fix them eventually, we don't want to flood the monitoring,
            // but we also want to track and alert upon them. Hence using a separate attribution.
            if (navigator.onLine) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: 'backbone-loadable'
            });
        }
    });
}
function $c077ecb804e28fe3$export$be3c90707c2c118c(id, name, preload) {
    $c077ecb804e28fe3$var$initializeLoadable();
    if (id && id in $c077ecb804e28fe3$var$resolveMap || name && name in $c077ecb804e28fe3$var$resolveMap) {
        const resolve = ()=>{
            // Note that due to the _mustPreloadWhenRenderingSPA logic the loadable may appear
            // in the list of loadables both under id and under name. If we have 2 entries for
            // the loadable, we should resolve both.
            if (id && $c077ecb804e28fe3$var$resolveMap[id]) $c077ecb804e28fe3$var$resolveMap[id]();
            if (name && $c077ecb804e28fe3$var$resolveMap[name]) $c077ecb804e28fe3$var$resolveMap[name]();
        };
        $c077ecb804e28fe3$var$logger.debug`SSR Preload: ${name || id}`;
        preload().then(resolve, (e)=>{
            $c077ecb804e28fe3$var$logger.error(e);
            resolve();
        });
    }
}
function $c077ecb804e28fe3$export$4ea5af06371f7b61(id, options) {
    if (!id) return;
    if (typeof id === 'string') {
        $c077ecb804e28fe3$var$preloadOnlyLoadableSet.add(id);
        if (!options?.preloadOnly) {
            if (window?.__SSR_REACT_STREAMING__) {
                if (!$c077ecb804e28fe3$var$loadableSet.has(id)) {
                    $c077ecb804e28fe3$var$loadableSet.add(id);
                    (0, $eUgss.getServerStream)($c077ecb804e28fe3$var$EVENT_STREAM_NAME).emit({
                        id: id
                    });
                }
            } else $c077ecb804e28fe3$var$loadableSet.add(id);
        }
    } else $c077ecb804e28fe3$var$conditionalLoadableSet.add(id);
}
function $c077ecb804e28fe3$export$cab4cd9f10ff9148() {
    return {
        loadableIds: Array.from($c077ecb804e28fe3$var$loadableSet),
        preloadOnlyLoadableIds: Array.from($c077ecb804e28fe3$var$preloadOnlyLoadableSet),
        conditionalLoadableIds: Array.from($c077ecb804e28fe3$var$conditionalLoadableSet)
    };
}
function $c077ecb804e28fe3$export$30d89501e59f558f(loadableIds) {
    var id;
}
function $c077ecb804e28fe3$export$bb24ec95ef11c72f() {
    $c077ecb804e28fe3$var$pending = [];
    $c077ecb804e28fe3$var$resolveMap = {};
    $c077ecb804e28fe3$var$loadableSet = new Set();
    $c077ecb804e28fe3$var$preloadOnlyLoadableSet = new Set();
    $c077ecb804e28fe3$var$conditionalLoadableSet = new Set();
    $c077ecb804e28fe3$var$clientInitialized = false;
}

});
parcelRegister("b6HON", function(module, exports) {

$parcel$export(module.exports, "defer", () => $f1ff60606a74851f$export$260e5c0943f31606);
/**
 * Returns a promise that can be resolved by calling the resolve function.
 * The promise will be resolved automatically after timeout
 */ function $f1ff60606a74851f$export$260e5c0943f31606(timeout, timeoutCallback) {
    let resolve;
    let timerId;
    const promise = new Promise((_resolve)=>{
        timerId = setTimeout(()=>{
            _resolve();
            if (timeoutCallback) timeoutCallback();
        }, timeout);
        resolve = _resolve;
    });
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    promise.finally(()=>{
        clearTimeout(timerId);
    });
    return {
        promise: promise,
        resolve: // @ts-ignore
        resolve
    };
}

});


parcelRegister("9j59h", function(module, exports) {

$parcel$export(module.exports, "BrowserNotSupportedLoader", () => $3e043679f890d9f3$export$bd1eaa02d03f4b49);

var $jmjWc = parcelRequire("jmjWc");

const $3e043679f890d9f3$export$bd1eaa02d03f4b49 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "viEzP",
    name: "BrowserNotSupportedLoader",
    loader: async ()=>(await (parcelRequire("gEVnQ"))).BrowserNotSupported
});

});
parcelRegister("jmjWc", function(module, exports) {

$parcel$export(module.exports, "createLoadable", () => $88e8236427be3059$export$7036027578ebb3d7);
$parcel$export(module.exports, "LoadablePaint", () => $88e8236427be3059$export$8227ef1c198f3b6c);
$parcel$export(module.exports, "LoadableAfterPaint", () => $88e8236427be3059$export$c96dcd31adf45b8c);
$parcel$export(module.exports, "LoadableLazy", () => $88e8236427be3059$export$d0978c060f6515fd);
$parcel$export(module.exports, "LoadableBackground", () => $88e8236427be3059$export$a81c0ed1ccdb363e);
$parcel$export(module.exports, "LoadableHydrateOnHover", () => $88e8236427be3059$export$6f7fe07ec2db9207);

var $5ZqQS = parcelRequire("5ZqQS");

var $9wGTI = parcelRequire("9wGTI");

var $7W8i8 = parcelRequire("7W8i8");

var $l3KBO = parcelRequire("l3KBO");

var $3GQl6 = parcelRequire("3GQl6");

var $398ES = parcelRequire("398ES");

var $hpjl4 = parcelRequire("hpjl4");

var $f0R75 = parcelRequire("f0R75");

var $bFjHK = parcelRequire("bFjHK");


var $lipSU = parcelRequire("lipSU");
const $88e8236427be3059$var$logger = (0, $7W8i8.getLogger)('Loadable');
function $88e8236427be3059$var$markLoadingStart(loadableName, priority) {
    const startMark = `${loadableName}(${priority})${(0, $hpjl4.JS_LOAD_START)}`;
    if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    priority <= (0, $398ES.LoadingPriority).AFTER_PAINT && performance?.getEntriesByName?.(startMark)?.length === 0) performance.mark(startMark);
}
function $88e8236427be3059$var$markLoadingEnd(loadableName, priority) {
    const endMark = `${loadableName}(${priority})${(0, $hpjl4.JS_LOAD_END)}`;
    if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    priority <= (0, $398ES.LoadingPriority).AFTER_PAINT && performance?.getEntriesByName?.(endMark)?.length === 0) performance.mark(endMark);
}
/**
 * Wraps a promise-returning function with a network online check.
 * If the network is online, it returns the function as is.
 * If the network is offline, it returns a new function that waits for the network to come online before calling the original function.
 * @param fn - The function to wrap.
 * @returns A new function that checks the network status before calling the original function.
 * @internal
 */ function $88e8236427be3059$var$wrapWithNetworkOnlineCheck(fn) {
    if (window.navigator.onLine) // If online, no delay is needed
    return fn;
    return ()=>new Promise((resolve)=>{
            if (window.navigator.onLine) // If online, resolve the promise immediately
            // We're double-checking here incase the network status changes between initializing this callback and running it
            resolve(fn());
            else {
                const onNetworkChange = ()=>{
                    if (window.navigator.onLine) {
                        // If online, resolve the promise and remove the event listener
                        resolve(fn());
                        window.removeEventListener('online', onNetworkChange);
                    }
                };
                window.addEventListener('online', onNetworkChange);
            }
        });
}
function $88e8236427be3059$var$evaluateBooleanOrPredicate(condition) {
    if (typeof condition === 'function') return condition();
    return condition;
}
function $88e8236427be3059$export$7036027578ebb3d7(priority) {
    return (definition)=>{
        const { __loadable_id__: __loadable_id__, loader: loader, name: name, waitForNetworkOnline: waitForNetworkOnline = false } = definition;
        const loadableName = name || __loadable_id__ || 'unknown';
        const displayName = `Loadable(${loadableName})`;
        const loadedModuleRef = {
            ref: null
        };
        const totalHydratedAtOnce = 10;
        /**
		 * DON'T CACHE THE LOADER RESULT OR PROMISE
		 * There are quite a few places that calls function defined in outer scope like packages/confluence-fabric-editor/src/components/EditorLoader/Loader.tsx
		 * There is no guarantee they won't change and loader result is consistent. Caching the result might lead to bugs.
		 * We can theoretically run babel plugin to find out these cases and exclude them https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/commits/6ab47236eec2fa7c4a7542ad05b8c45964443ba1
		 * However I don't feel worth the effort of maintaining another piece of logic in babel plugin and risk of missing out the side effects in loader function.
		 * So I am leaving it as it is.
		 */ const cleanup = ()=>{
            $88e8236427be3059$var$markLoadingEnd(loadableName, priority);
            (0, $f0R75.saveHasBeenLoaded)(__loadable_id__);
        };
        const runLoader = ()=>{
            $88e8236427be3059$var$markLoadingStart(loadableName, priority);
            const loaderWithNetworkOnline = // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            $88e8236427be3059$var$evaluateBooleanOrPredicate(waitForNetworkOnline) && true ? $88e8236427be3059$var$wrapWithNetworkOnlineCheck(loader) : loader;
            return loaderWithNetworkOnline().then((module)=>{
                cleanup();
                return loadedModuleRef.ref = module?.default || module;
            }, // At the time when a promise is rejected, it must already been attached with a catch.
            // However it is not the case when running in the task manager.
            // Because a task can return a promise or a value. We have to check before attaching a catch.
            // This makes the rejection unhandled. So we are converting it to a resolved promise with an error.
            // The error object will be handled later in LoadableComponent.
            (e)=>{
                cleanup();
                if ((0, $9wGTI.fg)('confluence_frontend_surface_loadable_errors')) {
                    (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                        attribution: 'backbone-loadable'
                    });
                    $88e8236427be3059$var$logger.error`Error loading loadable component ${loadableName}. Please check with #cc-fe-performance if you need help with this.\n`;
                }
                return e;
            });
        };
        const load = (priorityOverride = -1, isHydrating = false)=>{
            if (loadedModuleRef.ref) return Promise.resolve(loadedModuleRef.ref);
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            return (0, $f0R75.hasBeenLoaded)(__loadable_id__) ? runLoader() : (0, $l3KBO.getTaskManager)({
                totalHydratedAtOnce: totalHydratedAtOnce
            }).push({
                id: __loadable_id__,
                priority: priorityOverride >= (0, $398ES.LoadingPriority).PAINT ? priorityOverride : priority,
                task: runLoader,
                _delayHydration: isHydrating
            });
        };
        if ((0, $lipSU.shouldForceImportsForJest)()) runLoader();
        else if (window['__SSR_RENDERED__']) /*
			 * Preload dynamic split when:
			 * - In React SSR mode
			 * - id of the component is in the magical __LOADABLE__ array
			 * Note: __LOADABLE__ array is produced by React SSR server where server knows what loadable has been used on the server side.
			 * Client will preload everything in __LOADABLE__ so component do not flip back to the loading state.
			 */ (0, $3GQl6.preloadIfNeeded)(__loadable_id__, name, ()=>load((0, $398ES.LoadingPriority).PAINT));
        return (0, $bFjHK.createLoadableClientComponent)(definition, {
            displayName: displayName,
            loadableName: loadableName,
            priority: priority,
            load: load,
            loadedModuleRef: loadedModuleRef
        });
    };
}
const $88e8236427be3059$export$8227ef1c198f3b6c = $88e8236427be3059$export$7036027578ebb3d7((0, $398ES.LoadingPriority).PAINT);
const $88e8236427be3059$export$c96dcd31adf45b8c = $88e8236427be3059$export$7036027578ebb3d7((0, $398ES.LoadingPriority).AFTER_PAINT);
const $88e8236427be3059$export$d0978c060f6515fd = $88e8236427be3059$export$7036027578ebb3d7((0, $398ES.LoadingPriority).LAZY);
const $88e8236427be3059$export$a81c0ed1ccdb363e = $88e8236427be3059$export$7036027578ebb3d7((0, $398ES.LoadingPriority).BACKGROUND);
const $88e8236427be3059$export$6f7fe07ec2db9207 = $88e8236427be3059$export$7036027578ebb3d7((0, $398ES.LoadingPriority).HYDRATE_ON_HOVER);

});
parcelRegister("f0R75", function(module, exports) {

$parcel$export(module.exports, "hasBeenLoaded", () => $8e1dec05b5f88fdc$export$2f56a0fa8840f30a);
$parcel$export(module.exports, "saveHasBeenLoaded", () => $8e1dec05b5f88fdc$export$8482f065b8e1680a);
const $8e1dec05b5f88fdc$var$loaded = new Set();
function $8e1dec05b5f88fdc$export$2f56a0fa8840f30a(id) {
    return id ? $8e1dec05b5f88fdc$var$loaded.has(id) : false;
}
function $8e1dec05b5f88fdc$export$8482f065b8e1680a(id) {
    if (id) $8e1dec05b5f88fdc$var$loaded.add(id);
}
function $8e1dec05b5f88fdc$export$a9ab3d224786f2e4() {
    $8e1dec05b5f88fdc$var$loaded.clear();
}

});

parcelRegister("bFjHK", function(module, exports) {

$parcel$export(module.exports, "createLoadableClientComponent", () => $a5d00472ad834ee9$export$9b162f78e814433);

var $gwFzn = parcelRequire("gwFzn");

var $fwDOR = parcelRequire("fwDOR");

var $4VJDS = parcelRequire("4VJDS");

var $398ES = parcelRequire("398ES");

var $1aGr8 = parcelRequire("1aGr8");

var $5nSna = parcelRequire("5nSna");

var $4R5lb = parcelRequire("4R5lb");

var $ezH4I = parcelRequire("ezH4I");

var $b6HON = parcelRequire("b6HON");
const $a5d00472ad834ee9$var$DELAY_HYRATION_ON_HOVER_FF = 'confluence_frontend_delay_hydration_on_hover';
const $a5d00472ad834ee9$var$loadableCountByNameAndId = new Map();
function $a5d00472ad834ee9$export$9b162f78e814433({ __loadable_id__: __loadable_id__, isReactLoadable: isReactLoadable, render: render, loading: loading = (0, $398ES.NOOP), _reactTreeRootForServerPlaceholderId: // Following props are internal APIs.
// Do NOT use unless consulted with the performance team.
_reactTreeRootForServerPlaceholderId, _forceServerPlaceholderId: _forceServerPlaceholderId, _addVCPlaceholderWrapper: _addVCPlaceholderWrapper, hydrateImmediately: hydrateImmediately }, { displayName: displayName, loadableName: loadableName, priority: priority, load: load, loadedModuleRef: // Using ref here because we want to get the latest value not a snapshot of the reference
loadedModuleRef }) {
    const LoadableClientComponent = (props)=>{
        const [error, setError] = (0, $gwFzn.useState)(null);
        const active = (0, $gwFzn.useRef)(true);
        const elementRef = (0, $gwFzn.useRef)(null);
        const [module, setModule] = (0, $gwFzn.useState)(()=>loadedModuleRef.ref);
        const currentOccurrenceIndex = (0, $gwFzn.useRef)(0);
        const placeholderId = (0, $4R5lb.usePlaceholderId)(__loadable_id__, _forceServerPlaceholderId);
        const loadableNameWithId = `${loadableName}:${placeholderId}`;
        // similar to LoadableServerComponent, LoadableClientComponent needs a unique placeholderReplaceId.
        // Each client component uses a combination of its loadable's placeholderId and the nth occurrence, which
        // matches the id attached to the corresponding element coming from the server-side
        (0, $gwFzn.useEffect)(()=>{
            const currentIndex = $a5d00472ad834ee9$var$loadableCountByNameAndId.get(loadableNameWithId) || 0;
            $a5d00472ad834ee9$var$loadableCountByNameAndId.set(loadableNameWithId, currentIndex + 1);
            currentOccurrenceIndex.current = currentIndex;
            return ()=>{
                const currentIndex = $a5d00472ad834ee9$var$loadableCountByNameAndId.get(loadableNameWithId);
                if (currentIndex) $a5d00472ad834ee9$var$loadableCountByNameAndId.set(loadableNameWithId, currentIndex - 1);
            };
        }, [
            placeholderId,
            loadableNameWithId
        ]);
        const placeholderReplaceId = `${placeholderId}-${currentOccurrenceIndex.current}`;
        const isHydrating = (0, $ezH4I.getServerMarkup)().has(placeholderId);
        const updateModule = (0, $gwFzn.useCallback)((m)=>{
            if (m instanceof Error) setError(()=>m);
            else setModule(()=>m);
        }, []);
        LoadableClientComponent.setLoadedModule = updateModule;
        // Correct the priority with nearest React Loadable ancestor
        // Because we force all React Loadable to be AFTER_PAINT. We can't render any PAINT under AFTER_PAINT.
        // Don't change priority directly as this is scope variable that gonna change all the instances of the component.
        const newPriority = (0, $5nSna.useAutoCorrectPriorityWithAncestor)(priority);
        const runLoadFn = (0, $gwFzn.useCallback)((retry)=>{
            if (module || error && !retry) return;
            load(newPriority, isHydrating).then((m)=>{
                if (active.current) updateModule(m);
            });
        }, [
            module,
            error,
            isHydrating,
            newPriority,
            updateModule
        ]);
        (0, $gwFzn.useLayoutEffect)(()=>{
            active.current = true;
            const delayHydrationOnHoverTimeout = (0, $4VJDS.default).getNumber($a5d00472ad834ee9$var$DELAY_HYRATION_ON_HOVER_FF, 0);
            if (delayHydrationOnHoverTimeout > 0 && priority === (0, $398ES.LoadingPriority).HYDRATE_ON_HOVER && !hydrateImmediately?.() && window?.__SSR_RENDERED__) (0, $b6HON.defer)(delayHydrationOnHoverTimeout ?? 0, ()=>runLoadFn(false));
            else runLoadFn(false);
            return ()=>{
                active.current = false;
            };
        }, [
            runLoadFn
        ]);
        let element;
        if (module) {
            // Render is backward compatible with React Loadable
            // note render is a function not a functional component so you can't use hooks in it
            element = render ? render(module, props) : /*#__PURE__*/ (0, $gwFzn.createElement)(module, props);
            if (_addVCPlaceholderWrapper) element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(_addVCPlaceholderWrapper, {
                'data-loadable-vc-wrapper': true,
                'data-ssr-placeholder-replace': placeholderReplaceId
            }, element);
        } else {
            let mergedProps;
            if (isReactLoadable) {
                // Compatible with React Loadable
                // https://github.com/jamiebuilds/react-loadable#propserror
                const reactLoadableLoadingProps = {};
                if (error) {
                    reactLoadableLoadingProps.error = error;
                    reactLoadableLoadingProps.retry = runLoadFn.bind(null, true);
                }
                mergedProps = {
                    // Do not override user's error or retry props
                    ...reactLoadableLoadingProps,
                    ...props
                };
            } else mergedProps = props;
            // Render SSR markup-based placeholder when available, with fallback to
            // client-side placeholder in case server markup could not be retrieved
            element = window['__SSR_RENDERED__'] && (newPriority === (0, $398ES.LoadingPriority).AFTER_PAINT || newPriority === (0, $398ES.LoadingPriority).HYDRATE_ON_HOVER) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1aGr8.LoadablePlaceholderClient), {
                placeholderId: placeholderId,
                clientPlaceholder: loading,
                elementRef: elementRef,
                ...mergedProps
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(loading, mergedProps);
            if (priority !== (0, $398ES.LoadingPriority).BACKGROUND) element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fwDOR.default), {
                name: `${loadableName}Placeholder`
            }, element);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nSna.LoadableAncestorsProvider), {
            id: __loadable_id__,
            // placeholderReplaceId is passed to the context so that on hydration,
            // each element can access it and add a new attribute data-ssr-placeholder-replace, whose value is the placeholderId.
            // This data-attribute's value will be checked against the value of the data-ssr-placeholder (added to the initial SSR response).
            // If the placeholderIds match, as well as the size and position of the element, the element is excluded from the TTVC calculation.
            placeholderReplaceId: placeholderReplaceId,
            name: loadableName,
            priority: newPriority,
            rootForServerPlaceholderId: Boolean(_reactTreeRootForServerPlaceholderId),
            isReactLoadable: isReactLoadable
        }, element);
    };
    LoadableClientComponent.displayName = displayName;
    // Default priority is designed for predictive preloading.
    // E.g. preload the editor when on view page.
    LoadableClientComponent.preload = ()=>{
        if (loadedModuleRef.ref) return Promise.resolve(loadedModuleRef.ref);
        return load((0, $398ES.LoadingPriority).PAINT);
    };
    LoadableClientComponent.hydrateOnHover = ()=>{
        const delayHydrationOnHoverTimeout = (0, $4VJDS.default).getNumber($a5d00472ad834ee9$var$DELAY_HYRATION_ON_HOVER_FF, 0) || 0;
        if (delayHydrationOnHoverTimeout === 0 || loadedModuleRef.ref || hydrateImmediately?.() || !window?.__SSR_RENDERED__) return;
        return load((0, $398ES.LoadingPriority).HYDRATE_ON_HOVER).then((m)=>{
            LoadableClientComponent.setLoadedModule?.(m);
        });
    };
    return LoadableClientComponent;
}

});
parcelRegister("fwDOR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a731ba177520a45$export$2e2bcd8739ae039);

var $atuQf = parcelRequire("atuQf");
var $2a731ba177520a45$export$2e2bcd8739ae039 = (0, $atuQf.default);

});
parcelRegister("atuQf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5804b98de0d396d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $9x4nt = parcelRequire("9x4nt");
const $e5804b98de0d396d$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $gwFzn.useEffect) : (0, $gwFzn.useLayoutEffect);
function $e5804b98de0d396d$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true, experimental: experimental = false }) {
    // react-18: useId instead
    const context = (0, $gwFzn.useContext)((0, $9x4nt.default));
    $e5804b98de0d396d$var$useLayoutEffectSAFE(()=>{
        if (hold && context != null) {
            if (experimental && context.holdExperimental) return context.holdExperimental(name);
            return context.hold(name);
        }
    }, [
        hold,
        context,
        name
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    }) : null;
}

});


parcelRegister("1aGr8", function(module, exports) {

$parcel$export(module.exports, "LoadablePlaceholderServer", () => $9c50b78343bd774d$export$e524011ccbd7a3be);
$parcel$export(module.exports, "LoadablePlaceholderClient", () => $9c50b78343bd774d$export$659822d4296e941e);

var $gwFzn = parcelRequire("gwFzn");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $lojHn = parcelRequire("lojHn");

var $ezH4I = parcelRequire("ezH4I");

var $jaS0m = parcelRequire("jaS0m");
const $9c50b78343bd774d$export$e524011ccbd7a3be = ({ debugName: debugName, placeholderId: placeholderId, children: children, tag: tag = 'input', ssrPlaceholderId: ssrPlaceholderId, ssrPlaceholderIgnored: ssrPlaceholderIgnored })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};
const $9c50b78343bd774d$export$659822d4296e941e = /*#__PURE__*/ (0, $gwFzn.memo)(({ placeholderId: placeholderId, clientPlaceholder: clientPlaceholder, outlineJestEnforce: outlineJestEnforce, elementRef: elementRef, ...rest })=>{
    let shouldOutline = false;
    try {
        // handle The "operation is insecure" when cookie is disabled
        shouldOutline = typeof window !== 'undefined' && Boolean((0, $e9zUf.confluenceSessionStorageInstance)?.getItem((0, $1UApO.keys).CONFLUENCE_SSR_OUTLINE_ENABLED));
    } catch (e) {}
    const content = (0, $gwFzn.useMemo)(()=>{
        if (!placeholderId) return null;
        // One placeholderId could possibly map to multiple different contents.
        // For example, if one page has multiple Table of Content macros with different config, flat or bullet list.
        // The placeholderId represents TableOfContentsLoader, the contents are different for each ToC macro.
        const index = (0, $ezH4I.getAndIncreaseServerMarkupPointer)(placeholderId);
        return index !== undefined ? (0, $ezH4I.getServerMarkup)().get(placeholderId)?.[index] : null;
    }, [
        placeholderId
    ]);
    const showDebugOutline = outlineJestEnforce || shouldOutline;
    if (!placeholderId || !content) {
        const clientPlaceHolderElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(clientPlaceholder, rest);
        // When outlining is enabled, outline client-based placeholders in red
        return showDebugOutline ? (0, $lojHn.withOutline)('red', clientPlaceHolderElement) : clientPlaceHolderElement;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jaS0m.ReactBasedPlaceholder), {
        content: content,
        showDebugOutline: showDebugOutline,
        elementRef: elementRef
    });
});

});
parcelRegister("lojHn", function(module, exports) {

$parcel$export(module.exports, "withOutline", () => $dcc520ac648b1b27$export$59c76a2fc842a0f1);
/* outline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");
const $dcc520ac648b1b27$var$baseOutlineStyles = null;
const $dcc520ac648b1b27$var$colorMap = {
    red: "_12ji5scu _1qu2gq9o _12y3yh40 _1hfk5scu",
    yellow: "_12jiwxnz _1qu2gq9o _12y3yh40 _1hfkwxnz",
    blue: "_12ji13q2 _1qu2gq9o _12y3yh40 _1hfk13q2",
    green: "_12jibf54 _1qu2gq9o _12y3yh40 _1hfkbf54"
};
const $dcc520ac648b1b27$export$59c76a2fc842a0f1 = (color, element)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_kqswh2mm _aetrb3bt _18postnw _15l2idpf _19doidpf _32rxidpf _1x88idpf _1peqsxj9",
            $dcc520ac648b1b27$var$colorMap[color]
        ])
    }, element);

});

parcelRegister("jaS0m", function(module, exports) {

$parcel$export(module.exports, "ReactBasedPlaceholder", () => $29e2a393702ce3bd$export$80b13ad49275e3fd);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $lojHn = parcelRequire("lojHn");

var $6kBmh = parcelRequire("6kBmh");

var $ezH4I = parcelRequire("ezH4I");
const $29e2a393702ce3bd$var$nodeRemovalTasks = [];
let $29e2a393702ce3bd$var$nodeRemovalTimerHandle = null;
// scheduled tasks will be executed in the next microtask tick,
// this allows preventing unnecessary/expensive DOM manipulations during react render phase
function $29e2a393702ce3bd$var$scheduleNodeRemoval(fn) {
    $29e2a393702ce3bd$var$nodeRemovalTasks.push(fn);
    if (!$29e2a393702ce3bd$var$nodeRemovalTimerHandle) $29e2a393702ce3bd$var$nodeRemovalTimerHandle = setTimeout(()=>{
        for (const task of $29e2a393702ce3bd$var$nodeRemovalTasks)task();
        $29e2a393702ce3bd$var$nodeRemovalTimerHandle = null;
        $29e2a393702ce3bd$var$nodeRemovalTasks.length = 0;
    }, 0);
}
function $29e2a393702ce3bd$export$a61c075e1a7ff8fc({ attrs: attrs, innerHTML: innerHTML, nonce: nonce }) {
    (0, $gwFzn.useLayoutEffect)(()=>{
        const scriptElement = document.createElement('script');
        scriptElement.innerHTML = innerHTML;
        for(let i = 0; i < attrs.length; i++)scriptElement.setAttribute(attrs[i].name, attrs[i].value);
        if (nonce) scriptElement.nonce = nonce;
        document.body.appendChild(scriptElement);
        return ()=>$29e2a393702ce3bd$var$scheduleNodeRemoval(()=>{
                if (scriptElement.parentNode === document.body) document.body.removeChild(scriptElement);
            });
    }, [
        attrs,
        innerHTML,
        nonce
    ]);
    return null;
}
function $29e2a393702ce3bd$var$DOMElementFromSSRResult({ el: el }) {
    const ref = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useLayoutEffect)(()=>{
        const target = ref.current;
        const parent = target?.parentNode;
        if (parent) {
            const originalNode = (0, $ezH4I.lookupOriginalElement)(el);
            if (originalNode) parent.insertBefore(originalNode, target.nextSibling);
            return ()=>$29e2a393702ce3bd$var$scheduleNodeRemoval(()=>{
                    if (originalNode && originalNode.parentNode === parent) parent.removeChild(originalNode);
                });
        }
    }, [
        el
    ]);
    // There is no way around in React. We need a reference point to do the DOM manipulation.
    // We also can't operate on this node directly, because the siblings will reference to it.
    // Similar to https://github.com/facebook/react/issues/11538 it will cause exception.
    // data-loadable-ref here has no meaning. Just to add something to DOM so it can be trace back to here.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("input", {
        type: "hidden",
        ref: ref,
        "data-loadable-ref": true
    });
}
function $29e2a393702ce3bd$var$createElement(el, elementRef) {
    /**
	 * The value of Element.tagName, that is the uppercase name of the element tag if an HTML element,
	 * or the lowercase element tag if an XML element (like a SVG or MATHML element).
	 * https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeName
	 */ let tag = el.nodeName;
    if (tag === tag.toUpperCase()) tag = tag.toLowerCase();
    const attrs = el.attributes;
    const type = attrs.getNamedItem('type')?.value;
    const skipInlineScript = attrs.getNamedItem('data-skip-in-placeholder')?.value;
    if ((0, $ezH4I.shouldUseOriginalElement)(el)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($29e2a393702ce3bd$var$DOMElementFromSSRResult, {
        el: el
    });
    else if (tag === 'script' && (!type || type === 'text/javascript' || type === 'module') && !skipInlineScript) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($29e2a393702ce3bd$export$a61c075e1a7ff8fc, {
        nonce: el.nonce,
        attrs: attrs,
        innerHTML: el.innerHTML
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(tag, {
        ...(0, $6kBmh.attrsToReactProps)(attrs),
        ref: elementRef
    }, // do not pass ref to children as ref for viewport is only needed for parent node
    ...el.childNodes.length ? $29e2a393702ce3bd$var$convertToReactElements(el.childNodes) : []);
}
function $29e2a393702ce3bd$var$convertToReactElements(nodes, elementRef) {
    return Array.from(nodes).map((node)=>{
        switch(node.nodeType){
            case Node.COMMENT_NODE:
                return null;
            case Node.TEXT_NODE:
                return node.textContent;
            case Node.ELEMENT_NODE:
                //pass ref to parent node only
                return $29e2a393702ce3bd$var$createElement(node, elementRef);
        }
        throw new Error(`Unsupported node type (${node.nodeType}): ${node?.outerHTML}`);
    });
}
function $29e2a393702ce3bd$export$80b13ad49275e3fd({ content: content, showDebugOutline: showDebugOutline, elementRef: elementRef }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (!content) return null;
    try {
        const placeholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {}, ...$29e2a393702ce3bd$var$convertToReactElements(content, elementRef));
        return showDebugOutline ? (0, $lojHn.withOutline)('blue', placeholder) : placeholder;
    } catch (e) {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'loadable',
                action: 'failed',
                actionSubject: 'convertToReactElements',
                attributes: {
                    message: e.message,
                    stack: e.stack
                }
            }
        }).fire();
        return null;
    }
}

});
parcelRegister("inPa6", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $f1cee2cc4b3c9808$export$5bf35293e545f20c);

var $76I1K = parcelRequire("76I1K");

var $6v6KC = parcelRequire("6v6KC");

var $fFVny = parcelRequire("fFVny");
function $f1cee2cc4b3c9808$export$5bf35293e545f20c() {
    const analyticsContext = (0, $fFVny.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $76I1K.useCallbackOne)((payload)=>{
        return new (0, $6v6KC.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("6v6KC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e874e3d2f5965fb8$export$2e2bcd8739ae039);
/// <reference types="node" />

var $feHMU = parcelRequire("feHMU");
const $e874e3d2f5965fb8$export$35f8383928ba8d7 = (obj)=>obj instanceof $e874e3d2f5965fb8$export$2e2bcd8739ae039 || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
class $e874e3d2f5965fb8$export$2e2bcd8739ae039 extends (0, $feHMU.default) {
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
    constructor(props){
        super(props);
        this.context = void 0;
        this.handlers = void 0;
        this.hasFired = void 0;
        this._isUIAnalyticsEvent = true;
        this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $e874e3d2f5965fb8$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        };
        this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>handler(this, channel));
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
}

});
parcelRegister("feHMU", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c50a6d094c49db$export$2e2bcd8739ae039);
const $62c50a6d094c49db$export$ad4be5c2ec28cecf = (obj)=>obj instanceof $62c50a6d094c49db$export$2e2bcd8739ae039 || !!obj?._isAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'AnalyticsEvent';
class $62c50a6d094c49db$export$2e2bcd8739ae039 {
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
    constructor(props){
        this.payload = void 0;
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $62c50a6d094c49db$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
}

});


parcelRegister("fFVny", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", () => $0c159d1a51729e4b$export$d1f587f82ad51c4);

var $gwFzn = parcelRequire("gwFzn");

var $1M56W = parcelRequire("1M56W");
const $0c159d1a51729e4b$export$d1f587f82ad51c4 = ()=>{
    return (0, $gwFzn.useContext)((0, $1M56W.default));
};

});


parcelRegister("6kBmh", function(module, exports) {

$parcel$export(module.exports, "attrsToReactProps", () => $e02f9ffb6adca9c2$export$8a4197eb95130994);

var $4XqLz = parcelRequire("4XqLz");

var $8nDiA = parcelRequire("8nDiA");
function $e02f9ffb6adca9c2$export$57a1142d3de30c74(style) {
    return style.split(';').reduce((styleObj, entity)=>{
        const keyValuePair = entity.split(':', 2);
        const value = keyValuePair[1] || '';
        // -ms-style-property -> msStyleProperty
        // -moz-style-property -> MozStyleProperty
        // -webkit-style-property -> WebkitStyleProperty
        // style-property -> styleProperty
        let name = keyValuePair[0].replace(/^-ms-/, 'ms-').replace(/^-moz-/, 'Moz-').replace(/^-webkit-/, 'Webkit-');
        if (!name.startsWith('--')) name = name.replace(/-(.)/g, (_, ch)=>ch.toUpperCase());
        name = name.trim();
        if (name) styleObj[name] = value.trim();
        return styleObj;
    }, {});
}
function $e02f9ffb6adca9c2$export$8a4197eb95130994(attrs) {
    const props = {};
    for(let i = 0; i < attrs.length; i++){
        const attr = attrs[i];
        const name = attr.name.toLowerCase();
        if (name === 'style') props['style'] = $e02f9ffb6adca9c2$export$57a1142d3de30c74(attr.value);
        else if ((0, $4XqLz.booleanAttrs).has(name)) props[name] = true;
        else props[(0, $8nDiA.possibleStandardNames)[name] || name] = attr.value;
    }
    return props;
}

});
parcelRegister("4XqLz", function(module, exports) {

$parcel$export(module.exports, "booleanAttrs", () => $d902131b12376e56$export$c500cee86d483c82);
const $d902131b12376e56$export$c500cee86d483c82 = new Set([
    'allowfullscreen',
    'async',
    'autofocus',
    'autoplay',
    'checked',
    'controls',
    'default',
    'defer',
    'disabled',
    'formnovalidate',
    'hidden',
    'inert',
    'ismap',
    'itemscope',
    'loop',
    'multiple',
    'muted',
    'nomodule',
    'novalidate',
    'open',
    'playsinline',
    'readonly',
    'required',
    'reversed',
    'selected'
]);

});

parcelRegister("8nDiA", function(module, exports) {

$parcel$export(module.exports, "possibleStandardNames", () => $d32e3205c2513f7b$export$bbecfff5ecf65cd8);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Adopted from https://github.com/facebook/react/blob/main/packages/react-dom-bindings/src/shared/possibleStandardNames.js
// Filtered out ones that are equivalent to the original name.
const $d32e3205c2513f7b$export$bbecfff5ecf65cd8 = Object.assign(Object.create(null), {
    acceptcharset: 'acceptCharset',
    'accept-charset': 'acceptCharset',
    accesskey: 'accessKey',
    allowfullscreen: 'allowFullScreen',
    autocapitalize: 'autoCapitalize',
    autocomplete: 'autoComplete',
    autocorrect: 'autoCorrect',
    autofocus: 'autoFocus',
    autoplay: 'autoPlay',
    autosave: 'autoSave',
    cellpadding: 'cellPadding',
    cellspacing: 'cellSpacing',
    charset: 'charSet',
    class: 'className',
    classid: 'classID',
    classname: 'className',
    colspan: 'colSpan',
    contenteditable: 'contentEditable',
    contextmenu: 'contextMenu',
    controlslist: 'controlsList',
    crossorigin: 'crossOrigin',
    dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
    datetime: 'dateTime',
    defaultchecked: 'defaultChecked',
    defaultvalue: 'defaultValue',
    disablepictureinpicture: 'disablePictureInPicture',
    disableremoteplayback: 'disableRemotePlayback',
    enctype: 'encType',
    enterkeyhint: 'enterKeyHint',
    fetchpriority: 'fetchPriority',
    for: 'htmlFor',
    formmethod: 'formMethod',
    formaction: 'formAction',
    formenctype: 'formEncType',
    formnovalidate: 'formNoValidate',
    formtarget: 'formTarget',
    frameborder: 'frameBorder',
    hreflang: 'hrefLang',
    htmlfor: 'htmlFor',
    httpequiv: 'httpEquiv',
    'http-equiv': 'httpEquiv',
    imagesizes: 'imageSizes',
    imagesrcset: 'imageSrcSet',
    innerhtml: 'innerHTML',
    inputmode: 'inputMode',
    itemid: 'itemID',
    itemprop: 'itemProp',
    itemref: 'itemRef',
    itemscope: 'itemScope',
    itemtype: 'itemType',
    keyparams: 'keyParams',
    keytype: 'keyType',
    marginwidth: 'marginWidth',
    marginheight: 'marginHeight',
    maxlength: 'maxLength',
    mediagroup: 'mediaGroup',
    minlength: 'minLength',
    nomodule: 'noModule',
    novalidate: 'noValidate',
    playsinline: 'playsInline',
    radiogroup: 'radioGroup',
    readonly: 'readOnly',
    referrerpolicy: 'referrerPolicy',
    rowspan: 'rowSpan',
    spellcheck: 'spellCheck',
    srcdoc: 'srcDoc',
    srclang: 'srcLang',
    srcset: 'srcSet',
    tabindex: 'tabIndex',
    usemap: 'useMap',
    accentheight: 'accentHeight',
    'accent-height': 'accentHeight',
    alignmentbaseline: 'alignmentBaseline',
    'alignment-baseline': 'alignmentBaseline',
    allowreorder: 'allowReorder',
    arabicform: 'arabicForm',
    'arabic-form': 'arabicForm',
    attributename: 'attributeName',
    attributetype: 'attributeType',
    autoreverse: 'autoReverse',
    basefrequency: 'baseFrequency',
    baselineshift: 'baselineShift',
    'baseline-shift': 'baselineShift',
    baseprofile: 'baseProfile',
    calcmode: 'calcMode',
    capheight: 'capHeight',
    'cap-height': 'capHeight',
    clippath: 'clipPath',
    'clip-path': 'clipPath',
    clippathunits: 'clipPathUnits',
    cliprule: 'clipRule',
    'clip-rule': 'clipRule',
    colorinterpolation: 'colorInterpolation',
    'color-interpolation': 'colorInterpolation',
    colorinterpolationfilters: 'colorInterpolationFilters',
    'color-interpolation-filters': 'colorInterpolationFilters',
    colorprofile: 'colorProfile',
    'color-profile': 'colorProfile',
    colorrendering: 'colorRendering',
    'color-rendering': 'colorRendering',
    contentscripttype: 'contentScriptType',
    contentstyletype: 'contentStyleType',
    diffuseconstant: 'diffuseConstant',
    dominantbaseline: 'dominantBaseline',
    'dominant-baseline': 'dominantBaseline',
    edgemode: 'edgeMode',
    enablebackground: 'enableBackground',
    'enable-background': 'enableBackground',
    externalresourcesrequired: 'externalResourcesRequired',
    fillopacity: 'fillOpacity',
    'fill-opacity': 'fillOpacity',
    fillrule: 'fillRule',
    'fill-rule': 'fillRule',
    filterres: 'filterRes',
    filterunits: 'filterUnits',
    floodopacity: 'floodOpacity',
    'flood-opacity': 'floodOpacity',
    floodcolor: 'floodColor',
    'flood-color': 'floodColor',
    fontfamily: 'fontFamily',
    'font-family': 'fontFamily',
    fontsize: 'fontSize',
    'font-size': 'fontSize',
    fontsizeadjust: 'fontSizeAdjust',
    'font-size-adjust': 'fontSizeAdjust',
    fontstretch: 'fontStretch',
    'font-stretch': 'fontStretch',
    fontstyle: 'fontStyle',
    'font-style': 'fontStyle',
    fontvariant: 'fontVariant',
    'font-variant': 'fontVariant',
    fontweight: 'fontWeight',
    'font-weight': 'fontWeight',
    glyphname: 'glyphName',
    'glyph-name': 'glyphName',
    glyphorientationhorizontal: 'glyphOrientationHorizontal',
    'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
    glyphorientationvertical: 'glyphOrientationVertical',
    'glyph-orientation-vertical': 'glyphOrientationVertical',
    glyphref: 'glyphRef',
    gradienttransform: 'gradientTransform',
    gradientunits: 'gradientUnits',
    horizadvx: 'horizAdvX',
    'horiz-adv-x': 'horizAdvX',
    horizoriginx: 'horizOriginX',
    'horiz-origin-x': 'horizOriginX',
    imagerendering: 'imageRendering',
    'image-rendering': 'imageRendering',
    kernelmatrix: 'kernelMatrix',
    kernelunitlength: 'kernelUnitLength',
    keypoints: 'keyPoints',
    keysplines: 'keySplines',
    keytimes: 'keyTimes',
    lengthadjust: 'lengthAdjust',
    letterspacing: 'letterSpacing',
    'letter-spacing': 'letterSpacing',
    lightingcolor: 'lightingColor',
    'lighting-color': 'lightingColor',
    limitingconeangle: 'limitingConeAngle',
    markerend: 'markerEnd',
    'marker-end': 'markerEnd',
    markerheight: 'markerHeight',
    markermid: 'markerMid',
    'marker-mid': 'markerMid',
    markerstart: 'markerStart',
    'marker-start': 'markerStart',
    markerunits: 'markerUnits',
    markerwidth: 'markerWidth',
    maskcontentunits: 'maskContentUnits',
    maskunits: 'maskUnits',
    numoctaves: 'numOctaves',
    overlineposition: 'overlinePosition',
    'overline-position': 'overlinePosition',
    overlinethickness: 'overlineThickness',
    'overline-thickness': 'overlineThickness',
    paintorder: 'paintOrder',
    'paint-order': 'paintOrder',
    'panose-1': 'panose1',
    pathlength: 'pathLength',
    patterncontentunits: 'patternContentUnits',
    patterntransform: 'patternTransform',
    patternunits: 'patternUnits',
    pointerevents: 'pointerEvents',
    'pointer-events': 'pointerEvents',
    pointsatx: 'pointsAtX',
    pointsaty: 'pointsAtY',
    pointsatz: 'pointsAtZ',
    preservealpha: 'preserveAlpha',
    preserveaspectratio: 'preserveAspectRatio',
    primitiveunits: 'primitiveUnits',
    refx: 'refX',
    refy: 'refY',
    renderingintent: 'renderingIntent',
    'rendering-intent': 'renderingIntent',
    repeatcount: 'repeatCount',
    repeatdur: 'repeatDur',
    requiredextensions: 'requiredExtensions',
    requiredfeatures: 'requiredFeatures',
    shaperendering: 'shapeRendering',
    'shape-rendering': 'shapeRendering',
    specularconstant: 'specularConstant',
    specularexponent: 'specularExponent',
    spreadmethod: 'spreadMethod',
    startoffset: 'startOffset',
    stddeviation: 'stdDeviation',
    stitchtiles: 'stitchTiles',
    stopcolor: 'stopColor',
    'stop-color': 'stopColor',
    stopopacity: 'stopOpacity',
    'stop-opacity': 'stopOpacity',
    strikethroughposition: 'strikethroughPosition',
    'strikethrough-position': 'strikethroughPosition',
    strikethroughthickness: 'strikethroughThickness',
    'strikethrough-thickness': 'strikethroughThickness',
    strokedasharray: 'strokeDasharray',
    'stroke-dasharray': 'strokeDasharray',
    strokedashoffset: 'strokeDashoffset',
    'stroke-dashoffset': 'strokeDashoffset',
    strokelinecap: 'strokeLinecap',
    'stroke-linecap': 'strokeLinecap',
    strokelinejoin: 'strokeLinejoin',
    'stroke-linejoin': 'strokeLinejoin',
    strokemiterlimit: 'strokeMiterlimit',
    'stroke-miterlimit': 'strokeMiterlimit',
    strokewidth: 'strokeWidth',
    'stroke-width': 'strokeWidth',
    strokeopacity: 'strokeOpacity',
    'stroke-opacity': 'strokeOpacity',
    suppresscontenteditablewarning: 'suppressContentEditableWarning',
    suppresshydrationwarning: 'suppressHydrationWarning',
    surfacescale: 'surfaceScale',
    systemlanguage: 'systemLanguage',
    tablevalues: 'tableValues',
    targetx: 'targetX',
    targety: 'targetY',
    textanchor: 'textAnchor',
    'text-anchor': 'textAnchor',
    textdecoration: 'textDecoration',
    'text-decoration': 'textDecoration',
    textlength: 'textLength',
    textrendering: 'textRendering',
    'text-rendering': 'textRendering',
    transformorigin: 'transformOrigin',
    'transform-origin': 'transformOrigin',
    underlineposition: 'underlinePosition',
    'underline-position': 'underlinePosition',
    underlinethickness: 'underlineThickness',
    'underline-thickness': 'underlineThickness',
    unicodebidi: 'unicodeBidi',
    'unicode-bidi': 'unicodeBidi',
    unicoderange: 'unicodeRange',
    'unicode-range': 'unicodeRange',
    unitsperem: 'unitsPerEm',
    'units-per-em': 'unitsPerEm',
    valphabetic: 'vAlphabetic',
    'v-alphabetic': 'vAlphabetic',
    vectoreffect: 'vectorEffect',
    'vector-effect': 'vectorEffect',
    vertadvy: 'vertAdvY',
    'vert-adv-y': 'vertAdvY',
    vertoriginx: 'vertOriginX',
    'vert-origin-x': 'vertOriginX',
    vertoriginy: 'vertOriginY',
    'vert-origin-y': 'vertOriginY',
    vhanging: 'vHanging',
    'v-hanging': 'vHanging',
    videographic: 'vIdeographic',
    'v-ideographic': 'vIdeographic',
    viewbox: 'viewBox',
    viewtarget: 'viewTarget',
    vmathematical: 'vMathematical',
    'v-mathematical': 'vMathematical',
    wordspacing: 'wordSpacing',
    'word-spacing': 'wordSpacing',
    writingmode: 'writingMode',
    'writing-mode': 'writingMode',
    xchannelselector: 'xChannelSelector',
    xheight: 'xHeight',
    'x-height': 'xHeight',
    xlinkactuate: 'xlinkActuate',
    'xlink:actuate': 'xlinkActuate',
    xlinkarcrole: 'xlinkArcrole',
    'xlink:arcrole': 'xlinkArcrole',
    xlinkhref: 'xlinkHref',
    'xlink:href': 'xlinkHref',
    xlinkrole: 'xlinkRole',
    'xlink:role': 'xlinkRole',
    xlinkshow: 'xlinkShow',
    'xlink:show': 'xlinkShow',
    xlinktitle: 'xlinkTitle',
    'xlink:title': 'xlinkTitle',
    xlinktype: 'xlinkType',
    'xlink:type': 'xlinkType',
    xmlbase: 'xmlBase',
    'xml:base': 'xmlBase',
    xmllang: 'xmlLang',
    'xml:lang': 'xmlLang',
    'xml:space': 'xmlSpace',
    xmlnsxlink: 'xmlnsXlink',
    'xmlns:xlink': 'xmlnsXlink',
    xmlspace: 'xmlSpace',
    ychannelselector: 'yChannelSelector',
    zoomandpan: 'zoomAndPan'
});

});




parcelRegister("5nSna", function(module, exports) {

$parcel$export(module.exports, "LoadableAncestorsContext", () => $18fee0a06ef04028$export$5a6fb2dde15997f8);
$parcel$export(module.exports, "useAutoCorrectPriorityWithAncestor", () => $18fee0a06ef04028$export$1349e294f501f033);
$parcel$export(module.exports, "LoadableAncestorsProvider", () => $18fee0a06ef04028$export$4767a5b9f9a4f709);

var $gwFzn = parcelRequire("gwFzn");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $lojHn = parcelRequire("lojHn");

var $398ES = parcelRequire("398ES");
const $18fee0a06ef04028$var$PRIORITY_COLORS = {
    [(0, $398ES.LoadingPriority).PAINT]: 'red',
    [(0, $398ES.LoadingPriority).AFTER_PAINT]: 'yellow',
    [(0, $398ES.LoadingPriority).BACKGROUND]: 'blue',
    [(0, $398ES.LoadingPriority).LAZY]: 'green'
};
const $18fee0a06ef04028$export$5a6fb2dde15997f8 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    ancestors: []
});
const $18fee0a06ef04028$export$109af415c07093f3 = ({ id: id, name: name, priority: priority, rootForServerPlaceholderId: rootForServerPlaceholderId, isReactLoadable: isReactLoadable })=>{
    // Returns an array of Loadable names that appear as ancestors,
    // including the current one if `self` is supplied.
    const { ancestors: ancestors } = (0, $gwFzn.useContext)($18fee0a06ef04028$export$5a6fb2dde15997f8);
    const parent = ancestors[0];
    // Loadable names should be static, so this array should never be
    // recomputed to avoid excessive re-renders
    const [ancestorsIncludingSelf] = (0, $gwFzn.useState)(()=>[
            {
                id: id || name,
                name: name,
                priority: priority,
                rootForServerPlaceholderId: rootForServerPlaceholderId ?? false,
                isReactLoadable: isReactLoadable ?? false
            }
        ].concat(ancestors));
    if (parent && priority === (0, $398ES.LoadingPriority).PAINT && priority < parent.priority) return [
        false,
        parent,
        ancestorsIncludingSelf
    ];
    return [
        true,
        parent,
        ancestorsIncludingSelf
    ];
};
const $18fee0a06ef04028$export$1349e294f501f033 = (priority)=>{
    const { ancestors: ancestors } = (0, $gwFzn.useContext)($18fee0a06ef04028$export$5a6fb2dde15997f8);
    const ancestor = ancestors.find((ancestor)=>ancestor.isReactLoadable);
    // if ancestor is AFTER_PAINT and current is PAINT. Correct the current
    if (ancestor && ancestor.priority > priority) return ancestor.priority;
    return priority;
};
const $18fee0a06ef04028$export$4767a5b9f9a4f709 = (props)=>{
    const [correct, parent, ancestorsIncludingSelf] = $18fee0a06ef04028$export$109af415c07093f3(props);
    const { name: name, placeholderReplaceId: placeholderReplaceId, priority: priority, children: children } = props;
    // This setting allows to display the outline for Loadable components with a
    // specific priority, which helps to troubleshoot the page loading performance.
    let priorityToOutline = -1;
    try {
        // handle The "operation is insecure" when cookie is disabled
        priorityToOutline = typeof window !== 'undefined' ? Number((0, $e9zUf.confluenceSessionStorageInstance)?.getItem((0, $1UApO.keys).CONFLUENCE_SSR_OUTLINE_PRIORITY) || '-1') : -1;
    } catch (e) {}
    const wrappedChildren = priorityToOutline === priority ? (0, $lojHn.withOutline)($18fee0a06ef04028$var$PRIORITY_COLORS[priority], children) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($18fee0a06ef04028$export$5a6fb2dde15997f8.Provider, {
        value: (0, $gwFzn.useMemo)(()=>({
                ancestors: ancestorsIncludingSelf,
                placeholderReplaceId: placeholderReplaceId
            }), [
            ancestorsIncludingSelf,
            placeholderReplaceId
        ])
    }, wrappedChildren);
};

});

parcelRegister("4R5lb", function(module, exports) {

$parcel$export(module.exports, "usePlaceholderId", () => $c7e815481f3ced80$export$bbc8cfbe31c5396c);

var $gwFzn = parcelRequire("gwFzn");

var $5nSna = parcelRequire("5nSna");
function $c7e815481f3ced80$export$bbc8cfbe31c5396c(id, idOverride) {
    const { ancestors: ancestors } = (0, $gwFzn.useContext)((0, $5nSna.LoadableAncestorsContext));
    if (idOverride) return idOverride;
    const ids = [
        id
    ];
    for (const ancestor of ancestors){
        // Because SPA and SSR App roots from different components.
        // SPA's root is Loadable(ViewOrEditRoute)
        // SSR App's root is Loadable(MainLayout)
        // We need to stop at the common ancestor.
        if (ancestor.rootForServerPlaceholderId) break;
        // RouteComponent when set as loadables in classic package
        // do not have a similar mapping in SSR
        // causing hierarchy mismatch issues
        if (!ancestor.name?.includes('Route')) ids.push(ancestor.id);
    }
    return ids.join(':');
}

});


parcelRegister("lipSU", function(module, exports) {

$parcel$export(module.exports, "shouldForceImportsForJest", () => $85958d8769010b93$export$9a92a3060e3f5e60);
/**
 * Force imports under the loadable to be resolved early in all jest tests.
 * This prevents the first running test from becoming disproportionately slow.
 * Leaves behavior in integration tests unchanged.
 */ function $85958d8769010b93$export$9a92a3060e3f5e60() {
    return false;
}

});


parcelRegister("gEVnQ", function(module, exports) {

let $c20ce4f8a28140b4$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("6wHgv"), 5)),
    $c20ce4f8a28140b4$var$load("UnKVe")
]).then(()=>parcelRequire('2rIPr'));

});
parcelRegister("di5rn", function(module, exports) {
"use strict";

var $jDpSy = parcelRequire("jDpSy");
module.exports = $jDpSy(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("jDpSy", function(module, exports) {
"use strict";
let $e4b5bbdb98dce921$var$cachedBundles = {};
let $e4b5bbdb98dce921$var$cachedPreloads = {};
let $e4b5bbdb98dce921$var$cachedPrefetches = {};
function $e4b5bbdb98dce921$var$getCache(type) {
    switch(type){
        case 'preload':
            return $e4b5bbdb98dce921$var$cachedPreloads;
        case 'prefetch':
            return $e4b5bbdb98dce921$var$cachedPrefetches;
        default:
            return $e4b5bbdb98dce921$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        let cache = $e4b5bbdb98dce921$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("6f0Oj", function(module, exports) {

$parcel$export(module.exports, "Box", () => $b2f482e24395e02d$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $b2f482e24395e02d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $5rrZR = parcelRequire("5rrZR");

var $avd77 = parcelRequire("avd77");

var $ecnYn = parcelRequire("ecnYn");
const $b2f482e24395e02d$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $3jLHL.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $b2f482e24395e02d$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $avd77.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $avd77.isSurfaceColorToken)(backgroundColor) && (0, $avd77.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $avd77.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $avd77.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $avd77.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $avd77.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $avd77.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $avd77.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $avd77.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, $5rrZR.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $b2f482e24395e02d$export$2e2bcd8739ae039 = $b2f482e24395e02d$export$e71c4d32a2263218;
const $b2f482e24395e02d$var$baseStyles = (0, $3jLHL.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("5rrZR", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", () => $fe09f048ab2b6c21$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $fe09f048ab2b6c21$export$1aeb4f6b93c4540d);

var $gwFzn = parcelRequire("gwFzn");
const $fe09f048ab2b6c21$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $gwFzn.createContext)('elevation.surface');
const $fe09f048ab2b6c21$export$1aeb4f6b93c4540d = ()=>{
    return (0, $gwFzn.useContext)($fe09f048ab2b6c21$export$1ca2a26fecb070ae);
};
$fe09f048ab2b6c21$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("avd77", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", () => $7e5dacb61893bdcb$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $7e5dacb61893bdcb$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $7e5dacb61893bdcb$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $7e5dacb61893bdcb$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $7e5dacb61893bdcb$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $7e5dacb61893bdcb$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $7e5dacb61893bdcb$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $7e5dacb61893bdcb$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $7e5dacb61893bdcb$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $7e5dacb61893bdcb$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $7e5dacb61893bdcb$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $7e5dacb61893bdcb$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $7e5dacb61893bdcb$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $7e5dacb61893bdcb$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $7e5dacb61893bdcb$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $7e5dacb61893bdcb$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $7e5dacb61893bdcb$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $7e5dacb61893bdcb$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $7e5dacb61893bdcb$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "textSizeStylesMap", () => $7e5dacb61893bdcb$export$219d364c0da35ae4);
$parcel$export(module.exports, "textWeightStylesMap", () => $7e5dacb61893bdcb$export$38845ca010b93505);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $7e5dacb61893bdcb$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $7e5dacb61893bdcb$export$5e65a44e5b6ecadb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $a9dFP = parcelRequire("a9dFP");
const $7e5dacb61893bdcb$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $7e5dacb61893bdcb$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $7e5dacb61893bdcb$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $7e5dacb61893bdcb$export$632685d741f3dbbf = {
    ...$7e5dacb61893bdcb$export$958d0ae7f2977ae4,
    ...$7e5dacb61893bdcb$export$d2dc61f58390201c
};
const $7e5dacb61893bdcb$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $7e5dacb61893bdcb$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $7e5dacb61893bdcb$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $7e5dacb61893bdcb$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $7e5dacb61893bdcb$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $7e5dacb61893bdcb$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $7e5dacb61893bdcb$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
const $7e5dacb61893bdcb$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
const $7e5dacb61893bdcb$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $7e5dacb61893bdcb$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
const $7e5dacb61893bdcb$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
const $7e5dacb61893bdcb$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $7e5dacb61893bdcb$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
const $7e5dacb61893bdcb$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $7e5dacb61893bdcb$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $7e5dacb61893bdcb$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
// Generate maps for Box props. backgroundColor, padding, etc
const $7e5dacb61893bdcb$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $7e5dacb61893bdcb$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3jLHL.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $7e5dacb61893bdcb$export$e615f061ca585a6c = $7e5dacb61893bdcb$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7(spacingProperty, $7e5dacb61893bdcb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $7e5dacb61893bdcb$export$bf46c3f9eeafc71f = $7e5dacb61893bdcb$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7(spacingProperty, $7e5dacb61893bdcb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $7e5dacb61893bdcb$export$e7af83bafe7f9e63 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('backgroundColor', $7e5dacb61893bdcb$export$d1d79bf68ac056bd);
const $7e5dacb61893bdcb$export$3a1bcba60b23d7f0 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('color', $7e5dacb61893bdcb$export$8473307aa00d6ea1);
const $7e5dacb61893bdcb$export$45f3f4fe16f9f7d5 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('fontWeight', $7e5dacb61893bdcb$export$303e322c6b1ed114);
const $7e5dacb61893bdcb$export$68cc305da27dbaa4 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('fontFamily', $7e5dacb61893bdcb$export$3c7e9587132614b4);
const $7e5dacb61893bdcb$export$128f10c238242f83 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('font', $7e5dacb61893bdcb$export$6ffa317d5e70375);
const $7e5dacb61893bdcb$export$219d364c0da35ae4 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('font', $7e5dacb61893bdcb$export$236bfe3a33ef1292);
const $7e5dacb61893bdcb$export$38845ca010b93505 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('fontWeight', $7e5dacb61893bdcb$export$855cfd311192d666);
const $7e5dacb61893bdcb$export$ff257d957d48c421 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7((0, $a9dFP.CURRENT_SURFACE_CSS_VAR), $7e5dacb61893bdcb$export$41a358c9c2356760);
const $7e5dacb61893bdcb$export$5e65a44e5b6ecadb = (color)=>$7e5dacb61893bdcb$export$41a358c9c2356760[color] !== undefined;

});
parcelRegister("a9dFP", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $813968f9df797436$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $813968f9df797436$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $813968f9df797436$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $813968f9df797436$export$352e418ed5b6193a);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $813968f9df797436$export$9d7b58831ae93caa);
const $813968f9df797436$export$4ef52930e33717cd = 'data-theme';
const $813968f9df797436$export$a00eac3f8684bcd0 = 'data-color-mode';
const $813968f9df797436$export$2112803007239c61 = 'data-contrast-mode';
const $813968f9df797436$export$352e418ed5b6193a = 'data-custom-theme';
const $813968f9df797436$export$6f0c6fb8c80fcc92 = 'ds';
const $813968f9df797436$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
const $813968f9df797436$export$dddac1532e822863 = `--${$813968f9df797436$export$6f0c6fb8c80fcc92}-token-not-found`;
const $813968f9df797436$export$9d7b58831ae93caa = `--${$813968f9df797436$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});


parcelRegister("ecnYn", function(module, exports) {

$parcel$export(module.exports, "tokensMap", () => $612ff9077a434533$export$9a199fbafee0014e);
$parcel$export(module.exports, "parseXcss", () => $612ff9077a434533$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $612ff9077a434533$export$f6c783d06584602c);
/* xcss.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $avd77 = parcelRequire("avd77");

var $3mTvL = parcelRequire("3mTvL");
const $612ff9077a434533$export$9a199fbafee0014e = {
    backgroundColor: (0, $avd77.backgroundColorMap),
    blockSize: (0, $avd77.dimensionMap),
    borderBlockColor: (0, $avd77.borderColorMap),
    borderBlockEndColor: (0, $avd77.borderColorMap),
    borderBlockEndWidth: (0, $avd77.borderWidthMap),
    borderBlockStartColor: (0, $avd77.borderColorMap),
    borderBlockStartWidth: (0, $avd77.borderWidthMap),
    borderBlockWidth: (0, $avd77.borderWidthMap),
    borderBottomColor: (0, $avd77.borderColorMap),
    borderBottomLeftRadius: (0, $avd77.borderRadiusMap),
    borderBottomRightRadius: (0, $avd77.borderRadiusMap),
    borderBottomWidth: (0, $avd77.borderWidthMap),
    borderColor: (0, $avd77.borderColorMap),
    borderEndEndRadius: (0, $avd77.borderRadiusMap),
    borderEndStartRadius: (0, $avd77.borderRadiusMap),
    borderInlineColor: (0, $avd77.borderColorMap),
    borderInlineEndColor: (0, $avd77.borderColorMap),
    borderInlineEndWidth: (0, $avd77.borderWidthMap),
    borderInlineStartColor: (0, $avd77.borderColorMap),
    borderInlineStartWidth: (0, $avd77.borderWidthMap),
    borderInlineWidth: (0, $avd77.borderWidthMap),
    borderLeftColor: (0, $avd77.borderColorMap),
    borderLeftWidth: (0, $avd77.borderWidthMap),
    borderRadius: (0, $avd77.borderRadiusMap),
    borderRightColor: (0, $avd77.borderColorMap),
    borderRightWidth: (0, $avd77.borderWidthMap),
    borderStartEndRadius: (0, $avd77.borderRadiusMap),
    borderStartStartRadius: (0, $avd77.borderRadiusMap),
    borderTopColor: (0, $avd77.borderColorMap),
    borderTopLeftRadius: (0, $avd77.borderRadiusMap),
    borderTopRightRadius: (0, $avd77.borderRadiusMap),
    borderTopWidth: (0, $avd77.borderWidthMap),
    borderWidth: (0, $avd77.borderWidthMap),
    bottom: (0, $avd77.allSpaceMap),
    boxShadow: (0, $avd77.shadowMap),
    color: (0, $avd77.textColorMap),
    columnGap: (0, $avd77.positiveSpaceMap),
    font: (0, $avd77.fontMap),
    fontFamily: (0, $avd77.fontFamilyMap),
    fontWeight: (0, $avd77.fontWeightMap),
    gap: (0, $avd77.positiveSpaceMap),
    height: (0, $avd77.dimensionMap),
    inlineSize: (0, $avd77.dimensionMap),
    inset: (0, $avd77.allSpaceMap),
    insetBlock: (0, $avd77.allSpaceMap),
    insetBlockEnd: (0, $avd77.allSpaceMap),
    insetBlockStart: (0, $avd77.allSpaceMap),
    insetInline: (0, $avd77.allSpaceMap),
    insetInlineEnd: (0, $avd77.allSpaceMap),
    insetInlineStart: (0, $avd77.allSpaceMap),
    left: (0, $avd77.allSpaceMap),
    margin: (0, $avd77.allSpaceMap),
    marginBlock: (0, $avd77.allSpaceMap),
    marginBlockEnd: (0, $avd77.allSpaceMap),
    marginBlockStart: (0, $avd77.allSpaceMap),
    marginBottom: (0, $avd77.allSpaceMap),
    marginInline: (0, $avd77.allSpaceMap),
    marginInlineEnd: (0, $avd77.allSpaceMap),
    marginInlineStart: (0, $avd77.allSpaceMap),
    marginLeft: (0, $avd77.allSpaceMap),
    marginRight: (0, $avd77.allSpaceMap),
    marginTop: (0, $avd77.allSpaceMap),
    maxBlockSize: (0, $avd77.dimensionMap),
    maxHeight: (0, $avd77.dimensionMap),
    maxInlineSize: (0, $avd77.dimensionMap),
    maxWidth: (0, $avd77.dimensionMap),
    minBlockSize: (0, $avd77.dimensionMap),
    minHeight: (0, $avd77.dimensionMap),
    minInlineSize: (0, $avd77.dimensionMap),
    minWidth: (0, $avd77.dimensionMap),
    opacity: (0, $avd77.opacityMap),
    outlineColor: (0, $avd77.borderColorMap),
    outlineOffset: (0, $avd77.allSpaceMap),
    outlineWidth: (0, $avd77.borderWidthMap),
    padding: (0, $avd77.positiveSpaceMap),
    paddingBlock: (0, $avd77.positiveSpaceMap),
    paddingBlockEnd: (0, $avd77.positiveSpaceMap),
    paddingBlockStart: (0, $avd77.positiveSpaceMap),
    paddingBottom: (0, $avd77.positiveSpaceMap),
    paddingInline: (0, $avd77.positiveSpaceMap),
    paddingInlineEnd: (0, $avd77.positiveSpaceMap),
    paddingInlineStart: (0, $avd77.positiveSpaceMap),
    paddingLeft: (0, $avd77.positiveSpaceMap),
    paddingRight: (0, $avd77.positiveSpaceMap),
    paddingTop: (0, $avd77.positiveSpaceMap),
    right: (0, $avd77.allSpaceMap),
    rowGap: (0, $avd77.positiveSpaceMap),
    top: (0, $avd77.allSpaceMap),
    width: (0, $avd77.dimensionMap),
    zIndex: (0, $avd77.layerMap)
};
const $612ff9077a434533$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $612ff9077a434533$var$isSafeEnvToThrow = ()=>typeof $3mTvL === 'object' && typeof $3mTvL.env === 'object' && false;
const $612ff9077a434533$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $612ff9077a434533$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $612ff9077a434533$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
     // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($612ff9077a434533$var$transformStyles);
     // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $612ff9077a434533$var$safeSelectors.test(key)) {
            styleObj[key] = $612ff9077a434533$var$transformStyles(value);
            return;
        }
        if ($612ff9077a434533$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($612ff9077a434533$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        } // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $612ff9077a434533$export$9a199fbafee0014e)) return;
        const tokenValue = $612ff9077a434533$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $612ff9077a434533$var$baseXcss = (style)=>{
    const transformedStyles = $612ff9077a434533$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [$612ff9077a434533$var$uniqueSymbol]: (0, $3jLHL.css)(transformedStyles)
    };
}; /**
    * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
    * to supported both Emotion and Compiled styles until we've fully migrated
    * to Compiled.
    *
    * @private
    * @deprecated
    */ 
const $612ff9077a434533$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $612ff9077a434533$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$612ff9077a434533$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $612ff9077a434533$export$f6c783d06584602c(style) {
    return $612ff9077a434533$var$baseXcss(style);
}

});


parcelRegister("1kHsc", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerContext", () => $e1c74140bf6f0b05$export$a7b0697657ed8bd0);
$parcel$export(module.exports, "withExperienceTracker", () => $e1c74140bf6f0b05$export$f88dde183f4d31cb);

var $gwFzn = parcelRequire("gwFzn");
const $e1c74140bf6f0b05$export$a7b0697657ed8bd0 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    start () {},
    succeed () {},
    fail () {},
    abort () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    },
    getExperienceState () {
        return null;
    },
    updateAttributes () {},
    attachDebugPoint () {}
});
function $e1c74140bf6f0b05$export$f88dde183f4d31cb(WrappedComponent) {
    const withExperienceTracker = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e1c74140bf6f0b05$export$a7b0697657ed8bd0.Consumer, null, (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(WrappedComponent, {
                ...props,
                experienceTracker: value
            }));
    withExperienceTracker.displayName = `withExperienceTracker(${WrappedComponent.displayName || WrappedComponent.name})`;
    return withExperienceTracker;
}

});

parcelRegister("8n9tL", function(module, exports) {

$parcel$export(module.exports, "findAndMatchRoute", () => $edae94fe65ac72a1$export$b6024a131a1561d9);
$parcel$export(module.exports, "RouteManager", () => $edae94fe65ac72a1$export$1b5af09f58fb97da);

var $jiJCD = parcelRequire("jiJCD");

var $gwFzn = parcelRequire("gwFzn");

var $4y1GY = parcelRequire("4y1GY");

var $atveb = parcelRequire("atveb");

var $9wGTI = parcelRequire("9wGTI");

var $cb6fO = parcelRequire("cb6fO");

var $fMEnQ = parcelRequire("fMEnQ");

var $dHSeC = parcelRequire("dHSeC");

var $7zgzO = parcelRequire("7zgzO");

var $dPJCf = parcelRequire("dPJCf");

var $ek3aD = parcelRequire("ek3aD");
const $edae94fe65ac72a1$var$NOOP = ()=>{};
function $edae94fe65ac72a1$export$b6024a131a1561d9(routes, url) {
    // routes can be module from "import" which is not iterable
    const iterableRoutes = Object.values(routes);
    for (const route of iterableRoutes){
        if (!(route instanceof (0, $fMEnQ.Route))) continue;
        const match = route.match(url);
        if (match) // FIXME `route` is a `class` instance so it is not 100% safe to spread!
        // But we've been running with it for quite some time, we're not aware of
        // actual problems and I'm only discovering it now while translating to
        // TypeScript.
        //
        // @ts-ignore
        return {
            ...route,
            ...match
        };
    }
    return null;
}
const $edae94fe65ac72a1$export$5050caba5e109cc4 = (queryParams)=>{
    const array = Object.entries(queryParams);
    return array.length ? array.reduce((accumulator, current, index)=>`${accumulator + current[0]}=${encodeURIComponent(current[1])}${index < array.length - 1 ? '&' : ''}`, '?') : '';
};
class $edae94fe65ac72a1$var$RouteManagerInner extends (0, $gwFzn.Component) {
    componentDidMount() {
        const { location: location1, history: history } = this.props;
        const initialMatch = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
        let previousMatch = initialMatch;
        const processRouteTransition = ({ action: action, match: match })=>{
            if (action === 'PUSH' || action === 'POP') this.transitionId++;
            // we de-structure `onTransition` prop here instead of in enclosing scope
            // because otherwise changes to `onTransition` props will be ignored.
            // (as the consuming `routeChangeHandler` function will have a "cached" version of it via closure)
            const { onTransition: onTransition } = this.props;
            if (onTransition) onTransition(match, this.transitionId, action);
            previousMatch = match;
        };
        const routeChangeHandler = (location1, action)=>{
            // New logic determine if it is a transition by calling isTransition on route.
            const match = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
            if (!(0, $9wGTI.fg)('confluence_frontend_transition_preloading_system')) {
                // we de-structure `onTransition` prop here instead of in enclosing scope
                // because otherwise changes to `onTransition` props will be ignored (as this function
                // will have a "cached" version of it via closure).
                const { onTransition: onTransition } = this.props;
                if (onTransition && match && match.isTransition(previousMatch, match)) {
                    if (action === 'PUSH' || action === 'POP') this.transitionId++;
                    onTransition(match, this.transitionId, action);
                }
                previousMatch = match;
            } else {
                const isTransition = match && match.isTransition(previousMatch, match);
                if (isTransition) {
                    // Check if we have a transition callback promise that should resolve before continuing transition.
                    // If so, we rely on `processTransitionCallback` to invoke `onRouteContinue` when it's done blocking the transition.
                    const routeContinueCallback = ()=>{
                        processRouteTransition({
                            action: action,
                            match: match
                        });
                    };
                    const globalTransitionPreloader = (0, $ek3aD.getGlobalTransitionPreloader)();
                    const isProcessingTransitionCallback = globalTransitionPreloader.processTransitionCallback?.({
                        match: match,
                        onRouteContinue: routeContinueCallback
                    });
                    if (!isProcessingTransitionCallback) processRouteTransition({
                        action: action,
                        match: match
                    });
                } else previousMatch = match;
            }
        };
        if (this.props.setBrowserHistoryListener) // Ensure RouteManager's `listen` handler is called before the listen handler registered by ConnectedRouter and redux action
        // prettier-ignore
        this.unlistenToHistory = this.props.setBrowserHistoryListener(routeChangeHandler);
        else this.unlistenToHistory = history.block(routeChangeHandler);
    }
    componentWillUnmount() {
        this.unlistenToHistory?.();
    }
    mapRoutes(routeComponents) {
        const supportedRoutes = Object.keys(routeComponents);
        return supportedRoutes.map((name)=>{
            const route = this.getRoute(name);
            const mappedRoute = new (0, $fMEnQ.Route)({
                name: route.name,
                ufoName: route.ufoName,
                pattern: route.pattern,
                condition: route.condition,
                isTransition: route.isTransition
            });
            // @ts-ignore FIXME Who's using `component` on "mapped" `Route`?
            mappedRoute['component'] = routeComponents[name];
            return mappedRoute;
        });
    }
    getRoute(name) {
        const { namedRoutes: namedRoutes } = this.props;
        const route = namedRoutes[name];
        if (!route) throw new Error(`Unknown route name: ${name}`);
        return route;
    }
    matchAndRenderComponent(match) {
        const { notFound: notFound, routeComponents: routeComponents } = this.props;
        if (match === null) return notFound ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(notFound) : null;
        else {
            window.performance.mark('CFP-63.route-component-render');
            const memoizedComponent = this.memoizedRouteComponents.get(routeComponents[match.name]);
            return memoizedComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(memoizedComponent, match) : null;
        }
    }
    getHref() {
        return location.pathname + location.search;
    }
    render() {
        const { children: children } = this.props;
        const routesContextValue = this.getRoutesContextValue();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dPJCf.RouteStateContainer), routesContextValue, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7zgzO.RoutesContext).Provider, {
            value: routesContextValue
        }, this.matchAndRenderComponent(routesContextValue.match), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dHSeC.GlobalAnchorHandler), null)));
    }
    constructor(props){
        super(props);
        this.memoizedRouteComponents = new WeakMap();
        // transitionId is incremented on every push/pop to distinguish a deliberate
        // user navigation from an automatic redirect (replace). An id of 0 indicates that
        // we are currently on the initial load.
        //
        // Ideally this would be in component state, since it is passed down through context,
        // and should trigger a re-render when changed.
        // However, we don't want to re-render with the updated value until the location
        // changes, which unfortunately is controlled by <ConnectedRouter>.
        // At the same time, this state cannot be purely derived from location changes,
        // since we need to look at the action that caused the update.
        // When we remove react-router and can make both state changes atomically then
        // this can move into component state alongside the current location.
        this.transitionId = 0;
        this.pendingQueryParams = {};
        /**
     * Mapping components to named routes
     */ this.routes = this.mapRoutes(this.props.routeComponents);
        this.toUrl = (name, params = {})=>{
            const href = params['href'];
            if (href) return href;
            if (!name) return '';
            const query = params.query || {};
            const hash = params.hash || '';
            return this.getRoute(name).toUrl(params, {
                query: query,
                hash: hash
            });
        };
        this.matchRoute = (url)=>{
            const { namedRoutes: namedRoutes } = this.props;
            return $edae94fe65ac72a1$export$b6024a131a1561d9(namedRoutes, url);
        };
        this.matchSupportedRoute = (url)=>{
            const parsed = (0, $jiJCD.parse)(url);
            // Note here we are using location from window not from withRouter
            // history's location doesn't have host field
            // See https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/api/history.md
            //What is this doing?
            if (parsed.host && parsed.host !== window.location.host) return null;
            return $edae94fe65ac72a1$export$b6024a131a1561d9(this.routes, url);
        };
        this.replace = (url, forceReload = false)=>{
            const { history: history, onPageReload: onPageReload = $edae94fe65ac72a1$var$RouteManagerInner.defaultProps.onPageReload } = this.props;
            let match;
            if (!forceReload && (match = this.matchSupportedRoute(url))) // replace only supports pushing a path.
            // here the url might be a full URL that has same domain
            history.replace((0, $jiJCD.format)({
                pathname: match.pathname,
                search: match.search,
                hash: match.hash
            }));
            else {
                onPageReload(url, true);
                // eslint-disable-next-line no-restricted-syntax
                window.location.replace(url);
            }
        };
        this.open = (url, target, features)=>window.open(url, target, features);
        this.defaultPush = (url, forceReload = false)=>{
            const { history: history, onPageReload: onPageReload = $edae94fe65ac72a1$var$RouteManagerInner.defaultProps.onPageReload, location: location1 } = this.props;
            let match;
            if (!forceReload && (match = this.matchSupportedRoute((0, $cb6fO.isHashedOnlyURL)(url) ? (0, $jiJCD.format)({
                pathname: location1.pathname,
                search: location1.search,
                hash: url
            }) : url))) // push only supports pushing a path.
            // here the url might be a full URL that has same domain
            history.push((0, $jiJCD.format)({
                pathname: match.pathname,
                search: match.search,
                hash: match.hash
            }));
            else {
                onPageReload(url, false);
                // eslint-disable-next-line no-restricted-syntax
                window.location.assign(url);
            }
        };
        this.push = (url, forceReload = false)=>{
            const { routePolicy: routePolicy } = this.props;
            if (routePolicy) return routePolicy.push({
                ...this.getRoutesContextValue(),
                push: this.defaultPush
            }, url, forceReload);
            return this.defaultPush(url, forceReload);
        };
        this.getQueryParams = ()=>{
            const { location: location1 } = this.props;
            return (0, $jiJCD.parse)(location1.search, true).query;
        };
        this.setQueryParams = (query, replace = false)=>{
            if (query && typeof query === 'object') {
                const { history: history } = this.props;
                const queryParams = {
                    ...this.getQueryParams(),
                    ...this.pendingQueryParams,
                    ...query
                };
                Object.keys(queryParams).forEach((key)=>{
                    if (queryParams[key] === null || queryParams[key] === undefined) delete queryParams[key];
                });
                const search = this.buildQueryString(queryParams);
                (replace ? history.replace : history.push)({
                    search: search
                });
                Object.assign(this.pendingQueryParams, query);
                // https://github.com/ReactTraining/history/issues/767#issuecomment-573358882
                setTimeout(()=>this.pendingQueryParams = {});
            }
        };
        this.buildQueryString = $edae94fe65ac72a1$export$5050caba5e109cc4;
        this.getHash = ()=>{
            const { location: location1 } = this.props;
            return location1.hash ? location1.hash.substring(1) : '';
        };
        this.setHash = (hash)=>{
            const { history: history, location: location1 } = this.props;
            history.replace({
                ...location1,
                hash: hash
            });
        };
        this.preloadRoute = (matchOrUrl)=>{
            // URL match and string are among the most common representations in our
            // codebase. RouteManager owns converting between them so reduce the
            // strain on the caller and accept both:
            const match = typeof matchOrUrl === 'string' ? this.matchSupportedRoute(matchOrUrl) : matchOrUrl;
            if (match) {
                const previousMatch = this.matchSupportedRoute(this.getHref());
                const { onPreload: onPreload } = this.props;
                if (onPreload) onPreload(match, previousMatch);
            }
        };
        this.getRoutesContextValue = ()=>{
            const { history: history, location: location1, onPageReload: onPageReload } = this.props;
            return {
                getHref: this.getHref,
                history: history,
                location: location1,
                match: this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`),
                transitionId: this.transitionId,
                toUrl: this.toUrl,
                matchRoute: this.matchRoute,
                matchSupportedRoute: this.matchSupportedRoute,
                getQueryParams: this.getQueryParams,
                setQueryParams: this.setQueryParams,
                getHash: this.getHash,
                setHash: this.setHash,
                replace: this.replace,
                routes: this.routes,
                push: this.push,
                open: this.open,
                onPageReload: onPageReload || $edae94fe65ac72a1$var$NOOP,
                preloadRoute: this.preloadRoute
            };
        };
        const { location: _location, onInitialize: onInitialize, routeComponents: routeComponents } = this.props;
        // Keep a component => memo(component) mapping so later in matchAndRenderComponent we can render the memoized one.
        // We are not re-creating the routeComponents object because several items in the object may share the same reference.
        // If that is the case then our memoized component should sharing the same reference as well.
        for(const key in routeComponents){
            const component = routeComponents[key];
            if (!this.memoizedRouteComponents.has(component)) this.memoizedRouteComponents.set(component, /*#__PURE__*/ (0, $gwFzn.memo)(component, (0, (/*@__PURE__*/$parcel$interopDefault($atveb)))));
        }
        const _match = this.matchSupportedRoute(`${_location.pathname}${_location.search}${_location.hash}`);
        if (onInitialize) onInitialize(_match, this.transitionId);
    }
}
$edae94fe65ac72a1$var$RouteManagerInner.defaultProps = {
    routeComponents: {},
    namedRoutes: {},
    onPageReload: $edae94fe65ac72a1$var$NOOP
};
const $edae94fe65ac72a1$export$1b5af09f58fb97da = (0, $4y1GY.withRouter)($edae94fe65ac72a1$var$RouteManagerInner);

});
parcelRegister("cb6fO", function(module, exports) {

$parcel$export(module.exports, "CONTEXT_PATH", () => $66bd17d244a68303$export$8c6bf2df244e6a99);
$parcel$export(module.exports, "generateSlug", () => $66bd17d244a68303$export$ad28e141050c1e34);
$parcel$export(module.exports, "addQueryParams", () => $66bd17d244a68303$export$cbc5b385481fb319);
$parcel$export(module.exports, "removeEverythingAfterContentSlug", () => $66bd17d244a68303$export$64f436133a65fc62);
$parcel$export(module.exports, "getSpaceLink", () => $66bd17d244a68303$export$cefcfecf0835bcd9);
$parcel$export(module.exports, "buildContentPath", () => $66bd17d244a68303$export$6b45500787cf696);
$parcel$export(module.exports, "getContextAwareFullPath", () => $66bd17d244a68303$export$6a80a340d4e68de1);
$parcel$export(module.exports, "isHashedOnlyURL", () => $66bd17d244a68303$export$feb8df2d5227ff6c);

var $jiJCD = parcelRequire("jiJCD");

var $dKXPX = parcelRequire("dKXPX");

var $6Atyh = parcelRequire("6Atyh");
const $66bd17d244a68303$export$8c6bf2df244e6a99 = '/wiki';
const $66bd17d244a68303$var$SPACE_ROOT = 'spaces';
const $66bd17d244a68303$export$ad28e141050c1e34 = (title)=>{
    if (!title) return;
    const slug = title// replace groups of reservered chars with a space
    // From https://www.ietf.org/rfc/rfc3986.txt
    // unreserved  = ALPHA / DIGIT / "-" / "." / "_" / "~"
    .replaceAll(/[^A-Za-z0-9\-._~]+/g, ' ')// trim the edges
    .trim()// replace spaces with '+'
    .replaceAll(' ', '+');
    // guard against relative url attacks
    if (slug === '.' || slug === '..') return undefined;
    return slug || undefined;
};
const $66bd17d244a68303$export$cbc5b385481fb319 = (href, query)=>{
    const parsedUrl = {
        ...(0, $jiJCD.parse)(href, true),
        search: undefined
    };
    parsedUrl.query = {
        ...parsedUrl.query,
        ...query
    };
    parsedUrl.query = (0, (/*@__PURE__*/$parcel$interopDefault($dKXPX)))(parsedUrl.query, (0, (/*@__PURE__*/$parcel$interopDefault($6Atyh))));
    return (0, $jiJCD.format)(parsedUrl);
};
const $66bd17d244a68303$export$8189558ac52562eb = (params, href)=>{
    const parsedUrl = {
        ...(0, $jiJCD.parse)(href, true),
        search: undefined
    };
    params.forEach((paramName)=>delete parsedUrl.query[paramName]);
    return (0, $jiJCD.format)(parsedUrl);
};
const $66bd17d244a68303$var$removeAllAnchorsFromUrl = (href)=>{
    return href.split('#')[0];
};
const $66bd17d244a68303$var$removeAllQueryParamsFromUrl = (href)=>{
    return href.split('?')[0];
};
const $66bd17d244a68303$export$64f436133a65fc62 = (href)=>{
    return $66bd17d244a68303$var$removeAllAnchorsFromUrl($66bd17d244a68303$var$removeAllQueryParamsFromUrl(href));
};
const $66bd17d244a68303$export$cefcfecf0835bcd9 = (spaceKey, path = '')=>{
    spaceKey = encodeURIComponent(spaceKey);
    let spacePath = (typeof path === 'string' ? path : path.pathname) || '';
    if (spacePath.startsWith($66bd17d244a68303$export$8c6bf2df244e6a99)) spacePath = spacePath.substring($66bd17d244a68303$export$8c6bf2df244e6a99.length);
    if (spacePath.startsWith('/')) spacePath = spacePath.substring(1);
    const link = `${$66bd17d244a68303$export$8c6bf2df244e6a99}/${$66bd17d244a68303$var$SPACE_ROOT}/${spaceKey}${spacePath ? `/${spacePath}` : ''}`;
    if (typeof path === 'string') return link;
    return {
        ...path,
        pathname: link
    };
};
const $66bd17d244a68303$var$getBlogRoute = (spaceKey)=>$66bd17d244a68303$export$cefcfecf0835bcd9(spaceKey, 'blog');
const $66bd17d244a68303$var$getPagesRoute = (spaceKey)=>$66bd17d244a68303$export$cefcfecf0835bcd9(spaceKey, 'pages');
const $66bd17d244a68303$export$6b45500787cf696 = (spaceKey, id, contentType, createdDate, slug)=>{
    const trailingSlug = slug ? `/${slug}` : '';
    switch(contentType){
        case 'blogpost':
            const [yy, mm, dd] = createdDate.slice(0, 10).split('-');
            return `${$66bd17d244a68303$var$getBlogRoute(spaceKey)}/${yy}/${mm}/${dd}/${id}${trailingSlug}`;
        case 'page':
            return `${$66bd17d244a68303$var$getPagesRoute(spaceKey)}/${id}${trailingSlug}`;
        default:
            throw new Error(`Expected content type 'blogpost' or 'page', but received '${contentType}'`);
    }
};
const $66bd17d244a68303$export$257d483fa4a3254f = /^(http(s)?:)?\/\//;
const $66bd17d244a68303$export$bfc29523388820d7 = (url, isContextAware)=>isContextAware && url.toString().indexOf($66bd17d244a68303$export$8c6bf2df244e6a99) !== 0 ? $66bd17d244a68303$export$8c6bf2df244e6a99 : '';
const $66bd17d244a68303$export$6a80a340d4e68de1 = (url, isContextAware)=>{
    if ($66bd17d244a68303$export$257d483fa4a3254f.test(url)) return url;
    else return `${$66bd17d244a68303$export$bfc29523388820d7(url, isContextAware)}${url}`;
};
const $66bd17d244a68303$export$feb8df2d5227ff6c = (urn)=>urn.charAt(0) === '#';

});

parcelRegister("dHSeC", function(module, exports) {

$parcel$export(module.exports, "GlobalAnchorHandler", () => $691595bcd2385e34$export$cf1af05a5f90ab81);
$parcel$export(module.exports, "getSpaTransitionHref", () => $691595bcd2385e34$export$bc522e78d290b1ac);

var $gwFzn = parcelRequire("gwFzn");

var $1NBp8 = parcelRequire("1NBp8");

var $7zgzO = parcelRequire("7zgzO");
function $691595bcd2385e34$export$cf1af05a5f90ab81() {
    $691595bcd2385e34$var$useAnchorEventListener('click', $691595bcd2385e34$var$spaTransitionOnAnchorClick, false);
    $691595bcd2385e34$var$useAnchorEventListener('mousedown', $691595bcd2385e34$var$preloadRouteOnMouseDown, true);
    $691595bcd2385e34$var$useAnchorEventListener('preloadOnHover', $691595bcd2385e34$var$preloadRouteOnMouseDown, true);
    return null;
}
function $691595bcd2385e34$var$createAnchorEventListener(eventListener, routesContext) {
    return (e)=>{
        // Some code already handled this
        if (e.defaultPrevented) return;
        const href = $691595bcd2385e34$export$bc522e78d290b1ac(e, routesContext);
        if (href) eventListener(e, routesContext, href);
    };
}
function $691595bcd2385e34$var$isContentEditable(element) {
    return element instanceof HTMLElement && element.isContentEditable;
}
function $691595bcd2385e34$export$bc522e78d290b1ac(e, routesContext) {
    if (e.type === 'preloadOnHover') {
        if (e.detail?.preloadUrl) return e.detail.preloadUrl;
        return;
    }
    if (!('button' in e) || e['button'] !== 0 /* main button */ ) return;
    // Don't handle if modifier keys used
    if (e['ctrlKey'] || e['shiftKey'] || e['altKey'] || e['metaKey']) return;
    const { target: target } = e;
    if (!target || !(target instanceof Element)) return;
    // This might be the child of an anchor (such as the span inside of a smart card),
    // so check for a parent anchor.
    const anchor = target.closest('a');
    if (!anchor) return;
    //ignore hash links, they're handled by scroll handlers that also listen to document click
    if (!(anchor instanceof HTMLAnchorElement) || 'hash' in anchor && anchor['hash']) return;
    // Links in contenteditable elements are not clickable
    // https://product-fabric.atlassian.net/browse/CEMS-951
    // Checking closest 'contentEditable' for anchor,
    // In case there are "contenteditable=false" in between target and anchor.
    // Also check the property, since contenteditable="false" is possible
    const closestContentEditableFromAnchor = anchor.closest('[contenteditable]');
    const closestContentEditableFromTarget = target.closest('[contenteditable]');
    if ($691595bcd2385e34$var$isContentEditable(closestContentEditableFromAnchor) || $691595bcd2385e34$var$isContentEditable(closestContentEditableFromTarget)) return;
    const noGlobalAnchorHandler = target.closest('[data-no-global-anchor-handler]');
    if (noGlobalAnchorHandler) return;
    // Only handle anchors with relevant targets
    if (anchor.target && anchor.target !== '_self') return;
    const { href: href } = anchor;
    if (!href) return;
    // CONFCLOUD-69367
    // skip copy page legacy to allow user to edit page title
    // CEMS-1140
    // skip create page legacy to allow user to create a page using newer working fabric creation
    if (!routesContext || typeof routesContext.matchRoute !== 'function') return;
    const match = routesContext.matchRoute(href);
    if (match && (match.name === (0, $1NBp8.COPY_PAGE_LEGACY).name || match.name === (0, $1NBp8.CREATE_PAGE_ACTION_LEGACY).name)) return;
    return href;
}
function $691595bcd2385e34$var$preloadRouteOnMouseDown(_, { preloadRoute: preloadRoute }, href) {
    preloadRoute(href);
}
function $691595bcd2385e34$var$spaTransitionOnAnchorClick(e, { push: push }, href) {
    e.preventDefault();
    push(href, Boolean((0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname)));
}
function $691595bcd2385e34$var$useAnchorEventListener(type, anchorEventListener, useCapture) {
    const routesContext = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const eventListener = (0, $gwFzn.useMemo)(()=>$691595bcd2385e34$var$createAnchorEventListener(anchorEventListener, routesContext), [
        anchorEventListener,
        routesContext
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (eventListener) window.addEventListener(type, eventListener, useCapture);
        return ()=>{
            if (eventListener) window.removeEventListener(type, eventListener, useCapture);
        };
    }, [
        eventListener,
        type,
        useCapture
    ]);
}

});
parcelRegister("7zgzO", function(module, exports) {

$parcel$export(module.exports, "RoutesContext", () => $75b27f9b06ddd759$export$779e8f71c6bb38c);

var $gwFzn = parcelRequire("gwFzn");
const $75b27f9b06ddd759$var$nullNoop = ()=>null;
const $75b27f9b06ddd759$var$objNoop = ()=>({});
const $75b27f9b06ddd759$var$stringNoop = ()=>'';
const $75b27f9b06ddd759$var$voidNoop = ()=>{};
const $75b27f9b06ddd759$export$779e8f71c6bb38c = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    getHref: $75b27f9b06ddd759$var$stringNoop,
    history: null,
    location: null,
    match: null,
    transitionId: null,
    toUrl: $75b27f9b06ddd759$var$stringNoop,
    matchRoute: $75b27f9b06ddd759$var$nullNoop,
    matchSupportedRoute: $75b27f9b06ddd759$var$nullNoop,
    getQueryParams: $75b27f9b06ddd759$var$objNoop,
    setQueryParams: $75b27f9b06ddd759$var$voidNoop,
    getHash: $75b27f9b06ddd759$var$stringNoop,
    setHash: $75b27f9b06ddd759$var$voidNoop,
    replace: $75b27f9b06ddd759$var$voidNoop,
    routes: [],
    push: $75b27f9b06ddd759$var$voidNoop,
    open: $75b27f9b06ddd759$var$nullNoop,
    onPageReload: $75b27f9b06ddd759$var$voidNoop,
    preloadRoute: $75b27f9b06ddd759$var$voidNoop
});
$75b27f9b06ddd759$export$779e8f71c6bb38c.displayName = 'RoutesContext';

});


parcelRegister("ek3aD", function(module, exports) {

$parcel$export(module.exports, "getGlobalTransitionPreloader", () => $a13e9b2ce62d19e5$export$9675c02ec7fc88a8);

var $csnse = parcelRequire("csnse");

var $lECVg = parcelRequire("lECVg");
const $a13e9b2ce62d19e5$export$9675c02ec7fc88a8 = (0, $csnse.default)(()=>{
    return new (0, $lECVg.GlobalTransitionPreloader)();
});

});
parcelRegister("lECVg", function(module, exports) {

$parcel$export(module.exports, "GlobalTransitionPreloader", () => $b2c33a4aa51f5065$export$2f8f0e0ec8218c4b);

var $7W8i8 = parcelRequire("7W8i8");
class $b2c33a4aa51f5065$export$46a841557056026b extends Error {
    constructor(message){
        super(message);
        this.name = 'ExternalRejectionError';
    }
}
class $b2c33a4aa51f5065$export$2f8f0e0ec8218c4b {
    /**
   * Registers a transition callback that will be awaited on a route change.
   * The callback will only be invoked if the `onlyCalledIfFunc` returns true or if `onlyCalledIfFunc` is not provided. e.g. To check that a contentId is what you expect it should be. `onlyCalledIfFunc` should be very performant as it will run every route change.
   *
   * PERFORMANCE WARNING: `onlyCalledIfFunc` is executed every route change, and `callback` promise is awaited every time `onlyCalledIfFunc` returns `true` (or if it doesn't exist).
   *                      If either of these functions are not very performant, it could cause undesirable performance degradation on every transition.
   *                      Try to avoid any time-intensive invocations, especially in `onlyCalledIfFunc`. `onlyCalledIfFunc` ideally only runs a condition the `match` that it's passed, e.g. to check `match.params.contentId` or `match.pathname`.
   *                      BEFORE REGISTERING A NEW TRANSITION CALLBACK, you must be confident that the negative performance impact is acceptable.
   *
   * @example registerTransitionCallback({
   *     id: 'unique-id-related-to-my-code',
   *     callback: ({match}) => {
   *         return new Promise((resolve) => {
   *             const contentId = match.params?.contentId;
   *             // do logic that is a hard pre-requisite for next route and cannot be lazy/concurrently loaded, ideally shouldn't be slow
   *             resolve(); // route change gets unblocked after these callback promises are resolved
   *         }
   *     },
   *     onlyCalledIfFunc: ({match}) => {
   *         const contentId = match.params?.contentId;
   *         // do some very quick logic, ideally no logic that we need to wait for, this function is run every route change
   *         if (isLiveDoc(contentId)) {
   *             return true;
   *         } else {
   *             return false;
   *         }
   *     }
   * });
   *
   * @param {Object} params - The parameters for the transition callback.
   * @param {string} params.id - A unique identifier to prevent duplicate callback registrations.
   * @param {TransitionCallback} params.callback - The callback function to be executed during a route transition. Must return a promise.
   * @param {OnlyCalledIfFunc} [params.onlyCalledIfFunc] - A function that determines whether the callback should be called.
   */ registerTransitionCallback({ id: id, callback: callback, onlyCalledIfFunc: onlyCalledIfFunc }) {
        // We want to keep transition callbacks unique to guarantee we aren't duplicating work, so we tie callbacks to an ID. If there are multiple registrations of the same callback ID, we ignore registration attempts if we're already registered.
        if (this.callbacks.has(id)) return;
        this.callbacks.set(id, [
            callback,
            onlyCalledIfFunc
        ]);
    }
    /**
   * Processes transition callbacks during a route change, checking if we need to create promises from callbacks, and waiting for them to resolve/reject before continuing the route change.
   *
   * @param {OnlyCalledIfFuncArgs & { onRouteContinue: () => void }} args - The arguments containing the route `match` object and the `onRouteContinue` continuation function.
   *                                                                        `onRouteContinue` is called once promises resolve and should finish executing the route change.
   * @returns {boolean} - Returns `true` if processing transition callback and routeChangeHandler should not continue running.
   *                      Returns `false` if not processing transition callback and routeChangeHandler should continue running.
   */ processTransitionCallback({ match: match, onRouteContinue: onRouteContinue }) {
        try {
            if (!this.callbacks.size) return false;
            // Sometimes the same pathname is processed by routeChangeHandler twice in quick succession, once for PUSH action and then for REPLACE action.
            // This ensures that the REPLACE action doesn't skip over or delay the callback promise started by the PUSH action of the same pathname; it'll rely on the existing activelyRunningCallbackPromises from the first route change.
            const previousPathname = this.latestPathname;
            this.latestPathname = match?.pathname;
            if (this.latestPathname !== previousPathname) // Cancel all currently running promises because we're going to a different route. Helps prevent multiple quick route changes from causing race condition that could send user to outdated route change.
            // If needed, `getCallbackPromises` below will create new promises for the latest route.
            Object.entries(this.activelyRunningCallbackPromises).forEach(([callbackId, { reject: reject }])=>{
                reject();
                // Delete the active running promise to ensure a rejected promise isn't returned by `this.getCallbackPromises`, instead it should create a new one for this callbackId
                delete this.activelyRunningCallbackPromises[callbackId];
            });
            const { callbackPromises: callbackPromises, callbackPromiseIds: callbackPromiseIds } = this.getCallbackPromises({
                match: match
            });
            if (!callbackPromises.length) {
                // If there are no callback promises, route change will immediately continue. Reset our callbacks state as we don't want registered callbacks to linger once the user leaves the route. Callbacks should be registered on page/etc load if needed.
                // EDGE CASE: If the user is on a live doc and quickly clicks a non-live-doc like a view page, then quickly clicks back into a live doc before the view page has loaded, the preload-live-doc callback may have been removed, slowing down load time into that live doc.
                //            One alternative is to always check if we should preload a live doc on any route change by never unregistering that callback, but the performance impact doesn't seem worth it.
                this.callbacks = new Map();
                this.activelyRunningCallbackPromises = {};
                return false;
            }
            // Await all the promises and then send the user to the next route if appropriate.
            Promise.allSettled(callbackPromises).then((promiseResults)=>{
                let externallyRejectedCount = 0;
                promiseResults.forEach((result)=>{
                    if (result.status === 'rejected') {
                        if (result.reason instanceof $b2c33a4aa51f5065$export$46a841557056026b) externallyRejectedCount++;
                        else this.logger.error`There was an error with a transition callback promise: ${result.reason}, active callbackPromiseIds: ${callbackPromiseIds.join(',')}`;
                    }
                });
                // If all promises have been externally rejected, that means these promises are for an outdated route change, the user has since changed routes again, so we don't want to redirect the user to the route.
                // This avoids race condition scenarios where user goes from Doc A -> Doc B -> Doc C, but ends up on Doc B because its promises finished after Doc C's promises.
                if (externallyRejectedCount < callbackPromises.length) {
                    // On successful next route, we clear the currently registered callbacks. Callbacks should be registered on page/etc load if needed.
                    this.callbacks = new Map();
                    this.activelyRunningCallbackPromises = {};
                    onRouteContinue();
                }
            });
            return true;
        } catch (error) {
            this.logger.error`There was an error running processTransitionCallback: ${error}, registered callbackIds: ${Array.from(this.callbacks.keys()).join(',')}`;
        }
        return false;
    }
    /**
   * Creates an array of promises from registered callbacks that should be executed
   * during a route transition. This method checks conditions under which each callback
   * should be called and manages the lifecycle of the promises.
   *
   * @private
   * @param { match: Match } params - The parameters for the method, containing the match object.
   * @returns { callbackPromises: Array<Promise<void>>, callbackPromiseIds: Array<string> } An object containing an array of promises and their corresponding IDs.
   */ getCallbackPromises({ match: match }) {
        if (!this.callbacks) return {
            callbackPromises: [],
            callbackPromiseIds: []
        };
        const callbackPromises = [];
        const callbackPromiseIds = []; // Recommendation is to use this to help provide context to promise errors
        this.callbacks.forEach(([callback, onlyCalledIfFunc], callbackId)=>{
            // Call our `onlyCalledIfFunc` if it's set, we're only waiting for this callback promise if it's `true` or if it's not set.
            const isCallAllowed = onlyCalledIfFunc ? onlyCalledIfFunc({
                match: match
            }) : true;
            // If we want to trigger a callback promise, return the already running one if we have it, otherwise create a new one.
            if (isCallAllowed) {
                const activeRunningPromise = this.activelyRunningCallbackPromises[callbackId];
                if (activeRunningPromise?.promise) {
                    callbackPromises.push(activeRunningPromise.promise);
                    callbackPromiseIds.push(callbackId);
                } else {
                    // Start the promise and store the promise and its reject function in state (this.processTransitionCallback may call `reject` if the user changes route)
                    let callbackPromiseReject;
                    const callbackPromise = new Promise((resolve, reject)=>{
                        callbackPromiseReject = reject;
                        callback({
                            match: match
                        }).then(resolve).catch(reject);
                    });
                    callbackPromises.push(callbackPromise);
                    callbackPromiseIds.push(callbackId);
                    this.activelyRunningCallbackPromises[callbackId] = {
                        promise: callbackPromise,
                        reject: (reason)=>callbackPromiseReject(new $b2c33a4aa51f5065$export$46a841557056026b(reason))
                    };
                }
            } else if (this.activelyRunningCallbackPromises[callbackId]) {
                // If the promise no longer needs to run then stop tracking it if it's already running.
                this.activelyRunningCallbackPromises[callbackId]?.reject?.();
                delete this.activelyRunningCallbackPromises[callbackId];
            }
        });
        return {
            callbackPromises: callbackPromises,
            callbackPromiseIds: callbackPromiseIds
        };
    }
    constructor(){
        this.logger = (0, $7W8i8.getLogger)('GlobalTransitionPreloader');
        this.callbacks = new Map();
        this.activelyRunningCallbackPromises = {};
        this.latestPathname = '';
    }
}

});



parcelRegister("64KID", function(module, exports) {

$parcel$export(module.exports, "namedRoutes", () => $6b577cb9f675ff80$export$d4971375353d0454);

var $1NBp8 = parcelRequire("1NBp8");
const $6b577cb9f675ff80$export$d4971375353d0454 = [
    $1NBp8.BASE,
    $1NBp8.WIKI,
    $1NBp8.HOME,
    $1NBp8.TEMPLATE_GALLERY,
    $1NBp8.CALENDAR,
    $1NBp8.MY_CALENDAR,
    $1NBp8.QUESTIONS,
    $1NBp8.QUESTIONS_NATIVE,
    $1NBp8.QUESTION_NATIVE,
    $1NBp8.CONTENT_HISTORY,
    $1NBp8.CONTENT_HISTORY_LEGACY,
    $1NBp8.EDIT_PAGE,
    $1NBp8.EDIT_BLOG,
    $1NBp8.EDIT_PAGE_V2,
    $1NBp8.EDIT_BLOG_V2,
    $1NBp8.EDIT_PAGE_EMBED,
    $1NBp8.CREATE_CONTENT,
    $1NBp8.CREATE_PAGE,
    $1NBp8.CREATE_BLOG,
    $1NBp8.DELETE_PAGE,
    $1NBp8.ONBOARDING,
    $1NBp8.SPACE_DIRECTORY,
    $1NBp8.SPACE_SETTINGS,
    $1NBp8.SPACE_SETTINGS_REORDERPAGES,
    $1NBp8.SPACE_OVERVIEW_REDIRECT_LEGACY,
    $1NBp8.DELETE_SPACE_LEGACY,
    $1NBp8.SPACE_INDEX,
    $1NBp8.SPACE_OVERVIEW,
    $1NBp8.COMPANY_HUB,
    $1NBp8.COMPANY_HUB_ANALYTICS,
    $1NBp8.COMPANY_HUB_EDIT,
    $1NBp8.COMPANY_HUB_SETTINGS,
    $1NBp8.VIEW_PAGE,
    $1NBp8.NEXT_VIEW_PAGE,
    $1NBp8.BLOG_HOME,
    $1NBp8.VIEW_BLOG,
    $1NBp8.SPACE_JIRA_PROJECT_BOARD,
    $1NBp8.WHITEBOARD_HOME,
    $1NBp8.WHITEBOARD_BOARD,
    $1NBp8.CONTACT_ADMINISTRATOR,
    $1NBp8.ADMIN_SETTINGS,
    $1NBp8.ADMIN_GLOBAL_AUTOMATION,
    $1NBp8.ADMIN_EDIT_EXTERNAL_SHARING,
    $1NBp8.ADMIN_FORGE_APPS,
    $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS,
    $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS,
    $1NBp8.ADMIN_COMPANY_HOME_BUILDER,
    $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION,
    $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS,
    $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS,
    $1NBp8.SPACE_PERMISSIONS_APPS,
    $1NBp8.EDIT_SPACE_PERMISSIONS_APPS,
    $1NBp8.ADMIN_AUDIT_LOG,
    $1NBp8.ADMIN_BROWSE_SHORTCUTS,
    $1NBp8.ADMIN_CREATE_SHORTCUT,
    $1NBp8.ADMIN_REMOVE_SHORTCUT,
    $1NBp8.ADMIN_DARK_FEATURES,
    $1NBp8.ADMIN_ENABLE_DARK_FEATURE,
    $1NBp8.ADMIN_DISABLE_DARK_FEATURE,
    $1NBp8.ADMIN_BETA_FEATURES,
    $1NBp8.ADMIN_NEW_FEATURES,
    $1NBp8.ADMIN_LIVE_EDIT,
    $1NBp8.ADMIN_WORKFLOWS,
    $1NBp8.SPACE_CALENDAR,
    $1NBp8.SPACE_CALENDARS,
    $1NBp8.SPACE_CALENDARS_SUBCALENDAR,
    $1NBp8.SPACE_EMBEDDED_SUBCALENDAR,
    $1NBp8.DISCOVER,
    $1NBp8.ALL_UPDATES,
    $1NBp8.POPULAR,
    $1NBp8.MY_WORK_HOME,
    $1NBp8.MY_WORK_DRAFTS,
    $1NBp8.MY_WORK_RECENT,
    $1NBp8.MY_RECENTLY_VISITED,
    $1NBp8.MY_SAVED_FOR_LATER,
    $1NBp8.RECENT_PAGES,
    $1NBp8.RECENT_VISITED,
    $1NBp8.RECENT_DRAFTS,
    $1NBp8.RECENT_SAVED,
    $1NBp8.TEMPLATE_MIGRATION_PREVIEW,
    $1NBp8.EDIT_TEMPLATE,
    $1NBp8.EDIT_TEMPLATE_BLUEPRINT,
    $1NBp8.EDIT_TEMPLATE_SPACE,
    $1NBp8.CREATE_TEMPLATE,
    $1NBp8.CREATE_TEMPLATE_SPACE,
    $1NBp8.HELLO_WORLD,
    $1NBp8.DASHBOARD_ACTION_LEGACY,
    $1NBp8.SPA_ACTION_LEGACY,
    $1NBp8.INDEX_ACTION_LEGACY,
    $1NBp8.CREATE_PAGE_ACTION_LEGACY,
    $1NBp8.CREATE_BLOG_ACTION_LEGACY,
    $1NBp8.CREATE_PAGE_VARIABLES_ACTION_LEGACY,
    $1NBp8.RESUME_DRAFT_LEGACY,
    $1NBp8.COPY_PAGE_LEGACY,
    $1NBp8.VIEW_PAGE_ACTION_LEGACY,
    $1NBp8.SPACE_OVERVIEW_INDEX_ACTION_LEGACY,
    $1NBp8.SPACE_INDEX_ACTION_LEGACY,
    $1NBp8.SPACE_PAGES,
    $1NBp8.VIEW_BLOG_DATE_LEGACY,
    $1NBp8.ACTION_REDIRECT_LEGACY,
    $1NBp8.ADVANCED_SEARCH_LEGACY,
    $1NBp8.ADVANCED_SEARCH,
    $1NBp8.EXTERNAL_SHARE,
    $1NBp8.PDF_EXPORT_PAGE,
    $1NBp8.PDF_EXPORT_SPACE,
    $1NBp8.LEGACY_SPACE_PDF_EXPORT,
    $1NBp8.EXPORT_SPACE_CSV,
    $1NBp8.EXPORT_SPACE_XML,
    $1NBp8.EXPORT_SPACE_HTML,
    $1NBp8.SPACE_SETTINGS_EXPORT,
    $1NBp8.VIEW_PAGE_MOBILE,
    $1NBp8.VIEW_BLOG_MOBILE,
    $1NBp8.PEOPLE_DIRECTORY_SEARCH,
    $1NBp8.CONFLUENCE_PEOPLE_DIRECTORY_SEARCH,
    $1NBp8.MARKETPLACE_FIND_APPS,
    $1NBp8.MARKETPLACE_APP_REQUESTS,
    $1NBp8.MARKETPLACE_MANAGE_PROMOTIONS,
    $1NBp8.PEOPLE_DIRECTORY,
    $1NBp8.SPACE_RESTRICTED_PAGES,
    $1NBp8.SPACE_ARCHIVED_PAGES,
    $1NBp8.PAGE_DIFF_BY_VERSION,
    $1NBp8.SITE_ANALYTICS,
    $1NBp8.SITE_ANALYTICS_PERMISSIONS,
    $1NBp8.SPACE_ANALYTICS,
    $1NBp8.SPACE_ANALYTICS_PERMISSIONS,
    $1NBp8.PAGE_ANALYTICS,
    $1NBp8.SPACE_QUESTIONS,
    $1NBp8.SPACE_QUESTIONS_NATIVE,
    $1NBp8.SPACE_QUESTION_NATIVE,
    $1NBp8.SPACE_CUSTOM_CONTENT_LIST,
    $1NBp8.CUSTOM_CONTENT_VIEW,
    $1NBp8.SPACE_BULK_TOOLS,
    $1NBp8.SPACE_SETTINGS_LANDING_PAGE,
    $1NBp8.SPACE_SETTINGS_LANDING_PAGE_ALT,
    $1NBp8.SPACE_SETTINGS_AUTOMATION,
    $1NBp8.SPACE_SETTINGS_ARCHIVE_SPACE,
    $1NBp8.SPACE_SETTINGS_TRASH_SPACE,
    $1NBp8.SPACE_FORGE_APPS,
    $1NBp8.GLOBAL_PAGE_FORGE,
    $1NBp8.SPACE_SETTINGS_FORGE_APPS,
    $1NBp8.SPACE_SETTINGS_AVATARS_AND_STATUS,
    $1NBp8.SPACE_SETTINGS_CONTENT_STATE,
    $1NBp8.SPACE_SETTINGS_DATA_CLASSIFICATION,
    $1NBp8.SPACE_SETTINGS_EXPORT_SPACE,
    $1NBp8.SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE,
    $1NBp8.SPACE_SETTINGS_HIDDEN_PAGES,
    $1NBp8.SPACE_SETTINGS_RELATED_PAGES,
    $1NBp8.SPACE_SETTINGS_UNDEFINED_PAGES,
    $1NBp8.SPACE_SETTINGS_ATTACHMENTS,
    $1NBp8.SPACE_SETTINGS_APPLICATION_LINKS,
    $1NBp8.SPACE_SETTINGS_RSS_FEEDS,
    $1NBp8.SPACE_SETTINGS_EDITOR_CONVERSION,
    $1NBp8.SPACE_LOOK_AND_FEEL_SETTINGS,
    $1NBp8.SPACE_TRASH,
    $1NBp8.MOBILE_TAKEOVER_PAGE,
    $1NBp8.DEFAULT_ADMIN_MANAGE_APPS,
    $1NBp8.ADMIN_APP_AUDIT_LOGS,
    $1NBp8.SPACE_SETTINGS_TEMPLATE_LIST_PAGE_LEGACY,
    $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS,
    $1NBp8.ADMIN_APPLICATION_NAVIGATOR,
    $1NBp8.CUSTOM_CONTENTS_ON_PAGE_LIST,
    $1NBp8.SPACE_PERMISSIONS_SETTINGS,
    $1NBp8.USER_ACCESS,
    $1NBp8.ADMIN_ANNOUNCEMENT_BANNER_RENDERER,
    $1NBp8.SPACE_MANAGER,
    $1NBp8.ADMIN_CENTER,
    $1NBp8.ADMIN_CENTER_SPACE,
    $1NBp8.ADMIN_TEAM_CALENDARS,
    $1NBp8.ADMIN_CONFIGURATION,
    $1NBp8.ADMIN_DEFAULT_SPACE_LOGO,
    $1NBp8.ADMIN_HEADER_AND_FOOTER,
    $1NBp8.ADMIN_SECURITY_CONFIGURATION,
    $1NBp8.ADMIN_SPACE_REPORTS,
    $1NBp8.ADMIN_CODE_MACRO_CONFIGURATION,
    $1NBp8.ADMIN_COLOR_SCHEME,
    $1NBp8.DATABASE_VIEW,
    $1NBp8.DATABASE_CUSTOM_OVERVIEW,
    $1NBp8.DATABASE_CUSTOM_VIEW,
    $1NBp8.EMBED_VIEW,
    $1NBp8.FOLDER_VIEW,
    $1NBp8.SPACE_SETTINGS_EDIT_FEATURES,
    $1NBp8.ADMIN_BULK_PERMISSIONS,
    $1NBp8.ADMIN_NOTIFICATIONS,
    $1NBp8.ADMIN_TRASHED_SPACES,
    $1NBp8.ADMIN_JIRA_MACRO_REPAIR,
    $1NBp8.ADMIN_IMPORT_SPACES,
    $1NBp8.ADMIN_MACRO_USAGE,
    $1NBp8.ADMIN_MACRO_USAGE_LEGACY,
    $1NBp8.SPACE_MEMBERS,
    $1NBp8.ADMIN_THEMES,
    $1NBp8.ADMIN_PDF_EXPORT,
    $1NBp8.CREATE_TEMPLATE_SITE_LEGACY,
    $1NBp8.CREATE_TEMPLATE_SPACE_LEGACY,
    $1NBp8.SITE_SETTINGS_EDIT_TEMPLATE_LEGACY,
    $1NBp8.SPACE_SETTINGS_TEMPLATES,
    $1NBp8.SPACE_SETTINGS_EDIT_TEMPLATE_LEGACY,
    $1NBp8.TOPICS,
    $1NBp8.LABELLED_CONTENT,
    $1NBp8.SITE_SETTINGS_EDIT_SYSTEM_TEMPLATE_LEGACY,
    $1NBp8.EDIT_DEFAULT_BLUEPRINT_LEGACY,
    $1NBp8.SPACE_SETTINGS_DETAILS,
    $1NBp8.WORKFLOWS,
    $1NBp8.SMART_CREATE_PROMPT
].reduce((acc, route)=>{
    acc[route.name] = route;
    return acc;
}, {});

});

parcelRegister("1AV5C", function(module, exports) {

$parcel$export(module.exports, "hashData", () => $296ae6b56fdf64d7$export$7904c6256691057a);
$parcel$export(module.exports, "hashDataAsByte", () => $296ae6b56fdf64d7$export$5fdf8c875acfc1b3);
$parcel$export(module.exports, "hashDataWithSha1_DO_NOT_USE", () => $296ae6b56fdf64d7$export$bf9b056bcf5cf86a);
// @ts-ignore

var $3rxD2 = parcelRequire("3rxD2");
function $296ae6b56fdf64d7$var$hash(algorithm, data, asBytes = false) {
    const hash1 = (0, (/*@__PURE__*/$parcel$interopDefault($3rxD2))).createHash(algorithm);
    hash1.update(data);
    if (asBytes) return Array.from(hash1.digest());
    return hash1.digest('hex');
}
function $296ae6b56fdf64d7$export$7904c6256691057a(data) {
    return $296ae6b56fdf64d7$var$hash('sha256', data);
}
function $296ae6b56fdf64d7$export$5fdf8c875acfc1b3(data) {
    return $296ae6b56fdf64d7$var$hash('sha256', data, true);
}
function $296ae6b56fdf64d7$export$bf9b056bcf5cf86a(data) {
    return $296ae6b56fdf64d7$var$hash('sha1', data);
}

});

parcelRegister("1dnxO", function(module, exports) {

$parcel$export(module.exports, "getIsNav4Enabled", () => $a8a6b891166fd1bc$export$2af1f7a69c1ab0ad);

var $9wGTI = parcelRequire("9wGTI");

var $6mKj3 = parcelRequire("6mKj3");

var $9hcBu = parcelRequire("9hcBu");

var $deyhs = parcelRequire("deyhs");

var $iuIEr = parcelRequire("iuIEr");
const $a8a6b891166fd1bc$export$2af1f7a69c1ab0ad = ()=>{
    const currentGAPhase = (0, $deyhs.getNav4GAPhase)();
    if (currentGAPhase === 2) return true;
    if ((0, $9hcBu.getNav4OptOutCache)()) return false;
    return (0, $9wGTI.fg)('confluence_nav_4') || (0, $6mKj3.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false) || (0, $6mKj3.expVal)('confluence_nav_4_free', 'isEnabled', false) || currentGAPhase === 1 && ((0, $iuIEr.getNav4AdminOptInCache)() || (0, $9hcBu.getNav4GAOptInCache)()) // checks both site opt-in and admin only opt-in
    ;
};

});
parcelRegister("6mKj3", function(module, exports) {

$parcel$export(module.exports, "expVal", () => $86d6de4c9065cd14$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValNoExposure", () => $86d6de4c9065cd14$export$94f132839aec533f);
$parcel$export(module.exports, "expValEquals", () => $86d6de4c9065cd14$export$45abdb3f977b5b14);
$parcel$export(module.exports, "expValEqualsNoExposure", () => $86d6de4c9065cd14$export$63eebf86443a0a61);
$parcel$export(module.exports, "manuallyLogExpExposure", () => $86d6de4c9065cd14$export$d14de861476c5d7c);
$parcel$export(module.exports, "UNSAFE_noExposureExp", () => $86d6de4c9065cd14$export$677f9fa2e1ae6fec);

var $c6GJD = parcelRequire("c6GJD");

var $g68Gk = parcelRequire("g68Gk");
function $86d6de4c9065cd14$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $c6GJD.default).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $g68Gk.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $86d6de4c9065cd14$export$94f132839aec533f(experimentName, param, defaultValue) {
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $c6GJD.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: false
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $g68Gk.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $86d6de4c9065cd14$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $86d6de4c9065cd14$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
}
function $86d6de4c9065cd14$export$63eebf86443a0a61(experimentName, param, comparatorValue) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $86d6de4c9065cd14$export$94f132839aec533f(experimentName, param, null) === comparatorValue;
}
function $86d6de4c9065cd14$export$d14de861476c5d7c(experimentName) {
    (0, $c6GJD.default).manuallyLogExperimentExposure(experimentName);
}
class $86d6de4c9065cd14$var$ExperimentConfig {
    get(key, defaultValue, typeGuard) {
        // Check if the CRITERION override mechanism is available
        if (window && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            const overrideValue = window.__CRITERION__.getExperimentValueOverride(this._experimentName, key);
            if (overrideValue !== undefined && overrideValue !== null) {
                (0, $g68Gk.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, overrideValue);
                return overrideValue;
            }
        }
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $g68Gk.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
    constructor(experimentName, config){
        this._experimentName = void 0;
        this._config = void 0;
        this._experimentName = experimentName;
        this._config = config;
    }
}
const $86d6de4c9065cd14$var$cache = new Map();
function $86d6de4c9065cd14$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $86d6de4c9065cd14$var$cache.get(experimentName);
    if (instance == null) {
        const config = (0, $c6GJD.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        const fireExposure = ()=>(0, $c6GJD.default).manuallyLogExperimentExposure(experimentName);
        instance = [
            new $86d6de4c9065cd14$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $86d6de4c9065cd14$var$cache.set(experimentName, instance);
    }
    return instance;
}

});

parcelRegister("9hcBu", function(module, exports) {

$parcel$export(module.exports, "useNav4OptOut", () => $4aa660b1c29a3af1$export$77dd43be45cef9eb);
$parcel$export(module.exports, "getNav4OptOutCache", () => $4aa660b1c29a3af1$export$913ff9805687cd8);
$parcel$export(module.exports, "getNav4GAOptInCache", () => $4aa660b1c29a3af1$export$aca664b5b089bc42);

var $gwFzn = parcelRequire("gwFzn");

var $1KmJq = parcelRequire("1KmJq");
var $xQxzY = parcelRequire("xQxzY");

var $d2LG0 = parcelRequire("d2LG0");

var $inPa6 = parcelRequire("inPa6");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $9wGTI = parcelRequire("9wGTI");

var $dPJCf = parcelRequire("dPJCf");

var $7Sm4c = parcelRequire("7Sm4c");

var $dd2fS = parcelRequire("dd2fS");
const $4aa660b1c29a3af1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS = 31536000; // 1 year
const $4aa660b1c29a3af1$export$77dd43be45cef9eb = ({ onCompleted: onCompleted, onError: onError } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // useNav4OptOutMutation does not seem to return a response, success state is tracked with a hook instead
    const [isAdminUpdateSuccessful, setAdminUpdateSuccessful] = (0, $gwFzn.useState)(null);
    const { shouldSkipOptOutQuery: shouldSkipOptOutQuery } = (0, $dd2fS.useShouldSkipOptOutQuery)();
    const { loading: loading, data: data, error: queryError } = (0, $xQxzY.useQuery)((0, $d2LG0.default)`query useNav4OptOutQuery{userPreferences{nav4OptOut}}`, {
        skip: shouldSkipOptOutQuery
    });
    // Expected error - query will fail for anonymous and unlicensed users
    if (queryError?.message.includes('Cannot find authenticated user.')) (0, $7Sm4c.markErrorAsHandled)(queryError);
    const [updateNav4OptOutServer] = (0, $1KmJq.useMutation)((0, $d2LG0.default)`mutation useNav4OptOutMutation($nav4OptOut:Boolean!){updateUserPreferences(userPreferences:{nav4OptOut:$nav4OptOut}){nav4OptOut}}`);
    const neverOptedOut = !loading && data?.userPreferences?.nav4OptOut === null;
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const updateNav4OptOut = (0, $gwFzn.useCallback)(async (newNav4OptOut)=>{
        updateNav4OptOutServer({
            variables: {
                nav4OptOut: newNav4OptOut
            }
        }).then(()=>{
            $4aa660b1c29a3af1$var$updateNav4OptOutCache(newNav4OptOut);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'changed',
                    actionSubject: 'navigationVersion',
                    source: 'nav4OptOut',
                    attributes: {
                        originalNavVersion: newNav4OptOut ? '4' : '3',
                        newNavVersion: newNav4OptOut ? '3' : '4'
                    }
                }
            }).fire();
            if (newNav4OptOut && neverOptedOut && !(0, $9wGTI.fg)('confluence_nav4_ga_phase_1')) // If this is the first time opting out, reload with query param to trigger Nav4OptOutSpotlight
            setQueryParams({
                navOptOut: 'true'
            });
            setAdminUpdateSuccessful(true);
            onCompleted?.();
        }).catch((error)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'changeFailed',
                    actionSubject: 'navigationVersion',
                    source: 'nav4OptOut',
                    attributes: {
                        error: error
                    }
                }
            }).fire();
            setAdminUpdateSuccessful(false);
            onError?.(error);
        });
    }, [
        updateNav4OptOutServer,
        createAnalyticsEvent,
        neverOptedOut,
        setQueryParams,
        onCompleted,
        onError
    ]);
    const optOutCache = $4aa660b1c29a3af1$var$parseCacheValue((0, $e9zUf.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).NAV4_OPT_OUT_CACHE));
    const optOutServer = data?.userPreferences?.nav4OptOut;
    const nav4OptOut = ((0, $9wGTI.fg)('confluence_nav_4') || (0, $9wGTI.fg)('confluence_nav4_ga_phase_1')) && (loading ? optOutCache : optOutServer);
    (0, $gwFzn.useEffect)(()=>{
        if (!loading && optOutServer !== optOutCache) $4aa660b1c29a3af1$var$updateNav4OptOutCache(optOutServer);
    }, [
        loading,
        optOutCache,
        optOutServer
    ]);
    return {
        nav4OptOut: nav4OptOut,
        updateNav4OptOut: updateNav4OptOut,
        isAdminUpdateSuccessful: isAdminUpdateSuccessful
    };
};
const $4aa660b1c29a3af1$var$parseCacheValue = (cacheValue)=>{
    if (cacheValue === 'true') return true;
    else if (cacheValue === 'false') return false;
    else return undefined;
};
const $4aa660b1c29a3af1$export$913ff9805687cd8 = ()=>{
    return (0, $e9zUf.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).NAV4_OPT_OUT_CACHE) === 'true';
};
const $4aa660b1c29a3af1$export$aca664b5b089bc42 = ()=>{
    return (0, $e9zUf.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).NAV4_OPT_OUT_CACHE) === 'false';
};
const $4aa660b1c29a3af1$var$updateNav4OptOutCache = (nav4OptOut)=>{
    if (nav4OptOut) (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).NAV4_OPT_OUT_CACHE, true, $4aa660b1c29a3af1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS);
    else if (nav4OptOut === false) // if explicitly set to false, we need to save to check in phase_1 since false means "opt-in"
    (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).NAV4_OPT_OUT_CACHE, false, $4aa660b1c29a3af1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS);
    else // the value is null and has never been set
    (0, $e9zUf.confluenceLocalStorageInstance)?.removeItem((0, $1UApO.keys).NAV4_OPT_OUT_CACHE);
};

});
parcelRegister("1KmJq", function(module, exports) {

$parcel$export(module.exports, "useMutation", () => $1f2fbbafdbe2bc31$export$609860bf8b0084c);

var $gwFzn = parcelRequire("gwFzn");

var $fQ5Z2 = parcelRequire("fQ5Z2");

var $9x4nt = parcelRequire("9x4nt");

var $kH7bh = parcelRequire("kH7bh");
const $1f2fbbafdbe2bc31$export$609860bf8b0084c = (...args)=>{
    const ufoContext = (0, $gwFzn.useContext)((0, $9x4nt.default));
    const apolloResult = (0, $fQ5Z2.useMutation)(...args);
    const [query] = args;
    const operationName = (0, $kH7bh.default)(query);
    const isLoading = apolloResult?.[1]?.loading;
    (0, $gwFzn.useEffect)(()=>{
        if (isLoading) return ufoContext?.hold(operationName);
    }, [
        isLoading,
        operationName,
        ufoContext
    ]);
    return apolloResult;
};

});
parcelRegister("kH7bh", function(module, exports) {

$parcel$export(module.exports, "default", () => $91b77edaac521dc8$export$2e2bcd8739ae039);
function $91b77edaac521dc8$export$2e2bcd8739ae039(gqlQueryNode) {
    const operationDef = gqlQueryNode?.definitions?.find((d)=>d.kind === 'OperationDefinition' && d.name);
    const operationName = (operationDef?.kind === 'OperationDefinition' ? operationDef?.name?.value : undefined) ?? 'unnamed';
    return operationName;
}

});


parcelRegister("xQxzY", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $3e40b354eb23a248$export$dd0a697e1782aedd);

var $gwFzn = parcelRequire("gwFzn");

var $fQ5Z2 = parcelRequire("fQ5Z2");

var $9x4nt = parcelRequire("9x4nt");

var $kH7bh = parcelRequire("kH7bh");
const $3e40b354eb23a248$export$dd0a697e1782aedd = (...args)=>{
    const ufoContext = (0, $gwFzn.useContext)((0, $9x4nt.default));
    const apolloResult = (0, $fQ5Z2.useQuery)(...args);
    const [query] = args;
    const operationName = (0, $kH7bh.default)(query);
    const isLoading = apolloResult?.loading;
    (0, $gwFzn.useEffect)(()=>{
        if (isLoading) return ufoContext?.hold(operationName);
    }, [
        isLoading,
        operationName,
        ufoContext
    ]);
    return apolloResult;
};

});

parcelRegister("dd2fS", function(module, exports) {

$parcel$export(module.exports, "useShouldSkipOptOutQuery", () => $163bef83c88d2a98$export$d7e12273c5b6a967);

var $9wGTI = parcelRequire("9wGTI");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");
const $163bef83c88d2a98$export$cad4fa6c249bffe = ()=>{
    if ((0, $9wGTI.fg)('confluence_nav4_ga_phase_2')) //if phase 2 is enabled ignore all opt out
    return true;
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('confluence_nav_4')) //fire the query if nav4 is enabled
    return false;
    if ((0, $9wGTI.fg)('confluence_nav4_ga_phase_1')) //if nav4 is disabled, but phase 1 is enabled, check the opt status
    return false; //should still skip if admin opt in is enabled
    return true;
};
const $163bef83c88d2a98$var$hasAccess = (accessStatus)=>![
        (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS,
        null
    ].includes(accessStatus);
const $163bef83c88d2a98$export$d7e12273c5b6a967 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    // Should skip for anonymous and unlicensed users as userPreferences will return error in those cases
    return {
        shouldSkipOptOutQuery: !$163bef83c88d2a98$var$hasAccess(accessStatus) || $163bef83c88d2a98$export$cad4fa6c249bffe()
    };
};

});
parcelRegister("d9tcB", function(module, exports) {

$parcel$export(module.exports, "AccessStatus", () => $adbc8f20ade62008$export$9d38595f26d62a61);
$parcel$export(module.exports, "ConfluenceEdition", () => $adbc8f20ade62008$export$68577d543b14ae02);
/**
 * @generated SignedSource<<141e8afe30ac6898c08d6b7763f0a722>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["STAGING"] = "STAGING";
    Environment["PRODUCTION"] = "PRODUCTION";
    return Environment;
}({});

});

parcelRegister("bQm3c", function(module, exports) {

$parcel$export(module.exports, "useSessionData", () => $f754a96b8722739c$export$3571dffcff931902);

var $gwFzn = parcelRequire("gwFzn");

var $f7i8j = parcelRequire("f7i8j");
const $f754a96b8722739c$export$3571dffcff931902 = ()=>(0, $gwFzn.useContext)((0, $f7i8j.SessionDataContext));

});
parcelRegister("f7i8j", function(module, exports) {

$parcel$export(module.exports, "SessionDataContext", () => $651dccbfa84cc225$export$47bf0d5265bb1324);

var $gwFzn = parcelRequire("gwFzn");
const $651dccbfa84cc225$export$47bf0d5265bb1324 = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext(// The app should not be making use of `SessionDataContext` until it's loaded.
// It *should* be safe to assert the presence of SessionData by this point.
undefined);
$651dccbfa84cc225$export$47bf0d5265bb1324.displayName = 'SessionDataContext';

});




parcelRegister("deyhs", function(module, exports) {

$parcel$export(module.exports, "getNav4GAPhase", () => $ae73c93d192e1e2d$export$827babb08d748504);

var $9wGTI = parcelRequire("9wGTI");
const $ae73c93d192e1e2d$export$827babb08d748504 = ()=>{
    if ((0, $9wGTI.fg)('confluence_nav4_ga_phase_2')) return 2;
    if ((0, $9wGTI.fg)('confluence_nav4_ga_phase_1')) return 1;
    return 0;
};

});

parcelRegister("iuIEr", function(module, exports) {

$parcel$export(module.exports, "updateNav4AdminOptInCache", () => $b498080c9041fb4f$export$2157f431c298ed22);
$parcel$export(module.exports, "getNav4AdminOptInCache", () => $b498080c9041fb4f$export$4b020a7ac475108f);

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
const $b498080c9041fb4f$var$OPT_OUT_CACHE_EXPIRATION_SECONDS = 31536000; // 1 year
const $b498080c9041fb4f$export$2157f431c298ed22 = (nav4AdminOptIn)=>{
    if (nav4AdminOptIn) (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).NAV4_ADMIN_OPT_IN_CACHE, true, $b498080c9041fb4f$var$OPT_OUT_CACHE_EXPIRATION_SECONDS);
    else // the value is null and has never been set
    (0, $e9zUf.confluenceLocalStorageInstance)?.removeItem((0, $1UApO.keys).NAV4_ADMIN_OPT_IN_CACHE);
};
const $b498080c9041fb4f$export$4b020a7ac475108f = ()=>{
    return (0, $e9zUf.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).NAV4_ADMIN_OPT_IN_CACHE) === 'true';
};

});


parcelRegister("36IZS", function(module, exports) {

$parcel$export(module.exports, "SSRInlineScriptsInit", () => $2eff8a40a60fa79f$export$708921e5c63e07ae);

var $gwFzn = parcelRequire("gwFzn");

var $ipR6C = parcelRequire("ipR6C");
const $2eff8a40a60fa79f$export$708921e5c63e07ae = ({})=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipR6C.SSRInlineCommentsInit), null);
};

});
parcelRegister("ipR6C", function(module, exports) {

$parcel$export(module.exports, "SSRInlineCommentsInit", () => $ab36569cbfed18a7$export$857c9d19bfa05cb5);

var $gwFzn = parcelRequire("gwFzn");
const $ab36569cbfed18a7$export$857c9d19bfa05cb5 = ({})=>{
    // If there are no comments to SSR don't run scripts
    if (!window.__SSR_INLINE_COMMENT_MARKS__ || window.__SSR_INLINE_COMMENT_MARKS__ && window.__SSR_INLINE_COMMENT_MARKS__.length < 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        id: "inline-comments-script",
        "data-testid": "inline-comments-script",
        "data-marks": window.__SSR_INLINE_COMMENT_MARKS__,
        "data-focused": window.__SSR_FOCUSED_INLINE_COMMENTS__
    });
};

});


parcelRegister("PrCoC", function(module, exports) {

$parcel$export(module.exports, "ssrPrepareErrorsClient", () => $85f8cf83f10f86cd$export$17bc715070d0e7ef);
$parcel$export(module.exports, "superbatchCSSRecorder", () => $85f8cf83f10f86cd$export$7e0fa12f001c7621);
$parcel$export(module.exports, "superbatchJSRecorder", () => $85f8cf83f10f86cd$export$373af14cb13ff346);
$parcel$export(module.exports, "mediaConfigRecorder", () => $85f8cf83f10f86cd$export$279f2f878f49d0df);
$parcel$export(module.exports, "mediaConfigEnforceDSPRecorder", () => $85f8cf83f10f86cd$export$e125b144e38aa5db);
$parcel$export(module.exports, "globalMacrosCSSRecorder", () => $85f8cf83f10f86cd$export$41987981af6ac15b);
$parcel$export(module.exports, "globalMacrosJSRecorder", () => $85f8cf83f10f86cd$export$59d25f12f6b98bee);
$parcel$export(module.exports, "themeSSRManager", () => $85f8cf83f10f86cd$export$fd920a796bc0c5e);
$parcel$export(module.exports, "ssrDisableHydrationRecorder", () => $85f8cf83f10f86cd$export$b03446a83b2aa8c6);
$parcel$export(module.exports, "ssrPermissionsErrorHandler", () => $85f8cf83f10f86cd$export$c82fe4eede9104df);

var $jOLle = parcelRequire("jOLle");

var $8pKBz = parcelRequire("8pKBz");

var $2BiLx = parcelRequire("2BiLx");

var $1Ipq9 = parcelRequire("1Ipq9");

var $lrjR8 = parcelRequire("lrjR8");

var $fYzFk = parcelRequire("fYzFk");

var $kryrq = parcelRequire("kryrq");

var $3k5CN = parcelRequire("3k5CN");

var $e9Hvs = parcelRequire("e9Hvs");

var $94W4R = parcelRequire("94W4R");

var $etu7G = parcelRequire("etu7G");

var $36IZS = parcelRequire("36IZS");

var $45prt = parcelRequire("45prt");

var $j8UzL = parcelRequire("j8UzL");

var $i2tcl = parcelRequire("i2tcl");

var $60cDW = parcelRequire("60cDW");

var $8Hqv7 = parcelRequire("8Hqv7");

var $5Abqh = parcelRequire("5Abqh");

var $e4o8D = parcelRequire("e4o8D");

var $dtDUi = parcelRequire("dtDUi");
const $85f8cf83f10f86cd$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
const $85f8cf83f10f86cd$export$7e0fa12f001c7621 = new (0, $8pKBz.SuperbatchResourceRecorder)(false);
const $85f8cf83f10f86cd$export$373af14cb13ff346 = new (0, $8pKBz.SuperbatchResourceRecorder)(true);
const $85f8cf83f10f86cd$export$279f2f878f49d0df = new (0, $2BiLx.ObjectRecorder)();
const $85f8cf83f10f86cd$export$e125b144e38aa5db = new (0, $2BiLx.ObjectRecorder)();
const $85f8cf83f10f86cd$export$41987981af6ac15b = new (0, $jOLle.ResourceRecorder)();
const $85f8cf83f10f86cd$export$59d25f12f6b98bee = new (0, $jOLle.ResourceRecorder)();
const $85f8cf83f10f86cd$export$fd920a796bc0c5e = new (0, $1Ipq9.ThemeSSRManager)();
const $85f8cf83f10f86cd$export$6f28ab7c6647e579 = new (0, $fYzFk.SSRBannerManager)();
const $85f8cf83f10f86cd$export$71b19f18353d1646 = new (0, $kryrq.SSRContentStateManager)();
const $85f8cf83f10f86cd$export$8970c440985bb7fc = new (0, $3k5CN.SSREmojiTitleManager)();
const $85f8cf83f10f86cd$export$b1b267171abe50a3 = new (0, $e9Hvs.EditExperienceHandler)();
const $85f8cf83f10f86cd$export$b03446a83b2aa8c6 = new (0, $94W4R.SSRDisableHydrationRecorder)();
const $85f8cf83f10f86cd$export$c82fe4eede9104df = new (0, $etu7G.SSRPermissionsErrorHandler)();

});
parcelRegister("jOLle", function(module, exports) {

$parcel$export(module.exports, "ResourceRecorder", () => $fefe82051b0a8f7f$export$cfb6f987101ffbc9);

var $l6Xaz = parcelRequire("l6Xaz");
class $fefe82051b0a8f7f$export$cfb6f987101ffbc9 {
    reset() {
        this.resource = '';
    }
    add(resource) {
        this.resource += resource;
        return this;
    }
    addDeferTags(tags) {
        this.resource += (0, $l6Xaz.deferScript)(tags);
        return this;
    }
    get() {
        return this.resource;
    }
    constructor(){
        this.resource = void 0;
        this.resource = '';
    }
}

});
parcelRegister("l6Xaz", function(module, exports) {

$parcel$export(module.exports, "parseScriptTags", () => $372ebd682f0fb003$export$79fe7bf3ba344d67);
$parcel$export(module.exports, "removeJquery", () => $372ebd682f0fb003$export$eccc4243452442c6);
$parcel$export(module.exports, "deferScript", () => $372ebd682f0fb003$export$a26b30913d2c455f);
$parcel$export(module.exports, "addSSRInlineStyleAttr", () => $372ebd682f0fb003$export$d7ce6673daaad624);
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
const $372ebd682f0fb003$var$STYLE_REGEX = /<link([^>]*)\/*>/gi;
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$var$parseStyleTags(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, false, $372ebd682f0fb003$var$STYLE_REGEX);
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$d7ce6673daaad624(tags) {
    return $372ebd682f0fb003$var$parseStyleTags(tags).map((attributes)=>{
        if (!attributes['media'] || attributes['media'] === 'all') return `<link${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} data-ssr-inline-post-process>`;
        return `<link${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}>`;
    }).join('\n');
}

});


parcelRegister("8pKBz", function(module, exports) {

$parcel$export(module.exports, "SuperbatchResourceRecorder", () => $e83174e39025394c$export$f9f620dab3aaf022);

var $l6Xaz = parcelRequire("l6Xaz");

var $9wGTI = parcelRequire("9wGTI");

var $jOLle = parcelRequire("jOLle");
class $e83174e39025394c$export$f9f620dab3aaf022 extends (0, $jOLle.ResourceRecorder) {
    reset() {
        super.reset();
        this.includeConnect = false;
        this.connectResource = '';
    }
    includeConnectWebResources() {
        this.includeConnect = true;
    }
    get() {
        if (!this.isJS) return this.resource;
        // Connect script needs superbatch so don't defer it
        return this.includeConnect && (0, $9wGTI.fg)('content_early_connect_iframe_initialization') ? this.resource : (0, $l6Xaz.deferScript)(this.resource);
    }
    addConnectResource(connectResource) {
        this.connectResource = connectResource;
    }
    getConnect() {
        return this.includeConnect && (0, $9wGTI.fg)('content_early_connect_iframe_initialization') ? this.connectResource : '';
    }
    constructor(isJS){
        super();
        this.includeConnect = void 0;
        this.connectResource = void 0;
        this.isJS = void 0;
        this.includeConnect = false;
        this.connectResource = '';
        this.isJS = isJS;
    }
}

});

parcelRegister("2BiLx", function(module, exports) {

$parcel$export(module.exports, "ObjectRecorder", () => $53dcea44a491523c$export$e411414ea02dd271);
class $53dcea44a491523c$export$e411414ea02dd271 {
    set(object) {
        this.object = object;
    }
    get() {
        return this.object;
    }
    constructor(){
        this.object = null;
    }
}

});

parcelRegister("1Ipq9", function(module, exports) {

$parcel$export(module.exports, "ThemeSSRManager", () => $60061fec709c0fa4$export$f9bc2ffe605f0ec0);

var $aGlHe = parcelRequire("aGlHe");
var $hY0xh = parcelRequire("hY0xh");
var $geGFh = parcelRequire("geGFh");

var $58u2L = parcelRequire("58u2L");
class $60061fec709c0fa4$export$f9bc2ffe605f0ec0 {
    setThemeStateBasedOnSavedThemeState(theme) {
        // If theme is undefined, no reason to set that in themeState as it's not actually a theme (just Original)
        if (theme) this.themeState = {
            ...this.getThemeState(),
            ...theme,
            typography: 'typography-refreshed'
        };
    }
    getThemeState() {
        return this.themeState;
    }
    async getThemeStylesScript() {
        // Generates an array of styles
        if (this.getThemeState().colorMode) {
            const modifiedThemeState = {
                ...this.getThemeState(),
                typography: 'typography-refreshed'
            };
            const themeStyles = await (0, $geGFh.default)(modifiedThemeState);
            // Add a stylesheet for each theme being used
            return themeStyles.map((theme)=>{
                const attributes = Object.entries(theme.attrs).map(([key, value])=>`${key}="${value}"`);
                return `<style ${attributes}>${theme.css}</style>`;
            }).join('');
        } else return '';
    }
    getSSRAutoColorModeScript() {
        // Creates and returns the script used to set the html attributes if the user choose 'auto'
        const currentColorMode = this.getThemeState().colorMode;
        if (currentColorMode === 'auto') {
            const nonceValue = window.__SSR_NONCE_VALUE__;
            const scriptContent = (0, $aGlHe.default)(currentColorMode);
            return nonceValue !== undefined ? `<script nonce="${nonceValue}">${scriptContent}</script>` : `<script>${scriptContent}</script>`;
        } else return '';
    }
    getThemeHtmlAttrsScript() {
        // Simple script to add theme attributes to HTML tag based on users codeMode selection
        const currentThemeState = this.getThemeState();
        if (currentThemeState.colorMode) {
            const themeAttrs = (0, $hY0xh.default)(currentThemeState);
            if (currentThemeState.colorMode === 'auto') /*
               If the colorMode is auto, we don't want to just default to "light" because if the user's
               browser setting is "dark", this would set the "data-color-mode" to "light" and then set
               again with "dark" with the script from getSSRAutoColorModeScript(). Removing the "data-color-mode"
               setAttribute for "auto" makes sure that it is only set once by the getSSRAutoColorModeScript()
             */ delete themeAttrs['data-color-mode'];
            const attributeSetters = Object.entries(themeAttrs).map(([attr, value])=>`document?.documentElement?.setAttribute("${attr}", "${value}");`).join('');
            return `try { ${attributeSetters} } catch (e) {}`;
        } else return '';
    }
    constructor(){
        this.themeState = void 0;
        // If colorMode doesn't get set, you don't want to return anything
        this.themeState = (0, $58u2L.getDefaultTheme)();
    }
}

});
parcelRegister("aGlHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f244cc9b266328f$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $a9dFP = parcelRequire("a9dFP");

var $ajqJ5 = parcelRequire("ajqJ5");
/**
 * Provides a script that, when executed before paint, sets the `data-color-mode` attribute based on the current system theme,
 * to enable SSR support for automatic theme switching, avoid a flash of un-themed content on first paint.
 *
 * @param {string} colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 *
 * @returns {string} A string to be added to the innerHTML of a script tag in the document head
 */ const $1f244cc9b266328f$var$getSSRAutoScript = (colorMode, // TODO: This should be marked as required once safe to roll out.
contrastMode)=>{
    if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
    const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, $ajqJ5.darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, $a9dFP.COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
    const setContrastMode = contrastMode === 'auto' && (0, $dh538.fg)('platform_increased-contrast-themes') ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, $ajqJ5.moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, $a9dFP.CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
    return `(() => {${setColorMode}${setContrastMode}})()`;
};
var $1f244cc9b266328f$export$2e2bcd8739ae039 = $1f244cc9b266328f$var$getSSRAutoScript;

});
parcelRegister("ajqJ5", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", () => $669d2abcffd4d3b1$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "loadThemeCss", () => $669d2abcffd4d3b1$export$8a48286ed7df6720);
$parcel$export(module.exports, "darkModeMediaQuery", () => $669d2abcffd4d3b1$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $669d2abcffd4d3b1$export$8662df6937d86fcb);

var $dh538 = parcelRequire("dh538");

var $33VNB = parcelRequire("33VNB");

var $a9dFP = parcelRequire("a9dFP");
const $669d2abcffd4d3b1$export$26cd7ae85c7144e5 = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, $a9dFP.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $a9dFP.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await $669d2abcffd4d3b1$export$8a48286ed7df6720(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $669d2abcffd4d3b1$export$8a48286ed7df6720 = async (themeId)=>{
    if ((themeId === 'light' || themeId === 'dark') && (0, $dh538.fg)('platform-component-visual-refresh')) themeId += '-brand-refresh';
    const { default: themeCss } = await (0, $33VNB.default)[themeId]();
    return themeCss;
};
const $669d2abcffd4d3b1$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $669d2abcffd4d3b1$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("33VNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $18c1f3b13d61b93d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::8352f41e09dfe9d45ead708661744456>>
 * @codegenCommand yarn build tokens
 */ 














const $18c1f3b13d61b93d$var$themeImportsMap = {
    'light': ()=>(parcelRequire("ftSbO")),
    'light-future': ()=>(parcelRequire("aXq4o")),
    'light-increased-contrast': ()=>(parcelRequire("4LRJt")),
    'dark': ()=>(parcelRequire("l24is")),
    'dark-future': ()=>(parcelRequire("cAA0n")),
    'dark-increased-contrast': ()=>(parcelRequire("eg5Uu")),
    'legacy-light': ()=>(parcelRequire("fc2m9")),
    'legacy-dark': ()=>(parcelRequire("dLatI")),
    'spacing': ()=>(parcelRequire("2rOly")),
    'typography-adg3': ()=>(parcelRequire("kPBAx")),
    'shape': ()=>(parcelRequire("HlL31")),
    'typography-modernized': ()=>(parcelRequire("6ePyU")),
    'typography-refreshed': ()=>(parcelRequire("fwDNj")),
    'light-brand-refresh': ()=>(parcelRequire("7vuZW")),
    'dark-brand-refresh': ()=>(parcelRequire("ax0ws"))
};
var $18c1f3b13d61b93d$export$2e2bcd8739ae039 = $18c1f3b13d61b93d$var$themeImportsMap;

});
parcelRegister("ftSbO", function(module, exports) {

let $b453995600fe0181$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b453995600fe0181$var$load("h1tW8").then(()=>parcelRequire('abuh9'));

});

parcelRegister("aXq4o", function(module, exports) {

let $7fa3a2fbd86269ec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7fa3a2fbd86269ec$var$load("jNRei").then(()=>parcelRequire('epBk0'));

});

parcelRegister("4LRJt", function(module, exports) {

let $37953b5b8bbaa96e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $37953b5b8bbaa96e$var$load("3GB7D").then(()=>parcelRequire('lDnIk'));

});

parcelRegister("l24is", function(module, exports) {

let $f4fd1e1949d01e27$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f4fd1e1949d01e27$var$load("ebMC9").then(()=>parcelRequire('dzoJk'));

});

parcelRegister("cAA0n", function(module, exports) {

let $92a4c6ab80622fa2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $92a4c6ab80622fa2$var$load("iedV6").then(()=>parcelRequire('alLvI'));

});

parcelRegister("eg5Uu", function(module, exports) {

let $a61724f1d8330873$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a61724f1d8330873$var$load("l8hHe").then(()=>parcelRequire('3BTlS'));

});

parcelRegister("fc2m9", function(module, exports) {

let $b0f9cde556600cb2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b0f9cde556600cb2$var$load("56HnP").then(()=>parcelRequire('bzEe0'));

});

parcelRegister("dLatI", function(module, exports) {

let $a047caeac0ec967b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a047caeac0ec967b$var$load("hP5UZ").then(()=>parcelRequire('7UVx9'));

});

parcelRegister("2rOly", function(module, exports) {

let $1c852832d08a2b61$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1c852832d08a2b61$var$load("heSmI").then(()=>parcelRequire('7p1sh'));

});

parcelRegister("kPBAx", function(module, exports) {

let $f2a5ba56be19956c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f2a5ba56be19956c$var$load("hck5E").then(()=>parcelRequire('gArBD'));

});

parcelRegister("HlL31", function(module, exports) {

let $0824e4eb8e5c570d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0824e4eb8e5c570d$var$load("kpiLR").then(()=>parcelRequire('iPpEE'));

});

parcelRegister("6ePyU", function(module, exports) {

let $48ac0c01cfec0db4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $48ac0c01cfec0db4$var$load("be4Ow").then(()=>parcelRequire('9jf84'));

});

parcelRegister("fwDNj", function(module, exports) {

let $b4d8b681d61f6397$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b4d8b681d61f6397$var$load("9ZdQB").then(()=>parcelRequire('1KpW7'));

});

parcelRegister("7vuZW", function(module, exports) {

let $57737935caa245cd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $57737935caa245cd$var$load("k8jK1").then(()=>parcelRequire('glnls'));

});

parcelRegister("ax0ws", function(module, exports) {

let $7aad6439ae4094dc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7aad6439ae4094dc$var$load("iA8EQ").then(()=>parcelRequire('i33Fc'));

});




parcelRegister("hY0xh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6273d1ed92320a12$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $a9dFP = parcelRequire("a9dFP");

var $fwSE5 = parcelRequire("fwSE5");

var $j6S25 = parcelRequire("j6S25");

var $9NuSR = parcelRequire("9NuSR");

var $jf7dC = parcelRequire("jf7dC");
const $6273d1ed92320a12$var$defaultColorMode = 'light';
const $6273d1ed92320a12$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const $6273d1ed92320a12$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $fwSE5.themeStateDefaults)['colorMode'], dark: dark = (0, $fwSE5.themeStateDefaults)['dark'], light: light = (0, $fwSE5.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $fwSE5.themeStateDefaults)['contrastMode'], shape: shape = (0, $fwSE5.themeStateDefaults)['shape'], spacing: spacing = (0, $fwSE5.themeStateDefaults)['spacing'], typography: typography = (0, $fwSE5.themeStateDefaults)['typography'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $fwSE5.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $j6S25.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $a9dFP.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $a9dFP.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $6273d1ed92320a12$var$defaultColorMode : colorMode
    };
    if ((0, $dh538.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $a9dFP.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $6273d1ed92320a12$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $9NuSR.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $jf7dC.hash)(optionString);
        result[0, $a9dFP.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $6273d1ed92320a12$export$2e2bcd8739ae039 = $6273d1ed92320a12$var$getThemeHtmlAttrs;

});
parcelRegister("fwSE5", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", () => $4388733435d61915$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $4388733435d61915$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeIdsWithOverrides", () => $4388733435d61915$export$92ba366331403db2);
$parcel$export(module.exports, "themeStateDefaults", () => $4388733435d61915$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $4388733435d61915$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");
const $4388733435d61915$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ const $4388733435d61915$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
const $4388733435d61915$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ const $4388733435d61915$var$themeOverrideIds = [];
const $4388733435d61915$export$92ba366331403db2 = [
    ...$4388733435d61915$export$7d43e72a58e3283f,
    ...$4388733435d61915$var$themeOverrideIds
];
const $4388733435d61915$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Atlassian Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
const $4388733435d61915$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: ()=>{
        if ((0, $dh538.fg)('platform-default-typography-modernized')) return 'typography-modernized';
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var $4388733435d61915$export$2e2bcd8739ae039 = $4388733435d61915$var$themeConfig;

});

parcelRegister("j6S25", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", () => $8634106acb00ae52$export$f19b488f7c0547ee);
$parcel$export(module.exports, "themeObjectToString", () => $8634106acb00ae52$export$62c37ab81302621a);

var $fwSE5 = parcelRequire("fwSE5");
const $8634106acb00ae52$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
const $8634106acb00ae52$var$customThemeOptions = 'UNSAFE_themeOptions';
const $8634106acb00ae52$var$isThemeKind = (themeKind)=>{
    return $8634106acb00ae52$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};
const $8634106acb00ae52$var$isThemeIds = (themeId)=>{
    return (0, $fwSE5.themeIds).find((id)=>id === themeId) !== undefined;
};
const $8634106acb00ae52$var$isColorMode = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
const $8634106acb00ae52$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(RegExp(":(.*)", "s"))).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && $8634106acb00ae52$var$isColorMode(id)) themeObject[kind] = id;
        if ($8634106acb00ae52$var$isThemeKind(kind) && $8634106acb00ae52$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $8634106acb00ae52$var$customThemeOptions) try {
            themeObject[$8634106acb00ae52$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
const $8634106acb00ae52$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $8634106acb00ae52$var$isColorMode(id) || // custom theme state
        kind === $8634106acb00ae52$var$customThemeOptions && typeof id === 'object' || // other theme states
        $8634106acb00ae52$var$isThemeKind(kind) && typeof id === 'string' && $8634106acb00ae52$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});

parcelRegister("9NuSR", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", () => $7629a259bf911f3c$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $7629a259bf911f3c$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $7629a259bf911f3c$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $7629a259bf911f3c$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $7629a259bf911f3c$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $7629a259bf911f3c$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $7629a259bf911f3c$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $7629a259bf911f3c$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $7629a259bf911f3c$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
const $7629a259bf911f3c$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $7629a259bf911f3c$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $7629a259bf911f3c$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $7629a259bf911f3c$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $7629a259bf911f3c$export$b36dbdb4f463f05c(hex) {
    if (!$7629a259bf911f3c$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $7629a259bf911f3c$export$1212645cf40ebf71(hex)
    ];
}
function $7629a259bf911f3c$export$5a544e13ad4e1fa5(hex) {
    if (!$7629a259bf911f3c$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $7629a259bf911f3c$export$47ea145a83f50dc0(hex) {
    if (!$7629a259bf911f3c$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $7629a259bf911f3c$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $7629a259bf911f3c$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $7629a259bf911f3c$export$d061e26956a60b0a(foreground, background) {
    if (!$7629a259bf911f3c$var$isValidHex(foreground) || !$7629a259bf911f3c$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $7629a259bf911f3c$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $7629a259bf911f3c$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $7629a259bf911f3c$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $7629a259bf911f3c$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $7629a259bf911f3c$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $7629a259bf911f3c$var$rgbToLab(rgbA);
    let labB = $7629a259bf911f3c$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $7629a259bf911f3c$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("jf7dC", function(module, exports) {

$parcel$export(module.exports, "hash", () => $1e92a1c02d71d6b4$export$d6af199866bfb566);
const $1e92a1c02d71d6b4$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("geGFh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a5b891e60ca97ce$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $fwSE5 = parcelRequire("fwSE5");

var $9NuSR = parcelRequire("9NuSR");

var $1oKVt = parcelRequire("1oKVt");

var $ajqJ5 = parcelRequire("ajqJ5");

/**
 * Takes an object containing theme preferences, and returns an array of objects for use in applying styles to the document head.
 * Only supplies the color themes necessary for initial render, based on the current themeState. I.e. if in light mode, dark mode themes are not returned.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns A Promise of an object array, containing theme IDs, data-attributes to attach to the theme, and the theme CSS.
 * If an error is encountered while loading themes, the themes array will be empty.
 */ const $1a5b891e60ca97ce$var$getThemeStyles = async (preferences)=>{
    let themePreferences;
    let themeOverridePreferences = [];
    if (preferences === 'all') {
        themePreferences = (0, $fwSE5.themeIdsWithOverrides);
        // CLEANUP: Remove
        if (!(0, $dh538.fg)('platform_increased-contrast-themes')) themePreferences = themePreferences.filter((n)=>n !== 'light-increased-contrast' && n !== 'dark-increased-contrast');
        themePreferences = themePreferences.filter((n)=>n !== 'light-brand-refresh' && n !== 'dark-brand-refresh');
    } else {
        const themeState = {
            colorMode: preferences?.colorMode || (0, $fwSE5.themeStateDefaults)['colorMode'],
            contrastMode: preferences?.contrastMode || (0, $fwSE5.themeStateDefaults)['contrastMode'],
            dark: preferences?.dark || (0, $fwSE5.themeStateDefaults)['dark'],
            light: preferences?.light || (0, $fwSE5.themeStateDefaults)['light'],
            shape: preferences?.shape || (0, $fwSE5.themeStateDefaults)['shape'],
            spacing: preferences?.spacing || (0, $fwSE5.themeStateDefaults)['spacing'],
            typography: preferences?.typography || (0, $fwSE5.themeStateDefaults)['typography']()
        };
        themePreferences = (0, $1oKVt.getThemePreferences)(themeState);
        themeOverridePreferences = (0, $1oKVt.getThemeOverridePreferences)(themeState);
    }
    const results = await Promise.all([
        ...[
            ...themePreferences,
            ...themeOverridePreferences
        ].map(async (themeId)=>{
            try {
                const css = await (0, $ajqJ5.loadThemeCss)(themeId);
                return {
                    id: themeId,
                    attrs: {
                        'data-theme': themeId
                    },
                    css: css
                };
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
        }),
        // Add custom themes if they're present
        (async ()=>{
            if (preferences !== 'all' && preferences?.UNSAFE_themeOptions && (0, $9NuSR.isValidBrandHex)(preferences?.UNSAFE_themeOptions?.brandColor)) try {
                const { getCustomThemeStyles: getCustomThemeStyles } = await (parcelRequire("4atNR"));
                const customThemeStyles = await getCustomThemeStyles({
                    colorMode: preferences?.colorMode || (0, $fwSE5.themeStateDefaults)['colorMode'],
                    UNSAFE_themeOptions: preferences?.UNSAFE_themeOptions
                });
                return customThemeStyles;
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
        })()
    ]);
    return results.flat().filter((theme)=>theme !== undefined);
};
var $1a5b891e60ca97ce$export$2e2bcd8739ae039 = $1a5b891e60ca97ce$var$getThemeStyles;

});
parcelRegister("1oKVt", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", () => $1fa91599cfa7c506$export$dd6aeb7c823fc03d);
$parcel$export(module.exports, "getThemeOverridePreferences", () => $1fa91599cfa7c506$export$5d76d7014f4a5d08);

var $dh538 = parcelRequire("dh538");

var $iT2q7 = parcelRequire("iT2q7");
const $1fa91599cfa7c506$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $dh538.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $iT2q7.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $dh538.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $iT2q7.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};
const $1fa91599cfa7c506$export$5d76d7014f4a5d08 = (_themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("iT2q7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a8ff3bc097141ca$export$2e2bcd8739ae039);

var $fwSE5 = parcelRequire("fwSE5");
function $5a8ff3bc097141ca$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $fwSE5.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});


parcelRegister("4atNR", function(module, exports) {

let $308f36de7451a7bb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $308f36de7451a7bb$var$load("4tr9u").then(()=>parcelRequire('18QBh'));

});


parcelRegister("58u2L", function(module, exports) {

$parcel$export(module.exports, "getDefaultTheme", () => $8a43a65da3aff11c$export$1fdf6d3d1e0ee29c);
const $8a43a65da3aff11c$export$1fdf6d3d1e0ee29c = ()=>{
    return {
        dark: 'dark',
        light: 'light',
        colorMode: 'light',
        typography: 'typography-refreshed'
    };
};

});


parcelRegister("lrjR8", function(module, exports) {

$parcel$export(module.exports, "SSRPrepareErrorsClient", () => $7cc20c0ac0ad5b24$export$622a2782a1f9c63);
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}

});

parcelRegister("fYzFk", function(module, exports) {

$parcel$export(module.exports, "SSRBannerManager", () => $6069cdb664c4b392$export$c5377c2d90c2873e);
class $6069cdb664c4b392$export$c5377c2d90c2873e {
    registerBanner({ name: name, height: height }) {
        const bannerIndex = this.banners.findIndex((_banner)=>name === _banner.name);
        if (bannerIndex < 0) this.banners.push({
            name: name,
            height: height
        });
    }
    hasOtherBanners(bannerName) {
        return this.banners.some((banner)=>banner.name !== bannerName);
    }
    getBanners() {
        return this.banners;
    }
    clearBanners() {
        this.banners.length = 0;
    }
    constructor(){
        this.banners = [];
    }
}

});

parcelRegister("kryrq", function(module, exports) {

$parcel$export(module.exports, "SSRContentStateManager", () => $35f0b3b8b19ef661$export$2099f874c187e33c);
class $35f0b3b8b19ef661$export$2099f874c187e33c {
    setContentStateData(data) {
        this.contentStateData = data;
    }
    getContentStateData() {
        return this.contentStateData;
    }
    constructor(){
        this.contentStateData = null;
    }
}

});

parcelRegister("3k5CN", function(module, exports) {

$parcel$export(module.exports, "SSREmojiTitleManager", () => $1e89e55daa2cfe08$export$4e9d473910af750d);
class $1e89e55daa2cfe08$export$4e9d473910af750d {
    setEmojiTitleData(data) {
        this.emojiTitleData = data;
    }
    getEmojiTitleData() {
        return this.emojiTitleData;
    }
    constructor(){
        this.emojiTitleData = null;
    }
}

});

parcelRegister("e9Hvs", function(module, exports) {

$parcel$export(module.exports, "EditExperienceHandler", () => $3eb11c5c7fba08ff$export$a968e41065f74a2d);
class $3eb11c5c7fba08ff$export$a968e41065f74a2d {
    setEditExperience(isEditExperience) {
        this.isEditExperience = isEditExperience;
    }
    setDisableAfterPaintOptimization(disableAfterPaintOptimization) {
        this.disableAfterPaintOptimization = disableAfterPaintOptimization;
    }
    getShouldDisableAfterPaintOptimization() {
        return this.isEditExperience && this.disableAfterPaintOptimization;
    }
    constructor(){
        this.isEditExperience = false;
        this.disableAfterPaintOptimization = false;
    }
}

});

parcelRegister("94W4R", function(module, exports) {

$parcel$export(module.exports, "SSRDisableHydrationRecorder", () => $8aab8665d4c8703d$export$e8dd0ad35d70f9f0);
class $8aab8665d4c8703d$export$e8dd0ad35d70f9f0 {
    setDisableHydration(disable) {
        this.disableHydration = disable;
    }
    getDisableHydration() {
        return this.disableHydration;
    }
    constructor(){
        this.disableHydration = void 0;
        this.disableHydration = false;
    }
}

});

parcelRegister("etu7G", function(module, exports) {

$parcel$export(module.exports, "SSRPermissionsErrorHandler", () => $c6d83b8df27b1c26$export$e70f491dc46ba2ed);
class $c6d83b8df27b1c26$export$e70f491dc46ba2ed {
    markSSRPreloadPermissionError(route, error) {
        this.hasSSRPreloadPermissionsErrorForRoute = route;
        if (error) this.errorType = error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
    }
    getRestrictedRoute() {
        return this.hasSSRPreloadPermissionsErrorForRoute || window.__SSR_RESTRICTED_PAGE__?.route || null;
    }
    getErrorType() {
        return this.errorType || window.__SSR_RESTRICTED_PAGE__?.errorType || null;
    }
    constructor(){
        this.hasSSRPreloadPermissionsErrorForRoute = void 0;
        this.errorType = void 0;
        this.hasSSRPreloadPermissionsErrorForRoute = null;
        this.errorType = null;
    }
}

});

parcelRegister("j8UzL", function(module, exports) {

$parcel$export(module.exports, "SSRActionLoadingSpinner", () => $e6731c9a68711330$export$b4fb032ce7f990cd);
/* SSRActionLoadingSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $b1Jpy = parcelRequire("b1Jpy");

var $9hlns = parcelRequire("9hlns");

var $fT2ta = parcelRequire("fT2ta");

var $9wGTI = parcelRequire("9wGTI");

var $gEtAQ = parcelRequire("gEtAQ");
const $e6731c9a68711330$var$loadingSpinnerContainerStyles = null;
const $e6731c9a68711330$var$spinnerStyles = {
    flex: "_1e0c1txw",
    none: "_1e0cglyw"
};
const $e6731c9a68711330$var$isWhiteBoard = (href)=>/^\/wiki\/spaces\/[^\/]+\/whiteboard/.test(href);
const $e6731c9a68711330$var$isDatabase = (href)=>/^\/wiki\/spaces\/[^\/]+\/database/.test(href);
const $e6731c9a68711330$export$b4fb032ce7f990cd = ({ actionType: actionType, spinnerId: spinnerId, showSpinner: showSpinner, spinnerSize: spinnerSize = 'small', spinnerAppearance: spinnerAppearance, styleOverride: styleOverride })=>{
    const showSpinnerButton = Boolean(window.__SSR_EVENTS_CAPTURE__ && window.__SSR_EVENTS_CAPTURE__[`${actionType}`] || showSpinner);
    const mountTime = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(Date.now() % 860);
    const urlParams = new URLSearchParams(window.location.search);
    const hydrationParam = urlParams.has('FORCE_HYDRATE', '1');
    if ((0, $9wGTI.fg)('confluence_ssr_remove_action_button_clicks') || hydrationParam || ($e6731c9a68711330$var$isDatabase(window.location.pathname) || $e6731c9a68711330$var$isWhiteBoard(window.location.pathname)) && (0, $9wGTI.fg)('confluence_ssr_force_hydrate_db_wb') || (0, $gEtAQ.isHomePage)() && (0, $9wGTI.fg)('confluence_ssr_enable_hydration_home')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b1Jpy.default), {
        ignore: !showSpinnerButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-id": spinnerId,
        "data-testid": spinnerId,
        style: styleOverride,
        className: (0, $35pXk.default)([
            "_11c82smr _1bsbzwfg _4t3izwfg _1bah1h6o _4cvr1h6o",
            $e6731c9a68711330$var$spinnerStyles[showSpinnerButton ? 'flex' : 'none']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fT2ta.default), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
            size: spinnerSize,
            delay: -mountTime.current,
            appearance: spinnerAppearance,
            ...props,
            testId: `${spinnerId}-spinner`
        }))));
};

});
parcelRegister("b1Jpy", function(module, exports) {

$parcel$export(module.exports, "default", () => $23a47fcdab208eaa$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $90YwQ = parcelRequire("90YwQ");
function $23a47fcdab208eaa$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentContext = (0, $gwFzn.useContext)((0, $90YwQ.default));
    const ignoredInteractionContext = (0, $gwFzn.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: kids
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $90YwQ.default).Provider, {
        value: ignoredInteractionContext,
        children: kids
    });
}

});

parcelRegister("9hlns", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da242b485cc4514$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $90YwQ = parcelRequire("90YwQ");

var $h1S9Z = parcelRequire("h1S9Z");
function $3da242b485cc4514$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-inverse, #FFFFFF)";
}
const $3da242b485cc4514$var$rotate = null; /**
                      * There are three parts to the load in animation:
                      * 1. Fade in
                      * 2. Accelerated spin
                      * 3. Stretch the spinner line
                      */ 
const $3da242b485cc4514$var$loadIn = null;
const $3da242b485cc4514$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1eco _5sag9cwz _1pgl1ytf _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
}; /**
    * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
    * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
    * which makes things simpler than doing an `isServer` check or a `null` check.
    *
    * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
    */ 
const $3da242b485cc4514$var$useLayoutEffect = typeof window === 'undefined' ? (0, $gwFzn.useEffect) : (0, $gwFzn.useLayoutEffect); /**
                                                                                          * __Spinner__
                                                                                          *
                                                                                          * A spinner is an animated spinning icon that lets users know content is being loaded.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/spinner/examples)
                                                                                          * - [Code](https://atlassian.design/components/spinner/code)
                                                                                          * - [Usage](https://atlassian.design/components/spinner/usage)
                                                                                          */ 
const $3da242b485cc4514$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $h1S9Z.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $3da242b485cc4514$var$getStrokeColor(appearance);
    const context = (0, $gwFzn.useContext)((0, $90YwQ.default));
    $3da242b485cc4514$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]); /**
                                   * The Spinner animation uses a combination of two
                                   * css animations on two separate elements.
                                   */ 
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        /**
                * This span exists to off-load animations from the circle element,
                * which were causing performance issues (style recalculations)
                * on Safari and older versions of Chrome.
                *
                * This can be removed and styles placed back on the circle element once
                * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
                */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $35pXk.default)([
            $3da242b485cc4514$var$styles.wrapperStyles,
            $3da242b485cc4514$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $35pXk.default)([
                $3da242b485cc4514$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $35pXk.default)([
                    $3da242b485cc4514$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $3da242b485cc4514$export$2e2bcd8739ae039 = $3da242b485cc4514$var$Spinner;

});
parcelRegister("h1S9Z", function(module, exports) {

$parcel$export(module.exports, "presetSizes", () => $ecfb4828e95a67e7$export$4e9f1640bbe7a1a8);
const $ecfb4828e95a67e7$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("fT2ta", function(module, exports) {

$parcel$export(module.exports, "default", () => $e955c5befcdaf659$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gZTYb = parcelRequire("gZTYb");
const $e955c5befcdaf659$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $e955c5befcdaf659$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $e955c5befcdaf659$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gZTYb.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $e955c5befcdaf659$export$2e2bcd8739ae039 = $e955c5befcdaf659$var$FadeIn;

});
parcelRegister("gZTYb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0fcea6deeb8006c$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $7hpmn = parcelRequire("7hpmn");

var $4c48T = parcelRequire("4c48T");

var $jtTDB = parcelRequire("jtTDB");

var $g9Srd = parcelRequire("g9Srd");

var $bl9WW = parcelRequire("bl9WW");
const $a0fcea6deeb8006c$var$zoomIn = null;
const $a0fcea6deeb8006c$var$zoomOut = null;
const $a0fcea6deeb8006c$var$fadeIn = null;
const $a0fcea6deeb8006c$var$fadeOut = null;
const $a0fcea6deeb8006c$var$fadeInFromTop = null;
const $a0fcea6deeb8006c$var$fadeOutFromTop = null;
const $a0fcea6deeb8006c$var$fadeInFromLeft = null;
const $a0fcea6deeb8006c$var$fadeOutFromLeft = null;
const $a0fcea6deeb8006c$var$fadeInFromBottom = null;
const $a0fcea6deeb8006c$var$fadeOutFromBottom = null;
const $a0fcea6deeb8006c$var$fadeInFromRight = null;
const $a0fcea6deeb8006c$var$fadeOutFromRight = null;
const $a0fcea6deeb8006c$var$fadeInFromTopConstant = null;
const $a0fcea6deeb8006c$var$fadeOutFromTopConstant = null;
const $a0fcea6deeb8006c$var$fadeInFromLeftConstant = null;
const $a0fcea6deeb8006c$var$fadeOutFromLeftConstant = null;
const $a0fcea6deeb8006c$var$fadeInFromBottomConstant = null;
const $a0fcea6deeb8006c$var$fadeOutFromBottomConstant = null;
const $a0fcea6deeb8006c$var$fadeInFromRightConstant = null;
const $a0fcea6deeb8006c$var$fadeOutFromRightConstant = null;
const $a0fcea6deeb8006c$var$slideInFromTop = null;
const $a0fcea6deeb8006c$var$slideOutFromTop = null;
const $a0fcea6deeb8006c$var$slideInFromRight = null;
const $a0fcea6deeb8006c$var$slideOutFromRight = null;
const $a0fcea6deeb8006c$var$slideInFromBottom = null;
const $a0fcea6deeb8006c$var$slideOutFromBottom = null;
const $a0fcea6deeb8006c$var$slideInFromLeft = null;
const $a0fcea6deeb8006c$var$slideOutFromLeft = null;
const $a0fcea6deeb8006c$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $bl9WW.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $g9Srd.useExitingPersistence)();
    const setTimeout = (0, $jtTDB.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $gwFzn.useState)(appear);
    (0, $gwFzn.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
         // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        } /**
       * Updates relevant state.
       * Called when the animation is finished, or immediately with reduced motion.
       */ 
        const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion?.(state);
        };
        if ((0, $7hpmn.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        } // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true); // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $4c48T.exitingDurations)[duration] : (0, $4c48T.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        }; // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $35pXk.default)([
            (0, $35pXk.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $35pXk.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $35pXk.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $35pXk.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $35pXk.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $35pXk.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $35pXk.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $35pXk.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $35pXk.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $35pXk.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $35pXk.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $35pXk.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $35pXk.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $35pXk.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $35pXk.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $35pXk.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $35pXk.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $35pXk.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $35pXk.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $35pXk.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $35pXk.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $35pXk.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $35pXk.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $35pXk.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $35pXk.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $35pXk.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $35pXk.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $35pXk.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $35pXk.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $35pXk.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $35pXk.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $35pXk.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $35pXk.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $35pXk.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $35pXk.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $35pXk.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $35pXk.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $35pXk.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $35pXk.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $35pXk.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $35pXk.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $35pXk.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $35pXk.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $35pXk.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $35pXk.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
var $a0fcea6deeb8006c$export$2e2bcd8739ae039 = $a0fcea6deeb8006c$var$EnteringMotion;

});
parcelRegister("7hpmn", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", () => $e4514a84fb33dbe3$export$b7baf7667a68d87c);
$parcel$export(module.exports, "useIsReducedMotion", () => $e4514a84fb33dbe3$export$c537e63161742ce3);
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $e4514a84fb33dbe3$export$f0f789643ba5a83c);
$parcel$export(module.exports, "prefersReducedMotion", () => $e4514a84fb33dbe3$export$ff7706047246b98b);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");
const $e4514a84fb33dbe3$var$isMatchMediaAvailable = ()=>typeof window !== 'undefined' && 'matchMedia' in window;
const $e4514a84fb33dbe3$export$b7baf7667a68d87c = ()=>{
    if (!$e4514a84fb33dbe3$var$isMatchMediaAvailable()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};
const $e4514a84fb33dbe3$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $gwFzn.useState)($e4514a84fb33dbe3$export$b7baf7667a68d87c);
    (0, $gwFzn.useEffect)(()=>{
        if (!$e4514a84fb33dbe3$var$isMatchMediaAvailable()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $d8F95.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
const $e4514a84fb33dbe3$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
const $e4514a84fb33dbe3$export$ff7706047246b98b = ()=>$e4514a84fb33dbe3$export$f0f789643ba5a83c;

});

parcelRegister("4c48T", function(module, exports) {

$parcel$export(module.exports, "durations", () => $84a6236c125dbba8$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $84a6236c125dbba8$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $84a6236c125dbba8$export$368bacef0dacbe05 = 25;
const $84a6236c125dbba8$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $84a6236c125dbba8$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $84a6236c125dbba8$export$30fa1a2e62ae150c = {
    none: $84a6236c125dbba8$export$38b928a7167ce124.none,
    small: $84a6236c125dbba8$export$38b928a7167ce124.small * $84a6236c125dbba8$var$EXITING_MOTION_MULTIPLIER,
    medium: $84a6236c125dbba8$export$38b928a7167ce124.medium * $84a6236c125dbba8$var$EXITING_MOTION_MULTIPLIER,
    large: $84a6236c125dbba8$export$38b928a7167ce124.large * $84a6236c125dbba8$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("jtTDB", function(module, exports) {

$parcel$export(module.exports, "useRequestAnimationFrame", () => $4547f72065f13ecd$export$1775f27e7c8051ca);
$parcel$export(module.exports, "useSetTimeout", () => $4547f72065f13ecd$export$4f34107a2b00f39c);

var $gwFzn = parcelRequire("gwFzn");
const $4547f72065f13ecd$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $4547f72065f13ecd$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $gwFzn.useRef)([]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $4547f72065f13ecd$var$getHookDeps(opts));
    return (0, $gwFzn.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
const $4547f72065f13ecd$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $gwFzn.useRef)([]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $4547f72065f13ecd$var$getHookDeps(opts));
    return (0, $gwFzn.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("g9Srd", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", () => $5f2ebc72f672914d$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $5f2ebc72f672914d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
// We define empty context here so the object doesn't change.
const $5f2ebc72f672914d$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ const $5f2ebc72f672914d$var$ExitingContext = /*#__PURE__*/ (0, $gwFzn.createContext)($5f2ebc72f672914d$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $5f2ebc72f672914d$var$wrapChildWithContextProvider = (child, value = $5f2ebc72f672914d$var$emptyContext)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($5f2ebc72f672914d$var$ExitingContext.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $5f2ebc72f672914d$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $gwFzn.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $5f2ebc72f672914d$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $5f2ebc72f672914d$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $5f2ebc72f672914d$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $5f2ebc72f672914d$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $5f2ebc72f672914d$var$ExitingPersistence = /*#__PURE__*/ (0, $gwFzn.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $gwFzn.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $gwFzn.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $gwFzn.useState)(()=>({
            appear: appear,
            isExiting: false
        }));
    (0, $gwFzn.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
		 * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
		 * useState is mocked to return a boolean value.
		 */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $5f2ebc72f672914d$var$childrenToArray(previousChildren);
    const current = $5f2ebc72f672914d$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    const missingKeys = $5f2ebc72f672914d$var$getMissingKeys(current, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $5f2ebc72f672914d$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        return $5f2ebc72f672914d$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$5f2ebc72f672914d$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
const $5f2ebc72f672914d$export$3b6f38abbdcbd000 = ()=>{
    return (0, $gwFzn.useContext)($5f2ebc72f672914d$var$ExitingContext);
};
$5f2ebc72f672914d$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $5f2ebc72f672914d$export$2e2bcd8739ae039 = $5f2ebc72f672914d$var$ExitingPersistence;

});

parcelRegister("bl9WW", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", () => $044d9e84371c83c1$export$25c7213fc07ec080);
$parcel$export(module.exports, "default", () => $044d9e84371c83c1$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");

var $dclyF = parcelRequire("dclyF");

var $9c5Jt = parcelRequire("9c5Jt");
const $044d9e84371c83c1$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $gwFzn.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $ee7An.default)
    }));
const $044d9e84371c83c1$export$25c7213fc07ec080 = ()=>{
    const indentifier = (0, $9c5Jt.useUniqueId)();
    const context = (0, $gwFzn.useContext)($044d9e84371c83c1$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $044d9e84371c83c1$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $gwFzn.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $gwFzn.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($044d9e84371c83c1$var$StaggeredEntranceContext.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
var $044d9e84371c83c1$export$2e2bcd8739ae039 = $044d9e84371c83c1$var$StaggeredEntrance;

});
parcelRegister("ee7An", function(module, exports) {

$parcel$export(module.exports, "default", () => $84d1a8298454c0b5$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $84d1a8298454c0b5$export$2e2bcd8739ae039() {}

});

parcelRegister("dclyF", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $fb461de404a34100$export$e5c5a5f917a5871c);

var $gwFzn = parcelRequire("gwFzn");
const $fb461de404a34100$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $gwFzn.useEffect) : (0, $gwFzn.useLayoutEffect);

});

parcelRegister("9c5Jt", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", () => $c56773c239eec070$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $gwFzn = parcelRequire("gwFzn");
function $c56773c239eec070$export$c485849f2e393253() {
    const identifier = (0, $gwFzn.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("gEtAQ", function(module, exports) {

$parcel$export(module.exports, "isViewPage", () => $b5832a8b6d0203e7$export$d9797e3a42403d0f);
$parcel$export(module.exports, "isBlogPage", () => $b5832a8b6d0203e7$export$b6ab121b23baa35);
$parcel$export(module.exports, "isHomePage", () => $b5832a8b6d0203e7$export$99418391c9d4edd1);
$parcel$export(module.exports, "isSpaceOverview", () => $b5832a8b6d0203e7$export$3ea67fa37c59fc23);
$parcel$export(module.exports, "isDatabase", () => $b5832a8b6d0203e7$export$ea39914fa18450ef);
$parcel$export(module.exports, "isWhiteboard", () => $b5832a8b6d0203e7$export$3a15fff847513284);
$parcel$export(module.exports, "isEditPage", () => $b5832a8b6d0203e7$export$49ce8db5bd2e4087);

var $1NBp8 = parcelRequire("1NBp8");
const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = ()=>Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3a15fff847513284 = ()=>Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};

});


parcelRegister("8Hqv7", function(module, exports) {

$parcel$export(module.exports, "FullCycleRender", () => $6f5a0d3cf76b2edb$export$31f6ed9cad4c2da0);

var $gwFzn = parcelRequire("gwFzn");

var $7koGn = parcelRequire("7koGn");
function $6f5a0d3cf76b2edb$var$createFullCycleRenderRegistry() {
    const registry = new Set();
    function register(callback) {
        registry.add(callback);
    }
    function unregister(callback) {
        registry.delete(callback);
    }
    function notifyRenderComplete() {
        registry.forEach((callback)=>callback());
    }
    return {
        register: register,
        unregister: unregister,
        notifyRenderComplete: notifyRenderComplete
    };
}
const $6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac = $6f5a0d3cf76b2edb$var$createFullCycleRenderRegistry();
const $6f5a0d3cf76b2edb$export$31f6ed9cad4c2da0 = ({ name: name, children: children })=>{
    const fullCycleSSRState = window.__FULLCYCLE_SSR__;
    const containerRef = (0, $gwFzn.useRef)(null);
    const onFullCycleRenderComplete = (0, $gwFzn.useCallback)(()=>{
        if (containerRef.current && fullCycleSSRState) {
            const html = (0, $7koGn.sanitizeInputLoadablesForSSR)(containerRef.current.innerHTML);
            fullCycleSSRState.htmlOutput[name] = html;
        }
    }, [
        name,
        fullCycleSSRState
    ]);
    (0, $gwFzn.useEffect)(()=>{
        $6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac.register(onFullCycleRenderComplete);
        return ()=>$6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac.unregister(onFullCycleRenderComplete);
    }, [
        onFullCycleRenderComplete
    ]);
    return null;
};

});
parcelRegister("7koGn", function(module, exports) {

$parcel$export(module.exports, "sanitizeInputLoadablesForSSR", () => $a4af1bafcd952bf9$export$7400f7b8afb970c2);
const $a4af1bafcd952bf9$var$MARKER_REGEX = /<input(?:\s?type="hidden")? data-loadable-(begin|end)="([^"]*)"(?:\sdata-ssr-placeholder-id="([^"]*)")?(?:\sdata-debug-name="([^"]*)")?\s*?(?:\s?type="hidden")?\s*>(?!\s*<\/input>)/g;
function $a4af1bafcd952bf9$export$7400f7b8afb970c2(html) {
    return html.replace($a4af1bafcd952bf9$var$MARKER_REGEX, (inputTag)=>{
        return `${inputTag.slice(0, -1)} />`;
    });
}

});


parcelRegister("5Abqh", function(module, exports) {

$parcel$export(module.exports, "SSR_PARTIAL_COMPONENT", () => $dbe1faed53254825$export$816adaed6346a011);
$parcel$export(module.exports, "setSSRPartialSuccess", () => $dbe1faed53254825$export$c248d402f991de43);
$parcel$export(module.exports, "SetSSRPartialSuccess", () => $dbe1faed53254825$export$f2067e89b3060d54);
$parcel$export(module.exports, "checkSSRPartialSuccess", () => $dbe1faed53254825$export$333ae8817a24741a);
const $dbe1faed53254825$export$816adaed6346a011 = {
    AdminAnnouncementBanner: 'AdminAnnouncementBanner',
    PageTree: 'PageTree',
    AnalyticsByLine: 'AnalyticsByLine'
};
let $dbe1faed53254825$var$ssrPartialSuccess = null;
function $dbe1faed53254825$export$c248d402f991de43(name) {}
const $dbe1faed53254825$export$f2067e89b3060d54 = ({ name: name })=>{
    $dbe1faed53254825$export$c248d402f991de43(name);
    return null;
};
function $dbe1faed53254825$export$333ae8817a24741a(name) {
    if (!$dbe1faed53254825$var$ssrPartialSuccess) $dbe1faed53254825$var$ssrPartialSuccess = window.__SSR_PARTIAL_SUCCESS__ || {};
    return Boolean($dbe1faed53254825$var$ssrPartialSuccess[name]);
}
function $dbe1faed53254825$export$afda26353a9720a7() {
    return $dbe1faed53254825$var$ssrPartialSuccess;
}
function $dbe1faed53254825$export$dc2046fd74b6895c() {
    $dbe1faed53254825$var$ssrPartialSuccess = null;
}

});

parcelRegister("e4o8D", function(module, exports) {

$parcel$export(module.exports, "useRenderServerPlaceholder", () => $2679ebd914f0a083$export$96e8e9e8e57310bb);

var $gwFzn = parcelRequire("gwFzn");
const $2679ebd914f0a083$export$96e8e9e8e57310bb = (renderServerPlaceholderOnNonHydrate = false)=>{
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $gwFzn.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    (0, $gwFzn.useEffect)(()=>{
        setRenderServerPlaceholder(false);
    }, []);
    return renderServerPlaceholder;
};

});

parcelRegister("dtDUi", function(module, exports) {

$parcel$export(module.exports, "matchHydrationError", () => $dab54f7f733e6dc2$export$5796b97ecb5a412);
$parcel$export(module.exports, "getHydrationErrorWithRoute", () => $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2);

var $64KID = parcelRequire("64KID");

var $fMEnQ = parcelRequire("fMEnQ");
const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return new Error(`Hydration failed on route ${match?.name}`);
};

});


parcelRegister("4icxs", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", () => $1ea4a2d7bbefbd1e$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $1ea4a2d7bbefbd1e$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $1ea4a2d7bbefbd1e$export$e673f367da2ff23e);

var $1vDIt = parcelRequire("1vDIt");

var $a9dFP = parcelRequire("a9dFP");

var $jf7dC = parcelRequire("jf7dC");
function $1ea4a2d7bbefbd1e$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $jf7dC.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $a9dFP.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $a9dFP.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $1ea4a2d7bbefbd1e$export$e7ae172320e03461(sizeThreshold) {
    const styleTags = [
        ...Array.from(document.head.querySelectorAll(`style[${(0, $a9dFP.CUSTOM_THEME_ATTRIBUTE)}][${(0, $a9dFP.THEME_DATA_ATTRIBUTE)}]`))
    ];
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach((element)=>element.remove());
}
function $1ea4a2d7bbefbd1e$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce((acc, [key, value])=>{
        const cssVar = (0, $1vDIt.default)[key];
        return cssVar ? `${acc}\n  ${cssVar}: ${typeof value === 'string' ? value : themeRamp[value]};` : acc;
    }, '');
}

});
parcelRegister("1vDIt", function(module, exports) {

$parcel$export(module.exports, "default", () => $da652f7b9238bbc8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02412877f3dbfda4dbaee7a917f24b6c>>
 * @codegenCommand yarn build tokens
 */ const $da652f7b9238bbc8$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body'
};
var $da652f7b9238bbc8$export$2e2bcd8739ae039 = $da652f7b9238bbc8$var$tokens;

});


parcelRegister("jLfE2", function(module, exports) {

$parcel$export(module.exports, "initializePreloaderFnContext", () => $576d616caa654774$export$4facd4e9bac676da);
$parcel$export(module.exports, "getPreloaderFnContext", () => $576d616caa654774$export$54288b855f86de9e);

var $ge2sX = parcelRequire("ge2sX");

var $gmyMX = parcelRequire("gmyMX");

var $7rje0 = parcelRequire("7rje0");
function $576d616caa654774$var$sessionDataLikeToPreloadFnContext(data) {
    return {
        isLoggedIn: Boolean(data.isLoggedIn),
        isLicensed: Boolean(data.isLicensed),
        accessStatus: data.accessStatus || null,
        userId: data.userId || null,
        cloudId: data.cloudId || '',
        orgId: data.orgId,
        featureFlags: data.featureFlags || {},
        edition: data.edition || null,
        activationId: data.activationId || '',
        environment: data.environment || 'PRODUCTION',
        // Note: the locale from session data is not standard aa-AA format. It is aa_AA
        locale: data.locale?.replace('_', '-') || 'en-US',
        isAdminHubAIEnabled: Boolean(data.isAdminHubAIEnabled),
        isRovoEnabled: Boolean(data.isRovoEnabled),
        isRovoLLMEnabled: Boolean(data.isRovoLLMEnabled)
    };
}
let $576d616caa654774$var$resolveContext = (_)=>{};
const $576d616caa654774$var$contextPromise = new Promise((resolve)=>$576d616caa654774$var$resolveContext = resolve);
async function $576d616caa654774$export$4facd4e9bac676da(contextCreatedFromSSRApp = null) {
    if (contextCreatedFromSSRApp) return $576d616caa654774$var$resolveContext($576d616caa654774$var$sessionDataLikeToPreloadFnContext(contextCreatedFromSSRApp));
    const [sessionData, statsigBootstrapData] = await Promise.all([
        (0, $ge2sX.getSessionData)(),
        (0, $7rje0.getStatsigBootstrap)()
    ]);
    const { userId: userId, cloudId: cloudId, environment: environment } = sessionData;
    const { clientSdkKey: clientSdkKey, experimentValues: experimentValues, configCollectionValues: configCollectionValues } = statsigBootstrapData || {};
    await (0, $gmyMX.initializeClientFromValues)({
        clientSdkKey: clientSdkKey,
        experimentValues: experimentValues,
        configCollectionValues: configCollectionValues,
        identifiers: {
            userId: userId,
            tenantId: cloudId
        },
        environment: environment
    });
    // Please do NOT add random field to the return result of context object.
    // Because when rendering on the server-side.
    // cc-frontend-ssr will provide these values so we can avoid a round trip before requesting the actual queries.
    // It is VERY critical that every value returned by the getContext callback can be derived from cc-frontend-ssr service without querying graphql.
    // Please consult developers in #cc-fe-performance when changing this function
    // Also, when updating this function you MUST update the preloadQueryBasedOnRoute call in @confluence/ssr-app
    $576d616caa654774$var$resolveContext($576d616caa654774$var$sessionDataLikeToPreloadFnContext(sessionData));
}
async function $576d616caa654774$export$54288b855f86de9e() {
    return $576d616caa654774$var$contextPromise;
}

});
parcelRegister("gmyMX", function(module, exports) {

$parcel$export(module.exports, "initializeClientFromValues", () => $346d869f4696e20b$export$a62a6a16b93dc541);

var $c6GJD = parcelRequire("c6GJD");
var $7OROP = parcelRequire("7OROP");

var $5ZqQS = parcelRequire("5ZqQS");

var $ieuOH = parcelRequire("ieuOH");

var $4VJDS = parcelRequire("4VJDS");
// https://bitbucket.org/atlassian/feature-flag-service/src/a6adccc26a95818c8128c63e4eb817414793b3c2/src/main/resources/application.yml#lines-386
const $346d869f4696e20b$var$TARGET_APP = 'confluence_web';
async function $346d869f4696e20b$export$a62a6a16b93dc541({ experimentValues: experimentValues, clientSdkKey: clientSdkKey, identifiers: identifiers, environment: confluenceEnvironment, customAttributes: customAttributes, configCollectionValues: configCollectionValues, persistedStatsigOverrides: persistedStatsigOverrides }) {
    if ((0, $c6GJD.default).initializeCompleted()) return;
    const { userId: userId, tenantId: tenantId, orgId: orgId } = identifiers;
    if (clientSdkKey) window.__STATSIG_BOOTSTRAP__ = {
        experimentValues: experimentValues,
        clientSdkKey: clientSdkKey,
        configCollectionValues: configCollectionValues,
        persistedStatsigOverrides: persistedStatsigOverrides
    };
    try {
        await (0, $c6GJD.default).initializeFromValues({
            sdkKey: clientSdkKey,
            environment: (0, $ieuOH.getStatsigEnvironment)(confluenceEnvironment),
            targetApp: $346d869f4696e20b$var$TARGET_APP,
            perimeter: (0, (0, $7OROP.PerimeterType).COMMERCIAL)
        }, {
            atlassianAccountId: userId || undefined,
            tenantId: tenantId,
            atlassianOrgId: orgId
        }, customAttributes, experimentValues);
        // Initialize StatsigConfigurations after FeatureGates.initializeFromValues	so that
        // we can get the overrides from FeatureGates
        (0, $4VJDS.default).initializeFromValues(configCollectionValues || '{}');
        // apply persisted Statsig overrides if this is not an integration test site
        if (persistedStatsigOverrides && !(0, $4VJDS.default).isKillSwitchOn('confluence_ssr_apply_persisted_overrides_blocklist')) (0, $c6GJD.default).setOverrides(persistedStatsigOverrides);
    } catch (error) {
        if (error instanceof Error) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: 'statsig'
        });
    }
}

});
parcelRegister("ieuOH", function(module, exports) {

$parcel$export(module.exports, "getStatsigEnvironment", () => $3e63b9120b40dcf7$export$1652e838423b3090);

var $7OROP = parcelRequire("7OROP");
const $3e63b9120b40dcf7$export$1652e838423b3090 = (rawEnvironment)=>{
    let environment;
    switch(rawEnvironment){
        case 'PRODUCTION':
        case 'prod':
            environment = (0, $7OROP.FeatureGateEnvironment).Production;
            break;
        case 'STAGING':
        case 'staging':
            environment = (0, $7OROP.FeatureGateEnvironment).Staging;
            break;
        default:
            environment = (0, $7OROP.FeatureGateEnvironment).Development;
    }
    return environment;
};

});


parcelRegister("7rje0", function(module, exports) {

$parcel$export(module.exports, "getStatsigBootstrap", () => $dfa003841e3f68b1$export$cdb7b67d8153205f);

var $5ZqQS = parcelRequire("5ZqQS");

var $9WAeG = parcelRequire("9WAeG");

var $f7B1p = parcelRequire("f7B1p");

var $cgNzK = parcelRequire("cgNzK");

var $fmZ24 = parcelRequire("fmZ24");
const $dfa003841e3f68b1$export$cdb7b67d8153205f = async ()=>{
    // if we already have the promise or data return it
    if (window.__STATSIG_BOOTSTRAP__) return window.__STATSIG_BOOTSTRAP__;
    const URI = window['GLOBAL_APOLLO_CLIENT_URI'] || '/cgraphql';
    window.__STATSIG_BOOTSTRAP__ = (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:StatsigBootstrapQueryRaw', ()=>(0, $f7B1p.cfetch)(`${URI}?q=StatsigBootstrapQueryRaw`, (0, $cgNzK.constructCompatibleRequestInit)({
            method: 'POST',
            credentials: 'include',
            referrerPolicy: 'same-origin',
            headers: {
                'X-APOLLO-OPERATION-NAME': 'StatsigBootstrapQueryRaw',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                operationName: 'StatsigBootstrapQueryRaw',
                query: (0, $fmZ24.StatsigBootstrapQueryRaw)
            })
        })).then(async (res)=>{
            if (!res.ok) throw new Error(`Cannot load Statsig experiment values: ${res.statusText}`);
            const { data: data } = await res.json();
            window.__STATSIG_BOOTSTRAP__ = {
                ...JSON.parse(data.frontendExperimentsBootstrap?.value || '{}'),
                configCollectionValues: data.frontendDynamicConfigsBootstrap?.value || '{}'
            };
            return window.__STATSIG_BOOTSTRAP__;
        }).catch((e)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: 'statsig'
            });
            return undefined;
        }));
    return window.__STATSIG_BOOTSTRAP__;
};

});
parcelRegister("fmZ24", function(module, exports) {

$parcel$export(module.exports, "StatsigBootstrapQueryRaw", () => $057aa559b7818567$export$5e6acd8e03d0bdb4);
const $057aa559b7818567$export$5e6acd8e03d0bdb4 = `
  query StatsigBootstrapQueryRaw {
    frontendExperimentsBootstrap {
      value
    }
    frontendDynamicConfigsBootstrap {
      value
    }
  }
`;

});



parcelRegister("dYU3e", function(module, exports) {

$parcel$export(module.exports, "query", () => $48ba6fb41a85dc7e$export$2fa187e846a241c4);
$parcel$export(module.exports, "writeQuery", () => $48ba6fb41a85dc7e$export$eb834b3aa63d4199);

var $d2LG0 = parcelRequire("d2LG0");


var $7Lnfv = parcelRequire("7Lnfv");

var $jQ6FG = parcelRequire("jQ6FG");

var $3joiD = parcelRequire("3joiD");
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   * In component: query getQueryParamsAndSetFetchPolicyForNetworkOnlyQuery or getQueryPropsAndSetFetchPolicyForNetworkOnlyQuery
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT }) {
    if (!client) // Referencing to the client via global variable to avoid circular dependency
    // This should never happen and will be removed in the future
    return Promise.resolve((0, $7Lnfv.UNEXPECTED_RESPONSE));
    if (typeof query === 'string') // For backward compatibility. We shouldn't really doing this.
    query = (0, $d2LG0.default)(query);
    const name = (0, $7Lnfv.getOperationName)(query);
    const queryName = (0, $jQ6FG.getQueryName)(name, variables);
    let single = true;
    // If the query has already been preloaded with network only
    // Subsequent query with same name and variable should be done with cache-first to avoid duplicate network request
    (0, $3joiD.flagQueryPreloadedByNetworkOnly)(queryName, variables, fetchPolicy);
    const queryContext = {
        single: single,
        ...context
    };
    if (window.__SSR_REACT_STREAMING__) queryContext.preload = true;
    return client.query({
        query: query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    const client = options.client || window.GLOBAL_APOLLO_CLIENT;
    if (client) client.writeQuery(options);
}

});
parcelRegister("7Lnfv", function(module, exports) {

$parcel$export(module.exports, "UNEXPECTED_RESPONSE", () => $b5dd42974905c1cd$export$974b1060e58e0a3f);
$parcel$export(module.exports, "getOperationName", () => $b5dd42974905c1cd$export$41bca9dc6871dd4e);
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}

});

parcelRegister("jQ6FG", function(module, exports) {

$parcel$export(module.exports, "getQueryName", () => $c42fc28a75665357$export$1f99beb156766eb5);
function $c42fc28a75665357$export$1f99beb156766eb5(operationName, variables) {
    if (!operationName) return '';
    let name = operationName;
    if (operationName === 'WebItemLocationQuery' || operationName === 'WebPanelLocationQuery') name = `${operationName}:${variables?.location || (variables?.locations || []).join(',') || ''}`;
    return name.replace(/[^\-\.\w]/g, '_');
}

});

parcelRegister("3joiD", function(module, exports) {

$parcel$export(module.exports, "flagQueryPreloadedByNetworkOnly", () => $7bd333c4107e77c7$export$48f37ae0123d54a5);
$parcel$export(module.exports, "getQueryPropsAndSetFetchPolicyForNetworkOnlyQuery", () => $7bd333c4107e77c7$export$4fe9299564f25d28);
$parcel$export(module.exports, "getQueryParamsAndSetFetchPolicyForNetworkOnlyQuery", () => $7bd333c4107e77c7$export$419dbf8acbf3b9db);

var $7Lnfv = parcelRequire("7Lnfv");

var $jQ6FG = parcelRequire("jQ6FG");
const $7bd333c4107e77c7$var$QueryPreloadedWithNetworkOnly = new Set();
function $7bd333c4107e77c7$var$getKey(name, variables) {
    if (!variables) return name;
    const sortedVariables = Object.entries(variables).sort(([a], [b])=>a.localeCompare(b)).reduce((r, [k, v])=>({
            ...r,
            [k]: v
        }), {});
    return `${name}:${JSON.stringify(sortedVariables)}`;
}
function $7bd333c4107e77c7$export$48f37ae0123d54a5(name, variables, fetchPolicy) {
    const key = $7bd333c4107e77c7$var$getKey(name, variables);
    if (fetchPolicy === 'network-only') $7bd333c4107e77c7$var$QueryPreloadedWithNetworkOnly.add(key);
    else $7bd333c4107e77c7$var$QueryPreloadedWithNetworkOnly.delete(key);
}
function $7bd333c4107e77c7$export$4fe9299564f25d28(options) {
    const [query, queryOptions] = $7bd333c4107e77c7$export$419dbf8acbf3b9db(options);
    return {
        query: query,
        ...queryOptions
    };
}
function $7bd333c4107e77c7$export$419dbf8acbf3b9db(options) {
    const { query: query, ...queryOptions } = options;
    if (!query) return [
        query,
        queryOptions
    ];
    const { variables: variables = {}, fetchPolicy: fetchPolicy } = queryOptions;
    const name = (0, $7Lnfv.getOperationName)(query);
    const queryName = (0, $jQ6FG.getQueryName)(name, variables);
    const shouldUseCacheFirst = // If SSRed then the query has just been preloaded on server-side the data is fresh
    window.__SSR_RENDERED__ || // If we can ensure the query was preloaded with network-only then it is safe to read from cache
    $7bd333c4107e77c7$var$QueryPreloadedWithNetworkOnly.has($7bd333c4107e77c7$var$getKey(queryName, variables));
    return [
        query,
        {
            ...queryOptions,
            fetchPolicy: shouldUseCacheFirst ? 'cache-first' : fetchPolicy
        }
    ];
}

});


parcelRegister("4vyfK", function(module, exports) {

$parcel$export(module.exports, "preloadWebItemLocation", () => $2272f3d6a41ef128$export$8120ee10837c1dd);

var $dYU3e = parcelRequire("dYU3e");

var $fjiOd = parcelRequire("fjiOd");
function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null } = {}) {
    if (!contentId && spaceKey) return (0, $dYU3e.query)({
        query: (0, $fjiOd.WebItemLocationWithSpaceKeyQuery),
        variables: {
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            spaceKey: spaceKey,
            version: version
        }
    }).then(({ data: data })=>{
        if (data?.space?.homepageId) (0, $dYU3e.writeQuery)({
            query: (0, $fjiOd.WebItemLocationQuery),
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                contentId: data?.space?.homepageId,
                spaceKey: null,
                version: version
            },
            data: {
                webItemSections: data?.space?.homepageWebSections || []
            }
        });
    });
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    return (0, $dYU3e.query)({
        query: (0, $fjiOd.WebItemLocationQuery),
        variables: variables
    });
}

});
parcelRegister("fjiOd", function(module, exports) {

$parcel$export(module.exports, "WebItemLocationQuery", () => $78914c14925ace72$export$abf96c374bfacb58);
$parcel$export(module.exports, "WebItemLocationWithSpaceKeyQuery", () => $78914c14925ace72$export$c4b66d2db87918fa);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $78914c14925ace72$export$abf96c374bfacb58 = (0, $d2LG0.default)`query WebItemLocationQuery($location:String$locations:[String]$contentId:ID$spaceKey:String$version:Int){webItemSections(location:$location locations:$locations contentId:$contentId key:$spaceKey version:$version){id label cacheKey styleClass items{accessKey completeKey hasCondition id icon{height width path}params{key value}label moduleKey section styleClass tooltip url urlWithoutContextPath weight}}}`;
const $78914c14925ace72$export$c4b66d2db87918fa = (0, $d2LG0.default)`query WebItemLocationWithSpaceKeyQuery($location:String$locations:[String]$spaceKey:String$version:Int){space(key:$spaceKey){id homepageId homepageWebSections(location:$location locations:$locations version:$version){id label cacheKey styleClass items{accessKey completeKey hasCondition id icon{height width path}params{key value}label moduleKey section styleClass tooltip url urlWithoutContextPath weight}}}}`;

});


parcelRegister("e1GUi", function(module, exports) {

$parcel$export(module.exports, "SPAViewContextQuery", () => $18deabadb8e878e8$export$fa8235a62f4b5bcd);

var $d2LG0 = parcelRequire("d2LG0");
const $18deabadb8e878e8$export$fa8235a62f4b5bcd = (0, $d2LG0.default)`query SPAViewContextQuery{isSiteAdmin abTestCohorts experimentFeatures userCanCreateContent isNewUser confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}}tenant{cloudId}siteSettings{homepage{uri title}siteTitle showApplicationTitle frontCover{frontCoverState}companyHubName}siteDescription{logoUrl}currentConfluenceUser{isAnonymous}}`;

});

parcelRegister("a1A9A", function(module, exports) {

$parcel$export(module.exports, "OperationsQuery", () => $584545d3b04636eb$export$7ddbcd2882651055);

var $d2LG0 = parcelRequire("d2LG0");
const $584545d3b04636eb$export$7ddbcd2882651055 = (0, $d2LG0.default)`query OperationsQuery{siteOperations{userProfile application}}`;

});

parcelRegister("bUqLQ", function(module, exports) {

$parcel$export(module.exports, "FrontendResourceRenderQuery", () => $a50c782784c2bfae$export$d4f1513c33ce7d87);

var $d2LG0 = parcelRequire("d2LG0");
const $a50c782784c2bfae$export$d4f1513c33ce7d87 = (0, $d2LG0.default)`query FrontendResourceRenderQuery{internalFrontendResource{resourceList{type url attributes{key value}}}}`;

});

parcelRegister("dIouf", function(module, exports) {

$parcel$export(module.exports, "ErrorSectionMessage", () => $9814a6f1f63a2fb5$export$92fff8019d18eec1);
$parcel$export(module.exports, "ErrorBoundary", () => (parcelRequire("4PPzL")).ErrorBoundary);
$parcel$export(module.exports, "ErrorComponent", () => (parcelRequire("4PPzL")).ErrorComponent);
$parcel$export(module.exports, "KnownErrorBoundary", () => (parcelRequire("itsKb")).KnownErrorBoundary);
$parcel$export(module.exports, "isNotFoundError", () => (parcelRequire("f9jv7")).isNotFoundError);
$parcel$export(module.exports, "isStatusCodeError", () => (parcelRequire("aMcHK")).isStatusCodeError);
$parcel$export(module.exports, "getStatusCodeError", () => (parcelRequire("aMcHK")).getStatusCodeError);
$parcel$export(module.exports, "getStatusCode", () => (parcelRequire("aMcHK")).getStatusCode);
$parcel$export(module.exports, "isTooManyRequestsError", () => (parcelRequire("bFDX4")).isTooManyRequestsError);
$parcel$export(module.exports, "isUnauthenticatedError", () => (parcelRequire("7LI3Q")).isUnauthorizedError);
$parcel$export(module.exports, "isExpectedApolloError", () => (parcelRequire("95rLf")).isExpectedApolloError);
$parcel$export(module.exports, "isConfigMissingSpaceError", () => (parcelRequire("95rLf")).isConfigMissingSpaceError);
$parcel$export(module.exports, "isConfigUserPermissionError", () => (parcelRequire("95rLf")).isConfigUserPermissionError);
$parcel$export(module.exports, "isConfigSpacePermissionError", () => (parcelRequire("95rLf")).isConfigSpacePermissionError);
$parcel$export(module.exports, "isConfigDeletedSpaceError", () => (parcelRequire("95rLf")).isConfigDeletedSpaceError);
$parcel$export(module.exports, "UnauthorizedErrorBoundary", () => (parcelRequire("1uFM6")).UnauthorizedErrorBoundary);
$parcel$export(module.exports, "isUnauthorizedError", () => (parcelRequire("1uFM6")).isUnauthorizedError);
$parcel$export(module.exports, "withErrorBoundary", () => (parcelRequire("aJv6Q")).withErrorBoundary);
$parcel$export(module.exports, "withTransparentErrorBoundary", () => (parcelRequire("aJv6Q")).withTransparentErrorBoundary);
$parcel$export(module.exports, "TransparentErrorBoundary", () => (parcelRequire("hSqtY")).TransparentErrorBoundary);
$parcel$export(module.exports, "GenericErrorBoundary", () => (parcelRequire("eCryJ")).GenericErrorBoundary);
$parcel$export(module.exports, "AtlassianSupportLink", () => (parcelRequire("cqmCC")).AtlassianSupportLink);
$parcel$export(module.exports, "ATLASSIAN_SUPPORT_URL", () => (parcelRequire("cqmCC")).ATLASSIAN_SUPPORT_URL);
$parcel$export(module.exports, "Attribution", () => (parcelRequire("3IBnw")).Attribution);
$parcel$export(module.exports, "ErrorDisplay", () => (parcelRequire("b3j2Y")).ErrorDisplay);
$parcel$export(module.exports, "ErrorDetail", () => (parcelRequire("aQbeC")).ErrorDetail);

var $jmjWc = parcelRequire("jmjWc");

var $4PPzL = parcelRequire("4PPzL");

var $itsKb = parcelRequire("itsKb");

var $aMcHK = parcelRequire("aMcHK");
var $95rLf = parcelRequire("95rLf");
var $f9jv7 = parcelRequire("f9jv7");
var $bFDX4 = parcelRequire("bFDX4");
var $7LI3Q = parcelRequire("7LI3Q");

var $1uFM6 = parcelRequire("1uFM6");

var $aJv6Q = parcelRequire("aJv6Q");

var $hSqtY = parcelRequire("hSqtY");

var $eCryJ = parcelRequire("eCryJ");

var $cqmCC = parcelRequire("cqmCC");

var $3IBnw = parcelRequire("3IBnw");

var $b3j2Y = parcelRequire("b3j2Y");

var $aQbeC = parcelRequire("aQbeC");

const $9814a6f1f63a2fb5$export$92fff8019d18eec1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "szWnU",
    name: "ErrorSectionMessage",
    loader: async ()=>(await (parcelRequire("gIsqA"))).ErrorSectionMessage
});

});
parcelRegister("4PPzL", function(module, exports) {

$parcel$export(module.exports, "ErrorComponent", () => $334e323c22f82a8a$export$65db35c377fab04b);
$parcel$export(module.exports, "ErrorBoundary", () => $334e323c22f82a8a$export$e926676385687eaf);

var $gwFzn = parcelRequire("gwFzn");

var $fGzMp = parcelRequire("fGzMp");

var $lbti1 = parcelRequire("lbti1");

var $jmjWc = parcelRequire("jmjWc");

var $eCryJ = parcelRequire("eCryJ");

const $334e323c22f82a8a$export$65db35c377fab04b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8l8Kg",
    name: "ErrorComponent",
    loader: async ()=>(await (parcelRequire("6NgBh"))).ErrorComponent
});
const $334e323c22f82a8a$export$e926676385687eaf = ({ attribution: attribution, attributes: attributes, children: children, modal: modal })=>{
    const renderOnError = (0, $gwFzn.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($334e323c22f82a8a$export$65db35c377fab04b, {
            ...props,
            modal: modal
        }), [
        modal
    ]);
    const failExperiencesOnError = (0, $gwFzn.useCallback)((error)=>{
        if (error.name === 'ChunkLoadError') (0, $fGzMp.getExperienceTracker)().abort({
            reason: 'ChunkLoadErrorAbort'
        });
        // the error UI rendered by this component is scary enough for the user
        // to consider all experiences as failures (we prompt the user to contact support and stuff).
        // Session expiration check that you see here isn't excessive, as it is only
        // supposed to be temporary (while we are in the process of transitioning to better error
        // handling via ErrorDisplay components and the like).
        // Once that migration is complete, this failure will be __unconditional__.
        if (!(0, $lbti1.containsSessionExpiredError)(error)) (0, $fGzMp.getExperienceTracker)().fail({
            error: error,
            attributes: {
                ...attributes,
                errorAttribution: attribution
            }
        });
    }, [
        attributes,
        attribution
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: attribution,
        renderOnError: renderOnError,
        onError: failExperiencesOnError
    }, children);
};

});
parcelRegister("eCryJ", function(module, exports) {

$parcel$export(module.exports, "GenericErrorBoundary", () => $60cbc013ea7aa356$export$9e9b5b3f9c08ce57);
/* eslint-disable react/prop-types */ 
var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");

var $9x4nt = parcelRequire("9x4nt");

var $feexy = parcelRequire("feexy");

var $4u5NT = parcelRequire("4u5NT");

var $1AV5C = parcelRequire("1AV5C");

var $7Sm4c = parcelRequire("7Sm4c");

var $5ZqQS = parcelRequire("5ZqQS");
var $fJlJm = parcelRequire("fJlJm");

var $3QIlf = parcelRequire("3QIlf");

var $czbF6 = parcelRequire("czbF6");

var $e8r8Y = parcelRequire("e8r8Y");
/**
 * Implements as minial as possible a `Component` to allow
 * `GenericErrorBoundary` to be a function component.
 */ class $60cbc013ea7aa356$var$GenericErrorBoundaryComponent extends (0, $gwFzn.Component) {
    componentDidMount() {
        this.checkForAttributionError();
    }
    componentDidUpdate() {
        this.checkForAttributionError();
    }
    componentDidCatch(error, errorInfo) {
        this.props.onError(error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }
    checkForAttributionError() {}
    render() {
        const { attribution: attribution, children: children, renderOnError: RenderOnError } = this.props;
        return this.state && this.state.error && this.state.errorInfo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(RenderOnError, {
            attribution: attribution,
            error: this.state.error,
            errorInfo: this.state.errorInfo
        }) : children;
    }
}
function $60cbc013ea7aa356$export$9e9b5b3f9c08ce57(props) {
    const { children: children, onError: onError, renderOnError: RenderOnError } = props;
    const attribution = (0, $czbF6.useAttribution)(props.attribution);
    const ufoInteractionId = (0, $gwFzn.useContext)((0, $feexy.default));
    const ufoContext = (0, $gwFzn.useContext)((0, $9x4nt.default));
    const isKnownError = (0, $gwFzn.useContext)((0, $3QIlf.KnownErrorBoundaryContext));
    const handleError = (0, $gwFzn.useCallback)((error, errorInfo)=>{
        if (ufoInteractionId?.current && ufoContext?.labelStack) (0, $4u5NT.addError)(ufoInteractionId.current, `GenericErrorBoundary:${attribution}`, ufoContext.labelStack, error.name, error.message, error.stack);
        if (isKnownError && isKnownError(error)) throw error;
        (0, $fJlJm.setReactErrorAttributes)(error, {
            componentStack: errorInfo.componentStack ?? '',
            errorHashCode: $60cbc013ea7aa356$export$aee074596d734311(error, errorInfo)
        });
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) {
            // only report errors which haven't been marked as handled yet
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: attribution
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
        if (onError) onError(error, errorInfo);
    }, [
        attribution,
        isKnownError,
        onError,
        ufoInteractionId,
        ufoContext
    ]);
    const renderOnError = (0, $gwFzn.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(RenderOnError, props), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $czbF6.AttributionContext).Provider, {
        value: attribution
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($60cbc013ea7aa356$var$GenericErrorBoundaryComponent, {
        __boundaryMarker: true,
        attribution: attribution,
        onError: handleError,
        renderOnError: renderOnError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e8r8Y.IntlNextErrorBoundary), null, children)));
}
$60cbc013ea7aa356$export$9e9b5b3f9c08ce57.propTypes = {
    attribution: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    onError: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    renderOnError: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired
};
/**
 * Used to group errors containing a specified string under a stable hash
 * by providing a static input that always produces the same hash.
 *
 * ex. "Some error text to look for": "stableHashInputToEncode"
 *
 * IMPORTANT: Please use this functionality sparingly. If you do happen to add a new stable
 * hash input to this list, please document the generated hash code (ex. "g7s4p"), notify
 * the Counfluence Cloud support team of the new hash code, and consider adding it to
 * this document: https://hello.atlassian.net/wiki/spaces/~7012120740227026c440094e9900a280bba1c/pages/2918914324/Confluence+error+codes
 *
 * More context: https://product-fabric.atlassian.net/browse/PCC-3398
 */ const $60cbc013ea7aa356$var$stableHashMap = {
    'Minified React error #301': 'React error #301'
};
function $60cbc013ea7aa356$export$aee074596d734311(error, errorInfo) {
    let bytes = [];
    const stableHashInputKey = Object.keys($60cbc013ea7aa356$var$stableHashMap).find((errorText)=>`${error.message || String(error)}`.includes(errorText));
    if (stableHashInputKey) {
        // if the error matches one of the errors listed in the stableHashMap, produce a stable hash
        const stableHashInput = $60cbc013ea7aa356$var$stableHashMap[stableHashInputKey];
        bytes = (0, $1AV5C.hashDataAsByte)(stableHashInput);
    } else // otherwise hash using the message & component stack
    bytes = (0, $1AV5C.hashDataAsByte)(`${error.message || String(error)}${errorInfo.componentStack}`);
    return(// the bitwise operations are expected below
    /* eslint-disable no-bitwise */ ((bytes[0] & 0xff | (bytes[1] & 0xff) << 8 | (bytes[2] & 0xff) << 16 | (bytes[3] & 0xff) << 24) & /* eslint-enable no-bitwise */ 0x3fffffff).toString(32 /* 5 bits per character */ ));
}

});
parcelRegister("3QIlf", function(module, exports) {

$parcel$export(module.exports, "KnownErrorBoundaryContext", () => $dee474472bdb4825$export$6ae4df695e19c5);

var $gwFzn = parcelRequire("gwFzn");
const $dee474472bdb4825$export$6ae4df695e19c5 = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext(()=>false);
$dee474472bdb4825$export$6ae4df695e19c5.displayName = 'KnownErrorBoundaryContext';

});

parcelRegister("czbF6", function(module, exports) {

$parcel$export(module.exports, "AttributionContext", () => $d01e2abd0e062cfa$export$e0d764cccd459a26);
$parcel$export(module.exports, "useAttribution", () => $d01e2abd0e062cfa$export$46b870813daca3d4);

var $gwFzn = parcelRequire("gwFzn");

var $3IBnw = parcelRequire("3IBnw");
const $d01e2abd0e062cfa$export$e0d764cccd459a26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext('unknown');
$d01e2abd0e062cfa$export$e0d764cccd459a26.displayName = 'AttributionContext';
function $d01e2abd0e062cfa$export$46b870813daca3d4(attribution) {
    const inheritedAttribution = (0, $gwFzn.useContext)($d01e2abd0e062cfa$export$e0d764cccd459a26);
    return attribution === (0, $3IBnw.Attribution).INHERIT ? inheritedAttribution : attribution;
}

});
parcelRegister("3IBnw", function(module, exports) {

$parcel$export(module.exports, "Attribution", () => $c03205d5f10e46ff$export$c18a293673ef2524);
/**
 * What makes a good attribution? The answer is vertical name. While having an
 * attribution be other than your vertical name can be acceptable in certain
 * cases, the main purpose of attribution is to ensure the first responder is
 * picked correctly (e.g. on a team-by-team basis). In order to understand what
 * exact part of functionality is broken one would add experience tracking for
 * this functionality, not error boundary.
 */ var $c03205d5f10e46ff$export$c18a293673ef2524 = /*#__PURE__*/ function(Attribution) {
    Attribution["INHERIT"] = "inherit";
    //
    // Verticals:
    //
    // Not all attribution are using the enum due to circular dependency.
    // Check plain string `attribution: 'backbone'` or `attribution: 'backbone-` as well
    Attribution["BACKBONE"] = "backbone";
    Attribution["BETTER_TOGETHER"] = "better-together";
    Attribution["COLLABORATION"] = "collaboration";
    Attribution["DISCO"] = "disco";
    Attribution["DLP"] = "dlp";
    Attribution["ECOSYSTEM"] = "ecosystem";
    Attribution["VIRALITY"] = "virality";
    Attribution["EXTERNAL_COLLAB"] = "external-collaboration";
    Attribution["GROWTH"] = "growth";
    Attribution["GROWTH_LUNA"] = "growth-luna";
    Attribution["GROWTH_MULTIPLIERS"] = "growth-multipliers";
    Attribution["GROWTH_STARBURST"] = "growth-starburst";
    Attribution["GROWTH_TRANSMUTERS"] = "growth-transmuters";
    Attribution["GROWTH_TRAILBLAZERS"] = "growth-traiblazers";
    Attribution["FLYWHEEL_ACTIVATION"] = "flywheel-activation";
    Attribution["FLYWHEEL_ADOPTION"] = "flywheel-adoption";
    Attribution["NAVX"] = "navx";
    Attribution["COMPANY_HUB"] = "company-hub";
    Attribution["TAILORED_EXPERIENCES"] = "tailored-experiences";
    Attribution["SMARTS"] = "smarts";
    Attribution["CC_ANALYTICS"] = "cc-analytics";
    Attribution["ECONOMY"] = "economy";
    Attribution["CONTENT_TYPES"] = "content-types";
    Attribution["CONTENPLATES"] = "contenplates";
    Attribution["AI_MATE"] = "ai-mate";
    Attribution["KNOWLEDGE_DISCOVERY"] = "knowledge-discovery";
    Attribution["STATSIG"] = "statsig";
    Attribution["AUTOMATION_FOR_CONFLUENCE"] = "automation-for-confluence";
    Attribution["PERMISSIONS_EXPERIENCE"] = "permissions-experience";
    Attribution["WHITEBOARDS"] = "whiteboards";
    Attribution["DATABASES"] = "databases";
    Attribution["ADMIN_EXPERIENCE"] = "admin-experience";
    Attribution["PAGE_EXPERIENCES"] = "page-experiences";
    Attribution["PAGE_EXTENSIONS"] = "page-extensions";
    Attribution["NOTIFICATIONS"] = "cc-notifications";
    Attribution["PAGE_MODES"] = "page-modes";
    Attribution["POST_OFFICE"] = "post-office";
    Attribution["COMMENTS"] = "comments";
    Attribution["TOPICS"] = "topics";
    Attribution["CC_INSIGHTS_AND_REPORTING"] = "cc-insights-and-reporting";
    Attribution["MIGRATIONS"] = "migrations";
    Attribution["CC_EDITOR_CORE_EXPERIENCES"] = "cc-editor-core-experiences";
    Attribution["EDITOR_CORE"] = "editor-core";
    Attribution["COLLABORATION_PRESENCE"] = "collaboration-presence";
    return Attribution;
}({});

});


parcelRegister("e8r8Y", function(module, exports) {

$parcel$export(module.exports, "IntlNextErrorBoundary", () => $f3487e06591b6bc9$export$e57b625af5985ba6);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");
parcelRequire("bLJr5");
var $d4U2f = parcelRequire("d4U2f");

const $f3487e06591b6bc9$export$1b0d5999522d82d7 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "zalc1",
    name: "IntlNextProvider",
    loader: async ()=>(await Promise.resolve((parcelRequire("2nPZH")))).IntlProvider
});
const $f3487e06591b6bc9$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $f3487e06591b6bc9$export$e57b625af5985ba6 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidCatch(error) {
        // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state?.missingIntlProviderInAncestry) {
            const { locale: locale, messages: messages } = (0, $d4U2f.getTranslation)();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f3487e06591b6bc9$export$1b0d5999522d82d7, {
                key: locale,
                "data-test-language": locale,
                locale: locale,
                defaultLocale: (0, $d4U2f.DEFAULT_LOCALE),
                messages: messages,
                textComponent: "span"
            }, this.props.children);
        }
        return this.props.children;
    }
}

});


parcelRegister("6NgBh", function(module, exports) {

let $4f2432298a6dccd6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4f2432298a6dccd6$var$load("i5EJc").then(()=>parcelRequire('fBcAl'));

});


parcelRegister("itsKb", function(module, exports) {

$parcel$export(module.exports, "KnownErrorBoundary", () => $51acce01cca937d7$export$a6c66dc6b08c87fe);

var $gwFzn = parcelRequire("gwFzn");

var $3QIlf = parcelRequire("3QIlf");
class $51acce01cca937d7$export$a6c66dc6b08c87fe extends (0, $gwFzn.Component) {
    componentDidCatch(error) {
        if (this.props.isKnownError(error)) {
            this.props.onError?.(error);
            this.setState({
                error: error
            });
        } else throw error;
    }
    render() {
        const { error: error } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3QIlf.KnownErrorBoundaryContext).Consumer, null, (willCatch)=>{
            this.willParentCatch = willCatch;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3QIlf.KnownErrorBoundaryContext).Provider, {
                value: this.willCatch
            }, error ? this.props.renderOnError(error) : this.props.children);
        });
    }
    constructor(...args){
        super(...args);
        this.willParentCatch = void 0;
        this.state = {
            error: null
        };
        this.willCatch = (error)=>Boolean(this.props.isKnownError(error) || this.willParentCatch?.(error));
    }
}

});

parcelRegister("aMcHK", function(module, exports) {

$parcel$export(module.exports, "isStatusCodeError", () => $c1983a57b72eb5dc$export$93aea9a3d680252e);
$parcel$export(module.exports, "getStatusCodeError", () => $c1983a57b72eb5dc$export$4b7f1fcb987c29b8);
$parcel$export(module.exports, "getStatusCode", () => $c1983a57b72eb5dc$export$68868794c9b58e55);

var $aTqya = parcelRequire("aTqya");
function $c1983a57b72eb5dc$export$93aea9a3d680252e(error, statusCode, statusCodeAlternative) {
    if (error) {
        if ((0, $aTqya.isApolloError)(error)) return error.graphQLErrors?.some((graphQLError)=>$c1983a57b72eb5dc$var$isStatusCodeNonApolloError(graphQLError, statusCode, statusCodeAlternative)) || $c1983a57b72eb5dc$var$isStatusCodeNonApolloError(error?.networkError, statusCode, statusCodeAlternative);
        return $c1983a57b72eb5dc$var$isStatusCodeNonApolloError(error, statusCode, statusCodeAlternative);
    }
    return false;
}
function $c1983a57b72eb5dc$export$4b7f1fcb987c29b8(error) {
    if (error) {
        if ((0, $aTqya.isApolloError)(error)) {
            for (const graphQLError of error?.graphQLErrors || []){
                const result = $c1983a57b72eb5dc$var$getStatusCodeNonApolloError(graphQLError);
                if (result) return result;
            }
            const networkErrorStatusCode = $c1983a57b72eb5dc$var$getStatusCodeNonApolloError(error?.networkError);
            if (networkErrorStatusCode) return networkErrorStatusCode;
        }
        return $c1983a57b72eb5dc$var$getStatusCodeNonApolloError(error);
    }
    return undefined;
}
function $c1983a57b72eb5dc$var$isStatusCodeNonApolloError(error, statusCode, statusCodeAlternative) {
    if (error) {
        if ($c1983a57b72eb5dc$export$68868794c9b58e55(error) === statusCode || statusCodeAlternative?.(error)) return true;
        const { originalError: originalError } = error;
        if (originalError) return $c1983a57b72eb5dc$export$93aea9a3d680252e(originalError, statusCode, statusCodeAlternative);
    }
    return false;
}
function $c1983a57b72eb5dc$var$getStatusCodeNonApolloError(error) {
    if (error) {
        const result = $c1983a57b72eb5dc$export$68868794c9b58e55(error);
        if (result) return result;
        const { originalError: originalError } = error;
        if (originalError) return $c1983a57b72eb5dc$export$68868794c9b58e55(originalError);
    }
    return undefined;
}
function $c1983a57b72eb5dc$export$68868794c9b58e55(error) {
    if (error) {
        let status = error?.response?.status;
        if (status == null) {
            const { extensions: extensions } = error;
            if (extensions) status = extensions.statusCode || extensions.http?.status;
        }
        // Coercing to string because backend is inconsistent in the response type,
        // both string and number have been seen in practice:
        return status?.toString();
    }
    return undefined;
}

});

parcelRegister("95rLf", function(module, exports) {

$parcel$export(module.exports, "isExpectedApolloError", () => $4470315d103298df$export$288e4801a340fb3c);
$parcel$export(module.exports, "isConfigMissingSpaceError", () => $4470315d103298df$export$6ce1d41e4cf63857);
$parcel$export(module.exports, "isConfigSpacePermissionError", () => $4470315d103298df$export$33c833057c8824dc);
$parcel$export(module.exports, "isConfigUserPermissionError", () => $4470315d103298df$export$76a44867d527fcf4);
$parcel$export(module.exports, "isConfigDeletedSpaceError", () => $4470315d103298df$export$fd9ba55aefe8e8a5);
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};

});

parcelRegister("f9jv7", function(module, exports) {

$parcel$export(module.exports, "isNotFoundError", () => $b29e4bf652226e80$export$6ccdb59d3479f4f1);

var $aMcHK = parcelRequire("aMcHK");
const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');

});

parcelRegister("bFDX4", function(module, exports) {

$parcel$export(module.exports, "isTooManyRequestsError", () => $8182af0d2f396edd$export$5df30e64c619846d);

var $aMcHK = parcelRequire("aMcHK");
const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');

});

parcelRegister("7LI3Q", function(module, exports) {

$parcel$export(module.exports, "isUnauthorizedError", () => $02289dc82bb02982$export$55152de1f925fd05);

var $aMcHK = parcelRequire("aMcHK");
const $02289dc82bb02982$export$55152de1f925fd05 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '401');

});

parcelRegister("1uFM6", function(module, exports) {

$parcel$export(module.exports, "UnauthorizedErrorBoundary", () => $3e715362d34c6fb3$export$616870549cbd985);
$parcel$export(module.exports, "isUnauthorizedError", () => $3e715362d34c6fb3$export$55152de1f925fd05);

var $gwFzn = parcelRequire("gwFzn");

var $aMcHK = parcelRequire("aMcHK");

var $itsKb = parcelRequire("itsKb");
const $3e715362d34c6fb3$export$616870549cbd985 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $itsKb.KnownErrorBoundary), {
        isKnownError: $3e715362d34c6fb3$export$55152de1f925fd05,
        ...props
    });
/**
 * https://pug.jira-dev.com/wiki/spaces/CCB/pages/4709260932/GraphQL+Errors+Contract+for+Status+Code+401+and+403
 */ const $3e715362d34c6fb3$var$isLegacyUnauthorizedGraphQLError = (error)=>error?.extensions?.data?.authorized === false;
const $3e715362d34c6fb3$export$55152de1f925fd05 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '403', $3e715362d34c6fb3$var$isLegacyUnauthorizedGraphQLError);

});

parcelRegister("aJv6Q", function(module, exports) {

$parcel$export(module.exports, "withErrorBoundary", () => $1d5814e83a6e1177$export$f0c7a449e0cfaec7);
$parcel$export(module.exports, "withTransparentErrorBoundary", () => $1d5814e83a6e1177$export$c5425be6daeb353e);

var $gwFzn = parcelRequire("gwFzn");

var $4PPzL = parcelRequire("4PPzL");

var $hSqtY = parcelRequire("hSqtY");
function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$var$withTypedErrorBoundary((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$var$withTypedErrorBoundary((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$var$withTypedErrorBoundary(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(WrappedComponent, wrappedProps));
    };
}

});
parcelRegister("hSqtY", function(module, exports) {

$parcel$export(module.exports, "TransparentErrorBoundary", () => $300d7a5b554da2b2$export$a457282dd80ca698);

var $gwFzn = parcelRequire("gwFzn");

var $eCryJ = parcelRequire("eCryJ");
const $300d7a5b554da2b2$var$NullErrorComponent = ()=>null;
const $300d7a5b554da2b2$export$a457282dd80ca698 = ({ attribution: attribution, children: children, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: attribution,
        renderOnError: $300d7a5b554da2b2$var$NullErrorComponent,
        onError: onError
    }, children);

});


parcelRegister("cqmCC", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_SUPPORT_URL", () => $1805b22ab5ce9c71$export$98c2bfe563916273);
$parcel$export(module.exports, "AtlassianSupportLink", () => $1805b22ab5ce9c71$export$f1bb9e069c7d2c);

var $jiJCD = parcelRequire("jiJCD");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
const $1805b22ab5ce9c71$export$98c2bfe563916273 = 'https://support.atlassian.com/contact/#/';
const $1805b22ab5ce9c71$var$getLinkText = (showHostname)=>showHostname ? (0, $jiJCD.parse)($1805b22ab5ce9c71$export$98c2bfe563916273).hostname : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "error-boundary.description.support-link",
        defaultMessage: "Atlassian Support"
    });
const $1805b22ab5ce9c71$export$f1bb9e069c7d2c = ({ showHostname: showHostname, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
        href: $1805b22ab5ce9c71$export$98c2bfe563916273,
        target: "_blank"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.count(children) ? children : $1805b22ab5ce9c71$var$getLinkText(showHostname));

});

parcelRegister("b3j2Y", function(module, exports) {

$parcel$export(module.exports, "ErrorDisplay", () => $ff81fbcf85bdaf85$export$d56b0569bceb92ae);

var $gwFzn = parcelRequire("gwFzn");

var $3IBnw = parcelRequire("3IBnw");

var $eCryJ = parcelRequire("eCryJ");
function $ff81fbcf85bdaf85$export$d56b0569bceb92ae({ children: children, error: error }) {
    const [errorListenerIsReady, setErrorListenerIsReady] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        const listener = (event)=>{
            if (event.error === error) // this way we're preventing React from showing an ugly message in the console
            // because the developer is doing everything right
            event.preventDefault();
        };
        window.addEventListener('error', listener);
        setErrorListenerIsReady(true);
        return ()=>{
            window.removeEventListener('error', listener);
            setErrorListenerIsReady(false);
        };
    }, [
        error,
        setErrorListenerIsReady
    ]);
    const renderOnError = (0, $gwFzn.useCallback)((_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children), [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INHERIT,
        renderOnError: renderOnError
    }, errorListenerIsReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ff81fbcf85bdaf85$export$4d51f41a5e7cc382, {
        error: error
    }) : null);
}
function $ff81fbcf85bdaf85$export$4d51f41a5e7cc382({ error: error }) {
    throw error;
}

});

parcelRegister("aQbeC", function(module, exports) {

$parcel$export(module.exports, "ErrorDetail", () => $ab3d7e6c3ad6ea9c$export$1b15b3abeb74ae7c);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $2Nwuj = parcelRequire("2Nwuj");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $lMdlY = parcelRequire("lMdlY");

var $fJlJm = parcelRequire("fJlJm");

var $9wGTI = parcelRequire("9wGTI");

var $cqmCC = parcelRequire("cqmCC");

var $d5QxR = parcelRequire("d5QxR");
const $ab3d7e6c3ad6ea9c$var$CONFLUENCE_STATUS_PAGE_URL = 'https://confluence.status.atlassian.com/';
const $ab3d7e6c3ad6ea9c$var$ERROR_COMPONENT_KB_ARTICLE_URL = 'https://confluence.atlassian.com/confkb/getting-we-ve-hit-a-snag-error-message-when-viewing-confluence-pages-1095238852.html';
const $ab3d7e6c3ad6ea9c$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    description: {
        id: "error-boundary.description",
        defaultMessage: "The issue should resolve on its own. In the meantime, you can check the <statuslink>status page</statuslink>. There may be a known incident reported related to <kblink>this error</kblink>. If it keeps happening, ask your admin to contact <supportlink>our support team</supportlink> and give them:"
    },
    status403Description: {
        id: "error-boundary.status.403.description",
        defaultMessage: "To resolve this, try reloading or reach out to your admin about getting access. You can also check the <statuslink>status page</statuslink> about a potential known incident related to this <kblink>error</kblink>. If it keeps happening, ask your admin to contact <supportlink>support</supportlink> and give them:"
    },
    errorHash: {
        id: "error-boundary.code",
        defaultMessage: "The code associated with this error: {code}"
    },
    errorHashInCodeBlock: {
        id: "error-boundary.code.in-code-block",
        defaultMessage: "Hash: {code}"
    },
    url: {
        id: "error-boundary.url",
        defaultMessage: "The URL of this page"
    },
    trace: {
        id: "error-boundary.trace",
        defaultMessage: "Trace: {traceId}"
    }
});
const $ab3d7e6c3ad6ea9c$var$codeBlockContainerStyles = (0, $ecnYn.xcss)({
    maxWidth: '330px'
});
function $ab3d7e6c3ad6ea9c$export$1b15b3abeb74ae7c({ error: error, isFullSizeErrorComponent: isFullSizeErrorComponent }) {
    const graphqlErrorAttributes = !!error ? (0, $fJlJm.getGraphqlErrorAttributes)(error) : undefined;
    const reactErrorAttributes = !!error ? (0, $fJlJm.getReactErrorAttributes)(error) : undefined;
    const experienceTraceContext = (0, $lMdlY.getActiveTrace)();
    const errorHashCode = reactErrorAttributes ? reactErrorAttributes.errorHashCode : undefined;
    const traceId = experienceTraceContext?.traceId ?? graphqlErrorAttributes?.traceId;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $dBxQj.default)();
    const codeBlockLines = (0, $gwFzn.useMemo)(()=>{
        const lines = [];
        if (errorHashCode) lines.push(intl.formatMessage($ab3d7e6c3ad6ea9c$export$a7357cdd1f0b0168.errorHashInCodeBlock, {
            code: errorHashCode
        }));
        if (traceId) lines.push(intl.formatMessage($ab3d7e6c3ad6ea9c$export$a7357cdd1f0b0168.trace, {
            traceId: traceId
        }));
        return lines;
    }, [
        intl,
        errorHashCode,
        traceId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_error_details')) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'errorDetail',
                attributes: {
                    errorHashCode: errorHashCode,
                    traceId: traceId
                }
            }
        })?.fire();
    }, [
        createAnalyticsEvent,
        errorHashCode,
        traceId
    ]);
    const i18nDescription = graphqlErrorAttributes?.statusCode === 403 ? $ab3d7e6c3ad6ea9c$export$a7357cdd1f0b0168.status403Description : $ab3d7e6c3ad6ea9c$export$a7357cdd1f0b0168.description;
    return codeBlockLines.length > 0 || !(0, $9wGTI.fg)('confluence_error_component_trace_updates') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...i18nDescription,
        tagName: "p",
        values: {
            supportlink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ab3d7e6c3ad6ea9c$export$8ab5c6f0105ebb52, {
                    url: (0, $cqmCC.ATLASSIAN_SUPPORT_URL),
                    chunks: chunks,
                    analyticsName: "supportLink"
                }),
            statuslink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ab3d7e6c3ad6ea9c$export$8ab5c6f0105ebb52, {
                    url: $ab3d7e6c3ad6ea9c$var$CONFLUENCE_STATUS_PAGE_URL,
                    chunks: chunks,
                    analyticsName: "statusPageLink"
                }),
            kblink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ab3d7e6c3ad6ea9c$export$8ab5c6f0105ebb52, {
                    url: $ab3d7e6c3ad6ea9c$var$ERROR_COMPONENT_KB_ARTICLE_URL,
                    chunks: chunks,
                    analyticsName: "knowledgebaseLink"
                })
        }
    }), (0, $9wGTI.fg)('confluence_error_component_trace_updates') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: isFullSizeErrorComponent && $ab3d7e6c3ad6ea9c$var$codeBlockContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d5QxR.CodeBlockWithCopyButton), {
        lines: codeBlockLines,
        analyticsSource: "errorDetail"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $ab3d7e6c3ad6ea9c$export$a7357cdd1f0b0168.url)), errorHashCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$ab3d7e6c3ad6ea9c$export$a7357cdd1f0b0168.errorHash,
        values: {
            code: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, errorHashCode || '')
        }
    })))) : null;
}
const $ab3d7e6c3ad6ea9c$export$8ab5c6f0105ebb52 = ({ url: url, chunks: chunks, analyticsName: analyticsName })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: analyticsName,
                source: 'errorDetail'
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
        href: url,
        target: "_blank",
        onClick: fireClickAnalytics
    }, chunks);
};

});
parcelRegister("2Nwuj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0412590977f134ac$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $1Whri = parcelRequire("1Whri");

var $dh538 = parcelRequire("dh538");

var $auNCB = parcelRequire("auNCB");
var $gdv5Z = parcelRequire("gdv5Z");
const $0412590977f134ac$var$styles = {
    visitedLink: "_ect41gqc _1053w7te _1ienw7te _n0fxw7te _1vhvg3x0",
    defaultAppearance: "_4bfu18uv _1hms8stv _ajmmnqa1 _syaz14q2 _ect41gqc _1a3b18uv _4fpr8stv _5goinqa1 _f8pj14q2 _9oik18uv _1bnxglyw _jf4cnqa1 _30l314q2 _1nrm18uv _c2waglyw _1iohnqa1 _9h8h16c2",
    subtleAppearance: "_4bfu18uv _1hmsglyw _ajmmnqa1 _ect41gqc _syaz1gjq _1a3b18uv _4fprglyw _5goinqa1 _f8pj1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt",
    inverseAppearance: "_4bfu18uv _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b18uv _4fpr8stv _5goinqa1 _f8pj15cr _9oik18uv _1bnxglyw _jf4cnqa1 _30l315cr _1nrm18uv _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n4jp4b _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)(appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $35pXk.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        className: (0, $35pXk.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $gwFzn.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;

});
parcelRegister("1Whri", function(module, exports) {

$parcel$export(module.exports, "cx", () => $bed9dac56d676fa5$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("gwFzn");

var $9ke3u = parcelRequire("9ke3u");
const { XCSSProp: $bed9dac56d676fa5$var$XCSSProp, css: $bed9dac56d676fa5$export$dbf350e5966cf602, cssMap: $bed9dac56d676fa5$export$eb1ecd84a24ee424, cx: $bed9dac56d676fa5$export$a274e22fb40f762e } = (0, $9ke3u.createStrictAPI)();

});

parcelRegister("auNCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f11abad57339aafd$export$2e2bcd8739ae039);
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ddbVR = parcelRequire("ddbVR");

var $5Uzw3 = parcelRequire("5Uzw3");

var $gxtzC = parcelRequire("gxtzC");

var $6i41U = parcelRequire("6i41U");

var $ee7An = parcelRequire("ee7An");

var $c0qxy = parcelRequire("c0qxy");

var $90YwQ = parcelRequire("90YwQ");

var $6F6hl = parcelRequire("6F6hl");

var $1HnpQ = parcelRequire("1HnpQ");
const $f11abad57339aafd$var$styles = {
    root: "_4bfu18uv _1hms8stv _ajmmnqa1 _vchhusvi"
};
const $f11abad57339aafd$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $f11abad57339aafd$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $f11abad57339aafd$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $ee7An.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $gwFzn.useContext)((0, $90YwQ.default));
    const handleClick = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $c0qxy.useId)();
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $6i41U.default)();
    const isExternal = typeof href === 'string' && $f11abad57339aafd$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $f11abad57339aafd$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $5Uzw3.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1HnpQ.default // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
    ), {
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $ddbVR.cx)($f11abad57339aafd$var$styles.root, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6F6hl.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $f11abad57339aafd$var$Anchor = /*#__PURE__*/ (0, $gwFzn.forwardRef)($f11abad57339aafd$var$AnchorNoRef);
var $f11abad57339aafd$export$2e2bcd8739ae039 = $f11abad57339aafd$var$Anchor;

});
parcelRegister("gxtzC", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $121bfbcfa071ca74$export$a4687b0234b40e28);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $fTXBo = parcelRequire("fTXBo");
function $121bfbcfa071ca74$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $fTXBo.useTrackedRef)(analyticsData);
    const fnRef = (0, $fTXBo.useTrackedRef)(fn);
    const handler = (0, $gwFzn.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("fTXBo", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", () => $9a0610f9508374ad$export$1d27a74659855e44);

var $gwFzn = parcelRequire("gwFzn");
const $9a0610f9508374ad$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $gwFzn.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("6i41U", function(module, exports) {

$parcel$export(module.exports, "default", () => $77954d5459a690cb$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $8x1Q3 = parcelRequire("8x1Q3");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $gwFzn.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;

});
parcelRegister("8x1Q3", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", () => $830764d8fffe9f5a$export$2931e0ee690eee88);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $gwFzn.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;

});


parcelRegister("c0qxy", function(module, exports) {

$parcel$export(module.exports, "useId", () => $1be93bb4d62cd6c7$export$f680877a34711e37);
$parcel$export(module.exports, "IdProvider", () => $1be93bb4d62cd6c7$export$6be90bcb437e928f);
$parcel$export(module.exports, "useIdSeed", () => $1be93bb4d62cd6c7$export$6ee17796e3d70de2);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kRbf2 = parcelRequire("kRbf2");

var $dh538 = parcelRequire("dh538");
// @ts-ignore - useId is not accessible in React 16
const $1be93bb4d62cd6c7$var$react18UseId = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useId ?? undefined;
function $1be93bb4d62cd6c7$export$f680877a34711e37() {
    if ($1be93bb4d62cd6c7$var$react18UseId && (0, $dh538.fg)('platform-dst-react-18-use-id')) return $1be93bb4d62cd6c7$var$react18UseId();
    return `uid${(0, $kRbf2.useUID)()}`;
}
const $1be93bb4d62cd6c7$export$6be90bcb437e928f = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${$1be93bb4d62cd6c7$export$f680877a34711e37()}${postfix}`;
    (0, $gwFzn.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
function $1be93bb4d62cd6c7$export$6ee17796e3d70de2() {
    if ($1be93bb4d62cd6c7$var$react18UseId && (0, $dh538.fg)('platform-dst-react-18-use-id')) {
        const uid = $1be93bb4d62cd6c7$var$react18UseId();
        return (id)=>`${uid}-${id.toString()}`;
    }
    return (0, $kRbf2.useUIDSeed)();
}

});

parcelRegister("6F6hl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5c5f50cde9c0a7a$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $c5c5f50cde9c0a7a$var$visuallyHiddenStyles = null; /**
                                    * __Visually hidden__
                                    *
                                    * A composable element to apply a visually hidden effect to children.
                                    * Useful for accessibility compliance.
                                    *
                                    * @example
                                    * ```jsx
                                    * import VisuallyHidden from '@atlaskit/visually-hidden';
                                    *
                                    * export default () => (
                                    *   <div style={{ border: '1px solid black' }}>
                                    *      There is text hidden between the brackets [
                                    *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
                                    *   </div>
                                    * );
                                    * ```
                                    */ 
const $c5c5f50cde9c0a7a$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $35pXk.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
var $c5c5f50cde9c0a7a$export$2e2bcd8739ae039 = $c5c5f50cde9c0a7a$var$VisuallyHidden;

});

parcelRegister("1HnpQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $035a66874d3e86fd$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $035a66874d3e86fd$var$focusRingStyles = null;
const $035a66874d3e86fd$var$insetFocusRingStyles = null;
const $035a66874d3e86fd$var$Focusable = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        ...safeHtmlAttributes,
        ref: ref,
        className: (0, $35pXk.default)([
            "_mizu1p6i _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah311pw _2mwq11pw",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});
var $035a66874d3e86fd$export$2e2bcd8739ae039 = $035a66874d3e86fd$var$Focusable;

});


parcelRegister("gdv5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $57ce31ea3f72b099$export$2e2bcd8739ae039);
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $5rrZR = parcelRequire("5rrZR");
const $57ce31ea3f72b099$var$baseStyles = null;
const $57ce31ea3f72b099$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhk1w7a",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $57ce31ea3f72b099$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $57ce31ea3f72b099$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
const $57ce31ea3f72b099$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $57ce31ea3f72b099$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $57ce31ea3f72b099$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $57ce31ea3f72b099$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
}; /**
    * __Box__
    *
    * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
    * Renders a `div` by default.
    *
    * - [Examples](https://atlassian.design/components/primitives/box/examples)
    * - [Code](https://atlassian.design/components/primitives/box/code)
    * - [Usage](https://atlassian.design/components/primitives/box/usage)
    */ 
const $57ce31ea3f72b099$var$Box = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $7UHDa.jsx)(Component // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: style,
        ref: ref,
        className: (0, $35pXk.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $57ce31ea3f72b099$var$backgroundColorMap[backgroundColor],
            backgroundColor && $57ce31ea3f72b099$var$isSurfaceToken(backgroundColor) && $57ce31ea3f72b099$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $57ce31ea3f72b099$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $57ce31ea3f72b099$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $57ce31ea3f72b099$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $57ce31ea3f72b099$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5rrZR.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
} // @ts-ignore This typescript error has been surpessed while locally enrolling `@atlaskit/primitives` into Jira
);
var $57ce31ea3f72b099$export$2e2bcd8739ae039 = $57ce31ea3f72b099$var$Box;
function $57ce31ea3f72b099$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $57ce31ea3f72b099$var$setSurfaceTokenMap;
}

});


parcelRegister("1GzhS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4078d862f8d156c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $ecnYn = parcelRequire("ecnYn");

var $bUlM5 = parcelRequire("bUlM5");
const $d4078d862f8d156c$var$flexGrowMap = {
    hug: (0, $ecnYn.xcss)({
        flexGrow: 0
    }),
    fill: (0, $ecnYn.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $d4078d862f8d156c$var$Stack = /*#__PURE__*/ (0, $gwFzn.memo)(/*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $d4078d862f8d156c$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $bUlM5.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$d4078d862f8d156c$var$Stack.displayName = 'Stack';
var $d4078d862f8d156c$export$2e2bcd8739ae039 = $d4078d862f8d156c$var$Stack;

});
parcelRegister("bUlM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5da6bf9a1ca649aa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $avd77 = parcelRequire("avd77");

var $ecnYn = parcelRequire("ecnYn");
const $5da6bf9a1ca649aa$var$justifyContentMap = {
    start: (0, $3jLHL.css)({
        justifyContent: 'start'
    }),
    center: (0, $3jLHL.css)({
        justifyContent: 'center'
    }),
    end: (0, $3jLHL.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3jLHL.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3jLHL.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3jLHL.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3jLHL.css)({
        justifyContent: 'stretch'
    })
};
const $5da6bf9a1ca649aa$var$flexDirectionMap = {
    column: (0, $3jLHL.css)({
        flexDirection: 'column'
    }),
    row: (0, $3jLHL.css)({
        flexDirection: 'row'
    })
};
const $5da6bf9a1ca649aa$var$flexWrapMap = {
    wrap: (0, $3jLHL.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $3jLHL.css)({
        flexWrap: 'nowrap'
    })
};
const $5da6bf9a1ca649aa$var$alignItemsMap = {
    start: (0, $3jLHL.css)({
        alignItems: 'start'
    }),
    center: (0, $3jLHL.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3jLHL.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3jLHL.css)({
        alignItems: 'end'
    }),
    stretch: (0, $3jLHL.css)({
        alignItems: 'stretch'
    })
};
const $5da6bf9a1ca649aa$var$baseStyles = (0, $3jLHL.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $5da6bf9a1ca649aa$var$Flex = /*#__PURE__*/ (0, $gwFzn.memo)(/*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $3jLHL.jsx)(Component, {
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $5da6bf9a1ca649aa$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $avd77.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $avd77.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $avd77.spaceStylesMap).rowGap[rowGap],
            alignItems && $5da6bf9a1ca649aa$var$alignItemsMap[alignItems],
            direction && $5da6bf9a1ca649aa$var$flexDirectionMap[direction],
            justifyContent && $5da6bf9a1ca649aa$var$justifyContentMap[justifyContent],
            wrap && $5da6bf9a1ca649aa$var$flexWrapMap[wrap],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$5da6bf9a1ca649aa$var$Flex.displayName = 'Flex';
var $5da6bf9a1ca649aa$export$2e2bcd8739ae039 = $5da6bf9a1ca649aa$var$Flex;

});


parcelRegister("d5QxR", function(module, exports) {

$parcel$export(module.exports, "CodeBlockWithCopyButton", () => $da843bad7fe75e8b$export$ced1fc74d907d387);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $9QfXi = parcelRequire("9QfXi");

var $gt9HV = parcelRequire("gt9HV");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");
const $da843bad7fe75e8b$var$wrapperStyles = (0, $ecnYn.xcss)({
    width: '100%',
    position: 'relative'
});
const $da843bad7fe75e8b$var$copyButtonStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});
const $da843bad7fe75e8b$var$i18n = (0, $2nPZH.defineMessages)({
    copyTooltip: {
        id: "error-boundary.code-block.copy.tooltip",
        defaultMessage: "Copy"
    },
    copySuccess: {
        id: "error-boundary.code-block.copy.success",
        defaultMessage: "Copied!"
    },
    copyFailure: {
        id: "error-boundary.code-block.copy.failure",
        defaultMessage: "Copy to clipboard failed"
    }
});
const $da843bad7fe75e8b$export$ced1fc74d907d387 = ({ lines: lines, analyticsSource: analyticsSource })=>{
    const intl = (0, $dBxQj.default)();
    const [tooltipMessage, setTooltipMessage] = (0, $gwFzn.useState)(intl.formatMessage($da843bad7fe75e8b$var$i18n.copyTooltip));
    const [justCopied, setJustCopied] = (0, $gwFzn.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isValidLines = Array.isArray(lines) && lines.every((line)=>typeof line === 'string');
    const source = isValidLines ? lines.join('\n') : '';
    const writeToClipboard = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'codeBlockCopyToClipboard',
                source: analyticsSource
            }
        }).fire();
        try {
            await navigator.clipboard.writeText(source);
            setTooltipMessage(intl.formatMessage($da843bad7fe75e8b$var$i18n.copySuccess));
            setJustCopied(true);
        } catch (error) {
            setTooltipMessage(intl.formatMessage($da843bad7fe75e8b$var$i18n.copyFailure));
        }
    };
    const resetTooltipMessage = ()=>{
        if (!justCopied) setTooltipMessage(intl.formatMessage($da843bad7fe75e8b$var$i18n.copyTooltip));
    };
    const handleBlur = ()=>{
        setJustCopied(false);
        resetTooltipMessage();
    };
    const handleMouseOver = ()=>{
        if (!justCopied) resetTooltipMessage();
    };
    const handleMouseLeave = ()=>{
        setJustCopied(false);
        resetTooltipMessage();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $da843bad7fe75e8b$var$wrapperStyles,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $da843bad7fe75e8b$var$copyButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        isTooltipDisabled: false,
        label: tooltipMessage,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gt9HV))),
        onClick: writeToClipboard,
        onMouseOver: handleMouseOver,
        onMouseLeave: handleMouseLeave,
        onFocus: resetTooltipMessage,
        onBlur: handleBlur,
        "aria-live": "assertive",
        "aria-atomic": "true",
        appearance: "subtle",
        spacing: "compact"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9QfXi.default), {
        text: source,
        showLineNumbers: false,
        shouldWrapLongLines: false
    })));
};

});
parcelRegister("1qfLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $660af81825e1c4b6$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3654r = parcelRequire("3654r");

var $3gadb = parcelRequire("3gadb");

var $6F6hl = parcelRequire("6F6hl");

var $iprY1 = parcelRequire("iprY1");

var $jvXSm = parcelRequire("jvXSm");

var $6kISY = parcelRequire("6kISY");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $660af81825e1c4b6$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iprY1.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $jvXSm.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6kISY.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6F6hl.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iprY1.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    onClick?.(e, analyticsEvent);
                    triggerProps.onClick?.(e);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                ref: (0, $3654r.default)([
                    ref,
                    triggerProps?.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $jvXSm.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6kISY.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6F6hl.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$660af81825e1c4b6$var$IconButton.displayName = 'IconButton';
var $660af81825e1c4b6$export$2e2bcd8739ae039 = $660af81825e1c4b6$var$IconButton;

});
parcelRegister("3654r", function(module, exports) {

$parcel$export(module.exports, "default", () => $522abdc1035f6a47$export$2e2bcd8739ae039);
function $522abdc1035f6a47$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("3gadb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2caa4a7e85ae2d24$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $6yeVm = parcelRequire("6yeVm");

var $ee7An = parcelRequire("ee7An");

var $cr6pC = parcelRequire("cr6pC");

var $g6aM3 = parcelRequire("g6aM3");

var $if5rb = parcelRequire("if5rb");

var $g9Srd = parcelRequire("g9Srd");
var $fT2ta = parcelRequire("fT2ta");

var $dh538 = parcelRequire("dh538");

var $lqsSp = parcelRequire("lqsSp");

var $caX7N = parcelRequire("caX7N");

var $dTk3A = parcelRequire("dTk3A");

var $29bV2 = parcelRequire("29bV2");

var $8v9yf = parcelRequire("8v9yf");

var $3VJDH = parcelRequire("3VJDH");

var $5CLwS = parcelRequire("5CLwS");

var $btyPJ = parcelRequire("btyPJ");
const $2caa4a7e85ae2d24$var$tooltipZIndex = (0, $dTk3A.layers).tooltip();
const $2caa4a7e85ae2d24$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
// Inverts motion direction
const $2caa4a7e85ae2d24$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $2caa4a7e85ae2d24$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $2caa4a7e85ae2d24$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $5CLwS.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $ee7An.default), onHide: onHide = (0, $ee7An.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false }) {
    const tooltipPosition = position === 'mouse' ? mousePosition : position;
    const onShowHandler = (0, $6yeVm.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$2caa4a7e85ae2d24$var$analyticsAttributes
    });
    const onHideHandler = (0, $6yeVm.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$2caa4a7e85ae2d24$var$analyticsAttributes
    });
    const apiRef = (0, $gwFzn.useRef)(null);
    const [state, setState] = (0, $gwFzn.useState)('hide');
    const targetRef = (0, $gwFzn.useRef)(null);
    const containerRef = (0, $gwFzn.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $gwFzn.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $g6aM3.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $g6aM3.default)(onShowHandler);
    const onHideHandlerStable = (0, $g6aM3.default)(onHideHandler);
    const delayStable = (0, $g6aM3.default)(delay);
    const canAppearStable = (0, $g6aM3.default)(canAppear);
    const hasCalledShowHandler = (0, $gwFzn.useRef)(false);
    const start = (0, $gwFzn.useCallback)((api)=>{
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $gwFzn.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $gwFzn.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $gwFzn.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        return (0, $29bV2.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const tryShowTooltip = (0, $gwFzn.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        const api = (0, $8v9yf.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    const hideTooltipOnEsc = (0, $gwFzn.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $cr6pC.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $gwFzn.useEffect)(()=>{
        if (state === 'hide') return 0, $ee7An.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $d8F95.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $gwFzn.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $gwFzn.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $gwFzn.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $btyPJ.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $gwFzn.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = position === 'mouse' ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePosition = (0, $btyPJ.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    const onMouseOverTooltip = (0, $gwFzn.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $gwFzn.useCallback)(()=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (targetRef.current && !targetRef.current.matches(':focus-visible') && (0, $dh538.fg)('platform-tooltip-focus-visible')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $gwFzn.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $gwFzn.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    const handleOpenLayerObserverCloseSignal = (0, $gwFzn.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $if5rb.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && ((0, $dh538.fg)('platform_dst_open_layer_observer_close_layers') ? shouldRenderTooltipChildren : true),
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (position === 'mouse' && apiRef.current?.mousePosition) return apiRef.current?.mousePosition;
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $3VJDH.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = `${testId}--container`;
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $gwFzn.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
            // attribute back into the tooltipTriggerProps and make it required
            // instead of optional in `types`
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    children({
                        ...tooltipTriggerProps,
                        'aria-describedby': tooltipIdForHiddenContent,
                        ref: setDirectRef
                    }),
                    hiddenContent
                ]
            }) : /*#__PURE__*/ (0, $7UHDa.jsxs)(CastTargetContainer, {
                ...tooltipTriggerProps,
                ref: setImplicitRefFromChildren,
                /**
     * TODO: Why is role="presentation" added?
     * - Is it only to "remove" the `Container` from screen readers?
     * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
     * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
     */ role: "presentation",
                children: [
                    children,
                    hiddenContent
                ]
            }),
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $caX7N.default), {
                zIndex: $2caa4a7e85ae2d24$var$tooltipZIndex,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lqsSp.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        // Invert the entrance and exit directions.
                        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
                        // This gives the effect the tooltip is appearing from the target
                        const direction = position === 'mouse' ? undefined : $2caa4a7e85ae2d24$var$invertedDirection[$2caa4a7e85ae2d24$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g9Srd.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fT2ta.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $7UHDa.jsx)(Container, {
                                        ref: ref,
                                        /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
$2caa4a7e85ae2d24$var$Tooltip.displayName = 'Tooltip';
var $2caa4a7e85ae2d24$export$2e2bcd8739ae039 = $2caa4a7e85ae2d24$var$Tooltip;

});
parcelRegister("6yeVm", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $5975fb3f46b99358$export$1a04351537078b55);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $fTXBo = parcelRequire("fTXBo");
function $5975fb3f46b99358$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $fTXBo.useTrackedRef)(analyticsData);
    const fnRef = (0, $fTXBo.useTrackedRef)(fn);
    const handler = (0, $gwFzn.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("cr6pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed62970505a64678$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $4JWgN = parcelRequire("4JWgN");
function $ed62970505a64678$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $gwFzn.useRef)(false);
    const onKeyDown = (0, $gwFzn.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $4JWgN.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $gwFzn.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        return (0, $d8F95.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("4JWgN", function(module, exports) {

$parcel$export(module.exports, "KEY_UP", () => $86459c7074d8d3c8$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $86459c7074d8d3c8$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_HOME", () => $86459c7074d8d3c8$export$4af703091671bc);
$parcel$export(module.exports, "KEY_END", () => $86459c7074d8d3c8$export$e2bc30913faa5db7);
$parcel$export(module.exports, "KEY_TAB", () => $86459c7074d8d3c8$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "KEY_ENTER", () => $86459c7074d8d3c8$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_SPACE", () => $86459c7074d8d3c8$export$e51a3576c045c8d5);
$parcel$export(module.exports, "ESCAPE", () => $86459c7074d8d3c8$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ const $86459c7074d8d3c8$export$390330c10ff2b9a1 = 'ArrowUp';
const $86459c7074d8d3c8$export$a80636c6f41931fe = 'ArrowDown';
const $86459c7074d8d3c8$export$4af703091671bc = 'Home';
const $86459c7074d8d3c8$export$e2bc30913faa5db7 = 'End';
const $86459c7074d8d3c8$export$10f6869ed0a7d75b = 'Tab';
const $86459c7074d8d3c8$export$8152f929a25a0ff4 = 'Enter';
const $86459c7074d8d3c8$export$e51a3576c045c8d5 = 'Space';
const $86459c7074d8d3c8$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("g6aM3", function(module, exports) {

$parcel$export(module.exports, "default", () => $67db7a8b3e03080f$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
function $67db7a8b3e03080f$export$2e2bcd8739ae039(value) {
    const ref = (0, $gwFzn.useRef)(value);
    (0, $gwFzn.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("if5rb", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $c5d9ea856be07e85$export$469bb693f11edc7f);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $iHNqU = parcelRequire("iHNqU");

var $4pUFZ = parcelRequire("4pUFZ");
function $c5d9ea856be07e85$export$469bb693f11edc7f({ isOpen: isOpen, onClose: onClose }) {
    const context = (0, $gwFzn.useContext)((0, $iHNqU.OpenLayerObserverContext));
    const namespace = (0, $4pUFZ.useOpenLayerObserverNamespace)();
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_dst_open_layer_observer_close_layers')) return;
        /**
		 * Increments the layer count when the component mounts or becomes visible.
		 *
		 * Returns a cleanup function to decrement the layer count when the component unmounts or becomes hidden.
		 */ if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function cleanup() {
            context.decrement();
        };
    }, [
        context,
        isOpen,
        namespace
    ]);
    (0, $gwFzn.useEffect)(()=>{
        /**
		 * Registers the `onClose` callback with the OpenLayerObserver.
		 */ if (!(0, $dh538.fg)('platform_dst_open_layer_observer_close_layers')) return;
        if (context === null) return;
        if (!isOpen) /**
			 * If the layer is not open, we are not registering the `onClose` callback.
			 * This is important to prevent the `onClose` from being called for layers that
			 * are not open.
			 *
			 * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
			 * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
			 */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}

});
parcelRegister("iHNqU", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", () => $74b93f9437d114b9$export$5fbf4d7fae6cdc00);

var $gwFzn = parcelRequire("gwFzn");
const $74b93f9437d114b9$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $gwFzn.createContext)(null);

});

parcelRegister("4pUFZ", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $6a9a54d980ef75c0$export$1d57e79091cc3046);

var $gwFzn = parcelRequire("gwFzn");

var $cGkQr = parcelRequire("cGkQr");
function $6a9a54d980ef75c0$export$1d57e79091cc3046() {
    const namespace = (0, $gwFzn.useContext)((0, $cGkQr.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("cGkQr", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $a33883aec82c2423$export$644a49f3b8c50fcd);

var $gwFzn = parcelRequire("gwFzn");
const $a33883aec82c2423$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $gwFzn.createContext)(null);

});



parcelRegister("lqsSp", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $ecca7c16c8de9b75$export$badac9ada3a0bdf9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $8ExxI = parcelRequire("8ExxI");

var $6dR7h = parcelRequire("6dR7h");

const $ecca7c16c8de9b75$var$viewportPadding = 5;
const $ecca7c16c8de9b75$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $ecca7c16c8de9b75$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $ecca7c16c8de9b75$var$defaultChildrenFn() {
    return null;
}
const $ecca7c16c8de9b75$var$defaultOffset = [
    0,
    8
];
function $ecca7c16c8de9b75$export$badac9ada3a0bdf9({ children: children = $ecca7c16c8de9b75$var$defaultChildrenFn, offset: offset = $ecca7c16c8de9b75$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $gwFzn.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $ecca7c16c8de9b75$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $6dR7h.getMaxSizeModifiers)({
            viewportPadding: $ecca7c16c8de9b75$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [
            ...$ecca7c16c8de9b75$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $gwFzn.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8ExxI.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}

});
parcelRegister("6dR7h", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", () => $4f270dfd41d88c95$export$6d8c2b45c99d6e3f);
function $4f270dfd41d88c95$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
			 * Performing DOM measurements in the 'read' phase,
			 * which is the convention for popper modifiers
			 */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
			 * Applying max size CSS
			 */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                const data = state.modifiersData.maxSizeData;
                if (typeof data?.viewport?.width !== 'number' || typeof data?.viewport?.height !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = state.modifiersData?.offset?.[state.placement] ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});


parcelRegister("caX7N", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4dd5f555438ec52$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $aSAeP = parcelRequire("aSAeP");

var $c9Nef = parcelRequire("c9Nef");

var $9hItQ = parcelRequire("9hItQ");

var $4OYNm = parcelRequire("4OYNm");
function $f4dd5f555438ec52$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect' }) {
    const isSubsequentRender = (0, $9hItQ.default)(mountStrategy);
    (0, $4OYNm.default)(zIndex);
    return !(0, $dh538.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aSAeP.default), {
        zIndex: zIndex,
        children: children
    }) : null : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c9Nef.default), {
        zIndex: zIndex,
        children: children
    });
}

});
parcelRegister("aSAeP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8cb7e18b4c8e020$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $4FhhO = parcelRequire("4FhhO");

var $1uXrK = parcelRequire("1uXrK");
function $e8cb7e18b4c8e020$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const container = (0, $gwFzn.useMemo)(()=>(0, $1uXrK.createContainer)(zIndex), [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $1uXrK.appendPortalContainerIfNotAppended)(container);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            (0, $1uXrK.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $4FhhO.createPortal)(children, container);
}

});
parcelRegister("1uXrK", function(module, exports) {

$parcel$export(module.exports, "createContainer", () => $2f4e9fedc9ef26c3$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $2f4e9fedc9ef26c3$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $2f4e9fedc9ef26c3$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $2f4e9fedc9ef26c3$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $2f4e9fedc9ef26c3$export$95029ca7aca2989e);

var $9kRKd = parcelRequire("9kRKd");
const $2f4e9fedc9ef26c3$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $9kRKd.portalClassName);
    container.style.zIndex = `${zIndex}`;
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $2f4e9fedc9ef26c3$var$getBody = ()=>{
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ const $2f4e9fedc9ef26c3$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $9kRKd.portalParentSelector));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $9kRKd.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        $2f4e9fedc9ef26c3$var$getBody()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $2f4e9fedc9ef26c3$export$da99f98bf3fe55b3 = (container)=>{
    $2f4e9fedc9ef26c3$var$getPortalParent().removeChild(container);
};
const $2f4e9fedc9ef26c3$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $2f4e9fedc9ef26c3$var$getPortalParent().appendChild(container);
};
const $2f4e9fedc9ef26c3$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $2f4e9fedc9ef26c3$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($2f4e9fedc9ef26c3$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $9kRKd.portalClassName);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
};
const $2f4e9fedc9ef26c3$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($2f4e9fedc9ef26c3$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $9kRKd.portalParentSelector));
        if (!parentElement) {
            const parent = document.createElement('div');
            parent.className = (0, $9kRKd.portalParentClassName);
            parent.style.display = 'flex';
            $2f4e9fedc9ef26c3$var$getBody()?.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("9kRKd", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", () => $99ea7c45d47170fe$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $99ea7c45d47170fe$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $99ea7c45d47170fe$export$13f57c02915787b3);
const $99ea7c45d47170fe$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $99ea7c45d47170fe$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $99ea7c45d47170fe$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("c9Nef", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0145b3d0001629a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4FhhO = parcelRequire("4FhhO");

var $b3W83 = parcelRequire("b3W83");

var $1uXrK = parcelRequire("1uXrK");
function $a0145b3d0001629a$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $gwFzn.useState)(null);
    (0, $b3W83.useIsomorphicLayoutEffect)(()=>{
        const tempPortalContainer = (0, $1uXrK.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        const portalParent = (0, $1uXrK.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return ()=>{
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
	 * We wrap portal children with a Suspense boundary because in React 18 concurrent,
	 * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
	 * our portal gets in an infinite loop of rendering.
	 */ const suspendedChildren = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: null,
        children: children
    });
    return atlaskitPortal ? /*#__PURE__*/ (0, $4FhhO.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("b3W83", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $0b6ae911d7dbb2a8$export$700979bc83e7db82);

var $gwFzn = parcelRequire("gwFzn");
const $0b6ae911d7dbb2a8$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $gwFzn.useLayoutEffect) : (0, $gwFzn.useEffect);

});


parcelRegister("9hItQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $86c76191573711ee$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $b3W83 = parcelRequire("b3W83");
const $86c76191573711ee$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $gwFzn.useState)(false);
    const [useMountEffect] = (0, $gwFzn.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $b3W83.useIsomorphicLayoutEffect) : (0, $gwFzn.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $86c76191573711ee$export$2e2bcd8739ae039 = $86c76191573711ee$var$useIsSubsequentRender;

});

parcelRegister("4OYNm", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d63ccdf36bf175$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $dsrsC = parcelRequire("dsrsC");

var $gofgk = parcelRequire("gofgk");
const $46d63ccdf36bf175$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $gwFzn.useEffect)(()=>{
        (0, $gofgk.default)((0, $dsrsC.PORTAL_MOUNT_EVENT), zIndexNumber);
        return ()=>{
            (0, $gofgk.default)((0, $dsrsC.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $46d63ccdf36bf175$export$2e2bcd8739ae039 = $46d63ccdf36bf175$var$useFirePortalEvent;

});
parcelRegister("dsrsC", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $fe064809d28b4ab5$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $fe064809d28b4ab5$export$80816bd900e5bd00);
const $fe064809d28b4ab5$export$ed5835cc67e87f72 = 'akPortalMount';
const $fe064809d28b4ab5$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("gofgk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6df29763b6e7b48a$export$2e2bcd8739ae039);
const $6df29763b6e7b48a$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $6df29763b6e7b48a$var$getLayerName = (zIndex)=>{
    return $6df29763b6e7b48a$var$zIndexToName.hasOwnProperty(zIndex) ? $6df29763b6e7b48a$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $6df29763b6e7b48a$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $6df29763b6e7b48a$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $6df29763b6e7b48a$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $6df29763b6e7b48a$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("dTk3A", function(module, exports) {

$parcel$export(module.exports, "borderRadius", () => $45878ddd0fe449a8$export$7a57f79000377ca2);
$parcel$export(module.exports, "gridSize", () => $45878ddd0fe449a8$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "layers", () => $45878ddd0fe449a8$export$7be255094ccdc533);
$parcel$export(module.exports, "skeletonShimmer", () => $45878ddd0fe449a8$export$e497e856b4f89fcd);

var $bo9I4 = parcelRequire("bo9I4");

var $6fnsQ = parcelRequire("6fnsQ");
const $45878ddd0fe449a8$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $45878ddd0fe449a8$export$c93026a968943f95 = 'light';
const $45878ddd0fe449a8$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $45878ddd0fe449a8$export$7a57f79000377ca2 = ()=>3;
const $45878ddd0fe449a8$export$6d8204c2cb2e06b8 = ()=>8;
const $45878ddd0fe449a8$export$8e24544ddba725ee = (color = `var(--ds-border-focused, ${0, $6fnsQ.B200})`, outlineWidth = $45878ddd0fe449a8$export$6d8204c2cb2e06b8() / 4)=>{
    (0, $bo9I4.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return `
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
  }
`;
};
const $45878ddd0fe449a8$export$c0dd343266bc3261 = ()=>`
  box-shadow: none;
`;
const $45878ddd0fe449a8$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};
const $45878ddd0fe449a8$export$a1b3edb637fb4f35 = ()=>{
    (0, $bo9I4.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
const $45878ddd0fe449a8$export$ba1d834b86d72a09 = $45878ddd0fe449a8$export$a1b3edb637fb4f35;
const $45878ddd0fe449a8$export$e497e856b4f89fcd = ()=>({
        css: {
            backgroundColor: `var(--ds-skeleton, ${0, $6fnsQ.N20A})`,
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: `var(--ds-skeleton, ${0, $6fnsQ.N20A})`
            },
            to: {
                backgroundColor: `var(--ds-skeleton-subtle, ${0, $6fnsQ.N30A})`
            }
        }
    });

});
parcelRegister("bo9I4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cda9b359fee0756$export$2e2bcd8739ae039);

var $4S9ET = parcelRequire("4S9ET");

var $3mTvL = parcelRequire("3mTvL");
function $2cda9b359fee0756$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $4S9ET.default)(`[${packageName}]: The ${api} is deprecated.${additionalMessage && ` ${additionalMessage}`}`);
}
function $2cda9b359fee0756$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3mTvL;
}

});
parcelRegister("4S9ET", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c9c08079e62c333$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $2c9c08079e62c333$var$printed = {};
function $2c9c08079e62c333$export$2e2bcd8739ae039(message) {
    if ($2c9c08079e62c333$var$printed[message]) return;
    $2c9c08079e62c333$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("6fnsQ", function(module, exports) {

$parcel$export(module.exports, "R50", () => $4300ebad5a984131$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $4300ebad5a984131$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $4300ebad5a984131$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R200", () => $4300ebad5a984131$export$60847d42f9da92a6);
$parcel$export(module.exports, "R300", () => $4300ebad5a984131$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $4300ebad5a984131$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $4300ebad5a984131$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $4300ebad5a984131$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $4300ebad5a984131$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y100", () => $4300ebad5a984131$export$1cc05bbbf340e559);
$parcel$export(module.exports, "Y200", () => $4300ebad5a984131$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y300", () => $4300ebad5a984131$export$c6930421db9fa514);
$parcel$export(module.exports, "Y400", () => $4300ebad5a984131$export$59619663aa6500fb);
$parcel$export(module.exports, "Y500", () => $4300ebad5a984131$export$874739ea9e379ab6);
$parcel$export(module.exports, "G50", () => $4300ebad5a984131$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $4300ebad5a984131$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G100", () => $4300ebad5a984131$export$afbce1382ec95f73);
$parcel$export(module.exports, "G200", () => $4300ebad5a984131$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $4300ebad5a984131$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $4300ebad5a984131$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $4300ebad5a984131$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $4300ebad5a984131$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $4300ebad5a984131$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $4300ebad5a984131$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B200", () => $4300ebad5a984131$export$215b7063051591f1);
$parcel$export(module.exports, "B300", () => $4300ebad5a984131$export$e62e8919cca44969);
$parcel$export(module.exports, "B400", () => $4300ebad5a984131$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $4300ebad5a984131$export$a6ee3d71bc067634);
$parcel$export(module.exports, "B600", () => $4300ebad5a984131$export$67f15409e87642a1);
$parcel$export(module.exports, "B700", () => $4300ebad5a984131$export$f0539dbc42dbb067);
$parcel$export(module.exports, "P50", () => $4300ebad5a984131$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $4300ebad5a984131$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $4300ebad5a984131$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $4300ebad5a984131$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $4300ebad5a984131$export$b48405b95304b5a1);
$parcel$export(module.exports, "P400", () => $4300ebad5a984131$export$c71e4279dd54a18d);
$parcel$export(module.exports, "P500", () => $4300ebad5a984131$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $4300ebad5a984131$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $4300ebad5a984131$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $4300ebad5a984131$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $4300ebad5a984131$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $4300ebad5a984131$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T400", () => $4300ebad5a984131$export$7c835c78b6fcdef8);
$parcel$export(module.exports, "T500", () => $4300ebad5a984131$export$6036577f95c3877e);
$parcel$export(module.exports, "N0", () => $4300ebad5a984131$export$29a4f05edc054374);
$parcel$export(module.exports, "N10", () => $4300ebad5a984131$export$e655ef011c4aa1a2);
$parcel$export(module.exports, "N20", () => $4300ebad5a984131$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $4300ebad5a984131$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $4300ebad5a984131$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $4300ebad5a984131$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $4300ebad5a984131$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N70", () => $4300ebad5a984131$export$5f71e19f3a7ad9de);
$parcel$export(module.exports, "N80", () => $4300ebad5a984131$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N90", () => $4300ebad5a984131$export$7c87d337fb91a97d);
$parcel$export(module.exports, "N100", () => $4300ebad5a984131$export$d6447c357493214f);
$parcel$export(module.exports, "N200", () => $4300ebad5a984131$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $4300ebad5a984131$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "N400", () => $4300ebad5a984131$export$eece5f492e429f08);
$parcel$export(module.exports, "N500", () => $4300ebad5a984131$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $4300ebad5a984131$export$7090862dc3038a9f);
$parcel$export(module.exports, "N700", () => $4300ebad5a984131$export$ad0bacf983b7ddaa);
$parcel$export(module.exports, "N800", () => $4300ebad5a984131$export$7d61b15e0da132af);
$parcel$export(module.exports, "N900", () => $4300ebad5a984131$export$fbda843f0a27fe96);
$parcel$export(module.exports, "N10A", () => $4300ebad5a984131$export$791e57b27ca738ef);
$parcel$export(module.exports, "N20A", () => $4300ebad5a984131$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $4300ebad5a984131$export$920c0d5c49070351);
$parcel$export(module.exports, "N40A", () => $4300ebad5a984131$export$46987b49aab6d1a8);
$parcel$export(module.exports, "N50A", () => $4300ebad5a984131$export$7d3359664e8bb0e5);
$parcel$export(module.exports, "N60A", () => $4300ebad5a984131$export$d2d3bedfb276cac0);
$parcel$export(module.exports, "N70A", () => $4300ebad5a984131$export$6e5e7499ff054f6d);
$parcel$export(module.exports, "N80A", () => $4300ebad5a984131$export$59264b346c877fa7);
$parcel$export(module.exports, "N90A", () => $4300ebad5a984131$export$d092757d7c64925c);
$parcel$export(module.exports, "N100A", () => $4300ebad5a984131$export$486ab785e4bac3c6);
$parcel$export(module.exports, "N200A", () => $4300ebad5a984131$export$fba592bbc6419fea);
$parcel$export(module.exports, "N300A", () => $4300ebad5a984131$export$13609db0e6812ab8);
$parcel$export(module.exports, "N400A", () => $4300ebad5a984131$export$fbae4efaa892d883);
$parcel$export(module.exports, "N500A", () => $4300ebad5a984131$export$f13946d26f440ce6);
$parcel$export(module.exports, "N600A", () => $4300ebad5a984131$export$19f58225ac52a306);
$parcel$export(module.exports, "N700A", () => $4300ebad5a984131$export$6384f09da70e7b62);
$parcel$export(module.exports, "N800A", () => $4300ebad5a984131$export$d0dccc730683edc2);
$parcel$export(module.exports, "DN900", () => $4300ebad5a984131$export$2f6319cf7d736c2a);
$parcel$export(module.exports, "DN800", () => $4300ebad5a984131$export$95126bc8884d6634);
$parcel$export(module.exports, "DN700", () => $4300ebad5a984131$export$8338d8c35d44ff1);
$parcel$export(module.exports, "DN600", () => $4300ebad5a984131$export$5368d76ae4fbbda7);
$parcel$export(module.exports, "DN500", () => $4300ebad5a984131$export$9f0a771d16ec8d36);
$parcel$export(module.exports, "DN400", () => $4300ebad5a984131$export$abcf8c38338b4aa5);
$parcel$export(module.exports, "DN300", () => $4300ebad5a984131$export$97e81faa16a182c7);
$parcel$export(module.exports, "DN200", () => $4300ebad5a984131$export$bfe21c59123ecf33);
$parcel$export(module.exports, "DN100", () => $4300ebad5a984131$export$ee82aa2ea6a1558);
$parcel$export(module.exports, "DN90", () => $4300ebad5a984131$export$682927c6ed76be02);
$parcel$export(module.exports, "DN80", () => $4300ebad5a984131$export$91fd9994c5be9757);
$parcel$export(module.exports, "DN70", () => $4300ebad5a984131$export$d281fbfe3cff2df6);
$parcel$export(module.exports, "DN60", () => $4300ebad5a984131$export$3902c91d8b98a753);
$parcel$export(module.exports, "DN50", () => $4300ebad5a984131$export$8e8133c1ba5845b5);
$parcel$export(module.exports, "DN40", () => $4300ebad5a984131$export$33ff357f6620b39);
$parcel$export(module.exports, "DN30", () => $4300ebad5a984131$export$633847cf062b69e0);
$parcel$export(module.exports, "DN20", () => $4300ebad5a984131$export$9776a6e503bdbf76);
$parcel$export(module.exports, "DN10", () => $4300ebad5a984131$export$6c813d5160dff5db);
$parcel$export(module.exports, "DN0", () => $4300ebad5a984131$export$3d4f271a500072a);
$parcel$export(module.exports, "DN800A", () => $4300ebad5a984131$export$fe151285c22759ec);
$parcel$export(module.exports, "DN700A", () => $4300ebad5a984131$export$a101c6190d0da34);
$parcel$export(module.exports, "DN600A", () => $4300ebad5a984131$export$4b16f52932fda51);
$parcel$export(module.exports, "DN500A", () => $4300ebad5a984131$export$a74bcd7b9845b0d8);
$parcel$export(module.exports, "DN400A", () => $4300ebad5a984131$export$9209c179316d1751);
$parcel$export(module.exports, "DN300A", () => $4300ebad5a984131$export$88f55133f636c8dd);
$parcel$export(module.exports, "DN200A", () => $4300ebad5a984131$export$51126f85d1009512);
$parcel$export(module.exports, "DN100A", () => $4300ebad5a984131$export$a069b547bd23af78);
$parcel$export(module.exports, "DN90A", () => $4300ebad5a984131$export$40cce05af3b2600a);
$parcel$export(module.exports, "DN80A", () => $4300ebad5a984131$export$b78942185925a0d);
$parcel$export(module.exports, "DN70A", () => $4300ebad5a984131$export$e058fb44b8eaafca);
$parcel$export(module.exports, "DN60A", () => $4300ebad5a984131$export$92b0b8de26920c18);
$parcel$export(module.exports, "DN50A", () => $4300ebad5a984131$export$67564f7459d3fc9e);
$parcel$export(module.exports, "DN40A", () => $4300ebad5a984131$export$77868e1ca884ffa3);
$parcel$export(module.exports, "DN30A", () => $4300ebad5a984131$export$2afd71d7d3ea2cd5);
$parcel$export(module.exports, "DN20A", () => $4300ebad5a984131$export$f2a0acaab9972c70);
$parcel$export(module.exports, "DN10A", () => $4300ebad5a984131$export$9ab70e67d6475361);
$parcel$export(module.exports, "T30", () => $4300ebad5a984131$export$d2adc5dedf09fced);
$parcel$export(module.exports, "L50", () => $4300ebad5a984131$export$f51762073d2bb381);
$parcel$export(module.exports, "L75", () => $4300ebad5a984131$export$95e26d54def96891);
// Reds
const $4300ebad5a984131$export$4b84fd0e2c617bd = '#FFEBE6';
const $4300ebad5a984131$export$b34b069eff244586 = '#FFBDAD';
const $4300ebad5a984131$export$be802dd0d8b57f35 = '#FF8F73';
const $4300ebad5a984131$export$60847d42f9da92a6 = '#FF7452';
const $4300ebad5a984131$export$4a7404f376229999 = '#FF5630';
const $4300ebad5a984131$export$2010d0fb4295b346 = '#DE350B';
const $4300ebad5a984131$export$2837b5a1a71d5c02 = '#BF2600';
const $4300ebad5a984131$export$8d9596b529bbb9cf = '#FFFAE6';
const $4300ebad5a984131$export$41060a744ab0b7ae = '#FFF0B3';
const $4300ebad5a984131$export$1cc05bbbf340e559 = '#FFE380';
const $4300ebad5a984131$export$5aae31392d72caaa = '#FFC400';
const $4300ebad5a984131$export$c6930421db9fa514 = '#FFAB00';
const $4300ebad5a984131$export$59619663aa6500fb = '#FF991F';
const $4300ebad5a984131$export$874739ea9e379ab6 = '#FF8B00';
const $4300ebad5a984131$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $4300ebad5a984131$export$69a3bf21b9686c2b = '#ABF5D1';
const $4300ebad5a984131$export$afbce1382ec95f73 = '#79F2C0';
const $4300ebad5a984131$export$747d86715d4175de = '#57D9A3';
const $4300ebad5a984131$export$940e1f69e873f202 = '#36B37E';
const $4300ebad5a984131$export$a49394138f7b8e85 = '#00875A';
const $4300ebad5a984131$export$6fa04827ac68a4fb = '#006644';
const $4300ebad5a984131$export$226de0355ed012f8 = '#DEEBFF';
const $4300ebad5a984131$export$8c13c2ee36917869 = '#B3D4FF';
const $4300ebad5a984131$export$ecfc1dff386a3e7a = '#4C9AFF';
const $4300ebad5a984131$export$215b7063051591f1 = '#2684FF';
const $4300ebad5a984131$export$e62e8919cca44969 = '#0065FF';
const $4300ebad5a984131$export$b3de0ae08da2ce64 = '#0052CC';
const $4300ebad5a984131$export$a6ee3d71bc067634 = '#0747A6';
const $4300ebad5a984131$export$67f15409e87642a1 = '#669DF1';
const $4300ebad5a984131$export$f0539dbc42dbb067 = '#8FB8F6';
const $4300ebad5a984131$export$363e4475840015bb = '#EAE6FF';
const $4300ebad5a984131$export$4b0a4417ed59760f = '#C0B6F2';
const $4300ebad5a984131$export$6011520a64d9a187 = '#998DD9';
const $4300ebad5a984131$export$a7175d4e9206bc80 = '#8777D9';
const $4300ebad5a984131$export$b48405b95304b5a1 = '#6554C0';
const $4300ebad5a984131$export$c71e4279dd54a18d = '#5243AA';
const $4300ebad5a984131$export$147899de772240ec = '#403294';
const $4300ebad5a984131$export$2cf711fe14c66f06 = '#E6FCFF';
const $4300ebad5a984131$export$7a8f4d33f6f9772c = '#B3F5FF';
const $4300ebad5a984131$export$776c9c497ef08533 = '#79E2F2';
const $4300ebad5a984131$export$69cb3ca10c1e330e = '#00C7E6';
const $4300ebad5a984131$export$9dc1ef0f3f48059b = '#00B8D9';
const $4300ebad5a984131$export$7c835c78b6fcdef8 = '#00A3BF';
const $4300ebad5a984131$export$6036577f95c3877e = '#008DA6';
const $4300ebad5a984131$export$29a4f05edc054374 = '#FFFFFF';
const $4300ebad5a984131$export$e655ef011c4aa1a2 = '#FAFBFC';
const $4300ebad5a984131$export$9fdfb749e33cdf97 = '#F4F5F7';
const $4300ebad5a984131$export$3e51e8f1440314ba = '#EBECF0';
const $4300ebad5a984131$export$1ce2d1575d444ceb = '#DFE1E6';
const $4300ebad5a984131$export$8754fc7e6d8b3000 = '#C1C7D0';
const $4300ebad5a984131$export$c2e91cbeada39b8b = '#B3BAC5';
const $4300ebad5a984131$export$5f71e19f3a7ad9de = '#A5ADBA';
const $4300ebad5a984131$export$eaa8c8a70ac22806 = '#97A0AF';
const $4300ebad5a984131$export$7c87d337fb91a97d = '#8993A4';
const $4300ebad5a984131$export$d6447c357493214f = '#7A869A';
const $4300ebad5a984131$export$f563ee71e9ee74cd = '#6B778C';
const $4300ebad5a984131$export$e2ef2124cf4024b1 = '#5E6C84';
const $4300ebad5a984131$export$eece5f492e429f08 = '#505F79';
const $4300ebad5a984131$export$c39c0fe0f26207ae = '#42526E';
const $4300ebad5a984131$export$7090862dc3038a9f = '#344563';
const $4300ebad5a984131$export$ad0bacf983b7ddaa = '#253858';
const $4300ebad5a984131$export$7d61b15e0da132af = '#172B4D';
const $4300ebad5a984131$export$fbda843f0a27fe96 = '#091E42';
const $4300ebad5a984131$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $4300ebad5a984131$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $4300ebad5a984131$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $4300ebad5a984131$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $4300ebad5a984131$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $4300ebad5a984131$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $4300ebad5a984131$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $4300ebad5a984131$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $4300ebad5a984131$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $4300ebad5a984131$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $4300ebad5a984131$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $4300ebad5a984131$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $4300ebad5a984131$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $4300ebad5a984131$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $4300ebad5a984131$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $4300ebad5a984131$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $4300ebad5a984131$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $4300ebad5a984131$export$2f6319cf7d736c2a = '#E6EDFA';
const $4300ebad5a984131$export$95126bc8884d6634 = '#DCE5F5';
const $4300ebad5a984131$export$8338d8c35d44ff1 = '#CED9EB';
const $4300ebad5a984131$export$5368d76ae4fbbda7 = '#B8C7E0';
const $4300ebad5a984131$export$9f0a771d16ec8d36 = '#ABBBD6';
const $4300ebad5a984131$export$abcf8c38338b4aa5 = '#9FB0CC';
const $4300ebad5a984131$export$97e81faa16a182c7 = '#8C9CB8';
const $4300ebad5a984131$export$bfe21c59123ecf33 = '#7988A3';
const $4300ebad5a984131$export$ee82aa2ea6a1558 = '#67758F';
const $4300ebad5a984131$export$682927c6ed76be02 = '#56637A';
const $4300ebad5a984131$export$91fd9994c5be9757 = '#455166';
const $4300ebad5a984131$export$d281fbfe3cff2df6 = '#3B475C';
const $4300ebad5a984131$export$3902c91d8b98a753 = '#313D52';
const $4300ebad5a984131$export$8e8133c1ba5845b5 = '#283447';
const $4300ebad5a984131$export$33ff357f6620b39 = '#202B3D';
const $4300ebad5a984131$export$633847cf062b69e0 = '#1B2638';
const $4300ebad5a984131$export$9776a6e503bdbf76 = '#121A29';
const $4300ebad5a984131$export$6c813d5160dff5db = '#0E1624';
const $4300ebad5a984131$export$3d4f271a500072a = '#0D1424';
const $4300ebad5a984131$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $4300ebad5a984131$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $4300ebad5a984131$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $4300ebad5a984131$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $4300ebad5a984131$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $4300ebad5a984131$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $4300ebad5a984131$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $4300ebad5a984131$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $4300ebad5a984131$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $4300ebad5a984131$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $4300ebad5a984131$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $4300ebad5a984131$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $4300ebad5a984131$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $4300ebad5a984131$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $4300ebad5a984131$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $4300ebad5a984131$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $4300ebad5a984131$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $4300ebad5a984131$export$d2adc5dedf09fced = '#292A2E';
const $4300ebad5a984131$export$f51762073d2bb381 = '#94C748';
const $4300ebad5a984131$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("29bV2", function(module, exports) {

$parcel$export(module.exports, "register", () => $de67ee6726340b5c$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $d8F95 = parcelRequire("d8F95");
const $de67ee6726340b5c$var$registrations = new Set();
let $de67ee6726340b5c$var$cleanupEndEventListeners = null;
function $de67ee6726340b5c$var$onDragStart() {
    if ($de67ee6726340b5c$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $de67ee6726340b5c$var$cleanupEndEventListeners = (0, $d8F95.bindAll)(window, [
        {
            type: 'dragend',
            listener: $de67ee6726340b5c$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $de67ee6726340b5c$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $de67ee6726340b5c$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($de67ee6726340b5c$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $de67ee6726340b5c$var$onDragEnd() {
    $de67ee6726340b5c$var$cleanupEndEventListeners?.();
    $de67ee6726340b5c$var$cleanupEndEventListeners = null;
    const clone = Array.from($de67ee6726340b5c$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $de67ee6726340b5c$var$bindStartEvents() {
    return (0, $d8F95.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $de67ee6726340b5c$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $de67ee6726340b5c$var$onDragStart
        }
    ]);
}
let $de67ee6726340b5c$var$cleanupStartEventListeners = null;
function $de67ee6726340b5c$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$de67ee6726340b5c$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $de67ee6726340b5c$var$cleanupStartEventListeners = $de67ee6726340b5c$var$bindStartEvents();
    $de67ee6726340b5c$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $de67ee6726340b5c$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $de67ee6726340b5c$var$registrations.delete(registration);
        if ($de67ee6726340b5c$var$registrations.size === 0) {
            $de67ee6726340b5c$var$cleanupStartEventListeners?.();
            $de67ee6726340b5c$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("8v9yf", function(module, exports) {

$parcel$export(module.exports, "show", () => $65794b5be37fefa8$export$57bf213be019eeb0);

var $fR68N = parcelRequire("fR68N");
let $65794b5be37fefa8$var$active = null;
function $65794b5be37fefa8$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($65794b5be37fefa8$var$active && $65794b5be37fefa8$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $fR68N.clearScheduled)();
            $65794b5be37fefa8$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $fR68N.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $fR68N.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $fR68N.scheduleTimeout)(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        const showImmediately = Boolean($65794b5be37fefa8$var$active && $65794b5be37fefa8$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($65794b5be37fefa8$var$active) {
            (0, $fR68N.clearScheduled)();
            $65794b5be37fefa8$var$active.entry.hide({
                isImmediate: true
            });
            $65794b5be37fefa8$var$active.entry.done();
            $65794b5be37fefa8$var$active = null;
        }
        // this tooltip is now the active tooltip
        $65794b5be37fefa8$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $fR68N.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("fR68N", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", () => $376da88e101dc401$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $376da88e101dc401$export$5f4d6617421d489b);
let $376da88e101dc401$var$delayId = null;
function $376da88e101dc401$export$eaf678f6f93f5250() {
    if ($376da88e101dc401$var$delayId != null) {
        window.clearTimeout($376da88e101dc401$var$delayId);
        $376da88e101dc401$var$delayId = null;
    }
}
function $376da88e101dc401$export$5f4d6617421d489b(fn, delay) {
    $376da88e101dc401$export$eaf678f6f93f5250();
    $376da88e101dc401$var$delayId = window.setTimeout(()=>{
        $376da88e101dc401$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("3VJDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf844e3a7d1984bc$export$2e2bcd8739ae039);

var $c0qxy = parcelRequire("c0qxy");
function $cf844e3a7d1984bc$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $c0qxy.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});

parcelRegister("5CLwS", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf8463e499a7348e$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $afneb = parcelRequire("afneb");
const $bf8463e499a7348e$var$baseStyles = null;
const $bf8463e499a7348e$var$truncateStyles = null; /**
                              * Used as the default tooltip container component for the exported `Tooltip` component.
                              * Adds some styles to the tooltip primitive.
                              */ 
const $bf8463e499a7348e$var$TooltipContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $afneb.default), {
        ref: ref,
        style: style,
        className: (0, $35pXk.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        children: children
    });
});
$bf8463e499a7348e$var$TooltipContainer.displayName = 'TooltipContainer';
var $bf8463e499a7348e$export$2e2bcd8739ae039 = $bf8463e499a7348e$var$TooltipContainer;

});
parcelRegister("afneb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a3fad30e262233e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $dTk3A = parcelRequire("dTk3A");
const $9a3fad30e262233e$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
const $9a3fad30e262233e$var$primitiveStyles = (0, $3jLHL.css)({
    zindex: `var(${$9a3fad30e262233e$var$VAR_PRIMITIVE_ZINDEX})`,
    cursor: `default`
});
/**
 * The lower level component for rendering a tooltip.
 */ const $9a3fad30e262233e$var$TooltipPrimitive = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    const styleWithZIndex = {
        ...style,
        [$9a3fad30e262233e$var$VAR_PRIMITIVE_ZINDEX]: (0, $dTk3A.layers).tooltip()
    };
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styleWithZIndex,
        "data-testid": testId ? `${testId}--wrapper` : undefined
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        role: "tooltip",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // Because the tooltip should not be focusable, there is no reason to have key events.
        /* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
        /* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
        css: $9a3fad30e262233e$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$9a3fad30e262233e$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $9a3fad30e262233e$export$2e2bcd8739ae039 = $9a3fad30e262233e$var$TooltipPrimitive;

});


parcelRegister("btyPJ", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", () => $46554e5432af7c58$export$642213d516a9b928);
function $46554e5432af7c58$export$642213d516a9b928(mouseCoordinates) {
    const safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    const getBoundingClientRect = ()=>({
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        });
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("iprY1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6152e390413c0af$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $3654r = parcelRequire("3654r");

var $f93tv = parcelRequire("f93tv");

var $c0qxy = parcelRequire("c0qxy");

var $dh538 = parcelRequire("dh538");

var $fVUfS = parcelRequire("fVUfS");

var $6F6hl = parcelRequire("6F6hl");

var $48w2z = parcelRequire("48w2z");

var $l17gy = parcelRequire("l17gy");

var $5QLlw = parcelRequire("5QLlw");
const $a6152e390413c0af$var$LOADING_LABEL = ', Loading';
const $a6152e390413c0af$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu18uv _1hmsglyw _ajmmnqa1 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhk1w7a _y4ti12x7 _bozg12x7"
};
const $a6152e390413c0af$var$defaultStyles = {
    root: "_bfhkm7j4 _syaz1fxt _10531fxt _f8pj1fxt _30l31fxt _9h8h1fxt",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr315ej _30l31fxt _1di6ip91 _9h8h1fxt",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
const $a6152e390413c0af$var$primaryStyles = {
    root: "_bfhkb29m _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3u1se _9h8h15cr _1di6qkzo"
};
const $a6152e390413c0af$var$warningStyles = {
    root: "_bfhk190i _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31i4c _9h8hal3n _1di6rj9s"
};
const $a6152e390413c0af$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di69pqq"
};
const $a6152e390413c0af$var$discoveryStyles = {
    root: "_bfhk1lri _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31w72 _9h8h15cr _1di6rb53"
};
const $a6152e390413c0af$var$subtleStyles = {
    root: "_bfhk1w7a _syaz1fxt _10531fxt _f8pj1fxt _30l31fxt _9h8h1fxt",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3166n _30l31fxt _1di61dty _9h8h1fxt",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
const $a6152e390413c0af$var$selectedStyles = {
    root: "_bfhkfg4m _syazaqb7 _1053aqb7 _f8pjaqb7 _30l3aqb7 _9h8haqb7",
    rootRefreshed: "_bfhkfg4m _syazaqb7 _8l3m1yqz _aetrb3bt _1053aqb7 _f8pjaqb7 _30l3aqb7 _9h8haqb7",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7",
    warning: "_bfhkfg4m _syazaqb7 _30l3aqb7 _irr3fg4m _9h8haqb7 _1di6fg4m",
    danger: "_bfhkfg4m _syazaqb7 _30l3aqb7 _irr3fg4m _9h8haqb7 _1di6fg4m",
    discovery: "_bfhkfg4m _syazaqb7 _30l3aqb7 _irr3fg4m _9h8haqb7 _1di6fg4m"
}; /**
    * __button base__
    *
    * - Implements auto focus when enabled.
    * - Appends the `onClick` event with UFO analytics tracking.
    *
    * @private
    */ 
const $a6152e390413c0af$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    const localRef = (0, $gwFzn.useRef)(null);
    const splitButtonContext = (0, $48w2z.useSplitButtonContext)();
    const loadingLabelId = (0, $c0qxy.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton && (0, $dh538.fg)('platform-component-visual-refresh') ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading; // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $f93tv.default)(localRef, autoFocus); // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $3654r.default)([
            localRef,
            ref
        ]),
        xcss: (0, $1Whri.cx)($a6152e390413c0af$var$styles.base, appearance === 'default' && ((0, $dh538.fg)('platform-component-visual-refresh') ? $a6152e390413c0af$var$defaultStyles.rootRefreshed : $a6152e390413c0af$var$defaultStyles.root), appearance === 'default' && isInteractive && ((0, $dh538.fg)('platform-component-visual-refresh') ? $a6152e390413c0af$var$defaultStyles.interactiveRefreshed : $a6152e390413c0af$var$defaultStyles.interactive), appearance === 'primary' && $a6152e390413c0af$var$primaryStyles.root, appearance === 'primary' && isInteractive && $a6152e390413c0af$var$primaryStyles.interactive, appearance === 'warning' && $a6152e390413c0af$var$warningStyles.root, appearance === 'warning' && isInteractive && $a6152e390413c0af$var$warningStyles.interactive, appearance === 'danger' && $a6152e390413c0af$var$dangerStyles.root, appearance === 'danger' && isInteractive && $a6152e390413c0af$var$dangerStyles.interactive, appearance === 'discovery' && $a6152e390413c0af$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $a6152e390413c0af$var$discoveryStyles.interactive, appearance === 'subtle' && ((0, $dh538.fg)('platform-component-visual-refresh') ? $a6152e390413c0af$var$subtleStyles.rootRefreshed : $a6152e390413c0af$var$subtleStyles.root), appearance === 'subtle' && isInteractive && ((0, $dh538.fg)('platform-component-visual-refresh') ? $a6152e390413c0af$var$subtleStyles.interactiveRefreshed : $a6152e390413c0af$var$subtleStyles.interactive), $a6152e390413c0af$var$styles.linkDecorationUnset, isSelected && ((0, $dh538.fg)('platform-component-visual-refresh') ? $a6152e390413c0af$var$selectedStyles.rootRefreshed : $a6152e390413c0af$var$selectedStyles.root), isSelected && isSplitButton && $a6152e390413c0af$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $a6152e390413c0af$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $a6152e390413c0af$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $a6152e390413c0af$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $a6152e390413c0af$var$selectedStyles.discovery, isDisabled && $a6152e390413c0af$var$styles.disabled, isCircle && !isSplitButton && $a6152e390413c0af$var$styles.circle, spacing === 'compact' && $a6152e390413c0af$var$styles.spacingCompact, hasIconBefore && $a6152e390413c0af$var$styles.buttonIconBefore, shouldFitContainer && $a6152e390413c0af$var$styles.fullWidth, hasIconAfter && $a6152e390413c0af$var$styles.buttonIconAfter, isIconButton && $a6152e390413c0af$var$styles.iconButton, isIconButton && spacing === 'compact' && $a6152e390413c0af$var$styles.iconButtonCompact, isLoading && $a6152e390413c0af$var$styles.loading, isSplitButton && $a6152e390413c0af$var$styles.splitButton, isNavigationSplitButton && $a6152e390413c0af$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$a6152e390413c0af$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $l17gy.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $48w2z.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                    className: (0, $35pXk.default)([
                        $a6152e390413c0af$var$styles.loadingOverlay
                    ]),
                    children: (0, $5QLlw.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6F6hl.default), {
                    id: loadingLabelId,
                    children: $a6152e390413c0af$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $a6152e390413c0af$export$2e2bcd8739ae039 = $a6152e390413c0af$var$ButtonBase;

});
parcelRegister("f93tv", function(module, exports) {

$parcel$export(module.exports, "default", () => $420664e92ad6d15c$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
function $420664e92ad6d15c$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $gwFzn.useRef)(true);
    (0, $gwFzn.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("fVUfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $008d34ae4d0e7195$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ddbVR = parcelRequire("ddbVR");

var $gxtzC = parcelRequire("gxtzC");

var $9I2p1 = parcelRequire("9I2p1");

var $ee7An = parcelRequire("ee7An");

var $90YwQ = parcelRequire("90YwQ");

var $1HnpQ = parcelRequire("1HnpQ");
const $008d34ae4d0e7195$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $008d34ae4d0e7195$var$Pressable = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $ee7An.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $gwFzn.useContext)((0, $90YwQ.default));
    const handleClick = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1HnpQ.default // @ts-expect-error we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button" // Safari does not apply focus to buttons on click like other browsers, which means click events will not be fired.
        ,
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $9I2p1.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $ddbVR.cx)($008d34ae4d0e7195$var$styles.root, isDisabled && $008d34ae4d0e7195$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});
var $008d34ae4d0e7195$export$2e2bcd8739ae039 = $008d34ae4d0e7195$var$Pressable;

});
parcelRegister("9I2p1", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $510a49780a2fe3ed$export$95df08bae54cb4df);
$parcel$export(module.exports, "isAppleDevice", () => $510a49780a2fe3ed$export$e1865c3bedcd822b);
function $510a49780a2fe3ed$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $510a49780a2fe3ed$var$isIPhone() {
    return $510a49780a2fe3ed$var$testPlatform(/^iPhone/i);
}
function $510a49780a2fe3ed$var$isMac() {
    return $510a49780a2fe3ed$var$testPlatform(/^Mac/i);
}
function $510a49780a2fe3ed$var$isIPad() {
    return $510a49780a2fe3ed$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $510a49780a2fe3ed$var$isMac() && navigator.maxTouchPoints > 1;
}
function $510a49780a2fe3ed$var$isIOS() {
    return $510a49780a2fe3ed$var$isIPhone() || $510a49780a2fe3ed$var$isIPad();
}
function $510a49780a2fe3ed$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $510a49780a2fe3ed$export$e1865c3bedcd822b() {
    return $510a49780a2fe3ed$var$isMac() || $510a49780a2fe3ed$var$isIOS();
}

});


parcelRegister("48w2z", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", () => $39cc8a8dcc98e0da$export$4b86304b2c0d7e71);
$parcel$export(module.exports, "useSplitButtonContext", () => $39cc8a8dcc98e0da$export$47e2c6fdb142d947);

var $gwFzn = parcelRequire("gwFzn");
const $39cc8a8dcc98e0da$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $39cc8a8dcc98e0da$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $gwFzn.useContext)($39cc8a8dcc98e0da$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("l17gy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ebbfb42e3816633$export$2e2bcd8739ae039);
function $2ebbfb42e3816633$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $2ebbfb42e3816633$var$tabKeyCode = 9;
function $2ebbfb42e3816633$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $2ebbfb42e3816633$var$tabKeyCode) return;
    $2ebbfb42e3816633$var$abort(event);
}
function $2ebbfb42e3816633$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $2ebbfb42e3816633$var$abort,
        onMouseUpCapture: $2ebbfb42e3816633$var$abort,
        onKeyDownCapture: $2ebbfb42e3816633$var$onKey,
        onKeyUpCapture: $2ebbfb42e3816633$var$onKey,
        onTouchStartCapture: $2ebbfb42e3816633$var$abort,
        onTouchEndCapture: $2ebbfb42e3816633$var$abort,
        onPointerDownCapture: $2ebbfb42e3816633$var$abort,
        onPointerUpCapture: $2ebbfb42e3816633$var$abort,
        onClickCapture: $2ebbfb42e3816633$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $2ebbfb42e3816633$var$abort
    } : events;
}

});

parcelRegister("5QLlw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3958ed51c10911c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $9hlns = parcelRequire("9hlns");
function $a3958ed51c10911c$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $a3958ed51c10911c$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $a3958ed51c10911c$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
        size: $a3958ed51c10911c$var$getIconSpacing(spacing),
        appearance: $a3958ed51c10911c$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("jvXSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7ab755f143e12d0$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");
parcelRequire("gwFzn");
const $b7ab755f143e12d0$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
const $b7ab755f143e12d0$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading, position: position })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        className: (0, $35pXk.default)([
            $b7ab755f143e12d0$var$styles.common,
            type === 'text' && $b7ab755f143e12d0$var$styles.text,
            type === 'icon' && $b7ab755f143e12d0$var$styles.icon,
            isLoading && $b7ab755f143e12d0$var$styles.fade,
            position === 'before' && $b7ab755f143e12d0$var$styles.beforeIcon,
            position === 'after' && $b7ab755f143e12d0$var$styles.afterIcon
        ]),
        children: children
    });
};
var $b7ab755f143e12d0$export$2e2bcd8739ae039 = $b7ab755f143e12d0$var$Content;

});

parcelRegister("6kISY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4a742c86a2d9540$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
function $c4a742c86a2d9540$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $c4a742c86a2d9540$var$IconRenderer = ({ icon: Icon })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: $c4a742c86a2d9540$var$isIconRenderProp(Icon) ? Icon({
            label: '',
            color: 'currentColor'
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
            label: "",
            color: 'currentColor'
        })
    });
};
var $c4a742c86a2d9540$export$2e2bcd8739ae039 = $c4a742c86a2d9540$var$IconRenderer;

});


parcelRegister("9QfXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $05e49d7ff5fc6a12$export$2e2bcd8739ae039);
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $d8F95 = parcelRequire("d8F95");

var $2ZsRZ = parcelRequire("2ZsRZ");

var $eFvgJ = parcelRequire("eFvgJ");

var $ei7H8 = parcelRequire("ei7H8");

var $e2ssP = parcelRequire("e2ssP");

var $lQ9rc = parcelRequire("lQ9rc");
const $05e49d7ff5fc6a12$var$getCodeBlockStyles = {
    root: "_2rkoglpi _1dqoglyw _1wyb1crf _k48pi7a9 _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhktkvp _syaz1fxt _ect41odn _1ozdn7od _7xinn7od _t7aun7od _1v15u2gc _ilvcu2gc _m29uu2gc _17wyu2gc _pn28u2gc _gz9fu2gc _1hmyegat _vblregat _vbulegat _wozj1yev _1agb1yev _lkm81yev _tv41hkgb _1hmimyb0 _1ra01n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _j1w0ww7y _13cdh2mm _15ba126e _zvy9f705 _qcxof705 _14y71a66 _j0l11wug _1weckb7n _1na21hna _1xx2grf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909m7j4 _scgayz1z _ipl81e17 _jeky1l04 _1gec1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _1552u2gc _12afu2gc _28ddu2gc _1i8zu2gc _12tu1a66 _zu0j1a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgcpf9b _bu7zpf9b _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3moej _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eiht5x2v _t9zb5x2v _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t361fxt _137bh55r _1k7d1fxt _97lipnps _12nh9lu1 _1g0517qg _i2ig10m5 _326z1fxt _113p131l _1n6tpnps _tgu817qg _1k47pnps _g0lx1fxt _ys4e131l _7gp8h55r _1yvq10m5 _1vww10m5 _1rju10m5 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o610m5 _kxov17qg _1np517qg _m2f517qg _1b9tpnps _1tq6pnps _1rd2pnps _1pbkpnps _k3lipnps _13zt131l _2g12fb2s _k86b10m5 _b5iy131l _gti3131l _1f0gpnps _9d3e17qg _qdiapnps _72uvpnps",
    showLineNumbers: "_170714ej _1i3h1txw _1huoidpf _1a9lidpf _20bqidpf _1oggidpf _bympidpf _9nnjidpf",
    dontShowLineNumbers: "_1i3h1ule _1huou2gc _1a9lu2gc _20bqu2gc _1oggu2gc _bympu2gc _9nnju2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $05e49d7ff5fc6a12$var$CodeBlock = /*#__PURE__*/ (0, $gwFzn.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $gwFzn.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $gwFzn.useState)(false);
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $ei7H8.getLineNumWidth)(numLines) : 0; // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $gwFzn.useEffect)(()=>{
        const schedule = (0, $2ZsRZ.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $d8F95.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $eFvgJ.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $gwFzn.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $gwFzn.useMemo)(()=>(0, $e2ssP.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]); // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lQ9rc.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $35pXk.default)([
            $05e49d7ff5fc6a12$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $05e49d7ff5fc6a12$var$getCodeBlockStyles.shouldWrapLongLines : $05e49d7ff5fc6a12$var$getCodeBlockStyles.dontWrapLongLines,
            showLineNumbers ? $05e49d7ff5fc6a12$var$getCodeBlockStyles.showLineNumbers : $05e49d7ff5fc6a12$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $05e49d7ff5fc6a12$export$2e2bcd8739ae039 = $05e49d7ff5fc6a12$var$CodeBlock;

});
parcelRegister("eFvgJ", function(module, exports) {

$parcel$export(module.exports, "useHighlightLines", () => $762b8efdd2f451a9$export$84415a200bdf33ed);

var $gwFzn = parcelRequire("gwFzn");
const $762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $762b8efdd2f451a9$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $762b8efdd2f451a9$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $gwFzn.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $gwFzn.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("ei7H8", function(module, exports) {

$parcel$export(module.exports, "getLineNumWidth", () => $89bf9ce5f21eb7b0$export$cb7aec0206b595d2);
const $89bf9ce5f21eb7b0$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};

});

parcelRegister("e2ssP", function(module, exports) {

$parcel$export(module.exports, "normalizeLanguage", () => $93742eb3c537aef5$export$f38728011c178796);

var $csnse = parcelRequire("csnse");

var $cTQmR = parcelRequire("cTQmR");
const $93742eb3c537aef5$export$f38728011c178796 = (0, $csnse.default)((language)=>{
    if (!language) return '';
    const match = (0, $cTQmR.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("cTQmR", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $a6db6a3439cd9017$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $a6db6a3439cd9017$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    }
];

});


parcelRegister("lQ9rc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e33420ccf6f6f193$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $fjCXq = parcelRequire("fjCXq");
var $e33420ccf6f6f193$export$2e2bcd8739ae039 = (0, $fjCXq.default);

});
parcelRegister("fjCXq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d73ab72549e3e177$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5sMDX = parcelRequire("5sMDX");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $d73ab72549e3e177$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).PureComponent {
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $7UHDa.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    AsyncHighlighter.astGenerator = null;
    AsyncHighlighter.highlightInstance = (0, $5sMDX.default);
    AsyncHighlighter.astGeneratorPromise = void 0;
    return AsyncHighlighter;
};

const $d73ab72549e3e177$var$asyncGenerator = $d73ab72549e3e177$var$generator({
    loader: ()=>(parcelRequire("dENkf")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $d73ab72549e3e177$export$2e2bcd8739ae039 = $d73ab72549e3e177$var$asyncGenerator;

});
parcelRegister("5sMDX", function(module, exports) {

$parcel$export(module.exports, "default", () => $65cd19df82755559$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $9THMM = parcelRequire("9THMM");

var $39xAV = parcelRequire("39xAV");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $65cd19df82755559$var$Highlight = /*#__PURE__*/ (0, $gwFzn.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $9THMM.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $39xAV.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $65cd19df82755559$export$2e2bcd8739ae039 = $65cd19df82755559$var$Highlight;

});
parcelRegister("9THMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $91ea43af234a8926$export$2e2bcd8739ae039);

var $5izKv = parcelRequire("5izKv");

var $gOgW3 = parcelRequire("gOgW3");

var $6RvGZ = parcelRequire("6RvGZ");

var $dA1U5 = parcelRequire("dA1U5");
const $91ea43af234a8926$var$newLineRegex = /\n/g;
function $91ea43af234a8926$var$getNewLines(str) {
    return str.match($91ea43af234a8926$var$newLineRegex);
}
function $91ea43af234a8926$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $dA1U5.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $5izKv.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $6RvGZ.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $91ea43af234a8926$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $gOgW3.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $gOgW3.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("5izKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $837f3297854d8fe5$export$2e2bcd8739ae039);

var $gOgW3 = parcelRequire("gOgW3");

var $2hcc9 = parcelRequire("2hcc9");
function $837f3297854d8fe5$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $gOgW3.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $2hcc9.default)(lineNumber));
            return children;
        }
    };
}
var $837f3297854d8fe5$export$2e2bcd8739ae039 = $837f3297854d8fe5$var$createLineGenerator;

});
parcelRegister("gOgW3", function(module, exports) {

$parcel$export(module.exports, "default", () => $09aff78a89d513cf$export$2e2bcd8739ae039);

var $2hcc9 = parcelRequire("2hcc9");
function $09aff78a89d513cf$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && showLineNumbers) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $2hcc9.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $2hcc9.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("2hcc9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c2f4afe5a9a95f7$export$2e2bcd8739ae039);
function $3c2f4afe5a9a95f7$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("6RvGZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7ca1712ff76e68a$export$2e2bcd8739ae039);

var $gOgW3 = parcelRequire("gOgW3");
function $f7ca1712ff76e68a$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $gOgW3.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $f7ca1712ff76e68a$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("dA1U5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a86ea0fafcbd9c5$export$2e2bcd8739ae039);
function $1a86ea0fafcbd9c5$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("39xAV", function(module, exports) {

$parcel$export(module.exports, "default", () => $33a0d4443c5f07c9$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dalCl = parcelRequire("dalCl");
function $33a0d4443c5f07c9$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $dalCl.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});
parcelRegister("dalCl", function(module, exports) {

$parcel$export(module.exports, "default", () => $60fb1400ee6b4dd3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $g7Pc3 = parcelRequire("g7Pc3");

var $03WRT = parcelRequire("03WRT");

var $8L2tn = parcelRequire("8L2tn");
function $60fb1400ee6b4dd3$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $60fb1400ee6b4dd3$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $03WRT.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $g7Pc3.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $8L2tn.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $60fb1400ee6b4dd3$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("g7Pc3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e34dc1cd2084e09d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");

var $lHMuy = parcelRequire("lHMuy");
function $e34dc1cd2084e09d$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: label,
        tag: $e34dc1cd2084e09d$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lHMuy.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: skipChildren ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lHMuy.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: skipChildren ? null : bidiCharacter
    });
}
const $e34dc1cd2084e09d$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("lHMuy", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $994b46f1e25bb927$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $6F6hl = parcelRequire("6F6hl");
const $994b46f1e25bb927$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $994b46f1e25bb927$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $994b46f1e25bb927$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $35pXk.default)([
                    $994b46f1e25bb927$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6F6hl.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $994b46f1e25bb927$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("03WRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $484d2d2be4c10078$export$2e2bcd8739ae039);
const $484d2d2be4c10078$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $484d2d2be4c10078$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($484d2d2be4c10078$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("8L2tn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cef41ad946a85b2e$export$2e2bcd8739ae039);

var $dalCl = parcelRequire("dalCl");
function $cef41ad946a85b2e$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $dalCl.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("dENkf", function(module, exports) {

let $9f1545d275e7a370$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9f1545d275e7a370$var$load("i0v79").then(()=>parcelRequire('hBFnY'));

});




parcelRegister("gt9HV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746afd86dff7a846534476462b8fe4e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfd6e27f4d033cc6$var$_react = $bfd6e27f4d033cc6$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $bfd6e27f4d033cc6$var$_copy = $bfd6e27f4d033cc6$var$_interopRequireDefault((parcelRequire("2MuFw")));

var $bfd6e27f4d033cc6$var$_copy2 = $bfd6e27f4d033cc6$var$_interopRequireDefault((parcelRequire("5mdwm")));
function $bfd6e27f4d033cc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bfd6e27f4d033cc6$var$CopyIcon = (props)=>/*#__PURE__*/ $bfd6e27f4d033cc6$var$_react.default.createElement($bfd6e27f4d033cc6$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $bfd6e27f4d033cc6$var$_copy2.default
    }, props));
$bfd6e27f4d033cc6$var$CopyIcon.Name = 'CopyIconMigration';
var $bfd6e27f4d033cc6$var$_default = module.exports.default = $bfd6e27f4d033cc6$var$CopyIcon;

});
parcelRegister("2MuFw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2067daa476a75158$var$_react = $2067daa476a75158$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $2067daa476a75158$var$_baseNew = $2067daa476a75158$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2067daa476a75158$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2067daa476a75158$var$CopyIcon = (props)=>/*#__PURE__*/ $2067daa476a75158$var$_react.default.createElement($2067daa476a75158$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$2067daa476a75158$var$CopyIcon.displayName = 'CopyIcon';
var $2067daa476a75158$var$_default = module.exports.default = $2067daa476a75158$var$CopyIcon;

});
parcelRegister("aSNrY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("flZlQ")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("flZlQ")).Icon);

var $flZlQ = parcelRequire("flZlQ");

});
parcelRegister("flZlQ", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $578104b7f620e843$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $578104b7f620e843$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");
const $578104b7f620e843$var$svgStyles = null;
const $578104b7f620e843$var$iconStyles = null;
const $578104b7f620e843$var$utilityIconStyles = null;
const $578104b7f620e843$var$scaleStyles = null; /**
                           * For windows high contrast mode
                           */ 
const $578104b7f620e843$var$baseHcmStyles = null;
const $578104b7f620e843$var$scaleSize = null;
const $578104b7f620e843$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $578104b7f620e843$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $578104b7f620e843$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $578104b7f620e843$var$baseSizeMap = {
    core: 16,
    utility: 12
};
const $578104b7f620e843$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
}; /**
             * __Icon__
             *
             * An icon is used as a visual representation of common actions and commands to provide context.
             *
             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
             * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
             */ 
const $578104b7f620e843$export$f04a61298a47a40f = /*#__PURE__*/ (0, $gwFzn.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, LEGACY_primaryColor: LEGACY_primaryColor, LEGACY_secondaryColor: LEGACY_secondaryColor, LEGACY_size: LEGACY_size, LEGACY_fallbackIcon: FallbackIcon, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, LEGACY_margin: LEGACY_margin, spacing: spacing = 'none' } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined; // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $dh538.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ (0, $7UHDa.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor ?? color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    const type = props.type ?? 'core';
    const size = 'size' in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === 'small' || props.size === 'medium') ? props.size : 'medium';
    const baseSize = $578104b7f620e843$var$baseSizeMap[type];
    const viewBoxPadding = $578104b7f620e843$var$paddingMap[type][size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $35pXk.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va18uv _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
            fill: "none" // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
            ,
            // we want for Icon Tile
            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, $35pXk.default)([
                "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
                shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $578104b7f620e843$var$utilSizes[spacing] : size === 'small' ? $578104b7f620e843$var$coreSizeSmall[spacing] : $578104b7f620e843$var$coreSizeMedium[spacing]
            ])
        })
    });
});
var $578104b7f620e843$export$2e2bcd8739ae039 = $578104b7f620e843$export$f04a61298a47a40f;

});



parcelRegister("5mdwm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e697ed2d81c806b$var$_react = $3e697ed2d81c806b$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $3e697ed2d81c806b$var$_copy = $3e697ed2d81c806b$var$_interopRequireDefault((parcelRequire("2MuFw")));
function $3e697ed2d81c806b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e697ed2d81c806b$var$CopyIcon = (props)=>/*#__PURE__*/ $3e697ed2d81c806b$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $3e697ed2d81c806b$var$_copy.default
    }));
$3e697ed2d81c806b$var$CopyIcon.displayName = 'CopyIcon';
var $3e697ed2d81c806b$var$_default = module.exports.default = $3e697ed2d81c806b$var$CopyIcon;

});
parcelRegister("5DTTe", function(module, exports) {

$parcel$export(module.exports, "IconFacade", () => $d270db3ee8566caf$export$3cfb73f70dfca966);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $id7ja = parcelRequire("id7ja");
const $d270db3ee8566caf$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
const $d270db3ee8566caf$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $gwFzn.memo)(function IconFacade({ dangerouslySetGlyph: dangerouslySetGlyph, size: size, ...props }) {
    const NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    const iconSize = size ?? 'medium';
    const useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $dh538.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (iconSize === 'small' || iconSize === 'medium')) {
        if (props.iconType === 'utility') {
            const Icon = NewIcon;
            return /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                ...props,
                spacing: (0, $dh538.fg)('platform-visual-refresh-icons-facade-button-fix') ? $d270db3ee8566caf$var$sizeSpacingMap['utility'][iconSize] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            });
        } else {
            const Icon = NewIcon;
            return /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                ...props,
                size: iconSize,
                spacing: $d270db3ee8566caf$var$sizeSpacingMap['core'][iconSize],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            });
        }
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.Icon), {
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size,
        ...props
    });
});

});
parcelRegister("id7ja", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $3f1a80b6c7238c21$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $3f1a80b6c7238c21$export$2e2bcd8739ae039);
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $3f1a80b6c7238c21$var$iconStyles = null;
const $3f1a80b6c7238c21$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
}; /**
    * For windows high contrast mode
    */ 
const $3f1a80b6c7238c21$var$baseHcmStyles = null;
const $3f1a80b6c7238c21$var$primaryEqualsSecondaryHcmStyles = null;
const $3f1a80b6c7238c21$var$secondaryTransparentHcmStyles = null; /**
                                             * __Icon__
                                             *
                                             * An icon is used as a visual representation of common actions and commands to provide context.
                                             *
                                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
                                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
                                             */ 
const $3f1a80b6c7238c21$export$f04a61298a47a40f = /*#__PURE__*/ (0, $gwFzn.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ (0, $7UHDa.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi3acm",
            size && $3f1a80b6c7238c21$var$sizeStyles[size]
        ])
    });
});
var $3f1a80b6c7238c21$export$2e2bcd8739ae039 = $3f1a80b6c7238c21$export$f04a61298a47a40f;

});






parcelRegister("gIsqA", function(module, exports) {

let $c2b6ce8c756db7b0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c2b6ce8c756db7b0$var$load("i5EJc"),
    $c2b6ce8c756db7b0$var$load("8qpSy")
]).then(()=>parcelRequire('9wKGM'));

});


parcelRegister("ekolh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f1092a1ad6bc55f$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $gE0s1 = parcelRequire("gE0s1");

var $5KDDn = parcelRequire("5KDDn");

var $gxtzC = parcelRequire("gxtzC");

var $4kfV4 = parcelRequire("4kfV4");

var $ee7An = parcelRequire("ee7An");

var $iug2J = parcelRequire("iug2J");

var $fT2ta = parcelRequire("fT2ta");

var $caX7N = parcelRequire("caX7N");

var $dTk3A = parcelRequire("dTk3A");

var $amR5O = parcelRequire("amR5O");

var $bZ1JU = parcelRequire("bZ1JU");

var $bDzqh = parcelRequire("bDzqh");
const $9f1092a1ad6bc55f$var$fillScreenStyles = null;
const $9f1092a1ad6bc55f$var$allowlistElements = (element, callback)=>{
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
     // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
}; /**
    * __Modal wrapper__
    *
    * A modal wrapper displays content that requires user interaction, in a layer above the page.
    * This component is primary container for other modal components.
    *
    * - [Examples](https://atlassian.design/components/modal-dialog/examples)
    * - [Code](https://atlassian.design/components/modal-dialog/code)
    * - [Usage](https://atlassian.design/components/modal-dialog/usage)
    */ 
const $9f1092a1ad6bc55f$var$ModalWrapper = (props)=>{
    const { autoFocus: autoFocus = true, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $ee7An.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId } = props;
    const calculatedStackIndex = (0, $bZ1JU.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0; // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    const autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    const onCloseHandler = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $ee7An.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onBlanketClicked = (0, $gwFzn.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]); // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    const allowListCallback = (0, $gwFzn.useCallback)((element)=>$9f1092a1ad6bc55f$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]);
    (0, $bDzqh.default)();
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4kfV4.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $amR5O.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: Boolean(providedOnClose),
            children: children
        })
    });
    let returnFocus = true;
    let onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            shouldReturnFocus.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iug2J.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $caX7N.default), {
            zIndex: (0, $dTk3A.layers).modal(),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fT2ta.default), {
                children: (fadeInProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        ...fadeInProps,
                        className: (0, $35pXk.default)([
                            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                            fadeInProps.className
                        ]),
                        "aria-hidden": !isForeground,
                        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gE0s1.default), {
                            autoFocus: autoFocusLock,
                            returnFocus: returnFocus,
                            onDeactivation: onDeactivation,
                            whiteList: allowListCallback,
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5KDDn))), {}),
                                shouldScrollInViewport ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5KDDn.TouchScrollable), {
                                    children: modalDialogWithBlanket
                                }) : modalDialogWithBlanket
                            ]
                        })
                    })
            })
        })
    });
};
var $9f1092a1ad6bc55f$export$2e2bcd8739ae039 = $9f1092a1ad6bc55f$var$ModalWrapper;

});
parcelRegister("4kfV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0a8596802612558$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $gxtzC = parcelRequire("gxtzC");

var $ee7An = parcelRequire("ee7An");
const $e0a8596802612558$var$packageName = "platform-pkg";
const $e0a8596802612558$var$packageVersion = "0.0.0-use.local";
const $e0a8596802612558$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $e0a8596802612558$var$packageName,
    packageVersion: $e0a8596802612558$var$packageVersion
};
const $e0a8596802612558$var$baseStyles = null;
const $e0a8596802612558$var$shouldAllowClickThroughStyles = null;
const $e0a8596802612558$var$invisibleStyles = null; /**
                               * __Blanket__
                               *
                               * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
                               *
                               * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
                               */ 
const $e0a8596802612558$var$Blanket = /*#__PURE__*/ (0, $gwFzn.memo)(/*#__PURE__*/ (0, $gwFzn.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $ee7An.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $gwFzn.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$e0a8596802612558$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $gwFzn.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $gwFzn.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $35pXk.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk10xm _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk18uv"
        ]),
        children: children
    });
}));
$e0a8596802612558$var$Blanket.displayName = 'Blanket';
var $e0a8596802612558$export$2e2bcd8739ae039 = $e0a8596802612558$var$Blanket;

});

parcelRegister("iug2J", function(module, exports) {

$parcel$export(module.exports, "LevelContext", () => $eabb819e9bea5c4b$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "TopLevelContext", () => $eabb819e9bea5c4b$export$48b383b280e20440);
$parcel$export(module.exports, "Layering", () => $eabb819e9bea5c4b$export$7c885f891c940977);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");

var $dh538 = parcelRequire("dh538");
const $eabb819e9bea5c4b$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $gwFzn.createContext)(0);
const $eabb819e9bea5c4b$export$48b383b280e20440 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $ee7An.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ const $eabb819e9bea5c4b$var$LevelProvider = ({ children: children, currentLevel: currentLevel })=>{
    const { setTopLevel: setTopLevel, topLevelRef: topLevelRef, layerList: layerList } = (0, $gwFzn.useContext)($eabb819e9bea5c4b$export$48b383b280e20440);
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const id = (0, $gwFzn.useRef)((0, $dh538.fg)('layering-top-level-use-array') ? Math.random().toString(36) : '');
    if (!(0, $dh538.fg)('layering-top-level-use-array')) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $dh538.fg)('layering-top-level-use-array')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(()=>{
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $dh538.fg)('layering-top-level-use-array')) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $gwFzn.useEffect)(()=>{
        const safeLayerList = layerList?.current;
        const safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return ()=>{
            const index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($eabb819e9bea5c4b$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel,
        children: children
    });
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ const $eabb819e9bea5c4b$var$LayeringProvider = ({ children: children })=>{
    const topLevelRef = (0, $gwFzn.useRef)(0);
    const layerList = (0, $gwFzn.useRef)([]);
    const value = (0, $gwFzn.useMemo)(()=>({
            topLevelRef: topLevelRef,
            setTopLevel: (level)=>{
                topLevelRef.current = level;
            },
            ...(0, $dh538.fg)('layering-top-level-use-array') ? {
                layerList: layerList
            } : {}
        }), [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($eabb819e9bea5c4b$export$48b383b280e20440.Provider, {
        value: value,
        children: children
    });
};
const $eabb819e9bea5c4b$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $gwFzn.useContext)($eabb819e9bea5c4b$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $7UHDa.jsx)($eabb819e9bea5c4b$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $7UHDa.jsx)($eabb819e9bea5c4b$var$LayeringProvider, {
        children: content
    });
};

});

parcelRegister("amR5O", function(module, exports) {

$parcel$export(module.exports, "default", () => $501b75a1e057a3f1$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $3654r = parcelRequire("3654r");

var $f93tv = parcelRequire("f93tv");

var $c0qxy = parcelRequire("c0qxy");

var $16xFS = parcelRequire("16xFS");

var $fT2ta = parcelRequire("fT2ta");
parcelRequire("bSjaC");
var $bSwyQ = parcelRequire("bSwyQ");

var $dbEzH = parcelRequire("dbEzH");

var $8Gxfa = parcelRequire("8Gxfa");

var $2MqmU = parcelRequire("2MqmU");

var $gSjzW = parcelRequire("gSjzW");

var $WPNvU = parcelRequire("WPNvU");

var $5IMYZ = parcelRequire("5IMYZ");

var $7WBHn = parcelRequire("7WBHn");
const $501b75a1e057a3f1$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $501b75a1e057a3f1$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syaz1fxt _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1p6i _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y _epkx1sit _we1i1kw7 _zg7p1cd0 _yakv1kw7 _4lht1kw7 _1xlt6m9r"
};
const $501b75a1e057a3f1$var$viewportScrollStyles = null;
const $501b75a1e057a3f1$var$bodyScrollStyles = null;
const $501b75a1e057a3f1$var$ModalDialog = (props)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId } = props;
    const id = (0, $c0qxy.useId)();
    const titleId = `modal-dialog-title-${id}`;
    (0, $gwFzn.useEffect)(()=>{
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $bSwyQ.combine)((0, $2MqmU.disableDraggingToCrossOriginIFramesForElement)(), (0, $WPNvU.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $gSjzW.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $f93tv.default)(typeof autoFocus === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $8Gxfa.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $gwFzn.useMemo)(()=>({
            testId: testId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose
        }), [
        testId,
        titleId,
        onClose,
        hasProvidedOnClose
    ]);
    (0, $16xFS.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7WBHn.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dbEzH.ModalContext).Provider, {
            value: modalDialogContext,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dbEzH.ScrollContext).Provider, {
                value: shouldScrollInViewport,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fT2ta.default), {
                    entranceDirection: "bottom",
                    onFinish: onMotionFinish,
                    children: (bottomFadeInProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)("section", {
                            ...bottomFadeInProps,
                            "aria-label": label,
                            ref: (0, $3654r.default)([
                                bottomFadeInProps.ref,
                                motionRef
                            ]),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-width': (0, $5IMYZ.dialogWidth)(width),
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-height': (0, $5IMYZ.dialogHeight)(height)
                            },
                            className: (0, $35pXk.default)([
                                $501b75a1e057a3f1$var$dialogStyles.root,
                                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                                bottomFadeInProps.className
                            ]),
                            role: "dialog",
                            "aria-labelledby": label ? undefined : titleId,
                            "data-testid": testId,
                            "data-modal-stack": stackIndex,
                            tabIndex: -1,
                            "aria-modal": true,
                            "data-ds--level": currentLevel,
                            children: children
                        })
                })
            })
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $501b75a1e057a3f1$export$2e2bcd8739ae039 = $501b75a1e057a3f1$var$ModalDialog;

});
parcelRegister("16xFS", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", () => $abe89ff2765d17a5$export$4a4bf067ea9e7886);
$parcel$export(module.exports, "useLayering", () => $abe89ff2765d17a5$export$c8b4d54e03dee6ed);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $dh538 = parcelRequire("dh538");

var $iug2J = parcelRequire("iug2J");
const $abe89ff2765d17a5$var$ESCAPE = 'Escape';
function $abe89ff2765d17a5$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $gwFzn.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = $abe89ff2765d17a5$export$c8b4d54e03dee6ed();
    const onKeyDown = (0, $gwFzn.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $abe89ff2765d17a5$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $gwFzn.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        return (0, $d8F95.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $abe89ff2765d17a5$export$c8b4d54e03dee6ed() {
    const currentLevel = (0, $gwFzn.useContext)((0, $iug2J.LevelContext));
    const { topLevelRef: topLevelRef, layerList: layerList } = (0, $gwFzn.useContext)((0, $iug2J.TopLevelContext));
    const isLayerDisabled = (0, $gwFzn.useCallback)(()=>{
        if ((0, $dh538.fg)('layering-top-level-use-array')) return (layerList?.current?.length ?? 0) !== currentLevel;
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled,
        ...(0, $dh538.fg)('layering-top-level-use-array') ? {
            layerList: layerList
        } : {}
    };
}

});

parcelRegister("bSjaC", function(module, exports) {

$parcel$export(module.exports, "combine", () => (parcelRequire("bSwyQ")).combine);

var $bSwyQ = parcelRequire("bSwyQ");

});
parcelRegister("bSwyQ", function(module, exports) {

$parcel$export(module.exports, "combine", () => $7f85d759c07fedff$export$1be1fc439b849fdf);
function $7f85d759c07fedff$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});


parcelRegister("dbEzH", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $f53f8c78f8ced4bf$export$ab57792b9b6974a6);
$parcel$export(module.exports, "ScrollContext", () => $f53f8c78f8ced4bf$export$dece24112a937f92);

var $gwFzn = parcelRequire("gwFzn");
const $f53f8c78f8ced4bf$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $gwFzn.createContext)(null);
const $f53f8c78f8ced4bf$export$dece24112a937f92 = /*#__PURE__*/ (0, $gwFzn.createContext)(null);

});

parcelRegister("8Gxfa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f69e1ddc60a15e0f$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
function $f69e1ddc60a15e0f$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $gwFzn.useRef)(null);
    const onMotionFinish = (0, $gwFzn.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("2MqmU", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $78cd79ed3224f00a$export$ec28e97c7d8b1b35);

var $d8F95 = parcelRequire("d8F95");
parcelRequire("bSjaC");
var $bSwyQ = parcelRequire("bSwyQ");
parcelRequire("4T4vf");
var $3CnSH = parcelRequire("3CnSH");

var $2yxa5 = parcelRequire("2yxa5");
function $78cd79ed3224f00a$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $d8F95.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $3CnSH.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $bSwyQ.combine)(unbindEvents, unbindMonitor);
}
function $78cd79ed3224f00a$var$watchForInteractionStart({ start: start }) {
    return (0, $d8F95.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $78cd79ed3224f00a$var$api = (0, $2yxa5.makeFixForAdapter)({
    watchForInteractionStart: $78cd79ed3224f00a$var$watchForInteractionStart,
    watchForInteractionEnd: $78cd79ed3224f00a$var$watchForInteractionEnd
});
function $78cd79ed3224f00a$export$ec28e97c7d8b1b35() {
    return $78cd79ed3224f00a$var$api.registerUsage();
}

});
parcelRegister("4T4vf", function(module, exports) {

$parcel$export(module.exports, "draggable", () => (parcelRequire("3CnSH")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("3CnSH")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("3CnSH")).monitorForElements);

var $3CnSH = parcelRequire("3CnSH");

});
parcelRegister("3CnSH", function(module, exports) {

$parcel$export(module.exports, "dropTargetForElements", () => $12f499d4dfb562d1$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $12f499d4dfb562d1$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $12f499d4dfb562d1$export$c746a5152d4ba26c);

var $d8F95 = parcelRequire("d8F95");

var $66utD = parcelRequire("66utD");

var $75LZI = parcelRequire("75LZI");

var $iKd0N = parcelRequire("iKd0N");

var $bSwyQ = parcelRequire("bSwyQ");

var $gz7GF = parcelRequire("gz7GF");

var $ic3Jg = parcelRequire("ic3Jg");

var $btsNM = parcelRequire("btsNM");

var $k5wZ1 = parcelRequire("k5wZ1");

var $4Z1c2 = parcelRequire("4Z1c2");

var $839Yz = parcelRequire("839Yz");
const $12f499d4dfb562d1$var$draggableRegistry = new WeakMap();
function $12f499d4dfb562d1$var$addToRegistry(args) {
    $12f499d4dfb562d1$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $12f499d4dfb562d1$var$draggableRegistry.delete(args.element);
    };
}
const $12f499d4dfb562d1$var$honeyPotFix = (0, $75LZI.makeHoneyPotFix)();
const $12f499d4dfb562d1$var$adapter = (0, $iKd0N.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, $bSwyQ.combine)($12f499d4dfb562d1$var$honeyPotFix.bindEvents(), (0, $d8F95.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                const entry = $12f499d4dfb562d1$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
					 * A text selection drag _can_ have the `draggable` element be
					 * the `event.target` if the user is dragging the text selection
					 * from the `draggable`.
					 *
					 * To know if the `draggable` is being dragged, we look at whether any
					 * `"text/plain"` data is being dragged. If it is, then a text selection
					 * drag is occurring.
					 *
					 * This behaviour has been validated on:
					 *
					 * - Chrome@128 on Android@14
					 * - Chrome@128 on iOS@17.6.1
					 * - Chrome@128 on Windows@11
					 * - Chrome@128 on MacOS@14.6.1
					 * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
					 * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
					 *
					 * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
					 * but unfortunately ProseMirror is always setting `""` as the dragged text
					 *
					 * Note: Unfortunately editor is (heavily) leaning on the current functionality today
					 * and unwinding it will be a decent amount of effort. So for now, a text selection
					 * where the `event.target` is a `draggable` element will still trigger the
					 * element adapter.
					 *
					 * // Future state:
					 * if(event.dataTransfer.getData(textMediaType)) {
					 * 	return;
					 * }
					 *
					 */ const input = (0, $btsNM.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $66utD.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
					 *  **Goal**
					 *  Pass information to other applications
					 *
					 * **Approach**
					 *  Put data into the native data store
					 *
					 *  **What about the native adapter?**
					 *  When the element adapter puts native data into the native data store
					 *  the native adapter is not triggered in the current window,
					 *  but a native adapter in an external window _can_ be triggered
					 *
					 *  **Why bake this into core?**
					 *  This functionality could be pulled out and exposed inside of
					 *  `onGenerateDragPreview`. But decided to make it a part of the
					 *  base API as it felt like a common enough use case and ended
					 *  up being a similar amount of code to include this function as
					 *  it was to expose the hook for it
					 */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
					 *  📱 For Android devices, a drag operation will not start unless
					 * "text/plain" or "text/uri-list" data exists in the native data store
					 * https://twitter.com/alexandereardon/status/1732189803754713424
					 *
					 * Tested on:
					 * Device: Google Pixel 5
					 * Android version: 14 (November 5, 2023)
					 * Chrome version: 120.0
					 */ if ((0, $ic3Jg.isAndroid)() && !event.dataTransfer.types.includes((0, $k5wZ1.textMediaType)) && !event.dataTransfer.types.includes((0, $4Z1c2.URLMediaType))) event.dataTransfer.setData((0, $k5wZ1.textMediaType), (0, $ic3Jg.androidFallbackText));
                /**
					 * 1. Must set any media type for `iOS15` to work
					 * 2. We are also doing adding data so that the native adapter
					 * can know that the element adapter has handled this drag
					 *
					 * We used to wrap this `setData()` in a `try/catch` for Firefox,
					 * but it looks like that was not needed.
					 *
					 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
					 *
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
					 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
					 *
					 * // just checking a few more combinations to be super safe
					 *
					 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
					 * - ✅ Chrome@78 (Oct 2019) on Windows 10
					 * - ✅ Safari@14.1 on macOS Big Sur
					 */ event.dataTransfer.setData((0, $839Yz.elementAdapterNativeDataKey), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $12f499d4dfb562d1$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $12f499d4dfb562d1$var$honeyPotFix.getOnPostDispatch()
});
const $12f499d4dfb562d1$export$e7140b68045b5036 = $12f499d4dfb562d1$var$adapter.dropTarget;
const $12f499d4dfb562d1$export$59a074bac4c54f54 = $12f499d4dfb562d1$var$adapter.monitor;
function $12f499d4dfb562d1$export$c746a5152d4ba26c(args) {
    return (0, $bSwyQ.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $12f499d4dfb562d1$var$adapter.registerUsage(), $12f499d4dfb562d1$var$addToRegistry(args), (0, $gz7GF.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
}

});
parcelRegister("66utD", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $da7bea83c5260f30$export$81d0353f25f5dd);

var $i4gTI = parcelRequire("i4gTI");
function $da7bea83c5260f30$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $i4gTI.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("i4gTI", function(module, exports) {

$parcel$export(module.exports, "isHoneyPotElement", () => $cc37bf7dc6df308f$export$821bdcd739a2706b);

var $88g2N = parcelRequire("88g2N");
function $cc37bf7dc6df308f$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $88g2N.honeyPotDataAttribute));
}

});
parcelRegister("88g2N", function(module, exports) {

$parcel$export(module.exports, "honeyPotDataAttribute", () => $6a5f6bb656991b60$export$6eafea55f7947469);
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $6a5f6bb656991b60$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("75LZI", function(module, exports) {

$parcel$export(module.exports, "makeHoneyPotFix", () => $c27b859847955e76$export$8ecad27c959e89e0);

var $d8F95 = parcelRequire("d8F95");

var $f7qXf = parcelRequire("f7qXf");

var $88g2N = parcelRequire("88g2N");
const $c27b859847955e76$var$honeyPotSize = 2;
const $c27b859847955e76$var$halfHoneyPotSize = $c27b859847955e76$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $c27b859847955e76$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $c27b859847955e76$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $c27b859847955e76$var$halfHoneyPotSize,
        y: point.y - $c27b859847955e76$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $c27b859847955e76$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $c27b859847955e76$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $c27b859847955e76$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $c27b859847955e76$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $c27b859847955e76$var$getHoneyPotRectFor({ client: client }) {
    const point = $c27b859847955e76$var$preventGoingForwardsOffScreen($c27b859847955e76$var$preventGoingBackwardsOffScreen($c27b859847955e76$var$pullBackByHalfHoneyPotSize($c27b859847955e76$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $c27b859847955e76$var$honeyPotSize,
        height: $c27b859847955e76$var$honeyPotSize
    });
}
function $c27b859847955e76$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $c27b859847955e76$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $c27b859847955e76$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $88g2N.honeyPotDataAttribute), 'true');
    // can shift during the drag thanks to Firefox
    let clientRect = $c27b859847955e76$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        ...$c27b859847955e76$var$getRectStyles({
            clientRect: clientRect
        }),
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $f7qXf.maxZIndex)
    });
    document.body.appendChild(element);
    /**
	 *  🦊 In firefox we can get `"pointermove"` events after the drag
	 * has started, which is a spec violation.
	 * The final `"pointermove"` will reveal where the "depressed" position
	 * is for our honey pot fix.
	 */ const unbindPointerMove = (0, $d8F95.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $c27b859847955e76$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $c27b859847955e76$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($c27b859847955e76$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $d8F95.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $c27b859847955e76$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $d8F95.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $c27b859847955e76$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                const { input: input } = payload.location.current;
                finish?.({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("f7qXf", function(module, exports) {

$parcel$export(module.exports, "maxZIndex", () => $3e3de3bfe64952da$export$7d0a15ee70427305);
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $3e3de3bfe64952da$export$7d0a15ee70427305 = 2147483647;

});


parcelRegister("iKd0N", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", () => $6879436595dbe2c5$export$2aa3a33160990d96);

var $gnzSa = parcelRequire("gnzSa");

var $NVvMh = parcelRequire("NVvMh");

var $3YPrz = parcelRequire("3YPrz");

var $cuaz9 = parcelRequire("cuaz9");
function $6879436595dbe2c5$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $cuaz9.makeMonitor)();
    const dropTargetAPI = (0, $3YPrz.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch?.(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $gnzSa.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $gnzSa.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $NVvMh.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("gnzSa", function(module, exports) {

$parcel$export(module.exports, "lifecycle", () => $2d31ea8c6d57dfbd$export$3efdceeb8ca25c51);

var $d8F95 = parcelRequire("d8F95");

var $66utD = parcelRequire("66utD");

var $i4gTI = parcelRequire("i4gTI");

var $jzO5W = parcelRequire("jzO5W");

var $cmcCB = parcelRequire("cmcCB");

var $btsNM = parcelRequire("btsNM");

var $iMQqx = parcelRequire("iMQqx");
const $2d31ea8c6d57dfbd$var$globalState = {
    isActive: false
};
function $2d31ea8c6d57dfbd$var$canStart() {
    return !$2d31ea8c6d57dfbd$var$globalState.isActive;
}
function $2d31ea8c6d57dfbd$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $2d31ea8c6d57dfbd$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $2d31ea8c6d57dfbd$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$2d31ea8c6d57dfbd$var$canStart()) return;
    const initial = $2d31ea8c6d57dfbd$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $2d31ea8c6d57dfbd$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $2d31ea8c6d57dfbd$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $iMQqx.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $2d31ea8c6d57dfbd$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $btsNM.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $i4gTI.isHoneyPotElement)(event.target) ? (0, $66utD.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $2d31ea8c6d57dfbd$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $2d31ea8c6d57dfbd$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $d8F95.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $jzO5W.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $btsNM.getInput)(event)
                };
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $2d31ea8c6d57dfbd$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $btsNM.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $cmcCB.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $2d31ea8c6d57dfbd$var$getNativeSetDragImage(event)
    });
}
function $2d31ea8c6d57dfbd$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $2d31ea8c6d57dfbd$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $btsNM.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $2d31ea8c6d57dfbd$export$3efdceeb8ca25c51 = {
    canStart: $2d31ea8c6d57dfbd$var$canStart,
    start: $2d31ea8c6d57dfbd$var$start
};

});
parcelRegister("jzO5W", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", () => $7c20fd3bac90876e$export$57d220c74e84a273);

var $1iOCV = parcelRequire("1iOCV");

var $e880Z = parcelRequire("e880Z");

var $2NDLX = parcelRequire("2NDLX");

var $beiUR = parcelRequire("beiUR");
function $7c20fd3bac90876e$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $e880Z.isSafari)()) return (0, $2NDLX.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, $1iOCV.isFirefox)()) return (0, $beiUR.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("1iOCV", function(module, exports) {

$parcel$export(module.exports, "isFirefox", () => $6601d783db69824e$export$b7d78993b74f766d);

var $aYpzB = parcelRequire("aYpzB");
const $6601d783db69824e$export$b7d78993b74f766d = (0, $aYpzB.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("aYpzB", function(module, exports) {

$parcel$export(module.exports, "once", () => $d20a69cade0a9ae7$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $d20a69cade0a9ae7$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("e880Z", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $381be54fdfb26235$export$95df08bae54cb4df);

var $aYpzB = parcelRequire("aYpzB");
const $381be54fdfb26235$export$95df08bae54cb4df = (0, $aYpzB.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("2NDLX", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindowInSafari", () => $9d9b82cee26a251c$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $9d9b82cee26a251c$export$f21837c338005454);

var $d8F95 = parcelRequire("d8F95");

var $e880Z = parcelRequire("e880Z");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $9d9b82cee26a251c$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $9d9b82cee26a251c$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $e880Z.isSafari)()) return false;
    return dragEnter.hasOwnProperty($9d9b82cee26a251c$var$symbols.isEnteringWindow);
}
function $9d9b82cee26a251c$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $e880Z.isSafari)()) return false;
    return dragLeave.hasOwnProperty($9d9b82cee26a251c$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $e880Z.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $d8F95.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$9d9b82cee26a251c$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$9d9b82cee26a251c$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("beiUR", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", () => $ffeb788f65f8276d$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $ffeb788f65f8276d$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $ffeb788f65f8276d$export$e46810fef53b5b0e(eventTarget) {
    return $ffeb788f65f8276d$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("cmcCB", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $86d2bbe13c882731$export$ac5e5b0daf997b2);
function $86d2bbe13c882731$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("btsNM", function(module, exports) {

$parcel$export(module.exports, "getInput", () => $f6ca35f3a0236545$export$7c112ceec8941e67);
function $f6ca35f3a0236545$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("iMQqx", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", () => $efd469c0d961735f$export$9f13ecc44e83d682);

var $2ZsRZ = parcelRequire("2ZsRZ");
const $efd469c0d961735f$var$scheduleOnDrag = (0, $2ZsRZ.default)((fn)=>fn());
const $efd469c0d961735f$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $efd469c0d961735f$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $efd469c0d961735f$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $efd469c0d961735f$var$dragStart.flush();
            $efd469c0d961735f$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $efd469c0d961735f$var$scheduleOnDrag(()=>{
                $efd469c0d961735f$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $efd469c0d961735f$var$dragStart.flush();
            $efd469c0d961735f$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("NVvMh", function(module, exports) {

$parcel$export(module.exports, "register", () => $84e48945a397d5d8$export$6503ec6e8aabbaf);
const $84e48945a397d5d8$var$ledger = new Map();
function $84e48945a397d5d8$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $84e48945a397d5d8$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $84e48945a397d5d8$var$ledger.set(typeKey, initial);
    return initial;
}
function $84e48945a397d5d8$export$6503ec6e8aabbaf(args) {
    const entry = $84e48945a397d5d8$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $84e48945a397d5d8$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("3YPrz", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", () => $087df2c0a749e1c4$export$47d10e7bd9c81890);

var $bSwyQ = parcelRequire("bSwyQ");

var $gz7GF = parcelRequire("gz7GF");
function $087df2c0a749e1c4$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $087df2c0a749e1c4$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        return (0, $bSwyQ.combine)((0, $gz7GF.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $087df2c0a749e1c4$var$copyReverse(current);
        const actualCaptureOrdered = $087df2c0a749e1c4$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $087df2c0a749e1c4$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("gz7GF", function(module, exports) {

$parcel$export(module.exports, "addAttribute", () => $f6f79f7ab00b23b4$export$5dcb5c23b6ba980a);
function $f6f79f7ab00b23b4$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("cuaz9", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", () => $38c2157c450658b9$export$5dd4ed888d5b12ca);
function $38c2157c450658b9$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        return function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        };
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("ic3Jg", function(module, exports) {

$parcel$export(module.exports, "isAndroid", () => $283520dac20c3817$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $283520dac20c3817$export$aceb3ed8b7f7bd2c);

var $aYpzB = parcelRequire("aYpzB");
const $283520dac20c3817$export$a11b0059900ceec8 = (0, $aYpzB.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $283520dac20c3817$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("k5wZ1", function(module, exports) {

$parcel$export(module.exports, "textMediaType", () => $dabd2dc172f154c6$export$fd3d00026297c0ad);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $dabd2dc172f154c6$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("4Z1c2", function(module, exports) {

$parcel$export(module.exports, "URLMediaType", () => $e7958150b312f60f$export$4c44a460f123106);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $e7958150b312f60f$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("839Yz", function(module, exports) {

$parcel$export(module.exports, "elementAdapterNativeDataKey", () => $c77f43d403723972$export$c9c4cc54e73b125d);
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $c77f43d403723972$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});



parcelRegister("2yxa5", function(module, exports) {

$parcel$export(module.exports, "makeFixForAdapter", () => $bb116833379cde15$export$a74bff2507e6126b);
parcelRequire("bSjaC");
var $bSwyQ = parcelRequire("bSwyQ");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $bb116833379cde15$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $bb116833379cde15$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $bb116833379cde15$var$isIframeOnAnotherDomain(iframe) {
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
	 */ if (iframe.srcdoc) return false;
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
	 */ if (iframe.src.startsWith('data:')) return false;
    return !$bb116833379cde15$var$hasSameOrigin(window.location.href, iframe.src);
}
const $bb116833379cde15$var$registry = new Map();
function $bb116833379cde15$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($bb116833379cde15$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $bb116833379cde15$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $bb116833379cde15$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $bb116833379cde15$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $bb116833379cde15$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $bSwyQ.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $bb116833379cde15$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $bb116833379cde15$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart?.();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("gSjzW", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $9fb9b53f53535bce$export$27d79116d3a4e7d5);
parcelRequire("feJ8f");
var $7J9Bb = parcelRequire("7J9Bb");

var $2yxa5 = parcelRequire("2yxa5");
function $9fb9b53f53535bce$var$watchForInteractionStart({ start: start }) {
    return (0, $7J9Bb.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $9fb9b53f53535bce$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $7J9Bb.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $9fb9b53f53535bce$var$api = (0, $2yxa5.makeFixForAdapter)({
    watchForInteractionStart: $9fb9b53f53535bce$var$watchForInteractionStart,
    watchForInteractionEnd: $9fb9b53f53535bce$var$watchForInteractionEnd
});
function $9fb9b53f53535bce$export$27d79116d3a4e7d5() {
    return $9fb9b53f53535bce$var$api.registerUsage();
}

});
parcelRegister("feJ8f", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("7J9Bb")).monitorForExternal);
$parcel$export(module.exports, "dropTargetForExternal", () => (parcelRequire("7J9Bb")).dropTargetForExternal);

var $7J9Bb = parcelRequire("7J9Bb");

});
parcelRegister("7J9Bb", function(module, exports) {

$parcel$export(module.exports, "dropTargetForExternal", () => $6614ade0e20d66dc$export$9edc779df9a85289);
$parcel$export(module.exports, "monitorForExternal", () => $6614ade0e20d66dc$export$bb1740f3194979c1);

var $d8F95 = parcelRequire("d8F95");

var $iKd0N = parcelRequire("iKd0N");

var $ic3Jg = parcelRequire("ic3Jg");

var $6XPHb = parcelRequire("6XPHb");

var $cmcCB = parcelRequire("cmcCB");

var $k5wZ1 = parcelRequire("k5wZ1");

var $839Yz = parcelRequire("839Yz");
function $6614ade0e20d66dc$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $839Yz.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $k5wZ1.textMediaType) && value === (0, $ic3Jg.androidFallbackText)) return false;
    return true;
}
function $6614ade0e20d66dc$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>$6614ade0e20d66dc$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        }));
}
function $6614ade0e20d66dc$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || $6614ade0e20d66dc$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}
let $6614ade0e20d66dc$var$didDragStartLocally = false;
const $6614ade0e20d66dc$var$adapter = (0, $iKd0N.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $d8F95.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($6614ade0e20d66dc$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $6XPHb.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = $6614ade0e20d66dc$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = $6614ade0e20d66dc$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$6614ade0e20d66dc$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $6614ade0e20d66dc$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $6614ade0e20d66dc$var$adapter.dropTarget(args);
}
function $6614ade0e20d66dc$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $6614ade0e20d66dc$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $6614ade0e20d66dc$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $6614ade0e20d66dc$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $d8F95.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $cmcCB.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $d8F95.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $6614ade0e20d66dc$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("6XPHb", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindow", () => $7e1eb1dda9dbff10$export$d1c6f249e893cdf4);

var $1iOCV = parcelRequire("1iOCV");

var $e880Z = parcelRequire("e880Z");

var $2NDLX = parcelRequire("2NDLX");

var $beiUR = parcelRequire("beiUR");
function $7e1eb1dda9dbff10$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $e880Z.isSafari)()) return (0, $2NDLX.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is an element inside the child `iframe`
	 * (foreign element)
	 */ if ((0, $1iOCV.isFirefox)()) return (0, $beiUR.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is `null` *(standard check)*
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});




parcelRegister("WPNvU", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $7c91e8e518750b75$export$9c0606fcefb5d1e2);

var $d8F95 = parcelRequire("d8F95");
parcelRequire("bSjaC");
var $bSwyQ = parcelRequire("bSwyQ");
parcelRequire("fNPGC");
var $894UW = parcelRequire("894UW");

var $2yxa5 = parcelRequire("2yxa5");
function $7c91e8e518750b75$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $d8F95.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
					 * The pdnd `onDragStart()` fires in the frame after "dragstart"
					 * So we are delaying our isDragging check to give a chance
					 * for `onDragStart()` to set the value correctly.
					 *
					 * Note: could not use "pointercancel" as it is not
					 * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
					 */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $894UW.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $bSwyQ.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $7c91e8e518750b75$var$watchForInteractionStart({ start: start }) {
    return (0, $d8F95.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $7c91e8e518750b75$var$api = (0, $2yxa5.makeFixForAdapter)({
    watchForInteractionStart: $7c91e8e518750b75$var$watchForInteractionStart,
    watchForInteractionEnd: $7c91e8e518750b75$var$watchForInteractionEnd
});
function $7c91e8e518750b75$export$9c0606fcefb5d1e2() {
    return $7c91e8e518750b75$var$api.registerUsage();
}

});
parcelRegister("fNPGC", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("894UW")).monitorForTextSelection);

var $894UW = parcelRequire("894UW");

});
parcelRegister("894UW", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", () => $3c235b63087ea285$export$2e178e3647f5e6e9);

var $d8F95 = parcelRequire("d8F95");

var $75LZI = parcelRequire("75LZI");

var $iKd0N = parcelRequire("iKd0N");

var $bSwyQ = parcelRequire("bSwyQ");

var $e880Z = parcelRequire("e880Z");

var $k2XPN = parcelRequire("k2XPN");

var $k5wZ1 = parcelRequire("k5wZ1");

var $839Yz = parcelRequire("839Yz");
function $3c235b63087ea285$var$findTextNode(event) {
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $e880Z.isSafari)()) return null;
    /**
	 * According to the spec, `event.target` should be the `Text` node that
	 * the drag started from when dragging a text selection.
	 *
	 * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
	 *
	 * However, in Safari the closest `HTMLElement` is returned.
	 * So we need to figure out if text is dragging ourselves.
	 *
	 * → https://bugs.webkit.org/show_bug.cgi?id=268959
	 */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!event.dataTransfer?.getData((0, $k5wZ1.textMediaType))) return null;
    /**
	 * Grab the first Text node and use that.
	 * Only doing a single level search as that is all we need for this bug.
	 */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}
const $3c235b63087ea285$var$honeyPotFix = (0, $75LZI.makeHoneyPotFix)();
const $3c235b63087ea285$var$adapter = (0, $iKd0N.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $bSwyQ.combine)($3c235b63087ea285$var$honeyPotFix.bindEvents(), (0, $d8F95.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $839Yz.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $k5wZ1.textMediaType))) return;
                const target = $3c235b63087ea285$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $k5wZ1.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $k2XPN.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $3c235b63087ea285$var$honeyPotFix.getOnPostDispatch()
});
function $3c235b63087ea285$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $3c235b63087ea285$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $3c235b63087ea285$var$adapter.registerUsage();
})();
function $3c235b63087ea285$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $3c235b63087ea285$var$adapter.monitor(args);
}

});
parcelRegister("k2XPN", function(module, exports) {

$parcel$export(module.exports, "HTMLMediaType", () => $4ec37091dee56003$export$338a9f6c7a1f02b0);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $4ec37091dee56003$export$338a9f6c7a1f02b0 = 'text/html';

});




parcelRegister("5IMYZ", function(module, exports) {

$parcel$export(module.exports, "dialogWidth", () => $7b29cd8e727ab747$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogHeight", () => $7b29cd8e727ab747$export$ceba93bf0bdd16f2);
const $7b29cd8e727ab747$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
const $7b29cd8e727ab747$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = $7b29cd8e727ab747$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${$7b29cd8e727ab747$export$7e3df82ee760448c.widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};
const $7b29cd8e727ab747$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("7WBHn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c93df066478d62c$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ig6yX = parcelRequire("ig6yX");

var $4c48T = parcelRequire("4c48T");
const $9c93df066478d62c$var$gutter = 60;
const $9c93df066478d62c$var$maxWidthDimensions = `calc(100vw - ${$9c93df066478d62c$var$gutter * 2}px)`;
const $9c93df066478d62c$var$maxHeightDimensions = `calc(100vh - ${$9c93df066478d62c$var$gutter * 2 - 1}px)`; // Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $9c93df066478d62c$var$positionerStyles = null;
const $9c93df066478d62c$var$viewportScrollStyles = null;
const $9c93df066478d62c$var$bodyScrollStyles = null;
const $9c93df066478d62c$var$stackTransitionStyles = null;
const $9c93df066478d62c$var$stackTransformStyles = null;
const $9c93df066478d62c$var$stackIdleStyles = null;
const $9c93df066478d62c$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $4c48T.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $ig6yX.easeInOut)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            "_k8m01e03 _1bumglyw _sedtglyw",
            stackIndex > 0 ? "_t9ec1b95" : "_t9ecglyw",
            shouldScrollInViewport ? "_4t3i1wug _kqswh2mm _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug _eoawglyw" : "_we1i18uh _e8uozwhf _y1k5stnw _5ee41wqb _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw"
        ]),
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9c93df066478d62c$export$2e2bcd8739ae039 = $9c93df066478d62c$var$Positioner;

});
parcelRegister("ig6yX", function(module, exports) {

$parcel$export(module.exports, "easeInOut", () => $394e2d9e5b8112d3$export$c07234257a03d5e9);
$parcel$export(module.exports, "easeOut", () => $394e2d9e5b8112d3$export$57636bb43b1ccbb0);
const $394e2d9e5b8112d3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $394e2d9e5b8112d3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $394e2d9e5b8112d3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $394e2d9e5b8112d3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});



parcelRegister("bZ1JU", function(module, exports) {

$parcel$export(module.exports, "default", () => $de85b37502e8accd$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $aCLu8 = parcelRequire("aCLu8");

var $bzNqF = parcelRequire("bzNqF");

var $i9I6M = parcelRequire("i9I6M");

var $g9Srd = parcelRequire("g9Srd");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $de85b37502e8accd$var$modalStackRegister = [];
function $de85b37502e8accd$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $g9Srd.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $i9I6M.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $bzNqF.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $aCLu8.default)(()=>{
        const newStackIndex = $de85b37502e8accd$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $gwFzn.useEffect)(()=>{
        const currentStackIndex = $de85b37502e8accd$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $de85b37502e8accd$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $de85b37502e8accd$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $de85b37502e8accd$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $gwFzn.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $de85b37502e8accd$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $de85b37502e8accd$var$modalStackRegister.splice(currentStackIndex, 1);
                $de85b37502e8accd$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("aCLu8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34424c3c229a18a$export$2e2bcd8739ae039);

var $9GKca = parcelRequire("9GKca");
function $f34424c3c229a18a$export$2e2bcd8739ae039(callback) {
    const ref = (0, $9GKca.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("9GKca", function(module, exports) {

$parcel$export(module.exports, "default", () => $a43cd06ec205beb8$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
const $a43cd06ec205beb8$var$uniqueReferencedValue = {};
function $a43cd06ec205beb8$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $gwFzn.useRef)($a43cd06ec205beb8$var$uniqueReferencedValue);
    if (ref.current === $a43cd06ec205beb8$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("bzNqF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f807ab48e3c4806$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
function $5f807ab48e3c4806$export$2e2bcd8739ae039(value) {
    const ref = (0, $gwFzn.useRef)();
    (0, $gwFzn.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("i9I6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b5ac2306f5e1f9$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
function $e7b5ac2306f5e1f9$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $gwFzn.useState)(initialState);
    const valueRef = (0, $gwFzn.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("bDzqh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3707f93ea22b000$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $a3707f93ea22b000$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $a3707f93ea22b000$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $gwFzn.useState)(0);
    (0, $gwFzn.useLayoutEffect)(()=>{
        setScrollTopOffset($a3707f93ea22b000$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $gwFzn.useCallback)(()=>{
        if ($a3707f93ea22b000$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return (0, $d8F95.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("dOMrE", function(module, exports) {

$parcel$export(module.exports, "default", () => $90bd866f17043fb3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");
const $90bd866f17043fb3$var$BORDER_WIDTH = 2;
const $90bd866f17043fb3$var$baseFocusOutsideStyles = (0, $3jLHL.css)({
    outline: `${$90bd866f17043fb3$var$BORDER_WIDTH}px solid ${"var(--ds-border-focused, #2684FF)"}`,
    outlineOffset: $90bd866f17043fb3$var$BORDER_WIDTH
});
const $90bd866f17043fb3$var$baseInsetStyles = (0, $3jLHL.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$90bd866f17043fb3$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
const $90bd866f17043fb3$var$focusRingStyles = (0, $3jLHL.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $90bd866f17043fb3$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $90bd866f17043fb3$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $90bd866f17043fb3$var$insetFocusRingStyles = (0, $3jLHL.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $90bd866f17043fb3$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $90bd866f17043fb3$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ const $90bd866f17043fb3$var$FocusRing = /*#__PURE__*/ (0, $gwFzn.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $90bd866f17043fb3$var$baseInsetStyles : $90bd866f17043fb3$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $90bd866f17043fb3$var$insetFocusRingStyles : $90bd866f17043fb3$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3jLHL.ClassNames), null, ({ css: css, cx: cx })=>(0, $gwFzn.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $gwFzn.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$90bd866f17043fb3$var$FocusRing.displayName = 'FocusRing';
var $90bd866f17043fb3$export$2e2bcd8739ae039 = $90bd866f17043fb3$var$FocusRing;

});

parcelRegister("1jfCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e25fa526c0658720d6f2766d6bdbde06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f43af3b68aef803$var$_react = $0f43af3b68aef803$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $0f43af3b68aef803$var$_close = $0f43af3b68aef803$var$_interopRequireDefault((parcelRequire("lnqHu")));

var $0f43af3b68aef803$var$_cross = $0f43af3b68aef803$var$_interopRequireDefault((parcelRequire("ge0Ua")));
function $0f43af3b68aef803$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f43af3b68aef803$var$CloseIcon = (props)=>/*#__PURE__*/ $0f43af3b68aef803$var$_react.default.createElement($0f43af3b68aef803$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $0f43af3b68aef803$var$_cross.default
    }, props));
$0f43af3b68aef803$var$CloseIcon.Name = 'CloseIconMigration';
var $0f43af3b68aef803$var$_default = module.exports.default = $0f43af3b68aef803$var$CloseIcon;

});
parcelRegister("lnqHu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d0fc846b6bef3d8e704c9e8e0a2026>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f900751caeb20f1e$var$_react = $f900751caeb20f1e$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $f900751caeb20f1e$var$_baseNew = $f900751caeb20f1e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f900751caeb20f1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f900751caeb20f1e$var$CloseIcon = (props)=>/*#__PURE__*/ $f900751caeb20f1e$var$_react.default.createElement($f900751caeb20f1e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m9.06 8 4.97-4.97-1.06-1.06L8 6.94 3.03 1.97 1.97 3.03 6.94 8l-4.97 4.97 1.06 1.06L8 9.06l4.97 4.97 1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$f900751caeb20f1e$var$CloseIcon.displayName = 'CloseIcon';
var $f900751caeb20f1e$var$_default = module.exports.default = $f900751caeb20f1e$var$CloseIcon;

});

parcelRegister("ge0Ua", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bcfea7d783028047$var$_react = $bcfea7d783028047$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $bcfea7d783028047$var$_close = $bcfea7d783028047$var$_interopRequireDefault((parcelRequire("lnqHu")));
function $bcfea7d783028047$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bcfea7d783028047$var$CrossIcon = (props)=>/*#__PURE__*/ $bcfea7d783028047$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $bcfea7d783028047$var$_close.default
    }));
$bcfea7d783028047$var$CrossIcon.displayName = 'CrossIcon';
var $bcfea7d783028047$var$_default = module.exports.default = $bcfea7d783028047$var$CrossIcon;

});


parcelRegister("5L38b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a36a65999ae3c13d3a1917b5e2b052e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4313c54fb1df9273$var$_react = $4313c54fb1df9273$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $4313c54fb1df9273$var$_error = $4313c54fb1df9273$var$_interopRequireDefault((parcelRequire("iEKnc")));

var $4313c54fb1df9273$var$_error2 = $4313c54fb1df9273$var$_interopRequireDefault((parcelRequire("8QILn")));
function $4313c54fb1df9273$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4313c54fb1df9273$var$ErrorIcon = (props)=>/*#__PURE__*/ $4313c54fb1df9273$var$_react.default.createElement($4313c54fb1df9273$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $4313c54fb1df9273$var$_error2.default
    }, props));
$4313c54fb1df9273$var$ErrorIcon.Name = 'ErrorIconMigration';
var $4313c54fb1df9273$var$_default = module.exports.default = $4313c54fb1df9273$var$ErrorIcon;

});
parcelRegister("iEKnc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::257fef37d04db299e24e95484ff9b12f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d94fef2ba0efffc2$var$_react = $d94fef2ba0efffc2$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $d94fef2ba0efffc2$var$_baseNew = $d94fef2ba0efffc2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d94fef2ba0efffc2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d94fef2ba0efffc2$var$ErrorIcon = (props)=>/*#__PURE__*/ $d94fef2ba0efffc2$var$_react.default.createElement($d94fef2ba0efffc2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$d94fef2ba0efffc2$var$ErrorIcon.displayName = 'ErrorIcon';
var $d94fef2ba0efffc2$var$_default = module.exports.default = $d94fef2ba0efffc2$var$ErrorIcon;

});

parcelRegister("8QILn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6715e713cda7fb94$var$_react = $6715e713cda7fb94$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $6715e713cda7fb94$var$_error = $6715e713cda7fb94$var$_interopRequireDefault((parcelRequire("iEKnc")));
function $6715e713cda7fb94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6715e713cda7fb94$var$ErrorIcon = (props)=>/*#__PURE__*/ $6715e713cda7fb94$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $6715e713cda7fb94$var$_error.default
    }));
$6715e713cda7fb94$var$ErrorIcon.displayName = 'ErrorIcon';
var $6715e713cda7fb94$var$_default = module.exports.default = $6715e713cda7fb94$var$ErrorIcon;

});


parcelRegister("6hqEj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::783ce92761ea23bbb39745cb99e4a6be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4929009951d1c647$var$_react = $4929009951d1c647$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $4929009951d1c647$var$_warning = $4929009951d1c647$var$_interopRequireDefault((parcelRequire("2p7B1")));

var $4929009951d1c647$var$_warning2 = $4929009951d1c647$var$_interopRequireDefault((parcelRequire("5Xi9J")));
function $4929009951d1c647$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4929009951d1c647$var$WarningIcon = (props)=>/*#__PURE__*/ $4929009951d1c647$var$_react.default.createElement($4929009951d1c647$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $4929009951d1c647$var$_warning2.default
    }, props));
$4929009951d1c647$var$WarningIcon.Name = 'WarningIconMigration';
var $4929009951d1c647$var$_default = module.exports.default = $4929009951d1c647$var$WarningIcon;

});
parcelRegister("2p7B1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1447c2d9394cec1fac504fd0d225fa23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c03cf071f8f31e9$var$_react = $1c03cf071f8f31e9$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $1c03cf071f8f31e9$var$_baseNew = $1c03cf071f8f31e9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1c03cf071f8f31e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1c03cf071f8f31e9$var$WarningIcon = (props)=>/*#__PURE__*/ $1c03cf071f8f31e9$var$_react.default.createElement($1c03cf071f8f31e9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$1c03cf071f8f31e9$var$WarningIcon.displayName = 'WarningIcon';
var $1c03cf071f8f31e9$var$_default = module.exports.default = $1c03cf071f8f31e9$var$WarningIcon;

});

parcelRegister("5Xi9J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45608bda7050d4b8$var$_react = $45608bda7050d4b8$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $45608bda7050d4b8$var$_warning = $45608bda7050d4b8$var$_interopRequireDefault((parcelRequire("2p7B1")));
function $45608bda7050d4b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $45608bda7050d4b8$var$WarningIcon = (props)=>/*#__PURE__*/ $45608bda7050d4b8$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $45608bda7050d4b8$var$_warning.default
    }));
$45608bda7050d4b8$var$WarningIcon.displayName = 'WarningIcon';
var $45608bda7050d4b8$var$_default = module.exports.default = $45608bda7050d4b8$var$WarningIcon;

});


parcelRegister("7hXDW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5ad3e09f473ba51$export$2e2bcd8739ae039);
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $avd77 = parcelRequire("avd77");

var $5rrZR = parcelRequire("5rrZR");

var $1fLvy = parcelRequire("1fLvy");

var $3mTvL = parcelRequire("3mTvL");
const $a5ad3e09f473ba51$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
const $a5ad3e09f473ba51$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
const $a5ad3e09f473ba51$var$headingColorStylesMap = {
    'color.text': "_syaz1fxt",
    'color.text.inverse': "_syaz15cr",
    'color.text.warning.inverse': "_syazal3n"
}; /**
    * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
    * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
    * @codegenId typography
    * @codegenCommand yarn workspace @atlaskit/heading codegen
    */ 
const $a5ad3e09f473ba51$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
const $a5ad3e09f473ba51$var$useColor = (colorProp)=>{
    const surface = (0, $5rrZR.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $avd77.inverseColorMap).hasOwnProperty(surface)) return (0, $avd77.inverseColorMap)[surface];
    return 'color.text';
}; /**
    * __Heading__
    *
    * Heading is a typography component used to display text in defined sizes and styles.
    *
    * @example
    *
    * ```jsx
    * <Heading size="xxlarge">Page title</Heading>
    * ```
    */ 
const $a5ad3e09f473ba51$var$Heading = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $3mTvL;
    const [hLevel, inferredElement] = (0, $1fLvy.useHeading)($a5ad3e09f473ba51$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $a5ad3e09f473ba51$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $35pXk.default)([
            $a5ad3e09f473ba51$var$styles.reset,
            size && $a5ad3e09f473ba51$var$headingSizeStylesMap[size],
            $a5ad3e09f473ba51$var$headingColorStylesMap[color]
        ]),
        children: children
    });
});
var $a5ad3e09f473ba51$export$2e2bcd8739ae039 = $a5ad3e09f473ba51$var$Heading;

});
parcelRegister("1fLvy", function(module, exports) {

$parcel$export(module.exports, "useHeading", () => $d5887b98fd518b08$export$97a37b1befbbf9b1);
$parcel$export(module.exports, "default", () => $d5887b98fd518b08$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $d5887b98fd518b08$var$HeadingLevelContext = /*#__PURE__*/ (0, $gwFzn.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ const $d5887b98fd518b08$var$useHeadingLevel = ()=>{
    return (0, $gwFzn.useContext)($d5887b98fd518b08$var$HeadingLevelContext);
};
const $d5887b98fd518b08$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = $d5887b98fd518b08$var$useHeadingLevel();
    /**
	 * Order here is important, we for now apply
	 * 1. inferred a11y level (this only applies if context is present)
	 * 2. default final fallback
	 */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ const $d5887b98fd518b08$var$HeadingLevelContextProvider = ({ children: children, value: value })=>{
    const parentHeadingLevel = $d5887b98fd518b08$var$useHeadingLevel();
    const headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($d5887b98fd518b08$var$HeadingLevelContext.Provider, {
        value: value || headingLevel,
        children: children
    });
};
var $d5887b98fd518b08$export$2e2bcd8739ae039 = $d5887b98fd518b08$var$HeadingLevelContextProvider;

});


parcelRegister("u9agA", function(module, exports) {

$parcel$export(module.exports, "default", () => $99c9b99bf8ec1016$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $1Whri = parcelRequire("1Whri");

var $1s5hv = parcelRequire("1s5hv");
const $99c9b99bf8ec1016$var$styles = {
    separator: "_1mouze3t _195g1i6y _syaz1gjq _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $99c9b99bf8ec1016$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        className: (0, $35pXk.default)([
            $99c9b99bf8ec1016$var$styles.separator
        ]),
        children: children
    }); /**
                                                                   * __Inline__
                                                                   *
                                                                   * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
                                                                   *
                                                                   * @example
                                                                   * ```tsx
                                                                   *  <Inline>
                                                                   *    <Box padding="space.100" backgroundColor="neutral"></Box>
                                                                   *    <Box padding="space.100" backgroundColor="neutral"></Box>
                                                                   *  </Inline>
                                                                   * ```
                                                                   *
                                                                   */ 
const $99c9b99bf8ec1016$var$Inline = /*#__PURE__*/ (0, $gwFzn.memo)(/*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $7UHDa.jsx)($99c9b99bf8ec1016$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $gwFzn.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1s5hv.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $1Whri.cx)(grow === 'hug' && $99c9b99bf8ec1016$var$styles.hug, grow === 'fill' && $99c9b99bf8ec1016$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$99c9b99bf8ec1016$var$Inline.displayName = 'Inline';
var $99c9b99bf8ec1016$export$2e2bcd8739ae039 = $99c9b99bf8ec1016$var$Inline;

});
parcelRegister("1s5hv", function(module, exports) {

$parcel$export(module.exports, "default", () => $46c0ad632e23aab5$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $46c0ad632e23aab5$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $46c0ad632e23aab5$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $46c0ad632e23aab5$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $46c0ad632e23aab5$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $46c0ad632e23aab5$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $46c0ad632e23aab5$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $46c0ad632e23aab5$var$styles = {
    root: "_1e0c1txw _vchhusvi"
}; /**
    * __Flex__
    *
    * `Flex` is a primitive component that implements the CSS Flexbox API.
    *
    * - [Examples](https://atlassian.design/components/primitives/flex/examples)
    * - [Code](https://atlassian.design/components/primitives/flex/code)
    *
    * @example
    * ```tsx
    * import { Flex, Box } from '@atlaskit/primitives'
    *
    * const Component = () => (
    *   <Flex direction="column">
    *     <Box padding="space.100" backgroundColor="neutral"></Box>
    *     <Box padding="space.100" backgroundColor="neutral"></Box>
    *   </Flex>
    * )
    * ```
    */ 
const $46c0ad632e23aab5$var$Flex = /*#__PURE__*/ (0, $gwFzn.memo)(/*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        role: role,
        className: (0, $35pXk.default)([
            $46c0ad632e23aab5$var$styles.root,
            gap && $46c0ad632e23aab5$var$columnGapMap[gap],
            columnGap && $46c0ad632e23aab5$var$columnGapMap[columnGap],
            gap && $46c0ad632e23aab5$var$rowGapMap[gap],
            rowGap && $46c0ad632e23aab5$var$rowGapMap[rowGap],
            alignItems && $46c0ad632e23aab5$var$alignItemsMap[alignItems],
            direction && $46c0ad632e23aab5$var$flexDirectionMap[direction],
            justifyContent && $46c0ad632e23aab5$var$justifyContentMap[justifyContent],
            wrap && $46c0ad632e23aab5$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$46c0ad632e23aab5$var$Flex.displayName = 'Flex';
var $46c0ad632e23aab5$export$2e2bcd8739ae039 = $46c0ad632e23aab5$var$Flex;

});


parcelRegister("eyWa4", function(module, exports) {

$parcel$export(module.exports, "default", () => $222464dfbbd88f38$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $1s5hv = parcelRequire("1s5hv");
const $222464dfbbd88f38$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $222464dfbbd88f38$var$Stack = /*#__PURE__*/ (0, $gwFzn.memo)(/*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1s5hv.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $1Whri.cx)(grow === 'hug' && $222464dfbbd88f38$var$styles.hug, grow === 'fill' && $222464dfbbd88f38$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$222464dfbbd88f38$var$Stack.displayName = 'Stack';
var $222464dfbbd88f38$export$2e2bcd8739ae039 = $222464dfbbd88f38$var$Stack;

});

parcelRegister("lpHGz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a62cd542d4ba6c4ac33816bbd6056646>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f96dd1da319b2841$var$_react = $f96dd1da319b2841$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $f96dd1da319b2841$var$_information = $f96dd1da319b2841$var$_interopRequireDefault((parcelRequire("4vzBZ")));

var $f96dd1da319b2841$var$_info = $f96dd1da319b2841$var$_interopRequireDefault((parcelRequire("a7lwr")));
function $f96dd1da319b2841$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f96dd1da319b2841$var$InformationIcon = (props)=>/*#__PURE__*/ $f96dd1da319b2841$var$_react.default.createElement($f96dd1da319b2841$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $f96dd1da319b2841$var$_info.default
    }, props));
$f96dd1da319b2841$var$InformationIcon.Name = 'InformationIconMigration';
var $f96dd1da319b2841$var$_default = module.exports.default = $f96dd1da319b2841$var$InformationIcon;

});
parcelRegister("4vzBZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11503d00887c85dd37060e980bd5f02d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3485ae728ccb02f4$var$_react = $3485ae728ccb02f4$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $3485ae728ccb02f4$var$_baseNew = $3485ae728ccb02f4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3485ae728ccb02f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3485ae728ccb02f4$var$InformationIcon = (props)=>/*#__PURE__*/ $3485ae728ccb02f4$var$_react.default.createElement($3485ae728ccb02f4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$3485ae728ccb02f4$var$InformationIcon.displayName = 'InformationIcon';
var $3485ae728ccb02f4$var$_default = module.exports.default = $3485ae728ccb02f4$var$InformationIcon;

});

parcelRegister("a7lwr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75db40b5bd5f37fc$var$_react = $75db40b5bd5f37fc$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $75db40b5bd5f37fc$var$_information = $75db40b5bd5f37fc$var$_interopRequireDefault((parcelRequire("4vzBZ")));
function $75db40b5bd5f37fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $75db40b5bd5f37fc$var$InfoIcon = (props)=>/*#__PURE__*/ $75db40b5bd5f37fc$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $75db40b5bd5f37fc$var$_information.default
    }));
$75db40b5bd5f37fc$var$InfoIcon.displayName = 'InfoIcon';
var $75db40b5bd5f37fc$var$_default = module.exports.default = $75db40b5bd5f37fc$var$InfoIcon;

});


parcelRegister("bAfMd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::934663f3d49f13f5eb4d23bc2f11a666>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86ef4b6baa8c92c0$var$_react = $86ef4b6baa8c92c0$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $86ef4b6baa8c92c0$var$_success = $86ef4b6baa8c92c0$var$_interopRequireDefault((parcelRequire("aUEBE")));

var $86ef4b6baa8c92c0$var$_checkCircle = $86ef4b6baa8c92c0$var$_interopRequireDefault((parcelRequire("eCByP")));
function $86ef4b6baa8c92c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86ef4b6baa8c92c0$var$SuccessIcon = (props)=>/*#__PURE__*/ $86ef4b6baa8c92c0$var$_react.default.createElement($86ef4b6baa8c92c0$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $86ef4b6baa8c92c0$var$_checkCircle.default
    }, props));
$86ef4b6baa8c92c0$var$SuccessIcon.Name = 'SuccessIconMigration';
var $86ef4b6baa8c92c0$var$_default = module.exports.default = $86ef4b6baa8c92c0$var$SuccessIcon;

});
parcelRegister("aUEBE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8a54e77ebc6c63c295a0cd7c7e0eeda>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f1ea1e613039534$var$_react = $7f1ea1e613039534$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $7f1ea1e613039534$var$_baseNew = $7f1ea1e613039534$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $7f1ea1e613039534$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f1ea1e613039534$var$SuccessIcon = (props)=>/*#__PURE__*/ $7f1ea1e613039534$var$_react.default.createElement($7f1ea1e613039534$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$7f1ea1e613039534$var$SuccessIcon.displayName = 'SuccessIcon';
var $7f1ea1e613039534$var$_default = module.exports.default = $7f1ea1e613039534$var$SuccessIcon;

});

parcelRegister("eCByP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa51c011ba15f6d5$var$_react = $aa51c011ba15f6d5$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $aa51c011ba15f6d5$var$_success = $aa51c011ba15f6d5$var$_interopRequireDefault((parcelRequire("aUEBE")));
function $aa51c011ba15f6d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aa51c011ba15f6d5$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $aa51c011ba15f6d5$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $aa51c011ba15f6d5$var$_success.default
    }));
$aa51c011ba15f6d5$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $aa51c011ba15f6d5$var$_default = module.exports.default = $aa51c011ba15f6d5$var$CheckCircleIcon;

});


parcelRegister("eEA8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $7097509fdb1a2342$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");

var $bOG3Z = parcelRequire("bOG3Z");

var $gcG0P = parcelRequire("gcG0P");

var $10BNt = parcelRequire("10BNt");

var $hYfEs = parcelRequire("hYfEs");
const $7097509fdb1a2342$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $7097509fdb1a2342$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $ee7An.default), onMouseUp: providedOnMouseUp = (0, $ee7An.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const { mode: mode } = (0, $bOG3Z.useGlobalTheme)();
    const isOnlySingleIcon = (0, $hYfEs.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $gwFzn.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    const onMouseDown = (0, $gwFzn.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($7097509fdb1a2342$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $gwFzn.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($7097509fdb1a2342$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $gwFzn.useMemo)(()=>(0, $10BNt.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gcG0P.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        //  manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$7097509fdb1a2342$var$Button.displayName = 'Button';
var $7097509fdb1a2342$export$2e2bcd8739ae039 = $7097509fdb1a2342$var$Button;

});
parcelRegister("bOG3Z", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", () => $c1fc4d2bf2235e40$export$7692396083754928);
$parcel$export(module.exports, "default", () => $c1fc4d2bf2235e40$export$2e2bcd8739ae039);

var $9j05A = parcelRequire("9j05A");
// Create default global light theme
const { Provider: $c1fc4d2bf2235e40$var$Provider, Consumer: $c1fc4d2bf2235e40$var$Consumer, useTheme: $c1fc4d2bf2235e40$export$7692396083754928 } = (0, $9j05A.createTheme)(()=>({
        mode: 'light'
    }));
const $c1fc4d2bf2235e40$var$Theme = {
    Provider: $c1fc4d2bf2235e40$var$Provider,
    Consumer: $c1fc4d2bf2235e40$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c1fc4d2bf2235e40$export$2e2bcd8739ae039 = $c1fc4d2bf2235e40$var$Theme;

});
parcelRegister("9j05A", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => $a094bcf44d918c5b$export$25d302a5b900a763);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
function $a094bcf44d918c5b$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
	 * Internally, Theme uses React Context, with internal providers and consumers.
	 * The React Context passes only a function that gets props, and turns them into tokens. This
	 * function gets mixed as more Providers with their own themes are added. This mixed function
	 * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
	 * the theme.
	 */ const ThemeContext = /*#__PURE__*/ (0, $gwFzn.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $gwFzn.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: children(tokens)
        });
    }
    /**
	 * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
	 * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
	 * - The getTokens function isn't called immediately - instead the props are passed
	 *    through a mix of parent theming functions
	 * Children of this provider will receive this mixed theme
	 */ function Provider(props) {
        const themeFn = (0, $gwFzn.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $gwFzn.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("gcG0P", function(module, exports) {

$parcel$export(module.exports, "default", () => $6363a9f199f4604f$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $gxtzC = parcelRequire("gxtzC");

var $ee7An = parcelRequire("ee7An");

var $f93tv = parcelRequire("f93tv");

var $dOMrE = parcelRequire("dOMrE");

var $90YwQ = parcelRequire("90YwQ");

var $6fnsQ = parcelRequire("6fnsQ");

var $4aKUR = parcelRequire("4aKUR");

var $10BNt = parcelRequire("10BNt");

var $gDSSU = parcelRequire("gDSSU");
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $6363a9f199f4604f$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $6363a9f199f4604f$var$iconBeforeSpacingFixStyle = (0, $3jLHL.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
const $6363a9f199f4604f$var$iconAfterSpacingFixStyle = (0, $3jLHL.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
const $6363a9f199f4604f$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $gDSSU.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $6363a9f199f4604f$var$getChildren = (children, childrenStyles)=>{
    if ((0, $gDSSU.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $6363a9f199f4604f$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $ee7An.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $ee7An.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $gwFzn.useRef)();
    const setRef = (0, $gwFzn.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $f93tv.default)(ourRef, autoFocus);
    const interactionContext = (0, $gwFzn.useContext)((0, $90YwQ.default));
    const handleClick = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $gwFzn.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $gwFzn.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = (0, $3jLHL.css)((0, $10BNt.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? `var(--ds-icon-subtle, ${0, $6fnsQ.N500})` : `var(--ds-icon-warning-inverse, ${0, $6fnsQ.N500})`} !important`
        }
    };
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $dOMrE.default), null, /*#__PURE__*/ (0, $3jLHL.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $6363a9f199f4604f$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $4aKUR.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $10BNt.getIconStyle)({
                spacing: spacing
            }),
            $6363a9f199f4604f$var$getSpacingFix(children, $6363a9f199f4604f$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $6363a9f199f4604f$var$getChildren(children, [
        fadeStyles,
        (0, $10BNt.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $10BNt.getIconStyle)({
                spacing: spacing
            }),
            $6363a9f199f4604f$var$getSpacingFix(children, $6363a9f199f4604f$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: [
            (0, $10BNt.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6363a9f199f4604f$export$2e2bcd8739ae039 = $6363a9f199f4604f$var$ButtonBase;

});
parcelRegister("4aKUR", function(module, exports) {

$parcel$export(module.exports, "default", () => $14ed0e9b51202eb5$export$2e2bcd8739ae039);
function $14ed0e9b51202eb5$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $14ed0e9b51202eb5$var$tabKeyCode = 9;
function $14ed0e9b51202eb5$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $14ed0e9b51202eb5$var$tabKeyCode) return;
    $14ed0e9b51202eb5$var$abort(event);
}
const $14ed0e9b51202eb5$var$block = {
    onMouseDownCapture: $14ed0e9b51202eb5$var$abort,
    onMouseUpCapture: $14ed0e9b51202eb5$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $14ed0e9b51202eb5$var$onKey,
    onKeyUpCapture: $14ed0e9b51202eb5$var$onKey,
    onTouchStartCapture: $14ed0e9b51202eb5$var$abort,
    onTouchEndCapture: $14ed0e9b51202eb5$var$abort,
    onPointerDownCapture: $14ed0e9b51202eb5$var$abort,
    onPointerUpCapture: $14ed0e9b51202eb5$var$abort,
    onClickCapture: $14ed0e9b51202eb5$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $14ed0e9b51202eb5$var$abort
};
const $14ed0e9b51202eb5$var$doNotBlock = {};
function $14ed0e9b51202eb5$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $14ed0e9b51202eb5$var$doNotBlock : $14ed0e9b51202eb5$var$block;
}

});

parcelRegister("10BNt", function(module, exports) {

$parcel$export(module.exports, "getCss", () => $9d6e515abe0cf8ac$export$955358618f994a11);
$parcel$export(module.exports, "getIconStyle", () => $9d6e515abe0cf8ac$export$864eea3f4ec3368f);
$parcel$export(module.exports, "getContentStyle", () => $9d6e515abe0cf8ac$export$7ad0316cc0dd65a);
$parcel$export(module.exports, "getFadingCss", () => $9d6e515abe0cf8ac$export$1b5827d324e945b1);
$parcel$export(module.exports, "overlayCss", () => $9d6e515abe0cf8ac$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $dh538 = parcelRequire("dh538");

var $dTk3A = parcelRequire("dTk3A");

var $5v0Np = parcelRequire("5v0Np");
const $9d6e515abe0cf8ac$var$gridSize = (0, $dTk3A.gridSize)();
const $9d6e515abe0cf8ac$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
const $9d6e515abe0cf8ac$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $9d6e515abe0cf8ac$var$lineHeights = {
    default: $9d6e515abe0cf8ac$var$heights.default,
    compact: $9d6e515abe0cf8ac$var$heights.compact,
    none: 'inherit'
};
const $9d6e515abe0cf8ac$var$padding = {
    // 10px gutter
    default: `0 ${$9d6e515abe0cf8ac$var$gridSize + $9d6e515abe0cf8ac$var$gridSize / 4}px`,
    compact: `0 ${$9d6e515abe0cf8ac$var$gridSize + $9d6e515abe0cf8ac$var$gridSize / 4}px`,
    none: '0'
};
const $9d6e515abe0cf8ac$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$9d6e515abe0cf8ac$var$gridSize / 4}px`,
    default: `0 ${$9d6e515abe0cf8ac$var$gridSize / 4}px`,
    none: '0'
};
const $9d6e515abe0cf8ac$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $9d6e515abe0cf8ac$var$innerMargin = {
    content: `0 ${$9d6e515abe0cf8ac$var$gridSize / 4}px`,
    icon: `0 ${$9d6e515abe0cf8ac$var$gridSize / 4}px`
};
const $9d6e515abe0cf8ac$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $9d6e515abe0cf8ac$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    '&:not([disabled])::after': {
        ...$9d6e515abe0cf8ac$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
const $9d6e515abe0cf8ac$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
const $9d6e515abe0cf8ac$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #0C66E4)",
    '&:hover': {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: 'underline'
    }
};
const $9d6e515abe0cf8ac$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
const $9d6e515abe0cf8ac$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    }
};
const $9d6e515abe0cf8ac$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
const $9d6e515abe0cf8ac$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
const $9d6e515abe0cf8ac$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    '&:not([disabled])::after': {
        ...$9d6e515abe0cf8ac$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    }
};
const $9d6e515abe0cf8ac$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $9d6e515abe0cf8ac$var$getColor({ group: group, key: key, mode: mode }) {
    const rule = group[key] || group.default;
    return rule[mode];
}
function $9d6e515abe0cf8ac$var$getColors({ appearance: appearance, key: key, mode: mode }) {
    return {
        background: $9d6e515abe0cf8ac$var$getColor({
            group: (0, $5v0Np.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: `${$9d6e515abe0cf8ac$var$getColor({
            group: (0, $5v0Np.default).color[appearance],
            key: key,
            mode: mode
        })} !important`
    };
}
function $9d6e515abe0cf8ac$export$955358618f994a11({ appearance: appearance, spacing: spacing, mode: mode, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const baseColors = $9d6e515abe0cf8ac$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        // dynamic styles
        ...!(0, $dh538.fg)('platform-component-visual-refresh') && baseColors,
        cursor: 'pointer',
        height: $9d6e515abe0cf8ac$var$heights[spacing],
        lineHeight: $9d6e515abe0cf8ac$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $9d6e515abe0cf8ac$var$singleIconPadding[spacing] : $9d6e515abe0cf8ac$var$padding[spacing],
        verticalAlign: $9d6e515abe0cf8ac$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        ...!(0, $dh538.fg)('platform-component-visual-refresh') && {
            // Disabling visited styles (just using the base colors)
            '&:visited': {
                ...baseColors
            },
            '&:hover': {
                ...$9d6e515abe0cf8ac$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'hover',
                    mode: mode
                }),
                textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
                // background, box-shadow
                transitionDuration: '0s, 0.15s'
            },
            // giving active styles preference by listing them after focus
            '&:active': {
                ...$9d6e515abe0cf8ac$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'active',
                    mode: mode
                }),
                // background, box-shadow
                transitionDuration: '0s, 0s'
            },
            // preventDefault prevents regular active styles from applying in Firefox
            '&[data-firefox-is-active="true"]': {
                ...$9d6e515abe0cf8ac$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'active',
                    mode: mode
                }),
                // background, box-shadow
                transitionDuration: '0s, 0s'
            },
            // Giving disabled styles preference over active by listing them after.
            // Not using '&:disabled' because :disabled is not a valid state for all element types
            // so we are targeting the attribute
            // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
            '&[disabled]': {
                // always using 'disabled' even when selected
                ...$9d6e515abe0cf8ac$var$getColors({
                    appearance: appearance,
                    key: 'disabled',
                    mode: mode
                }),
                cursor: 'not-allowed',
                textDecoration: 'none'
            },
            ...$9d6e515abe0cf8ac$var$hasOverlayStyles,
            // disabling hover and active color changes when there is an overlay, but the button is not disabled
            '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': {
                ...$9d6e515abe0cf8ac$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'default',
                    mode: mode
                })
            }
        },
        // dynamic colours for visual refresh:
        ...(0, $dh538.fg)('platform-component-visual-refresh') && (isSelected ? $9d6e515abe0cf8ac$var$selectedStyles : {
            ...appearance === 'default' && $9d6e515abe0cf8ac$var$defaultStyles,
            ...appearance === 'primary' && $9d6e515abe0cf8ac$var$primaryStyles,
            ...appearance === 'link' && $9d6e515abe0cf8ac$var$linkStyles,
            ...appearance === 'subtle' && $9d6e515abe0cf8ac$var$subtleStyles,
            ...appearance === 'subtle-link' && $9d6e515abe0cf8ac$var$subtleLinkStyles,
            ...appearance === 'warning' && $9d6e515abe0cf8ac$var$warningStyles,
            ...appearance === 'danger' && $9d6e515abe0cf8ac$var$dangerStyles,
            '&[disabled]': {
                color: "var(--ds-text-disabled, #091E424F)",
                backgroundColor: $9d6e515abe0cf8ac$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $9d6e515abe0cf8ac$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $9d6e515abe0cf8ac$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
                }
            },
            ...$9d6e515abe0cf8ac$var$hasOverlayStyles
        }),
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}
function $9d6e515abe0cf8ac$export$864eea3f4ec3368f({ spacing: spacing }) {
    return (0, $3jLHL.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $9d6e515abe0cf8ac$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $9d6e515abe0cf8ac$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $9d6e515abe0cf8ac$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $9d6e515abe0cf8ac$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
const $9d6e515abe0cf8ac$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("5v0Np", function(module, exports) {

$parcel$export(module.exports, "default", () => $df5c9fd4aed23c67$export$2e2bcd8739ae039);

var $6fnsQ = parcelRequire("6fnsQ");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
const $df5c9fd4aed23c67$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
const $df5c9fd4aed23c67$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: `var(--ds-background-neutral, ${$6fnsQ.N20A})`,
                dark: `var(--ds-background-neutral, ${$6fnsQ.DN70})`
            },
            hover: {
                light: `var(--ds-background-neutral-hovered, ${$6fnsQ.N30A})`,
                dark: `var(--ds-background-neutral-hovered, ${$6fnsQ.DN60})`
            },
            active: {
                light: `var(--ds-background-neutral-pressed, ${$df5c9fd4aed23c67$var$fadedB75})`,
                dark: `var(--ds-background-neutral-pressed, ${$6fnsQ.B75})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$6fnsQ.N20A})`,
                dark: `var(--ds-background-disabled, ${$6fnsQ.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$6fnsQ.N700})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$6fnsQ.N700})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.DN0})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-background-brand-bold, ${$6fnsQ.B400})`,
                dark: `var(--ds-background-brand-bold, ${$6fnsQ.B100})`
            },
            hover: {
                light: `var(--ds-background-brand-bold-hovered, ${$6fnsQ.B300})`,
                dark: `var(--ds-background-brand-bold-hovered, ${$6fnsQ.B75})`
            },
            active: {
                light: `var(--ds-background-brand-bold-pressed, ${$6fnsQ.B500})`,
                dark: `var(--ds-background-brand-bold-pressed, ${$6fnsQ.B200})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$6fnsQ.N20A})`,
                dark: `var(--ds-background-disabled, ${$6fnsQ.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$6fnsQ.N700})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$6fnsQ.N700})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.DN0})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-background-warning-bold, ${$6fnsQ.Y300})`,
                dark: `var(--ds-background-warning-bold, ${$6fnsQ.Y300})`
            },
            hover: {
                light: `var(--ds-background-warning-bold-hovered, ${$6fnsQ.Y200})`,
                dark: `var(--ds-background-warning-bold-hovered, ${$6fnsQ.Y200})`
            },
            active: {
                light: `var(--ds-background-warning-bold-pressed, ${$6fnsQ.Y400})`,
                dark: `var(--ds-background-warning-bold-pressed, ${$6fnsQ.Y400})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$6fnsQ.N20A})`,
                dark: `var(--ds-background-disabled, ${$6fnsQ.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$6fnsQ.Y400})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.Y400})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$6fnsQ.Y400})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.Y400})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-background-danger-bold, ${$6fnsQ.R400})`,
                dark: `var(--ds-background-danger-bold, ${$6fnsQ.R400})`
            },
            hover: {
                light: `var(--ds-background-danger-bold-hovered, ${$6fnsQ.R300})`,
                dark: `var(--ds-background-danger-bold-hovered, ${$6fnsQ.R300})`
            },
            active: {
                light: `var(--ds-background-danger-bold-pressed, ${$6fnsQ.R500})`,
                dark: `var(--ds-background-danger-bold-pressed, ${$6fnsQ.R500})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$6fnsQ.N20A})`,
                dark: `var(--ds-background-disabled, ${$6fnsQ.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$6fnsQ.R500})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.R500})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$6fnsQ.R500})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.R500})`
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$6fnsQ.N700})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.N20})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$6fnsQ.N700})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.N20})`
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: `var(--ds-background-neutral-subtle-hovered, ${$6fnsQ.N30A})`,
                dark: `var(--ds-background-neutral-subtle-hovered, ${$6fnsQ.DN60})`
            },
            active: {
                light: `var(--ds-background-neutral-subtle-pressed, ${$df5c9fd4aed23c67$var$fadedB75})`,
                dark: `var(--ds-background-neutral-subtle-pressed, ${$6fnsQ.B75})`
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$6fnsQ.N700})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$6fnsQ.N700})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.DN0})`
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$6fnsQ.N700})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.N20})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$6fnsQ.N700})`,
                dark: `var(--ds-background-selected, ${$6fnsQ.N20})`
            }
        }
    },
    color: {
        default: {
            default: {
                light: `var(--ds-text, ${$6fnsQ.N500})`,
                dark: `var(--ds-text, ${$6fnsQ.DN400})`
            },
            active: {
                light: `var(--ds-text, ${$6fnsQ.B400})`,
                dark: `var(--ds-text, ${$6fnsQ.B400})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$6fnsQ.N70})`,
                dark: `var(--ds-text-disabled, ${$6fnsQ.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N20})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N20})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.DN400})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-text-inverse, ${$6fnsQ.N0})`,
                dark: `var(--ds-text-inverse, ${$6fnsQ.DN30})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$6fnsQ.N70})`,
                dark: `var(--ds-text-disabled, ${$6fnsQ.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N20})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N20})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.DN400})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-text-warning-inverse, ${$6fnsQ.N800})`,
                dark: `var(--ds-text-warning-inverse, ${$6fnsQ.N800})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$6fnsQ.N70})`,
                dark: `var(--ds-text-disabled, ${$6fnsQ.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N800})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.N800})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N800})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.N800})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-text-inverse, ${$6fnsQ.N0})`,
                dark: `var(--ds-text-inverse, ${$6fnsQ.N0})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$6fnsQ.N70})`,
                dark: `var(--ds-text-disabled, ${$6fnsQ.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N0})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.N0})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N0})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.N0})`
            }
        },
        link: {
            default: {
                light: `var(--ds-link, ${$6fnsQ.B400})`,
                dark: `var(--ds-link, ${$6fnsQ.B100})`
            },
            hover: {
                light: `var(--ds-link, ${$6fnsQ.B300})`,
                dark: `var(--ds-link, ${$6fnsQ.B75})`
            },
            active: {
                light: `var(--ds-link-pressed, ${$6fnsQ.B500})`,
                dark: `var(--ds-link-pressed, ${$6fnsQ.B200})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$6fnsQ.N70})`,
                dark: `var(--ds-text-disabled, ${$6fnsQ.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N20})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.N700})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N20})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.N700})`
            }
        },
        subtle: {
            default: {
                light: `var(--ds-text, ${$6fnsQ.N500})`,
                dark: `var(--ds-text, ${$6fnsQ.DN400})`
            },
            active: {
                light: `var(--ds-text, ${$6fnsQ.B400})`,
                dark: `var(--ds-text, ${$6fnsQ.B400})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$6fnsQ.N70})`,
                dark: `var(--ds-text-disabled, ${$6fnsQ.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N20})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N20})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.DN400})`
            }
        },
        'subtle-link': {
            default: {
                light: `var(--ds-text-subtle, ${$6fnsQ.N200})`,
                dark: `var(--ds-text-subtle, ${$6fnsQ.DN400})`
            },
            hover: {
                light: `var(--ds-text-subtle, ${$6fnsQ.N90})`,
                dark: `var(--ds-text-subtle, ${$6fnsQ.B50})`
            },
            active: {
                light: `var(--ds-text, ${$6fnsQ.N400})`,
                dark: `var(--ds-text, ${$6fnsQ.DN300})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$6fnsQ.N70})`,
                dark: `var(--ds-text-disabled, ${$6fnsQ.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N20})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$6fnsQ.N20})`,
                dark: `var(--ds-text-selected, ${$6fnsQ.DN400})`
            }
        }
    }
};
var $df5c9fd4aed23c67$export$2e2bcd8739ae039 = $df5c9fd4aed23c67$var$values;

});


parcelRegister("gDSSU", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $37dd97bea21ce072$export$20bbd2efb0d734c4);

var $gwFzn = parcelRequire("gwFzn");

var $6F6hl = parcelRequire("6F6hl");
const $37dd97bea21ce072$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $gwFzn.isValidElement)(children) && children.type === (0, $6F6hl.default);
};

});


parcelRegister("hYfEs", function(module, exports) {

$parcel$export(module.exports, "default", () => $297b32beaea491d4$export$2e2bcd8739ae039);

var $gDSSU = parcelRequire("gDSSU");
function $297b32beaea491d4$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $gDSSU.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("dcJ7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb95e3519017b7c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $ecnYn = parcelRequire("ecnYn");

var $bUlM5 = parcelRequire("bUlM5");
const $bcb95e3519017b7c$var$flexGrowMap = {
    hug: (0, $ecnYn.xcss)({
        flexGrow: 0
    }),
    fill: (0, $ecnYn.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $bcb95e3519017b7c$var$separatorStyles = (0, $3jLHL.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $bcb95e3519017b7c$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $bcb95e3519017b7c$var$separatorStyles
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $bcb95e3519017b7c$var$Inline = /*#__PURE__*/ (0, $gwFzn.memo)(/*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $3jLHL.jsx)($bcb95e3519017b7c$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $gwFzn.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $bcb95e3519017b7c$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $bUlM5.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$bcb95e3519017b7c$var$Inline.displayName = 'Inline';
var $bcb95e3519017b7c$export$2e2bcd8739ae039 = $bcb95e3519017b7c$var$Inline;

});

parcelRegister("8z9j5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2dfb7fd832b1de2$export$2e2bcd8739ae039);

var $a9dFP = parcelRequire("a9dFP");

var $fwSE5 = parcelRequire("fwSE5");

var $j6S25 = parcelRequire("j6S25");
const $b2dfb7fd832b1de2$var$isThemeColorMode = (colorMode)=>{
    return (0, $fwSE5.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $b2dfb7fd832b1de2$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $a9dFP.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $a9dFP.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $j6S25.themeStringToObject)(theme),
        ...$b2dfb7fd832b1de2$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $b2dfb7fd832b1de2$export$2e2bcd8739ae039 = $b2dfb7fd832b1de2$var$getGlobalTheme;

});

parcelRegister("bRSdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e70f44cacbaf4963$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $fwSE5 = parcelRequire("fwSE5");

var $9NuSR = parcelRequire("9NuSR");

var $8lHid = parcelRequire("8lHid");

var $4icxs = parcelRequire("4icxs");

var $1oKVt = parcelRequire("1oKVt");

var $ajqJ5 = parcelRequire("ajqJ5");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $e70f44cacbaf4963$var$setGlobalTheme = async ({ colorMode: colorMode = (0, $fwSE5.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $fwSE5.themeStateDefaults)['contrastMode'], dark: dark = (0, $fwSE5.themeStateDefaults)['dark'], light: light = (0, $fwSE5.themeStateDefaults)['light'], shape: shape = (0, $fwSE5.themeStateDefaults)['shape'], spacing: spacing = (0, $fwSE5.themeStateDefaults)['spacing'], typography: typography = (0, $fwSE5.themeStateDefaults)['typography'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $fwSE5.themeStateDefaults)['UNSAFE_themeOptions'] } = {}, themeLoader)=>{
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $dh538.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, $1oKVt.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $ajqJ5.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $9NuSR.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $fwSE5.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $4icxs.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("4atNR"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, $1oKVt.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, $8lHid.default)(themeState);
    return autoUnbind;
};
var $e70f44cacbaf4963$export$2e2bcd8739ae039 = $e70f44cacbaf4963$var$setGlobalTheme;

});
parcelRegister("8lHid", function(module, exports) {

$parcel$export(module.exports, "default", () => $64f73cf756421a81$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $hY0xh = parcelRequire("hY0xh");

var $aCPa1 = parcelRequire("aCPa1");

var $l6FFa = parcelRequire("l6FFa");
function $64f73cf756421a81$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $aCPa1.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $aCPa1.default).bind();
    } else (0, $aCPa1.default).unbind();
    if ((0, $dh538.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $l6FFa.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $l6FFa.default).bind();
        } else (0, $l6FFa.default).unbind();
    }
    const themeAttributes = (0, $hY0xh.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $aCPa1.default).unbind();
        if ((0, $dh538.fg)('platform_increased-contrast-themes')) (0, $l6FFa.default).unbind();
    };
}

});
parcelRegister("aCPa1", function(module, exports) {

$parcel$export(module.exports, "default", () => $06d4924e4f58c3fc$export$2e2bcd8739ae039);

var $d8F95 = parcelRequire("d8F95");

var $a9dFP = parcelRequire("a9dFP");

var $ajqJ5 = parcelRequire("ajqJ5");
const $06d4924e4f58c3fc$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $06d4924e4f58c3fc$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $a9dFP.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $06d4924e4f58c3fc$var$darkModeMql = $06d4924e4f58c3fc$var$isMatchMediaAvailable && window.matchMedia((0, $ajqJ5.darkModeMediaQuery));
class $06d4924e4f58c3fc$var$ColorModeObserver {
    getColorMode() {
        if (!$06d4924e4f58c3fc$var$darkModeMql) return 'light';
        return $06d4924e4f58c3fc$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($06d4924e4f58c3fc$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $d8F95.bind)($06d4924e4f58c3fc$var$darkModeMql, {
            type: 'change',
            listener: $06d4924e4f58c3fc$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $06d4924e4f58c3fc$var$SingletonColorModeObserver = new $06d4924e4f58c3fc$var$ColorModeObserver();
var $06d4924e4f58c3fc$export$2e2bcd8739ae039 = $06d4924e4f58c3fc$var$SingletonColorModeObserver;

});

parcelRegister("l6FFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a87d142ec6e5dd5$export$2e2bcd8739ae039);

var $d8F95 = parcelRequire("d8F95");

var $a9dFP = parcelRequire("a9dFP");

var $ajqJ5 = parcelRequire("ajqJ5");
const $0a87d142ec6e5dd5$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $0a87d142ec6e5dd5$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $a9dFP.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $0a87d142ec6e5dd5$var$contrastModeMql = $0a87d142ec6e5dd5$var$isMatchMediaAvailable && window.matchMedia((0, $ajqJ5.moreContrastMediaQuery));
class $0a87d142ec6e5dd5$var$ContrastModeObserver {
    getContrastMode() {
        if (!$0a87d142ec6e5dd5$var$contrastModeMql) return 'no-preference';
        return $0a87d142ec6e5dd5$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($0a87d142ec6e5dd5$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $d8F95.bind)($0a87d142ec6e5dd5$var$contrastModeMql, {
            type: 'change',
            listener: $0a87d142ec6e5dd5$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $0a87d142ec6e5dd5$var$SingletonContrastModeObserver = new $0a87d142ec6e5dd5$var$ContrastModeObserver();
var $0a87d142ec6e5dd5$export$2e2bcd8739ae039 = $0a87d142ec6e5dd5$var$SingletonContrastModeObserver;

});



parcelRegister("60yhz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b02187130652f29$export$2e2bcd8739ae039);

var $a9dFP = parcelRequire("a9dFP");

var $8z9j5 = parcelRequire("8z9j5");
class $2b02187130652f29$export$2e2bcd8739ae039 {
    observe() {
        if (!$2b02187130652f29$export$2e2bcd8739ae039.observer) {
            $2b02187130652f29$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $8z9j5.default)();
                $2b02187130652f29$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $2b02187130652f29$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $a9dFP.THEME_DATA_ATTRIBUTE),
                    (0, $a9dFP.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $2b02187130652f29$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($2b02187130652f29$export$2e2bcd8739ae039.callbacks.size === 0 && $2b02187130652f29$export$2e2bcd8739ae039.observer) {
            $2b02187130652f29$export$2e2bcd8739ae039.observer.disconnect();
            $2b02187130652f29$export$2e2bcd8739ae039.observer = null;
        }
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = void 0;
        this.callback = callback;
        $2b02187130652f29$export$2e2bcd8739ae039.callbacks.add(callback);
    }
}
$2b02187130652f29$export$2e2bcd8739ae039.observer = null;
$2b02187130652f29$export$2e2bcd8739ae039.callbacks = new Set();

});

parcelRegister("5dK2X", function(module, exports) {

$parcel$export(module.exports, "default", () => $09e903c734194f41$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $5Uzw3 = parcelRequire("5Uzw3");

var $kFobZ = parcelRequire("kFobZ");

var $5rrZR = parcelRequire("5rrZR");

var $avd77 = parcelRequire("avd77");
const $09e903c734194f41$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $09e903c734194f41$var$resetStyles = (0, $3jLHL.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
const $09e903c734194f41$var$strongStyles = (0, $3jLHL.css)({
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
const $09e903c734194f41$var$emStyles = (0, $3jLHL.css)({
    fontStyle: 'italic'
});
const $09e903c734194f41$var$textAlignMap = {
    center: (0, $3jLHL.css)({
        textAlign: 'center'
    }),
    end: (0, $3jLHL.css)({
        textAlign: 'end'
    }),
    start: (0, $3jLHL.css)({
        textAlign: 'start'
    })
};
const $09e903c734194f41$var$truncationStyles = (0, $3jLHL.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
const $09e903c734194f41$var$wordBreakMap = {
    breakAll: (0, $3jLHL.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $09e903c734194f41$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $5rrZR.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $avd77.inverseColorMap).hasOwnProperty(surface)) return (0, $avd77.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $09e903c734194f41$var$Text = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $5Uzw3.default)($09e903c734194f41$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $kFobZ.useHasTextAncestor)();
    const color = $09e903c734194f41$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $3jLHL.jsx)(Component, {
        ref: ref,
        css: [
            $09e903c734194f41$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $avd77.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $avd77.textColorStylesMap)[color],
            maxLines && $09e903c734194f41$var$truncationStyles,
            maxLines === 1 && $09e903c734194f41$var$wordBreakMap.breakAll,
            align && $09e903c734194f41$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $avd77.textWeightStylesMap)[weight],
            Component === 'em' && $09e903c734194f41$var$emStyles,
            Component === 'strong' && $09e903c734194f41$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $3jLHL.jsx)((0, $kFobZ.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $09e903c734194f41$export$2e2bcd8739ae039 = $09e903c734194f41$var$Text;

});
parcelRegister("kFobZ", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", () => $94814a712afd9b2e$export$9322276ec105d055);
$parcel$export(module.exports, "HasTextAncestorProvider", () => $94814a712afd9b2e$export$ae933c6cbe5643ad);

var $gwFzn = parcelRequire("gwFzn");
const $94814a712afd9b2e$var$HasTextAncestorContext = /*#__PURE__*/ (0, $gwFzn.createContext)(false);
const $94814a712afd9b2e$export$9322276ec105d055 = ()=>(0, $gwFzn.useContext)($94814a712afd9b2e$var$HasTextAncestorContext);
const $94814a712afd9b2e$export$ae933c6cbe5643ad = $94814a712afd9b2e$var$HasTextAncestorContext.Provider;

});


parcelRegister("5SzHz", function(module, exports) {

$parcel$export(module.exports, "preloadSpaceDetail", () => $01831239f93415a0$export$2403e25f29f92c16);

var $dYU3e = parcelRequire("dYU3e");

var $6mKj3 = parcelRequire("6mKj3");

var $4QkCw = parcelRequire("4QkCw");
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '')=>{
    if (spaceKey && !(0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) return (0, $dYU3e.query)({
        query: (0, $4QkCw.SpaceDetailQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
    return Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
};

});
parcelRegister("4QkCw", function(module, exports) {

$parcel$export(module.exports, "SpaceDetailQuery", () => $3c15f160eb03021d$export$feebdf21739b6c4b);

var $d2LG0 = parcelRequire("d2LG0");
const $3c15f160eb03021d$export$feebdf21739b6c4b = (0, $d2LG0.default)`query SpaceDetailQuery($spaceKey:String){space(key:$spaceKey){id name alias key type dataClassificationTags}}`;

});


parcelRegister("6bQlH", function(module, exports) {

$parcel$export(module.exports, "getApolloCache", () => $5fea79bbaf762dea$export$c25b3a02c2d5dc72);
$parcel$export(module.exports, "setFallbackAtlExperience", () => $5fea79bbaf762dea$export$7388eaba0b85ff24);
$parcel$export(module.exports, "enableGraphqlRetries", () => $5fea79bbaf762dea$export$948cfabebbf3f293);

var $7Sm4c = parcelRequire("7Sm4c");

var $8H5XZ = parcelRequire("8H5XZ");

var $eHj6r = parcelRequire("eHj6r");

var $gKr8t = parcelRequire("gKr8t");

var $eE7v6 = parcelRequire("eE7v6");


var $e43zd = parcelRequire("e43zd");

var $b2nDI = parcelRequire("b2nDI");




var $7r0e1 = parcelRequire("7r0e1");

var $hp2SH = parcelRequire("hp2SH");

function $5fea79bbaf762dea$export$c25b3a02c2d5dc72() {
    return 0, $eHj6r.apolloCache;
}
function $5fea79bbaf762dea$export$b4a2d416bf2548b() {
    return 0, $gKr8t.apolloAGGCache;
}
function $5fea79bbaf762dea$export$6c285e8febf86122(uri) {
    window['GLOBAL_APOLLO_CLIENT_URI'] = uri;
}
function $5fea79bbaf762dea$export$7388eaba0b85ff24(exp) {
    window['GLOBAL_FALLBACK_ATL_EXP'] = exp;
}
function $5fea79bbaf762dea$export$c02bc301beb4f28(value) {
    window['GLOBAL_APOLLO_SKIP_QUERY'] = value;
}
function $5fea79bbaf762dea$export$948cfabebbf3f293() {
    (0, $e43zd.enableNetworkRetryLink)();
    (0, $b2nDI.enableStatusCodeRetryLink)();
}

});
parcelRegister("7r0e1", function(module, exports) {

$parcel$export(module.exports, "useQueryNoFurtherUpdate", () => $eaa7ed6d4ed0fcab$export$1971d5caa800af4);

var $gwFzn = parcelRequire("gwFzn");

var $aTqya = parcelRequire("aTqya");

var $hp2SH = parcelRequire("hp2SH");
const $eaa7ed6d4ed0fcab$var$queryResults = new WeakMap();
function $eaa7ed6d4ed0fcab$export$1971d5caa800af4(query, options) {
    const client = options?.client ?? (0, $hp2SH.getApolloClient)();
    let dataFromCache = null;
    try {
        if (!options?.skip) dataFromCache = client.readQuery({
            query: query,
            ...options
        });
    } catch  {}
    const [result, setResult] = (0, $gwFzn.useState)(()=>{
        return dataFromCache ? {
            data: dataFromCache,
            loading: false,
            networkStatus: (0, $aTqya.NetworkStatus).ready
        } : {
            data: null,
            loading: true,
            networkStatus: (0, $aTqya.NetworkStatus).loading
        };
    });
    (0, $gwFzn.useEffect)(()=>{
        if (result.loading && !options?.skip) {
            // technically not a hash but it's good enough since variable is an plain object.
            const variablesHash = JSON.stringify(options?.variables || {});
            // Same query + variable should reuse the same promise to avoid going through expensive Apollo client.
            let queryResultPromise;
            if ($eaa7ed6d4ed0fcab$var$queryResults.has(query) && $eaa7ed6d4ed0fcab$var$queryResults.get(query).has(variablesHash)) queryResultPromise = $eaa7ed6d4ed0fcab$var$queryResults.get(query)?.get(variablesHash);
            else {
                queryResultPromise = client.query({
                    query: query,
                    ...options
                });
                if (!$eaa7ed6d4ed0fcab$var$queryResults.has(query)) $eaa7ed6d4ed0fcab$var$queryResults.set(query, new Map());
                $eaa7ed6d4ed0fcab$var$queryResults.get(query).set(variablesHash, queryResultPromise);
            }
            queryResultPromise.then((result)=>setResult(result)).catch((e)=>{
                setResult({
                    ...result,
                    loading: false,
                    networkStatus: (0, $aTqya.NetworkStatus).ready,
                    error: e
                });
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return result;
}

});


parcelRegister("lesra", function(module, exports) {

$parcel$export(module.exports, "API_DEFAULT_THEME_STATE", () => $7aee2c9bb6aa1dbe$export$758dd268a3743917);
$parcel$export(module.exports, "API_ORIGINAL_THEME_STATE", () => $7aee2c9bb6aa1dbe$export$736646d09a814fb6);
$parcel$export(module.exports, "getEffectiveThemeState", () => $7aee2c9bb6aa1dbe$export$f0d5a0615e86ce0);
$parcel$export(module.exports, "getEffectiveThemeStateSerialized", () => $7aee2c9bb6aa1dbe$export$64359bcab6734a31);

var $j6S25 = parcelRequire("j6S25");

var $hxeND = parcelRequire("hxeND");

var $58u2L = parcelRequire("58u2L");
const $7aee2c9bb6aa1dbe$export$758dd268a3743917 = 'default';
const $7aee2c9bb6aa1dbe$export$736646d09a814fb6 = 'original';
const $7aee2c9bb6aa1dbe$export$f0d5a0615e86ce0 = (themeStateSerialized)=>{
    if ([
        $7aee2c9bb6aa1dbe$export$736646d09a814fb6,
        $7aee2c9bb6aa1dbe$export$758dd268a3743917
    ].includes(themeStateSerialized)) return (0, $58u2L.getDefaultTheme)();
    return (0, $hxeND.buildThemeFromState)((0, $j6S25.themeStringToObject)(themeStateSerialized));
};
const $7aee2c9bb6aa1dbe$export$64359bcab6734a31 = (themeStateOrDefault)=>{
    if (themeStateOrDefault === $7aee2c9bb6aa1dbe$export$758dd268a3743917 || themeStateOrDefault === $7aee2c9bb6aa1dbe$export$736646d09a814fb6) return themeStateOrDefault;
    return (0, $j6S25.themeObjectToString)(themeStateOrDefault);
};

});
parcelRegister("hxeND", function(module, exports) {

$parcel$export(module.exports, "buildThemeFromState", () => $eedd4917ca826380$export$e099b20409de544b);

var $58u2L = parcelRequire("58u2L");
const $eedd4917ca826380$export$e099b20409de544b = (themeState)=>{
    return {
        ...(0, $58u2L.getDefaultTheme)(),
        ...themeState,
        typography: 'typography-refreshed'
    };
};

});


parcelRegister("8CHHT", function(module, exports) {

$parcel$export(module.exports, "preloadUseExtensionList", () => $23196774779b9db8$export$afb6180712276ba1);

var $bsX2q = parcelRequire("bsX2q");

var $jLfE2 = parcelRequire("jLfE2");
var $dYU3e = parcelRequire("dYU3e");

var $d9tcB = parcelRequire("d9tcB");

var $5SzHz = parcelRequire("5SzHz");

var $PrCoC = parcelRequire("PrCoC");

var $7bGfj = parcelRequire("7bGfj");

var $ai75e = parcelRequire("ai75e");

var $3b6WO = parcelRequire("3b6WO");

var $8pViN = parcelRequire("8pViN");
async function $23196774779b9db8$export$afb6180712276ba1({ contentId: contentId, spaceKey: spaceKey, moduleType: moduleType, queryOptions: queryOptions, expandAppOwner: expandAppOwner = false, skipFilter: skipFilter = false }) {
    const { cloudId: cloudId, activationId: activationId, isLoggedIn: isLoggedIn, accessStatus: accessStatus, locale: locale } = await (0, $jLfE2.getPreloaderFnContext)();
    const hasAccessNarrowingSupport = (0, $3b6WO.supportsAccessNarrowing)(moduleType);
    const isAnonymous = !isLoggedIn;
    const isExternalCollaborator = accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    const [staticContext, { data: data }] = await Promise.all([
        (0, $7bGfj.preloadUseStaticContext)({
            spaceKey: spaceKey
        }),
        (0, $5SzHz.preloadSpaceDetail)(spaceKey)
    ]);
    const dataClassificationTags = data?.space?.dataClassificationTags;
    try {
        const extensions = await (0, $bsX2q.getExtensionListForSSR)({
            ...(0, $8pViN.getUseExtensionListOptions)({
                cloudId: cloudId,
                activationId: activationId,
                locale: locale,
                dataClassificationTags: dataClassificationTags,
                hasAccessNarrowingSupport: hasAccessNarrowingSupport,
                expandAppOwner: expandAppOwner,
                moduleType: moduleType,
                queryOptions: queryOptions,
                skip: isAnonymous || isExternalCollaborator,
                skipFilter: skipFilter
            }),
            queryFn: (0, $dYU3e.query)
        });
        if (extensions) {
            const fetchContext = {
                contentId: contentId,
                spaceKey: spaceKey
            };
            const filteredResult = await (0, $ai75e.filterExtensionsByDisplayConditions)(extensions, staticContext, fetchContext);
            window.__SSR_FORGE_EXTENSIONS__ = window.__SSR_FORGE_EXTENSIONS__ || {};
            window.__SSR_FORGE_EXTENSIONS__[moduleType] = {
                extensions: filteredResult.extsToDisplay,
                error: filteredResult.conditionsError
            };
        }
    } catch (e) {
        (0, $PrCoC.ssrPrepareErrorsClient).submitError(new Error(`Filed to get forge extension list: ${e.message}`));
    }
}

});
parcelRegister("bsX2q", function(module, exports) {

$parcel$export(module.exports, "createExtensionListQueryOptions", () => $0f17c7f20af36c2d$export$73c0408abd298d1b);
$parcel$export(module.exports, "getExtensionsFromGQLResult", () => $0f17c7f20af36c2d$export$1e6dc3c07340999);
$parcel$export(module.exports, "getExtensionListForSSR", () => $0f17c7f20af36c2d$export$152846a4183c1a10);
$parcel$export(module.exports, "useExtensionList", () => $0f17c7f20af36c2d$export$cab421e039d23b2);

var $gwFzn = parcelRequire("gwFzn");

var $xQxzY = parcelRequire("xQxzY");

var $dh538 = parcelRequire("dh538");

var $grQpA = parcelRequire("grQpA");

var $5U2YR = parcelRequire("5U2YR");

var $39Ajm = parcelRequire("39Ajm");

var $inPa6 = parcelRequire("inPa6");

var $7TH2w = parcelRequire("7TH2w");

var $3Spjc = parcelRequire("3Spjc");

var $1Igmn = parcelRequire("1Igmn");
const $0f17c7f20af36c2d$export$73c0408abd298d1b = (client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale, ssr = false)=>{
    const variables = filter ? {
        contextIds: contextIds,
        locale: locale,
        filter: filter
    } : {
        contextIds: contextIds,
        locale: locale,
        type: extensionType
    };
    const query = filter ? (0, $39Ajm.getExtensionListQuery)(expandAppOwner, dataClassificationTagIds) : (0, $39Ajm.getExtensionListQueryOld)(expandAppOwner, undefined, dataClassificationTagIds);
    const headers = {};
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $dh538.fg)('forge-ui-include-atl-attribution-header')) headers['atl-attribution'] = (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join());
    // In SSR mode render and fetch is one-pass we can't do cache-and-network
    if (ssr && queryOptions?.fetchPolicy === 'cache-and-network') queryOptions.fetchPolicy = 'cache-first';
    return {
        variables: variables,
        ...queryOptions,
        query: query,
        client: client,
        /**
		 * We don't want to set 'ignore' because that discards errors and we need to inspect
		 * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
		 * https://www.apollographql.com/docs/react/data/error-handling/
		 */ errorPolicy: 'all',
        context: {
            headers: headers
        }
    };
};
const $0f17c7f20af36c2d$export$1e6dc3c07340999 = ({ loading: loading, data: data })=>{
    if (!loading && data && data.extensionContexts && data.extensionContexts[0]) {
        if ('extensions' in data.extensionContexts[0]) return data.extensionContexts[0].extensions ?? null;
        else if ('extensionsByType' in data.extensionContexts[0]) return data.extensionContexts[0].extensionsByType ?? null;
    }
    return null;
};
const $0f17c7f20af36c2d$export$152846a4183c1a10 = async ({ client: client, contextIds: contextIds, type: extensionType, filter: filter, queryOptions: queryOptions, expandAppOwner: expandAppOwner, dataClassificationTagIds: dataClassificationTagIds, locale: locale, queryFn: queryFn })=>{
    if (!queryFn) return null;
    const requestOptions = $0f17c7f20af36c2d$export$73c0408abd298d1b(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale, true);
    const query = filter ? (0, $39Ajm.getExtensionListQuery)(expandAppOwner) : (0, $39Ajm.getExtensionListQueryOld)(expandAppOwner);
    requestOptions.query = requestOptions.query || query;
    const { data: data } = await queryFn(requestOptions);
    if (!data) return null;
    return $0f17c7f20af36c2d$export$1e6dc3c07340999({
        loading: false,
        data: data
    });
};
const $0f17c7f20af36c2d$export$cab421e039d23b2 = ({ contextIds: contextIds, type: extensionType, filter: filter, client: client, queryOptions: queryOptions, expandAppOwner: expandAppOwner, dataClassificationTagIds: dataClassificationTagIds, locale: locale })=>{
    const requestOptions = $0f17c7f20af36c2d$export$73c0408abd298d1b(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale);
    const query = filter ? (0, $39Ajm.getExtensionListQuery)(expandAppOwner) : (0, $39Ajm.getExtensionListQueryOld)(expandAppOwner);
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)(requestOptions.query || query, requestOptions);
    const extensions = $0f17c7f20af36c2d$export$1e6dc3c07340999({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'useExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err = error.graphQLErrors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};

});
parcelRegister("grQpA", function(module, exports) {

$parcel$export(module.exports, "GQLExtensionContextsFilterType", () => $3afb5a6a58db13d7$export$d76ef0f862d061a6);
$parcel$export(module.exports, "isGQLGatewayError", () => $3afb5a6a58db13d7$export$8d1c210bc17223c1);
$parcel$export(module.exports, "isGQLUnderlyingServiceError", () => $3afb5a6a58db13d7$export$9c0545f564a8227f);
var $3afb5a6a58db13d7$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $3afb5a6a58db13d7$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $3afb5a6a58db13d7$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';

});

parcelRegister("5U2YR", function(module, exports) {

$parcel$export(module.exports, "MetricsContext", () => $a50a0967117e6a0e$export$b438ce9ad9530ae5);
$parcel$export(module.exports, "MetricsContextProvider", () => $a50a0967117e6a0e$export$163ecee29aa3a8f);
$parcel$export(module.exports, "useMetricsContext", () => $a50a0967117e6a0e$export$dba2dab0d0f39612);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $76I1K = parcelRequire("76I1K");

var $jIiuI = parcelRequire("jIiuI");
const $a50a0967117e6a0e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $a50a0967117e6a0e$export$163ecee29aa3a8f = ({ value: value, children: children })=>{
    const envFromContext = (0, $gwFzn.useContext)((0, $jIiuI.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $76I1K.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($a50a0967117e6a0e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue,
        children: children
    });
};
const $a50a0967117e6a0e$export$dba2dab0d0f39612 = ()=>{
    return (0, $gwFzn.useContext)($a50a0967117e6a0e$export$b438ce9ad9530ae5);
};

});
parcelRegister("jIiuI", function(module, exports) {

$parcel$export(module.exports, "EnvironmentContext", () => $669e2d348d1011a7$export$6a671bebd9daad64);

var $gwFzn = parcelRequire("gwFzn");
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");
const $669e2d348d1011a7$export$6a671bebd9daad64 = (0, $gwFzn.createContext)((0, $1Aku8.ProductEnvironment).PRODUCTION);

});
parcelRegister("1c598", function(module, exports) {

$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");
parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");

});
parcelRegister("i3Ypo", function(module, exports) {

$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");

var $1Aku8 = parcelRequire("1Aku8");

var $6sM2K = parcelRequire("6sM2K");

var $2JC3k = parcelRequire("2JC3k");

});
parcelRegister("9dbGT", function(module, exports) {

$parcel$export(module.exports, "MarkupRecursiveList", () => $1ec3e8240f57817b$export$3b98ab6402702476);
$parcel$export(module.exports, "MarkupList", () => $1ec3e8240f57817b$export$3ee8c58bb87b9685);
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {

$parcel$export(module.exports, "ProductEnvironment", () => $d128cc36ec70c56c$export$2688cec3c24cb60b);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => $d128cc36ec70c56c$export$beaef1891b3e7ca3);
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {

$parcel$export(module.exports, "ExtensionEnvironment", () => $d977f97374f9d2c9$export$6e95f5308d9156f9);
$parcel$export(module.exports, "ConfluenceExtension", () => $d977f97374f9d2c9$export$9a2372818e2520c6);
$parcel$export(module.exports, "JiraExtension", () => $d977f97374f9d2c9$export$f06ffa3aa6bfec95);
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};

});


parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");

var $kg3OT = parcelRequire("kg3OT");

var $gUjm2 = parcelRequire("gUjm2");

});
parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});





parcelRegister("39Ajm", function(module, exports) {

$parcel$export(module.exports, "getExtensionListQueryOld", () => $2ce486181186726b$export$b4649e379af92913);
$parcel$export(module.exports, "getExtensionListQuery", () => $2ce486181186726b$export$23f6ad93bea7724);

var $d2LG0 = parcelRequire("d2LG0");

var $dh538 = parcelRequire("dh538");
const $2ce486181186726b$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2ce486181186726b$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $d2LG0.default)`${query}`;
};
const $2ce486181186726b$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $d2LG0.default)`${query}`;
};

});

parcelRegister("7TH2w", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $c1d340ae8dab4627$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $c1d340ae8dab4627$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $c1d340ae8dab4627$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $c1d340ae8dab4627$export$12346a674644c156);
$parcel$export(module.exports, "DEFAULT_SOURCE", () => $c1d340ae8dab4627$export$b055de0e665cb20c);
// same types defined in analytics-web-client but avoid creating dependency with that
const $c1d340ae8dab4627$export$a1562d08625f5d7e = 'ui';
const $c1d340ae8dab4627$export$947dac6c72b26f81 = 'track';
const $c1d340ae8dab4627$export$f1d537d508d2945a = 'screen';
const $c1d340ae8dab4627$export$12346a674644c156 = 'operational';
const $c1d340ae8dab4627$export$b055de0e665cb20c = 'unknown';

});

parcelRegister("3Spjc", function(module, exports) {

$parcel$export(module.exports, "FORGE_UI_ANALYTICS_CHANNEL", () => $ee4a4828226e63ce$export$d28801614368e543);
$parcel$export(module.exports, "sendEvent", () => $ee4a4828226e63ce$export$7329bcdc3edcd90e);
$parcel$export(module.exports, "default", () => $ee4a4828226e63ce$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $kDuN4 = parcelRequire("kDuN4");

var $7TH2w = parcelRequire("7TH2w");
const $ee4a4828226e63ce$export$d28801614368e543 = 'forge-ui';
const $ee4a4828226e63ce$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $7TH2w.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $7TH2w.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $7TH2w.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $ee4a4828226e63ce$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
const $ee4a4828226e63ce$var$ForgeUIAnalyticsListener = ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $ee4a4828226e63ce$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $ee4a4828226e63ce$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDuN4.default), {
        onEvent: listenerHandler,
        channel: $ee4a4828226e63ce$export$d28801614368e543,
        children: children
    });
};
var $ee4a4828226e63ce$export$2e2bcd8739ae039 = $ee4a4828226e63ce$var$ForgeUIAnalyticsListener;

});
parcelRegister("kDuN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a6a1dbb8af9a9ed$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $8OOLo = parcelRequire("8OOLo");

var $ji1lM = parcelRequire("ji1lM");

var $gksg0 = parcelRequire("gksg0");
const $2a6a1dbb8af9a9ed$var$ExportedAnalyticsListener = (props)=>{
    const isModernContext = (0, $8OOLo.default) || (0, $dh538.fg)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gksg0.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ji1lM.default), {
        ...props
    });
};
var $2a6a1dbb8af9a9ed$export$2e2bcd8739ae039 = $2a6a1dbb8af9a9ed$var$ExportedAnalyticsListener;

});
parcelRegister("8OOLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $64a48c975d7be76e$export$2e2bcd8739ae039);
/// <reference types="node" />

var $3mTvL = parcelRequire("3mTvL");
var $64a48c975d7be76e$export$2e2bcd8739ae039 = typeof $3mTvL !== 'undefined' && $3mTvL !== null && $3mTvL.env?.['ANALYTICS_NEXT_MODERN_CONTEXT'];

});

parcelRegister("ji1lM", function(module, exports) {

$parcel$export(module.exports, "default", () => $758d3573a6ed6002$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $1M56W = parcelRequire("1M56W");
const $758d3573a6ed6002$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func
};
const $758d3573a6ed6002$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $758d3573a6ed6002$var$AnalyticsListener extends (0, $gwFzn.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1M56W.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
    constructor(props){
        super(props);
        this.context = void 0;
        this.contextValue = void 0;
        this.getChildContext = ()=>({
                getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext
            });
        this.getAnalyticsEventHandlers = ()=>{
            const { channel: channel, onEvent: onEvent } = this.props;
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $758d3573a6ed6002$var$noop } = this.context;
            const handler = (event, eventChannel)=>{
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler,
                ...getAtlaskitAnalyticsEventHandlers()
            ];
        };
        this.getAtlaskitAnalyticsContext = ()=>{
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $758d3573a6ed6002$var$noop } = this.context;
            return getAtlaskitAnalyticsContext();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
}
$758d3573a6ed6002$var$AnalyticsListener.contextTypes = $758d3573a6ed6002$var$ContextTypes;
$758d3573a6ed6002$var$AnalyticsListener.childContextTypes = $758d3573a6ed6002$var$ContextTypes;
var $758d3573a6ed6002$export$2e2bcd8739ae039 = $758d3573a6ed6002$var$AnalyticsListener;

});

parcelRegister("gksg0", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcdbf3af0374115c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1M56W = parcelRequire("1M56W");

var $fFVny = parcelRequire("fFVny");

var $fTXBo = parcelRequire("fTXBo");
const $fcdbf3af0374115c$var$AnalyticsListener = ({ children: children, channel: channel, onEvent: onEvent })=>{
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = ()=>[], getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext } = (0, $fFVny.useAnalyticsContext)();
    const onEventRef = (0, $fTXBo.useTrackedRef)(onEvent);
    const channelRef = (0, $fTXBo.useTrackedRef)(channel);
    const getAnalyticsEventHandlers = (0, $gwFzn.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler,
            ...getAtlaskitAnalyticsEventHandlers()
        ];
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    const value = (0, $gwFzn.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1M56W.default).Provider, {
        value: value,
        children: children
    });
};
var $fcdbf3af0374115c$export$2e2bcd8739ae039 = $fcdbf3af0374115c$var$AnalyticsListener;

});



parcelRegister("1Igmn", function(module, exports) {

$parcel$export(module.exports, "createAtlAttributionHeader", () => $0be0f811af274f82$export$14ef296862e3705e);
// our service
const $0be0f811af274f82$var$SERVICE = 'forge-ui';
// static values to pass to atl-attribution header taken from go/workday
const $0be0f811af274f82$var$BUSINESS_UNIT = 'Ecosystem Engineering';
const $0be0f811af274f82$var$COST_CENTER = '3039';
const $0be0f811af274f82$var$TEAM = 'Eng - Ecosystem - Developer Platform - UI';
const $0be0f811af274f82$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $0be0f811af274f82$var$SERVICE,
        businessUnit: $0be0f811af274f82$var$BUSINESS_UNIT,
        costCenter: $0be0f811af274f82$var$COST_CENTER,
        team: $0be0f811af274f82$var$TEAM
    });
};

});


parcelRegister("7bGfj", function(module, exports) {

$parcel$export(module.exports, "preloadUseStaticContext", () => $2425eddd602024a2$export$b1ba723b791aac28);

var $jLfE2 = parcelRequire("jLfE2");
var $dYU3e = parcelRequire("dYU3e");

var $fWkVZ = parcelRequire("fWkVZ");
var $w033M = parcelRequire("w033M");

var $PrCoC = parcelRequire("PrCoC");

var $fZP6u = parcelRequire("fZP6u");

var $lW4X5 = parcelRequire("lW4X5");
async function $2425eddd602024a2$export$b1ba723b791aac28({ spaceKey: spaceKey }) {
    const { isLoggedIn: isLoggedIn } = await (0, $jLfE2.getPreloaderFnContext)();
    try {
        const [{ data: spaceAdminData }, { data: privilegeData }] = await Promise.all([
            (0, $dYU3e.query)({
                query: (0, $fZP6u.DisplayConditionsSpaceAdminQuery),
                variables: {
                    spaceKey: spaceKey
                }
            }),
            (0, $dYU3e.query)({
                query: (0, $lW4X5.UserPrivilegeQuery)
            })
        ]);
        const isSpaceAdmin = spaceAdminData?.space?.currentUser?.isAdmin;
        const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(privilegeData);
        const isAdmin = isSiteAdmin || (0, $fWkVZ.getIsProductAdminFromQuery)(privilegeData);
        return {
            isSpaceAdmin: isSpaceAdmin,
            isLoggedIn: isLoggedIn,
            isAdmin: isAdmin,
            isSiteAdmin: isSiteAdmin
        };
    } catch (e) {
        (0, $PrCoC.ssrPrepareErrorsClient).submitError(new Error(`Cannot preload data for useStaticContext, using defaults for SSR: ${e.message}`));
        return {
            isLoggedIn: isLoggedIn,
            isSpaceAdmin: false,
            isAdmin: false,
            isSiteAdmin: false
        };
    }
}

});
parcelRegister("fWkVZ", function(module, exports) {

$parcel$export(module.exports, "getIsProductAdminFromQuery", () => $b7fc105cb96f63fd$export$7ed4faccc7e85b7f);
const $b7fc105cb96f63fd$export$7ed4faccc7e85b7f = (queryData)=>Boolean(queryData?.user?.confluence?.operations?.some((o)=>o?.operation === 'administer' && o?.targetType === 'application'));

});

parcelRegister("w033M", function(module, exports) {

$parcel$export(module.exports, "getIsSiteAdminFromQuery", () => $ea2c8f52a33264f1$export$4782acb2cb5b7c11);
const $ea2c8f52a33264f1$export$4782acb2cb5b7c11 = (queryData)=>Boolean(queryData?.isSiteAdmin);

});

parcelRegister("fZP6u", function(module, exports) {

$parcel$export(module.exports, "DisplayConditionsSpaceAdminQuery", () => $b1231f710711408a$export$f23a0916c5538950);

var $d2LG0 = parcelRequire("d2LG0");
const $b1231f710711408a$export$f23a0916c5538950 = (0, $d2LG0.default)`query DisplayConditionsSpaceAdminQuery($spaceKey:String!){space(key:$spaceKey){id currentUser{isAdmin}}}`;

});

parcelRegister("lW4X5", function(module, exports) {

$parcel$export(module.exports, "UserPrivilegeQuery", () => $1d2ccf453314b8e9$export$7f7daa8dea90d2b2);

var $d2LG0 = parcelRequire("d2LG0");
const $1d2ccf453314b8e9$export$7f7daa8dea90d2b2 = (0, $d2LG0.default)`query UserPrivilegeQuery{user:confluence_atlassianUser(current:true){id confluence{operations{operation targetType}}}isSiteAdmin hasUserAccessAdminRole}`;

});


parcelRegister("ai75e", function(module, exports) {

$parcel$export(module.exports, "filterExtensionsByDisplayConditions", () => $3dc7d80f22ba1523$export$fe102d81db9ee117);
$parcel$export(module.exports, "useExtensionsFilteredByDisplayConditions", () => $3dc7d80f22ba1523$export$7e85617fdd979ffe);

var $gwFzn = parcelRequire("gwFzn");

var $5uz1n = parcelRequire("5uz1n");

var $jV49M = parcelRequire("jV49M");

var $inPa6 = parcelRequire("inPa6");

var $dyHbo = parcelRequire("dyHbo");

var $7Sm4c = parcelRequire("7Sm4c");

var $ep3mz = parcelRequire("ep3mz");

var $e4o8D = parcelRequire("e4o8D");

var $7Ndnw = parcelRequire("7Ndnw");

var $hEvd5 = parcelRequire("hEvd5");

var $hrNEt = parcelRequire("hrNEt");
const $3dc7d80f22ba1523$var$noExtensions = [];
const $3dc7d80f22ba1523$var$extendStaticContext = (baseContext, ext)=>{
    const { hasAccess: hasAppAccess = false } = ext.userAccess || {};
    const { active: appIsLicensed = false, capabilitySet: capabilitySet } = ext.license || {};
    const appEdition = $3dc7d80f22ba1523$var$mapCapabilitySetToEdition(capabilitySet);
    const extendedContext = {
        ...baseContext,
        hasAppAccess: hasAppAccess,
        appIsLicensed: appIsLicensed,
        ...appEdition && {
            appEdition: appEdition
        }
    };
    return extendedContext;
};
const $3dc7d80f22ba1523$var$mapCapabilitySetToEdition = (capabilitySet)=>{
    switch(capabilitySet){
        case 'capabilityStandard':
            return 'standard';
        case 'capabilityAdvanced':
            return 'advanced';
        case 'capabilityFree':
            return 'free';
        default:
            return capabilitySet;
    }
};
const $3dc7d80f22ba1523$var$initiateConditionsCheck = (extensions, dataProvider, staticContext)=>{
    // TODO(rtoropov): Add displayConditions to Extension type to avoid conversion to 'any'.
    return extensions.map((ext)=>{
        const conditions = ext.properties.displayConditions;
        if (!conditions) return true;
        const contextToUse = $3dc7d80f22ba1523$var$extendStaticContext(staticContext, ext);
        return (0, $dyHbo.doesMeetConditions)(conditions, contextToUse, dataProvider);
    }).map((boolOrPromise)=>typeof boolOrPromise === 'boolean' ? Promise.resolve(boolOrPromise) : boolOrPromise);
};
const $3dc7d80f22ba1523$var$maybeFetchPropertyData = (dataProvider, fetchContext, fetchErrorRef)=>{
    if (dataProvider.propertyValueRequests.length) (0, $hEvd5.fetchPropertyData)(dataProvider.propertyValueRequests, fetchContext).then((response)=>dataProvider.resolve({
            propertyValues: response
        })).catch((error)=>{
        fetchErrorRef.error = error;
        (0, $7Sm4c.markErrorAsHandled)(error);
        return dataProvider.reject(error);
    });
};
const $3dc7d80f22ba1523$var$hasConditions = (extension)=>extension.properties.displayConditions;
const $3dc7d80f22ba1523$var$getAnalyticsEvent = ({ contentId: contentId, spaceKey: spaceKey, moduleType: moduleType, allExtensions: allExtensions, displayedExtensions: displayedExtensions, propertyRequests: propertyRequests, fetchError: fetchError, conditionsError: conditionsError })=>{
    const requestCountByEntityType = (0, (/*@__PURE__*/$parcel$interopDefault($5uz1n)))(// Remove requests for the same property key and same entity type (could be multiple because of `objectName` attr).
    (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(propertyRequests, (req)=>req.entity + req.propertyKey), (request)=>request.entity);
    return {
        type: 'sendOperationalEvent',
        data: {
            containerType: 'space',
            containerId: spaceKey,
            objectType: 'page',
            objectId: contentId,
            source: moduleType,
            action: 'displayConditionsProcessed',
            actionSubject: 'forgeUIExtensions',
            actionSubjectId: moduleType,
            attributes: {
                totalExtensions: allExtensions.length,
                totalWithConditions: allExtensions.filter($3dc7d80f22ba1523$var$hasConditions).length,
                totalDisplayed: displayedExtensions.length,
                fetchedPropertyCounts: requestCountByEntityType,
                fetchFailed: Boolean(fetchError),
                conditionsFailed: Boolean(conditionsError)
            }
        }
    };
};
const $3dc7d80f22ba1523$var$handleFulfilled = (results, extensions)=>extensions.filter((_, i)=>results[i].status === 'fulfilled' && results[i].value);
const $3dc7d80f22ba1523$var$handleRejected = (results)=>{
    const reason = results.find((result)=>result.status === 'rejected')?.reason;
    return reason ? new Error(reason.message || reason) : undefined;
};
// If the module supports and uses useExtensionsFilteredByDisplayConditions hook, the module name should be added to the array below
const $3dc7d80f22ba1523$var$supportedDisplayConditionsModules = new Set([
    (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
    (0, $7Ndnw.FORGE_MODULE_BYLINE),
    (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
    (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
    (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
    (0, $7Ndnw.FORGE_MODULE_GLOBAL_SETTINGS),
    (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
    (0, $7Ndnw.FORGE_MODULE_SPACE_SETTINGS)
]);
const $3dc7d80f22ba1523$export$fe102d81db9ee117 = async (extensions, staticContext, fetchContext)=>{
    const dataProvider = new (0, $dyHbo.ClientDataProvider)();
    // This function has side effects to set dataProvider.propertyValueRequests used in maybeFetchPropertyData
    const resultsPromises = $3dc7d80f22ba1523$var$initiateConditionsCheck(extensions, dataProvider, staticContext);
    const fetchErrorRef = {};
    // This function has side effects that if it is not called before allSettled, the promise below will never resolve.
    $3dc7d80f22ba1523$var$maybeFetchPropertyData(dataProvider, fetchContext, fetchErrorRef);
    const results = await Promise.allSettled(resultsPromises);
    const extsToDisplay = $3dc7d80f22ba1523$var$handleFulfilled(results, extensions);
    const conditionsError = $3dc7d80f22ba1523$var$handleRejected(results);
    return {
        dataProvider: dataProvider,
        extsToDisplay: extsToDisplay,
        conditionsError: conditionsError,
        fetchError: fetchErrorRef.error
    };
};
function $3dc7d80f22ba1523$export$7e85617fdd979ffe(moduleType, allExtensions, extensionsLoading, extensionsError) {
    const extensions = !allExtensions.length ? $3dc7d80f22ba1523$var$noExtensions : allExtensions;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { staticContext: staticContext, loading: staticContextLoading, error: staticContextError } = (0, $hrNEt.useStaticContext)({
        moduleType: moduleType,
        spaceKey: spaceKey
    });
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [extensionsState, setExtensionsState] = (0, $gwFzn.useState)(()=>{
        // Only use the cached data once on server-side and when hydrate
        const serverOrSSRRendered = renderServerPlaceholder || window.__SSR_RENDERED__;
        const hasContext = !staticContextLoading && staticContext;
        if (serverOrSSRRendered && hasContext && window.__SSR_FORGE_EXTENSIONS__) {
            const cached = window.__SSR_FORGE_EXTENSIONS__[moduleType];
            if (cached) {
                if (window.__SSR_RENDERED__) // Ensure on client-side the cached data only used once when hydrate.
                delete window.__SSR_FORGE_EXTENSIONS__[moduleType];
                return {
                    ...cached,
                    loading: false
                };
            }
        }
        return {
            extensions: $3dc7d80f22ba1523$var$noExtensions,
            loading: true,
            error: undefined
        };
    });
    (0, $gwFzn.useEffect)(()=>{
        if (!$3dc7d80f22ba1523$var$supportedDisplayConditionsModules.has(moduleType)) {
            setExtensionsState({
                extensions: extensions,
                loading: extensionsLoading,
                error: extensionsError
            });
            return;
        }
        if (extensionsError || staticContextError) {
            setExtensionsState({
                extensions: $3dc7d80f22ba1523$var$noExtensions,
                loading: false,
                error: extensionsError || staticContextError
            });
            return;
        }
        if (staticContextLoading || extensionsLoading) return;
        const fetchContext = {
            contentId: contentId,
            spaceKey: spaceKey
        };
        $3dc7d80f22ba1523$export$fe102d81db9ee117(extensions, staticContext, fetchContext).then(({ dataProvider: dataProvider, extsToDisplay: extsToDisplay, conditionsError: conditionsError, fetchError: fetchError })=>{
            setExtensionsState({
                extensions: extsToDisplay,
                loading: false,
                error: conditionsError
            });
            if (extensions.some($3dc7d80f22ba1523$var$hasConditions)) createAnalyticsEvent($3dc7d80f22ba1523$var$getAnalyticsEvent({
                contentId: contentId,
                spaceKey: spaceKey,
                moduleType: moduleType,
                allExtensions: extensions,
                displayedExtensions: extsToDisplay,
                propertyRequests: dataProvider.propertyValueRequests,
                fetchError: fetchError,
                conditionsError: conditionsError
            })).fire();
        });
    }, [
        extensions,
        staticContext,
        extensionsLoading,
        staticContextLoading,
        extensionsError,
        staticContextError,
        contentId,
        spaceKey,
        moduleType,
        createAnalyticsEvent
    ]);
    return extensionsState;
}

});
parcelRegister("ep3mz", function(module, exports) {

$parcel$export(module.exports, "pageStateShape", () => $e24805fae35ad0b6$export$296aceb5cc7d453f);
$parcel$export(module.exports, "initialPageState", () => $e24805fae35ad0b6$export$5bc91d282e4edb5e);
$parcel$export(module.exports, "PageStateContainer", () => $e24805fae35ad0b6$export$18653b487e721221);
$parcel$export(module.exports, "PageSubscriber", () => $e24805fae35ad0b6$export$59f09755fe720062);
$parcel$export(module.exports, "usePageState", () => $e24805fae35ad0b6$export$d2bdb7c20492cc5);
$parcel$export(module.exports, "usePageContentId", () => $e24805fae35ad0b6$export$456b2a163af76e89);
$parcel$export(module.exports, "usePageSpaceKey", () => $e24805fae35ad0b6$export$88a2d28db423ed67);
$parcel$export(module.exports, "useContentType", () => $e24805fae35ad0b6$export$1508d269525fc6e8);

var $fppBw = parcelRequire("fppBw");

var $2S0Fz = parcelRequire("2S0Fz");
var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
var $bd25s = parcelRequire("bd25s");
const $e24805fae35ad0b6$export$296aceb5cc7d453f = (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).shape({
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).symbol
    ]),
    contentIdLoading: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    contentSlug: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    embeddedContentRender: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    queryHash: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    routeName: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number,
    searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    isLite: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).oneOf([
        'page',
        'blogpost',
        'whiteboard',
        'database',
        'embed'
    ])
});
const $e24805fae35ad0b6$var$actions = {
    setPageStore: (pageState)=>({ setState: setState })=>setState(pageState)
};
const $e24805fae35ad0b6$export$5bc91d282e4edb5e = {
    contentId: undefined,
    contentType: undefined,
    contentIdLoading: false,
    contentSlug: undefined,
    embeddedContentRender: undefined,
    queryHash: undefined,
    routeName: undefined,
    spaceKey: undefined,
    versionOverride: undefined,
    isLite: false
};
const $e24805fae35ad0b6$var$PageStore = (0, $4ZoIm.createStore)({
    name: 'PageStore',
    initialState: $e24805fae35ad0b6$export$5bc91d282e4edb5e,
    actions: $e24805fae35ad0b6$var$actions
});
const $e24805fae35ad0b6$export$18653b487e721221 = (0, $2S0Fz.createContainer)($e24805fae35ad0b6$var$PageStore, {
    onInit: ()=>({ setState: setState }, pageState)=>{
            setState(pageState);
        },
    onUpdate: ()=>({ setState: setState }, pageState)=>{
            setState(pageState);
        }
});
const $e24805fae35ad0b6$export$59f09755fe720062 = (0, $bd25s.createSubscriber)($e24805fae35ad0b6$var$PageStore);
const $e24805fae35ad0b6$export$d2bdb7c20492cc5 = (0, $iFWZA.createHook)($e24805fae35ad0b6$var$PageStore);
const $e24805fae35ad0b6$export$456b2a163af76e89 = (0, $iFWZA.createHook)($e24805fae35ad0b6$var$PageStore, {
    selector: (state)=>state.contentId
});
const $e24805fae35ad0b6$export$88a2d28db423ed67 = (0, $iFWZA.createHook)($e24805fae35ad0b6$var$PageStore, {
    selector: (state)=>state.spaceKey
});
const $e24805fae35ad0b6$export$1508d269525fc6e8 = (0, $iFWZA.createHook)($e24805fae35ad0b6$var$PageStore, {
    selector: (state)=>state.contentType
});

});

parcelRegister("7Ndnw", function(module, exports) {

$parcel$export(module.exports, "FORGE_MODULE_BYLINE", () => $af2b0e533822f413$export$77aa6bcc53373193);
$parcel$export(module.exports, "FORGE_MODULE_CONTEXT_MENU", () => $af2b0e533822f413$export$dfd79dc5aae7414d);
$parcel$export(module.exports, "FORGE_MODULE_CONTENT_ACTION", () => $af2b0e533822f413$export$93827e7f1bb6974c);
$parcel$export(module.exports, "FORGE_MODULE_GLOBAL_PAGE", () => $af2b0e533822f413$export$931827627b89a6ba);
$parcel$export(module.exports, "FORGE_MODULE_GLOBAL_SETTINGS", () => $af2b0e533822f413$export$109ae14a8174901f);
$parcel$export(module.exports, "FORGE_MODULE_HOMEPAGE_FEED", () => $af2b0e533822f413$export$e31530da5c277984);
$parcel$export(module.exports, "FORGE_MODULE_PAGE_BANNER", () => $af2b0e533822f413$export$54edc26d40e1a8eb);
$parcel$export(module.exports, "FORGE_MODULE_SPACE_PAGE", () => $af2b0e533822f413$export$75695e15f2aab495);
$parcel$export(module.exports, "FORGE_MODULE_SPACE_SETTINGS", () => $af2b0e533822f413$export$f17386882264cfae);
$parcel$export(module.exports, "FORGE_MODULE_CUSTOM_CONTENT", () => $af2b0e533822f413$export$3e9f3e416c5066aa);
$parcel$export(module.exports, "FORGE_MODULE_BACKGROUND_SCRIPT", () => $af2b0e533822f413$export$b9c5c98eb97dff92);
$parcel$export(module.exports, "FORGE_MODULE_XEN_MACRO", () => $af2b0e533822f413$export$769f3a278705a683);
$parcel$export(module.exports, "forgeGlobalExtensions", () => $af2b0e533822f413$export$492ceb220fc48ad2);
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];

});

parcelRegister("hEvd5", function(module, exports) {

$parcel$export(module.exports, "fetchPropertyData", () => $26012d14f130037a$export$56719c7943afd673);
// Usage of 'lodash/get' is justified here because:
// 1. Object from which the property is read is an arbitrary JSON object thus it has 'any' type.
// 2. The path that is used to read a property from an object is represented by a string and that is coming from a
//    Forge app config, thus 'idx' doesn't quite work here.
// eslint-disable-next-line no-restricted-imports

var $g9LeK = parcelRequire("g9LeK");

var $fTDBP = parcelRequire("fTDBP");

var $gKumh = parcelRequire("gKumh");

var $dyHbo = parcelRequire("dyHbo");

var $hp2SH = parcelRequire("hp2SH");

var $kDGTp = parcelRequire("kDGTp");

var $h3AlT = parcelRequire("h3AlT");
const $26012d14f130037a$var$fetchProperties = (propKeysById, query, fetchContext, extractPropsFromResponse)=>{
    const propKeysToFetch = [
        ...new Set(propKeysById.map(([_, key])=>key))
    ];
    return (0, $hp2SH.getApolloClient)().query({
        query: query,
        fetchPolicy: 'cache-first',
        variables: {
            ...fetchContext,
            propertyKeys: propKeysToFetch
        }
    }).then((response)=>{
        const properties = extractPropsFromResponse(response);
        const propValuesByKeys = new Map(properties.map((prop)=>[
                prop.key,
                JSON.parse(prop.value)
            ]));
        return Object.fromEntries(propKeysById.filter(([_, key])=>propValuesByKeys.has(key)).map(([id, key])=>[
                id,
                propValuesByKeys.get(key)
            ]));
    });
};
const $26012d14f130037a$var$fetchContentProperties = (propKeysById, fetchContext)=>{
    return $26012d14f130037a$var$fetchProperties(propKeysById, (0, $kDGTp.DisplayConditionsContentPropertiesQuery), fetchContext, (res)=>res.data.content.nodes[0].properties.nodes);
};
const $26012d14f130037a$var$fetchSpaceProperties = (propKeysById, fetchContext)=>{
    return $26012d14f130037a$var$fetchProperties(propKeysById, (0, $h3AlT.SpacePropertiesQuery), fetchContext, (res)=>res.data.experimentalSpaceProperties);
};
const $26012d14f130037a$var$propertyFetchers = new Map([
    [
        (0, $dyHbo.EntityType).Content,
        $26012d14f130037a$var$fetchContentProperties
    ],
    [
        (0, $dyHbo.EntityType).Space,
        $26012d14f130037a$var$fetchSpaceProperties
    ]
]);
const $26012d14f130037a$var$createIdToPropValuePair = (propRequest, propValuesById)=>{
    const propValue = propValuesById[propRequest.id];
    if (!propRequest.objectName) return [
        propRequest.id,
        $26012d14f130037a$var$stringify(propValue)
    ];
    const nestedValue = (0, (/*@__PURE__*/$parcel$interopDefault($g9LeK)))(propValue, propRequest.objectName);
    return [
        propRequest.id,
        $26012d14f130037a$var$stringify(nestedValue)
    ];
};
const $26012d14f130037a$var$stringify = (value, stringifyArray = false)=>{
    if (typeof value === 'undefined' || value === null) return undefined;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gKumh)))(value)) return value;
    if (!stringifyArray && Array.isArray(value)) return value.map((item)=>$26012d14f130037a$var$stringify(item, true));
    return JSON.stringify(value);
};
const $26012d14f130037a$export$56719c7943afd673 = (propertyRequestsInput, fetchContext)=>{
    const propertyRequests = propertyRequestsInput || [];
    if (!propertyRequests.length) return Promise.resolve({});
    const requestsByEntityType = (0, (/*@__PURE__*/$parcel$interopDefault($fTDBP)))(propertyRequests, (request)=>request.entity);
    const propValuePromises = Object.entries(requestsByEntityType).map(([entityType, propRequests])=>{
        const propFetcher = $26012d14f130037a$var$propertyFetchers.get(entityType);
        if (!propFetcher) throw new Error(`Can't find entity property fetcher. Unknown entity type: ${entityType}`);
        return propFetcher(propRequests.map((p)=>[
                p.id,
                p.propertyKey
            ]), fetchContext);
    });
    return Promise.all(propValuePromises).then((propValues)=>{
        if (!propValues.length || propValues.every((values)=>!Object.keys(values).length)) return {};
        const allValuesById = propValues.reduce((previous, current)=>({
                ...previous,
                ...current
            }));
        const propValuesResponse = {};
        propertyRequests.map((propRequest)=>$26012d14f130037a$var$createIdToPropValuePair(propRequest, allValuesById)).filter(([_, value])=>typeof value !== 'undefined') // Filter out those with undefined value.
        .forEach(([id, value])=>propValuesResponse[id] = value);
        return propValuesResponse;
    });
};

});
parcelRegister("kDGTp", function(module, exports) {

$parcel$export(module.exports, "DisplayConditionsContentPropertiesQuery", () => $14c27313364e494e$export$6339cc1dc96d188e);

var $d2LG0 = parcelRequire("d2LG0");
const $14c27313364e494e$export$6339cc1dc96d188e = (0, $d2LG0.default)`query DisplayConditionsContentPropertiesQuery($contentId:ID!$propertyKeys:[String]!){content(id:$contentId){nodes{id properties(keys:$propertyKeys){nodes{id key value}}}}}`;

});

parcelRegister("h3AlT", function(module, exports) {

$parcel$export(module.exports, "SpacePropertiesQuery", () => $ee88e82b5e23aa66$export$c1909450e0cdd8c);

var $d2LG0 = parcelRequire("d2LG0");
const $ee88e82b5e23aa66$export$c1909450e0cdd8c = (0, $d2LG0.default)`query SpacePropertiesQuery($spaceKey:String!$propertyKeys:[String!]!)@experimental{experimentalSpaceProperties(spaceKey:$spaceKey propertyKeys:$propertyKeys){key value}}`;

});


parcelRegister("hrNEt", function(module, exports) {

$parcel$export(module.exports, "useStaticContext", () => $890fd8ee42caf977$export$ea6c3ae2bd3a5510);

var $xQxzY = parcelRequire("xQxzY");

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $fWkVZ = parcelRequire("fWkVZ");
var $w033M = parcelRequire("w033M");

var $a1A9A = parcelRequire("a1A9A");

var $7Ndnw = parcelRequire("7Ndnw");

var $lW4X5 = parcelRequire("lW4X5");

var $fZP6u = parcelRequire("fZP6u");
function $890fd8ee42caf977$export$ea6c3ae2bd3a5510({ moduleType: moduleType, spaceKey: spaceKey }) {
    const { isLoggedIn: isLoggedIn, userId: userId } = (0, $bQm3c.useSessionData)();
    const isGlobalExtension = (0, $7Ndnw.forgeGlobalExtensions).includes(moduleType);
    const { data: spaceAdminData, loading: spaceAdminLoading, error: spaceAdminError } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $fZP6u.DisplayConditionsSpaceAdminQuery), {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey || isGlobalExtension
    });
    const { data: operationData, loading: operationLoading, error: operationError } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $a1A9A.OperationsQuery), {
        skip: !userId
    });
    let canViewUserProfiles = false;
    if (operationData) canViewUserProfiles = operationData?.siteOperations?.userProfile?.includes('read');
    const { data: privilegeData, loading: privilegeLoading, error: privilegeError } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $lW4X5.UserPrivilegeQuery), {
        skip: operationLoading || !!operationError || !canViewUserProfiles
    });
    const isSpaceAdmin = spaceAdminData?.space?.currentUser?.isAdmin;
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(privilegeData);
    const isAdmin = isSiteAdmin || (0, $fWkVZ.getIsProductAdminFromQuery)(privilegeData);
    const staticContext = (0, $gwFzn.useMemo)(()=>({
            isSpaceAdmin: isSpaceAdmin,
            isLoggedIn: isLoggedIn,
            isAdmin: isAdmin,
            isSiteAdmin: isSiteAdmin
        }), [
        isSpaceAdmin,
        isLoggedIn,
        isAdmin,
        isSiteAdmin
    ]);
    if (spaceAdminLoading || spaceAdminError) return {
        loading: spaceAdminLoading,
        error: spaceAdminError
    };
    if (operationLoading || operationError) return {
        loading: operationLoading,
        error: operationError
    };
    if (privilegeLoading || privilegeError) return {
        loading: privilegeLoading,
        error: privilegeError
    };
    return {
        staticContext: staticContext,
        loading: false
    };
}

});


parcelRegister("3b6WO", function(module, exports) {

$parcel$export(module.exports, "supportsAccessNarrowing", () => $8eb9026be26e0c85$export$14fabe1ddcf1dc25);
$parcel$export(module.exports, "useExtensionList", () => $8eb9026be26e0c85$export$cab421e039d23b2);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $bsX2q = parcelRequire("bsX2q");

var $7Sm4c = parcelRequire("7Sm4c");

var $bQm3c = parcelRequire("bQm3c");

var $kqIWy = parcelRequire("kqIWy");

var $ep3mz = parcelRequire("ep3mz");

var $foQ4a = parcelRequire("foQ4a");
parcelRequire("dIouf");
var $bFDX4 = parcelRequire("bFDX4");
var $1uFM6 = parcelRequire("1uFM6");

var $9wGTI = parcelRequire("9wGTI");

var $ai75e = parcelRequire("ai75e");

var $7Ndnw = parcelRequire("7Ndnw");

var $1OQlm = parcelRequire("1OQlm");

var $8pViN = parcelRequire("8pViN");
const $8eb9026be26e0c85$var$supportedAccessNarrowingModules = new Set([
    (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
    (0, $7Ndnw.FORGE_MODULE_BYLINE),
    (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
    (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
    (0, $7Ndnw.FORGE_MODULE_CUSTOM_CONTENT),
    (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
    (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE),
    (0, $7Ndnw.FORGE_MODULE_SPACE_SETTINGS)
]);
const $8eb9026be26e0c85$export$14fabe1ddcf1dc25 = (moduleType)=>{
    return $8eb9026be26e0c85$var$supportedAccessNarrowingModules.has(moduleType);
};
const $8eb9026be26e0c85$export$cab421e039d23b2 = ({ moduleType: moduleType, queryOptions: queryOptions, expandAppOwner: expandAppOwner = false, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false })=>{
    const { locale: locale } = (0, $dBxQj.default)();
    const { userId: userId, cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: spaceData, loading: spaceLoading, error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const isAnonymous = !userId;
    const dataClassificationTags = spaceData?.dataClassificationTags;
    const hasAccessNarrowingSupport = $8eb9026be26e0c85$export$14fabe1ddcf1dc25(moduleType);
    const shouldSkip = Boolean(skipQuery) || !userId || Boolean(isExternalCollaborator) || Boolean(spaceLoading) || Boolean(spaceError);
    // Memorize most of the computations
    const memoHasAccessNarrowingSupport = (0, $gwFzn.useMemo)(()=>$8eb9026be26e0c85$export$14fabe1ddcf1dc25(moduleType), [
        moduleType
    ]);
    const memoUseExtensionListExternalProps = (0, $gwFzn.useMemo)(()=>(0, $8pViN.getUseExtensionListOptions)({
            cloudId: cloudId,
            activationId: activationId,
            locale: locale,
            dataClassificationTags: dataClassificationTags,
            hasAccessNarrowingSupport: memoHasAccessNarrowingSupport,
            expandAppOwner: expandAppOwner,
            moduleType: moduleType,
            queryOptions: queryOptions,
            skip: shouldSkip,
            skipFilter: false
        }), [
        cloudId,
        activationId,
        locale,
        dataClassificationTags,
        memoHasAccessNarrowingSupport,
        expandAppOwner,
        moduleType,
        queryOptions,
        shouldSkip
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = (0, $bsX2q.useExtensionList)((0, $9wGTI.fg)('cc_complexit_fe_reduce_rerender') ? memoUseExtensionListExternalProps : (0, $8pViN.getUseExtensionListOptions)({
        cloudId: cloudId,
        activationId: activationId,
        locale: locale,
        dataClassificationTags: dataClassificationTags,
        hasAccessNarrowingSupport: hasAccessNarrowingSupport,
        expandAppOwner: expandAppOwner,
        moduleType: moduleType,
        queryOptions: queryOptions,
        skip: skipQuery || isAnonymous || isExternalCollaborator || spaceLoading || Boolean(spaceError),
        skipFilter: false
    }));
    // Filter out extensions blocked by App Access Rule if necessary
    const extsDataFilteredByAppAccessRule = (0, $gwFzn.useMemo)(()=>extsData && !returnBlockedExtensions ? extsData.filter((ext)=>!(0, $1OQlm.isBlockedByAppAccessRule)(ext)) : extsData, [
        extsData,
        returnBlockedExtensions
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    const { extensions: extensions, loading: loading, error: error } = (0, $ai75e.useExtensionsFilteredByDisplayConditions)(moduleType, extsDataFilteredByAppAccessRule, extsLoading || spaceLoading, extsError || spaceError);
    return {
        extensions: extensions,
        loading: loading,
        error: error
    };
};

});
parcelRegister("kqIWy", function(module, exports) {

$parcel$export(module.exports, "useSpaceDetail", () => $bbbfebced5e36727$export$7081570f83890156);

var $xQxzY = parcelRequire("xQxzY");

var $4QkCw = parcelRequire("4QkCw");
const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey)=>{
    const { loading: loading, data: data, error: error } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $4QkCw.SpaceDetailQuery), {
        variables: {
            spaceKey: spaceKey
        },
        fetchPolicy: 'cache-first'
    });
    return {
        loading: loading,
        data: data && {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias
        },
        error: error
    };
};

});

parcelRegister("foQ4a", function(module, exports) {

$parcel$export(module.exports, "useIsExternalCollaborator", () => $19052bf55936e796$export$e581bd1f88227e0a);

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");
const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};

});

parcelRegister("1OQlm", function(module, exports) {

$parcel$export(module.exports, "isBlockedByAppAccessRule", () => $b3217fa901c7995d$export$bf98aa5bf4a9468c);
const $b3217fa901c7995d$export$bf98aa5bf4a9468c = (extension)=>extension?.dataClassificationPolicyDecision?.status === 'BLOCKED';

});

parcelRegister("8pViN", function(module, exports) {

$parcel$export(module.exports, "getUseExtensionListOptions", () => $fd7354817da8896a$export$6fc31218a1cb9c7c);

var $grQpA = parcelRequire("grQpA");

var $gKr8t = parcelRequire("gKr8t");

var $aF5bm = parcelRequire("aF5bm");
const $fd7354817da8896a$export$6fc31218a1cb9c7c = ({ cloudId: cloudId, activationId: activationId, locale: locale, dataClassificationTags: dataClassificationTags, hasAccessNarrowingSupport: hasAccessNarrowingSupport, expandAppOwner: expandAppOwner, moduleType: moduleType, queryOptions: queryOptions, skip: skip, skipFilter: skipFilter })=>{
    const workspaceARI = (0, $aF5bm.getWorkspaceARI)({
        cloudId: cloudId,
        activationId: activationId
    });
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        contextIds: [
            workspaceARI
        ],
        type: moduleType,
        queryOptions: {
            ...queryOptions,
            skip: skip
        },
        expandAppOwner: expandAppOwner,
        locale: locale
    };
    // Passing the `filter` key will use the newer extension() resolver over the extensionByType() resolver
    // Going forward we to use the newer resolver
    // IMPORTANT NOTE: For some reason the addition of using filter (uses newer Forge resolver) is causing SSR to timeout when calling
    // preloadUseExtensionList with the FORGE_MODULE_BYLINE extension point. Creating this workaround by skipping the filter - be careful to test before removing this flag.
    // TODO: replace with new resolver  https://product-fabric.atlassian.net/browse/CCECO-3476
    if (hasAccessNarrowingSupport && !skipFilter) {
        options.filter = [
            {
                type: (0, $grQpA.GQLExtensionContextsFilterType).ExtensionType,
                value: [
                    moduleType
                ]
            }
        ];
        options.dataClassificationTagIds = dataClassificationTags || [];
    }
    return options;
};

});
parcelRegister("aF5bm", function(module, exports) {

$parcel$export(module.exports, "getWorkspaceARI", () => $3217b30f8fcccab4$export$c922e8420e7a46c9);
$parcel$export(module.exports, "useWorkspaceARI", () => $3217b30f8fcccab4$export$3c417c5065f4ac35);

var $bQm3c = parcelRequire("bQm3c");
const $3217b30f8fcccab4$export$c922e8420e7a46c9 = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $3217b30f8fcccab4$export$3c417c5065f4ac35 = ()=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    return $3217b30f8fcccab4$export$c922e8420e7a46c9({
        cloudId: cloudId,
        activationId: activationId
    });
};

});




parcelRegister("eSLr0", function(module, exports) {

$parcel$export(module.exports, "TOOLS_MENU_CONTAINER", () => $0673dc41d4591954$export$b1fc939aa7feb92f);
$parcel$export(module.exports, "PAGE_BUTTONS", () => $0673dc41d4591954$export$cc265e0ec08cd67d);
$parcel$export(module.exports, "SYSTEM_CONTENT_BYLINE", () => $0673dc41d4591954$export$9aacf4bfaa57e6fc);
$parcel$export(module.exports, "SYSTEM_CONTENT_METADATA", () => $0673dc41d4591954$export$1b2697f8e6fa897f);
$parcel$export(module.exports, "PAGE_METADATA_BANNER", () => $0673dc41d4591954$export$76fccc09e967256f);
$parcel$export(module.exports, "SYSTEM_HEADER_LEFT", () => $0673dc41d4591954$export$630f26f93c0b82dc);
$parcel$export(module.exports, "SYSTEM_HELP", () => $0673dc41d4591954$export$ac6c373b69972f05);
$parcel$export(module.exports, "SYSTEM_USER", () => $0673dc41d4591954$export$1835f2a2eaa3b55b);
$parcel$export(module.exports, "SYSTEM_ADMIN", () => $0673dc41d4591954$export$8fc5196f34e2202a);
$parcel$export(module.exports, "SYSTEM_EDITOR_PRECURSOR_BUTTONS", () => $0673dc41d4591954$export$e83e042e2b565918);
$parcel$export(module.exports, "CREATE_DIALOG", () => $0673dc41d4591954$export$2a98a7a0b026585a);
$parcel$export(module.exports, "CREATE_SPACE_DIALOG", () => $0673dc41d4591954$export$9022327d826319c7);
$parcel$export(module.exports, "ACTION_PANEL", () => $0673dc41d4591954$export$b7555e81ec195340);
$parcel$export(module.exports, "DASHBOARD_SECONDARY", () => $0673dc41d4591954$export$dbd4ce8bddb36f82);
$parcel$export(module.exports, "ATL_GENERAL", () => $0673dc41d4591954$export$78738b07c213d412);
$parcel$export(module.exports, "ATL_FOOTER", () => $0673dc41d4591954$export$45c1e55ebc7a8070);
$parcel$export(module.exports, "ATL_PAGE_METADATA", () => $0673dc41d4591954$export$e1325689a3e8f66b);
$parcel$export(module.exports, "ATL_PAGE_CONTENT_FOOTER_ACTIONS", () => $0673dc41d4591954$export$e8a1b6a55853b054);
$parcel$export(module.exports, "ATL_EDITOR_SAVEBAR", () => $0673dc41d4591954$export$488204faf384ca14);
$parcel$export(module.exports, "SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY", () => $0673dc41d4591954$export$a7876e82ed48f038);
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';

});

parcelRegister("gYXuI", function(module, exports) {

$parcel$export(module.exports, "ALLOWED_CONTENT_STATUSES", () => $0a2b5b16106e7926$export$3211963609921415);
// In order to allow us to fetch any data for draft content always we need to specify the status
const $0a2b5b16106e7926$export$3211963609921415 = [
    'current',
    'draft',
    'archived'
];

});

parcelRegister("hL5Va", function(module, exports) {

$parcel$export(module.exports, "PageRestrictionsQuery", () => $f12d759194a93053$export$db66a07381b14db8);

var $d2LG0 = parcelRequire("d2LG0");
const $f12d759194a93053$export$db66a07381b14db8 = (0, $d2LG0.default)`query PageRestrictionsQuery($contentId:ID!$status:[String]$includeAncestors:Boolean!){singleContent(id:$contentId status:$status){id hasInheritedRestrictions hasViewRestrictions hasRestrictions ancestors@include(if:$includeAncestors){id title hasRestrictions links{webui}}}}`;

});

parcelRegister("2eBB6", function(module, exports) {

$parcel$export(module.exports, "TitleContentPropertyQuery", () => $1f4aa8fbcf4655e8$export$3c49a0cb2883cfe4);
$parcel$export(module.exports, "HomepageIdQuery", () => $1f4aa8fbcf4655e8$export$ebbf9aacf1858ce5);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $1f4aa8fbcf4655e8$export$3c49a0cb2883cfe4 = (0, $d2LG0.default)`query TitleContentPropertyQuery($contentId:ID$status:[String]){content(id:$contentId status:$status){nodes{id pageTitlePublished:properties(key:"page-title-property-published"){nodes{id key value version{number}}}pageTitleDraft:properties(key:"page-title-property-draft"){nodes{id key value version{number}}}metadata{frontend{coverPictureWidth}}}}}`;
const $1f4aa8fbcf4655e8$export$ebbf9aacf1858ce5 = (0, $d2LG0.default)`query HomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id homepage{id}}}`;

});

parcelRegister("2gD2K", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $b606e78441a46987$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $b606e78441a46987$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eWRwJ = parcelRequire("eWRwJ");
var $ggbZE = parcelRequire("ggbZE");
var $1DWH0 = parcelRequire("1DWH0");

var $9tehW = parcelRequire("9tehW");

var $81yTx = parcelRequire("81yTx");
const $b606e78441a46987$var$packageName = "platform-pkg";
const $b606e78441a46987$var$packageVersion = "0.0.0-use.local";
const $b606e78441a46987$export$d1de3b251ccaa8a3 = (0, $81yTx.default)((0, $9tehW.default));
const $b606e78441a46987$var$createAndFireEventOnAtlaskit = (0, $eWRwJ.default)('atlaskit');
const $b606e78441a46987$var$Select = (0, $ggbZE.default)({
    componentName: 'select',
    packageName: $b606e78441a46987$var$packageName,
    packageVersion: $b606e78441a46987$var$packageVersion
})((0, $1DWH0.default)({
    onChange: $b606e78441a46987$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $b606e78441a46987$var$packageName,
            packageVersion: $b606e78441a46987$var$packageVersion
        }
    })
})($b606e78441a46987$export$d1de3b251ccaa8a3));
var $b606e78441a46987$export$2e2bcd8739ae039 = $b606e78441a46987$var$Select;

});
parcelRegister("eWRwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("ggbZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5586dd8087ce3fa$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $bYRk6 = parcelRequire("bYRk6");
const $a5586dd8087ce3fa$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $gwFzn.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
                data: analyticsData,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(WrappedComponent, {
                    ...rest,
                    ref: ref
                })
            });
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $a5586dd8087ce3fa$export$2e2bcd8739ae039 = $a5586dd8087ce3fa$var$withAnalyticsContext;

});
parcelRegister("bYRk6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea8853976ea9996a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $8OOLo = parcelRequire("8OOLo");

var $563la = parcelRequire("563la");

var $5kH4g = parcelRequire("5kH4g");
const $ea8853976ea9996a$var$ExportedAnalyticsContext = (props)=>{
    const isModernContext = (0, $8OOLo.default) || (0, $dh538.fg)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5kH4g.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $563la.default), {
        ...props
    });
};
var $ea8853976ea9996a$export$2e2bcd8739ae039 = $ea8853976ea9996a$var$ExportedAnalyticsContext;

});
parcelRegister("563la", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dd72f4f00b67523$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $1M56W = parcelRequire("1M56W");
const $7dd72f4f00b67523$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func
};
const $7dd72f4f00b67523$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $7dd72f4f00b67523$var$AnalyticsContext extends (0, $gwFzn.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1M56W.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
    constructor(props){
        super(props);
        this.context = void 0;
        this.contextValue = void 0;
        this.getChildContext = ()=>({
                getAtlaskitAnalyticsContext: this.getAnalyticsContext
            });
        this.getAnalyticsContext = ()=>{
            const { data: data } = this.props;
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $7dd72f4f00b67523$var$noop } = this.context;
            return [
                ...getAtlaskitAnalyticsContext(),
                data
            ];
        };
        this.getAnalyticsEventHandlers = ()=>{
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $7dd72f4f00b67523$var$noop } = this.context;
            return getAtlaskitAnalyticsEventHandlers();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
}
$7dd72f4f00b67523$var$AnalyticsContext.contextTypes = $7dd72f4f00b67523$var$ContextTypes;
$7dd72f4f00b67523$var$AnalyticsContext.childContextTypes = $7dd72f4f00b67523$var$ContextTypes;
var $7dd72f4f00b67523$export$2e2bcd8739ae039 = $7dd72f4f00b67523$var$AnalyticsContext;

});

parcelRegister("5kH4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $111872f54037d6c3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1M56W = parcelRequire("1M56W");

var $fFVny = parcelRequire("fFVny");

var $fTXBo = parcelRequire("fTXBo");
const $111872f54037d6c3$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $fTXBo.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $fFVny.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $gwFzn.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $gwFzn.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1M56W.default).Provider, {
        value: value,
        children: children
    });
};
var $111872f54037d6c3$export$2e2bcd8739ae039 = $111872f54037d6c3$var$AnalyticsContext;

});



parcelRegister("1DWH0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b27ee6b189e0611$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $3KlFO = parcelRequire("3KlFO");
const $4b27ee6b189e0611$var$withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
            const { patchedEventProps: patchedEventProps } = (0, $3KlFO.usePatchedProps)(createEventMap, props);
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, $7UHDa.jsx)(WrappedComponent, {
                ...props,
                ...patchedEventProps,
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            });
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
var $4b27ee6b189e0611$export$2e2bcd8739ae039 = $4b27ee6b189e0611$var$withAnalyticsEvents;

});
parcelRegister("3KlFO", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", () => $1d9881ad5a9270b6$export$9ebb5a84d17e5d18);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");
function $1d9881ad5a9270b6$export$9ebb5a84d17e5d18(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handlerCache = (0, $gwFzn.useRef)({});
    const patchedProps = (0, $gwFzn.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return {
                ...p,
                [k]: cache[k].wrappedCallback
            };
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return {
                ...p,
                [k]: wrappedCallback
            };
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("9tehW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4e0b23ec271d805$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("gJgOY")).default);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $jb7rL = parcelRequire("jb7rL");

var $gJgOY = parcelRequire("gJgOY");

var $kjDWr = parcelRequire("kjDWr");
const $c4e0b23ec271d805$var$AsyncSelect = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $gJgOY.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $kjDWr.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jb7rL.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c4e0b23ec271d805$export$2e2bcd8739ae039 = $c4e0b23ec271d805$var$AsyncSelect;

});
parcelRegister("jb7rL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4fab8b1eb2ddac3$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $9I2p1 = parcelRequire("9I2p1");

var $dh538 = parcelRequire("dh538");

var $1Ywmy = parcelRequire("1Ywmy");

var $3hOY6 = parcelRequire("3hOY6");

var $bVoXV = parcelRequire("bVoXV");
var $1wcY0 = parcelRequire("1wcY0");
var $cUklV = parcelRequire("cUklV");

var $jCj4R = parcelRequire("jCj4R");

var $kNPPt = parcelRequire("kNPPt");

var $13TeD = parcelRequire("13TeD");

var $hJzqL = parcelRequire("hJzqL");

var $eKXGE = parcelRequire("eKXGE");

var $A6wna = parcelRequire("A6wna");
const $b4fab8b1eb2ddac3$export$9c21a3269931e1e6 = {
    // aria-live is by default with the live region so we don't need it
    // eslint-disable-next-line @atlaskit/platform/no-module-level-eval
    'aria-live': (0, $dh538.fg)('design_system_select-a11y-improvement') ? undefined : 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $A6wna.isTouchCapable)(),
    captureMenuScroll: !(0, $A6wna.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $hJzqL.createFilter)(),
    formatGroupLabel: (0, $1Ywmy.formatGroupLabel),
    getOptionLabel: (0, $1Ywmy.getOptionLabel),
    getOptionValue: (0, $1Ywmy.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $1Ywmy.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $A6wna.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false,
    shouldOmitDefaultDescription: false
};
function $b4fab8b1eb2ddac3$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $b4fab8b1eb2ddac3$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $b4fab8b1eb2ddac3$var$isOptionSelected(props, option, selectValue);
    const label = $b4fab8b1eb2ddac3$var$getOptionLabel(props, option);
    const value = $b4fab8b1eb2ddac3$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $b4fab8b1eb2ddac3$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$b4fab8b1eb2ddac3$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$b4fab8b1eb2ddac3$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $b4fab8b1eb2ddac3$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $b4fab8b1eb2ddac3$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $A6wna.notNullish));
}
function $b4fab8b1eb2ddac3$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $b4fab8b1eb2ddac3$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $b4fab8b1eb2ddac3$var$buildFocusableOptions(props, selectValue) {
    return $b4fab8b1eb2ddac3$var$buildFocusableOptionsFromCategorizedOptions($b4fab8b1eb2ddac3$var$buildCategorizedOptions(props, selectValue));
}
function $b4fab8b1eb2ddac3$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$b4fab8b1eb2ddac3$var$shouldHideSelectedOptions(props) || !isSelected) && $b4fab8b1eb2ddac3$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $b4fab8b1eb2ddac3$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $b4fab8b1eb2ddac3$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $b4fab8b1eb2ddac3$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $b4fab8b1eb2ddac3$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $b4fab8b1eb2ddac3$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $b4fab8b1eb2ddac3$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $b4fab8b1eb2ddac3$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $b4fab8b1eb2ddac3$var$getOptionValue(props, option);
    return selectValue.some((i)=>$b4fab8b1eb2ddac3$var$getOptionValue(props, i) === candidate);
}
function $b4fab8b1eb2ddac3$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $b4fab8b1eb2ddac3$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $b4fab8b1eb2ddac3$var$instanceId = 1;
class $b4fab8b1eb2ddac3$export$2e2bcd8739ae039 extends (0, $gwFzn.Component) {
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $A6wna.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $b4fab8b1eb2ddac3$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $b4fab8b1eb2ddac3$var$buildFocusableOptionsWithIds($b4fab8b1eb2ddac3$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $b4fab8b1eb2ddac3$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $b4fab8b1eb2ddac3$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $b4fab8b1eb2ddac3$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $A6wna.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $A6wna.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $A6wna.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $b4fab8b1eb2ddac3$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $b4fab8b1eb2ddac3$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $b4fab8b1eb2ddac3$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription(action) {
        const descriptionProp = this.props['aria-describedby'] || this.props['descriptionId'];
        const { isMulti: isMulti, shouldOmitDefaultDescription: shouldOmitDefaultDescription } = this.props;
        const { selectValue: selectValue } = this.state;
        const defaultDescription = selectValue.length ? this.getElementId('live-region') : this.getElementId('placeholder');
        if (!isMulti && selectValue.length && action !== 'initial-input-focus') return;
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            return {
                'aria-describedby': [
                    descriptionProp,
                    !shouldOmitDefaultDescription && defaultDescription,
                    multiMessage
                ].filter(Boolean).join(' ')
            };
        } else return {
            'aria-describedby': descriptionProp ? [
                descriptionProp,
                defaultDescription
            ].join(' ') : defaultDescription
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'both',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-describedby': this.props['aria-describedby'] || descriptionId,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            // TODO: Might need to remove this
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.calculateDescription(ariaSelection?.action)
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bVoXV.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $A6wna.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $gwFzn.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $gwFzn.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $7UHDa.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $7UHDa.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $7UHDa.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $7UHDa.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled && (0, $dh538.fg)('design_system_select-a11y-improvement') ? undefined : isDisabled,
                'aria-describedby': (0, $dh538.fg)('design_system_select-a11y-improvement') ? headingId : undefined,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $gwFzn.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $gwFzn.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $7UHDa.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $7UHDa.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const calculateListboxLabel = ()=>{
            // First in name calculation, overwrites aria-label
            if (labelId) return {
                'aria-labelledby': labelId
            };
            // Second in name calcuation, overwrites everything else except aria-labelledby
            if (label) return {
                'aria-label': label
            };
            // Fallback if no label or labelId is provided, might catch label via <label for> otherwise
            // will most likely not have an accessible name
            return {
                'aria-labelledby': this.inputRef?.id || this.getElementId('input')
            };
        };
        const menuElement = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $13TeD.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $7UHDa.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cUklV.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $7UHDa.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    'aria-multiselectable': (this.isVoiceOver || !commonProps.isMulti) && (0, $dh538.fg)('design_system_select-a11y-improvement') || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox when ff is on
                                    ...(0, $dh538.fg)('design_system_select-a11y-improvement') && calculateListboxLabel()
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $7UHDa.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1wcY0.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $7UHDa.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $7UHDa.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $7UHDa.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $7UHDa.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kNPPt.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isVoiceOver
        });
    }
    renderMultiselectMessage() {
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: ", multiple selections available,"
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $7UHDa.jsxs)(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            children: [
                this.renderLiveRegion(),
                commonProps.isMulti && this.renderMultiselectMessage(),
                /*#__PURE__*/ (0, $7UHDa.jsxs)(Control, {
                    ...commonProps,
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd,
                        ...testId && {
                            'data-testid': `${testId}-select--control`
                        }
                    },
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsxs)(ValueContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            isCompact: isCompact,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--value-container`
                                },
                                ...commonProps.isMulti && commonProps.hasValue && !(0, $9I2p1.isAppleDevice)() && {
                                    // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                    // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                    // DST Accessibility.
                                    role: 'application'
                                }
                            },
                            children: [
                                this.renderPlaceholderOrValue(),
                                this.renderInput()
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)(IndicatorsContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }
                            },
                            children: [
                                this.renderClearIndicator(),
                                this.renderLoadingIndicator(),
                                this.renderDropdownIndicator()
                            ]
                        })
                    ]
                }),
                this.renderMenu(),
                this.renderFormField(),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jCj4R.NotifyOpenLayerObserver), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    // Lifecycle
    // ------------------------------
    constructor(_props){
        super(_props);
        this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false;
        this.isComposing = false;
        this.commonProps = void 0;
        // TODO
        this.initialTouchX = 0;
        this.initialTouchY = 0;
        this.openAfterFocus = false;
        this.scrollToFocusedOptionOnUpdate = false;
        this.userIsDragging = void 0;
        this.isVoiceOver = (0, $dh538.fg)('design_system_select-a11y-improvement') && (0, $9I2p1.isAppleDevice)();
        // Refs
        // ------------------------------
        this.controlRef = null;
        this.getControlRef = (ref)=>{
            this.controlRef = ref;
        };
        this.focusedOptionRef = null;
        this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        };
        this.menuListRef = null;
        this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        };
        this.inputRef = null;
        this.getInputRef = (ref)=>{
            this.inputRef = ref;
        };
        // aliased for consumers
        this.focus = this.focusInput;
        this.blur = this.blurInput;
        this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $A6wna.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $A6wna.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $A6wna.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $A6wna.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        };
        this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $A6wna.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        };
        this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $A6wna.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $A6wna.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $b4fab8b1eb2ddac3$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        };
        this.getFocusableOptionsWithIds = ()=>{
            return $b4fab8b1eb2ddac3$var$buildFocusableOptionsWithIds($b4fab8b1eb2ddac3$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        };
        this.getValue = ()=>this.state.selectValue;
        this.cx = (...args)=>(0, $A6wna.classNames)(this.props.classNamePrefix, ...args);
        this.getOptionLabel = (data)=>{
            return $b4fab8b1eb2ddac3$var$getOptionLabel(this.props, data);
        };
        this.getOptionValue = (data)=>{
            return $b4fab8b1eb2ddac3$var$getOptionValue(this.props, data);
        };
        this.getStyles = (key, props)=>{
            const base = (0, $eKXGE.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            if (!custom) return base;
            const customStyles = (0, $dh538.fg)('compiled-react-select') ? (0, $A6wna.filterUnsupportedSelectors)(custom(base, props)) : custom(base, props);
            return customStyles;
        };
        this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
        this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        };
        this.getComponents = ()=>{
            return (0, $3hOY6.defaultComponents)(this.props);
        };
        this.buildCategorizedOptions = ()=>$b4fab8b1eb2ddac3$var$buildCategorizedOptions(this.props, this.state.selectValue);
        this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
        this.buildFocusableOptions = ()=>$b4fab8b1eb2ddac3$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
        this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
        // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        };
        // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        };
        this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        };
        this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        };
        this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        };
        this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $A6wna.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        };
        this.onCompositionStart = ()=>{
            this.isComposing = true;
        };
        this.onCompositionEnd = ()=>{
            this.isComposing = false;
        };
        this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        };
        this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        };
        this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        };
        this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        };
        this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        };
        // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        };
        this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        };
        this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        };
        this.shouldHideSelectedOptions = ()=>{
            return $b4fab8b1eb2ddac3$var$shouldHideSelectedOptions(this.props);
        };
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        };
        // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        this.handleOpenLayerObserverCloseSignal = ()=>{
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$b4fab8b1eb2ddac3$var$instanceId);
        this.state.selectValue = (0, $A6wna.cleanValue)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $b4fab8b1eb2ddac3$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
}
$b4fab8b1eb2ddac3$export$2e2bcd8739ae039.defaultProps = $b4fab8b1eb2ddac3$export$9c21a3269931e1e6;

});
parcelRegister("1Ywmy", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $5c60f9082494b8c0$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $5c60f9082494b8c0$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $5c60f9082494b8c0$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $5c60f9082494b8c0$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $5c60f9082494b8c0$export$f4da216a6ca54656 = (group)=>group.label;
const $5c60f9082494b8c0$export$dac6ace3020563ca = (option)=>option.label;
const $5c60f9082494b8c0$export$40be908210c5a79c = (option)=>option.value;
const $5c60f9082494b8c0$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("3hOY6", function(module, exports) {

$parcel$export(module.exports, "components", () => $2cf6dc8b1e65c9fe$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $2cf6dc8b1e65c9fe$export$71abc632aa29e6fe);

var $kM6CX = parcelRequire("kM6CX");

var $dLCCQ = parcelRequire("dLCCQ");

var $fPe0U = parcelRequire("fPe0U");

var $bX0kj = parcelRequire("bX0kj");

var $9gJAx = parcelRequire("9gJAx");

var $13TeD = parcelRequire("13TeD");

var $2ASIF = parcelRequire("2ASIF");

var $4K6SB = parcelRequire("4K6SB");

var $hsH3d = parcelRequire("hsH3d");

var $hf117 = parcelRequire("hf117");
const $2cf6dc8b1e65c9fe$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $bX0kj.ClearIndicator),
    Control: (0, $dLCCQ.default),
    DropdownIndicator: (0, $bX0kj.DropdownIndicator),
    Group: (0, $fPe0U.default),
    GroupHeading: (0, $fPe0U.GroupHeading),
    IndicatorsContainer: (0, $kM6CX.IndicatorsContainer),
    Input: (0, $9gJAx.default),
    LoadingIndicator: (0, $bX0kj.LoadingIndicator),
    Menu: (0, $13TeD.default),
    MenuList: (0, $13TeD.MenuList),
    MenuPortal: (0, $13TeD.MenuPortal),
    LoadingMessage: (0, $13TeD.LoadingMessage),
    NoOptionsMessage: (0, $13TeD.NoOptionsMessage),
    MultiValue: (0, $2ASIF.default),
    MultiValueContainer: (0, $2ASIF.MultiValueContainer),
    MultiValueLabel: (0, $2ASIF.MultiValueLabel),
    MultiValueRemove: (0, $2ASIF.MultiValueRemove),
    Option: (0, $4K6SB.default),
    Placeholder: (0, $hsH3d.default),
    SelectContainer: (0, $kM6CX.SelectContainer),
    SingleValue: (0, $hf117.default),
    ValueContainer: (0, $kM6CX.ValueContainer)
};
const $2cf6dc8b1e65c9fe$export$71abc632aa29e6fe = (props)=>({
        ...$2cf6dc8b1e65c9fe$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("kM6CX", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $e2d30bad9e484062$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $e2d30bad9e484062$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $e2d30bad9e484062$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $e2d30bad9e484062$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $e2d30bad9e484062$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $e2d30bad9e484062$export$d0ffd7e649cab6f);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $d7PLA = parcelRequire("d7PLA");

var $8wQfx = parcelRequire("8wQfx");
const $e2d30bad9e484062$export$949392aeaf7d2e3a = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $d7PLA.containerCSS)() : (0, $8wQfx.containerCSS)(props);
const $e2d30bad9e484062$export$446eebadefe1123b = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d7PLA.SelectContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8wQfx.SelectContainer), {
        ...props
    });
const $e2d30bad9e484062$export$47aec73c7aa6b9aa = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $d7PLA.valueContainerCSS)() : (0, $8wQfx.valueContainerCSS)(props);
const $e2d30bad9e484062$export$4dc9f58ad9a1a000 = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d7PLA.ValueContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8wQfx.ValueContainer), {
        ...props
    });
const $e2d30bad9e484062$export$9d74e3c8b5868ad7 = ()=>(0, $dh538.fg)('compiled-react-select') ? (0, $d7PLA.indicatorsContainerCSS)() : (0, $8wQfx.indicatorsContainerCSS)();
const $e2d30bad9e484062$export$d0ffd7e649cab6f = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d7PLA.IndicatorsContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8wQfx.IndicatorsContainer), {
        ...props
    });

});
parcelRegister("d7PLA", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $ebb8a11e633125b9$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $ebb8a11e633125b9$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $ebb8a11e633125b9$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $ebb8a11e633125b9$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $ebb8a11e633125b9$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $ebb8a11e633125b9$export$d0ffd7e649cab6f);
/* containers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ddbVR = parcelRequire("ddbVR");

var $dh538 = parcelRequire("dh538");

var $A6wna = parcelRequire("A6wna");
const $ebb8a11e633125b9$export$949392aeaf7d2e3a = ()=>({});
const $ebb8a11e633125b9$var$containerStyles = {
    default: "_11c82smr _kqswh2mm _lcxv1rj4",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf",
    ff_safari_input_fix: "_11c81ixg _1tn22smr"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $ebb8a11e633125b9$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $A6wna.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $35pXk.default)([
            $ebb8a11e633125b9$var$containerStyles.default,
            isRtl && $ebb8a11e633125b9$var$containerStyles.rtl,
            isDisabled && $ebb8a11e633125b9$var$containerStyles.disabled,
            (0, $dh538.fg)('platform_design_system_team_safari_input_fix') && $ebb8a11e633125b9$var$containerStyles.ff_safari_input_fix,
            (0, $ddbVR.cx)(className, xcss, '-container')
        ]),
        style: css,
        ...innerProps,
        children: children
    });
};
const $ebb8a11e633125b9$export$47aec73c7aa6b9aa = ()=>({});
const $ebb8a11e633125b9$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qidpf _u5f312x7 _n3tdidpf _19bv12x7"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $ebb8a11e633125b9$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $35pXk.default)([
            $ebb8a11e633125b9$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $ebb8a11e633125b9$var$valueContainerStyles.flex,
            isCompact && $ebb8a11e633125b9$var$valueContainerStyles.compact,
            (0, $ddbVR.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css,
        ...innerProps,
        children: children
    });
}; // ==============================
const $ebb8a11e633125b9$export$9d74e3c8b5868ad7 = ()=>({});
const $ebb8a11e633125b9$var$indicatorContainerStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $ebb8a11e633125b9$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $35pXk.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $ddbVR.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};

});
parcelRegister("A6wna", function(module, exports) {

$parcel$export(module.exports, "noop", () => $ef9a0bb7473fac9e$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $ef9a0bb7473fac9e$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $ef9a0bb7473fac9e$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $ef9a0bb7473fac9e$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $ef9a0bb7473fac9e$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $ef9a0bb7473fac9e$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $ef9a0bb7473fac9e$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $ef9a0bb7473fac9e$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $ef9a0bb7473fac9e$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $ef9a0bb7473fac9e$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $ef9a0bb7473fac9e$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $ef9a0bb7473fac9e$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $ef9a0bb7473fac9e$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $ef9a0bb7473fac9e$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $ef9a0bb7473fac9e$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $ef9a0bb7473fac9e$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $ef9a0bb7473fac9e$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $ef9a0bb7473fac9e$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $ef9a0bb7473fac9e$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $ef9a0bb7473fac9e$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $ef9a0bb7473fac9e$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $ef9a0bb7473fac9e$export$4213b25a1c4e877);
$parcel$export(module.exports, "filterUnsupportedSelectors", () => $ef9a0bb7473fac9e$export$bf2eda47afa5f369);
const $ef9a0bb7473fac9e$export$8793edee2d425525 = ()=>{};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $ef9a0bb7473fac9e$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $ef9a0bb7473fac9e$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$ef9a0bb7473fac9e$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $ef9a0bb7473fac9e$export$33f062f47f21a01 = (value)=>{
    if ($ef9a0bb7473fac9e$var$isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $ef9a0bb7473fac9e$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: // not listed in commonProps documentation, needs to be removed to allow Emotion to generate classNames
    clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: // not listed in commonProps documentation
    selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $ef9a0bb7473fac9e$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $ef9a0bb7473fac9e$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $ef9a0bb7473fac9e$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $ef9a0bb7473fac9e$export$2e0654fad740d2e4(el) {
    if ($ef9a0bb7473fac9e$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $ef9a0bb7473fac9e$export$c4a223a8ba9e4ea5(el) {
    if ($ef9a0bb7473fac9e$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $ef9a0bb7473fac9e$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($ef9a0bb7473fac9e$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $ef9a0bb7473fac9e$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $ef9a0bb7473fac9e$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $ef9a0bb7473fac9e$export$858c30343199f3af(element, to, duration = 200, callback = $ef9a0bb7473fac9e$export$8793edee2d425525) {
    const start = $ef9a0bb7473fac9e$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $ef9a0bb7473fac9e$var$easeOutCubic(currentTime, start, change, duration);
        $ef9a0bb7473fac9e$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $ef9a0bb7473fac9e$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $ef9a0bb7473fac9e$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $ef9a0bb7473fac9e$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $ef9a0bb7473fac9e$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $ef9a0bb7473fac9e$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $ef9a0bb7473fac9e$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $ef9a0bb7473fac9e$var$passiveOptionAccessed = false;
const $ef9a0bb7473fac9e$var$options = {
    get passive () {
        return $ef9a0bb7473fac9e$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $ef9a0bb7473fac9e$var$w = typeof window !== 'undefined' ? window : {};
if ($ef9a0bb7473fac9e$var$w.addEventListener && $ef9a0bb7473fac9e$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $ef9a0bb7473fac9e$var$w.addEventListener('p', $ef9a0bb7473fac9e$export$8793edee2d425525, $ef9a0bb7473fac9e$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $ef9a0bb7473fac9e$var$w.removeEventListener('p', $ef9a0bb7473fac9e$export$8793edee2d425525, false);
}
const $ef9a0bb7473fac9e$export$b0622a6911dbeaf5 = $ef9a0bb7473fac9e$var$passiveOptionAccessed;
function $ef9a0bb7473fac9e$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $ef9a0bb7473fac9e$var$isArray(arg) {
    return Array.isArray(arg);
}
function $ef9a0bb7473fac9e$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $ef9a0bb7473fac9e$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $ef9a0bb7473fac9e$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $ef9a0bb7473fac9e$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $ef9a0bb7473fac9e$export$bf2eda47afa5f369 = (styles)=>{
    const unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};

});


parcelRegister("8wQfx", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $36caae45c9726d6c$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $36caae45c9726d6c$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $36caae45c9726d6c$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $36caae45c9726d6c$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $36caae45c9726d6c$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $36caae45c9726d6c$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $dh538 = parcelRequire("dh538");

var $bWLcG = parcelRequire("bWLcG");

var $A6wna = parcelRequire("A6wna");
const $36caae45c9726d6c$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        position: 'relative',
        font: (0, $dh538.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        pointerEvents: 'all',
        cursor: isDisabled ? 'not-allowed' : undefined,
        [`${(0, $bWLcG.media).above.xs}`]: {
            font: (0, $dh538.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : undefined
        }
    });
const $36caae45c9726d6c$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $36caae45c9726d6c$export$47aec73c7aa6b9aa = ({ isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        padding: `${isCompact ? 0 : "var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`
    });
const $36caae45c9726d6c$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $A6wna.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $36caae45c9726d6c$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0,
        paddingRight: "var(--ds-space-050, 4px)"
    });
const $36caae45c9726d6c$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});
parcelRegister("bWLcG", function(module, exports) {

$parcel$export(module.exports, "media", () => $3d6428cbc8265f6c$export$987d49ffe1b0900f);
$parcel$export(module.exports, "UNSAFE_media", () => $3d6428cbc8265f6c$export$c881183ca713c214);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $3d6428cbc8265f6c$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
const $3d6428cbc8265f6c$export$c881183ca713c214 = $3d6428cbc8265f6c$export$987d49ffe1b0900f;

});



parcelRegister("dLCCQ", function(module, exports) {

$parcel$export(module.exports, "css", () => $c7cbf49b89c34667$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $c7cbf49b89c34667$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $9gWNU = parcelRequire("9gWNU");

var $jLiIP = parcelRequire("jLiIP");
const $c7cbf49b89c34667$export$dbf350e5966cf602 = (props)=>{
    return (0, $dh538.fg)('compiled-react-select') ? (0, $9gWNU.css)() : (0, $jLiIP.css)(props);
};
const $c7cbf49b89c34667$var$Control = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9gWNU.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jLiIP.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c7cbf49b89c34667$export$2e2bcd8739ae039 = $c7cbf49b89c34667$var$Control;

});
parcelRegister("9gWNU", function(module, exports) {

$parcel$export(module.exports, "css", () => $cb4d49048962c9b4$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $cb4d49048962c9b4$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ddbVR = parcelRequire("ddbVR");

var $A6wna = parcelRequire("A6wna");
const $cb4d49048962c9b4$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkosqtm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123b1h4p _d0altlke _irr31d5g _1oglgxqn",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsq049",
    disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
    focused: "_1h6d1p6i _bfhkr01l _16qsq049 _1u6lq049 _4cvx1p6i _irr3r01l",
    subtle: "_1h6d3acm _bfhk18uv _1u6lnruj",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d3acm _bfhk18uv _1u6lnruj _4cvx3acm _irr318uv"
};
const $cb4d49048962c9b4$export$dbf350e5966cf602 = ()=>({});
const $cb4d49048962c9b4$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: innerRef,
        className: (0, $35pXk.default)([
            $cb4d49048962c9b4$var$styles.default,
            isDisabled && $cb4d49048962c9b4$var$styles.disabled,
            isInvalid && $cb4d49048962c9b4$var$styles.invalid,
            isCompact && $cb4d49048962c9b4$var$styles.compact,
            appearance === 'subtle' && $cb4d49048962c9b4$var$styles.subtle,
            appearance === 'subtle' && isFocused && $cb4d49048962c9b4$var$styles.subtleFocused,
            isFocused && $cb4d49048962c9b4$var$styles.focused,
            appearance === 'none' && $cb4d49048962c9b4$var$styles.none,
            (0, $ddbVR.cx)(className, xcss, '-control')
        ]),
        style: css,
        ...innerProps,
        "aria-disabled": isDisabled || undefined,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $cb4d49048962c9b4$export$2e2bcd8739ae039 = $cb4d49048962c9b4$var$Control;

});

parcelRegister("jLiIP", function(module, exports) {

$parcel$export(module.exports, "css", () => $79edbb0007ae4304$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $79edbb0007ae4304$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $A6wna = parcelRequire("A6wna");
const $79edbb0007ae4304$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, isCompact: isCompact, appearance: appearance })=>{
    let borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    let backgroundColor = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)";
    let backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    let borderColorHover = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    if (isDisabled) {
        backgroundColor = "var(--ds-background-disabled, #091E4208)";
        borderColor = "var(--ds-background-disabled, #091E4208)";
    }
    if (isInvalid) {
        borderColor = "var(--ds-border-danger, #E2483D)";
        borderColorHover = "var(--ds-border-danger, #E2483D)";
    }
    const transitionDuration = '200ms';
    if (appearance === 'subtle') {
        borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : 'transparent';
        backgroundColor = isFocused ? "var(--ds-surface, #FFFFFF)" : 'transparent';
        backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    }
    if (appearance === 'none') {
        borderColor = 'transparent';
        backgroundColor = 'transparent';
        backgroundColorHover = 'transparent';
        borderColorHover = 'transparent';
    }
    return {
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        outline: '0 !important',
        position: 'relative',
        // Turn pointer events off when disabled - this makes it so hover etc don't work.
        pointerEvents: isDisabled ? 'none' : undefined,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderStyle: 'solid',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        borderWidth: "var(--ds-border-width, 1px)",
        boxShadow: isInvalid ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
        '&:focus-within': {
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
        },
        minHeight: isCompact ? 32 : 40,
        padding: 0,
        transition: `background-color ${transitionDuration} ease-in-out,
border-color ${transitionDuration} ease-in-out`,
        '::-webkit-scrollbar': {
            height: 8,
            width: 8
        },
        '::-webkit-scrollbar-corner': {
            display: 'none'
        },
        ':hover': {
            '::-webkit-scrollbar-thumb': {
                // scrollbars occur only if the user passes in a custom component with overflow: scroll
                backgroundColor: 'rgba(0,0,0,0.2)'
            },
            cursor: 'pointer',
            backgroundColor: backgroundColorHover,
            borderColor: borderColorHover
        },
        '::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(0,0,0,0.4)'
        }
    };
};
const $79edbb0007ae4304$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ref: innerRef,
        ...(0, $A6wna.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$79edbb0007ae4304$export$2e2bcd8739ae039 = $79edbb0007ae4304$var$Control;

});


parcelRegister("fPe0U", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $1a73b6f9808ffda5$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $1a73b6f9808ffda5$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $1a73b6f9808ffda5$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $1a73b6f9808ffda5$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $3olWs = parcelRequire("3olWs");

var $1Z7cM = parcelRequire("1Z7cM");
const $1a73b6f9808ffda5$export$b6794329c1460634 = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $3olWs.groupCSS)() : (0, $1Z7cM.groupCSS)(props);
const $1a73b6f9808ffda5$var$Group = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3olWs.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1Z7cM.default), {
        ...props
    });
const $1a73b6f9808ffda5$export$e5a7fbb542efcb7d = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $3olWs.groupHeadingCSS)() : (0, $1Z7cM.groupHeadingCSS)(props); // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $1a73b6f9808ffda5$export$85c8b41a3cd87edc = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3olWs.GroupHeading), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1Z7cM.GroupHeading), {
        ...props
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $1a73b6f9808ffda5$export$2e2bcd8739ae039 = $1a73b6f9808ffda5$var$Group;

});
parcelRegister("3olWs", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $29758b11b850f5a2$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $29758b11b850f5a2$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $29758b11b850f5a2$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $29758b11b850f5a2$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ddbVR = parcelRequire("ddbVR");

var $A6wna = parcelRequire("A6wna");
const $29758b11b850f5a2$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
const $29758b11b850f5a2$export$b6794329c1460634 = ()=>({});
const $29758b11b850f5a2$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        ...innerProps,
        className: (0, $35pXk.default)([
            $29758b11b850f5a2$var$styles.root,
            (0, $ddbVR.cx)(className, xcss, innerProps?.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $7UHDa.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                children: children
            })
        ]
    });
};
const $29758b11b850f5a2$var$headingStyles = null;
const $29758b11b850f5a2$export$e5a7fbb542efcb7d = ()=>({}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $29758b11b850f5a2$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $A6wna.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $35pXk.default)([
            "_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $ddbVR.cx)(className, xcss, '-group')
        ]),
        style: css,
        ...innerProps
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $29758b11b850f5a2$export$2e2bcd8739ae039 = $29758b11b850f5a2$var$Group;

});

parcelRegister("1Z7cM", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $f14321b1910d79de$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $f14321b1910d79de$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $f14321b1910d79de$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $f14321b1910d79de$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $A6wna = parcelRequire("A6wna");
const $f14321b1910d79de$export$b6794329c1460634 = ({})=>({
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingTop: "var(--ds-space-100, 8px)"
    });
const $f14321b1910d79de$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, label && /*#__PURE__*/ (0, $3jLHL.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $3jLHL.jsx)("div", null, children));
};
const $f14321b1910d79de$export$e5a7fbb542efcb7d = ({})=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        marginBottom: '0.25em',
        paddingLeft: "var(--ds-space-150, 12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        color: "var(--ds-text-subtle, #44546F)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textTransform: 'none'
    });
const $f14321b1910d79de$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $A6wna.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f14321b1910d79de$export$2e2bcd8739ae039 = $f14321b1910d79de$var$Group;

});


parcelRegister("bX0kj", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $f3b0780a6703beee$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $f3b0780a6703beee$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $f3b0780a6703beee$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $f3b0780a6703beee$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $f3b0780a6703beee$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $f3b0780a6703beee$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $Hyscn = parcelRequire("Hyscn");

var $9MZ5K = parcelRequire("9MZ5K");
const $f3b0780a6703beee$export$e1687335805e1230 = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $Hyscn.dropdownIndicatorCSS)() : (0, $9MZ5K.dropdownIndicatorCSS)(props);
const $f3b0780a6703beee$export$ec98719d3db7f2e4 = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Hyscn.DropdownIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9MZ5K.DropdownIndicator), {
        ...props
    });
const $f3b0780a6703beee$export$9c0419fd944c1def = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $Hyscn.clearIndicatorCSS)() : (0, $9MZ5K.clearIndicatorCSS)(props);
const $f3b0780a6703beee$export$ecf9cf59142dd54a = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Hyscn.ClearIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9MZ5K.ClearIndicator), {
        ...props
    });
const $f3b0780a6703beee$export$1d3f24cde248e6b5 = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $Hyscn.loadingIndicatorCSS)() : (0, $9MZ5K.loadingIndicatorCSS)(props);
const $f3b0780a6703beee$export$7c20be4c1d342248 = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Hyscn.LoadingIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9MZ5K.LoadingIndicator), {
        ...props
    });

});
parcelRegister("Hyscn", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $8f20df3846524036$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $8f20df3846524036$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $8f20df3846524036$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $8f20df3846524036$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $8f20df3846524036$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $8f20df3846524036$export$7c20be4c1d342248);
/* indicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ddbVR = parcelRequire("ddbVR");

var $fk6ei = parcelRequire("fk6ei");

var $96Dpg = parcelRequire("96Dpg");

var $u9agA = parcelRequire("u9agA");
var $fVUfS = parcelRequire("fVUfS");

var $9hlns = parcelRequire("9hlns");

var $A6wna = parcelRequire("A6wna");
// Dropdown & Clear Icons
// ==============================
const $8f20df3846524036$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
const $8f20df3846524036$var$dropdownWrapperStyles = {
    root: "_ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7"
}; // ==============================
const $8f20df3846524036$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1gjq _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf",
    disabled: "_syaz1lh4"
};
const $8f20df3846524036$export$e1687335805e1230 = ()=>({}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $8f20df3846524036$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $35pXk.default)([
            $8f20df3846524036$var$dropdownStyles.default,
            isDisabled && $8f20df3846524036$var$dropdownStyles.disabled,
            isCompact && $8f20df3846524036$var$dropdownStyles.compact,
            (0, $ddbVR.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: children ? children : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
            as: "span",
            xcss: $8f20df3846524036$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fk6ei))), {
                color: "currentColor",
                label: "open",
                LEGACY_margin: "var(--ds-space-negative-075, -6px)"
            })
        })
    });
};
const $8f20df3846524036$export$9c0419fd944c1def = ()=>({});
const $8f20df3846524036$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz131l _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $8f20df3846524036$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $35pXk.default)([
            $8f20df3846524036$var$clearIndicatorStyles.default,
            isCompact && $8f20df3846524036$var$clearIndicatorStyles.compact,
            (0, $ddbVR.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
            xcss: $8f20df3846524036$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96Dpg))), {
                label: "",
                color: "currentColor",
                LEGACY_size: "small",
                LEGACY_margin: "var(--ds-space-negative-025, -2px)"
            })
        })
    });
}; // ==============================
const $8f20df3846524036$export$1d3f24cde248e6b5 = ()=>({});
const $8f20df3846524036$var$loadingIndicatorStyles = {
    default: "_ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc",
    compact: "_ca0qidpf _n3tdidpf"
};
const $8f20df3846524036$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $A6wna.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $35pXk.default)([
            $8f20df3846524036$var$loadingIndicatorStyles.default,
            isCompact && $8f20df3846524036$var$loadingIndicatorStyles.compact,
            (0, $ddbVR.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
            size: "small"
        })
    });
};

});
parcelRegister("fk6ei", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a08e2cd9fd0eae78f18da4572f37370>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02e0fe2ac6a5435f$var$_react = $02e0fe2ac6a5435f$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $02e0fe2ac6a5435f$var$_chevronDown = $02e0fe2ac6a5435f$var$_interopRequireDefault((parcelRequire("6kv9e")));

var $02e0fe2ac6a5435f$var$_chevronDown2 = $02e0fe2ac6a5435f$var$_interopRequireDefault((parcelRequire("klvaQ")));
function $02e0fe2ac6a5435f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02e0fe2ac6a5435f$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $02e0fe2ac6a5435f$var$_react.default.createElement($02e0fe2ac6a5435f$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $02e0fe2ac6a5435f$var$_chevronDown2.default
    }, props));
$02e0fe2ac6a5435f$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $02e0fe2ac6a5435f$var$_default = module.exports.default = $02e0fe2ac6a5435f$var$ChevronDownIcon;

});
parcelRegister("6kv9e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1a026656028c05157ac730015f665601>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $49bcc5a6c199621b$var$_react = $49bcc5a6c199621b$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $49bcc5a6c199621b$var$_baseNew = $49bcc5a6c199621b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $49bcc5a6c199621b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $49bcc5a6c199621b$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $49bcc5a6c199621b$var$_react.default.createElement($49bcc5a6c199621b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.03 3.97 6 7.94l3.97-3.97 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$49bcc5a6c199621b$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $49bcc5a6c199621b$var$_default = module.exports.default = $49bcc5a6c199621b$var$ChevronDownIcon;

});

parcelRegister("klvaQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ecfdf350e71d82e2$var$_react = $ecfdf350e71d82e2$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $ecfdf350e71d82e2$var$_chevronDown = $ecfdf350e71d82e2$var$_interopRequireDefault((parcelRequire("ghftu")));
function $ecfdf350e71d82e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ecfdf350e71d82e2$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $ecfdf350e71d82e2$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $ecfdf350e71d82e2$var$_chevronDown.default
    }));
$ecfdf350e71d82e2$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $ecfdf350e71d82e2$var$_default = module.exports.default = $ecfdf350e71d82e2$var$ChevronDownIcon;

});
parcelRegister("ghftu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::05a4941b07732842dd47a8ac581e394b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd9a3cd17c99332c$var$_react = $bd9a3cd17c99332c$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $bd9a3cd17c99332c$var$_baseNew = $bd9a3cd17c99332c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bd9a3cd17c99332c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd9a3cd17c99332c$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $bd9a3cd17c99332c$var$_react.default.createElement($bd9a3cd17c99332c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$bd9a3cd17c99332c$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $bd9a3cd17c99332c$var$_default = module.exports.default = $bd9a3cd17c99332c$var$ChevronDownIcon;

});



parcelRegister("96Dpg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7da2857c3151a92889bed61f5baa1334>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a133de6a35743a1$var$_react = $6a133de6a35743a1$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $6a133de6a35743a1$var$_crossCircle = $6a133de6a35743a1$var$_interopRequireDefault((parcelRequire("eKwWJ")));

var $6a133de6a35743a1$var$_selectClear = $6a133de6a35743a1$var$_interopRequireDefault((parcelRequire("cPXGO")));
function $6a133de6a35743a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a133de6a35743a1$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $6a133de6a35743a1$var$_react.default.createElement($6a133de6a35743a1$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $6a133de6a35743a1$var$_selectClear.default
    }, props));
$6a133de6a35743a1$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $6a133de6a35743a1$var$_default = module.exports.default = $6a133de6a35743a1$var$CrossCircleIcon;

});
parcelRegister("eKwWJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23b3104937a360e799abf4f0ea698b9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abceeb07d254c4bc$var$_react = $abceeb07d254c4bc$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $abceeb07d254c4bc$var$_baseNew = $abceeb07d254c4bc$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $abceeb07d254c4bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $abceeb07d254c4bc$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $abceeb07d254c4bc$var$_react.default.createElement($abceeb07d254c4bc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$abceeb07d254c4bc$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $abceeb07d254c4bc$var$_default = module.exports.default = $abceeb07d254c4bc$var$CrossCircleIcon;

});

parcelRegister("cPXGO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95888c8fcc018083$var$_react = $95888c8fcc018083$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $95888c8fcc018083$var$_crossCircle = $95888c8fcc018083$var$_interopRequireDefault((parcelRequire("7yDmn")));
function $95888c8fcc018083$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95888c8fcc018083$var$SelectClearIcon = (props)=>/*#__PURE__*/ $95888c8fcc018083$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $95888c8fcc018083$var$_crossCircle.default
    }));
$95888c8fcc018083$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $95888c8fcc018083$var$_default = module.exports.default = $95888c8fcc018083$var$SelectClearIcon;

});
parcelRegister("7yDmn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70e4741cbfa8f6087ac64902b38a7366>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $580a3d6d99b490e5$var$_react = $580a3d6d99b490e5$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $580a3d6d99b490e5$var$_baseNew = $580a3d6d99b490e5$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $580a3d6d99b490e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $580a3d6d99b490e5$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $580a3d6d99b490e5$var$_react.default.createElement($580a3d6d99b490e5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$580a3d6d99b490e5$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $580a3d6d99b490e5$var$_default = module.exports.default = $580a3d6d99b490e5$var$CrossCircleIcon;

});




parcelRegister("9MZ5K", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $4a85409e34e7a423$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $4a85409e34e7a423$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $4a85409e34e7a423$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $4a85409e34e7a423$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $4a85409e34e7a423$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $4a85409e34e7a423$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $fk6ei = parcelRequire("fk6ei");

var $96Dpg = parcelRequire("96Dpg");

var $dcJ7R = parcelRequire("dcJ7R");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $9hlns = parcelRequire("9hlns");

var $A6wna = parcelRequire("A6wna");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $4a85409e34e7a423$var$iconContainerStyles = (0, $ecnYn.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $4a85409e34e7a423$var$dropdownWrapperStyles = (0, $ecnYn.xcss)({
    padding: 'space.075'
});
const $4a85409e34e7a423$export$e1687335805e1230 = ({ isCompact: isCompact, isDisabled: isDisabled })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtle, #44546F)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $4a85409e34e7a423$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children ? children : /*#__PURE__*/ (0, $3jLHL.jsx)((0, $dcJ7R.default), {
        as: "span",
        xcss: $4a85409e34e7a423$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fk6ei))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
};
const $4a85409e34e7a423$export$9c0419fd944c1def = ({ isCompact: isCompact })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: "var(--ds-text-subtlest, #626F86)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $4a85409e34e7a423$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear' } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2W0qg.default), {
        xcss: $4a85409e34e7a423$var$iconContainerStyles,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96Dpg))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
};
const $4a85409e34e7a423$export$1d3f24cde248e6b5 = ({ isCompact: isCompact })=>({
        label: 'loadingIndicator',
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`
    });
const $4a85409e34e7a423$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $9hlns.default), {
        size: "small"
    }));
};

});
parcelRegister("2W0qg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d7e397a775b6b9d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $gxtzC = parcelRequire("gxtzC");

var $ee7An = parcelRequire("ee7An");

var $90YwQ = parcelRequire("90YwQ");

var $avd77 = parcelRequire("avd77");

var $ecnYn = parcelRequire("ecnYn");
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $1d7e397a775b6b9d$var$focusRingStyles = (0, $3jLHL.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $avd77.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $avd77.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $avd77.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $1d7e397a775b6b9d$var$baseStyles = (0, $3jLHL.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
const $1d7e397a775b6b9d$var$enabledStyles = (0, $3jLHL.css)({
    cursor: 'pointer'
});
const $1d7e397a775b6b9d$var$disabledStyles = (0, $3jLHL.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $1d7e397a775b6b9d$var$Pressable = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $ee7An.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $gwFzn.useContext)((0, $90YwQ.default));
    const handleClick = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $3jLHL.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $1d7e397a775b6b9d$var$baseStyles,
            $1d7e397a775b6b9d$var$focusRingStyles,
            isDisabled ? $1d7e397a775b6b9d$var$disabledStyles : $1d7e397a775b6b9d$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $avd77.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $avd77.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $avd77.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $avd77.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $avd77.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $avd77.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $avd77.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $avd77.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
var $1d7e397a775b6b9d$export$2e2bcd8739ae039 = $1d7e397a775b6b9d$var$Pressable;

});



parcelRegister("9gJAx", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $7ff29bbfbffbc74f$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $7ff29bbfbffbc74f$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $hjF2c = parcelRequire("hjF2c");

var $fI6uK = parcelRequire("fI6uK");
const $7ff29bbfbffbc74f$export$14a7781d0ca7abea = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $hjF2c.inputCSS)() : (0, $fI6uK.inputCSS)(props);
const $7ff29bbfbffbc74f$var$Input = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hjF2c.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fI6uK.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7ff29bbfbffbc74f$export$2e2bcd8739ae039 = $7ff29bbfbffbc74f$var$Input;

});
parcelRegister("hjF2c", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $06b996e25513c1bf$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $06b996e25513c1bf$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ddbVR = parcelRequire("ddbVR");

var $A6wna = parcelRequire("A6wna");
const $06b996e25513c1bf$export$14a7781d0ca7abea = ()=>({});
const $06b996e25513c1bf$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
const $06b996e25513c1bf$var$nativeInnputStyles = null;
const $06b996e25513c1bf$var$hidden = null;
const $06b996e25513c1bf$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $A6wna.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'input', {
        'input-container': true
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $35pXk.default)([
            $06b996e25513c1bf$var$inputStyles.root,
            isDisabled && $06b996e25513c1bf$var$inputStyles.disabled,
            (0, $ddbVR.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("input" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        , {
            className: (0, $35pXk.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $06b996e25513c1bf$export$2e2bcd8739ae039 = $06b996e25513c1bf$var$Input;

});

parcelRegister("fI6uK", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $43d4cee8f745eda8$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $43d4cee8f745eda8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $A6wna = parcelRequire("A6wna");
const $43d4cee8f745eda8$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value })=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$43d4cee8f745eda8$var$containerStyle,
        margin: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingTop: "var(--ds-space-025, 2px)",
        color: "var(--ds-text, #172B4D)"
    });
const $43d4cee8f745eda8$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $43d4cee8f745eda8$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$43d4cee8f745eda8$var$spacingStyle
    }
};
const $43d4cee8f745eda8$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$43d4cee8f745eda8$var$spacingStyle
    });
const $43d4cee8f745eda8$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $A6wna.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $43d4cee8f745eda8$var$inputStyle(isHidden),
        disabled: isDisabled,
        "data-testid": dataId,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43d4cee8f745eda8$export$2e2bcd8739ae039 = $43d4cee8f745eda8$var$Input;

});


parcelRegister("13TeD", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $592398492de9d999$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $592398492de9d999$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $592398492de9d999$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $592398492de9d999$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $592398492de9d999$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $592398492de9d999$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $592398492de9d999$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $592398492de9d999$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $592398492de9d999$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $592398492de9d999$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $592398492de9d999$export$793392f970497feb);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $lPLZK = parcelRequire("lPLZK");

var $8j953 = parcelRequire("8j953");
const $592398492de9d999$export$a228922d5ca42a79 = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $lPLZK.menuCSS)() : (0, $8j953.menuCSS)(props);
const $592398492de9d999$export$f32337f3a7617699 = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lPLZK.MenuPlacer), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8j953.MenuPlacer), {
        ...props
    });
const $592398492de9d999$var$Menu = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lPLZK.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8j953.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$592398492de9d999$export$2e2bcd8739ae039 = $592398492de9d999$var$Menu;
const $592398492de9d999$export$abafed69cff95d5e = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $lPLZK.menuListCSS)() : (0, $8j953.menuListCSS)(props);
const $592398492de9d999$export$d4c4e98c5044dc8 = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lPLZK.MenuList), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8j953.MenuList), {
        ...props
    });
// ==============================
// Menu Notices
// ==============================
const $592398492de9d999$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $592398492de9d999$export$cf0e22534d8b0074 = $592398492de9d999$var$noticeCSS;
const $592398492de9d999$export$98ec46397a8cb3cd = $592398492de9d999$var$noticeCSS;
const $592398492de9d999$export$d58b72b7d3c4072c = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lPLZK.NoOptionsMessage), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8j953.NoOptionsMessage), {
        ...props
    });
const $592398492de9d999$export$e928a71d039d3102 = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lPLZK.LoadingMessage), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8j953.LoadingMessage), {
        ...props
    });
const $592398492de9d999$export$1dbbeb9648d1fdc9 = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $lPLZK.menuPortalCSS)() : (0, $8j953.menuPortalCSS)(props);
const $592398492de9d999$export$793392f970497feb = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lPLZK.MenuPortal), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8j953.MenuPortal), {
        ...props
    });

});
parcelRegister("lPLZK", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $0a3db06aabe3e688$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $0a3db06aabe3e688$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $0a3db06aabe3e688$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $0a3db06aabe3e688$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $0a3db06aabe3e688$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "NoOptionsMessage", () => $0a3db06aabe3e688$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $0a3db06aabe3e688$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $0a3db06aabe3e688$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $0a3db06aabe3e688$export$793392f970497feb);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ddbVR = parcelRequire("ddbVR");

var $hvCDr = parcelRequire("hvCDr");

var $4FhhO = parcelRequire("4FhhO");

var $akTSC = parcelRequire("akTSC");

var $dh538 = parcelRequire("dh538");

var $iXCQx = parcelRequire("iXCQx");

var $A6wna = parcelRequire("A6wna");
function $0a3db06aabe3e688$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $A6wna.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    }; // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
     // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight, top: scrollParentTop } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $A6wna.normalizedHeight)(scrollParent);
    const scrollTop = (0, $A6wna.getScrollTop)(scrollParent); // use menuTop - scrollParentTop for the actual top space of menu in the scroll container
    const menuTopFromParent = (0, $dh538.fg)('design-system-select-fix-placement') ? menuTop - scrollParentTop : menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $A6wna.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $A6wna.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                 // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            } // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $A6wna.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $A6wna.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight; // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $A6wna.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            } // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $0a3db06aabe3e688$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $0a3db06aabe3e688$var$menuStyles = {
    root: "_2rkoglpi _kqswstnw _1bsb1osq _1pbykb7n _otyru2gc _19pku2gc _bfhk1bhr _16qs1cd0",
    bottom: "_154i1osq",
    top: "_94n51osq"
};
const $0a3db06aabe3e688$export$a228922d5ca42a79 = ()=>({});
const $0a3db06aabe3e688$var$PortalPlacementContext = /*#__PURE__*/ (0, $gwFzn.createContext)(null); // NOTE: internal only
const $0a3db06aabe3e688$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $gwFzn.useContext)($0a3db06aabe3e688$var$PortalPlacementContext) || {};
    const ref = (0, $gwFzn.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $gwFzn.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $gwFzn.useState)(null); // The minimum height of the control
    const controlHeight = 38;
    (0, $akTSC.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
         // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $0a3db06aabe3e688$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $0a3db06aabe3e688$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $0a3db06aabe3e688$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $35pXk.default)([
            $0a3db06aabe3e688$var$menuStyles.root,
            $0a3db06aabe3e688$var$menuStyles[placement],
            (0, $ddbVR.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $0a3db06aabe3e688$export$2e2bcd8739ae039 // ==============================
 = $0a3db06aabe3e688$var$Menu;
const $0a3db06aabe3e688$export$abafed69cff95d5e = ()=>({});
const $0a3db06aabe3e688$var$menuListStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $0a3db06aabe3e688$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $35pXk.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $ddbVR.cx)(className, xcss, '-MenuList')
        ]),
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
}; // ==============================
// Menu Notices
// ==============================
const $0a3db06aabe3e688$var$noticeCSS = ()=>({});
const $0a3db06aabe3e688$var$noticeStyles = null;
const $0a3db06aabe3e688$export$cf0e22534d8b0074 = $0a3db06aabe3e688$var$noticeCSS;
const $0a3db06aabe3e688$export$98ec46397a8cb3cd = $0a3db06aabe3e688$var$noticeCSS;
const $0a3db06aabe3e688$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $A6wna.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $35pXk.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $ddbVR.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
            color: "color.text.subtle",
            children: children
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $0a3db06aabe3e688$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $A6wna.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $35pXk.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $ddbVR.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css,
        ...innerProps,
        role: "option",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
            color: "color.text.subtle",
            children: children
        })
    });
}; // ==============================
const $0a3db06aabe3e688$export$1dbbeb9648d1fdc9 = ()=>({});
const $0a3db06aabe3e688$var$menuPortalStyles = {
    root: "_1pbydx66 _1ltva1vk _kqswcp1v _154i1nmo _1bsb1qxj"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $0a3db06aabe3e688$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $gwFzn.useRef)(null);
    const cleanupRef = (0, $gwFzn.useRef)(null);
    const [placement, setPortalPlacement] = (0, $gwFzn.useState)($0a3db06aabe3e688$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $gwFzn.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $gwFzn.useState)(null);
    const updateComputedPosition = (0, $gwFzn.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $A6wna.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $akTSC.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $gwFzn.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $hvCDr.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $akTSC.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $gwFzn.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]); // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    }); // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $35pXk.default)([
            $0a3db06aabe3e688$var$menuPortalStyles.root,
            (0, $ddbVR.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($0a3db06aabe3e688$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $4FhhO.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
};

});
parcelRegister("iXCQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $30e81a3114605546$export$2e2bcd8739ae039);
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $5Uzw3 = parcelRequire("5Uzw3");

var $kFobZ = parcelRequire("kFobZ");

var $5rrZR = parcelRequire("5rrZR");
const $30e81a3114605546$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
const $30e81a3114605546$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $5rrZR.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($30e81a3114605546$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $30e81a3114605546$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
const $30e81a3114605546$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pmoej",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $30e81a3114605546$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
const $30e81a3114605546$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $30e81a3114605546$var$textColorMap = {
    'color.text': "_syaz1fxt",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syaz1q28",
    'color.text.accent.orange.bolder': "_syaz1vps",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syazpnps",
    'color.text.accent.blue.bolder': "_syazsc1o",
    'color.text.accent.purple': "_syaz10m5",
    'color.text.accent.purple.bolder': "_syaz2ibx",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1dyx",
    'color.text.accent.gray.bolder': "_syaz1x9z",
    'color.text.disabled': "_syaz1lh4",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syazaqb7",
    'color.text.brand': "_syaz1e6v",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syazwx40",
    'color.text.warning.inverse': "_syazal3n",
    'color.text.success': "_syazy73q",
    'color.text.discovery': "_syazzjem",
    'color.text.information': "_syaze0os",
    'color.text.subtlest': "_syaz131l",
    'color.text.subtle': "_syaz1gjq",
    'color.link': "_syaz14q2",
    'color.link.pressed': "_syaz16c2",
    'color.link.visited': "_syazw7te",
    'color.link.visited.pressed': "_syazg3x0"
};
const $30e81a3114605546$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
}; /**
             * __Text__
             *
             * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
             * This includes considerations for text attributes such as color, font size, font weight, and line height.
             * It renders a `span` by default.
             *
             * @internal
             */ 
const $30e81a3114605546$var$Text = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $5Uzw3.default)($30e81a3114605546$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $kFobZ.useHasTextAncestor)();
    const color = $30e81a3114605546$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        id: id,
        className: (0, $35pXk.default)([
            $30e81a3114605546$var$styles.root,
            size && $30e81a3114605546$var$fontSizeMap[size],
            color && $30e81a3114605546$var$textColorMap[color],
            maxLines && $30e81a3114605546$var$styles.truncation,
            maxLines === 1 && $30e81a3114605546$var$styles.breakAll,
            align && $30e81a3114605546$var$styles[`textAlign.${align}`],
            weight && $30e81a3114605546$var$fontWeightMap[weight],
            Component === 'em' && $30e81a3114605546$var$styles['as.em'],
            Component === 'strong' && $30e81a3114605546$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kFobZ.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});
var $30e81a3114605546$export$2e2bcd8739ae039 = $30e81a3114605546$var$Text;

});


parcelRegister("8j953", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $294e1ecc8fc7baae$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $294e1ecc8fc7baae$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $294e1ecc8fc7baae$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $294e1ecc8fc7baae$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $294e1ecc8fc7baae$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "NoOptionsMessage", () => $294e1ecc8fc7baae$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $294e1ecc8fc7baae$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $294e1ecc8fc7baae$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $294e1ecc8fc7baae$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $hvCDr = parcelRequire("hvCDr");

var $4FhhO = parcelRequire("4FhhO");

var $akTSC = parcelRequire("akTSC");

var $dh538 = parcelRequire("dh538");

var $5dK2X = parcelRequire("5dK2X");

var $A6wna = parcelRequire("A6wna");
function $294e1ecc8fc7baae$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $A6wna.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight, top: scrollParentTop } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $A6wna.normalizedHeight)(scrollParent);
    const scrollTop = (0, $A6wna.getScrollTop)(scrollParent);
    // use menuTop - scrollParentTop for the actual top space of menu in the scroll container
    const menuTopFromParent = (0, $dh538.fg)('design-system-select-fix-placement') ? menuTop - scrollParentTop : menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $A6wna.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $A6wna.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $A6wna.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $A6wna.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $A6wna.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $294e1ecc8fc7baae$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $294e1ecc8fc7baae$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $294e1ecc8fc7baae$export$a228922d5ca42a79 = ({ placement: placement })=>({
        label: 'menu',
        [$294e1ecc8fc7baae$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        borderRadius: "var(--ds-border-radius, 4px)",
        marginBottom: "var(--ds-space-100, 8px)",
        marginTop: "var(--ds-space-100, 8px)",
        backgroundColor: "var(--ds-surface-overlay, white)",
        boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
    });
const $294e1ecc8fc7baae$var$PortalPlacementContext = /*#__PURE__*/ (0, $gwFzn.createContext)(null);
const $294e1ecc8fc7baae$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $gwFzn.useContext)($294e1ecc8fc7baae$var$PortalPlacementContext) || {};
    const ref = (0, $gwFzn.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $gwFzn.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $gwFzn.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $akTSC.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $294e1ecc8fc7baae$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $294e1ecc8fc7baae$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $294e1ecc8fc7baae$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$294e1ecc8fc7baae$export$2e2bcd8739ae039 = $294e1ecc8fc7baae$var$Menu;
const $294e1ecc8fc7baae$export$abafed69cff95d5e = ({ maxHeight: maxHeight })=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        paddingTop: "var(--ds-space-100, 8px)",
        paddingBottom: "var(--ds-space-100, 8px)"
    });
const $294e1ecc8fc7baae$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $294e1ecc8fc7baae$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $294e1ecc8fc7baae$export$cf0e22534d8b0074 = $294e1ecc8fc7baae$var$noticeCSS;
const $294e1ecc8fc7baae$export$98ec46397a8cb3cd = $294e1ecc8fc7baae$var$noticeCSS;
const $294e1ecc8fc7baae$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $5dK2X.default), {
        color: "color.text.subtle"
    }, children));
};
const $294e1ecc8fc7baae$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $5dK2X.default), {
        color: "color.text.subtle"
    }, children));
};
const $294e1ecc8fc7baae$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $294e1ecc8fc7baae$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $gwFzn.useRef)(null);
    const cleanupRef = (0, $gwFzn.useRef)(null);
    const [placement, setPortalPlacement] = (0, $gwFzn.useState)($294e1ecc8fc7baae$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $gwFzn.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $gwFzn.useState)(null);
    const updateComputedPosition = (0, $gwFzn.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $A6wna.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $akTSC.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $gwFzn.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $hvCDr.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $akTSC.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $gwFzn.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $A6wna.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $3jLHL.jsx)($294e1ecc8fc7baae$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $4FhhO.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});


parcelRegister("2ASIF", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $280e2de5ed2817ab$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $280e2de5ed2817ab$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $280e2de5ed2817ab$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $280e2de5ed2817ab$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $280e2de5ed2817ab$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $280e2de5ed2817ab$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $280e2de5ed2817ab$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $9bkCd = parcelRequire("9bkCd");

var $8AkOR = parcelRequire("8AkOR");
const $280e2de5ed2817ab$export$23c213f7717186af = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $9bkCd.multiValueCSS)() : (0, $8AkOR.multiValueCSS)(props);
const $280e2de5ed2817ab$export$f40612612e0af964 = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $9bkCd.multiValueLabelCSS)() : (0, $8AkOR.multiValueLabelCSS)(props);
const $280e2de5ed2817ab$export$283467f6c4ac142b = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $9bkCd.multiValueRemoveCSS)() : (0, $8AkOR.multiValueRemoveCSS)(props);
const $280e2de5ed2817ab$export$cf9cf2a30a59265c = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9bkCd.MultiValueContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8AkOR.MultiValueContainer), {
        ...props
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $280e2de5ed2817ab$export$544aeea2a5ce08ee = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9bkCd.MultiValueLabel), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8AkOR.MultiValueLabel), {
        ...props
    });
function $280e2de5ed2817ab$export$8e1fd1a40e7a2f4a(props) {
    return(// The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    (0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9bkCd.MultiValueRemove), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8AkOR.MultiValueRemove), {
        ...props
    }));
}
const $280e2de5ed2817ab$var$MultiValue = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9bkCd.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8AkOR.default), {
        ...props
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $280e2de5ed2817ab$export$2e2bcd8739ae039 = $280e2de5ed2817ab$var$MultiValue;

});
parcelRegister("9bkCd", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $b8603eeed79104f2$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $b8603eeed79104f2$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $b8603eeed79104f2$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $b8603eeed79104f2$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $b8603eeed79104f2$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $b8603eeed79104f2$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $b8603eeed79104f2$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ddbVR = parcelRequire("ddbVR");

var $cPXGO = parcelRequire("cPXGO");

var $5H7UU = parcelRequire("5H7UU");

var $dh538 = parcelRequire("dh538");

var $A6wna = parcelRequire("A6wna");
const $b8603eeed79104f2$var$multiValueStyles = {
    root: "_2rkogqwt _1e0c1txw _1ul9ze3t _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _bfhkm7j4 _p12f1osq _syaz1fxt _3yq3glyw",
    disabled: "_syaz1lh4 _bfhkm7j4",
    focused: "_syazaqb7 _bfhkfg4m _16qsxs5e _1aewe4h9 _6up53acm _1xdnnqa1",
    refresh: "_2rkoiti9 _1h6d14je _1dqonqa1 _189ee4h9 _bfhk1j9a"
};
const $b8603eeed79104f2$export$23c213f7717186af = ()=>({});
const $b8603eeed79104f2$export$f40612612e0af964 = ()=>({});
const $b8603eeed79104f2$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkogqwt _11c8dcr7 _o5721q9c _ca0qv77o _u5f3v77o _n3tdv77o _19bv12x7 _syaz1kw7",
    disabled: "_syaz1lh4",
    ellipsis: "_1bto1l2s",
    refresh: "_11c82smr _ca0qidpf _n3tdidpf _19bv1b66"
};
const $b8603eeed79104f2$export$283467f6c4ac142b = ()=>({});
const $b8603eeed79104f2$var$multiValueRemoveStyles = {
    focused: "_bfhk1km6 _lswuaqb7",
    root: "_2rkovtp2 _4cvr1h6o _1e0c1txw _lswu1fxt _19bvv77o _u5f3v77o _irr31yvi _13br1tmw _1di61io2 _i5f81tmw",
    refresh: "_19itglyw _2rkoglpi _bfhk1w7a _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _syaz1fxt _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _2hwxv77o _1ah312gs _irr3166n _1di61dty"
};
const $b8603eeed79104f2$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ...innerProps,
        className: (0, $35pXk.default)([
            $b8603eeed79104f2$var$multiValueStyles.root,
            isDisabled && $b8603eeed79104f2$var$multiValueStyles.disabled,
            isFocused && $b8603eeed79104f2$var$multiValueStyles.focused,
            (0, $dh538.fg)('platform-component-visual-refresh') && $b8603eeed79104f2$var$multiValueStyles.refresh,
            (0, $ddbVR.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $b8603eeed79104f2$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ...innerProps,
        className: (0, $35pXk.default)([
            $b8603eeed79104f2$var$multiValueLabelStyles.root,
            isDisabled && $b8603eeed79104f2$var$multiValueLabelStyles.disabled,
            hasEllipsis && $b8603eeed79104f2$var$multiValueLabelStyles.ellipsis,
            (0, $dh538.fg)('platform-component-visual-refresh') && $b8603eeed79104f2$var$multiValueLabelStyles.refresh,
            (0, $ddbVR.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};
const $b8603eeed79104f2$var$disabledStyles = null;
const $b8603eeed79104f2$var$enabledStyles = null;
function $b8603eeed79104f2$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ...innerProps,
        className: (0, $35pXk.default)([
            $b8603eeed79104f2$var$multiValueRemoveStyles.root,
            isFocused && $b8603eeed79104f2$var$multiValueRemoveStyles.focused,
            (0, $dh538.fg)('platform-component-visual-refresh') && $b8603eeed79104f2$var$multiValueRemoveStyles.refresh,
            (0, $ddbVR.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $35pXk.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5H7UU))), {
                label: "",
                color: "currentColor",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cPXGO))),
                LEGACY_primaryColor: "transparent",
                LEGACY_secondaryColor: "inherit",
                LEGACY_size: "small"
            })
        })
    });
}
const $b8603eeed79104f2$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    const { css: containerCss, className: containerClassName } = (0, $A6wna.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $A6wna.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $A6wna.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${ariaLabel || 'option'}, remove`,
                    ...removeProps
                },
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $b8603eeed79104f2$export$2e2bcd8739ae039 = $b8603eeed79104f2$var$MultiValue;

});
parcelRegister("5H7UU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56f9c413d8fbf4deb11215ad83bf4b70>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42571c06dfc05bd9$var$_react = $42571c06dfc05bd9$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $42571c06dfc05bd9$var$_baseNew = $42571c06dfc05bd9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $42571c06dfc05bd9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42571c06dfc05bd9$var$CrossIcon = (props)=>/*#__PURE__*/ $42571c06dfc05bd9$var$_react.default.createElement($42571c06dfc05bd9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m7.06 6 3.47-3.47-1.06-1.06L6 4.94 2.53 1.47 1.47 2.53 4.94 6 1.47 9.47l1.06 1.06L6 7.06l3.47 3.47 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$42571c06dfc05bd9$var$CrossIcon.displayName = 'CrossIcon';
var $42571c06dfc05bd9$var$_default = module.exports.default = $42571c06dfc05bd9$var$CrossIcon;

});


parcelRegister("8AkOR", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $87852888dfc57b19$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $87852888dfc57b19$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $87852888dfc57b19$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $87852888dfc57b19$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $87852888dfc57b19$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $87852888dfc57b19$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $87852888dfc57b19$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $cPXGO = parcelRequire("cPXGO");

var $5H7UU = parcelRequire("5H7UU");

var $dh538 = parcelRequire("dh538");

var $A6wna = parcelRequire("A6wna");
const $87852888dfc57b19$export$23c213f7717186af = ({ isDisabled: isDisabled, isFocused: isFocused })=>{
    let backgroundColor;
    let color;
    if (isDisabled) {
        // Use the basic neutral background so it is slightly separate from the
        // field's background
        backgroundColor = "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text-disabled, #091E424F)";
    } else if (isFocused) {
        backgroundColor = "var(--ds-background-selected, #E9F2FF)";
        color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
    } else {
        backgroundColor = (0, $dh538.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text, hsl(0, 0%, 20%))";
    }
    return {
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        margin: "var(--ds-space-025, 2px)",
        borderRadius: "var(--ds-border-radius-050, 2px)",
        backgroundColor: backgroundColor,
        boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
        maxWidth: '100%',
        '@media screen and (-ms-high-contrast: active)': {
            border: isFocused ? '1px solid transparent' : 'none'
        },
        color: color,
        ...(0, $dh538.fg)('platform-component-visual-refresh') && {
            borderRadius: "var(--ds-border-radius-100, 4px)",
            // Hardcode this color for visual refresh as there is no token color yet
            borderColor: '#B7B9BE',
            borderWidth: "var(--ds-border-width, 1px)",
            borderStyle: 'solid',
            backgroundColor: "var(--ds-background-input, #FFFFFF)"
        }
    };
};
const $87852888dfc57b19$export$f40612612e0af964 = ({ cropWithEllipsis: cropWithEllipsis, isDisabled: isDisabled })=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '85%',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        padding: "var(--ds-space-025, 2px)",
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : 'inherit',
        paddingLeft: "var(--ds-space-075, 6px)",
        ...(0, $dh538.fg)('platform-component-visual-refresh') && {
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: "var(--ds-space-050, 4px)"
        }
    });
const $87852888dfc57b19$export$283467f6c4ac142b = ({ isFocused: isFocused })=>({
        alignItems: 'center',
        display: 'flex',
        backgroundColor: isFocused ? "var(--ds-UNSAFE-transparent, transparent)" : undefined,
        fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
        paddingLeft: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-025, 2px)",
        borderRadius: '0px 2px 2px 0px',
        // DSP-6470 we should style like Tag once we have the :has selector
        ':hover': {
            backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)",
            fill: "var(--ds-text-danger, #000)"
        },
        ':active': {
            backgroundColor: "var(--ds-background-danger-pressed, #FD9891)",
            fill: "var(--ds-text-danger, #000)"
        },
        ...(0, $dh538.fg)('platform-component-visual-refresh') && {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            border: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            appearance: 'none',
            borderRadius: "var(--ds-border-radius, 4px)",
            color: "var(--ds-text, #172B4D)",
            padding: "var(--ds-space-025, 2px)",
            marginRight: "var(--ds-space-025, 2px)",
            ':focus-visible': {
                outlineOffset: "var(--ds-space-negative-025, -2px)"
            },
            ':hover': {
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
            },
            ':active': {
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
            }
        }
    });
const $87852888dfc57b19$var$MultiValueGeneric = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $3jLHL.jsx)("div", innerProps, children);
const $87852888dfc57b19$export$cf9cf2a30a59265c = $87852888dfc57b19$var$MultiValueGeneric;
const $87852888dfc57b19$export$544aeea2a5ce08ee = $87852888dfc57b19$var$MultiValueGeneric;
const $87852888dfc57b19$var$disabledStyles = (0, $3jLHL.css)({
    display: 'none'
});
const $87852888dfc57b19$var$enabledStyles = (0, $3jLHL.css)({
    display: 'inherit'
});
function $87852888dfc57b19$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, innerProps: innerProps }) {
    return(// The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", innerProps, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: isDisabled ? $87852888dfc57b19$var$disabledStyles : $87852888dfc57b19$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5H7UU))), {
        label: "",
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cPXGO))),
        LEGACY_primaryColor: "transparent",
        LEGACY_secondaryColor: "inherit",
        LEGACY_size: "small"
    }))));
}
const $87852888dfc57b19$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    return /*#__PURE__*/ (0, $3jLHL.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $A6wna.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $3jLHL.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $A6wna.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $3jLHL.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $A6wna.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            role: 'button',
            tabIndex: -1,
            'aria-label': `${ariaLabel || 'option'}, remove`,
            ...removeProps
        },
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$87852888dfc57b19$export$2e2bcd8739ae039 = $87852888dfc57b19$var$MultiValue;

});


parcelRegister("4K6SB", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $62b8d5f515c5e7a2$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $62b8d5f515c5e7a2$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $fkYyB = parcelRequire("fkYyB");

var $dvLRI = parcelRequire("dvLRI");
const $62b8d5f515c5e7a2$export$ef897119b7e920ba = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $fkYyB.optionCSS)() : (0, $dvLRI.optionCSS)(props);
const $62b8d5f515c5e7a2$var$Option = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fkYyB.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dvLRI.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$62b8d5f515c5e7a2$export$2e2bcd8739ae039 = $62b8d5f515c5e7a2$var$Option;

});
parcelRegister("fkYyB", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $49698da8bca37448$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $49698da8bca37448$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ddbVR = parcelRequire("ddbVR");

var $A6wna = parcelRequire("A6wna");
const $49698da8bca37448$export$ef897119b7e920ba = ()=>({});
const $49698da8bca37448$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syaz1fxt _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di61dty",
    disabled: "_syaz1lh4 _80om13gf _bfhk18uv _16qsglyw _1di618uv _1pknglyw",
    focused: "_bfhk166n _16qsu4to _1pknj1ic",
    selected: "_syazaqb7 _bfhkfg4m _16qsu4to _1di619ru _1pknj1ic",
    focusedSelected: "_bfhki1yw"
};
const $49698da8bca37448$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $35pXk.default)([
            $49698da8bca37448$var$optionStyles.root,
            isFocused && $49698da8bca37448$var$optionStyles.focused,
            isSelected && $49698da8bca37448$var$optionStyles.selected,
            isFocused && isSelected && $49698da8bca37448$var$optionStyles.focusedSelected,
            isDisabled && $49698da8bca37448$var$optionStyles.disabled,
            (0, $ddbVR.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $49698da8bca37448$export$2e2bcd8739ae039 = $49698da8bca37448$var$Option;

});

parcelRegister("dvLRI", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $a0fbe808eb34b0a2$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $a0fbe808eb34b0a2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $A6wna = parcelRequire("A6wna");
const $a0fbe808eb34b0a2$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    let color = "var(--ds-text, #172B4D)";
    if (isDisabled) color = "var(--ds-text-disabled, #091E424F)";
    else if (isSelected) color = "var(--ds-text-selected, #0C66E4)";
    let boxShadow;
    let backgroundColor;
    if (isDisabled) backgroundColor = undefined;
    else if (isSelected && isFocused) backgroundColor = "var(--ds-background-selected-hovered, #CCE0FF)";
    else if (isSelected) backgroundColor = "var(--ds-background-selected, #E9F2FF)";
    else if (isFocused) backgroundColor = "var(--ds-background-neutral-subtle-hovered, #091E420F)";
    if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${"var(--ds-border-selected, #0C66E4)"}`;
    const cursor = isDisabled ? 'not-allowed' : 'default';
    return {
        label: 'option',
        display: 'block',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        backgroundColor: backgroundColor,
        color: color,
        cursor: cursor,
        boxShadow: boxShadow,
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? "var(--ds-background-selected-pressed, #85B8FF)" : "var(--ds-background-neutral-subtle-pressed, #091E4224)" : undefined
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
        }
    };
};
const $a0fbe808eb34b0a2$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a0fbe808eb34b0a2$export$2e2bcd8739ae039 = $a0fbe808eb34b0a2$var$Option;

});


parcelRegister("hsH3d", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $1153562350781597$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $1153562350781597$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $kl5x7 = parcelRequire("kl5x7");

var $beuXU = parcelRequire("beuXU");
const $1153562350781597$export$5f3ffacd6594d90f = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $kl5x7.placeholderCSS)() : (0, $beuXU.placeholderCSS)(props);
const $1153562350781597$var$Placeholder = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kl5x7.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $beuXU.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1153562350781597$export$2e2bcd8739ae039 = $1153562350781597$var$Placeholder;

});
parcelRegister("kl5x7", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $acf82b40f4a3dd7c$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $acf82b40f4a3dd7c$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ddbVR = parcelRequire("ddbVR");

var $A6wna = parcelRequire("A6wna");
const $acf82b40f4a3dd7c$export$5f3ffacd6594d90f = ()=>({});
const $acf82b40f4a3dd7c$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz131l",
    disabled: "_syaz1lh4"
};
const $acf82b40f4a3dd7c$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $35pXk.default)([
            $acf82b40f4a3dd7c$var$placeholderStyles.root,
            isDisabled && $acf82b40f4a3dd7c$var$placeholderStyles.disabled,
            (0, $ddbVR.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $acf82b40f4a3dd7c$export$2e2bcd8739ae039 = $acf82b40f4a3dd7c$var$Placeholder;

});

parcelRegister("beuXU", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $b9063ce3f7178314$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $b9063ce3f7178314$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $A6wna = parcelRequire("A6wna");
const $b9063ce3f7178314$export$5f3ffacd6594d90f = ({ isDisabled: isDisabled })=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtlest, #626F86)"
    });
const $b9063ce3f7178314$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b9063ce3f7178314$export$2e2bcd8739ae039 = $b9063ce3f7178314$var$Placeholder;

});


parcelRegister("hf117", function(module, exports) {

$parcel$export(module.exports, "css", () => $e74d5d34f7141b15$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $e74d5d34f7141b15$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $kLfiG = parcelRequire("kLfiG");

var $3k2Ag = parcelRequire("3k2Ag");
const $e74d5d34f7141b15$export$dbf350e5966cf602 = (props)=>(0, $dh538.fg)('compiled-react-select') ? (0, $kLfiG.css)() : (0, $3k2Ag.css)(props);
const $e74d5d34f7141b15$var$SingleValue = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kLfiG.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3k2Ag.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e74d5d34f7141b15$export$2e2bcd8739ae039 = $e74d5d34f7141b15$var$SingleValue;

});
parcelRegister("kLfiG", function(module, exports) {

$parcel$export(module.exports, "css", () => $eede378268a31e42$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $eede378268a31e42$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ddbVR = parcelRequire("ddbVR");

var $A6wna = parcelRequire("A6wna");
const $eede378268a31e42$export$dbf350e5966cf602 = ()=>({});
const $eede378268a31e42$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1fxt",
    disalbed: "_syaz1lh4"
};
const $eede378268a31e42$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $35pXk.default)([
            $eede378268a31e42$var$styles.root,
            isDisabled && $eede378268a31e42$var$styles.disalbed,
            (0, $ddbVR.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $eede378268a31e42$export$2e2bcd8739ae039 = $eede378268a31e42$var$SingleValue;

});

parcelRegister("3k2Ag", function(module, exports) {

$parcel$export(module.exports, "css", () => $45dba4b677813a56$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $45dba4b677813a56$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $A6wna = parcelRequire("A6wna");
const $45dba4b677813a56$export$dbf350e5966cf602 = ({ isDisabled: isDisabled })=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text, #172B4D)"
    });
const $45dba4b677813a56$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...(0, $A6wna.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$45dba4b677813a56$export$2e2bcd8739ae039 = $45dba4b677813a56$var$SingleValue;

});



parcelRegister("bVoXV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8720dadcd61931c8$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $kTo9t = parcelRequire("kTo9t");

var $2LTFb = parcelRequire("2LTFb");
function $8720dadcd61931c8$export$2e2bcd8739ae039(props) {
    return (0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kTo9t.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LTFb.default), {
        ...props
    });
}

});
parcelRegister("kTo9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $d953cb3a5947461b$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $A6wna = parcelRequire("A6wna");
const $d953cb3a5947461b$var$dummyInputStyles = null;
function $d953cb3a5947461b$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $A6wna.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear'); // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $7UHDa.jsx)("input", {
        ref: innerRef,
        className: (0, $35pXk.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d3acm _syaz3acm _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}

});

parcelRegister("2LTFb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3575249b065ec02$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $A6wna = parcelRequire("A6wna");
const $d3575249b065ec02$var$dummyInputStyles = (0, $3jLHL.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $d3575249b065ec02$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $A6wna.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $3jLHL.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $d3575249b065ec02$var$dummyInputStyles
    });
}

});


parcelRegister("1wcY0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c529e29bf8540d6a$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $3V2qk = parcelRequire("3V2qk");

var $b9X8D = parcelRequire("b9X8D");
const $c529e29bf8540d6a$var$RequiredInput = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3V2qk.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $b9X8D.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c529e29bf8540d6a$export$2e2bcd8739ae039 = $c529e29bf8540d6a$var$RequiredInput;

});
parcelRegister("3V2qk", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a239d831be6afd$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ee7An = parcelRequire("ee7An");
const $25a239d831be6afd$var$styles = null;
const $25a239d831be6afd$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $7UHDa.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true" // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        ,
        className: (0, $35pXk.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _jqf61a21 _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        value: "",
        onChange: (0, $ee7An.default)
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $25a239d831be6afd$export$2e2bcd8739ae039 = $25a239d831be6afd$var$RequiredInput;

});

parcelRegister("b9X8D", function(module, exports) {

$parcel$export(module.exports, "default", () => $50138a5aab476698$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $ee7An = parcelRequire("ee7An");
const $50138a5aab476698$var$styles = (0, $3jLHL.css)({
    width: '100%',
    position: 'absolute',
    insetBlockEnd: 0,
    insetInlineEnd: 0,
    insetInlineStart: 0,
    label: 'requiredInput',
    opacity: 0,
    pointerEvents: 'none'
});
const $50138a5aab476698$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $3jLHL.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $50138a5aab476698$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $ee7An.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$50138a5aab476698$export$2e2bcd8739ae039 = $50138a5aab476698$var$RequiredInput;

});


parcelRegister("cUklV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d6eae5816d21c55$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3ftWH = parcelRequire("3ftWH");

var $3KKWU = parcelRequire("3KKWU");
const $4d6eae5816d21c55$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $4d6eae5816d21c55$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $3ftWH.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $3KKWU.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                onClick: $4d6eae5816d21c55$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

});
parcelRegister("3ftWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0211107e3935e90f$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $A6wna = parcelRequire("A6wna");
const $0211107e3935e90f$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $0211107e3935e90f$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $gwFzn.useRef)(false);
    const isTop = (0, $gwFzn.useRef)(false);
    const touchStart = (0, $gwFzn.useRef)(0);
    const scrollTarget = (0, $gwFzn.useRef)(null);
    const handleEventDelta = (0, $gwFzn.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $0211107e3935e90f$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $gwFzn.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $gwFzn.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $gwFzn.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $gwFzn.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $A6wna.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $gwFzn.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("3KKWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c9aff3c45ae82af$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
const $9c9aff3c45ae82af$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $9c9aff3c45ae82af$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $9c9aff3c45ae82af$var$preventTouchMove(e) {
    e.preventDefault();
}
function $9c9aff3c45ae82af$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $9c9aff3c45ae82af$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $9c9aff3c45ae82af$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $9c9aff3c45ae82af$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $9c9aff3c45ae82af$var$activeScrollLocks = 0;
const $9c9aff3c45ae82af$var$listenerOptions = {
    capture: false,
    passive: false
};
function $9c9aff3c45ae82af$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $gwFzn.useRef)({});
    const scrollTarget = (0, $gwFzn.useRef)(null);
    const addScrollLock = (0, $gwFzn.useCallback)((touchScrollTarget)=>{
        if (!$9c9aff3c45ae82af$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $9c9aff3c45ae82af$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $9c9aff3c45ae82af$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($9c9aff3c45ae82af$var$LOCK_STYLES).forEach((key)=>{
                const val = $9c9aff3c45ae82af$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $9c9aff3c45ae82af$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $9c9aff3c45ae82af$var$preventTouchMove, $9c9aff3c45ae82af$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $9c9aff3c45ae82af$var$preventInertiaScroll, $9c9aff3c45ae82af$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $9c9aff3c45ae82af$var$allowTouchMove, $9c9aff3c45ae82af$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $9c9aff3c45ae82af$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $gwFzn.useCallback)((touchScrollTarget)=>{
        if (!$9c9aff3c45ae82af$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $9c9aff3c45ae82af$var$activeScrollLocks = Math.max($9c9aff3c45ae82af$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $9c9aff3c45ae82af$var$activeScrollLocks < 1) $9c9aff3c45ae82af$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $9c9aff3c45ae82af$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $9c9aff3c45ae82af$var$preventTouchMove, $9c9aff3c45ae82af$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $9c9aff3c45ae82af$var$preventInertiaScroll, $9c9aff3c45ae82af$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $9c9aff3c45ae82af$var$allowTouchMove, $9c9aff3c45ae82af$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("jCj4R", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $ad100f5db547f4f3$export$17baa7c95b6ba1b8);

var $if5rb = parcelRequire("if5rb");
function $ad100f5db547f4f3$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $if5rb.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("kNPPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $304230040a649a89$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $dLtdg = parcelRequire("dLtdg");

var $ijbDW = parcelRequire("ijbDW");
const $304230040a649a89$var$LiveRegion = (props)=>(0, $dh538.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dLtdg.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ijbDW.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$304230040a649a89$export$2e2bcd8739ae039 = $304230040a649a89$var$LiveRegion;

});
parcelRegister("dLtdg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fa5843b36101e66$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $5Jm6h = parcelRequire("5Jm6h");

var $gdfBE = parcelRequire("gdfBE");
const $5fa5843b36101e66$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // for safari, we will use minimum support from aria-live region
    const isA11yImprovementEnabled = (0, $dh538.fg)('design_system_select-a11y-improvement') && !isAppleDevice;
    // Update aria live message configuration when prop changes
    const messages = (0, $gwFzn.useMemo)(()=>({
            ...(0, $5Jm6h.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $gwFzn.useMemo)(()=>{
        let message = '';
        if (isA11yImprovementEnabled && menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (isA11yImprovementEnabled && !label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        isA11yImprovementEnabled,
        menuIsOpen
    ]);
    const prevInputValue = (0, $gwFzn.useRef)('');
    const ariaFocused = (0, $gwFzn.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (inputValue === prevInputValue.current && isA11yImprovementEnabled) // only announce focus option when searching when ff is on and the input value changed
        // for safari, we will announce for all
        return '';
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isMulti: isMulti
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        prevInputValue.current = inputValue;
        return focusMsg;
    }, [
        inputValue,
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isA11yImprovementEnabled,
        isMulti
    ]);
    const ariaResults = (0, $gwFzn.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $gwFzn.useMemo)(()=>{
        if ((0, $dh538.fg)('design_system_select-a11y-improvement')) // don't announce guidance at all when ff is on
        return '';
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            }),
            !(0, $dh538.fg)('design_system_select-a11y-improvement') && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                        id: "aria-focused",
                        children: ariaFocused
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                        id: "aria-guidance",
                        children: ariaGuidance
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdfBE.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdfBE.default), {
                "aria-live": ariaLive,
                "aria-atomic": (0, $dh538.fg)('design_system_select-a11y-improvement') ? undefined : 'false',
                "aria-relevant": (0, $dh538.fg)('design_system_select-a11y-improvement') ? undefined : 'additions text',
                role: (0, $dh538.fg)('design_system_select-a11y-improvement') ? 'status' : 'log',
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fa5843b36101e66$export$2e2bcd8739ae039 = $5fa5843b36101e66$var$LiveRegion;

});
parcelRegister("5Jm6h", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $442ba9ea0dcbe6b6$export$a7265767c78f9bae);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $dh538 = parcelRequire("dh538");
const $442ba9ea0dcbe6b6$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length && (0, $dh538.fg)('design_system_select-a11y-improvement') || !(0, $dh538.fg)('design_system_select-a11y-improvement') ? `option ${label}, deselected` : ''; // TODO: this should be handled on backspace|delete if no value, but doing it here first
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return label.length && (0, $dh538.fg)('design_system_select-a11y-improvement') || !(0, $dh538.fg)('design_system_select-a11y-improvement') ? `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.` : '';
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isDisabled: isDisabled, isSelected: isSelected } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        // No longer needed after fg('design_system_select-a11y-improvement') is cleaned up
        if (context === 'menu' && !(0, $dh538.fg)('design_system_select-a11y-improvement')) {
            const disabled = isDisabled ? ' disabled' : '';
            const status = `${isSelected ? ' selected' : ' not selected'}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("gdfBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $daf86c00dab9e786$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v0.36.1 */ // Assistive text to describe visual elements. Hidden for sighted users.

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $daf86c00dab9e786$var$styles = null;
const $daf86c00dab9e786$var$A11yText = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("span" // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $35pXk.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _jqf6ydhy _uiztglyw _o5721q9c",
            "-a11yText"
        ]),
        ...props
    });
var $daf86c00dab9e786$export$2e2bcd8739ae039 = $daf86c00dab9e786$var$A11yText;

});


parcelRegister("ijbDW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c62bd3ef47cb3dc$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ /**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $dh538 = parcelRequire("dh538");

var $5Jm6h = parcelRequire("5Jm6h");

var $03qlE = parcelRequire("03qlE");
const $1c62bd3ef47cb3dc$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // for safari, we will use minimum support from aria-live region
    const isA11yImprovementEnabled = (0, $dh538.fg)('design_system_select-a11y-improvement') && !isAppleDevice;
    // Update aria live message configuration when prop changes
    const messages = (0, $gwFzn.useMemo)(()=>({
            ...(0, $5Jm6h.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $gwFzn.useMemo)(()=>{
        let message = '';
        if (isA11yImprovementEnabled && menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (isA11yImprovementEnabled && !label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        isA11yImprovementEnabled,
        menuIsOpen
    ]);
    const prevInputValue = (0, $gwFzn.useRef)('');
    const ariaFocused = (0, $gwFzn.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (inputValue === prevInputValue.current && isA11yImprovementEnabled) // only announce focus option when searching when ff is on and the input value changed
        // for safari, we will announce for all
        return '';
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isMulti: isMulti
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        prevInputValue.current = inputValue;
        return focusMsg;
    }, [
        inputValue,
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isA11yImprovementEnabled,
        isMulti
    ]);
    const ariaResults = (0, $gwFzn.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $gwFzn.useMemo)(()=>{
        if ((0, $dh538.fg)('design_system_select-a11y-improvement')) // don't announce guidance at all when ff is on
        return '';
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        id: "aria-results"
    }, ariaResults), !(0, $dh538.fg)('design_system_select-a11y-improvement') && /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance)));
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $03qlE.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $03qlE.default), {
        "aria-live": ariaLive,
        "aria-atomic": (0, $dh538.fg)('design_system_select-a11y-improvement') ? undefined : 'false',
        "aria-relevant": (0, $dh538.fg)('design_system_select-a11y-improvement') ? undefined : 'additions text',
        role: (0, $dh538.fg)('design_system_select-a11y-improvement') ? 'status' : 'log'
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1c62bd3ef47cb3dc$export$2e2bcd8739ae039 = $1c62bd3ef47cb3dc$var$LiveRegion;

});
parcelRegister("03qlE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6b929e1705496bb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $3jLHL = parcelRequire("3jLHL");
// Assistive text to describe visual elements. Hidden for sighted users.
const $a6b929e1705496bb$var$styles = (0, $3jLHL.css)({
    width: 1,
    height: 1,
    padding: 0,
    position: 'absolute',
    zIndex: 9999,
    border: 0,
    clip: 'rect(1px, 1px, 1px, 1px)',
    label: 'a11yText',
    overflow: 'hidden',
    userSelect: 'none',
    // while hidden text is sitting in the DOM, it should not be selectable
    whiteSpace: 'nowrap'
});
const $a6b929e1705496bb$var$A11yText = (props)=>/*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $a6b929e1705496bb$var$styles,
        ...props
    });
var $a6b929e1705496bb$export$2e2bcd8739ae039 = $a6b929e1705496bb$var$A11yText;

});



parcelRegister("hJzqL", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $f921464ea1e07ecb$export$5d81789ff4aeccdf);

var $csnse = parcelRequire("csnse");

var $hlwqc = parcelRequire("hlwqc");
const $f921464ea1e07ecb$var$memoizedStripDiacriticsForInput = (0, $csnse.default)((0, $hlwqc.stripDiacritics));
const $f921464ea1e07ecb$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $f921464ea1e07ecb$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $f921464ea1e07ecb$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $f921464ea1e07ecb$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $f921464ea1e07ecb$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $f921464ea1e07ecb$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $f921464ea1e07ecb$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $hlwqc.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("hlwqc", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $3f411f3f8b100b70$export$b5bee4b27048330b);
const $3f411f3f8b100b70$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $3f411f3f8b100b70$var$anyDiacritic = new RegExp('[' + $3f411f3f8b100b70$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $3f411f3f8b100b70$var$diacriticToBase = {};
for(let i = 0; i < $3f411f3f8b100b70$var$diacritics.length; i++){
    let diacritic = $3f411f3f8b100b70$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$3f411f3f8b100b70$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $3f411f3f8b100b70$export$b5bee4b27048330b = (str)=>{
    return str.replace($3f411f3f8b100b70$var$anyDiacritic, (match)=>$3f411f3f8b100b70$var$diacriticToBase[match]);
};

});


parcelRegister("eKXGE", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $6ab331f7326b3ca4$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $6ab331f7326b3ca4$export$e618dc39ac9ad607);

var $kM6CX = parcelRequire("kM6CX");

var $dLCCQ = parcelRequire("dLCCQ");

var $fPe0U = parcelRequire("fPe0U");

var $bX0kj = parcelRequire("bX0kj");

var $9gJAx = parcelRequire("9gJAx");

var $13TeD = parcelRequire("13TeD");

var $2ASIF = parcelRequire("2ASIF");

var $4K6SB = parcelRequire("4K6SB");

var $hsH3d = parcelRequire("hsH3d");

var $hf117 = parcelRequire("hf117");
const $6ab331f7326b3ca4$export$214b055320e0bf32 = {
    clearIndicator: (0, $bX0kj.clearIndicatorCSS),
    container: (0, $kM6CX.containerCSS),
    control: (0, $dLCCQ.css),
    dropdownIndicator: (0, $bX0kj.dropdownIndicatorCSS),
    group: (0, $fPe0U.groupCSS),
    groupHeading: (0, $fPe0U.groupHeadingCSS),
    indicatorsContainer: (0, $kM6CX.indicatorsContainerCSS),
    input: (0, $9gJAx.inputCSS),
    loadingIndicator: (0, $bX0kj.loadingIndicatorCSS),
    loadingMessage: (0, $13TeD.loadingMessageCSS),
    menu: (0, $13TeD.menuCSS),
    menuList: (0, $13TeD.menuListCSS),
    menuPortal: (0, $13TeD.menuPortalCSS),
    multiValue: (0, $2ASIF.multiValueCSS),
    multiValueLabel: (0, $2ASIF.multiValueLabelCSS),
    multiValueRemove: (0, $2ASIF.multiValueRemoveCSS),
    noOptionsMessage: (0, $13TeD.noOptionsMessageCSS),
    option: (0, $4K6SB.optionCSS),
    placeholder: (0, $hsH3d.placeholderCSS),
    singleValue: (0, $hf117.css),
    valueContainer: (0, $kM6CX.valueContainerCSS)
};
function $6ab331f7326b3ca4$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});


parcelRegister("gJgOY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ff5e862515f2388$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $A6wna = parcelRequire("A6wna");
function $3ff5e862515f2388$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $gwFzn.useRef)(undefined);
    const mounted = (0, $gwFzn.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $gwFzn.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $gwFzn.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $gwFzn.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $gwFzn.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $gwFzn.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $gwFzn.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $gwFzn.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $gwFzn.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $gwFzn.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $gwFzn.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $gwFzn.useCallback)((newValue, actionMeta)=>{
        const inputValue = (0, $A6wna.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("kjDWr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec570eb86c5ed061$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
function $ec570eb86c5ed061$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $gwFzn.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $gwFzn.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $gwFzn.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $gwFzn.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $gwFzn.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $gwFzn.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $gwFzn.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("81yTx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f75804e8b9c96f3$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $df3G3 = parcelRequire("df3G3");
function $3f75804e8b9c96f3$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: // TODO: set to true when cleaning up validationState prop so it has a default value
        onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $gwFzn.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $gwFzn.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": (0, $dh538.fg)('design_system_select-a11y-improvement') ? undefined : 'assertive',
            ariaLiveMessages: //TO DO: Still need live region for PopupSelect because of the menu being open by default
            (0, $df3G3.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $df3G3.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("df3G3", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $6eab0dca4f49f8cd$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $6eab0dca4f49f8cd$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $6eab0dca4f49f8cd$export$8ee33f304118fce4);

var $dh538 = parcelRequire("dh538");
function $6eab0dca4f49f8cd$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    if (focused.label && groupData?.label && (0, $dh538.fg)('design_system_select-a11y-improvement')) return `${focused.label}, ${groupData?.label}`;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $6eab0dca4f49f8cd$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $6eab0dca4f49f8cd$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("aD1SW", function(module, exports) {

$parcel$export(module.exports, "default", () => $43a9bd12f06a7115$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gxtzC = parcelRequire("gxtzC");

var $ee7An = parcelRequire("ee7An");

var $eCEXz = parcelRequire("eCEXz");

var $6uGcC = parcelRequire("6uGcC");
const $43a9bd12f06a7115$var$packageName = "platform-pkg";
const $43a9bd12f06a7115$var$packageVersion = "0.0.0-use.local";
const $43a9bd12f06a7115$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $43a9bd12f06a7115$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $ee7An.default) } = props;
    const autoDismissTimer = (0, $gwFzn.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $6uGcC.useFlagGroup)();
    const onDismissed = (0, $gwFzn.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $43a9bd12f06a7115$var$packageName,
        packageVersion: $43a9bd12f06a7115$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $gwFzn.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $gwFzn.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $gwFzn.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $43a9bd12f06a7115$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $gwFzn.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eCEXz.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $43a9bd12f06a7115$export$2e2bcd8739ae039 = $43a9bd12f06a7115$var$AutoDismissFlag;

});
parcelRegister("eCEXz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5a25210448b050f$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $gxtzC = parcelRequire("gxtzC");

var $ee7An = parcelRequire("ee7An");

var $7hXDW = parcelRequire("7hXDW");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
var $eyWa4 = parcelRequire("eyWa4");

var $6F6hl = parcelRequire("6F6hl");

var $88kih = parcelRequire("88kih");

var $hbAVA = parcelRequire("hbAVA");

var $6uGcC = parcelRequire("6uGcC");

var $dPscY = parcelRequire("dPscY");
var $357kL = parcelRequire("357kL");

var $f9ZC9 = parcelRequire("f9ZC9");
const $b5a25210448b050f$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkosqtm _1reo15vq _18m915vq _v564z97a _16qs1cd0 _1pbyni7l _1bsb1osq"
};
const $b5a25210448b050f$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $b5a25210448b050f$var$oldDescriptionStyles = null;
const $b5a25210448b050f$var$descriptionStyles = null;
const $b5a25210448b050f$var$oldIconWrapperStyles = null;
const $b5a25210448b050f$var$iconWrapperStyles = null;
const $b5a25210448b050f$var$flagWrapperStyles = null;
const $b5a25210448b050f$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $b5a25210448b050f$var$transitionStyles = null; /**
                                * __Flag__
                                *
                                * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
                                * often displayed using a flag group.
                                *
                                * - [Examples](https://atlassian.design/components/flag/examples)
                                * - [Code](https://atlassian.design/components/flag/code)
                                * - [Usage](https://atlassian.design/components/flag/usage)
                                */ 
const $b5a25210448b050f$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $88kih.DEFAULT_APPEARANCE), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $ee7An.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $ee7An.default), onDismissed: onDismissedProp = (0, $ee7An.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $gwFzn.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $6uGcC.useFlagGroup)();
    const onDismissed = (0, $gwFzn.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $gwFzn.useState)(false);
    const onDismissedAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$b5a25210448b050f$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $88kih.DEFAULT_APPEARANCE);
    const toggleExpand = (0, $gwFzn.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $gwFzn.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$b5a25210448b050f$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$b5a25210448b050f$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $f9ZC9.flagTextColor)[appearance];
    const iconColor = (0, $f9ZC9.flagIconColor)[appearance];
    const iconGlyph = (0, $f9ZC9.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded; // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6F6hl.default), {
        children: [
            title,
            description
        ]
    }) : undefined;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $35pXk.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            padding: "space.200",
            backgroundColor: (0, $f9ZC9.flagBackgroundColor)[appearance],
            xcss: $b5a25210448b050f$var$styles.flag,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                alignBlock: (0, $dh538.fg)('platform_ads_component_no_icon_spacing_support') ? 'start' : 'stretch',
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    , {
                        style: {
                            [$b5a25210448b050f$var$CSS_VAR_ICON_COLOR]: iconColor
                        },
                        "data-testid": testId && `${testId}-icon-container`,
                        className: (0, $35pXk.default)([
                            (0, $dh538.fg)('platform_ads_component_no_icon_spacing_support') ? "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0" : "_1e0c1txw _4cvrv2br _1o9zidpf _syaz1jn0"
                        ]),
                        children: icon || (iconGlyph && (0, $dh538.fg)('platform_ads_component_no_icon_spacing_support') ? iconGlyph : null)
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                        className: (0, $35pXk.default)([
                            "_v5641hdc _16jlkb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: $b5a25210448b050f$var$styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                                                as: `h${headingLevel}`,
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                                                    /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                                    children: title
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dPscY.default), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $357kL.default), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        , {
                                            style: {
                                                color: (0, $f9ZC9.flagTextColorToken)[appearance]
                                            },
                                            "data-testid": testId && `${testId}-description`,
                                            "aria-hidden": isDelayToAnnounce,
                                            className: (0, $35pXk.default)([
                                                (0, $dh538.fg)('platform_ads_explicit_font_styles') ? "_11c82smr _1reo1wug _18m91wug _c71l53f4 _1i4qfg65" : "_1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hbAVA.default), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $b5a25210448b050f$export$2e2bcd8739ae039 = $b5a25210448b050f$var$Flag;

});
parcelRegister("88kih", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_APPEARANCE", () => $f1e025004f98561c$export$d6830277b06edd6);
const $f1e025004f98561c$export$d6830277b06edd6 = 'normal';

});

parcelRegister("hbAVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $94057a5e7a8c60bb$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4KS7f = parcelRequire("4KS7f");

var $dh538 = parcelRequire("dh538");

var $u9agA = parcelRequire("u9agA");

var $88kih = parcelRequire("88kih");

var $f9ZC9 = parcelRequire("f9ZC9");
const $94057a5e7a8c60bb$var$buttonStyles = null;
const $94057a5e7a8c60bb$var$fontStyles = null;
const $94057a5e7a8c60bb$var$appearanceNormalButtonStyles = null;
const $94057a5e7a8c60bb$var$appearanceNormalActionsContainerStyles = null;
const $94057a5e7a8c60bb$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $88kih.DEFAULT_APPEARANCE), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $88kih.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        className: (0, $35pXk.default)([
            !isBold && "_1g4l107e _y8dn107e",
            (0, $dh538.fg)('platform_ads_explicit_font_styles') && "_11c82smr"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && `${testId}-actions`,
            children: actions.map((action, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4KS7f.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $f9ZC9.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $f9ZC9.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $f9ZC9.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $f9ZC9.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $35pXk.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow0718uv _1p6b18uv _8dbm18uv _77mc18uv _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        appearance === (0, $88kih.DEFAULT_APPEARANCE) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index))
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $94057a5e7a8c60bb$export$2e2bcd8739ae039 = $94057a5e7a8c60bb$var$FlagActions;

});
parcelRegister("4KS7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecebd5c55c31879a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $bOG3Z = parcelRequire("bOG3Z");

var $gcG0P = parcelRequire("gcG0P");

var $hYfEs = parcelRequire("hYfEs");

var $etbQ0 = parcelRequire("etbQ0");

var $boHsq = parcelRequire("boHsq");
function $ecebd5c55c31879a$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $ecebd5c55c31879a$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $ecebd5c55c31879a$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $boHsq.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $gwFzn.useState)($ecebd5c55c31879a$var$initial);
    const onMouseEnter = (0, $gwFzn.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $gwFzn.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $gwFzn.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $gwFzn.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $gwFzn.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $gwFzn.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $boHsq.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bOG3Z.default).Consumer, {
            children: ({ mode: mode })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $boHsq.default).Consumer, {
                    mode: mode,
                    state: $ecebd5c55c31879a$var$getInteractionState({
                        ...state,
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    }),
                    iconIsOnlyChild: (0, $hYfEs.default)(restProps),
                    isLoading: isLoading,
                    ...restProps,
                    children: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gcG0P.default), {
                            ...restProps,
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $etbQ0.default), {
                                ...restProps
                            }) : null,
                            // No need to render aria-disabled when it is false
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, $boHsq.getSpecifiers)(buttonStyles)
                        })
                })
        })
    });
}));
// Tools including enzyme rely on components having a display name
$ecebd5c55c31879a$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $ecebd5c55c31879a$export$2e2bcd8739ae039 = $ecebd5c55c31879a$var$CustomThemeButton;

});
parcelRegister("etbQ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $abde033265554c13$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $9hlns = parcelRequire("9hlns");
function $abde033265554c13$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $abde033265554c13$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
        size: size,
        label: ", Loading",
        appearance: $abde033265554c13$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});

parcelRegister("boHsq", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", () => $8730f26c81bbd247$export$643db0b8d8778e);
$parcel$export(module.exports, "defaultThemeFn", () => $8730f26c81bbd247$export$437a7f77d13d7916);
$parcel$export(module.exports, "default", () => $8730f26c81bbd247$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9j05A = parcelRequire("9j05A");

var $10BNt = parcelRequire("10BNt");
const $8730f26c81bbd247$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $8730f26c81bbd247$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', mode: mode = 'light', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $10BNt.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $8730f26c81bbd247$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $8730f26c81bbd247$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $8730f26c81bbd247$export$437a7f77d13d7916(current, values) {
    return current(values);
}
const $8730f26c81bbd247$var$Theme = (0, $9j05A.createTheme)((themeProps)=>({
        buttonStyles: $8730f26c81bbd247$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8730f26c81bbd247$export$2e2bcd8739ae039 = $8730f26c81bbd247$var$Theme;

});


parcelRegister("f9ZC9", function(module, exports) {

$parcel$export(module.exports, "flagBackgroundColor", () => $effc7874d3d3411e$export$59e42969c95d314);
$parcel$export(module.exports, "flagIconColor", () => $effc7874d3d3411e$export$7f70afe2167f8235);
$parcel$export(module.exports, "flagIconGlyph", () => $effc7874d3d3411e$export$73f08aee70487cd4);
$parcel$export(module.exports, "flagTextColor", () => $effc7874d3d3411e$export$f50075b2584087f);
$parcel$export(module.exports, "flagTextColorToken", () => $effc7874d3d3411e$export$13b42cd9d596bfe0);
$parcel$export(module.exports, "actionBackgroundColor", () => $effc7874d3d3411e$export$81ba6b63eedb299f);
$parcel$export(module.exports, "actionTextColor", () => $effc7874d3d3411e$export$7bcfe3cca4dd78b6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5L38b = parcelRequire("5L38b");

var $lpHGz = parcelRequire("lpHGz");

var $bAfMd = parcelRequire("bAfMd");

var $6hqEj = parcelRequire("6hqEj");

var $6fnsQ = parcelRequire("6fnsQ");
const $effc7874d3d3411e$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};
const $effc7874d3d3411e$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #626F86)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #172B4D)"
};
const $effc7874d3d3411e$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5L38b))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`,
        LEGACY_secondaryColor: "var(--ds-background-danger-bold, #C9372C)"
    }),
    info: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lpHGz))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`,
        LEGACY_secondaryColor: "var(--ds-background-neutral-bold, #44546F)"
    }),
    normal: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lpHGz))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-subtle, ${(0, $6fnsQ.N500)})`,
        LEGACY_secondaryColor: "var(--ds-surface-overlay, #FFFFFF)"
    }),
    success: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bAfMd))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`,
        LEGACY_secondaryColor: "var(--ds-background-success-bold, #1F845A)"
    }),
    warning: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6hqEj))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-warning-inverse, ${(0, $6fnsQ.N700)})`,
        LEGACY_secondaryColor: "var(--ds-background-warning-bold, #F5CD47)"
    })
};
const $effc7874d3d3411e$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};
const $effc7874d3d3411e$export$13b42cd9d596bfe0 = {
    error: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    info: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    normal: `var(--ds-text, ${(0, $6fnsQ.N800)})`,
    success: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $6fnsQ.N700)})`
};
const $effc7874d3d3411e$export$81ba6b63eedb299f = {
    success: {
        default: `var(--ds-background-inverse-subtle, ${(0, $6fnsQ.N30A)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $6fnsQ.N30A)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $6fnsQ.N30A)})`
    },
    info: {
        default: `var(--ds-background-inverse-subtle, ${(0, $6fnsQ.N30A)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $6fnsQ.N30A)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $6fnsQ.N30A)})`
    },
    error: {
        default: `var(--ds-background-inverse-subtle, ${(0, $6fnsQ.N30A)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $6fnsQ.N30A)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $6fnsQ.N30A)})`
    },
    warning: {
        default: `var(--ds-background-inverse-subtle, ${(0, $6fnsQ.N30A)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $6fnsQ.N30A)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $6fnsQ.N30A)})`
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};
const $effc7874d3d3411e$export$7bcfe3cca4dd78b6 = {
    success: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    info: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    error: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $6fnsQ.N700)})`,
    normal: `var(--ds-link, ${(0, $6fnsQ.B400)})`
};

});


parcelRegister("6uGcC", function(module, exports) {

$parcel$export(module.exports, "useFlagGroup", () => $b67362102deb1f23$export$e91ea202abb66350);
$parcel$export(module.exports, "default", () => $b67362102deb1f23$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ee7An = parcelRequire("ee7An");

var $g9Srd = parcelRequire("g9Srd");
var $h3cbw = parcelRequire("h3cbw");

var $caX7N = parcelRequire("caX7N");

var $dTk3A = parcelRequire("dTk3A");

var $6F6hl = parcelRequire("6F6hl");
const $b67362102deb1f23$export$1eee5ddc4f6d41c5 = 400;
const $b67362102deb1f23$var$defaultFlagGroupContext = {
    onDismissed: (0, $ee7An.default),
    isDismissAllowed: false
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $b67362102deb1f23$export$c57ba665aaa722be = /*#__PURE__*/ (0, $gwFzn.createContext)($b67362102deb1f23$var$defaultFlagGroupContext); // eslint-disable-next-line @repo/internal/react/require-jsdoc
function $b67362102deb1f23$export$e91ea202abb66350() {
    return (0, $gwFzn.useContext)($b67362102deb1f23$export$c57ba665aaa722be);
} // transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $b67362102deb1f23$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
}; // Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $b67362102deb1f23$var$dismissAllowedStyles = null;
const $b67362102deb1f23$var$flagGroupContainerStyles = null; /**
                                        * __Flag group__
                                        *
                                        * A flag group is used to group a set of related flags, with entry and exit animations.
                                        *
                                        * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
                                        * - [Code](https://atlassian.design/components/flag/flag-group/code)
                                        */ 
const $b67362102deb1f23$var$FlagGroup = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $ee7An.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $gwFzn.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $gwFzn.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h3cbw.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $35pXk.default)([
                            $b67362102deb1f23$var$groupStyles.root,
                            index === 0 && $b67362102deb1f23$var$groupStyles.first,
                            index === 1 && $b67362102deb1f23$var$groupStyles.second,
                            index >= 1 && $b67362102deb1f23$var$groupStyles.nth,
                            index >= 2 && $b67362102deb1f23$var$groupStyles.hidden,
                            isDismissAllowed && "_12a7luct",
                            className
                        ]),
                        ref: ref,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)($b67362102deb1f23$export$c57ba665aaa722be.Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : $b67362102deb1f23$var$defaultFlagGroupContext,
                            children: flag
                        })
                    })
            });
        }) : false;
    };
    const flags = /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        id: id,
        className: (0, $35pXk.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6F6hl.default), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(LabelTag, {
                    children: label
                })
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g9Srd.default), {
                appear: false,
                children: renderChildren()
            })
        ]
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $caX7N.default), {
        zIndex: (0, $dTk3A.layers).flag(),
        children: flags
    });
};
var $b67362102deb1f23$export$2e2bcd8739ae039 = $b67362102deb1f23$var$FlagGroup;

});
parcelRegister("h3cbw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e228db1926f0e35$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gZTYb = parcelRequire("gZTYb");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ const $8e228db1926f0e35$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, fade: fade = 'none', duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gZTYb.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
var $8e228db1926f0e35$export$2e2bcd8739ae039 = $8e228db1926f0e35$var$SlideIn;

});


parcelRegister("dPscY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c61e4adb052f9c6$export$2e2bcd8739ae039);
/* dismiss-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1jfCH = parcelRequire("1jfCH");

var $hDEQG = parcelRequire("hDEQG");

var $6UNpq = parcelRequire("6UNpq");

var $fVUfS = parcelRequire("fVUfS");

var $f9ZC9 = parcelRequire("f9ZC9");
const $5c61e4adb052f9c6$var$styles = {
    button: "_16jlidpf _1o9zidpf _i0dl1wug _1dqoglyw _1e0c1txw _1bsb1tcg _4t3i1tcg _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4cvr1h6o _1bah1h6o _80omtlke _o5721q9c"
};
const $5c61e4adb052f9c6$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($1jfCH)));
    let buttonLabel = 'Dismiss';
    let size = 'small';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($6UNpq))) : (0, (/*@__PURE__*/$parcel$interopDefault($hDEQG)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        size = 'medium';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        xcss: $5c61e4adb052f9c6$var$styles.button,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            background: 'none'
        },
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId,
        "aria-label": buttonLabel,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)(ButtonIcon, {
            label: "",
            LEGACY_size: size,
            LEGACY_primaryColor: (0, $f9ZC9.flagTextColorToken)[appearance],
            color: (0, $f9ZC9.flagTextColorToken)[appearance]
        })
    });
};
const $5c61e4adb052f9c6$var$DismissButton = /*#__PURE__*/ (0, $gwFzn.memo)($5c61e4adb052f9c6$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5c61e4adb052f9c6$export$2e2bcd8739ae039 = $5c61e4adb052f9c6$var$DismissButton;

});
parcelRegister("hDEQG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d03c6653983b99c648f0774c0bc3810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd75c3e8622fec82$var$_react = $cd75c3e8622fec82$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $cd75c3e8622fec82$var$_chevronDown = $cd75c3e8622fec82$var$_interopRequireDefault((parcelRequire("6kv9e")));

var $cd75c3e8622fec82$var$_chevronDown2 = $cd75c3e8622fec82$var$_interopRequireDefault((parcelRequire("3rvkR")));
function $cd75c3e8622fec82$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cd75c3e8622fec82$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $cd75c3e8622fec82$var$_react.default.createElement($cd75c3e8622fec82$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $cd75c3e8622fec82$var$_chevronDown2.default
    }, props));
$cd75c3e8622fec82$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $cd75c3e8622fec82$var$_default = module.exports.default = $cd75c3e8622fec82$var$ChevronDownIcon;

});
parcelRegister("3rvkR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $281c3349a3aa0728$var$_react = $281c3349a3aa0728$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $281c3349a3aa0728$var$_chevronDown = $281c3349a3aa0728$var$_interopRequireDefault((parcelRequire("ghftu")));
function $281c3349a3aa0728$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $281c3349a3aa0728$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $281c3349a3aa0728$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $281c3349a3aa0728$var$_chevronDown.default
    }));
$281c3349a3aa0728$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $281c3349a3aa0728$var$_default = module.exports.default = $281c3349a3aa0728$var$HipchatChevronDownIcon;

});


parcelRegister("6UNpq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c9bd6be3e7327013ae0b836bac300b8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $508e4ca1498459a4$var$_react = $508e4ca1498459a4$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $508e4ca1498459a4$var$_chevronUp = $508e4ca1498459a4$var$_interopRequireDefault((parcelRequire("gcvXg")));

var $508e4ca1498459a4$var$_chevronUp2 = $508e4ca1498459a4$var$_interopRequireDefault((parcelRequire("lj1Sg")));
function $508e4ca1498459a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronUpIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $508e4ca1498459a4$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $508e4ca1498459a4$var$_react.default.createElement($508e4ca1498459a4$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $508e4ca1498459a4$var$_chevronUp2.default
    }, props));
$508e4ca1498459a4$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $508e4ca1498459a4$var$_default = module.exports.default = $508e4ca1498459a4$var$ChevronUpIcon;

});
parcelRegister("gcvXg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afcaa915720f5b4d9e69ee6ef0943c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bcb68de3780bf6d1$var$_react = $bcb68de3780bf6d1$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $bcb68de3780bf6d1$var$_baseNew = $bcb68de3780bf6d1$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bcb68de3780bf6d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bcb68de3780bf6d1$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $bcb68de3780bf6d1$var$_react.default.createElement($bcb68de3780bf6d1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 4.06 2.03 8.03.97 6.97l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5-1.06 1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$bcb68de3780bf6d1$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $bcb68de3780bf6d1$var$_default = module.exports.default = $bcb68de3780bf6d1$var$ChevronUpIcon;

});

parcelRegister("lj1Sg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f82cd384519fde1f$var$_react = $f82cd384519fde1f$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $f82cd384519fde1f$var$_chevronUp = $f82cd384519fde1f$var$_interopRequireDefault((parcelRequire("2AytZ")));
function $f82cd384519fde1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f82cd384519fde1f$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $f82cd384519fde1f$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $f82cd384519fde1f$var$_chevronUp.default
    }));
$f82cd384519fde1f$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $f82cd384519fde1f$var$_default = module.exports.default = $f82cd384519fde1f$var$HipchatChevronUpIcon;

});
parcelRegister("2AytZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::384cf900fa5e1e265919ad6f422b5c61>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e29b122ed40dfe9$var$_react = $1e29b122ed40dfe9$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $1e29b122ed40dfe9$var$_baseNew = $1e29b122ed40dfe9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1e29b122ed40dfe9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1e29b122ed40dfe9$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $1e29b122ed40dfe9$var$_react.default.createElement($1e29b122ed40dfe9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$1e29b122ed40dfe9$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $1e29b122ed40dfe9$var$_default = module.exports.default = $1e29b122ed40dfe9$var$ChevronUpIcon;

});




parcelRegister("357kL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf4348f0ae69e93$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $g9Srd = parcelRequire("g9Srd");
var $fT2ta = parcelRequire("fT2ta");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");
const $9bf4348f0ae69e93$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
const $9bf4348f0ae69e93$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $9bf4348f0ae69e93$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g9Srd.default), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fT2ta.default), {
                children: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: $9bf4348f0ae69e93$var$styles.container,
                        ...props,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eyWa4.default), {
                            space: "space.100",
                            children: children
                        })
                    })
            })
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9bf4348f0ae69e93$export$2e2bcd8739ae039 = $9bf4348f0ae69e93$var$Expander;

});



parcelRegister("gqqjz", function(module, exports) {

$parcel$export(module.exports, "FlagsStateContainer", () => $d20d6e16f6c11b99$export$4ce3626a8d59c88d);

var $ipPpS = parcelRequire("ipPpS");
class $d20d6e16f6c11b99$export$4ce3626a8d59c88d extends (0, $ipPpS.Container) {
    constructor(_flags){
        super();
        this.previousShowFlag = void 0;
        this.showMultipleFlags = (flags)=>this.setState(({ nextFlagId: nextFlagId })=>{
                const newFlags = flags.map((flag)=>({
                        ...flag,
                        id: nextFlagId++
                    }));
                return {
                    flags: newFlags,
                    nextFlagId: nextFlagId
                };
            });
        this.showFlag = (flag)=>{
            const updateFlagState = ()=>{
                let newFlag;
                const setStateCallback = ()=>{
                    return this.setState(({ flags: flags, nextFlagId: nextFlagId })=>{
                        const equalsFlag = (testFlag)=>testFlag.id === flag.id;
                        if (flags.some(equalsFlag)) {
                            const newFlags = flags.map((testFlag)=>equalsFlag(testFlag) ? flag : testFlag);
                            return {
                                flags: newFlags,
                                nextFlagId: nextFlagId
                            };
                        }
                        newFlag = {
                            ...flag,
                            id: flag.id || nextFlagId
                        };
                        return {
                            flags: [
                                newFlag,
                                ...flags
                            ],
                            nextFlagId: nextFlagId + 1
                        };
                    });
                };
                return new Promise((resolve)=>{
                    setStateCallback();
                    resolve(newFlag);
                }).then(()=>newFlag);
            };
            const delay = ()=>new Promise((resolve)=>{
                    // Timeout protects against visual bug caused by
                    // race condition from concurrent executions of this function.
                    setTimeout(resolve, 500);
                });
            if (this.previousShowFlag) {
                const result = this.previousShowFlag.then(updateFlagState);
                this.previousShowFlag = delay();
                return result;
            } else {
                this.previousShowFlag = delay();
                return updateFlagState();
            }
        };
        this.updateFlag = (id, patch)=>this.setState((state)=>{
                // Ensure we create new instance of both updated flag and of an entire flags array,
                // and retain the order of the flags in the array.
                // Avoid direct mutation of flag and array as it may cause bugs when rendering flags.
                const flags = [
                    ...state.flags
                ];
                for(let index = 0; index < flags.length; index++){
                    const flag = flags[index];
                    if (flag.id === id) flags[index] = {
                        ...flag,
                        ...patch
                    };
                }
                return {
                    flags: flags
                };
            });
        this.hideFlag = (id)=>this.setState((state)=>({
                    flags: state.flags.filter((flag)=>flag.id !== id)
                }));
        /**
     * Hides all active flags but the ones which have explicitly been marked with
     * `close: "never"` - these have been marked explicitly, because an
     * undesireable interaction with existing `hideAllFlags()` calls was observed.
     */ this.hideAllFlags = ()=>this.setState((state)=>({
                    flags: state.flags.filter((flag)=>flag.close === 'never')
                }));
        // Allows for setting whether the flags should be visually hidden or shown in the UI
        this.setFlagsVisibility = (areFlagsVisible)=>this.setState({
                areFlagsVisible: areFlagsVisible
            });
        this.showFlagOfType = (type)=>({ id: id, title: title, description: description, actions: actions, onClose: onClose, isAutoDismiss: isAutoDismiss, customIcon: customIcon, appearance: appearance, delayAnnouncement: delayAnnouncement })=>this.showFlag({
                    id: id,
                    type: type,
                    title: title,
                    description: description,
                    actions: actions,
                    onClose: onClose,
                    close: isAutoDismiss ? 'auto' : undefined,
                    customIcon: customIcon,
                    appearance: appearance,
                    delayAnnouncement: delayAnnouncement
                });
        this.showSuccessFlag = this.showFlagOfType('success');
        this.showSuccessCircleFlag = this.showFlagOfType('success-circle');
        this.showInfoFlag = this.showFlagOfType('info');
        this.showCustomFlag = this.showFlagOfType('custom');
        this.showWarningFlag = this.showFlagOfType('warning');
        this.showErrorFlag = this.showFlagOfType('error');
        this.previousShowFlag = null;
        this.state = {
            flags: _flags || [],
            nextFlagId: _flags ? _flags.length : 0,
            areFlagsVisible: true
        };
    }
}

});

parcelRegister("3jwuS", function(module, exports) {

$parcel$export(module.exports, "useIsCurrentPageLive", () => $5e7dba3a8b909406$export$e251530099f9a5aa);

var $efvKr = parcelRequire("efvKr");

var $eNbbn = parcelRequire("eNbbn");
const $5e7dba3a8b909406$export$e251530099f9a5aa = ()=>{
    const [isLiveClientside] = (0, $efvKr.useIsCurrentPageLiveRaw)();
    const { isTypeKnown: isSSRKnown, isLive: isLiveSSR } = (0, $eNbbn.useLivePageSSRStatus)();
    // Use SSR value if we know we're in SSR mode, otherwise fall back to client-side store value
    return isSSRKnown ? !!isLiveSSR : isLiveClientside;
};

});
parcelRegister("efvKr", function(module, exports) {

$parcel$export(module.exports, "useIsCurrentPageLiveRaw", () => $686b59ca96a4b29b$export$bf6645c1c39d60e9);
$parcel$export(module.exports, "useLivePageStoreActions", () => $686b59ca96a4b29b$export$2b0a7d308d70bcce);
$parcel$export(module.exports, "useLivePageMode", () => $686b59ca96a4b29b$export$4b142161af17c82a);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $686b59ca96a4b29b$var$initialState = {
    isLive: false,
    mode: undefined
};
// Action creators
/**
 * Switches the live status of the page to control whether the page is currently live or not.
 * @param isLive - A boolean indicating the desired live status of the page. Accepts:
 *                 - `true`: The page is live.
 *                 - `false`: The page is not live.
 */ const $686b59ca96a4b29b$var$setIsLive = (isLive)=>({ setState: setState })=>{
        setState({
            isLive: isLive
        });
    };
/**
 * Switches the page mode to control how users see a live page: 'view' mode for a read only view,
 * and 'edit' mode to allow a user to make changes to the page.
 *
 * @param mode - The desired mode for the page. Accepts:
 *               - 'view': Users can only view content.
 *               - 'edit': Users can modify the content.
 */ const $686b59ca96a4b29b$var$setMode = (mode)=>({ setState: setState })=>{
        setState({
            mode: mode
        });
    };
const $686b59ca96a4b29b$var$actions = {
    setIsLive: $686b59ca96a4b29b$var$setIsLive,
    setMode: $686b59ca96a4b29b$var$setMode
};
// Store creation
const $686b59ca96a4b29b$var$LivePagesStore = (0, $4ZoIm.createStore)({
    initialState: $686b59ca96a4b29b$var$initialState,
    actions: $686b59ca96a4b29b$var$actions,
    name: 'live-pages-store'
});
// Selectors
const $686b59ca96a4b29b$var$selectIsLive = (state)=>state.isLive;
const $686b59ca96a4b29b$var$selectMode = (state)=>({
        mode: state.mode,
        isEditMode: state.mode === 'edit',
        isViewMode: state.mode === 'view'
    });
const $686b59ca96a4b29b$export$bf6645c1c39d60e9 = (0, $iFWZA.createHook)($686b59ca96a4b29b$var$LivePagesStore, {
    selector: $686b59ca96a4b29b$var$selectIsLive
});
const $686b59ca96a4b29b$export$2b0a7d308d70bcce = (0, $iFWZA.createActionsHook)($686b59ca96a4b29b$var$LivePagesStore);
const $686b59ca96a4b29b$export$4b142161af17c82a = (0, $iFWZA.createHook)($686b59ca96a4b29b$var$LivePagesStore, {
    selector: $686b59ca96a4b29b$var$selectMode
});
const $686b59ca96a4b29b$export$2bf92e65e8a188f0 = (0, $iFWZA.createHook)($686b59ca96a4b29b$var$LivePagesStore);

});

parcelRegister("eNbbn", function(module, exports) {

$parcel$export(module.exports, "useLivePageSSRStatus", () => $b55b7feb878ccd35$export$1ba073176000cd58);

const $b55b7feb878ccd35$export$1ba073176000cd58 = ()=>{
    if (window.__SSR_RENDERED__ && window.__SSR_IS_LIVE_PAGE__ !== undefined) return {
        isLive: window.__SSR_IS_LIVE_PAGE__,
        isTypeKnown: true
    };
    return {
        isLive: undefined,
        isTypeKnown: false
    };
};

});


parcelRegister("gTyTP", function(module, exports) {

$parcel$export(module.exports, "LIVE_DOC_GA_EXP_TRAIT_NAME", () => $994775cb6427bea0$export$1e0344ddce81a796);
$parcel$export(module.exports, "LivePageReleasePhase", () => $994775cb6427bea0$export$32d761c7795593f9);
$parcel$export(module.exports, "useIsLivePagesFeatureEnabled", () => $994775cb6427bea0$export$d9b2df506ebad5d5);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $9wGTI = parcelRequire("9wGTI");

var $1ytiN = parcelRequire("1ytiN");
// TAP trait name and values
const $994775cb6427bea0$var$LIVE_EDIT_AB_TEST_TRAIT_NAME = 'confluence_live_page_opt_in';
const $994775cb6427bea0$var$LIVE_EDIT_AB_TEST_OPTED_IN_VALUE = 'experiment_opted_in';
const $994775cb6427bea0$var$LIVE_EDIT_AB_TEST_OPTED_OUT_VALUE = 'experiment_opted_out';
const $994775cb6427bea0$var$LIVE_PAGES_BETA_TRAIT_NAME = 'confluence_live_pages_beta';
const $994775cb6427bea0$var$LIVE_PAGES_BETA_DEFAULT_ON_VALUE = 'beta-default-on';
const $994775cb6427bea0$var$LIVE_PAGES_BETA_DEFAULT_OFF_VALUE = 'beta-default-off';
const $994775cb6427bea0$export$1e0344ddce81a796 = 'confluence_modernize';
const $994775cb6427bea0$var$LIVE_DOC_GA_EXP_TEST_GROUP_VALUE = 'exp-test';
const $994775cb6427bea0$var$LIVE_DOC_GA_EXP_CONTROL_GROUP_VALUE = 'exp-control';
var $994775cb6427bea0$export$32d761c7795593f9 = /*#__PURE__*/ function(LivePageReleasePhase) {
    LivePageReleasePhase["NOT_ENABLED"] = "not_enabled";
    LivePageReleasePhase["AB_TEST_OPTED_IN"] = "ab_test_opted_in";
    LivePageReleasePhase["AB_TEST_OPTED_OUT"] = "ab_test_opted_out";
    LivePageReleasePhase["OPEN_BETA_INITIAL"] = "open_beta_initial";
    LivePageReleasePhase["OPEN_BETA_DEFAULT_ON"] = "open_beta_default_on";
    LivePageReleasePhase["OPEN_BETA_DEFAULT_OFF"] = "open_beta_default_off";
    LivePageReleasePhase["MODERNIZATION_GA_EXP_TEST"] = "modernization_ga_exp_test";
    LivePageReleasePhase["MODERNIZATION_GA_EXP_CONTROL"] = "modernization_ga_exp_control";
    return LivePageReleasePhase;
}({});
const $994775cb6427bea0$var$RELEASE_PHASES_WITH_FEATURE_ENABLED = [
    "ab_test_opted_in",
    "open_beta_default_on",
    "open_beta_default_off",
    "modernization_ga_exp_test"
];
// TODO: Cleanup
const $994775cb6427bea0$var$RELEASE_PHASES_WITH_TWO_PAGE_TYPES_EXPERIENCE = [
    "open_beta_default_on",
    "open_beta_default_off",
    "modernization_ga_exp_test"
];
const $994775cb6427bea0$var$useLivePageReleasePhase = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { experimentFeatures: experimentFeatures, loading: isSPAViewContextLoading } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    (0, $gwFzn.useEffect)(()=>{
        if (isSPAViewContextLoading) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'traitValueLoading',
                actionSubject: 'useLivePageReleasePhase',
                source: 'useLivePageReleasePhase'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSPAViewContextLoading
    ]);
    let openBetaTraitValue;
    let abTestTraitValue;
    let modernizationGaTraitValue;
    try {
        const parsedExperimentFeatures = JSON.parse(experimentFeatures);
        if (typeof parsedExperimentFeatures === 'object') ({ [$994775cb6427bea0$var$LIVE_PAGES_BETA_TRAIT_NAME]: openBetaTraitValue, [$994775cb6427bea0$var$LIVE_EDIT_AB_TEST_TRAIT_NAME]: abTestTraitValue, [$994775cb6427bea0$export$1e0344ddce81a796]: modernizationGaTraitValue } = parsedExperimentFeatures);
    } catch (e) {
        openBetaTraitValue = null;
        abTestTraitValue = null;
        modernizationGaTraitValue = null;
    }
    // Modernization GA release phase
    /**
	 * Tenants are enrolled once they land in confluence.
	 *
	 * Tenants already in open beta or release tracks will not be part of the GA experiment.
	 * All other tenants will be split 50/50 between the test and control groups.
	 *
	 * Only the test group will have the modernization ga experience.
	 */ if (modernizationGaTraitValue === $994775cb6427bea0$var$LIVE_DOC_GA_EXP_TEST_GROUP_VALUE) return "modernization_ga_exp_test";
    else if (modernizationGaTraitValue === $994775cb6427bea0$var$LIVE_DOC_GA_EXP_CONTROL_GROUP_VALUE) return "modernization_ga_exp_control";
    // Open Beta release phase
    /**
	 * `confluence_live_pages_open_beta` - Tells us that the tenant has been added to open beta. It allows the tenant to opt into the ope beta experience.
	 * This does not guarantee that the tenant has opted in. This is NOT a kill switch for the open beta experience. Once set to true, it cannot be set to false.
	 * `confluence_live_pages_open_beta_trait_opted_in` - Set to true when the tenant opts into the open beta experience. Will stay true even if the tenant opts out of the open beta experience.
	 * The meaning of this gate is that live docs are enabled for the tenant.
	 *
	 * The main trait value can have three states: null, beta-default-on, beta-default-off.
	 * 	- `null`: The tenant is not in open beta or has not yet opted into the open beta experience.
	 * 	- `beta-default-on`: The tenant has opted into the open beta experience and live docs are available
	 * 	- `beta-default-off`: The tenant has previously opted in and then opted out of the open beta experience.
	 * Live docs are still available but space settings have live docs turned off by default. User can still turn live docs back on in space settings.
	 *
	 * `confluence_live_pages_open_beta_trait_opted_in` is an abstraction of the trait value where it is true when the trait value is either `beta-default-on` or `beta-default-off`.
	 *
	 * We check both the fg and trait value to ensure the phase returned is accurate. Sometimes the feature gate fails to get the correct value.
	 * Currently, customers do not have the ability to opt out or completely opt out of the open beta experience once they have opted in.
	 * https://hello.atlassian.net/wiki/spaces/PCG/pages/4415395121/Live+Pages+Open+Beta+Feature+Gate+Approach
	 */ if (openBetaTraitValue === $994775cb6427bea0$var$LIVE_PAGES_BETA_DEFAULT_ON_VALUE || (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') // we can assume that the tenant has opted in if the gate is true, opt out is not possible at the moment.
    ) return "open_beta_default_on";
    else if (openBetaTraitValue === $994775cb6427bea0$var$LIVE_PAGES_BETA_DEFAULT_OFF_VALUE) return "open_beta_default_off";
    else if ((0, $9wGTI.fg)('confluence_live_pages_open_beta')) return "open_beta_initial";
    // AB testing release phase
    /**
	 * Evaluating both feature gate and trait value here because:
	 *
	 * Feature gate value is available faster but may not always have the most up to date value.
	 * There is some latency between updating the tenant trait and then updating statsig feature gate.
	 * Checking the trait value will get the most recent value before statsig feature gate does so if the tenant opts in recently we will get the correct value quicker.
	 *
	 * For AB testing, frontend care more about getting the correct opt in status because sites are opted in through Landing process,
	 * 	where opt out is through manual process and user is informed by the UI that manual opt in/ opt out status change may take time to apply.
	 *
	 */ if (abTestTraitValue === $994775cb6427bea0$var$LIVE_EDIT_AB_TEST_OPTED_IN_VALUE || (0, $9wGTI.fg)('confluence_live_pages_ab_test_opted_in')) return "ab_test_opted_in";
    if (abTestTraitValue === $994775cb6427bea0$var$LIVE_EDIT_AB_TEST_OPTED_OUT_VALUE) return "ab_test_opted_out";
    // Default
    return "not_enabled";
};
const $994775cb6427bea0$export$d9b2df506ebad5d5 = ()=>{
    const phase = $994775cb6427bea0$var$useLivePageReleasePhase();
    return {
        isLivePagesFeatureEnabled: $994775cb6427bea0$var$RELEASE_PHASES_WITH_FEATURE_ENABLED.includes(phase),
        isTwoPageTypesExperience: $994775cb6427bea0$var$RELEASE_PHASES_WITH_TWO_PAGE_TYPES_EXPERIENCE.includes(phase),
        livePageReleasePhase: phase
    };
};

});
parcelRegister("1ytiN", function(module, exports) {

$parcel$export(module.exports, "SPAViewContext", () => $a659e2987d622809$export$c0090315433886dc);
$parcel$export(module.exports, "SPAViewContextProvider", () => $a659e2987d622809$export$10a1885560a2fd1d);

var $gwFzn = parcelRequire("gwFzn");

var $xQxzY = parcelRequire("xQxzY");

var $7Sm4c = parcelRequire("7Sm4c");

var $5ZqQS = parcelRequire("5ZqQS");

var $1uFM6 = parcelRequire("1uFM6");

var $gFHOP = parcelRequire("gFHOP");

var $e1GUi = parcelRequire("e1GUi");
const $a659e2987d622809$export$2fba198b5b2e37fa = {
    tenantId: '',
    isNewUser: false,
    userCanCreateContent: false,
    isAnonymous: false,
    siteLogoUrl: '',
    siteTitle: '',
    showSiteTitle: false,
    homepageUri: '',
    homepageTitle: '',
    companyHubName: '',
    frontCoverState: '',
    experimentFeatures: '',
    abTestCohorts: '',
    isSiteAdmin: false,
    loading: true
};
const $a659e2987d622809$export$c0090315433886dc = /*#__PURE__*/ (0, $gwFzn.createContext)($a659e2987d622809$export$2fba198b5b2e37fa);
const $a659e2987d622809$export$10a1885560a2fd1d = /*#__PURE__*/ (0, $gwFzn.memo)(({ children: children })=>{
    const isSiteInformationQueryEnabled = // @ts-ignore
    window['__ENABLE_SITE_INFORMATION_QUERY__'] || false;
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    isSiteInformationQueryEnabled ? (0, $gFHOP.SiteInformationQuery) : (0, $e1GUi.SPAViewContextQuery));
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: 'backbone'
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    // The context will fallback to default if any error happens
    const context = (0, $gwFzn.useMemo)(()=>({
            ...data ? $a659e2987d622809$export$3ceb62baab058c6b(data) : $a659e2987d622809$export$2fba198b5b2e37fa,
            loading: loading,
            error: error
        }), [
        loading,
        error,
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($a659e2987d622809$export$c0090315433886dc.Provider, {
        value: context
    }, children);
});
const $a659e2987d622809$export$3ceb62baab058c6b = (data)=>{
    const { isSiteAdmin: isSiteAdmin, abTestCohorts: abTestCohorts, experimentFeatures: experimentFeatures, userCanCreateContent: userCanCreateContent, isNewUser: isNewUser } = data;
    const { uri: homepageUri, title: homepageTitle } = data?.siteSettings?.homepage || {};
    const { isAnonymous: isAnonymous } = data?.currentConfluenceUser || {};
    const { logoUrl: siteLogoUrl } = data?.siteDescription || {};
    const { siteTitle: siteTitle } = data?.siteSettings || {};
    const { showApplicationTitle: showSiteTitle, companyHubName: companyHubName } = data?.siteSettings || {};
    const { frontCoverState: frontCoverState } = data?.siteSettings?.frontCover || {};
    const tenantId = data?.tenant?.cloudId;
    const contextData = {
        tenantId: tenantId,
        isNewUser: isNewUser,
        userCanCreateContent: userCanCreateContent,
        isAnonymous: isAnonymous,
        siteLogoUrl: siteLogoUrl,
        siteTitle: siteTitle,
        showSiteTitle: showSiteTitle,
        homepageUri: homepageUri,
        frontCoverState: frontCoverState,
        companyHubName: companyHubName,
        homepageTitle: homepageTitle,
        experimentFeatures: experimentFeatures,
        abTestCohorts: abTestCohorts,
        isSiteAdmin: isSiteAdmin,
        loading: false
    };
    // replace null values from query data with default values
    for (const [key, value] of Object.entries(contextData))if (value === null || value === undefined) contextData[key] = $a659e2987d622809$export$2fba198b5b2e37fa[key];
    return contextData;
};

});


parcelRegister("euL71", function(module, exports) {

$parcel$export(module.exports, "ConfluenceEdition", () => $51adb6f8b97e4ad9$export$68577d543b14ae02);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $51adb6f8b97e4ad9$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});

});

parcelRegister("5jrGM", function(module, exports) {

$parcel$export(module.exports, "ScreenQuery", () => $3de43490561dba32$export$b02c0b814e843e71);

var $d2LG0 = parcelRequire("d2LG0");
const $3de43490561dba32$export$b02c0b814e843e71 = (0, $d2LG0.default)`query ScreenQuery($spaceKey:String!){space(key:$spaceKey){id homepage{id}}}`;

});

parcelRegister("cvj7x", function(module, exports) {

$parcel$export(module.exports, "preloadEditorData", () => $c13994d6914d469f$export$1149cf9041c3e7b8);

var $9wGTI = parcelRequire("9wGTI");

var $7W8i8 = parcelRequire("7W8i8");

var $65pdw = parcelRequire("65pdw");

var $1TElT = parcelRequire("1TElT");

var $3cpum = parcelRequire("3cpum");

var $7PLO8 = parcelRequire("7PLO8");

var $irrTO = parcelRequire("irrTO");
parcelRequire("kGDoD");
var $9nGwZ = parcelRequire("9nGwZ");

var $1c0dB = parcelRequire("1c0dB");

var $kDt9L = parcelRequire("kDt9L");

var $4vyfK = parcelRequire("4vyfK");
parcelRequire("bth99");
var $cRQNp = parcelRequire("cRQNp");

var $eSLr0 = parcelRequire("eSLr0");

var $8CHHT = parcelRequire("8CHHT");

var $7Ndnw = parcelRequire("7Ndnw");

var $9OYfw = parcelRequire("9OYfw");
const $c13994d6914d469f$var$logger = (0, $7W8i8.getLogger)('load-edit-page');
async function $c13994d6914d469f$export$1149cf9041c3e7b8({ spaceKey: spaceKey, userId: userId, contentId: contentId, shouldPreloadMentionsProvider: shouldPreloadMentionsProvider = false, useCache: useCache = false, catchFn: // use cache for native editor data
catchFn, isLivePage: isLivePage = false }) {
    // note: explicitly casting to Promise<any> to avoid typescript incorrectly inferring tuple types; although we don't use the return value of this function regardless
    $c13994d6914d469f$var$logger.debug`Calling preloadEditorData ${performance.now() / 1000}`;
    const draftShareId = (0, $7PLO8.getDraftShareIdFromQueryParam)();
    // preload queries shared by Synchrony and Native Collab editors
    const immediateResultsPromises = [
        (0, $irrTO.preloadDraftContentAppearance)(contentId, useCache)
    ];
    // specific native collab editor queries
    if (!!contentId) {
        immediateResultsPromises.push((0, $9OYfw.preloadCollabDraftContent)(contentId, draftShareId, useCache));
        immediateResultsPromises.push((0, $1TElT.preloadEmojiTitle)(contentId, draftShareId, useCache), (0, $9OYfw.preloadNativeCollab)(contentId, draftShareId, useCache), (0, $9OYfw.preloadNativeCollabProvider)({
            accountId: userId,
            useCache: useCache,
            shouldIncludePermissionType: (0, $9wGTI.fg)('confluence_team_presence_general_availability')
        }));
    }
    immediateResultsPromises.push((0, $65pdw.preloadEditorPageCoverPicture)(contentId, draftShareId, useCache), (0, $3cpum.preloadEditorContentState)({
        contentId: contentId,
        useCache: useCache,
        shouldGetDraftVersion: !isLivePage
    }));
    if (isLivePage) {
        // Pre-loading apps in the byline area for live pages. Currently only live pages have extension point apps and not classic editor.
        immediateResultsPromises.push((0, $4vyfK.preloadWebItemLocation)({
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
        }), // For some reason the addition of the filter (uses new Forge query) is causing SSR to timeout - workaround by skipping the filter
        (0, $8CHHT.preloadUseExtensionList)({
            spaceKey: spaceKey || '',
            moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE),
            skipFilter: true
        }));
        if ((0, $9wGTI.fg)('confluence_frontend_preload_last_updated')) immediateResultsPromises.push((0, $9nGwZ.preloadLastUpdated)(contentId, useCache));
        if ((0, $9wGTI.fg)('live_pages_byline_read_time')) immediateResultsPromises.push((0, $cRQNp.preloadReadTime)(contentId, useCache));
    }
    if (shouldPreloadMentionsProvider) immediateResultsPromises.push((0, $kDt9L.preloadMentionsProvider)());
    immediateResultsPromises.push((0, $1c0dB.preloadEditorPageTitleContentProperties)({
        contentId: contentId,
        draftShareId: draftShareId,
        useCache: useCache
    }));
    await Promise.all(immediateResultsPromises.map((p)=>!!catchFn ? p?.catch(catchFn) : p));
    $c13994d6914d469f$var$logger.debug`preloadEditorData complete ${performance.now() / 1000}`;
}

});
parcelRegister("65pdw", function(module, exports) {

$parcel$export(module.exports, "preloadEditorPageCoverPicture", () => $4e9d3c2f55d09139$export$cca2a63dd6cc6345);

var $dYU3e = parcelRequire("dYU3e");

var $gr7Mm = parcelRequire("gr7Mm");
function $4e9d3c2f55d09139$export$cca2a63dd6cc6345(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $gr7Mm.CoverPictureQuery),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: draftShareId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}

});
parcelRegister("gr7Mm", function(module, exports) {

$parcel$export(module.exports, "CoverPictureQuery", () => $34fb18e1eff4cb9b$export$32667dced0d2dcef);

var $d2LG0 = parcelRequire("d2LG0");
const $34fb18e1eff4cb9b$export$32667dced0d2dcef = (0, $d2LG0.default)`query CoverPictureQuery($contentId:ID$status:[String]$draftShareId:String){content(id:$contentId draftShareId:$draftShareId status:$status){nodes{id properties(keys:["cover-picture-id-draft" "cover-picture-id-published"]){nodes{id key value version{number}}}}}}`;

});


parcelRegister("1TElT", function(module, exports) {

$parcel$export(module.exports, "preloadEmojiTitle", () => $0272cf4ae0232c26$export$a9fe7043b42a1476);

var $dYU3e = parcelRequire("dYU3e");

var $87Z8O = parcelRequire("87Z8O");
const $0272cf4ae0232c26$export$a9fe7043b42a1476 = (contentId, draftShareId, useCache)=>{
    return (0, $dYU3e.query)({
        query: (0, $87Z8O.getEmojiTitleProperty),
        variables: {
            contentId: contentId,
            draftShareId: draftShareId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};

});
parcelRegister("87Z8O", function(module, exports) {

$parcel$export(module.exports, "getEmojiTitleProperty", () => $30f101ece1f63b68$export$a6ac8a3b189818d7);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $30f101ece1f63b68$export$a6ac8a3b189818d7 = (0, $d2LG0.default)`query getEmojiTitlePropertyQuery($contentId:ID$status:[String]$draftShareId:String$skipPublishedFragment:Boolean!){content(id:$contentId draftShareId:$draftShareId status:$status){nodes{id emojiTitlePublished:properties(key:"emoji-title-published")@skip(if:$skipPublishedFragment){nodes{id key value version{number}}}emojiTitleDraft:properties(key:"emoji-title-draft"){nodes{id key value version{number}}}contentProperties{latest{defaultTitleEmoji}}}}}`;

});


parcelRegister("3cpum", function(module, exports) {

$parcel$export(module.exports, "preloadEditorContentState", () => $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0);

var $dYU3e = parcelRequire("dYU3e");

var $bd27Q = parcelRequire("bd27Q");
function $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0({ contentId: contentId, useCache: useCache, shouldGetDraftVersion: shouldGetDraftVersion }) {
    return (0, $dYU3e.query)({
        query: (0, $bd27Q.EditorContentStateQuery),
        variables: {
            contentId: contentId,
            isDraft: shouldGetDraftVersion
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}

});
parcelRegister("bd27Q", function(module, exports) {

$parcel$export(module.exports, "EditorContentStateQuery", () => $aea79842a038b4f9$export$c33c26637710a569);

var $d2LG0 = parcelRequire("d2LG0");
const $aea79842a038b4f9$export$c33c26637710a569 = (0, $d2LG0.default)`query EditorContentStateQuery($contentId:ID!$isDraft:Boolean!){singleContent(id:$contentId){id contentState(isDraft:$isDraft){id name color restrictionLevel isCallerPermitted}contentStateLastUpdated(format:USER_FRIENDLY)@skip(if:$isDraft){value}}availableContentStates(contentId:$contentId){customContentStates{name color id}spaceContentStates{name color id restrictionLevel}}}`;

});


parcelRegister("7PLO8", function(module, exports) {

$parcel$export(module.exports, "getDraftShareIdFromQueryParam", () => $3009aa09d1bfedbe$export$93a0fdadbf6c055a);
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};

});

parcelRegister("irrTO", function(module, exports) {

$parcel$export(module.exports, "preloadDraftContentAppearance", () => $e1546bd447729439$export$f4a1f447ac6a7a9a);

var $dYU3e = parcelRequire("dYU3e");

var $lztxY = parcelRequire("lztxY");
const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        query: (0, $lztxY.getDraftContentAppearanceProperty),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};

});
parcelRegister("lztxY", function(module, exports) {

$parcel$export(module.exports, "getDraftContentAppearanceProperty", () => $3b0f8352614b0ede$export$abc0031a08dd95cf);
$parcel$export(module.exports, "getPublishedContentAppearanceProperty", () => $3b0f8352614b0ede$export$aed0dcf8ce9eb36);

var $d2LG0 = parcelRequire("d2LG0");
const $3b0f8352614b0ede$export$abc0031a08dd95cf = (0, $d2LG0.default)`query getDraftContentAppearanceProperty($contentId:ID$status:[String]){content(id:$contentId status:$status){nodes{id appearanceDraft:properties(key:"content-appearance-draft"){nodes{id key value version{number}}}}}}`;
const $3b0f8352614b0ede$export$aed0dcf8ce9eb36 = (0, $d2LG0.default)`query getPublishedContentAppearanceProperty($contentId:ID$status:[String])@SLA{content(id:$contentId status:$status){nodes{id appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}}}}`;

});


parcelRegister("kGDoD", function(module, exports) {

$parcel$export(module.exports, "preloadLastUpdated", () => (parcelRequire("9nGwZ")).preloadLastUpdated);

var $9nGwZ = parcelRequire("9nGwZ");

var $6iSKO = parcelRequire("6iSKO");

});
parcelRegister("9nGwZ", function(module, exports) {

$parcel$export(module.exports, "preloadLastUpdated", () => $693a95aca15bff58$export$e7a15421d1327843);

var $dYU3e = parcelRequire("dYU3e");

var $6iSKO = parcelRequire("6iSKO");
function $693a95aca15bff58$export$e7a15421d1327843(contentId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $6iSKO.ByLineLastUpdatedQuery),
        variables: {
            contentId: contentId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}

});
parcelRegister("6iSKO", function(module, exports) {

$parcel$export(module.exports, "ByLineLastUpdatedQuery", () => $496ee58992d0a352$export$aae43c54b1ffa341);

var $d2LG0 = parcelRequire("d2LG0");
const $496ee58992d0a352$export$aae43c54b1ffa341 = (0, $d2LG0.default)`query ByLineLastUpdatedQuery($contentId:ID!$status:[String]){content(id:$contentId status:$status){nodes{id version{friendlyWhen when}}}}`;

});



parcelRegister("1c0dB", function(module, exports) {

$parcel$export(module.exports, "preloadEditorPageTitleContentProperties", () => $cb49cba09ddc32ea$export$2ea86854c75d3ec8);

var $dYU3e = parcelRequire("dYU3e");

var $2eBB6 = parcelRequire("2eBB6");
const $cb49cba09ddc32ea$export$2ea86854c75d3ec8 = async ({ contentId: contentId, draftShareId: draftShareId, useCache: useCache })=>{
    const variables = {
        contentId: contentId,
        status: [
            'current',
            'draft',
            'archived'
        ],
        draftShareId: draftShareId,
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    };
    return (0, $dYU3e.query)({
        query: (0, $2eBB6.TitleContentPropertyQuery),
        variables: variables
    });
};

});

parcelRegister("kDt9L", function(module, exports) {

$parcel$export(module.exports, "preloadMentionsProvider", () => $6bd71bdc26599ad9$export$45c648ba9bf4e12f);

var $dYU3e = parcelRequire("dYU3e");

var $egFdh = parcelRequire("egFdh");
const $6bd71bdc26599ad9$export$45c648ba9bf4e12f = async ()=>(0, $dYU3e.query)({
        query: (0, $egFdh.MentionsProviderQuery)
    });

});
parcelRegister("egFdh", function(module, exports) {

$parcel$export(module.exports, "MentionsProviderQuery", () => $032347ca36d77113$export$a93100a78b528047);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $032347ca36d77113$export$a93100a78b528047 = (0, $d2LG0.default)`query MentionsProviderQuery{entitlements{externalCollaborator{isEntitled}}}`;

});


parcelRegister("bth99", function(module, exports) {

$parcel$export(module.exports, "ReadTime", () => $2c14a806eb276594$export$77dedcd16f070a20);
$parcel$export(module.exports, "preloadReadTime", () => (parcelRequire("cRQNp")).preloadReadTime);

var $jmjWc = parcelRequire("jmjWc");

var $cRQNp = parcelRequire("cRQNp");

const $2c14a806eb276594$export$77dedcd16f070a20 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "If625",
    name: "ReadTime",
    loader: async ()=>(await (parcelRequire("1oznt"))).ReadTimeLoader
});

const $2c14a806eb276594$export$372a862ebf6e5d68 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jzts2",
    name: "ReadTimePopup",
    loader: async ()=>(await (parcelRequire("1HU4b"))).ReadTimePopupWithErrorBoundary
});

});
parcelRegister("cRQNp", function(module, exports) {

$parcel$export(module.exports, "preloadReadTime", () => $345f814d0887da7c$export$8301c585ee328ce0);

var $dYU3e = parcelRequire("dYU3e");

var $3T2Zj = parcelRequire("3T2Zj");
function $345f814d0887da7c$export$8301c585ee328ce0(contentId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $3T2Zj.ReadTimeQuery),
        variables: {
            contentId: contentId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}

});
parcelRegister("3T2Zj", function(module, exports) {

$parcel$export(module.exports, "ReadTimeQuery", () => $bb1db1cfcc51cbce$export$9a0a69714186a2dc);

var $d2LG0 = parcelRequire("d2LG0");
const $bb1db1cfcc51cbce$export$9a0a69714186a2dc = (0, $d2LG0.default)`query ReadTimeQuery($contentId:ID){content(id:$contentId){nodes{id type body{dynamic{value representation}}}}}`;

});


parcelRegister("1oznt", function(module, exports) {

let $10437995738479de$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $10437995738479de$var$load("bAAmE"),
    $10437995738479de$var$load("irgIM")
]).then(()=>parcelRequire('cbZqw'));

});

parcelRegister("1HU4b", function(module, exports) {

let $13e54c3b79eadace$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $13e54c3b79eadace$var$load("bAAmE").then(()=>parcelRequire('jgpqF'));

});


parcelRegister("9OYfw", function(module, exports) {

$parcel$export(module.exports, "preloadCollabDraftContent", () => $cb117090d47a4a62$export$952cf09a216eb6d);
$parcel$export(module.exports, "preloadNativeCollab", () => $cb117090d47a4a62$export$7c1f00ae06ab82b8);
$parcel$export(module.exports, "preloadNativeCollabProvider", () => $cb117090d47a4a62$export$55c4df0deb62a3b7);

var $dYU3e = parcelRequire("dYU3e");

var $l1kdf = parcelRequire("l1kdf");

var $lPJbQ = parcelRequire("lPJbQ");

var $7ZQNA = parcelRequire("7ZQNA");

var $8R0gj = parcelRequire("8R0gj");

var $9wGTI = parcelRequire("9wGTI");

var $PrCoC = parcelRequire("PrCoC");
function $cb117090d47a4a62$export$952cf09a216eb6d(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $7ZQNA.CollabDraftQuery),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    }).then((result)=>{
        // There is a bug in appolo client (https://github.com/apollographql/react-apollo/issues/3918)
        // that doesn't preserve the result in caches if there is an error in SSR
        // So we need to preserve the error, to be able to verify it later during render phase in SSR
        if (result?.errors?.some((err)=>(0, $8R0gj.isDraftSSRPreloadPermissionError)(err?.message))) {
            if ((0, $9wGTI.fg)('confluence_ssr_permissions_error_handler')) (0, $PrCoC.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('edit');
            else (0, $8R0gj.markDraftSSRPreloadPermissionError)();
        }
        return result;
    });
}
function $cb117090d47a4a62$export$7c1f00ae06ab82b8(contentId, draftShareId, useCache, status) {
    return (0, $dYU3e.query)({
        query: (0, $l1kdf.NativeCollabQuery),
        variables: {
            contentId: contentId,
            ...draftShareId && {
                draftShareId: draftShareId
            },
            status: status ?? [
                'draft',
                'current'
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        context: {
            single: 'true'
        }
    });
}
function $cb117090d47a4a62$export$55c4df0deb62a3b7({ accountId: accountId, useCache: useCache, shouldIncludePermissionType: shouldIncludePermissionType }) {
    return (0, $dYU3e.query)({
        query: (0, $lPJbQ.NativeCollabProviderQuery),
        variables: {
            accountId: accountId,
            shouldIncludePermissionType: shouldIncludePermissionType
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        context: {
            single: 'true'
        }
    });
}

});
parcelRegister("l1kdf", function(module, exports) {

$parcel$export(module.exports, "NativeCollabQuery", () => $c2e596865d8e6fea$export$79b924d780de6f0d);

var $d2LG0 = parcelRequire("d2LG0");
const $c2e596865d8e6fea$export$79b924d780de6f0d = (0, $d2LG0.default)`query NativeCollabQuery($contentId:ID$draftShareId:String$status:[String])@SLA{content(id:$contentId draftShareId:$draftShareId status:$status){nodes{id type status version{number ncsStepVersion by{type ...on KnownUser{accountId}...on User{accountId}}}history{createdBy{displayName}createdDate}space{id name homepageId}labels{nodes{id name}}subType}}}`;

});

parcelRegister("lPJbQ", function(module, exports) {

$parcel$export(module.exports, "NativeCollabProviderQuery", () => $53beb8cd44664983$export$22e98c290034558);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $53beb8cd44664983$export$22e98c290034558 = (0, $d2LG0.default)`query NativeCollabProviderQuery($accountId:ID$shouldIncludePermissionType:Boolean=false){user:confluence_atlassianUser(id:$accountId){id displayName photos{value isPrimary}confluence@include(if:$shouldIncludePermissionType){permissionType}}}`;

});

parcelRegister("7ZQNA", function(module, exports) {

$parcel$export(module.exports, "CollabDraftQuery", () => $270318977b9095e1$export$89183b1b5e58f33c);

var $d2LG0 = parcelRequire("d2LG0");
const $270318977b9095e1$export$89183b1b5e58f33c = (0, $d2LG0.default)`query CollabDraftQuery($id:ID!$draftShareId:String=""$hydrateAdf:Boolean){collabDraft(id:$id draftShareId:$draftShareId hydrateAdf:$hydrateAdf){document version metadata{title}}}`;

});

parcelRegister("8R0gj", function(module, exports) {

$parcel$export(module.exports, "preloadDraft", () => $65899b702fdd32b1$export$dfd3c4c0aa957792);
$parcel$export(module.exports, "markDraftSSRPreloadPermissionError", () => $65899b702fdd32b1$export$77a8ac6ca4e5ddb2);
$parcel$export(module.exports, "isDraftSSRPreloadPermissionError", () => $65899b702fdd32b1$export$9d45b1b64b2cb8e1);
$parcel$export(module.exports, "isEditPageDraftRestricted", () => $65899b702fdd32b1$export$8fecb24b3e77114b);

var $747ya = parcelRequire("747ya");
async function $65899b702fdd32b1$export$dfd3c4c0aa957792(contentId, draftShareId) {
    window.__PRELOAD_DRAFT__ = {
        contentId: contentId,
        draftFetchPromise: (0, $747ya.fetchDraft)(contentId, draftShareId),
        // eslint-disable-next-line no-restricted-properties
        startTime: window?.performance?.now?.()
    };
}
let $65899b702fdd32b1$var$hasDraftSSRPreloadError = false;
function $65899b702fdd32b1$export$77a8ac6ca4e5ddb2(value = true) {
    $65899b702fdd32b1$var$hasDraftSSRPreloadError = value;
}
const $65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR = 'com.atlassian.confluence.api.service.exceptions.PermissionException: User does not have permission';
function $65899b702fdd32b1$export$9d45b1b64b2cb8e1(message) {
    if (!message) return false;
    return message.indexOf($65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR) > -1 || false;
}
function $65899b702fdd32b1$export$8fecb24b3e77114b() {
    return $65899b702fdd32b1$var$hasDraftSSRPreloadError || window.__SSR_EDIT_PAGE_DRAFT_RESTRICTED__ || false;
}
function $65899b702fdd32b1$export$abdce0f749a71407() {
    if ($65899b702fdd32b1$var$hasDraftSSRPreloadError) return {
        __SSR_EDIT_PAGE_DRAFT_RESTRICTED__: true
    };
    return undefined;
}

});
parcelRegister("747ya", function(module, exports) {

$parcel$export(module.exports, "fetchDraft", () => $67d2826966f59cb2$export$af6160a01d539948);

var $hp2SH = parcelRequire("hp2SH");

var $7ZQNA = parcelRequire("7ZQNA");
async function $67d2826966f59cb2$export$af6160a01d539948(contentId, draftShareId) {
    const response = await (0, $hp2SH.getApolloClient)().query({
        query: (0, $7ZQNA.CollabDraftQuery),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'network-only'
    });
    const { data: data, errors: errors } = response;
    if (errors || !data.collabDraft) return {
        draft: null,
        response: response
    };
    const { document: document, version: version, metadata: metadata } = data.collabDraft;
    const draft = {
        version: version,
        metadata: $67d2826966f59cb2$var$excludeTypename(metadata),
        document: JSON.parse(document || '')
    };
    return {
        draft: draft,
        response: response
    };
}
function $67d2826966f59cb2$var$excludeTypename(metadata) {
    if (!metadata) return metadata;
    const { __typename: __typename, ...rest } = metadata;
    return rest;
}

});




parcelRegister("lGgRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e30c70ca2cd01247$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Popup", () => (parcelRequire("2mqmH")).Popup);

var $2mqmH = parcelRequire("2mqmH");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e30c70ca2cd01247$export$2e2bcd8739ae039 = (0, $2mqmH.Popup);

});
parcelRegister("2mqmH", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $6072e21ac854e34a$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $c0qxy = parcelRequire("c0qxy");

var $iug2J = parcelRequire("iug2J");

var $if5rb = parcelRequire("if5rb");

var $dh538 = parcelRequire("dh538");

var $2ED7Q = parcelRequire("2ED7Q");
var $epI1O = parcelRequire("epI1O");

var $caX7N = parcelRequire("caX7N");

var $gdv5Z = parcelRequire("gdv5Z");

var $2cdko = parcelRequire("2cdko");

var $fiAWX = parcelRequire("fiAWX");

var $9Ghf3 = parcelRequire("9Ghf3");

var $advfQ = parcelRequire("advfQ");
const $6072e21ac854e34a$var$defaultLayer = 400;
const $6072e21ac854e34a$var$wrapperStyles = {
    root: "_kqswh2mm"
};
const $6072e21ac854e34a$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $gwFzn.memo)(({ xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $6072e21ac854e34a$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport })=>{
    const [triggerRef, setTriggerRef] = (0, $gwFzn.useState)(null);
    const getMergedTriggerRef = (0, $9Ghf3.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $advfQ.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $c0qxy.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $fiAWX.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $gwFzn.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $if5rb.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    const renderPopperWrapper = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iug2J.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2cdko.default), {
            xcss: xcss,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    const popupContent = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2ED7Q.Manager), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epI1O.Reference), {
                children: ({ ref: ref })=>{
                    return trigger({
                        ref: !(0, $dh538.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, $dh538.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $caX7N.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            }))
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $6072e21ac854e34a$var$wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
});

});
parcelRegister("2cdko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f664ccea70fe7a55$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $16xFS = parcelRequire("16xFS");

var $dh538 = parcelRequire("dh538");

var $lqsSp = parcelRequire("lqsSp");

var $6LDD6 = parcelRequire("6LDD6");

var $jK2xQ = parcelRequire("jK2xQ");

var $dsWUo = parcelRequire("dsWUo");
const $f664ccea70fe7a55$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $f664ccea70fe7a55$var$fullWidthStyles = null;
const $f664ccea70fe7a55$var$wrapperStyles = {
    root: "_2rkoglpi _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _syaz1fxt _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36"
};
const $f664ccea70fe7a55$var$scrollableStyles = null;
const $f664ccea70fe7a55$var$blanketStyles = null;
const $f664ccea70fe7a55$var$modalStyles = null;
const $f664ccea70fe7a55$var$focusRingStyles = {
    root: "_mizu1p6i _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y"
};
const $f664ccea70fe7a55$var$DefaultPopupComponent = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $35pXk.default)([
            $f664ccea70fe7a55$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            !shouldRenderToParent && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ]),
        ...htmlAttributes,
        ref: ref,
        children: children
    });
});
function $f664ccea70fe7a55$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
popupComponent: PopupContainer = $f664ccea70fe7a55$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default' }) {
    const [popupRef, setPopupRef] = (0, $gwFzn.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $gwFzn.useState)(null); // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $dsWUo.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $jK2xQ.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    const mergedModifiers = (0, $gwFzn.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lqsSp.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: ({ ref: ref, style: style, placement: placement, update: update })=>{
            const popupContainer = /*#__PURE__*/ (0, $7UHDa.jsx)(PopupContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $35pXk.default)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                    (0, $dh538.fg)('platform-design-system-apply-popup-wrapper-focus') && $f664ccea70fe7a55$var$focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6LDD6.RepositionOnUpdate), {
                    update: update,
                    children: content({
                        update: update,
                        isOpen: isOpen,
                        onClose: onClose,
                        setInitialFocusRef: setInitialFocusRef
                    })
                })
            });
            return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
                children: [
                    popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        className: (0, $35pXk.default)([
                            "_1r04idpf _kqsw1n9t _bfhk10xm"
                        ])
                    })
                ]
            });
        }
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f664ccea70fe7a55$export$2e2bcd8739ae039 = $f664ccea70fe7a55$var$PopperWrapper;

});
parcelRegister("6LDD6", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", () => $358e604dbfb8af77$export$51eddd7655ca235a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $358e604dbfb8af77$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $gwFzn.useRef)(true);
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: children
    });
};

});

parcelRegister("jK2xQ", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", () => $b6349930617ff547$export$92dae2778ae88f9d);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $ee7An = parcelRequire("ee7An");

var $16xFS = parcelRequire("16xFS");

var $dh538 = parcelRequire("dh538");

var $5PTZq = parcelRequire("5PTZq");

var $lyzio = parcelRequire("lyzio");
const $b6349930617ff547$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $lyzio.useAnimationFrame)();
    (0, $gwFzn.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $ee7An.default;
        const inIframe = window && window.self !== window.top && (0, $dh538.fg)('fix-dropdown-close-outside-iframe');
        const closePopup = (event)=>{
            if (onClose) {
                let currentLevel = null;
                if (event.target instanceof HTMLElement) currentLevel = event.target.closest(`[data-ds--level]`)?.getAttribute('data-ds--level');
                currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $dh538.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef?.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    const layeredElement = target.closest?.(`[data-ds--level]`);
                    if (layeredElement) {
                        const closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $5PTZq.isInteractiveElement)(document.activeElement) && (0, $dh538.fg)('platform_dst_popup-disable-focuslock')) triggerRef?.focus();
            }
        };
        const onKeyDown = (event)=>{
            if ((0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
                const { key: key, shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef?.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && document.activeElement?.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                const { key: key } = event;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $d8F95.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        let unbind = (0, $ee7An.default);
        if ((0, $dh538.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $d8F95.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                }
            ]);
        }, 0);
        else unbind = (0, $d8F95.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $ee7An.default);
        unbindBlur = (0, $d8F95.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $dh538.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            parentUnbind?.();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("5PTZq", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $55ef7559dd2f6324$export$3dee5e4542c672d9);
const $55ef7559dd2f6324$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $55ef7559dd2f6324$export$3dee5e4542c672d9 = (element)=>{
    if ($55ef7559dd2f6324$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("lyzio", function(module, exports) {

$parcel$export(module.exports, "useAnimationFrame", () => $bfd399335701df88$export$641fa9c94086b46e);

var $gwFzn = parcelRequire("gwFzn");
const $bfd399335701df88$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $gwFzn.useRef)([]);
    const requestFrame = (0, $gwFzn.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $gwFzn.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $gwFzn.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("dsWUo", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", () => $f5b63653351b33e7$export$10c5169755ce7bd7);

var $gwFzn = parcelRequire("gwFzn");

var $7tiJw = parcelRequire("7tiJw");

var $ee7An = parcelRequire("ee7An");

var $16xFS = parcelRequire("16xFS");

var $dh538 = parcelRequire("dh538");

var $lyzio = parcelRequire("lyzio");
const $f5b63653351b33e7$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $lyzio.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    (0, $gwFzn.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $ee7An.default;
        if (shouldDisableFocusTrap && (0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef?.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $ee7An.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($7tiJw)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("fiAWX", function(module, exports) {

$parcel$export(module.exports, "usePopupAppearance", () => $84f8030b6f5953d1$export$4065aef1d79a5730);

var $gwFzn = parcelRequire("gwFzn");

var $2hNw6 = parcelRequire("2hNw6");
function $84f8030b6f5953d1$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const mq = (0, $2hNw6.UNSAFE_useMediaQuery)('below.sm', (e)=>{
        setIsSmallViewport(!!e.matches);
    });
    const [isSmallViewport, setIsSmallViewport] = (0, $gwFzn.useState)(!!mq?.matches);
    const appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("2hNw6", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $ce3c82ea32c3605a$export$49e55ae2c03d6045);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $1Ry5l = parcelRequire("1Ry5l");
const $ce3c82ea32c3605a$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1Ry5l.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1Ry5l.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1Ry5l.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1Ry5l.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1Ry5l.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1Ry5l.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1Ry5l.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1Ry5l.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1Ry5l.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1Ry5l.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1Ry5l.media).below.xl.replace('@media ', '').trim())
};
const $ce3c82ea32c3605a$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $gwFzn.useRef)(listener);
    (0, $gwFzn.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $ce3c82ea32c3605a$var$queries[queryString];
    (0, $gwFzn.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $d8F95.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("1Ry5l", function(module, exports) {

$parcel$export(module.exports, "media", () => $c1fa9040ef00e564$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $c1fa9040ef00e564$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("9Ghf3", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $17aa3267309602ff$export$7cc5c058dd769dff);

var $gwFzn = parcelRequire("gwFzn");

var $csnse = parcelRequire("csnse");
const $17aa3267309602ff$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $gwFzn.useState)(()=>(0, $csnse.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("advfQ", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $eb7a244451737e86$export$5d3a2de79e07b376);

var $gwFzn = parcelRequire("gwFzn");

var $csnse = parcelRequire("csnse");
const $eb7a244451737e86$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $gwFzn.useState)(()=>(0, $csnse.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("iu6m9", function(module, exports) {

$parcel$export(module.exports, "editorExperiment", () => $763ece530a70fe0e$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $763ece530a70fe0e$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $c6GJD = parcelRequire("c6GJD");

var $7Rqpr = parcelRequire("7Rqpr");

var $8ihu7 = parcelRequire("8ihu7");
function $763ece530a70fe0e$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $7Rqpr.editorExperimentsConfig)[experimentName];
    if ((0, $8ihu7._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $8ihu7._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $8ihu7._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $8ihu7._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $7Rqpr.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $c6GJD.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    return expectedExperimentValue === experimentValue;
}
function $763ece530a70fe0e$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $8ihu7._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $8ihu7._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $c6GJD.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});

parcelRegister("k7eoe", function(module, exports) {

$parcel$export(module.exports, "FabricChannel", () => $12953c8cc50d9b6a$export$8faa0b115ef0268b);
var $12953c8cc50d9b6a$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    return FabricChannel;
}({});

});

parcelRegister("aFUXX", function(module, exports) {

$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $cf06caec6e967ae4$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $cf06caec6e967ae4$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $cf06caec6e967ae4$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $cf06caec6e967ae4$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $cf06caec6e967ae4$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $cf06caec6e967ae4$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $cf06caec6e967ae4$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $cf06caec6e967ae4$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $cf06caec6e967ae4$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $cf06caec6e967ae4$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $cf06caec6e967ae4$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $cf06caec6e967ae4$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $cf06caec6e967ae4$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $cf06caec6e967ae4$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBoldBoxShadow", () => $cf06caec6e967ae4$export$37e178ca41c198ca);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $cf06caec6e967ae4$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $cf06caec6e967ae4$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $cf06caec6e967ae4$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $cf06caec6e967ae4$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $cf06caec6e967ae4$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $cf06caec6e967ae4$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $cf06caec6e967ae4$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $cf06caec6e967ae4$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $cf06caec6e967ae4$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $cf06caec6e967ae4$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $cf06caec6e967ae4$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $cf06caec6e967ae4$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $cf06caec6e967ae4$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $cf06caec6e967ae4$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $cf06caec6e967ae4$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $cf06caec6e967ae4$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $cf06caec6e967ae4$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $cf06caec6e967ae4$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $cf06caec6e967ae4$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $cf06caec6e967ae4$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $cf06caec6e967ae4$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $cf06caec6e967ae4$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $cf06caec6e967ae4$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $cf06caec6e967ae4$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $cf06caec6e967ae4$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $cf06caec6e967ae4$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $cf06caec6e967ae4$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $cf06caec6e967ae4$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $cf06caec6e967ae4$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $cf06caec6e967ae4$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $cf06caec6e967ae4$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $cf06caec6e967ae4$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $cf06caec6e967ae4$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $cf06caec6e967ae4$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $cf06caec6e967ae4$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $cf06caec6e967ae4$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorToolbarKeylineHeight", () => $cf06caec6e967ae4$export$d29cb2c31fcbb7c5);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $cf06caec6e967ae4$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $cf06caec6e967ae4$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $cf06caec6e967ae4$export$de3cef07cda55645);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $cf06caec6e967ae4$export$e88f6c898960b391);
$parcel$export(module.exports, "layoutBreakpointWidth", () => $cf06caec6e967ae4$export$e5c605f2b2a12b00);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $cf06caec6e967ae4$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $cf06caec6e967ae4$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $cf06caec6e967ae4$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $cf06caec6e967ae4$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $cf06caec6e967ae4$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $cf06caec6e967ae4$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $cf06caec6e967ae4$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $cf06caec6e967ae4$export$59733a9f61449b25);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $cf06caec6e967ae4$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $cf06caec6e967ae4$export$42608c013398a830);

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");
const $cf06caec6e967ae4$export$fe6b0b821a0e9067 = 16;
const $cf06caec6e967ae4$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $cf06caec6e967ae4$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $cf06caec6e967ae4$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
const $cf06caec6e967ae4$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $cf06caec6e967ae4$export$f0e953d95429ca1 = '12px';
const $cf06caec6e967ae4$export$a309dbdeca0adb1a = '2px 4px';
const $cf06caec6e967ae4$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $cf06caec6e967ae4$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $cf06caec6e967ae4$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $cf06caec6e967ae4$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $cf06caec6e967ae4$export$d2715266dd4a1fd1 = 20;
const $cf06caec6e967ae4$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
const $cf06caec6e967ae4$export$8dac549e32469ac4 = 1;
const $cf06caec6e967ae4$export$befaaae517e3d864 = 2;
const $cf06caec6e967ae4$export$6e1e1996c4e8cc51 = `${$cf06caec6e967ae4$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
const $cf06caec6e967ae4$export$b6a59ac3a19b6343 = `0 0 0 ${$cf06caec6e967ae4$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $cf06caec6e967ae4$export$37e178ca41c198ca = `0 0 0 ${$cf06caec6e967ae4$export$befaaae517e3d864}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $cf06caec6e967ae4$export$4a007c22e25e31f6 = 0.3;
const $cf06caec6e967ae4$export$f35cc48f3398ab79 = 1;
const $cf06caec6e967ae4$export$b46cda584c619451 = 2;
const $cf06caec6e967ae4$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $cf06caec6e967ae4$export$321ddd2f049dd12 = $cf06caec6e967ae4$export$6bed85de54b5de42 + 1;
const $cf06caec6e967ae4$export$daeac9b8422ac3c2 = 2;
const $cf06caec6e967ae4$export$501d46e11ed5bf73 = 500;
const $cf06caec6e967ae4$export$6817b4b6a5ef78f1 = 400;
const $cf06caec6e967ae4$export$93768eb72dec48ce = $cf06caec6e967ae4$export$501d46e11ed5bf73 + 10;
const $cf06caec6e967ae4$export$c0aec4e0896849a0 = $cf06caec6e967ae4$export$93768eb72dec48ce - 5;
const $cf06caec6e967ae4$export$5886f057e4f21fe4 = $cf06caec6e967ae4$export$6817b4b6a5ef78f1 + 5;
const $cf06caec6e967ae4$export$6e85faa46d537a3f = 11;
const $cf06caec6e967ae4$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $cf06caec6e967ae4$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $cf06caec6e967ae4$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $cf06caec6e967ae4$export$95e9a0285b97474d = '#2C333A';
const $cf06caec6e967ae4$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
const $cf06caec6e967ae4$export$76b5e653883e5290 = '3px';
const $cf06caec6e967ae4$export$6d85fe8177a50c0c = 0.5;
const $cf06caec6e967ae4$export$fad19f16d3f953a3 = 680;
const $cf06caec6e967ae4$export$9db045950eedb49f = 760;
const $cf06caec6e967ae4$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $cf06caec6e967ae4$export$f580e3d28d0986de = 1800;
const $cf06caec6e967ae4$export$9d5488b5afad62bf = 1792;
const $cf06caec6e967ae4$export$37df10057d36a0e5 = 42;
const $cf06caec6e967ae4$export$437293c5e9fc2703 = 96;
const $cf06caec6e967ae4$export$6e0f4d52efd3d2d = 32;
const $cf06caec6e967ae4$export$f222e0c7a2dc5324 = ()=>// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52;
const $cf06caec6e967ae4$export$efe8561bbd3f74d2 = 720;
const $cf06caec6e967ae4$export$e4d39a9e8607c1d3 = 48;
const $cf06caec6e967ae4$export$43946f2400ab6f1f = 128;
const $cf06caec6e967ae4$export$558438ae7fd4b8ce = 12;
const $cf06caec6e967ae4$export$6beb98d32d4ca149 = 4;
const $cf06caec6e967ae4$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $cf06caec6e967ae4$export$5edb4f38c3eacb1a = 1024;
const $cf06caec6e967ae4$export$e60820063058ed59 = 1.33;
const $cf06caec6e967ae4$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $cf06caec6e967ae4$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $cf06caec6e967ae4$export$fb15fade89f67217 = $cf06caec6e967ae4$export$f35cc48f3398ab79 * 99;
const $cf06caec6e967ae4$export$847030921e9d5a40 = 12;
const $cf06caec6e967ae4$export$40eb41ab799f0329 = 1.714;
const $cf06caec6e967ae4$export$e271312fc7124aec = '1px';
const $cf06caec6e967ae4$export$d29cb2c31fcbb7c5 = 2;
const $cf06caec6e967ae4$export$688a6dc01e760755 = 320;
const $cf06caec6e967ae4$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $cf06caec6e967ae4$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $cf06caec6e967ae4$export$e88f6c898960b391 = $cf06caec6e967ae4$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $cf06caec6e967ae4$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $cf06caec6e967ae4$export$1d0d506416d457f1 = '0.75rem';
const $cf06caec6e967ae4$export$e683ef42725d1713 = 680;
const $cf06caec6e967ae4$export$226c784ba04bd04b = 480;
const $cf06caec6e967ae4$export$214ff00e5618d86c = 20;
const $cf06caec6e967ae4$export$c82675fa56f2eefd = '56px';
const $cf06caec6e967ae4$var$DEFAULT_FONT_SIZE = 14;
const $cf06caec6e967ae4$export$d7726a000ae2d7c = ()=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    if ((0, $dh538.fg)('live_pages_content_jump_mitigation')) return '2.188rem';
    return "var(--ds-space-500, 40px)";
};
const $cf06caec6e967ae4$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $cf06caec6e967ae4$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $cf06caec6e967ae4$var$DEFAULT_FONT_SIZE;
const $cf06caec6e967ae4$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$cf06caec6e967ae4$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $cf06caec6e967ae4$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $cf06caec6e967ae4$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $cf06caec6e967ae4$export$9369fd010fa0ddd6 = 0;
const $cf06caec6e967ae4$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$cf06caec6e967ae4$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $cf06caec6e967ae4$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $cf06caec6e967ae4$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E56910)",
    "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #1D7AFC)",
    "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #8270DB)",
    "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
    "var(--ds-icon-accent-gray, #758195)",
    "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
];
const $cf06caec6e967ae4$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)"
    }
];

});

parcelRegister("7i8J9", function(module, exports) {

$parcel$export(module.exports, "EDITOR_CONTEXT", () => $b5cba05215695b9c$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $b5cba05215695b9c$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $b5cba05215695b9c$export$629cada6c5e621e1);

var $lzPoe = parcelRequire("lzPoe");
const $b5cba05215695b9c$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $b5cba05215695b9c$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $b5cba05215695b9c$export$629cada6c5e621e1 = (0, $lzPoe.default)($b5cba05215695b9c$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});
parcelRegister("lzPoe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e445bef6beedf905$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $bYRk6 = parcelRequire("bYRk6");
const $e445bef6beedf905$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
            data: newData,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.only(props.children)
        });
    };
    Component.displayName = displayName;
    return Component;
};
var $e445bef6beedf905$export$2e2bcd8739ae039 = $e445bef6beedf905$var$createNamespaceContext;

});


parcelRegister("hArLp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5ff95295a4c1701$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");
const $a5ff95295a4c1701$var$buttonGroupStyles = (0, $3jLHL.css)({
    display: 'inline-flex',
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> *': {
        flex: '1 0 auto'
    }
});
function $a5ff95295a4c1701$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $a5ff95295a4c1701$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), {
            key: idx
        }, child);
    }));
}

});

parcelRegister("cvXh8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $91c65c25a9968649$var$_react = $91c65c25a9968649$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $91c65c25a9968649$var$_baseNew = $91c65c25a9968649$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $91c65c25a9968649$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $91c65c25a9968649$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $91c65c25a9968649$var$_react.default.createElement($91c65c25a9968649$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$91c65c25a9968649$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $91c65c25a9968649$var$_default = module.exports.default = $91c65c25a9968649$var$CheckMarkIcon;

});

parcelRegister("ffCOo", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => (parcelRequire("cT1Md")).ELEMENTS_CONTEXT);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => (parcelRequire("cT1Md")).FabricElementsAnalyticsContext);
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => (parcelRequire("1oYFx")).NAVIGATION_CONTEXT);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("1oYFx")).NavigationAnalyticsContext);
$parcel$export(module.exports, "EDITOR_CONTEXT", () => (parcelRequire("7i8J9")).EDITOR_CONTEXT);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => (parcelRequire("7i8J9")).FabricEditorAnalyticsContext);
$parcel$export(module.exports, "MEDIA_CONTEXT", () => (parcelRequire("gSKON")).MEDIA_CONTEXT);
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => (parcelRequire("gqplE")).PEOPLE_TEAMS_CONTEXT);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => (parcelRequire("gqplE")).PeopleTeamsAnalyticsContext);
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => (parcelRequire("ePh4F")).NOTIFICATIONS_CONTEXT);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => (parcelRequire("ePh4F")).NotificationsAnalyticsContext);
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => (parcelRequire("8hvil")).RECENT_WORK_CONTEXT);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => (parcelRequire("8hvil")).RecentWorkAnalyticsContext);
$parcel$export(module.exports, "ATLAS_CONTEXT", () => (parcelRequire("dWoPW")).ATLAS_CONTEXT);
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => (parcelRequire("kwKGS")).LINKING_PLATFORM_CONTEXT);
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => (parcelRequire("26stD")).POST_OFFICE_CONTEXT);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => (parcelRequire("26stD")).PostOfficeAnalyticsContext);
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => (parcelRequire("2jQZn")).AI_MATE_CONTEXT);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => (parcelRequire("2jQZn")).AIMateAnalyticsContext);
$parcel$export(module.exports, "AVP_CONTEXT", () => (parcelRequire("aVIsj")).AVP_CONTEXT);
$parcel$export(module.exports, "GROWTH_CONTEXT", () => (parcelRequire("hcByP")).GROWTH_CONTEXT);

var $cT1Md = parcelRequire("cT1Md");

var $1oYFx = parcelRequire("1oYFx");

var $7i8J9 = parcelRequire("7i8J9");

var $gSKON = parcelRequire("gSKON");

var $gqplE = parcelRequire("gqplE");

var $ePh4F = parcelRequire("ePh4F");

var $8hvil = parcelRequire("8hvil");

var $dWoPW = parcelRequire("dWoPW");

var $kwKGS = parcelRequire("kwKGS");

var $26stD = parcelRequire("26stD");

var $2jQZn = parcelRequire("2jQZn");

var $aVIsj = parcelRequire("aVIsj");

var $hcByP = parcelRequire("hcByP");

});
parcelRegister("cT1Md", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $46f3b05eb9c58251$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $46f3b05eb9c58251$export$3fe25500478a635c);

var $lzPoe = parcelRequire("lzPoe");
const $46f3b05eb9c58251$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $46f3b05eb9c58251$export$3fe25500478a635c = (0, $lzPoe.default)($46f3b05eb9c58251$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});

parcelRegister("1oYFx", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $ff8209db9a792c53$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $ff8209db9a792c53$export$d0a82da1a0b94929);

var $lzPoe = parcelRequire("lzPoe");
const $ff8209db9a792c53$export$1fd3aad76a7c6788 = 'navigationCtx';
const $ff8209db9a792c53$export$d0a82da1a0b94929 = (0, $lzPoe.default)($ff8209db9a792c53$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("gSKON", function(module, exports) {

$parcel$export(module.exports, "MEDIA_CONTEXT", () => $4d0bf9efc7729ff2$export$70df29c238ba7306);
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $4d0bf9efc7729ff2$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

});

parcelRegister("gqplE", function(module, exports) {

$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $9edf731f97a24332$export$b326383bee6cb993);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => $9edf731f97a24332$export$4119ddb38ccbfb87);

var $lzPoe = parcelRequire("lzPoe");
const $9edf731f97a24332$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $9edf731f97a24332$export$4119ddb38ccbfb87 = (0, $lzPoe.default)($9edf731f97a24332$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("ePh4F", function(module, exports) {

$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $9d8ba06d8384c89b$export$da1befb791e93c7e);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => $9d8ba06d8384c89b$export$6f8e7ff1e3feafd7);

var $lzPoe = parcelRequire("lzPoe");
const $9d8ba06d8384c89b$export$da1befb791e93c7e = 'NotificationsCtx';
const $9d8ba06d8384c89b$export$6f8e7ff1e3feafd7 = (0, $lzPoe.default)($9d8ba06d8384c89b$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("8hvil", function(module, exports) {

$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $060232cf4e4d539d$export$fc7a65795610cb71);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => $060232cf4e4d539d$export$745926731087ebe2);

var $lzPoe = parcelRequire("lzPoe");
const $060232cf4e4d539d$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $060232cf4e4d539d$export$745926731087ebe2 = (0, $lzPoe.default)($060232cf4e4d539d$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("dWoPW", function(module, exports) {

$parcel$export(module.exports, "ATLAS_CONTEXT", () => $46a73b440d6113f3$export$4906017439f33fc0);

var $lzPoe = parcelRequire("lzPoe");
const $46a73b440d6113f3$export$4906017439f33fc0 = 'atlasCtx';
const $46a73b440d6113f3$export$43ebbe41370d4543 = (0, $lzPoe.default)($46a73b440d6113f3$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("kwKGS", function(module, exports) {

$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $65864e4d26a7c98c$export$3240443bf2b83834);

var $lzPoe = parcelRequire("lzPoe");
const $65864e4d26a7c98c$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $65864e4d26a7c98c$export$6d568da622ce0a08 = (0, $lzPoe.default)($65864e4d26a7c98c$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("26stD", function(module, exports) {

$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $1c7021ddb425333f$export$ef0c05448f0f8f9);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => $1c7021ddb425333f$export$dcd232f3be312f94);

var $lzPoe = parcelRequire("lzPoe");
const $1c7021ddb425333f$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $1c7021ddb425333f$export$dcd232f3be312f94 = (0, $lzPoe.default)($1c7021ddb425333f$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("2jQZn", function(module, exports) {

$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $c5296d06c7e65da9$export$5c3a6fd8b96e8b66);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => $c5296d06c7e65da9$export$de3826c30468da26);

var $lzPoe = parcelRequire("lzPoe");
const $c5296d06c7e65da9$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $c5296d06c7e65da9$export$de3826c30468da26 = (0, $lzPoe.default)($c5296d06c7e65da9$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});

parcelRegister("aVIsj", function(module, exports) {

$parcel$export(module.exports, "AVP_CONTEXT", () => $7f234d72bc6ab634$export$c2a811a4e42f4af5);

var $lzPoe = parcelRequire("lzPoe");
const $7f234d72bc6ab634$export$c2a811a4e42f4af5 = 'avpCtx';
const $7f234d72bc6ab634$export$da383e8879a25b03 = (0, $lzPoe.default)($7f234d72bc6ab634$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});

parcelRegister("hcByP", function(module, exports) {

$parcel$export(module.exports, "GROWTH_CONTEXT", () => $13998c7aae48d2e2$export$82023f2f4bfb06c1);

var $lzPoe = parcelRequire("lzPoe");
const $13998c7aae48d2e2$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $13998c7aae48d2e2$export$84980182680018f = (0, $lzPoe.default)($13998c7aae48d2e2$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});


parcelRegister("6auOX", function(module, exports) {

$parcel$export(module.exports, "choreographerFactory", () => $2bc8c852c894953d$export$55d2aeb17c4cfbe);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fw9LG = parcelRequire("fw9LG");

var $fhmex = parcelRequire("fhmex");

var $aK29g = parcelRequire("aK29g");
var $3uBX0 = parcelRequire("3uBX0");
var $c80Ta = parcelRequire("c80Ta");
var $e7WW2 = parcelRequire("e7WW2");
var $7QPgW = parcelRequire("7QPgW");
var $9OkE6 = parcelRequire("9OkE6");
var $5EcUp = parcelRequire("5EcUp");
var $6sxJX = parcelRequire("6sxJX");
var $du0KY = parcelRequire("du0KY");
var $brlLt = parcelRequire("brlLt");
function $2bc8c852c894953d$export$55d2aeb17c4cfbe(productId, env, metaMetricsData = {}, choreographerOptions = {
    enableChoreographer: true
}) {
    // Instantiate our plugin instance, passing the productId through for segmenting any messageId's from any other plugins
    const plugin = new (0, $fhmex.ProductChoreographerPlugin)(productId, env, metaMetricsData);
    /**
	 * React hook that provides startMessage and stopMessage functions that call through the plugin API with the provided messageId, for easy assignment to React event handlers.
	 *
	 * @param messageId The messageId to be provided to the choreographer API whenever the startMessage and stopMessage callbacks are invoked.
	 * @param startCallback A callback to be used to set local state that determines whether a message should be shown, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @param stopCallback A callback to be used to set local state that determines whether a message should be hidden, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @returns An object with startMessage and stopMessage callbacks, which contain references to the messageId to be passed to the choreographer API, so that the consumer no longer needs to specify that at call time.
	 */ const useChoreographer = (messageId, { [(0, $fw9LG.MessageEventType).START]: startCallback, [(0, $fw9LG.MessageEventType).STOP]: stopCallback } = {})=>{
        const isMessageStarted = (0, $gwFzn.useRef)(false);
        const startRef = (0, $gwFzn.useRef)(startCallback);
        const stopRef = (0, $gwFzn.useRef)(stopCallback);
        // Callback that uses a ref to track any changes in the received startCallback parameter, so the caller doesn't have to worry about memoization
        const startMessageCallback = (0, $gwFzn.useCallback)(async (...args)=>{
            const didMessageStart = await startRef.current?.(...args) ?? true;
            isMessageStarted.current = didMessageStart;
            return didMessageStart;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's startMessage function, for use in components.
        const startMessage = (0, $gwFzn.useCallback)((...args)=>{
            plugin.onStart(messageId, ()=>startMessageCallback(...args));
            return plugin.startMessage(messageId);
        }, [
            messageId,
            startMessageCallback
        ]);
        // Callback that uses a ref to track any changes in the received stopCallback parameter, so the caller doesn't have to worry about memoization
        const stopMessageCallback = (0, $gwFzn.useCallback)(async (...args)=>{
            const didMessageStop = await stopRef.current?.(...args) ?? true;
            isMessageStarted.current = !didMessageStop;
            return didMessageStop;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's stopMessage function, for use in components.
        const stopMessage = (0, $gwFzn.useCallback)((...args)=>{
            if (isMessageStarted.current) {
                plugin.onStop(messageId, ()=>stopMessageCallback(...args));
                return plugin.stopMessage(messageId);
            }
            return Promise.resolve((0, $fw9LG.MessageDeliveryStatus).STOPPED);
        }, [
            isMessageStarted,
            messageId,
            stopMessageCallback
        ]);
        // Stable function reference that invokes whichever start or stop handler is appropriate for the message's current display state.
        // Tracking this state with a ref allows us to know the current display state in real-time, so that potentially subsequent calls
        // can be made to toggle its state, without requiring tracking a useState value and requiring rerenders to update the callback
        // with the latest display state, and without generating false blocked messages from cached/outdated toggleMessage references.
        const toggleMessage = (0, $gwFzn.useCallback)(()=>{
            return isMessageStarted.current ? stopMessage() : startMessage();
        }, [
            isMessageStarted,
            startMessage,
            stopMessage
        ]);
        // Syncs any incoming startCallback and stopCallback functions as the latest version to be invoked when a startMessage or stopMessage call is issued through the choreographer API
        (0, $gwFzn.useLayoutEffect)(()=>{
            startRef.current = startCallback;
            stopRef.current = stopCallback;
        }, [
            startCallback,
            stopCallback
        ]);
        /**
		 * At component mount, we want to default a start and stop function, which invokes these functions with no additional parameters,
		 * just to supply some sane defaults. If startMessage or stopMessage are called explicitly, they can optionally supply some extra
		 * parameters, at which point, a just-in-time registration of a new callback version will be supplied to the choreographer, which
		 * will proxy those parameter through to the target state-setter functions. But if they are not called explicitly, such as in the
		 * case where a message is started and never stopped, and is timed out from the Choreographer, we want to have a default version
		 * available to execute against.
		 *
		 * At component unmount, stop the current message, if it's displayed, and unsubscribe the stop callback for this messageId within
		 * the plugin.
		 */ (0, $gwFzn.useLayoutEffect)(()=>{
            plugin.on(messageId, {
                start: async ()=>{
                    return await startMessage() === (0, $fw9LG.MessageDeliveryStatus).STARTED;
                },
                stop: async ()=>{
                    return await stopMessage() === (0, $fw9LG.MessageDeliveryStatus).STOPPED;
                }
            });
            return ()=>{
                // If unsubscribing, fire the stopMessageCallback one last time to ensure the component can clear the local state responsible for displaying its message
                stopMessage(messageId);
                plugin.off(messageId);
            };
        }, [
            messageId,
            startMessage,
            stopMessage
        ]);
        // Return the wrapped startMessage and stopMessage functions to the consumer, which will route their requests through the choreographer API with the messageId proxied straight through on behalf of the caller
        return (0, $gwFzn.useMemo)(()=>({
                startMessage: startMessage,
                stopMessage: stopMessage,
                toggleMessage: toggleMessage
            }), [
            startMessage,
            stopMessage,
            toggleMessage
        ]);
    };
    const shouldBeChoreographed = (props)=>{
        return (0, $6sxJX.shouldBeChoreographed)(props, choreographerOptions);
    };
    const useChoreographedRender = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
        const [shouldRender, setShouldRender] = (0, $gwFzn.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
            start: ()=>setShouldRender(true),
            stop: ()=>setShouldRender(false)
        });
        (0, $gwFzn.useLayoutEffect)(()=>{
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            const stopMessageAsync = async ()=>{
                const disposition = await stopMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>void stopMessageAsync();
        }, [
            messageId,
            onMessageDisposition,
            startMessage,
            stopMessage
        ]);
        return shouldRender;
    };
    const withChoreographedRender = (Component)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
            const shouldRender = useChoreographedRender({
                messageId: messageId,
                onMessageDisposition: onMessageDisposition
            });
            if (shouldRender) // Need to cast "props" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition"> is the same as T
            return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                ...props
            });
            return null;
        }
        ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
        return ChoreographedComponent;
    };
    const withChoreographedToggle = (Component, toggleableProp)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest }) {
            // Need to cast "rest" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition"> is the same as T
            const props = rest;
            const toggleablePropValue = props[toggleableProp];
            const [shouldRender, setShouldRender] = (0, $gwFzn.useState)(false);
            const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
                start: ()=>setShouldRender(true),
                stop: ()=>setShouldRender(false)
            });
            (0, $gwFzn.useLayoutEffect)(()=>{
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                const stopMessageAsync = async ()=>{
                    const disposition = await stopMessage();
                    onMessageDisposition?.(disposition);
                };
                if (toggleablePropValue && !shouldRender) startMessageAsync();
                else if (!toggleablePropValue && shouldRender) stopMessageAsync();
                return ()=>{
                    if (!toggleablePropValue && shouldRender) stopMessageAsync();
                };
            }, [
                messageId,
                onMessageDisposition,
                shouldRender,
                startMessage,
                stopMessage,
                toggleablePropValue
            ]);
            return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                ...props,
                [toggleableProp]: shouldRender
            });
        }
        return ChoreographedComponent;
    };
    function wrapWithFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $7UHDa.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedRender: withChoreographedRender
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    function wrapWithToggleFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $7UHDa.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    const AutoDismissFlag = wrapWithFactoryFunctions((0, $aK29g.AutoDismissFlag));
    const Banner = wrapWithFactoryFunctions((0, $3uBX0.Banner));
    const Flag = wrapWithFactoryFunctions((0, $c80Ta.Flag));
    const Modal = wrapWithFactoryFunctions((0, $7QPgW.Modal));
    const Popper = wrapWithFactoryFunctions((0, $9OkE6.Popper));
    const Spotlight = wrapWithFactoryFunctions((0, $du0KY.Spotlight));
    const SpotlightCard = wrapWithFactoryFunctions((0, $brlLt.SpotlightCard));
    const InlineDialog = wrapWithToggleFactoryFunctions((0, $e7WW2.InlineDialog));
    // Would ideally like to use wrapWithToggleFactoryFunctions here, but the Popup component's props is a union
    // type, and that for some reason causes ToggleableChoreographerUtilities to be passed through to the
    // consumer-exposed Popup component's prop type, which is not what we want, so we'll just wrap it manually here
    const Popup = function() {
        function WrappedPopup(props) {
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5EcUp.Popup), {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        WrappedPopup.displayName = `ChoreographerFactory(${(0, $5EcUp.Popup).displayName})`;
        return WrappedPopup;
    }();
    // Return these items from the factory function for use within React products
    return {
        plugin: plugin,
        useChoreographer: useChoreographer,
        shouldBeChoreographed: shouldBeChoreographed,
        useChoreographedRender: useChoreographedRender,
        withChoreographedRender: withChoreographedRender,
        withChoreographedToggle: withChoreographedToggle,
        AutoDismissFlag: AutoDismissFlag,
        Banner: Banner,
        Flag: Flag,
        InlineDialog: InlineDialog,
        Modal: Modal,
        Popper: Popper,
        Popup: Popup,
        Spotlight: Spotlight,
        SpotlightCard: SpotlightCard
    };
}

});
parcelRegister("fw9LG", function(module, exports) {

$parcel$export(module.exports, "MessageEventType", () => $b14cc3666efa8496$export$d33b097e0a285bc2);
$parcel$export(module.exports, "MessageDeliveryStatus", () => $b14cc3666efa8496$export$f6a9504bc1305cf0);
$parcel$export(module.exports, "ProductIds", () => $b14cc3666efa8496$export$7fb117db98868be6);
$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $b14cc3666efa8496$export$dbe9e38c9d6f26d0);
$parcel$export(module.exports, "MessageAction", () => $b14cc3666efa8496$export$865c0eaaa43d90f8);
const $b14cc3666efa8496$export$d33b097e0a285bc2 = {
    START: 'start',
    STOP: 'stop'
};
const $b14cc3666efa8496$export$f6a9504bc1305cf0 = {
    BLOCKED: 'blocked',
    CANCELED: 'canceled',
    ERROR: 'error',
    STARTED: 'started',
    STOPPED: 'stopped',
    UNREGISTERED: 'unregistered'
};
var $b14cc3666efa8496$export$7fb117db98868be6 = /*#__PURE__*/ function(ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
    ProductIds["CLOUDADMIN"] = "cloudadmin";
    ProductIds["BITBUCKET"] = "bitbucket";
    ProductIds["POST_OFFICE"] = "post-office";
    return ProductIds;
}({});
const $b14cc3666efa8496$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $b14cc3666efa8496$export$dbe9e38c9d6f26d0 = [
    $b14cc3666efa8496$export$94e85cf3348f045a.ENGAGEMENT,
    $b14cc3666efa8496$export$94e85cf3348f045a.MARKETING
];
const $b14cc3666efa8496$export$865c0eaaa43d90f8 = {
    START: 'messageStart',
    STOP: 'messageStop'
};
const $b14cc3666efa8496$export$fc6a8b8cb405f50 = {
    INFO: 'info',
    VERBOSE: 'verbose'
};

});

parcelRegister("fhmex", function(module, exports) {

$parcel$export(module.exports, "ProductChoreographerPlugin", () => $76b7cc3ac50fdae1$export$44bee9c9373d59fb);

var $9Oif4 = parcelRequire("9Oif4");
class $76b7cc3ac50fdae1$export$44bee9c9373d59fb extends (0, $9Oif4.ChoreographerPlugin) {
    constructor(product, env, metaMetricsData = {}){
        super(product, env, metaMetricsData);
    }
}

});
parcelRegister("9Oif4", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPlugin", () => $39a7bbb2f38c34c0$export$71324a662782c710);

var $a9sR2 = parcelRequire("a9sR2");
var $5DUgU = parcelRequire("5DUgU");

var $6empl = parcelRequire("6empl");
class $39a7bbb2f38c34c0$export$71324a662782c710 {
    /**
   * Public method to clean up this plugin instance, which will handle unregistering it from the choreographer API.
   */ destroy() {
        this.state.unregisterPlugin();
    }
    /**
   * Determines whether this plugin is currently displaying a message on the screen. By default, is a simple boolean
   * toggle that gets flipped back and forth, but it could also be a function that checks the DOM for a given message
   * container to be present, or checks with some external API to tell it whether a message is being displayed, or
   * anything else. The logic is up to the consumer to implement, if something custom is desired.
   *
   * @returns A boolean that represents whether this plugin is currently displaying a message on the screen.
   */ isDisplayingMessage() {
        return this.state.isDisplayingMessage;
    }
    /**
   * Sets the internal isDisplayingMessage state to true, to denote that this plugin is currently blocking the UI.
   */ blockDisplayState() {
        this.state.isDisplayingMessage = true;
    }
    /**
   * Sets the internal isDisplayingMessage state to false, to denote that this plugin is no longer blocking the UI.
   */ clearDisplayState() {
        this.state.isDisplayingMessage = false;
    }
    /**
   * Disables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ disable() {
        this.state.isDisabled = true;
    }
    /**
   * Enables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ enable() {
        this.state.isDisabled = false;
    }
    /**
   * Makes a request to start a message through the choreographer API. Will immediately return false if this plugin
   * is currently in a disabled state, and will otherwise return the ultimate result of the startMessage request.
   *
   * @param messageId The messageId for the message to be started through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message start request
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(messageId, additionalData = {}) {
        return (0, $6empl.Choreographer).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        }, this);
    }
    /**
   * Makes a request to stop a message through the choreographer API. Will return the ultimate result of the stopMessage request.
   *
   * @param messageId The messageId for the message to be stopped through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message stop request
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(messageId, additionalData = {}) {
        return (0, $6empl.Choreographer).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        });
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   */ on(messageId, options = {}) {
        return (0, $6empl.Choreographer).getInstance().on(this.state.productId, messageId, options, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   */ onStart(messageId, startCallback) {
        return (0, $6empl.Choreographer).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   */ onStop(messageId, stopCallback) {
        return (0, $6empl.Choreographer).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for unsubscribing this message subscription.
   */ off(messageId) {
        return (0, $6empl.Choreographer).getInstance().off(this.state.productId, messageId);
    }
    /**
   * Registers this plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId) {
        return (0, $6empl.Choreographer).getInstance().registerPlugin(productId, this);
    }
    /**
   * Creates a new instance of the Analytics Web Client for a plugin to use for sending analytics events.
   *
   * @param env environment type used to create the analytics client
   * @returns AnalyticsWebClient instance
   */ createAnalyticsClient(env) {
        const analyticsClient = new (0, $a9sR2.default)({
            env: env,
            product: 'postOffice',
            origin: (0, $5DUgU.originType).WEB
        });
        return analyticsClient;
    }
    /**
   * Instantiates a plugin to be used with the main choreographer API. Requires a productId string
   * to be used for segmenting registered messageIds in other parts of the API, which ensures uniqueness
   * between individual products for tracking purposes.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @param env The environment type for the product, to be used for analytics events.
   * @param metaMetricsData An object containing additional metadata to be sent along with every message request.
   * @returns A new instance of this plugin to use for integrating a 1P or 3P product with the choreographer API.
   */ constructor(productId, env, metaMetricsData = {}){
        this.state = void 0;
        this.analyticsClient = void 0;
        this.finalizers = void 0;
        this.state = {
            isDisabled: false,
            isDisplayingMessage: false,
            metaMetricsData: metaMetricsData,
            productId: productId,
            unregisterPlugin: ()=>{}
        };
        this.analyticsClient = this.createAnalyticsClient(env);
        /**
     * These finalizers are callbacks to be invoked after a valid start or stop request in the Choreographer core.
     * Declaring them in the constructor because it's the same onStart/onStop pair that will be passed ot all of the
     * .on, .onStart, and .onStop function registrations.
     *
     * This behavior used to be managed by a decorator function that would auto-set the isDisplayingMessage value
     * whenever its start or stop callbacks were invoked. However, those start and stop callbacks are optional from
     * this layer, so if a consumer did *not* register a stop callback, the display state would never be cleared here
     * in the plugin, and would continue blocking messages.
     *
     * We're now passing these onStart and onStop callbacks as part of the message registration, so that any time a
     * message is started or stopped at the core layer, we can fire these callbacks to update the plugin's local state,
     * whether or not an actual start or stop callback was registered by the consumer.
     */ this.finalizers = {
            onStart: ()=>this.blockDisplayState(),
            onStop: ()=>this.clearDisplayState()
        };
        this.state.unregisterPlugin = this.registerPlugin(productId);
    }
}

});
parcelRegister("6empl", function(module, exports) {

$parcel$export(module.exports, "Choreographer", () => $b27cd53e8327a957$export$236158f15971c92e);

var $fw9LG = parcelRequire("fw9LG");

var $9gzc5 = parcelRequire("9gzc5");

var $B8oFf = parcelRequire("B8oFf");

var $fJEl2 = parcelRequire("fJEl2");
// This timeout is used for any long-running messages that are either stuck for some reason, or that the user has yet to clear, to ensure that messaging doesn't stay blocked indefinitely
const $b27cd53e8327a957$var$CHOREOGRAPHER_MESSAGE_TTL = 300000; // 5 minute TTL for messages
// Lazily instantiate this the first time it's requested
let $b27cd53e8327a957$var$singleton;
class $b27cd53e8327a957$export$236158f15971c92e {
    /**
   * Static method to create and/or return a singleton of the choreographer API.
   *
   * @returns Shared instance of choreographer API.
   */ static getInstance() {
        if (!$b27cd53e8327a957$var$singleton) $b27cd53e8327a957$var$singleton = new this();
        return $b27cd53e8327a957$var$singleton;
    }
    stopCurrentMessage() {
        if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, this.state.currentMessage.plugin, true).then(()=>{
            // Manually clear the message TTL and reenable plugins here just in case the unregistered plugin's message denied the
            // stop request. We may still get a collision on-screen, but we're considering the message forcibly stopped at this
            // point, so need to allow new requests.
            this.clearMessageTtl();
            this.enablePlugins();
        });
    }
    /**
   * Enables the message queue, and logs which message everybody else is queueing up behind.
   *
   * @param productId Unique identifier for the product making the current startMessage request blocking others.
   * @param messageId Unique identifier for the messageId blocking others.
   */ queueMessages(productId, messageId) {
        this.state.shouldQueueMessages = true;
        this.state.queueingBehindMessage = {
            productId: productId,
            messageId: messageId,
            timestamp: Date.now()
        };
    }
    /**
   * Pushes all data associated with a startMessage request onto an internal queue, to potentially be processed at a later time.
   * If a pending message request opts out (or otherwise fails to start), this data will be used to reinitiate the startMessage
   * request for this message request instance. Returns a Promise that the caller can await as normal, and which will eventually
   * either be resolved as 'blocked' if any prior pending message is started, or will be resolved with its eventual outcome when
   * its startMessage request is processed.
   *
   * @param productId Unique identifier for the product making the current startMessage request being queued.
   * @param messageId Unique identifier for the messageId being queued.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
        return new Promise((resolve)=>{
            this.state.messageQueue.push({
                productId: productId,
                messageId: messageId,
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                resolve: resolve
            });
        });
    }
    /**
   * Responsible for pulling a previously queued message request that was received while a message request was already in flight.
   * Shift the first message off the top of the queue, and use the stored resolve function to kickstart another pass through the
   * startMessage function, ultimately resolving with the final disposition of the request. Set the internal state for shouldQueueMessages
   * to false if we're restarting a startMessage request, so that this doesn't get immediately thrown back into the queue. If it
   * makes it through to its start callback being fired, that code will turn the shouldQueueMessages state back on.
   */ processQueuedMessage() {
        const queuedMessage = this.state.messageQueue.shift();
        // Disable the shouldQueueMessages state here. If we have a queued message, it will turn the shouldQueueMessages state back on when it
        // hits the call to its message's startCallback function. Otherwise, the queue is now empty, and we let things process normally.
        this.state.shouldQueueMessages = false;
        // Also null out the queueingBehindMessage value, which will be recreated if/when another message opens the queue below.
        this.state.queueingBehindMessage = null;
        if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
    }
    /**
   * Responsible for flushing out any queued messages and resolving their Promises as "blocked". We don't officially consider a
   * message as "blocked" until one of the prior calls has signaled a valid "started" state. This way, any async callbacks that
   * are in flight can allow additional messages to queue up, and if they eventually opt out, we can move on to the next message
   * in the queue and see if it will signal success. Only when we get a successful start to we consider all queued up messages to
   * be "blocked". Run a loop to shift each of them off of the array and resolve them as blocked, until the array is empty.
   *
   * @param [plugin] An optional plugin instance
   */ destroyMessageQueue(plugin) {
        this.state.shouldQueueMessages = false;
        this.state.queueingBehindMessage = null;
        while(this.state.messageQueue.length > 0){
            const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const actionSubject = (0, $fw9LG.MessageAction).START;
            const logger = new (0, $B8oFf.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
            const debugLogger = new (0, $9gzc5.DebugLogger)(productId, messageId);
            logger.blocked({
                blockedByProductId: this.state.currentMessage?.productId,
                blockedByMessageId: this.state.currentMessage?.messageId
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $fw9LG.MessageDeliveryStatus).BLOCKED,
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                }
            });
            resolve((0, $fw9LG.MessageDeliveryStatus).BLOCKED);
        }
    }
    /**
   * Sets a timeout to auto-expire any messaging that stays open for too long, to prevent messaging from being blocked indefinitely.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param AnalyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   */ setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin) {
        this.state.currentMessage = {
            productId: productId,
            messageId: messageId,
            analyticsClient: analyticsClient,
            metricsData: metricsData,
            plugin: plugin,
            timestamp: Date.now()
        };
        this.state.messageTtl = setTimeout(()=>{
            if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
        }, $b27cd53e8327a957$var$CHOREOGRAPHER_MESSAGE_TTL);
    }
    /**
   * Checks to see if the requesting productId/messageId pair matches the data for the currently-displayed message.
   *
   * @param productId Unique identifier for the product being checked for a current message match.
   * @param messageId Unique identifier for the messageId being checked for a current message match.
   */ isCurrentMessage(productId, messageId) {
        return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
    }
    /**
   * Returns the currentMessage object.
   */ getCurrentMessage() {
        return this.state.currentMessage;
    }
    /**
   * Returns the queueingBehindMessage object.
   */ getCurrentPendingMessage() {
        return this.state.queueingBehindMessage;
    }
    /**
   * Clears the timeout that was established for the currently-displayed message.
   */ clearMessageTtl() {
        this.state.currentMessage = null;
        if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
    }
    /**
   * Disables all plugins that are currently registered with the choreographer, called when a startMessage call is being dispatched.
   *
   * @param [exceptFor] An optional plugin instance.
   */ disablePlugins(exceptFor) {
        this.state.isDisabled = true;
        [
            ...this.state.plugins.values()
        ].forEach((p)=>{
            if (p !== exceptFor) p.disable();
        });
    }
    /**
   * Enables all plugins that are currently registered with the choreographer, called when a matching stopMessage call is successful.
   */ enablePlugins() {
        [
            ...this.state.plugins.values()
        ].forEach((p)=>p.enable());
        this.state.isDisabled = false;
    }
    /**
   * A callback used to remove a plugin from the list of subscribers for the choreographer service.
   *
   * @param productId A unique string representing the plugin to be unregistered from the choreographer API.
   */ unregisterPlugin(productId) {
        // If we're unregistering this productId's plugin, and the currentMessage is from this productId, we need to stop it to clear the choreographer
        if (this.state.currentMessage?.productId === productId) this.stopCurrentMessage();
        this.state.messages.delete(productId);
        this.state.plugins.delete(productId);
    }
    /**
   * Determines whether any message is currently being displayed, by checking its own status and optionally, asking each registered plugin for its individual status.
   *
   * @returns A value reflecting whether a message is currently being displayed on screen.
   */ isDisplayingMessage() {
        return Boolean(this.state.currentMessage || [
            ...this.state.plugins.values()
        ].reduce((isDisplayingMessage, p)=>{
            return isDisplayingMessage || p.isDisplayingMessage();
        }, false));
    }
    /**
   * This function is intended for test cleanup purposes only, *not* to be called by external callers.
   *
   * @ignore
   * @param productId Unique identifier for the product whose messages are being requested
   * @returns A Map of IMessage objects, keyed by unique messageId strings.
   */ getMessages(productId) {
        return this.state.messages.get(productId) ?? new Map();
    }
    /**
   * Requests to start a message via the choreographer service, ensuring only a single message instance at a time on the screen.
   * A successful request will block any other message attempts until such time as the matching stopMessage request is received,
   * or a message TTL timeout has expired.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        if ((0, $fJEl2.isChoreographerSuppressed)()) {
            if (this.hasMessageRecord(productId, messageId)) {
                const message = this.ensureMessageRecord(productId, messageId);
                const didStart = await message.start?.() ?? true;
                if (didStart) {
                    // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                    message.onStart?.();
                    return (0, $fw9LG.MessageDeliveryStatus).STARTED;
                }
                return (0, $fw9LG.MessageDeliveryStatus).CANCELED;
            }
            return (0, $fw9LG.MessageDeliveryStatus).UNREGISTERED;
        }
        const debugLogger = new (0, $9gzc5.DebugLogger)(productId, messageId);
        const actionSubject = (0, $fw9LG.MessageAction).START;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $B8oFf.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            if (!this.hasMessageRecord(productId, messageId)) {
                // Bail early here, before even checking if we're in a queueing situation, or blocked, or anything else
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $fw9LG.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $fw9LG.MessageDeliveryStatus).UNREGISTERED;
            }
            // If we're currently queueing messages, push this one onto the queue and return the new Promise
            if (this.state.shouldQueueMessages) {
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: `queued behind ${this.state.queueingBehindMessage?.productId} ${this.state.queueingBehindMessage?.messageId}`
                    }
                });
                return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
            }
            if (this.state.isDisabled || this.isDisplayingMessage()) {
                logger.blocked({
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $fw9LG.MessageDeliveryStatus).BLOCKED,
                        blockedByProductId: this.state.currentMessage?.productId,
                        blockedByMessageId: this.state.currentMessage?.messageId
                    }
                });
                return (0, $fw9LG.MessageDeliveryStatus).BLOCKED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            this.queueMessages(productId, messageId);
            const didStart = await message.start?.() ?? true;
            if (didStart) {
                // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                message.onStart?.();
                logger.started();
                this.disablePlugins(plugin);
                this.setMessageTtl(productId, messageId, analyticsClient, metricsData);
                // Successfully started the message, flush the queue and mark any pending requests as "blocked"
                this.destroyMessageQueue(plugin);
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $fw9LG.MessageDeliveryStatus).STARTED
                    }
                });
                return (0, $fw9LG.MessageDeliveryStatus).STARTED;
            }
            // Check to see if we have any pending requests in the message queue and attempt to start the next one in line
            this.processQueuedMessage();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $fw9LG.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $fw9LG.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $fw9LG.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $fw9LG.MessageDeliveryStatus).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   * This version of the stopMessage function is private, and only intended to be called internally, so that it can make use of the forceStop parameter without exposing that to external callers.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [forceStop] A boolean to denote whether to forcefully clear the Choreographer's blocked state (used for TTL expiration and unregistering a plugin).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, plugin, forceStop = false) {
        if ((0, $fJEl2.isChoreographerSuppressed)()) {
            if (this.hasMessageRecord(productId, messageId)) {
                const message = this.ensureMessageRecord(productId, messageId);
                const didStop = await message.stop?.() ?? true;
                if (didStop) {
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    message.onStop?.();
                    return (0, $fw9LG.MessageDeliveryStatus).STOPPED;
                }
                return (0, $fw9LG.MessageDeliveryStatus).CANCELED;
            }
            return (0, $fw9LG.MessageDeliveryStatus).UNREGISTERED;
        }
        const debugLogger = new (0, $9gzc5.DebugLogger)(productId, messageId);
        const actionSubject = (0, $fw9LG.MessageAction).STOP;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $B8oFf.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            if (!this.hasMessageRecord(productId, messageId)) {
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $fw9LG.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $fw9LG.MessageDeliveryStatus).UNREGISTERED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            // Enable the message queue *if* the current stopMessage request matches the currentMessage data.
            // Any incoming startMessage requests will be queued while this stopMessage request is in-flight,
            // so that they can be immediately honored if this request comes back successfully.
            if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
            const didStop = await message.stop?.() ?? true;
            // If we're hitting this from stopCurrentMessage, it means either a TTL has expired, or we're
            // unregistering a plugin. We forceStop the choreographer blocked state here, even if the stop
            // callback returned false.We don't want to block the UI indefinitely, we'll just have to risk
            // 1 additional message collision if the current message's stop callback refuses to clear.
            if (didStop || forceStop) {
                if (this.isCurrentMessage(productId, messageId)) {
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    message.onStop?.();
                    // Only log this even if we're stopping the current message, so we have a 1:1 mapping of starts to stops.
                    // If this is a forced stop, log that in the attributes, so we can track those events specifically.
                    // Also log the value of didStop, so we know if this was a rejected stop attempt that *had* to be force stopped.
                    logger.stopped(forceStop ? {
                        forceStop: forceStop,
                        didStop: didStop
                    } : undefined);
                    // Only clear the message TTL and reenable plugins if we're stopping the *current* message
                    this.clearMessageTtl();
                    this.enablePlugins();
                }
                // Check to see if we have any pending requests in the message queue and attempt to start them
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $fw9LG.MessageDeliveryStatus).STOPPED
                    }
                });
                return (0, $fw9LG.MessageDeliveryStatus).STOPPED;
            }
            // Stopping the message failed, so the UI is still intentionally blocked, flush the queue and mark any pending requests as "blocked"
            this.destroyMessageQueue(plugin);
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $fw9LG.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $fw9LG.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $fw9LG.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $fw9LG.MessageDeliveryStatus).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData, plugin);
    }
    /**
   * Registers a plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId Unique identifier to register as the product owner of this plugin.
   * @param plugin A plugin instance to be registered with the choreographer instance.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId, plugin) {
        if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
        this.state.plugins = this.state.plugins.set(productId, plugin);
        if (this.state.isDisabled) plugin.disable();
        return ()=>{
            this.unregisterPlugin(productId);
        };
    }
    /**
   * Validates that a message record is present and ready to be retrieved and/or manipulated.
   * Creates the message instance if it doesn't yet exist, initializing both start and stop callbacks to noop functions.
   *
   * @param productId Unique identifier to retrieve map of IMessage objects.
   * @param messageId Unique identifier for the messageId to be retrieved.
   * @returns IMessage object for the requested productId/messageId combination.
   */ ensureMessageRecord(productId, messageId) {
        let productMessages = this.state.messages.get(productId);
        if (!productMessages) {
            productMessages = new Map();
            this.state.messages.set(productId, productMessages);
        }
        let message = productMessages.get(messageId);
        if (!message) {
            message = {};
            productMessages.set(messageId, message);
        }
        return message;
    }
    /**
   * Checks for the existance of a message record for a given productId/messageId combination.
   *
   * @param productId Unique identifier to check for a map of IMessage objects.
   * @param messageId Unique identifier to check for within the map of productId IMessage objects.
   * @returns Boolean indicating whether or not an IMessage record exists for the requested productId/messageId combination.
   */ hasMessageRecord(productId, messageId) {
        return Boolean(this.state.messages.get(productId)?.has?.(messageId));
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param options An object containing optional start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ on(productId, messageId, options = {}, finalizers = {}) {
        const message = {
            ...this.ensureMessageRecord(productId, messageId),
            ...options,
            ...finalizers
        };
        this.state.messages.get(productId).set(messageId, message);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStart(productId, messageId, startCallback, finalizers) {
        this.on(productId, messageId, {
            start: startCallback
        }, finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStop(productId, messageId, stopCallback, finalizers = {}) {
        this.on(productId, messageId, {
            stop: stopCallback
        }, finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for unsubscribing this message.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for unsubscribing this message.
   */ off(productId, messageId) {
        this.state.messages.get(productId)?.delete?.(messageId);
    }
    constructor(){
        this.state = void 0;
        this.state = {
            currentMessage: null,
            isDisabled: false,
            messages: new Map(),
            messageQueue: [],
            messageTtl: null,
            plugins: new Map(),
            queueingBehindMessage: null,
            shouldQueueMessages: false
        };
    }
}

});
parcelRegister("9gzc5", function(module, exports) {

$parcel$export(module.exports, "DebugLogger", () => $c9e657d0e8c68e56$export$21e6cc849c1dc1ab);
function $c9e657d0e8c68e56$var$getCurrentLoggingLevel() {
    return window.choreographerLoggingLevel;
}
function $c9e657d0e8c68e56$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
    if ($c9e657d0e8c68e56$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.table(data);
}
function $c9e657d0e8c68e56$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
    if ($c9e657d0e8c68e56$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
}
class $c9e657d0e8c68e56$export$21e6cc849c1dc1ab {
    constructor(productId, messageId){
        this.state = void 0;
        /**
     * A function that takes an object of properties for each logging level
     * name, e.g. log.info and log.verbose, which are functions that take an
     * object of any key/value pairs, which will be merged with the productId
     * and the messageId values passed to the constructor, and output via
     * console.table.
     *
     * Example: debugLogger.log({
     *   info: { foo: true },
     *   verbose: {
     *     foo: true,
     *     bar: 123,
     *     baz 'abc',
     *     timestamp: performance.now()
     *   },
     * });
     *
     * @param messages Record<LoggingLevels, Record<string, unknown>> An object
     * keyed by the desired log-level, with each value being an object of any
     * key/value pairs to be output to console.table.
     */ this.log = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $c9e657d0e8c68e56$var$logMessageIfValidLoggingLevel(loggingLevel, {
                    productId: this.state.productId,
                    messageId: this.state.messageId,
                    ...messages[loggingLevel] ?? {},
                    ...loggingLevel === 'verbose' ? {
                        timestamp: performance.now()
                    } : {}
                });
            });
        };
        /**
     * A function that takes an object of properties for each logging level
     * name, e.g. trace.info and trace.verbose, which are functions that take
     * a string to be used as the label for a stack trace via console.trace.
     *
     * Example: debugLogger.trace({
     *   info: 'This is a stack trace',
     *   verbose: `This is a stack trace with a much more verbose message which
     * contains data about the ${productId} and ${messageId} within my function,
     * invoked at ${performance.now()}ms`,
     * });
     *
     * @param messages Record<LoggingLevels, string> An object keyed by the
     * desired log-level, with each value being a string to be output as the
     * label to console.trace.
     */ this.trace = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $c9e657d0e8c68e56$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === 'verbose' ? ` (${performance.now()})` : ''}`);
            });
        };
        this.state = {
            productId: productId,
            messageId: messageId
        };
    }
}

});

parcelRegister("B8oFf", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $de1f89189bfc70dc$export$efa9a398d6368992);

var $fw9LG = parcelRequire("fw9LG");
class $de1f89189bfc70dc$export$efa9a398d6368992 {
    /**
   * Send operational event to the Analytics web client for logging/metrics.
   *
   * @param action A (MessageDeliveryStatuses) string denoting the ultimate disposition of this message start or stop request.
   */ sendOperationalEvent(action, additionalAttributes) {
        const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes, plugin: plugin } = this.state;
        const event = {
            source: 'choreographer',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes ?? {},
                ...additionalAttributes ?? {}
            },
            tags: [
                'postOffice'
            ]
        };
        if (plugin?.shouldLogEvent?.(event) ?? true) analyticsClient.sendOperationalEvent(event);
    }
    blocked(additionalAttributes) {
        this.sendOperationalEvent((0, $fw9LG.MessageDeliveryStatus).BLOCKED, additionalAttributes);
    }
    error(additionalAttributes) {
        this.sendOperationalEvent((0, $fw9LG.MessageDeliveryStatus).ERROR, additionalAttributes);
    }
    unregistered(additionalAttributes) {
        this.sendOperationalEvent((0, $fw9LG.MessageDeliveryStatus).UNREGISTERED, additionalAttributes);
    }
    started(additionalAttributes) {
        this.sendOperationalEvent((0, $fw9LG.MessageDeliveryStatus).STARTED, additionalAttributes);
    }
    stopped(additionalAttributes) {
        this.sendOperationalEvent((0, $fw9LG.MessageDeliveryStatus).STOPPED, additionalAttributes);
    }
    /**
   * Utility class to simplify and allow for wider use of sending operational event to the Analytics web client for logging/metrics.
   *
   * @param actionSubject A (MessageActions) string denoting either the start or stop phase of a message.
   * @param actionSubjectId Unique messageId to be logged with this even.
   * @param metricsData Additional data from plugin to be sent with event for metrics logging.
   * @param analyticsClient An instance of AnalyticsWebClient, unique to each caller
   * @param [plugin] An optional plugin instance.
   */ constructor(actionSubject, actionSubjectId, metricsData, analyticsClient, plugin){
        this.state = void 0;
        this.state = {
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            metricsData: metricsData,
            analyticsClient: analyticsClient,
            plugin: plugin
        };
    }
}

});

parcelRegister("fJEl2", function(module, exports) {

$parcel$export(module.exports, "isChoreographerSuppressed", () => $f1ec1dd6a07d3253$export$a0c8fa5038db1b93);

var $c6GJD = parcelRequire("c6GJD");
function $f1ec1dd6a07d3253$export$a0c8fa5038db1b93() {
    return (0, $c6GJD.default).initializeCompleted() && (0, $c6GJD.default).getExperimentValue('post-office_ipm_choreographer_new_tenants', 'supressChoreographer', false);
}

});




parcelRegister("aK29g", function(module, exports) {

$parcel$export(module.exports, "AutoDismissFlag", () => $b19b0d58a00642e5$export$9879a8e0db317538);

var $aD1SW = parcelRequire("aD1SW");

var $6sxJX = parcelRequire("6sxJX");
const $b19b0d58a00642e5$export$9879a8e0db317538 = (0, $6sxJX.wrapComponentForChoreographer)((0, $aD1SW.default));

});
parcelRegister("6sxJX", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $bdcfd05ec26a65b1$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "wrapComponentForChoreographer", () => $bdcfd05ec26a65b1$export$51d40de083bcc6e7);
$parcel$export(module.exports, "wrapToggleableComponentForChoreographer", () => $bdcfd05ec26a65b1$export$7c574bc7a8b74124);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fw9LG = parcelRequire("fw9LG");
const $bdcfd05ec26a65b1$export$a8ba9111c7eec9ac = (props, coordinationOptions)=>{
    return Boolean(coordinationOptions?.enableChoreographer) && props?.messageType !== undefined && (0, $fw9LG.IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
};
const $bdcfd05ec26a65b1$export$51d40de083bcc6e7 = (Component)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedRender: withChoreographedRender, ...props }) {
        const ChoreographedComponent = (0, $gwFzn.useMemo)(()=>withChoreographedRender(Component), [
            withChoreographedRender
        ]);
        if (shouldBeChoreographedProp(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, $7UHDa.jsx)(ChoreographedComponent, {
                ...rest
            });
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
            ...rest
        });
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};
const $bdcfd05ec26a65b1$export$7c574bc7a8b74124 = (Component, toggleableProp)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedToggle: withChoreographedToggle, ...props }) {
        const ChoreographedComponent = (0, $gwFzn.useMemo)(()=>withChoreographedToggle(Component, toggleableProp), [
            withChoreographedToggle
        ]);
        if (shouldBeChoreographedProp(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, $7UHDa.jsx)(ChoreographedComponent, {
                ...rest
            });
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
            ...rest
        });
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};

});


parcelRegister("3uBX0", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $7fb5c97ca53d1775$export$3b4e64e77073e307);

var $15EjN = parcelRequire("15EjN");

var $6sxJX = parcelRequire("6sxJX");
const $7fb5c97ca53d1775$export$3b4e64e77073e307 = (0, $6sxJX.wrapComponentForChoreographer)((0, $15EjN.default));

});
parcelRegister("15EjN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae6f75ae0a49f00d$export$2e2bcd8739ae039);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
const $ae6f75ae0a49f00d$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $ae6f75ae0a49f00d$var$inlineStyles = {
    root: "_1ul9idpf"
};
const $ae6f75ae0a49f00d$var$textStyles = {
    root: "_11c82smr _1reo15vq _18m915vq _syaz12s4 _k48p1wq8 _1bto1l2s _o5721q9c _593818uv _7hxb18uv _9m7f18uv _rfqo18uv _qfs118uv _yha28stv _15zv8stv _w7sw8stv _1bgk8stv _s41o8stv _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _43ds1r31 _p03c1r31 _oavv1r31 _oxk41r31 _1cay1r31"
};
const $ae6f75ae0a49f00d$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $ae6f75ae0a49f00d$var$tokenBackgroundColors = {
    warning: "var(--ds-background-warning-bold, #F5CD47)",
    error: "var(--ds-background-danger-bold, #C9372C)",
    announcement: "var(--ds-background-neutral-bold, #44546F)"
};
const $ae6f75ae0a49f00d$var$tokenTextColors = {
    warning: "var(--ds-text-warning-inverse, #172B4D)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    announcement: "var(--ds-text-inverse, #FFFFFF)"
};
const $ae6f75ae0a49f00d$var$containerStyles = {
    root: "_4t3i1wto _4cvr1h6o _1e0c1txw"
};
const $ae6f75ae0a49f00d$var$iconWrapperStyles = {
    root: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s _1o9zidpf"
};
const $ae6f75ae0a49f00d$var$Banner = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $ae6f75ae0a49f00d$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $ae6f75ae0a49f00d$var$containerStyles.root,
        backgroundColor: $ae6f75ae0a49f00d$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $ae6f75ae0a49f00d$var$inlineStyles.root,
            children: [
                icon ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $ae6f75ae0a49f00d$var$iconWrapperStyles.root,
                    style: {
                        fill: $ae6f75ae0a49f00d$var$tokenBackgroundColors[appearanceType],
                        color: $ae6f75ae0a49f00d$var$tokenTextColors[appearanceType]
                    },
                    children: icon
                }) : null,
                /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                    style: {
                        [$ae6f75ae0a49f00d$var$CSS_VAR_TEXT_COLOR]: $ae6f75ae0a49f00d$var$tokenTextColors[appearanceType]
                    },
                    className: (0, $35pXk.default)([
                        $ae6f75ae0a49f00d$var$textStyles.root
                    ]),
                    children: children
                })
            ]
        })
    });
});
var $ae6f75ae0a49f00d$export$2e2bcd8739ae039 = $ae6f75ae0a49f00d$var$Banner;

});


parcelRegister("c80Ta", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $4d9494329fe7700e$export$48ea269755562084);

var $eCEXz = parcelRequire("eCEXz");

var $6sxJX = parcelRequire("6sxJX");
const $4d9494329fe7700e$export$48ea269755562084 = (0, $6sxJX.wrapComponentForChoreographer)((0, $eCEXz.default));

});

parcelRegister("e7WW2", function(module, exports) {

$parcel$export(module.exports, "InlineDialog", () => $cca4986a061dde06$export$c7313f750e9cbc9d);

var $hPd3F = parcelRequire("hPd3F");

var $6sxJX = parcelRequire("6sxJX");
const $cca4986a061dde06$export$c7313f750e9cbc9d = (0, $6sxJX.wrapToggleableComponentForChoreographer)((0, $hPd3F.default), 'isOpen');

});
parcelRegister("hPd3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c1ccf76fa34aae8$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $gxtzC = parcelRequire("gxtzC");

var $ee7An = parcelRequire("ee7An");

var $iug2J = parcelRequire("iug2J");
var $16xFS = parcelRequire("16xFS");

var $dh538 = parcelRequire("dh538");

var $2ED7Q = parcelRequire("2ED7Q");
var $lqsSp = parcelRequire("lqsSp");
var $epI1O = parcelRequire("epI1O");

var $f47zb = parcelRequire("f47zb");

var $9ca29 = parcelRequire("9ca29");
const $9c1ccf76fa34aae8$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $9c1ccf76fa34aae8$var$checkIsChildOfPortal(node.parentElement);
};
// Close manager for layering
const $9c1ccf76fa34aae8$var$CloseManager = ({ handleEscapeClose: handleEscapeClose, handleClick: handleClick })=>{
    (0, $16xFS.useCloseOnEscapePress)({
        onClose: handleEscapeClose
    });
    const { isLayerDisabled: isLayerDisabled } = (0, $16xFS.useLayering)();
    (0, $gwFzn.useEffect)(()=>{
        return (0, $d8F95.bind)(window, {
            type: 'click',
            listener: (e)=>{
                if (isLayerDisabled()) return;
                handleClick(e);
            },
            options: {
                capture: true
            }
        });
    }, [
        handleClick,
        isLayerDisabled
    ]);
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {});
};
const $9c1ccf76fa34aae8$var$InlineDialog = /*#__PURE__*/ (0, $gwFzn.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $ee7An.default), onContentClick: onContentClick = (0, $ee7An.default), onContentFocus: onContentFocus = (0, $ee7An.default), onClose: providedOnClose = (0, $ee7An.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children, fallbackPlacements: fallbackPlacements }) {
    const containerRef = (0, $gwFzn.useRef)(null);
    const triggerRef = (0, $gwFzn.useRef)(null);
    const onClose = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $gwFzn.useRef)(onClose);
    (0, $gwFzn.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $gwFzn.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isOpen) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($9c1ccf76fa34aae8$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isOpen
    ]);
    const handleClick = (0, $gwFzn.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        if (containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        containerRef,
        triggerRef
    ]);
    /**
   * Auto-flip is enabled by default in `@atlaskit/popper` and
   * the `InlineDialog` API does not allow disabling it.
   *
   * We only need to override it if there are `fallbackPlacements` specified.
   */ const modifiers = (0, $gwFzn.useMemo)(()=>fallbackPlacements ? [
            {
                name: 'flip',
                options: {
                    fallbackPlacements: fallbackPlacements
                }
            }
        ] : [], [
        fallbackPlacements
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lqsSp.Popper), {
        placement: placement,
        strategy: strategy,
        modifiers: modifiers,
        children: ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $9ca29.Container), {
                onBlur: onContentBlur,
                onFocus: onContentFocus,
                onClick: onContentClick,
                ref: (node)=>{
                    if (node) {
                        containerRef.current = node;
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                    }
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                testId: testId,
                children: typeof content === 'function' ? content() : content
            })
    }) : null;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2ED7Q.Manager), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epI1O.Reference), {
                children: ({ ref: ref })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $f47zb.default), {
                        innerRef: (node)=>{
                            triggerRef.current = node;
                            if (typeof ref === 'function') ref(node);
                            else ref.current = node;
                        },
                        hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_portal_logic_r18_fix'),
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                            children: children
                        })
                    })
            }),
            isOpen ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $iug2J.Layering), {
                isDisabled: false,
                children: [
                    popper,
                    /*#__PURE__*/ (0, $7UHDa.jsx)($9c1ccf76fa34aae8$var$CloseManager, {
                        handleEscapeClose: handleCloseRequest,
                        handleClick: handleClick
                    })
                ]
            }) : popper
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9c1ccf76fa34aae8$export$2e2bcd8739ae039 = $9c1ccf76fa34aae8$var$InlineDialog;

});
parcelRegister("f47zb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca101c266866ff4c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dlAOT = parcelRequire("dlAOT");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $ca101c266866ff4c$var$NodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dlAOT))), {
        innerRef: innerRef,
        children: children
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: (node)=>{
            innerRef(node?.firstElementChild);
        },
        children: children
    });
};
var $ca101c266866ff4c$export$2e2bcd8739ae039 = $ca101c266866ff4c$var$NodeResolverWrapper;

});

parcelRegister("9ca29", function(module, exports) {

$parcel$export(module.exports, "Container", () => $d578f7e8fcdfb2c7$export$42a852a2b6b56249);
/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $d578f7e8fcdfb2c7$var$CSS_THEME_BACKGROUND = '--theme-background';
const $d578f7e8fcdfb2c7$var$CSS_THEME_COLOR = '--theme-color';
const $d578f7e8fcdfb2c7$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $d578f7e8fcdfb2c7$var$containerStyles = null;
const $d578f7e8fcdfb2c7$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        style: {
            [$d578f7e8fcdfb2c7$var$CSS_THEME_BACKGROUND]: "var(--ds-surface-overlay, #FFFFFF)",
            [$d578f7e8fcdfb2c7$var$CSS_THEME_COLOR]: "var(--ds-text, #172B4D)",
            [$d578f7e8fcdfb2c7$var$CSS_THEME_BOX_SHADOW]: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            ...style
        },
        className: (0, $35pXk.default)([
            "_11q7gluh _2rko1sit _vchh18uv _p12flti4 _c71llti4 _1pbyowjs _16qs1r44 _syazjslb _85i5pxbi _1q51pxbi _y4ti1ejb _bozg1ejb _nt751r31 _49pcglyw _1hvw1o36"
        ]),
        children: typeof children === 'function' ? children() : children
    });
});

});



parcelRegister("7QPgW", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $2aa064f91d3e3a1e$export$2b77a92f1a5ad772);

var $ekolh = parcelRequire("ekolh");

var $6sxJX = parcelRequire("6sxJX");
const $2aa064f91d3e3a1e$export$2b77a92f1a5ad772 = (0, $6sxJX.wrapComponentForChoreographer)((0, $ekolh.default));

});

parcelRegister("9OkE6", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $468edaccd0529729$export$badac9ada3a0bdf9);

var $lqsSp = parcelRequire("lqsSp");

var $6sxJX = parcelRequire("6sxJX");
const $468edaccd0529729$export$badac9ada3a0bdf9 = (0, $6sxJX.wrapComponentForChoreographer)((0, $lqsSp.Popper));

});

parcelRegister("5EcUp", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $d13ffcfee2ff3666$export$129a32eedafa97c5);
parcelRequire("lGgRw");
var $2mqmH = parcelRequire("2mqmH");

var $6sxJX = parcelRequire("6sxJX");
const $d13ffcfee2ff3666$export$129a32eedafa97c5 = (0, $6sxJX.wrapToggleableComponentForChoreographer)((0, $2mqmH.Popup), 'isOpen');

});

parcelRegister("du0KY", function(module, exports) {

$parcel$export(module.exports, "Spotlight", () => $e745bdec4f55f1ed$export$1033c28b5e1c2deb);

var $5RBJ9 = parcelRequire("5RBJ9");

var $6sxJX = parcelRequire("6sxJX");
const $e745bdec4f55f1ed$export$1033c28b5e1c2deb = (0, $6sxJX.wrapComponentForChoreographer)((0, $5RBJ9.default));

});
parcelRegister("5RBJ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7334bd40f3f3a2f6$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dZJ5U = parcelRequire("dZJ5U");

var $6cnUO = parcelRequire("6cnUO");
/**
 * __Spotlight__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $7334bd40f3f3a2f6$var$Spotlight = ({ actions: actions, actionsBeforeElement: actionsBeforeElement, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth = 400, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label, pulse: pulse = true, scrollPositionBlock: scrollPositionBlock, shouldWatchTarget: shouldWatchTarget = false, target: target, targetBgColor: targetBgColor, targetNode: targetNode, targetOnClick: targetOnClick, targetRadius: targetRadius, targetReplacement: targetReplacement, testId: testId = 'spotlight', titleId: titleId, ...rest })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6cnUO.SpotlightConsumer), {
        children: ({ opened: opened, closed: closed, targets: targets })=>{
            // use the targetNode prop or try get the target from context targets using name
            const actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
            return actualTargetNode ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dZJ5U.default), {
                ...rest,
                actions: actions,
                actionsBeforeElement: actionsBeforeElement,
                children: children,
                dialogPlacement: dialogPlacement,
                dialogWidth: dialogWidth,
                footer: footer,
                header: header,
                heading: heading,
                headingAfterElement: headingAfterElement,
                image: image,
                label: label,
                onClosed: closed,
                onOpened: opened,
                pulse: pulse,
                scrollPositionBlock: scrollPositionBlock,
                shouldWatchTarget: shouldWatchTarget,
                target: target,
                targetBgColor: targetBgColor,
                targetNode: actualTargetNode,
                targetOnClick: targetOnClick,
                targetRadius: targetRadius,
                targetReplacement: targetReplacement,
                testId: testId,
                titleId: titleId
            }) : null;
        }
    });
var $7334bd40f3f3a2f6$export$2e2bcd8739ae039 = $7334bd40f3f3a2f6$var$Spotlight;

});
parcelRegister("dZJ5U", function(module, exports) {

$parcel$export(module.exports, "default", () => $979e9e34546576db$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fw2Qu = parcelRequire("fw2Qu");

var $5KDDn = parcelRequire("5KDDn");

var $fFxV1 = parcelRequire("fFxV1");

var $iug2J = parcelRequire("iug2J");

var $dh538 = parcelRequire("dh538");

var $caX7N = parcelRequire("caX7N");

var $boO6R = parcelRequire("boO6R");

var $eUuZn = parcelRequire("eUuZn");

var $kMfDl = parcelRequire("kMfDl");

var $9f9th = parcelRequire("9f9th");

var $bZzGh = parcelRequire("bZzGh");

var $2Fndw = parcelRequire("2Fndw");
/**
 * __Spotlight inner__
 *
 * Renders the spotlight target clone and dialog.
 *
 * @internal
 */ class $979e9e34546576db$var$SpotlightInner extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.targetNode !== this.props.targetNode) (0, $fFxV1.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
    }
    componentDidMount() {
        (0, $fFxV1.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
        this.props.onOpened();
    }
    componentWillUnmount() {
        this.props.onClosed();
    }
    render() {
        const { pulse: pulse, shouldWatchTarget: shouldWatchTarget, target: target, targetNode: targetNode, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetRadius: targetRadius, testId: testId, targetReplacement: TargetReplacement } = this.props;
        const { replacementElement: replacementElement } = this.state;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Fndw.SpotlightTransitionConsumer), {
            children: ({ isOpen: isOpen, onExited: onExited })=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $caX7N.default), {
                    zIndex: 701,
                    children: [
                        TargetReplacement ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9f9th.default), {
                            hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                            innerRef: (elem)=>this.setState({
                                    replacementElement: elem
                                }),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $boO6R.ElementBox), {
                                element: targetNode,
                                resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                                children: (box)=>/*#__PURE__*/ (0, $7UHDa.jsx)(TargetReplacement, {
                                        "data-testid": `${testId}--target`,
                                        ...this.getTargetNodeStyle(box)
                                    })
                            })
                        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $boO6R.ElementBox), {
                            element: targetNode,
                            resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                            children: (box)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $kMfDl.default), {
                                    shouldWatch: shouldWatchTarget,
                                    testId: `${testId}--target`,
                                    pulse: pulse,
                                    target: target,
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                    style: this.getTargetNodeStyle(box),
                                    targetBgColor: targetBgColor,
                                    targetNode: targetNode,
                                    targetOnClick: targetOnClick,
                                    targetRadius: targetRadius
                                })
                        }),
                        TargetReplacement && !replacementElement ? null : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eUuZn.Fade), {
                            hasEntered: isOpen,
                            onExited: onExited,
                            children: (animationStyles)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iug2J.Layering), {
                                    isDisabled: false,
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bZzGh.default), {
                                        testId: `${testId}--dialog`,
                                        actions: this.props.actions,
                                        actionsBeforeElement: this.props.actionsBeforeElement,
                                        children: this.props.children,
                                        dialogPlacement: this.props.dialogPlacement,
                                        dialogWidth: this.props.dialogWidth,
                                        footer: this.props.footer,
                                        header: this.props.header,
                                        heading: this.props.heading,
                                        titleId: this.props.titleId,
                                        label: this.props.label,
                                        headingAfterElement: this.props.headingAfterElement,
                                        image: this.props.image,
                                        targetNode: replacementElement || targetNode,
                                        animationStyles: animationStyles
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5KDDn))), {})
                    ]
                })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            // This is only used when targetReplacement is specified.
            // In this case, we have to render the targetReplacement component,
            // get a dom reference from that component, then render again passing
            // that reference into SpotlightDialog (Popper).
            replacementElement: null
        };
        this.getTargetNodeStyle = (box)=>{
            if (!(0, $fw2Qu.canUseDOM)) return {};
            const { height: height, left: left, top: top, width: width, ...rest } = box;
            return {
                // Handling this just in case there are invalid elements being sent in to
                // the `box` arg
                ...rest,
                height: height,
                left: left,
                top: top,
                width: width,
                position: 'fixed',
                // when width is 0, set visibility hidden to avoid the target flashing issue
                ...width === 0 && (0, $dh538.fg)('scroll-lock-replacement') && {
                    visibility: 'hidden'
                }
            };
        };
    }
}
$979e9e34546576db$var$SpotlightInner.defaultProps = {
    dialogWidth: 400,
    pulse: true
};
var $979e9e34546576db$export$2e2bcd8739ae039 = $979e9e34546576db$var$SpotlightInner;

});
parcelRegister("boO6R", function(module, exports) {

$parcel$export(module.exports, "ElementBox", () => $9c7b365b14a69429$export$1b6719bd7aff3c00);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $dh538 = parcelRequire("dh538");
// The minimum interval between position updates in milliseconds
const $9c7b365b14a69429$var$POSITION_UPDATE_INTERVAL = 200;
const $9c7b365b14a69429$var$getElementRect = (element)=>{
    const { height: height, left: left, top: top, width: width } = element.getBoundingClientRect();
    return {
        height: height,
        left: left,
        top: top,
        width: width
    };
};
const $9c7b365b14a69429$var$useResizeAwareElementBox = (element, updateMethod)=>{
    const [box, setBox] = (0, $gwFzn.useState)({
        width: 0,
        height: 0,
        left: 0,
        top: 0
    });
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (updateMethod === 'resizeListener') {
            if ((0, $dh538.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                setBox($9c7b365b14a69429$var$getElementRect(element));
            }, 0);
            else setBox($9c7b365b14a69429$var$getElementRect(element));
        }
    }, [
        element,
        updateMethod
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const onResize = ()=>{
            requestAnimationFrame(()=>{
                setBox($9c7b365b14a69429$var$getElementRect(element));
            });
        };
        if (updateMethod === 'resizeListener') return (0, $d8F95.bind)(window, {
            type: 'resize',
            listener: onResize
        });
    }, [
        element,
        updateMethod
    ]);
    return box;
};
const $9c7b365b14a69429$var$usePollingElementBox = (element, updateMethod)=>{
    // These are intentionally tracked as number primitives rather than as a shared `box` object.
    // Since the requestAnimationFrame code below updates this often, we want to avoid re-renders
    // when the values are the same.  React uses `Object.is` to figure out if the state changed after a setState.
    // If we represent this as a shared `box` object, this will re-render even if the two objects have identical contents.
    const [width, setWidth] = (0, $gwFzn.useState)(0);
    const [height, setHeight] = (0, $gwFzn.useState)(0);
    const [left, setLeft] = (0, $gwFzn.useState)(0);
    const [top, setTop] = (0, $gwFzn.useState)(0);
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (updateMethod === 'polling') {
            if ((0, $dh538.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                const newBox = $9c7b365b14a69429$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }, 0);
            else {
                const newBox = $9c7b365b14a69429$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }
        }
    }, [
        element,
        updateMethod
    ]);
    // Souce: https://css-tricks.com/using-requestanimationframe-with-react-hooks/
    // Use useRef for mutable variables that we want to persist
    // without triggering a re-render on their change
    const requestRef = (0, $gwFzn.useRef)();
    const previousUpdateTimeRef = (0, $gwFzn.useRef)();
    const animate = (0, $gwFzn.useCallback)((time)=>{
        if (previousUpdateTimeRef.current !== undefined) {
            const timeSinceLastUpdate = time - previousUpdateTimeRef.current;
            if (timeSinceLastUpdate > $9c7b365b14a69429$var$POSITION_UPDATE_INTERVAL) {
                const newBox = $9c7b365b14a69429$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
                previousUpdateTimeRef.current = time;
            }
        } else // Initialize previousUpdateTimeRef
        previousUpdateTimeRef.current = time;
        requestRef.current = requestAnimationFrame(animate);
    }, [
        element
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (updateMethod === 'polling') requestRef.current = requestAnimationFrame(animate);
        return ()=>{
            if (requestRef.current !== undefined) cancelAnimationFrame(requestRef.current);
        };
    // This useEffect should only run on mount and when `element` or `updateMethod` changes.
    }, [
        animate,
        element,
        updateMethod
    ]);
    const box = (0, $gwFzn.useMemo)(()=>({
            width: width,
            height: height,
            left: left,
            top: top
        }), [
        width,
        height,
        left,
        top
    ]);
    return box;
};
/**
 * Will listen to the document resizing to see if an element has moved positions.
 * Not using ResizeObserver because of IE11 support.
 * @param element HTMLElement to watch when resizing.
 */ const $9c7b365b14a69429$var$useElementBox = (element, resizeUpdateMethod)=>{
    const updateMethod = resizeUpdateMethod || 'resizeListener';
    const boxViaResizeListener = $9c7b365b14a69429$var$useResizeAwareElementBox(element, updateMethod);
    const boxViaPolling = $9c7b365b14a69429$var$usePollingElementBox(element, updateMethod);
    return updateMethod === 'resizeListener' ? boxViaResizeListener : boxViaPolling;
};
const $9c7b365b14a69429$export$1b6719bd7aff3c00 = (props)=>{
    const box = $9c7b365b14a69429$var$useElementBox(props.element, props.resizeUpdateMethod);
    return props.children(box);
};

});

parcelRegister("eUuZn", function(module, exports) {

$parcel$export(module.exports, "Fade", () => $95532aa7221a8220$export$c983850c6c9d8b0e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $iryfe = parcelRequire("iryfe");

var $dh538 = parcelRequire("dh538");
const $95532aa7221a8220$var$duration = {
    enter: 0,
    exit: 100
};
const $95532aa7221a8220$export$c983850c6c9d8b0e = ({ hasEntered: hasEntered, children: children, onExited: onExited })=>{
    const nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(null);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iryfe.default), {
        in: hasEntered,
        timeout: $95532aa7221a8220$var$duration,
        onExited: onExited,
        unmountOnExit: true,
        appear: true,
        ...(0, $dh538.fg)('platform_design_system_team_transition_group_r18') && {
            nodeRef: nodeRef
        },
        children: (status)=>{
            const anim = {
                entered: {
                    opacity: 1
                },
                exiting: {
                    opacity: 0
                }
            };
            return children({
                transition: `opacity ${$95532aa7221a8220$var$duration.exit}ms`,
                opacity: 0,
                ...status in anim ? anim[status] : {}
            });
        }
    });
};

});

parcelRegister("kMfDl", function(module, exports) {

$parcel$export(module.exports, "default", () => $acd3e7dd0e53336b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1lhEF = parcelRequire("1lhEF");

var $8W99A = parcelRequire("8W99A");
const $acd3e7dd0e53336b$var$computedStyleAttributesToClone = [
    'fontSize',
    'fontWeight',
    'lineHeight',
    'padding',
    'color',
    'textOverflow'
];
function $acd3e7dd0e53336b$var$cloneAndOverrideStyles(node) {
    const shouldCloneChildren = true;
    const clonedNode = node.cloneNode(shouldCloneChildren);
    const computedStyles = getComputedStyle(node);
    $acd3e7dd0e53336b$var$computedStyleAttributesToClone.forEach((attribute)=>{
        clonedNode.style[attribute] = computedStyles[attribute];
    });
    clonedNode.style.margin = '0';
    clonedNode.style.position = 'static';
    // The target may have other transforms applied. Avoid unintended side effects
    // by zeroing out "translate" rather than applying a value of "none".
    clonedNode.style.transform = 'translate(0, 0) translate3d(0, 0, 0)';
    return clonedNode;
}
/**
 * __Clone__
 *
 * Used for cloning spotlight targets. The clone is positioned on top of the spotlight target with
 * a pulsing animation.
 *
 * @internal
 */ const $acd3e7dd0e53336b$var$Clone = (props)=>{
    const { pulse: pulse, style: style, shouldWatch: shouldWatch, target: target, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetNode: targetNode, targetRadius: targetRadius, testId: testId } = props;
    const contentVersion = (0, $8W99A.useElementObserver)(targetNode, {
        disableWatch: !shouldWatch
    });
    const contentHTML = (0, $gwFzn.useMemo)(()=>$acd3e7dd0e53336b$var$cloneAndOverrideStyles(targetNode).outerHTML, // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to update when the content changes
    [
        contentVersion,
        targetNode
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1lhEF.TargetInner), {
        "data-testid": testId,
        pulse: pulse,
        bgColor: targetBgColor,
        radius: targetRadius,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: contentHTML
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    height: '100%',
                    pointerEvents: 'none'
                }
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1lhEF.TargetOverlay), {
                onClick: targetOnClick ? (event)=>targetOnClick({
                        event: event,
                        target: target
                    }) : undefined
            })
        ]
    });
};
var $acd3e7dd0e53336b$export$2e2bcd8739ae039 = $acd3e7dd0e53336b$var$Clone;

});
parcelRegister("1lhEF", function(module, exports) {

$parcel$export(module.exports, "TargetInner", () => $027c081b8a3db08f$export$b1542cc928b93af);
$parcel$export(module.exports, "TargetOverlay", () => $027c081b8a3db08f$export$a28a07e0025d709d);
$parcel$export(module.exports, "Pulse", () => $027c081b8a3db08f$export$927d63e2511364c0);
/* target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $027c081b8a3db08f$var$reduceMotionAsPerUserPreference = null;
// Pulse color "rgb(101, 84, 192)" derived from "colors.P300"
const $027c081b8a3db08f$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #8270DB)"}`;
const $027c081b8a3db08f$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $027c081b8a3db08f$var$pulseKeyframes = null;
const $027c081b8a3db08f$var$animationStyles = null;
const $027c081b8a3db08f$var$Base = ({ bgColor: bgColor, children: children, className: className, radius: radius, testId: testId, style: style, // The rest of these props are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: className,
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style is not allowed at the moment
            ...style,
            backgroundColor: bgColor,
            borderRadius: radius ? `${radius}px` : undefined
        },
        ...props,
        children: children
    }); /**
          * __Target inner__
          *
          * Used to apply spotlight border and pulse to spotlight targets.
          *
          * @internal
          */ 
const $027c081b8a3db08f$export$b1542cc928b93af = ({ bgColor: bgColor, children: children, className: className, pulse: pulse, radius: radius, testId: testId, // Thes rest of these are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)($027c081b8a3db08f$var$Base, {
        bgColor: bgColor,
        className: (0, $35pXk.default)([
            pulse && "",
            pulse && "_5sagi11n _tip812c5 _j7hq1ukm _1pglmcjr _16qs1wx8",
            "_1bumglyw _sedtglyw",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        style: props.style,
        children: children
    });
const $027c081b8a3db08f$var$targetOverlayStyles = null; /**
                                   * __Target overlay__
                                   *
                                   * Overlays a spotlight target, allowing for custom click events that are intended
                                   * only for onboarding.
                                   *
                                   * @internal
                                   */ 
const $027c081b8a3db08f$export$a28a07e0025d709d = ({ onClick: onClick, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        onClick: onClick,
        ...props,
        style: {
            cursor: onClick ? 'pointer' : 'auto'
        },
        className: (0, $35pXk.default)([
            "_1bsb1osq _4t3i1osq _kqswstnw _152tze3t _1e02ze3t"
        ])
    }); /**
                                                                                                     * __Spotlight pulse__
                                                                                                     *
                                                                                                     * A spotlight pulse draws attention to a new feature.
                                                                                                     *
                                                                                                     * - [Examples](https://atlassian.design/components/onboarding/examples)
                                                                                                     * - [Code](https://atlassian.design/components/onboarding/code)
                                                                                                     * - [Usage](https://atlassian.design/components/onboarding/usage)
                                                                                                     */ 
const $027c081b8a3db08f$export$927d63e2511364c0 = ({ bgColor: bgColor, children: children, className: className, radius: radius, pulse: pulse = true, testId: testId, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)($027c081b8a3db08f$var$Base, {
        bgColor: bgColor,
        className: (0, $35pXk.default)([
            pulse && "",
            pulse && "_5sagi11n _tip812c5 _j7hq1ukm _1pglmcjr _16qs1wx8",
            "_1bumglyw _sedtglyw",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        style: props.style,
        children: children
    });

});

parcelRegister("8W99A", function(module, exports) {

$parcel$export(module.exports, "useElementObserver", () => $d6343403a6ef2ee3$export$729bafd4e621fba0);

var $gwFzn = parcelRequire("gwFzn");
function $d6343403a6ef2ee3$export$729bafd4e621fba0(element, opts = {}) {
    const { onChange: onChange, disableWatch: disableWatch = false } = opts;
    // This state is used to force a re-render when the target changes
    const [targetContentVersion, setTargetContentVersion] = (0, $gwFzn.useState)(0);
    const mutationObserver = (0, $gwFzn.useRef)(undefined);
    const cancelIdleCallback1 = (0, $gwFzn.useRef)(undefined);
    const disposer = (0, $gwFzn.useCallback)(()=>{
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = undefined;
        mutationObserver.current?.disconnect();
        mutationObserver.current = undefined;
    }, []);
    const onMutation = (0, $gwFzn.useCallback)(()=>{
        // MutationObserver can make multiple calls to the callback in quick succession so debounce when idle
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = $d6343403a6ef2ee3$var$callWhenIdle(()=>setTargetContentVersion((v)=>{
                const version = v + 1;
                onChange?.(version);
                return version;
            }));
    }, [
        onChange
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // Clean up any existing observer in the case that the target node has changed
        disposer();
        if (!disableWatch && element) {
            mutationObserver.current = new MutationObserver(onMutation);
            mutationObserver.current.observe(element, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        return disposer;
    }, [
        disableWatch,
        disposer,
        element,
        onMutation
    ]);
    return targetContentVersion;
}
/**
 * When the browser is idle call the callback.
 *
 * This function will use `requestIdleCallback` if available, otherwise it will fallback to `setTimeout`.
 *
 * @param callback The function to call when the browser is idle.
 * @param [opts] Options for the idle callback.
 * @param [opts.timeout=100] The maximum time to wait for the browser to be idle.
 *
 * @returns A function that can be called to cancel the idle callback.
 *
 * @internal
 */ function $d6343403a6ef2ee3$var$callWhenIdle(callback, opts = {}) {
    const { timeout: timeout = 100 } = opts;
    if (typeof window.requestIdleCallback === 'function') {
        const idleHandle = window.requestIdleCallback(callback, {
            timeout: timeout
        });
        return ()=>cancelIdleCallback(idleHandle);
    }
    // Fallback to setTimeout if requestIdleCallback is not available
    const timeoutHandle = setTimeout(callback, timeout);
    return ()=>clearTimeout(timeoutHandle);
}

});


parcelRegister("9f9th", function(module, exports) {

$parcel$export(module.exports, "default", () => $449aef48fe228d6d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dlAOT = parcelRequire("dlAOT");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $449aef48fe228d6d$var$NodeResolverSpotlightInner = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    const divRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        if (!hasNodeResolver) innerRef(divRef.current?.firstElementChild);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasNodeResolver
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dlAOT))), {
        innerRef: innerRef,
        children: children
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: divRef,
        children: children
    });
};
var $449aef48fe228d6d$export$2e2bcd8739ae039 = $449aef48fe228d6d$var$NodeResolverSpotlightInner;

});

parcelRegister("bZzGh", function(module, exports) {

$parcel$export(module.exports, "default", () => $086cd565d48ecbc4$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gE0s1 = parcelRequire("gE0s1");

var $lqsSp = parcelRequire("lqsSp");

var $gdv5Z = parcelRequire("gdv5Z");

var $2tfwO = parcelRequire("2tfwO");

var $91xA1 = parcelRequire("91xA1");

var $8d34H = parcelRequire("8d34H");
/**
 * __Spotlight dialog__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $086cd565d48ecbc4$var$SpotlightDialogComponent extends (0, $gwFzn.Component) {
    componentDidMount() {
        this.focusLockTimeoutId = window.setTimeout(()=>{
            // we delay the enabling of the focus lock to avoid the scroll position
            // jumping around in some situations
            this.setState({
                focusLockDisabled: false
            });
        }, 200);
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusLockTimeoutId);
    }
    render() {
        const { actions: actions, actionsBeforeElement: actionsBeforeElement, animationStyles: animationStyles, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label = 'Introducing new feature', titleId: titleId, targetNode: targetNode, testId: testId } = this.props;
        const { focusLockDisabled: focusLockDisabled } = this.state;
        const dialogLabel = !heading && !titleId ? label : undefined;
        const dialogLabelledBy = titleId || (heading ? 'spotlight-dialog-label' : undefined);
        const translatedPlacement = dialogPlacement ? ({
            'top left': 'top-start',
            'top center': 'top',
            'top right': 'top-end',
            'right top': 'right-start',
            'right middle': 'right',
            'right bottom': 'right-end',
            'bottom left': 'bottom-start',
            'bottom center': 'bottom',
            'bottom right': 'bottom-end',
            'left top': 'left-start',
            'left middle': 'left',
            'left bottom': 'left-end'
        })[dialogPlacement] : undefined;
        // If there's no room on either side of the popper, it will extend off-screen.
        //  This looks buggy when scroll-lock and focus is placed on the dialog, so we
        //  customise popper so it overflows the spotlight instead with altAxis=true.
        const modifiers = [
            {
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    rootBoundary: 'document',
                    altAxis: true,
                    tether: false
                }
            }
        ];
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lqsSp.Popper), {
            modifiers: modifiers,
            referenceElement: targetNode,
            placement: translatedPlacement,
            children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $8d34H.default), {
                    value: dialogWidth,
                    onChange: update,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gE0s1.default), {
                        disabled: focusLockDisabled,
                        returnFocus: false,
                        autoFocus: true,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: {
                                ...style,
                                ...animationStyles
                            },
                            ref: ref,
                            "aria-modal": true,
                            role: "dialog",
                            "aria-label": dialogLabel,
                            "aria-labelledby": dialogLabelledBy,
                            testId: `${testId}-container`,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $91xA1.default), {
                                testId: testId,
                                width: dialogWidth,
                                actions: actions,
                                actionsBeforeElement: actionsBeforeElement,
                                image: image && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2tfwO.DialogImage), {
                                    alt: heading,
                                    src: image
                                }),
                                components: {
                                    Header: header,
                                    Footer: footer
                                },
                                heading: heading,
                                headingId: "spotlight-dialog-label",
                                headingAfterElement: headingAfterElement,
                                // This should be heading level 1 since this is technically a modal, including a focus lock on the modal window.
                                // But because it is not a _true_ modal, we are setting it to `2` until that is fixed.
                                headingLevel: 2,
                                children: children
                            })
                        })
                    })
                })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            focusLockDisabled: true
        };
        this.focusLockTimeoutId = void 0;
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$086cd565d48ecbc4$export$2e2bcd8739ae039 = $086cd565d48ecbc4$var$SpotlightDialogComponent;

});
parcelRegister("2tfwO", function(module, exports) {

$parcel$export(module.exports, "DialogImage", () => $3d8bed936bc122c0$export$855e1a47874d6b81);
$parcel$export(module.exports, "DialogActionItemContainer", () => $3d8bed936bc122c0$export$ed9b6b50bbed5f27);
$parcel$export(module.exports, "DialogActionItem", () => $3d8bed936bc122c0$export$6ae54e00f59e1f33);
/* dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $gdv5Z = parcelRequire("gdv5Z");
const $3d8bed936bc122c0$var$imageStyles = null;
const $3d8bed936bc122c0$var$actionItemContainerStyles = {
    root: "_1e0c1txw _2lx21sbv _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr"
};
const $3d8bed936bc122c0$var$actionItemStyles = {
    root: "_6rthze3t _1pfhze3t _12l21b66 _ahbq1b66"
}; /**
    * __Dialog image__
    *
    * An optional header image in spotlight dialogs.
    *
    * @internal
    */ 
const $3d8bed936bc122c0$export$855e1a47874d6b81 = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("img", {
        alt: alt,
        ...props,
        className: (0, $35pXk.default)([
            "_p12f1osq _4t3i1wug"
        ])
    }); /**
                                                                                                                  * __Dialog action item container__
                                                                                                                  *
                                                                                                                  * Flex wrapper around dialog action items.
                                                                                                                  *
                                                                                                                  * @internal
                                                                                                                  */ 
const $3d8bed936bc122c0$export$ed9b6b50bbed5f27 = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $3d8bed936bc122c0$var$actionItemContainerStyles.root,
        children: children
    }); /**
                                                                    * __Dialog action item__
                                                                    *
                                                                    * Action items shown inside of the dialog.
                                                                    *
                                                                    * @internal
                                                                    */ 
const $3d8bed936bc122c0$export$6ae54e00f59e1f33 = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $3d8bed936bc122c0$var$actionItemStyles.root,
        children: children
    });

});

parcelRegister("91xA1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3cd8811b45d4630$export$2e2bcd8739ae039);
/* spotlight-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4KS7f = parcelRequire("4KS7f");
var $boHsq = parcelRequire("boHsq");

var $1Whri = parcelRequire("1Whri");

var $7hXDW = parcelRequire("7hXDW");

var $16xFS = parcelRequire("16xFS");

var $gdv5Z = parcelRequire("gdv5Z");
var $iXCQx = parcelRequire("iXCQx");

var $2tfwO = parcelRequire("2tfwO");

var $9BPJm = parcelRequire("9BPJm");
const $e3cd8811b45d4630$var$bodyStyles = null;
const $e3cd8811b45d4630$var$imageStyles = null;
const $e3cd8811b45d4630$var$defaultHeaderStyles = null;
const $e3cd8811b45d4630$var$DefaultHeader = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            "_1e0c1txw _4cvr1q9y _1bah1yb4 _85i5u2gc"
        ]),
        children: children
    });
const $e3cd8811b45d4630$var$defaultFooterStyles = null;
const $e3cd8811b45d4630$var$DefaultFooter = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": "spotlight--dialog-footer",
        className: (0, $35pXk.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1q51u2gc"
        ]),
        children: children
    });
const $e3cd8811b45d4630$var$containerStyles = {
    root: "_2rkoglpi _1reo1wug _18m91wug _4t3i1ns9 _syaz15cr _1ul91lit _p12f1ogm"
};
const $e3cd8811b45d4630$var$containerShadowStyles = {
    root: "_16qszucj"
}; /**
    * __Spotlight card__
    *
    * A spotlight card is for onboarding messages that need a more flexible layout, or don't require a dialog.
    *
    * - [Examples](https://atlassian.design/components/onboarding/spotlight-card/examples)
    * - [Code](https://atlassian.design/components/onboarding/spotlight-card/code)
    * - [Usage](https://atlassian.design/components/onboarding/spotlight-card/usage)
    */ 
const $e3cd8811b45d4630$var$SpotlightCard = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { actions: actions = [], actionsBeforeElement: actionsBeforeElement, children: children, components: components = {}, heading: heading, headingLevel: headingLevel = 4, headingAfterElement: headingAfterElement, image: image, innerRef: innerRef, isFlat: isFlat, testId: testId, width: width = 400, headingId: headingId } = props;
    const { Header: Header = $e3cd8811b45d4630$var$DefaultHeader, Footer: Footer = $e3cd8811b45d4630$var$DefaultFooter } = components;
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $boHsq.default).Provider, {
        value: (0, $9BPJm.spotlightButtonTheme),
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
            backgroundColor: "color.background.discovery.bold",
            xcss: (0, $1Whri.cx)($e3cd8811b45d4630$var$containerStyles.root, !isFlat && $e3cd8811b45d4630$var$containerShadowStyles.root),
            style: {
                width: width
            },
            ref: ref || innerRef,
            testId: testId,
            "data-ds--level": currentLevel,
            "data-ds--close--type": "single",
            children: [
                typeof image === 'string' ? /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
                    src: image,
                    alt: "",
                    className: (0, $35pXk.default)([
                        "_1e0c1ule"
                    ])
                }) : image,
                /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                    className: (0, $35pXk.default)([
                        "_1e0c1txw _2lx21bp4 _85i5pxbi _1q51pxbi _y4tiv47k _bozgv47k"
                    ]),
                    children: [
                        heading || headingAfterElement ? /*#__PURE__*/ (0, $7UHDa.jsxs)(Header, {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                                    id: headingId,
                                    size: "medium",
                                    as: `h${headingLevel}`,
                                    color: "color.text.inverse",
                                    children: heading
                                }),
                                headingAfterElement
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                            children: children
                        }),
                        actions.length > 0 || actionsBeforeElement ? /*#__PURE__*/ (0, $7UHDa.jsxs)(Footer, {
                            children: [
                                actionsBeforeElement || /*#__PURE__*/ (0, $7UHDa.jsx)("span", {}),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2tfwO.DialogActionItemContainer), {
                                    children: actions.map(({ text: text, key: key, ...rest }, idx)=>{
                                        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2tfwO.DialogActionItem), {
                                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4KS7f.default), {
                                                ...rest,
                                                children: text
                                            })
                                        }, key || (typeof text === 'string' ? text : `${idx}`));
                                    })
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
});
$e3cd8811b45d4630$var$SpotlightCard.displayName = 'SpotlightCard';
var $e3cd8811b45d4630$export$2e2bcd8739ae039 = $e3cd8811b45d4630$var$SpotlightCard;

});
parcelRegister("9BPJm", function(module, exports) {

$parcel$export(module.exports, "spotlightButtonTheme", () => $8861ef687fb5b99a$export$39a36121076ca24);
$parcel$export(module.exports, "modalButtonTheme", () => $8861ef687fb5b99a$export$d131eb21ba4cbd16);
const $8861ef687fb5b99a$var$spotlightTheme = {
    default: {
        background: {
            default: "var(--ds-background-inverse-subtle, #00000029)",
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: "var(--ds-background-disabled, #091E4208)",
            selected: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            focus: "var(--ds-background-inverse-subtle, #00000029)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #091E424F)",
                dark: "var(--ds-text-disabled, #091E424F)"
            },
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: 'none',
            selected: {
                light: "var(--ds-background-selected-hovered, #CCE0FF)",
                dark: "var(--ds-background-selected-hovered, #CCE0FF)"
            },
            focusSelected: {
                light: "var(--ds-background-selected-hovered, #CCE0FF)",
                dark: "var(--ds-background-selected-hovered, #CCE0FF)"
            }
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-disabled, #091E424F)",
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${"var(--ds-text-inverse, #FFFFFF)"}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-discovery, #5E4DB2)",
            selected: "var(--ds-text-selected, #0C66E4)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $8861ef687fb5b99a$var$modalTheme = {
    primary: {
        background: {
            default: "var(--ds-background-discovery-bold, #6E5DC6)",
            hover: "var(--ds-background-discovery-bold-hovered, #5E4DB2)",
            active: "var(--ds-background-discovery-bold-pressed, #352C63)",
            disabled: {
                light: "var(--ds-background-disabled, #091E4208)",
                dark: "var(--ds-background-disabled, #091E4208)"
            },
            selected: "var(--ds-background-selected-hovered, #CCE0FF)",
            focus: "var(--ds-background-discovery-bold-hovered, #5E4DB2)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #091E424F)",
                dark: "var(--ds-text-disabled, #091E424F)"
            },
            selected: "var(--ds-text-selected, #0C66E4)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
function $8861ef687fb5b99a$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $8861ef687fb5b99a$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$8861ef687fb5b99a$var$extract($8861ef687fb5b99a$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $8861ef687fb5b99a$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$8861ef687fb5b99a$var$extract($8861ef687fb5b99a$var$modalTheme, themeProps)
        },
        ...rest
    };
};

});


parcelRegister("8d34H", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d6c5b008d24705f$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
class $3d6c5b008d24705f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) this.props.onChange();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("2Fndw", function(module, exports) {

$parcel$export(module.exports, "SpotlightTransitionConsumer", () => $c5e8b79346cf6bce$export$7d63b19b854c2fe8);
$parcel$export(module.exports, "default", () => $c5e8b79346cf6bce$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");
const $c5e8b79346cf6bce$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    isOpen: true,
    onExited: (0, $ee7An.default)
});
// checks if children exist and are truthy
const $c5e8b79346cf6bce$var$hasChildren = (children)=>(0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.count(children) > 0 && ((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(children || false, (child)=>!!child)?.filter(Boolean)?.length || 0) > 0;
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ class $c5e8b79346cf6bce$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $c5e8b79346cf6bce$var$hasChildren(previousChildren) && !$c5e8b79346cf6bce$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, $7UHDa.jsx)($c5e8b79346cf6bce$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $c5e8b79346cf6bce$var$hasChildren(this.props.children)
            },
            children: this.state.currentChildren
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            currentChildren: undefined
        };
        this.onExited = ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        };
    }
}
const $c5e8b79346cf6bce$export$7d63b19b854c2fe8 = $c5e8b79346cf6bce$var$SpotlightTransitionContext.Consumer;
var $c5e8b79346cf6bce$export$2e2bcd8739ae039 = $c5e8b79346cf6bce$var$SpotlightTransition;

});


parcelRegister("6cnUO", function(module, exports) {

$parcel$export(module.exports, "TargetConsumer", () => $e5b53c53ad1b1f53$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightContext", () => $e5b53c53ad1b1f53$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "SpotlightConsumer", () => $e5b53c53ad1b1f53$export$3503199acd121708);
$parcel$export(module.exports, "default", () => $e5b53c53ad1b1f53$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $csnse = parcelRequire("csnse");

var $ee7An = parcelRequire("ee7An");

var $dh538 = parcelRequire("dh538");

var $caX7N = parcelRequire("caX7N");

var $bbTtY = parcelRequire("bbTtY");

var $eUuZn = parcelRequire("eUuZn");

var $3mTvL = parcelRequire("3mTvL");
const { Consumer: $e5b53c53ad1b1f53$export$f643dd64c1952cc8, Provider: $e5b53c53ad1b1f53$var$TargetProvider } = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $e5b53c53ad1b1f53$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $gwFzn.createContext)({
    opened: (0, $ee7An.default),
    closed: (0, $ee7An.default),
    targets: {}
});
const { Consumer: $e5b53c53ad1b1f53$export$3503199acd121708, Provider: $e5b53c53ad1b1f53$var$SpotlightStateProvider } = $e5b53c53ad1b1f53$export$7b5aa0f5b37a336d;
const $e5b53c53ad1b1f53$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)(Wrapper, {
        children: children
    });
class $e5b53c53ad1b1f53$export$2e2bcd8739ae039 extends (0, $gwFzn.PureComponent) {
    componentDidMount() {
        typeof $3mTvL;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)($e5b53c53ad1b1f53$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($e5b53c53ad1b1f53$var$TargetProvider, {
                value: this.getTargetRef,
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)($e5b53c53ad1b1f53$var$Container, {
                    component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eUuZn.Fade), {
                            hasEntered: this.state.spotlightCount > 0,
                            children: (animationStyles)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $caX7N.default), {
                                    zIndex: 700,
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bbTtY.default), {
                                        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: animationStyles,
                                        isTinted: blanketIsTinted,
                                        onBlanketClicked: onBlanketClicked
                                    })
                                })
                        }),
                        children
                    ]
                })
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            spotlightCount: 0,
            targets: {}
        };
        /*
     * When enabling React Streaming in Confluence, a
     * "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering"
     * error happens.
     * This is to fix this error by wrapping the state update in startTransition as suggested by React: https://react.dev/errors/421?invariant=421
     */ this.getTargetRef = (0, $dh538.fg)('platform_fix_component_state_update_for_suspense') ? (name)=>(element)=>{
                (0, $gwFzn.startTransition)(()=>{
                    this.setState((state)=>({
                            targets: {
                                ...state.targets,
                                [name]: element || undefined
                            }
                        }));
                });
            } : (name)=>(element)=>{
                this.setState((state)=>({
                        targets: {
                            ...state.targets,
                            [name]: element || undefined
                        }
                    }));
            };
        this.spotlightOpen = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        };
        this.spotlightClose = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        };
        this.getStateProviderValue = (0, $csnse.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            }));
    }
}
$e5b53c53ad1b1f53$export$2e2bcd8739ae039.defaultProps = {
    blanketIsTinted: true
};

});
parcelRegister("bbTtY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5d7146d37e8bdeb$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ // IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $d5d7146d37e8bdeb$var$blanketStyles = null;
const $d5d7146d37e8bdeb$var$Blanket = ({ isTinted: isTinted, onBlanketClicked: onBlanketClicked, style: style })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        role: "presentation",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style props are not allowed
            ...style,
            backgroundColor: isTinted ? "var(--ds-blanket, #091E427D)" : 'transparent'
        },
        onClick: onBlanketClicked,
        className: (0, $35pXk.default)([
            "_1r04idpf _v56414ka _kqsw1n9t _1pby1fw0"
        ])
    });
};
var $d5d7146d37e8bdeb$export$2e2bcd8739ae039 = $d5d7146d37e8bdeb$var$Blanket;

});




parcelRegister("brlLt", function(module, exports) {

$parcel$export(module.exports, "SpotlightCard", () => $faebbb111c596651$export$14710e13fc01d383);

var $91xA1 = parcelRequire("91xA1");

var $6sxJX = parcelRequire("6sxJX");
const $faebbb111c596651$export$14710e13fc01d383 = (0, $6sxJX.wrapComponentForChoreographer)((0, $91xA1.default));

});


parcelRegister("j1Ss3", function(module, exports) {

$parcel$export(module.exports, "Query", () => (parcelRequire("kz8z3")).Query);
$parcel$export(module.exports, "Mutation", () => (parcelRequire("btX6h")).Mutation);
$parcel$export(module.exports, "useQuery", () => (parcelRequire("xQxzY")).useQuery);
$parcel$export(module.exports, "useLazyQuery", () => (parcelRequire("jxs8y")).useLazyQuery);
$parcel$export(module.exports, "useMutation", () => (parcelRequire("1KmJq")).useMutation);
$parcel$export(module.exports, "useApolloClient", () => (parcelRequire("fQ5Z2")).useApolloClient);
$parcel$export(module.exports, "ApolloProvider", () => (parcelRequire("fJcSe")).ApolloProvider);
$parcel$export(module.exports, "ApolloConsumer", () => (parcelRequire("fJcSe")).ApolloConsumer);
$parcel$export(module.exports, "withApollo", () => (parcelRequire("c1Y9A")).withApollo);
// exports of our version of react-apollo's components and hooks, with proper integration for UFO holds

var $btX6h = parcelRequire("btX6h");
var $kz8z3 = parcelRequire("kz8z3");

var $fQ5Z2 = parcelRequire("fQ5Z2");
var $jxs8y = parcelRequire("jxs8y");
var $1KmJq = parcelRequire("1KmJq");
var $xQxzY = parcelRequire("xQxzY");

var $fJcSe = parcelRequire("fJcSe");
var $c1Y9A = parcelRequire("c1Y9A");

});
parcelRegister("btX6h", function(module, exports) {

$parcel$export(module.exports, "Mutation", () => $07b3085bab71f368$export$17b8b19c814bcf56);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $UFutL = parcelRequire("UFutL");

var $kH7bh = parcelRequire("kH7bh");

var $5vBGA = parcelRequire("5vBGA");
function $07b3085bab71f368$export$17b8b19c814bcf56({ children: children, ...props }) {
    const operationName = (0, $gwFzn.useMemo)(()=>(0, $kH7bh.default)(props.mutation), [
        props.mutation
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $UFutL.Mutation), {
        ...props,
        children: (0, $5vBGA.withUFOHold)('mutation', operationName, children)
    });
}

});
parcelRegister("5vBGA", function(module, exports) {

$parcel$export(module.exports, "withUFOHold", () => $52a49e18e388df81$export$f8a82bd03fc51330);

var $gwFzn = parcelRequire("gwFzn");

var $9x4nt = parcelRequire("9x4nt");
const $52a49e18e388df81$export$f8a82bd03fc51330 = (operationType, operationName, children)=>{
    const UFOWrappedChildren = (...childrenArgs)=>{
        const { loading: loading } = operationType === 'mutation' ? childrenArgs[1] : childrenArgs[0];
        const ufoContext = (0, $gwFzn.useContext)((0, $9x4nt.default));
        const isChildrenAvailable = children !== null && children !== undefined;
        (0, $gwFzn.useEffect)(()=>{
            if (loading || !isChildrenAvailable) return ufoContext?.hold(operationName);
        }, [
            loading,
            ufoContext,
            isChildrenAvailable
        ]);
        if (!isChildrenAvailable) return null;
        return children(...childrenArgs);
    };
    return UFOWrappedChildren;
};

});


parcelRegister("kz8z3", function(module, exports) {

$parcel$export(module.exports, "Query", () => $1712c7e406c1dcc1$export$62297b13309008b2);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $UFutL = parcelRequire("UFutL");

var $kH7bh = parcelRequire("kH7bh");

var $5vBGA = parcelRequire("5vBGA");
function $1712c7e406c1dcc1$export$62297b13309008b2({ children: children, ...props }) {
    const operationName = (0, $gwFzn.useMemo)(()=>(0, $kH7bh.default)(props.query), [
        props.query
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $UFutL.Query), {
        ...props,
        children: (0, $5vBGA.withUFOHold)('query', operationName, children)
    });
}

});

parcelRegister("jxs8y", function(module, exports) {

$parcel$export(module.exports, "useLazyQuery", () => $b3cf7016ab40112b$export$fd83eea6ecd2d8fa);

var $gwFzn = parcelRequire("gwFzn");

var $fQ5Z2 = parcelRequire("fQ5Z2");

var $9x4nt = parcelRequire("9x4nt");

var $kH7bh = parcelRequire("kH7bh");
const $b3cf7016ab40112b$export$fd83eea6ecd2d8fa = (...args)=>{
    const ufoContext = (0, $gwFzn.useContext)((0, $9x4nt.default));
    const apolloResult = (0, $fQ5Z2.useLazyQuery)(...args);
    const [query] = args;
    const operationName = (0, $kH7bh.default)(query);
    const isLoading = apolloResult?.[1]?.loading;
    (0, $gwFzn.useEffect)(()=>{
        if (isLoading) return ufoContext?.hold(operationName);
    }, [
        isLoading,
        operationName,
        ufoContext
    ]);
    return apolloResult;
};

});


parcelRegister("eWNlq", function(module, exports) {

$parcel$export(module.exports, "useSubscription", () => $6a6a245a32117bed$export$368b4214baeb914c);

var $gwFzn = parcelRequire("gwFzn");

var $fQ5Z2 = parcelRequire("fQ5Z2");

var $9x4nt = parcelRequire("9x4nt");

var $kH7bh = parcelRequire("kH7bh");
const $6a6a245a32117bed$export$368b4214baeb914c = (...args)=>{
    const ufoContext = (0, $gwFzn.useContext)((0, $9x4nt.default));
    const apolloResult = (0, $fQ5Z2.useSubscription)(...args);
    const [query] = args;
    const operationName = (0, $kH7bh.default)(query);
    const isLoading = apolloResult?.loading;
    (0, $gwFzn.useEffect)(()=>{
        if (isLoading) return ufoContext?.hold(operationName);
    }, [
        isLoading,
        operationName,
        ufoContext
    ]);
    return apolloResult;
};

});

parcelRegister("2DVQX", function(module, exports) {

$parcel$export(module.exports, "coreBrowserNotSupported", () => $6da18ce9d3ba5905$export$c754a3a767dfb813);

var $1LUne = parcelRequire("1LUne");
const $6da18ce9d3ba5905$export$c754a3a767dfb813 = ()=>!(0, $1LUne.coreCapabilitiesSupportedBrowsers).test(navigator.userAgent);

});
parcelRegister("1LUne", function(module, exports) {

$parcel$export(module.exports, "coreCapabilitiesSupportedBrowsers", () => $e1e486c4f7efdb15$export$43ac22cc425ea52e);
// This file was automatically generated and should not be edited.
const $e1e486c4f7efdb15$export$43ac22cc425ea52e = /Edge?\/(8[5-9]|9\d|\d{3,})\.\d+(\.\d+|)|Firefox\/(7[7-9]|[89]\d|\d{3,})\.\d+(\.\d+|)|Chrom(ium|e)\/(8[5-9]|9\d|\d{3,})\.\d+(\.\d+|)|(Maci|X1{2}).+ Version\/(13\.([1-9]|\d{2,})|(1[4-9]|[2-9]\d|\d{3,})\.\d+)([,.]\d+|)( \(\w+\)|)( Mobile\/\w+|) Safari\/|Chrome.+OPR\/(8[5-9]|9\d|\d{3,})\.\d+\.\d+|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(14[._]\d+|(1[5-9]|[2-9]\d|\d{3,})[._]\d+)([._]\d+|)|Android:?[ /-](129|1[3-9]\d|[2-9]\d{2}|\d{4,})(\.\d+|)(\.\d+|)|Mobile Safari.+OPR\/([89]\d|\d{3,})\.\d+\.\d+|Android.+Firefox\/(13\d|1[4-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Android.+Chrom(ium|e)\/(129|1[3-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Android.+(UC? ?Browser|UCWEB|U3)[ /]?(15\.([5-9]|\d{2,})|(1[6-9]|[2-9]\d|\d{3,})\.\d+)\.\d+|SamsungBrowser\/(2[4-9]|[3-9]\d|\d{3,})\.\d+|Android.+MQ{2}Browser\/(14(\.(9|\d{2,})|)|(1[5-9]|[2-9]\d|\d{3,})(\.\d+|))(\.\d+|)|K[Aa][Ii]OS\/(3\.\d+|([4-9]|\d{2,})\.\d+)(\.\d+|)/;

});


parcelRegister("3Tw8v", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d5f6fbfb5c3dc75$export$2e2bcd8739ae039);

var $jxPid = parcelRequire("jxPid");

var $8aej1 = parcelRequire("8aej1");

var $62HPt = parcelRequire("62HPt");

var $hmRc4 = parcelRequire("hmRc4");

var $iZ0YS = parcelRequire("iZ0YS");

var $255Ab = parcelRequire("255Ab");

var $2fA6B = parcelRequire("2fA6B");

var $fFo7a = parcelRequire("fFo7a");

var $kaU4c = parcelRequire("kaU4c");
function $2d5f6fbfb5c3dc75$export$2e2bcd8739ae039(initialState = {}) {
    const devMiddleware = [
        // Uncomment this line to enable timing middleware.
        // It will provide some helpful information to tune the performance.
        // applyMiddleware(require('../middleware/timing').default),
        // if you want devtools, install the chrome extension
        // https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd
        typeof $parcel$global.__REDUX_DEVTOOLS_EXTENSION__ === 'function' ? $parcel$global.__REDUX_DEVTOOLS_EXTENSION__() : (f)=>f
    ];
    const browserHistory = (0, $hmRc4.getBrowserHistory)();
    const finalCreateStore = (0, $jxPid.compose)((0, $jxPid.applyMiddleware)((0, $62HPt.default), (0, $iZ0YS.default), (0, $255Ab.default), (0, $2fA6B.default)), (0, $jxPid.applyMiddleware)((0, $8aej1.default)(browserHistory)), ...[])((0, $jxPid.createStore));
    return finalCreateStore((0, $fFo7a.default)({}, browserHistory), (0, $kaU4c.default)($parcel$global, initialState));
}

});
parcelRegister("iZ0YS", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd1eaf48c6b4ba66$export$2e2bcd8739ae039);

var $ehJLJ = parcelRequire("ehJLJ");

var $5cBWV = parcelRequire("5cBWV");
// should implement action lifecycle management inside redux?
// this makes me super uncomfortable
const $dd1eaf48c6b4ba66$var$calling = {};
var $dd1eaf48c6b4ba66$export$2e2bcd8739ae039 = ()=>(next)=>(action)=>{
            const callAPI = action[0, $5cBWV.CALL_API];
            if (typeof callAPI === 'undefined') return next(action);
            const { apiMethod: apiMethod, types: types, options: options, actionOptions: actionOptions } = callAPI;
            const callKey = JSON.stringify({
                types: types,
                options: options
            });
            function actionWith(data) {
                const finalAction = Object.assign({}, action, data);
                delete finalAction[0, $5cBWV.CALL_API];
                return finalAction;
            }
            const [requestType, successType, failureType] = types;
            if (callKey in $dd1eaf48c6b4ba66$var$calling) return $dd1eaf48c6b4ba66$var$calling[callKey];
            next(actionWith({
                type: requestType,
                ...options
            }));
            let promiseResolve;
            let promiseReject;
            const deferredPromise = new Promise((resolve, reject)=>{
                promiseResolve = resolve;
                promiseReject = reject;
            });
            $dd1eaf48c6b4ba66$var$calling[callKey] = deferredPromise;
            apiMethod(options, (err, response)=>{
                delete $dd1eaf48c6b4ba66$var$calling[callKey];
                if (err) {
                    const errorResponse = actionOptions && actionOptions.errorHandler && actionOptions.errorHandler(err, response, options);
                    if (!errorResponse) {
                        let errorMessage;
                        try {
                            errorMessage = JSON.parse(err.message);
                        } catch (e) {
                            if (err.message && err.message.indexOf('<!DOCTYPE html>') > -1) console.error('A rest call returned a HTML document that could not be parsed by the rest API middleware.', {
                                failureType: failureType,
                                options: options,
                                err: err,
                                response: response
                            });
                            else console.error(`Could not parse response from rest API: ${err.message}`, {
                                failureType: failureType,
                                options: options,
                                err: err,
                                response: response
                            });
                            errorMessage = err.message;
                        }
                        promiseReject(err);
                        return next(actionWith({
                            type: failureType,
                            message: errorMessage,
                            error: err,
                            options: options
                        }));
                    } else response = errorResponse;
                }
                if (actionOptions && actionOptions.schema) {
                    const normalized = (0, $ehJLJ.normalize)(response, actionOptions.schema);
                    response = {
                        ...response,
                        ...normalized
                    };
                }
                promiseResolve();
                return next(actionWith({
                    type: successType,
                    response: response,
                    ...options
                }));
            });
            return deferredPromise;
        };

});
parcelRegister("5cBWV", function(module, exports) {

$parcel$export(module.exports, "CALL_API", () => $3c9b82b99b8428ca$export$294b0449955347ad);
$parcel$export(module.exports, "restActionCreator", () => $3c9b82b99b8428ca$export$83aefcfe5d77bdc1);
$parcel$export(module.exports, "commonActionCreator", () => $3c9b82b99b8428ca$export$69915ab5a7dce1ca);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $3c9b82b99b8428ca$export$294b0449955347ad = Symbol('Call API');
function $3c9b82b99b8428ca$export$83aefcfe5d77bdc1(type, apiMethod, actionOptions) {
    return (options)=>({
            [$3c9b82b99b8428ca$export$294b0449955347ad]: {
                types: [
                    `${type}_REQUEST`,
                    `${type}_SUCCESS`,
                    `${type}_FAILURE`
                ],
                apiMethod: apiMethod,
                options: options,
                actionOptions: actionOptions
            }
        });
}
function $3c9b82b99b8428ca$export$69915ab5a7dce1ca(type) {
    return (options)=>({
            type: type,
            ...options
        });
}
function $3c9b82b99b8428ca$export$b914a335c72ca6b6(type, apiMethod, actionOptions) {
    return $3c9b82b99b8428ca$export$83aefcfe5d77bdc1(type, apiMethod, actionOptions);
}
function $3c9b82b99b8428ca$export$48f3ba85f13d91ae(type) {
    return $3c9b82b99b8428ca$export$69915ab5a7dce1ca(type);
}

});


parcelRegister("255Ab", function(module, exports) {

$parcel$export(module.exports, "default", () => $184060ff10462130$export$2e2bcd8739ae039);

var $aTqya = parcelRequire("aTqya");

var $ehJLJ = parcelRequire("ehJLJ");

var $lwdd5 = parcelRequire("lwdd5");

var $hp2SH = parcelRequire("hp2SH");

var $h6cjM = parcelRequire("h6cjM");
const $184060ff10462130$var$applyTransformers = (store, response, variables, actionName, transformer, schema)=>{
    const actionNames = actionName instanceof Array ? actionName : [
        actionName
    ];
    for (const actionType of actionNames)try {
        const data = response.data && $184060ff10462130$var$transformGraphqlResponseToState(response.data, variables, transformer, schema);
        if (!data) return;
        store.dispatch({
            type: `${actionType}_SUCCESS`,
            response: (0, $h6cjM.default)(data, '__typename'),
            ...variables
        });
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).console.error(error);
        store.dispatch({
            type: `${actionType}_FAILED`,
            error: error
        });
    }
};
const $184060ff10462130$var$transformGraphqlResponseToState = (data, variables, transformer, schema)=>{
    const transformed = transformer ? transformer(data, variables) : data;
    if (!transformed) return null;
    if (!schema) return transformed;
    const normalized = (0, $ehJLJ.normalize)(transformed, schema);
    return {
        ...transformed,
        ...normalized
    };
};
var $184060ff10462130$export$2e2bcd8739ae039 = (store)=>(next)=>(action)=>{
            if (action.type === 'APOLLO_QUERY') {
                if (action.errorFilter && action.batch) throw new Error('errorFilter is only supported when batch=false');
                const actionNames = action.actionName instanceof Array ? action.actionName : action.actionName ? [
                    action.actionName
                ] : [];
                for (const actionName of actionNames)store.dispatch({
                    type: `${actionName}_REQUEST`,
                    ...action.variables
                });
                const gqlClientQueryOptions = {
                    query: action.query,
                    variables: action.variables,
                    context: {
                        single: !action.batch
                    }
                };
                if (action.fetchPolicy) gqlClientQueryOptions.fetchPolicy = action.fetchPolicy;
                const queryPromise = (0, $hp2SH.getApolloClient)().query(gqlClientQueryOptions);
                queryPromise.then((response)=>{
                    if (response instanceof Array) {
                        let errors = response[0].errors;
                        if (errors && action.errorsFilter) errors = action.errorsFilter(errors);
                        if (errors) throw new (0, $aTqya.ApolloError)({
                            graphQLErrors: response[0].errors
                        });
                        return response[0];
                    }
                    return response;
                }).then((response)=>store.dispatch({
                        type: 'APOLLO_QUERY_SUCCESS',
                        response: response,
                        actionName: action.actionName,
                        transformer: action.transformer,
                        schema: action.schema,
                        variables: action.variables
                    })).catch((error)=>{
                    store.dispatch({
                        type: 'APOLLO_QUERY_FAILURE',
                        error: error,
                        actionName: action.actionName,
                        variables: action.variables
                    });
                });
                next(action);
                return queryPromise;
            } else if (action.type === 'APOLLO_QUERY_SUCCESS') {
                if (action.response.data && action.response.data.content && action.response.data.content.nodes && !action.response.data.content.nodes.length) {
                    if (action.actionName === 'EDITOR_CONTENT_V2') return store.dispatch({
                        type: `${action.actionName}_FAILURE`,
                        error: {
                            statusCode: 404
                        },
                        options: action.variables
                    });
                    // TODO: this should be removed in favour of generic failure action above
                    return store.dispatch({
                        type: 'CONTENT_FAILURE',
                        error: {
                            statusCode: 404
                        }
                    });
                } else $184060ff10462130$var$applyTransformers(store, action.response, action.variables, action.actionName, action.transformer, action.schema);
            } else if (action.type === 'APOLLO_QUERY_FAILURE') {
                let error = action.error?.graphQLErrors?.length ? action.error?.graphQLErrors[0] : action.error;
                if (error?.response?.status) error = {
                    ...error,
                    statusCode: error.response.status
                };
                const message = error ? error.message : action.error.message;
                const actionNames = action.actionName instanceof Array ? action.actionName : [
                    action.actionName
                ];
                for (const actionName of actionNames)store.dispatch({
                    type: `${actionName}_FAILURE`,
                    error: error,
                    message: message,
                    options: action.variables
                });
            }
            return next(action);
        };

});
parcelRegister("h6cjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c72c8d4ad9ba26d7$export$2e2bcd8739ae039);
/**
 * Recursively omits a key from any javascript type.
 *
 * @param val
 * @param keyToOmit
 *
 */ const $c72c8d4ad9ba26d7$var$omitDeep = (val, keyToOmit)=>{
    const type = typeof val;
    if (type !== 'object' || val === null || val === undefined) return val;
    if (Array.isArray(val)) return val.map((arrItem)=>$c72c8d4ad9ba26d7$var$omitDeep(arrItem, keyToOmit));
    if (type === 'object') return Object.keys(val).reduce((newObj, key)=>{
        if (key !== keyToOmit) newObj[key] = $c72c8d4ad9ba26d7$var$omitDeep(val[key], keyToOmit);
        return newObj;
    }, {});
    throw new Error(`Unsupported type "${type}" confronted in omitDeep function`);
};
var $c72c8d4ad9ba26d7$export$2e2bcd8739ae039 = $c72c8d4ad9ba26d7$var$omitDeep;

});


parcelRegister("2fA6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a38fd4db987f5e5$export$2e2bcd8739ae039);
// eslint-disable-next-line check-cross-package-imports/dont-import-redux-in-next

var $3P3UD = parcelRequire("3P3UD");

var $irVI7 = parcelRequire("irVI7");
var $fGzMp = parcelRequire("fGzMp");

var $04e9M = parcelRequire("04e9M");
const $1a38fd4db987f5e5$var$trackAnalyticEvents = (store)=>(next)=>(action)=>{
            const state = store.getState();
            const { error: error } = action;
            switch(action.type){
                case 'EDITOR_CONTENT_PUBLISH_SUCCESS':
                case 'EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_SUCCESS':
                    $1a38fd4db987f5e5$var$triggerAnalyticsForPage(action, state);
                    (0, $fGzMp.getExperienceTracker)().succeed({
                        name: (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)
                    });
                    break;
                case 'EDITOR_CONTENT_PUBLISH_FAILURE':
                case 'EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_FAILURE':
                    const statusCode = error?.statusCode || 0;
                    // does not let ExperienceTracker track user errors
                    if (statusCode === 0 || statusCode >= 500 && statusCode <= 599) // User (e.g. 0 status code) or non-user (e.g. 5xx status code) error.
                    // Abort or fail, respectively, the experience.
                    (0, $fGzMp.stopExperienceOnError)((0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE), error);
                    else if (statusCode >= 400 && statusCode <= 499) // User error. Don't fail the experience which includes don't let the
                    // experience time out so abort the experience.
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE),
                        reason: error?.message || action?.message?.message,
                        checkForTimeout: false
                    });
                    break;
            }
            return next(action);
        };
const $1a38fd4db987f5e5$var$callAnalyticsEvent = (analyticsObj)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((analyticWebClientResponse)=>{
        analyticWebClientResponse.sendTrackEvent(analyticsObj);
    });
};
const $1a38fd4db987f5e5$var$triggerAnalyticsForPage = (action, state)=>{
    let spaceId;
    let spaceType;
    let homepageId;
    const { id: id, type: type, version: version } = action.response;
    try {
        const spaceKey = state.router.params.spaceKey;
        const space = (0, $3P3UD.getSpaceInfoSelector)(state, spaceKey);
        spaceId = space.id;
        spaceType = space.type;
        homepageId = space.homepageId;
    } catch (e) {}
    const analyticsObject = {
        containerType: 'space',
        containerId: spaceId,
        source: 'editPageScreen',
        objectType: 'page',
        objectId: id,
        action: version?.number === 1 ? 'created' : 'updated',
        actionSubject: 'page',
        actionSubjectId: id,
        attributes: {
            pageType: type,
            spaceType: spaceType,
            versionNum: version?.number,
            createExperience: null,
            isOverviewPage: homepageId === id
        }
    };
    analyticsObject.attributes.createExperience = 'createPageModal';
    $1a38fd4db987f5e5$var$callAnalyticsEvent(analyticsObject);
};
var $1a38fd4db987f5e5$export$2e2bcd8739ae039 = $1a38fd4db987f5e5$var$trackAnalyticEvents;

});
parcelRegister("3P3UD", function(module, exports) {

$parcel$export(module.exports, "getSpaceInfoSelector", () => $2c892b785fc45978$export$1942ba3c2094e3ed);

var $atveb = parcelRequire("atveb");

var $bsCwp = parcelRequire("bsCwp");

var $cGH1v = parcelRequire("cGH1v");
const $2c892b785fc45978$export$52f6ec48775979e3 = ()=>{
    const selectorCreator = (0, $bsCwp.createSelectorCreator)((0, $bsCwp.defaultMemoize), (0, (/*@__PURE__*/$parcel$interopDefault($atveb))));
    return selectorCreator((ids)=>ids, (ids, state)=>state.entities.get('spaces'), (ids, spaces)=>{
        if (!ids || !ids.size) return (0, $cGH1v.Set)([]);
        return ids.map((id)=>id ? spaces.get(`${id}`) : null);
    });
};
const $2c892b785fc45978$export$f49532ceefece8fc = (0, $bsCwp.createSelector)((spaceKey)=>spaceKey, (spaceKey, state)=>state.entities.get('spaces'), (spaceKey, spaces)=>spaces.getIn([
        spaceKey,
        'homepageId'
    ], null));
const $2c892b785fc45978$export$1942ba3c2094e3ed = (0, $bsCwp.createSelector)([
    (state)=>state.entities.get('spaces'),
    (state, spaceKey)=>spaceKey
], (spaces, spaceKey)=>spaces.get(spaceKey, null));

});


parcelRegister("fFo7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $b67d640653fa7387$export$2e2bcd8739ae039);

var $jxPid = parcelRequire("jxPid");

var $cGH1v = parcelRequire("cGH1v");

var $6QgDK = parcelRequire("6QgDK");

var $eH0qm = parcelRequire("eH0qm");

var $dEWzl = parcelRequire("dEWzl");

var $ebjWb = parcelRequire("ebjWb");

var $gCBCj = parcelRequire("gCBCj");

var $fntqT = parcelRequire("fntqT");

var $6hgAv = parcelRequire("6hgAv");

var $d5EYy = parcelRequire("d5EYy");
const $b67d640653fa7387$var$isServerRenderedPage = (state = null)=>state;
const $b67d640653fa7387$var$meta = (state = (0, $cGH1v.Map)())=>state;
function $b67d640653fa7387$export$2e2bcd8739ae039(extraReducers, browserHistory) {
    return (0, $jxPid.combineReducers)({
        router: (0, $ebjWb.default)(browserHistory),
        session: $gCBCj.default,
        views: $fntqT.default,
        entities: $dEWzl.entities,
        meta: $b67d640653fa7387$var$meta,
        modal: $6hgAv.default,
        discoveredFeatures: $d5EYy.default,
        editor: $eH0qm.default,
        fabricEditor: $6QgDK.default,
        isServerRenderedPage: $b67d640653fa7387$var$isServerRenderedPage,
        ...extraReducers
    });
}

});
parcelRegister("6QgDK", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdf14fbf1783baa$export$2e2bcd8739ae039);

var $jxPid = parcelRequire("jxPid");

var $kje6u = parcelRequire("kje6u");

var $lfrOL = parcelRequire("lfrOL");
var $dfdf14fbf1783baa$export$2e2bcd8739ae039 = (0, $jxPid.combineReducers)({
    synchrony: $kje6u.default,
    views: $lfrOL.default
});

});
parcelRegister("kje6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $17444e379c4f4dcc$export$2e2bcd8739ae039);

var $ink3H = parcelRequire("ink3H");

var $f0u1B = parcelRequire("f0u1B");
const $17444e379c4f4dcc$export$49d5fc8cba920a0 = {
    // default value is null to indicate a value of first page loading
    status: null,
    synchronyConfigMap: {},
    contentReconciliationStatus: {
        isRequesting: false
    },
    synchronyProviderMap: {}
};
function $17444e379c4f4dcc$export$25d14d759b7df9bc(synchronyAppId, contentId) {
    return synchronyAppId === null || contentId === null ? null : `/${synchronyAppId}/confluence-adf-${contentId}`;
}
function $17444e379c4f4dcc$export$2e2bcd8739ae039(state = $17444e379c4f4dcc$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case (0, $ink3H.ActionTypes).CONNECTION_OFFLINE:
            return {
                ...state,
                status: 'disconnected'
            };
        case (0, $ink3H.ActionTypes).CONNECTION_ONLINE:
            return {
                ...state,
                status: 'connected'
            };
        case (0, $ink3H.ActionTypes).SYNCHRONY_UPDATE_STATUS:
            return {
                ...state,
                status: action.status
            };
        case (0, $f0u1B.ActionTypes).RESET_EDITOR_STATE:
            return {
                ...$17444e379c4f4dcc$export$49d5fc8cba920a0,
                synchronyConfigMap: state.synchronyConfigMap
            };
        case (0, $ink3H.ActionTypes).INIT_COLLAB_PROVIDER_REQUEST:
            return {
                ...state,
                synchronyProviderMap: {
                    ...state.synchronyProviderMap,
                    [action.contentId]: {
                        ...state.synchronyProviderMap[action.contentId],
                        isInitializingProvider: true,
                        preInitSucceeded: false
                    }
                }
            };
        case (0, $ink3H.ActionTypes).INIT_COLLAB_PROVIDER_FAILURE:
            return {
                ...state,
                synchronyProviderMap: {
                    ...state.synchronyProviderMap,
                    [action.contentId]: {
                        provider: null,
                        isInitializingProvider: false,
                        preInitSucceeded: false
                    }
                }
            };
        case (0, $ink3H.ActionTypes).INIT_COLLAB_PROVIDER_SUCCESS:
            return {
                ...state,
                synchronyProviderMap: {
                    ...state.synchronyProviderMap,
                    [action.contentId]: {
                        provider: action.provider,
                        isInitializingProvider: false,
                        preInitSucceeded: action.preInitSucceeded
                    }
                }
            };
        case (0, $ink3H.ActionTypes).RESET_COLLAB_PROVIDER:
            delete state.synchronyProviderMap[action.contentId];
            return {
                ...state
            };
        default:
            return state;
    }
}

});
parcelRegister("ink3H", function(module, exports) {

$parcel$export(module.exports, "ActionTypes", () => $4516f26c30387249$export$1385d81a6c6bbcd4);
var $4516f26c30387249$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["HANDLE_PUBLISH_EVENT"] = "HANDLE_PUBLISH_EVENT";
    ActionTypes["HANDLE_VERSION_UPDATE"] = "HANDLE_VERSION_UPDATE";
    ActionTypes["SYNCHRONY_UPDATE_STATUS"] = "SYNCHRONY_UPDATE_STATUS";
    ActionTypes["CONNECTION_OFFLINE"] = "CONNECTION_OFFLINE";
    ActionTypes["CONNECTION_ONLINE"] = "CONNECTION_ONLINE";
    ActionTypes["INIT_COLLAB_PROVIDER_FAILURE"] = "INIT_COLLAB_PROVIDER_FAILURE";
    ActionTypes["INIT_COLLAB_PROVIDER_SUCCESS"] = "INIT_COLLAB_PROVIDER_SUCCESS";
    ActionTypes["INIT_COLLAB_PROVIDER_REQUEST"] = "INIT_COLLAB_PROVIDER_REQUEST";
    ActionTypes["RESET_COLLAB_PROVIDER"] = "RESET_COLLAB_PROVIDER";
    return ActionTypes;
}({});

});

parcelRegister("f0u1B", function(module, exports) {

$parcel$export(module.exports, "ActionTypes", () => $4baa5f8073ff2654$export$1385d81a6c6bbcd4);
var $4baa5f8073ff2654$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["RESET_EDITOR_STATE"] = "RESET_EDITOR_STATE";
    return ActionTypes;
}({});

});


parcelRegister("lfrOL", function(module, exports) {

$parcel$export(module.exports, "default", () => $79b7be3fcb035b95$export$2e2bcd8739ae039);

var $jxPid = parcelRequire("jxPid");

var $dAw6F = parcelRequire("dAw6F");

var $kv6FQ = parcelRequire("kv6FQ");

var $j26JB = parcelRequire("j26JB");
var $79b7be3fcb035b95$export$2e2bcd8739ae039 = (0, $jxPid.combineReducers)({
    editorContentV2: $dAw6F.default,
    mediaPreviewer: $kv6FQ.mediaPreviewer,
    draft: $j26JB.default
});

});
parcelRegister("dAw6F", function(module, exports) {

$parcel$export(module.exports, "default", () => $31c2a1429cbabe2b$export$2e2bcd8739ae039);

var $fGzMp = parcelRequire("fGzMp");
var $irVI7 = parcelRequire("irVI7");

var $CTedk = parcelRequire("CTedk");
var $8VcPj = parcelRequire("8VcPj");

var $lbr71 = parcelRequire("lbr71");

var $f0u1B = parcelRequire("f0u1B");

var $bx6Tx = parcelRequire("bx6Tx");

var $euETc = parcelRequire("euETc");
// TODO: Move these back when typing the synchrony state
// import {
//   HANDLE_PUBLISH_EVENT,
// } from "../../support/synchrony-support/action-types";
const $31c2a1429cbabe2b$var$noError = {
    errorData: $31c2a1429cbabe2b$var$_getErrorData(null),
    statusCode: null
};
function $31c2a1429cbabe2b$var$_getErrorData(error) {
    if (error === null) return {};
    const errorMap = {};
    if (error.data && error.data.errors) error.data.errors.forEach((error)=>{
        errorMap[error.message.key] = error.details || true;
    });
    return {
        [error.message]: error.details || true,
        ...errorMap
    };
}
const $31c2a1429cbabe2b$export$49d5fc8cba920a0 = {
    hasRequestedEditorContent: false,
    contentId: undefined,
    editorContent: null,
    title: null,
    hasRefreshedPage: false,
    contentType: null,
    editorMode: (0, $bx6Tx.EDITOR_NAV_DESTINATION).NONE,
    isUnpublishedDraft: null,
    isPublishingContent: false,
    syncRev: null,
    confRev: null,
    lastPublisher: null,
    publishedEditorContent: null,
    isADFContentInvalid: false,
    publishedTitle: '',
    contentSpaceKey: '',
    fetchReconciledEditorContentFinished: false,
    fetchReconciledEditorContentFailure: false,
    fetchReconciledEditorContentRequest: false,
    nextTryIn: null,
    contentAppearanceDraft: {
        appearance: (0, $CTedk.ContentAppearanceType).DEFAULT,
        version: -1
    },
    contentAppearancePublished: {
        appearance: (0, $CTedk.ContentAppearanceType).DEFAULT,
        version: -1
    },
    contentAppearanceLoading: false,
    showErrorOnUpdateContentAppearanceDraftConflict: false,
    showErrorOnUpdateContentAppearancePublishedConflict: false,
    shouldShowScheduledPublishDialog: false,
    shouldShowScheduledPublishModal: false,
    currentlyScheduledPublishDate: null,
    isSchedulingPublish: false,
    ...$31c2a1429cbabe2b$var$noError
};
function $31c2a1429cbabe2b$export$2e2bcd8739ae039(state = $31c2a1429cbabe2b$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case (0, $lbr71.ActionTypes).EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_REQUEST:
            if (state.contentId !== action.contentId) return state;
            // updating the published and draft content appearance is the same except for the key. so this reducer handles both.
            // defining new state here is important for getting type safety on conditional key name
            // also does this for EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_SUCCESS
            const updatedAppearanceState = {
                ...state,
                contentAppearanceLoading: true
            };
            if (action.propertyKey === (0, $CTedk.ContentAppearancePropertyKey).PUBLISHED) updatedAppearanceState.contentAppearancePublished = {
                ...updatedAppearanceState.contentAppearancePublished,
                appearance: action.propertyValue
            };
            else updatedAppearanceState.contentAppearanceDraft = {
                ...updatedAppearanceState.contentAppearanceDraft,
                appearance: action.propertyValue
            };
            return updatedAppearanceState;
        case (0, $lbr71.ActionTypes).EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_SUCCESS:
            if (state.contentId !== action.contentId) return state;
            const contentAppearance = {
                appearance: action.response.value,
                version: action.response.version.number
            };
            const updatedState = {
                ...state,
                contentAppearanceLoading: false
            };
            if (action.response.key === (0, $CTedk.ContentAppearancePropertyKey).PUBLISHED) {
                updatedState.contentAppearancePublished = contentAppearance;
                updatedState.showErrorOnUpdateContentAppearancePublishedConflict = false;
            } else {
                updatedState.contentAppearanceDraft = contentAppearance;
                updatedState.showErrorOnUpdateContentAppearanceDraftConflict = false;
            }
            return updatedState;
        case (0, $lbr71.ActionTypes).EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_FAILURE:
            if (state.contentId !== action.options.contentId) return state;
            if (action.error?.statusCode === 409) {
                if (action.options.propertyKey === (0, $CTedk.ContentAppearancePropertyKey).DRAFT) {
                    if (!state.showErrorOnUpdateContentAppearanceDraftConflict) return {
                        ...state,
                        contentAppearanceLoading: false,
                        showErrorOnUpdateContentAppearanceDraftConflict: true
                    };
                } else {
                    if (!state.showErrorOnUpdateContentAppearancePublishedConflict) return {
                        ...state,
                        contentAppearanceLoading: false,
                        showErrorOnUpdateContentAppearancePublishedConflict: true
                    };
                }
            }
            return {
                ...state,
                contentAppearanceLoading: false,
                statusCode: action.error && action.error.statusCode,
                errorData: $31c2a1429cbabe2b$var$_getErrorData(action.message)
            };
        case (0, $lbr71.ActionTypes).CHANGE_EDITOR_MODE:
            return {
                ...state,
                editorMode: action.mode
            };
        case (0, $lbr71.ActionTypes).CHANGE_EDITOR_TITLE:
            return {
                ...state,
                title: action.title
            };
        case (0, $lbr71.ActionTypes).EDITOR_CONTENT_V2_REQUEST:
            if (state.contentId !== action.contentId) return {
                ...state,
                contentId: action.contentId,
                editorContent: null,
                publishedEditorContent: null,
                isADFContentInvalid: false,
                hasRequestedEditorContent: false,
                fetchReconciledEditorContentRequest: true,
                ...$31c2a1429cbabe2b$var$noError
            };
            else // This typically happens if we need to perform a second request to obtain published content
            // like after content reconciliation asks the confluence backend to perform a recovery.
            // When that happens, we should not wipe out the existing content and state.
            return {
                ...state,
                hasRequestedEditorContent: false
            };
        case (0, $lbr71.ActionTypes).EDITOR_CONTENT_V2_SUCCESS:
            if (state.contentId !== action.contentId) return state;
            const document = action.response.editorContent[action.docFormat];
            const { isADFContentInvalid: isADFContentInvalid = false, value: publishedEditorContent } = document;
            const publishedTitle = action.response.title || '';
            const contentAppearanceDraft = (0, $8VcPj.getContentAppearanceFromContentProperties)(action.response.appearanceDraft, (0, $CTedk.ContentAppearancePropertyKey).DRAFT);
            const contentAppearancePublished = (0, $8VcPj.getContentAppearanceFromContentProperties)(action.response.appearancePublished, (0, $CTedk.ContentAppearancePropertyKey).PUBLISHED);
            const schedulePublishDate = action.response.schedulePublishDate;
            const currentlyScheduledPublishDate = schedulePublishDate ? new Date(schedulePublishDate) : null;
            return {
                ...state,
                publishedEditorContent: publishedEditorContent,
                publishedTitle: publishedTitle,
                contentSpaceKey: action?.response?.space?.key || '',
                statusCode: (0, $euETc.OK),
                hasRequestedEditorContent: true,
                errorData: $31c2a1429cbabe2b$var$_getErrorData(null),
                contentType: action.response.type,
                isUnpublishedDraft: action.response.isUnpublishedDraft,
                isADFContentInvalid: isADFContentInvalid,
                contentAppearanceDraft: contentAppearanceDraft,
                contentAppearancePublished: contentAppearancePublished,
                currentlyScheduledPublishDate: currentlyScheduledPublishDate
            };
        case (0, $lbr71.ActionTypes).EDITOR_CONTENT_V2_FAILURE:
            if (state.contentId !== action.options.contentId) return state;
            return {
                ...state,
                statusCode: action.error && action.error.statusCode,
                errorData: $31c2a1429cbabe2b$var$_getErrorData(action.message || null),
                hasRequestedEditorContent: true,
                // In case of editor failure the reconciliation request thunk chain will be terminated before it get's
                // to a promise catch part, so we need to flag that content reconciliation has ended
                fetchReconciledEditorContentFinished: true,
                fetchReconciledEditorContentFailure: true,
                fetchReconciledEditorContentRequest: false
            };
        case (0, $lbr71.ActionTypes).UPDATE_CONTENT_SPACE_KEY:
            return {
                ...state,
                contentSpaceKey: action.spaceKey
            };
        case (0, $lbr71.ActionTypes).SET_IS_PUBLISHING_CONTENT:
            return {
                ...state,
                isPublishingContent: action.isPublishingContent
            };
        case (0, $lbr71.ActionTypes).SET_IS_SCHEDULING_PUBLISH:
            return {
                ...state,
                isSchedulingPublish: action.isSchedulingPublish
            };
        case (0, $lbr71.ActionTypes).EDITOR_CONTENT_PUBLISH_REQUEST:
            return {
                ...state,
                isPublishingContent: !action.content.schedulePublishDate
            };
        case (0, $lbr71.ActionTypes).EDITOR_CONTENT_PUBLISH_FAILURE:
        case (0, $lbr71.ActionTypes).EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_FAILURE:
            const contentId = action?.options?.content?.id;
            // contentId is undefined for new templates
            if (contentId && contentId.toString() !== state.contentId) return state;
            if (action.options.migratedRecently) (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.MIGRATE_PAGE_PUBLISH_EXPERIENCE),
                error: new Error(JSON.stringify($31c2a1429cbabe2b$var$_getErrorData(action.message || null)))
            });
            // Don't show an error message if we are going to retry
            if (action.options && action.options.retryOnConflict && action.error && action.error.statusCode === 409) return state;
            return {
                ...state,
                isPublishingContent: false,
                isSchedulingPublish: false,
                statusCode: action.error && action.error.statusCode,
                errorData: $31c2a1429cbabe2b$var$_getErrorData(action.message)
            };
        case (0, $lbr71.ActionTypes).EDITOR_CONTENT_PUBLISH_SUCCESS:
        case (0, $lbr71.ActionTypes).EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_SUCCESS:
            if (action.migratedRecently) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.MIGRATE_PAGE_PUBLISH_EXPERIENCE)
            });
            return {
                ...state,
                isUnpublishedDraft: action.content.schedulePublishDate ? state.isUnpublishedDraft : false,
                isPublishingContent: false,
                isSchedulingPublish: false,
                editorMode: action.editorMode
            };
        case (0, $lbr71.ActionTypes).CLOSE_EDITOR_ERROR:
            return {
                ...state,
                ...$31c2a1429cbabe2b$var$noError
            };
        case (0, $lbr71.ActionTypes).SHOW_EDITOR_ERROR:
            return {
                ...state,
                statusCode: action.statusCode || null,
                errorData: action.errorData
            };
        case (0, $lbr71.ActionTypes).EDITOR_CONTENT_PREVIEW_FAILURE:
            return {
                ...state,
                statusCode: action.error && action.error.statusCode,
                errorData: $31c2a1429cbabe2b$var$_getErrorData(action.message)
            };
        case (0, $lbr71.ActionTypes).HANDLE_PUBLISH_EVENT:
            if (state.contentId !== action.contentId) return state;
            return {
                ...state,
                statusCode: null,
                errorData: $31c2a1429cbabe2b$var$_getErrorData({
                    message: 'other-publish'
                }),
                isUnpublishedDraft: false,
                lastPublisher: action.lastPublisher
            };
        case (0, $f0u1B.ActionTypes).RESET_EDITOR_STATE:
            return $31c2a1429cbabe2b$export$49d5fc8cba920a0;
        case (0, $lbr71.ActionTypes).EDITOR_SHOW_SCHEDULED_PUBLISH_DIALOG:
            return {
                ...state,
                ...action.context === 'modal' ? {
                    shouldShowScheduledPublishModal: true
                } : {
                    shouldShowScheduledPublishDialog: true
                }
            };
        case (0, $lbr71.ActionTypes).EDITOR_HIDE_SCHEDULED_PUBLISH_COMPONENT:
            return {
                ...state,
                shouldShowScheduledPublishDialog: false,
                shouldShowScheduledPublishModal: false
            };
        case (0, $lbr71.ActionTypes).EDITOR_CURRENTLY_SCHEDULED_PUBLISH_DATE:
            return {
                ...state,
                currentlyScheduledPublishDate: action.currentlyScheduledPublishDate
            };
        case (0, $lbr71.ActionTypes).EDITOR_CANCEL_SCHEDULED_PUBLISH:
            return {
                ...state,
                currentlyScheduledPublishDate: null
            };
        default:
            return state;
    }
}

});
parcelRegister("CTedk", function(module, exports) {

$parcel$export(module.exports, "ContentAppearancePropertyKey", () => $f409429897b979cb$export$12d28147ee0fcd7c);
$parcel$export(module.exports, "ContentAppearanceType", () => $f409429897b979cb$export$72beb3923a6d34b3);
var $f409429897b979cb$export$12d28147ee0fcd7c = /*#__PURE__*/ function(ContentAppearancePropertyKey) {
    ContentAppearancePropertyKey["PUBLISHED"] = "content-appearance-published";
    ContentAppearancePropertyKey["DRAFT"] = "content-appearance-draft";
    return ContentAppearancePropertyKey;
}({});
var $f409429897b979cb$export$72beb3923a6d34b3 = /*#__PURE__*/ function(ContentAppearanceType) {
    ContentAppearanceType["DEFAULT"] = "default";
    ContentAppearanceType["FULL_WIDTH"] = "full-width";
    return ContentAppearanceType;
}({});

});

parcelRegister("8VcPj", function(module, exports) {

$parcel$export(module.exports, "getContentAppearanceFromContentProperties", () => $df5e53df2c3ce3a1$export$b1d01ffe4898696d);
$parcel$export(module.exports, "getContentAppearancePublished", () => $df5e53df2c3ce3a1$export$31055ca3b35a4c84);
$parcel$export(module.exports, "updateContentAppearancePropertyWithRetry", () => $df5e53df2c3ce3a1$export$2521257be0c7ea48);
$parcel$export(module.exports, "getContentAppearanceQuery", () => $df5e53df2c3ce3a1$export$7490752b89a3fa25);
$parcel$export(module.exports, "getContentAppearanceFromQueryData", () => $df5e53df2c3ce3a1$export$95c1397e685f545a);
$parcel$export(module.exports, "ContentAppearanceButton", () => $df5e53df2c3ce3a1$export$36c1915a504dc477);

var $gwFzn = parcelRequire("gwFzn");
parcelRequire("dIouf");
var $aMcHK = parcelRequire("aMcHK");

var $lztxY = parcelRequire("lztxY");

var $CTedk = parcelRequire("CTedk");
const $df5e53df2c3ce3a1$export$b1d01ffe4898696d = (properties, key)=>{
    const contentAppearanceProperty = properties?.find((property)=>property?.key === key && property?.version);
    let appearance = (0, $CTedk.ContentAppearanceType).DEFAULT;
    let version = 0;
    if (contentAppearanceProperty) {
        appearance = contentAppearanceProperty.value ? JSON.parse(contentAppearanceProperty.value) : appearance;
        version = contentAppearanceProperty.version?.number || version;
    }
    return {
        appearance: appearance,
        version: version
    };
};
const $df5e53df2c3ce3a1$export$3435d65c6da71431 = (content)=>{
    return $df5e53df2c3ce3a1$export$b1d01ffe4898696d(content.appearanceDraft?.nodes ?? null, (0, $CTedk.ContentAppearancePropertyKey).DRAFT);
};
const $df5e53df2c3ce3a1$export$31055ca3b35a4c84 = (content)=>{
    return $df5e53df2c3ce3a1$export$b1d01ffe4898696d(content.appearancePublished?.nodes ?? null, (0, $CTedk.ContentAppearancePropertyKey).PUBLISHED);
};
const $df5e53df2c3ce3a1$export$2521257be0c7ea48 = async (updateContentAppearanceProperty, params, apolloClient, collabEditProvider)=>{
    try {
        await updateContentAppearanceProperty(params);
        $df5e53df2c3ce3a1$export$444e60a54db64042(collabEditProvider, params);
        return params;
    } catch (error) {
        // If it was an HTTP 409 conflict, retry once with the latest version number + 1
        if ((0, $aMcHK.isStatusCodeError)(error, '409')) {
            const appearanceProperty = await $df5e53df2c3ce3a1$export$1e0fa67d5da0b9b3(params.contentId, params.propertyKey, apolloClient, 'network-only');
            if (appearanceProperty.version) {
                params = $df5e53df2c3ce3a1$export$b7d46c1a2c850d6c(params, appearanceProperty);
                await updateContentAppearanceProperty(params);
                $df5e53df2c3ce3a1$export$444e60a54db64042(collabEditProvider, params);
                return params;
            }
        }
        throw error;
    }
};
const $df5e53df2c3ce3a1$export$b7d46c1a2c850d6c = (params, appearanceProperty)=>{
    params.versionNumber = appearanceProperty.version + 1;
    if (params.propertyValue !== appearanceProperty.appearance) params.propertyValue = appearanceProperty.appearance === (0, $CTedk.ContentAppearanceType).DEFAULT ? (0, $CTedk.ContentAppearanceType).FULL_WIDTH : (0, $CTedk.ContentAppearanceType).DEFAULT;
    return params;
};
function $df5e53df2c3ce3a1$export$7490752b89a3fa25(propertyKey) {
    return propertyKey === (0, $CTedk.ContentAppearancePropertyKey).PUBLISHED ? (0, $lztxY.getPublishedContentAppearanceProperty) : (0, $lztxY.getDraftContentAppearanceProperty);
}
function $df5e53df2c3ce3a1$export$95c1397e685f545a(data, propertyKey) {
    const content = data?.content?.nodes?.[0];
    if (content) return propertyKey === (0, $CTedk.ContentAppearancePropertyKey).PUBLISHED ? $df5e53df2c3ce3a1$export$31055ca3b35a4c84(content) : $df5e53df2c3ce3a1$export$3435d65c6da71431(content);
    return $df5e53df2c3ce3a1$export$a03a5edc3d041369();
}
const $df5e53df2c3ce3a1$export$1e0fa67d5da0b9b3 = async (contentId, propertyKey, apolloClient, fetchPolicy = 'cache-first')=>{
    const query = $df5e53df2c3ce3a1$export$7490752b89a3fa25(propertyKey);
    // This is dummy variable is used to force "network-only" requests to only be run as network calls.
    // A bug in Apollo sometimes makes this query return data from the cache even if the policy is "network-only"
    // See for more details: https://pug.jira-dev.com/wiki/spaces/~683304838/pages/5971970200/Apollo+Client+-+weird+refetch+behavior
    const dummy = fetchPolicy === 'network-only' ? Date.now() : undefined;
    const contentAppearanceDraftProperty = await apolloClient.query({
        query: query,
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            dummy: dummy
        },
        fetchPolicy: fetchPolicy,
        context: {
            single: 'true'
        }
    });
    return $df5e53df2c3ce3a1$export$95c1397e685f545a(contentAppearanceDraftProperty?.data, propertyKey);
};
const $df5e53df2c3ce3a1$export$a03a5edc3d041369 = ()=>{
    return {
        appearance: (0, $CTedk.ContentAppearanceType).DEFAULT,
        version: 0
    };
};
const $df5e53df2c3ce3a1$export$bf8bc2ce12ceefdd = 'editorAppearance';
const $df5e53df2c3ce3a1$export$444e60a54db64042 = (collabEditProvider, params)=>{
    if (!collabEditProvider) return;
    // Implies NCS provider
    if (typeof collabEditProvider.setMetadata === 'function') collabEditProvider.setMetadata({
        ...collabEditProvider.getMetadata(),
        metadataSource: 'client',
        editorWidth: {
            value: params.propertyValue,
            version: params.versionNumber
        }
    });
    else collabEditProvider.sendMessage({
        type: $df5e53df2c3ce3a1$export$bf8bc2ce12ceefdd,
        appearance: params.propertyValue,
        version: params.versionNumber
    });
};
const $df5e53df2c3ce3a1$export$acf12c613e8460b9 = async (appearanceProperty, params, updateContentAppearanceProperty, collabEditProvider)=>{
    const newParams = {
        ...params,
        propertyValue: appearanceProperty.appearance,
        versionNumber: appearanceProperty.version + 1
    };
    if (appearanceProperty.version) {
        await updateContentAppearanceProperty(newParams);
        $df5e53df2c3ce3a1$export$444e60a54db64042(collabEditProvider, newParams);
    }
};
const $df5e53df2c3ce3a1$export$36c1915a504dc477 = ({ children: children, userOffline: userOffline, params: params, apolloClient: apolloClient, updateContentAppearanceProperty: updateContentAppearanceProperty, collabEditProvider: collabEditProvider })=>{
    const [shouldFetchAppearance, setShouldFetchAppearance] = (0, $gwFzn.useState)(false);
    const fetchAndUpdateAfterOffline = async ()=>{
        const appearanceProperty = await $df5e53df2c3ce3a1$export$1e0fa67d5da0b9b3(params.contentId, params.propertyKey, apolloClient, 'network-only');
        await $df5e53df2c3ce3a1$export$acf12c613e8460b9(appearanceProperty, params, updateContentAppearanceProperty, collabEditProvider);
    };
    (0, $gwFzn.useEffect)(()=>{
        // should refetch contentAppearanceProperty after user reconnected
        setShouldFetchAppearance(!!userOffline);
    }, [
        userOffline
    ]);
    if (!userOffline && shouldFetchAppearance) fetchAndUpdateAfterOffline();
    return children;
};

});

parcelRegister("lbr71", function(module, exports) {

$parcel$export(module.exports, "ActionTypes", () => $e94ecf4f7002a765$export$1385d81a6c6bbcd4);
const $e94ecf4f7002a765$export$51a8fff1191e00 = 'EDITOR_CONTENT_PREVIEW';
const $e94ecf4f7002a765$export$9ae8757b668977b9 = 'CHANGE_EDITOR_MODE';
var $e94ecf4f7002a765$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["CHANGE_EDITOR_TITLE"] = "CHANGE_EDITOR_TITLE";
    ActionTypes["CLOSE_EDITOR_ERROR"] = "CLOSE_EDITOR_ERROR";
    ActionTypes["SHOW_EDITOR_ERROR"] = "SHOW_EDITOR_ERROR";
    ActionTypes["EDITOR_CONTENT_V2_REQUEST"] = "EDITOR_CONTENT_V2_REQUEST";
    ActionTypes["EDITOR_CONTENT_V2_SUCCESS"] = "EDITOR_CONTENT_V2_SUCCESS";
    ActionTypes["EDITOR_CONTENT_V2_FAILURE"] = "EDITOR_CONTENT_V2_FAILURE";
    ActionTypes["EDITOR_CONTENT_PUBLISH_REQUEST"] = "EDITOR_CONTENT_PUBLISH_REQUEST";
    ActionTypes["EDITOR_CONTENT_PUBLISH_SUCCESS"] = "EDITOR_CONTENT_PUBLISH_SUCCESS";
    ActionTypes["EDITOR_CONTENT_PUBLISH_FAILURE"] = "EDITOR_CONTENT_PUBLISH_FAILURE";
    ActionTypes["EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_SUCCESS"] = "EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_SUCCESS";
    ActionTypes["EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_FAILURE"] = "EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_FAILURE";
    ActionTypes["EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_REQUEST"] = "EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_REQUEST";
    ActionTypes["EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_SUCCESS"] = "EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_SUCCESS";
    ActionTypes["EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_FAILURE"] = "EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_FAILURE";
    ActionTypes["EDITOR_CONTENT_PREVIEW"] = "EDITOR_CONTENT_PREVIEW";
    ActionTypes["EDITOR_CONTENT_PREVIEW_REQUEST"] = "EDITOR_CONTENT_PREVIEW_REQUEST";
    ActionTypes["EDITOR_CONTENT_PREVIEW_SUCCESS"] = "EDITOR_CONTENT_PREVIEW_SUCCESS";
    ActionTypes["EDITOR_CONTENT_PREVIEW_FAILURE"] = "EDITOR_CONTENT_PREVIEW_FAILURE";
    ActionTypes["EDITOR_DRAFT_SAVE_SUCCESS"] = "EDITOR_DRAFT_SAVE_SUCCESS";
    ActionTypes["SET_IS_PUBLISHING_CONTENT"] = "SET_IS_PUBLISHING_CONTENT";
    ActionTypes["UPDATE_CONTENT_SPACE_KEY"] = "UPDATE_CONTENT_SPACE_KEY";
    ActionTypes["CHANGE_EDITOR_MODE"] = "CHANGE_EDITOR_MODE";
    ActionTypes["CONTENT_SUCCESS"] = "CONTENT_SUCCESS";
    ActionTypes["HANDLE_PUBLISH_EVENT"] = "HANDLE_PUBLISH_EVENT";
    ActionTypes["FEATURE_DISCOVERED_MARK_SUCCESS"] = "FEATURE_DISCOVERED_MARK_SUCCESS";
    ActionTypes["EDITOR_SHOW_SCHEDULED_PUBLISH_DIALOG"] = "EDITOR_SHOW_SCHEDULED_PUBLISH_DIALOG";
    ActionTypes["EDITOR_HIDE_SCHEDULED_PUBLISH_COMPONENT"] = "EDITOR_HIDE_SCHEDULED_PUBLISH_COMPONENT";
    ActionTypes["EDITOR_CURRENTLY_SCHEDULED_PUBLISH_DATE"] = "EDITOR_CURRENTLY_SCHEDULED_PUBLISH_DATE";
    ActionTypes["EDITOR_CANCEL_SCHEDULED_PUBLISH"] = "EDITOR_CANCEL_SCHEDULED_PUBLISH";
    ActionTypes["SET_IS_SCHEDULING_PUBLISH"] = "SET_IS_SCHEDULING_PUBLISH";
    return ActionTypes;
}({});
var $e94ecf4f7002a765$export$c5c68a3d26246634 = /*#__PURE__*/ function(ContentTypeType) {
    ContentTypeType["PAGE"] = "page";
    ContentTypeType["BLOGPOST"] = "blogpost";
    return ContentTypeType;
}({});

});

parcelRegister("bx6Tx", function(module, exports) {

$parcel$export(module.exports, "EDITOR_NAV_DESTINATION", () => $06836d9e9d0af6ba$export$5607a6f6a1982099);
$parcel$export(module.exports, "MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH", () => $06836d9e9d0af6ba$export$12c3fa6b8a339bbd);
var $06836d9e9d0af6ba$export$5607a6f6a1982099 = /*#__PURE__*/ function(EDITOR_NAV_DESTINATION) {
    EDITOR_NAV_DESTINATION["NONE"] = "none";
    EDITOR_NAV_DESTINATION["PREVIEW"] = "preview";
    EDITOR_NAV_DESTINATION["VIEWPAGE"] = "viewpage";
    EDITOR_NAV_DESTINATION["HOMEPAGE"] = "homepage";
    return EDITOR_NAV_DESTINATION;
}({});
const $06836d9e9d0af6ba$export$12c3fa6b8a339bbd = 255;
const $06836d9e9d0af6ba$export$643b14d94ff0897b = {
    FABRIC: 'FABRIC',
    TINY_MCE: 'TINY_MCE'
};
var $06836d9e9d0af6ba$export$9c28bc693ca74328 = /*#__PURE__*/ function(SYNC_STATUS_KEY) {
    SYNC_STATUS_KEY["CONNECTED"] = "connected";
    SYNC_STATUS_KEY["DISCONNECTED"] = "disconnected";
    SYNC_STATUS_KEY["ERROR"] = "error";
    SYNC_STATUS_KEY["COLLAB_LIMIT"] = "collab-limit";
    SYNC_STATUS_KEY["PERMISSION_CHANGED"] = "permission-changed";
    return SYNC_STATUS_KEY;
}({});
const $06836d9e9d0af6ba$export$f292b2b582c6bbae = {
    ["connected"]: {
        text: 'collab.status.connected',
        tooltip: 'collab.status.tooltip.success',
        shouldAutoHide: true,
        type: 'success'
    },
    ["error"]: {
        text: 'collab.status.error',
        tooltip: 'collab.status.tooltip.error',
        shouldAutoHide: false,
        type: 'error'
    },
    ["collab-limit"]: {
        text: 'editor.collab.user.limit.title',
        tooltip: 'editor.collab.user.limit.body',
        shouldAutoHide: false,
        type: 'error'
    },
    ["permission-changed"]: {
        text: 'fabric.editor.permission.removed.title',
        tooltip: 'fabric.editor.permission.removed.description',
        shouldAutoHide: false,
        type: 'error'
    }
};
const $06836d9e9d0af6ba$export$ebc7c6dde3af2f94 = 8;
const $06836d9e9d0af6ba$export$ad0dea64d86a0b40 = 12;
const $06836d9e9d0af6ba$export$2319941692274211 = 'editor.content.placeholder.easy.mentions';
const $06836d9e9d0af6ba$export$65b686286dab5755 = 'editor.onboarding.draft.placeholder';
const $06836d9e9d0af6ba$export$7f03b831e2e40b16 = 'editor.content.placeholder.ai';
const $06836d9e9d0af6ba$export$6a44b93c4f739392 = "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we'll let them know).";

});

parcelRegister("euETc", function(module, exports) {

$parcel$export(module.exports, "OK", () => $b2219e7f428639b5$export$c6813a8d51f77eaf);
const $b2219e7f428639b5$export$c6813a8d51f77eaf = 200;
const $b2219e7f428639b5$export$8bca792d963eb0ef = 404;
const $b2219e7f428639b5$export$8c5e74eae7b64cc2 = 412;
const $b2219e7f428639b5$export$e813cd7045fcc98d = 500;
const $b2219e7f428639b5$export$5ed7505d2b52f8b1 = 503;

});


parcelRegister("kv6FQ", function(module, exports) {

$parcel$export(module.exports, "mediaPreviewer", () => $eecbe12cc5f62c7c$export$126a5094a834342d);

var $btz1y = parcelRequire("btz1y");
const $eecbe12cc5f62c7c$var$previewerInitialState = {
    currentMediaItem: null,
    isOpen: false
};
const $eecbe12cc5f62c7c$export$126a5094a834342d = (state = $eecbe12cc5f62c7c$var$previewerInitialState, action)=>{
    switch(action.type){
        case 0, $btz1y.OPEN_PREVIEWER:
            return Object.assign({}, state, {
                currentMediaItem: action.item.id,
                isOpen: true
            });
        case 0, $btz1y.CLOSE_PREVIEWER:
            return $eecbe12cc5f62c7c$var$previewerInitialState;
    }
    return state;
};

});
parcelRegister("btz1y", function(module, exports) {

$parcel$export(module.exports, "OPEN_PREVIEWER", () => $85ad922d79aba78f$export$248a2cbc69bbb275);
$parcel$export(module.exports, "CLOSE_PREVIEWER", () => $85ad922d79aba78f$export$c891abbc061364af);
$parcel$export(module.exports, "closePreviewer", () => $85ad922d79aba78f$export$6305e437e46c6e97);

var $5cBWV = parcelRequire("5cBWV");
const $85ad922d79aba78f$export$248a2cbc69bbb275 = 'OPEN_PREVIEWER';
const $85ad922d79aba78f$export$66c06c0cd94c0b11 = (0, $5cBWV.commonActionCreator)($85ad922d79aba78f$export$248a2cbc69bbb275);
const $85ad922d79aba78f$export$c891abbc061364af = 'CLOSE_PREVIEWER';
const $85ad922d79aba78f$export$6305e437e46c6e97 = (0, $5cBWV.commonActionCreator)($85ad922d79aba78f$export$c891abbc061364af);

});


parcelRegister("j26JB", function(module, exports) {

$parcel$export(module.exports, "default", () => $db94512ebab9c421$export$2e2bcd8739ae039);

var $6Hj1z = parcelRequire("6Hj1z");

var $f0u1B = parcelRequire("f0u1B");
const $db94512ebab9c421$export$49d5fc8cba920a0 = {
    isSaving: false,
    isError: false,
    errorCode: null
};
function $db94512ebab9c421$export$2e2bcd8739ae039(state = $db94512ebab9c421$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case (0, $6Hj1z.ActionTypes).EDITOR_DRAFT_SAVE_REQUEST:
            return {
                isSaving: true,
                isError: false,
                errorCode: null
            };
        case (0, $6Hj1z.ActionTypes).EDITOR_DRAFT_SAVE_FAILURE:
            return {
                isSaving: false,
                isError: true,
                errorCode: action.message && action.message.statusCode
            };
        case (0, $6Hj1z.ActionTypes).EDITOR_DRAFT_SAVE_SUCCESS:
            return {
                isSaving: false,
                isError: false,
                errorCode: null
            };
        case (0, $6Hj1z.ActionTypes).SET_SAVE_DRAFT:
            return {
                isSaving: action.isSaving === undefined ? false : action.isSaving,
                isError: false,
                errorCode: null
            };
        case (0, $f0u1B.ActionTypes).RESET_EDITOR_STATE:
            return $db94512ebab9c421$export$49d5fc8cba920a0;
        default:
            return state;
    }
}

});
parcelRegister("6Hj1z", function(module, exports) {

$parcel$export(module.exports, "ActionTypes", () => $d5433d48db1ede97$export$1385d81a6c6bbcd4);
var $d5433d48db1ede97$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["EDITOR_DRAFT_SAVE_REQUEST"] = "EDITOR_DRAFT_SAVE_REQUEST";
    ActionTypes["EDITOR_DRAFT_SAVE_SUCCESS"] = "EDITOR_DRAFT_SAVE_SUCCESS";
    ActionTypes["EDITOR_DRAFT_SAVE_FAILURE"] = "EDITOR_DRAFT_SAVE_FAILURE";
    ActionTypes["SET_SAVE_DRAFT"] = "SET_SAVE_DRAFT";
    return ActionTypes;
}({});

});




parcelRegister("eH0qm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab256916bdf15e30$export$2e2bcd8739ae039);
$parcel$export(module.exports, "createEditorContentSelector", () => $ab256916bdf15e30$export$b2f908ac75c2cd6a);

var $cGH1v = parcelRequire("cGH1v");

var $bsCwp = parcelRequire("bsCwp");

var $h0zqw = parcelRequire("h0zqw");
const $ab256916bdf15e30$var$OK = 200;
// This is based on viewpage's defaultState
const $ab256916bdf15e30$var$defaultState = (0, $cGH1v.fromJS)({
    draftId: null,
    isRequesting: false,
    hasFetched: false,
    result: null,
    errorData: null,
    statusCode: null,
    silent: null
});
const $ab256916bdf15e30$var$copyFromOriginalResponse = (response, keys)=>{
    if (!response || !response._originalResponse) return {};
    return Object.keys(response._originalResponse).filter((key)=>keys.indexOf(key) > -1).reduce((filteredKeys, key)=>{
        filteredKeys[key] = response._originalResponse[key];
        return filteredKeys;
    }, {});
};
function $ab256916bdf15e30$export$2e2bcd8739ae039(state = $ab256916bdf15e30$var$defaultState, action) {
    switch(action.type){
        // Creating page.
        case `${0, $h0zqw.EDITOR_CREATE_PAGE}_REQUEST`:
            return state.merge({
                draftId: null,
                isRequesting: true,
                hasFetched: false,
                result: null,
                errorData: null,
                statusCode: null,
                silent: !!action.silent
            });
        case `${0, $h0zqw.EDITOR_CREATE_PAGE}_SUCCESS`:
            return state.merge({
                draftId: action.response.id,
                isRequesting: false,
                hasFetched: true,
                result: {
                    title: '',
                    editorContent: '',
                    ...action.response
                },
                statusCode: $ab256916bdf15e30$var$OK,
                errorData: null
            });
        case `${0, $h0zqw.EDITOR_CREATE_PAGE}_FAILURE`:
            if (state.get('draftId') !== action.options.contentId) return state;
            return state.merge({
                isRequesting: false,
                hasFetched: true,
                statusCode: action.error && action.error.statusCode,
                errorData: action.message
            });
        // Loading existing draft.
        case `${0, $h0zqw.EDITOR_LOAD_DRAFT}_REQUEST`:
            return state.merge({
                draftId: action.contentId,
                isRequesting: true,
                hasFetched: false,
                result: null,
                errorData: null,
                statusCode: null,
                silent: !!action.silent
            });
        case `${0, $h0zqw.EDITOR_LOAD_DRAFT}_SUCCESS`:
            return state.mergeDeep({
                draftId: action.response.id.toString(),
                isRequesting: false,
                hasFetched: true,
                result: {
                    // editorContent - Not having this attribute causes failure in collaborative-helper.js on 'rte-loaded' event and collaborative editing is never initialised propertly.
                    // syncRev - needed by collab editing plugin when loading draft
                    ...$ab256916bdf15e30$var$copyFromOriginalResponse(action.response, [
                        'ancestors',
                        'confRev',
                        'editorContent',
                        'spaceKey',
                        'syncRev',
                        'syncRevSource',
                        'type',
                        'publishedId'
                    ]),
                    ...action.response,
                    title: action.response && action.response.title ? action.response.title : ''
                },
                statusCode: $ab256916bdf15e30$var$OK,
                errorData: null
            });
        case `${0, $h0zqw.EDITOR_LOAD_DRAFT}_FAILURE`:
            if (state.get('draftId') !== action.options.contentId) return state;
            return state.merge({
                isRequesting: false,
                hasFetched: true,
                statusCode: action.error && action.error.statusCode,
                errorData: action.message
            });
        // Loading metadata for existing draft (ancestors, spaceKey etc).
        case `${0, $h0zqw.EDITOR_LOAD_DRAFTMETADATA}_REQUEST`:
            return state.merge({});
        case `${0, $h0zqw.EDITOR_LOAD_DRAFTMETADATA}_SUCCESS`:
            return state.mergeDeep({
                result: {
                    ...action.response
                }
            });
        case `${0, $h0zqw.EDITOR_LOAD_DRAFTMETADATA}_FAILURE`:
            if (state.get('draftId') !== action.options.contentId) return state;
            return state.merge({
                hasFetched: true,
                statusCode: action.error && action.error.statusCode,
                errorData: action.message
            });
        default:
            return state;
    }
}
/*
 * Selectors
 */ const $ab256916bdf15e30$var$getEditorContentState = (state)=>state.editor;
const $ab256916bdf15e30$export$b2f908ac75c2cd6a = ()=>(0, $bsCwp.createSelector)($ab256916bdf15e30$var$getEditorContentState, (contentState)=>{
        const isRequesting = contentState.get('isRequesting', false);
        const hasFetched = contentState.get('hasFetched', false);
        const draftId = contentState.get('draftId');
        const silent = contentState.get('silent', false);
        const statusCode = contentState.get('statusCode');
        const errorData = contentState.get('errorData', null);
        const result = contentState.get('result', null);
        return {
            draftId: draftId,
            isRequesting: isRequesting,
            hasFetched: hasFetched,
            result: result && typeof result.toJS === 'function' ? result.toJS() : result,
            statusCode: statusCode,
            errorData: errorData && typeof errorData.toJS === 'function' ? errorData.toJS() : errorData,
            // calculated data
            shouldNavigateToEditPage: !silent && hasFetched && statusCode === $ab256916bdf15e30$var$OK
        };
    });

});
parcelRegister("h0zqw", function(module, exports) {

$parcel$export(module.exports, "SHOW_EDITOR", () => $c61deac1d0fcb139$export$adab377c3747e6ec);
$parcel$export(module.exports, "HIDE_EDITOR", () => $c61deac1d0fcb139$export$769680a800b3e49b);
$parcel$export(module.exports, "CHANGE_EDITOR_TITLE", () => $c61deac1d0fcb139$export$f536364345fa901);
$parcel$export(module.exports, "CLOSE_EDITOR_ERROR", () => $c61deac1d0fcb139$export$cf3830159073b5c6);
$parcel$export(module.exports, "SHOW_EDITOR_ERROR", () => $c61deac1d0fcb139$export$8d355854b1568521);
$parcel$export(module.exports, "EDITOR_LOAD_COMPLETE", () => $c61deac1d0fcb139$export$bb74b4aa9d2a7883);
$parcel$export(module.exports, "EDITOR_PRELOAD_START", () => $c61deac1d0fcb139$export$844e5d28d7c53716);
$parcel$export(module.exports, "EDITOR_PRELOAD_FINISH", () => $c61deac1d0fcb139$export$5414e4eb34232361);
$parcel$export(module.exports, "RESET_EDITOR_STATE", () => $c61deac1d0fcb139$export$df4d75fdeb9b0a75);
$parcel$export(module.exports, "EDITOR_CONTENT", () => $c61deac1d0fcb139$export$1b6e2215dbbf3c21);
$parcel$export(module.exports, "EDITOR_CONTENT_PUBLISH", () => $c61deac1d0fcb139$export$1d1f1f4f7efebacf);
$parcel$export(module.exports, "EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH", () => $c61deac1d0fcb139$export$e0b0325845bd4c65);
$parcel$export(module.exports, "CHANGE_EDITOR_MODE", () => $c61deac1d0fcb139$export$9ae8757b668977b9);
$parcel$export(module.exports, "EDITOR_CONTENT_EDITABLE", () => $c61deac1d0fcb139$export$8bea51dc3517b81a);
$parcel$export(module.exports, "EDITOR_DRAFT_SAVE", () => $c61deac1d0fcb139$export$80c3dfc9d5cacb39);
$parcel$export(module.exports, "SET_SAVE_DRAFT", () => $c61deac1d0fcb139$export$be00ff52a5d342df);
$parcel$export(module.exports, "EDITOR_CREATE_PAGE", () => $c61deac1d0fcb139$export$1b2c38a78682fc42);
$parcel$export(module.exports, "EDITOR_LOAD_DRAFT", () => $c61deac1d0fcb139$export$bb7a1e42ff29bee3);
$parcel$export(module.exports, "EDITOR_LOAD_DRAFTMETADATA", () => $c61deac1d0fcb139$export$8e503201b9a4fa83);
$parcel$export(module.exports, "SET_IS_PUBLISHING_CONTENT", () => $c61deac1d0fcb139$export$660d7837b5f43300);
$parcel$export(module.exports, "EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY", () => $c61deac1d0fcb139$export$6abc1bce3635b823);
$parcel$export(module.exports, "UPDATE_CONTENT_SPACE_KEY", () => $c61deac1d0fcb139$export$1bcb5f8fa4e3ec7b);
$parcel$export(module.exports, "EDITOR_SHOW_SCHEDULED_PUBLISH_DIALOG", () => $c61deac1d0fcb139$export$8a1237499437174d);
$parcel$export(module.exports, "EDITOR_HIDE_SCHEDULED_PUBLISH_COMPONENT", () => $c61deac1d0fcb139$export$c44d1aa4144e442a);
$parcel$export(module.exports, "EDITOR_CURRENTLY_SCHEDULED_PUBLISH_DATE", () => $c61deac1d0fcb139$export$9a9886cb61805b71);
$parcel$export(module.exports, "EDITOR_CANCEL_SCHEDULED_PUBLISH", () => $c61deac1d0fcb139$export$80219463b60ef911);
$parcel$export(module.exports, "SET_IS_SCHEDULING_PUBLISH", () => $c61deac1d0fcb139$export$8dfd7df63c7e238c);
const $c61deac1d0fcb139$export$adab377c3747e6ec = 'SHOW_EDITOR';
const $c61deac1d0fcb139$export$769680a800b3e49b = 'HIDE_EDITOR';
const $c61deac1d0fcb139$export$f536364345fa901 = 'CHANGE_EDITOR_TITLE';
const $c61deac1d0fcb139$export$cf3830159073b5c6 = 'CLOSE_EDITOR_ERROR';
const $c61deac1d0fcb139$export$8d355854b1568521 = 'SHOW_EDITOR_ERROR';
const $c61deac1d0fcb139$export$bb74b4aa9d2a7883 = 'EDITOR_LOAD_COMPLETE';
const $c61deac1d0fcb139$export$844e5d28d7c53716 = 'EDITOR_PRELOAD_START';
const $c61deac1d0fcb139$export$5414e4eb34232361 = 'EDITOR_PRELOAD_FINISH';
const $c61deac1d0fcb139$export$df4d75fdeb9b0a75 = 'RESET_EDITOR_STATE';
const $c61deac1d0fcb139$export$1b6e2215dbbf3c21 = 'EDITOR_CONTENT';
const $c61deac1d0fcb139$export$1280b2627d9867ba = 'EDITOR_CONTENT_V2';
const $c61deac1d0fcb139$export$1d1f1f4f7efebacf = 'EDITOR_CONTENT_PUBLISH';
const $c61deac1d0fcb139$export$e0b0325845bd4c65 = 'EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH';
const $c61deac1d0fcb139$export$9ae8757b668977b9 = 'CHANGE_EDITOR_MODE';
const $c61deac1d0fcb139$export$8bea51dc3517b81a = 'EDITOR_CONTENT_EDITABLE';
const $c61deac1d0fcb139$export$80c3dfc9d5cacb39 = 'EDITOR_DRAFT_SAVE';
const $c61deac1d0fcb139$export$be00ff52a5d342df = 'SET_SAVE_DRAFT';
const $c61deac1d0fcb139$export$1b2c38a78682fc42 = 'EDITOR_CREATE_PAGE';
const $c61deac1d0fcb139$export$bb7a1e42ff29bee3 = 'EDITOR_LOAD_DRAFT';
const $c61deac1d0fcb139$export$8e503201b9a4fa83 = 'EDITOR_LOAD_DRAFTMETADATA';
const $c61deac1d0fcb139$export$660d7837b5f43300 = 'SET_IS_PUBLISHING_CONTENT';
const $c61deac1d0fcb139$export$6abc1bce3635b823 = 'EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY';
const $c61deac1d0fcb139$export$1bcb5f8fa4e3ec7b = 'UPDATE_CONTENT_SPACE_KEY';
const $c61deac1d0fcb139$export$8a1237499437174d = 'EDITOR_SHOW_SCHEDULED_PUBLISH_DIALOG';
const $c61deac1d0fcb139$export$c44d1aa4144e442a = 'EDITOR_HIDE_SCHEDULED_PUBLISH_COMPONENT';
const $c61deac1d0fcb139$export$9a9886cb61805b71 = 'EDITOR_CURRENTLY_SCHEDULED_PUBLISH_DATE';
const $c61deac1d0fcb139$export$80219463b60ef911 = 'EDITOR_CANCEL_SCHEDULED_PUBLISH';
const $c61deac1d0fcb139$export$8dfd7df63c7e238c = 'SET_IS_SCHEDULING_PUBLISH';

});


parcelRegister("dEWzl", function(module, exports) {

$parcel$export(module.exports, "entities", () => $9f1c715f0cac804e$export$5345fd892b40e1f6);

var $cGH1v = parcelRequire("cGH1v");

var $3zCSz = parcelRequire("3zCSz");

var $7PU1Q = parcelRequire("7PU1Q");

var $j3UAj = parcelRequire("j3UAj");

var $1LVIv = parcelRequire("1LVIv");

var $iPLCY = parcelRequire("iPLCY");
const $9f1c715f0cac804e$export$643b14d94ff0897b = {
    FABRIC: 'FABRIC',
    TINY_MCE: 'TINY_MCE'
};
const $9f1c715f0cac804e$export$b8df60f367f4105 = (0, $cGH1v.fromJS)({
    spaces: {},
    lookAndFeelSettings: {},
    contents: {},
    versions: {},
    users: {},
    labels: {}
});
const $9f1c715f0cac804e$var$entityReducerCommon = (state, action, entityKey, recordCreator = (0, $cGH1v.fromJS))=>{
    if (!action.response || !action.response.entities || !action.response.entities.hasOwnProperty(entityKey)) return state;
    const actionEntities = action.response.entities[entityKey];
    for (const key of Object.keys(actionEntities)){
        const stateEntity = state.get(key);
        let record = recordCreator(actionEntities[key]);
        if (stateEntity) record = stateEntity.mergeDeepWith((prev, next)=>{
            if (next === null) return prev;
            return next;
        }, record);
        state = state.set(key, record);
    }
    return state;
};
const $9f1c715f0cac804e$var$contents = (state, action)=>{
    state = $9f1c715f0cac804e$var$entityReducerCommon(state, action, 'contents', (item)=>new (0, $3zCSz.default)(item));
    switch(action.type){
        case 'CONTENT_FAILURE':
        case 'EDITOR_CONTENT_V2_FAILURE':
            if (action.error?.extensions?.statusCode === 403) {
                let hasInheritedRestrictions = false;
                let data = action.error && action.error.data;
                // handle the REST case, which will be removed soon
                if (action.message && action.message.data) data = action.message && action.message.data;
                if (data) {
                    if ((data.errors || []).some((error)=>error.message.key === 'confluence.space.restricted')) // Show not found when user doesn't have permission to view the space
                    // Make it consistent with pre-SPA
                    return state;
                    hasInheritedRestrictions = (data.errors || []).some((error)=>error.message.key === 'confluence.content.restricted.inherited');
                }
                // replace by new content record
                state = state.set(action.options.contentId, new (0, $3zCSz.default)({
                    id: action.options.contentId,
                    isUnauthorized: true,
                    hasInheritedRestrictions: hasInheritedRestrictions
                }));
            }
            return state;
        case 'QUICK_RELOAD_SUCCESS':
        case 'CONTENT_SUCCESS':
            if (action.type === 'CONTENT_SUCCESS') {
                const editorValue = action?.response?.properties?.editor?.value;
                const editorVersion = editorValue === 'v2' ? $9f1c715f0cac804e$export$643b14d94ff0897b.FABRIC : $9f1c715f0cac804e$export$643b14d94ff0897b.TINY_MCE;
                state = state.setIn([
                    action.contentId,
                    'editorVersion'
                ], editorVersion);
            }
            // update last fetched time.
            const lastFetchTime = action.response && action.response.lastFetchTime ? action.response.lastFetchTime : new Date().getTime();
            return state.setIn([
                action.contentId,
                'lastFetchTime'
            ], lastFetchTime);
        case 'EDITOR_CONTENT_METADATA_SUCCESS':
            const updatedAncestors = action.response?.ancestors?.map((ancestor)=>{
                return ancestor.id;
            });
            if (updatedAncestors) return state.setIn([
                action.contentId,
                'ancestors'
            ], (0, $cGH1v.OrderedSet)(updatedAncestors));
    }
    return state;
};
const $9f1c715f0cac804e$var$users = (state, action)=>$9f1c715f0cac804e$var$entityReducerCommon(state, action, 'users', (item)=>new (0, $j3UAj.default)(item));
const $9f1c715f0cac804e$var$lookAndFeelSettings = (state, action)=>$9f1c715f0cac804e$var$entityReducerCommon(state, action, 'lookAndFeelSettings', (item)=>(0, $cGH1v.fromJS)(item));
const $9f1c715f0cac804e$var$labels = (state, action)=>$9f1c715f0cac804e$var$entityReducerCommon(state, action, 'labels', (item)=>new (0, $iPLCY.default)(item));
const $9f1c715f0cac804e$var$versions = (state, action)=>{
    state = $9f1c715f0cac804e$var$entityReducerCommon(state, action, 'versions', (item)=>new (0, $7PU1Q.default)(item));
    if (action.type === 'HANDLE_VERSION_UPDATE') state = state.setIn([
        action.contentId,
        'number'
    ], action.version);
    return state;
};
function $9f1c715f0cac804e$export$efbef60d53829a48(state, action) {
    const spaceKeyInRequest = action.key || action.spaceKey;
    if (!spaceKeyInRequest || !action.response || !action.response.entities || !action.response.entities.spaces) return state;
    const spaceKeysInResponse = Object.keys(action.response.entities.spaces);
    if (spaceKeysInResponse.length) {
        const spaceKeyInResponse = spaceKeysInResponse[0];
        if (spaceKeyInRequest !== spaceKeyInResponse && spaceKeyInRequest.toLowerCase() === spaceKeyInResponse.toLowerCase()) // Front-end is fetching a space with wrong letter case
        // Copy the record to correct place that rest of the code is expecting.
        state = state.withMutations((spaces)=>{
            spaces.set(spaceKeyInRequest, spaces.get(spaceKeyInResponse)).delete(spaceKeyInResponse);
        });
    }
    return state;
}
const $9f1c715f0cac804e$var$spaces = (state, action)=>{
    const previousState = state;
    state = $9f1c715f0cac804e$var$entityReducerCommon(state, action, 'spaces', (item)=>new (0, $1LVIv.default)(item));
    if (state !== previousState) state = $9f1c715f0cac804e$export$efbef60d53829a48(state, action);
    if (action.type === 'SPACE_HOME_CONTENT_SUCCESS') {
        if (state.get(action.spaceKey)) return state.mergeDeep({
            [action.spaceKey]: {
                homepageId: action.response.id
            }
        });
        return state;
    } else return state;
};
const $9f1c715f0cac804e$var$entityReducers = {
    contents: $9f1c715f0cac804e$var$contents,
    versions: $9f1c715f0cac804e$var$versions,
    users: $9f1c715f0cac804e$var$users,
    spaces: $9f1c715f0cac804e$var$spaces,
    lookAndFeelSettings: $9f1c715f0cac804e$var$lookAndFeelSettings,
    labels: $9f1c715f0cac804e$var$labels
};
const $9f1c715f0cac804e$var$invokeEntityReducer = (state, action, entityKey)=>{
    const entityReducer = $9f1c715f0cac804e$var$entityReducers[entityKey];
    let stateEntities = state.get(entityKey);
    stateEntities = entityReducer(stateEntities, action);
    return state.set(entityKey, stateEntities);
};
function $9f1c715f0cac804e$export$5345fd892b40e1f6(state = $9f1c715f0cac804e$export$b8df60f367f4105, action) {
    return state.withMutations((state)=>{
        for (const entityKey of Object.keys($9f1c715f0cac804e$var$entityReducers))state = $9f1c715f0cac804e$var$invokeEntityReducer(state, action, entityKey);
        return state;
    });
}

});
parcelRegister("3zCSz", function(module, exports) {

$parcel$export(module.exports, "default", () => $29a2cc98ace825c0$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");

var $cb6fO = parcelRequire("cb6fO");
const $29a2cc98ace825c0$var$UserContext = (0, $cGH1v.Record)({
    isFavourite: null,
    favouritedDate: null,
    lastSeen: null,
    lastModified: null,
    contentStatus: null
});
const $29a2cc98ace825c0$var$Link = (0, $cGH1v.Record)({
    editui: null,
    webui: null,
    webuiIsSpa: null,
    viewChangesLink: null
});
const $29a2cc98ace825c0$var$CardCount = (0, $cGH1v.Record)({
    cssClass: null,
    iconType: null,
    count: 0
});
const $29a2cc98ace825c0$var$Body = (0, $cGH1v.Record)({
    html: null,
    editorHtml: null,
    cssTags: '',
    jsUris: (0, $cGH1v.List)([])
});
class $29a2cc98ace825c0$export$2e2bcd8739ae039 extends (0, $cGH1v.Record)({
    id: null,
    type: null,
    iconType: null,
    kind: null,
    title: null,
    slug: null,
    links: null,
    version: null,
    summary: null,
    iconCssClass: null,
    iconPath: null,
    createdBy: null,
    createdDate: null,
    friendlyDate: null,
    contentCssClass: null,
    userContext: null,
    numberOfLikes: null,
    numberOfComments: null,
    willbedeleted: null,
    cardCounts: (0, $cGH1v.fromJS)([]),
    contributors: (0, $cGH1v.List)([]),
    hasChildren: null,
    childNodes: (0, $cGH1v.List)([]),
    body: null,
    position: null,
    webItems: (0, $cGH1v.Set)([]),
    ancestors: (0, $cGH1v.OrderedSet)([]),
    currentUserPermissions: (0, $cGH1v.Set)([]),
    labels: (0, $cGH1v.Set)([]),
    spaceKey: null,
    // `isUnauthorized` is set to be `true` explicitly in a content reducer.
    // `isUnauthorized` can not be `false`
    // because while merging old and new content entities in `entityReducerCommon,
    // we don't want the new content entity can override `isUnauthorized` prop and make it from `true` to `false`.
    isUnauthorized: null,
    hasInheritedRestrictions: null,
    lastFetchTime: null,
    viewers: (0, $cGH1v.List)([]),
    editorVersion: null
}) {
    constructor(recordData){
        super(recordData);
        return this.withMutations((contentData)=>{
            if (recordData.links) contentData.set('links', new $29a2cc98ace825c0$var$Link(recordData.links));
            if (recordData.userContext) contentData.set('userContext', new $29a2cc98ace825c0$var$UserContext(recordData.userContext));
            if (recordData.cardCounts) contentData.set('cardCounts', (0, $cGH1v.fromJS)(recordData.cardCounts, (key, val)=>{
                const isIndexed = (0, $cGH1v.Iterable).isIndexed(val);
                return isIndexed ? val.toList() : new $29a2cc98ace825c0$var$CardCount(val);
            }));
            if (recordData.viewers) contentData.set('viewers', (0, $cGH1v.List)(recordData.viewers));
            if (recordData.childNodes) contentData.set('childNodes', (0, $cGH1v.List)(recordData.childNodes));
            if (recordData.contributors) contentData.set('contributors', (0, $cGH1v.List)(recordData.contributors));
            if (recordData.body) contentData.set('body', new $29a2cc98ace825c0$var$Body(recordData.body));
            if (recordData.ancestors) contentData.set('ancestors', (0, $cGH1v.OrderedSet)(recordData.ancestors));
            if (recordData.currentUserPermissions) contentData.set('currentUserPermissions', (0, $cGH1v.Set)(recordData.currentUserPermissions));
            if (recordData.title) contentData.set('slug', (0, $cb6fO.generateSlug)(recordData.title));
            if (recordData.labels) contentData.set('labels', (0, $cGH1v.Set)(recordData.labels));
            // schema of content entity `schemas/entities.js` has a `space` prop.
            // Before normalizr, `content.space` is a space object.
            // After normalizr, `content.space` is a space key value
            if (recordData.space) contentData.set('spaceKey', recordData.space);
            return contentData;
        });
    }
}

});

parcelRegister("7PU1Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b48c1fb1fe4a908$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");
const $5b48c1fb1fe4a908$var$Version = (0, $cGH1v.Record)({
    id: null,
    by: null,
    when: null,
    message: null,
    friendlyWhen: null,
    number: null,
    syncRev: null,
    confRev: null
});
var $5b48c1fb1fe4a908$export$2e2bcd8739ae039 = $5b48c1fb1fe4a908$var$Version;

});

parcelRegister("j3UAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $de0a30b1544dd4ed$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");
const $de0a30b1544dd4ed$var$User = (0, $cGH1v.Record)({
    isAnonymous: false,
    displayName: null,
    fullName: null,
    email: null,
    avatarUrl: null,
    isCurrentUser: null,
    currentUserCanFollow: null,
    currentUserIsFollowing: null,
    currentUserCanViewProfile: null,
    detailsPosition: null,
    detailsDepartment: null,
    detailsLocation: null,
    hasPersonalSpace: null,
    hasBlog: null,
    accountId: null,
    unknownUser: null
});
var $de0a30b1544dd4ed$export$2e2bcd8739ae039 = $de0a30b1544dd4ed$var$User;

});

parcelRegister("1LVIv", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a6f39917c86841$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");

var $9LIaS = parcelRequire("9LIaS");

var $b0Rvz = parcelRequire("b0Rvz");

var $hwi7Z = parcelRequire("hwi7Z");
const $14a6f39917c86841$var$Settings = (0, $cGH1v.Record)({
    routeOverrideEnabled: null
});
class $14a6f39917c86841$export$2e2bcd8739ae039 extends (0, $cGH1v.Record)({
    id: null,
    key: null,
    name: null,
    alias: null,
    type: null,
    description: null,
    iconPath: null,
    isFavourite: null,
    isWatched: null,
    labels: [],
    homepageId: null,
    currentUserPermissions: null,
    operations: (0, $cGH1v.List)([]),
    shortcutLinks: null,
    settings: new $14a6f39917c86841$var$Settings({}),
    lookAndFeel: new (0, $b0Rvz.default)({}),
    theme: new (0, $hwi7Z.default)({})
}) {
    constructor(recordData){
        super(recordData);
        return this.withMutations((spaceData)=>{
            if (recordData.currentUserPermissions) spaceData.set('currentUserPermissions', (0, $cGH1v.List)(recordData.currentUserPermissions));
            if (recordData.settings) spaceData.set('settings', new $14a6f39917c86841$var$Settings(recordData.settings));
            if (recordData.operations) spaceData.set('operations', (0, $cGH1v.fromJS)(recordData.operations, (key, val)=>{
                const isIndexed = (0, $cGH1v.Iterable).isIndexed(val);
                return isIndexed ? val.toList() : new (0, $9LIaS.default)(val);
            }));
            if (recordData.lookAndFeel) spaceData.set('lookAndFeel', new (0, $b0Rvz.default)(recordData.lookAndFeel));
            if (recordData.theme) spaceData.set('theme', new (0, $hwi7Z.default)(recordData.theme));
            return spaceData;
        });
    }
}

});
parcelRegister("9LIaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $71cac4f0d22dbe71$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");
const $71cac4f0d22dbe71$var$OperationRecord = (0, $cGH1v.Record)({
    operation: null,
    targetType: null
});
var $71cac4f0d22dbe71$export$2e2bcd8739ae039 = $71cac4f0d22dbe71$var$OperationRecord;

});

parcelRegister("b0Rvz", function(module, exports) {

$parcel$export(module.exports, "default", () => $80493364ed2e8c98$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");
const $80493364ed2e8c98$var$LookAndFeel = (0, $cGH1v.Record)({
    headings: null,
    header: null,
    content: null
});
var $80493364ed2e8c98$export$2e2bcd8739ae039 = $80493364ed2e8c98$var$LookAndFeel;

});

parcelRegister("hwi7Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc137ca62277422b$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");
const $cc137ca62277422b$var$ThemeRecord = new (0, $cGH1v.Record)({
    addonKey: null,
    moduleKey: null
});
var $cc137ca62277422b$export$2e2bcd8739ae039 = $cc137ca62277422b$var$ThemeRecord;

});


parcelRegister("iPLCY", function(module, exports) {

$parcel$export(module.exports, "default", () => $db61ef3e61ad2825$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ErrorLabelRecord", () => $db61ef3e61ad2825$export$13a00d386e124fe1);

var $cGH1v = parcelRequire("cGH1v");
const $db61ef3e61ad2825$var$Label = (0, $cGH1v.Record)({
    id: null,
    name: null,
    prefix: null
});
var $db61ef3e61ad2825$export$2e2bcd8739ae039 = $db61ef3e61ad2825$var$Label;
const $db61ef3e61ad2825$export$13a00d386e124fe1 = (0, $cGH1v.Record)({
    message: '',
    messageKey: '',
    args: []
});

});


parcelRegister("ebjWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5318ef16786ff1d$export$2e2bcd8739ae039);

var $jiJCD = parcelRequire("jiJCD");

var $dBmJE = parcelRequire("dBmJE");
var $kJOOQ = parcelRequire("kJOOQ");

var $aAPlI = parcelRequire("aAPlI");
var /**
 * Takes a LOCATION_CHANGE action from connected-react-router and augments it with a "query" object (which represents the
 * querystring parameters), and the route parameters extracted from Confluence's supported routes.
 *
 * This was written for backwards compatibility with the state provided by redux-router (which we moved away from).
 *
 * @param {object} state
 * @param {object} action
 * @returns {{ location: object, params: object }}
 */ $a5318ef16786ff1d$export$2e2bcd8739ae039 = (browserHistory)=>{
    const routerReducer = browserHistory ? (0, $dBmJE.connectRouter)(browserHistory) : (state = null)=>state;
    return (state, action)=>{
        const newState = routerReducer(state, action);
        if (action && action.type === (0, $kJOOQ.LOCATION_CHANGE)) {
            const { match: match, routeName: routeName, screenName: screenName } = (0, $aAPlI.default)(action.payload.location.pathname);
            const query = newState.location.search ? (0, $jiJCD.parse)(newState.location.search, true).query : {};
            return {
                action: newState.action,
                location: {
                    ...newState.location,
                    query: query,
                    routeName: routeName,
                    screenName: screenName
                },
                params: match ? match.params : {}
            };
        }
        return newState;
    };
};

});
parcelRegister("aAPlI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b651915a8161023$export$2e2bcd8739ae039);

var $64KID = parcelRequire("64KID");

var $fMEnQ = parcelRequire("fMEnQ");

var $cb6fO = parcelRequire("cb6fO");

var $gusyn = parcelRequire("gusyn");
const $7b651915a8161023$var$routes = Object.values((0, $gusyn.default)((0, $64KID.namedRoutes)));
function $7b651915a8161023$var$replaceParams(token) {
    return token.replace(/^:\w+/g, '').replace(/\(.+?\)/g, '');
}
function $7b651915a8161023$export$96ef22564cc59326(a, b) {
    const tokensA = a.definition.pattern.split('/');
    const tokensB = b.definition.pattern.split('/');
    for(let i = 0; i < tokensA.length || i < tokensB.length; i++){
        if (i < tokensA.length && i < tokensB.length) {
            const lengthA = $7b651915a8161023$var$replaceParams(tokensA[i]).length;
            const lengthB = $7b651915a8161023$var$replaceParams(tokensB[i]).length;
            if (lengthA < lengthB) return 1;
            else if (lengthA > lengthB) return -1;
        } else if (i < tokensA.length) return -1;
        else return 1;
    }
    return 0;
}
var $7b651915a8161023$export$2e2bcd8739ae039 = (pathname)=>{
    if (typeof pathname !== 'string') return {
        match: null,
        routeName: ''
    };
    const matches = [];
    for (const definition of $7b651915a8161023$var$routes){
        if (!(definition instanceof (0, $fMEnQ.Route))) continue;
        const match = definition.match((0, $cb6fO.getContextAwareFullPath)(pathname, true));
        if (match) matches.push({
            definition: definition,
            match: match
        });
    }
    if (matches.length >= 1) {
        let match = matches[0];
        if (matches.length > 1) {
            // Match as many literals as possible
            matches.sort($7b651915a8161023$export$96ef22564cc59326);
            match = matches[0];
        }
        return {
            match: match.match,
            routeName: match.definition.name,
            screenName: match.definition.screenName || ''
        };
    }
    return {
        match: null,
        routeName: '',
        screenName: ''
    };
};

});
parcelRegister("gusyn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c01598d377ef7a00$export$2e2bcd8739ae039);
/*
    This is a temporary solution for adding screenNames to named-routes.

    Rather than explicitly couple analytics to routing, we will end up moving screenName to a
    wrapper component that will take care of sending screen events, and will also have a decorator to
    add screenName to all events below it.
*/ const $c01598d377ef7a00$export$e603d10457baeb34 = {
    EDIT_PAGE: 'editPageScreen',
    EDIT_BLOG: 'editPageScreen',
    EDIT_PAGE_V2: 'editPageScreen',
    EDIT_BLOG_V2: 'editPageScreen',
    EDIT_PAGE_EMBED: 'editPageEmbedScreen',
    CREATE_PAGE: 'editPageScreen',
    CREATE_BLOG: 'editPageScreen',
    SPACE_OVERVIEW: 'spaceOverviewScreen',
    VIEW_PAGE: 'viewPageScreen',
    VIEW_BLOG_DATE_LEGACY: 'viewPageScreen',
    VIEW_BLOG: 'viewPageScreen',
    SPACE_CALENDARS: 'spaceCalendarsScreen',
    ALL_UPDATES: 'allUpdatesScreen',
    POPULAR: 'popularScreen',
    MY_WORK_DRAFTS: 'draftsScreen',
    RECENT_DRAFTS: 'recentDraftsScreen',
    MY_WORK_RECENT: 'recentlyWorkedOnScreen',
    RECENT_PAGES: 'recentPagesScreen',
    MY_RECENTLY_VISITED: 'recentlyVisitedScreen',
    RECENT_VISITED: 'recentVisitedScreen',
    MY_SAVED_FOR_LATER: 'savedScreen',
    RECENT_SAVED_FOR_LATER: 'recentSavedScreen',
    HOME: 'homeScreen',
    PDF_EXPORT_PAGE: 'pdfExportScreen',
    PDF_EXPORT_SPACE: 'pdfExportScreen',
    TOPICS: 'topicsScreen'
};
const $c01598d377ef7a00$var$mapRoutesToScreenName = (routes, screenNames = $c01598d377ef7a00$export$e603d10457baeb34)=>{
    for(const name in routes)if (typeof routes[name] === 'object') routes[name].screenName = screenNames[name];
    return routes;
};
var $c01598d377ef7a00$export$2e2bcd8739ae039 = $c01598d377ef7a00$var$mapRoutesToScreenName;

});



parcelRegister("gCBCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c19d5fe3ca344db2$export$2e2bcd8739ae039);

var $jiJCD = parcelRequire("jiJCD");

var $jxPid = parcelRequire("jxPid");

var $cGH1v = parcelRequire("cGH1v");

var $kJOOQ = parcelRequire("kJOOQ");

var $iU8DZ = parcelRequire("iU8DZ");

var $7M69y = parcelRequire("7M69y");
const $c19d5fe3ca344db2$var$MAXIMUM_ITEM_SAVE_IN_HISTORY = 10;
const $c19d5fe3ca344db2$var$rootState = {
    session: {
        history: (0, $cGH1v.List)([]),
        analytics: (0, $cGH1v.fromJS)({
            currentSection: '',
            previousSection: '',
            searchSessionId: ''
        })
    }
};
function $c19d5fe3ca344db2$export$55abd4691b317664(state = $c19d5fe3ca344db2$var$rootState.session.history, action) {
    switch(action.type){
        case 0, $kJOOQ.LOCATION_CHANGE:
            return state.push(action.payload.location.pathname).takeLast($c19d5fe3ca344db2$var$MAXIMUM_ITEM_SAVE_IN_HISTORY);
        default:
            return state;
    }
}
function $c19d5fe3ca344db2$export$71a493436f9bccb6(state = $c19d5fe3ca344db2$var$rootState.session.analytics, action) {
    switch(action.type){
        case 0, $kJOOQ.LOCATION_CHANGE:
            const previousSection = state.get('currentSection');
            const currentSection = (0, $iU8DZ.stripContentTitlesFromURL)(action.payload.location.pathname);
            const searchSessionId = (0, $jiJCD.parse)(action.payload.location.search, true).query.search_id || state.get('searchSessionId');
            return state.merge({
                currentSection: currentSection,
                previousSection: previousSection,
                searchSessionId: searchSessionId
            });
        default:
            return state;
    }
}
var $c19d5fe3ca344db2$export$2e2bcd8739ae039 = (0, $jxPid.combineReducers)({
    errors: $7M69y.default,
    history: $c19d5fe3ca344db2$export$55abd4691b317664,
    analytics: $c19d5fe3ca344db2$export$71a493436f9bccb6
});

});
parcelRegister("iU8DZ", function(module, exports) {

$parcel$export(module.exports, "stripContentTitlesFromURL", () => $dc34297d07844a72$export$bd2270b4ca226dc6);
$parcel$export(module.exports, "getEditPageV2", () => $dc34297d07844a72$export$51becd8adde0429c);
$parcel$export(module.exports, "isSpaceOverviewRoute", () => $dc34297d07844a72$export$d6ed4b21ccee5919);

var $jiJCD = parcelRequire("jiJCD");

var $lwdd5 = parcelRequire("lwdd5");

var $1NBp8 = parcelRequire("1NBp8");

var $aTWRz = parcelRequire("aTWRz");
const $dc34297d07844a72$export$ecf541e09a511845 = (param, url)=>$dc34297d07844a72$export$ec161d740909e39d(url)[param];
const $dc34297d07844a72$export$ec161d740909e39d = (url)=>{
    /* istanbul ignore next */ if (typeof url === 'undefined') url = (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location.href;
    const parsedUrl = (0, $jiJCD.parse)(url, true);
    return parsedUrl.query || {};
};
const $dc34297d07844a72$export$6d562956a780c337 = (url)=>{
    if (0, $aTWRz.CONTEXT_PATH) url = url.replace((0, $aTWRz.CONTEXT_PATH), '');
    return url.replace(/^\/(.*)/, '$1');
};
const $dc34297d07844a72$var$PAGE_CONTENT_SLUG_REGEX = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/([^\/]+)/pages/([0-9]+)/([^?/]+)`);
const $dc34297d07844a72$var$BLOG_CONTENT_SLUG_REGEX = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/([^\/]+)/blog/(\\d{4})/(\\d{2})/(\\d{2})/([0-9]+)/([^?/]+)`);
const $dc34297d07844a72$export$bd2270b4ca226dc6 = (url)=>{
    if (!url) return '';
    else if ($dc34297d07844a72$var$PAGE_CONTENT_SLUG_REGEX.test(url)) return url.replace($dc34297d07844a72$var$PAGE_CONTENT_SLUG_REGEX, '/spaces/$1/pages/$2/:contentSlug');
    else if ($dc34297d07844a72$var$BLOG_CONTENT_SLUG_REGEX.test(url)) return url.replace($dc34297d07844a72$var$BLOG_CONTENT_SLUG_REGEX, '/spaces/$1/blog/$2/$3/$4/$5/:contentSlug');
    else return url.replace((0, $aTWRz.CONTEXT_PATH), '') || '/';
};
const $dc34297d07844a72$export$53355f81448f1b1f = (params, url)=>{
    const parsedUrl = (0, $jiJCD.parse)(url, true);
    delete parsedUrl.search;
    parsedUrl.query = {
        ...parsedUrl.query,
        ...params
    };
    return (0, $jiJCD.format)(parsedUrl);
};
const $dc34297d07844a72$export$8189558ac52562eb = (params, url)=>{
    const parsedUrl = (0, $jiJCD.parse)(url, true);
    delete parsedUrl.search;
    params.forEach((paramName)=>delete parsedUrl.query[paramName]);
    return (0, $jiJCD.format)(parsedUrl);
};
const $dc34297d07844a72$export$8c0251135969de83 = (spaceKey)=>$dc34297d07844a72$var$getSpaceLink(spaceKey, 'pages');
const $dc34297d07844a72$export$85bee227b225f54c = (spaceKey, year, month, day, contentId, slug)=>$dc34297d07844a72$var$getSpaceLink(spaceKey, `blog/${year}/${month}/${day}/${contentId}${slug ? `/${slug}` : ''}`);
const $dc34297d07844a72$export$72f2ced4cb2807e1 = (spaceKey)=>$dc34297d07844a72$var$getSpaceLink(spaceKey, 'overview');
const $dc34297d07844a72$export$d926fe7959ff33ad = (spaceKey)=>$dc34297d07844a72$var$getSpaceLink(spaceKey, 'questions');
const $dc34297d07844a72$export$e1cedf0f16f74081 = (spaceKey)=>$dc34297d07844a72$var$getSpaceLink(spaceKey, 'calendars');
const $dc34297d07844a72$export$826b1d418b638b4b = (spaceKey)=>`${0, $aTWRz.CONTEXT_PATH}/${0, $aTWRz.SPACE_ROOT}/viewspacesummary.action?key=${encodeURIComponent(spaceKey)}&src=spacetools`;
const $dc34297d07844a72$export$31fff003e6b0fa09 = (spaceKey, contentType, contentId)=>{
    const contentTypeRoute = contentType === 'blogpost' ? 'blog' : 'pages';
    return $dc34297d07844a72$var$getSpaceLink(spaceKey, `${contentTypeRoute}/edit/${contentId}`);
};
const $dc34297d07844a72$export$51becd8adde0429c = (spaceKey, contentType, contentId)=>{
    const contentTypeRoute = contentType === 'blogpost' ? 'blog' : 'pages';
    return $dc34297d07844a72$var$getSpaceLink(spaceKey, `${contentTypeRoute}/edit-v2/${contentId}`);
};
const $dc34297d07844a72$export$ed1bbdbf30c51bda = (contentId, spaceKey)=>{
    if (spaceKey) return $dc34297d07844a72$var$getSpaceLink(spaceKey, `templates/edit/${contentId}`);
    return `${0, $aTWRz.CONTEXT_PATH}/templates/edit/${contentId}`;
};
const $dc34297d07844a72$export$b75aa7172d174854 = (spaceKey, contentId)=>`${$dc34297d07844a72$export$8c0251135969de83(spaceKey)}/${contentId}`;
/**
 * Build a space link. If path starts with contains context path then it will be removed
 *
 * @param spaceKey
 * @param path
 * @returns {string|*}
 */ const $dc34297d07844a72$var$getSpaceLink = (spaceKey, path = '')=>{
    spaceKey = encodeURIComponent(spaceKey);
    let spacePath = (typeof path === 'string' ? path : path.pathname) || '';
    if (spacePath.startsWith((0, $aTWRz.CONTEXT_PATH))) spacePath = spacePath.substring((0, $aTWRz.CONTEXT_PATH).length);
    if (spacePath.startsWith('/')) spacePath = spacePath.substring(1);
    const link = `${(0, $aTWRz.CONTEXT_PATH)}/${(0, $aTWRz.SPACE_ROOT)}/${spaceKey}${spacePath ? `/${spacePath}` : ''}`;
    if (typeof path === 'string') return link;
    return {
        ...path,
        pathname: link
    };
};
const $dc34297d07844a72$export$c6e1a1f2787e89f3 = (spaceKey)=>(0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
const $dc34297d07844a72$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
const $dc34297d07844a72$export$6687a923d0d006ad = ()=>`${0, $aTWRz.CONTEXT_PATH}/admin/configuration`;
const $dc34297d07844a72$export$43c82211f01dfa9 = (location)=>$dc34297d07844a72$export$4abd56cd4494d96(location) || $dc34297d07844a72$export$65ea6c3cfd39f693(location);
const $dc34297d07844a72$var$myWorkMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/${(0, $aTWRz.MY_WORK_ROOT)}`);
const $dc34297d07844a72$export$4abd56cd4494d96 = (location)=>$dc34297d07844a72$var$myWorkMatcher.test(location.pathname);
const $dc34297d07844a72$var$discoverMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/${(0, $aTWRz.DISCOVER_ROOT)}`);
const $dc34297d07844a72$export$65ea6c3cfd39f693 = (location)=>$dc34297d07844a72$var$discoverMatcher.test(location.pathname);
const $dc34297d07844a72$var$viewPageMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/pages/[0-9]+`);
const $dc34297d07844a72$export$a9ddd6d29c62e50e = (location)=>$dc34297d07844a72$var$viewPageMatcher.test(location.pathname);
const $dc34297d07844a72$var$legacyViewPageMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/pages/viewpage\.action`);
const $dc34297d07844a72$export$ed7272ed68dfabd2 = (location)=>$dc34297d07844a72$var$legacyViewPageMatcher.test(location.pathname);
const $dc34297d07844a72$var$blogpostMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/blog/[0-9]+`);
const $dc34297d07844a72$export$44d25c3a122172cb = (location)=>$dc34297d07844a72$var$blogpostMatcher.test(location.pathname);
const $dc34297d07844a72$var$legacySpaceMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/viewspace.action`);
const $dc34297d07844a72$export$6c15954bf6aeeacc = (location)=>$dc34297d07844a72$var$legacySpaceMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceOverviewMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/overview`);
const $dc34297d07844a72$export$d6ed4b21ccee5919 = (location)=>$dc34297d07844a72$var$spaceOverviewMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceShortcutsMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/shortcuts`);
const $dc34297d07844a72$export$addc150fc0e323b8 = (location)=>$dc34297d07844a72$var$spaceShortcutsMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceBlogMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/blog`);
const $dc34297d07844a72$export$c84b760c145ebd67 = (location)=>$dc34297d07844a72$var$spaceBlogMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceQuestionMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/questions`);
const $dc34297d07844a72$export$f72f595c5ad62068 = (location)=>$dc34297d07844a72$var$spaceQuestionMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceLegacyCalendarMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/${(0, $aTWRz.DISPLAY_ROOT)}/[^\/]+/calendar`);
const $dc34297d07844a72$export$c5bfac930eea07f5 = (location)=>$dc34297d07844a72$var$spaceLegacyCalendarMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceToolMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/${(0, $aTWRz.SPACE_ROOT)}/viewspacesummary.action`);
const $dc34297d07844a72$export$f9d4d3f2b95c40d6 = (location)=>$dc34297d07844a72$var$spaceToolMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceLegacyQuestionMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/${(0, $aTWRz.DISPLAY_ROOT)}/[^\/]+/customcontent/list/ac%3Acom.atlassian.confluence.plugins.confluence-questions%3Aquestion`);
const $dc34297d07844a72$export$27879a875df890c5 = (location)=>$dc34297d07844a72$var$spaceLegacyQuestionMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceCalendarMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/calendars`);
const $dc34297d07844a72$export$547a8bbd531e6b17 = (location)=>$dc34297d07844a72$var$spaceCalendarMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceAddonMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/addon`);
const $dc34297d07844a72$export$fb83911ae0e73188 = (location)=>$dc34297d07844a72$var$spaceAddonMatcher.test(location.pathname);
const $dc34297d07844a72$var$fabricEditorMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/(pages|blog)/edit-v2/`);
const $dc34297d07844a72$export$2540db8c6c588f9e = (location)=>$dc34297d07844a72$var$fabricEditorMatcher.test(location.pathname);

});
parcelRegister("aTWRz", function(module, exports) {

$parcel$export(module.exports, "CONTEXT_PATH", () => $7efcb36d690ff658$export$8c6bf2df244e6a99);
$parcel$export(module.exports, "SPACE_ROOT", () => $7efcb36d690ff658$export$1c377798a4ee5636);
$parcel$export(module.exports, "DISPLAY_ROOT", () => $7efcb36d690ff658$export$34022960ff006f30);
$parcel$export(module.exports, "DISCOVER_ROOT", () => $7efcb36d690ff658$export$c3c32b74ef7566a2);
$parcel$export(module.exports, "MY_WORK_ROOT", () => $7efcb36d690ff658$export$d9cb79c4fd8ef00a);

var $lwdd5 = parcelRequire("lwdd5");
const $7efcb36d690ff658$var$contextPathFromPathname = (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location && (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location.pathname.split('/')[1];
const $7efcb36d690ff658$export$8c6bf2df244e6a99 = $7efcb36d690ff658$var$contextPathFromPathname ? `/${$7efcb36d690ff658$var$contextPathFromPathname}` : '/wiki';
const $7efcb36d690ff658$export$1c377798a4ee5636 = 'spaces';
const $7efcb36d690ff658$export$34022960ff006f30 = 'display';
const $7efcb36d690ff658$export$f897f771d110c086 = 'display';
const $7efcb36d690ff658$export$c3c32b74ef7566a2 = 'discover';
const $7efcb36d690ff658$export$d9cb79c4fd8ef00a = 'my';
const $7efcb36d690ff658$export$ec55178b655ee174 = 'recent';

});


parcelRegister("7M69y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a91c9f814b51343$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");

var $flE5X = parcelRequire("flE5X");

var $1j4ZI = parcelRequire("1j4ZI");
const $5a91c9f814b51343$export$b0cd0e90c2f435c7 = (0, $cGH1v.Record)({
    error: false,
    type: undefined,
    title: undefined,
    body: undefined,
    bodyKey: undefined,
    close: undefined,
    isNetworkConnected: true
});
function $5a91c9f814b51343$export$2e2bcd8739ae039(state = new $5a91c9f814b51343$export$b0cd0e90c2f435c7(), action) {
    if (action.error && /_FAILURE$/.test(action.type)) {
        if (action.error instanceof TypeError || action.error instanceof (0, $flE5X.NoNetworkError)) {
            if (!state.isNetworkConnected) // local network is disconnected, but fetch attempted
            return new $5a91c9f814b51343$export$b0cd0e90c2f435c7({
                error: true,
                type: 'error',
                title: 'error.connection.lost.title',
                bodyKey: 'error.connection.lost.body',
                close: 'manual',
                isNetworkConnected: false
            });
        } else if (action.error.statusCode === (0, $1j4ZI.INTERNAL_SERVER_ERROR) || action.error.statusCode === (0, $1j4ZI.SERVICE_UNAVAILABLE_ERROR)) return new $5a91c9f814b51343$export$b0cd0e90c2f435c7({
            error: true,
            type: 'error',
            title: 'error.server-error.title',
            bodyKey: 'error.server-error.body',
            close: 'auto'
        });
    }
    switch(action.type){
        case 'CONNECTION_OFFLINE':
            return new $5a91c9f814b51343$export$b0cd0e90c2f435c7({
                error: false,
                isNetworkConnected: false
            });
        case 'CONNECTION_ONLINE':
            if (state.error) // 'connection lost' message displayed, connection recovered
            return new $5a91c9f814b51343$export$b0cd0e90c2f435c7({
                error: true,
                type: 'success',
                title: 'error.connection.recovered.title',
                body: '<button onclick="window.location.reload()" class="aui-button aui-button-link btn-reload-content">i18nPlaceholder</button>',
                bodyKey: 'error.connection.recovered.action',
                close: 'manual',
                isNetworkConnected: true
            });
            return new $5a91c9f814b51343$export$b0cd0e90c2f435c7({
                isNetworkConnected: true
            });
        case 'REMOVE_ERROR':
            return new $5a91c9f814b51343$export$b0cd0e90c2f435c7({
                error: false
            }).set('isNetworkConnected', state.isNetworkConnected);
    }
    return state;
}

});
parcelRegister("1j4ZI", function(module, exports) {

$parcel$export(module.exports, "OK", () => $0f3b708e2957dfc6$export$c6813a8d51f77eaf);
$parcel$export(module.exports, "NOT_FOUND", () => $0f3b708e2957dfc6$export$8bca792d963eb0ef);
$parcel$export(module.exports, "INTERNAL_SERVER_ERROR", () => $0f3b708e2957dfc6$export$e813cd7045fcc98d);
$parcel$export(module.exports, "SERVICE_UNAVAILABLE_ERROR", () => $0f3b708e2957dfc6$export$5ed7505d2b52f8b1);
const $0f3b708e2957dfc6$export$c6813a8d51f77eaf = 200;
const $0f3b708e2957dfc6$export$8bca792d963eb0ef = 404;
const $0f3b708e2957dfc6$export$8c5e74eae7b64cc2 = 412;
const $0f3b708e2957dfc6$export$e813cd7045fcc98d = 500;
const $0f3b708e2957dfc6$export$5ed7505d2b52f8b1 = 503;

});



parcelRegister("fntqT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b31fd5b8991a5273$export$2e2bcd8739ae039);

var $jxPid = parcelRequire("jxPid");

var $2EUf4 = parcelRequire("2EUf4");

var $l2E0f = parcelRequire("l2E0f");

var $lrKHR = parcelRequire("lrKHR");

var $iXr1D = parcelRequire("iXr1D");

var $ezr2b = parcelRequire("ezr2b");
var $b31fd5b8991a5273$export$2e2bcd8739ae039 = (0, $jxPid.combineReducers)({
    dashboard: $l2E0f.dashboard,
    spaceHome: $lrKHR.default,
    viewPage: $iXr1D.default,
    space: $ezr2b.default,
    changeboarding: $2EUf4.default
});

});
parcelRegister("2EUf4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1efaf1b91071e201$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");

var $f6asy = parcelRequire("f6asy");
const $1efaf1b91071e201$var$DEFAULT_SPOTLIGHT_STATE = (0, $cGH1v.fromJS)({
    id: -1,
    ready: false,
    requested: false,
    dismissed: false,
    attributes: {
        heading: '',
        footer: '',
        dialogPlacement: 'right top',
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetRadius: 4
    }
});
const $1efaf1b91071e201$var$ORIGINAL_FLOW_SET = (0, $f6asy.SPOTLIGHTS_FLOWS).map((flow)=>flow.map((id)=>$1efaf1b91071e201$var$DEFAULT_SPOTLIGHT_STATE.merge({
            id: id
        })));
const $1efaf1b91071e201$var$DEFAULT_STATE = (0, $cGH1v.fromJS)({
    index: -1,
    flow: -1,
    loaded: 0,
    spotlights: $1efaf1b91071e201$var$ORIGINAL_FLOW_SET
});
function $1efaf1b91071e201$export$2e2bcd8739ae039(state = $1efaf1b91071e201$var$DEFAULT_STATE, action = {}) {
    const { spotlightId: spotlightId } = action;
    const spotlights = state.get('spotlights');
    const index = state.get('index');
    switch(action.type){
        case 'CHANGEBOARDING_NEXT':
            return state.merge({
                index: index + 1
            });
        case 'CHANGEBOARDING_PREV':
            return state.merge({
                index: index - 1
            });
        case 'CHANGEBOARDING_TARGET_READY':
            for(let flowIndex = 0; flowIndex < spotlights.size; flowIndex++){
                let flowReady = !!spotlights.get(flowIndex).size;
                for(let spotlightIndex = 0; spotlightIndex < spotlights.get(flowIndex).size; spotlightIndex++){
                    if (spotlights.getIn([
                        flowIndex,
                        spotlightIndex,
                        'id'
                    ]) === spotlightId) {
                        state = state.setIn([
                            'spotlights',
                            flowIndex,
                            spotlightIndex,
                            'loaded'
                        ], true);
                        const { spotlightAttributes: spotlightAttributes } = action;
                        const existingAttributes = state.getIn([
                            'spotlights',
                            flowIndex,
                            spotlightIndex,
                            'attributes'
                        ]);
                        const newAttributes = (0, $cGH1v.fromJS)(spotlightAttributes);
                        /*
                    pass in spotlightAttributes from action to the state (if there is any)
                   */ state = state.setIn([
                            'spotlights',
                            flowIndex,
                            spotlightIndex,
                            'attributes'
                        ], existingAttributes.merge(newAttributes));
                    }
                    flowReady = flowReady && state.getIn([
                        'spotlights',
                        flowIndex,
                        spotlightIndex,
                        'loaded'
                    ]);
                }
                if (flowReady) return state.merge({
                    flow: flowIndex,
                    index: 0,
                    loaded: spotlights.get(flowIndex).size
                });
            }
            break;
        case 'CHANGEBOARDING_DISMISS':
            const flow = state.get('flow');
            // The last flow should be empty.
            const last = spotlights.size - 1;
            if (flow === last) return state.setIn([
                'spotlights',
                last
            ], (0, $cGH1v.List)([]));
            else /*
              for multi step flow, clear the spotlights on dismiss to make it disappear
             */ return state.deleteIn([
                'spotlights',
                flow
            ]);
        case 'CHANGEBOARDING_INVOKE':
            for(let flowIndex = 0; flowIndex < spotlights.size; flowIndex++){
                for(let spotlightIndex = 0; spotlightIndex < spotlights.get(flowIndex).size; spotlightIndex++)if (spotlights.getIn([
                    flowIndex,
                    spotlightIndex,
                    'id'
                ]) === spotlightId) {
                    let newState = state.setIn([
                        'spotlights',
                        flowIndex,
                        spotlightIndex,
                        'requested'
                    ], true);
                    const { spotlightAttributes: spotlightAttributes } = action;
                    const existingAttributes = newState.getIn([
                        'spotlights',
                        flowIndex,
                        spotlightIndex,
                        'attributes'
                    ]);
                    const newAttributes = (0, $cGH1v.fromJS)(spotlightAttributes);
                    /*
                    pass in spotlightAttributes from action to the state (if there is any)
                   */ newState = newState.setIn([
                        'spotlights',
                        flowIndex,
                        spotlightIndex,
                        'attributes'
                    ], existingAttributes.merge(newAttributes));
                    return newState;
                }
            }
            return state.setIn([
                'spotlights',
                spotlights.size - 1,
                spotlights.get(spotlights.size - 1).size
            ], $1efaf1b91071e201$var$DEFAULT_SPOTLIGHT_STATE.merge({
                id: spotlightId
            }));
        case 'CHANGEBOARDING_SET_SPOTLIGHT_ATTRIBUTES':
            const { spotlightAttributes: spotlightAttributes } = action;
            for(let flowIndex = 0; flowIndex < spotlights.size; flowIndex++)for(let spotlightIndex = 0; spotlightIndex < spotlights.get(flowIndex).size; spotlightIndex++){
                if (spotlights.getIn([
                    flowIndex,
                    spotlightIndex,
                    'id'
                ]) === spotlightId) return state.setIn([
                    'spotlights',
                    flowIndex,
                    spotlightIndex,
                    'attributes'
                ], spotlightAttributes);
            }
            break;
    }
    return state;
}

});
parcelRegister("f6asy", function(module, exports) {

$parcel$export(module.exports, "EXAMPLE_SPOTLIGHT", () => $afdf879a7c53f520$export$4b2ae5d9ac5f5c38);
$parcel$export(module.exports, "HELP_MENU_SPOTLIGHT", () => $afdf879a7c53f520$export$29775c4096cc1552);
$parcel$export(module.exports, "SPOTLIGHTS_FLOWS", () => $afdf879a7c53f520$export$8c85345117119989);
$parcel$export(module.exports, "SPOTLIGHT_CALLBACKS", () => $afdf879a7c53f520$export$7f5de72135b17c6b);
const $afdf879a7c53f520$export$4b2ae5d9ac5f5c38 = 'example.spotlight';
const $afdf879a7c53f520$export$29775c4096cc1552 = 'editor.help.center.spotlight.on.help.menu';
const $afdf879a7c53f520$export$8c85345117119989 = [
    []
];
const $afdf879a7c53f520$export$7f5de72135b17c6b = {};

});


parcelRegister("l2E0f", function(module, exports) {

$parcel$export(module.exports, "dashboard", () => $f518d0aa4952ed94$export$a5f98448b9315739);

var $cGH1v = parcelRequire("cGH1v");
function $f518d0aa4952ed94$export$a5f98448b9315739(state = (0, $cGH1v.Map)({}), action) {
    switch(action.type){
        case 'GET_EXPERIMENT_FEATURES_SUCCESS':
        case 'DASHBOARD_VIEW_MODEL_SUCCESS':
            return state.merge({
                ...action.response
            });
        default:
            return state;
    }
}

});

parcelRegister("lrKHR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9d0597e01a892ba$export$2e2bcd8739ae039);

var $jxPid = parcelRequire("jxPid");

var $cGH1v = parcelRequire("cGH1v");

var $ir3XE = parcelRequire("ir3XE");
const $f9d0597e01a892ba$var$DEFAULT_SPACE_INFO_STATE = (0, $cGH1v.fromJS)({
    results: [],
    isRequesting: null,
    hasFetched: false
});
function $f9d0597e01a892ba$export$144592bc8f143152(state = $f9d0597e01a892ba$var$DEFAULT_SPACE_INFO_STATE, action) {
    switch(action.type){
        case 'SPACE_INFO_SUCCESS':
            const isFound = action.response.results.length > 0;
            return state.merge({
                isRequesting: false,
                hasFetched: true,
                spaceKey: action.spaceKey,
                isFound: isFound
            });
        case 'SPACE_INFO_REQUEST':
            return state.merge({
                hasFetched: false,
                isRequesting: true,
                spaceKey: action.spaceKey
            });
        case 'SPACE_INFO_FAILURE':
            return state.merge({
                hasFetched: false,
                isRequesting: false,
                spaceKey: action.spaceKey
            });
        default:
            return state;
    }
}
var $f9d0597e01a892ba$export$2e2bcd8739ae039 = (0, $jxPid.combineReducers)({
    currentSpace: $f9d0597e01a892ba$export$144592bc8f143152,
    homePage: $ir3XE.default
});

});
parcelRegister("ir3XE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6bdd22f8ce8e6ba$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");
const $d6bdd22f8ce8e6ba$var$DEFAULT_STATE = (0, $cGH1v.fromJS)({});
function $d6bdd22f8ce8e6ba$export$2e2bcd8739ae039(state = $d6bdd22f8ce8e6ba$var$DEFAULT_STATE, action) {
    switch(action.type){
        case 'SPACE_HOME_CONTENT_SUCCESS':
            return state.mergeIn([
                action.spaceKey
            ], {
                isSpaceFound: action?.response?.result !== undefined
            });
        default:
            return state;
    }
}

});


parcelRegister("iXr1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcd2b35d4e6c1054$export$2e2bcd8739ae039);

var $jxPid = parcelRequire("jxPid");

var $cGH1v = parcelRequire("cGH1v");

var $h0zqw = parcelRequire("h0zqw");

var $b0W8O = parcelRequire("b0W8O");

var $73DWF = parcelRequire("73DWF");

var $hFUwW = parcelRequire("hFUwW");
const $dcd2b35d4e6c1054$var$defaultState = (0, $cGH1v.fromJS)({
    contentId: null,
    hasLoaded: false
});
function $dcd2b35d4e6c1054$export$8a24ff1d7713b626(state = $dcd2b35d4e6c1054$var$defaultState, action) {
    switch(action.type){
        case 0, $h0zqw.EDITOR_PRELOAD_START:
            if (state.get('contentId') === action.contentId) return state;
            return state.merge({
                hasLoaded: false,
                contentId: action.contentId
            });
        case 0, $h0zqw.EDITOR_PRELOAD_FINISH:
            if (state.get('contentId') !== action.contentId) return state;
            return state.merge({
                hasLoaded: true
            });
        default:
            return state;
    }
}
var $dcd2b35d4e6c1054$export$2e2bcd8739ae039 = (0, $jxPid.combineReducers)({
    editorContent: $hFUwW.default,
    labels: $b0W8O.labels,
    labelDialog: $b0W8O.labelDialog,
    editor: $73DWF.editor,
    quickEditPreload: $dcd2b35d4e6c1054$export$8a24ff1d7713b626
});

});
parcelRegister("b0W8O", function(module, exports) {

$parcel$export(module.exports, "labels", () => $804ccb6cde257677$export$a238cb463698c900);
$parcel$export(module.exports, "labelDialog", () => $804ccb6cde257677$export$69dd859854a593f5);

var $8yIJl = parcelRequire("8yIJl");

var $cGH1v = parcelRequire("cGH1v");

var $iPLCY = parcelRequire("iPLCY");

var $bbN9H = parcelRequire("bbN9H");
const $804ccb6cde257677$var$rootState = {
    labels: (0, $cGH1v.fromJS)({
        isShowingDialog: false
    }),
    labelDialog: (0, $cGH1v.fromJS)({
        error: '',
        suggestions: []
    })
};
const $804ccb6cde257677$export$92448cc3bc36f688 = (errorMsgObject)=>{
    let message = '';
    let messageKey = '';
    const args = [];
    if (typeof errorMsgObject === 'object' && errorMsgObject.message) message = errorMsgObject.message;
    // try to get error key and its arguments from error message string
    if (typeof message === 'string' && message.indexOf('messageKey') >= 0) {
        // Regular expression to parse error message key and its arguments.
        // Here is exmaple of error string which is returned from server side
        // Ex: "com.atlassian.confluence.core.service.NotValidException: [ValidationError [messageKey=label.contains.invalid.chars, args=[a:b, 1, 2, 3]]]"
        // `(?:\w|\.)+` : is a non-capturing group - to match with message key value
        // `{1}` - exactly 1 time
        // `\s*` : match any white space character
        const re = /\[messageKey=((?:\w|\.)+){1},\s*args=\[((?:.)+)?\]\]\]/;
        if (re.test(message)) {
            const results = re.exec(message);
            // first element of array which is returned from `re.exec` is ful string of charecter matched.
            // Ex: if message="com.atlassian.confluence.core.service.NotValidException: [ValidationError [messageKey=label.contains.invalid.chars, args=[a:b, 1, 2, 3]]]"
            // results[0] = "[ValidationError [messageKey=label.contains.invalid.chars, args=[a:b, 1, 2, 3]]]"
            // Full detail: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec
            messageKey = results[1];
            // Basing on all error messages patterns, there are maximum of 2 arguments for message.
            const argArray = results[2] ? results[2].split(',') : '';
            if (argArray) {
                args[0] = (0, (/*@__PURE__*/$parcel$interopDefault($8yIJl)))(argArray);
                args[1] = (argArray || []).slice(1).join(', ');
            }
        }
    }
    return new (0, $iPLCY.ErrorLabelRecord)({
        message: message,
        messageKey: messageKey,
        args: args
    });
};
const $804ccb6cde257677$export$a238cb463698c900 = (state = $804ccb6cde257677$var$rootState.labels, action)=>{
    switch(action.type){
        case 0, $bbN9H.SHOW_EDIT_LABEL_DIALOG:
            return state.merge({
                isShowingDialog: true
            });
        case 0, $bbN9H.CLOSE_EDIT_LABEL_DIALOG:
            return state.merge({
                isShowingDialog: false
            });
        default:
            return state;
    }
};
const $804ccb6cde257677$export$69dd859854a593f5 = (state = $804ccb6cde257677$var$rootState.labelDialog, action)=>{
    switch(action.type){
        case `${0, $bbN9H.ADD_LABELS}_REQUEST`:
            return state.merge({
                error: ''
            });
        case `${0, $bbN9H.ADD_LABELS}_FAILURE`:
            return state.merge({
                error: $804ccb6cde257677$export$92448cc3bc36f688(action.message)
            });
        case `${0, $bbN9H.ADD_LABELS}_SUCCESS`:
            return state.merge({
                error: '',
                results: action.response.result.results
            });
        case `${0, $bbN9H.DELETE_LABELS}_FAILURE`:
            return state.merge({
                error: $804ccb6cde257677$export$92448cc3bc36f688(action.message)
            });
        case `${0, $bbN9H.SUGGEST_LABELS}_SUCCESS`:
            return state.set('suggestions', action.response.results);
        case 0, $bbN9H.CLEAR_SUGGESTIONS:
            return state.merge({
                suggestions: []
            });
        case 0, $bbN9H.CLEAR_ERROR_MESSAGES:
            return state.merge({
                error: null
            });
        default:
            return state;
    }
};

});
parcelRegister("bbN9H", function(module, exports) {

$parcel$export(module.exports, "ADD_LABELS", () => $8256da07864d1748$export$39202f2f00fd507c);
$parcel$export(module.exports, "DELETE_LABELS", () => $8256da07864d1748$export$7d307ae1a0d03697);
$parcel$export(module.exports, "SUGGEST_LABELS", () => $8256da07864d1748$export$866f750dcc9450e4);
$parcel$export(module.exports, "SHOW_EDIT_LABEL_DIALOG", () => $8256da07864d1748$export$9f56054b244900a7);
$parcel$export(module.exports, "CLOSE_EDIT_LABEL_DIALOG", () => $8256da07864d1748$export$68a3f93e71fbe3f8);
$parcel$export(module.exports, "CLEAR_SUGGESTIONS", () => $8256da07864d1748$export$59689cff3c76c06b);
$parcel$export(module.exports, "CLEAR_ERROR_MESSAGES", () => $8256da07864d1748$export$e714584b2a07100d);
const $8256da07864d1748$export$39202f2f00fd507c = 'ADD_LABELS';
const $8256da07864d1748$export$7d307ae1a0d03697 = 'DELETE_LABELS';
const $8256da07864d1748$export$866f750dcc9450e4 = 'SUGGEST_LABELS';
const $8256da07864d1748$export$9f56054b244900a7 = 'SHOW_EDIT_LABEL_DIALOG';
const $8256da07864d1748$export$68a3f93e71fbe3f8 = 'CLOSE_EDIT_LABEL_DIALOG';
const $8256da07864d1748$export$59689cff3c76c06b = 'CLEAR_SUGGESTIONS';
const $8256da07864d1748$export$e714584b2a07100d = 'CLEAR_ERROR_MESSAGES';

});


parcelRegister("73DWF", function(module, exports) {

$parcel$export(module.exports, "editor", () => $5237cc873ace9795$export$b5d042d2b680aed6);

var $h0zqw = parcelRequire("h0zqw");
const $5237cc873ace9795$var$defaultState = {
    contentId: null,
    isEditorLoaded: false,
    isContentEditable: false
};
const $5237cc873ace9795$export$b5d042d2b680aed6 = (state = $5237cc873ace9795$var$defaultState, action)=>{
    switch(action.type){
        case 0, $h0zqw.SHOW_EDITOR:
            return {
                ...state,
                contentId: action.contentId
            };
        case 0, $h0zqw.HIDE_EDITOR:
            return {
                ...state,
                contentId: null
            };
        case 0, $h0zqw.EDITOR_LOAD_COMPLETE:
            return {
                ...state,
                isEditorLoaded: true
            };
        case 0, $h0zqw.EDITOR_CONTENT_EDITABLE:
            return {
                ...state,
                isContentEditable: true
            };
        default:
            return state;
    }
};

});

parcelRegister("hFUwW", function(module, exports) {

$parcel$export(module.exports, "default", () => $cde21dc327dc8089$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");

var $h0zqw = parcelRequire("h0zqw");

var $1j4ZI = parcelRequire("1j4ZI");
const $cde21dc327dc8089$var$defaultState = (0, $cGH1v.fromJS)({
    contentId: null,
    hasFetched: null,
    result: null,
    errorData: null,
    statusCode: null,
    silent: null,
    spaceKey: null
});
function $cde21dc327dc8089$export$2e2bcd8739ae039(state = $cde21dc327dc8089$var$defaultState, action) {
    switch(action.type){
        case `${0, $h0zqw.EDITOR_CONTENT}_REQUEST`:
            return state.merge({
                contentId: action.contentId,
                silent: !!action.silent,
                hasFetched: false,
                result: null,
                errorData: null,
                statusCode: null,
                spaceKey: null
            });
        case `${0, $h0zqw.EDITOR_CONTENT}_SUCCESS`:
            if (state.get('contentId') !== action.contentId) return state;
            return state.merge({
                hasFetched: true,
                result: action.response && action.response._originalResponse,
                statusCode: (0, $1j4ZI.OK),
                errorData: null,
                spaceKey: action.response.spaceKey
            });
        case `${0, $h0zqw.EDITOR_CONTENT}_FAILURE`:
            if (state.get('contentId') !== action.options.contentId) return state;
            return state.merge({
                hasFetched: true,
                statusCode: action.error && action.error.statusCode,
                errorData: action.message
            });
        case 0, $h0zqw.RESET_EDITOR_STATE:
            return $cde21dc327dc8089$var$defaultState;
        default:
            return state;
    }
}

});


parcelRegister("ezr2b", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9b94e02b9cec0e3$export$2e2bcd8739ae039);

var $jxPid = parcelRequire("jxPid");

var $cGH1v = parcelRequire("cGH1v");

var $hmUBG = parcelRequire("hmUBG");

var $jBnsv = parcelRequire("jBnsv");
const $a9b94e02b9cec0e3$var$ALWAYS_VISIBLE_WEBITEMS = [
    (0, $jBnsv.SPACE_TAB_PAGES_KEY),
    (0, $jBnsv.SPACE_SETTINGS_KEY)
];
// items that shouldn't appear in ADG3 sidebar
const $a9b94e02b9cec0e3$var$blacklist = [
    'spacebar-profile'
];
function $a9b94e02b9cec0e3$export$463d32b91de8b4d(state = (0, $cGH1v.Map)({}), action) {
    switch(action.type){
        case 'GET_SPACE_LINKS_SUCCESS':
            const spaceKey = action.spaceKey;
            Object.keys(action.response).forEach((group)=>{
                const allowedItems = action.response[group].filter((link)=>{
                    return !(link.webItemKey && $a9b94e02b9cec0e3$var$blacklist.indexOf(link.webItemKey) !== -1);
                });
                const spaceLinks = allowedItems.map((link)=>{
                    const item = {
                        ...link
                    };
                    if (group === 'quick') item.canHide = true;
                    // force "pages" and "space settings" always visible
                    if ($a9b94e02b9cec0e3$var$ALWAYS_VISIBLE_WEBITEMS.indexOf(item.webItemCompleteKey) !== -1) {
                        item.hidden = false;
                        item.canHide = false;
                    }
                    return (0, $hmUBG.default)(item);
                });
                state = state.setIn([
                    spaceKey,
                    group
                ], (0, $cGH1v.List)(spaceLinks));
            });
            return state;
        case 'MOVE_SPACE_LINK_REQUEST':
            const { group: group } = action;
            return state.updateIn([
                action.spaceKey,
                group
            ], (items)=>{
                const indexSource = items.findIndex((item)=>item.id === action.id);
                if (indexSource !== -1) {
                    const item = items.get(indexSource);
                    const updatedItems = items.delete(indexSource);
                    let indexDestination = -1;
                    if (action.position && action.position === 'First') // Move to the first
                    indexDestination = 0;
                    else if (action.after) // Move the item to a item with certain id
                    indexDestination = updatedItems.findIndex((item)=>item.id === action.after) + 1;
                    if (indexDestination !== -1) return updatedItems.insert(indexDestination, item);
                }
                return items;
            });
        case 'TOGGLE_SPACE_LINK_REQUEST':
            const path = [
                action.spaceKey,
                action.group
            ];
            const index = state.getIn(path).findIndex((item)=>item.id === action.id);
            return state.updateIn(path.concat(index), (item)=>item.set('hidden', !item.hidden));
        case 'REMOVE_SPACE_SHORTCUT_LINK_REQUEST':
            const { linkId: linkId } = action;
            return state.updateIn([
                action.spaceKey,
                'quick'
            ], (items)=>{
                const indexSource = items.findIndex((item)=>item.id === linkId);
                return items.delete(indexSource);
            });
        default:
            return state;
    }
}
function $a9b94e02b9cec0e3$export$8c9a508833948c64(state = (0, $cGH1v.OrderedSet)(), action) {
    switch(action.type){
        case 'GET_SPACES_SUCCESS':
            if (action.response.result.allSpaces && action.response.result.allSpaces.results.length) return (0, $cGH1v.OrderedSet)(action.response.result.allSpaces.results);
            return state;
    }
    return state;
}
var $a9b94e02b9cec0e3$export$2e2bcd8739ae039 = (0, $jxPid.combineReducers)({
    links: $a9b94e02b9cec0e3$export$463d32b91de8b4d,
    allSpaces: $a9b94e02b9cec0e3$export$8c9a508833948c64
});

});
parcelRegister("hmUBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca5066a8f1d56a2f$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");
var $ca5066a8f1d56a2f$export$2e2bcd8739ae039 = (0, $cGH1v.Record)({
    id: null,
    webItemKey: null,
    webItemCompleteKey: null,
    title: null,
    url: null,
    position: null,
    icon: null,
    iconClass: null,
    styleClass: null,
    hidden: null,
    canHide: null,
    tooltip: null,
    urlWithoutContextPath: null
});

});

parcelRegister("jBnsv", function(module, exports) {

$parcel$export(module.exports, "CONNECT_APP_PREFIX_KEY", () => $4bdd9ca75c1e9e19$export$d1ca15e02cb0246b);
$parcel$export(module.exports, "PAGE_FAVOURITE_KEY", () => $4bdd9ca75c1e9e19$export$40c6e950ae94b0da);
$parcel$export(module.exports, "EDIT_BUTTON_PAGE_KEY", () => $4bdd9ca75c1e9e19$export$eb1c4b0864d522cc);
$parcel$export(module.exports, "EDIT_BUTTON_BLOGPOST_KEY", () => $4bdd9ca75c1e9e19$export$3b945464f5d89ed3);
$parcel$export(module.exports, "WATCH_BUTTON_KEY", () => $4bdd9ca75c1e9e19$export$4bf4f0ec2f25e202);
$parcel$export(module.exports, "INVITE_TO_EDIT_KEY", () => $4bdd9ca75c1e9e19$export$9ca243087e50564a);
$parcel$export(module.exports, "PAGE_UNFAVOURITE_KEY", () => $4bdd9ca75c1e9e19$export$b8499a432f3f0b75);
$parcel$export(module.exports, "CREATE_NEW_BLOGPOST_KEY", () => $4bdd9ca75c1e9e19$export$ea940583a16e119b);
$parcel$export(module.exports, "SPACE_TAB_PAGES_KEY", () => $4bdd9ca75c1e9e19$export$ceee661d99c6cdff);
$parcel$export(module.exports, "SPACE_SETTINGS_KEY", () => $4bdd9ca75c1e9e19$export$f618e448a4ddfafa);
const $4bdd9ca75c1e9e19$export$d1ca15e02cb0246b = 'com.atlassian.plugins.atlassian-connect-plugin';
const $4bdd9ca75c1e9e19$export$40c6e950ae94b0da = 'confluence.sections.page.temp:pagefavourite';
const $4bdd9ca75c1e9e19$export$eb1c4b0864d522cc = 'confluence.sections.page.temp:edit-page';
const $4bdd9ca75c1e9e19$export$3b945464f5d89ed3 = 'confluence.sections.page.temp:edit-blogpost';
const $4bdd9ca75c1e9e19$export$4bf4f0ec2f25e202 = 'com.atlassian.confluence.plugins.watch-button:watch';
const $4bdd9ca75c1e9e19$export$5ed0fed1719982a1 = 'com.atlassian.confluence.plugins.share-page:share';
const $4bdd9ca75c1e9e19$export$9ca243087e50564a = 'com.atlassian.confluence.plugins.confluence-invite-to-edit:share';
const $4bdd9ca75c1e9e19$export$b8499a432f3f0b75 = 'confluence.sections.page.temp:pageunfavourite';
const $4bdd9ca75c1e9e19$export$ea940583a16e119b = 'com.atlassian.confluence.plugins.confluence-create-content-plugin:create-blog-post';
const $4bdd9ca75c1e9e19$export$ceee661d99c6cdff = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-pages';
const $4bdd9ca75c1e9e19$export$f618e448a4ddfafa = 'com.atlassian.confluence.plugins.confluence-frontend-support:space-tools-link';

});



parcelRegister("6hgAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4921329f71e36dc5$export$2e2bcd8739ae039);
function $4921329f71e36dc5$export$2e2bcd8739ae039(state = {}, action) {
    switch(action.type){
        case 'SET_ACTIVE_MODAL':
            return {
                modalComponent: action.component,
                modalProps: action.props
            };
        case 'CLOSE_ACTIVE_MODAL':
            return {};
    }
    return state;
}

});

parcelRegister("d5EYy", function(module, exports) {

$parcel$export(module.exports, "default", () => $987b86ef1844383b$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");

var $19fl2 = parcelRequire("19fl2");
// TODO: temporary to support the transition from the 'confluence-dashboard' plugin name
const $987b86ef1844383b$var$updateFeature = (feature)=>{
    if (feature.pluginKey.indexOf('confluence-dashboard') !== -1) feature.pluginKey = feature.pluginKey.replace('confluence-dashboard', 'confluence-frontend-support');
    return feature;
};
const $987b86ef1844383b$export$49d5fc8cba920a0 = (0, $cGH1v.fromJS)({
    hasLoaded: false,
    list: (0, $cGH1v.List)([])
});
function $987b86ef1844383b$export$2e2bcd8739ae039(state = $987b86ef1844383b$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 'DISCOVERED_FEATURES_SUCCESS':
            const newList = (0, $cGH1v.List)(action.response && action.response.map($987b86ef1844383b$var$updateFeature));
            return state.withMutations((state)=>{
                state.set('hasLoaded', true);
                // merge 2 list
                const currentList = state.get('list');
                const updatedList = currentList.concat(newList.filter((item)=>!(0, $19fl2.hasFeatureBeenDiscovered)(currentList, item)));
                state.set('list', updatedList);
                return state;
            });
        case 'FEATURE_DISCOVERED_MARK_REQUEST':
        case 'FEATURE_DISCOVERED_MARK_SUCCESS':
            // there is no success action dispatch for mark feature discover
            // because the POST request does not return any response
            // this change is necessary to update the state after the action happens
            // and mark that the feature has been discovered
            const alreadyDiscovered = (0, $19fl2.hasFeatureBeenDiscovered)(state.get('list'), action);
            if (alreadyDiscovered) return state;
            else {
                const newEntry = {
                    pluginKey: action.pluginKey,
                    featureKey: action.featureKey
                };
                return state.set('list', state.get('list').push(newEntry));
            }
        default:
            return state;
    }
}

});
parcelRegister("19fl2", function(module, exports) {

$parcel$export(module.exports, "hasFeatureBeenDiscovered", () => $0d628794a509b7d9$export$58d7cf3acebc0ad9);
const $0d628794a509b7d9$export$58d7cf3acebc0ad9 = (discoveredFeatures, { pluginKey: pluginKey = '', featureKey: featureKey = '' } = {})=>(typeof discoveredFeatures?.some === 'function' ? discoveredFeatures : []).some((discoveredFeature)=>discoveredFeature?.pluginKey === pluginKey && discoveredFeature?.featureKey === featureKey);

});



parcelRegister("kaU4c", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb003b822bc822f9$export$2e2bcd8739ae039);

var $cGH1v = parcelRequire("cGH1v");

var $iNu3E = parcelRequire("iNu3E");

var $8EsbU = parcelRequire("8EsbU");

var $kgOkC = parcelRequire("kgOkC");
const $eb003b822bc822f9$export$3934bd4722d03882 = new Set([
    'i18n',
    'watches',
    'pagination',
    'session',
    'views',
    'hover',
    'meta',
    'isServerRenderedPage'
]);
// This blacklist is so we can gradually remove the usage of meta tags from the server-side.
const $eb003b822bc822f9$var$META_BLACKLIST = new Set([
    'discovered-plugin-features'
]);
function $eb003b822bc822f9$export$2e2bcd8739ae039(windowGlobal = $parcel$global, extraState = {}) {
    const initialState = Object.assign(windowGlobal.__INITIAL_STATE__ || {}, extraState);
    initialState.meta = (0, (/*@__PURE__*/$parcel$interopDefault($iNu3E)))(initialState.meta || {}, (0, $kgOkC.exclude)((0, $8EsbU.getAllAsMap)(), $eb003b822bc822f9$var$META_BLACKLIST));
    return (0, $kgOkC.map)(initialState, (value, key)=>{
        if (!$eb003b822bc822f9$export$3934bd4722d03882.has(key)) console.error(`Unsupported key \"${key}\" was found in the __INITIAL_STATE__.\nCheck if it works and add it to the whitelist of the initialStateFactory.`);
        return (0, $cGH1v.fromJS)(value);
    });
}

});
parcelRegister("kgOkC", function(module, exports) {

$parcel$export(module.exports, "exclude", () => $ec1c581290e7239a$export$44c361b8ec72ef7f);
$parcel$export(module.exports, "map", () => $ec1c581290e7239a$export$871de8747c9eaa88);
/**
 * Takes an object and returns a new object with the specified keys removed.
 * @param {Object} obj - The object that will have keys removed.
 * @param {Set} keys - The keys to remove from the target object.
 * @returns {Object}
 */ function $ec1c581290e7239a$export$44c361b8ec72ef7f(obj, keys) {
    return Object.keys(obj).reduce((newObj, key)=>{
        if (!keys.has(key)) newObj[key] = obj[key];
        return newObj;
    }, {});
}
function $ec1c581290e7239a$export$871de8747c9eaa88(obj, fn) {
    const newObj = {};
    Object.keys(obj || {}).forEach((key)=>{
        newObj[key] = fn(obj[key], key, obj);
    });
    return newObj;
}

});



parcelRegister("9F7Qb", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $708e066696694052$export$ec068583843480e7);
parcelRequire("fY9o0");
var $7MCqB = parcelRequire("7MCqB");
function $708e066696694052$export$ec068583843480e7(store) {
    store.subscribe(()=>{
        (0, $7MCqB.debouncedConfigureRestApiClient)(store);
    });
    (0, $7MCqB.debouncedConfigureRestApiClient)(store);
}

});
parcelRegister("fY9o0", function(module, exports) {

$parcel$export(module.exports, "configureRestApiClient", () => (parcelRequire("7MCqB")).debouncedConfigureRestApiClient);
$parcel$export(module.exports, "updateContentProperty", () => (parcelRequire("gCs5d")).updateContentProperty);
$parcel$export(module.exports, "editPageMetadata", () => (parcelRequire("chDZy")).editPageMetadata);
$parcel$export(module.exports, "editorPage", () => (parcelRequire("chDZy")).editorPage);
$parcel$export(module.exports, "publishEditorPage", () => (parcelRequire("chDZy")).publishEditorPage);
$parcel$export(module.exports, "syncEditorDraft", () => (parcelRequire("chDZy")).syncEditorDraft);
$parcel$export(module.exports, "publishEditorPageFromTemplate", () => (parcelRequire("chDZy")).publishEditorPageFromTemplate);
$parcel$export(module.exports, "createPage", () => (parcelRequire("chDZy")).createPage);
$parcel$export(module.exports, "draftMetadata", () => (parcelRequire("chDZy")).draftMetadata);
$parcel$export(module.exports, "cancelScheduledPublish", () => (parcelRequire("chDZy")).cancelScheduledPublish);
$parcel$export(module.exports, "getPluginCodeLanguages", () => (parcelRequire("3xce3")).getPluginCodeLanguages);
$parcel$export(module.exports, "getWikiConfluenceToXhtml", () => (parcelRequire("3xce3")).getWikiConfluenceToXhtml);
$parcel$export(module.exports, "getWikiMarkdownToXhtml", () => (parcelRequire("3xce3")).getWikiMarkdownToXhtml);
$parcel$export(module.exports, "space", () => (parcelRequire("1OVaR")).space);
$parcel$export(module.exports, "markDiscovered", () => (parcelRequire("2cpJ0")).markDiscovered);

var $EGdrQ = parcelRequire("EGdrQ");

var $7MCqB = parcelRequire("7MCqB");

var $chDZy = parcelRequire("chDZy");
var $3xce3 = parcelRequire("3xce3");
var $2cpJ0 = parcelRequire("2cpJ0");
var $1OVaR = parcelRequire("1OVaR");
var $gCs5d = parcelRequire("gCs5d");

});
parcelRegister("EGdrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $07a47bbdb815b6f8$export$2e2bcd8739ae039);

var $lwdd5 = parcelRequire("lwdd5");

var $aTWRz = parcelRequire("aTWRz");
function $07a47bbdb815b6f8$export$2e2bcd8739ae039() {
    const API_HOST = (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location ? `${(0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location.protocol}//${(0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location.host}` : ``;
    return {
        endpoint: API_HOST,
        contextPath: (0, $aTWRz.CONTEXT_PATH),
        extraHeaders: {
            // required for auth/referrer in rest calls
            'X-Requested-With': 'XMLHttpRequest'
        }
    };
}

});

parcelRegister("7MCqB", function(module, exports) {

$parcel$export(module.exports, "debouncedConfigureRestApiClient", () => $5aaad316cd20dd80$export$e405c2b0f74207f);

var $2jjxD = parcelRequire("2jjxD");

var $bsCwp = parcelRequire("bsCwp");

var $cGH1v = parcelRequire("cGH1v");

var $fb3VX = parcelRequire("fb3VX");
const $5aaad316cd20dd80$export$e60872e78c337210 = (state)=>state.views.dashboard.get('tenantId', null);
const $5aaad316cd20dd80$var$getAtlToken = (state)=>state.meta.get('atl-token', null);
const $5aaad316cd20dd80$var$getFields = (0, $bsCwp.createSelector)($5aaad316cd20dd80$export$e60872e78c337210, $5aaad316cd20dd80$var$getAtlToken, (tenantId, atlToken)=>(0, $cGH1v.Map)({
        tenantId: tenantId,
        atlToken: atlToken
    }));
function $5aaad316cd20dd80$var$hasChanged(previousState, state) {
    return previousState !== state;
}
let $5aaad316cd20dd80$var$cache = (0, $cGH1v.Map)({});
function $5aaad316cd20dd80$var$configureRestApiClient(store) {
    const newState = $5aaad316cd20dd80$var$getFields(store.getState());
    if ($5aaad316cd20dd80$var$hasChanged($5aaad316cd20dd80$var$cache, newState)) {
        $5aaad316cd20dd80$var$cache = newState;
        (0, $fb3VX.default)(newState.toJS());
    }
}
const $5aaad316cd20dd80$export$e405c2b0f74207f = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))($5aaad316cd20dd80$var$configureRestApiClient, 500);

});
parcelRegister("fb3VX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0caef45af5fc05b$export$2e2bcd8739ae039);
/***
 * BEWARE: THIS INSTANCE OF THE REST API INCLUDES ALL ENDPOINTS (IT ENDS UP ADDING ABOUT 300kb WHEREVER IT IS USED).
 * YOU MAY WANT TO CONSIDER IMPORTING THE SPECIFIC ENDPOINT AND CONFIGURING IT WITH THE DEFAULT CONFIGURATION:
 *
 *   import { webResources } from '@confluence-classic/confluence-rest-api';
 *   import configuration from './rest-api-configuration';
 *   webResources.configure(configuration());
 *
 */ 
var $glJkW = parcelRequire("glJkW");

var $EGdrQ = parcelRequire("EGdrQ");
(0, $glJkW.configure)((0, $EGdrQ.default)());
function $b0caef45af5fc05b$export$2e2bcd8739ae039(newConfiguration = {}) {
    (0, $glJkW.configure)({
        ...(0, $EGdrQ.default)(),
        ...newConfiguration
    });
}

});
parcelRegister("glJkW", function(module, exports) {

$parcel$export(module.exports, "configure", () => $be71c66c5fa57adb$export$8d21e34596265fa2);
/**
 * Official Atlassian javascript library for Confluence REST API calls.
 * @module confluence-rest-api
 */ 
var $4ZFIE = parcelRequire("4ZFIE");

var $1OVaR = parcelRequire("1OVaR");

var $chDZy = parcelRequire("chDZy");

var $2cpJ0 = parcelRequire("2cpJ0");


var $3xce3 = parcelRequire("3xce3");

var $gCs5d = parcelRequire("gCs5d");



const $be71c66c5fa57adb$export$e7aa7bc5c1b3cfb3 = (0, $4ZFIE.default).fetch;
function $be71c66c5fa57adb$export$8d21e34596265fa2(configuration) {
    (0, $4ZFIE.default).configure(configuration);
}

});
parcelRegister("4ZFIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a2d38778062baf1$export$2e2bcd8739ae039);
/* eslint-disable check-credentials-option/has-credentials-option */ 
var $jiJCD = parcelRequire("jiJCD");

var $hBkCm = parcelRequire("hBkCm");
var $f7B1p = parcelRequire("f7B1p");
var $50bhB = parcelRequire("50bhB");
var $flE5X = parcelRequire("flE5X");

var $3A6oh = parcelRequire("3A6oh");
/**
 * Substitute tokens with values
 *
 * @param {String} url - the url with ':token' or ':token?' tokens to be replaced.
 * @param {Object} parameters - the substitutions.
 */ const $3a2d38778062baf1$var$replaceTokens = (url, parameters)=>{
    return url.replace(/:([a-zA-Z]+)\?*/g, function(match, token) {
        let param = parameters[token];
        // blueprint urls need a ? following the contentId
        if (match === ':contentId?') param = param + '?';
        // Do not encode token like :query => key=value or :contentId? => 123188823?
        return typeof param === 'string' && param.indexOf('=') === -1 && match !== ':contentId?' ? encodeURIComponent(decodeURIComponent(param)) : param;
    });
};
function $3a2d38778062baf1$var$waitFor({ condition: condition, maxTries: maxTries = 10, interval: interval = 250, callback: callback }) {
    if (typeof condition !== 'function') throw new Error('waitFor requires a condition wrapped in a function as first argument');
    if (typeof callback !== 'function') throw new Error('waitFor requires a function as callback');
    // if condition passes, return immediately
    if (condition()) return callback();
    let currentTry = 0;
    const waitForTimeout = ()=>setTimeout(()=>{
            if (condition()) return callback();
            // count number of tries
            currentTry = currentTry + 1;
            // escape if it's over the maximum
            if (maxTries && maxTries > 0 && currentTry >= maxTries) return;
            // check again
            waitForTimeout();
        }, interval);
    // start waiting
    waitForTimeout();
}
function $3a2d38778062baf1$var$requestErrorHandler(callback, httpCodeHandlers = {}, method = '', urlPath = '', routeName = '') {
    return (error)=>{
        if (error instanceof (0, $hBkCm.BadStatusError)) {
            // XXX Translate BadStatusError to ConfluenceRestApiError because that's what
            // customHandler and callback (may) rely on (since they predate the
            // introduction of BadStatusError).
            const { response: response } = error;
            return response.text().then((text)=>$3a2d38778062baf1$var$requestErrorHandler(callback, httpCodeHandlers, method, urlPath, routeName)(new (0, $50bhB.ConfluenceRestApiError)({
                    message: text,
                    'status-code': response.status,
                    method: method,
                    url: urlPath
                }, {
                    route: routeName,
                    traceId: error.traceId
                })));
        }
        if (error instanceof (0, $50bhB.ConfluenceRestApiError)) {
            const customHandler = httpCodeHandlers[error.statusCode];
            if (customHandler) customHandler(error);
            return callback(error);
        }
        // XXX TypeError was given to callback before the introduction of
        // NoNetworkError. Based on searching for TypeError in the source code base,
        // it appears that the TypeError was used as a signal of an offline network.
        // That's understandable given that fetch throws a TypeError when the
        // network is offline. However, requestErrorHandler runs in a catch of a
        // chain of Promises each of which may throw TypeError for reasons other
        // than the network being offline. So preserve the legacy behavior for
        // compatibility reasons.
        //
        // However, we now wrap fetch and throw NoNetworkError so take that new type
        // into account as well.
        if (error instanceof TypeError || error instanceof (0, $flE5X.NoNetworkError)) return callback(error);
        throw error;
    };
}
const $3a2d38778062baf1$export$8ae1430f8babe4d9 = $3a2d38778062baf1$var$requestErrorHandler;
function $3a2d38778062baf1$var$invokeResource(url, { body: body, callback: callback, headers: headers, method: method, extraConfig: extraConfig = {}, responseTransformer: responseTransformer, httpCodeHandlers: httpCodeHandlers, routeName: routeName }, config) {
    let bodyParam = body;
    const contentType = headers['Content-Type'];
    // remove Content-Type if 'null', which is required for multipart/form-data
    // so that the browser populates the mime boundary string correctly
    if (!contentType) delete headers['Content-Type'];
    if (contentType && contentType.indexOf('application/x-www-form-urlencoded') !== -1) bodyParam = new URLSearchParams(body).toString();
    else if (contentType === 'application/json') bodyParam = JSON.stringify(body);
    const urlPath = (0, $jiJCD.parse)(url).path;
    const passThrough = ()=>(0, $f7B1p.cfetch)(url, {
            headers: headers,
            method: method,
            body: bodyParam
        });
    return (0, $3A6oh.preloadedRestLink)(urlPath, {
        method: method,
        headers: headers,
        body: body
    }, passThrough).then(function(response) {
        if (extraConfig.ignoreResponseJson) return null;
        if (response.status !== 204) return response.json();
        else return response;
    }).then(function(responseJson) {
        if (responseJson && responseJson['status-code']) throw new (0, $50bhB.ConfluenceRestApiError)(responseJson, {
            route: routeName
        });
        return callback(null, responseTransformer ? responseTransformer(responseJson, url, config.contextPath, body) : responseJson);
    }).catch($3a2d38778062baf1$var$requestErrorHandler(callback, httpCodeHandlers, method, urlPath, routeName));
}
function $3a2d38778062baf1$export$34cd9bd409b5730c() {
    let config = {
        endpoint: null,
        contextPath: null,
        extraHeaders: {},
        atlToken: null,
        tenantId: null
    };
    return {
        configure (configuration = {}) {
            config = {
                ...config,
                ...configuration
            };
        },
        getConfig () {
            return config;
        },
        getAtlToken () {
            if (!config.atlToken) throw new Error('Tried to use atlToken before it was available');
            return config.atlToken;
        },
        /**
		 * Wait for tenant id and resolves the promise
		 * @returns {Promise}
		 */ withTenantId () {
            return new Promise((resolve, reject)=>{
                $3a2d38778062baf1$var$waitFor({
                    condition: ()=>config.tenantId !== null,
                    callback: ()=>resolve(config.tenantId)
                });
            });
        },
        /**
		 * Returns the full PATH for a given path.
		 * @param {string} path
		 * @param {Object} [params]
		 */ getFullPath (path, params) {
            const absoluteUrl = config.endpoint ? `${config.endpoint}${config.contextPath}${path}` : `${config.contextPath}${path}`;
            return params ? $3a2d38778062baf1$var$replaceTokens(absoluteUrl, params) : absoluteUrl;
        },
        getExternalServicePath (path, params) {
            if (typeof path !== 'function') throw new Error('getExternalServicePath expects path to be a function so it can be lazy evaluated');
            const lazyPath = path();
            return $3a2d38778062baf1$var$replaceTokens(lazyPath, params);
        },
        get (url, { callback: callback, headers: headers, responseTransformer: responseTransformer, httpCodeHandlers: httpCodeHandlers, extraConfig: extraConfig = {}, routeName: routeName }) {
            const actualHeaders = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...config.extraHeaders,
                ...headers
            };
            return $3a2d38778062baf1$var$invokeResource(url, {
                callback: callback,
                headers: actualHeaders,
                method: 'GET',
                responseTransformer: responseTransformer,
                httpCodeHandlers: httpCodeHandlers,
                extraConfig: extraConfig,
                routeName: routeName
            }, config);
        },
        post (url, { body: body, callback: callback, headers: headers, extraConfig: extraConfig, responseTransformer: responseTransformer, httpCodeHandlers: httpCodeHandlers, routeName: routeName }) {
            const actualHeaders = {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...config.extraHeaders,
                ...headers
            };
            return $3a2d38778062baf1$var$invokeResource(url, {
                body: body,
                callback: callback,
                headers: actualHeaders,
                method: 'POST',
                extraConfig: extraConfig,
                responseTransformer: responseTransformer,
                httpCodeHandlers: httpCodeHandlers,
                routeName: routeName
            }, config);
        },
        put (url, { body: body, callback: callback, headers: headers, extraConfig: extraConfig, responseTransformer: responseTransformer, httpCodeHandlers: httpCodeHandlers, routeName: routeName }) {
            const actualHeaders = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...config.extraHeaders,
                ...headers
            };
            return $3a2d38778062baf1$var$invokeResource(url, {
                body: body,
                callback: callback,
                headers: actualHeaders,
                method: 'PUT',
                extraConfig: extraConfig,
                responseTransformer: responseTransformer,
                httpCodeHandlers: httpCodeHandlers,
                routeName: routeName
            }, config);
        },
        delete (url, { callback: callback, headers: headers, extraConfig: extraConfig, responseTransformer: responseTransformer, httpCodeHandlers: httpCodeHandlers, routeName: routeName }) {
            const actualHeaders = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...config.extraHeaders,
                ...headers
            };
            return $3a2d38778062baf1$var$invokeResource(url, {
                callback: callback,
                headers: actualHeaders,
                method: 'DELETE',
                extraConfig: extraConfig,
                responseTransformer: responseTransformer,
                httpCodeHandlers: httpCodeHandlers,
                routeName: routeName
            }, config);
        },
        postLegacyResource (url, { body: body, callback: callback, headers: headers, method: method, responseTransformer: responseTransformer, httpCodeHandlers: httpCodeHandlers, routeName: routeName }) {
            return (0, $f7B1p.cfetch)(url, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    ...config.extraHeaders,
                    ...headers
                },
                method: 'POST',
                body: typeof body === 'string' ? body : new URLSearchParams(body).toString()
            }).then(/* onFulfilled */ (response)=>{
                const contentType = response.headers.get('content-type');
                return !contentType || contentType.indexOf('text/html') !== -1 || contentType.indexOf('text/plain') !== -1 ? response.text() : response.json();
            }, /* onRejected */ (reason)=>{
                if (reason instanceof (0, $hBkCm.BadStatusError)) return new Error('Request failed with ' + reason.response.status);
                throw reason;
            }).then((result)=>{
                if (result instanceof Error) return callback(result);
                else return callback(null, responseTransformer ? responseTransformer(result, url, config.contextPath, body) : result);
            }).catch($3a2d38778062baf1$var$requestErrorHandler(callback, httpCodeHandlers, method, url, routeName));
        },
        /**
		 * Clean wrapper around Native fetch - it returns the fetch promise so it
		 * can be used when we need to delegate workflow rules to the action creator
		 * instead of relying on the middleware.
		 *
		 * @param url
		 * @param options
		 * @returns Promise
		 */ fetch (url, options) {
            // eslint-disable-next-line no-restricted-syntax
            return fetch(url, options);
        }
    };
}
/** Global request helper with shared configuration to avoid breaking API changes.
 *
 * @deprecated
 * @type Object
 */ const $3a2d38778062baf1$var$globalRequestHelper = $3a2d38778062baf1$export$34cd9bd409b5730c();
$3a2d38778062baf1$var$globalRequestHelper.configure();
var $3a2d38778062baf1$export$2e2bcd8739ae039 = $3a2d38778062baf1$var$globalRequestHelper;

});
parcelRegister("3A6oh", function(module, exports) {

$parcel$export(module.exports, "preloadedRestLink", () => $be70be676a6626b5$export$7c8f96a75ff5904);

var $8HmnL = parcelRequire("8HmnL");
const $be70be676a6626b5$export$7c8f96a75ff5904 = async (url, { method: method, headers: headers, claimKey: claimKey }, passThrough)=>{
    if (!method || method.toUpperCase() !== 'GET') return passThrough();
    return (0, $8HmnL.getPreloadResult)().claim(claimKey ? {
        name: claimKey
    } : {
        name: url,
        variables: {
            method: method,
            ...headers
        }
    }, (result)=>{
        return result;
    }).then((data)=>{
        if (!data) return passThrough();
        return data;
    });
};

});
parcelRegister("8HmnL", function(module, exports) {

$parcel$export(module.exports, "getPreloadResult", () => $7460d2a0255ec893$export$2e8e3f1fde57bbfe);

var $6X8o4 = parcelRequire("6X8o4");

var $45prt = parcelRequire("45prt");
class $7460d2a0255ec893$export$8f7a8a727d75d90e {
    serialize(value) {
        if (Array.isArray(value)) return `[${value.map(this.serialize, this).join(',')}]`;
        else if (typeof value === 'object') {
            const serializedObject = Object.entries(value ?? {}).filter((entry)=>entry[1] !== undefined).sort((a, b)=>a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0).map(([key, child])=>`${key}:${this.serialize(child)}`).join(',');
            return `{${serializedObject}}`;
        } else return String(value);
    }
    toHashKey({ name: name, variables: variables }) {
        const serializedVariables = this.serialize(variables ?? {});
        return `${name}:${serializedVariables}`;
    }
    load(key, loader, { refetchIfNotClaimed: refetchIfNotClaimed = true } = {}, saveToStore = true) {
        const hash = this.toHashKey(key);
        const disablePreloadedQueryLinkSaveToStore = (0, $45prt.getSSRFeatureFlag)('confluence.ssr.disable-preloadedquerylink-save-to-store') || false;
        // Ignore the request if there is a pending request with the exact same query name and variables.
        let query;
        if (!this.store[hash] || refetchIfNotClaimed && (0, $6X8o4.isResolved)(this.store[hash])) {
            query = (0, $6X8o4.liftPromiseState)(loader());
            if (saveToStore || !disablePreloadedQueryLinkSaveToStore) this.store[hash] = query;
        }
        if (disablePreloadedQueryLinkSaveToStore) return this.store[hash] || query;
        return this.store[hash];
    }
    claim(key, dataAccessor) {
        const hash = this.toHashKey(key);
        const result = this.store[hash];
        return result ? result.catch(()=>{
            delete this.store[hash];
            return null;
        }).then((result)=>{
            // Cypress uses Electron 61 which doesn't support finally
            delete this.store[hash];
            // Custom implementation for accessing preloaded data
            if (dataAccessor) return dataAccessor(result);
            // Ignore the preloaded data if there is no valid data field
            return result && result.data ? result : null;
        }) : Promise.resolve(null);
    }
    constructor(store = {}){
        this.store = void 0;
        this.store = store;
    }
}
let $7460d2a0255ec893$var$preloadResult = null;
function $7460d2a0255ec893$export$2e8e3f1fde57bbfe() {
    if ($7460d2a0255ec893$var$preloadResult === null) {
        // Save data to a global variable so they can be shared between bundles.
        if (!window.QUERY_PRELOADER_RESULTS) window.QUERY_PRELOADER_RESULTS = {};
        $7460d2a0255ec893$var$preloadResult = new $7460d2a0255ec893$export$8f7a8a727d75d90e(window.QUERY_PRELOADER_RESULTS);
    }
    return $7460d2a0255ec893$var$preloadResult;
}

});



parcelRegister("1OVaR", function(module, exports) {

$parcel$export(module.exports, "space", () => $1536cf93d43d6602$export$a941ed4b947d12f8);
parcelRequire("1wgMJ");
var $6cikW = parcelRequire("6cikW");

var $glTst = parcelRequire("glTst");

var $kzVdH = parcelRequire("kzVdH");

var $4ZFIE = parcelRequire("4ZFIE");
/**
 * Add a relationship between a space and current user.
 *
 * @param {Object} options
 * @param {String} options.relation - The relation between 2 entities
 * @param {String} options.key - The id of the entity
 * @param {String} options.action - The action to the entity
 * @param callback - The callback that handles the response.
 */ const $1536cf93d43d6602$var$relations = (options, callback)=>{
    const params = {
        sourceType: 'user',
        sourceKey: 'current',
        relationName: options.relation,
        targetType: 'Space',
        targetKey: options.key
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.RELATION_ENTITIES), params);
    if (options.action === 'add') (0, $4ZFIE.default).put(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        routeName: 'RELATION_ENTITIES'
    });
    else if (options.action === 'delete') (0, $4ZFIE.default).delete(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        routeName: 'RELATION_ENTITIES'
    });
};
function $1536cf93d43d6602$export$a941ed4b947d12f8(options, callback) {
    const defaultSpaceExpansions = 'icon,metadata.labels,operations,lookAndFeel,settings,theme';
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.SPACE), {
        spaceKey: options.spaceKey,
        expand: options.expand ? options.expand : defaultSpaceExpansions
    });
    (0, $4ZFIE.default).get(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        responseTransformer: (0, $kzVdH.spaceResponseTransformer),
        routeName: 'SPACE'
    });
}

});
parcelRegister("1wgMJ", function(module, exports) {

$parcel$export(module.exports, "redirectToLoginPage", () => (parcelRequire("6cikW")).redirectToLoginPage);

var $6cikW = parcelRequire("6cikW");

});
parcelRegister("6cikW", function(module, exports) {

$parcel$export(module.exports, "redirectToLoginPage", () => $4832165b3cb00945$export$53fdc13b0725dc2f);

var $lwdd5 = parcelRequire("lwdd5");

var $jlIaF = parcelRequire("jlIaF");
function $4832165b3cb00945$export$53fdc13b0725dc2f() {
    (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location = `${0, $jlIaF.CONTEXT_PATH}/login.action?os_destination=${(0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location.pathname.replace((0, $jlIaF.CONTEXT_PATH), '')}`;
}

});


parcelRegister("glTst", function(module, exports) {

$parcel$export(module.exports, "CONTENT_CREATE", () => $be79a06186edd30a$export$d7b094653547f492);
$parcel$export(module.exports, "EDIT_PAGE_METADATA", () => $be79a06186edd30a$export$7289b07637c5429e);
$parcel$export(module.exports, "DRAFT_METADATA", () => $be79a06186edd30a$export$df073c2379a2dd3f);
$parcel$export(module.exports, "DRAFT_SYNC", () => $be79a06186edd30a$export$49f3ec801d107ef1);
$parcel$export(module.exports, "CONTENT_PUBLISH", () => $be79a06186edd30a$export$9903792537254d5);
$parcel$export(module.exports, "CONTENT_FROM_TEMPLATE_PUBLISH", () => $be79a06186edd30a$export$4623bae024a48b71);
$parcel$export(module.exports, "EDIT_PAGE_PROPERTIES", () => $be79a06186edd30a$export$533c0de32020cfb7);
$parcel$export(module.exports, "SPACE", () => $be79a06186edd30a$export$27b7b95a5fde2b31);
$parcel$export(module.exports, "RELATION_ENTITIES", () => $be79a06186edd30a$export$71a35391239a6305);
$parcel$export(module.exports, "FEATURE_DISCOVERY", () => $be79a06186edd30a$export$4ce7537a3461d0d3);
$parcel$export(module.exports, "EDITOR_PAGE", () => $be79a06186edd30a$export$eabb116af1a87c7);
$parcel$export(module.exports, "CANCEL_SCHEDULED_PUBLISH", () => $be79a06186edd30a$export$8457ce6f530e7dc4);
// NOTE: These constants are alphabetised by value to help avoid duplication.
const $be79a06186edd30a$export$999beecd9976dfe6 = '/labels/autocompletelabel.action?maxResults=3&query=:query&contentId=:contentId';
const $be79a06186edd30a$export$d7b094653547f492 = '/rest/api/content';
const $be79a06186edd30a$export$60da72490d291c94 = '/rest/api/content/:contentId/?status=:status';
const $be79a06186edd30a$export$7289b07637c5429e = '/rest/api/content/:contentId/?expand=ancestors,version';
const $be79a06186edd30a$export$df073c2379a2dd3f = '/rest/api/content/:contentId/?status=draft&expand=ancestors,space';
const $be79a06186edd30a$export$49f3ec801d107ef1 = '/rest/api/content/:contentId/?status=draft&action=sync';
const $be79a06186edd30a$export$9903792537254d5 = '/rest/api/content/:contentId/?status=draft&action=publish';
const $be79a06186edd30a$export$4623bae024a48b71 = '/rest/api/content/blueprint/instance/:contentId?status=draft';
const $be79a06186edd30a$export$533c0de32020cfb7 = '/rest/api/content/:contentId/property/:propertyKey';
const $be79a06186edd30a$export$27b7b95a5fde2b31 = '/rest/api/space?spaceKey=:spaceKey&expand=:expand';
const $be79a06186edd30a$export$71a35391239a6305 = '/rest/experimental/relation/:sourceType/:sourceKey/:relationName/to:targetType/:targetKey';
const $be79a06186edd30a$export$4ce7537a3461d0d3 = '/rest/feature-discovery/1.0/discovered/:pluginKey/:featureKey';
const $be79a06186edd30a$export$eabb116af1a87c7 = '/rest/tinymce/1/content/:contentId.json?draftShareId=:draftShareId&_=:timestamp';
const $be79a06186edd30a$export$81b54e219a26d7f3 = '/pages/rendercontent.action';
const $be79a06186edd30a$export$178c227390220f0e = '/rest/synchrony/1.0/content/:contentId/changes/unpublished';
const $be79a06186edd30a$export$8457ce6f530e7dc4 = '/rest/api/content/:contentId/schedule/publish';

});

parcelRegister("kzVdH", function(module, exports) {

$parcel$export(module.exports, "spaceResponseTransformer", () => $efb3763ab8e07bb8$export$9d4d8ac8f8e79877);
$parcel$export(module.exports, "contentWithBodyResponseTransformer", () => $efb3763ab8e07bb8$export$b8b68047d69aeebb);
$parcel$export(module.exports, "editorContentWithBodyResponseTransformer", () => $efb3763ab8e07bb8$export$5b7f66cbeaa0c63f);
$parcel$export(module.exports, "publishContentTransformer", () => $efb3763ab8e07bb8$export$8e8f969893c7131f);
$parcel$export(module.exports, "schedulePublishContentTransformer", () => $efb3763ab8e07bb8$export$308ad3c647525282);

var $fHHNy = parcelRequire("fHHNy");
const $efb3763ab8e07bb8$var$_toStringPreserveNull = (value)=>{
    if (typeof value === 'undefined' || value === null) return value;
    return String(value);
};
const $efb3763ab8e07bb8$var$_contentPropertiesResponseTransformer = (properties)=>{
    const contentProperties = {};
    if (!properties) return contentProperties;
    if (properties instanceof Array) // GraphQL
    for (const property of properties)contentProperties[property.key] = {
        key: property.key,
        value: JSON.parse(property.value)
    };
    else // REST
    Object.keys(properties).filter((key)=>!key.startsWith('_')).forEach((key)=>{
        const value = properties[key].value;
        contentProperties[key] = {
            key: key,
            value: value
        };
    });
    return contentProperties;
};
/**
 * @typedef {Object} NormalizedAllUpdatesResponse
 * @property {Object} response - The original REST API response. This will be removed as development progresses.
 * @property {Array<Object>} changeSets - The normalized content entities from the response object.
 */ /**
 * @typedef {Object} SpaceEntity
 * @property {string} key - The unique key for a space.
 * @property {string} title - The display title of a space.
 */ /**
 * Transforms common properties from a REST Space object response.
 * @param spaceResult The REST space object
 * @returns {{id: Number, key: String, name: String, type: String, description: null, iconPath: String, homepageId: String}}
 * @private
 */ const $efb3763ab8e07bb8$var$_transformSpaceEntity = (spaceResult)=>{
    const homepageId = spaceResult._expandable && spaceResult._expandable.homepage ? spaceResult._expandable.homepage.substring(18) : spaceResult.homepage && spaceResult.homepage.id;
    const space = {
        id: spaceResult.id ? `${spaceResult.id}` : spaceResult.id,
        key: spaceResult.key,
        alias: spaceResult.alias,
        name: spaceResult.name,
        type: spaceResult.type
    };
    if (homepageId) space.homepageId = `${homepageId}`;
    if (spaceResult.icon && spaceResult.icon.path) space.iconPath = spaceResult.icon.path;
    if (spaceResult.isFavourite) space.isFavourite = spaceResult.isFavourite;
    if (spaceResult.isWatched) space.isWatched = spaceResult.isWatched;
    if (spaceResult.operations) {
        space.operations = spaceResult.operations;
        space.currentUserPermissions = spaceResult.operations.filter((op)=>op.targetType === 'space').map((op)=>op.operation);
    }
    if (spaceResult.lookAndFeel) space.lookAndFeel = spaceResult.lookAndFeel;
    if (spaceResult.settings) space.settings = spaceResult.settings;
    if (spaceResult.theme) space.theme = $efb3763ab8e07bb8$export$90060682b63d0d22(spaceResult.theme);
    return space;
};
const $efb3763ab8e07bb8$export$9d4d8ac8f8e79877 = (response)=>{
    const results = [];
    (response.results || response.nodes).map((space)=>{
        const labels = space.metadata && space.metadata.labels && (space.metadata.labels.results || space.metadata.labels.nodes);
        results.push($efb3763ab8e07bb8$var$_transformSpaceEntity({
            ...space,
            isFavourite: labels && labels.some((label)=>label.prefix === 'my' && (label.name === 'favourite' || label.name === 'favorite'))
        }));
    });
    return {
        results: results
    };
};
const $efb3763ab8e07bb8$var$spaceThemeKeyModuleKeyRegex = /^ac:(.*)__(.*)-remote-theme$/;
const $efb3763ab8e07bb8$export$90060682b63d0d22 = (response)=>{
    const regexResult = $efb3763ab8e07bb8$var$spaceThemeKeyModuleKeyRegex.exec(response.themeKey);
    return regexResult ? {
        addonKey: regexResult[1],
        moduleKey: regexResult[2]
    } : {
        addonKey: null,
        moduleKey: null
    };
};
/**
 * Return 'null' in place of 'undefined'
 */ const $efb3763ab8e07bb8$var$orNull = (value)=>typeof value === 'undefined' ? null : value;
const $efb3763ab8e07bb8$export$51f5684b148b495e = (response)=>{
    if (!response) return {};
    const { metadata: metadata = {} } = response;
    const id = response ? $efb3763ab8e07bb8$var$_toStringPreserveNull(response.id) : null;
    const properties = response.properties && response.properties.nodes || metadata.properties;
    const data = {
        id: id,
        properties: $efb3763ab8e07bb8$var$_contentPropertiesResponseTransformer(properties),
        title: response.title,
        type: response.type,
        operations: response.operations,
        currentUserPermissions: response.operations ? response.operations.map((op)=>op.operation) : null
    };
    if (response.version) data.version = $efb3763ab8e07bb8$var$contentVersionResponseTransformer(response).version;
    return data;
};
/**
 * Standardize the response for getting the space home content.
 * @param response - The REST response
 * @returns {*} a normalized content response for the space home.
 */ const $efb3763ab8e07bb8$var$contentBodyResponseTransformer = (response)=>{
    if (!response) return {};
    const { body: body } = response;
    const id = response ? $efb3763ab8e07bb8$var$_toStringPreserveNull(response.id) : null;
    return {
        body: {
            id: id,
            html: body && body.view && body.view.value,
            cssTags: body && body.view && body.view.webresource.tags.css,
            jsUris: body && body.view && body.view.webresource.uris.js
        }
    };
};
/**
 * Standardize the response for getting versions.
 * @param response - The REST response
 * @param id - The content id
 * @returns {*} a normalized content response for the version
 */ const $efb3763ab8e07bb8$var$contentVersionResponseTransformer = (response, id)=>{
    if (!response) return {};
    id = $efb3763ab8e07bb8$var$_toStringPreserveNull(id || response.id);
    return {
        version: {
            id: `${id}`,
            by: response.version && response.version.by && (0, $fHHNy.userTransformer)(response.version.by),
            when: response.version && response.version.when,
            friendlyWhen: response.version && response.version.friendlyWhen,
            number: response.version && response.version.number,
            syncRev: response.version && response.version.syncRev,
            confRev: response.version && response.version.confRev
        }
    };
};
/**
 * Standardize the response for getting createdBy field.
 * @param response - The REST response
 * @param id - The content id
 * @returns {*} a normalized content response for the createdBy field
 */ const $efb3763ab8e07bb8$var$contentCreatedResponseTransformer = (content)=>{
    const created = {
        createdDate: undefined,
        createdBy: undefined
    };
    if (!content || !content.history) return created;
    const { createdDate: createdDate, createdBy: createdBy } = content.history;
    if (createdDate) created.createdDate = createdDate;
    if (createdBy) {
        const user = (0, $fHHNy.userTransformer)(createdBy);
        if (typeof user.isAnonymous !== 'undefined') created.createdBy = user;
    }
    return created;
};
const $efb3763ab8e07bb8$export$b8b68047d69aeebb = (response)=>{
    if (!response) return {};
    // when using cql search through graphql, there is one extra level of nesting
    const content = response.content || response;
    return {
        ...$efb3763ab8e07bb8$export$51f5684b148b495e(content),
        ...$efb3763ab8e07bb8$var$contentBodyResponseTransformer(content),
        ancestors: content.ancestors,
        ...$efb3763ab8e07bb8$var$contentCreatedResponseTransformer(content),
        ...$efb3763ab8e07bb8$var$contentVersionResponseTransformer(content),
        space: content.space
    };
};
const $efb3763ab8e07bb8$export$f4598dcdfe03c0cd = (response)=>{
    const results = response && (response.results || response.nodes);
    if (!results || !results.length) return null;
    return $efb3763ab8e07bb8$export$b8b68047d69aeebb(results[0]);
};
const $efb3763ab8e07bb8$export$5b7f66cbeaa0c63f = (response, url)=>{
    if (!response) return {};
    // Do not use the id from the response - there could be a rounding error if the id is too large.
    const id = $efb3763ab8e07bb8$var$_toStringPreserveNull(url.substring(url.lastIndexOf('/') + 1).split('.')[0]);
    return {
        _originalResponse: response,
        id: id,
        title: response.title,
        version: {
            id: `${id}`,
            number: parseInt(response.pageVersion, 10)
        },
        spaceKey: response.spaceKey
    };
};
const $efb3763ab8e07bb8$export$8e8f969893c7131f = (response, url)=>{
    if (!response) return {};
    return {
        id: response.id,
        createdDate: response.history && response.history.createdDate,
        createdBy: response.history && response.history.createdBy && (0, $fHHNy.userTransformer)(response.history.createdBy),
        ...$efb3763ab8e07bb8$var$contentVersionResponseTransformer(response),
        type: response.type,
        title: response.title
    };
};
const $efb3763ab8e07bb8$export$308ad3c647525282 = (response, url)=>{
    if (!response) return {};
    return {
        id: response.id,
        createdDate: response.history && response.history.createdDate,
        createdBy: response.history && response.history.createdBy && (0, $fHHNy.userTransformer)(response.history.createdBy),
        type: response.type,
        title: response.title
    };
};
const $efb3763ab8e07bb8$export$22c94088267c8e81 = (response)=>{
    const results = response && (response.results || response.nodes);
    if (!results || !results.length) return null;
    return $efb3763ab8e07bb8$export$b89596f1f8559835(results[0]);
};
const $efb3763ab8e07bb8$var$EMPTY_ADF_DOCUMENT = {
    value: {
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ],
        type: 'doc',
        version: 1
    }
};
function $efb3763ab8e07bb8$var$_parseAtlasDocFormat(atlas_doc_format) {
    //TODO: CFE-610 Remove this empty ADF document
    if (!atlas_doc_format.value || atlas_doc_format.value.length === 0) return $efb3763ab8e07bb8$var$EMPTY_ADF_DOCUMENT;
    try {
        return {
            value: JSON.parse(atlas_doc_format.value)
        };
    } catch (e) {
        return {
            // use the value to show in ADF Parsing Error dialog
            value: atlas_doc_format.value,
            isADFContentInvalid: true
        };
    }
}
const $efb3763ab8e07bb8$export$b89596f1f8559835 = (response, url)=>{
    if (!response) return {};
    let id;
    if (response.id) id = response.id;
    else if (url) id = $efb3763ab8e07bb8$var$_toStringPreserveNull(url.substring(url.lastIndexOf('/') + 1).split('.')[0]);
    const parsedEditorContent = {};
    parsedEditorContent.atlas_doc_format = $efb3763ab8e07bb8$var$_parseAtlasDocFormat(response.body.atlas_doc_format);
    const data = {
        id: id,
        title: response.title,
        editorContent: {
            ...response.body,
            ...parsedEditorContent
        },
        type: response.type,
        isUnpublishedDraft: !response.history.createdBy,
        ancestors: response.ancestors,
        space: response.space,
        links: response.links,
        currentUserPermissions: response.operations && response.operations.map((op)=>op.operation),
        ...$efb3763ab8e07bb8$var$contentCreatedResponseTransformer(response),
        ...$efb3763ab8e07bb8$var$contentVersionResponseTransformer(response),
        appearancePublished: response.appearancePublished.nodes,
        appearanceDraft: response.appearanceDraft.nodes,
        labels: response.metadata.labels,
        schedulePublishDate: response.schedulePublishDate
    };
    return data;
};
const $efb3763ab8e07bb8$export$f7a7df7bf8236bf1 = (response, url)=>{
    if (!response) return {};
    const id = $efb3763ab8e07bb8$var$_toStringPreserveNull(url.substring(url.lastIndexOf('/') + 1).split('.')[0]);
    return {
        id: id,
        renderedPreviewContent: response
    };
};
const $efb3763ab8e07bb8$export$b74925f6c30cdf19 = (response, url)=>{
    if (url) {
        const spaceKey = url.substr(url.lastIndexOf('/') + 1);
        return {
            entities: {
                spaces: {
                    [spaceKey]: {
                        isFavourite: true
                    }
                }
            }
        };
    } else return {
        entities: {
            spaces: {}
        }
    };
};
const $efb3763ab8e07bb8$export$304e680a6aa46d45 = (response, url)=>{
    if (url) {
        const spaceKey = url.substr(url.lastIndexOf('/') + 1);
        return {
            entities: {
                spaces: {
                    [spaceKey]: {
                        isFavourite: false
                    }
                }
            }
        };
    } else return {
        entities: {
            spaces: {}
        }
    };
};
const $efb3763ab8e07bb8$export$b1e23bed8ebe8d4c = (response)=>{
    return response.results.map(({ source: { displayName: displayName, accountId: accountId, profilePicture: { path: avatarUrl } = {} }, relationData: { createdDate: createdDate, friendlyCreatedDate: friendlyCreatedDate } })=>{
        return {
            avatarUrl: avatarUrl,
            displayName: displayName,
            accountId: accountId,
            createdDate: createdDate,
            friendlyCreatedDate: friendlyCreatedDate
        };
    });
};

});
parcelRegister("fHHNy", function(module, exports) {

$parcel$export(module.exports, "userTransformer", () => $b6ecd8937a6050a6$export$6938163b060d2a80);
const $b6ecd8937a6050a6$export$6938163b060d2a80 = ({ type: type, accountId: accountId, displayName: displayName, profilePicture: { path: avatarUrl } = {}, permissionType: permissionType } = {})=>{
    if (!avatarUrl) return {};
    if (type === 'anonymous') return {
        isAnonymous: true,
        avatarUrl: avatarUrl
    };
    return {
        isAnonymous: false,
        displayName: displayName,
        avatarUrl: avatarUrl,
        accountId: accountId,
        permissionType: permissionType
    };
};

});



parcelRegister("chDZy", function(module, exports) {

$parcel$export(module.exports, "editPageMetadata", () => $8f16181e8882e6f9$export$3d345574ab01eed1);
$parcel$export(module.exports, "editorPage", () => $8f16181e8882e6f9$export$a6789ac37d2f0d42);
$parcel$export(module.exports, "publishEditorPage", () => $8f16181e8882e6f9$export$a288c2036303f9da);
$parcel$export(module.exports, "syncEditorDraft", () => $8f16181e8882e6f9$export$d6662bc368e1c48b);
$parcel$export(module.exports, "publishEditorPageFromTemplate", () => $8f16181e8882e6f9$export$db7e0944681d3c58);
$parcel$export(module.exports, "createPage", () => $8f16181e8882e6f9$export$eea1b38e4aaafc7d);
$parcel$export(module.exports, "draftMetadata", () => $8f16181e8882e6f9$export$62e554e9e3f861e);
$parcel$export(module.exports, "cancelScheduledPublish", () => $8f16181e8882e6f9$export$ce9e47b8e2fdc29c);
/**
 * Helper methods for fetching content.
 * @module confluence-rest-api/content
 */ parcelRequire("1wgMJ");
var $6cikW = parcelRequire("6cikW");

var $glTst = parcelRequire("glTst");

var $kzVdH = parcelRequire("kzVdH");

var $6Okcl = parcelRequire("6Okcl");

var $4ZFIE = parcelRequire("4ZFIE");
const $8f16181e8882e6f9$var$JSONPostHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
function $8f16181e8882e6f9$export$3d345574ab01eed1(options, callback) {
    const params = {
        contentId: options.contentId
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.EDIT_PAGE_METADATA), params);
    (0, $4ZFIE.default).get(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        responseTransformer: (0, $kzVdH.contentWithBodyResponseTransformer),
        routeName: 'EDIT_PAGE_METADATA'
    });
}
function $8f16181e8882e6f9$export$a6789ac37d2f0d42(options, callback) {
    const params = {
        contentId: options.contentId,
        timestamp: Date.now(),
        draftShareId: options.draftShareId
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.EDITOR_PAGE), params);
    (0, $4ZFIE.default).get(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        responseTransformer: (0, $kzVdH.editorContentWithBodyResponseTransformer),
        routeName: 'EDITOR_PAGE'
    });
}
function $8f16181e8882e6f9$export$a288c2036303f9da(options, callback) {
    const schedulePublishTime = options.content.schedulePublishDate;
    const params = {
        contentId: options.content.id,
        schedulePublishTime: schedulePublishTime
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.CONTENT_PUBLISH), params);
    (0, $4ZFIE.default).put(url, {
        body: options.content,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: $8f16181e8882e6f9$var$JSONPostHeaders,
        responseTransformer: schedulePublishTime ? (0, $kzVdH.schedulePublishContentTransformer) : (0, $kzVdH.publishContentTransformer),
        routeName: 'CONTENT_PUBLISH'
    });
}
function $8f16181e8882e6f9$export$d6662bc368e1c48b(options, callback) {
    const params = {
        contentId: options.content.id
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.DRAFT_SYNC), params);
    (0, $4ZFIE.default).put(url, {
        body: options.content,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: $8f16181e8882e6f9$var$JSONPostHeaders,
        responseTransformer: (0, $kzVdH.publishContentTransformer),
        routeName: 'DRAFT_SYNC'
    });
}
function $8f16181e8882e6f9$export$db7e0944681d3c58(options, callback) {
    const schedulePublishTime = options.content.schedulePublishDate;
    const params = {
        contentId: options.content.id,
        schedulePublishTime: schedulePublishTime
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.CONTENT_FROM_TEMPLATE_PUBLISH), params);
    (0, $4ZFIE.default).put(url, {
        body: options.content,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: $8f16181e8882e6f9$var$JSONPostHeaders,
        responseTransformer: schedulePublishTime ? (0, $kzVdH.schedulePublishContentTransformer) : (0, $kzVdH.publishContentTransformer),
        routeName: 'CONTENT_FROM_TEMPLATE_PUBLISH'
    });
}
function $8f16181e8882e6f9$export$eea1b38e4aaafc7d(options, callback) {
    const body = {
        type: options.contentType || 'page',
        status: 'draft',
        //title: "",    // This is possible for draft but not for published page.
        space: {
            key: options.spaceKey
        }
    };
    if (options.fromPageId) body.ancestors = [
        {
            id: options.fromPageId
        }
    ];
    if (options.title) body.title = options.title;
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.CONTENT_CREATE));
    (0, $4ZFIE.default).post(url, {
        body: body,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: $8f16181e8882e6f9$var$JSONPostHeaders,
        responseTransformer: (0, $6Okcl.contentTransformer),
        routeName: 'CONTENT_CREATE'
    });
}
function $8f16181e8882e6f9$export$62e554e9e3f861e(options, callback) {
    const params = {
        contentId: options.contentId
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.DRAFT_METADATA), params);
    (0, $4ZFIE.default).get(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        responseTransformer: (0, $kzVdH.contentWithBodyResponseTransformer),
        routeName: 'DRAFT_METADATA'
    });
}
function $8f16181e8882e6f9$export$ce9e47b8e2fdc29c(options, callback) {
    const params = {
        contentId: options.contentId
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.CANCEL_SCHEDULED_PUBLISH), params);
    (0, $4ZFIE.default).delete(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        routeName: 'CANCEL_SCHEDULED_PUBLISH'
    });
}

});
parcelRegister("6Okcl", function(module, exports) {

$parcel$export(module.exports, "contentTransformer", () => $4f571486c73ec3f3$export$ba6cee8d0d45e052);

var $fHHNy = parcelRequire("fHHNy");
const $4f571486c73ec3f3$export$7328289ba9a44022 = (content, labels)=>{
    if (labels) {
        const kind = $4f571486c73ec3f3$export$25a56c84cce0b050(labels);
        if (kind) return kind;
    }
    // TODO: that will need to be i18n
    const typesToKind = {
        page: 'Page',
        blog: 'Blogpost',
        question: 'Question'
    };
    return typesToKind[content.type];
};
const $4f571486c73ec3f3$export$25a56c84cce0b050 = (labels)=>{
    if (!labels.length) return null;
    // TODO: that will need to be i18n
    const labelToKind = {
        'meeting-notes': 'Meeting notes',
        'product-requirements': 'Product requirement',
        decisions: 'Decision',
        'file-list': 'File list',
        retrospective: 'Retrospective',
        'kb-how-to-article': 'How to article',
        'task-report': 'Task report',
        jirareport: 'Jira report',
        'shared-links': 'Shared link',
        'kb-troubleshooting-article': 'Troubleshooting article',
        'gliffy-blueprint': 'Gliffy diagram'
    };
    const acceptedLabels = Object.keys(labelToKind);
    const found = labels.filter((label)=>acceptedLabels.indexOf(label.name) > -1);
    return found.length ? labelToKind[found[0].name] : null;
};
const $4f571486c73ec3f3$export$d2296f7618a3dcd = (item, defaultResult)=>{
    if (typeof item === 'object' && item && typeof item.metadata === 'object' && item.metadata && typeof item.metadata.labels === 'object' && item.metadata.labels && typeof item.metadata.labels.results !== 'undefined') return item.metadata.labels.results;
    return defaultResult;
};
function $4f571486c73ec3f3$export$ba6cee8d0d45e052(response) {
    return {
        ...response,
        version: {
            ...response.version,
            id: response.id,
            by: {
                ...response.version.by
            }
        },
        contributors: response.history && response.history.contributors && response.history.contributors.publishers && response.history.contributors.publishers.users && response.history.contributors.publishers.users.map((0, $fHHNy.userTransformer)),
        labels: $4f571486c73ec3f3$export$d2296f7618a3dcd(response, [])
    };
}

});


parcelRegister("2cpJ0", function(module, exports) {

$parcel$export(module.exports, "markDiscovered", () => $19a0a834f2942e87$export$29913089bc850e3);
/**
 * Helper methods for feature discovery plugin.
 * @module confluence-rest-api/feature-discovery
 */ parcelRequire("1wgMJ");
var $6cikW = parcelRequire("6cikW");

var $glTst = parcelRequire("glTst");

var $4ZFIE = parcelRequire("4ZFIE");
function $19a0a834f2942e87$export$29913089bc850e3(options, callback) {
    const params = {
        pluginKey: options.pluginKey,
        featureKey: options.featureKey
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.FEATURE_DISCOVERY), params);
    (0, $4ZFIE.default).postLegacyResource(url, {
        body: {
            atl_token: (0, $4ZFIE.default).getAtlToken()
        },
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        callback: callback,
        routeName: 'FEATURE_DISCOVERY'
    });
}

});

parcelRegister("3xce3", function(module, exports) {

$parcel$export(module.exports, "getPluginCodeLanguages", () => $292defebfb376489$export$36fc1cabd39f481b);
$parcel$export(module.exports, "getWikiConfluenceToXhtml", () => $292defebfb376489$export$3b78f501cfcecded);
$parcel$export(module.exports, "getWikiMarkdownToXhtml", () => $292defebfb376489$export$b0105dc9e36efff1);
parcelRequire("1wgMJ");
var $6cikW = parcelRequire("6cikW");

var $4ZFIE = parcelRequire("4ZFIE");
// This is intentionally outside endpoints.js to prevent any transformers leaking here.
const $292defebfb376489$var$EDITOR_PLUGIN_CODE_LANGUAGES = '/plugins/newcode/getlanguages.action';
const $292defebfb376489$var$EDITOR_PLUGIN_WIKI_CONFLUENCE_CONVERTER = '/rest/tinymce/1/wikixhtmlconverter';
const $292defebfb376489$var$EDITOR_PLUGIN_WIKI_MARKDOWN_CONVERTER = '/rest/tinymce/1/markdownxhtmlconverter';
function $292defebfb376489$export$36fc1cabd39f481b(callback) {
    const url = (0, $4ZFIE.default).getFullPath($292defebfb376489$var$EDITOR_PLUGIN_CODE_LANGUAGES);
    (0, $4ZFIE.default).get(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        routeName: 'EDITOR_PLUGIN_CODE_LANGUAGES'
    });
}
function $292defebfb376489$export$3b78f501cfcecded(body, callback) {
    const url = (0, $4ZFIE.default).getFullPath($292defebfb376489$var$EDITOR_PLUGIN_WIKI_CONFLUENCE_CONVERTER);
    (0, $4ZFIE.default).postLegacyResource(url, {
        body: body,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: {
            Accept: 'text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8'
        },
        routeName: 'EDITOR_PLUGIN_WIKI_CONFLUENCE_CONVERTER'
    });
}
function $292defebfb376489$export$b0105dc9e36efff1(body, callback) {
    const url = (0, $4ZFIE.default).getFullPath($292defebfb376489$var$EDITOR_PLUGIN_WIKI_MARKDOWN_CONVERTER);
    (0, $4ZFIE.default).postLegacyResource(url, {
        body: body,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: {
            Accept: 'text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8'
        },
        routeName: 'EDITOR_PLUGIN_WIKI_MARKDOWN_CONVERTER'
    });
}

});

parcelRegister("gCs5d", function(module, exports) {

$parcel$export(module.exports, "updateContentProperty", () => $c195faa763349116$export$392f5cb0a0c7397a);
parcelRequire("1wgMJ");
var $6cikW = parcelRequire("6cikW");

var $glTst = parcelRequire("glTst");

var $4ZFIE = parcelRequire("4ZFIE");
function $c195faa763349116$export$392f5cb0a0c7397a(options, callback) {
    const params = {
        contentId: options.contentId,
        propertyKey: options.propertyKey
    };
    const body = {
        value: options.propertyValue,
        version: {
            number: options.versionNumber,
            minorEdit: true
        }
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.EDIT_PAGE_PROPERTIES), params);
    (0, $4ZFIE.default).put(url, {
        body: body,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: {
            'Content-Type': 'application/json'
        },
        routeName: 'EDIT_PAGE_PROPERTIES'
    });
}

});






parcelRegister("3pfAb", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("7l88B")).default);
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("k7eoe")).FabricChannel);

var $7l88B = parcelRequire("7l88B");

var $cCg1W = parcelRequire("cCg1W");

var $k7eoe = parcelRequire("k7eoe");

});
parcelRegister("7l88B", function(module, exports) {

$parcel$export(module.exports, "default", () => $104739198ff898b6$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $k7eoe = parcelRequire("k7eoe");

var $39uxR = parcelRequire("39uxR");

var $3E6Gp = parcelRequire("3E6Gp");

var $cCg1W = parcelRequire("cCg1W");

var $1V02V = parcelRequire("1V02V");

var $15skR = parcelRequire("15skR");

var $8pDQ9 = parcelRequire("8pDQ9");

var $4xH15 = parcelRequire("4xH15");

var $bO61E = parcelRequire("bO61E");

var $12ysu = parcelRequire("12ysu");

var $iwNQU = parcelRequire("iwNQU");

var $eY1oR = parcelRequire("eY1oR");

var $kARvT = parcelRequire("kARvT");

var $7ETsB = parcelRequire("7ETsB");

var $c3sKJ = parcelRequire("c3sKJ");

var $5cQbO = parcelRequire("5cQbO");

var $5ArSt = parcelRequire("5ArSt");
const $104739198ff898b6$var$listenerMap = {
    [(0, $k7eoe.FabricChannel).elements]: (0, $39uxR.default),
    [(0, $k7eoe.FabricChannel).editor]: (0, $15skR.default),
    [(0, $k7eoe.FabricChannel).atlaskit]: (0, $3E6Gp.default),
    [(0, $k7eoe.FabricChannel).navigation]: (0, $1V02V.default),
    [(0, $k7eoe.FabricChannel).media]: (0, $8pDQ9.default),
    [(0, $k7eoe.FabricChannel).peopleTeams]: (0, $4xH15.default),
    [(0, $k7eoe.FabricChannel).notifications]: (0, $bO61E.default),
    [(0, $k7eoe.FabricChannel).recentWork]: (0, $12ysu.default),
    [(0, $k7eoe.FabricChannel).atlas]: (0, $iwNQU.default),
    [(0, $k7eoe.FabricChannel).crossFlow]: (0, $eY1oR.default),
    [(0, $k7eoe.FabricChannel).linkingPlatform]: (0, $kARvT.default),
    [(0, $k7eoe.FabricChannel).postOffice]: (0, $7ETsB.default),
    [(0, $k7eoe.FabricChannel).aiMate]: (0, $c3sKJ.default),
    [(0, $k7eoe.FabricChannel).avp]: (0, $5cQbO.default),
    [(0, $k7eoe.FabricChannel).growth]: (0, $5ArSt.default)
};
class $104739198ff898b6$var$FabricAnalyticsListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { client: client, children: children, logLevel: logLevel, excludedChannels: excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys($104739198ff898b6$var$listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>$104739198ff898b6$var$listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, $7UHDa.jsx)(Listener, {
                client: client,
                logger: this.logger,
                children: prev
            }), children);
        return listeners;
    }
    constructor(props){
        super(props);
        this.logger = void 0;
        this.logger = new (0, $cCg1W.default)({
            logLevel: props.logLevel
        });
    }
}
var $104739198ff898b6$export$2e2bcd8739ae039 = $104739198ff898b6$var$FabricAnalyticsListeners;

});
parcelRegister("39uxR", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_TAG", () => $399527ab09064620$export$ed71ae78997933a);
$parcel$export(module.exports, "default", () => $399527ab09064620$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kDuN4 = parcelRequire("kDuN4");

var $k7eoe = parcelRequire("k7eoe");

var $bf4Yi = parcelRequire("bf4Yi");
const $399527ab09064620$export$ed71ae78997933a = 'fabricElements';
class $399527ab09064620$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDuN4.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $k7eoe.FabricChannel).elements,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args);
        this.handleEventWrapper = (event)=>{
            (0, $bf4Yi.handleEvent)(event, $399527ab09064620$export$ed71ae78997933a, this.props.logger, this.props.client);
        };
    }
}

});
parcelRegister("bf4Yi", function(module, exports) {

$parcel$export(module.exports, "handleEvent", () => $0324ab2e636f2852$export$d6e5ca10785815df);

var $5nRMf = parcelRequire("5nRMf");

var $6h7ON = parcelRequire("6h7ON");
const $0324ab2e636f2852$export$d6e5ca10785815df = (event, // If passing through multiple tags, the primary tag should be first in the array.
// The primary tag is used for matching context.
tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $6h7ON.processEventPayload)(event, tags);
    (0, $5nRMf.sendEvent)(logger, client)(payload);
};

});
parcelRegister("5nRMf", function(module, exports) {

$parcel$export(module.exports, "sendEvent", () => $08ebe6d2f096a5ea$export$7329bcdc3edcd90e);
const $08ebe6d2f096a5ea$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $08ebe6d2f096a5ea$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const { eventType: eventType, ...gasEvent } = event;
            const withClient = (cb)=>{
                if ($08ebe6d2f096a5ea$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});

parcelRegister("6h7ON", function(module, exports) {

$parcel$export(module.exports, "processEventPayload", () => $e066e6e8fe62f4ce$export$c37d638b7f2ca192);

var $7TH2w = parcelRequire("7TH2w");
parcelRequire("ffCOo");
var $7i8J9 = parcelRequire("7i8J9");
var $cT1Md = parcelRequire("cT1Md");

var $ewFdA = parcelRequire("ewFdA");

var $39uxR = parcelRequire("39uxR");

var $15skR = parcelRequire("15skR");
const $e066e6e8fe62f4ce$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(result, item), {});
const $e066e6e8fe62f4ce$var$fieldExtractor = (contextKey)=>$e066e6e8fe62f4ce$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const $e066e6e8fe62f4ce$var$getContextKey = (tag)=>{
    switch(tag){
        case 0, $39uxR.ELEMENTS_TAG:
            return 0, $cT1Md.ELEMENTS_CONTEXT;
        case 0, $15skR.EDITOR_TAG:
            return 0, $7i8J9.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const $e066e6e8fe62f4ce$var$updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return {
        source: (0, $7TH2w.DEFAULT_SOURCE),
        ...event.payload
    };
    const contextKey = $e066e6e8fe62f4ce$var$getContextKey(primaryTag) || 'attributes';
    const { [contextKey]: attributes, ...fields } = $e066e6e8fe62f4ce$var$fieldExtractor(contextKey)(event.context);
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(attributes, event.payload.attributes || {});
    return {
        source: (0, $7TH2w.DEFAULT_SOURCE),
        ...fields,
        ...event.payload
    };
};
const $e066e6e8fe62f4ce$var$addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $e066e6e8fe62f4ce$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const $e066e6e8fe62f4ce$export$c37d638b7f2ca192 = (event, tags)=>{
    const primaryTag = $e066e6e8fe62f4ce$var$getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return {
        ...$e066e6e8fe62f4ce$var$updatePayloadWithContext(primaryTag, event),
        tags: $e066e6e8fe62f4ce$var$addTags(tagsArray, event.payload.tags)
    };
};

});
parcelRegister("15skR", function(module, exports) {

$parcel$export(module.exports, "EDITOR_TAG", () => $c1861bb6696554c9$export$a1d9dc589a29b3aa);
$parcel$export(module.exports, "default", () => $c1861bb6696554c9$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kDuN4 = parcelRequire("kDuN4");

var $k7eoe = parcelRequire("k7eoe");

var $bf4Yi = parcelRequire("bf4Yi");
const $c1861bb6696554c9$export$a1d9dc589a29b3aa = 'editor';
const $c1861bb6696554c9$export$8aa0d788f94a809 = 'fabricEditor';
class $c1861bb6696554c9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDuN4.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $k7eoe.FabricChannel).editor,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args);
        this.handleEventWrapper = (event)=>{
            (0, $bf4Yi.handleEvent)(event, [
                $c1861bb6696554c9$export$a1d9dc589a29b3aa,
                $c1861bb6696554c9$export$8aa0d788f94a809
            ], this.props.logger, this.props.client);
        };
    }
}

});




parcelRegister("3E6Gp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9808379ecad6fe49$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k7eoe = parcelRequire("k7eoe");

var $4zPDd = parcelRequire("4zPDd");

var $hPf3V = parcelRequire("hPf3V");
function $9808379ecad6fe49$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPf3V.default), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).atlaskit,
        processEvent: (0, $4zPDd.default)
    });
}

});
parcelRegister("4zPDd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1024103f531856dc$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $5XKHf = parcelRequire("5XKHf");

var $ewFdA = parcelRequire("ewFdA");

var $7TH2w = parcelRequire("7TH2w");

var $cmjWy = parcelRequire("cmjWy");
const $1024103f531856dc$var$ATLASKIT_TAG = 'atlaskit';
const $1024103f531856dc$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $1024103f531856dc$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $cmjWy.getSources)(event);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $cmjWy.getExtraAttributes)(event);
    const components = (0, $cmjWy.getComponents)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))((0, $cmjWy.getPackageInfo)(event)) || {};
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $1024103f531856dc$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $cmjWy.getPackageHierarchy)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(extraAttributes, payloadAttributes)
    };
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($1024103f531856dc$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $7TH2w.UI_EVENT_TYPE)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $cmjWy.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $7TH2w.TRACK_EVENT_TYPE) || eventType === (0, $7TH2w.OPERATIONAL_EVENT_TYPE) || eventType === (0, $7TH2w.SCREEN_EVENT_TYPE)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

});
parcelRegister("cmjWy", function(module, exports) {

$parcel$export(module.exports, "extractFromEventContext", () => $de25c6b1a3aac308$export$9b947b4502cd2705);
$parcel$export(module.exports, "getActionSubject", () => $de25c6b1a3aac308$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getSources", () => $de25c6b1a3aac308$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $de25c6b1a3aac308$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $de25c6b1a3aac308$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $de25c6b1a3aac308$export$cd17d76da7967240);
$parcel$export(module.exports, "getPackageHierarchy", () => $de25c6b1a3aac308$export$4e0b83da1896ebc7);
/**
 * Largely taken from analytics-web-react
 */ 
var $ewFdA = parcelRequire("ewFdA");
const $de25c6b1a3aac308$export$9b947b4502cd2705 = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);
const $de25c6b1a3aac308$export$6f40cdf6d42c018d = (event)=>{
    const overrides = $de25c6b1a3aac308$export$9b947b4502cd2705('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};
const $de25c6b1a3aac308$export$5f9bc633b116660f = (event)=>$de25c6b1a3aac308$export$9b947b4502cd2705('source', event);
const $de25c6b1a3aac308$export$4e811121b221213b = (event)=>$de25c6b1a3aac308$export$9b947b4502cd2705('component', event);
const $de25c6b1a3aac308$export$67c3590839ebecdd = (event)=>$de25c6b1a3aac308$export$9b947b4502cd2705('attributes', event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(result, extraAttributes), {});
const $de25c6b1a3aac308$export$cd17d76da7967240 = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $de25c6b1a3aac308$export$18cd124b5098d330 = (event)=>$de25c6b1a3aac308$export$9b947b4502cd2705('packageVersion', event);
function $de25c6b1a3aac308$export$4e0b83da1896ebc7(event) {
    const packages = $de25c6b1a3aac308$export$cd17d76da7967240(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}

});


parcelRegister("hPf3V", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e095df3c01dc7b7$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kDuN4 = parcelRequire("kDuN4");

var $5nRMf = parcelRequire("5nRMf");
class $4e095df3c01dc7b7$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDuN4.default), {
            onEvent: this.listenerHandler,
            channel: this.props.channel,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args);
        this.listenerHandler = (event)=>{
            const { client: client, logger: logger, channel: channel, processEvent: processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, $5nRMf.sendEvent)(logger, client)(payload);
        };
    }
}

});


parcelRegister("cCg1W", function(module, exports) {

$parcel$export(module.exports, "default", () => $72dce2384e397b71$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $72dce2384e397b71$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $72dce2384e397b71$export$2e2bcd8739ae039 {
    setLogLevel(logLevel) {
        if (logLevel >= $72dce2384e397b71$export$ffe0c436e29512cf.DEBUG && logLevel <= $72dce2384e397b71$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $72dce2384e397b71$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage($72dce2384e397b71$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($72dce2384e397b71$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($72dce2384e397b71$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($72dce2384e397b71$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $72dce2384e397b71$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
}

});

parcelRegister("1V02V", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6e39daa81a4df2a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k7eoe = parcelRequire("k7eoe");

var $beCr8 = parcelRequire("beCr8");

var $hPf3V = parcelRequire("hPf3V");
function $f6e39daa81a4df2a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPf3V.default), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).navigation,
        processEvent: (0, $beCr8.default)
    });
}

});
parcelRegister("beCr8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6f08321b231e7ec$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $5XKHf = parcelRequire("5XKHf");

var $ewFdA = parcelRequire("ewFdA");

var $7TH2w = parcelRequire("7TH2w");
parcelRequire("ffCOo");
var $1oYFx = parcelRequire("1oYFx");

var $fRkSY = parcelRequire("fRkSY");
const $b6f08321b231e7ec$var$NAVIGATION_TAG = 'navigation';
const $b6f08321b231e7ec$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $b6f08321b231e7ec$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fRkSY.getSources)(event, (0, $1oYFx.NAVIGATION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $fRkSY.getExtraAttributes)(event, (0, $1oYFx.NAVIGATION_CONTEXT));
    const components = (0, $fRkSY.getComponents)(event, (0, $1oYFx.NAVIGATION_CONTEXT));
    const packages = (0, $fRkSY.getPackageInfo)(event, (0, $1oYFx.NAVIGATION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))((0, $fRkSY.getPackageInfo)(event, (0, $1oYFx.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $b6f08321b231e7ec$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($b6f08321b231e7ec$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("fRkSY", function(module, exports) {

$parcel$export(module.exports, "getSources", () => $99c5302a58ee3827$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $99c5302a58ee3827$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $99c5302a58ee3827$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $99c5302a58ee3827$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ 
var $ewFdA = parcelRequire("ewFdA");
const $99c5302a58ee3827$var$extractFromEventContext = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);
const $99c5302a58ee3827$export$5f9bc633b116660f = (event, contextName)=>$99c5302a58ee3827$var$extractFromEventContext([
        'source'
    ], event, false, contextName);
const $99c5302a58ee3827$export$4e811121b221213b = (event, contextName)=>$99c5302a58ee3827$var$extractFromEventContext([
        'component',
        'componentName'
    ], event, false, contextName);
const $99c5302a58ee3827$export$67c3590839ebecdd = (event, contextName)=>$99c5302a58ee3827$var$extractFromEventContext([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(result, extraAttributes), {});
const $99c5302a58ee3827$export$cd17d76da7967240 = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);
const $99c5302a58ee3827$export$18cd124b5098d330 = (event, contextName)=>$99c5302a58ee3827$var$extractFromEventContext([
        'packageVersion'
    ], event, true, contextName);

});



parcelRegister("8pDQ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e34a9c02452623d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k7eoe = parcelRequire("k7eoe");

var $hCQXy = parcelRequire("hCQXy");

var $hPf3V = parcelRequire("hPf3V");
function $6e34a9c02452623d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPf3V.default), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).media,
        processEvent: (0, $hCQXy.processEvent)
    });
}

});
parcelRegister("hCQXy", function(module, exports) {

$parcel$export(module.exports, "processEvent", () => $f63901d19e7bdc18$export$22af68e3614bf024);

var $7TH2w = parcelRequire("7TH2w");
parcelRequire("ffCOo");
var $gSKON = parcelRequire("gSKON");

var $ewFdA = parcelRequire("ewFdA");

var $5XKHf = parcelRequire("5XKHf");

var $cmjWy = parcelRequire("cmjWy");
const $f63901d19e7bdc18$var$listenerVersion = "0.0.0-use.local";
function $f63901d19e7bdc18$var$getMediaContexts(event) {
    return (0, $cmjWy.extractFromEventContext)((0, $gSKON.MEDIA_CONTEXT), event);
}
function $f63901d19e7bdc18$var$getMediaRegion() {
    try {
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $f63901d19e7bdc18$export$22af68e3614bf024(event) {
    const sources = (0, $cmjWy.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))((0, $cmjWy.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $cmjWy.getExtraAttributes)(event);
    const mediaContexts = $f63901d19e7bdc18$var$getMediaContexts(event) || [];
    const mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, $cmjWy.getComponents)(event);
    const mediaRegion = $f63901d19e7bdc18$var$getMediaRegion();
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(sources) || (0, $7TH2w.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))({}, extraAttributes, mediaAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $cmjWy.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $f63901d19e7bdc18$var$listenerVersion,
            ...mediaRegion ? {
                mediaRegion: mediaRegion
            } : undefined
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});


parcelRegister("4xH15", function(module, exports) {

$parcel$export(module.exports, "default", () => $96136f03b059d91c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k7eoe = parcelRequire("k7eoe");

var $ktP34 = parcelRequire("ktP34");

var $hPf3V = parcelRequire("hPf3V");
function $96136f03b059d91c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPf3V.default), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).peopleTeams,
        processEvent: (0, $ktP34.default)
    });
}

});
parcelRegister("ktP34", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cadc3c25c9846ec$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $5XKHf = parcelRequire("5XKHf");

var $ewFdA = parcelRequire("ewFdA");

var $7TH2w = parcelRequire("7TH2w");
parcelRequire("ffCOo");
var $gqplE = parcelRequire("gqplE");

var $fRkSY = parcelRequire("fRkSY");
const $8cadc3c25c9846ec$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
const $8cadc3c25c9846ec$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $8cadc3c25c9846ec$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fRkSY.getSources)(event, (0, $gqplE.PEOPLE_TEAMS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $fRkSY.getExtraAttributes)(event, (0, $gqplE.PEOPLE_TEAMS_CONTEXT));
    const components = (0, $fRkSY.getComponents)(event, (0, $gqplE.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, $fRkSY.getPackageInfo)(event, (0, $gqplE.PEOPLE_TEAMS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))((0, $fRkSY.getPackageInfo)(event, (0, $gqplE.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $8cadc3c25c9846ec$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($8cadc3c25c9846ec$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("bO61E", function(module, exports) {

$parcel$export(module.exports, "default", () => $07dbb2b9190d7b14$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k7eoe = parcelRequire("k7eoe");

var $2On7N = parcelRequire("2On7N");

var $hPf3V = parcelRequire("hPf3V");
function $07dbb2b9190d7b14$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPf3V.default), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).notifications,
        processEvent: (0, $2On7N.default)
    });
}

});
parcelRegister("2On7N", function(module, exports) {

$parcel$export(module.exports, "default", () => $544439629a9bf3fd$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $5XKHf = parcelRequire("5XKHf");

var $ewFdA = parcelRequire("ewFdA");

var $7TH2w = parcelRequire("7TH2w");

var $fRkSY = parcelRequire("fRkSY");
parcelRequire("ffCOo");
var $ePh4F = parcelRequire("ePh4F");

var $k7eoe = parcelRequire("k7eoe");
const $544439629a9bf3fd$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $544439629a9bf3fd$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fRkSY.getSources)(event, (0, $ePh4F.NOTIFICATIONS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $fRkSY.getExtraAttributes)(event, (0, $ePh4F.NOTIFICATIONS_CONTEXT));
    const components = (0, $fRkSY.getComponents)(event, (0, $ePh4F.NOTIFICATIONS_CONTEXT));
    const packages = (0, $fRkSY.getPackageInfo)(event, (0, $ePh4F.NOTIFICATIONS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))((0, $fRkSY.getPackageInfo)(event, (0, $ePh4F.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $544439629a9bf3fd$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $k7eoe.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("12ysu", function(module, exports) {

$parcel$export(module.exports, "default", () => $20cd78c23fb9f419$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k7eoe = parcelRequire("k7eoe");

var $cPrMG = parcelRequire("cPrMG");

var $hPf3V = parcelRequire("hPf3V");
function $20cd78c23fb9f419$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPf3V.default), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).recentWork,
        processEvent: (0, $cPrMG.default)
    });
}

});
parcelRegister("cPrMG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce2161de111877bc$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $5XKHf = parcelRequire("5XKHf");

var $ewFdA = parcelRequire("ewFdA");

var $7TH2w = parcelRequire("7TH2w");

var $fRkSY = parcelRequire("fRkSY");
parcelRequire("ffCOo");
var $8hvil = parcelRequire("8hvil");

var $k7eoe = parcelRequire("k7eoe");
const $ce2161de111877bc$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $ce2161de111877bc$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fRkSY.getSources)(event, (0, $8hvil.RECENT_WORK_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $fRkSY.getExtraAttributes)(event, (0, $8hvil.RECENT_WORK_CONTEXT));
    const components = (0, $fRkSY.getComponents)(event, (0, $8hvil.RECENT_WORK_CONTEXT));
    const packages = (0, $fRkSY.getPackageInfo)(event, (0, $8hvil.RECENT_WORK_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))((0, $fRkSY.getPackageInfo)(event, (0, $8hvil.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $ce2161de111877bc$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $k7eoe.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("iwNQU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0213153459c4e853$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k7eoe = parcelRequire("k7eoe");

var $hLxtm = parcelRequire("hLxtm");

var $hPf3V = parcelRequire("hPf3V");
function $0213153459c4e853$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPf3V.default), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).atlas,
        processEvent: (0, $hLxtm.default)
    });
}

});
parcelRegister("hLxtm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d899a2b8fb68cab$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $5XKHf = parcelRequire("5XKHf");

var $ewFdA = parcelRequire("ewFdA");

var $7TH2w = parcelRequire("7TH2w");

var $fRkSY = parcelRequire("fRkSY");
parcelRequire("ffCOo");
var $dWoPW = parcelRequire("dWoPW");
const $2d899a2b8fb68cab$var$ATLAS_TAG = 'atlas';
const $2d899a2b8fb68cab$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $2d899a2b8fb68cab$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fRkSY.getSources)(event, (0, $dWoPW.ATLAS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $fRkSY.getExtraAttributes)(event, (0, $dWoPW.ATLAS_CONTEXT));
    const components = (0, $fRkSY.getComponents)(event, (0, $dWoPW.ATLAS_CONTEXT));
    const packages = (0, $fRkSY.getPackageInfo)(event, (0, $dWoPW.ATLAS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))((0, $fRkSY.getPackageInfo)(event, (0, $dWoPW.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $2d899a2b8fb68cab$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($2d899a2b8fb68cab$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("eY1oR", function(module, exports) {

$parcel$export(module.exports, "default", () => $63906427acfeed89$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k7eoe = parcelRequire("k7eoe");

var $7p81S = parcelRequire("7p81S");

var $hPf3V = parcelRequire("hPf3V");
function $63906427acfeed89$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPf3V.default), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).crossFlow,
        processEvent: (0, $7p81S.default)
    });
}

});
parcelRegister("7p81S", function(module, exports) {

$parcel$export(module.exports, "default", () => $133994367adca510$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $7TH2w = parcelRequire("7TH2w");

var $5XKHf = parcelRequire("5XKHf");
parcelRequire("ffCOo");
var $1oYFx = parcelRequire("1oYFx");

var $cmjWy = parcelRequire("cmjWy");

var $fRkSY = parcelRequire("fRkSY");
const $133994367adca510$var$CROSS_FLOW_TAG = 'crossFlow';
var $133994367adca510$export$2e2bcd8739ae039 = (event, logger)=>{
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, name: name } = event.payload;
    let sources = (0, $cmjWy.getSources)(event);
    const lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(sources);
    const source = event.payload.source ?? lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = {
        // To get extra attributes from AnalyticsContext from other products/platforms, e.g. Jira-frontend
        ...(0, $cmjWy.getExtraAttributes)(event),
        // To inherit the extra attributes from the navigation (Atlassian Switcher) context into the crossFlow events,
        // because the events current crossFlow touchpionts already inherit these attributes in the payload.
        ...(0, $fRkSY.getExtraAttributes)(event, (0, $1oYFx.NAVIGATION_CONTEXT)),
        ...event.payload.attributes,
        namespaces: sources.join('.')
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($133994367adca510$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("kARvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bce08cf99fe0dac$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eb35i = parcelRequire("eb35i");

var $k7eoe = parcelRequire("k7eoe");

var $hPf3V = parcelRequire("hPf3V");
function $2bce08cf99fe0dac$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPf3V.default), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).linkingPlatform,
        processEvent: (0, $eb35i.default)
    });
}

});
parcelRegister("eb35i", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f46c414ec40580e$export$2e2bcd8739ae039);

var $5XKHf = parcelRequire("5XKHf");

var $ewFdA = parcelRequire("ewFdA");

var $7TH2w = parcelRequire("7TH2w");
parcelRequire("ffCOo");
var $kwKGS = parcelRequire("kwKGS");

var $fRkSY = parcelRequire("fRkSY");

var $k7eoe = parcelRequire("k7eoe");
const $5f46c414ec40580e$var$listenerVersion = "0.0.0-use.local";
var $5f46c414ec40580e$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $fRkSY.getSources)(event, (0, $kwKGS.LINKING_PLATFORM_CONTEXT));
    const packages = (0, $fRkSY.getPackageInfo)(event, (0, $kwKGS.LINKING_PLATFORM_CONTEXT));
    const components = (0, $fRkSY.getComponents)(event, (0, $kwKGS.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, $fRkSY.getExtraAttributes)(event, (0, $kwKGS.LINKING_PLATFORM_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $k7eoe.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $5f46c414ec40580e$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(extraAttributes, event.payload.attributes)
        },
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(sources) || (0, $7TH2w.DEFAULT_SOURCE),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});


parcelRegister("7ETsB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d14160c3893b0733$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k7eoe = parcelRequire("k7eoe");

var $hIr96 = parcelRequire("hIr96");

var $hPf3V = parcelRequire("hPf3V");
function $d14160c3893b0733$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPf3V.default), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).postOffice,
        processEvent: (0, $hIr96.default)
    });
}

});
parcelRegister("hIr96", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9762b64767a874c$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $5XKHf = parcelRequire("5XKHf");

var $ewFdA = parcelRequire("ewFdA");

var $7TH2w = parcelRequire("7TH2w");
parcelRequire("ffCOo");
var $26stD = parcelRequire("26stD");

var $fRkSY = parcelRequire("fRkSY");

var $k7eoe = parcelRequire("k7eoe");
const $e9762b64767a874c$var$POST_OFFICE_TAG = (0, $k7eoe.FabricChannel).postOffice;
const $e9762b64767a874c$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $e9762b64767a874c$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fRkSY.getSources)(event, (0, $26stD.POST_OFFICE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $fRkSY.getExtraAttributes)(event, (0, $26stD.POST_OFFICE_CONTEXT));
    const components = (0, $fRkSY.getComponents)(event, (0, $26stD.POST_OFFICE_CONTEXT));
    const packages = (0, $fRkSY.getPackageInfo)(event, (0, $26stD.POST_OFFICE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))((0, $fRkSY.getPackageInfo)(event, (0, $26stD.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $e9762b64767a874c$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($e9762b64767a874c$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("c3sKJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $99eee8d37ca1b185$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k7eoe = parcelRequire("k7eoe");

var $joyGU = parcelRequire("joyGU");

var $hPf3V = parcelRequire("hPf3V");
function $99eee8d37ca1b185$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPf3V.default), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).aiMate,
        processEvent: (0, $joyGU.default)
    });
}

});
parcelRegister("joyGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d1e264d0be06509$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $5XKHf = parcelRequire("5XKHf");

var $ewFdA = parcelRequire("ewFdA");

var $7TH2w = parcelRequire("7TH2w");
parcelRequire("ffCOo");
var $2jQZn = parcelRequire("2jQZn");

var $fRkSY = parcelRequire("fRkSY");
const $7d1e264d0be06509$var$AI_MATE_TAG = 'aiMate';
const $7d1e264d0be06509$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $7d1e264d0be06509$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fRkSY.getSources)(event, (0, $2jQZn.AI_MATE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $fRkSY.getExtraAttributes)(event, (0, $2jQZn.AI_MATE_CONTEXT));
    const components = (0, $fRkSY.getComponents)(event, (0, $2jQZn.AI_MATE_CONTEXT));
    const packages = (0, $fRkSY.getPackageInfo)(event, (0, $2jQZn.AI_MATE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))((0, $fRkSY.getPackageInfo)(event, (0, $2jQZn.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $7d1e264d0be06509$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($7d1e264d0be06509$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("5cQbO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3b70804c56098a4$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k7eoe = parcelRequire("k7eoe");

var $dJnqJ = parcelRequire("dJnqJ");

var $hPf3V = parcelRequire("hPf3V");
function $b3b70804c56098a4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPf3V.default), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).avp,
        processEvent: (0, $dJnqJ.default)
    });
}

});
parcelRegister("dJnqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $52f6da4fdcbb05f5$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $5XKHf = parcelRequire("5XKHf");

var $ewFdA = parcelRequire("ewFdA");

var $7TH2w = parcelRequire("7TH2w");
parcelRequire("ffCOo");
var $aVIsj = parcelRequire("aVIsj");

var $fRkSY = parcelRequire("fRkSY");
const $52f6da4fdcbb05f5$var$AVP_TAG = 'avp';
const $52f6da4fdcbb05f5$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $52f6da4fdcbb05f5$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fRkSY.getSources)(event, (0, $aVIsj.AVP_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $fRkSY.getExtraAttributes)(event, (0, $aVIsj.AVP_CONTEXT));
    const components = (0, $fRkSY.getComponents)(event, (0, $aVIsj.AVP_CONTEXT));
    const packages = (0, $fRkSY.getPackageInfo)(event, (0, $aVIsj.AVP_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))((0, $fRkSY.getPackageInfo)(event, (0, $aVIsj.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $52f6da4fdcbb05f5$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(extraAttributes, payloadAttributes),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))({}, ...event.context)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($52f6da4fdcbb05f5$var$AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("5ArSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ce442b4c3e5345$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k7eoe = parcelRequire("k7eoe");

var $fY5QZ = parcelRequire("fY5QZ");

var $hPf3V = parcelRequire("hPf3V");
function $b0ce442b4c3e5345$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPf3V.default), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).growth,
        processEvent: (0, $fY5QZ.default)
    });
}

});
parcelRegister("fY5QZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b335e7076eadb138$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $5XKHf = parcelRequire("5XKHf");

var $ewFdA = parcelRequire("ewFdA");

var $7TH2w = parcelRequire("7TH2w");
parcelRequire("ffCOo");
var $hcByP = parcelRequire("hcByP");

var $fRkSY = parcelRequire("fRkSY");
const $b335e7076eadb138$var$GROWTH_TAG = 'growth';
const $b335e7076eadb138$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $b335e7076eadb138$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fRkSY.getSources)(event, (0, $hcByP.GROWTH_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $fRkSY.getExtraAttributes)(event, (0, $hcByP.GROWTH_CONTEXT));
    const components = (0, $fRkSY.getComponents)(event, (0, $hcByP.GROWTH_CONTEXT));
    const packages = (0, $fRkSY.getPackageInfo)(event, (0, $hcByP.GROWTH_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))((0, $fRkSY.getPackageInfo)(event, (0, $hcByP.GROWTH_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $b335e7076eadb138$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($b335e7076eadb138$var$GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});




parcelRegister("cryCi", function(module, exports) {

$parcel$export(module.exports, "Context", () => $441587f534f59cf5$export$841858b892ce1f4c);
$parcel$export(module.exports, "Consumer", () => $441587f534f59cf5$export$b3bffd4bb7da6b8f);
$parcel$export(module.exports, "Provider", () => $441587f534f59cf5$export$2a2b82ec45ab1f55);

var $gwFzn = parcelRequire("gwFzn");

var $hdKuZ = parcelRequire("hdKuZ");
const $441587f534f59cf5$export$841858b892ce1f4c = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const { Consumer: $441587f534f59cf5$export$b3bffd4bb7da6b8f, Provider: $441587f534f59cf5$var$Provider } = $441587f534f59cf5$export$841858b892ce1f4c;
const $441587f534f59cf5$export$2a2b82ec45ab1f55 = ({ children: children })=>{
    const choreographerFactoryAssets = (0, $hdKuZ.useChoreographerServices)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($441587f534f59cf5$var$Provider, {
        value: choreographerFactoryAssets
    }, children);
};

});
parcelRegister("hdKuZ", function(module, exports) {

$parcel$export(module.exports, "useChoreographerServices", () => $9ce9b7b31c3598e6$export$fd6146171fa6f88f);

var $gwFzn = parcelRequire("gwFzn");

var $6auOX = parcelRequire("6auOX");
var $fw9LG = parcelRequire("fw9LG");

var $jdlXH = parcelRequire("jdlXH");

var $jOtRZ = parcelRequire("jOtRZ");
let $9ce9b7b31c3598e6$var$choreographerServices;
const $9ce9b7b31c3598e6$var$ajsEnvironment = (0, $jdlXH.getMeta)('ajs-environment');
if (globalThis.window, $9ce9b7b31c3598e6$var$ajsEnvironment) {
    const environment = (0, $jOtRZ.determineAnalyticsEnvironment)($9ce9b7b31c3598e6$var$ajsEnvironment);
    $9ce9b7b31c3598e6$var$choreographerServices = (0, $6auOX.choreographerFactory)((0, $fw9LG.ProductIds).CONFLUENCE, environment);
}
const $9ce9b7b31c3598e6$export$fd6146171fa6f88f = ()=>{
    const analyticsEnv = (0, $jOtRZ.useAnalyticsEnvironment)();
    const choreographerServiceInstance = (0, $gwFzn.useMemo)(()=>{
        if (!$9ce9b7b31c3598e6$var$choreographerServices && analyticsEnv) $9ce9b7b31c3598e6$var$choreographerServices = (0, $6auOX.choreographerFactory)((0, $fw9LG.ProductIds).CONFLUENCE, analyticsEnv);
        // Return module level choreographer services
        return $9ce9b7b31c3598e6$var$choreographerServices;
    }, [
        analyticsEnv
    ]);
    const { plugin: plugin } = choreographerServiceInstance ?? {};
    (0, $gwFzn.useEffect)(()=>{
        /**
		 * Cleanup function in case we unmount this component to remount another one.
		 */ return ()=>{
            if (plugin) plugin.destroy();
        };
    }, [
        plugin
    ]);
    return choreographerServiceInstance;
};

});
parcelRegister("jdlXH", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $af74349712b9bfd2$export$c47913ca32a5c6f7);
const $af74349712b9bfd2$export$c47913ca32a5c6f7 = (name)=>{
    if (typeof globalThis.document !== 'undefined') {
        const node = document.querySelector(`meta[name="${name}"]`);
        const metaValue = node?.getAttribute('content');
        return metaValue ?? null;
    }
    return null;
};

});

parcelRegister("jOtRZ", function(module, exports) {

$parcel$export(module.exports, "determineAnalyticsEnvironment", () => $b1c92c0a0cfda130$export$3dc2b705cb95c13f);
$parcel$export(module.exports, "useAnalyticsEnvironment", () => $b1c92c0a0cfda130$export$6f29e1e316768b98);

var $9neYa = parcelRequire("9neYa");

var $bQm3c = parcelRequire("bQm3c");
const $b1c92c0a0cfda130$export$3dc2b705cb95c13f = (environment)=>{
    let analyticsEnvironment;
    switch(environment){
        case 'PRODUCTION':
        case 'prod':
            analyticsEnvironment = (0, $9neYa.envType).PROD;
            break;
        case 'STAGING':
        case 'staging':
            analyticsEnvironment = (0, $9neYa.envType).STAGING;
            break;
        default:
            analyticsEnvironment = (0, $9neYa.envType).DEV;
    }
    return analyticsEnvironment;
};
const $b1c92c0a0cfda130$export$6f29e1e316768b98 = (rawEnvironment)=>{
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    return $b1c92c0a0cfda130$export$3dc2b705cb95c13f(rawEnvironment ?? environment);
};

});
parcelRegister("9neYa", function(module, exports) {

$parcel$export(module.exports, "envType", () => $f2665f9f833e3f35$export$56ac8ebc9870b1b9);
var $f2665f9f833e3f35$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});

});




parcelRegister("jHo7b", function(module, exports) {

$parcel$export(module.exports, "defaultEditLoadingValues", () => $859242c82edf918e$export$ed7a4d2a58750e5a);
$parcel$export(module.exports, "EditPageLoadingContextProvider", () => $859242c82edf918e$export$dc5be4ae949c7899);
$parcel$export(module.exports, "useEditPageLoadingValues", () => $859242c82edf918e$export$9db478d7cbc3a0ec);
$parcel$export(module.exports, "useEditPageLoadingActions", () => $859242c82edf918e$export$61b834689819c7d3);

var $gwFzn = parcelRequire("gwFzn");

var $bmBgY = parcelRequire("bmBgY");
const $859242c82edf918e$export$ed7a4d2a58750e5a = {
    contentId: '',
    spaceKey: undefined,
    redirectUrl: null,
    contentType: null,
    isFabricSupported: true,
    isEmbeddedContent: false,
    referredFromLivePage: undefined
};
const $859242c82edf918e$export$dab6678a6d0a2033 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    ...$859242c82edf918e$export$ed7a4d2a58750e5a
});
const $859242c82edf918e$export$8f14bd77387a9a80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    loadEditor: ()=>{},
    nativeEditorComponentsPreloader: ()=>Promise.resolve(),
    livePageComponentsPreloader: ()=>Promise.resolve()
});
function $859242c82edf918e$export$dc5be4ae949c7899({ nativeEditorComponentsPreloader: nativeEditorComponentsPreloader, livePageComponentsPreloader: livePageComponentsPreloader, children: children }) {
    const [editLoadingValues, setEditLoadingValues] = (0, $gwFzn.useState)($859242c82edf918e$export$ed7a4d2a58750e5a);
    const nativeEditorPreloaderRef = (0, $gwFzn.useRef)(()=>Promise.resolve());
    nativeEditorPreloaderRef.current = nativeEditorComponentsPreloader;
    const stableNativeEditorComponentsPreloader = (0, $gwFzn.useCallback)(()=>nativeEditorPreloaderRef.current?.(), []);
    const livePagePreloaderRef = (0, $gwFzn.useRef)(()=>Promise.resolve());
    livePagePreloaderRef.current = livePageComponentsPreloader ?? (()=>Promise.resolve());
    const stableLivePageComponentsPreloader = (0, $gwFzn.useCallback)(()=>livePagePreloaderRef.current?.(), []);
    const actionsContextValue = (0, $gwFzn.useMemo)(()=>({
            loadEditor: (newValues)=>{
                if (newValues.contentId) // There's a special case for loadEditor call with default values and empty contentId.
                // It cleans up loading state before navigating to editor, and IS NOT indicating the
                // start of editor loading. So we should not start editor loading measurement in this
                // case, as it is already started.
                (0, $bmBgY.startPageLoadForEditor)({
                    isBlogpost: newValues.contentType === 'blogpost',
                    isFabricSupported: Boolean(newValues.isFabricSupported),
                    isEmbeddedContent: Boolean(newValues.isEmbeddedContent)
                }, // NOTE: passing transitionId for editor loading measurement doesn't warrant
                // the complexity of managing it in this context. It's barely used for performance
                // measurements but, being tied to Route context may force a lot of unnecessary
                // re-renders. If this is needed in future, we can revisit this decision.
                null, newValues.contentId);
                return setEditLoadingValues((oldState)=>({
                        ...oldState,
                        ...newValues
                    }));
            },
            nativeEditorComponentsPreloader: stableNativeEditorComponentsPreloader,
            livePageComponentsPreloader: stableLivePageComponentsPreloader
        }), [
        setEditLoadingValues,
        stableNativeEditorComponentsPreloader,
        stableLivePageComponentsPreloader
    ]);
    const contextValue = (0, $gwFzn.useMemo)(()=>({
            ...editLoadingValues
        }), [
        editLoadingValues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($859242c82edf918e$export$dab6678a6d0a2033.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($859242c82edf918e$export$8f14bd77387a9a80.Provider, {
        value: actionsContextValue
    }, children));
}
const $859242c82edf918e$export$9db478d7cbc3a0ec = ()=>{
    return (0, $gwFzn.useContext)($859242c82edf918e$export$dab6678a6d0a2033);
};
const $859242c82edf918e$export$61b834689819c7d3 = ()=>{
    return (0, $gwFzn.useContext)($859242c82edf918e$export$8f14bd77387a9a80);
};

});
parcelRegister("bmBgY", function(module, exports) {

$parcel$export(module.exports, "startPageLoadForEditor", () => $22d263012b74da52$export$e822f0a47cab2f33);

var $jfrcs = parcelRequire("jfrcs");

var $iFjdQ = parcelRequire("iFjdQ");

var $1NBp8 = parcelRequire("1NBp8");
const $22d263012b74da52$var$getRouteType = ({ isBlogpost: isBlogpost, isFabricSupported: isFabricSupported, isEmbeddedContent: isEmbeddedContent })=>{
    // Currently a temporary check for blogs is added here until Embedded Pages supports blogs.
    if (isEmbeddedContent && !isBlogpost) return 0, $1NBp8.EDIT_PAGE_EMBED;
    if (isFabricSupported) return isBlogpost ? (0, $1NBp8.EDIT_BLOG_V2) : (0, $1NBp8.EDIT_PAGE_V2);
    else return isBlogpost ? (0, $1NBp8.EDIT_BLOG) : (0, $1NBp8.EDIT_PAGE);
};
const $22d263012b74da52$export$e822f0a47cab2f33 = (routeDetails, transitionId, contentId)=>{
    const routeType = $22d263012b74da52$var$getRouteType(routeDetails);
    // Need to clear measures every time we start measuring. Otherwise initial measurements
    // will keep being used for all entry points.
    (0, $iFjdQ.ExperienceActionMeasures).clearMeasures();
    if (routeType.name) // transitionId cant be 0 since 0 is only for initial page load.
    (0, $jfrcs.startBrowserMetricsPageLoad)(routeType.name, routeType.ufoName, (transitionId || 0) + 1, contentId);
};

});
parcelRegister("jfrcs", function(module, exports) {

$parcel$export(module.exports, "startBrowserMetricsPageLoad", () => $a2ef04dcd02665b5$export$4b2f5043c46174c);

var $054Kg = parcelRequire("054Kg");

var $6eGYE = parcelRequire("6eGYE");

var $3kTfj = parcelRequire("3kTfj");

var $9eE57 = parcelRequire("9eE57");
parcelRequire("7sK8i");
var $dgXJ7 = parcelRequire("dgXJ7");

var $hZpML = parcelRequire("hZpML");

var $6VdZc = parcelRequire("6VdZc");

var $gpK3n = parcelRequire("gpK3n");

var $doccd = parcelRequire("doccd");
const $a2ef04dcd02665b5$export$4b2f5043c46174c = (routeName = '', ufoName = routeName, transitionId, contentId = '')=>{
    // Begin the loading timer _immediately_ using BM libraries generic meta startPageLoad metric.
    // Routes should later call stopPageLoad on the actual PageLoadMetric that is specifically defined for
    // the route in order to claim this page load.
    (0, $3kTfj.browserMetrics).startPageLoad({
        isInitial: transitionId === 0
    });
    if (transitionId === 0) (0, $054Kg.default)(ufoName.toLocaleLowerCase());
    else (0, $6eGYE.default)(ufoName.toLocaleLowerCase());
    performance.mark('browser-metric.start');
    const pageLoadMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    (0, $6VdZc.browserMetricsState).transitionId = transitionId;
    (0, $6VdZc.browserMetricsState).pageLoadStartTimestamp = pageLoadMetric.getData().start ?? performance.now();
    (0, $6VdZc.browserMetricsState).previousRoute = (0, $6VdZc.browserMetricsState).routeName;
    (0, $6VdZc.browserMetricsState).routeName = routeName;
    (0, $3kTfj.browserMetrics).setRoute(routeName);
    (0, $6VdZc.browserMetricsState).previousContentId = (0, $6VdZc.browserMetricsState).contentId;
    (0, $6VdZc.browserMetricsState).contentId = contentId;
    // will pause low priority events to avoid impacting page load performance
    // once the pageLoadEnd is triggered the resumeLowPriorityEvents will be called
    (0, $dgXJ7.pauseLowPriorityEvents)(routeName);
    if (pageLoadMetric.isInitialLoad() && window?.__SSR_RENDERED__) // Mark the legacy FMP point if server-side rendered
    pageLoadMetric.mark('fy21-legacy-fmp', (0, $9eE57.getMark)('CFP-63.ssr-ttr'));
    pageLoadMetric.onStop(()=>{
        if (pageLoadMetric.isInitialLoad()) {
            const t = window.performance?.getEntriesByType?.('navigation')?.[0];
            if (t) {
                // Redirection time
                if (t.redirectStart >= 0 && t.redirectEnd >= t.redirectStart) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).REDIRECTION, t.redirectStart);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).REDIRECTION, t.redirectEnd);
                }
                // DNS resolution
                if (t.domainLookupStart >= 0 && t.domainLookupEnd >= t.domainLookupStart) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).DNS, t.domainLookupStart);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).DNS, t.domainLookupEnd);
                }
                // TCP connection
                if (t.connectStart >= 0 && t.connectEnd >= t.connectStart) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).TCP, t.connectStart);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).TCP, t.connectEnd);
                }
                // TLS handshake
                if (t.secureConnectionStart >= 0 && t.connectEnd >= 0) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).TLS, t.secureConnectionStart);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).TLS, t.connectEnd);
                }
                // Response
                if (t.requestStart >= 0 && t.responseStart >= t.requestStart) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).RESPONSE, t.requestStart);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).RESPONSE, t.responseStart);
                }
                // TTFB
                if (t.startTime >= 0 && t.responseStart >= 0) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).TTFB, t.startTime);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).TTFB, t.responseStart);
                }
                // SSR complete
                if (t.requestStart >= 0 && t.responseEnd >= t.requestStart) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).FULL_HTML, t.requestStart);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).FULL_HTML, t.responseEnd);
                }
            }
        }
        // Copy all /wf markers to the page load metric
        // - window.performance.mark('wf/something.start/.end')
        // - WaterfallMetrics.run()
        // - WaterfallMetrics.markMeasureStart/markMeasureEnd()
        const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
        (0, $gpK3n.getPerformanceEntries)('wf/').forEach(({ name: name, startTime: startTime })=>{
            currentMetric.mark(name, startTime);
        });
        // NOTE: currentMetric is stopping _too early_ and some segment-end marks are added _after_ the metric is already stopped
        // To see this, console.log the following and compare the outputs:
        // console.log({ ...currentMetric.getData().marks }); // the marks available at the time of the object spread
        // console.log(currentMetric.getData().marks); // the marks available when browser can log to the console
        // what is logged at the bottom console.log is the contents of the memory reference of (currentMetric.getData().marks, which seems to be getting modified at a later point in time.
        (0, $doccd.addAllBM3TimingsToUFO)(currentMetric.getData().marks);
    }, ()=>{});
};

});
parcelRegister("6eGYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa51124acf13a996$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $9HkI0 = parcelRequire("9HkI0");

var $1haRI = parcelRequire("1haRI");

var $53d5Q = parcelRequire("53d5Q");

var $lMdlY = parcelRequire("lMdlY");

var $feexy = parcelRequire("feexy");

var $4u5NT = parcelRequire("4u5NT");

var $ic4nn = parcelRequire("ic4nn");

var $kNusD = parcelRequire("kNusD");
function $aa51124acf13a996$var$traceUFOTransition(ufoName, routeName = ufoName) {
    const pressInteractionsList = (0, $53d5Q.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $4u5NT.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $ic4nn.default).current = ufoName;
        const rate = (0, $53d5Q.getInteractionRate)(ufoName, 'transition');
        if ((0, $1haRI.default)(rate)) {
            const newId = (0, $9HkI0.v4)();
            (0, $kNusD.setInteractionActiveTrace)(newId);
            (0, $feexy.DefaultInteractionID).current = newId;
            (0, $4u5NT.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $lMdlY.getActiveTrace)());
        }
    }
}
function $aa51124acf13a996$export$369f0ded13ce6c50() {
    const interactionId = (0, $gwFzn.useContext)((0, $feexy.default));
    const capturedInteractionId = interactionId.current;
    (0, $gwFzn.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $4u5NT.tryComplete)(capturedInteractionId);
                });
            });
            (0, $4u5NT.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
var $aa51124acf13a996$export$2e2bcd8739ae039 = $aa51124acf13a996$var$traceUFOTransition;

});
parcelRegister("kNusD", function(module, exports) {

$parcel$export(module.exports, "setInteractionActiveTrace", () => $e39721b2151f3953$export$f2e521e495a88544);

var $lMdlY = parcelRequire("lMdlY");

var $k7Y6l = parcelRequire("k7Y6l");
function $e39721b2151f3953$export$f2e521e495a88544(newId) {
    (0, $lMdlY.setActiveTrace)(newId.replace(/-/g, ''), (0, $k7Y6l.generateSpanId)(), 'transition');
}

});
parcelRegister("k7Y6l", function(module, exports) {

$parcel$export(module.exports, "generateSpanId", () => $4c0de59d7e455996$export$295213bc4d0c54ad);
function $4c0de59d7e455996$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});



parcelRegister("7sK8i", function(module, exports) {

$parcel$export(module.exports, "pauseLowPriorityEvents", () => (parcelRequire("dgXJ7")).pauseLowPriorityEvents);
$parcel$export(module.exports, "resumeLowPriorityEvents", () => (parcelRequire("dgXJ7")).resumeLowPriorityEvents);

var $dgXJ7 = parcelRequire("dgXJ7");

});
parcelRegister("dgXJ7", function(module, exports) {

$parcel$export(module.exports, "pauseLowPriorityEvents", () => $9db38887cf5a61fb$export$79d5d0605aceeccc);
$parcel$export(module.exports, "resumeLowPriorityEvents", () => $9db38887cf5a61fb$export$f627161e107278c0);

var $ge2sX = parcelRequire("ge2sX");

var $04e9M = parcelRequire("04e9M");
const $9db38887cf5a61fb$var$STOP_DELAY_TIMEOUT = 11000;
let $9db38887cf5a61fb$var$lastDelayActionPromise = (0, $04e9M.getAnalyticsWebClient)();
let $9db38887cf5a61fb$var$isAutomaticExposuresEnabled = false;
const $9db38887cf5a61fb$export$79d5d0605aceeccc = async (routeName)=>{
    if (routeName !== 'VIEW_PAGE') return $9db38887cf5a61fb$var$lastDelayActionPromise;
    const { featureFlagClient: featureFlagClient } = await (0, $ge2sX.getSessionData)();
    // By using chained promises we can ensure that the order of pause and resume calls are kept
    $9db38887cf5a61fb$var$lastDelayActionPromise = $9db38887cf5a61fb$var$lastDelayActionPromise.then((analyticsClient)=>{
        // If pauseLowPriorityEvents is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!$9db38887cf5a61fb$var$isAutomaticExposuresEnabled) {
            featureFlagClient.setIsAutomaticExposuresEnabled(true);
            $9db38887cf5a61fb$var$isAutomaticExposuresEnabled = true;
        }
        analyticsClient.startLowPriorityEventDelay($9db38887cf5a61fb$var$STOP_DELAY_TIMEOUT, $9db38887cf5a61fb$var$stopLowPriorityEventDelayCallback);
        return analyticsClient;
    });
    // return only for test usage
    return $9db38887cf5a61fb$var$lastDelayActionPromise;
};
const $9db38887cf5a61fb$export$f627161e107278c0 = ()=>{
    $9db38887cf5a61fb$var$lastDelayActionPromise = $9db38887cf5a61fb$var$lastDelayActionPromise.then((analyticsClient)=>{
        analyticsClient.stopLowPriorityEventDelay();
        return analyticsClient;
    });
    // return only for test usage
    return $9db38887cf5a61fb$var$lastDelayActionPromise;
};
// this callback will always be called from the analytics web client
const $9db38887cf5a61fb$var$stopLowPriorityEventDelayCallback = async ()=>{
    const { featureFlagClient: featureFlagClient } = await (0, $ge2sX.getSessionData)();
    featureFlagClient.setIsAutomaticExposuresEnabled(false);
    $9db38887cf5a61fb$var$isAutomaticExposuresEnabled = true;
};

});


parcelRegister("doccd", function(module, exports) {

$parcel$export(module.exports, "addAllBM3TimingsToUFO", () => $606dbc3d0ca2130d$export$812904046c66e1a3);

var $feexy = parcelRequire("feexy");

var $4u5NT = parcelRequire("4u5NT");
function $606dbc3d0ca2130d$export$812904046c66e1a3(marks) {
    const interactionId = (0, $feexy.getInteractionId)().current;
    if (!interactionId) return;
    const interactionType = (0, $4u5NT.getCurrentInteractionType)(interactionId);
    if (interactionType === 'press') return;
    const bm3Timings = {};
    Object.keys(marks).forEach((mark)=>{
        if (mark.startsWith('segment-start')) {
            const segmentName = mark.split(':')[1];
            const key = `wf/react/${segmentName}`;
            const endMark = `segment-end:${segmentName}`;
            const startTime = marks[mark];
            const endTime = marks[endMark];
            if (typeof startTime === 'number' && typeof endTime === 'number') bm3Timings[key] = {
                startTime: startTime,
                endTime: endTime
            };
        }
        if (mark.startsWith('wf') && mark.endsWith('.start')) {
            const key = mark.split('.start')[0];
            const startTime = marks[mark];
            const endMark = `${key}.end`;
            const endTime = marks[endMark];
            if (typeof startTime === 'number' && typeof endTime === 'number') bm3Timings[key] = {
                startTime: startTime,
                endTime: endTime
            };
        }
    });
    (0, $4u5NT.addCustomTiming)(interactionId, [], bm3Timings);
}

});


parcelRegister("iFjdQ", function(module, exports) {

$parcel$export(module.exports, "ExperienceActionMeasures", () => $35e12b3261878eea$export$85aba550a2da4b89);

var $kGrzq = parcelRequire("kGrzq");
const $35e12b3261878eea$export$85aba550a2da4b89 = new (0, $kGrzq.BaseMeasures)();

});



parcelRegister("gz8ZY", function(module, exports) {

$parcel$export(module.exports, "useIsNav4Enabled", () => $90a9f787a509158d$export$22793b194a2253b9);

var $9wGTI = parcelRequire("9wGTI");

var $6mKj3 = parcelRequire("6mKj3");

var $9hcBu = parcelRequire("9hcBu");

var $deyhs = parcelRequire("deyhs");

var $dKIZZ = parcelRequire("dKIZZ");
const $90a9f787a509158d$export$22793b194a2253b9 = ()=>{
    const currentGAPhase = (0, $deyhs.getNav4GAPhase)();
    const { nav4AdminOptedIn: nav4AdminOptedIn } = (0, $dKIZZ.useGetNav4OptIn)();
    const { nav4OptOut: nav4OptOut } = (0, $9hcBu.useNav4OptOut)();
    if (currentGAPhase === 2) return true;
    if (nav4OptOut) return false;
    return (0, $9wGTI.fg)('confluence_nav_4') || (0, $6mKj3.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false) || (0, $6mKj3.expVal)('confluence_nav_4_free', 'isEnabled', false) || // nav4OptOut === false means the user has explicitly opted in for themselves
    currentGAPhase === 1 && (nav4AdminOptedIn || nav4OptOut === false);
};

});
parcelRegister("dKIZZ", function(module, exports) {

$parcel$export(module.exports, "useGetNav4OptIn", () => $5926d1d206c7b1bd$export$a638e53225283f3c);

var $xQxzY = parcelRequire("xQxzY");

var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $iuIEr = parcelRequire("iuIEr");
const $5926d1d206c7b1bd$export$a638e53225283f3c = ()=>{
    const { loading: loading, data: data } = (0, $xQxzY.useQuery)((0, $d2LG0.default)`query useGetNav4OptInQuery{siteSettings{isNav4OptedIn}}`, {
        skip: !(0, $9wGTI.fg)('confluence_nav4_ga_phase_1')
    });
    const updateNav4AdminOptIn = (0, $gwFzn.useCallback)(async (isNav4OptedIn)=>{
        (0, $iuIEr.updateNav4AdminOptInCache)(isNav4OptedIn);
    }, []);
    const optInCache = $5926d1d206c7b1bd$var$parseCacheValue((0, $e9zUf.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).NAV4_ADMIN_OPT_IN_CACHE));
    const optInServer = Boolean(data?.siteSettings?.isNav4OptedIn);
    const nav4AdminOptedIn = (0, $9wGTI.fg)('confluence_nav4_ga_phase_1') && (loading ? optInCache : optInServer);
    (0, $gwFzn.useEffect)(()=>{
        if (!loading && optInServer !== optInCache) (0, $iuIEr.updateNav4AdminOptInCache)(optInServer);
    }, [
        loading,
        optInCache,
        optInServer
    ]);
    return {
        nav4AdminOptedIn: nav4AdminOptedIn,
        updateNav4AdminOptIn: updateNav4AdminOptIn
    };
};
const $5926d1d206c7b1bd$var$parseCacheValue = (cacheValue)=>{
    if (cacheValue === 'true') return true;
    else if (cacheValue === 'false') return false;
    else return undefined;
};

});


parcelRegister("dEBDF", function(module, exports) {
$parcel$export(module.exports, "END", () => (parcelRequire("iu6oZ")).END);
$parcel$export(module.exports, "START", () => (parcelRequire("iu6oZ")).START);
$parcel$export(module.exports, "START_TOUCH", () => (parcelRequire("iu6oZ")).START_TOUCH);
$parcel$export(module.exports, "TOUCH", () => (parcelRequire("iu6oZ")).TOUCH);

$parcel$export(module.exports, "NavdexListener", () => (parcelRequire("7Gyt2")).NavdexListener);

var $7Gyt2 = parcelRequire("7Gyt2");
parcelRequire("iu6oZ");

});
parcelRegister("7Gyt2", function(module, exports) {

$parcel$export(module.exports, "NavdexListener", () => $b052390ea3c4f36a$export$13953a62d51faabe);

var $gwFzn = parcelRequire("gwFzn");

var $kyKWe = parcelRequire("kyKWe");

var $kDuN4 = parcelRequire("kDuN4");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $cMrrO = parcelRequire("cMrrO");

var $iu6oZ = parcelRequire("iu6oZ");
const $b052390ea3c4f36a$var$SESSION_EXPIRE_MILLIS = 600000;
const $b052390ea3c4f36a$var$loadSession = ()=>{
    const sessionString = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).NAVDEX_STORAGE_KEY);
    if (!sessionString) return null;
    const session = JSON.parse(sessionString);
    session.updated = new Date(session.updated);
    return session;
};
const $b052390ea3c4f36a$export$13953a62d51faabe = ({ children: children })=>{
    const session = (0, $gwFzn.useRef)($b052390ea3c4f36a$var$loadSession());
    const setSession = (newSession)=>{
        session.current = newSession;
        if (!session.current) (0, $e9zUf.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).NAVDEX_STORAGE_KEY);
        else if (session.current.updateStorage) try {
            (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).NAVDEX_STORAGE_KEY, JSON.stringify(session.current));
        } catch (e) {
            (0, $e9zUf.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).NAVDEX_STORAGE_KEY);
        }
    };
    (0, $gwFzn.useEffect)(()=>{
        const storageListener = (event)=>{
            if (event.key === (0, $1UApO.keys).NAVDEX_STORAGE_KEY) {
                const newSession = $b052390ea3c4f36a$var$loadSession();
                if (newSession) touchSession(newSession.id, false);
                else setSession(null);
            }
        };
        window.addEventListener('storage', storageListener);
        return ()=>{
            window.removeEventListener('storage', storageListener);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const updateEvent = (event, navigationSessionId, pointTypeOverride)=>{
        if (event.payload.data) event.update((payload)=>({
                ...payload,
                data: {
                    ...payload.data,
                    attributes: {
                        ...payload.data.attributes,
                        navigationSessionId: navigationSessionId,
                        navdexPointType: pointTypeOverride || payload.data.attributes.navdexPointType
                    }
                }
            }));
        else // Atlaskit events lack the data object
        event.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    navigationSessionId: navigationSessionId,
                    navdexPointType: pointTypeOverride || payload.attributes.navdexPointType
                }
            }));
    };
    const touchSession = (sessionId, updateStorage = true)=>{
        setSession({
            id: sessionId,
            updated: new Date(),
            updateStorage: updateStorage
        });
    };
    const handleTouchPoint = (event)=>{
        const type = event?.payload?.data?.attributes?.navdexPointType || // Atlaskit events lack the data object
        event?.payload?.attributes?.navdexPointType;
        let sessionId = session.current && session.current.id;
        if (session.current && Date.now() - session.current.updated.getTime() > $b052390ea3c4f36a$var$SESSION_EXPIRE_MILLIS) {
            setSession(null);
            sessionId = null;
        }
        switch(type){
            case 0, $iu6oZ.START:
                const newSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
                updateEvent(event, newSessionId);
                touchSession(newSessionId);
                break;
            case 0, $iu6oZ.START_TOUCH:
                const actualPointType = sessionId ? (0, $iu6oZ.TOUCH) : (0, $iu6oZ.START);
                sessionId = sessionId || (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
                updateEvent(event, sessionId, actualPointType);
                touchSession(sessionId);
                break;
            case 0, $iu6oZ.TOUCH:
                if (sessionId) {
                    updateEvent(event, sessionId);
                    touchSession(sessionId);
                }
                break;
            case 0, $iu6oZ.END:
                if (sessionId) {
                    updateEvent(event, sessionId);
                    setSession(null);
                }
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kDuN4.default), {
        onEvent: handleTouchPoint,
        channel: "*"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cMrrO.AtlaskitShim), null, children));
};

});
parcelRegister("cMrrO", function(module, exports) {

$parcel$export(module.exports, "AtlaskitShim", () => $3610af1ecb1deabe$export$203e3ae7319f8133);

var $gwFzn = parcelRequire("gwFzn");

var $kDuN4 = parcelRequire("kDuN4");

var $iu6oZ = parcelRequire("iu6oZ");
const $3610af1ecb1deabe$var$atlaskitRegistry = {
    [(0, $iu6oZ.START_TOUCH)]: [
        {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'productLogo'
        },
        {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'recentIcon'
        },
        {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'quickSearch'
        },
        {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'notifications'
        },
        {
            action: 'clicked',
            actionSubject: 'smartLink'
        },
        {
            action: 'dismissed',
            actionSubject: 'drawer'
        },
        {
            action: 'selected',
            actionSubject: 'navigationItem',
            actionSubjectId: 'searchResult'
        },
        {
            action: 'selected',
            actionSubject: 'navigationItem',
            actionSubjectId: 'advanced_search_confluence'
        }
    ]
};
const $3610af1ecb1deabe$export$203e3ae7319f8133 = ({ children: children })=>{
    const onEvent = (event)=>{
        for(const type in $3610af1ecb1deabe$var$atlaskitRegistry)if ($3610af1ecb1deabe$var$atlaskitRegistry[type].some((entry)=>Object.keys(entry).every((key)=>entry[key] === event.payload[key]))) event.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    navdexPointType: type
                }
            }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kDuN4.default), {
        onEvent: onEvent,
        channel: "*"
    }, children);
};

});
parcelRegister("iu6oZ", function(module, exports) {

$parcel$export(module.exports, "START", () => $f3b5cc99c5d99322$export$21c466265830bc3a);
$parcel$export(module.exports, "START_TOUCH", () => $f3b5cc99c5d99322$export$2a8e400e9c788e93);
$parcel$export(module.exports, "TOUCH", () => $f3b5cc99c5d99322$export$d46bd3ead7cc759b);
$parcel$export(module.exports, "END", () => $f3b5cc99c5d99322$export$32239d68d9c6cb49);
const $f3b5cc99c5d99322$export$21c466265830bc3a = 'navigationSessionStart';
const $f3b5cc99c5d99322$export$2a8e400e9c788e93 = 'navigationSessionStartTouch';
const $f3b5cc99c5d99322$export$d46bd3ead7cc759b = 'navigationSessionTouch';
const $f3b5cc99c5d99322$export$32239d68d9c6cb49 = 'navigationSessionEnd';

});




parcelRegister("7QM6o", function(module, exports) {

$parcel$export(module.exports, "useSpaceId", () => $664c239122afca31$export$86d46ef78621f34c);

var $6uUjl = parcelRequire("6uUjl");
const $664c239122afca31$export$86d46ef78621f34c = (spaceKey)=>{
    const { spaceId: spaceId } = (0, $6uUjl.useSpaceIdentifiers)(spaceKey);
    return spaceId;
};

});
parcelRegister("6uUjl", function(module, exports) {

$parcel$export(module.exports, "useSpaceIdentifiers", () => $b3fa348c6c38e0de$export$a63a3cfa26b2bab3);

var $xQxzY = parcelRequire("xQxzY");

var $ep3mz = parcelRequire("ep3mz");

var $4rkMa = parcelRequire("4rkMa");
const $b3fa348c6c38e0de$export$a63a3cfa26b2bab3 = (spaceKey)=>{
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    // The given space key may be an alias, not the actual key.
    spaceKey = spaceKey ?? pageContextSpaceKey;
    const { data: data } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $4rkMa.SpaceIdentifiersQuery), {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey
    });
    return {
        spaceId: data?.space?.id || undefined,
        // The returned space key is the actual key, not an alias.
        spaceKey: data?.space?.key || undefined
    };
};

});
parcelRegister("4rkMa", function(module, exports) {

$parcel$export(module.exports, "SpaceIdentifiersQuery", () => $a35e2eb493cc5775$export$c47f6453dc84ce2f);

var $d2LG0 = parcelRequire("d2LG0");
const $a35e2eb493cc5775$export$c47f6453dc84ce2f = (0, $d2LG0.default)`query SpaceIdentifiersQuery($spaceKey:String){space(key:$spaceKey){id key}}`;

});



parcelRegister("ll2sR", function(module, exports) {

$parcel$export(module.exports, "getMessages", () => $a9459a94d201e75b$export$8c20ab16ac9cf14f);
$parcel$export(module.exports, "startMessage", () => $a9459a94d201e75b$export$7a77c9a7b182680b);
$parcel$export(module.exports, "stopMessage", () => $a9459a94d201e75b$export$159ff839f1f095d2);
$parcel$export(module.exports, "sendUserResponse", () => $a9459a94d201e75b$export$e1fd1449cf83c1f5);
$parcel$export(module.exports, "markAsSeenAndFatigued", () => $a9459a94d201e75b$export$3683393f780c6905);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths -- Preventing pre-commit error from being thrown when importing NO_CONTENT from controllers folder*/ 
var $bcK5f = parcelRequire("bcK5f");

var $jz1sO = parcelRequire("jz1sO");

var $7xlwT = parcelRequire("7xlwT");

var $aqVTl = parcelRequire("aqVTl");
const $a9459a94d201e75b$export$f4d1b02d312560f5 = '2';
const $a9459a94d201e75b$var$inProductMessagesUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($bcK5f))).parse('/engage-targeting/api/v2/user/{cloudId}/in-product-messages{?product,schema,locale}');
async function $a9459a94d201e75b$export$8c20ab16ac9cf14f(cloudId, stargateUrl, product, locale) {
    return (0, $aqVTl.stargateFetch)(`${stargateUrl}${$a9459a94d201e75b$var$inProductMessagesUrlTemplate.expand({
        cloudId: cloudId,
        product: product,
        schema: $a9459a94d201e75b$export$f4d1b02d312560f5,
        locale: locale
    })}`).then((0, $aqVTl.errorIfNotOk)).then((r)=>r.json().then((messages)=>({
                messages: messages,
                interval: Number.parseFloat(r.headers.get('POLL-INTERVAL') || '0')
            })));
}
function $a9459a94d201e75b$var$handleStartStopMessageResponse(response) {
    return response.status === (0, $7xlwT.NO_CONTENT);
}
const $a9459a94d201e75b$var$startMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($bcK5f))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start');
const $a9459a94d201e75b$var$startMessageWithVariationIdUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($bcK5f))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start/{variationId}');
const $a9459a94d201e75b$var$stopMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($bcK5f))).parse('/engage-targeting/api/v2/user/messages/{messageId}/stop');
var $a9459a94d201e75b$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
let $a9459a94d201e75b$var$choreographerPlugin;
async function $a9459a94d201e75b$export$7a77c9a7b182680b(startMessageConfig, options) {
    if (options?.enableChoreographer) return $a9459a94d201e75b$var$startMessageWithChoreographer(startMessageConfig, options);
    return $a9459a94d201e75b$var$startMessageWithCoordination(startMessageConfig);
}
async function $a9459a94d201e75b$export$159ff839f1f095d2(stopMessageConfig, options) {
    if (options?.enableChoreographer) return $a9459a94d201e75b$var$stopMessageWithChoreographer(stopMessageConfig, options);
    return $a9459a94d201e75b$var$stopMessageWithCoordination(stopMessageConfig);
}
async function $a9459a94d201e75b$var$startMessageWithChoreographer(startMessageConfig, options) {
    if (!$a9459a94d201e75b$var$choreographerPlugin) $a9459a94d201e75b$var$choreographerPlugin = new (0, $jz1sO.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $a9459a94d201e75b$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, ()=>$a9459a94d201e75b$var$startMessageWithCoordination(startMessageConfig, true), options.additionalData);
}
async function $a9459a94d201e75b$var$stopMessageWithChoreographer(stopMessageConfig, options) {
    if (!$a9459a94d201e75b$var$choreographerPlugin) $a9459a94d201e75b$var$choreographerPlugin = new (0, $jz1sO.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $a9459a94d201e75b$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, ()=>$a9459a94d201e75b$var$stopMessageWithCoordination(stopMessageConfig, true), options.additionalData);
}
async function $a9459a94d201e75b$var$startMessageWithCoordination(startMessageConfig, choreographerEnabled = false) {
    const requestBody = {
        cloudId: startMessageConfig.cloudId,
        orgId: startMessageConfig.orgId,
        workspaceId: startMessageConfig.workspaceId,
        choreographerEnabled: choreographerEnabled
    };
    return (0, $aqVTl.stargateFetch)(startMessageConfig.variationId ? `${startMessageConfig.stargateUrl}${$a9459a94d201e75b$var$startMessageWithVariationIdUrlTemplate.expand({
        messageId: startMessageConfig.messageId,
        variationId: startMessageConfig.variationId
    })}` : `${startMessageConfig.stargateUrl}${$a9459a94d201e75b$var$startMessageUrlTemplate.expand({
        messageId: startMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $aqVTl.pullResponseTextIfNotOk)).then($a9459a94d201e75b$var$handleStartStopMessageResponse);
}
async function $a9459a94d201e75b$var$stopMessageWithCoordination(stopMessageConfig, choreographerEnabled = false) {
    const requestBody = {
        cloudId: stopMessageConfig.cloudId,
        orgId: stopMessageConfig.orgId,
        workspaceId: stopMessageConfig.workspaceId,
        choreographerEnabled: choreographerEnabled
    };
    return (0, $aqVTl.stargateFetch)(`${stopMessageConfig.stargateUrl}${$a9459a94d201e75b$var$stopMessageUrlTemplate.expand({
        messageId: stopMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $aqVTl.pullResponseTextIfNotOk)).then($a9459a94d201e75b$var$handleStartStopMessageResponse);
}
const $a9459a94d201e75b$var$userResponseUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($bcK5f))).parse('/engage-targeting/api/v2/user/{cloudId}/messages/{messageId}/response');
async function $a9459a94d201e75b$export$e1fd1449cf83c1f5(cloudId, stargateUrl, messageId, payload) {
    return (0, $aqVTl.stargateFetch)(`${stargateUrl}${$a9459a94d201e75b$var$userResponseUrlTemplate.expand({
        cloudId: cloudId,
        messageId: messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $aqVTl.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
}
const $a9459a94d201e75b$var$markSeenAndFatigueUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($bcK5f))).parse('/engage-targeting/api/v2/user/messages/{messageId}/seen');
async function $a9459a94d201e75b$export$3683393f780c6905(seenMessageConfig) {
    const requestBody = {
        cloudId: seenMessageConfig.cloudId,
        orgId: seenMessageConfig.orgId,
        workspaceId: seenMessageConfig.workspaceId
    };
    return (0, $aqVTl.stargateFetch)(`${seenMessageConfig.stargateUrl}${$a9459a94d201e75b$var$markSeenAndFatigueUrlTemplate.expand({
        messageId: seenMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $aqVTl.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
}

});
parcelRegister("jz1sO", function(module, exports) {

$parcel$export(module.exports, "EngagekitChoreographerPlugin", () => $d6ce555f4a185bef$export$da23bd36e2d631b);

var $6empl = parcelRequire("6empl");

var $fw9LG = parcelRequire("fw9LG");

var $9gzc5 = parcelRequire("9gzc5");

var $B8oFf = parcelRequire("B8oFf");

var $9Oif4 = parcelRequire("9Oif4");
const $d6ce555f4a185bef$export$63ce1a41d951945d = 300000; // 5m timeout for duplicate request attempts
class $d6ce555f4a185bef$export$da23bd36e2d631b extends (0, $9Oif4.ChoreographerPlugin) {
    /**
   * Informs the Logger utility class to *NOT* log the provided event if it contains a blockedByProductId
   * attribute of the Engagekit product. EP is _super_ noisy when it comes to logging, and we get no value
   * out of the events it logs for its own message starts that are blocked, by any messages. The reason is
   * that EP tries to start all of its messages all of the time, and lets the gateway determine whether to
   * actually display the message. Roughly 99.9% of messages fail to start for reasons of prior exposure,
   * the user being in the holdout group, or any number of other reasons, so we're logging roughly 1000x what
   * we get any value out of. This filter will now prevent all of those extra, more useless logs, from being
   * actually fired off, and will keep just the log entries from which we can derive some actual value.
   *
   * @param event OperationalEventPayload
   * @returns boolean
   */ shouldLogEvent(event) {
        return event.actionSubject !== (0, $fw9LG.MessageAction).START || event.action !== (0, $fw9LG.MessageDeliveryStatus).BLOCKED;
    }
    isValidDuplicateStartRequest(messageId) {
        const currentMessage = (0, $6empl.Choreographer).getInstance().getCurrentMessage() ?? (0, $6empl.Choreographer).getInstance().getCurrentPendingMessage();
        return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < $d6ce555f4a185bef$export$63ce1a41d951945d);
    }
    async startMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $9gzc5.DebugLogger)(this.state.productId, messageId);
        const actionSubject = (0, $fw9LG.MessageAction).START;
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
        });
        /**
     * The Choreographer sets a 5m TTL for any message that opens, before forcefully closing it.
     * EP also allows a messageId to re-request its start if it hasn't yet been dismissed (this is a
     * feature of HISI. For this reason, we can mimic that functionality here (otherwise, Choreographer
     * will block the subsequest start request attempt altogether), by checking the Choreographer's
     * currentMessage against our productId/messageId combo here. If this *is* the currentMessage being
     * displayed, it means it hasn't been dismissed, and we let the request dispatch for EP to make the call.
     */ const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
        if (isValidDuplicateStartRequest) {
            const logger = new (0, $B8oFf.Logger)(actionSubject, messageId, {
                ...this.state.metaMetricsData,
                ...additionalData
            }, this.analyticsClient);
            const didStart = Boolean(await callback());
            if (didStart) {
                logger.started();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        plugin: this.constructor.name,
                        disposition: (0, $fw9LG.MessageDeliveryStatus).STARTED,
                        timestamp: performance.now()
                    }
                });
            }
            return didStart;
        }
        // Do a just-in-time message start subscription with our callback to stargate
        this.onStart(messageId, callback);
        /**
     * Dispatch the request to start the message, and return the response, which will
     * either be 'started' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.startMessage(messageId, additionalData);
        return result === (0, $fw9LG.MessageDeliveryStatus).STARTED;
    }
    async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $9gzc5.DebugLogger)(this.state.productId, messageId);
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
        });
        // Do a just-in-time message stop subscription with our callback to stargate
        this.onStop(messageId, callback);
        /**
     * Dispatch the request to stop the message, and return the response, which will
     * either be 'stopped' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.stopMessage(messageId, additionalData);
        return result === (0, $fw9LG.MessageDeliveryStatus).STOPPED;
    }
    constructor(env, metaMetricsData = {}){
        super((0, $fw9LG.ProductIds).ENGAGEKIT, env, metaMetricsData);
    }
}

});

parcelRegister("7xlwT", function(module, exports) {

$parcel$export(module.exports, "NO_CONTENT", () => $7a9fd76f016b15ed$export$3288b14b6745c572);
const $7a9fd76f016b15ed$export$3288b14b6745c572 = 204;
const $7a9fd76f016b15ed$export$c09e7ea0fc79f34f = 409;
const $7a9fd76f016b15ed$export$974c37534b0191b1 = 503;

});

parcelRegister("aqVTl", function(module, exports) {

$parcel$export(module.exports, "errorIfNotOk", () => $ed42c4b7ef51ed97$export$4adbd37839ed7718);
$parcel$export(module.exports, "pullResponseTextIfNotOk", () => $ed42c4b7ef51ed97$export$2ba4cde277adb6b1);
$parcel$export(module.exports, "stargateFetch", () => $ed42c4b7ef51ed97$export$317bcea84a3bea48);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ 
var $deiVB = parcelRequire("deiVB");
const $ed42c4b7ef51ed97$export$1f86472c1374185a = 3;
const $ed42c4b7ef51ed97$export$a2d611d5c7be4bb1 = 0.1;
const $ed42c4b7ef51ed97$export$957d605a51548b59 = 2;
const $ed42c4b7ef51ed97$export$80aa83cae6a6c290 = 1000;
async function $ed42c4b7ef51ed97$export$4adbd37839ed7718(response) {
    if (!response.ok) // We use the response body for two reasons:
    // 1. To ensure that we consume the response body, so that it gets reported on in Chrome DevTools
    // 2. It could have some useful information relevant to the error
    throw Error(`${response.status}: ${await response.text()}`);
    return response;
}
async function $ed42c4b7ef51ed97$export$2ba4cde277adb6b1(response) {
    if (!response.ok) await response.text();
    return response;
}
function $ed42c4b7ef51ed97$export$317bcea84a3bea48(input, reqOptions) {
    return $ed42c4b7ef51ed97$var$fetchWithRetry({
        input: input,
        reqOptions: reqOptions,
        numRetries: 0,
        maxRetries: $ed42c4b7ef51ed97$export$1f86472c1374185a,
        waitTimeMs: $ed42c4b7ef51ed97$export$80aa83cae6a6c290,
        backoffFn: $ed42c4b7ef51ed97$export$924aee1254634401
    });
}
function $ed42c4b7ef51ed97$var$fetchWithRetry({ input: input, reqOptions: reqOptions, numRetries: numRetries = 0, maxRetries: maxRetries = 0, waitTimeMs: waitTimeMs = 0, backoffFn: backoffFn = $ed42c4b7ef51ed97$export$924aee1254634401 }) {
    if (numRetries > maxRetries) throw new Error(`Failed to fetch ${input}: Max retries exceeded`);
    const options = {
        ...reqOptions,
        credentials: (0, $deiVB.default).includes(location.host) ? 'include' : 'same-origin'
    };
    const retryAttempt = ()=>new Promise((resolve)=>{
            setTimeout(()=>{
                resolve($ed42c4b7ef51ed97$var$fetchWithRetry({
                    input: input,
                    reqOptions: reqOptions,
                    numRetries: numRetries + 1,
                    maxRetries: maxRetries,
                    waitTimeMs: backoffFn(waitTimeMs),
                    backoffFn: backoffFn
                }));
            }, waitTimeMs);
        });
    return fetch(input, options).then((response)=>{
        if (response.status >= 500 && response.status <= 599) return retryAttempt();
        return response;
    }).catch(()=>{
        return retryAttempt();
    });
}
function $ed42c4b7ef51ed97$export$924aee1254634401(waitTimeMs) {
    const nextWaitTime = waitTimeMs * $ed42c4b7ef51ed97$export$957d605a51548b59;
    const jitter = nextWaitTime * $ed42c4b7ef51ed97$export$a2d611d5c7be4bb1 * Math.random();
    return nextWaitTime + jitter;
}

});
parcelRegister("deiVB", function(module, exports) {

$parcel$export(module.exports, "default", () => $acb686442d02a48b$export$2e2bcd8739ae039);
var $acb686442d02a48b$export$2e2bcd8739ae039 = [
    // Bitbucket Pipelines domains (is an iframe and require CORS)
    'bitbucket-pipelines.dev.public.atl-paas.net',
    'bitbucket-pipelines.staging.public.atl-paas.net',
    'bitbucket-pipelines.prod.public.atl-paas.net'
];

});



parcelRegister("4nGsu", function(module, exports) {

$parcel$export(module.exports, "isMessagingEnabled", () => $fd5afa82043d8fde$export$a77934ac158768dd);

var $lzcvT = parcelRequire("lzcvT");
function $fd5afa82043d8fde$export$a77934ac158768dd() {
    return !(0, $lzcvT.isFedRamp)();
}

});

parcelRegister("bbp3G", function(module, exports) {

$parcel$export(module.exports, "Dialogs", () => $0c65d0138cbdc5c8$export$6aea35d848d72744);
$parcel$export(module.exports, "DialogsStateContainer", () => (parcelRequire("kRW4Y")).DialogsStateContainer);
$parcel$export(module.exports, "isDialogShown", () => (parcelRequire("l65Bo")).isDialogShown);
$parcel$export(module.exports, "withDialogs", () => (parcelRequire("inDu6")).withDialogs);

var $jmjWc = parcelRequire("jmjWc");

var $kRW4Y = parcelRequire("kRW4Y");

var $l65Bo = parcelRequire("l65Bo");

var $inDu6 = parcelRequire("inDu6");

const $0c65d0138cbdc5c8$export$6aea35d848d72744 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "EmCca",
    name: "Dialogs",
    loader: async ()=>(await (parcelRequire("2H78H"))).Dialogs
});

});
parcelRegister("kRW4Y", function(module, exports) {

$parcel$export(module.exports, "DialogsStateContainer", () => $c329db8a0d5b9472$export$11ff2eb6414212c6);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $2BAFx = parcelRequire("2BAFx");
class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $ipPpS.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}

});
parcelRegister("2BAFx", function(module, exports) {

$parcel$export(module.exports, "dialogKeyState", () => $d32907502a426d2e$export$2e170616461fb3b6);
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();

});


parcelRegister("l65Bo", function(module, exports) {

$parcel$export(module.exports, "isDialogShown", () => $0afa19b4dc37db45$export$f0b76e53a3d1db73);
// we'd like to be able to check if the dialog is displaying right now
const $0afa19b4dc37db45$export$f0b76e53a3d1db73 = ()=>{
    const portals = Array.from(document.getElementsByClassName('atlaskit-portal')).filter((portal)=>portal.firstChild);
    const isAtlaskitDialogShown = Boolean(portals.filter((item)=>item.querySelectorAll('[role="dialog"]').length).length);
    const isLoomRecorderDialogShown = Boolean(document.getElementById('loom-sdk-record-overlay-shadow-root-id')?.shadowRoot?.getElementById('preview-recording'));
    return isAtlaskitDialogShown || isLoomRecorderDialogShown;
};

});

parcelRegister("inDu6", function(module, exports) {

$parcel$export(module.exports, "withDialogs", () => $34458177b4f70747$export$69f1ef99d32d73a0);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $kRW4Y = parcelRequire("kRW4Y");
function $34458177b4f70747$export$69f1ef99d32d73a0(InnerComponent) {
    var _WithDialogs;
    return _WithDialogs = class WithDialogs extends (0, $gwFzn.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
                to: [
                    (0, $kRW4Y.DialogsStateContainer)
                ]
            }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(InnerComponent, {
                    ...this.props,
                    dialogs: dialogs
                }));
        }
    }, _WithDialogs.displayName = `withDialogs(${InnerComponent.displayName || InnerComponent.name})`, _WithDialogs;
}

});

parcelRegister("2H78H", function(module, exports) {

let $1f6522a2b2d0f4ef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1f6522a2b2d0f4ef$var$load("iiMWZ").then(()=>parcelRequire('8Ugl4'));

});


parcelRegister("67Foi", function(module, exports) {

$parcel$export(module.exports, "ScreenEvent", () => $66735002228b2e7e$export$b901544a79a3bbad);

var $gwFzn = parcelRequire("gwFzn");

var $1DWH0 = parcelRequire("1DWH0");
const $66735002228b2e7e$export$b901544a79a3bbad = (0, $1DWH0.default)()(class ScreenEvent extends (0, $gwFzn.Component) {
    componentDidMount() {
        this.sendScreenEvent();
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.name !== this.props.name || nextProps.id !== this.props.id;
    }
    componentDidUpdate() {
        this.sendScreenEvent();
    }
    sendScreenEvent() {
        const { createAnalyticsEvent: createAnalyticsEvent, name: name, attributes: attributes } = this.props;
        const analyticsEvent = createAnalyticsEvent?.({
            type: 'sendScreenEvent',
            data: {
                name: name,
                attributes: attributes
            }
        });
        analyticsEvent?.fire();
    }
    render() {
        return null;
    }
});

});

parcelRegister("4WmbV", function(module, exports) {

$parcel$export(module.exports, "SectionMessageButtonConfig", () => $3a454656eb0e87cd$export$d33a80488b9cab17);
$parcel$export(module.exports, "ChangeEditionSectionMessage", () => $3a454656eb0e87cd$export$2e68cfab3dc25476);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $hArLp = parcelRequire("hArLp");
var $eEA8O = parcelRequire("eEA8O");

var $1ytiN = parcelRequire("1ytiN");

var $iJ9aA = parcelRequire("iJ9aA");

var $ki6F7 = parcelRequire("ki6F7");

var $k4Vdy = parcelRequire("k4Vdy");

var $iC1wS = parcelRequire("iC1wS");

var $lNKOh = parcelRequire("lNKOh");

var $bhvFb = parcelRequire("bhvFb");
var $3a454656eb0e87cd$export$d33a80488b9cab17 = /*#__PURE__*/ function(SectionMessageButtonConfig) {
    SectionMessageButtonConfig["DEFAULT"] = "default";
    SectionMessageButtonConfig["UPGRADE_ONLY"] = "upgradeOnly";
    SectionMessageButtonConfig["NONE"] = "none";
    return SectionMessageButtonConfig;
}({});
const $3a454656eb0e87cd$export$2e68cfab3dc25476 = ({ canShowUpgradeButton: canShowUpgradeButton = true, buttonConfig: buttonConfig = "default", upgradeEditionActionSubjectId: upgradeEditionActionSubjectId = 'freeTryNow', grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const CTAAnalyticsAttributes = (0, $gwFzn.useMemo)(()=>{
        return {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: Boolean(grandfathered)
        };
    }, [
        grandfathered,
        isSiteAdmin
    ]);
    const generateCTAAnalyticsProps = (actionSubjectId)=>({
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: CTAAnalyticsAttributes
        });
    const triggerLinkClickAnalytics = (clickEventActionSubjectId, linkMessage)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: clickEventActionSubjectId,
                source: source,
                attributes: {
                    ...CTAAnalyticsAttributes,
                    linkMessage: linkMessage
                }
            }
        }).fire();
    };
    const handleSecondaryLinkClick = ()=>{
        const link = secondaryLink;
        if (link) {
            triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
            if (typeof link.onClick === 'function') link.onClick();
        }
    };
    (0, $gwFzn.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'changeEditionGatewayScreen',
                attributes: {
                    ...CTAAnalyticsAttributes,
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        CTAAnalyticsAttributes,
        source
    ]);
    const renderButtons = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
            isSiteAdmin: isSiteAdmin,
            canShowUpgradeButton: canShowUpgradeButton,
            shouldShowLearnMore: !Boolean(secondaryLink)
        }, ({ showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA })=>{
            //
            // primary
            //
            let primary;
            const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ki6F7.UpgradeEditionButton), {
                analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                ...props
            }) : null;
            if (upgradeEditionButton) primary = upgradeEditionButton;
            //
            // secondaries
            //
            let secondaries;
            if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                // If the 'Try it free/now' button is to be shown, but it is not the
                // primary CTA, then make sure its appearance is appropriate for a
                // secondary:
                if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(upgradeEditionButton, {
                        appearance: 'link'
                    })
                ];
                else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, primary, secondaries);
        });
    };
    const getSecondaries = (showLearnMore, learnMoreIsPrimaryCTA)=>{
        const withIcon = Boolean(learnMoreLink?.icon);
        const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA ? learnMoreLink?.appearance || 'default' : 'link';
        const learnMoreButton = showLearnMore ? renderLearnMoreLink({
            appearance: learnMoreAppearance
        }) : null;
        const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
            key: "secondLink",
            appearance: secondaryLink.appearance || 'default',
            href: secondaryLink.href ? secondaryLink.href : undefined,
            id: "secondaryLink",
            spacing: "default",
            target: secondaryLink.target || '_blank',
            onClick: handleSecondaryLinkClick,
            testId: (0, $k4Vdy.calculateTestId)({
                source: source,
                actionSubjectId: secondaryLink.actionSubjectId
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), secondaryLink.messageDescriptor)) : null;
        return secondaryLink?.appearance === 'primary' && learnMoreAppearance !== 'primary' ? [
            secondaryLinkComponent,
            learnMoreButton
        ] : [
            learnMoreButton,
            secondaryLinkComponent
        ];
    };
    const renderLearnMoreLink = ({ children: children, ...learnMoreProps })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iJ9aA.LearnMoreButton), {
            key: "learnMore",
            analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || 'freeLearnMore'),
            appearance: learnMoreLink?.appearance || 'default',
            onUpFlowOpen: onUpFlowOpen,
            targetEdition: targetEdition,
            inProductHelpId: learnMoreLink?.inProductHelpId,
            inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
            href: learnMoreLink?.href,
            icon: learnMoreLink?.icon,
            ariaLabel: learnMoreLink?.ariaLabel,
            ...learnMoreProps,
            onClick: learnMoreLink?.onClick
        }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), learnMoreLink.messageDescriptor) : undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bhvFb.EditionSectionMessage), {
        actions: buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hArLp.default), null, renderButtons()) : undefined,
        edition: targetEdition,
        footer: isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, footer) : null,
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hArLp.default), null, headerButton),
        ...props
    });
};

});
parcelRegister("iJ9aA", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $c00269aedb3a5e7e$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "LearnMoreButtonComponent", () => $c00269aedb3a5e7e$export$628b38b203828231);
$parcel$export(module.exports, "LearnMoreButton", () => $c00269aedb3a5e7e$export$176492db868efc7f);

var $lassV = parcelRequire("lassV");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $eEA8O = parcelRequire("eEA8O");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $2KmnS = parcelRequire("2KmnS");

var $bQm3c = parcelRequire("bQm3c");

var $bBQPT = parcelRequire("bBQPT");

var $gsZdA = parcelRequire("gsZdA");

var $f7Bnv = parcelRequire("f7Bnv");

var $iC1wS = parcelRequire("iC1wS");

var $euL71 = parcelRequire("euL71");

var $e5k34 = parcelRequire("e5k34");

var $k4Vdy = parcelRequire("k4Vdy");
const $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    margin: 'auto'
});
const $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding = (0, $ecnYn.xcss)({
    padding: 'space.0'
});
const $c00269aedb3a5e7e$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    tryItFree: {
        id: "change-edition.section.message.try.free",
        defaultMessage: "Try it free"
    },
    learnMoreButton: {
        id: "change-edition.section.message.general.button.link",
        defaultMessage: "Learn more"
    }
});
const $c00269aedb3a5e7e$export$628b38b203828231 = ({ analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, isGrandfathered: isGrandfathered = false, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps })=>{
    const intl = (0, $dBxQj.default)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $gwFzn.useState)(false);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    const message = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
    const iconOnly = icon && !message;
    (0, $gwFzn.useEffect)(()=>()=>{
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'freeLearnMore',
                ...analyticsProps,
                attributes: {
                    currentEdition: edition,
                    isSiteAdmin: isSiteAdmin,
                    linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                    targetEdition: targetEdition,
                    ...analyticsProps.attributes
                }
            }
        }).fire();
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: edition,
                linkClicked: actionSubjectId || 'freeLearnMore',
                source: source,
                targetEdition: targetEdition
            }
        });
    };
    const onUpFlowClose = ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($lassV)))(onUpFlowOpen)) // only attempt to close if there is no onUpFlowOpen handler (as
        // UpFlowComponent will invoke it to unmount our parent already)
        setIsUpFlowOpen(false);
    };
    const renderLearnMoreButton = (props = {})=>{
        if (appearance === 'inline-link') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", props, message);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
            appearance: appearance,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: appearance === 'subtle-link' ? undefined : 'primaryButton',
            id: "learnMoreLink",
            spacing: iconOnly ? 'none' : 'default',
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    const fireAnalyticsEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'helpLink',
                source: 'adminKeyUpSell',
                attributes: {
                    targetArticleId: inProductHelpId,
                    isSPA: true
                }
            }
        }).fire();
    };
    if (isGrandfathered && !isSiteAdmin) return null;
    // prioritizing href if it passed by the consumer regardless of edition type
    if (!href) href = showUpFlow ? '#' : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith('#') ? undefined : '_blank';
    const buttonProps = {
        target: target,
        href: href,
        onClick: (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        },
        'aria-label': ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, !showUpFlow && inProductHelpId && inProductHelpTopic ? /**
     * Special handling In Product Help Button
     * InProductHelpButton force the spacing to none, thus creating a BOX here to add back the padding and margin
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bBQPT.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps), showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
        cloudId: cloudId,
        atlassianAccountId: userId || undefined,
        canChangeEdition: isSiteAdmin,
        currentEdition: edition || undefined,
        targetEdition: targetEdition,
        flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
        product: "confluence",
        touchpointId: source,
        onClose: onUpFlowClose,
        onOpen: onUpFlowOpen,
        isExperienceTrackerEnabled: true,
        epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
    }));
};
const $c00269aedb3a5e7e$export$176492db868efc7f = (0, $f7Bnv.withIsSiteAdmin)($c00269aedb3a5e7e$export$628b38b203828231);

});
parcelRegister("2KmnS", function(module, exports) {

$parcel$export(module.exports, "UpFlowComponentFlowType", () => $af6754ea8048b03c$export$a719c036dcaa8cea);
var $af6754ea8048b03c$export$a719c036dcaa8cea = /*#__PURE__*/ function(UpFlowComponentFlowType) {
    UpFlowComponentFlowType["LEARN_MORE"] = "learn-more";
    UpFlowComponentFlowType["UPGRADE"] = "upgrade";
    UpFlowComponentFlowType["REQUEST_UPGRADE"] = "request-upgrade";
    UpFlowComponentFlowType["REQUEST_LEARN_MORE"] = "request-learn-more";
    return UpFlowComponentFlowType;
}({});

});

parcelRegister("bBQPT", function(module, exports) {

$parcel$export(module.exports, "HelpPanel", () => $ca2ff8b0a2fb2121$export$f5043157c1558e39);
$parcel$export(module.exports, "InProductHelpButton", () => $ca2ff8b0a2fb2121$export$b14685a9b52779e1);
$parcel$export(module.exports, "BackupManagerButton", () => $ca2ff8b0a2fb2121$export$b52880da76836cd4);
$parcel$export(module.exports, "SiteSettingsHelpPanelLink", () => $ca2ff8b0a2fb2121$export$2c12a08ca2f15d0e);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => (parcelRequire("dIDyF")).HELP_PANEL_WIDTH);
$parcel$export(module.exports, "HELP_PANEL_ID", () => (parcelRequire("dIDyF")).HELP_PANEL_ID);
$parcel$export(module.exports, "getRouteData", () => (parcelRequire("14QAi")).getRouteData);
$parcel$export(module.exports, "InProductHelpProvider", () => (parcelRequire("cLgYq")).InProductHelpProvider);
$parcel$export(module.exports, "useInProductHelpActions", () => (parcelRequire("cLgYq")).useInProductHelpActions);
$parcel$export(module.exports, "useInProductHelpArticleId", () => (parcelRequire("cLgYq")).useInProductHelpArticleId);
$parcel$export(module.exports, "HelpPanelQuery", () => (parcelRequire("zpqJA")).HelpPanelQuery);

var $jmjWc = parcelRequire("jmjWc");

var $dIDyF = parcelRequire("dIDyF");

var $14QAi = parcelRequire("14QAi");

var $cLgYq = parcelRequire("cLgYq");

var $zpqJA = parcelRequire("zpqJA");

const $ca2ff8b0a2fb2121$export$f5043157c1558e39 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "UyWpz",
    name: "HelpPanel",
    loader: async ()=>(await (parcelRequire("f3iQ9"))).HelpPanel
});

const $ca2ff8b0a2fb2121$export$b14685a9b52779e1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "_TNM0",
    name: "InProductHelpButton",
    loader: async ()=>(await (parcelRequire("jqMXk"))).InProductHelpButton
});

const $ca2ff8b0a2fb2121$export$b52880da76836cd4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wyWyB",
    name: "BackupManagerButton",
    loader: async ()=>(await (parcelRequire("52yfG"))).BackupManagerButton
});

const $ca2ff8b0a2fb2121$export$2c12a08ca2f15d0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "snd7Z",
    name: "SiteSettingsHelpPanelLink",
    loader: async ()=>(await (parcelRequire("85M8m"))).SiteSettingsHelpPanelLink
});

});
parcelRegister("dIDyF", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_ID", () => $c2412d4c16af1f46$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $c2412d4c16af1f46$export$23aa6670f346c214);
$parcel$export(module.exports, "FEEDBACK_FIELDS_ID", () => $c2412d4c16af1f46$export$dd8cabd06ab03363);
$parcel$export(module.exports, "WAS_THIS_HELPFUL_OPTIONS", () => $c2412d4c16af1f46$export$597555bbf10f10b8);
$parcel$export(module.exports, "FEEDBACK_REASON_OPTIONS", () => $c2412d4c16af1f46$export$cd692d959c11a1e9);
$parcel$export(module.exports, "CAN_BE_CONTACTED_OPTIONS", () => $c2412d4c16af1f46$export$ee3be114bf2680b4);
$parcel$export(module.exports, "EMBEDDABLE_KEY", () => $c2412d4c16af1f46$export$31f0ec6fc5b07a82);
$parcel$export(module.exports, "REQUEST_TYPE_ID", () => $c2412d4c16af1f46$export$d006cfb73688051e);
const $c2412d4c16af1f46$export$c43c7444da662fa1 = '1';
const $c2412d4c16af1f46$export$e99efa3985fa3c26 = 'in-product-help';
const $c2412d4c16af1f46$export$23aa6670f346c214 = 368;
const $c2412d4c16af1f46$export$dd8cabd06ab03363 = {
    summary: 'summary',
    wasThisHelpful: 'customfield_10081',
    description: 'description',
    reason: 'customfield_10082',
    title: 'customfield_10083',
    contentId: 'customfield_10084',
    contentLink: 'customfield_10088',
    feedbackContext: 'customfield_10047',
    routeGroup: 'customfield_10085',
    routeName: 'customfield_10086',
    customerName: 'customfield_10045',
    email: 'email',
    contactMe: 'customfield_10043'
};
const $c2412d4c16af1f46$export$597555bbf10f10b8 = {
    yes: {
        id: '10182',
        label: 'yes'
    },
    no: {
        id: '10183',
        label: 'no'
    }
};
const $c2412d4c16af1f46$export$cd692d959c11a1e9 = {
    noAccurate: {
        id: '10184',
        label: "It wasn\u2019t accurate"
    },
    noClear: {
        id: '10185',
        label: "It wasn\u2019t clear"
    },
    noRelevant: {
        id: '10186',
        label: "It wasn\u2019t relevant"
    }
};
const $c2412d4c16af1f46$export$ee3be114bf2680b4 = {
    yes: {
        id: '10109',
        label: 'yes'
    },
    no: {
        id: '10111',
        label: 'no'
    }
};
const $c2412d4c16af1f46$export$31f0ec6fc5b07a82 = 'afae180b-eb61-43c5-bc3f-5f65349a8853';
const $c2412d4c16af1f46$export$d006cfb73688051e = '279';

});

parcelRegister("14QAi", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_NOTICE_AT_COLLECTION_LINK", () => $1ce5a19013c572e5$export$244e5242c65921be);
$parcel$export(module.exports, "EXTERNAL_NOTICE_AT_COLLECTION_LINK", () => $1ce5a19013c572e5$export$ab8f8977c5e363cb);
$parcel$export(module.exports, "INTERNAL_PRIVACY_POLICY_LINK", () => $1ce5a19013c572e5$export$86f8e0fbd7845b32);
$parcel$export(module.exports, "EXTERNAL_PRIVACY_POLICY_LINK", () => $1ce5a19013c572e5$export$87259143062a27ea);
$parcel$export(module.exports, "FILTERED_MENU_ITEMS", () => $1ce5a19013c572e5$export$108231643dc5e01e);
$parcel$export(module.exports, "getRouteData", () => $1ce5a19013c572e5$export$40e045b7d0d057fd);
$parcel$export(module.exports, "isSearchProviderUnreachableError", () => $1ce5a19013c572e5$export$c28bcc688252a1b6);

var $hBkCm = parcelRequire("hBkCm");
var $flE5X = parcelRequire("flE5X");
// ANALYTICS PROPERTIES
const $1ce5a19013c572e5$var$SPACE_OVERVIEW = 'spaceSettings/overview';
const $1ce5a19013c572e5$var$SPACE_PERMISSIONS = 'spaceSettings/permissions';
const $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS = 'spaceSettings/contentTools';
const $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL = 'spaceSettings/lookAndFeel';
const $1ce5a19013c572e5$var$SPACE_INTEGRATIONS = 'spaceSettings/Integrations';
// ROUTE GROUPS
const $1ce5a19013c572e5$var$SPACE_SETTINGS = 'space-settings';
const $1ce5a19013c572e5$export$244e5242c65921be = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice#13.-Additional-Disclosures-for-California-Residents';
const $1ce5a19013c572e5$export$ab8f8977c5e363cb = 'https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents';
const $1ce5a19013c572e5$export$86f8e0fbd7845b32 = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice';
const $1ce5a19013c572e5$export$87259143062a27ea = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $1ce5a19013c572e5$export$108231643dc5e01e = [
    'Online Help',
    'Get the mobile app',
    'Feed Builder',
    'Keyboard Shortcuts',
    'Site Status',
    "What\u2019s new",
    'About Confluence'
];
const $1ce5a19013c572e5$export$40e045b7d0d057fd = (route)=>{
    // get what route we're on by switching based on
    // the regex evaluating to true
    switch(true){
        /**
		 * SPACE SETTINGS - OVERVIEW
		 */ case /viewspacesummary/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-details',
                articleId: '2ngx6W7OSkTdvFP6m1jdYC',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'spaceDetailsScreen'
            };
        case /archivespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /archiveSpace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /editFeatures/.test(route):
            return {
                routeName: 'edit-sidebar',
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                articleId: '6ivofSJlfSXa9IASo00kvA',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'sidebarConfigurationScreen'
            };
        case /removespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'delete-space',
                articleId: '7edCGN0nkqsvUd9s3AzEq8',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'deleteSpaceScreen'
            };
        /**
		 * SPACE SETTINGS - PERMISSIONS
		 */ case /spaces\/.*\/settings\/permissions\/\d*/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /spacepermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /addonpermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'addOnScreen'
            };
        case /listpermissionpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'page-restrictions',
                articleId: '7f9j14trnF75aeuihHAoLp',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'restrictedPagesScreen'
            };
        case /reorderpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'reorder-pages',
                articleId: '5faOvjH2hAw2CpZY3tC3ej',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'reorderPagesScreen'
            };
        case /listorphanedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'orphaned-pages',
                articleId: '1mxG2f1dvIifiDqKrkvy98',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'orphanedPagesScreen'
            };
        case /listundefinedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined-pages',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'undefinedPagesScreen'
            };
        case /listattachmentsforspace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'attachments',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'attachmentsScreen'
            };
        case /viewtrash/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'trash',
                articleId: '6NL5cRC6aV7k9ucd2yEZzZ',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'trashScreen'
            };
        case /exportspacewelcome/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'export-space',
                articleId: '6RcXthpHKQasH09gERDkE8',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'exportScreen'
            };
        case /listrssfeeds/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'rss-feed',
                articleId: '6TyTkhaowcNTwvq9V0rt10',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'rssFeedsScreen'
            };
        /**
		 * SPACE SETTINGS - LOOK AND FEEL
		 */ case /spaces\/choosetheme/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'themes',
                articleId: '3Owkyfl2mshKQQ2mECCV8q',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'themesScreen'
            };
        case /custompagecontent/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'header-and-footer',
                articleId: '2i2NAHbTjkWeoprrdWlNX',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'headerAndFooterScreen'
            };
        case /viewpdfconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfConfigScreen'
            };
        case /viewpdflayoutconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfLayoutScreen'
            };
        case /viewpdfstyleconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfStylesheetScreen'
            };
        /**
		 * SPACE SETTINGS - INTEGRATIONS
		 */ case /listentitylinks/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_INTEGRATIONS,
                screen: 'applicationLinksScreen'
            };
        /**
		 * CONNECT ADDONS
		 */ case /analytics\/permissions/.test(route):
            return {
                routeGroup: 'site-settings',
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /atlassian-connect\/space-tools-tab.action/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'analyticsPermissionsScreen'
            };
        /**
		 * CONTENT TYPE VIEW PAGES
		 */ case /spaces\/.*\/pages\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-page',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/whiteboard\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-whiteboard',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/database\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-database',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/embed\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-embed',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/calendars/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-calendars',
                articleId: '85KAXe75f9VdMibJa5FHz',
                section: 'notTracked',
                screen: 'notTracked'
            };
        /**
		 * EVERYTHING ELSE
		 */ default:
            return {
                routeGroup: 'undefined',
                articleId: '',
                section: 'notTracked',
                routeName: 'undefined',
                screen: 'notTracked'
            };
    }
};
const $1ce5a19013c572e5$export$c28bcc688252a1b6 = (error)=>{
    return [
        'algolia',
        'unreachable hosts'
    ].some((err)=>error.message.toLowerCase().includes(err)) || error instanceof (0, $flE5X.NoNetworkError) || error instanceof (0, $hBkCm.BadStatusError) && error.response.status >= 500;
};

});

parcelRegister("cLgYq", function(module, exports) {

$parcel$export(module.exports, "useInProductHelpActions", () => $80f6c4cf061c88c5$export$d9f3a3de6974e16a);
$parcel$export(module.exports, "useInProductHelpArticleId", () => $80f6c4cf061c88c5$export$b1fca540f7ef5476);
$parcel$export(module.exports, "InProductHelpProvider", () => $80f6c4cf061c88c5$export$a61d77bd8effd79e);

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");

var $gwFzn = parcelRequire("gwFzn");
const $80f6c4cf061c88c5$export$909966f260e2b2b = (articleId, setArticleId, routeName, setRouteName, routeGroup, setRouteGroup)=>({
        getArticleId: ()=>articleId,
        setArticleId: setArticleId,
        getRouteName: ()=>routeName,
        setRouteName: setRouteName,
        getRouteGroup: ()=>routeGroup,
        setRouteGroup: setRouteGroup
    });
const $80f6c4cf061c88c5$var$initialInProductHelpState = {
    articleId: '',
    routeName: '',
    routeGroup: ''
};
const $80f6c4cf061c88c5$var$inProductHelpActions = {
    setArticleId: (articleId)=>({ setState: setState })=>{
            setState({
                articleId: articleId
            });
        },
    setRouteName: (routeName)=>({ setState: setState })=>{
            setState({
                routeName: routeName
            });
        },
    setRouteGroup: (routeGroup)=>({ setState: setState })=>{
            setState({
                routeGroup: routeGroup
            });
        }
};
const $80f6c4cf061c88c5$var$Store = (0, $4ZoIm.createStore)({
    initialState: {
        ...$80f6c4cf061c88c5$var$initialInProductHelpState
    },
    actions: $80f6c4cf061c88c5$var$inProductHelpActions,
    name: 'inProductHelpContext'
});
const $80f6c4cf061c88c5$export$d9f3a3de6974e16a = (0, $iFWZA.createActionsHook)($80f6c4cf061c88c5$var$Store);
const $80f6c4cf061c88c5$export$b1fca540f7ef5476 = (0, $iFWZA.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.articleId
});
const $80f6c4cf061c88c5$export$15e1d4730ce65e9d = (0, $iFWZA.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.routeName
});
const $80f6c4cf061c88c5$export$1dfb78b8caec7720 = (0, $iFWZA.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.routeGroup
});
const $80f6c4cf061c88c5$export$a611b87b3ebe1475 = (0, $2S0Fz.createContainer)($80f6c4cf061c88c5$var$Store, {
    onInit: ()=>({ setState: setState }, productState)=>{
            setState(productState);
        },
    onUpdate: ()=>({ setState: setState }, productState)=>{
            setState(productState);
        }
});
const $80f6c4cf061c88c5$export$a61d77bd8effd79e = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($80f6c4cf061c88c5$export$a611b87b3ebe1475, null, children);
};

});

parcelRegister("zpqJA", function(module, exports) {

$parcel$export(module.exports, "HelpPanelQuery", () => $1cfa805e40f472d8$export$1aca890c910b1270);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $1cfa805e40f472d8$export$1aca890c910b1270 = (0, $d2LG0.default)`query HelpPanelQuery{user:confluence_atlassianUser(current:true){id displayName emails{value isPrimary}}}`;

});

parcelRegister("f3iQ9", function(module, exports) {

let $af55c01a0e2c738e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $af55c01a0e2c738e$var$load("ir7Dc"),
    $af55c01a0e2c738e$var$load("hGXAt"),
    $af55c01a0e2c738e$var$load("26IOy"),
    $af55c01a0e2c738e$var$load("2nuqm"),
    $af55c01a0e2c738e$var$load("giPb3"),
    $af55c01a0e2c738e$var$load("ecOVI"),
    $af55c01a0e2c738e$var$load("3xznI"),
    $af55c01a0e2c738e$var$load("dkV2T"),
    $af55c01a0e2c738e$var$load("kgJcP"),
    $af55c01a0e2c738e$var$load("2S1L6"),
    $af55c01a0e2c738e$var$load("7LJ3q"),
    $af55c01a0e2c738e$var$load("U7y88"),
    $af55c01a0e2c738e$var$load("fEx3B"),
    $af55c01a0e2c738e$var$load("dJQEi"),
    $af55c01a0e2c738e$var$load("6qah4"),
    $af55c01a0e2c738e$var$load("j4gWN"),
    $af55c01a0e2c738e$var$load("c6MKV"),
    $af55c01a0e2c738e$var$load("aZinD"),
    $af55c01a0e2c738e$var$load("iOFzT")
]).then(()=>parcelRequire('b8FTv'));

});

parcelRegister("jqMXk", function(module, exports) {

let $e2566baa40efb9da$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e2566baa40efb9da$var$load("82QsP").then(()=>parcelRequire('lcEzf'));

});

parcelRegister("52yfG", function(module, exports) {

let $3ab7b565e0b79c26$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3ab7b565e0b79c26$var$load("82QsP"),
    $3ab7b565e0b79c26$var$load("gJRFC")
]).then(()=>parcelRequire('bQl5d'));

});

parcelRegister("85M8m", function(module, exports) {

let $5e4420bc4e31980f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $5e4420bc4e31980f$var$load("82QsP"),
    $5e4420bc4e31980f$var$load("an2zh")
]).then(()=>parcelRequire('3Fqft'));

});


parcelRegister("gsZdA", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE_LINK", () => $f57489e4f8cda39e$export$997e23a0aec74966);
$parcel$export(module.exports, "SECTION_MESSAGE_APPEARANCE_TYPES", () => $f57489e4f8cda39e$export$fd53124e1292f3e0);
$parcel$export(module.exports, "UP_FLOW_EP_MESSAGE_ID", () => $f57489e4f8cda39e$export$9d01cd0779f8a694);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_EP_MESSAGE_ID", () => $f57489e4f8cda39e$export$8a4b4d778c622ea1);
/* eslint-disable check-file/filename-blocklist */ const $f57489e4f8cda39e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Cloud+plans';
var $f57489e4f8cda39e$export$fd53124e1292f3e0 = /*#__PURE__*/ function(SECTION_MESSAGE_APPEARANCE_TYPES) {
    SECTION_MESSAGE_APPEARANCE_TYPES["DEFAULT"] = "default";
    SECTION_MESSAGE_APPEARANCE_TYPES["FLAT"] = "flat";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE"] = "inline";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE_MODAL"] = "inline-modal";
    return SECTION_MESSAGE_APPEARANCE_TYPES;
}({});
const $f57489e4f8cda39e$export$9d01cd0779f8a694 = 'confluence-up-flow-modal';
const $f57489e4f8cda39e$export$8a4b4d778c622ea1 = 'upflow-confluence-persistent-upgrade';

});

parcelRegister("f7Bnv", function(module, exports) {

$parcel$export(module.exports, "withIsSiteAdmin", () => $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5);

var $gwFzn = parcelRequire("gwFzn");

var $1ytiN = parcelRequire("1ytiN");
function $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5(WrappedComponent) {
    return function WithIsSiteAdminComponent(props) {
        const { isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
        if (error || loading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(WrappedComponent, {
            ...props,
            isSiteAdmin: isSiteAdmin
        });
    };
}

});

parcelRegister("iC1wS", function(module, exports) {

$parcel$export(module.exports, "useEditionsAnalyticsContext", () => $8ea1c6a3abbe8170$export$ce3e4b18be9c194b);
$parcel$export(module.exports, "AnalyticsProvider", () => $8ea1c6a3abbe8170$export$1b581a2ec13e37f1);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");
const $8ea1c6a3abbe8170$var$EditionsAnalyticsContext = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $8ea1c6a3abbe8170$export$198c73506737f848 = (payload, data)=>({
        ...payload,
        data: {
            ...payload.data,
            attributes: {
                ...payload.data.attributes,
                ...data?.customAttributes
            }
        }
    });
const $8ea1c6a3abbe8170$export$ce3e4b18be9c194b = ()=>{
    const internalData = (0, $gwFzn.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const wrapAnalyticsEventPayload = (0, $gwFzn.useCallback)((data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData), [
        internalData
    ]);
    const wrappedCreateAnalyticsEvent = (0, $gwFzn.useCallback)((initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload)), [
        createAnalyticsEvent,
        wrapAnalyticsEventPayload
    ]);
    return {
        createAnalyticsEvent: wrappedCreateAnalyticsEvent,
        wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
    };
};
const $8ea1c6a3abbe8170$var$emptyAttributes = {};
const $8ea1c6a3abbe8170$export$1b581a2ec13e37f1 = ({ children: children, customAttributes: customAttributes = $8ea1c6a3abbe8170$var$emptyAttributes })=>{
    const editionsAnalyticsContextValue = (0, $gwFzn.useMemo)(()=>({
            customAttributes: customAttributes
        }), [
        customAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
        value: editionsAnalyticsContextValue
    }, children);
};
const $8ea1c6a3abbe8170$export$19bbfac2f7120ab5 = (Component)=>{
    const WrappedComponent = (props)=>{
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
            ...props,
            ...context
        });
    };
    return WrappedComponent;
};

});

parcelRegister("e5k34", function(module, exports) {

$parcel$export(module.exports, "UpFlowCommerceRouterLoadable", () => $39559a87bbe2d5db$export$fad9b967c5750450);

var $jmjWc = parcelRequire("jmjWc");

const $39559a87bbe2d5db$export$fad9b967c5750450 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "WKfML",
    name: "UpFlowCommerceRouterLoadable",
    loader: async ()=>(await (parcelRequire("6pfAa"))).UpFlowCommerceRouter
});

});
parcelRegister("6pfAa", function(module, exports) {

let $4aa12a36032ce7cb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4aa12a36032ce7cb$var$load("gV84f").then(()=>parcelRequire('7SmYm'));

});


parcelRegister("k4Vdy", function(module, exports) {

$parcel$export(module.exports, "calculateTestId", () => $b05bae0ef566e919$export$b1556774836001f5);

var $csqxs = parcelRequire("csqxs");
const $b05bae0ef566e919$export$b1556774836001f5 = ({ actionSubjectId: actionSubjectId, source: source })=>actionSubjectId !== undefined ? `${source}${(0, (/*@__PURE__*/$parcel$interopDefault($csqxs)))(actionSubjectId)}` : undefined;

});


parcelRegister("ki6F7", function(module, exports) {

$parcel$export(module.exports, "UpgradeEditionButton", () => $3615035320db7a8b$export$2f4bd8d23e81b246);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $4KS7f = parcelRequire("4KS7f");

var $izVB4 = parcelRequire("izVB4");

var $1kHsc = parcelRequire("1kHsc");
var $fGzMp = parcelRequire("fGzMp");
var $irVI7 = parcelRequire("irVI7");
parcelRequire("dIouf");
var $b3j2Y = parcelRequire("b3j2Y");

var $bQm3c = parcelRequire("bQm3c");

var $gsZdA = parcelRequire("gsZdA");

var $5M47w = parcelRequire("5M47w");

var $dqdrq = parcelRequire("dqdrq");

var $ktelT = parcelRequire("ktelT");

var $euL71 = parcelRequire("euL71");

var $e5k34 = parcelRequire("e5k34");

var $fDbEj = parcelRequire("fDbEj");

var $k4Vdy = parcelRequire("k4Vdy");

var $iC1wS = parcelRequire("iC1wS");
const $3615035320db7a8b$var$i18n = (0, $2nPZH.defineMessages)({
    tryItFree: {
        id: "change-edition.upgrade.try.free",
        defaultMessage: "Try it free"
    },
    tryItNow: {
        id: "change-edition.upgrade.try.now",
        defaultMessage: "Try it now"
    },
    tryPremium: {
        id: "change-edition.upgrade.try.premium",
        defaultMessage: "Try Premium"
    }
});
const $3615035320db7a8b$var$editionMap = {
    [(0, $euL71.ConfluenceEdition).FREE]: (0, $5M47w.CommerceDeepLinksTargetEdition).FREE,
    [(0, $euL71.ConfluenceEdition).STANDARD]: (0, $5M47w.CommerceDeepLinksTargetEdition).STANDARD,
    [(0, $euL71.ConfluenceEdition).PREMIUM]: (0, $5M47w.CommerceDeepLinksTargetEdition).PREMIUM
};
const $3615035320db7a8b$var$determineButtonComponent = (appearance)=>{
    if (appearance === 'primary') return 0, $dqdrq.GradientCTAButton;
    if (appearance === 'subtle-link') return 0, $ktelT.GradientSubtleLinkButton;
    return 0, $4KS7f.default;
};
const $3615035320db7a8b$export$2f4bd8d23e81b246 = ({ analyticsProps: { actionSubjectId: actionSubjectId, attributes: attributes, source: source }, appearance: appearance = 'primary', children: children, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, onUpgradeButtonClick: onUpgradeButtonClick })=>{
    const [openUpFlow, setOpenUpFlow] = (0, $gwFzn.useState)(false);
    const [pollingError, setPollingError] = (0, $gwFzn.useState)();
    const { cloudId: cloudId, edition: currentEdition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // free -> standard: upflow spa;
    // free/standard -> premium: adminhub
    const showUpFlow = targetEdition === (0, $euL71.ConfluenceEdition).STANDARD;
    const { commerceBackendName: commerceBackendName, planConsentDeepLink: planConsentDeepLink, errorMessage: commerceDeepLinksError } = (0, $5M47w.useCommerceDeepLinks)({
        targetEdition: $3615035320db7a8b$var$editionMap[targetEdition],
        skipDeepLinks: showUpFlow
    });
    (0, $gwFzn.useEffect)(()=>()=>{
            // 1. With upflow enabled, when the user clicks on the upgrade CTA, the
            //    upflow dialog opens and this component unmounts; the upsell experience
            //    continues and experience tracking is subsequently handled by the
            //    UpFlow component.
            // or
            // 2. With upflow DISabled, unmounting here simply means user navigated away
            //    from the upsell UI and we DO want to signal an aborted experience.
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // Using a TRACK event for tacking the traffic to the UpgradeEditionButton.
        // This will help us gauage Commerce API traffic to compute the deep links.
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'upgradeEditionButton',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition
                }
            }
        }).fire();
    // We only need this to fire once, when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireClickAnalytics = ()=>{
        if (attributes) {
            attributes.currentEdition = currentEdition;
            attributes.targetEdition = targetEdition;
            attributes.commerceBackend = commerceBackendName;
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: attributes
            }
        }).fire();
        if (commerceDeepLinksError) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'errored',
                actionSubject: 'useCommerceDeepLinks',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    upsellDeepLink: planConsentDeepLink ? planConsentDeepLink.split('?')[0] : undefined,
                    errorMessage: commerceDeepLinksError
                }
            }
        }).fire();
    };
    const onTryWithoutUpFlowClick = async ()=>{
        if (onUpgradeButtonClick) onUpgradeButtonClick();
        // start polling and reload the page when done
        try {
            const updatedEdition = await (0, $fDbEj.waitForEditionChange)(currentEdition);
            experienceTracker.succeed({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: currentEdition,
                    targetEdition: updatedEdition
                }
            });
            // Default behavior
            window.location.reload();
        } catch (error) {
            if (error === (0, $fDbEj.TimeoutError)) // We don't expect the user to always proceed to upgrade in Admin Hub after seeing the estimated billing info.
            experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Possibly canceled by user'
            });
            else {
                (0, $fGzMp.stopExperienceOnError)((0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE), error);
                setPollingError(error);
            }
        }
    };
    const onUpFlowClose = ()=>{
        setOpenUpFlow(false);
    };
    const onTryButtonClick = ()=>{
        // we always want to fire both the exposure event as well as the click event
        fireClickAnalytics();
        // start the experience tracker
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: currentEdition,
                linkClicked: actionSubjectId,
                source: source,
                targetEdition: targetEdition
            }
        });
        // then handle the click behaviour based on FF
        if (showUpFlow) setOpenUpFlow(true);
        else onTryWithoutUpFlowClick();
    };
    const buttonProps = {
        appearance: appearance,
        className: 'primaryButton',
        href: showUpFlow ? undefined : planConsentDeepLink,
        onClick: onTryButtonClick,
        target: showUpFlow ? undefined : '_blank',
        iconBefore: appearance === 'primary' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }) : undefined,
        testId: (0, $k4Vdy.calculateTestId)({
            source: source,
            actionSubjectId: actionSubjectId
        })
    };
    const buttonChildren = children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3615035320db7a8b$var$i18n.tryItFree);
    const ButtonComponent = $3615035320db7a8b$var$determineButtonComponent(appearance);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, pollingError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: pollingError
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ButtonComponent, buttonProps, buttonChildren), showUpFlow && openUpFlow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
        canChangeEdition: true // this component should only ever be used for site admins
        ,
        cloudId: cloudId,
        currentEdition: currentEdition || undefined,
        atlassianAccountId: userId || undefined,
        flow: "upgrade",
        product: "confluence",
        targetEdition: targetEdition,
        touchpointId: source,
        isExperienceTrackerEnabled: true,
        onClose: // Note: onUpFlowOpen function closes the parent component which
        // means we don't need to trigger the onClose.
        onUpFlowOpen ? undefined : onUpFlowClose,
        onOpen: onUpFlowOpen,
        epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
    }) : null);
};

});
parcelRegister("izVB4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cc8d44dd44920ffd526686a9e2bd3636>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8682c67cc42b6ad$var$_react = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $d8682c67cc42b6ad$var$_baseNew = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d8682c67cc42b6ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features and functionality. Editions may replace the current premium sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8682c67cc42b6ad$var$EditionsIcon = (props)=>/*#__PURE__*/ $d8682c67cc42b6ad$var$_react.default.createElement($d8682c67cc42b6ad$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.614 1.353A.75.75 0 0 1 3.25 1h9.5a.75.75 0 0 1 .636.353l2.5 4a.75.75 0 0 1-.065.884l-7.25 8.5a.75.75 0 0 1-1.142 0l-7.25-8.5a.75.75 0 0 1-.065-.885zM3.666 2.5 2.103 5H4.7l.78-2.5zm3.385 0L6.271 5H9.73l-.781-2.5zm3.47 0L11.3 5h2.596l-1.563-2.5zm3.103 4h-2.328l-1.424 4.399zM8 11.813 9.72 6.5H6.28zM4.704 6.5l1.424 4.399L2.375 6.5z" clip-rule="evenodd"/>`
    }, props));
$d8682c67cc42b6ad$var$EditionsIcon.displayName = 'EditionsIcon';
var $d8682c67cc42b6ad$var$_default = module.exports.default = $d8682c67cc42b6ad$var$EditionsIcon;

});

parcelRegister("5M47w", function(module, exports) {

$parcel$export(module.exports, "CommerceDeepLinksTargetEdition", () => $ae96eb60e6557b8b$export$92b15cc7e26a62fb);
$parcel$export(module.exports, "useCommerceDeepLinks", () => $ae96eb60e6557b8b$export$91505ae0b86ded0b);
/* eslint-disable react-hooks/exhaustive-deps */ 
var $gwFzn = parcelRequire("gwFzn");
parcelRequire("j1Ss3");
var $xQxzY = parcelRequire("xQxzY");

var $6Co6F = parcelRequire("6Co6F");

var $6bHqX = parcelRequire("6bHqX");

var $lzcvT = parcelRequire("lzcvT");

var $bQm3c = parcelRequire("bQm3c");

var $1ytiN = parcelRequire("1ytiN");

var $gKr8t = parcelRequire("gKr8t");
var $7Sm4c = parcelRequire("7Sm4c");
var $8H5XZ = parcelRequire("8H5XZ");

var $kSPeY = parcelRequire("kSPeY");

var $lh1MN = parcelRequire("lh1MN");

var $hfUvC = parcelRequire("hfUvC");

var $iDfyh = parcelRequire("iDfyh");
var $ae96eb60e6557b8b$export$92b15cc7e26a62fb = /*#__PURE__*/ function(CommerceDeepLinksTargetEdition) {
    CommerceDeepLinksTargetEdition["FREE"] = "free";
    CommerceDeepLinksTargetEdition["STANDARD"] = "standard";
    CommerceDeepLinksTargetEdition["PREMIUM"] = "premium";
    return CommerceDeepLinksTargetEdition;
}({});
const $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS = {
    PRODUCTION: 'https://admin.atlassian.com',
    STAGING: 'https://admin.stg.atlassian.com'
};
const $ae96eb60e6557b8b$export$16287b6da0e34b4e = '/admin/billing/applications/change-edition/confluence.ondemand';
const $ae96eb60e6557b8b$export$4591cf268e289775 = '/admin/billing/applications';
const $ae96eb60e6557b8b$var$addAtlOriginToUrl = (url)=>{
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    return origin.addToUrl(url);
};
const $ae96eb60e6557b8b$export$39685ba9de2c4192 = ({ cloudId: cloudId, environment: environment, orgId: orgId })=>{
    const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
    if (orgId || cloudId) return orgId ? `${CLOUD_ADMIN_URL}/o/${orgId}/billing-preview` : `${CLOUD_ADMIN_URL}/s/${cloudId}/billing-preview`;
    // In an extreme case where we cannot detect cloudId or orgId, we route user to main AdminHub page.
    return CLOUD_ADMIN_URL;
};
const $ae96eb60e6557b8b$var$buildPlanSelectionLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, transactionAccountId: transactionAccountId, orgId: orgId } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$16287b6da0e34b4e;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?referrer=[referrer]
        // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=confluence`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildPlanConsentLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, entitlementId: entitlementId, environment: environment, orgId: orgId, transactionAccountId: transactionAccountId, targetEdition: targetEdition } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}/${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?offeringName=[offering name]&referrer=[referrer]
    // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2820329173/How+to+Deeplink+change+plan+consent
    return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}&offeringName=${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildSubscriptionDetailsLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, orgId: orgId, transactionAccountId: transactionAccountId } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$4591cf268e289775;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
// (Concept is adopted from Kent C. Dodds here:
//  https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript)
const $ae96eb60e6557b8b$var$getErrorMessage = (label, error)=>{
    const message = error instanceof Error ? error.message : String(error);
    return `${label}: ${message}`;
};
const $ae96eb60e6557b8b$export$91505ae0b86ded0b = ({ targetEdition: targetEdition, skipDeepLinks: skipDeepLinks = false })=>{
    const { environment: environment, cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    if (!isSiteAdmin || !cloudId) skipDeepLinks = true;
    /**
	 * The best practice advocates for one graphql per component and ideally no graphql quries in a hook
	 * but to construct the deeplink, we need to:
	 * 1. first call Commerce API to retrieve the Confluence instance backend service (CCP or HAMS),
	 * 2. for CCP, call ccgraphql to retrieve the ccpEntitlementId
	 * 3. for CCP, call AGG to retrieve the CCP transaction account Id using the ccpEntitlementId retrieved in step #2.
	 *
	 * This is a stop gap solution while we work with Commerce to eventually have one AGG query
	 * to provide everything we need with just a CloudId and the product key (e.g. confluence
	 */ const { commerceBackendName: commerceBackendName, loading: commerceBackendNameLoading, error: commerceBackendNameError } = (0, $hfUvC.useCommerceRolloutInformation)(skipDeepLinks || (0, $lzcvT.isFedRamp)());
    // If it is in FedRamp, we can assume it is CCP backend.
    // More details -> https://atlassian.slack.com/archives/C04LF8UKAE4/p1734981625650579
    const isCcpBackend = commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) || (0, $lzcvT.isFedRamp)();
    const { data: ccpEntitlementIdData, loading: ccpEntitlementIdLoading, error: ccpEntitlementIdError } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $kSPeY.CcpEntitlementQuery), {
        skip: skipDeepLinks || !isCcpBackend
    });
    const ccpEntitlementId = !ccpEntitlementIdLoading ? (0, $lh1MN.getCcpEntitlementFromQuery)(ccpEntitlementIdData) : undefined;
    const { data: ccpEntitlementTxaIdData, loading: ccpEntitlementTxaIdLoading, error: ccpEntitlementTxaIdError } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $iDfyh.CcpTransactionAccountIdQuery), {
        variables: {
            entitlementId: ccpEntitlementId
        },
        skip: skipDeepLinks || !isCcpBackend || !ccpEntitlementId,
        client: (0, $gKr8t.getAGGClient)()
    });
    if (skipDeepLinks) return {
        commerceBackendName: null,
        planSelectionDeepLink: undefined,
        planConsentDeepLink: undefined,
        subscriptionDetailsDeepLink: undefined,
        loading: false,
        errorMessage: undefined
    };
    let errorMessage;
    let planSelectionDeepLink;
    let planConsentDeepLink;
    let subscriptionDetailsDeepLink;
    try {
        const entitlementId = ccpEntitlementId;
        const transactionAccountId = ccpEntitlementTxaIdData?.ccp?.entitlement?.transactionAccountId;
        const commerceParams = {
            cloudId: cloudId,
            commerceBackendName: commerceBackendName,
            environment: environment,
            entitlementId: entitlementId,
            orgId: orgId,
            transactionAccountId: transactionAccountId
        };
        planSelectionDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanSelectionLink(commerceParams));
        planConsentDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanConsentLink({
            targetEdition: targetEdition,
            ...commerceParams
        }));
        subscriptionDetailsDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildSubscriptionDetailsLink(commerceParams));
        // Mark all graphql errors as handled since we will return the fallback plan selection url
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementIdError);
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementTxaIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementTxaIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementTxaIdError);
        if (commerceBackendNameError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving Commerce Backend Service', commerceBackendNameError);
        else if (ccpEntitlementIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Entitlement Id', ccpEntitlementIdError);
        else if (ccpEntitlementTxaIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Transaction Account Id', ccpEntitlementTxaIdError);
    } catch (e) {
        errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error in useCommerceDeepLinks', e);
    }
    const loading = commerceBackendNameLoading || ccpEntitlementIdLoading || ccpEntitlementTxaIdLoading;
    return {
        commerceBackendName: commerceBackendName,
        planSelectionDeepLink: planSelectionDeepLink,
        planConsentDeepLink: planConsentDeepLink,
        subscriptionDetailsDeepLink: subscriptionDetailsDeepLink,
        loading: loading,
        errorMessage: errorMessage
    };
};

});
parcelRegister("6bHqX", function(module, exports) {

$parcel$export(module.exports, "COMMERCE_BACKEND_HAMS", () => $30c48f23b8aa47be$export$56507f8f3f7349a5);
$parcel$export(module.exports, "COMMERCE_BACKEND_CCP", () => $30c48f23b8aa47be$export$9a39331b1bb2f849);
$parcel$export(module.exports, "fetchCommerceRolloutInformation", () => $30c48f23b8aa47be$export$49ab1426acf387e4);

var $gwFzn = parcelRequire("gwFzn");

var $gstll = parcelRequire("gstll");
var $6H9BA = parcelRequire("6H9BA");

var $4Twfb = parcelRequire("4Twfb");

var $3yFL2 = parcelRequire("3yFL2");
var $3SLm1 = parcelRequire("3SLm1");
var $cEhot = parcelRequire("cEhot");

var $1Y5Zp = parcelRequire("1Y5Zp");
const $30c48f23b8aa47be$var$BILLING_API_GATEWAY_URL = `${(0, $gstll.GATEWAY_URL)}/bag`;
const $30c48f23b8aa47be$export$56507f8f3f7349a5 = 'HAMS';
const $30c48f23b8aa47be$export$9a39331b1bb2f849 = 'CCP';
const $30c48f23b8aa47be$export$49ab1426acf387e4 = async (params, { fetch: fetch })=>{
    try {
        const response = await fetch(`${$30c48f23b8aa47be$var$BILLING_API_GATEWAY_URL}/rollout/service?cloudId=${encodeURIComponent(params.cloudId)}`);
        if (response.status !== 200) return {
            payload: undefined,
            error: `Failed to fetch commerce rollout information: ${response.statusText}`,
            exception: undefined
        };
        const service = (await response.json()).service;
        return {
            payload: service === 'CCP' ? {
                commerceBackend: service,
                ccp: {}
            } : {
                commerceBackend: service,
                hams: {}
            },
            error: undefined,
            exception: undefined
        };
    } catch (exception) {
        return {
            payload: undefined,
            error: undefined,
            exception: exception
        };
    }
};
const $30c48f23b8aa47be$export$532017a098b73852 = (params, options)=>{
    const fetch = (0, $6H9BA.useCommerceFetch)();
    const effectiveOptions = (0, $gwFzn.useMemo)(()=>({
            fetch: fetch,
            ...options
        }), [
        fetch,
        options
    ]);
    const startTask = (0, $cEhot.useTaskTracker)({
        action: 'fetched',
        actionSubject: 'commerceRolloutInformation',
        source: 'unknown'
    });
    return (0, $4Twfb.useFetchService)((0, $gwFzn.useCallback)(async ()=>{
        const taskResult = await startTask(async ()=>{
            const result = await $30c48f23b8aa47be$export$49ab1426acf387e4(params, effectiveOptions);
            if ((0, $1Y5Zp.isSuccessful)(result)) return {
                succeed: {
                    payload: result.payload
                }
            };
            else if ((0, $1Y5Zp.isException)(result)) // fetch can sometimes throw, but most likely this is a bug
            return {
                fail: {
                    payload: result.exception,
                    loggablePayload: result.exception,
                    responsibleService: (0, $3SLm1).COMMERCE_LIBRARIES,
                    probabilityOfBug: (0, $3yFL2).GUARANTEED
                }
            };
            return {
                // Failed response from server.
                fail: {
                    payload: result.error,
                    responsibleService: (0, $3SLm1).BILLING_API_GATEWAY,
                    // TODO: Review HTTP codes to differentiate between bug and normal errors
                    probabilityOfBug: (0, $3yFL2).MAYBE
                }
            };
        });
        if (taskResult.succeed !== undefined) return taskResult.succeed.payload;
        throw taskResult.fail.payload;
    }, [
        startTask,
        params,
        effectiveOptions
    ]));
};

});
parcelRegister("gstll", function(module, exports) {

$parcel$export(module.exports, "GATEWAY_URL", () => $973c3a69f9510c45$export$91e8019c72e4e6d);
// top level domain should have a stargate proxy under this path
// see https://developer.atlassian.com/platform/stargate/concepts/domains/
const $973c3a69f9510c45$export$91e8019c72e4e6d = `/gateway/api`;

});

parcelRegister("6H9BA", function(module, exports) {

$parcel$export(module.exports, "useCommerceFetch", () => $5f57f8a421838b9c$export$5f844fc0012b62a);

var $gwFzn = parcelRequire("gwFzn");

var $4u5NT = parcelRequire("4u5NT");

var $goqBE = parcelRequire("goqBE");

var $bIMHH = parcelRequire("bIMHH");

var $1cK19 = parcelRequire("1cK19");

var $1EMUC = parcelRequire("1EMUC");

var $lzJ3V = parcelRequire("lzJ3V");
const $5f57f8a421838b9c$export$5f844fc0012b62a = ()=>{
    const commerceContextFetch = (0, $1EMUC.useCommerceOverride)(fetch);
    const dispatchSentryException = (0, $bIMHH.useSentryExceptionDispatch)();
    return (0, $gwFzn.useCallback)(async (...args)=>{
        const startTime = performance.now();
        const [fetchInput] = args;
        const sanitizedUrl = (0, $1cK19.sanitizeUrlString)((0, $lzJ3V.getRequestUrl)(fetchInput));
        try {
            const response = await commerceContextFetch(...args);
            if (response.status >= 400) dispatchSentryException({
                exception: new Error(`Status: ${response.status}\nURL: ${sanitizedUrl}`)
            });
            (0, $4u5NT.addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now(), JSON.stringify(response).length);
            return response;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            const oldErrorMessage = (()=>{
                if (error instanceof Error) return error.stack ?? error.toString();
                else return JSON.stringify(error);
            })();
            const newErrorMessage = `An error occurred when fetching from ${sanitizedUrl}\n\n ${oldErrorMessage}`;
            const wrappedError = new Error(newErrorMessage);
            dispatchSentryException({
                exception: wrappedError
            });
            throw error;
        }
    }, [
        commerceContextFetch,
        dispatchSentryException
    ]);
};
const $5f57f8a421838b9c$export$2eeff918208c7909 = (request, dispatchSentryException)=>request.catch((error)=>{
        // reportHttpError doesn't dispatch url as HttpResponseError has a resource name in the message
        if (error instanceof (0, $goqBE.HttpResponseError)) dispatchSentryException({
            exception: error
        });
        const oldErrorMessage = (()=>{
            if (error instanceof Error) return error.stack ?? error.toString();
            else return JSON.stringify(error);
        })();
        const newErrorMessage = `An error occurred when fetching data\n\n ${oldErrorMessage}`;
        dispatchSentryException({
            exception: new Error(newErrorMessage)
        });
        return error;
    });

});
parcelRegister("goqBE", function(module, exports) {

$parcel$export(module.exports, "HttpResponseError", () => $de24e055bcb736b9$export$d2f2761cbe9cebf2);
$parcel$export(module.exports, "rejectOnHttpError", () => $de24e055bcb736b9$export$a4c208475de70990);
class $de24e055bcb736b9$export$d2f2761cbe9cebf2 extends Error {
    constructor(resourceName, statusCode, body){
        super(`Unable to fetch ${resourceName}, status: ${statusCode}`);
        this.statusCode = void 0;
        this.body = void 0;
        this.name = 'HttpResponseError';
        this.statusCode = statusCode;
        this.body = body;
        // necessary as Subclassing Error needs special treatment in typescript for some compilation targets
        //https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $de24e055bcb736b9$export$d2f2761cbe9cebf2.prototype);
    }
}
const $de24e055bcb736b9$export$a4c208475de70990 = async (resourceName, response)=>{
    const res = await response;
    if (res.ok) return response;
    throw new $de24e055bcb736b9$export$d2f2761cbe9cebf2(resourceName, res.status, // ignore error if there is no body,
    // there is no way to check if body is set as https://developer.mozilla.org/en-US/docs/Web/API/Body/bodyUsed is not supported by many browsers
    await res.json().catch(()=>undefined));
};

});

parcelRegister("bIMHH", function(module, exports) {

$parcel$export(module.exports, "useSentryExceptionDispatch", () => $48dc7deec6188f73$export$cf4d833c52e18bed);

var $aNwpq = parcelRequire("aNwpq");

var $k6lJw = parcelRequire("k6lJw");

var $6YLhE = parcelRequire("6YLhE");
const { useBreadcrumbedEventDispatch: $48dc7deec6188f73$export$3c3f21d4489e178a } = (0, $aNwpq.internalGasV3UIEventChannel);
const { useEventDispatch: $48dc7deec6188f73$export$5e75c4fb0a07e6f4 } = (0, $aNwpq.internalGasV3ScreenEventChannel);
const { useBreadcrumbedEventDispatch: $48dc7deec6188f73$export$eb1dac57abae25e8 } = (0, $aNwpq.internalGasV3TrackEventChannel);
const { useBreadcrumbedEventDispatch: $48dc7deec6188f73$export$ab6d20b2228c09c6 } = (0, $aNwpq.internalGasV3OperationalEventChannel);
const { useBreadcrumbedEventDispatch: $48dc7deec6188f73$export$cf4d833c52e18bed } = (0, $aNwpq.internalSentryExceptionChannel);
const $48dc7deec6188f73$export$8eb9a37a282b8ea6 = (0, $k6lJw.createAtlaskitToEventChannelRepackager)($48dc7deec6188f73$export$3c3f21d4489e178a);
const { Listener: $48dc7deec6188f73$export$d6cab26720f11779 } = (0, $aNwpq.breadcrumbMountedEventChannel);
const $48dc7deec6188f73$export$794ea2871d096951 = (Component, name, attributes)=>(0, $6YLhE.withBreadcrumb)(Component, (0, $aNwpq.Breadcrumb), name, attributes);

});
parcelRegister("aNwpq", function(module, exports) {

$parcel$export(module.exports, "breadcrumbMountedEventChannel", () => $48f3d8edf25a7fa7$export$1622e7b9340efb0);
$parcel$export(module.exports, "Breadcrumb", () => $48f3d8edf25a7fa7$export$dabcc1ec9dd9d1cc);
$parcel$export(module.exports, "internalGasV3UIEventChannel", () => $48f3d8edf25a7fa7$export$b7973f9532f3f87f);
$parcel$export(module.exports, "internalGasV3ScreenEventChannel", () => $48f3d8edf25a7fa7$export$5a78c7e669ed705e);
$parcel$export(module.exports, "internalGasV3TrackEventChannel", () => $48f3d8edf25a7fa7$export$90a2fbbf51eb525f);
$parcel$export(module.exports, "internalGasV3OperationalEventChannel", () => $48f3d8edf25a7fa7$export$c70a8fa9e6b52c91);
$parcel$export(module.exports, "internalSentryExceptionChannel", () => $48f3d8edf25a7fa7$export$d9101fe70b7457a1);

var $6YLhE = parcelRequire("6YLhE");

var $eUjEX = parcelRequire("eUjEX");
const $48f3d8edf25a7fa7$var$breadcrumbAPI = (0, $6YLhE.createBreadcrumbAPI)();
const { breadcrumbMountedEventChannel: $48f3d8edf25a7fa7$export$1622e7b9340efb0, Breadcrumb: $48f3d8edf25a7fa7$export$dabcc1ec9dd9d1cc, useGetBreadcrumbs: $48f3d8edf25a7fa7$export$a841c408695b0137 } = $48f3d8edf25a7fa7$var$breadcrumbAPI;
const $48f3d8edf25a7fa7$export$58a908b728d2cddc = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$34eb9485fd3a664a = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$fb5e587076f78057 = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$f92d259194a988f8 = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$d9c23c680d73705d = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$b7973f9532f3f87f = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$5a78c7e669ed705e = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$90a2fbbf51eb525f = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$c70a8fa9e6b52c91 = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$d9101fe70b7457a1 = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));

});
parcelRegister("6YLhE", function(module, exports) {

$parcel$export(module.exports, "createBreadcrumbAPI", () => $098bf883a354e4d9$export$783e5d823c500873);
$parcel$export(module.exports, "createBreadcrumbedEventChannel", () => $098bf883a354e4d9$export$d3653322274df895);
$parcel$export(module.exports, "withBreadcrumb", () => $098bf883a354e4d9$export$794ea2871d096951);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $eUjEX = parcelRequire("eUjEX");
const $098bf883a354e4d9$var$emptyObject = {};
const $098bf883a354e4d9$export$783e5d823c500873 = ()=>{
    const context = /*#__PURE__*/ (0, $gwFzn.createContext)(()=>undefined);
    const useGetBreadcrumbs = ()=>(0, $gwFzn.useContext)(context);
    const breadcrumbMountedEventChannel = (0, $eUjEX.createEventChannel)();
    const { useEventDispatch: useEventDispatch } = breadcrumbMountedEventChannel;
    const EmitEventOnMount = ({ name: name, getMountedBreadcrumbPayload: getMountedBreadcrumbPayload })=>{
        const eventDispatch = useEventDispatch();
        (0, $gwFzn.useEffect)(()=>{
            // Should always be defined at this point.
            eventDispatch(getMountedBreadcrumbPayload());
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            name
        ]);
        return null;
    };
    const Breadcrumb = ({ children: children, ...breadcrumbPayload })=>{
        const getParentBreadcrumbs = useGetBreadcrumbs();
        // TODO: Type inference doesn't seem to understand that children and name are never a part of breadcrumbPayload. Investigate and fix.
        const castBreadcrumbPayload = breadcrumbPayload;
        // Prevents breadcrumb callback from being recreated everytime props change/every-render
        const breadcrumbRef = (0, $gwFzn.useRef)(castBreadcrumbPayload);
        (0, $gwFzn.useLayoutEffect)(()=>{
            // Ensures that the breadcrumb only updates when it component is mounted
            breadcrumbRef.current = castBreadcrumbPayload;
        });
        // TODO: Memoize this in the future?
        const getMountedBreadcrumbPayload = (0, $gwFzn.useCallback)(()=>({
                breadcrumbs: [
                    ...getParentBreadcrumbs()?.breadcrumbs ?? [],
                    breadcrumbRef.current
                ],
                payload: breadcrumbRef.current
            }), [
            getParentBreadcrumbs
        ]);
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)(EmitEventOnMount, {
                    name: breadcrumbPayload.name,
                    getMountedBreadcrumbPayload: getMountedBreadcrumbPayload
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)(context.Provider, {
                    value: getMountedBreadcrumbPayload,
                    children: children
                })
            ]
        });
    };
    return {
        breadcrumbMountedEventChannel: /**
		 * An event channel whos event represents that a breadcrumb was mounted
		 */ breadcrumbMountedEventChannel,
        Breadcrumb: Breadcrumb,
        useGetBreadcrumbs: useGetBreadcrumbs
    };
};
const $098bf883a354e4d9$export$d3653322274df895 = ({ useGetBreadcrumbs: useGetBreadcrumbs }, createEventChannelFn = (0, $eUjEX.createEventChannel))=>{
    const { Listener: Listener, useEventDispatch: useEventDispatch } = createEventChannelFn();
    const useBreadcrumbedEventDispatch = ()=>{
        const eventDispatch = useEventDispatch();
        const getParentBreadcrumbs = useGetBreadcrumbs();
        const breadcrumbedEventDispatch = (0, $gwFzn.useCallback)((payload)=>eventDispatch({
                breadcrumbs: getParentBreadcrumbs()?.breadcrumbs ?? [],
                payload: payload
            }), [
            getParentBreadcrumbs,
            eventDispatch
        ]);
        return breadcrumbedEventDispatch;
    };
    return {
        Listener: Listener,
        useEventDispatch: useEventDispatch,
        useBreadcrumbedEventDispatch: useBreadcrumbedEventDispatch
    };
};
const $098bf883a354e4d9$export$794ea2871d096951 = (Component, Breadcrumb, name, // TODO: Fix up this type
breadcrumbFields = $098bf883a354e4d9$var$emptyObject)=>{
    const ComponentWithBreadcrumb = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)(Breadcrumb, {
            ...breadcrumbFields,
            name: name,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                ...props
            })
        });
    return ComponentWithBreadcrumb;
};

});
parcelRegister("eUjEX", function(module, exports) {

$parcel$export(module.exports, "createCatchingEventChannel", () => $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e);
$parcel$export(module.exports, "createEventChannel", () => $e0bd124d99ee3c1b$export$7b182ad6fa711a33);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e = (defaultOnEventCallback)=>{
    const context = /*#__PURE__*/ (0, $gwFzn.createContext)(defaultOnEventCallback);
    const useEventDispatch = ()=>{
        const onEventCallback = (0, $gwFzn.useContext)(context);
        const fireEventCallback = (0, $gwFzn.useCallback)((event)=>{
            onEventCallback?.(event);
        }, [
            onEventCallback
        ]);
        return fireEventCallback;
    };
    const EventCatcher = ({ onEvent: onEvent, children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)(context.Provider, {
            value: onEvent,
            children: children
        });
    return {
        Listener: EventCatcher,
        useEventDispatch: useEventDispatch
    };
};
const $e0bd124d99ee3c1b$export$7b182ad6fa711a33 = ()=>{
    const catchingEventChannel = $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e();
    const ListenerThatDoesntConsumeEvent = $e0bd124d99ee3c1b$export$a5fa32b3c7f79e99({
        from: catchingEventChannel.Listener,
        to: catchingEventChannel.useEventDispatch
    });
    return {
        Listener: ListenerThatDoesntConsumeEvent,
        useEventDispatch: catchingEventChannel.useEventDispatch
    };
};
const $e0bd124d99ee3c1b$export$21d0f08655d40180 = (...listenersToCombine)=>{
    const CombinedListener = ({ children: children, onEvent: onEvent })=>{
        let wrappedChildren = children;
        for (const ListenerToCombine of listenersToCombine)wrappedChildren = ListenerToCombine({
            onEvent: onEvent,
            children: wrappedChildren
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: wrappedChildren
        });
    };
    return CombinedListener;
};
const $e0bd124d99ee3c1b$export$9591aa59b8e3deeb = ({ from: inboundListenerValue, to: useOutboundEventDispatch, useTransformer: useTransformer })=>{
    const InboundListener = Array.isArray(inboundListenerValue) ? $e0bd124d99ee3c1b$export$21d0f08655d40180(...inboundListenerValue) : inboundListenerValue;
    const Transformer = ({ children: children, ...transformerProps })=>{
        const dispatchTransformedEvent = useOutboundEventDispatch();
        const transform = useTransformer(transformerProps);
        const transformFn = (0, $gwFzn.useCallback)((payload)=>{
            const transformed = transform(payload);
            dispatchTransformedEvent(transformed);
        }, [
            dispatchTransformedEvent,
            transform
        ]);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(InboundListener, {
            onEvent: transformFn,
            children: children
        });
    };
    return Transformer;
};
const $e0bd124d99ee3c1b$export$a5fa32b3c7f79e99 = ({ from: from, to: to })=>{
    const ListenerThatDoesntConsumeEvent = $e0bd124d99ee3c1b$export$9591aa59b8e3deeb({
        from: from,
        to: to,
        useTransformer: ({ onEvent: onEvent })=>(0, $gwFzn.useCallback)((payload)=>{
                onEvent(payload);
                return payload;
            }, [
                onEvent
            ])
    });
    return ListenerThatDoesntConsumeEvent;
};
const $e0bd124d99ee3c1b$export$6c91a1925c226122 = (Listener, filter)=>{
    const FilteredListener = ({ onEvent: onEvent, ...other })=>{
        const filteredOnEvent = (0, $gwFzn.useCallback)((eventPayload)=>{
            if (filter(eventPayload)) onEvent(eventPayload);
        }, [
            onEvent
        ]);
        return Listener({
            onEvent: filteredOnEvent,
            ...other
        });
    };
    return FilteredListener;
};
const $e0bd124d99ee3c1b$export$acca048df1683b81 = (children, components)=>{
    let wrappedChildren = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
    for(let i = components.length - 1; i >= 0; i--){
        const { Listener: Listener, onEvent: onEvent } = components[i];
        wrappedChildren = /*#__PURE__*/ (0, $7UHDa.jsx)(Listener, {
            onEvent: onEvent,
            children: wrappedChildren
        });
    }
    return wrappedChildren;
};

});



parcelRegister("k6lJw", function(module, exports) {

$parcel$export(module.exports, "createAtlaskitToEventChannelRepackager", () => $39d282bcf5375d57$export$1ec809871e34d2f0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kDuN4 = parcelRequire("kDuN4");
var $inPa6 = parcelRequire("inPa6");
const $39d282bcf5375d57$var$ATLASKIT_CHANNEL = 'atlaskit';
const $39d282bcf5375d57$export$b1e3a2222bb9a86d = (useEventDispatch, channel)=>{
    const RepackageAnalyticsNextEvent = ({ children: children, ...uiProperties })=>{
        const dispatchAnalytics = useEventDispatch();
        const repackageAtlaskitEvent = (0, $gwFzn.useCallback)((event)=>{
            dispatchAnalytics({
                ...uiProperties,
                ...event.payload,
                attributes: {
                    ...uiProperties.attributes,
                    ...event.payload.attributes
                }
            });
        }, [
            dispatchAnalytics,
            uiProperties
        ]);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDuN4.default), {
            channel: channel,
            onEvent: repackageAtlaskitEvent,
            children: children
        });
    };
    return RepackageAnalyticsNextEvent;
};
const $39d282bcf5375d57$export$1ec809871e34d2f0 = (// TODO: Technically, we can make the type more specific than just UIAnalyticsPayload
useEventDispatch)=>{
    const RepackageAtlaskitEvent = $39d282bcf5375d57$export$b1e3a2222bb9a86d(useEventDispatch, 'atlaskit');
    return RepackageAtlaskitEvent;
};
const $39d282bcf5375d57$export$ad0c43fbe23d07ab = (Listener, channel = $39d282bcf5375d57$var$ATLASKIT_CHANNEL)=>{
    return ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
        const fireAsAtlaskitEvent = (0, $gwFzn.useCallback)((payload)=>{
            createAnalyticsEvent(payload).fire(channel);
        }, [
            createAnalyticsEvent
        ]);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Listener, {
            onEvent: fireAsAtlaskitEvent,
            children: children
        });
    };
};

});


parcelRegister("1cK19", function(module, exports) {

$parcel$export(module.exports, "sanitizeUrlString", () => $3031758fc3a9c9bd$export$ceb09b958e605eff);
/**
 * @param url The URL you want to sanitize
 * @returns A URL string without any user generated content (UGC) or PII (personally identifiable information). The URL will not necessarily be valid URL.
 */ const $3031758fc3a9c9bd$export$ceb09b958e605eff = (url)=>{
    // TODO: Should redact anything not from atlassian.com/atlassian.net/bitbucket.org/etc
    return url.replace(/\?.*$/, '');
};

});

parcelRegister("1EMUC", function(module, exports) {

$parcel$export(module.exports, "useCommerceOverride", () => $fb2833db791c8fde$export$cf6f15ae0c6d3b84);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $9Bcp3 = parcelRequire("9Bcp3");
const $fb2833db791c8fde$export$8d3ccdf5c3b9600a = ({ children: children, overrides: overrides })=>{
    const [registry] = (0, $gwFzn.useState)(()=>new Map(overrides));
    (0, $gwFzn.useEffect)(()=>{
        const callbacks = overrides.map(([subject, target])=>$fb2833db791c8fde$export$87a46fc2314946e0(registry, subject, target));
        return ()=>callbacks.forEach((cb)=>cb());
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    overrides);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9Bcp3.overrideContext).Provider, {
        value: registry,
        children: children
    });
};
const $fb2833db791c8fde$export$edb6244a86733174 = ()=>(0, $gwFzn.useContext)((0, $9Bcp3.overrideContext));
const $fb2833db791c8fde$export$87a46fc2314946e0 = (registry, subject, override)=>{
    registry.set(subject, override);
    return ()=>{
        registry.delete(subject);
    };
};
const $fb2833db791c8fde$export$9218bfcced62f524 = (registry, subject)=>{
    return registry.get(subject) || subject;
};
const $fb2833db791c8fde$export$cf6f15ae0c6d3b84 = (subject)=>{
    const registry = $fb2833db791c8fde$export$edb6244a86733174();
    return (registry || new Map()).get(subject) || subject;
};
const $fb2833db791c8fde$export$ef191f4a42af511d = (subject, target)=>[
        subject,
        target
    ];

});
parcelRegister("9Bcp3", function(module, exports) {

$parcel$export(module.exports, "overrideContext", () => $0f5923cabface8ba$export$81b0387840a1a60c);
// eslint-disable-next-line import/no-extraneous-dependencies

var $gwFzn = parcelRequire("gwFzn");
const $0f5923cabface8ba$export$81b0387840a1a60c = (0, $gwFzn.createContext)(new Map());

});


parcelRegister("lzJ3V", function(module, exports) {

$parcel$export(module.exports, "getRequestUrl", () => $8b805f09b2bef0e7$export$14619c0eed01a470);
const $8b805f09b2bef0e7$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;

});


parcelRegister("4Twfb", function(module, exports) {

$parcel$export(module.exports, "useFetchService", () => $b022c09cd7385a9a$export$ff7e5879ade03276);
$parcel$export(module.exports, "useUpdateService", () => $b022c09cd7385a9a$export$18e513c1248d8ad5);
// eslint-disable-next-line import/no-extraneous-dependencies

var $gwFzn = parcelRequire("gwFzn");
const $b022c09cd7385a9a$export$6de4685a6c88b4e9 = (request, initialState = {
    loading: false,
    data: undefined,
    error: undefined
})=>{
    const [state, setState] = (0, $gwFzn.useState)(initialState);
    const fetchData = (0, $gwFzn.useCallback)(async (...requestArgs)=>{
        setState({
            loading: true,
            data: undefined,
            error: undefined
        });
        try {
            const data = await request(...requestArgs);
            setState({
                loading: false,
                data: data,
                error: undefined
            });
            return data;
        } catch (error) {
            // Casting promise error to provided type. I assumes that the person that
            // provides types know that kind of type promise will return on reject.
            setState({
                loading: false,
                data: undefined,
                error: error
            });
            throw error;
        }
    }, [
        request
    ]);
    return (0, $gwFzn.useMemo)(()=>({
            ...state,
            fetchData: fetchData
        }), [
        state,
        fetchData
    ]);
};
const $b022c09cd7385a9a$export$ff7e5879ade03276 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request, {
        loading: true,
        data: undefined,
        error: undefined
    });
    const { fetchData: fetchData } = service;
    (0, $gwFzn.useEffect)(()=>{
        // on error promise will be resolved to undefined, error instance available in state
        // eslint-disable-next-line no-console
        fetchData().catch((error)=>console.warn(error));
    }, [
        fetchData
    ]);
    return (0, $gwFzn.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            refresh: ()=>fetchData()
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$18e513c1248d8ad5 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request, {
        loading: false,
        data: undefined,
        error: undefined
    });
    return (0, $gwFzn.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            update: fetchData
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$d9765c5cd98039 = (request)=>{
    const service = $b022c09cd7385a9a$export$18e513c1248d8ad5(request);
    return (0, $gwFzn.useMemo)(()=>{
        const { update: update, ...state } = service;
        return {
            ...state,
            fetch: update
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$7077fee76310bc60 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request);
    return (0, $gwFzn.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            create: fetchData
        };
    }, [
        service
    ]);
};

});

parcelRegister("3yFL2", function(module, exports) {

$parcel$export(module.exports, "GUARANTEED", () => $46d5cbdb1ec76aac$export$6af268b89fae390b);
$parcel$export(module.exports, "MAYBE", () => $46d5cbdb1ec76aac$export$dab33e9f81ed2cbf);
$parcel$export(module.exports, "NONE", () => $46d5cbdb1ec76aac$export$c53d0f541b41b88e);
/**
 * For when the code is meant to only ever executed when a bug has ocurred.
 *
 * Note: Choosing a probability-of-bug value should not be speculate/account for specific bugs in the code base
 *
 * Examples:
 * - A top-level try-catch whos only purpose is to prevent your entire application from crashing when random exceptions are thrown
 * - HTTP 500 status code handling logic (assuming 500s only happen when the server has experienced a bug/crash)
 * - Server responses that signal that the JSON payload frontend sent was completely wrong
 * - Part of your app unexpectedly crashes
 * - Any response bodys/HTTP statuses you were not expecting to receive
 */ const $46d5cbdb1ec76aac$export$6af268b89fae390b = 'guaranteed';
const $46d5cbdb1ec76aac$export$dab33e9f81ed2cbf = 'maybe';
const $46d5cbdb1ec76aac$export$c53d0f541b41b88e = 'none';

});

parcelRegister("3SLm1", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN", () => $a2df338368098843$export$78244dbb77cfa6b6);
$parcel$export(module.exports, "UNKNOWN_EXTERNAL", () => $a2df338368098843$export$aed27a6561cc0f5c);
$parcel$export(module.exports, "COMMERCE_LIBRARIES", () => $a2df338368098843$export$983d8427a452c1b);
$parcel$export(module.exports, "HAMS", () => $a2df338368098843$export$d5a5208541f78b0);
$parcel$export(module.exports, "BILLING_API_GATEWAY", () => $a2df338368098843$export$856303030f6df405);
/**
 * Note: If you add a service here please name after what's mentioned in Microscope.
 * It'll make figuring out who to page (if we need to) easier. See: https://microscope.prod.atl-paas.net/services/commerce-libraries
 *
 * TODO: Probably worth adding some sort of build check to make sure this is enforced
 */ /**
 * It's not enforced, but if you add a service here
 */ /**
 * Generally, you'll want to use this value if you're not 100% sure who can cause the error.
 */ const $a2df338368098843$export$78244dbb77cfa6b6 = 'unknown';
const $a2df338368098843$export$aed27a6561cc0f5c = 'unknown-external';
const $a2df338368098843$export$983d8427a452c1b = 'commerce-libraries';
const $a2df338368098843$export$d5a5208541f78b0 = 'hams';
const $a2df338368098843$export$856303030f6df405 = 'billing-api-gateway';

});

parcelRegister("cEhot", function(module, exports) {

$parcel$export(module.exports, "useTaskTracker", () => $d09c0c9679eec46e$export$8ea5335bded027a0);

var $gwFzn = parcelRequire("gwFzn");

var $3yFL2 = parcelRequire("3yFL2");

var $aNwpq = parcelRequire("aNwpq");

var $in0Xj = parcelRequire("in0Xj");

var $3SLm1 = parcelRequire("3SLm1");

var $jVQXW = parcelRequire("jVQXW");
const $d09c0c9679eec46e$export$9a00dee1beb8f576 = (actionSubject)=>{
    return actionSubject.charAt(0).toUpperCase() + actionSubject.substring(1);
};
const $d09c0c9679eec46e$export$4903c942fa101973 = {
    TASK_FAILURE: 'fe.user.task.failure',
    TASK_SUCCESS: 'fe.user.task.success'
};
const $d09c0c9679eec46e$export$b921bb722afe30af = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, histogramBuckets: histogramBuckets = '4000' })=>{
    const dispatchGasV3Track = (0, $aNwpq.internalGasV3TrackEventChannel).useBreadcrumbedEventDispatch();
    const dispatchSentry = (0, $aNwpq.internalSentryExceptionChannel).useBreadcrumbedEventDispatch();
    const task = actionSubjectId ? `${actionSubjectId}` : `${action}${$d09c0c9679eec46e$export$9a00dee1beb8f576(actionSubject)}`;
    return (0, $gwFzn.useCallback)((payload)=>{
        const sharedGasV3Payload = {
            ...payload
        };
        const sendSentryEvent = (loggablePayload, eventName, eventTaskId, exceptionTags)=>{
            if (loggablePayload === undefined && [
                (0, $3yFL2.MAYBE),
                (0, $3yFL2.NONE)
            ].includes(exceptionTags.probabilityOfBug)) // Don't bother sending a payload if it's undefined and the probability of bug isn't guaranteed
            // TODO: Should enforce that it's never undefined for ProbabilityOfBug.GUARANTEED
            return;
            dispatchSentry({
                exception: loggablePayload,
                scopeContext: (0, $in0Xj.withTelemetryInfoScopeContext)({
                    tags: {
                        task: task,
                        eventName: eventName,
                        ...exceptionTags,
                        ...eventTaskId !== undefined ? {
                            eventTaskId: eventTaskId
                        } : undefined,
                        ...payload.actionSubjectId !== undefined ? {
                            actionSubjectId: payload.actionSubjectId
                        } : undefined
                    }
                })
            });
        };
        const fail = ({ loggablePayload: loggablePayload, probabilityOfBug: probabilityOfBug = (0, $3yFL2.MAYBE), eventTaskId: baseEventTaskId, responsibleService: responsibleService = (0, $3SLm1.UNKNOWN) } = {})=>{
            const eventTaskId = (()=>{
                if (baseEventTaskId !== undefined) return baseEventTaskId;
                if (probabilityOfBug === (0, $3yFL2.GUARANTEED)) {
                    if ((0, $jVQXW.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'guaranteed-bug';
                    return 'external-bug';
                }
                // Not sending any other values in fear of cardinality problems
                return undefined;
            })();
            sendSentryEvent(loggablePayload, $d09c0c9679eec46e$export$4903c942fa101973.TASK_FAILURE, eventTaskId, {
                probabilityOfBug: probabilityOfBug,
                responsibleService: responsibleService
            });
        // TODO: Consider sending some sort of GasV3 failure information
        };
        const succeed = ({ loggablePayload: loggablePayload, eventTaskId: eventTaskId, responsibleService: responsibleService = (0, $3SLm1.UNKNOWN) } = {})=>{
            sendSentryEvent(loggablePayload, $d09c0c9679eec46e$export$4903c942fa101973.TASK_SUCCESS, eventTaskId, {
                probabilityOfBug: (0, $3yFL2.NONE),
                responsibleService: responsibleService
            });
            dispatchGasV3Track(sharedGasV3Payload);
        };
        return {
            fail: fail,
            succeed: succeed
        };
    }, [
        dispatchGasV3Track,
        dispatchSentry,
        task
    ]);
};
const $d09c0c9679eec46e$export$94273a7593441cd3 = (x)=>x.succeed !== undefined;
const $d09c0c9679eec46e$export$8ea5335bded027a0 = (taskInfo)=>{
    const startTask = $d09c0c9679eec46e$export$b921bb722afe30af(taskInfo);
    const taskInfoRef = (0, $gwFzn.useRef)(taskInfo);
    // TODO: replace by useEvent once it is available. Ponyfilling with useRef for now
    const higherLevelStartTask = (0, $gwFzn.useCallback)(/**
		 * Please note that thrown errors will be interpreted as guaranteed buggy failures.
		 * @param payload This data passed into this function will be shared between both failure and successful tasks
		 */ async (callback, payload)=>{
        const { fail: fail, succeed: succeed } = startTask(payload || taskInfoRef.current);
        try {
            const result = await callback();
            if (result.succeed !== undefined) succeed(result.succeed);
            else if (result.fail !== undefined) fail(result.fail);
            else fail({
                probabilityOfBug: (0, $3yFL2.GUARANTEED),
                loggablePayload: {
                    result: result,
                    error: new Error('Could not find succeed nor fail')
                }
            });
            return result;
        } catch (err) {
            if (err instanceof TypeError && err.message === 'Failed to fetch') fail({
                probabilityOfBug: (0, $3yFL2.MAYBE),
                loggablePayload: err
            });
            else fail({
                probabilityOfBug: (0, $3yFL2.GUARANTEED),
                loggablePayload: err
            });
            throw err;
        }
    }, [
        startTask
    ]);
    return higherLevelStartTask;
};

});
parcelRegister("in0Xj", function(module, exports) {

$parcel$export(module.exports, "withTelemetryInfoScopeContext", () => $2cec5ac4f8c71665$export$c7063fd1387b3458);

var $3yFL2 = parcelRequire("3yFL2");

var $3SLm1 = parcelRequire("3SLm1");

var $jVQXW = parcelRequire("jVQXW");
const $2cec5ac4f8c71665$export$bf5f90a1a9d2de58 = ({ probabilityOfBug: probabilityOfBug, responsibleService: responsibleService })=>{
    switch(probabilityOfBug){
        case 0, $3yFL2.GUARANTEED:
            if ((0, $jVQXW.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'fatal';
            return 'error';
        case 0, $3yFL2.MAYBE:
            return 'warning';
        case 0, $3yFL2.NONE:
            return 'log';
        default:
            // Should never happen so sending critical :3
            return 'fatal';
    }
};
const $2cec5ac4f8c71665$var$severityOrdering = new Map([
    [
        'fatal',
        0
    ],
    [
        'fatal',
        1
    ],
    [
        'error',
        2
    ],
    [
        'warning',
        3
    ],
    [
        'info',
        4
    ],
    [
        'log',
        5
    ],
    [
        undefined,
        6
    ]
]);
const $2cec5ac4f8c71665$export$cae73843c52c598b = (severity1, severity2)=>{
    if ($2cec5ac4f8c71665$var$severityOrdering.get(severity1) <= $2cec5ac4f8c71665$var$severityOrdering.get(severity2)) return severity1;
    return severity2;
};
const $2cec5ac4f8c71665$export$c7063fd1387b3458 = (scopeContext)=>{
    const tags = {
        ...scopeContext.tags,
        responsibleService: scopeContext.tags.responsibleService ?? (0, $3SLm1.UNKNOWN)
    };
    return {
        ...scopeContext,
        tags: tags,
        level: $2cec5ac4f8c71665$export$bf5f90a1a9d2de58(tags)
    };
};

});
parcelRegister("jVQXW", function(module, exports) {

$parcel$export(module.exports, "responsibleServiceIncludesCommerceLibraries", () => $d91c14f6a33096f8$export$6d5fcf71bce583e2);

var $3SLm1 = parcelRequire("3SLm1");
const $d91c14f6a33096f8$export$6d5fcf71bce583e2 = (responsibleService)=>responsibleService === (0, $3SLm1.COMMERCE_LIBRARIES) || responsibleService === (0, $3SLm1.UNKNOWN);

});



parcelRegister("1Y5Zp", function(module, exports) {

$parcel$export(module.exports, "isException", () => $1fb762876766bde5$export$40f07171f4b6ee01);
$parcel$export(module.exports, "isSuccessful", () => $1fb762876766bde5$export$a7324067d5b1efd6);
const $1fb762876766bde5$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $1fb762876766bde5$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $1fb762876766bde5$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $1fb762876766bde5$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $1fb762876766bde5$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $1fb762876766bde5$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $1fb762876766bde5$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};

});


parcelRegister("kSPeY", function(module, exports) {

$parcel$export(module.exports, "CcpEntitlementQuery", () => $5246b9d6aa89737f$export$954f7c91a5fe45b);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $5246b9d6aa89737f$export$954f7c91a5fe45b = (0, $d2LG0.default)`query CcpEntitlementQuery{confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}}tenant{cloudId}}`;

});

parcelRegister("lh1MN", function(module, exports) {

$parcel$export(module.exports, "getCcpEntitlementFromQuery", () => $7f1ee6750f4adf66$export$db45730c9afae012);
const $7f1ee6750f4adf66$export$db45730c9afae012 = (data)=>{
    if (!data) return undefined;
    return data.confluence_tenantContext?.licenseStates?.confluence?.ccpEntitlementId || undefined;
};

});

parcelRegister("hfUvC", function(module, exports) {

$parcel$export(module.exports, "useCommerceRolloutInformation", () => $e7daf7179cc3ad9e$export$44d1450d6b2633f0);

var $csnse = parcelRequire("csnse");

var $gwFzn = parcelRequire("gwFzn");

var $6bHqX = parcelRequire("6bHqX");

var $bXe73 = parcelRequire("bXe73");

var $f7B1p = parcelRequire("f7B1p");

var $bQm3c = parcelRequire("bQm3c");
const $e7daf7179cc3ad9e$export$b65b36d21c9a62a9 = 'confluence.ondemand';
const $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation = (0, $csnse.default)(async (cloudId)=>{
    const rolloutInfoResult = await (0, $6bHqX.fetchCommerceRolloutInformation)({
        cloudId: cloudId,
        productKey: $e7daf7179cc3ad9e$export$b65b36d21c9a62a9
    }, {
        fetch: (0, $f7B1p.cfetch)
    });
    return rolloutInfoResult;
});
const $e7daf7179cc3ad9e$export$44d1450d6b2633f0 = (skip = false)=>{
    const [loading, setLoading] = (0, $gwFzn.useState)(true);
    const [error, setError] = (0, $gwFzn.useState)(null);
    const [commerceBackendName, setCommerceBackendName] = (0, $gwFzn.useState)(null);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    if (!cloudId) skip = true;
    (0, $gwFzn.useEffect)(()=>{
        if (skip) return;
        const fetchCommerceRolloutInformation = async ()=>{
            try {
                const rolloutInfoResult = await $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation(cloudId);
                if ((0, $bXe73.isSuccessful)(rolloutInfoResult)) setCommerceBackendName(rolloutInfoResult.payload.commerceBackend);
                else {
                    const error = (0, $bXe73.isException)(rolloutInfoResult) ? rolloutInfoResult.exception : rolloutInfoResult.error;
                    setError(error);
                }
            } catch (error) {
                error.message = `useCommerceBackendName: ${error.message}`;
                setError(error);
            } finally{
                setLoading(false);
            }
        };
        fetchCommerceRolloutInformation();
    }, [
        cloudId,
        skip
    ]);
    return {
        commerceBackendName: skip ? null : commerceBackendName,
        loading: skip ? false : loading,
        error: skip ? null : error
    };
};

});
parcelRegister("bXe73", function(module, exports) {

$parcel$export(module.exports, "isException", () => $f975479e12996987$export$40f07171f4b6ee01);
$parcel$export(module.exports, "isSuccessful", () => $f975479e12996987$export$a7324067d5b1efd6);
const $f975479e12996987$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $f975479e12996987$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $f975479e12996987$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $f975479e12996987$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $f975479e12996987$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $f975479e12996987$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $f975479e12996987$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};

});


parcelRegister("iDfyh", function(module, exports) {

$parcel$export(module.exports, "CcpTransactionAccountIdQuery", () => $c02bf2b50e0c0450$export$2fdd2568ccb720de);

var $d2LG0 = parcelRequire("d2LG0");
const $c02bf2b50e0c0450$export$2fdd2568ccb720de = (0, $d2LG0.default)`query CCPEntitlement($entitlementId:ID!){ccp{entitlement(id:$entitlementId){transactionAccountId}}}`;

});


parcelRegister("dqdrq", function(module, exports) {

$parcel$export(module.exports, "GradientCTAButton", () => $ce55fe36479bc4cf$export$d1aef6466b5ecaa5);
/* GradientCTAButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $izVB4 = parcelRequire("izVB4");

var $j4WDj = parcelRequire("j4WDj");

var $6J7Bn = parcelRequire("6J7Bn");
const $ce55fe36479bc4cf$var$StyledButton = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $6J7Bn.ButtonBase), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_iozncj": (0, $iAWao.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START)),
            "--_id2ec3": (0, $iAWao.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END)),
            "--_1wa1xp5": (0, $iAWao.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START)),
            "--_1ck0ygl": (0, $iAWao.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END)),
            "--_1jf6nc6": (0, $iAWao.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START)),
            "--_1kksnqn": (0, $iAWao.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END))
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1wgmglyw _1tnqiti9 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
            __cmplp.className
        ])
    });
});
const $ce55fe36479bc4cf$var$ButtonText = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c82smr _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
}); /**
     * A styled button with a gradient background, intended to be used as a product edition upgrade CTA button.
     */ 
const $ce55fe36479bc4cf$export$d1aef6466b5ecaa5 = ({ children: children, ...buttonProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ce55fe36479bc4cf$var$StyledButton, {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        }),
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children));
};

});
parcelRegister("j4WDj", function(module, exports) {

$parcel$export(module.exports, "GRADIENT_CTA_BUTTON_DEFAULT_START", () => $67193f3c2d75b820$export$3ff4048780acdec9);
$parcel$export(module.exports, "GRADIENT_CTA_BUTTON_DEFAULT_END", () => $67193f3c2d75b820$export$ac8ee41608bff6f4);
$parcel$export(module.exports, "GRADIENT_CTA_BUTTON_HOVER_START", () => $67193f3c2d75b820$export$12fbdde791205cea);
$parcel$export(module.exports, "GRADIENT_CTA_BUTTON_HOVER_END", () => $67193f3c2d75b820$export$7653c62635354aaf);
$parcel$export(module.exports, "GRADIENT_CTA_BUTTON_ACTIVE_START", () => $67193f3c2d75b820$export$d4accc94291dcf84);
$parcel$export(module.exports, "GRADIENT_CTA_BUTTON_ACTIVE_END", () => $67193f3c2d75b820$export$16a15d5a9b73591b);
$parcel$export(module.exports, "GRADIENT_BACKGROUND_SUBTLEST_START", () => $67193f3c2d75b820$export$fca70c3c81bb0f58);
$parcel$export(module.exports, "GRADIENT_BACKGROUND_SUBTLEST_END", () => $67193f3c2d75b820$export$f737ffc625de304f);
$parcel$export(module.exports, "GRADIENT_CTA_BUTTON_INVERTED_BORDER_START", () => $67193f3c2d75b820$export$b1ab5fb618714abb);
$parcel$export(module.exports, "GRADIENT_CTA_BUTTON_INVERTED_BORDER_END", () => $67193f3c2d75b820$export$7a262e0e9c5a1e2a);
$parcel$export(module.exports, "GRADIENT_CTA_BUTTON_SELECTED_START", () => $67193f3c2d75b820$export$71b6aed4f8256b2);
$parcel$export(module.exports, "GRADIENT_CTA_BUTTON_SELECTED_END", () => $67193f3c2d75b820$export$c9d89eb8e0b59a5a);
const $67193f3c2d75b820$export$3ff4048780acdec9 = "var(--ds-chart-purple-bolder, #8270DB)";
const $67193f3c2d75b820$export$ac8ee41608bff6f4 = "var(--ds-chart-blue-bolder, #1D7AFC)";
const $67193f3c2d75b820$export$12fbdde791205cea = "var(--ds-chart-purple-bolder-hovered, #6E5DC6)";
const $67193f3c2d75b820$export$7653c62635354aaf = "var(--ds-chart-blue-bolder-hovered, #0C66E4)";
const $67193f3c2d75b820$export$d4accc94291dcf84 = "var(--ds-chart-purple-boldest, #5E4DB2)";
const $67193f3c2d75b820$export$16a15d5a9b73591b = "var(--ds-chart-blue-boldest, #0055CC)";
const $67193f3c2d75b820$export$fca70c3c81bb0f58 = "var(--ds-background-accent-blue-subtlest, #E9F2FF)";
const $67193f3c2d75b820$export$f737ffc625de304f = "var(--ds-background-accent-purple-subtlest, #F3F0FF)";
const $67193f3c2d75b820$export$b1ab5fb618714abb = "var(--ds-border-accent-purple, #8270DB)";
const $67193f3c2d75b820$export$7a262e0e9c5a1e2a = "var(--ds-border-accent-blue, #1D7AFC)";
const $67193f3c2d75b820$export$71b6aed4f8256b2 = "var(--ds-background-discovery-bold-pressed, #352C63)";
const $67193f3c2d75b820$export$c9d89eb8e0b59a5a = "var(--ds-background-selected-bold-pressed, #09326C)";

});

parcelRegister("6J7Bn", function(module, exports) {

$parcel$export(module.exports, "ButtonBase", () => $e9beab952dc913a3$export$b0bb876e969289cd);
/* GradientCTAButtonBase.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $eEA8O = parcelRequire("eEA8O");
const $e9beab952dc913a3$export$b0bb876e969289cd = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_d16p1ano _1dqt12x7 _1toh18uv _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ktelT", function(module, exports) {

$parcel$export(module.exports, "GradientSubtleLinkButton", () => $903332396267b541$export$7e6e2bf13161f2a);
/* GradientSubtleLinkButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $izVB4 = parcelRequire("izVB4");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $903332396267b541$var$LinkWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11q7tg0z _11c82smr _zulpv77o _1e0c116y _4cvr1h6o _80omtlke _k48pmoej _1bsb1ns9 _pjrq1758 _oo9g3acm _18u01b66 _1xjxgktf _1nj117w3 _db5m7vkz _p7n67vkz _19lcht1k _1fyq13tv _1h7d1kdv _v6kc3acm",
            __cmplp.className
        ])
    });
});
const $903332396267b541$export$7e6e2bf13161f2a = ({ href: href, onClick: onClick, target: target, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($903332396267b541$var$LinkWrapper, {
        href: href,
        onClick: onClick,
        target: target,
        role: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
        label: ""
    }), children);
};

});

parcelRegister("fDbEj", function(module, exports) {

$parcel$export(module.exports, "TimeoutError", () => $3737157ebbad3bf6$export$66d311bf29d5c89c);
$parcel$export(module.exports, "waitForEditionChange", () => $3737157ebbad3bf6$export$d63cfb67ca7b2a0);

var $hp2SH = parcelRequire("hp2SH");

var $gQY3Y = parcelRequire("gQY3Y");

var $jKFU9 = parcelRequire("jKFU9");
const $3737157ebbad3bf6$var$timeNow = ()=>new Date().getTime();
const $3737157ebbad3bf6$export$66d311bf29d5c89c = new Error('TIMEOUT');
const $3737157ebbad3bf6$export$d63cfb67ca7b2a0 = (currentEdition)=>{
    if (!currentEdition) return Promise.reject(new Error('No currentEdition supplied'));
    const pollEndTime = new Date($3737157ebbad3bf6$var$timeNow() + (0, $jKFU9.CHANGE_EDITION_POLL_DURATION_MINS) * 60000).getTime();
    const pollAndResolve = (resolve, reject)=>{
        if ($3737157ebbad3bf6$var$timeNow() > pollEndTime) reject($3737157ebbad3bf6$export$66d311bf29d5c89c);
        (0, $hp2SH.getApolloClient)().query({
            query: (0, $gQY3Y.waitForEditionChangeQuery),
            errorPolicy: 'all',
            fetchPolicy: 'network-only'
        }).then((response)=>{
            const polledEdition = response.data?.tenant?.editions?.edition;
            if (polledEdition && currentEdition !== polledEdition) {
                // Write the latest edition to cache.
                (0, $hp2SH.getApolloClient)().writeQuery({
                    query: (0, $gQY3Y.waitForEditionChangeQuery),
                    data: {
                        tenant: {
                            edition: polledEdition,
                            __typename: 'ConfluenceEditions'
                        }
                    }
                });
                resolve(polledEdition);
            } else setTimeout(()=>{
                pollAndResolve(resolve, reject);
            }, (0, $jKFU9.CHANGE_EDITION_POLL_INTERVAL_SECS) * 1000);
        }).catch(reject);
    };
    return new Promise((resolve, reject)=>pollAndResolve(resolve, reject));
};

});
parcelRegister("gQY3Y", function(module, exports) {

$parcel$export(module.exports, "waitForEditionChangeQuery", () => $1047f6c600fde1f6$export$291c2fa2b3781c67);

var $d2LG0 = parcelRequire("d2LG0");
const $1047f6c600fde1f6$export$291c2fa2b3781c67 = (0, $d2LG0.default)`query waitForEditionChangeQuery{tenant{editions{edition}}}`;

});

parcelRegister("jKFU9", function(module, exports) {

$parcel$export(module.exports, "CHANGE_EDITION_POLL_INTERVAL_SECS", () => $97f7046950ca68f7$export$4f9b7eb5b7999045);
$parcel$export(module.exports, "CHANGE_EDITION_POLL_DURATION_MINS", () => $97f7046950ca68f7$export$6925031fb600919f);
const $97f7046950ca68f7$export$4f9b7eb5b7999045 = 3;
const $97f7046950ca68f7$export$6925031fb600919f = 1;

});



parcelRegister("lNKOh", function(module, exports) {

$parcel$export(module.exports, "ChangeEditionSectionMessageButtonsWrapper", () => $5ea77288491beecf$export$2321d4fb07b49d13);
const $5ea77288491beecf$export$2321d4fb07b49d13 = ({ canShowUpgradeButton: canShowUpgradeButton, children: children, isSiteAdmin: isSiteAdmin, shouldShowLearnMore: shouldShowLearnMore = true })=>{
    let showUpgradeTryNowButton = false;
    let showLearnMore = true;
    let learnMoreIsPrimaryCTA = true;
    if (canShowUpgradeButton) {
        if (isSiteAdmin) showUpgradeTryNowButton = true;
        if (showUpgradeTryNowButton) {
            // NOTE: Don't show 'Learn More' CTA if it will appear in between the
            // Upgrade Edition button and a secondary feature link (like
            // "Remove this page's restrictions" button). In those cases, "Learn
            // More" CTA will be displayed at the end of the general text content,
            // outside of this component.
            showLearnMore = shouldShowLearnMore;
            learnMoreIsPrimaryCTA = false;
        }
    }
    return children({
        showUpgradeTryNowButton: showUpgradeTryNowButton,
        showLearnMore: showLearnMore,
        learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA
    });
};

});

parcelRegister("bhvFb", function(module, exports) {

$parcel$export(module.exports, "EditionSectionMessage", () => $1848832735763b59$export$d8126cfce410377d);
/* EditionSectionMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $g6wBx = parcelRequire("g6wBx");

var $gsZdA = parcelRequire("gsZdA");
const $1848832735763b59$var$contentContainerStyles = {
    regular: "_1e0c1txw _2lx21bp4 _16jlkb7n _p12f1lk2",
    isCard: "_p12f1osq"
};
const $1848832735763b59$var$sectionMessageTitleStyles = {
    regular: "_11c8nbxd _19pkidpf _syaz1fxt",
    inlineModal: "_11c8lodh _19pkze3t _n3tdpxbi"
};
const $1848832735763b59$var$sectionMessageBodyStyles = {
    withTitle: "_19pku2gc",
    noTitle: "_19pkidpf"
};
const $1848832735763b59$var$sectionMessageHeaderButtonStyles = {
    regular: "_1e0c1txw _1bahesu3 _kqswstnw _154ipxbi _1xi21ejb",
    default: "_154ixy5q _1xi2oahv",
    isCardDefault: "_1xi2xy5q",
    isCard: "_1xi2pxbi"
};
const $1848832735763b59$var$sectionMessageActionRowStyles = {
    default: "_1e0c1txw _19pkpxbi",
    right: "_1bahesu3 _166l1sbv _6ufw1q9c",
    inlineModal: "_19pk16xz _1e0c1txw"
};
const $1848832735763b59$var$sectionMessageFooterStyles = {
    default: "_x3doudwz _19pkpxbi _otyrpxbi _ca0qutpp"
};
const $1848832735763b59$var$sectionMessageContainerStyles = {
    regular: "_2rko1l7b _19pkidpf _2hwx1wug _otyridpf _18u01wug _bfhk1bhr _1e0c1txw _16jlkb7n",
    withTasteAndToneStyling: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv",
    default: "_1yt44ar7 _16qs1cd0 _p12fasau",
    flat: "_1yt44ar7 _p12fasau",
    inline: "_11c82smr",
    inlineModal: "_p12f1kdj"
};
const $1848832735763b59$export$d8126cfce410377d = ({ actions: actions, appearanceType: appearanceType, body: body, footer: footer, title: title, headerButton: headerButton, withTasteAndToneStyling: withTasteAndToneStyling = false, buttonGroupAlignment: buttonGroupAlignment = 'left' })=>{
    const withTitle = Boolean(title);
    const isCard = Boolean(buttonGroupAlignment === 'right');
    const updatedAppearanceType = appearanceType || (withTasteAndToneStyling ? (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE : (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "edition-section-message",
        className: (0, $35pXk.default)([
            $1848832735763b59$var$sectionMessageContainerStyles['regular'],
            withTasteAndToneStyling && $1848832735763b59$var$sectionMessageContainerStyles['withTasteAndToneStyling'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageContainerStyles['default'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).FLAT && $1848832735763b59$var$sectionMessageContainerStyles['flat'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE && $1848832735763b59$var$sectionMessageContainerStyles['inline'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageContainerStyles['inlineModal']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            $1848832735763b59$var$contentContainerStyles['regular'],
            isCard && $1848832735763b59$var$contentContainerStyles['isCard']
        ])
    }, withTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            $1848832735763b59$var$sectionMessageTitleStyles['regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageTitleStyles['inlineModal']
        ])
    }, title), typeof body === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div" // See https://hello.atlassian.net/browse/APOLLO-3511
    , {
        // and other code tagged with this ticket
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($g6wBx))).sanitize(body)
        },
        className: (0, $35pXk.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }, body), headerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            $1848832735763b59$var$sectionMessageHeaderButtonStyles['regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['default'],
            isCard && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCard'],
            isCard && updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCardDefault']
        ])
    }, headerButton), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $35pXk.default)([
            $1848832735763b59$var$sectionMessageActionRowStyles['default'],
            buttonGroupAlignment === 'right' && $1848832735763b59$var$sectionMessageActionRowStyles['right'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageActionRowStyles['inlineModal'],
            "actionButtons"
        ])
    }, actions), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            $1848832735763b59$var$sectionMessageFooterStyles['default']
        ])
    }, footer)));
};

});


parcelRegister("8SfNq", function(module, exports) {

$parcel$export(module.exports, "requireSuperBatch", () => $a0327ccdf3d1c822$export$89d51a91254af4d7);

var $csnse = parcelRequire("csnse");

var $6X8o4 = parcelRequire("6X8o4");

var $hBkCm = parcelRequire("hBkCm");

var $hp2SH = parcelRequire("hp2SH");

var $88NjS = parcelRequire("88NjS");

var $gNwLy = parcelRequire("gNwLy");

var $bUqLQ = parcelRequire("bUqLQ");
const $a0327ccdf3d1c822$export$41a89f309d284b76 = (0, $csnse.default)(async (client)=>{
    return client.query({
        query: (0, $bUqLQ.FrontendResourceRenderQuery),
        variables: {},
        context: {
            allowOnExternalPage: true
        }
    }).then((response)=>(response?.data?.internalFrontendResource?.resourceList || []).map((resource)=>{
            resource.attributes = resource.attributes || {};
            if (Array.isArray(resource.attributes)) resource.attributes = resource.attributes.reduce((obj, { key: key, value: value })=>{
                obj[key] = value;
                return obj;
            }, {});
            return resource;
        }) || [], (reason)=>{
        if (reason instanceof (0, $hBkCm.BadStatusError)) return [];
        throw reason;
    });
});
function $a0327ccdf3d1c822$var$createElement(type, attributes) {
    const element = document.createElement(type);
    Object.keys(attributes).forEach((attributeKey)=>element.setAttribute(attributeKey, attributes[attributeKey]));
    return element;
}
function $a0327ccdf3d1c822$var$createStyleElement(attributes) {
    return $a0327ccdf3d1c822$var$createElement('link', {
        rel: 'stylesheet',
        ...attributes
    });
}
function $a0327ccdf3d1c822$var$createSyncScriptElement(attributes) {
    attributes.crossorigin = 'anonymous';
    const element = $a0327ccdf3d1c822$var$createElement('script', attributes);
    element.async = false;
    return element;
}
function $a0327ccdf3d1c822$export$ddbd232684cf7af3(resourceList) {
    return resourceList.reduce((resources, { type: type, attributes: attributes, url: url })=>{
        if (!resources[type]) resources[type] = [];
        resources[type].push({
            attributes: attributes,
            url: url
        });
        return resources;
    }, {
        js: [],
        css: []
    });
}
function $a0327ccdf3d1c822$export$9bf2691bda54425c(url) {
    return url.replace(/externals=[^&]+&/, 'externals=__local-default__&');
}
async function $a0327ccdf3d1c822$var$fetchAndInsertJsAndCssTagsToHead() {
    const resources = await $a0327ccdf3d1c822$export$41a89f309d284b76((0, $hp2SH.getApolloClient)());
    const resourceByType = $a0327ccdf3d1c822$export$ddbd232684cf7af3(resources);
    const fragment = window.document.createDocumentFragment();
    const tagsAdded = [];
    resourceByType.js.forEach(({ url: url, attributes: attributes })=>{
        // Jquery is always statically loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
        if (attributes['data-wrm-key'] === 'com.atlassian.plugins.jquery:jquery') return;
        if (!window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) {
            // use https when running locally as some links with the
            // non-secure http protocol throws 403 locally instead of redirecting to https
            const src = $a0327ccdf3d1c822$export$9bf2691bda54425c(url);
            const tag = $a0327ccdf3d1c822$var$createSyncScriptElement({
                src: // Note: url on BE pipeline is relative
                src,
                ...attributes
            });
            tagsAdded.push(tag);
            fragment.appendChild(tag);
        }
    });
    resourceByType.css.forEach(({ url: url, attributes: attributes })=>{
        if (!window.document.querySelector(`link[data-wrm-key='${attributes['data-wrm-key']}']`)) {
            // use https when running locally as some links with the
            // non-secure http protocol throws 403 locally instead of redirecting to https
            const src = $a0327ccdf3d1c822$export$9bf2691bda54425c(url);
            const tag = $a0327ccdf3d1c822$var$createStyleElement({
                // Note: url on BE pipeline is relative
                href: src,
                ...attributes
            });
            tagsAdded.push(tag);
            fragment.appendChild(tag);
        }
    });
    if (tagsAdded.length) {
        window.document.head.appendChild(fragment);
        return (0, $88NjS.onScriptsAndCSSLoaded)(tagsAdded);
    }
    return Promise.resolve();
}
const $a0327ccdf3d1c822$export$89d51a91254af4d7 = (0, $csnse.default)(()=>{
    // NOTE: superbatch may be requested at the server side already, in which case
    // we don't need to refetch the superbatch resources again and can assume that
    // they are (or are being) loaded.
    const superbatchPromise = window.__SUPERBATCH_REQUESTED__ ? Promise.resolve() : $a0327ccdf3d1c822$var$fetchAndInsertJsAndCssTagsToHead();
    return (0, $6X8o4.liftPromiseState)(superbatchPromise.then(()=>(0, $gNwLy.overrideAJSMeta)()));
});

});
parcelRegister("88NjS", function(module, exports) {

$parcel$export(module.exports, "onScriptsAndCSSLoaded", () => $85f34d5a545e075f$export$9a852ffab1f95733);

var $6X8o4 = parcelRequire("6X8o4");
function $85f34d5a545e075f$export$9a852ffab1f95733(tags) {
    return (0, $6X8o4.liftPromiseState)(Promise.all(tags.map((script)=>{
        return new Promise((resolve)=>{
            script.onload = ()=>{
                resolve();
                script.setAttribute('data-loaded', 'true');
            };
        });
    })).then(()=>{}));
}

});

parcelRegister("gNwLy", function(module, exports) {

$parcel$export(module.exports, "overrideAJSMeta", () => $e1d7e468b9f7b2b3$export$5ca65deaeaf7b896);
function $e1d7e468b9f7b2b3$var$updateMetaTag(param, value) {
    let el = window.document.querySelector(`[name="ajs-${param}"]`);
    if (typeof value === 'undefined') {
        if (el) window.document.head.removeChild(el);
        return;
    }
    if (!el) {
        el = window.document.createElement('meta');
        el.name = `ajs-${param}`;
        window.document.head.appendChild(el);
    }
    el.content = value;
}
function $e1d7e468b9f7b2b3$export$5ca65deaeaf7b896() {
    // Only proxy window.AJS.Meta if it's already defined.
    if (window.AJS !== undefined && window.AJS.Meta !== undefined && window.AJS.Meta.set !== undefined) {
        const origMeta = window.AJS.Meta;
        const origSet = window.AJS.Meta.set;
        function proxiedSet(...args) {
            const param = args[0];
            const value = args[1];
            $e1d7e468b9f7b2b3$var$updateMetaTag(param, value);
            return origSet.apply(origMeta, args);
        }
        window.AJS.Meta.set = proxiedSet;
    }
}

});


parcelRegister("ca4OQ", function(module, exports) {

$parcel$export(module.exports, "updatePersistedStatsigOverrides", () => $a349d31427d192d8$export$ba7d7ab1019e9971);
$parcel$export(module.exports, "applyPersistedStatsigOverrides", () => $a349d31427d192d8$export$4c475fb68f50ce97);

var $c6GJD = parcelRequire("c6GJD");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $lA4l8 = parcelRequire("lA4l8");
const $a349d31427d192d8$var$STATSIG_OVERRIDES_STORAGE_KEY = (0, $1UApO.PERSISTED_KEYS_ON_SERVER)?.PERSISTED_OVERRIDES_STATSIG;
const $a349d31427d192d8$export$ba7d7ab1019e9971 = (overrides)=>(0, $e9zUf.confluenceLocalStorageInstance).setItem($a349d31427d192d8$var$STATSIG_OVERRIDES_STORAGE_KEY, overrides);
const $a349d31427d192d8$export$52ad7e3568cc3a24 = ()=>{
    const localStorageOverrides = (0, $e9zUf.confluenceLocalStorageInstance).getItem($a349d31427d192d8$var$STATSIG_OVERRIDES_STORAGE_KEY);
    const { configs: configs = {}, gates: gates = {}, layers: layers = {} } = localStorageOverrides || {};
    const urlOverrideGates = (0, $lA4l8.processQueryParamFeatureGates)();
    return {
        configs: configs,
        gates: {
            ...gates,
            ...urlOverrideGates
        },
        layers: layers
    };
};
const $a349d31427d192d8$export$4c475fb68f50ce97 = ()=>{
    const { configs: configs = {}, gates: gates = {}, layers: layers = {} } = $a349d31427d192d8$export$52ad7e3568cc3a24() || {};
    // only apply overrides if there are any, otherwise tests overrides will be wiped
    if (Object.keys(configs).length > 0 || Object.keys(gates).length > 0 || Object.keys(layers).length > 0) return (0, $c6GJD.default).setOverrides({
        configs: configs,
        layers: layers,
        gates: gates
    });
    return null;
};

});
parcelRegister("lA4l8", function(module, exports) {

$parcel$export(module.exports, "processQueryParamFeatureGates", () => $f25d1cf6f831867e$export$22dc5b768495ef8e);
const $f25d1cf6f831867e$var$getQueryParam = (url)=>{
    // eslint-disable-next-line no-restricted-syntax
    if (!url && !window.location.href) return {};
    // eslint-disable-next-line no-restricted-syntax
    const generatedUrl = new URL(url || window.location.href);
    return new URLSearchParams(generatedUrl.search);
};
function $f25d1cf6f831867e$var$parseParamGate(gate) {
    const [rawGateName, rawGateValue] = gate.split(':');
    // Set default gate value to true
    let gateValue = rawGateValue ?? 'true';
    // Convert string values to real boolean values.
    if (gateValue.toLowerCase() === 'true') gateValue = true;
    else if (gateValue.toLowerCase() === 'false') gateValue = false;
    return [
        rawGateName,
        gateValue
    ];
}
const $f25d1cf6f831867e$export$22dc5b768495ef8e = (url)=>{
    const queryParams = $f25d1cf6f831867e$var$getQueryParam(url);
    if (!queryParams?.get || !queryParams.get('fg')) return {};
    const paramGates = queryParams.get('fg').split(',');
    const urlOverrides = {};
    paramGates.forEach((gate)=>{
        const [gateName, gateValue] = $f25d1cf6f831867e$var$parseParamGate(gate);
        // filter out feature gates with non-boolean values
        if (typeof gateValue === 'boolean') urlOverrides[gateName] = gateValue;
    });
    return urlOverrides;
};

});


parcelRegister("fcF01", function(module, exports) {

$parcel$export(module.exports, "UpFlowContext", () => $f28efedc8639895a$export$82a72ebc0ad4b09b);
$parcel$export(module.exports, "UpFlowProvider", () => $f28efedc8639895a$export$60acad7768008761);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");
parcelRequire("dIouf");
var $3IBnw = parcelRequire("3IBnw");
var $hSqtY = parcelRequire("hSqtY");

var $bQm3c = parcelRequire("bQm3c");

var $1ytiN = parcelRequire("1ytiN");

var $euL71 = parcelRequire("euL71");

var $e5k34 = parcelRequire("e5k34");
const $f28efedc8639895a$export$82a72ebc0ad4b09b = /*#__PURE__*/ (0, $gwFzn.createContext)({
    shouldShowUpFlow: false,
    isSiteAdmin: false,
    cloudId: '',
    currentEdition: undefined,
    showUpFlow: ()=>{},
    hideUpFlow: ()=>{}
});
const $f28efedc8639895a$var$UPFLOW_PROVIDER_INITIAL_DATA = {
    shouldShowUpFlow: false,
    touchpointId: '',
    targetEdition: (0, $euL71.ConfluenceEdition).STANDARD,
    flow: '',
    epMessageId: ''
};
const $f28efedc8639895a$export$60acad7768008761 = ({ children: children })=>{
    const [upFlowProviderData, setUpFlowProviderData] = (0, $gwFzn.useState)($f28efedc8639895a$var$UPFLOW_PROVIDER_INITIAL_DATA);
    const upFlowProviderDataRef = (0, $gwFzn.useRef)(upFlowProviderData);
    upFlowProviderDataRef.current = upFlowProviderData;
    const { shouldShowUpFlow: shouldShowUpFlow, targetEdition: targetEdition, flow: flow, touchpointId: touchpointId, epMessageId: epMessageId } = upFlowProviderData;
    const { isSiteAdmin: isSiteAdmin, tenantId: tenantId } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { edition: currentEdition, userId: userId } = (0, $bQm3c.useSessionData)();
    const showUpFlow = (0, $gwFzn.useCallback)((data)=>{
        experienceTracker.start({
            name: (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE),
            attributes: {
                currentEdition: currentEdition || undefined,
                targetEdition: data.targetEdition,
                experience: (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE),
                experienceId: data.touchpointId
            }
        });
        setUpFlowProviderData({
            ...data,
            shouldShowUpFlow: true
        });
    }, [
        setUpFlowProviderData,
        currentEdition,
        experienceTracker
    ]);
    const hideUpFlow = (0, $gwFzn.useCallback)(()=>{
        // UpFlow calls the experience fail/abort, so we should not do it here.
        setUpFlowProviderData({
            ...upFlowProviderDataRef.current,
            shouldShowUpFlow: false,
            touchpointId: '',
            flow: '',
            epMessageId: ''
        });
    }, [
        upFlowProviderDataRef,
        setUpFlowProviderData
    ]);
    const onUpFlowOpen = ()=>{
    // no-op
    };
    const failExperienceOnError = (0, $gwFzn.useCallback)((error)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    const context = (0, $gwFzn.useMemo)(()=>({
            shouldShowUpFlow: shouldShowUpFlow,
            isSiteAdmin: isSiteAdmin,
            cloudId: tenantId,
            currentEdition: currentEdition || undefined,
            showUpFlow: showUpFlow,
            hideUpFlow: hideUpFlow
        }), [
        shouldShowUpFlow,
        isSiteAdmin,
        tenantId,
        currentEdition,
        showUpFlow,
        hideUpFlow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f28efedc8639895a$export$82a72ebc0ad4b09b.Provider, {
        value: context
    }, children, shouldShowUpFlow && targetEdition && flow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).VIRALITY,
        onError: failExperienceOnError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
        canChangeEdition: isSiteAdmin,
        cloudId: tenantId,
        currentEdition: currentEdition || undefined,
        atlassianAccountId: userId || undefined,
        flow: flow,
        product: "confluence",
        targetEdition: targetEdition,
        touchpointId: touchpointId,
        onClose: hideUpFlow,
        onOpen: onUpFlowOpen,
        epMessageId: epMessageId,
        isExperienceTrackerEnabled: true
    })) : null);
};
const { Consumer: $f28efedc8639895a$export$b3bffd4bb7da6b8f } = $f28efedc8639895a$export$82a72ebc0ad4b09b;

});

parcelRegister("d5ap9", function(module, exports) {

$parcel$export(module.exports, "ConfluenceAnalyticsListener", () => $4d278d9889e67ce9$export$1e92460c034514a4);

var $gwFzn = parcelRequire("gwFzn");

var $kDuN4 = parcelRequire("kDuN4");

var $04e9M = parcelRequire("04e9M");

var $aKUqQ = parcelRequire("aKUqQ");

var $6YtDx = parcelRequire("6YtDx");
const $4d278d9889e67ce9$var$eventTypes = [
    'sendOperationalEvent',
    'sendPageEvent',
    'sendTrackEvent',
    'sendUIEvent',
    'sendScreenEvent'
];
// Checks if content attributes should be added to this analytics events
// If so, also retrieves the contentId used to fetch those attributes
// out of the GraphQL cache.
// Currently, the only attributes added are `type` and `subType`
//
// Returns [shouldAddContentAttributes: boolean, contentId: string];
const $4d278d9889e67ce9$var$getContentAttributesInfo = (event)=>{
    if (event?.payload?.type === 'sendOperationalEvent') // Exclude operational events
    return [
        false,
        ''
    ];
    else if (event?.payload?.data?.attributes?.contentId) // Use the contentId attribute if it exists
    return [
        true,
        event?.payload?.data?.attributes?.contentId
    ];
    else if (event?.payload?.data?.objectType === 'page') // Otherwise, use the objectId if the object is a page
    return [
        true,
        event?.payload?.data?.objectId
    ];
    else // Otherwise, exclude this event because we don't have a contentId for it
    return [
        false,
        ''
    ];
};
const $4d278d9889e67ce9$export$1e92460c034514a4 = ({ children: children, apolloClient: apolloClient })=>{
    const sendAnalyticEvents = (apolloClient)=>(event)=>{
            if (!event || !event.payload) throw new Error('Analytics Web Client Payload is required');
            else if (!$4d278d9889e67ce9$var$eventTypes.includes(event.payload.type)) throw new Error(`Recieved Unknown Type for Analytics Web Client: ${event.payload.type}`);
            let contentAttributes = {};
            const [shouldAddContentAttributes, contentId] = $4d278d9889e67ce9$var$getContentAttributesInfo(event);
            if (apolloClient && shouldAddContentAttributes) contentAttributes = (0, $6YtDx.extractContentAttributes)(apolloClient, contentId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticWebClientResponse)=>{
                const newData = {
                    ...event.payload.data,
                    attributes: {
                        ...contentAttributes,
                        ...event.payload.data?.attributes
                    }
                };
                analyticWebClientResponse[event.payload.type](newData);
            });
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kDuN4.default), {
        onEvent: sendAnalyticEvents(apolloClient)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aKUqQ.EmbeddedConfluenceSource), null, children));
};

});
parcelRegister("aKUqQ", function(module, exports) {

$parcel$export(module.exports, "EmbeddedConfluenceSource", () => $0afc595234550cbb$export$b196590577ebe6b8);

var $jiJCD = parcelRequire("jiJCD");

var $gwFzn = parcelRequire("gwFzn");

var $iV5Ic = parcelRequire("iV5Ic");

var $1iSzD = parcelRequire("1iSzD");

var $iSamx = parcelRequire("iSamx");

var $caehQ = parcelRequire("caehQ");
const $0afc595234550cbb$export$b196590577ebe6b8 = ({ channel: channel, children: children })=>{
    let { embeddedConfluenceSource: embeddedConfluenceSource } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    if (!embeddedConfluenceSource && (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()) embeddedConfluenceSource = (0, $jiJCD.parse)(location.search, true).query.embeddedConfluenceSource?.toString();
    if (embeddedConfluenceSource) {
        const embeddedConfluenceSourceEventUpdater = (payload)=>(0, $caehQ.updateEmbeddedConfluenceSource)(payload, embeddedConfluenceSource);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iSamx.AddAttributesWrapper), {
            eventUpdater: embeddedConfluenceSourceEventUpdater,
            channel: channel || '*'
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};

});
parcelRegister("iV5Ic", function(module, exports) {

$parcel$export(module.exports, "useReactProps_DO_NOT_USE", () => $3365988b1c4c1737$export$df02d2df0bc6f323);

var $gwFzn = parcelRequire("gwFzn");

var $gzdsP = parcelRequire("gzdsP");
function $3365988b1c4c1737$export$df02d2df0bc6f323() {
    const unsubscribeRef = (0, $gwFzn.useRef)();
    const [embeddedConfluenceReactProps, setEmbeddedConfluenceReactProps] = (0, $gwFzn.useState)(null);
    if (!unsubscribeRef.current) {
        const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
        if (observableObject) {
            const updateProps = ()=>{
                setEmbeddedConfluenceReactProps(observableObject.object);
            };
            unsubscribeRef.current = observableObject.subscribe(updateProps);
            updateProps();
        }
    }
    (0, $gwFzn.useEffect)(()=>unsubscribeRef.current, []);
    return embeddedConfluenceReactProps;
}

});
parcelRegister("gzdsP", function(module, exports) {

$parcel$export(module.exports, "getIframeObservable_DO_NOT_USE", () => $5a1450dca323cc16$export$375e0252045b3278);

var $3XKuW = parcelRequire("3XKuW");
const $5a1450dca323cc16$export$375e0252045b3278 = ()=>window.frameElement?.[0, $3XKuW.EP_REACT_PROPS_OBSERVABLE_OBJECT] || // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
    window[0, $3XKuW.EP_REACT_PROPS_OBSERVABLE_OBJECT];

});


parcelRegister("iSamx", function(module, exports) {

$parcel$export(module.exports, "AddAttributesWrapper", () => $5e8dbc9ca8500f23$export$709fad0211a80c64);

var $gwFzn = parcelRequire("gwFzn");

var $kDuN4 = parcelRequire("kDuN4");
const $5e8dbc9ca8500f23$export$709fad0211a80c64 = ({ eventUpdater: eventUpdater, channel: channel, children: children })=>{
    const onEvent = (event)=>{
        event.update(eventUpdater);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kDuN4.default), {
        onEvent: onEvent,
        channel: channel
    }, children);
};

});

parcelRegister("caehQ", function(module, exports) {

$parcel$export(module.exports, "updateEmbeddedConfluenceSource", () => $1630c56c1c8a2ea8$export$a49142cbc66558d);
const $1630c56c1c8a2ea8$export$a49142cbc66558d = (payload, embeddedConfluenceSource)=>{
    const data = payload.data || payload; //this is needed because some events have their attributes property wrapped within data: { ... } , and some don't.
    data.attributes = {
        ...data.attributes,
        embeddedConfluenceSource: embeddedConfluenceSource
    };
    return payload;
};

});


parcelRegister("6YtDx", function(module, exports) {

$parcel$export(module.exports, "extractContentAttributes", () => $28d97015391dc398$export$84d41f0b1bd1af5b);

var $d2LG0 = parcelRequire("d2LG0");
const $28d97015391dc398$var$ExtractContentAutoAttributesSubTypeQuery = // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Read https://go/connie-relay-migration-fyi
(0, $d2LG0.default)`query ExtractContentAutoAttributesQuery($contentId:ID!){singleContent(id:$contentId){subType}}`;
const $28d97015391dc398$var$convertToAnalyticsAttribute = (value)=>{
    if (value === null) // A subType of `null` is used for non-live pages
    return false;
    else if (value === 'live') return true;
    else // Otherwise, subType was not found or the page had a subType other than 'live'.
    return undefined;
};
const $28d97015391dc398$var$gracefullyReadFromCache = (client, contentId, query)=>{
    // Apollo's `readQuery` method will throw an error if ANY of the requested fields are missing.
    // In order to gracefully read each field from the cache, we query for them one at a time in a try/catch block.
    // We don't need to do any error handling/reporting because we just want to return undefined if an error occurs.
    let data;
    try {
        data = client.readQuery({
            query: query,
            variables: {
                contentId: contentId
            }
        });
    } catch  {}
    return data;
};
const $28d97015391dc398$export$84d41f0b1bd1af5b = (client, contentId)=>{
    const subTypeData = $28d97015391dc398$var$gracefullyReadFromCache(client, contentId, $28d97015391dc398$var$ExtractContentAutoAttributesSubTypeQuery);
    return {
        isLivePage: $28d97015391dc398$var$convertToAnalyticsAttribute(subTypeData?.singleContent?.subType)
    };
};

});


parcelRegister("eJhXX", function(module, exports) {

$parcel$export(module.exports, "getUserPrivilegeFromQuery", () => $a7000458c02582d2$export$d036114e4ad5c4c3);

var $fWkVZ = parcelRequire("fWkVZ");

var $w033M = parcelRequire("w033M");

var $icMDs = parcelRequire("icMDs");
function $a7000458c02582d2$export$d036114e4ad5c4c3(queryData) {
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(queryData);
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(queryData);
    return typeof queryData === 'undefined' ? undefined : isSiteAdmin ? (0, $icMDs.UserPrivilege).SITE_ADMIN : isProductAdmin ? (0, $icMDs.UserPrivilege).PRODUCT_ADMIN : (0, $icMDs.UserPrivilege).NON_ADMIN;
}

});
parcelRegister("icMDs", function(module, exports) {

$parcel$export(module.exports, "UserPrivilege", () => $296e2d91f769f195$export$fa8745fb6d256802);
var $296e2d91f769f195$export$fa8745fb6d256802 = /*#__PURE__*/ function(UserPrivilege) {
    UserPrivilege["NON_ADMIN"] = "nonAdmin";
    UserPrivilege["PRODUCT_ADMIN"] = "productAdmin";
    UserPrivilege["SITE_ADMIN"] = "siteAdmin";
    return UserPrivilege;
}({});

});


parcelRegister("c0urc", function(module, exports) {

$parcel$export(module.exports, "ReloadType", () => $5cd029b88ef194e8$export$b2e4b0d02265baf4);
$parcel$export(module.exports, "ReloadPriority", () => $5cd029b88ef194e8$export$ec7bbfd8959ab0ea);
$parcel$export(module.exports, "QuickReloadContext", () => $5cd029b88ef194e8$export$813f95dc8c45078c);
$parcel$export(module.exports, "QuickReloadContextProvider", () => $5cd029b88ef194e8$export$b159bb10e675c5ff);

var $gwFzn = parcelRequire("gwFzn");
var $5cd029b88ef194e8$export$b2e4b0d02265baf4 = /*#__PURE__*/ function(ReloadType) {
    ReloadType["content"] = "content";
    ReloadType["comment"] = "comment";
    return ReloadType;
}({});
var $5cd029b88ef194e8$export$ec7bbfd8959ab0ea = /*#__PURE__*/ function(ReloadPriority) {
    ReloadPriority[ReloadPriority["immediate"] = 0] = "immediate";
    ReloadPriority[ReloadPriority["normal"] = 1] = "normal";
    ReloadPriority[ReloadPriority["background"] = 2] = "background";
    return ReloadPriority;
}({});
const $5cd029b88ef194e8$var$reloadAll = async (reloaders, contentId, contentIdRef, options)=>{
    // Arrange reloader by priority to ensure that lower priority reloaders are
    // called strictly after higher-priority ones
    const reloadersByPriority = Object.keys(reloaders).reduce((res, key)=>{
        const reloader = reloaders[key];
        const priority = Number(reloader.priority || 0);
        if (res[priority]) res[priority].push(reloader);
        else res[priority] = [
            reloader
        ];
        return res;
    }, []);
    // Call reloaders according to their priorities
    for (const reloaders of reloadersByPriority){
        // It is possible that by the time the execution flow reached this point,
        // user may have already transitioned to another `contentId`,
        // and in such case some reloaders may contain closures to stale/unmounted components.
        // Comparing `contentIdRef` (which contains up-to-date value)
        // with `contentId` (which is dated the same as `reloaders`) allows to detect such cases.
        const isOriginalContentId = contentIdRef.current === contentId;
        if (reloaders && isOriginalContentId) {
            const reloaderPromises = reloaders.map((reloader)=>reloader.reload(options));
            await Promise.all(reloaderPromises);
        }
    }
};
const $5cd029b88ef194e8$export$813f95dc8c45078c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    registerReloader: ()=>{},
    unregisterReloader: ()=>{},
    reloaders: {
        ["content"]: async ()=>{},
        ["comment"]: async ()=>{}
    }
});
const $5cd029b88ef194e8$export$b159bb10e675c5ff = /*#__PURE__*/ (0, $gwFzn.memo)(({ contentId: contentId, children: children })=>{
    const contentIdRef = (0, $gwFzn.useRef)(contentId);
    const isUnmountedRef = (0, $gwFzn.useRef)(false);
    const [contentReloader, setContentReloader] = (0, $gwFzn.useState)({});
    const [commentReloader, setCommentReloader] = (0, $gwFzn.useState)({});
    (0, $gwFzn.useLayoutEffect)(()=>{
        // Due to having empty dependency array the `cleanup` function will be called
        // when component unmounts.
        return ()=>{
            isUnmountedRef.current = true;
        };
    }, []);
    (0, $gwFzn.useLayoutEffect)(()=>{
        contentIdRef.current = contentId;
        // When contentId changes all reloaders have to be cleaned up, so new page
        // can register their own reloaders.
        // NOTE that reloaders are cleaned up not in the effect but in a `cleanup`
        // function that effect returns.
        return ()=>{
            if (!isUnmountedRef.current) {
                setContentReloader({});
                setCommentReloader({});
            }
        };
    }, [
        contentId
    ]);
    /**
		 * Handles common logic for registering and unregistering reloaders.
		 *
		 * @param {QuickReloaderType} reloader - The reloader object containing
		 * information about the reloader function to be registered or unregistered,
		 * including its name, types, and reloading logic.
		 * @param {(setReloader: (prevState: (prevState: ReloaderStateType) => ReloaderStateType) => void) => void} callback - A callback function that takes
		 * the setReloader function as an argument and performs the necessary logic for
		 * registering or unregistering the given reloader within the context provider.
		 * The setReloader function is used to update the state of either contentReloader
		 * or commentReloader, depending on the reloader's type.
		 */ const handleReloader = (reloader, callback)=>{
        reloader.types.forEach((type)=>{
            const setReloader = type === "comment" ? setCommentReloader : setContentReloader;
            callback(setReloader);
        });
    };
    // Allows to register multiple reload functions for specific type of data to reload.
    // For example, to reload content you need to refetch Content and ViewPageSwitcher
    // queries and possibly run some other functions, if needed.
    const registerReloader = (0, $gwFzn.useCallback)((reloader)=>{
        handleReloader(reloader, (setReloader)=>{
            setReloader((reloaders)=>({
                    ...reloaders,
                    [reloader.name]: reloader
                }));
        });
    }, []);
    const unregisterReloader = (0, $gwFzn.useCallback)((reloader)=>{
        handleReloader(reloader, (setReloader)=>{
            setReloader((reloaders)=>{
                const { [reloader.name]: _removedReloader, ...newReloaders } = reloaders;
                return newReloaders;
            });
        });
    }, []);
    // Create the context for all the reloaders
    const context = (0, $gwFzn.useMemo)(()=>({
            contentId: contentId,
            registerReloader: registerReloader,
            unregisterReloader: unregisterReloader,
            reloaders: {
                ["content"]: (options)=>$5cd029b88ef194e8$var$reloadAll(contentReloader, contentId, contentIdRef, options),
                ["comment"]: (options)=>$5cd029b88ef194e8$var$reloadAll(commentReloader, contentId, contentIdRef, options)
            }
        }), [
        contentId,
        registerReloader,
        unregisterReloader,
        contentReloader,
        commentReloader
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5cd029b88ef194e8$export$813f95dc8c45078c.Provider, {
        value: context
    }, children);
});

});

parcelRegister("97W74", function(module, exports) {

$parcel$export(module.exports, "EngagementProvider", () => (parcelRequire("iSprN")).EngagementProvider);

var $iSprN = parcelRequire("iSprN");

});
parcelRegister("iSprN", function(module, exports) {

$parcel$export(module.exports, "EngagementProvider", () => $b27b10f99376c25d$export$83b8ae7ce7b4d59c);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");
parcelRequire("dIouf");
var $3IBnw = parcelRequire("3IBnw");
var $eCryJ = parcelRequire("eCryJ");

var $bQm3c = parcelRequire("bQm3c");

var $eQlTl = parcelRequire("eQlTl");
function $b27b10f99376c25d$var$EngagementProviderComponentWrapper({ children: children }) {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const renderOnError = (0, $gwFzn.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    if (!isLicensed) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INHERIT,
        renderOnError: renderOnError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eQlTl.EngagementProviderComponent), null, children));
}
$b27b10f99376c25d$var$EngagementProviderComponentWrapper.propTypes = {
    children: (0, $fppBw.element)
};
const $b27b10f99376c25d$export$83b8ae7ce7b4d59c = $b27b10f99376c25d$var$EngagementProviderComponentWrapper;

});
parcelRegister("eQlTl", function(module, exports) {

$parcel$export(module.exports, "EngagementProviderComponent", () => $dd0f530acbd7ff69$export$cd24ff735be1c995);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $bvRYc = parcelRequire("bvRYc");

var $fw9LG = parcelRequire("fw9LG");

var $04e9M = parcelRequire("04e9M");

var $jOtRZ = parcelRequire("jOtRZ");

var $bQm3c = parcelRequire("bQm3c");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
function $dd0f530acbd7ff69$export$cd24ff735be1c995(props) {
    const { cloudId: cloudId, locale: locale, userId: userId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    if ((0, $e9zUf.confluenceSessionStorageInstance).getItem((0, $1UApO.keys).DISABLE_ENGAGEMENT_FOR_TESTS) === 'true') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, props.children);
    const config = {
        cloudId: cloudId,
        aaid: userId,
        locale: locale,
        product: 'confluence',
        stargateUrl: '/gateway/api',
        workspaceId: workspaceId,
        isFedRAMPEnvironment: false
    };
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    const coordinationOptions = (0, $gwFzn.useMemo)(()=>({
            enableChoreographer: true,
            envType: envType,
            additionalData: {
                sourceProductId: (0, $fw9LG.ProductIds).CONFLUENCE
            }
        }), [
        envType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bvRYc.default), {
        ...props,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, props.children),
        config: config,
        analyticsClientInstance: (0, $04e9M.getAnalyticsWebClient)(),
        coordinationOptions: coordinationOptions
    });
}
$dd0f530acbd7ff69$export$cd24ff735be1c995.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).element,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string
};

});
parcelRegister("bvRYc", function(module, exports) {

$parcel$export(module.exports, "default", () => $58bc48178420584b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $1DWH0 = parcelRequire("1DWH0");

var $eQ46F = parcelRequire("eQ46F");

var $38pu5 = parcelRequire("38pu5");

var $dKh1P = parcelRequire("dKh1P");
const $58bc48178420584b$var$EngagementProviderWithEvents = (0, $1DWH0.default)()((0, $dKh1P.EngagementProvider));
const $58bc48178420584b$var$EngagementProviderWithDefaultStore = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($58bc48178420584b$var$EngagementProviderWithEvents, {
        ...props,
        store: (0, $38pu5.default)(props.config)
    });
};
var $58bc48178420584b$export$2e2bcd8739ae039 = (0, $eQ46F.default)($58bc48178420584b$var$EngagementProviderWithDefaultStore);

});
parcelRegister("eQ46F", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b0df458834f5425$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
function $8b0df458834f5425$export$2e2bcd8739ae039(Component) {
    const PreventNestedInstancesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext(false);
    return function PreventNestedInstances(props) {
        return(// TODO: Replace usage of PreventNestedInstancesContext.Consumer with useContext(PreventNestedInstancesContext)
        /*#__PURE__*/ (0, $7UHDa.jsx)(PreventNestedInstancesContext.Consumer, {
            children: (shouldPreventInstantiation)=>shouldPreventInstantiation ? props.children : /*#__PURE__*/ (0, $7UHDa.jsx)(PreventNestedInstancesContext.Provider, {
                    value: true,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                        ...props
                    })
                })
        }));
    };
}

});

parcelRegister("38pu5", function(module, exports) {

$parcel$export(module.exports, "store", () => $25d7841ba52366e9$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "default", () => $25d7841ba52366e9$export$2e2bcd8739ae039);

var $atveb = parcelRequire("atveb");
parcelRequire("aRy4J");
var $a5xAk = parcelRequire("a5xAk");

var $e20kv = parcelRequire("e20kv");

var $4nGsu = parcelRequire("4nGsu");

var $4EMha = parcelRequire("4EMha");

var $a3qoL = parcelRequire("a3qoL");
const $25d7841ba52366e9$export$36d128238e6b60f5 = {
    messageMapping: new Map(),
    current: null,
    initialized: false,
    initializing: false,
    config: {
        cloudId: '',
        aaid: '',
        locale: '',
        product: '',
        stargateUrl: '',
        orgId: '',
        workspaceId: ''
    }
};
let $25d7841ba52366e9$var$processMessagesCancellationToken = (0, $e20kv.createCancellationToken)();
function $25d7841ba52366e9$export$7a10f46f72407bc5(messageMapping, component) {
    const newMapping = new Map();
    messageMapping.forEach((value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(value.component, component)) newMapping.set(key, value);
    });
    return newMapping;
}
const $25d7841ba52366e9$export$6f57813fe9f31bf9 = (0, $a5xAk.default)((state = $25d7841ba52366e9$export$36d128238e6b60f5, action)=>{
    switch(action.type){
        case 0, $4EMha.SET_MESSAGE_MAPPING:
            return {
                ...state,
                initialized: true,
                initializing: false,
                messageMapping: action.messageMapping
            };
        case 0, $4EMha.SET_INITIALIZING:
            return {
                ...state,
                config: action.config,
                initializing: true
            };
        case 0, $4EMha.SET_CURRENT:
            {
                const { eventMapping: eventMapping } = action;
                const { message: message, component: component } = eventMapping;
                const messageMapping = $25d7841ba52366e9$export$7a10f46f72407bc5(state.messageMapping, component);
                return {
                    ...state,
                    current: {
                        messageId: message.messageId,
                        variationId: message.variationId,
                        ...component
                    },
                    messageMapping: messageMapping
                };
            }
        case 0, $4EMha.CLEAR_CURRENT:
            return {
                ...state,
                current: null
            };
        case 0, $4EMha.RESET_STORE:
            return $25d7841ba52366e9$export$36d128238e6b60f5;
        default:
            return state;
    }
});
var $25d7841ba52366e9$export$2e2bcd8739ae039 = (config)=>{
    const state = $25d7841ba52366e9$export$6f57813fe9f31bf9.getState();
    if (state.initializing || state.initialized) {
        if (state.config.cloudId === config.cloudId) return $25d7841ba52366e9$export$6f57813fe9f31bf9;
        // CloudId has changed, cancel any in process processMessages request
        $25d7841ba52366e9$var$processMessagesCancellationToken.isCancelled = true;
        $25d7841ba52366e9$var$processMessagesCancellationToken = (0, $e20kv.createCancellationToken)();
        $25d7841ba52366e9$export$6f57813fe9f31bf9.dispatch((0, $4EMha.resetStore)());
    }
    const newConfig = {
        ...config
    };
    newConfig.locale = newConfig.locale.replace('_', '-');
    $25d7841ba52366e9$export$6f57813fe9f31bf9.dispatch((0, $4EMha.initialize)(newConfig));
    if ((0, $4nGsu.isMessagingEnabled)()) (0, $a3qoL.processMessages)($25d7841ba52366e9$export$6f57813fe9f31bf9, newConfig, $25d7841ba52366e9$var$processMessagesCancellationToken);
    return $25d7841ba52366e9$export$6f57813fe9f31bf9;
};

});
parcelRegister("aRy4J", function(module, exports) {

$parcel$export(module.exports, "createStore", () => (parcelRequire("a5xAk")).default);

var $a5xAk = parcelRequire("a5xAk");

var $99eZU = parcelRequire("99eZU");

var $eJpN7 = parcelRequire("eJpN7");

var $8Cveg = parcelRequire("8Cveg");

var $4Ozbf = parcelRequire("4Ozbf");
parcelRequire("1ZEmt");
/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function $7e89494aa6977a9b$var$isCrushed() {}

});
parcelRegister("a5xAk", function(module, exports) {

$parcel$export(module.exports, "ActionTypes", () => $75846c4a46277c98$export$1385d81a6c6bbcd4);
$parcel$export(module.exports, "default", () => $75846c4a46277c98$export$2e2bcd8739ae039);

var $b0C22 = parcelRequire("b0C22");

var $eviWr = parcelRequire("eviWr");
var $75846c4a46277c98$export$1385d81a6c6bbcd4 = {
    INIT: '@@redux/INIT'
};
function $75846c4a46277c98$export$2e2bcd8739ae039(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer($75846c4a46277c98$export$2e2bcd8739ae039)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $b0C22.default)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer;
        dispatch({
            type: $75846c4a46277c98$export$1385d81a6c6bbcd4.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $eviWr.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $75846c4a46277c98$export$1385d81a6c6bbcd4.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $eviWr.default] = observable, _ref2;
}

});

parcelRegister("99eZU", function(module, exports) {

var $a5xAk = parcelRequire("a5xAk");

var $b0C22 = parcelRequire("b0C22");
parcelRequire("1ZEmt");
function $6a90968abdcb9e94$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
    return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}
function $6a90968abdcb9e94$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, $a5xAk.ActionTypes).INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, $b0C22.default)(inputState)) return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $6a90968abdcb9e94$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, $a5xAk.ActionTypes).INIT
        });
        if (typeof initialState === 'undefined') throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
        var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
        if (typeof reducer(undefined, {
            type: type
        }) === 'undefined') throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + (0, $a5xAk.ActionTypes).INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    });
}
function $6a90968abdcb9e94$export$2e2bcd8739ae039(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        $6a90968abdcb9e94$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var errorMessage = $6a90968abdcb9e94$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}

});
parcelRegister("1ZEmt", function(module, exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $173acbe48b749cd9$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});


parcelRegister("eJpN7", function(module, exports) {
function $ab9946491398861d$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function $ab9946491398861d$export$2e2bcd8739ae039(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $ab9946491398861d$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $ab9946491398861d$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}

});

parcelRegister("8Cveg", function(module, exports) {

var $4Ozbf = parcelRequire("4Ozbf");
var $646a18c4e021ae0e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $646a18c4e021ae0e$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, $4Ozbf.default).apply(undefined, chain)(store.dispatch);
            return $646a18c4e021ae0e$var$_extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("4Ozbf", function(module, exports) {

$parcel$export(module.exports, "default", () => $38171f0d9a659813$export$2e2bcd8739ae039);
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $38171f0d9a659813$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}

});



parcelRegister("e20kv", function(module, exports) {

$parcel$export(module.exports, "createCancellationToken", () => $51038d8f9e47263d$export$eac027797b968991);
function $51038d8f9e47263d$export$eac027797b968991(isCancelled = false) {
    return {
        isCancelled: isCancelled
    };
}

});

parcelRegister("4EMha", function(module, exports) {

$parcel$export(module.exports, "SET_MESSAGE_MAPPING", () => $349caf1aae10645a$export$d05fe3e897340c89);
$parcel$export(module.exports, "SET_INITIALIZING", () => $349caf1aae10645a$export$eacd3ec165715d8);
$parcel$export(module.exports, "RESET_STORE", () => $349caf1aae10645a$export$874c5149d7f0e3b8);
$parcel$export(module.exports, "CLEAR_CURRENT", () => $349caf1aae10645a$export$cb5041d68cb18859);
$parcel$export(module.exports, "SET_CURRENT", () => $349caf1aae10645a$export$a9319af002a4c677);
$parcel$export(module.exports, "resetStore", () => $349caf1aae10645a$export$a20a1205b2a2b7e4);
$parcel$export(module.exports, "initialize", () => $349caf1aae10645a$export$2a47f398eeff8b01);
$parcel$export(module.exports, "setMessageMapping", () => $349caf1aae10645a$export$375dd0a76fecd4c7);
$parcel$export(module.exports, "setCurrent", () => $349caf1aae10645a$export$5f80f094fd31fffd);
$parcel$export(module.exports, "clearCurrent", () => $349caf1aae10645a$export$96105f873ade39d7);
const $349caf1aae10645a$export$d05fe3e897340c89 = 'SET_MESSAGE_MAPPING';
const $349caf1aae10645a$export$eacd3ec165715d8 = 'SET_INITIALIZING';
const $349caf1aae10645a$export$874c5149d7f0e3b8 = 'RESET_STORE';
const $349caf1aae10645a$export$cb5041d68cb18859 = 'CLEAR_CURRENT';
const $349caf1aae10645a$export$a9319af002a4c677 = 'SET_CURRENT';
const $349caf1aae10645a$export$a20a1205b2a2b7e4 = ()=>({
        type: $349caf1aae10645a$export$874c5149d7f0e3b8
    });
const $349caf1aae10645a$export$2a47f398eeff8b01 = (config)=>({
        type: $349caf1aae10645a$export$eacd3ec165715d8,
        config: config
    });
const $349caf1aae10645a$export$375dd0a76fecd4c7 = (messageMapping)=>({
        type: $349caf1aae10645a$export$d05fe3e897340c89,
        messageMapping: messageMapping
    });
function $349caf1aae10645a$export$5f80f094fd31fffd(eventMapping) {
    return {
        type: $349caf1aae10645a$export$a9319af002a4c677,
        eventMapping: eventMapping
    };
}
function $349caf1aae10645a$export$96105f873ade39d7() {
    return {
        type: $349caf1aae10645a$export$cb5041d68cb18859
    };
}

});

parcelRegister("a3qoL", function(module, exports) {

$parcel$export(module.exports, "processMessages", () => $236a1e5ddbdeb765$export$d2e92820f98a2592);

var $ll2sR = parcelRequire("ll2sR");

var $4EMha = parcelRequire("4EMha");

var $38pu5 = parcelRequire("38pu5");
const $236a1e5ddbdeb765$export$a9d4ce3abb5d2365 = (messages)=>{
    const mapping = new Map();
    messages.forEach((message)=>{
        const components = message.components;
        components.forEach((component, index)=>{
            component.triggers.forEach((trigger)=>{
                mapping.set(trigger, {
                    message: message,
                    component: {
                        componentId: index,
                        isLast: index === components.length - 1,
                        ...component
                    }
                });
            });
        });
    });
    return mapping;
};
async function $236a1e5ddbdeb765$export$d2e92820f98a2592(engagementStore, config, cancellationToken) {
    if (cancellationToken.isCancelled) return;
    const state = (0, $38pu5.store).getState();
    const { cloudId: cloudId, stargateUrl: stargateUrl, product: product, locale: locale } = config;
    let messages, interval;
    try {
        const results = await (0, $ll2sR.getMessages)(cloudId, stargateUrl, product, locale);
        if (cancellationToken.isCancelled) return;
        messages = results.messages;
        interval = results.interval;
    } catch (e) {
        // TODO: Configure metal to monitor errors here
        // Give up, don't try fetching again
        return;
    }
    // Don't overwrite the messageMapping if there's an active message
    if (state.current === null) {
        const messageMapping = $236a1e5ddbdeb765$export$a9d4ce3abb5d2365(messages);
        engagementStore.dispatch((0, $4EMha.setMessageMapping)(messageMapping));
    }
    if (interval !== 0) setTimeout(()=>{
        $236a1e5ddbdeb765$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
    }, interval * 1000);
// TODO: Configure metal to monitor success response here
}

});


parcelRegister("dKh1P", function(module, exports) {

$parcel$export(module.exports, "EngagementProvider", () => $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c);
/* eslint-disable max-lines */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hRun9 = parcelRequire("hRun9");

var $ekM9Q = parcelRequire("ekM9Q");

var $fppBw = parcelRequire("fppBw");

var $lwdd5 = parcelRequire("lwdd5");

var $feHMU = parcelRequire("feHMU");
var $kDuN4 = parcelRequire("kDuN4");

var $fw9LG = parcelRequire("fw9LG");
var $6sxJX = parcelRequire("6sxJX");

var $ll2sR = parcelRequire("ll2sR");

var $1359s = parcelRequire("1359s");

var $iMlBx = parcelRequire("iMlBx");

var $kryDa = parcelRequire("kryDa");

var $4nGsu = parcelRequire("4nGsu");

var $4EMha = parcelRequire("4EMha");

var $eUsDv = parcelRequire("eUsDv");
const $9c8bc4bcbfdac5c7$var$MAX_EVENT_QUEUE_SIZE = 100;
const $9c8bc4bcbfdac5c7$var$EK_LOADED_EVENT = 'engagement.inproduct.loaded';
const $9c8bc4bcbfdac5c7$export$5306bd00631dbf8c = 'ep.analyticEvent';
function $9c8bc4bcbfdac5c7$var$collapseEventToPayload(event) {
    const payload = {
        ...event.payload,
        context: {}
    };
    Object.assign(payload.context, ...event.context);
    return payload;
}
function $9c8bc4bcbfdac5c7$var$findMatchingTrigger(messageMapping, payload) {
    return Array.from(messageMapping.keys()).find((trigger)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($hRun9)))(payload, trigger);
    });
}
function $9c8bc4bcbfdac5c7$var$fireExposureEvent(attributes, clientOrPromise) {
    const analyticsEvent = new (0, $feHMU.default)({
        payload: {
            action: 'exposed',
            actionSubject: 'feature',
            actionSubjectId: attributes.flagKey,
            source: 'engagement-platform',
            attributes: attributes
        }
    });
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendTrackEvent(analyticsEvent.payload);
    });
}
function $9c8bc4bcbfdac5c7$var$getExposureAttributes(messageId, cohort, additionalProps) {
    return {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        flagKey: `engagement.inproduct.${messageId}`,
        value: cohort,
        ...additionalProps
    };
}
function $9c8bc4bcbfdac5c7$var$getBaseAttributes(messageId, variationId, componentId, locale) {
    return {
        messageId: messageId,
        variationId: variationId,
        componentIndex: componentId,
        locale: locale
    };
}
async function $9c8bc4bcbfdac5c7$export$473a2bbbfd90c87b(eventMapping, config, store, clientOrPromise, coordinationOptions, componentConfig) {
    const { locale: locale } = config;
    const { message: message, component: component } = eventMapping;
    if (message.holdout) {
        await (0, $ll2sR.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        await (0, $ll2sR.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        $9c8bc4bcbfdac5c7$var$fireExposureEvent($9c8bc4bcbfdac5c7$var$getExposureAttributes(message.messageId, 'holdout', {
            locale: locale
        }), clientOrPromise);
        return;
    }
    if (component.componentId === 0) {
        const success = await (0, $ll2sR.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions?.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(success ? (0, $fw9LG.MessageDeliveryStatus).STARTED : (0, $fw9LG.MessageDeliveryStatus).BLOCKED);
        if (success) {
            $9c8bc4bcbfdac5c7$var$fireExposureEvent($9c8bc4bcbfdac5c7$var$getExposureAttributes(message.messageId, message.variationId, {
                locale: locale
            }), clientOrPromise);
            store.dispatch((0, $4EMha.setCurrent)(eventMapping));
        }
    } else {
        $9c8bc4bcbfdac5c7$var$fireExposureEvent($9c8bc4bcbfdac5c7$var$getExposureAttributes(message.messageId, message.variationId, {
            locale: locale
        }), clientOrPromise);
        store.dispatch((0, $4EMha.setCurrent)(eventMapping));
    }
}
class $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c extends (0, $gwFzn.Component) {
    getConfig() {
        const { config: config } = this.getState();
        return config;
    }
    getChildContext() {
        return {
            subscribeEngagementState: this.subscribeEngagementState,
            setComponentConfig: this.setComponentConfig
        };
    }
    getState() {
        return this.props.store.getState();
    }
    getActiveMessage() {
        return this.getState().current;
    }
    async completeMessage(messageId, componentConfig) {
        const config = this.getConfig();
        const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
        const disposition = await (0, $ll2sR.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(disposition ? (0, $fw9LG.MessageDeliveryStatus).STOPPED : (0, $fw9LG.MessageDeliveryStatus).CANCELED);
    }
    handleClickEvent(messageId, variationId, componentId) {
        const activeMessage = this.getActiveMessage();
        // It is important to check that the event we're handling matches the
        // current active message because it is possible for an event to come
        // through for a past message. We don't want to mess up the current
        // message by calling clearCurrent just because the old message is done.
        if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
        let componentConfig;
        if (activeMessage.componentType) {
            const componentConfigId = this.getConfigId(activeMessage.componentType, activeMessage.target);
            componentConfig = $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
        }
        if (activeMessage.isLast) this.completeMessage(messageId, componentConfig);
        this.props.store.dispatch((0, $4EMha.clearCurrent)());
    }
    componentWillUnmount() {
        this.unsubscribeFromStore && this.unsubscribeFromStore();
    }
    render() {
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDuN4.default), {
            channel: "*",
            onEvent: this.onEvent,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDuN4.default), {
                channel: "engagement",
                onEvent: this.onEngagementEvent,
                children: this.props.children
            })
        });
    }
    constructor(props){
        super(props);
        this.analyticsEventQueue = void 0;
        this.unsubscribeFromStore = void 0;
        this.fireQueueOverflowEvent = void 0;
        this.sendUIEventWithClient = void 0;
        this.sendScreenEventWithClient = void 0;
        this.sendOperationalEventWithClient = void 0;
        this.onStoreChange = (state)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const config = this.getConfig();
            const { locale: locale } = config;
            if (state.initialized) {
                if (!$9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider) {
                    this.sendOperationalEventWithClient({
                        action: 'loaded',
                        actionSubject: 'messages',
                        actionSubjectId: undefined,
                        source: 'engagekit',
                        attributes: {
                            locale: locale
                        }
                    });
                    const browserInfo = (0, $iMlBx.getBrowserInfo)();
                    this.onEvent(createAnalyticsEvent({
                        event: $9c8bc4bcbfdac5c7$var$EK_LOADED_EVENT,
                        properties: {
                            browser: browserInfo.name,
                            browserVersion: browserInfo.version
                        }
                    }));
                    $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = true;
                }
                this.analyticsEventQueue.flush(this.onEvent);
                if (this.unsubscribeFromStore) this.unsubscribeFromStore();
            }
        };
        this.onEvent = (event)=>{
            const state = this.getState();
            if (!state.initialized) {
                const success = this.analyticsEventQueue.enqueue(event);
                if (!success) this.fireQueueOverflowEvent();
                return;
            }
            const { eventTarget: eventTarget, store: store, analyticsClientInstance: analyticsClientInstance } = this.props;
            const config = this.getConfig();
            const { current: current, messageMapping: messageMapping } = state;
            const payload = $9c8bc4bcbfdac5c7$var$collapseEventToPayload(event);
            eventTarget.dispatchEvent((0, $kryDa.default)({
                eventName: $9c8bc4bcbfdac5c7$export$5306bd00631dbf8c,
                canBubble: false,
                cancellable: false,
                detail: payload
            }));
            if (!(0, $4nGsu.isMessagingEnabled)()) return;
            // existing message found
            if (current) return;
            const trigger = $9c8bc4bcbfdac5c7$var$findMatchingTrigger(messageMapping, payload);
            // No messages found for trigger
            if (!trigger) return;
            const eventMapping = messageMapping.get(trigger);
            let componentConfig;
            if (eventMapping.component?.componentType) {
                const componentConfigId = this.getConfigId(eventMapping.component.componentType, eventMapping.component.target);
                componentConfig = $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
            }
            const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
            $9c8bc4bcbfdac5c7$export$473a2bbbfd90c87b(eventMapping, config, store, analyticsClientInstance, coordinationOptions, componentConfig);
        };
        this.onEngagementEvent = (event)=>{
            const { action: action, clickType: clickType, ekMessageId: ekMessageId, ekVariationId: ekVariationId, ekComponentId: ekComponentId, ekComponentType: ekComponentType, ekIsLast: ekIsLast } = event.payload;
            const config = this.getConfig();
            const { locale: locale } = config;
            const attributes = $9c8bc4bcbfdac5c7$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
            if (action === 'click') {
                this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                attributes.buttonType = clickType;
                this.sendUIEventWithClient({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: `${clickType}Button`,
                    source: `engagement_${ekComponentType}`,
                    attributes: attributes
                });
            } else {
                if (action === 'shown') {
                    attributes.componentType = ekComponentType;
                    this.sendScreenEventWithClient({
                        name: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
                if (action === 'hidden') {
                    attributes.isLast = ekIsLast;
                    this.sendUIEventWithClient({
                        action: 'hid',
                        actionSubject: 'component',
                        actionSubjectId: undefined,
                        source: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
            }
            this.onEvent(event);
        };
        this.subscribeEngagementState = (callback)=>{
            const { store: store } = this.props;
            callback(store.getState());
            return store.subscribe(()=>{
                callback(store.getState());
            });
        };
        this.getComponentCoordinationOptions = (componentConfig)=>{
            // Default enableChoreographer to the EngagementProvider's coordinationOptions
            const enableChoreographer = Boolean(this.props.coordinationOptions?.enableChoreographer);
            return {
                ...this.props.coordinationOptions,
                enableChoreographer: componentConfig?.messageType ? // Use the component's individual choreographer configuration, if defined,
                // regardless of the EngagementProvider's coordinationOptions
                (0, $6sxJX.shouldBeChoreographed)(componentConfig, {
                    enableChoreographer: true
                }) : enableChoreographer
            };
        };
        this.getConfigId = (componentType, engagementId)=>{
            return engagementId ? `${componentType}-${engagementId}` : componentType;
        };
        this.setComponentConfig = (componentType, config, engagementId)=>{
            const configId = this.getConfigId(componentType, engagementId);
            $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.componentConfig.set(configId, config);
            return ()=>this.removeComponentConfig(configId);
        };
        this.removeComponentConfig = (configId)=>{
            if ($9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.componentConfig.has(configId)) $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.componentConfig.delete(configId);
        };
        const { analyticsClientInstance: _analyticsClientInstance } = this.props;
        this.sendUIEventWithClient = (0, $1359s.sendUIEvent).bind(null, _analyticsClientInstance);
        this.sendScreenEventWithClient = (0, $1359s.sendScreenEvent).bind(null, _analyticsClientInstance);
        this.sendOperationalEventWithClient = (0, $1359s.sendOperationalEvent).bind(null, _analyticsClientInstance);
        this.analyticsEventQueue = new (0, $eUsDv.default)($9c8bc4bcbfdac5c7$var$MAX_EVENT_QUEUE_SIZE);
        this.unsubscribeFromStore = this.subscribeEngagementState(this.onStoreChange);
        this.fireQueueOverflowEvent = (0, (/*@__PURE__*/$parcel$interopDefault($ekM9Q)))(// TODO: create metric for this with Metal
        ()=>{});
    }
}
$9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.componentConfig = new Map();
$9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.childContextTypes = {
    subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func
};
$9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.defaultProps = {
    eventTarget: (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5)))
};
/*
 * We use this flag for ensuring that we only fire the engagement.inproduct.loaded event once. This is an interim solution
 * until we can more holistically rethink our code architecture to eliminate duplicate behaviour across EngagementProviders.
 */ $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = false;

});
parcelRegister("1359s", function(module, exports) {

$parcel$export(module.exports, "sendScreenEvent", () => $59b1b265b9049137$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendUIEvent", () => $59b1b265b9049137$export$1aecf263098db667);
$parcel$export(module.exports, "sendOperationalEvent", () => $59b1b265b9049137$export$e5f89b51c6d4e36b);
function $59b1b265b9049137$export$22a3b1671f38a193(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendScreenEvent(payload);
    });
}
function $59b1b265b9049137$export$1aecf263098db667(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendUIEvent(payload);
    });
}
function $59b1b265b9049137$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendOperationalEvent(payload);
    });
}

});

parcelRegister("iMlBx", function(module, exports) {

$parcel$export(module.exports, "getBrowserInfo", () => $812a060980ce0ea1$export$6c724a6ffa2dc3e1);
const $812a060980ce0ea1$var$browserMatchers = [
    {
        name: 'IE',
        pattern: /Trident\/.*; rv:([^;)]+)/
    },
    {
        name: 'Chrome',
        pattern: /Chrome\/([^ )]+)/
    },
    {
        name: 'Firefox',
        pattern: /Firefox\/([^ )]+)/
    }
];
const $812a060980ce0ea1$export$cda2203640e08931 = {
    name: 'unknown',
    version: 'unknown'
};
function $812a060980ce0ea1$export$6c724a6ffa2dc3e1(userAgent) {
    if (!window.navigator) return $812a060980ce0ea1$export$cda2203640e08931;
    if (!userAgent) userAgent = window.navigator.userAgent;
    for (const matcher of $812a060980ce0ea1$var$browserMatchers){
        const versionMatch = userAgent.match(matcher.pattern);
        if (versionMatch) return {
            name: matcher.name,
            version: versionMatch[1]
        };
    }
    return $812a060980ce0ea1$export$cda2203640e08931;
}

});

parcelRegister("kryDa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d2a366249ac5f1c$export$2e2bcd8739ae039);
// @ts-nocheck
const $3d2a366249ac5f1c$var$createCustomEvent = ({ eventName: eventName, canBubble: canBubble, cancellable: cancellable, detail: detail })=>{
    const customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
    return customEvent;
};
var $3d2a366249ac5f1c$export$2e2bcd8739ae039 = $3d2a366249ac5f1c$var$createCustomEvent;

});

parcelRegister("eUsDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1929a7ab4bc735e$export$2e2bcd8739ae039);
class $b1929a7ab4bc735e$export$2e2bcd8739ae039 {
    enqueue(item) {
        if (this.queue.length === this.maxSize) return false;
        this.queue.push(item);
        return true;
    }
    flush(callback) {
        this.queue.forEach(callback);
        this.queue = [];
    }
    getSize() {
        return this.queue.length;
    }
    constructor(maxSize){
        this.queue = void 0;
        this.maxSize = void 0;
        this.queue = [];
        this.maxSize = maxSize;
    }
}

});






parcelRegister("eXODy", function(module, exports) {

$parcel$export(module.exports, "nativeEditorComponentsPreloader", () => $f98b0c3bb9dfd9f4$export$fd639506b0932339);
$parcel$export(module.exports, "tinyEditorComponentsPreloader", () => $f98b0c3bb9dfd9f4$export$bfdd6c06749e6ec3);
$parcel$export(module.exports, "getEditorPreloader", () => $f98b0c3bb9dfd9f4$export$6545754a45dc5973);

const $f98b0c3bb9dfd9f4$export$fd639506b0932339 = async ()=>{
    return (await (parcelRequire("lxDeG"))).nativeEditorComponentsPreloader();
};

const $f98b0c3bb9dfd9f4$export$bfdd6c06749e6ec3 = async ()=>{
    return (await (parcelRequire("6Ooxs"))).tinyEditorComponentsPreloader();
};

const $f98b0c3bb9dfd9f4$export$6545754a45dc5973 = async ()=>{
    return (await (parcelRequire("aRtlv"))).getEditorPreloader;
};

});
parcelRegister("lxDeG", function(module, exports) {

let $faeb1d71c8e8f00d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $faeb1d71c8e8f00d$var$load("c6MKV"),
    $faeb1d71c8e8f00d$var$load("bKvoJ")
]).then(()=>parcelRequire('aFK6m'));

});

parcelRegister("6Ooxs", function(module, exports) {

let $4f5a7273ab634f2e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4f5a7273ab634f2e$var$load("cnJeU"),
    $4f5a7273ab634f2e$var$load("5zRHF"),
    $4f5a7273ab634f2e$var$load("cRUrz"),
    $4f5a7273ab634f2e$var$load("k7roz"),
    $4f5a7273ab634f2e$var$load("is6uI"),
    $4f5a7273ab634f2e$var$load("jHDh2"),
    $4f5a7273ab634f2e$var$load("e1cuZ"),
    $4f5a7273ab634f2e$var$load("cqHdp"),
    $4f5a7273ab634f2e$var$load("iHZci"),
    $4f5a7273ab634f2e$var$load("4gZEH"),
    $4f5a7273ab634f2e$var$load("7orLM"),
    $4f5a7273ab634f2e$var$load("jmPIf"),
    $4f5a7273ab634f2e$var$load("dV8kC"),
    $4f5a7273ab634f2e$var$load("gc3ey"),
    $4f5a7273ab634f2e$var$load("kHPmI"),
    $4f5a7273ab634f2e$var$load("gkmZg"),
    $4f5a7273ab634f2e$var$load("kQvbt"),
    $4f5a7273ab634f2e$var$load("jQFGH"),
    $4f5a7273ab634f2e$var$load("fQ1rW"),
    $4f5a7273ab634f2e$var$load("4tUsp"),
    $4f5a7273ab634f2e$var$load("f96v0"),
    $4f5a7273ab634f2e$var$load("ev7SX"),
    $4f5a7273ab634f2e$var$load("2YKx2"),
    $4f5a7273ab634f2e$var$load("hGmYF"),
    $4f5a7273ab634f2e$var$load("9jsMO"),
    $4f5a7273ab634f2e$var$load("26IOy"),
    $4f5a7273ab634f2e$var$load("2nuqm"),
    $4f5a7273ab634f2e$var$load("giPb3"),
    $4f5a7273ab634f2e$var$load("ecOVI"),
    $4f5a7273ab634f2e$var$load("7X74w"),
    $4f5a7273ab634f2e$var$load("4we3T"),
    $4f5a7273ab634f2e$var$load("gavZG"),
    $4f5a7273ab634f2e$var$load("1hjmQ"),
    $4f5a7273ab634f2e$var$load("h4Nf7"),
    $4f5a7273ab634f2e$var$load("4fCJZ"),
    $4f5a7273ab634f2e$var$load("hzK1f"),
    $4f5a7273ab634f2e$var$load("fqrMn"),
    $4f5a7273ab634f2e$var$load("fYi1a"),
    $4f5a7273ab634f2e$var$load("bjzRn"),
    $4f5a7273ab634f2e$var$load("8mzoy"),
    $4f5a7273ab634f2e$var$load("7a9CL"),
    $4f5a7273ab634f2e$var$load("ivQYH"),
    $4f5a7273ab634f2e$var$load("8pE8S"),
    $4f5a7273ab634f2e$var$load("9Bu2S"),
    $4f5a7273ab634f2e$var$load("42vdC"),
    $4f5a7273ab634f2e$var$load("P5iE2"),
    $4f5a7273ab634f2e$var$load("9FBaW"),
    $4f5a7273ab634f2e$var$load("2JlZe"),
    $4f5a7273ab634f2e$var$load("2S1L6"),
    $4f5a7273ab634f2e$var$load("6zfzy"),
    $4f5a7273ab634f2e$var$load("6StWh"),
    $4f5a7273ab634f2e$var$load("g9CVe"),
    $4f5a7273ab634f2e$var$load("5wcLJ"),
    $4f5a7273ab634f2e$var$load("4C5VU"),
    $4f5a7273ab634f2e$var$load("85N0c"),
    $4f5a7273ab634f2e$var$load("3JWH2"),
    $4f5a7273ab634f2e$var$load("U7y88"),
    $4f5a7273ab634f2e$var$load("fEx3B"),
    $4f5a7273ab634f2e$var$load("dJQEi"),
    $4f5a7273ab634f2e$var$load("j4gWN"),
    $4f5a7273ab634f2e$var$load("hTb35"),
    $4f5a7273ab634f2e$var$load("87F9B"),
    $4f5a7273ab634f2e$var$load("4aLlP"),
    $4f5a7273ab634f2e$var$load("hrAMe"),
    $4f5a7273ab634f2e$var$load("6qah4"),
    $4f5a7273ab634f2e$var$load("aZinD"),
    $4f5a7273ab634f2e$var$load("cyGuT"),
    $4f5a7273ab634f2e$var$load("2X0n2"),
    $4f5a7273ab634f2e$var$load("aJ21i"),
    $4f5a7273ab634f2e$var$load("c6MKV"),
    $4f5a7273ab634f2e$var$load("eILJU"),
    $4f5a7273ab634f2e$var$load("2qXXY"),
    $4f5a7273ab634f2e$var$load("kNZr8")
]).then(()=>parcelRequire('847Yj'));

});

parcelRegister("aRtlv", function(module, exports) {

let $7e859e1cb0dc9183$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7e859e1cb0dc9183$var$load("aDgIB").then(()=>parcelRequire('3K1px'));

});


parcelRegister("jXpbL", function(module, exports) {

$parcel$export(module.exports, "NativeCollabLoader", () => $7bc638e3e10c6840$export$871388fb833dfa56);
$parcel$export(module.exports, "isHeartbeatPermissionError", () => (parcelRequire("5MyXJ")).isPermissionError);
$parcel$export(module.exports, "CollabRecoveryErrorType", () => (parcelRequire("S6mif")).CollabRecoveryErrorType);
$parcel$export(module.exports, "CollabServiceProperty", () => (parcelRequire("gkIgp")).CollabServiceProperty);
$parcel$export(module.exports, "fetchCollabPermissionToken", () => (parcelRequire("8KbKw")).fetchCollabPermissionToken);
$parcel$export(module.exports, "NativeCollabQuery", () => (parcelRequire("l1kdf")).NativeCollabQuery);
$parcel$export(module.exports, "useDraftSyncAndPublishContext", () => (parcelRequire("2wSyg")).useDraftSyncAndPublishContext);
$parcel$export(module.exports, "useConnected", () => (parcelRequire("9ohnn")).useConnected);
$parcel$export(module.exports, "useConnecting", () => (parcelRequire("e1cuh")).useConnecting);
$parcel$export(module.exports, "useNativeCollabConnected", () => (parcelRequire("hYoU4")).useNativeCollabConnected);
$parcel$export(module.exports, "useNativeCollabDraftSync", () => (parcelRequire("hYoU4")).useNativeCollabDraftSync);
$parcel$export(module.exports, "useNativeCollabState", () => (parcelRequire("hYoU4")).useNativeCollabState);
$parcel$export(module.exports, "useNativeCollabActions", () => (parcelRequire("hYoU4")).useNativeCollabActions);
$parcel$export(module.exports, "nativeCollabPermissionsTokenState", () => (parcelRequire("1sAC2")).nativeCollabPermissionsTokenState);
$parcel$export(module.exports, "useNativeCollabPresenceState", () => (parcelRequire("2VZOl")).useNativeCollabPresenceState);
$parcel$export(module.exports, "NativeCollabPresenceStateContainer", () => (parcelRequire("2VZOl")).NativeCollabPresenceStateContainer);

var $jmjWc = parcelRequire("jmjWc");


var $5MyXJ = parcelRequire("5MyXJ");

var $S6mif = parcelRequire("S6mif");

var $gkIgp = parcelRequire("gkIgp");


var $8KbKw = parcelRequire("8KbKw");

var $l1kdf = parcelRequire("l1kdf");

var $2wSyg = parcelRequire("2wSyg");

var $9ohnn = parcelRequire("9ohnn");

var $e1cuh = parcelRequire("e1cuh");

var $hYoU4 = parcelRequire("hYoU4");

var $1sAC2 = parcelRequire("1sAC2");

var $2VZOl = parcelRequire("2VZOl");

const $7bc638e3e10c6840$export$871388fb833dfa56 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "SydrJ",
    name: "NativeCollabLoader",
    loader: async ()=>{
        const { NativeCollabComponent: NativeCollabComponent } = await (parcelRequire("k6KLZ"));
        return NativeCollabComponent;
    }
});

});
parcelRegister("5MyXJ", function(module, exports) {

$parcel$export(module.exports, "isPermissionError", () => $2350038afb2a4a3e$export$e11674744930cd15);
$parcel$export(module.exports, "useEditorHeartbeat", () => $2350038afb2a4a3e$export$af429709ba6838d6);

var $gwFzn = parcelRequire("gwFzn");

var $1KmJq = parcelRequire("1KmJq");

var $inPa6 = parcelRequire("inPa6");

var $bQm3c = parcelRequire("bQm3c");

var $3jwuS = parcelRequire("3jwuS");

var $4VJDS = parcelRequire("4VJDS");

var $9wGTI = parcelRequire("9wGTI");

var $bdpoI = parcelRequire("bdpoI");

var $8MyKT = parcelRequire("8MyKT");

var $jKP0k = parcelRequire("jKP0k");

var $7DS9s = parcelRequire("7DS9s");
/* Editor heartbeat set to tick every 60 seconds */ const $2350038afb2a4a3e$var$HEARTBEAT_TIMER_INTERVAL = 60000;
const $2350038afb2a4a3e$var$EDITOR_NCS_MAX_PARTICIPANTS = 'confluence_frontend_collab_ncs_max_participants';
const $2350038afb2a4a3e$var$LIVE_PAGES_LIMITS = 'confluence_frontend_collab_live_pages_limits';
const $2350038afb2a4a3e$var$COLLAB_SERVICE = 'ncs'; // this hook is only used for NCS editor
const $2350038afb2a4a3e$var$DEFAULT_MAX_EDIT_PARTICIPANTS = 12;
class $2350038afb2a4a3e$export$17a91496024ff2c1 extends Error {
    constructor(message, reason){
        super(message), this.message = message, this.reason = reason;
        this.reason = reason;
    }
}
const $2350038afb2a4a3e$export$e11674744930cd15 = (heartbeatError)=>{
    return heartbeatError?.reason === 'unauthorised' || heartbeatError?.reason === 'UNAUTHORIZED';
};
const $2350038afb2a4a3e$export$af429709ba6838d6 = ({ contentId: contentId, contentType: contentType, collabEditInitialized: collabEditInitialized, viewMode: viewMode })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const heartbeatTimerId = (0, $gwFzn.useRef)(null);
    const editorSessionIdRef = (0, $gwFzn.useRef)(null);
    const [subtypeMismatch, setSubtypeMismatch] = (0, $gwFzn.useState)(false);
    const [heartbeatSubtype, setHeartbeatSubtype] = (0, $gwFzn.useState)(undefined);
    // If view mode changes, trigger new heartbeat request with new "user type", before enforcing any limits or returning errors
    const prevViewModeRef = (0, $gwFzn.useRef)(viewMode !== undefined ? viewMode : null);
    const isResettingHeartbeat = (0, $gwFzn.useRef)(false);
    // keep track of list of users from heartbeat response, which are ordered by time that they joined the collaborative session
    const [orderedActiveUsers, setOrderedActiveUsers] = (0, $gwFzn.useState)(null);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // used for regular pages
    const [collabLimitReached, setCollabLimitReached] = (0, $gwFzn.useState)(false);
    // used for live pages
    const [liveEditLimitReached, setLiveEditLimitReached] = (0, $gwFzn.useState)(false);
    const [liveViewLimitReached, setLiveViewLimitReached] = (0, $gwFzn.useState)(false);
    const [heartbeatError, setHeartbeatError] = (0, $gwFzn.useState)();
    let maxEditParticipants = (0, $4VJDS.default).getNumber($2350038afb2a4a3e$var$EDITOR_NCS_MAX_PARTICIPANTS, $2350038afb2a4a3e$var$DEFAULT_MAX_EDIT_PARTICIPANTS);
    const livePagesLimitConfig = (0, $4VJDS.default).getString($2350038afb2a4a3e$var$LIVE_PAGES_LIMITS, '');
    const { viewLimit: livePageViewLimit, editLimit: livePageEditLimit } = (0, $gwFzn.useMemo)(()=>{
        const defaultLimits = {
            editLimit: $2350038afb2a4a3e$var$DEFAULT_MAX_EDIT_PARTICIPANTS,
            viewLimit: 100
        };
        if (typeof livePagesLimitConfig === 'string') try {
            const limitObject = JSON.parse(livePagesLimitConfig);
            if (!('viewLimit' in limitObject) || !('editLimit' in limitObject)) return defaultLimits;
            return limitObject;
        } catch (err) {
        // ignore and fallback to default
        }
        return defaultLimits;
    }, [
        livePagesLimitConfig
    ]);
    if (isLivePage) maxEditParticipants = livePageEditLimit;
    const [startHeartbeat] = (0, $1KmJq.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $bdpoI.EditorStartHeartbeatMutation), {
        variables: {
            contentId: contentId,
            contentType: contentType,
            collabService: $2350038afb2a4a3e$var$COLLAB_SERVICE,
            heartbeatUserType: viewMode ? (0, $8MyKT.ExperimentalHeartbeatUserType).VIEW : (0, $8MyKT.ExperimentalHeartbeatUserType).EDIT
        }
    });
    const [stopHeartbeat] = (0, $1KmJq.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $7DS9s.EditorStopHeartbeatMutation), {
        variables: {
            contentId: contentId,
            contentType: contentType,
            heartbeatUserType: viewMode ? (0, $jKP0k.ExperimentalHeartbeatUserType).VIEW : (0, $jKP0k.ExperimentalHeartbeatUserType).EDIT
        }
    });
    const handleError = (0, $gwFzn.useCallback)((error, data)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: 'heartbeat',
                source: 'useEditorHeartbeat',
                objectId: contentId,
                objectType: contentType,
                attributes: {
                    error: {
                        reason: error instanceof $2350038afb2a4a3e$export$17a91496024ff2c1 ? error.reason : 'Error',
                        message: error.message
                    },
                    activeUsersSize: data?.experimentalEditorStartHeartbeat?.orderedUsers?.length
                }
            }
        }).fire();
        setHeartbeatError(error);
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const stopHeartbeatCallback = (0, $gwFzn.useCallback)(()=>{
        if (heartbeatTimerId?.current) clearInterval(heartbeatTimerId.current);
        stopHeartbeat().catch((error)=>{
            handleError(error);
        });
    }, [
        stopHeartbeat,
        handleError
    ]);
    const handleHeartbeatSubtypeMismatch = (0, $gwFzn.useCallback)((subtype)=>{
        setHeartbeatSubtype(subtype);
        // Detect if page type (live/classic page) differs between frontend and backend
        // This can happen when a page is converted but the user hasn't received the event
        // We disable the editor in NCS to prevent potential data loss in this state
        const hasSubtypeMismatch = isLivePage && subtype !== 'live' || // Live doc with a different subtype
        !isLivePage && subtype !== null; // Non-live doc with any subtype
        setSubtypeMismatch(hasSubtypeMismatch);
    }, [
        isLivePage,
        setHeartbeatSubtype,
        setSubtypeMismatch
    ]);
    const startHeartbeatCallback = (0, $gwFzn.useCallback)(()=>{
        startHeartbeat().then(({ data: data })=>{
            if (isResettingHeartbeat.current) isResettingHeartbeat.current = false;
            if (!data || !data.experimentalEditorStartHeartbeat) {
                handleError(new $2350038afb2a4a3e$export$17a91496024ff2c1('Missing response data', !data ? 'No data' : 'No heartbeat data'));
                return;
            }
            const { error: error, message: message, orderedUsers: orderedUsers, editorSessionId: editorSessionId, subtype: subtype } = data.experimentalEditorStartHeartbeat;
            editorSessionIdRef.current = editorSessionId;
            if ((0, $9wGTI.fg)('confluence_ncs_disconnect_idle_tabs_pubsub')) handleHeartbeatSubtypeMismatch(subtype);
            if (error) {
                const heartbeatError = new $2350038afb2a4a3e$export$17a91496024ff2c1(message ?? 'Heartbeat failed', error);
                if (isLivePage && $2350038afb2a4a3e$export$e11674744930cd15(heartbeatError)) // heartbeat permission check is a redundant extra check on top of NCS permission enforcement
                // for live pages:
                //    there is a race condition where heartbeat is sent with outdated user type
                //    we ignore the permission error and re-send the heartbeat with the correct user type
                return;
                handleError(heartbeatError, data);
            }
            if (!!orderedUsers) setOrderedActiveUsers(orderedUsers);
        }).catch((error)=>{
            handleError(error);
        });
    }, [
        startHeartbeat,
        handleError,
        isLivePage,
        handleHeartbeatSubtypeMismatch
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!orderedActiveUsers || isResettingHeartbeat.current) return;
        const isCurrentUserOverLimit = ({ activeUsers: activeUsers, limit: limit })=>{
            // If there are less active users than the limit, the user is not over the limit
            if (activeUsers.length < limit) return false;
            const isUserAnActiveUser = userId ? activeUsers.slice(0, limit).includes(userId) : false;
            return(// heartbeat backend doesn't handle anonymous users, they will be locked out regardless of order that they joined (i.e. we just use activeUsers size number comparison for anonymous users)
            // otherwise, only the first N users should be able to continue editing
            !userId && activeUsers.length > limit || !!userId && !isUserAnActiveUser);
        };
        const editUsers = orderedActiveUsers.filter((user)=>user.heartbeatUserType === (0, $8MyKT.ExperimentalHeartbeatUserType).EDIT).map((user)=>user.accountId) ?? [];
        const isEditLimitExceeded = isCurrentUserOverLimit({
            activeUsers: editUsers,
            limit: maxEditParticipants
        });
        if (!isLivePage) {
            setCollabLimitReached(isEditLimitExceeded);
            return;
        }
        // include edit->view fallback users, based on queue order
        const allowedEditUsers = editUsers.slice(0, maxEditParticipants);
        const viewUsers = orderedActiveUsers.filter((user)=>!allowedEditUsers.includes(user.accountId)).map((user)=>user.accountId) ?? [];
        const isViewLimitExceeded = isCurrentUserOverLimit({
            activeUsers: viewUsers,
            limit: livePageViewLimit
        });
        if (isEditLimitExceeded && !(prevViewModeRef.current || isViewLimitExceeded)) setLiveEditLimitReached(true);
        else setLiveEditLimitReached(false);
        if (isViewLimitExceeded && (prevViewModeRef.current || isEditLimitExceeded)) setLiveViewLimitReached(true);
        else setLiveViewLimitReached(false);
    }, [
        orderedActiveUsers,
        maxEditParticipants,
        userId,
        isLivePage,
        livePageViewLimit
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (viewMode !== undefined && viewMode !== prevViewModeRef.current) {
            // view mode has changed, refetch heartbeat with new user type
            isResettingHeartbeat.current = true;
            startHeartbeatCallback();
            prevViewModeRef.current = viewMode;
        }
    }, [
        viewMode,
        startHeartbeatCallback
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (collabEditInitialized) {
            startHeartbeatCallback();
            heartbeatTimerId.current = setInterval(startHeartbeatCallback, $2350038afb2a4a3e$var$HEARTBEAT_TIMER_INTERVAL);
            return ()=>stopHeartbeatCallback();
        }
    // prevent re-triggering start/stop when heartbeat type changes (i.e. when mutation callback changes)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditInitialized,
        contentId,
        // only re-trigger heartbeat on specific mutation variables, not viewMode
        contentType
    ]);
    return {
        collabLimitReached: // regular edit pages
        collabLimitReached,
        liveEditLimitReached: // live pages specific
        liveEditLimitReached,
        liveViewLimitReached: liveViewLimitReached,
        heartbeatError: // shared data
        heartbeatError,
        stopHeartbeatCallback: stopHeartbeatCallback,
        editorSessionId: editorSessionIdRef.current,
        subtypeMismatch: subtypeMismatch,
        heartbeatSubtype: heartbeatSubtype
    };
};

});
parcelRegister("bdpoI", function(module, exports) {

$parcel$export(module.exports, "EditorStartHeartbeatMutation", () => $92212e2a5a6103ef$export$8a73362456aab508);

var $d2LG0 = parcelRequire("d2LG0");
const $92212e2a5a6103ef$export$8a73362456aab508 = (0, $d2LG0.default)`mutation EditorStartHeartbeatMutation($contentId:ID!$contentType:String!$collabService:String!$heartbeatUserType:ExperimentalHeartbeatUserType)@experimental{experimentalEditorStartHeartbeat(contentId:$contentId contentType:$contentType collabService:$collabService heartbeatUserType:$heartbeatUserType){orderedUsers{accountId heartbeatUserType}editorSessionId error message subtype}}`;

});

parcelRegister("8MyKT", function(module, exports) {

$parcel$export(module.exports, "ExperimentalHeartbeatUserType", () => $d61f6181e4c7da5b$export$5d0e43ccb00ec46a);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $d61f6181e4c7da5b$export$5d0e43ccb00ec46a = /*#__PURE__*/ function(ExperimentalHeartbeatUserType) {
    ExperimentalHeartbeatUserType["EDIT"] = "EDIT";
    ExperimentalHeartbeatUserType["VIEW"] = "VIEW";
    return ExperimentalHeartbeatUserType;
}({});

});

parcelRegister("jKP0k", function(module, exports) {

$parcel$export(module.exports, "ExperimentalHeartbeatUserType", () => $89185ab988181834$export$5d0e43ccb00ec46a);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $89185ab988181834$export$5d0e43ccb00ec46a = /*#__PURE__*/ function(ExperimentalHeartbeatUserType) {
    ExperimentalHeartbeatUserType["EDIT"] = "EDIT";
    ExperimentalHeartbeatUserType["VIEW"] = "VIEW";
    return ExperimentalHeartbeatUserType;
}({});

});

parcelRegister("7DS9s", function(module, exports) {

$parcel$export(module.exports, "EditorStopHeartbeatMutation", () => $39780a74218a9a35$export$4d691c38c8ad495f);

var $d2LG0 = parcelRequire("d2LG0");
const $39780a74218a9a35$export$4d691c38c8ad495f = (0, $d2LG0.default)`mutation EditorStopHeartbeatMutation($contentId:ID!$contentType:String!$heartbeatUserType:ExperimentalHeartbeatUserType)@experimental{experimentalEditorStopHeartbeat(contentId:$contentId contentType:$contentType heartbeatUserType:$heartbeatUserType)}`;

});


parcelRegister("S6mif", function(module, exports) {

$parcel$export(module.exports, "CollabRecoveryErrorType", () => $03a48f98bcaadc9f$export$26130dc3dd4c1286);
$parcel$export(module.exports, "useError", () => $03a48f98bcaadc9f$export$5027865de34f9ec6);

var $gwFzn = parcelRequire("gwFzn");

var $aTqya = parcelRequire("aTqya");

var $h3X17 = parcelRequire("h3X17");

var $inPa6 = parcelRequire("inPa6");

var $bMmYR = parcelRequire("bMmYR");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");
var $amL1s = parcelRequire("amL1s");

var $hBkCm = parcelRequire("hBkCm");

var $aMcHK = parcelRequire("aMcHK");

var $fJlJm = parcelRequire("fJlJm");

var $3jwuS = parcelRequire("3jwuS");

var $gTyTP = parcelRequire("gTyTP");
class $03a48f98bcaadc9f$export$26130dc3dd4c1286 extends Error {
    constructor(message, status, traceId){
        super(message), this.message = message, this.status = status, this.traceId = traceId;
        this.status = status;
        this.traceId = traceId;
    }
}
const $03a48f98bcaadc9f$var$isNotPermittedError = (error)=>{
    return error.code === (0, $h3X17.PROVIDER_ERROR_CODE).NO_PERMISSION_ERROR && 'EXPIRED_TOKEN' !== error.reason || error.code === (0, $h3X17.PROVIDER_ERROR_CODE).DOCUMENT_NOT_FOUND;
};
const $03a48f98bcaadc9f$var$isUnrecoverableError = (error)=>{
    return !error.recoverable && (0, $h3X17.PROVIDER_ERROR_CODE).INTERNAL_SERVICE_ERROR !== error.code;
};
const $03a48f98bcaadc9f$var$getStatusCodeFromApolloError = (error)=>{
    return (0, $aTqya.isApolloError)(error) && (0, $hBkCm.BadStatusError).isBadStatusError(error?.graphQLErrors?.[0]?.originalError) ? Number((0, $aMcHK.getStatusCodeError)(error.graphQLErrors[0].originalError)) : null;
};
const $03a48f98bcaadc9f$var$isTenantSuspendedError = (error)=>error.status === 423;
const $03a48f98bcaadc9f$export$5027865de34f9ec6 = (collabEditProvider, resetCollabService, contentId, contentType)=>{
    const [error, setError] = (0, $gwFzn.useState)(null);
    const [recoveryError, setRecoveryError] = (0, $gwFzn.useState)(null);
    const hasResetRef = (0, $gwFzn.useRef)({
        resetInProgress: false,
        resetCount: 0
    });
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const currentEditorPageLoadExperienceName = isLivePage ? (0, $amL1s.getLivePageViewExperienceName)() : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
    const currentEditorPageExperienceName = isLivePage ? (0, $amL1s.getLivePageEditExperienceName)() : (0, $irVI7.EDIT_PAGE_EXPERIENCE);
    const { livePageReleasePhase: livePageReleasePhase } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const stopExperienceOnRecoveryError = (0, $gwFzn.useCallback)((recoveryErrorForAnalytics)=>{
        if (!!recoveryErrorForAnalytics?.status && recoveryErrorForAnalytics?.status < 500) {
            experienceTracker.abort({
                name: currentEditorPageLoadExperienceName,
                reason: `Recovery failed with error status ${recoveryErrorForAnalytics.status}`,
                attributes: {
                    errorStatus: recoveryErrorForAnalytics?.status,
                    traceId: recoveryErrorForAnalytics?.traceId,
                    objectId: contentId,
                    objectType: contentType,
                    isLivePage: isLivePage,
                    ...isLivePage ? {
                        livePageReleasePhase: livePageReleasePhase
                    } : {}
                }
            });
            return;
        }
        experienceTracker.stopOnError({
            name: currentEditorPageLoadExperienceName,
            error: recoveryErrorForAnalytics,
            attributes: {
                ...recoveryErrorForAnalytics?.status ? {
                    errorStatus: recoveryErrorForAnalytics.status
                } : {},
                errorType: 'Recovery failed',
                traceId: recoveryErrorForAnalytics?.traceId,
                objectId: contentId,
                objectType: contentType,
                isLivePage: isLivePage,
                ...isLivePage ? {
                    livePageReleasePhase: livePageReleasePhase
                } : {}
            }
        });
    }, [
        contentId,
        contentType,
        experienceTracker,
        currentEditorPageLoadExperienceName,
        isLivePage,
        livePageReleasePhase
    ]);
    const setErrorAndDisconnect = (0, $gwFzn.useCallback)((newError)=>{
        if ($03a48f98bcaadc9f$var$isNotPermittedError(newError) || $03a48f98bcaadc9f$var$isUnrecoverableError(newError) || $03a48f98bcaadc9f$var$isTenantSuspendedError(newError)) setError(newError);
        const experienceState = experienceTracker.getExperienceState(currentEditorPageLoadExperienceName);
        if (!experienceState || experienceState.hasStopped) {
            // initialisation completed but we received an error later
            if (!$03a48f98bcaadc9f$var$isNotPermittedError(newError)) {
                if ($03a48f98bcaadc9f$var$isUnrecoverableError(newError)) experienceTracker.stopOnError({
                    name: currentEditorPageExperienceName,
                    error: {
                        name: newError.code,
                        message: newError.message
                    },
                    attributes: {
                        errorStatus: newError.status,
                        objectId: contentId,
                        objectType: contentType,
                        isLivePage: isLivePage
                    }
                });
                else createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'error',
                        actionSubject: 'nativeEditor',
                        source: 'confluenceFrontend',
                        objectId: contentId,
                        objectType: contentType,
                        attributes: {
                            errorName: newError.code,
                            errorMessage: newError.message,
                            errorStatus: newError.status,
                            isRecoverable: true,
                            reason: 'reason' in newError ? newError.reason : 'unknown',
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            }
            return;
        }
        if ($03a48f98bcaadc9f$var$isNotPermittedError(newError)) {
            // expected 403 for restricted page or deleted page
            // for deleted page, 403 is returned with reason "RESOURCE_DELETED"
            let newErrorReason;
            if ('reason' in newError) newErrorReason = newError.reason;
            collabEditProvider.disconnect();
            experienceTracker.abort({
                name: currentEditorPageLoadExperienceName,
                reason: newErrorReason ?? 'page restricted or deleted',
                attributes: {
                    errorStatus: newError.status,
                    errorName: newError.code,
                    errorMessage: newError.message,
                    objectId: contentId,
                    objectType: contentType,
                    isLivePage: isLivePage,
                    ...isLivePage ? {
                        livePageReleasePhase: livePageReleasePhase
                    } : {}
                }
            });
        } else if ($03a48f98bcaadc9f$var$isUnrecoverableError(newError)) // unhandled/unexpected errors
        experienceTracker.stopOnError({
            name: currentEditorPageLoadExperienceName,
            error: {
                name: newError.code,
                message: newError.message
            },
            attributes: {
                errorStatus: newError.status,
                objectId: contentId,
                objectType: contentType,
                isLivePage: isLivePage,
                ...isLivePage ? {
                    livePageReleasePhase: livePageReleasePhase
                } : {}
            }
        });
    }, [
        collabEditProvider,
        experienceTracker,
        createAnalyticsEvent,
        contentId,
        contentType,
        currentEditorPageLoadExperienceName,
        currentEditorPageExperienceName,
        isLivePage,
        livePageReleasePhase
    ]);
    const collabRecovery = (0, $gwFzn.useCallback)(async ()=>{
        if (hasResetRef.current.resetInProgress) return;
        else if (hasResetRef.current.resetCount > 0) {
            // recovery has already been attempted but we've received another 404d
            const error = new $03a48f98bcaadc9f$export$26130dc3dd4c1286(`Collab recovery unsuccessful`);
            setRecoveryError(error);
            stopExperienceOnRecoveryError(error);
            return;
        }
        hasResetRef.current = {
            resetInProgress: true,
            resetCount: hasResetRef.current.resetCount += 1
        };
        const shouldRetryPredicate = async (error)=>{
            const statusCode = $03a48f98bcaadc9f$var$getStatusCodeFromApolloError(error);
            return !!statusCode && statusCode >= 500;
        };
        try {
            await (0, $bMmYR.retry)(resetCollabService, {
                maxAttempts: 2,
                timeout: 2000
            }, shouldRetryPredicate); // kick off page recovery, with retry
            hasResetRef.current.resetInProgress = false;
        } catch (e) {
            // page recovery has failed, editor is empty... fatal error
            let recoveryError = e; // "public" error used by other components
            const statusCode = $03a48f98bcaadc9f$var$getStatusCodeFromApolloError(e);
            if (!!statusCode) recoveryError = new $03a48f98bcaadc9f$export$26130dc3dd4c1286(`Collab recovery responded with ${statusCode}`, statusCode, (0, $fJlJm.getTraceIdFromApolloError)(e) ?? undefined);
            setRecoveryError(recoveryError);
            stopExperienceOnRecoveryError(recoveryError);
            hasResetRef.current.resetInProgress = false;
        }
    }, [
        resetCollabService,
        stopExperienceOnRecoveryError
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleError = (emittedError)=>{
            if (emittedError.status == 404) // 404 means that collab service doesn't have the document but Confluence does
            // try reset the document before displaying error (will be created in collab service if it doesn't exist). Currently only attempt reset once (no retry)
            collabRecovery();
            else setErrorAndDisconnect(emittedError);
        };
        collabEditProvider.on('error', handleError);
        return ()=>{
            collabEditProvider.off('error', handleError);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditProvider,
        resetCollabService
    ]);
    return {
        error: error,
        recoveryError: recoveryError
    };
};

});
parcelRegister("h3X17", function(module, exports) {

$parcel$export(module.exports, "PROVIDER_ERROR_CODE", () => $f0c66da303fc9af9$export$54cb529986e2487b);
$parcel$export(module.exports, "DisconnectReason", () => $f0c66da303fc9af9$export$258d16488300d83f);
$parcel$export(module.exports, "TELEPOINTER_DIM_CLASS", () => $f0c66da303fc9af9$export$75f1e2b0ae2c8197);
$parcel$export(module.exports, "TELEPOINTER_PULSE_CLASS", () => $f0c66da303fc9af9$export$44ee82a2b1106d13);
$parcel$export(module.exports, "TELEPOINTER_DATA_SESSION_ID_ATTR", () => $f0c66da303fc9af9$export$74788e2dc4d9be50);
$parcel$export(module.exports, "telepointerStyleWithInitialOnly", () => $f0c66da303fc9af9$export$42e13fa9d2b0c35d);
$parcel$export(module.exports, "telepointerStyle", () => $f0c66da303fc9af9$export$c94087d6ea5127ad);
$parcel$export(module.exports, "isDirtyTransaction", () => $f0c66da303fc9af9$export$c500b1bc696a0abc);
$parcel$export(module.exports, "tintDirtyTransaction", () => $f0c66da303fc9af9$export$f25182515d14d793);

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");

var $8z9j5 = parcelRequire("8z9j5");
var $f0c66da303fc9af9$export$54cb529986e2487b = /*#__PURE__*/ function(PROVIDER_ERROR_CODE) {
    PROVIDER_ERROR_CODE["NO_PERMISSION_ERROR"] = "NO_PERMISSION_ERROR";
    PROVIDER_ERROR_CODE["INVALID_USER_TOKEN"] = "INVALID_USER_TOKEN";
    PROVIDER_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    PROVIDER_ERROR_CODE["LOCKED"] = "LOCKED";
    PROVIDER_ERROR_CODE["FAIL_TO_SAVE"] = "FAIL_TO_SAVE";
    PROVIDER_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    PROVIDER_ERROR_CODE["INITIALISATION_ERROR"] = "INITIALISATION_ERROR";
    PROVIDER_ERROR_CODE["NETWORK_ISSUE"] = "NETWORK_ISSUE";
    PROVIDER_ERROR_CODE["INVALID_PROVIDER_CONFIGURATION"] = "INVALID_PROVIDER_CONFIGURATION";
    PROVIDER_ERROR_CODE["INTERNAL_SERVICE_ERROR"] = "INTERNAL_SERVICE_ERROR";
    PROVIDER_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    return PROVIDER_ERROR_CODE;
}({});
var $f0c66da303fc9af9$export$258d16488300d83f = /*#__PURE__*/ function(DisconnectReason) {
    DisconnectReason["CLIENT_DISCONNECT"] = "CLIENT_DISCONNECT";
    DisconnectReason["SERVER_DISCONNECT"] = "SERVER_DISCONNECT";
    DisconnectReason["SOCKET_CLOSED"] = "SOCKET_CLOSED";
    DisconnectReason["SOCKET_ERROR"] = "SOCKET_ERROR";
    DisconnectReason["SOCKET_TIMEOUT"] = "SOCKET_TIMEOUT";
    DisconnectReason["UNKNOWN_DISCONNECT"] = "UNKNOWN_DISCONNECT";
    return DisconnectReason;
}({});
const $f0c66da303fc9af9$var$telepointerColorStyle = (backgroundColor, textColor, index)=>{
    const { colorMode: colorMode } = (0, $8z9j5.default)();
    const backgroundStyle = colorMode === 'dark' ? `linear-gradient(to bottom, ${backgroundColor} -800000%, transparent 200000%)` : `linear-gradient(to bottom, ${backgroundColor} -850000%, transparent 150000%)`;
    return `
    &.color-${index} {
      background: ${backgroundStyle};
      &::after {
        background-color: ${backgroundColor};
        color: ${textColor};
        border-color: ${backgroundColor};
      }
    }
  `;
};
const $f0c66da303fc9af9$export$75f1e2b0ae2c8197 = 'telepointer-dim';
const $f0c66da303fc9af9$export$44ee82a2b1106d13 = 'telepointer-pulse-animate';
const $f0c66da303fc9af9$export$74788e2dc4d9be50 = 'data-telepointer-sessionid';
const $f0c66da303fc9af9$export$42e13fa9d2b0c35d = (0, $3jLHL.css)`
	.ProseMirror .telepointer {
		position: relative;
		transition: opacity 200ms;

		&.telepointer-selection:not(.inlineNodeView) {
			line-height: 1.2;
			pointer-events: none;
			user-select: none;
		}

		&.telepointer-selection-badge::after {
			content: attr(data-initial);
			position: absolute;
			display: block;
			top: -14px;
			font-size: ${(0, $aFUXX.relativeFontSizeToBase16)(9)};
			padding: ${"var(--ds-space-025, 2px)"};
			color: ${"var(--ds-text-inverse, #FFFFFF)"};
			left: 0px;
			border-radius: 2px 2px 2px 0;
			line-height: initial;
		}

		&.${$f0c66da303fc9af9$export$75f1e2b0ae2c8197} {
			opacity: 0.2;
		}

		${(0, $aFUXX.participantColors).map((participantColor, index)=>$f0c66da303fc9af9$var$telepointerColorStyle(participantColor.backgroundColor, participantColor.textColor, index))};
	}
`;
const $f0c66da303fc9af9$export$c94087d6ea5127ad = (0, $3jLHL.css)`
	@keyframes pulseIn {
		0%,
		100% {
			transform: scaleX(0);
			opacity: 0;
		}
		13% {
			transform: scaleX(1.4) scaleY(1.4);
			opacity: 1;
		}
		20%,
		85% {
			transform: scaleX(1) scaleY(1);
			opacity: 1;
		}
	}

	@keyframes pulseOut {
		0%,
		90%,
		100% {
			transform: scaleX(1);
			opacity: 1;
		}
		10%,
		80% {
			transform: scaleX(0);
			opacity: 0;
		}
	}

	.ProseMirror .telepointer {
		position: relative;
		transition: opacity 200ms;

		&.telepointer-selection:not(.inlineNodeView) {
			line-height: 1.2;
			pointer-events: none;
			user-select: none;
		}

		&.telepointer-selection-badge {
			.telepointer-initial,
			.telepointer-fullname {
				position: absolute;
				display: block;
				user-select: none;
				white-space: pre;
				top: -14px;
				left: 0px;
				font: ${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
				padding-left: ${"var(--ds-space-050, 4px)"};
				padding-right: ${"var(--ds-space-050, 4px)"};
				color: ${"var(--ds-text-inverse, #FFFFFF)"};
				border-radius: 0 2px 2px 0;
			}

			.telepointer-initial {
				opacity: 1;
				transition: opacity 0.15s ease-out;
			}

			.telepointer-fullname {
				opacity: 0;
				transform: scaleX(0);
				transform-origin: top left;
				transition:
					transform 0.15s ease-out,
					opacity 0.15s ease-out;
			}
		}

		&.${$f0c66da303fc9af9$export$44ee82a2b1106d13} {
			.telepointer-initial {
				animation: pulseOut 2s ease-in-out;
			}

			.telepointer-fullname {
				animation: pulseIn 2s ease-in-out;
			}
		}

		&:hover {
			.telepointer-initial {
				opacity: 0;
				transition-delay: 150ms;
			}

			.telepointer-fullname {
				transform: scaleX(1);
				opacity: 1;
				z-index: 1;
			}
		}

		&.${$f0c66da303fc9af9$export$75f1e2b0ae2c8197} {
			opacity: 0.2;
		}

		${(0, $aFUXX.participantColors).map((participantColor, index)=>$f0c66da303fc9af9$var$telepointerColorStyle(participantColor.backgroundColor, participantColor.textColor, index))};
	}
`;
const $f0c66da303fc9af9$var$tintKey = 'collab:isDirtyTransaction';
const $f0c66da303fc9af9$export$c500b1bc696a0abc = (tr)=>{
    return Boolean(tr.getMeta($f0c66da303fc9af9$var$tintKey));
};
const $f0c66da303fc9af9$export$f25182515d14d793 = (tr)=>{
    tr.setMeta($f0c66da303fc9af9$var$tintKey, true);
};

});

parcelRegister("bMmYR", function(module, exports) {

$parcel$export(module.exports, "retry", () => $e3747894d76f1f8c$export$9369b12211e1fce4);
/**
 * Sleep an async context for timeoutMs milliseconds
 *
 * Note this does not block but instead sets a timeout
 *
 * @param timeoutMs The timeout in milliseconds
 * @returns {Promise} A promise that resolves after timeoutMs milliseconds
 */ const $e3747894d76f1f8c$var$sleep = (timeoutMs)=>new Promise((resolve)=>setTimeout(resolve, timeoutMs));
const $e3747894d76f1f8c$export$9369b12211e1fce4 = (action, { backOff: backOff = true, jitter: jitter = true, timeout: timeout = 2000, maxAttempts: maxAttempts = 3 } = {}, shouldRetry)=>{
    const recursiveRetry = async (attempt)=>{
        let nextTryIn = null;
        if (attempt < maxAttempts) {
            const jitterFactor = jitter ? 1 + Math.random() : 1;
            const backOffFactor = backOff ? Math.pow(2, attempt) : 1;
            nextTryIn = timeout * backOffFactor * jitterFactor;
        }
        try {
            return await action(attempt, nextTryIn);
        } catch (ex) {
            if (nextTryIn === null) throw ex;
            if (shouldRetry && !await shouldRetry(ex)) throw ex;
            await $e3747894d76f1f8c$var$sleep(nextTryIn);
            return await recursiveRetry(attempt + 1);
        }
    };
    return recursiveRetry(0);
};

});


parcelRegister("gkIgp", function(module, exports) {

$parcel$export(module.exports, "CollabServiceProperty", () => $44e99c386783fe05$export$ea1a2a449eaeaa2d);
var $44e99c386783fe05$export$ea1a2a449eaeaa2d = /*#__PURE__*/ function(CollabServiceProperty) {
    CollabServiceProperty["NCS"] = "ncs";
    CollabServiceProperty["SYNCHRONY"] = "synchrony";
    return CollabServiceProperty;
}({});

});

parcelRegister("8KbKw", function(module, exports) {

$parcel$export(module.exports, "fetchCollabPermissionToken", () => $6f395e426fb151a0$export$e344958ab47793df);

var $csnse = parcelRequire("csnse");

var $hp2SH = parcelRequire("hp2SH");
var $7Sm4c = parcelRequire("7Sm4c");

var $j8hiR = parcelRequire("j8hiR");

var $9137z = parcelRequire("9137z");

var $9wGTI = parcelRequire("9wGTI");

var $3pJBd = parcelRequire("3pJBd");

var $1sAC2 = parcelRequire("1sAC2");
const $6f395e426fb151a0$var$isContentNotFoundError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.message.includes('Invalid content id'));
    return false;
};
const $6f395e426fb151a0$export$e344958ab47793df = (0, $csnse.default)((contentId, draftShareId)=>async ()=>{
        const permissionsTokenState = (0, $1sAC2.nativeCollabPermissionsTokenState).getPermissionsTokenState(contentId);
        if (permissionsTokenState) {
            const { getToken: getToken, isUsedForDraftFetch: isUsedForDraftFetch, isUsedForWSInitialization: isUsedForWSInitialization } = permissionsTokenState;
            // fetchCollabPermissionToken should only return the token if it is valid and has successfully been passed to the getDraft call
            if (isUsedForDraftFetch && !isUsedForWSInitialization) {
                const token = await getToken;
                if (token) {
                    (0, $1sAC2.nativeCollabPermissionsTokenState).setIsUsedForWSInitialization(contentId, true);
                    return token;
                }
            }
        }
        const apolloClient = (0, $hp2SH.getApolloClient)();
        try {
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            const result = await apolloClient.query({
                query: (0, $3pJBd.GetCollabPermissionTokenQuery),
                variables: {
                    contentId: contentId,
                    ...draftShareId && {
                        draftShareId: draftShareId
                    }
                },
                fetchPolicy: 'network-only',
                context: {
                    fetchOptions: {
                        // If we have a "no network error" this will never resolve and subsequent calls will
                        // be in limbo. This means we are unable to ever connect to NCS again (requiring a page reset)
                        ignoreNoNetworkError: (0, $9wGTI.fg)('platform_editor_fix_collab_provider_stuck_offline')
                    }
                }
            });
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            return result.data?.collabToken?.token ?? null; // if token is null, collab service will fall back to permissions service check
        } catch (e) {
            (0, $7Sm4c.markErrorAsHandled)(e);
            if ($6f395e426fb151a0$var$isContentNotFoundError(e)) // nasty fragile hack, mimic 404 exception which goes through collab-provider, then gets wrapped and emitted and handled in `useError`.
            // collab provider simply emits errors thrown in permissionTokenRefresh directly on its internal channel, so we have to conform to their error type
            // prettier-ignore
            throw {
                message: "Content not found",
                data: {
                    status: 404,
                    code: "INSUFFICIENT_EDITING_PERMISSION",
                    meta: {
                        description: "RESOURCE_DELETED",
                        reason: "RESOURCE_DELETED"
                    }
                }
            };
            else if (e?.networkError?.response?.status === 503) // prettier-ignore
            throw {
                message: "Service unavailable",
                data: {
                    meta: {
                        reason: "RESOURCE_DELETED"
                    }
                }
            }; // temporary hack to ensure draft cannot be edited during tenant migration, but we should throw TENANT_INSTANCE_MAINTENANCE once supported by collab-provider
            return null;
        }
    });

});
parcelRegister("j8hiR", function(module, exports) {

$parcel$export(module.exports, "COLLAB_EDIT_PROVIDER_MEASURES", () => $fbca710eb28c4147$export$d0a57beabaefb993);
var $fbca710eb28c4147$export$d0a57beabaefb993 = /*#__PURE__*/ function(COLLAB_EDIT_PROVIDER_MEASURES) {
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH"] = "collabEditProviderAnalyticsFetch";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CREATED"] = "collabEditProviderCreated";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_DISABLED"] = "collabEditProviderDisabled";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT"] = "collabEditProviderInitialized";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRE_CONNECTED"] = "collabEditProviderPreconnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CONNECTED"] = "collabEditProviderConnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT_DOC"] = "collabEditProviderInitDoc";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT"] = "collabEditProviderFetchNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT"] = "collabEditProviderPreloadNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT_TIMEOUT"] = "collabEditProviderPreloadNCSDraftTimeout";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_PERMS_TOKEN_FETCH"] = "collabEditProviderPermsTokenFetch";
    return COLLAB_EDIT_PROVIDER_MEASURES;
}({});

});

parcelRegister("9137z", function(module, exports) {

$parcel$export(module.exports, "CollabEditProviderMeasures", () => $e77725a58fc80757$export$d93492bf620814be);

var $kGrzq = parcelRequire("kGrzq");
const $e77725a58fc80757$export$d93492bf620814be = new (0, $kGrzq.BaseMeasures)();

});

parcelRegister("3pJBd", function(module, exports) {

$parcel$export(module.exports, "GetCollabPermissionTokenQuery", () => $8fbe44097771f132$export$20260f2c545eeec0);

var $d2LG0 = parcelRequire("d2LG0");
const $8fbe44097771f132$export$20260f2c545eeec0 = (0, $d2LG0.default)`query getCollabToken($contentId:ID!$draftShareId:String)@SLA{collabToken(id:$contentId draftShareId:$draftShareId){token}}`;

});

parcelRegister("1sAC2", function(module, exports) {

$parcel$export(module.exports, "nativeCollabPermissionsTokenState", () => $3f756fb591e8330c$export$8e63d30e585828b3);
class $3f756fb591e8330c$export$88b5d10ee0ed72d9 {
    getPermissionsTokenState(contentId) {
        return this.tokenState[contentId];
    }
    setToken(contentId, tokenPromise = Promise.resolve(null)) {
        // clear any existing tokens/bools in state
        this.tokenState[contentId] = {
            getToken: tokenPromise,
            isUsedForDraftFetch: false,
            isUsedForWSInitialization: false
        };
    }
    setIsUsedForDraftFetch(contentId, isUsedForDraftFetch) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForDraftFetch = isUsedForDraftFetch;
    }
    setIsUsedForWSInitialization(contentId, isUsedForWSInitialization) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForWSInitialization = isUsedForWSInitialization;
    }
    setTimestamp(contentId) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].timestamp = performance.now();
    }
    clearPermissionsTokenState(contentId) {
        if (this.tokenState[contentId]) delete this.tokenState[contentId];
    }
    constructor(){
        this.tokenState = {};
    }
}
const $3f756fb591e8330c$export$8e63d30e585828b3 = new $3f756fb591e8330c$export$88b5d10ee0ed72d9();

});


parcelRegister("2wSyg", function(module, exports) {

$parcel$export(module.exports, "DraftSyncAndPublishContextProvider", () => $87bc0f5ac3c4b9fb$export$dc8d83ecee528ce8);
$parcel$export(module.exports, "DraftSyncAndPublishContextConsumer", () => $87bc0f5ac3c4b9fb$export$bceb447197cf2e23);
$parcel$export(module.exports, "useDraftSyncAndPublishContext", () => $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4);

var $gwFzn = parcelRequire("gwFzn");
const $87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    getIsPublishing: ()=>false,
    setIsPublishing: (_)=>{
    // Intentional no-op
    },
    isPublishing: false
});
const $87bc0f5ac3c4b9fb$export$dc8d83ecee528ce8 = ({ children: children })=>{
    // These should remain in sync. The ref is used while a draft sync occurs, while
    // the state variable is used for re-rendering.
    const isPublishingRef = (0, $gwFzn.useRef)(false);
    const [isPublishing, setIsPublishing] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(false);
    const getIsPublishing = (0, $gwFzn.useCallback)(()=>isPublishingRef.current, []);
    const setPublishing = (0, $gwFzn.useCallback)((value)=>{
        isPublishingRef.current = value;
        setIsPublishing(value);
    }, []);
    const contextValue = (0, $gwFzn.useMemo)(()=>({
            getIsPublishing: getIsPublishing,
            setIsPublishing: setPublishing,
            isPublishing: isPublishing
        }), [
        getIsPublishing,
        setPublishing,
        isPublishing
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext.Provider, {
        value: contextValue
    }, children);
};
const $87bc0f5ac3c4b9fb$export$bceb447197cf2e23 = ({ children: children })=>{
    const context = $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4();
    return children(context);
};
const $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4 = ()=>{
    return (0, $gwFzn.useContext)($87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext);
};

});

parcelRegister("9ohnn", function(module, exports) {

$parcel$export(module.exports, "useConnected", () => $173e9417c57854b2$export$2257bd3a33884363);

var $gwFzn = parcelRequire("gwFzn");

var $j8hiR = parcelRequire("j8hiR");

var $9137z = parcelRequire("9137z");

var $hYoU4 = parcelRequire("hYoU4");

var $1sAC2 = parcelRequire("1sAC2");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");
const $173e9417c57854b2$export$2257bd3a33884363 = (collabEditProvider, contentId)=>{
    const [{ collabEditConnected: collabEditConnected }, nativeCollabActions] = (0, $hYoU4.useNativeCollabConnected)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $gwFzn.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleConnected = ()=>{
            nativeCollabActions.setCollabEditConnected(true);
            (0, $1sAC2.nativeCollabPermissionsTokenState).clearPermissionsTokenState(contentId);
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CONNECTED);
            // tracking time between when connection has been established and 'init' event is fired
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_INIT_DOC);
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
                message: 'NCS Connected'
            });
        };
        collabEditProvider.on('connected', handleConnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
        };
    }, [
        collabEditProvider,
        nativeCollabActions,
        contentId,
        experienceTracker
    ]);
    return {
        isCollabProviderConnected: collabEditConnected
    };
};

});
parcelRegister("hYoU4", function(module, exports) {

$parcel$export(module.exports, "useNativeCollabState", () => $cf3a2c4e252823d7$export$b01c6ac62a4aed2c);
$parcel$export(module.exports, "useNativeCollabActions", () => $cf3a2c4e252823d7$export$3f0287ea828df991);
$parcel$export(module.exports, "useNativeCollabDraftSync", () => $cf3a2c4e252823d7$export$31e00ebc52451b8e);
$parcel$export(module.exports, "useNativeCollabConnected", () => $cf3a2c4e252823d7$export$4bfbf4dd405bc207);

var $h75qY = parcelRequire("h75qY");

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");
const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$var$Store = (0, $4ZoIm.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $2S0Fz.createContainer)($cf3a2c4e252823d7$var$Store, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $iFWZA.createHook)($cf3a2c4e252823d7$var$Store, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($h75qY)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $iFWZA.createActionsHook)($cf3a2c4e252823d7$var$Store);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $iFWZA.createHook)($cf3a2c4e252823d7$var$Store, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($h75qY)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $iFWZA.createHook)($cf3a2c4e252823d7$var$Store, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($h75qY)))(state, 'collabEditConnected')
});

});


parcelRegister("e1cuh", function(module, exports) {

$parcel$export(module.exports, "useConnecting", () => $455b0e3615badc4d$export$257c6c9e28c0ad4b);

var $gwFzn = parcelRequire("gwFzn");

var $j8hiR = parcelRequire("j8hiR");

var $9137z = parcelRequire("9137z");
const $455b0e3615badc4d$export$257c6c9e28c0ad4b = (collabEditProvider)=>{
    const handleConnecting = ()=>{
        // tracking time between when provider is created in the FE and when channel initialization starts
        (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_PRE_CONNECTED);
        // tracking time between when provider's channel is initialized and when connected event is fired
        (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CONNECTED);
    };
    (0, $gwFzn.useEffect)(()=>{
        if (!collabEditProvider) return;
        // @ts-ignore
        collabEditProvider.on('connecting', handleConnecting);
        return ()=>{
            // @ts-ignore
            collabEditProvider.off('connecting', handleConnecting);
        };
    }, [
        collabEditProvider
    ]);
};

});

parcelRegister("2VZOl", function(module, exports) {

$parcel$export(module.exports, "NativeCollabPresenceStateContainer", () => $a3221c0e46c131d6$export$cd763072e62a98fa);
$parcel$export(module.exports, "useNativeCollabPresenceState", () => $a3221c0e46c131d6$export$f529db6cceb299f5);

var $2S0Fz = parcelRequire("2S0Fz");
var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");

var $9HkI0 = parcelRequire("9HkI0");
const $a3221c0e46c131d6$export$cd763072e62a98fa = (0, $2S0Fz.createContainer)();
const $a3221c0e46c131d6$var$Store = (0, $4ZoIm.createStore)({
    containedBy: $a3221c0e46c131d6$export$cd763072e62a98fa,
    initialState: {
        presenceId: ''
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    presenceId: (0, $9HkI0.v4)()
                });
            }
    }
});
const $a3221c0e46c131d6$export$f529db6cceb299f5 = (0, $iFWZA.createHook)($a3221c0e46c131d6$var$Store);

});

parcelRegister("k6KLZ", function(module, exports) {

let $ea38a65180763991$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ea38a65180763991$var$load("ipK41"),
    $ea38a65180763991$var$load("gUudp"),
    $ea38a65180763991$var$load("5zDuS"),
    $ea38a65180763991$var$load("37V0d"),
    $ea38a65180763991$var$load("5vatq"),
    $ea38a65180763991$var$load("87F9B"),
    $ea38a65180763991$var$load("aZinD"),
    $ea38a65180763991$var$load("6qah4"),
    $ea38a65180763991$var$load("btqFK")
]).then(()=>parcelRequire('03pNx'));

});


parcelRegister("hl1Kw", function(module, exports) {

$parcel$export(module.exports, "SearchSessionStateContainer", () => $cbda5d49866ab516$export$e1171f5486fb75fe);
$parcel$export(module.exports, "useSearchSessionId", () => $cbda5d49866ab516$export$e1e7a4797df1a656);
$parcel$export(module.exports, "withSearchSession", () => $cbda5d49866ab516$export$fab1485137890991);

var $gwFzn = parcelRequire("gwFzn");

var $2S0Fz = parcelRequire("2S0Fz");
var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
var $bd25s = parcelRequire("bd25s");
const $cbda5d49866ab516$var$parseAnalyticsFromQueryParams = (additionalAnalyticsToParse)=>{
    const formattedEvents = {};
    if (typeof additionalAnalyticsToParse !== 'string') return formattedEvents;
    const events = additionalAnalyticsToParse?.split('____');
    events.forEach((event)=>{
        const formattedEvent = event?.split('---', 2);
        const hasProperlyFormattedEvent = formattedEvent.length === 2;
        if (hasProperlyFormattedEvent) formattedEvents[formattedEvent[0]] = formattedEvent[1];
    });
    return formattedEvents;
};
const $cbda5d49866ab516$var$actions = {
    setSearchSessionId: (searchSessionId)=>({ setState: setState })=>{
            setState({
                searchSessionId: searchSessionId
            });
        },
    setAdditionalAnalytics: (additionalAnalyticsToParse)=>({ setState: setState })=>{
            const parsedAnalytics = $cbda5d49866ab516$var$parseAnalyticsFromQueryParams(additionalAnalyticsToParse);
            setState({
                additionalAnalytics: parsedAnalytics
            });
        }
};
const $cbda5d49866ab516$var$SearchSessionStore = (0, $4ZoIm.createStore)({
    initialState: {
        searchSessionId: undefined,
        additionalAnalytics: {}
    },
    actions: $cbda5d49866ab516$var$actions,
    name: 'SearchSessionStore'
});
const $cbda5d49866ab516$export$e1171f5486fb75fe = (0, $2S0Fz.createContainer)($cbda5d49866ab516$var$SearchSessionStore, {
    onInit: ()=>({ setState: setState }, { searchSessionId: searchSessionId, additionalAnalyticsToParse: additionalAnalyticsToParse })=>{
            const parsedAnalytics = $cbda5d49866ab516$var$parseAnalyticsFromQueryParams(additionalAnalyticsToParse);
            setState({
                searchSessionId: searchSessionId,
                additionalAnalytics: parsedAnalytics
            });
        },
    onUpdate: ()=>({ setState: setState }, { searchSessionId: searchSessionId, additionalAnalyticsToParse: additionalAnalyticsToParse })=>{
            const parsedAnalytics = $cbda5d49866ab516$var$parseAnalyticsFromQueryParams(additionalAnalyticsToParse);
            setState({
                searchSessionId: searchSessionId,
                additionalAnalytics: parsedAnalytics
            });
        }
});
const $cbda5d49866ab516$export$e1e7a4797df1a656 = (0, $iFWZA.createHook)($cbda5d49866ab516$var$SearchSessionStore, {
    selector: (state)=>({
            searchSessionId: state.searchSessionId,
            additionalAnalytics: state.additionalAnalytics
        })
});
const $cbda5d49866ab516$export$eaddae88f92f0971 = (0, $bd25s.createSubscriber)($cbda5d49866ab516$var$SearchSessionStore);
function $cbda5d49866ab516$export$fab1485137890991(WrappedComponent) {
    const SearchSessionComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($cbda5d49866ab516$export$eaddae88f92f0971, null, (searchSessionState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(WrappedComponent, {
                ...props,
                searchSessionState: searchSessionState
            }));
    SearchSessionComponent.displayName = `withSearchSession(${WrappedComponent.displayName || WrappedComponent.name})`;
    return SearchSessionComponent;
}

});

parcelRegister("jLw6A", function(module, exports) {

$parcel$export(module.exports, "PageRestrictionsContextConsumer", () => $6893a43d748c1b7d$export$6ad0c1d41c4e3f99);
$parcel$export(module.exports, "PageRestrictionsContextProvider", () => $6893a43d748c1b7d$export$90d20bb1366d586);
$parcel$export(module.exports, "usePageRestrictionsContext", () => $6893a43d748c1b7d$export$636524bec905cfd7);

var $gwFzn = parcelRequire("gwFzn");

var $xQxzY = parcelRequire("xQxzY");

var $7Sm4c = parcelRequire("7Sm4c");

var $5ZqQS = parcelRequire("5ZqQS");
parcelRequire("dIouf");
var $1uFM6 = parcelRequire("1uFM6");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $3joiD = parcelRequire("3joiD");

var $hL5Va = parcelRequire("hL5Va");

var $ckmNl = parcelRequire("ckmNl");

var $gYXuI = parcelRequire("gYXuI");
const $6893a43d748c1b7d$var$defaultContext = {
    loading: false,
    refetch: ()=>{}
};
const $6893a43d748c1b7d$export$e29354c764b84d73 = /*#__PURE__*/ (0, $gwFzn.createContext)($6893a43d748c1b7d$var$defaultContext);
const $6893a43d748c1b7d$export$6ad0c1d41c4e3f99 = $6893a43d748c1b7d$export$e29354c764b84d73.Consumer;
function $6893a43d748c1b7d$export$90d20bb1366d586(props) {
    const contentId = (0, $ckmNl.useContentId)(props.contentId);
    const { edition: edition } = (0, $bQm3c.useSessionData)() || {};
    const includeAncestors = (0, $euL71.ConfluenceEdition).FREE === edition;
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $xQxzY.useQuery)(...(0, $3joiD.getQueryParamsAndSetFetchPolicyForNetworkOnlyQuery)({
        query: (0, $hL5Va.PageRestrictionsQuery),
        variables: {
            contentId: contentId?.toString(),
            status: (0, $gYXuI.ALLOWED_CONTENT_STATUSES),
            includeAncestors: includeAncestors
        },
        skip: !contentId || typeof contentId === 'symbol'
    }));
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: 'backbone'
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const contextValue = (0, $gwFzn.useMemo)(()=>contentId ? {
            loading: loading,
            error: error,
            restrictions: $6893a43d748c1b7d$var$transformData(data),
            refetch: refetch
        } : $6893a43d748c1b7d$var$defaultContext, [
        loading,
        error,
        data,
        refetch,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6893a43d748c1b7d$export$e29354c764b84d73.Provider, {
        value: contextValue
    }, props.children);
}
const $6893a43d748c1b7d$var$transformData = (data)=>{
    const content = data?.singleContent;
    if (content) return {
        hasRestrictions: content.hasRestrictions,
        hasViewRestrictions: content.hasViewRestrictions,
        hasInheritedRestrictions: content.hasInheritedRestrictions,
        ancestors: content.ancestors?.map((a)=>({
                id: a?.id || null,
                title: a?.title || null,
                hasRestrictions: Boolean(a?.hasRestrictions),
                links: {
                    webui: a?.links?.webui || null
                }
            })) || []
    };
};
const $6893a43d748c1b7d$export$636524bec905cfd7 = ()=>(0, $gwFzn.useContext)($6893a43d748c1b7d$export$e29354c764b84d73);

});
parcelRegister("ckmNl", function(module, exports) {

$parcel$export(module.exports, "useContentId", () => $f8d167b20155dada$export$61f30ffd7f56d537);

var $gwFzn = parcelRequire("gwFzn");

var $ep3mz = parcelRequire("ep3mz");

var $c3Qwv = parcelRequire("c3Qwv");
var $7zgzO = parcelRequire("7zgzO");
function $f8d167b20155dada$export$61f30ffd7f56d537(contentId) {
    // As we have a bunch of places where IsUpsellQueryComponent is used, we need
    // to cover all possible cases how we're getting contentId:
    const [pageStateContentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    // 1) Legacy create page link - *directly passed as a prop*
    //    /wiki/spaces/~533571401/pages/create?fromPageId=55410689
    if (contentId) return contentId;
    // 2) New editor - *get contentID from RoutesContext*
    //    /wiki/spaces/{SPACE}/pages/{CONTENTID}
    //    /wiki/spaces/~351876773/pages/edit-v2/{CONTENTID}?draftShareId=7539fbb2-5f68-4982-8571-36bb8ef89c06
    if (pageStateContentId) return pageStateContentId;
    // 3) Old Editor creating new page - *get contentId as draftId from query*
    //    /wiki/spaces/~351876773/pages/create?draftId={DRAFTID}&draftShareId=ab6a566d-2ecd-4c32-a5ff-f8c13a36f713&
    return (0, $c3Qwv.getSingleParam)(getQueryParams(), 'draftId');
}

});


parcelRegister("gLeLL", function(module, exports) {

$parcel$export(module.exports, "SectionMessage", () => $103cc6a380e10ff8$export$a36903bd214cec06);
/* SectionMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $j4WDj = parcelRequire("j4WDj");

var $4WmbV = parcelRequire("4WmbV");
const $103cc6a380e10ff8$export$a36903bd214cec06 = ({ children: children, withGradient: withGradient = true, topBanner: // TODO: refactor topBanner and customPadding per https://product-fabric.atlassian.net/browse/USD-337
// for now since we only support 2 different cases, we give a boolean, going forward, if more use cases surface, we can revisit and design a better API
topBanner = false, customPadding: customPadding, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($103cc6a380e10ff8$var$Layout, {
        withGradient: withGradient,
        topBanner: topBanner,
        customPadding: customPadding,
        "data-testid": "section-message"
    }, !!children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($103cc6a380e10ff8$var$ChildrenLayout, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true
    }));
const $103cc6a380e10ff8$var$ChildrenLayout = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2hwx1ejb _p12f68cl _1ul968cl",
            __cmplp.className
        ])
    });
});
const $103cc6a380e10ff8$var$gradientBackground = `linear-gradient(84.09deg,
  ${(0, $j4WDj.GRADIENT_BACKGROUND_SUBTLEST_START)} 0%,
  ${(0, $j4WDj.GRADIENT_BACKGROUND_SUBTLEST_END)} 100%)`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $103cc6a380e10ff8$var$Layout = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withGradient: withGradient, customPadding: customPadding, topBanner: topBanner, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1p4ue13": (0, $iAWao.default)($103cc6a380e10ff8$var$gradientBackground),
            "--_krzptn": (0, $iAWao.default)((()=>{
                if (__cmplp.customPadding) return __cmplp.customPadding;
                if (__cmplp.topBanner) return `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"}`;
                return `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`;
            })())
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt41r3g _2rkoiti9 _1e0c1txw _1bsb1osq _vchhusvi _kqswh2mm",
            __cmplp.withGradient ? "_11q7hu7i" : "_11q7glyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fzfTC", function(module, exports) {

$parcel$export(module.exports, "ThemeAPI", () => $5d98d2226bcd7645$export$4afb38fcac7fd7a6);

var $9wGTI = parcelRequire("9wGTI");

var $ge2sX = parcelRequire("ge2sX");

var $lesra = parcelRequire("lesra");

var $8tOvf = parcelRequire("8tOvf");

var $bkldv = parcelRequire("bkldv");

var $l7ck4 = parcelRequire("l7ck4");
class $5d98d2226bcd7645$export$4afb38fcac7fd7a6 {
    static async saveTheme(theme) {
        if ((0, $9wGTI.fg)('confluence_typography_refreshed')) theme.typography = 'typography-refreshed';
        (0, $8tOvf.LocalThemeStorage).saveThemeLocal(theme);
        const { isLoggedIn: isLoggedIn } = await (0, $ge2sX.getSessionData)();
        if (isLoggedIn) await (0, $bkldv.RemoteThemeStorage).saveThemeRemote(theme);
    }
    static async getSavedTheme() {
        const persistedLocalTheme = $5d98d2226bcd7645$export$4afb38fcac7fd7a6.getSavedThemeLocal();
        const { isLoggedIn: isLoggedIn } = await (0, $ge2sX.getSessionData)();
        let persistedRemoteTheme = undefined;
        if (isLoggedIn) try {
            persistedRemoteTheme = await (0, $bkldv.RemoteThemeStorage).getThemeRemote();
            // Theme from the DB should indicate last preference regardless of browser
            if (!$5d98d2226bcd7645$export$4afb38fcac7fd7a6.localAndRemoteAreEqual(persistedLocalTheme, persistedRemoteTheme)) (0, $8tOvf.LocalThemeStorage).saveThemeLocal(persistedRemoteTheme);
        } catch (e) {
            // Fall through to local
            const attributes = {
                message: e.message,
                stack: e.stack,
                persistedRemoteTheme: persistedRemoteTheme,
                persistedLocalTheme: persistedLocalTheme
            };
            await (0, $l7ck4.reportThemingError)((0, $l7ck4.ErrorSubjects).themeAPI, (0, $l7ck4.ErrorSubjectIds).getSavedTheme, attributes);
        }
        const effectiveTheme = persistedRemoteTheme || persistedLocalTheme;
        if ((0, $9wGTI.fg)('confluence_typography_refreshed')) effectiveTheme.typography = 'typography-refreshed';
        return effectiveTheme;
    }
    static getSavedThemeLocal() {
        return (0, $8tOvf.LocalThemeStorage).getThemeLocal();
    }
    static localAndRemoteAreEqual(local, remote) {
        return (0, $lesra.getEffectiveThemeStateSerialized)(remote) === (0, $lesra.getEffectiveThemeStateSerialized)(local);
    }
}

});
parcelRegister("8tOvf", function(module, exports) {

$parcel$export(module.exports, "LocalThemeStorage", () => $1004ef7739cc518e$export$5294efe0574a1e18);

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $lesra = parcelRequire("lesra");
class $1004ef7739cc518e$export$5294efe0574a1e18 {
    static getThemeLocal() {
        const persistedLocalTheme = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_USER_THEME_PREFERENCE);
        return (0, $lesra.getEffectiveThemeState)(persistedLocalTheme || (0, $lesra.API_DEFAULT_THEME_STATE));
    }
    static saveThemeLocal(theme) {
        (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_USER_THEME_PREFERENCE, (0, $lesra.getEffectiveThemeStateSerialized)(theme));
    }
    // TODO - FF cleanup - This is only used when the RemoveOriginal FF is NOT enabled.
    // When the FF is enabled, there are no states where there isn't a theme.
    static removeThemeLocal() {
        // setItem is required for server-side local storage as removeItem does not remove server-side values
        (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_USER_THEME_PREFERENCE, (0, $lesra.API_ORIGINAL_THEME_STATE));
    }
}

});

parcelRegister("bkldv", function(module, exports) {

$parcel$export(module.exports, "RemoteThemeStorage", () => $d72d6a2d6dd6a6ab$export$d1c9d31e873127d9);

var $hp2SH = parcelRequire("hp2SH");

var $lesra = parcelRequire("lesra");

var $l7ck4 = parcelRequire("l7ck4");

var $15gP1 = parcelRequire("15gP1");

var $hxIwW = parcelRequire("hxIwW");
class $d72d6a2d6dd6a6ab$export$d1c9d31e873127d9 {
    static async getThemeRemote() {
        const { data: data, errors: errors } = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $15gP1.ThemePreferenceSelectorQuery)
        });
        if (errors) throw errors;
        return (0, $lesra.getEffectiveThemeState)(data.userPreferences.theme);
    }
    static async saveThemeRemote(theme) {
        try {
            const { errors: errors } = await (0, $hp2SH.getApolloClient)().mutate({
                mutation: (0, $hxIwW.ThemePreferenceMutation),
                variables: {
                    theme: (0, $lesra.getEffectiveThemeStateSerialized)(theme)
                }
            });
            if (errors) {
                const attributes = {
                    errors: errors.map((error)=>({
                            message: error.message,
                            stack: error.stack
                        })),
                    theme: theme
                };
                await (0, $l7ck4.reportThemingError)((0, $l7ck4.ErrorSubjects).remoteThemeStorage, (0, $l7ck4.ErrorSubjectIds).apolloMutationErrors, attributes);
            }
        } catch (e) {
            const attributes = {
                message: e.message,
                stack: e.stack,
                theme: theme
            };
            await (0, $l7ck4.reportThemingError)((0, $l7ck4.ErrorSubjects).remoteThemeStorage, (0, $l7ck4.ErrorSubjectIds).saveThemeRemote, attributes);
        }
    }
}

});
parcelRegister("l7ck4", function(module, exports) {

$parcel$export(module.exports, "ErrorSubjects", () => $c02479209652268b$export$d3fdcaafc90b083a);
$parcel$export(module.exports, "ErrorSubjectIds", () => $c02479209652268b$export$72a05cdc0e0fc7eb);
$parcel$export(module.exports, "reportThemingError", () => $c02479209652268b$export$57a9bc2929c9a2b1);

var $04e9M = parcelRequire("04e9M");
const $c02479209652268b$export$d3fdcaafc90b083a = {
    themeAPI: 'themeAPI',
    remoteThemeStorage: 'remoteThemeStorage',
    useThemingState: 'useThemingState'
};
const $c02479209652268b$export$72a05cdc0e0fc7eb = {
    getSavedTheme: 'getSavedTheme',
    apolloMutationErrors: 'apolloMutationErrors',
    saveThemeRemote: 'saveThemeRemote',
    setColorMode: 'setColorMode'
};
const $c02479209652268b$export$57a9bc2929c9a2b1 = async (subject, subjectId, attributes)=>{
    const client = await (0, $04e9M.getAnalyticsWebClient)();
    client.sendUIEvent({
        source: 'theming',
        action: 'error',
        actionSubject: subject,
        actionSubjectId: subjectId,
        attributes: attributes
    });
};

});

parcelRegister("15gP1", function(module, exports) {

$parcel$export(module.exports, "ThemePreferenceSelectorQuery", () => $225ceb107f3374df$export$5c26aa61dfa6c7dd);

var $d2LG0 = parcelRequire("d2LG0");
const $225ceb107f3374df$export$5c26aa61dfa6c7dd = (0, $d2LG0.default)`query ThemePreferenceSelectorQuery{userPreferences{theme}}`;

});

parcelRegister("hxIwW", function(module, exports) {

$parcel$export(module.exports, "ThemePreferenceMutation", () => $d8b91dac6faab6a9$export$8413d46ad6cb8150);

var $d2LG0 = parcelRequire("d2LG0");
const $d8b91dac6faab6a9$export$8413d46ad6cb8150 = (0, $d2LG0.default)`mutation ThemePreferenceMutation($theme:String!){updateUserPreferences(userPreferences:{theme:$theme}){theme}}`;

});



parcelRegister("cpjd2", function(module, exports) {

$parcel$export(module.exports, "requireLegacyWRM", () => $7aedb2e6c8290322$export$f89844936aed7607);
$parcel$export(module.exports, "realForceRequireLegacyWRM", () => $7aedb2e6c8290322$export$20f64252ab26976b);

var $7W8i8 = parcelRequire("7W8i8");

var $8SfNq = parcelRequire("8SfNq");

var $h3ZNO = parcelRequire("h3ZNO");
const $7aedb2e6c8290322$var$logger = (0, $7W8i8.getLogger)('wrm');
let $7aedb2e6c8290322$var$wrmEnabled = true;
function $7aedb2e6c8290322$export$889e833efbc89be2(enabled) {
    $7aedb2e6c8290322$var$wrmEnabled = enabled;
}
function $7aedb2e6c8290322$export$f89844936aed7607(wrm, callback, unavailableCallback) {
    if (!callback || !unavailableCallback || !$7aedb2e6c8290322$var$wrmEnabled) {
        // Timeout to avoid trigger infinite render loop in React Hooks
        if (unavailableCallback) setTimeout(unavailableCallback);
        return;
    }
    Promise.all([
        (0, $8SfNq.requireSuperBatch)(),
        (0, $h3ZNO.waitForWRM)()
    ]).then(([_superBatch, wrmFns])=>wrmFns?.require?.(Array.isArray(wrm) ? wrm : [
            wrm
        ], callback));
}
function $7aedb2e6c8290322$export$20f64252ab26976b(wrm, callback, unavailableCallback) {
    if (!callback || !unavailableCallback || !$7aedb2e6c8290322$var$wrmEnabled) {
        // Timeout to avoid trigger infinite render loop in React Hooks
        if (unavailableCallback) setTimeout(unavailableCallback);
        return;
    }
    Promise.all([
        (0, $8SfNq.requireSuperBatch)(),
        (0, $h3ZNO.waitForWRM)()
    ]).then(([_superBatch, wrmFns])=>wrmFns?.realForceRequire?.(Array.isArray(wrm) ? wrm : [
            wrm
        ], callback));
}

});
parcelRegister("h3ZNO", function(module, exports) {

$parcel$export(module.exports, "waitForWRM", () => $f663dee70ebb5ad8$export$6031f4216c50c6b);
let $f663dee70ebb5ad8$var$wrm = null;
function $f663dee70ebb5ad8$export$6031f4216c50c6b() {
    if ($f663dee70ebb5ad8$var$wrm) return $f663dee70ebb5ad8$var$wrm;
    $f663dee70ebb5ad8$var$wrm = new Promise((resolve)=>{
        const wrmInterval = window.setInterval(()=>{
            if (window.WRM && typeof window.WRM.require === 'function') {
                window.clearInterval(wrmInterval);
                resolve(window.WRM);
            }
        }, 50);
    });
    return $f663dee70ebb5ad8$var$wrm;
}

});


parcelRegister("8hUXc", function(module, exports) {

$parcel$export(module.exports, "CreateDialogContext", () => $73d59a54035866e7$export$8a4955b67fcd46ec);

var $gwFzn = parcelRequire("gwFzn");

var $3p0JS = parcelRequire("3p0JS");
const $73d59a54035866e7$export$8a4955b67fcd46ec = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext((0, $3p0JS.getDefaultContextState)());
$73d59a54035866e7$export$8a4955b67fcd46ec.displayName = 'CreateDialogContext';

});
parcelRegister("3p0JS", function(module, exports) {

$parcel$export(module.exports, "getDefaultChangeableValues", () => $53e04b1c25cc05a9$export$d04ae6f61d7c3eb1);
$parcel$export(module.exports, "getDefaultContextState", () => $53e04b1c25cc05a9$export$a2e7ab36beb33d74);
const $53e04b1c25cc05a9$export$d04ae6f61d7c3eb1 = {
    contentId: '',
    spaceKey: '',
    parentPageId: '',
    templateId: '',
    title: '',
    blueprint: {
        contentBlueprintId: '',
        itemModuleCompleteKey: ''
    },
    showTemplateVariableInputDrawer: false,
    showBlueprintVariableWizard: false,
    onContentUpdated: ()=>{},
    onError: ()=>{}
};
const $53e04b1c25cc05a9$export$a2e7ab36beb33d74 = ()=>{
    return {
        ...$53e04b1c25cc05a9$export$d04ae6f61d7c3eb1,
        onClose: ()=>{},
        openTemplateVariables: ({})=>{},
        openBlueprintWizard: ({})=>{}
    };
};

});


parcelRegister("caYQd", function(module, exports) {

$parcel$export(module.exports, "SpaceSelector", () => $a745dfd537cdace3$export$ae81af835e192ac4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $jmjWc = parcelRequire("jmjWc");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a745dfd537cdace3$var$LoadingSpaceSelector = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1tke1ylp",
            __cmplp.className
        ])
    });
});

const $a745dfd537cdace3$export$ae81af835e192ac4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SLEHS",
    name: "SpaceSelector",
    loader: async ()=>(await (parcelRequire("1Ax5U"))).SpaceSelector,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($a745dfd537cdace3$var$LoadingSpaceSelector, null)
});

});
parcelRegister("1Ax5U", function(module, exports) {

let $1282d30d9f6d4aeb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1282d30d9f6d4aeb$var$load("58UdM"),
    $1282d30d9f6d4aeb$var$load("4Qstt"),
    $1282d30d9f6d4aeb$var$load("5odbj"),
    $1282d30d9f6d4aeb$var$load("1ZoPC"),
    $1282d30d9f6d4aeb$var$load("hY77v"),
    $1282d30d9f6d4aeb$var$load("26IOy"),
    $1282d30d9f6d4aeb$var$load("2nuqm"),
    $1282d30d9f6d4aeb$var$load("giPb3"),
    $1282d30d9f6d4aeb$var$load("ecOVI"),
    $1282d30d9f6d4aeb$var$load("2S1L6"),
    $1282d30d9f6d4aeb$var$load("U7y88"),
    $1282d30d9f6d4aeb$var$load("fEx3B"),
    $1282d30d9f6d4aeb$var$load("dJQEi"),
    $1282d30d9f6d4aeb$var$load("aZinD"),
    $1282d30d9f6d4aeb$var$load("6qah4"),
    $1282d30d9f6d4aeb$var$load("j4gWN"),
    $1282d30d9f6d4aeb$var$load("i5Fj1"),
    $1282d30d9f6d4aeb$var$load("c6MKV"),
    $1282d30d9f6d4aeb$var$load("eMbU0")
]).then(()=>parcelRequire('bHtQ2'));

});


parcelRegister("7HO5s", function(module, exports) {

$parcel$export(module.exports, "SuperAdminBanner", () => $59c366c823143082$export$d71d84f1864a608a);
$parcel$export(module.exports, "SuperAdminEntryPoint", () => $59c366c823143082$export$f265d8a86f21f5a8);
$parcel$export(module.exports, "AdminKeyUpSell", () => $59c366c823143082$export$428a8cf25dac230d);
$parcel$export(module.exports, "PremiumAdminEvent", () => $59c366c823143082$export$e67af8512f9fa98a);
$parcel$export(module.exports, "AdminKeyEligibilityQuery", () => (parcelRequire("0g3Y7")).AdminKeyEligibilityQuery);
$parcel$export(module.exports, "AdminKeyQuery", () => (parcelRequire("lfFzM")).AdminKeyQuery);
$parcel$export(module.exports, "useIsSuperAdmin", () => (parcelRequire("lfFzM")).useIsSuperAdmin);

var $jmjWc = parcelRequire("jmjWc");

var $0g3Y7 = parcelRequire("0g3Y7");

var $lfFzM = parcelRequire("lfFzM");

const $59c366c823143082$export$d71d84f1864a608a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "RGjuy",
    name: "SuperAdminBanner",
    loader: async ()=>(await (parcelRequire("8cEtH"))).SuperAdminBanner
});

const $59c366c823143082$export$36fd1dbe77f9111f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "W_m0g",
    name: "SuperAdminExpiration",
    loader: async ()=>(await (parcelRequire("jxF2h"))).SuperAdminExpiration
});

const $59c366c823143082$export$f265d8a86f21f5a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "S3W4o",
    name: "SuperAdminEntryPoint",
    loader: async ()=>(await (parcelRequire("7HvMX"))).SuperAdminEntryPoint
});

const $59c366c823143082$export$428a8cf25dac230d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "FWk2H",
    name: "AdminKeyUpSell",
    loader: async ()=>(await (parcelRequire("klFvv"))).AdminKeyUpSell
});

const $59c366c823143082$export$6afac0a4ae06cb48 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ekK-r",
    name: "SuperAdminSatisfactionSurvey",
    loader: async ()=>(await (parcelRequire("7YujD"))).SuperAdminSatisfactionSurvey
});

const $59c366c823143082$export$e67af8512f9fa98a = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "Zj71S",
    name: "PremiumAdminEvent",
    loader: async ()=>(await (parcelRequire("jyl3n"))).PremiumAdminEvent
});

});
parcelRegister("0g3Y7", function(module, exports) {

$parcel$export(module.exports, "AdminKeyEligibilityQuery", () => $bb950e1e25a27f84$export$8e5be031fba9cbe5);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $fppBw = parcelRequire("fppBw");
parcelRequire("j1Ss3");
var $xQxzY = parcelRequire("xQxzY");
parcelRequire("dIouf");
var $1uFM6 = parcelRequire("1uFM6");

var $7Sm4c = parcelRequire("7Sm4c");
function $bb950e1e25a27f84$export$8e5be031fba9cbe5({ children: children }) {
    const { data: data, error: error, loading: loading } = (0, $xQxzY.useQuery)((0, $d2LG0.default)`query AdminKeyEligibilityQueryAdminKeyEligibilityQuery{tenant{cloudId editions{edition}}user(current:true){id confluence{roles{canBeSuperAdmin}}}}`);
    let errorToReportToChildren;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) // If `edition` is not permitted to the current user (e.g. anonymous
        // access is not permitted), then the current user is definitely not
        // eligible for admin key. So here an unauthorized error is an expected
        // error.
        (0, $7Sm4c.markErrorAsHandled)(error);
        else errorToReportToChildren = error;
    }
    return children({
        canBeSuperAdmin: Boolean(data?.user?.confluence?.roles?.canBeSuperAdmin),
        edition: data?.tenant?.editions?.edition,
        error: errorToReportToChildren,
        loading: loading
    });
}
$bb950e1e25a27f84$export$8e5be031fba9cbe5.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired
};

});

parcelRegister("lfFzM", function(module, exports) {

$parcel$export(module.exports, "useIsSuperAdmin", () => $f78b3fd6fbd1f922$export$dd53ec461ae8f03e);
$parcel$export(module.exports, "AdminKeyQuery", () => $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a);

var $fppBw = parcelRequire("fppBw");

var $xQxzY = parcelRequire("xQxzY");

var $6jrkJ = parcelRequire("6jrkJ");

var $kOBmw = parcelRequire("kOBmw");
const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $xQxzY.useQuery)((0, $kOBmw.IsSuperAdmin), {
        skip: !hasSuperAdminClaim
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired
};

});
parcelRegister("kOBmw", function(module, exports) {

$parcel$export(module.exports, "IsSuperAdmin", () => $1f121c69ed56862b$export$b43e9b817e671e28);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $1f121c69ed56862b$export$b43e9b817e671e28 = (0, $d2LG0.default)`query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id confluence{roles{isSuperAdmin}}}}`;

});


parcelRegister("8cEtH", function(module, exports) {

let $5f8ed7cf0b5f9118$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $5f8ed7cf0b5f9118$var$load("fmzVU"),
    $5f8ed7cf0b5f9118$var$load("gdXTv"),
    $5f8ed7cf0b5f9118$var$load("kiqoj")
]).then(()=>parcelRequire('hnH0O'));

});

parcelRegister("jxF2h", function(module, exports) {

let $e3a0ee371a595472$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e3a0ee371a595472$var$load("fmzVU").then(()=>parcelRequire('8rvy7'));

});

parcelRegister("7HvMX", function(module, exports) {

let $59b535225a180932$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $59b535225a180932$var$load("euA5f").then(()=>parcelRequire('bZz8I'));

});

parcelRegister("klFvv", function(module, exports) {

let $ed05f73fb2bcee4a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ed05f73fb2bcee4a$var$load("6f3t8").then(()=>parcelRequire('ie54a'));

});

parcelRegister("7YujD", function(module, exports) {

let $5ce5a713596b1b91$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5ce5a713596b1b91$var$load("gdXTv").then(()=>parcelRequire('31yub'));

});

parcelRegister("jyl3n", function(module, exports) {

let $e3c186165e4793a0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e3c186165e4793a0$var$load("8mbeF").then(()=>parcelRequire('8fA1P'));

});


parcelRegister("2VHSy", function(module, exports) {

$parcel$export(module.exports, "createAnalyticsEventFactory", () => $d84dbdb638867381$export$71e2f6367fb20728);
function $d84dbdb638867381$export$71e2f6367fb20728(createAnalyticsEvent, eventSource, defaultAttributes) {
    return (payload)=>{
        const { data: data } = payload;
        if (!data) throw new Error('payload.data should be defined');
        return createAnalyticsEvent({
            ...payload,
            data: {
                ...data,
                source: eventSource,
                attributes: {
                    ...defaultAttributes,
                    ...data.attributes
                }
            }
        });
    };
}

});

parcelRegister("bmTgR", function(module, exports) {

$parcel$export(module.exports, "isDesktop", () => $7e1979726f59660a$export$1e4fed98bcaa1d82);
$parcel$export(module.exports, "establishIPCListeners", () => $7e1979726f59660a$export$b21bea20d2d8ffb1);

var $04e9M = parcelRequire("04e9M");
const $7e1979726f59660a$export$1e4fed98bcaa1d82 = ()=>{
    return !!$parcel$global?.window?.desktopNativeBridge;
};
const $7e1979726f59660a$export$b21bea20d2d8ffb1 = ()=>{
    if (!$7e1979726f59660a$export$1e4fed98bcaa1d82()) return ()=>{};
    const listenersCleanup = [];
    listenersCleanup.push($parcel$global.window.desktopNativeBridge.onAnalyticsEvent((eventData)=>{
        (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
            if (eventData.type === 'sendTrackEvent' && eventData.data) client.sendTrackEvent(eventData.data);
        }).catch(()=>{});
    }));
    return ()=>{
        listenersCleanup.forEach((cleanUpFn)=>cleanUpFn());
    };
};

});

parcelRegister("1BYn9", function(module, exports) {

$parcel$export(module.exports, "useIsProductAdmin", () => $141bd073c52fec74$export$44f5b9746e66da9);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $xQxzY = parcelRequire("xQxzY");

var $5ZqQS = parcelRequire("5ZqQS");
parcelRequire("dIouf");
var $3IBnw = parcelRequire("3IBnw");
var $1uFM6 = parcelRequire("1uFM6");

var $7Sm4c = parcelRequire("7Sm4c");

var $fWkVZ = parcelRequire("fWkVZ");
const $141bd073c52fec74$export$44f5b9746e66da9 = ()=>{
    const { data: data, error: error, loading: isAdminCheckLoading } = (0, $xQxzY.useQuery)((0, $d2LG0.default)`query useIsProductAdminUseIsProductAdminQuery{user(current:true){id confluence{operations{operation targetType}}}isSiteAdmin hasUserAccessAdminRole}`);
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(data);
    return {
        isProductAdmin: isProductAdmin,
        isAdminCheckLoading: isAdminCheckLoading
    };
};

});

parcelRegister("7J5Uc", function(module, exports) {

$parcel$export(module.exports, "useThemingState", () => $84c4a68da1697f73$export$effd3de03784e6fe);
$parcel$export(module.exports, "useThemingActions", () => $84c4a68da1697f73$export$f33beb6f493a54ff);

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");

var $bRwDd = parcelRequire("bRwDd");
var $iZdrT = parcelRequire("iZdrT");
var $hxeND = parcelRequire("hxeND");
var $58u2L = parcelRequire("58u2L");
var $5yVAS = parcelRequire("5yVAS");

var $04e9M = parcelRequire("04e9M");

var $l7ck4 = parcelRequire("l7ck4");

var $fzfTC = parcelRequire("fzfTC");

var $1NBp8 = parcelRequire("1NBp8");
const $84c4a68da1697f73$var$initialState = {
    isInitialized: false,
    theme: (0, $58u2L.getDefaultTheme)()
};
const $84c4a68da1697f73$export$bf1195c0a25965df = {
    applyTheme: (theme)=>async ()=>{
            await (0, $iZdrT.applyTheme)(theme);
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            client.setUIViewedAttributes({
                theme: theme,
                // OStheme may become stale until the session is restarted since the user can
                //      change their system/browser settings at any time without manually changing their theme in the app.
                OStheme: (0, $5yVAS.getSystemPreferredColorScheme)()
            });
        },
    initializeTheme: (initialTheme)=>async ({ setState: setState, dispatch: dispatch })=>{
            if (!initialTheme) {
                // Get local theme first to help render theme faster than waiting to fetch latest preference from remote
                const persistedLocalTheme = (0, $fzfTC.ThemeAPI).getSavedThemeLocal();
                if (persistedLocalTheme) dispatch($84c4a68da1697f73$export$bf1195c0a25965df.applyTheme((0, $hxeND.buildThemeFromState)(persistedLocalTheme)));
            }
            (0, $bRwDd.addIframeThemingSupport)();
            const theme = initialTheme || await (0, $fzfTC.ThemeAPI).getSavedTheme();
            // Check if it's the PDF export route and force light mode if it is
            const isPdfExport = (0, $1NBp8.PDF_EXPORT_PAGE).match(window.location.pathname);
            if (isPdfExport) theme.colorMode = 'light';
            const effectiveTheme = (0, $hxeND.buildThemeFromState)(theme);
            setState({
                isInitialized: true,
                theme: effectiveTheme
            });
            await dispatch($84c4a68da1697f73$export$bf1195c0a25965df.applyTheme(effectiveTheme));
        },
    setColorModePreference: (themeColorMode)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const theme = {
                ...getState().theme,
                colorMode: themeColorMode
            };
            try {
                setState({
                    ...getState(),
                    theme: theme
                });
                await Promise.all([
                    dispatch($84c4a68da1697f73$export$bf1195c0a25965df.applyTheme(theme)),
                    (0, $fzfTC.ThemeAPI).saveTheme(theme)
                ]);
            } catch (e) {
                const attributes = {
                    message: e.message,
                    stack: e.stack
                };
                await (0, $l7ck4.reportThemingError)((0, $l7ck4.ErrorSubjects).useThemingState, (0, $l7ck4.ErrorSubjectIds).setColorMode, attributes);
            }
        },
    restoreThemePreference: ()=>async ({ dispatch: dispatch, getState: getState })=>{
            const { theme: theme } = getState();
            await dispatch($84c4a68da1697f73$export$bf1195c0a25965df.applyTheme(theme));
        }
};
const $84c4a68da1697f73$var$Store = (0, $4ZoIm.createStore)({
    initialState: $84c4a68da1697f73$var$initialState,
    actions: $84c4a68da1697f73$export$bf1195c0a25965df,
    name: 'themingState'
});
const $84c4a68da1697f73$export$338c28a47b6eab8 = (0, $2S0Fz.createContainer)($84c4a68da1697f73$var$Store, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialTheme: initialTheme })=>{
            dispatch($84c4a68da1697f73$export$bf1195c0a25965df.initializeTheme(initialTheme));
        }
});
const $84c4a68da1697f73$export$effd3de03784e6fe = (0, $iFWZA.createHook)($84c4a68da1697f73$var$Store);
const $84c4a68da1697f73$export$f33beb6f493a54ff = (0, $iFWZA.createActionsHook)($84c4a68da1697f73$var$Store);

});
parcelRegister("bRwDd", function(module, exports) {

$parcel$export(module.exports, "setupThemeInsideIframe", () => $d731e5061d622ebc$export$377bd665ab309e4c);
$parcel$export(module.exports, "applyThemeInsideIframe", () => $d731e5061d622ebc$export$99897b9fec3a0556);
$parcel$export(module.exports, "addIframeThemingSupport", () => $d731e5061d622ebc$export$aba0049abf5d5b9a);

var $8z9j5 = parcelRequire("8z9j5");
var $hY0xh = parcelRequire("hY0xh");
var $geGFh = parcelRequire("geGFh");
var $60yhz = parcelRequire("60yhz");
const $d731e5061d622ebc$var$buildStyleElements = async (activeTheme)=>{
    return (await (0, $geGFh.default)(activeTheme)).map((theme)=>{
        const styleElement = document.createElement('style');
        styleElement.innerHTML = theme.css;
        Object.entries(theme.attrs).forEach(([key, value])=>styleElement.setAttribute(key, value));
        return styleElement;
    });
};
// Can be invoked from iframes that have access to the parent window and allows for theme information to be passed into the iframe
const $d731e5061d622ebc$var$initializeIframeTheming = async (onThemeUpdated)=>{
    const activeTheme = (0, $8z9j5.default)();
    const observer = new (0, $60yhz.default)(async (newTheme)=>{
        onThemeUpdated({
            themeHtmlAttrs: (0, $hY0xh.default)(newTheme),
            styleElements: await $d731e5061d622ebc$var$buildStyleElements(newTheme)
        });
    });
    observer.observe();
    const onIframeClose = ()=>observer.disconnect();
    return {
        themeHtmlAttrs: (0, $hY0xh.default)(activeTheme),
        styleElements: await $d731e5061d622ebc$var$buildStyleElements(activeTheme),
        onIframeClose: onIframeClose
    };
};
const $d731e5061d622ebc$export$377bd665ab309e4c = (onThemeUpdated)=>{
    if (window.parent.initializeIframeTheming) window.parent.initializeIframeTheming(onThemeUpdated).then((iframeThemeInitInfo)=>{
        onThemeUpdated(iframeThemeInitInfo);
        // Remove listener to prevent memory leaks
        window.addEventListener('beforeunload', iframeThemeInitInfo.onIframeClose);
    });
};
const $d731e5061d622ebc$export$99897b9fec3a0556 = (iframeThemeInfo, doc)=>{
    // Add HTMl attributes which trigger styles to take effect
    Object.entries(iframeThemeInfo.themeHtmlAttrs).forEach(([key, value])=>doc.documentElement.setAttribute(key, value));
    // Add theming stylesheet(s) into page
    iframeThemeInfo.styleElements.forEach((styleElement)=>{
        const existingStyleElement = doc.head.querySelector(`style[data-theme="${styleElement.getAttribute('data-theme')}"]`);
        if (!existingStyleElement) // Prevent re-inserting the same style element into the DOM repeatedly
        doc.head.appendChild(styleElement);
    });
};
const $d731e5061d622ebc$export$aba0049abf5d5b9a = ()=>{
    window.initializeIframeTheming = $d731e5061d622ebc$var$initializeIframeTheming;
};

});

parcelRegister("iZdrT", function(module, exports) {

$parcel$export(module.exports, "applyTheme", () => $9f527f233178b863$export$49e16ec648d05eb2);

var $bRSdj = parcelRequire("bRSdj");
const $9f527f233178b863$export$49e16ec648d05eb2 = async (theme)=>{
    await (0, $bRSdj.default)(theme);
};

});

parcelRegister("5yVAS", function(module, exports) {

$parcel$export(module.exports, "getSystemPreferredColorScheme", () => $e3e99e727739913b$export$fd83dd01b496ad39);
const $e3e99e727739913b$var$darkModeMediaQuery = '(prefers-color-scheme: dark)';
const $e3e99e727739913b$export$fd83dd01b496ad39 = ()=>{
    const isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
    const darkModeMql = isMatchMediaAvailable && window.matchMedia($e3e99e727739913b$var$darkModeMediaQuery);
    return darkModeMql && darkModeMql.matches ? 'dark' : 'light';
};

});


parcelRegister("iyEDi", function(module, exports) {

$parcel$export(module.exports, "routerStateExists", () => $d82aebd029e71988$export$7143d27196c8ece);
$parcel$export(module.exports, "getLocation", () => $d82aebd029e71988$export$e7fd20fad3cf4b5f);
$parcel$export(module.exports, "getRouteParams", () => $d82aebd029e71988$export$b9a4691d132f3891);
const $d82aebd029e71988$export$7143d27196c8ece = (state)=>// TODO: https://product-fabric.atlassian.net/browse/BM-429
    // Note: It is not safe to checking the state.router anymore because it is always not null
    // This is a temporary fix to avoid fixing every usage of this function
    !state.isServerRenderedPage && Boolean(state.router);
const $d82aebd029e71988$export$e7fd20fad3cf4b5f = (state)=>!state.isServerRenderedPage && state.router ? state.router.location : {};
const $d82aebd029e71988$export$e2de15bbd9edf9c6 = (state)=>{
    const stateLocation = $d82aebd029e71988$export$e7fd20fad3cf4b5f(state);
    return stateLocation && stateLocation.query ? stateLocation.query : {};
};
const $d82aebd029e71988$export$b9a4691d132f3891 = (state)=>!state.isServerRenderedPage && state.router ? state.router.params || {} : {};

});

parcelRegister("2MhGC", function(module, exports) {

$parcel$export(module.exports, "EditPageLoadingListener", () => $acca497e53e6da3b$export$ef343af51345d8b6);
$parcel$export(module.exports, "useEditPageLoadingValues", () => (parcelRequire("jHo7b")).useEditPageLoadingValues);
$parcel$export(module.exports, "useEditPageLoadingActions", () => (parcelRequire("jHo7b")).useEditPageLoadingActions);
$parcel$export(module.exports, "NativeEditPageDataLoader", () => (parcelRequire("fP8CJ")).NativeEditPageDataLoader);
$parcel$export(module.exports, "extractIsEditorVersionFabric", () => (parcelRequire("6THoV")).extractIsEditorVersionFabric);
$parcel$export(module.exports, "extractEditorContentType", () => (parcelRequire("6THoV")).extractEditorContentType);
$parcel$export(module.exports, "EditorTypeAndVersionPropertyQuery", () => (parcelRequire("iU4hK")).EditorTypeAndVersionPropertyQuery);
$parcel$export(module.exports, "preloadEditorData", () => (parcelRequire("cvj7x")).preloadEditorData);

var $jmjWc = parcelRequire("jmjWc");

var $jHo7b = parcelRequire("jHo7b");

var $fP8CJ = parcelRequire("fP8CJ");

var $6THoV = parcelRequire("6THoV");

var $iU4hK = parcelRequire("iU4hK");

var $cvj7x = parcelRequire("cvj7x");


const $acca497e53e6da3b$export$ef343af51345d8b6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "-gHi2",
    name: "EditPageLoadingListener",
    loader: async ()=>(await (parcelRequire("jF5VE"))).EditPageLoadingListener
});

});
parcelRegister("fP8CJ", function(module, exports) {

$parcel$export(module.exports, "NativeEditPageDataLoader", () => $3572f49d3116b537$export$b571e87650a41a8a);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $bQm3c = parcelRequire("bQm3c");
parcelRequire("jXpbL");
var $8KbKw = parcelRequire("8KbKw");
var $1sAC2 = parcelRequire("1sAC2");
const $3572f49d3116b537$export$b571e87650a41a8a = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        (async ()=>{
            const getPermissionsToken = async ()=>{
                try {
                    const token = await (0, $8KbKw.fetchCollabPermissionToken)(contentId, '')();
                    if (token) {
                        (0, $1sAC2.nativeCollabPermissionsTokenState).setTimestamp(contentId);
                        return token;
                    }
                } catch (err) {
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            actionSubject: 'NCS preloading',
                            action: 'error preloading perms token on hover',
                            source: 'NativeEditPageDataLoader',
                            attributes: {
                                contentId: contentId,
                                err: err
                            }
                        }
                    }).fire();
                }
                return null;
            };
            (0, $1sAC2.nativeCollabPermissionsTokenState).setToken(contentId, getPermissionsToken());
        })();
    }, [
        contentId,
        cloudId,
        contentType,
        spaceKey,
        userId,
        createAnalyticsEvent
    ]);
    return null;
};

});

parcelRegister("6THoV", function(module, exports) {

$parcel$export(module.exports, "fetchEditorTypeAndVersionPropertyQuery", () => $e90b24eb9bf112a3$export$f4cf64a580f914c9);
$parcel$export(module.exports, "extractIsEditorVersionFabric", () => $e90b24eb9bf112a3$export$ff64ced87bc09a97);
$parcel$export(module.exports, "extractEditorContentType", () => $e90b24eb9bf112a3$export$7bf9d503a242c2d4);

var $hp2SH = parcelRequire("hp2SH");

var $iU4hK = parcelRequire("iU4hK");
const $e90b24eb9bf112a3$var$firePerformanceEvent = (createAnalyticsEvent, { queryLoadTime: queryLoadTime, contentId: contentId })=>{
    createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'fetchEditorTypeAndVersionPropertyQuery',
            actionSubject: 'nativeEditor',
            source: 'confluenceFrontend',
            objectId: contentId,
            attributes: {
                queryLoadTime: queryLoadTime
            }
        }
    }).fire();
};
const $e90b24eb9bf112a3$export$f4cf64a580f914c9 = async ({ contentId: contentId, createAnalyticsEvent: createAnalyticsEvent })=>{
    const apolloClient = (0, $hp2SH.getApolloClient)();
    const beforeQueryTime = performance.now();
    const editorTypeAndVersionPropertyResult = await apolloClient.query({
        query: (0, $iU4hK.EditorTypeAndVersionPropertyQuery),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'cache-first',
        context: {
            single: 'true'
        }
    });
    if (createAnalyticsEvent) $e90b24eb9bf112a3$var$firePerformanceEvent(createAnalyticsEvent, {
        queryLoadTime: performance.now() - beforeQueryTime,
        contentId: contentId
    });
    return editorTypeAndVersionPropertyResult?.data;
};
const $e90b24eb9bf112a3$export$ff64ced87bc09a97 = (data)=>{
    const value = data?.content?.nodes?.[0]?.editor?.nodes?.[0]?.value;
    return value === '"v2"' || value === 'v2';
};
const $e90b24eb9bf112a3$export$7bf9d503a242c2d4 = (data)=>{
    return data?.content?.nodes?.[0]?.type || null;
};

});
parcelRegister("iU4hK", function(module, exports) {

$parcel$export(module.exports, "EditorTypeAndVersionPropertyQuery", () => $70617a758801487b$export$e4c62aad8fe37429);

var $d2LG0 = parcelRequire("d2LG0");
const $70617a758801487b$export$e4c62aad8fe37429 = (0, $d2LG0.default)`query EditorTypeAndVersionPropertyQuery($contentId:ID){content(id:$contentId status:["current" "draft"]){nodes{id type editor:properties(key:"editor"){nodes{id key value}}}}}`;

});


parcelRegister("jF5VE", function(module, exports) {

let $e50672030c12f93f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e50672030c12f93f$var$load("37V0d"),
    $e50672030c12f93f$var$load("5vatq"),
    $e50672030c12f93f$var$load("6qah4"),
    $e50672030c12f93f$var$load("87F9B"),
    $e50672030c12f93f$var$load("aZinD"),
    $e50672030c12f93f$var$load("4m5MY")
]).then(()=>parcelRequire('j89ZI'));

});


parcelRegister("ggM8l", function(module, exports) {

$parcel$export(module.exports, "haveDiscoveredFeaturesBeenLoaded", () => $bd837a4cdefa63be$export$ef98cff420b6492b);
$parcel$export(module.exports, "hasFeatureBeenDiscoveredSelector", () => $bd837a4cdefa63be$export$f006967cf667fd76);

var $bsCwp = parcelRequire("bsCwp");

var $19fl2 = parcelRequire("19fl2");
const $bd837a4cdefa63be$export$e17af168639dd312 = (state)=>state.discoveredFeatures;
const $bd837a4cdefa63be$export$ef98cff420b6492b = (0, $bsCwp.createSelector)($bd837a4cdefa63be$export$e17af168639dd312, (discoveredPluginFeatures)=>discoveredPluginFeatures.get('hasLoaded'));
const $bd837a4cdefa63be$var$getInputParameter = (state, param)=>param;
const $bd837a4cdefa63be$export$f006967cf667fd76 = (0, $bsCwp.createSelector)($bd837a4cdefa63be$export$e17af168639dd312, $bd837a4cdefa63be$export$ef98cff420b6492b, $bd837a4cdefa63be$var$getInputParameter, (discoveredPluginFeatures, discoveredFeaturesLoaded, { pluginKey: pluginKey = '', featureKey: featureKey = '' } = {})=>!discoveredFeaturesLoaded || (0, $19fl2.hasFeatureBeenDiscovered)(discoveredPluginFeatures.get('list'), {
        pluginKey: pluginKey,
        featureKey: featureKey
    }));

});

parcelRegister("52UBD", function(module, exports) {

$parcel$export(module.exports, "hasSpotlightBeenInvoked", () => $3ac90c69984fb32c$export$808b4cfe1b1fa184);
$parcel$export(module.exports, "getSpotlightStorageKey", () => $3ac90c69984fb32c$export$ba6c4d8b172bbf9e);
$parcel$export(module.exports, "pluginKey", () => $3ac90c69984fb32c$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "getCurrentSpotlightAttributes", () => $3ac90c69984fb32c$export$c1d7738d965e3481);
$parcel$export(module.exports, "getChangeboardingSpotlightIds", () => $3ac90c69984fb32c$export$b5666a506d13f000);
$parcel$export(module.exports, "getTotalChangeboardingSpotlights", () => $3ac90c69984fb32c$export$443049729e323335);
$parcel$export(module.exports, "getCurrentSpotlightId", () => $3ac90c69984fb32c$export$d1564a5cdee8c52f);
$parcel$export(module.exports, "isChangeboardingUrlBlacklisted", () => $3ac90c69984fb32c$export$59bfe9c3b3be6bc);
$parcel$export(module.exports, "shouldChangeboardingInstanceRender", () => $3ac90c69984fb32c$export$32decc16a9d1b7c4);
$parcel$export(module.exports, "getChangeboardingActions", () => $3ac90c69984fb32c$export$80e7cb43dd9cc8a6);

var $bsCwp = parcelRequire("bsCwp");

var $ggM8l = parcelRequire("ggM8l");
var $gnnzK = parcelRequire("gnnzK");

var $iyEDi = parcelRequire("iyEDi");
const $3ac90c69984fb32c$var$A_SECOND_AGO = new Date(Date.now() - 1000);
const $3ac90c69984fb32c$var$A_YEAR_FROM_NOW = new Date(Date.now() + 3.154e10);
const $3ac90c69984fb32c$var$getSpotlightId = (props)=>props.spotlightId;
const $3ac90c69984fb32c$var$getStartDate = (props)=>props.startDate || $3ac90c69984fb32c$var$A_SECOND_AGO;
const $3ac90c69984fb32c$var$getEndDate = (props)=>props.endDate || $3ac90c69984fb32c$var$A_YEAR_FROM_NOW;
const $3ac90c69984fb32c$var$getDarkFeatureEnabled = (props)=>props.darkFeatureEnabled;
const $3ac90c69984fb32c$var$getDarkFeatureDisabled = (props)=>props.darkFeatureDisabled;
const $3ac90c69984fb32c$var$getIndex = (state)=>state.get('index');
const $3ac90c69984fb32c$var$getLoaded = (state)=>state.get('loaded');
const $3ac90c69984fb32c$var$getFlow = (state)=>state.get('flow');
const $3ac90c69984fb32c$var$getSpotlights = (state)=>state.get('spotlights');
const $3ac90c69984fb32c$export$808b4cfe1b1fa184 = (0, $bsCwp.createSelector)([
    $3ac90c69984fb32c$var$getSpotlights,
    (state, props)=>$3ac90c69984fb32c$var$getSpotlightId(props)
], (spotlights, spotlightId)=>{
    for(let flowIndex = 0; flowIndex < spotlights.size; flowIndex++)for(let spotlightIndex = 0; spotlightIndex < spotlights.get(flowIndex).size; spotlightIndex++){
        if (spotlights.getIn([
            flowIndex,
            spotlightIndex,
            'id'
        ]) === spotlightId) return spotlights.getIn([
            flowIndex,
            spotlightIndex,
            'requested'
        ]);
    }
    return false;
});
const $3ac90c69984fb32c$export$ba6c4d8b172bbf9e = (spotlightId)=>`${spotlightId}.viewed`;
const $3ac90c69984fb32c$export$18d4026d1ea86bb1 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $3ac90c69984fb32c$var$getCurrentFlow = (0, $bsCwp.createSelector)([
    $3ac90c69984fb32c$var$getSpotlights,
    $3ac90c69984fb32c$var$getFlow
], (spotlights, flow)=>spotlights.get(flow));
const $3ac90c69984fb32c$var$getCurrentSpotlight = (0, $bsCwp.createSelector)([
    $3ac90c69984fb32c$var$getCurrentFlow,
    $3ac90c69984fb32c$var$getIndex
], (currentFlow, index)=>currentFlow.get(index));
const $3ac90c69984fb32c$export$c1d7738d965e3481 = (0, $bsCwp.createSelector)([
    $3ac90c69984fb32c$var$getCurrentSpotlight
], (spotlight)=>spotlight ? spotlight.get('attributes').toJSON() : {});
const $3ac90c69984fb32c$export$b5666a506d13f000 = (0, $bsCwp.createSelector)([
    $3ac90c69984fb32c$var$getCurrentFlow
], (currentFlow)=>currentFlow ? currentFlow.map((spotlight)=>spotlight.get('id')).toArray() : []);
const $3ac90c69984fb32c$export$443049729e323335 = (0, $bsCwp.createSelector)([
    $3ac90c69984fb32c$var$getLoaded
], (loaded)=>loaded);
const $3ac90c69984fb32c$export$d1564a5cdee8c52f = (0, $bsCwp.createSelector)([
    $3ac90c69984fb32c$var$getCurrentSpotlight
], (currentSpotlight)=>currentSpotlight ? currentSpotlight.get('id') : null);
const $3ac90c69984fb32c$var$isChangeboardingWithinDateRange = (0, $bsCwp.createSelector)([
    $3ac90c69984fb32c$var$getStartDate,
    $3ac90c69984fb32c$var$getEndDate
], (startDate, endDate)=>{
    const now = Date.now();
    return startDate.getTime() <= now && endDate.getTime() >= now;
});
const $3ac90c69984fb32c$var$hasBeenDiscovered = (state, ownProps)=>{
    const featureKey = $3ac90c69984fb32c$export$ba6c4d8b172bbf9e($3ac90c69984fb32c$var$getSpotlightId(ownProps));
    return (0, $ggM8l.hasFeatureBeenDiscoveredSelector)(state, {
        pluginKey: $3ac90c69984fb32c$export$18d4026d1ea86bb1,
        featureKey: featureKey
    });
};
const $3ac90c69984fb32c$var$getDarkFeatureFulfillment = (0, $bsCwp.createSelector)([
    (state, ownProps)=>{
        const darkFeature = $3ac90c69984fb32c$var$getDarkFeatureEnabled(ownProps);
        return !darkFeature || (0, $gnnzK.isDarkFeatureEnabledSelector)(state, darkFeature);
    },
    (state, ownProps)=>{
        const darkFeature = $3ac90c69984fb32c$var$getDarkFeatureDisabled(ownProps);
        return !darkFeature || !(0, $gnnzK.isDarkFeatureEnabledSelector)(state, darkFeature);
    }
], (enabledOk, disabledOk)=>enabledOk && disabledOk);
const $3ac90c69984fb32c$export$59bfe9c3b3be6bc = (state)=>{
    const { query: query = {}, hash: hash = '' } = (0, $iyEDi.getLocation)(state);
    return hash !== '' || query.preview;
};
const $3ac90c69984fb32c$export$32decc16a9d1b7c4 = (0, $bsCwp.createSelector)([
    (0, $ggM8l.haveDiscoveredFeaturesBeenLoaded),
    $3ac90c69984fb32c$var$hasBeenDiscovered,
    $3ac90c69984fb32c$var$getDarkFeatureFulfillment,
    (state, ownProps)=>$3ac90c69984fb32c$var$isChangeboardingWithinDateRange(ownProps)
], (discoveredFeaturesLoaded, discovered, darkFeaturesFulfilled, withinRange)=>discoveredFeaturesLoaded && !discovered && darkFeaturesFulfilled && withinRange);
const $3ac90c69984fb32c$export$80e7cb43dd9cc8a6 = (0, $bsCwp.createSelector)([
    $3ac90c69984fb32c$export$443049729e323335,
    $3ac90c69984fb32c$var$getIndex
], (total, index)=>{
    const prev = index > 0;
    const next = index + 1 < total;
    const done = !next;
    return {
        prev: prev,
        next: next,
        done: done
    };
});

});
parcelRegister("gnnzK", function(module, exports) {

$parcel$export(module.exports, "isDarkFeatureEnabledSelector", () => $bec114f6471429fc$export$8c6804d930fb4852);
$parcel$export(module.exports, "isContentTypeOf", () => $bec114f6471429fc$export$ce5ed99486d97400);

var $bsCwp = parcelRequire("bsCwp");
const $bec114f6471429fc$export$7eb3da172b73083d = (0, $bsCwp.createSelector)((state)=>state.meta, (meta)=>{
    if (!meta) return true;
    return !meta.get('atlassian-account-id');
});
const $bec114f6471429fc$export$a15e774d3d888bb9 = (state)=>state.meta ? state.meta.get('enabled-dark-features', '').split(',') : [];
const $bec114f6471429fc$var$getInputDarkFeature = (state, input)=>input;
const $bec114f6471429fc$export$8c6804d930fb4852 = (0, $bsCwp.createSelector)($bec114f6471429fc$export$a15e774d3d888bb9, $bec114f6471429fc$var$getInputDarkFeature, (enabledDarkFeatures, input)=>enabledDarkFeatures.indexOf(input) > -1 && enabledDarkFeatures.indexOf(`${input}.disable`) === -1);
const $bec114f6471429fc$export$ce5ed99486d97400 = (0, $bsCwp.createSelector)((type)=>type, (type, state)=>state.meta.get('content-type', ''), (type, contentType)=>contentType.toLowerCase() === type.toLowerCase());

});


parcelRegister("bYVgS", function(module, exports) {

$parcel$export(module.exports, "ChangeboardingTargetLazyLoader", () => $8b91b9309a2477ed$export$eb3796e87f924aea);
$parcel$export(module.exports, "ChangeboardingSpotlightLazyLoader", () => $8b91b9309a2477ed$export$cc62753e1f95cf16);

var $jmjWc = parcelRequire("jmjWc");

const $8b91b9309a2477ed$export$eb3796e87f924aea = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Yu-v_",
    name: "ChangeboardingTargetLazyLoader",
    loader: ()=>(parcelRequire("1Vklz"))
});

const $8b91b9309a2477ed$export$cc62753e1f95cf16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cs9b2",
    name: "ChangeboardingSpotlightLazyLoader",
    loader: ()=>(parcelRequire("bhwWJ"))
});

});
parcelRegister("1Vklz", function(module, exports) {

let $166ae5ca66942094$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $166ae5ca66942094$var$load("bC7Er").then(()=>parcelRequire('7jOBk'));

});

parcelRegister("bhwWJ", function(module, exports) {

let $836ad6ae31f7ffc8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $836ad6ae31f7ffc8$var$load("iHaR1").then(()=>parcelRequire('88S3w'));

});


parcelRegister("iJ8K8", function(module, exports) {

$parcel$export(module.exports, "SPACE_OVERVIEW", () => $da2336279c92527f$export$65b723bb995d4fb6);
$parcel$export(module.exports, "Screen", () => $da2336279c92527f$export$a98515d67472a41f);

var $gwFzn = parcelRequire("gwFzn");
parcelRequire("j1Ss3");
var $xQxzY = parcelRequire("xQxzY");

var $fppBw = parcelRequire("fppBw");

var $csnse = parcelRequire("csnse");

var $atveb = parcelRequire("atveb");

var $c0urc = parcelRequire("c0urc");

var $ep3mz = parcelRequire("ep3mz");

var $jLw6A = parcelRequire("jLw6A");

var $67Foi = parcelRequire("67Foi");

var $7HO5s = parcelRequire("7HO5s");

var $fn3cd = parcelRequire("fn3cd");

var $gC23J = parcelRequire("gC23J");

var $6vxzh = parcelRequire("6vxzh");

var $1NBp8 = parcelRequire("1NBp8");
parcelRequire("dIouf");
var $3IBnw = parcelRequire("3IBnw");
var $4PPzL = parcelRequire("4PPzL");

var $2MhGC = parcelRequire("2MhGC");

var $hl1Kw = parcelRequire("hl1Kw");
var $8HhDZ = parcelRequire("8HhDZ");

var $9wGTI = parcelRequire("9wGTI");

var $jdo3D = parcelRequire("jdo3D");

var $5jrGM = parcelRequire("5jrGM");

var $7yta8 = parcelRequire("7yta8");

var $clyxK = parcelRequire("clyxK");
const $da2336279c92527f$export$65b723bb995d4fb6 = Symbol('overview');
const $da2336279c92527f$var$newRefIfChanged = (0, $csnse.default)((obj)=>({
        ...obj
    }), (0, (/*@__PURE__*/$parcel$interopDefault($atveb))));
function $da2336279c92527f$export$a98515d67472a41f({ screenEvent: screenEvent, pageState: pageState = {}, showPremiumOnboarding: showPremiumOnboarding = true, children: children }) {
    const pageStateValues = {
        // setState does a shallow merge this will cause transition to read stale data
        ...(0, $ep3mz.initialPageState),
        // Making a new copy is important here because isEqual will bail if it is a same reference.
        // If we update pageState directly here it will be the same reference when fetchSpaceHomePage comes back.
        // newRefIfChanged won't pick the change up to create a new copy of page state thus not triggering the re-render of children.
        ...pageState
    };
    const missingContentId = !pageStateValues.contentId || pageStateValues.contentId === $da2336279c92527f$export$65b723bb995d4fb6;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const skipQuery = !(pageStateValues.spaceKey && missingContentId);
    const { data: screenQueryData, loading: screenQueryLoading } = (0, $xQxzY.useQuery)((0, $5jrGM.ScreenQuery), {
        variables: {
            spaceKey: pageStateValues.spaceKey
        },
        skip: skipQuery
    });
    if (missingContentId) {
        if (screenQueryData && !screenQueryLoading) {
            pageStateValues.contentId = screenQueryData?.space?.homepage?.id;
            pageStateValues.contentIdLoading = false;
        } else {
            pageStateValues.contentId = undefined;
            pageStateValues.contentIdLoading = true;
        }
    }
    const isCreateContentRoute = pageStateValues.routeName === (0, $1NBp8.CREATE_CONTENT).name;
    if (// If query was skipped means we can never resolve the content id. Most likely there is no space key
    skipQuery || // create flow does not require contentId so set this value to false
    // to prevent issue of blank white screen when redirected to viewing a content on its route
    isCreateContentRoute) pageStateValues.contentIdLoading = false;
    const { searchSessionId: searchSessionId, additionalAnalyticsToParse: additionalAnalyticsToParse } = (0, $8HhDZ.useSearchSessionIdFromQueryParam)({
        spaceKey: pageStateValues.spaceKey,
        contentId: pageStateValues.contentId
    });
    //this captures if any page is inside a space when viewed, for the purpose of tracking space usage
    if (screenEvent && pageStateValues.spaceKey) {
        let { attributes: attributes } = screenEvent;
        if (attributes == null || typeof attributes !== 'object') screenEvent.attributes = attributes = {};
        // Allow the `Screen` consumer the final say. For example, Company Hub
        // hides its space from the user, doesn't refer to its page as such, is
        // rather presented to the user as "a new surface", and thus doesn't
        // constitute space usage from the perspective of the user.
        if (attributes.screenIsInSpace == null) attributes.screenIsInSpace = true;
    }
    const extra = [
        ...(0, $9wGTI.fg)('confluence_modernization_aa_exp_gate') ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $clyxK.InitModernizationAaExp), {
                key: "InitModernizationAaExp"
            })
        ] : [],
        ...(0, $9wGTI.fg)('modernize_ga_exp_gate') ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7yta8.InitModernizationGa), {
                key: "InitModernizationGa"
            })
        ] : [],
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jdo3D.LivePagesOpenBetaPromptModalWrapper), {
            key: "LivePagesOpenBetaPromptModalWrapper"
        }),
        screenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67Foi.ScreenEvent), {
            name: screenEvent.name,
            id: screenEvent.id || 'none',
            attributes: screenEvent.attributes,
            key: "screen"
        }),
        ...pageStateValues.routeName === (0, $1NBp8.EXTERNAL_SHARE).name ? [] : [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4PPzL.ErrorBoundary), {
                key: "missionControlBoundary",
                attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7HO5s.PremiumAdminEvent), {
                key: "premiumAdmin"
            }), showPremiumOnboarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fn3cd.PremiumOnboarding), {
                key: "premiumOnboarding"
            })),
            // CreateContentLegacyQueryParamRedirect & CreateContentDataPreloader are using PageState, it needs to be placed here.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gC23J.CreateContentLegacyQueryParamRedirect), {
                key: "CreateContentLegacyQueryParamRedirect"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6vxzh.CreateContentDataPreloader), {
                key: "CreateContentDataPreloader"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2MhGC.EditPageLoadingListener), {
                key: "editPageLoadingListener"
            })
        ]
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ep3mz.PageStateContainer), $da2336279c92527f$var$newRefIfChanged(pageStateValues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hl1Kw.SearchSessionStateContainer), {
        searchSessionId: searchSessionId,
        additionalAnalyticsToParse: additionalAnalyticsToParse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c0urc.QuickReloadContextProvider), {
        contentId: pageStateValues.contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jLw6A.PageRestrictionsContextProvider), {
        contentId: pageStateValues.contentId
    }, extra.concat(children)))));
}
$da2336279c92527f$export$a98515d67472a41f.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).any.isRequired,
    /**
	 * If provided, will send a "screen" analytics event.
	 */ screenEvent: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
        id: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
        attributes: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
        objectType: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
        objectId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string
    }).isRequired,
    /**
	 * If provided, will be used as PageState.
	 */ pageState: (0, $ep3mz.pageStateShape),
    /**
	 * If false, the Premium onboarding flow is not rendered
	 * For now, this will be false on the editor routes to not intrude
	 * in the user's editing experience.
	 */ showPremiumOnboarding: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
};

});
parcelRegister("fn3cd", function(module, exports) {

$parcel$export(module.exports, "PremiumOnboarding", () => $b5dc701a84f8894c$export$e1028d6b86a91d21);
$parcel$export(module.exports, "PremiumAdminOnboarding", () => $b5dc701a84f8894c$export$a0f4e1fa13a23780);
$parcel$export(module.exports, "PremiumTrialOnboardingModal", () => $b5dc701a84f8894c$export$936374c058c289fa);
$parcel$export(module.exports, "PremiumTrialOnboardingSpotlight", () => $b5dc701a84f8894c$export$9d05b4c1ccafbb15);

var $jmjWc = parcelRequire("jmjWc");

const $b5dc701a84f8894c$export$e1028d6b86a91d21 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "e-xhY",
    name: "PremiumOnboarding",
    loader: async ()=>(await (parcelRequire("dPV4X"))).PremiumOnboarding
});

const $b5dc701a84f8894c$export$a0f4e1fa13a23780 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "DS0D2",
    name: "PremiumAdminOnboarding",
    loader: async ()=>(await (parcelRequire("3JNLA"))).PremiumAdminOnboarding
});

const $b5dc701a84f8894c$export$936374c058c289fa = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "-PbKv",
    name: "PremiumTrialOnboardingModal",
    loader: async ()=>(await (parcelRequire("6Aq6l"))).PremiumTrialOnboardingModal
});

const $b5dc701a84f8894c$export$9d05b4c1ccafbb15 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "1Tyet",
    name: "PremiumTrialOnboardingSpotlight",
    loader: async ()=>(await (parcelRequire("gB8Ss"))).PremiumTrialOnboardingSpotlight
});

});
parcelRegister("dPV4X", function(module, exports) {

let $a12c507e80b5e842$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a12c507e80b5e842$var$load("48ML3"),
    $a12c507e80b5e842$var$load("7rEYM"),
    $a12c507e80b5e842$var$load("e2946"),
    $a12c507e80b5e842$var$load("9Zo7z"),
    $a12c507e80b5e842$var$load("5o49p")
]).then(()=>parcelRequire('2iFkw'));

});

parcelRegister("3JNLA", function(module, exports) {

let $2b8c2da8479f785b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2b8c2da8479f785b$var$load("9Zo7z").then(()=>parcelRequire('cuJd5'));

});

parcelRegister("6Aq6l", function(module, exports) {

let $4cba5a10f5596de0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4cba5a10f5596de0$var$load("48ML3"),
    $4cba5a10f5596de0$var$load("7rEYM"),
    $4cba5a10f5596de0$var$load("e2946")
]).then(()=>parcelRequire('jupik'));

});

parcelRegister("gB8Ss", function(module, exports) {

let $c156fce4590b3f23$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c156fce4590b3f23$var$load("60S8F").then(()=>parcelRequire('8JC1j'));

});


parcelRegister("gC23J", function(module, exports) {

$parcel$export(module.exports, "CreateContentLegacyQueryParamRedirect", () => $d44920250c4aaff7$export$6c880503785d1ff0);

var $jmjWc = parcelRequire("jmjWc");

const $d44920250c4aaff7$export$6c880503785d1ff0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "-vbtB",
    name: "CreateContentLegacyQueryParamRedirect",
    loader: async ()=>(await (parcelRequire("kbEFr"))).CreateContentLegacyQueryParamRedirect
});

});
parcelRegister("kbEFr", function(module, exports) {

let $eb246172a1732c53$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $eb246172a1732c53$var$load("73mUw").then(()=>parcelRequire('g1Gaf'));

});


parcelRegister("6vxzh", function(module, exports) {

$parcel$export(module.exports, "CreateContentDataPreloader", () => $1bb3d0bdc2835241$export$b04f2418ece85f67);

var $jmjWc = parcelRequire("jmjWc");

const $1bb3d0bdc2835241$export$b04f2418ece85f67 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "J1znW",
    name: "CreateContentDataPreloader",
    loader: async ()=>(await (parcelRequire("g0ldw"))).CreateContentDataPreloader
});

});
parcelRegister("g0ldw", function(module, exports) {

let $ba6d1aae0bd68e6d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ba6d1aae0bd68e6d$var$load("aDV08").then(()=>parcelRequire('ef32u'));

});


parcelRegister("8HhDZ", function(module, exports) {

$parcel$export(module.exports, "useSearchSessionIdFromQueryParam", () => $8563a48fc5b2cd04$export$84140e809b1e895a);

var $gwFzn = parcelRequire("gwFzn");

var $dPJCf = parcelRequire("dPJCf");
const $8563a48fc5b2cd04$var$useSearchIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('search_id');
const $8563a48fc5b2cd04$var$useAdditionalAnalyticsQueryParam = (0, $dPJCf.createSingleQueryParamHook)('additional_analytics');
const $8563a48fc5b2cd04$export$84140e809b1e895a = ({ spaceKey: spaceKey, contentId: contentId })=>{
    const searchSessionCache = (0, $gwFzn.useRef)(null);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const search_id = $8563a48fc5b2cd04$var$useSearchIdQueryParam() || null;
    const additional_analytics = $8563a48fc5b2cd04$var$useAdditionalAnalyticsQueryParam() || null;
    const isCacheStale = searchSessionCache.current == null || searchSessionCache.current.spaceKey != spaceKey || searchSessionCache.current.contentId != contentId || searchSessionCache.current.additionalAnalyticsToParse != additional_analytics && additional_analytics != null || searchSessionCache.current.searchSessionId != search_id && search_id != null;
    // Cache the searchSessionId/additionalAnalytics because it will be stripped from the query string
    (0, $gwFzn.useEffect)(()=>{
        if (isCacheStale) searchSessionCache.current = {
            spaceKey: spaceKey,
            contentId: contentId,
            searchSessionId: search_id,
            additionalAnalyticsToParse: additional_analytics
        };
    }, [
        isCacheStale,
        spaceKey,
        contentId,
        search_id,
        additional_analytics
    ]);
    // Strip query param
    (0, $gwFzn.useEffect)(()=>{
        if (search_id) setQueryParams({
            search_id: null
        }, true);
        if (additional_analytics) setQueryParams({
            additional_analytics: null
        }, true);
    });
    let searchSessionId = search_id;
    let additionalAnalyticsToParse = additional_analytics;
    if (!search_id && !isCacheStale && searchSessionCache.current != null) searchSessionId = searchSessionCache.current.searchSessionId;
    if (!additional_analytics && !isCacheStale && searchSessionCache.current != null) additionalAnalyticsToParse = searchSessionCache.current.additionalAnalyticsToParse;
    return {
        searchSessionId: searchSessionId,
        additionalAnalyticsToParse: additionalAnalyticsToParse
    };
};

});

parcelRegister("jdo3D", function(module, exports) {

$parcel$export(module.exports, "LivePagesOpenBetaPromptModalWrapper", () => $61d13c896558312d$export$b0b41f098fc2103b);

var $gwFzn = parcelRequire("gwFzn");

var $xQxzY = parcelRequire("xQxzY");

var $1iSzD = parcelRequire("1iSzD");

var $bQm3c = parcelRequire("bQm3c");

var $9wGTI = parcelRequire("9wGTI");

var $1BYn9 = parcelRequire("1BYn9");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $gTyTP = parcelRequire("gTyTP");

var $1NBp8 = parcelRequire("1NBp8");

var $8PDDb = parcelRequire("8PDDb");

var $3GNxA = parcelRequire("3GNxA");
const $61d13c896558312d$var$MODAL_FIRST_SEEN_KEY = 'confluence_screen_viewed_livepagesopenbetapromptmodal_first_time';
const $61d13c896558312d$var$hasSeenModalBefore = (data)=>{
    return !!data?.experimentalSiteUserPersonalization?.attributes?.some(({ name: name })=>name === $61d13c896558312d$var$MODAL_FIRST_SEEN_KEY);
};
const $61d13c896558312d$export$b0b41f098fc2103b = ()=>{
    const [seenBefore, setSeenBefore] = (0, $gwFzn.useState)(false);
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { livePageReleasePhase: livePageReleasePhase } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { isProductAdmin: isProductAdmin } = (0, $1BYn9.useIsProductAdmin)();
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const isPdfExport = (0, $1NBp8.PDF_EXPORT_PAGE).match(window.location.pathname);
    (0, $gwFzn.useEffect)(()=>{
        const localSeenBefore = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_OPEN_BETA_PROMPT_MODAL_FIRST_SEEN);
        if (localSeenBefore) setSeenBefore(true);
    }, []);
    const skipQuery = !isProductAdmin || // not a product admin
    livePageReleasePhase !== (0, $gTyTP.LivePageReleasePhase).OPEN_BETA_INITIAL || // not in open beta initial phase
    seenBefore || // already seen the modal
    !!isPdfExport; // do not show the modal in PDF export
    const { data: data, error: error, loading: loading } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $8PDDb.SiteUserPersonalizationQuery), {
        variables: {
            cloudId: cloudId,
            userId: userId || ''
        },
        fetchPolicy: 'cache-and-network',
        skip: skipQuery,
        onCompleted: (result)=>{
            setSeenBefore($61d13c896558312d$var$hasSeenModalBefore(result));
        }
    });
    // only checks if modal passes basic conditions to be shown, does not check coordination with choreographer
    // if the query is skipped, it means the user is not eligible to see the modal
    if (isEmbeddedConfluence || skipQuery || !!error || loading || data && $61d13c896558312d$var$hasSeenModalBefore(data) || !(0, $9wGTI.fg)('live_pages_open_beta_in_product_prompt_dismissible')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3GNxA.LivePagesOpenBetaPromptModalLoader), null);
};

});
parcelRegister("8PDDb", function(module, exports) {

$parcel$export(module.exports, "SiteUserPersonalizationQuery", () => $cd8109b25d7e314c$export$4f3d469d1dadeee8);

var $d2LG0 = parcelRequire("d2LG0");
const $cd8109b25d7e314c$export$4f3d469d1dadeee8 = (0, $d2LG0.default)`query SiteUserPersonalizationQuery($cloudId:String!$userId:String!)@experimental{experimentalSiteUserPersonalization(cloudId:$cloudId userId:$userId){attributes{name value}}}`;

});

parcelRegister("3GNxA", function(module, exports) {

$parcel$export(module.exports, "LivePagesOpenBetaPromptModalLoader", () => $add2fa338edfabfb$export$6eb15ee7308c5b8b);

var $jmjWc = parcelRequire("jmjWc");

const $add2fa338edfabfb$export$6eb15ee7308c5b8b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "RPbDL",
    name: "LivePagesOpenBetaPromptModalLoader",
    loader: async ()=>(await (parcelRequire("5NgWG"))).LivePagesOpenBetaPromptModal
});

});
parcelRegister("5NgWG", function(module, exports) {

let $437eac6043aa7055$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $437eac6043aa7055$var$load("4MFmF").then(()=>parcelRequire('j3CaG'));

});



parcelRegister("7yta8", function(module, exports) {

$parcel$export(module.exports, "InitModernizationGa", () => $3f19135f9449fadc$export$92d36ae965196589);
/**
 * @graphql cc
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $d2LG0 = parcelRequire("d2LG0");

var $1KmJq = parcelRequire("1KmJq");

var $bQm3c = parcelRequire("bQm3c");

var $gTyTP = parcelRequire("gTyTP");

var $1ytiN = parcelRequire("1ytiN");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
const $3f19135f9449fadc$var$InitModernizationGaMutation = (0, $d2LG0.default)`mutation InitModernizationGaMutation($cloudId:ID!){confluence_experimentInitModernize(cloudId:$cloudId){success}}`;
const $3f19135f9449fadc$export$92d36ae965196589 = ()=>{
    const [isInitialized, setIsInitialized] = (0, $gwFzn.useState)(false);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [initModernizationGaMutation] = (0, $1KmJq.useMutation)($3f19135f9449fadc$var$InitModernizationGaMutation, {
        variables: {
            cloudId: cloudId
        }
    });
    const hasInitializedModernizationGa = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_DOCS_HAS_INIT_MODERNIZE);
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { experimentFeatures: experimentFeatures, loading: isSPAViewContextLoading } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    (0, $gwFzn.useEffect)(()=>{
        if (isInitialized || hasInitializedModernizationGa || isLivePagesFeatureEnabled || isSPAViewContextLoading || !experimentFeatures) return;
        try {
            const modernizationGaTraitValue = JSON.parse(experimentFeatures)?.[0, $gTyTP.LIVE_DOC_GA_EXP_TRAIT_NAME];
            if (modernizationGaTraitValue === 'null' || !modernizationGaTraitValue) {
                setIsInitialized(true);
                initModernizationGaMutation().then(({ data: data })=>{
                    data?.confluence_experimentInitModernize?.success && (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_DOCS_HAS_INIT_MODERNIZE, 'true');
                });
            }
        } catch (e) {
        // do nothing
        }
    }, [
        isInitialized,
        hasInitializedModernizationGa,
        isLivePagesFeatureEnabled,
        isSPAViewContextLoading,
        experimentFeatures,
        initModernizationGaMutation
    ]);
    return null;
};

});

parcelRegister("clyxK", function(module, exports) {

$parcel$export(module.exports, "InitModernizationAaExp", () => $0fd4ef794d1457cc$export$6b414c614e9e9708);

var $gwFzn = parcelRequire("gwFzn");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $gTyTP = parcelRequire("gTyTP");

var $6mKj3 = parcelRequire("6mKj3");
const $0fd4ef794d1457cc$export$6b414c614e9e9708 = ()=>{
    const hasInitializedModernizationGa = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_DOCS_HAS_EXPOSED_AA_EXP);
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    (0, $gwFzn.useEffect)(()=>{
        if (hasInitializedModernizationGa || isLivePagesFeatureEnabled) return;
        if ((0, $6mKj3.expVal)('confluence_modernization_aa_exp', 'cohort', 'not-enrolled') !== 'not-enrolled') (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_DOCS_HAS_EXPOSED_AA_EXP, 'true');
    }, [
        hasInitializedModernizationGa,
        isLivePagesFeatureEnabled
    ]);
    return null;
};

});


parcelRegister("8jvvW", function(module, exports) {

$parcel$export(module.exports, "getOverrides", () => $16d780c40c82006c$export$f525cc57d37ca574);
$parcel$export(module.exports, "applyPersistedOverrides", () => $16d780c40c82006c$export$5681db34bdd4ce56);
$parcel$export(module.exports, "updateSessionData", () => $16d780c40c82006c$export$9f411403a6357bca);

var $7W8i8 = parcelRequire("7W8i8");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
const $16d780c40c82006c$var$logger = (0, $7W8i8.getLogger)('session-data');
const $16d780c40c82006c$export$9188225596b00133 = (0, $1UApO.PERSISTED_KEYS_ON_SERVER)?.PERSISTED_OVERRIDE_FEATURE_FLAGS;
const $16d780c40c82006c$export$2e556774d11391ad = ()=>{
    return (0, $e9zUf.confluenceLocalStorageInstance) && (0, $e9zUf.confluenceLocalStorageInstance).doesContain($16d780c40c82006c$export$9188225596b00133);
};
const $16d780c40c82006c$export$f525cc57d37ca574 = ()=>{
    if (!$16d780c40c82006c$export$2e556774d11391ad()) return {};
    const raw = (0, $e9zUf.confluenceLocalStorageInstance).getItem($16d780c40c82006c$export$9188225596b00133);
    try {
        return raw ? JSON.parse(raw) : {};
    } catch (_) {
        return {};
    }
};
const $16d780c40c82006c$export$5681db34bdd4ce56 = (featureFlags)=>{
    const overrides = $16d780c40c82006c$export$f525cc57d37ca574();
    return Object.keys(featureFlags).reduce((acc, key)=>{
        acc[key] = overrides.hasOwnProperty(key) ? overrides[key] : featureFlags[key];
        return acc;
    }, {});
};
const $16d780c40c82006c$export$9f411403a6357bca = (sessionData, featureFlagsWithOverrides)=>{
    // FeatureFlagClient requires a slightly different format than featureFlags:
    // { <key>: { value: <val> } } instead of just { <key>: <val> }
    const normalizedFeatureFlagsWithOverrides = Object.keys(featureFlagsWithOverrides).reduce((acc, key)=>{
        // This is a dirty hack - accessing a private method `getFlagWrapper`
        // TODO need to figure out a way to properly pass and preserve `explanation` field of a featureFlag
        const previousFlagState = sessionData.featureFlagClient.getFlagWrapper(key).flag;
        acc[key] = {
            ...previousFlagState,
            value: featureFlagsWithOverrides[key]
        };
        return acc;
    }, {});
    sessionData.featureFlags = featureFlagsWithOverrides;
    sessionData.featureFlagClient.setFlags(normalizedFeatureFlagsWithOverrides);
};
const $16d780c40c82006c$var$setOverrides = (func)=>{
    if (!(0, $e9zUf.confluenceLocalStorageInstance)) {
        $16d780c40c82006c$var$logger.error`Unable to set persisted FF overrides. storage-manager not available.`;
        return;
    }
    const overrides = $16d780c40c82006c$export$f525cc57d37ca574();
    const result = func(overrides);
    try {
        // Persist the overrides to the server. Note: When result is an empty object,
        // we still persist it. If we used confluenceLocalStorageInstance.removeItem()
        // it wouldn't actually persist the data back to the server, as that method
        // only removes it from local storage.
        (0, $e9zUf.confluenceLocalStorageInstance).setItem($16d780c40c82006c$export$9188225596b00133, JSON.stringify(result));
    } catch (_) {
        $16d780c40c82006c$var$logger.error`Unable to set persisted FF overrides. key = "${$16d780c40c82006c$export$9188225596b00133}", value = "${JSON.stringify(result)}"`;
    }
    return result;
};
const $16d780c40c82006c$export$357972e1dc28ee9f = (key, value)=>$16d780c40c82006c$var$setOverrides((overrides)=>{
        overrides[key] = value;
        return overrides;
    });
const $16d780c40c82006c$export$dc8435f11da520c3 = (key)=>$16d780c40c82006c$var$setOverrides((overrides)=>{
        delete overrides[key];
        return overrides;
    });
const $16d780c40c82006c$export$c1b1141673e494cd = ()=>$16d780c40c82006c$var$setOverrides(()=>{
        return {};
    });

});

parcelRegister("dsz8u", function(module, exports) {

$parcel$export(module.exports, "EMPTY_SPACE", () => $0fd2af518e91029a$export$657dee6d5648750a);
$parcel$export(module.exports, "CopySpacePermissionsSelector", () => $0fd2af518e91029a$export$327bf7ab4c0b09c9);
$parcel$export(module.exports, "isSourceSpaceValid", () => $0fd2af518e91029a$export$8764bbb8a782240c);
/* CopySpacePermissionsSelector.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $d2LG0 = parcelRequire("d2LG0");

var $2nPZH = parcelRequire("2nPZH");
parcelRequire("j1Ss3");
var $xQxzY = parcelRequire("xQxzY");

var $inPa6 = parcelRequire("inPa6");

var $2VHSy = parcelRequire("2VHSy");

var $eJhXX = parcelRequire("eJhXX");

var $bQm3c = parcelRequire("bQm3c");

var $6H6bO = parcelRequire("6H6bO");

var $crGnL = parcelRequire("crGnL");

var $4yGRT = parcelRequire("4yGRT");

var $lsPeB = parcelRequire("lsPeB");

var $4xjqG = parcelRequire("4xjqG");
const $0fd2af518e91029a$var$CopySpacePermissionsSelectorQuery = (0, $d2LG0.default)`query CopySpacePermissionsSelectorQuery{user:confluence_atlassianUser(current:true){id confluence{operations{operation targetType}}}isSiteAdmin hasUserAccessAdminRole}`;
const $0fd2af518e91029a$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    sourceSpaceSelectorPlaceholder: {
        id: "copy-space-permissions.space-selector.placeholder",
        defaultMessage: "Choose a space"
    },
    sourceSpaceSelectorLabel: {
        id: "copy-space-permissions.space-selector.prompt",
        defaultMessage: "Copy from"
    }
});
const $0fd2af518e91029a$export$657dee6d5648750a = {
    isRestricted: false,
    containsExternalCollaborators: false,
    key: '',
    name: '',
    isAdmin: false,
    id: ''
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0fd2af518e91029a$var$FlexRow = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4cvr1h6o _1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
function $0fd2af518e91029a$export$327bf7ab4c0b09c9({ analyticsEventSourceName: analyticsEventSourceName, defaultOption: defaultOption, defaultSpaceKey: defaultSpaceKey, isDisabled: isDisabled, label: label, onChange: onChange, options: options, showUpsell: showUpsell, filterSourceSpaceOptions: filterSourceSpaceOptions, sourceSpaceSelectorValidationState: sourceSpaceSelectorValidationState = 'default', renderGuestsWarning: renderGuestsWarning, fullWidth: fullWidth, validationPlaceholder: validationPlaceholder, optionSelectInputId: optionSelectInputId, allowOnlyAdminSpaces: allowOnlyAdminSpaces }) {
    const [option, setOption] = (0, $gwFzn.useState)(defaultOption);
    const [sourceSpace, setSourceSpace] = (0, $gwFzn.useState)($0fd2af518e91029a$export$657dee6d5648750a); /* Bind createAnalyticsEvent to the event Source, edition, and userPrivilege so that these two pieces of
                                                                                                   data go out with all analytics events */ 
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $xQxzY.useQuery)($0fd2af518e91029a$var$CopySpacePermissionsSelectorQuery);
    const wrappedCreateAnalyticsEvent = (0, $gwFzn.useMemo)(()=>{
        const userPrivilege = (0, $eJhXX.getUserPrivilegeFromQuery)(data);
        return (0, $2VHSy.createAnalyticsEventFactory)(createAnalyticsEvent, analyticsEventSourceName, {
            ...edition && {
                edition: edition
            },
            ...userPrivilege && {
                userPrivilege: userPrivilege
            }
        });
    }, [
        analyticsEventSourceName,
        createAnalyticsEvent,
        data,
        edition
    ]);
    const onCopySpacePermissionsOptionMenuOpen = ()=>{
        (0, $6H6bO.fireUIClickEvent)(wrappedCreateAnalyticsEvent, (0, $6H6bO.OPTION_SELECT_ACTION_SUBJECT), (0, $6H6bO.OPTION_SELECT_DROPDOWN_OPEN_ACTION_SUBJECT_ID));
    };
    const onCopySpacePermissionsOptionChange = (option)=>{
        setOption(option); // Always clear the source Space Key, as the SpaceSelector has no initial selection
        if (sourceSpace !== $0fd2af518e91029a$export$657dee6d5648750a) setSourceSpace($0fd2af518e91029a$export$657dee6d5648750a);
        (0, $6H6bO.fireUIClickEvent)(wrappedCreateAnalyticsEvent, (0, $6H6bO.OPTION_SELECT_ACTION_SUBJECT), (0, $6H6bO.getEventActionSubjectId)(option));
        onChange({
            option: option,
            sourceSpace: $0fd2af518e91029a$export$657dee6d5648750a
        });
    };
    const onSpacePermissionsSourceChange = ({ isRestricted: isRestricted, containsExternalCollaborators: containsExternalCollaborators, spaceKey: spaceKey, spaceName: spaceName, isAdmin: isAdmin, id: id })=>{
        if (sourceSpace.key !== spaceKey || sourceSpace.name !== spaceName) {
            const nextSourceSpace = {
                isRestricted: isRestricted,
                containsExternalCollaborators: containsExternalCollaborators,
                isAdmin: isAdmin,
                key: spaceKey,
                name: spaceName,
                id: id
            };
            setSourceSpace(nextSourceSpace);
            (0, $6H6bO.fireUIClickEvent)(wrappedCreateAnalyticsEvent, (0, $6H6bO.SOURCE_SPACE_SELECT_ACTION_SUBJECT), (0, $6H6bO.SOURCE_SPACE_SELECTED_SUBJECT_ID));
            onChange({
                option: option,
                sourceSpace: nextSourceSpace
            });
        }
    };
    const isSourceSpaceInvalid = !$0fd2af518e91029a$export$8764bbb8a782240c({
        option: option,
        sourceSpace: sourceSpace,
        allowOnlyAdminSpaces: allowOnlyAdminSpaces
    });
    if (sourceSpaceSelectorValidationState === 'default' && sourceSpace !== $0fd2af518e91029a$export$657dee6d5648750a && isSourceSpaceInvalid) // DON'T show a validation error if the user has not selected a space yet
    // even though no space selected is an invalid state:
    sourceSpaceSelectorValidationState = 'error';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0fd2af518e91029a$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4yGRT.OptionSelect), {
        analyticsEventSourceName: analyticsEventSourceName,
        isDisabled: isDisabled,
        label: label,
        onChange: onCopySpacePermissionsOptionChange,
        onMenuOpen: onCopySpacePermissionsOptionMenuOpen,
        options: options,
        showUpsell: showUpsell,
        value: option,
        fullWidth: fullWidth,
        inputId: optionSelectInputId
    })), option === (0, $crGnL.Option).COPY_PERMISSIONS_FROM_ANOTHER_SPACE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4xjqG.LabeledSelect), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lsPeB.SourceSpaceSelector), {
        onChange: onSpacePermissionsSourceChange,
        label: label ? $0fd2af518e91029a$export$a7357cdd1f0b0168.sourceSpaceSelectorLabel : undefined,
        placeholder: $0fd2af518e91029a$export$a7357cdd1f0b0168.sourceSpaceSelectorPlaceholder,
        validationState: sourceSpaceSelectorValidationState,
        filterSourceSpaceOptions: filterSourceSpaceOptions,
        renderGuestsWarning: renderGuestsWarning,
        fullWidth: fullWidth,
        validationPlaceholder: validationPlaceholder,
        defaultSpaceKey: defaultSpaceKey,
        allowOnlyAdminSpaces: allowOnlyAdminSpaces,
        showSpaceLabel: true,
        labelTextTransform: "none"
    })) : null);
}
function $0fd2af518e91029a$export$8764bbb8a782240c({ option: option, sourceSpace: sourceSpace, allowOnlyAdminSpaces: allowOnlyAdminSpaces, targetSpaceKey: targetSpaceKey }) {
    return option != (0, $crGnL.Option).COPY_PERMISSIONS_FROM_ANOTHER_SPACE || sourceSpace && Boolean(sourceSpace.key) && !sourceSpace.isRestricted && (allowOnlyAdminSpaces ? sourceSpace.isAdmin : true) && (targetSpaceKey === undefined || targetSpaceKey !== sourceSpace.key);
}

});
parcelRegister("6H6bO", function(module, exports) {

$parcel$export(module.exports, "OPTION_SELECT_ACTION_SUBJECT", () => $4dd7cabfb97762a1$export$c2f50b86729b5b74);
$parcel$export(module.exports, "SOURCE_SPACE_SELECT_ACTION_SUBJECT", () => $4dd7cabfb97762a1$export$fedfc172a3b39723);
$parcel$export(module.exports, "BUTTON_ACTION_SUBJECT", () => $4dd7cabfb97762a1$export$79fc012ce0853550);
$parcel$export(module.exports, "OPTION_SELECT_DROPDOWN_OPEN_ACTION_SUBJECT_ID", () => $4dd7cabfb97762a1$export$44e673763b6e05ef);
$parcel$export(module.exports, "getEventActionSubjectId", () => $4dd7cabfb97762a1$export$7d73f9f8afee3edd);
$parcel$export(module.exports, "SOURCE_SPACE_SELECTED_SUBJECT_ID", () => $4dd7cabfb97762a1$export$4cbfed6bd1204375);
$parcel$export(module.exports, "APPLY_PERMS_ACTION_SUBJECT_ID", () => $4dd7cabfb97762a1$export$63856a579338aaa8);
$parcel$export(module.exports, "RESTORE_DEFAULT_PERMS_ACTION_SUBJECT_ID", () => $4dd7cabfb97762a1$export$8ba837500fb31309);
$parcel$export(module.exports, "APPLY_PERMS_CANCEL_ACTION_SUBJECT_ID", () => $4dd7cabfb97762a1$export$72e9e37bbaf0a2c3);
$parcel$export(module.exports, "APPLY_PERMS_CONFIRM_ACTION_SUBJECT_ID", () => $4dd7cabfb97762a1$export$96a59ca17b6762f0);
$parcel$export(module.exports, "fireUIClickEvent", () => $4dd7cabfb97762a1$export$5edee710fd3e881c);

var $crGnL = parcelRequire("crGnL");
const $4dd7cabfb97762a1$export$c2f50b86729b5b74 = 'selectDropdown';
const $4dd7cabfb97762a1$export$fedfc172a3b39723 = 'spaceSelect';
const $4dd7cabfb97762a1$export$79fc012ce0853550 = 'button';
const $4dd7cabfb97762a1$export$44e673763b6e05ef = 'copySpacePermissionsSpacePermissionsDropdownOpen';
const $4dd7cabfb97762a1$export$a964296cb5c0acac = 'copySpacePermissionsCopyFromExisting';
const $4dd7cabfb97762a1$export$d9caa862be38cd79 = 'copySpacePermissionsUseDefaults';
const $4dd7cabfb97762a1$export$648a702396c42939 = 'copySpacePermissionsMakePrivate';
// Translates an option selected from the CSP Option Select control into Action Subject ID:
const $4dd7cabfb97762a1$var$OptionToEventActionSubjectIdMap = new Map([
    [
        (0, $crGnL.Option).ONLY_VISIBLE_TO_ME,
        $4dd7cabfb97762a1$export$648a702396c42939
    ],
    [
        (0, $crGnL.Option).DEFAULT_PERMISSIONS,
        $4dd7cabfb97762a1$export$d9caa862be38cd79
    ],
    [
        (0, $crGnL.Option).COPY_PERMISSIONS_FROM_ANOTHER_SPACE,
        $4dd7cabfb97762a1$export$a964296cb5c0acac
    ]
]);
const $4dd7cabfb97762a1$export$7d73f9f8afee3edd = (option)=>$4dd7cabfb97762a1$var$OptionToEventActionSubjectIdMap.get(option) || '';
const $4dd7cabfb97762a1$export$4cbfed6bd1204375 = 'copySpacePermissionsSourceSpaceSelected';
const $4dd7cabfb97762a1$export$63856a579338aaa8 = 'copySpacePermissionsApplyPermissions';
const $4dd7cabfb97762a1$export$8ba837500fb31309 = 'spacePermissionsRestoreDefaults';
const $4dd7cabfb97762a1$export$72e9e37bbaf0a2c3 = 'copySpacePermissionsCancelApply';
const $4dd7cabfb97762a1$export$96a59ca17b6762f0 = 'copySpacePermissionsConfirmApply';
const $4dd7cabfb97762a1$export$5edee710fd3e881c = (createAnalyticsEvent, actionSubject, actionSubjectId)=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId
        }
    }).fire();
};

});
parcelRegister("crGnL", function(module, exports) {

$parcel$export(module.exports, "Option", () => $e44d7192d4830fcb$export$36d18380658d5d20);
$parcel$export(module.exports, "getOptionsByEdition", () => $e44d7192d4830fcb$export$8f569d426f861ccc);

var $euL71 = parcelRequire("euL71");
var $e44d7192d4830fcb$export$36d18380658d5d20 = /*#__PURE__*/ function(Option) {
    Option["ONLY_VISIBLE_TO_ME"] = "OnlyVisibleToMe";
    Option["DEFAULT_PERMISSIONS"] = "DefaultPermissions";
    Option["COPY_PERMISSIONS_FROM_ANOTHER_SPACE"] = "CopyPermissionsFromAnotherSpace";
    return Option;
}({});
const $e44d7192d4830fcb$var$OPTIONS_BY_EDITION = {
    [(0, $euL71.ConfluenceEdition).FREE]: [
        "DefaultPermissions"
    ],
    [(0, $euL71.ConfluenceEdition).STANDARD]: [
        "DefaultPermissions",
        "OnlyVisibleToMe"
    ],
    [(0, $euL71.ConfluenceEdition).PREMIUM]: [
        "DefaultPermissions",
        "CopyPermissionsFromAnotherSpace",
        "OnlyVisibleToMe"
    ]
};
function $e44d7192d4830fcb$export$8f569d426f861ccc(edition) {
    switch(edition){
        case (0, $euL71.ConfluenceEdition).PREMIUM:
        case (0, $euL71.ConfluenceEdition).STANDARD:
            return $e44d7192d4830fcb$var$OPTIONS_BY_EDITION[edition];
        case (0, $euL71.ConfluenceEdition).FREE:
        default:
            return $e44d7192d4830fcb$var$OPTIONS_BY_EDITION[(0, $euL71.ConfluenceEdition).FREE];
    }
}

});


parcelRegister("4yGRT", function(module, exports) {

$parcel$export(module.exports, "OptionSelect", () => $afd0d04d210c004f$export$6bab038dd5186918);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $3hOY6 = parcelRequire("3hOY6");
var $2gD2K = parcelRequire("2gD2K");

var $gxbof = parcelRequire("gxbof");

var $9wGTI = parcelRequire("9wGTI");

var $crGnL = parcelRequire("crGnL");

var $eax6l = parcelRequire("eax6l");

var $4xjqG = parcelRequire("4xjqG");
const $afd0d04d210c004f$var$OPTION_NOT_SELECTABLE_VALUE = '';
const $afd0d04d210c004f$var$formatOptionLabel = (option, { context: context, selectValue: selectValue })=>{
    if (context === 'menu') {
        const selected = selectValue?.[0]?.value;
        const isSelected = selected ? selected === option.value : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eax6l.OptionWithDescription), {
            label: option.label,
            description: option.description,
            isSelected: isSelected,
            isMenu: true
        });
    } else if ((0, $9wGTI.fg)('confluence_rbac_spaces_beta_opt_in')) {
        const selected = selectValue?.[0]?.value;
        const isSelected = selected ? selected === option.value : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eax6l.OptionWithDescription), {
            label: option.label,
            description: option.description,
            isSelected: isSelected,
            isMenu: false
        });
    } else return option.label;
};
const $afd0d04d210c004f$var$getOptionLabel = (option)=>{
    return `${option.label} ${option.description}`;
};
const $afd0d04d210c004f$export$3e92eb7b7644ac65 = (props)=>{
    const { data: data, innerProps: innerProps, innerRef: innerRef } = props;
    return data.alternateComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ref: innerRef,
        ...innerProps
    }, data.alternateComponent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3hOY6.components).Option, props);
};
const $afd0d04d210c004f$export$bcd24b8f826ea9a2 = (0, $2nPZH.defineMessages)({
    placeholder: {
        id: "copy-space-permissions.selector.placeholder",
        defaultMessage: "Select an option"
    },
    defaultPermissions: {
        id: "copy-space-permissions.selector.items.default",
        defaultMessage: "Default permissions"
    },
    defaultPermissionsDescription: {
        id: "copy-space-permissions.selector.items.default.description",
        defaultMessage: "Use the space permissions set by your admin"
    },
    default: {
        id: "copy-space-permissions.selector.items.default-roles",
        defaultMessage: "Default"
    },
    defaultDescription: {
        id: "copy-space-permissions.selector.items.default-roles.description",
        defaultMessage: "Use the access settings recommended by your admin"
    },
    onlyVisibleToMe: {
        id: "copy-space-permissions.selector.items.private",
        defaultMessage: "Only visible to me"
    },
    onlyVisibleToMeDescription: {
        id: "copy-space-permissions.selector.items.private.description",
        defaultMessage: "Only you can view this space"
    },
    restricted: {
        id: "copy-space-permissions.selector.items.restricted",
        defaultMessage: "Restricted"
    },
    restrictedDescription: {
        id: "copy-space-permissions.selector.items.restricted.description",
        defaultMessage: "Only you have access until you add others"
    },
    copyPermissions: {
        id: "copy-space-permissions.selector.items.copy.from.existing.space",
        defaultMessage: "Copy permissions from another space"
    },
    copyPermissionsDescription: {
        id: "copy-space-permissions.selector.items.copy.from.existing.space.description",
        defaultMessage: "Use the permissions from a similar space"
    },
    copyAccess: {
        id: "copy-space-permissions.selector.items.copy.access",
        defaultMessage: "Copy access settings"
    },
    copyAccessDescription: {
        id: "copy-space-permissions.selector.items.copy.access.description",
        defaultMessage: "Use another space\u2019s settings"
    }
});
const $afd0d04d210c004f$var$copySpacePermissionsUpsellMessagesForNewSpace = (0, $2nPZH.defineMessages)({
    title: {
        id: "copy-space-permissions.for-new-space.upsell.title",
        defaultMessage: "Setting up permissions can be faster than ever"
    },
    body: {
        id: "copy-space-permissions.for-new-space.upsell.description",
        defaultMessage: "Quickly copy your unique permissions from another space with Premium."
    }
});
const $afd0d04d210c004f$var$OptionSelectComponent = ({ analyticsEventSourceName: analyticsEventSourceName, options: options, defaultValue: defaultValue, intl: intl, label: label, onChange: onChange, onMenuOpen: onMenuOpen, showUpsell: showUpsell, value: value, isDisabled: isDisabled, fullWidth: fullWidth, inputId: inputId })=>{
    const optionList = [
        {
            label: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.onlyVisibleToMe),
            description: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.onlyVisibleToMeDescription),
            value: (0, $crGnL.Option).ONLY_VISIBLE_TO_ME
        },
        {
            label: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.defaultPermissions),
            description: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.defaultPermissionsDescription),
            value: (0, $crGnL.Option).DEFAULT_PERMISSIONS
        },
        {
            label: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.copyPermissions),
            description: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.copyPermissionsDescription),
            value: (0, $crGnL.Option).COPY_PERMISSIONS_FROM_ANOTHER_SPACE
        },
        {
            label: '',
            value: $afd0d04d210c004f$var$OPTION_NOT_SELECTABLE_VALUE,
            alternateComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gxbof.CopySpacePermissionsUpsell), {
                source: analyticsEventSourceName,
                messages: $afd0d04d210c004f$var$copySpacePermissionsUpsellMessagesForNewSpace
            }),
            isDisabled: true
        }
    ];
    //TODO: Update the restricted options when RBAC is released
    const descriptiveOptionList = [
        {
            label: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.default),
            description: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.defaultDescription),
            value: (0, $crGnL.Option).DEFAULT_PERMISSIONS
        },
        {
            label: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.copyAccess),
            description: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.copyAccessDescription),
            value: (0, $crGnL.Option).COPY_PERMISSIONS_FROM_ANOTHER_SPACE
        },
        {
            label: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.restricted),
            description: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.restrictedDescription),
            value: (0, $crGnL.Option).ONLY_VISIBLE_TO_ME
        },
        {
            label: '',
            value: $afd0d04d210c004f$var$OPTION_NOT_SELECTABLE_VALUE,
            alternateComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gxbof.CopySpacePermissionsUpsell), {
                source: analyticsEventSourceName,
                messages: $afd0d04d210c004f$var$copySpacePermissionsUpsellMessagesForNewSpace
            }),
            isDisabled: true
        }
    ];
    const availableOptions = (0, $9wGTI.fg)('confluence_rbac_spaces_beta_opt_in') ? descriptiveOptionList.filter(({ value: value })=>// Only show the UpSell option (whose `value` is `OPTION_NOT_SELECTABLE_VALUE`) if UpSell is enabled
        value === $afd0d04d210c004f$var$OPTION_NOT_SELECTABLE_VALUE ? showUpsell : options.indexOf(value) !== -1) : optionList.filter(({ value: value })=>// Only show the UpSell option (whose `value` is `OPTION_NOT_SELECTABLE_VALUE`) if UpSell is enabled
        value === $afd0d04d210c004f$var$OPTION_NOT_SELECTABLE_VALUE ? showUpsell : options.indexOf(value) !== -1);
    const onSelectMenuOpen = ()=>{
        if (typeof onMenuOpen === 'function') onMenuOpen();
    };
    const onSelectChange = (selection)=>{
        if (typeof onChange === 'function') onChange(selection.value);
    };
    const select = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2gD2K.default), {
        classNamePrefix: "option-select",
        components: {
            Option: $afd0d04d210c004f$export$3e92eb7b7644ac65
        },
        defaultValue: availableOptions.find((option)=>option.value === defaultValue),
        formatOptionLabel: $afd0d04d210c004f$var$formatOptionLabel,
        getOptionLabel: $afd0d04d210c004f$var$getOptionLabel,
        id: "copy-space-perms-option-select",
        isDisabled: isDisabled || availableOptions.length === 1,
        maxMenuHeight: 350,
        onChange: onSelectChange,
        onMenuOpen: onSelectMenuOpen,
        options: availableOptions,
        placeholder: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.placeholder),
        // @ts-ignore this prop doesn't seem to be defined
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4xjqG.customSelectStyles)(fullWidth),
        value: availableOptions.find((option)=>option.value === value),
        inputId: inputId,
        isSearchable: false
    });
    const optionSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2gD2K.default), {
        classNamePrefix: "option-select",
        components: {
            Option: $afd0d04d210c004f$export$3e92eb7b7644ac65
        },
        defaultValue: availableOptions.find((option)=>option.value === defaultValue),
        formatOptionLabel: $afd0d04d210c004f$var$formatOptionLabel,
        getOptionLabel: $afd0d04d210c004f$var$getOptionLabel,
        id: "copy-space-perms-option-select",
        isDisabled: isDisabled || availableOptions.length === 1,
        maxMenuHeight: 350,
        onChange: onSelectChange,
        onMenuOpen: onSelectMenuOpen,
        options: availableOptions,
        placeholder: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.placeholder),
        // @ts-ignore this prop doesn't seem to be defined
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4xjqG.customSelectStyles)(fullWidth),
        value: availableOptions.find((option)=>option.value === value),
        inputId: inputId,
        isSearchable: false
    });
    const selectComponent = (0, $9wGTI.fg)('confluence_rbac_spaces_beta_opt_in') ? optionSelect : select;
    const selectComponentWithLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4xjqG.SelectLabel), {
        htmlFor: "copy-space-perms-option-select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), label)), selectComponent);
    return label ? selectComponentWithLabel : selectComponent;
};
const $afd0d04d210c004f$export$6bab038dd5186918 = (0, $js7oX.default)($afd0d04d210c004f$var$OptionSelectComponent);

});
parcelRegister("gxbof", function(module, exports) {

$parcel$export(module.exports, "CopySpacePermissionsUpsell", () => $bf3e625c36397126$export$a5bc4eb407ffa75f);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
parcelRequire("dIouf");
var $3IBnw = parcelRequire("3IBnw");
var $hSqtY = parcelRequire("hSqtY");

var $euL71 = parcelRequire("euL71");

var $gLeLL = parcelRequire("gLeLL");
const $bf3e625c36397126$export$a5bc4eb407ffa75f = ({ messages: messages, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gLeLL.SectionMessage), {
        ...props,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), messages.title),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...messages.body,
            tagName: "p"
        }),
        targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
        learnMoreLink: {
            actionSubjectId: 'copySpacePermissionsUpsellLearnMore',
            href: 'https://support.atlassian.com/confluence-cloud/docs/copy-space-permissions/'
        },
        upgradeEditionActionSubjectId: "copySpacePermissionsUpsellTryNow",
        withGradient: false
    }));

});

parcelRegister("eax6l", function(module, exports) {

$parcel$export(module.exports, "OptionWithDescription", () => $3e3b50d0439aeed6$export$22ef38b3d0b0f282);

var $gwFzn = parcelRequire("gwFzn");

var $bUlM5 = parcelRequire("bUlM5");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $9wGTI = parcelRequire("9wGTI");
const $3e3b50d0439aeed6$var$optionStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    flexDirection: 'column'
});
const $3e3b50d0439aeed6$export$22ef38b3d0b0f282 = ({ label: label, description: description, isSelected: isSelected, isMenu: isMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $3e3b50d0439aeed6$var$optionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        weight: !isMenu && (0, $9wGTI.fg)('confluence_rbac_spaces_beta_opt_in') ? 'bold' : 'regular'
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: isSelected ? 'color.text.subtle' : 'color.text.subtlest',
        size: "small"
    }, description));

});

parcelRegister("4xjqG", function(module, exports) {

$parcel$export(module.exports, "LabeledSelect", () => $0cad5bb3c9b9cbab$export$365377be1492ee64);
$parcel$export(module.exports, "SelectLabel", () => $0cad5bb3c9b9cbab$export$f67338d29bd972f8);
$parcel$export(module.exports, "selectStyles", () => $0cad5bb3c9b9cbab$export$70a9ea0b017c448a);
$parcel$export(module.exports, "customSelectStyles", () => $0cad5bb3c9b9cbab$export$1c6948252e0c8a0d);
/* LabeledSelect.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $0cad5bb3c9b9cbab$export$365377be1492ee64 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $0cad5bb3c9b9cbab$export$f67338d29bd972f8 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt4r6c2 _1e0c1o8l _2hwxpxbi _y3gnusic _1bsb1j4a _slp31hna",
            __cmplp.className
        ])
    });
});
const $0cad5bb3c9b9cbab$export$70a9ea0b017c448a = (fullWidth)=>({
        display: 'inline-block',
        width: fullWidth ? '100%' : '300px'
    });
const $0cad5bb3c9b9cbab$export$1c6948252e0c8a0d = (fullWidth)=>({
        container: (provided)=>({
                ...provided,
                ...$0cad5bb3c9b9cbab$export$70a9ea0b017c448a(fullWidth)
            })
    });

});


parcelRegister("lsPeB", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $43a6135eb3098c87$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "EMPTY_SPACE", () => $43a6135eb3098c87$export$657dee6d5648750a);
$parcel$export(module.exports, "ValidationMessage", () => $43a6135eb3098c87$export$9973d23b8b5c1744);
$parcel$export(module.exports, "SourceSpaceSelector", () => $43a6135eb3098c87$export$5f8003bf5fd36aef);
/* SourceSpaceSelector.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $caYQd = parcelRequire("caYQd");

var $4xjqG = parcelRequire("4xjqG");
const $43a6135eb3098c87$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    sourceSpaceValidationError: {
        id: "copy-space-permissions.option-select.source-space.validation-error",
        defaultMessage: "This space can\u2019t be used as a source."
    },
    sourceSpaceGuestsWarning: {
        id: "copy-space-permissions.option-select.source-space.guests-warning",
        defaultMessage: "The guests in this space won\u2019t be included because guests can only have access to one space at a time."
    }
});
const $43a6135eb3098c87$export$657dee6d5648750a = {
    isRestricted: false,
    containsExternalCollaborators: false,
    spaceKey: '',
    spaceName: '',
    isAdmin: false
};
const $43a6135eb3098c87$export$9973d23b8b5c1744 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isErrorMessage: isErrorMessage, isExtraTall: isExtraTall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "",
            __cmplp.isErrorMessage ? "_syaz1tmw" : "_syazn7od",
            __cmplp.isExtraTall ? "_1tket9kd" : "_1tkegktf",
            __cmplp.className
        ])
    });
});
const $43a6135eb3098c87$export$5f8003bf5fd36aef = ({ label: label, onChange: onChange, filterSourceSpaceOptions: filterSourceSpaceOptions, placeholder: placeholder, validationState: validationState = 'default', renderGuestsWarning: renderGuestsWarning = false, fullWidth: fullWidth = false, validationPlaceholder: validationPlaceholder = false, defaultSpaceKey: defaultSpaceKey, allowOnlyAdminSpaces: allowOnlyAdminSpaces, showSpaceLabel: showSpaceLabel = false, labelTextTransform: labelTextTransform })=>{
    const [selection, setSelection] = (0, $gwFzn.useState)($43a6135eb3098c87$export$657dee6d5648750a);
    const onChangeInternal = (newSelection)=>{
        setSelection(newSelection);
        onChange(newSelection);
    };
    const errorMessage = validationState === 'error' ? $43a6135eb3098c87$export$a7357cdd1f0b0168.sourceSpaceValidationError : null;
    const infoMessage = renderGuestsWarning && selection.containsExternalCollaborators ? $43a6135eb3098c87$export$a7357cdd1f0b0168.sourceSpaceGuestsWarning : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4xjqG.SelectLabel), {
        htmlFor: "copy-space-perms-space-select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        style: (0, $4xjqG.selectStyles)(fullWidth)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $caYQd.SpaceSelector), {
        id: "copy-space-perms-space-select",
        onChange: onChangeInternal,
        placeholder: placeholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), placeholder),
        showDefaultSpace: false,
        showSpaceLabel: showSpaceLabel,
        validationState: validationState,
        filterOption: filterSourceSpaceOptions,
        spaceKey: defaultSpaceKey,
        allowOnlyAdminSpaces: allowOnlyAdminSpaces,
        lazyLoadOptions: true,
        labelTextTransform: labelTextTransform
    })), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4xjqG.SelectLabel), null), (validationPlaceholder || errorMessage || infoMessage) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($43a6135eb3098c87$export$9973d23b8b5c1744, {
        id: "copy-space-perms-space-select-validation-message" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        ,
        style: (0, $4xjqG.selectStyles)(fullWidth),
        isExtraTall: validationPlaceholder && renderGuestsWarning,
        isErrorMessage: !!errorMessage
    }, errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), errorMessage), !errorMessage && infoMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), infoMessage)));
};

});


parcelRegister("4l6Wo", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_HOME_ID", () => $98ff507ce6a2362a$export$823dfce5c2bceecb);
$parcel$export(module.exports, "PRODUCT_ADDONS_ID", () => $98ff507ce6a2362a$export$6ff1c5d96830f745);
$parcel$export(module.exports, "CONTAINER_HOME_ID", () => $98ff507ce6a2362a$export$b8c5fd47fee73aae);
$parcel$export(module.exports, "CONTAINER_HOME_LOADING_ID", () => $98ff507ce6a2362a$export$4b542de2568592b5);
$parcel$export(module.exports, "CONTAINER_BLOG_ID", () => $98ff507ce6a2362a$export$1237a23d18648140);
$parcel$export(module.exports, "CONTAINER_ADMIN_HOME_ID", () => $98ff507ce6a2362a$export$c3f826fbea17177);
$parcel$export(module.exports, "COMPANY_HUB_SETTINGS_ID", () => $98ff507ce6a2362a$export$e1cac4d5c92cf74b);
$parcel$export(module.exports, "ADMIN_HOME_ID", () => $98ff507ce6a2362a$export$a9aa544aabcc3ca1);
//Product View IDs
const $98ff507ce6a2362a$export$823dfce5c2bceecb = 'product/home';
const $98ff507ce6a2362a$export$6ff1c5d96830f745 = 'product/addons';
const $98ff507ce6a2362a$export$b8c5fd47fee73aae = 'container/home';
const $98ff507ce6a2362a$export$4b542de2568592b5 = 'container/home/loading';
const $98ff507ce6a2362a$export$1237a23d18648140 = 'container/blog';
const $98ff507ce6a2362a$export$245a96a4a566e845 = 'container/pdf-export';
const $98ff507ce6a2362a$export$c3f826fbea17177 = 'container/admin/home';
const $98ff507ce6a2362a$export$e1cac4d5c92cf74b = 'container/admin/company-hub';
const $98ff507ce6a2362a$export$a9aa544aabcc3ca1 = 'admin/home';

});

parcelRegister("joCMa", function(module, exports) {

$parcel$export(module.exports, "getLegacyMessageQueue", () => $b004eff2eb0be064$export$cef9eeb277f61645);
/* eslint-disable no-restricted-properties */ function $b004eff2eb0be064$export$cef9eeb277f61645() {
    return new Promise((resolve)=>{
        const tryToResolve = (retry)=>{
            if (retry <= 0) return;
            if (window?.legacyMessageQueue?.push) resolve(window.legacyMessageQueue);
            else setTimeout(()=>tryToResolve(retry - 1), 100);
        };
        tryToResolve(50);
    });
}

});

parcelRegister("feuG2", function(module, exports) {

$parcel$export(module.exports, "SpaceSettingsNavigationV2Portal", () => $b00cf28e8f13375f$export$9e3c60dd96fa2f8);
$parcel$export(module.exports, "SpaceSettingsSidebarLinks", () => $b00cf28e8f13375f$export$ce72f5360cf6ed0);
$parcel$export(module.exports, "SpaceSettingsV2ForgeApp", () => $b00cf28e8f13375f$export$80a4abaa5ce40322);
$parcel$export(module.exports, "SpaceSettingsV2LandingPage", () => $b00cf28e8f13375f$export$427e207118ab314a);
$parcel$export(module.exports, "ContentStateSettings", () => $b00cf28e8f13375f$export$3edf328f9b8c29f);
$parcel$export(module.exports, "ArchiveSpace", () => $b00cf28e8f13375f$export$3777b033eca1f6e0);
$parcel$export(module.exports, "EditorConversion", () => $b00cf28e8f13375f$export$1d7dd072dca164eb);
$parcel$export(module.exports, "DataClassificationSpaceSettings", () => $b00cf28e8f13375f$export$e9572bc84661916);
$parcel$export(module.exports, "ExportSpaceUnavailable", () => $b00cf28e8f13375f$export$4b21898ae61239bd);
$parcel$export(module.exports, "ExportSpace", () => $b00cf28e8f13375f$export$93b842abd8ad75f9);
$parcel$export(module.exports, "EditFeatures", () => $b00cf28e8f13375f$export$bc89e6c0f5af9aeb);
$parcel$export(module.exports, "LazyPdfExportPage", () => $b00cf28e8f13375f$export$def53ea7cb291102);
$parcel$export(module.exports, "LazyPageLayoutPage", () => $b00cf28e8f13375f$export$21d23c9293c0e1b6);
$parcel$export(module.exports, "LazyThemesPage", () => $b00cf28e8f13375f$export$39b0a52384de05d);
$parcel$export(module.exports, "LazyTemplatesPage", () => $b00cf28e8f13375f$export$dfb17b75c81c879e);
$parcel$export(module.exports, "SpaceSettingsSideNavigation", () => $b00cf28e8f13375f$export$8ac2027648d0e996);
$parcel$export(module.exports, "LazySpaceDetailsPage", () => $b00cf28e8f13375f$export$3d886d71e69bfaa7);
$parcel$export(module.exports, "SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE", () => (parcelRequire("5PeCy")).SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE);

var $jmjWc = parcelRequire("jmjWc");

var $5PeCy = parcelRequire("5PeCy");

const $b00cf28e8f13375f$export$9e3c60dd96fa2f8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "uLHEX",
    loader: async ()=>(await (parcelRequire("lDYRH"))).SpaceSettingsNavigationPortal,
    name: 'SpaceSettingsNavigationPortal'
});

const $b00cf28e8f13375f$export$ce72f5360cf6ed0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Qp6ij",
    loader: async ()=>(await (parcelRequire("gc3Cq"))).SpaceSettingsSidebarLinks,
    name: 'SpaceSettingsSidebarLinks'
});

const $b00cf28e8f13375f$export$80a4abaa5ce40322 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3t1oo",
    loader: async ()=>(await (parcelRequire("hFidv"))).ForgeApp,
    name: 'SpaceSettingsV2ForgeApp'
});

const $b00cf28e8f13375f$export$427e207118ab314a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qLkPh",
    loader: async ()=>(await (parcelRequire("4ss34"))).LandingPage,
    name: 'SpaceSettingsV2LandingPage'
});

const $b00cf28e8f13375f$export$3edf328f9b8c29f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "FToEO",
    loader: async ()=>(await (parcelRequire("76QwJ"))).ContentStateSettings,
    name: 'ContentStateSettings'
});

const $b00cf28e8f13375f$export$3777b033eca1f6e0 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "cpLCK",
    loader: async ()=>(await (parcelRequire("c9O6H"))).ArchiveSpace,
    name: 'ArchiveSpace'
});

const $b00cf28e8f13375f$export$1d7dd072dca164eb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "YzrOE",
    loader: async ()=>(await (parcelRequire("lWNZt"))).EditorConversion,
    name: 'EditorConversion'
});

const $b00cf28e8f13375f$export$e9572bc84661916 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qWPYU",
    loader: async ()=>(await (parcelRequire("lUcGb"))).DataClassificationSpaceSettings,
    name: 'DataClassificationSpaceSettings'
});

const $b00cf28e8f13375f$export$4b21898ae61239bd = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "vt_3W",
    loader: async ()=>(await (parcelRequire("3zUOp"))).ExportSpaceUnavailable,
    name: 'ExportSpaceUnavailable'
});

const $b00cf28e8f13375f$export$93b842abd8ad75f9 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "biBYY",
    loader: async ()=>(await (parcelRequire("fXIEk"))).ExportSpace,
    name: 'ExportSpace'
});

const $b00cf28e8f13375f$export$bc89e6c0f5af9aeb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nGPFr",
    loader: async ()=>(await (parcelRequire("4ji68"))).EditFeatures,
    name: 'EditFeatures'
});

const $b00cf28e8f13375f$export$def53ea7cb291102 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zu9Zj",
    loader: async ()=>(await (parcelRequire("8NVMl"))).PdfExportPage,
    name: 'PdfExportPage'
});

const $b00cf28e8f13375f$export$21d23c9293c0e1b6 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "TXVcD",
    loader: async ()=>(await (parcelRequire("gAkZx"))).PageLayoutPage,
    name: 'PageLayoutPage'
});

const $b00cf28e8f13375f$export$39b0a52384de05d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "uXV6v",
    loader: async ()=>(await (parcelRequire("bGqoQ"))).ThemesPage,
    name: 'ThemesPage'
});

const $b00cf28e8f13375f$export$dfb17b75c81c879e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4VN1e",
    loader: async ()=>(await (parcelRequire("lQRFG"))).TemplatesAndBlueprintsPage,
    name: 'TemplatesPage'
});

const $b00cf28e8f13375f$export$8ac2027648d0e996 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JHS8c",
    loader: async ()=>(await (parcelRequire("acrkU"))).SpaceSettingsSideNavigation,
    name: 'SpaceSettingsSideNavigation'
});

const $b00cf28e8f13375f$export$3d886d71e69bfaa7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6JNth",
    loader: async ()=>(await (parcelRequire("5znQS"))).SpaceDetailsPage,
    name: 'SpaceDetailsPage'
});

});
parcelRegister("5PeCy", function(module, exports) {

$parcel$export(module.exports, "SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE", () => $3f1a68f508d23df8$export$9e09723d1b627d8f);
$parcel$export(module.exports, "NOT_APPLICABLE", () => $3f1a68f508d23df8$export$e8958a6508ec5b71);
const $3f1a68f508d23df8$export$9e09723d1b627d8f = 'spaceSettingsDetails';
const $3f1a68f508d23df8$export$c92839d2fae816f4 = 'confluence-fe-space-settings-space-details';
const $3f1a68f508d23df8$export$e8958a6508ec5b71 = 'N/A';

});

parcelRegister("lDYRH", function(module, exports) {

let $fc1c7404111f11c5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fc1c7404111f11c5$var$load("2A55e"),
    $fc1c7404111f11c5$var$load("85I6z"),
    $fc1c7404111f11c5$var$load("bZeLH"),
    $fc1c7404111f11c5$var$load("3kHns"),
    $fc1c7404111f11c5$var$load("3JzPO"),
    $fc1c7404111f11c5$var$load("6zfzy"),
    $fc1c7404111f11c5$var$load("c6MKV"),
    $fc1c7404111f11c5$var$load("aZinD"),
    $fc1c7404111f11c5$var$load("cyGuT"),
    $fc1c7404111f11c5$var$load("kemVp")
]).then(()=>parcelRequire('fE3rm'));

});

parcelRegister("gc3Cq", function(module, exports) {

let $bca092f51b9bf106$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bca092f51b9bf106$var$load("3VpdY").then(()=>parcelRequire('iqUA6'));

});

parcelRegister("hFidv", function(module, exports) {

let $cdc465802f84f7f0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $cdc465802f84f7f0$var$load("2A55e"),
    $cdc465802f84f7f0$var$load("85I6z"),
    $cdc465802f84f7f0$var$load("bZeLH"),
    $cdc465802f84f7f0$var$load("3kHns"),
    $cdc465802f84f7f0$var$load("3JzPO"),
    $cdc465802f84f7f0$var$load("6zfzy"),
    $cdc465802f84f7f0$var$load("c6MKV"),
    $cdc465802f84f7f0$var$load("aZinD"),
    $cdc465802f84f7f0$var$load("cyGuT"),
    $cdc465802f84f7f0$var$load("hikiA")
]).then(()=>parcelRequire('62VWj'));

});

parcelRegister("4ss34", function(module, exports) {

let $33ef88d37927a420$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $33ef88d37927a420$var$load("2A55e"),
    $33ef88d37927a420$var$load("85I6z"),
    $33ef88d37927a420$var$load("3kHns"),
    $33ef88d37927a420$var$load("3JzPO"),
    $33ef88d37927a420$var$load("c6MKV"),
    $33ef88d37927a420$var$load("aZinD"),
    $33ef88d37927a420$var$load("cyGuT"),
    $33ef88d37927a420$var$load("aOJkF")
]).then(()=>parcelRequire('fOc3P'));

});

parcelRegister("76QwJ", function(module, exports) {

let $52d1d6b16783b55f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $52d1d6b16783b55f$var$load("2A55e"),
    $52d1d6b16783b55f$var$load("85I6z"),
    $52d1d6b16783b55f$var$load("bZeLH"),
    $52d1d6b16783b55f$var$load("leIbB"),
    $52d1d6b16783b55f$var$load("3kHns"),
    $52d1d6b16783b55f$var$load("3JzPO"),
    $52d1d6b16783b55f$var$load("6zfzy"),
    $52d1d6b16783b55f$var$load("c6MKV"),
    $52d1d6b16783b55f$var$load("aZinD"),
    $52d1d6b16783b55f$var$load("cyGuT"),
    $52d1d6b16783b55f$var$load("hWed1")
]).then(()=>parcelRequire('7bHkN'));

});

parcelRegister("c9O6H", function(module, exports) {

let $8d9d318419f4cae1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8d9d318419f4cae1$var$load("2A55e"),
    $8d9d318419f4cae1$var$load("85I6z"),
    $8d9d318419f4cae1$var$load("bZeLH"),
    $8d9d318419f4cae1$var$load("3kHns"),
    $8d9d318419f4cae1$var$load("3JzPO"),
    $8d9d318419f4cae1$var$load("6zfzy"),
    $8d9d318419f4cae1$var$load("c6MKV"),
    $8d9d318419f4cae1$var$load("aZinD"),
    $8d9d318419f4cae1$var$load("cyGuT"),
    $8d9d318419f4cae1$var$load("3oo5Z")
]).then(()=>parcelRequire('58FKJ'));

});

parcelRegister("lWNZt", function(module, exports) {

let $ffa5cad7d5f4d508$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ffa5cad7d5f4d508$var$load("2A55e"),
    $ffa5cad7d5f4d508$var$load("85I6z"),
    $ffa5cad7d5f4d508$var$load("bZeLH"),
    $ffa5cad7d5f4d508$var$load("3kHns"),
    $ffa5cad7d5f4d508$var$load("3JzPO"),
    $ffa5cad7d5f4d508$var$load("6zfzy"),
    $ffa5cad7d5f4d508$var$load("c6MKV"),
    $ffa5cad7d5f4d508$var$load("aZinD"),
    $ffa5cad7d5f4d508$var$load("cyGuT"),
    $ffa5cad7d5f4d508$var$load("kf91U")
]).then(()=>parcelRequire('jE6bv'));

});

parcelRegister("lUcGb", function(module, exports) {

let $ff28a9cb44cb9db2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ff28a9cb44cb9db2$var$load("2A55e"),
    $ff28a9cb44cb9db2$var$load("85I6z"),
    $ff28a9cb44cb9db2$var$load("bZeLH"),
    $ff28a9cb44cb9db2$var$load("58UdM"),
    $ff28a9cb44cb9db2$var$load("4Qstt"),
    $ff28a9cb44cb9db2$var$load("5odbj"),
    $ff28a9cb44cb9db2$var$load("1ZoPC"),
    $ff28a9cb44cb9db2$var$load("hY77v"),
    $ff28a9cb44cb9db2$var$load("3kHns"),
    $ff28a9cb44cb9db2$var$load("3JzPO"),
    $ff28a9cb44cb9db2$var$load("26IOy"),
    $ff28a9cb44cb9db2$var$load("2nuqm"),
    $ff28a9cb44cb9db2$var$load("giPb3"),
    $ff28a9cb44cb9db2$var$load("ecOVI"),
    $ff28a9cb44cb9db2$var$load("2S1L6"),
    $ff28a9cb44cb9db2$var$load("6zfzy"),
    $ff28a9cb44cb9db2$var$load("U7y88"),
    $ff28a9cb44cb9db2$var$load("fEx3B"),
    $ff28a9cb44cb9db2$var$load("dJQEi"),
    $ff28a9cb44cb9db2$var$load("6qah4"),
    $ff28a9cb44cb9db2$var$load("j4gWN"),
    $ff28a9cb44cb9db2$var$load("i5Fj1"),
    $ff28a9cb44cb9db2$var$load("aZinD"),
    $ff28a9cb44cb9db2$var$load("cyGuT"),
    $ff28a9cb44cb9db2$var$load("c6MKV"),
    $ff28a9cb44cb9db2$var$load("1RXGd")
]).then(()=>parcelRequire('4XP30'));

});

parcelRegister("3zUOp", function(module, exports) {

let $29b0b5b0c6f47c46$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $29b0b5b0c6f47c46$var$load("2A55e"),
    $29b0b5b0c6f47c46$var$load("85I6z"),
    $29b0b5b0c6f47c46$var$load("bZeLH"),
    $29b0b5b0c6f47c46$var$load("58UdM"),
    $29b0b5b0c6f47c46$var$load("4Qstt"),
    $29b0b5b0c6f47c46$var$load("5odbj"),
    $29b0b5b0c6f47c46$var$load("1ZoPC"),
    $29b0b5b0c6f47c46$var$load("hY77v"),
    $29b0b5b0c6f47c46$var$load("3kHns"),
    $29b0b5b0c6f47c46$var$load("3JzPO"),
    $29b0b5b0c6f47c46$var$load("26IOy"),
    $29b0b5b0c6f47c46$var$load("2nuqm"),
    $29b0b5b0c6f47c46$var$load("giPb3"),
    $29b0b5b0c6f47c46$var$load("ecOVI"),
    $29b0b5b0c6f47c46$var$load("2S1L6"),
    $29b0b5b0c6f47c46$var$load("6zfzy"),
    $29b0b5b0c6f47c46$var$load("U7y88"),
    $29b0b5b0c6f47c46$var$load("fEx3B"),
    $29b0b5b0c6f47c46$var$load("dJQEi"),
    $29b0b5b0c6f47c46$var$load("6qah4"),
    $29b0b5b0c6f47c46$var$load("j4gWN"),
    $29b0b5b0c6f47c46$var$load("i5Fj1"),
    $29b0b5b0c6f47c46$var$load("aZinD"),
    $29b0b5b0c6f47c46$var$load("cyGuT"),
    $29b0b5b0c6f47c46$var$load("c6MKV"),
    $29b0b5b0c6f47c46$var$load("8dtLd")
]).then(()=>parcelRequire('29NvJ'));

});

parcelRegister("fXIEk", function(module, exports) {

let $b9ef002da7378250$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b9ef002da7378250$var$load("b52u5"),
    $b9ef002da7378250$var$load("2A55e"),
    $b9ef002da7378250$var$load("85I6z"),
    $b9ef002da7378250$var$load("bZeLH"),
    $b9ef002da7378250$var$load("3Eu7W"),
    $b9ef002da7378250$var$load("ej4rO"),
    $b9ef002da7378250$var$load("3kHns"),
    $b9ef002da7378250$var$load("3JzPO"),
    $b9ef002da7378250$var$load("6zfzy"),
    $b9ef002da7378250$var$load("6qah4"),
    $b9ef002da7378250$var$load("c6MKV"),
    $b9ef002da7378250$var$load("aZinD"),
    $b9ef002da7378250$var$load("cyGuT"),
    $b9ef002da7378250$var$load("5l56g")
]).then(()=>parcelRequire('13289'));

});

parcelRegister("4ji68", function(module, exports) {

let $3236f9ab30468e1c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3236f9ab30468e1c$var$load("2A55e"),
    $3236f9ab30468e1c$var$load("85I6z"),
    $3236f9ab30468e1c$var$load("bZeLH"),
    $3236f9ab30468e1c$var$load("3kHns"),
    $3236f9ab30468e1c$var$load("3JzPO"),
    $3236f9ab30468e1c$var$load("6zfzy"),
    $3236f9ab30468e1c$var$load("c6MKV"),
    $3236f9ab30468e1c$var$load("aZinD"),
    $3236f9ab30468e1c$var$load("cyGuT"),
    $3236f9ab30468e1c$var$load("4R2Ie")
]).then(()=>parcelRequire('cUMZA'));

});

parcelRegister("8NVMl", function(module, exports) {

let $668fb803c8d8da91$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $668fb803c8d8da91$var$load("gavZG"),
    $668fb803c8d8da91$var$load("c6MKV"),
    $668fb803c8d8da91$var$load("aZinD"),
    $668fb803c8d8da91$var$load("eCKto")
]).then(()=>parcelRequire('lt04m'));

});

parcelRegister("gAkZx", function(module, exports) {

let $c1304aa39aeaf258$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c1304aa39aeaf258$var$load("c6MKV"),
    $c1304aa39aeaf258$var$load("aZinD"),
    $c1304aa39aeaf258$var$load("5K3iw")
]).then(()=>parcelRequire('lhpIB'));

});

parcelRegister("bGqoQ", function(module, exports) {

let $881818650f6c7a93$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $881818650f6c7a93$var$load("gr3fi").then(()=>parcelRequire('h595R'));

});

parcelRegister("lQRFG", function(module, exports) {

let $fe88164f0a4dee7c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fe88164f0a4dee7c$var$load("gkmZg"),
    $fe88164f0a4dee7c$var$load("f96v0"),
    $fe88164f0a4dee7c$var$load("ev7SX"),
    $fe88164f0a4dee7c$var$load("hGmYF"),
    $fe88164f0a4dee7c$var$load("c6MKV"),
    $fe88164f0a4dee7c$var$load("h4Nf7"),
    $fe88164f0a4dee7c$var$load("4fCJZ"),
    $fe88164f0a4dee7c$var$load("aZinD"),
    $fe88164f0a4dee7c$var$load("4aLlP"),
    $fe88164f0a4dee7c$var$load("75ddA")
]).then(()=>parcelRequire('6xruv'));

});

parcelRegister("acrkU", function(module, exports) {

let $76d03ac5d7b9e15c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $76d03ac5d7b9e15c$var$load("85I6z"),
    $76d03ac5d7b9e15c$var$load("7xv66"),
    $76d03ac5d7b9e15c$var$load("hXJOj")
]).then(()=>parcelRequire('f53HT'));

});

parcelRegister("5znQS", function(module, exports) {

let $40e2b919a9865288$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $40e2b919a9865288$var$load("1wMt1"),
    $40e2b919a9865288$var$load("2A55e"),
    $40e2b919a9865288$var$load("85I6z"),
    $40e2b919a9865288$var$load("bZeLH"),
    $40e2b919a9865288$var$load("3kHns"),
    $40e2b919a9865288$var$load("3JzPO"),
    $40e2b919a9865288$var$load("kQvbt"),
    $40e2b919a9865288$var$load("jQFGH"),
    $40e2b919a9865288$var$load("fQ1rW"),
    $40e2b919a9865288$var$load("4tUsp"),
    $40e2b919a9865288$var$load("f96v0"),
    $40e2b919a9865288$var$load("ev7SX"),
    $40e2b919a9865288$var$load("hGmYF"),
    $40e2b919a9865288$var$load("1hjmQ"),
    $40e2b919a9865288$var$load("h4Nf7"),
    $40e2b919a9865288$var$load("4fCJZ"),
    $40e2b919a9865288$var$load("dTsOE"),
    $40e2b919a9865288$var$load("9FBaW"),
    $40e2b919a9865288$var$load("6zfzy"),
    $40e2b919a9865288$var$load("6StWh"),
    $40e2b919a9865288$var$load("87F9B"),
    $40e2b919a9865288$var$load("4aLlP"),
    $40e2b919a9865288$var$load("c6MKV"),
    $40e2b919a9865288$var$load("aZinD"),
    $40e2b919a9865288$var$load("cyGuT"),
    $40e2b919a9865288$var$load("aGPD2")
]).then(()=>parcelRequire('Nfj1T'));

});


parcelRegister("itS9i", function(module, exports) {

$parcel$export(module.exports, "debuggerEnabled", () => $87d19dc7160c9951$export$d29204ec4461f93d);
$parcel$export(module.exports, "enableAnalyticsDebugger", () => $87d19dc7160c9951$export$fa5a3071e40f49f0);
$parcel$export(module.exports, "cacheExpectedViewPageSegments", () => $87d19dc7160c9951$export$aca950d042781720);
$parcel$export(module.exports, "clearAnalyticsDebugger", () => $87d19dc7160c9951$export$3bcd87824542df8d);
/**
 * Analytics Debugger
 *
 * A micro debugger for the load testing team designed to safely cache View Page's
 * page segment load metrics on the window.
 */ /**
 * Indicates whether debugging analytics-web-client is enabled
 */ let $87d19dc7160c9951$export$d29204ec4461f93d = false;
const $87d19dc7160c9951$export$fa5a3071e40f49f0 = ()=>{
    $87d19dc7160c9951$export$d29204ec4461f93d = true;
};
/**
 * Check the window for the test interface added by the load testing team
 */ const $87d19dc7160c9951$var$getTestInterface = ()=>{
    return !!window.testAnalytics;
};
const $87d19dc7160c9951$export$aca950d042781720 = (segments)=>{
    if ($87d19dc7160c9951$var$getTestInterface()) window.testAnalytics.expectedPageSegments = segments;
};
const $87d19dc7160c9951$export$3bcd87824542df8d = ()=>{
    if ($87d19dc7160c9951$var$getTestInterface()) window.testAnalytics.clear();
};
const $87d19dc7160c9951$export$f80940ef284a6232 = ()=>{
    $87d19dc7160c9951$export$d29204ec4461f93d = false;
};

});

parcelRegister("le1Dp", function(module, exports) {

$parcel$export(module.exports, "CopySpacePermissionsForLegacyNewSpace", () => $f2c725b269ab2f20$export$5dc791f41eb205df);
$parcel$export(module.exports, "SourceSpaceSelector", () => $f2c725b269ab2f20$export$5f8003bf5fd36aef);
$parcel$export(module.exports, "CompletionFlag", () => $f2c725b269ab2f20$export$25044b3ea27d2610);
$parcel$export(module.exports, "EMPTY_SPACE", () => (parcelRequire("dsz8u")).EMPTY_SPACE);
$parcel$export(module.exports, "isSourceSpaceValid", () => (parcelRequire("dsz8u")).isSourceSpaceValid);
$parcel$export(module.exports, "Option", () => (parcelRequire("crGnL")).Option);

var $jmjWc = parcelRequire("jmjWc");

var $dsz8u = parcelRequire("dsz8u");

var $crGnL = parcelRequire("crGnL");

const $f2c725b269ab2f20$export$67aa88db754bd005 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lBMlq",
    loader: async ()=>(await (parcelRequire("kDOvK"))).CopySpacePermissionsForExistingSpacePortal,
    name: 'CopySpacePermissionsForExistingSpacePortal'
});

const $f2c725b269ab2f20$export$5dc791f41eb205df = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "dw4pL",
    loader: async ()=>(await (parcelRequire("a4fi2"))).CopySpacePermissionsForLegacyNewSpace,
    name: 'CopySpacePermissionsForLegacyNewSpace'
});

const $f2c725b269ab2f20$export$5f8003bf5fd36aef = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "A2FEs",
    loader: async ()=>(await Promise.resolve((parcelRequire("lsPeB")))).SourceSpaceSelector,
    name: 'SourceSpaceSelector'
});

const $f2c725b269ab2f20$export$25044b3ea27d2610 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_ksNM",
    loader: async ()=>(await (parcelRequire("gN5A2"))).CompletionFlag,
    name: 'CompletionFlag'
});

});
parcelRegister("kDOvK", function(module, exports) {

let $f06ea19ba82791ac$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f06ea19ba82791ac$var$load("g4ylS").then(()=>parcelRequire('gbul6'));

});

parcelRegister("a4fi2", function(module, exports) {

let $7546235f84a9308d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7546235f84a9308d$var$load("fx531").then(()=>parcelRequire('dGO9h'));

});

parcelRegister("gN5A2", function(module, exports) {

let $c3958d155118cca7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c3958d155118cca7$var$load("kPQBd").then(()=>parcelRequire('86ugq'));

});


parcelRegister("iJELi", function(module, exports) {

$parcel$export(module.exports, "ConnectSupport", () => $a8580388344cd16b$export$9123996dc48566a9);

var $jmjWc = parcelRequire("jmjWc");

const $a8580388344cd16b$export$9123996dc48566a9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ugvPP",
    name: "ConnectSupport",
    loader: async ()=>(await (parcelRequire("dRWui"))).ConnectSupport
});

});
parcelRegister("dRWui", function(module, exports) {

let $a18d980a5c1feaa2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a18d980a5c1feaa2$var$load("8myCk"),
    $a18d980a5c1feaa2$var$load("jXIn9"),
    $a18d980a5c1feaa2$var$load("aZinD"),
    $a18d980a5c1feaa2$var$load("2X0n2"),
    $a18d980a5c1feaa2$var$load("8m15Y")
]).then(()=>parcelRequire('jsyvA'));

});


parcelRegister("25MM7", function(module, exports) {

$parcel$export(module.exports, "Flags", () => $c26bad631d03df7b$export$434ba092ed0eee4e);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $gqqjz = parcelRequire("gqqjz");

var $bAD5F = parcelRequire("bAD5F");
const $c26bad631d03df7b$export$434ba092ed0eee4e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bAD5F.FlagsComponent), {
            flags: flags.state.flags,
            areFlagsVisible: flags.state.areFlagsVisible,
            showFlag: flags.showFlag,
            hideFlag: flags.hideFlag,
            ...props
        }));

});
parcelRegister("bAD5F", function(module, exports) {

$parcel$export(module.exports, "FlagsComponent", () => $cbc57a64ac2cf4e8$export$355f6c9384246c75);

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $aD1SW = parcelRequire("aD1SW");
var $eCEXz = parcelRequire("eCEXz");
var $6uGcC = parcelRequire("6uGcC");

var $cryCi = parcelRequire("cryCi");

var $hfsbF = parcelRequire("hfsbF");
const $cbc57a64ac2cf4e8$export$355f6c9384246c75 = (0, $js7oX.default)(class FlagsComponent extends (0, $gwFzn.PureComponent) {
    componentDidMount() {
        const { showFlag: showFlag, applyAJSFlagOverride: applyAJSFlagOverride } = this.props;
        if (showFlag) applyAJSFlagOverride?.(showFlag);
    }
    componentWillUnmount() {
        this.props.removeAJSFlagOverride?.();
    }
    translateActions(actions) {
        const { intl: intl } = this.props;
        return actions.map((action)=>{
            if ('contentKey' in action) {
                const i18nMessage = {
                    id: action.contentKey
                };
                return {
                    ...action,
                    content: intl.formatMessage(i18nMessage)
                };
            }
            return action;
        });
    }
    toFlagProps({ id: id, title: title = '', description: description = '', actions: actions = [], type: type, appearance: appearance, customIcon: customIcon, messageId: messageId, messageType: messageType, onMessageDisposition: onMessageDisposition, delayAnnouncement: delayAnnouncement }) {
        return {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hfsbF.FlagIcon), {
                type: type,
                isBold: Boolean(appearance),
                customIcon: customIcon
            }),
            appearance: appearance,
            id: id,
            title: title,
            description: description,
            messageId: messageId,
            messageType: messageType,
            onMessageDisposition: onMessageDisposition,
            actions: this.translateActions(actions),
            ...delayAnnouncement && {
                delayAnnouncement: delayAnnouncement
            }
        };
    }
    render() {
        const { flags: flags, areFlagsVisible: areFlagsVisible } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cryCi.Consumer), null, (choreographerAssets)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6uGcC.default), {
                onDismissed: this.onDismissed
            }, flags.map((flagDescriptor)=>{
                const FlagComponentType = flagDescriptor.customComponent || (flagDescriptor.close === 'auto' ? choreographerAssets?.AutoDismissFlag ?? (0, $aD1SW.default) : choreographerAssets?.Flag ?? (0, $eCEXz.default));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                    "data-test-id": "flag-visibility-wrapper",
                    key: flagDescriptor.id,
                    style: {
                        visibility: areFlagsVisible ? 'visible' : 'hidden'
                    },
                    "aria-hidden": !areFlagsVisible
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(FlagComponentType, this.toFlagProps(flagDescriptor)));
            })));
    }
    constructor(...args){
        super(...args);
        this.onDismissed = (flagId)=>{
            const { flags: flags, hideFlag: hideFlag } = this.props;
            flags.forEach((flag)=>{
                if (flag.id === flagId && typeof flag.onClose === 'function') flag.onClose();
            });
            hideFlag?.(flagId);
        };
    }
});

});
parcelRegister("hfsbF", function(module, exports) {

$parcel$export(module.exports, "FlagIcon", () => $b1c1b600180069b4$export$4fd8d63cb0915eb0);

var $gwFzn = parcelRequire("gwFzn");

var $cvXh8 = parcelRequire("cvXh8");

var $7yDmn = parcelRequire("7yDmn");

var $4vzBZ = parcelRequire("4vzBZ");

var $aUEBE = parcelRequire("aUEBE");

var $2p7B1 = parcelRequire("2p7B1");
function $b1c1b600180069b4$var$colorizeIcon(Icon, color, label, isBold) {
    return isBold ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
        label: label,
        color: "currentColor",
        spacing: "spacious"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
        label: label,
        color: color,
        spacing: "spacious"
    });
}
const $b1c1b600180069b4$export$4fd8d63cb0915eb0 = ({ type: type, isBold: isBold, customIcon: customIcon })=>{
    switch(type){
        case 'success-circle':
            return $b1c1b600180069b4$var$colorizeIcon((0, (/*@__PURE__*/$parcel$interopDefault($aUEBE))), "var(--ds-icon-success, #22A06B)", 'Success', isBold);
        case 'success':
            return $b1c1b600180069b4$var$colorizeIcon((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), "var(--ds-icon-success, #22A06B)", 'Success', isBold);
        case 'error':
            return $b1c1b600180069b4$var$colorizeIcon((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), "var(--ds-icon-danger, #C9372C)", 'Error', isBold);
        case 'warning':
            return $b1c1b600180069b4$var$colorizeIcon((0, (/*@__PURE__*/$parcel$interopDefault($2p7B1))), "var(--ds-icon-warning, #E56910)", 'Warning', isBold);
        case 'custom':
            return customIcon ?? $b1c1b600180069b4$var$colorizeIcon((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), "var(--ds-icon-information, #1D7AFC)", 'Info', isBold);
        case 'info':
        default:
            return $b1c1b600180069b4$var$colorizeIcon((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), "var(--ds-icon-information, #1D7AFC)", 'Info', isBold);
    }
};

});



parcelRegister("NAPtM", function(module, exports) {

$parcel$export(module.exports, "CreateDialogContextProvider", () => $1f88a3fce0610a72$export$1fdbf19afa2e1224);

var $gwFzn = parcelRequire("gwFzn");

var $csnse = parcelRequire("csnse");

var $joCMa = parcelRequire("joCMa");

var $8hUXc = parcelRequire("8hUXc");

var $3p0JS = parcelRequire("3p0JS");
class $1f88a3fce0610a72$export$1fdbf19afa2e1224 extends (0, $gwFzn.Component) {
    componentDidMount() {
        (0, $joCMa.getLegacyMessageQueue)().then((legacyMessageQueue)=>{
            legacyMessageQueue.push({
                type: 'ATLASSIAN_CONFLUENCE_VARIABLEINPUT_REGISTER_CALLBACK',
                payload: this.openTemplateVariables
            });
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8hUXc.CreateDialogContext).Provider, {
            value: this.getProviderValue(this.state)
        }, this.props.children);
    }
    constructor(props){
        super(props);
        this.openTemplateVariables = ({ templateId: templateId, parentPageId: parentPageId, spaceKey: spaceKey, title: title, contentId: contentId, onContentUpdated: onContentUpdated, onError: onError, beforeUpdateRequest: beforeUpdateRequest, forceTemplatePanelOpen: forceTemplatePanelOpen, openContentInNewTab: openContentInNewTab })=>{
            this.setState({
                templateId: templateId,
                parentPageId: parentPageId,
                spaceKey: spaceKey,
                title: title,
                contentId: contentId,
                onContentUpdated: onContentUpdated,
                onError: onError,
                showTemplateVariableInputDrawer: true,
                beforeUpdateRequest: beforeUpdateRequest,
                forceTemplatePanelOpen: forceTemplatePanelOpen,
                openContentInNewTab: openContentInNewTab
            });
        };
        this.openBlueprintWizard = ({ blueprint: blueprint, parentPageId: parentPageId, spaceKey: spaceKey, templateOriginSpaceKey: templateOriginSpaceKey, title: title, contentId: contentId, onContentUpdated: onContentUpdated, onError: onError, beforeUpdateRequest: beforeUpdateRequest })=>{
            this.setState({
                contentId: contentId,
                blueprint: blueprint,
                parentPageId: parentPageId,
                spaceKey: spaceKey,
                templateOriginSpaceKey: templateOriginSpaceKey,
                onContentUpdated: onContentUpdated,
                onError: onError,
                showBlueprintVariableWizard: true,
                title: title || '',
                beforeUpdateRequest: beforeUpdateRequest
            });
        };
        this.onClose = ()=>{
            this.setState((0, $3p0JS.getDefaultChangeableValues));
        };
        this.getProviderValue = (0, $csnse.default)((state)=>({
                ...state,
                openTemplateVariables: this.openTemplateVariables,
                openBlueprintWizard: this.openBlueprintWizard,
                onClose: this.onClose
            }));
        this.state = (0, $3p0JS.getDefaultChangeableValues);
    }
}

});

parcelRegister("cBuRD", function(module, exports) {

$parcel$export(module.exports, "NotificationLandedEvent", () => $dbb766fb537d30bb$export$eac8f819fa93e7ef);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $3jwuS = parcelRequire("3jwuS");

var $7zgzO = parcelRequire("7zgzO");

var $7W8i8 = parcelRequire("7W8i8");
const $dbb766fb537d30bb$var$logger = (0, $7W8i8.getLogger)('notifications');
const $dbb766fb537d30bb$export$eac8f819fa93e7ef = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Check for the notification landed query params "atl_p" when loading
    (0, $gwFzn.useEffect)(()=>{
        const queryParams = getQueryParams();
        const base64NotificationParams = queryParams.atl_p;
        // If we have the query param for the event, send it and clear them
        if (base64NotificationParams) {
            // Its a Base64 encoded JSON string which we need to unpack
            try {
                const paramsJSONStr = window.atob(base64NotificationParams);
                const params = JSON.parse(paramsJSONStr);
                // Ensure we have a "source" field in the param
                if (params && !params.source) throw new Error('source field is required to send event');
                const attributes = Object.assign({
                    isLivePage: isLivePage
                }, params);
                delete attributes['source'];
                // COMMENTS-372 Persisting originId for cc-notifications to use
                // @ts-ignore
                window.atlp = {
                    originId: params.i
                };
                // Send event
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'landed',
                        actionSubject: 'notification',
                        source: params.source,
                        attributes: attributes
                    }
                }).fire();
            } catch (e) {
                $dbb766fb537d30bb$var$logger.error`An error occurred attempting to decode the notifications query params: ${e}`;
            }
            // Unset the query params
            setQueryParams({
                ...queryParams,
                atl_p: undefined
            });
        }
    }, [
        getQueryParams,
        createAnalyticsEvent,
        setQueryParams,
        isLivePage
    ]);
    return null;
};

});

parcelRegister("arkw6", function(module, exports) {

$parcel$export(module.exports, "LazyCreateDialogQueryRenderer", () => $799c5730c040f94e$export$8a15724b9c449449);

var $jmjWc = parcelRequire("jmjWc");

const $799c5730c040f94e$export$8a15724b9c449449 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "24dkw",
    name: "LazyCreateDialogQueryRenderer",
    loader: async ()=>(await (parcelRequire("hboYR"))).CreateDialogQueryRenderer
});

});
parcelRegister("hboYR", function(module, exports) {

let $c826d7619be1b25b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c826d7619be1b25b$var$load("hGXAt"),
    $c826d7619be1b25b$var$load("c6MKV"),
    $c826d7619be1b25b$var$load("aZinD"),
    $c826d7619be1b25b$var$load("8sv0D")
]).then(()=>parcelRequire('awg6S'));

});


parcelRegister("4QflW", function(module, exports) {

$parcel$export(module.exports, "LegacyCreateDialogCssOverridesLoader", () => $3867ed838141f5c5$export$cb6c2610bed03a36);
$parcel$export(module.exports, "default", () => $3867ed838141f5c5$export$2e2bcd8739ae039);
parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $3867ed838141f5c5$export$cb6c2610bed03a36 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Hii47",
    name: "LegacyCreateDialogCssOverridesLoader",
    loader: ()=>(parcelRequire("5EKxW"))
});

const $3867ed838141f5c5$var$LegacyCssOverridesLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3Za_w",
    name: "LegacyCssOverridesLoader",
    loader: ()=>(parcelRequire("h2CP3"))
});
var $3867ed838141f5c5$export$2e2bcd8739ae039 = $3867ed838141f5c5$var$LegacyCssOverridesLoader;

});
parcelRegister("5EKxW", function(module, exports) {

let $41e4cb54ae6f7702$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $41e4cb54ae6f7702$var$load("5zc8S").then(()=>parcelRequire('77xGo'));

});

parcelRegister("h2CP3", function(module, exports) {

let $c680bceb4e9812cd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c680bceb4e9812cd$var$load("kS1Zx").then(()=>parcelRequire('dvfbF'));

});


parcelRegister("3j0Cc", function(module, exports) {

$parcel$export(module.exports, "LazyCreateDialogBlueprintWizardRenderer", () => $26839f94c757541d$export$581cdb67a7c2d168);

var $jmjWc = parcelRequire("jmjWc");

const $26839f94c757541d$export$581cdb67a7c2d168 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "6iAdD",
    name: "LazyCreateDialogBlueprintWizardRenderer",
    loader: async ()=>(await (parcelRequire("aQTed"))).CreateDialogBlueprintWizardRenderer
});

});
parcelRegister("aQTed", function(module, exports) {

let $7e6999eb4c8f54af$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7e6999eb4c8f54af$var$load("c37CC").then(()=>parcelRequire('cVptH'));

});


parcelRegister("jwv1p", function(module, exports) {

$parcel$export(module.exports, "preloadLivePagesComponents", () => $e36911ba101658f6$export$148862cf4cade69d);
$parcel$export(module.exports, "preloadViewPageComponents", () => $e36911ba101658f6$export$ae265da577871bc0);
$parcel$export(module.exports, "preloadSpaceOverview", () => $e36911ba101658f6$export$2fae7b45037154b8);

const $e36911ba101658f6$export$148862cf4cade69d = async ()=>{
    return (await (parcelRequire("b3WWT"))).preloadLivePagesComponents();
};

const $e36911ba101658f6$export$ae265da577871bc0 = async ()=>{
    return (await (parcelRequire("giyX9"))).preloadViewPage();
};

const $e36911ba101658f6$export$2fae7b45037154b8 = async ()=>{
    (await (parcelRequire("lcvtB"))).preloadSpaceOverview();
};

});
parcelRegister("b3WWT", function(module, exports) {

let $80ddb38894ad4956$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $80ddb38894ad4956$var$load("hTcok").then(()=>parcelRequire('3u3VR'));

});

parcelRegister("giyX9", function(module, exports) {

let $bdd970bfbb14d4a5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $bdd970bfbb14d4a5$var$load("jLbdY"),
    $bdd970bfbb14d4a5$var$load("3xec3"),
    $bdd970bfbb14d4a5$var$load("jHDh2"),
    $bdd970bfbb14d4a5$var$load("7xv66"),
    $bdd970bfbb14d4a5$var$load("aJJUY"),
    $bdd970bfbb14d4a5$var$load("3kHns"),
    $bdd970bfbb14d4a5$var$load("3JzPO"),
    $bdd970bfbb14d4a5$var$load("gseUi"),
    $bdd970bfbb14d4a5$var$load("2YKx2"),
    $bdd970bfbb14d4a5$var$load("26IOy"),
    $bdd970bfbb14d4a5$var$load("2nuqm"),
    $bdd970bfbb14d4a5$var$load("6zfzy"),
    $bdd970bfbb14d4a5$var$load("hTb35"),
    $bdd970bfbb14d4a5$var$load("87F9B"),
    $bdd970bfbb14d4a5$var$load("aZinD"),
    $bdd970bfbb14d4a5$var$load("hrAMe"),
    $bdd970bfbb14d4a5$var$load("hsB1k"),
    $bdd970bfbb14d4a5$var$load("7qbsX")
]).then(()=>parcelRequire('jpdb8'));

});

parcelRegister("lcvtB", function(module, exports) {

let $f6f32282e43c5c9b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f6f32282e43c5c9b$var$load("jLbdY"),
    $f6f32282e43c5c9b$var$load("7xv66"),
    $f6f32282e43c5c9b$var$load("aJJUY"),
    $f6f32282e43c5c9b$var$load("gseUi"),
    $f6f32282e43c5c9b$var$load("2YKx2"),
    $f6f32282e43c5c9b$var$load("26IOy"),
    $f6f32282e43c5c9b$var$load("2nuqm"),
    $f6f32282e43c5c9b$var$load("6zfzy"),
    $f6f32282e43c5c9b$var$load("hTb35"),
    $f6f32282e43c5c9b$var$load("87F9B"),
    $f6f32282e43c5c9b$var$load("aZinD"),
    $f6f32282e43c5c9b$var$load("hrAMe"),
    $f6f32282e43c5c9b$var$load("c9p5N")
]).then(()=>parcelRequire('eyGwZ'));

});


parcelRegister("aiAUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $77f836f57929774c$export$2e2bcd8739ae039);
parcelRequire("gwFzn");

var $cKyDI = parcelRequire("cKyDI");

var $G5CuV = parcelRequire("G5CuV");

var $kc5x1 = parcelRequire("kc5x1");
const $77f836f57929774c$var$mapStateToProps = ({ modal: { modalComponent: modalComponent, modalProps: modalProps } })=>({
        modalComponent: modalComponent,
        modalProps: modalProps
    });
var $77f836f57929774c$export$2e2bcd8739ae039 = (0, $cKyDI.connect)($77f836f57929774c$var$mapStateToProps, {
    closeActiveModal: $G5CuV.closeActiveModal
})((0, $kc5x1.default));

});
parcelRegister("G5CuV", function(module, exports) {

$parcel$export(module.exports, "closeActiveModal", () => $07e8485c1a071f58$export$6d4e820aaceb5999);

var $5cBWV = parcelRequire("5cBWV");
const $07e8485c1a071f58$export$6d4e820aaceb5999 = (0, $5cBWV.commonActionCreator)('CLOSE_ACTIVE_MODAL');
const $07e8485c1a071f58$export$7c7b664744e0bbd3 = (0, $5cBWV.commonActionCreator)('SET_ACTIVE_MODAL');

});

parcelRegister("kc5x1", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb39382018b931f4$export$2e2bcd8739ae039);

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");
class $eb39382018b931f4$export$2e2bcd8739ae039 extends (0, $gwFzn.PureComponent) {
    render() {
        const { modalComponent: Modal, modalProps: modalProps, closeActiveModal: closeActiveModal } = this.props;
        if (Modal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Modal, {
            ...modalProps,
            closeModal: closeActiveModal
        });
        return null;
    }
}
$eb39382018b931f4$export$2e2bcd8739ae039.defaultProps = {
    modalProps: {}
};
$eb39382018b931f4$export$2e2bcd8739ae039.propTypes = {
    closeActiveModal: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    modalComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    modalProps: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object
};

});


parcelRegister("lmeKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8c71911bfe19f54$export$2e2bcd8739ae039);

var $cKyDI = parcelRequire("cKyDI");

var $k1TJH = parcelRequire("k1TJH");

var $52UBD = parcelRequire("52UBD");
const $f8c71911bfe19f54$var$mapStateToProps = (state)=>({
        spotlightId: (0, $52UBD.getCurrentSpotlightId)(state.views.changeboarding)
    });
const $f8c71911bfe19f54$var$ChangeboardingManager = (0, $cKyDI.connect)($f8c71911bfe19f54$var$mapStateToProps)((0, $k1TJH.default));
var $f8c71911bfe19f54$export$2e2bcd8739ae039 = $f8c71911bfe19f54$var$ChangeboardingManager;

});
parcelRegister("k1TJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e94f22adbf97ff84$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $6cnUO = parcelRequire("6cnUO");

var $bYVgS = parcelRequire("bYVgS");
class $e94f22adbf97ff84$export$2e2bcd8739ae039 extends (0, $gwFzn.Component) {
    render() {
        const { spotlightId: spotlightId, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6cnUO.default), null, children, !spotlightId ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bYVgS.ChangeboardingSpotlightLazyLoader), null));
    }
}
$e94f22adbf97ff84$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).any,
    spotlightId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string
};

});


parcelRegister("7RVQB", function(module, exports) {

$parcel$export(module.exports, "lazyLanguage", () => $5baa5af3b62b17d6$export$e275acea19f48fe8);
/* eslint-disable import/dynamic-import-chunkname */ /**
 * The webpackChunkName "translations.foo" is important. Do not change without updating following files:
 * - packages/confluence-frontend-server/webpack.config.js
 * - packages/confluence-frontend-server/templates/generator.js
 */ 























function $5baa5af3b62b17d6$var$fetchLanguage(locale) {
    /**
     * en-ZZ is a special locale used for locate translation strings. Real user won't see it.
     * Split the condition statements so webpack can remove the whole thing when compiling for SSR
     * SSR doesn't have splits this file will make the ssr-app significantly bigger
     */ if (locale === 'en-ZZ') return ()=>(parcelRequire("4cvsc"));
    const languageHash = {
        'fr-FR': ()=>(parcelRequire("8SKcP")),
        'de-DE': ()=>(parcelRequire("GS71V")),
        'ja-JP': ()=>(parcelRequire("luAO3")),
        'es-ES': ()=>(parcelRequire("5K5a9")),
        'ko-KR': ()=>(parcelRequire("bWCT4")),
        'pt-BR': ()=>(parcelRequire("1ZVLO")),
        'ru-RU': ()=>(parcelRequire("eGk5x")),
        'en-GB': ()=>(parcelRequire("eOQZp")),
        'da-DK': ()=>(parcelRequire("h8pYT")),
        'et-EE': ()=>(parcelRequire("gbpZx")),
        'fi-FI': ()=>(parcelRequire("lK0pU")),
        'hu-HU': ()=>(parcelRequire("4LOxS")),
        'is-IS': ()=>(parcelRequire("azAej")),
        'it-IT': ()=>(parcelRequire("gd0eF")),
        'nl-NL': ()=>(parcelRequire("jv0Hs")),
        'no-NO': ()=>(parcelRequire("3oOIF")),
        'pl-PL': ()=>(parcelRequire("fNhT6")),
        'ro-RO': ()=>(parcelRequire("i3NgM")),
        'sk-SK': ()=>(parcelRequire("4rEzS")),
        'cs-CZ': ()=>(parcelRequire("fWj8A")),
        'sv-SE': ()=>(parcelRequire("6YXMu")),
        'zh-CN': ()=>(parcelRequire("3BFy8")),
        'zh-TW': ()=>(parcelRequire("9nMZ5"))
    };
    return locale in languageHash ? languageHash[locale] : undefined;
}

function $5baa5af3b62b17d6$export$e275acea19f48fe8(locale) {
    const promises = [
        (parcelRequire("7Cp4M"))
    ];
    const languageChunk = $5baa5af3b62b17d6$var$fetchLanguage(locale);
    if (languageChunk) promises.push(languageChunk());
    return promises;
}

});
parcelRegister("4cvsc", function(module, exports) {

let $30f0ae7fd7c21099$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $30f0ae7fd7c21099$var$load("kb8GE").then(()=>parcelRequire('lQBzA'));

});

parcelRegister("8SKcP", function(module, exports) {

let $677735670019a965$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $677735670019a965$var$load("g3sTA").then(()=>parcelRequire('4ftaS'));

});

parcelRegister("GS71V", function(module, exports) {

let $080de5f394e5f74e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $080de5f394e5f74e$var$load("g7zq1").then(()=>parcelRequire('cGYky'));

});

parcelRegister("luAO3", function(module, exports) {

let $fa58f34d87a27f2f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fa58f34d87a27f2f$var$load("d2Mdd").then(()=>parcelRequire('brEWr'));

});

parcelRegister("5K5a9", function(module, exports) {

let $42e540d2dfd9c06e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $42e540d2dfd9c06e$var$load("dNqrn").then(()=>parcelRequire('6HMxZ'));

});

parcelRegister("bWCT4", function(module, exports) {

let $8b2346b3fa5eda83$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8b2346b3fa5eda83$var$load("ckbna").then(()=>parcelRequire('6wpE3'));

});

parcelRegister("1ZVLO", function(module, exports) {

let $17484ce7121b6e0f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $17484ce7121b6e0f$var$load("8nqTj").then(()=>parcelRequire('9C0G5'));

});

parcelRegister("eGk5x", function(module, exports) {

let $ab0492145ac11dd0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ab0492145ac11dd0$var$load("iH8IF").then(()=>parcelRequire('cXJcl'));

});

parcelRegister("eOQZp", function(module, exports) {

let $ac9ed6d43f7c0b70$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ac9ed6d43f7c0b70$var$load("kKFqa").then(()=>parcelRequire('cmTE1'));

});

parcelRegister("h8pYT", function(module, exports) {

let $c797565739a9ea17$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c797565739a9ea17$var$load("esTEG").then(()=>parcelRequire('2QzjW'));

});

parcelRegister("gbpZx", function(module, exports) {

let $030a5a28847ad922$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $030a5a28847ad922$var$load("eYtek").then(()=>parcelRequire('1eNHV'));

});

parcelRegister("lK0pU", function(module, exports) {

let $fd3e37a9bd643cac$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd3e37a9bd643cac$var$load("cvthC").then(()=>parcelRequire('2mvVd'));

});

parcelRegister("4LOxS", function(module, exports) {

let $3792c275ea85d7df$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3792c275ea85d7df$var$load("ced9G").then(()=>parcelRequire('fivEJ'));

});

parcelRegister("azAej", function(module, exports) {

let $7b2946c4fc3b8b84$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7b2946c4fc3b8b84$var$load("2F3bE").then(()=>parcelRequire('3N3RQ'));

});

parcelRegister("gd0eF", function(module, exports) {

let $bcce0b0073e5d241$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bcce0b0073e5d241$var$load("4r7x8").then(()=>parcelRequire('68Zf7'));

});

parcelRegister("jv0Hs", function(module, exports) {

let $e3217492118ed191$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e3217492118ed191$var$load("6z6cv").then(()=>parcelRequire('1yifm'));

});

parcelRegister("3oOIF", function(module, exports) {

let $279af4d08b19407c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $279af4d08b19407c$var$load("aoQ1d").then(()=>parcelRequire('4V6BS'));

});

parcelRegister("fNhT6", function(module, exports) {

let $b7f94ebfe143ba14$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b7f94ebfe143ba14$var$load("8N2iJ").then(()=>parcelRequire('73ds9'));

});

parcelRegister("i3NgM", function(module, exports) {

let $d25eb9bf0f01610a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d25eb9bf0f01610a$var$load("1QINL").then(()=>parcelRequire('qpOhL'));

});

parcelRegister("4rEzS", function(module, exports) {

let $33c928eeae70e98c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $33c928eeae70e98c$var$load("kd6Lw").then(()=>parcelRequire('1y6fn'));

});

parcelRegister("fWj8A", function(module, exports) {

let $b9ab1e1401e3510c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b9ab1e1401e3510c$var$load("2kJcS").then(()=>parcelRequire('12uCo'));

});

parcelRegister("6YXMu", function(module, exports) {

let $5156b7f9c777c222$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5156b7f9c777c222$var$load("eA9cu").then(()=>parcelRequire('iFaar'));

});

parcelRegister("3BFy8", function(module, exports) {

let $2a050eb23a78c9da$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2a050eb23a78c9da$var$load("6Rcy9").then(()=>parcelRequire('bn69C'));

});

parcelRegister("9nMZ5", function(module, exports) {

let $6d4c424c22cbb7af$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6d4c424c22cbb7af$var$load("hn34F").then(()=>parcelRequire('grb79'));

});

parcelRegister("7Cp4M", function(module, exports) {

let $58bf8894a4db9418$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $58bf8894a4db9418$var$load("8IiKJ").then(()=>parcelRequire('5pL4M'));

});


parcelRegister("feRZU", function(module, exports) {

$parcel$export(module.exports, "postProcessSessionData", () => $b1820c9e8f7c0e6f$export$e5def783215cad0);

var $g68Gk = parcelRequire("g68Gk");

var $4VJDS = parcelRequire("4VJDS");

var $2oDRW = parcelRequire("2oDRW");

var $68uaC = parcelRequire("68uaC");

var $9wGTI = parcelRequire("9wGTI");

var $8jvvW = parcelRequire("8jvvW");
var $ca4OQ = parcelRequire("ca4OQ");

var $45prt = parcelRequire("45prt");

var $e9zUf = parcelRequire("e9zUf");
const $b1820c9e8f7c0e6f$export$e5def783215cad0 = async (sessionData)=>{
    const { userId: userId, featureFlags: featureFlags, isLicensed: isLicensed } = sessionData;
    await (0, $68uaC.Cookies).initialize();
    // Local and session storage
    (0, $e9zUf.initializeStorageManager)({
        userId: userId,
        isLicensed: isLicensed
    }).then(()=>{
        // Load and process FF overrides persisted by storage-manager
        (0, $8jvvW.updateSessionData)(sessionData, (0, $8jvvW.applyPersistedOverrides)(featureFlags));
        // Apply Statsig overrides persisted by storage-manager if this is not an integration test site
        if (!(0, $4VJDS.default).isKillSwitchOn('confluence_ssr_apply_persisted_overrides_blocklist')) (0, $ca4OQ.applyPersistedStatsigOverrides)();
    });
    // To add allowed feature flags to UFO payload
    [
        ...(0, $2oDRW.FF_ALLOWLIST_FOR_PERF_METRICS),
        ...(0, $2oDRW.ALLOWLIST_FFS_CUSTOM_EVENTS)
    ].forEach((flag)=>{
        if (featureFlags.hasOwnProperty(flag) && typeof featureFlags[flag] !== 'object') {
            (0, $g68Gk.addFeatureFlagAccessed)(flag, featureFlags[flag]);
            return;
        }
        const ssrFeatureFlag = (0, $45prt.getSSRFeatureFlag)(flag);
        if (ssrFeatureFlag !== null && ssrFeatureFlag !== undefined && typeof ssrFeatureFlag !== 'object') {
            (0, $g68Gk.addFeatureFlagAccessed)(flag, ssrFeatureFlag);
            return;
        }
        // eslint-disable-next-line confluence-feature-gating/static-feature-gates, confluence-feature-gating/inline-usage
        const statsigFlag = (0, $9wGTI.fg)(flag);
        if (typeof statsigFlag !== 'object') (0, $g68Gk.addFeatureFlagAccessed)(flag, statsigFlag);
    });
    return sessionData;
};

});

parcelRegister("7LuKf", function(module, exports) {

$parcel$export(module.exports, "initialization", () => $5a74c583a9da3f53$export$66b82bc0ee0db41d);

var $jiJCD = parcelRequire("jiJCD");

var $1iSzD = parcelRequire("1iSzD");

var $68uaC = parcelRequire("68uaC");

var $l3KBO = parcelRequire("l3KBO");
var $398ES = parcelRequire("398ES");

var $6bQlH = parcelRequire("6bQlH");

var $eSuZj = parcelRequire("eSuZj");

var $27y2X = parcelRequire("27y2X");

var $5ZqQS = parcelRequire("5ZqQS");

var $04e9M = parcelRequire("04e9M");

var $6vg9V = parcelRequire("6vg9V");

var $blhvm = parcelRequire("blhvm");

var $itS9i = parcelRequire("itS9i");

var $bmTgR = parcelRequire("bmTgR");

var $6SLr4 = parcelRequire("6SLr4");

var $4Y7MV = parcelRequire("4Y7MV");

var $4VJDS = parcelRequire("4VJDS");



function $5a74c583a9da3f53$export$66b82bc0ee0db41d(sessionData) {
    const { featureFlags: featureFlags, cloudId: cloudId, environment: environment, shard: shard, activationId: activationId, edition: edition } = sessionData;
    (0, $blhvm.patchLocalStorage)();
    (0, $6SLr4.setFrontendBranch)();
    if (featureFlags['confluence.frontend.bm.unique-identifier']) (0, $4Y7MV.setBrowserMetricsUniqueIdentifier)();
    (0, $6bQlH.enableGraphqlRetries)();
    (0, $5ZqQS.enableSendErrorsToTelemetryService)();
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const product = isEmbeddedConfluence ? 'embeddedConfluence' : 'confluence';
    //Grabbing parentProduct and setting it to subproduct
    const subproduct = isEmbeddedConfluence ? (0, $jiJCD.parse)(location.search, true).query.parentProduct : undefined;
    // Monitoring context initialization
    (0, $5ZqQS.getMonitoringClient)().updateContext({
        tenantId: cloudId,
        shard: shard,
        product: product,
        edition: edition
    });
    // initialize metal client
    (0, $6vg9V.initMetalClient)({
        environment: environment || 'DEVELOPMENT',
        synthetic: (0, $4VJDS.default).getBoolean('confluence_frontend_pollinator_synthetic_tenants', false)
    });
    // Before initializing the Analytics Web Client (AWC), set the
    // `atlassian_analytics_debug` cookie to indicate that CC Scale bot users (load testing)
    // can use `window.testAnalytics` object to detect whether a page is loaded
    // (AWC saves all the events that are fired under `window.testAnalytics`)
    const analyticsDebuggingEnabled = (0, $4VJDS.default).getBoolean('confluence_frontend_analytics_load_testing', false);
    const shouldFilterEvents = Boolean((0, $4VJDS.default).isKillSwitchOn('confluence_frontend_filter_events_config') ?? false);
    if (analyticsDebuggingEnabled) (0, $68uaC.Cookies).set('atlassian_analytics_debug', true);
    // GASv3 analytics client
    // ActivationId: sessionData.activationId needs to be added after https://experimentation-platform.atlassian.net/browse/MEP-2924
    (0, $04e9M.initializeAnalyticsClient)({
        cloudId: cloudId,
        activationId: activationId,
        userId: sessionData.userIdForAnalytics,
        locale: sessionData.locale,
        environment: (0, $4VJDS.default).getBoolean('confluence_frontend_pollinator_synthetic_tenants', false) ? 'DEVELOPMENT' : environment,
        product: product,
        subproduct: subproduct,
        eventFilterOptions: {
            shouldFilterEvents: shouldFilterEvents,
            eventMatchers: (0, $27y2X.defaultEventMatchers)
        },
        callback: analyticsDebuggingEnabled ? (0, $itS9i.enableAnalyticsDebugger) : undefined
    });
    // Please put stuff that can be delayed here
    (0, $l3KBO.getTaskManager)().push({
        id: 'BackgroundInitialization',
        priority: (0, $398ES.LoadingPriority).BACKGROUND,
        task: ()=>{
            // Global function available for support engineer to get all environmental data for troubleshooting.
            window.__CONFLUENCE_SUPPORT = ()=>{
                const supportData = {
                    version: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
                    tinymce: window.tinymce ? `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}` : undefined,
                    activeEditor: window.tinymce && window.tinymce.activeEditor ? true : undefined
                };
                return JSON.stringify(supportData);
            };
            // Register service worker
            (parcelRequire("3Hct2")).then(({ unregister: unregisterServiceWorker })=>{
                unregisterServiceWorker();
            });
            // Message queue for sending GASv3 event from legacy pages
            (parcelRequire("eBfFg")).then(({ initializeLegacyMessageQueue: initializeLegacyMessageQueue })=>{
                initializeLegacyMessageQueue();
            });
            // https://developer.mozilla.org/en-US/docs/Glossary/Domain_sharding
            // We roughly has 8% of users still on http/1.1 https://redash.data.internal.atlassian.com/queries/126773/source#242723
            // Http/1.1 is 2x slower than http/2 https://redash.data.internal.atlassian.com/queries/126772/source#242719
            (parcelRequire("6kvdl")).then(({ initializeFlag: initializeFlag })=>initializeFlag());
            // Establish IPC listeners for Confluence Desktop App
            const shouldInitializeDesktop = (0, $4VJDS.default).getBoolean('confluence_should_initialize_desktop', false);
            if (shouldInitializeDesktop) (0, $bmTgR.establishIPCListeners)();
            var packageReports;
        }
    });
}

});
parcelRegister("6SLr4", function(module, exports) {

$parcel$export(module.exports, "setFrontendBranch", () => $502c94f8f5d6e348$export$b4feebdfd4dc5ca8);

var $jiJCD = parcelRequire("jiJCD");

var $lwdd5 = parcelRequire("lwdd5");

var $68uaC = parcelRequire("68uaC");
const $502c94f8f5d6e348$var$CLASSIC_BRANCH = 'useFrontendBranch';
const $502c94f8f5d6e348$var$BUILD_VERSION = 'useFrontendBuildVersion';
const $502c94f8f5d6e348$var$REGEX = /[^A-Za-z0-9\-]/g;
async function $502c94f8f5d6e348$var$setCookie(key, value) {
    const original = (0, $68uaC.Cookies).get(key);
    if (value === 'off' || key === $502c94f8f5d6e348$var$BUILD_VERSION && !value) (0, $68uaC.Cookies).remove(key);
    else if (value) await (0, $68uaC.Cookies).set(key, decodeURIComponent(value).replace($502c94f8f5d6e348$var$REGEX, '-'));
    return (0, $68uaC.Cookies).get(key) !== original;
}
async function $502c94f8f5d6e348$export$b4feebdfd4dc5ca8() {
    const urlComponents = (0, $jiJCD.parse)((0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location.href, true);
    let branchName = null;
    let buildVersion = null;
    if (urlComponents.query && (urlComponents.query.useFrontendBranch || urlComponents.query.useFrontendBuildVersion)) {
        branchName = urlComponents.query.useFrontendBranch;
        buildVersion = urlComponents.query.useFrontendBuildVersion;
        const branchVersionChanged = await $502c94f8f5d6e348$var$setCookie($502c94f8f5d6e348$var$CLASSIC_BRANCH, branchName);
        const buildVersionChanged = await $502c94f8f5d6e348$var$setCookie($502c94f8f5d6e348$var$BUILD_VERSION, buildVersion);
        if (branchVersionChanged || buildVersionChanged) (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location.assign((0, $jiJCD.format)({
            pathname: urlComponents.pathname,
            query: urlComponents.query,
            hash: urlComponents.hash
        }));
    }
}

});

parcelRegister("4Y7MV", function(module, exports) {

$parcel$export(module.exports, "setBrowserMetricsUniqueIdentifier", () => $39e2ce9abd3d5cf3$export$79147544b544e349);

var $jiJCD = parcelRequire("jiJCD");

var $lwdd5 = parcelRequire("lwdd5");

var $68uaC = parcelRequire("68uaC");
const $39e2ce9abd3d5cf3$var$BM_UNIQUE_IDENTIFIER = 'bmUniqueIdentifier';
function $39e2ce9abd3d5cf3$export$79147544b544e349() {
    const urlComponents = (0, $jiJCD.parse)((0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location.href, true);
    const identifier = urlComponents.query?.bmUniqueIdentifier;
    if (identifier === 'off') (0, $68uaC.Cookies).remove($39e2ce9abd3d5cf3$var$BM_UNIQUE_IDENTIFIER);
    else if (identifier) (0, $68uaC.Cookies).set($39e2ce9abd3d5cf3$var$BM_UNIQUE_IDENTIFIER, identifier);
}

});

parcelRegister("3Hct2", function(module, exports) {

let $2b0f0efc6ab6aca2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2b0f0efc6ab6aca2$var$load("erEMS").then(()=>parcelRequire('lQAde'));

});

parcelRegister("eBfFg", function(module, exports) {

let $aa10ac06286fcbde$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aa10ac06286fcbde$var$load("eOPjI").then(()=>parcelRequire('93DJf'));

});

parcelRegister("6kvdl", function(module, exports) {

let $49bcd2db3f76a71a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $49bcd2db3f76a71a$var$load("gHIIj").then(()=>parcelRequire('gzkU4'));

});



//# sourceMappingURL=dashboard-spa-container-jquery3.9068be02.js.map
